export default {
data: {
routes: [
{
gtfsId: "HSL:4421",
shortName: "421",
longName: "Elielinaukio-Martinlaakso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEzMg==",
lat: 60.171921,
lon: 24.939716
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIzMQ==",
lat: 60.27793,
lon: 24.86877
},
{
id: "U3RvcDpIU0w6NDE3MDIyMw==",
lat: 60.27959,
lon: 24.86557
},
{
id: "U3RvcDpIU0w6NDE3MDIyNQ==",
lat: 60.28239,
lon: 24.86421
},
{
id: "U3RvcDpIU0w6NDE3MDIyNw==",
lat: 60.28305,
lon: 24.85951
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE3MDIzMg==",
lat: 60.28126,
lon: 24.83584
},
{
id: "U3RvcDpIU0w6NDE3MDIxMw==",
lat: 60.27618,
lon: 24.83573
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0OA==",
lat: 60.27723,
lon: 24.85379
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mw==",
lat: 60.27737,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE3MDIxMg==",
lat: 60.27741,
lon: 24.83602
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIzMA==",
lat: 60.28075,
lon: 24.85491
},
{
id: "U3RvcDpIU0w6NDE3MDIyOA==",
lat: 60.28318,
lon: 24.86074
},
{
id: "U3RvcDpIU0w6NDE3MDIyNg==",
lat: 60.28204,
lon: 24.86449
},
{
id: "U3RvcDpIU0w6NDE3MDIyNA==",
lat: 60.27874,
lon: 24.86524
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:1033",
shortName: "33",
longName: "Munkkivuori-Tarvo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMwNDE2MA==",
lat: 60.2055,
lon: 24.879
},
{
id: "U3RvcDpIU0w6MTMwNDEyOQ==",
lat: 60.203905,
lon: 24.873805
},
{
id: "U3RvcDpIU0w6MTMwMTEyOQ==",
lat: 60.201871,
lon: 24.873394
},
{
id: "U3RvcDpIU0w6MTMwMTE0NQ==",
lat: 60.201432,
lon: 24.87506
},
{
id: "U3RvcDpIU0w6MTMwMTEyNw==",
lat: 60.199,
lon: 24.8765
},
{
id: "U3RvcDpIU0w6MTMwMTE1Mw==",
lat: 60.195947,
lon: 24.873401
},
{
id: "U3RvcDpIU0w6MTMwMTEzNQ==",
lat: 60.197189,
lon: 24.871448
},
{
id: "U3RvcDpIU0w6MTMwMTEzNg==",
lat: 60.198077,
lon: 24.870246
},
{
id: "U3RvcDpIU0w6MTMwMTEwNg==",
lat: 60.19884,
lon: 24.86811
},
{
id: "U3RvcDpIU0w6MTMwMTEwNw==",
lat: 60.199862,
lon: 24.864593
},
{
id: "U3RvcDpIU0w6MTMwMTEwNA==",
lat: 60.200228,
lon: 24.863685
},
{
id: "U3RvcDpIU0w6MTMwMTEzNw==",
lat: 60.200927,
lon: 24.862837
},
{
id: "U3RvcDpIU0w6MTMwMTEwOQ==",
lat: 60.201913,
lon: 24.858765
},
{
id: "U3RvcDpIU0w6MTMwMTExMQ==",
lat: 60.204705,
lon: 24.848228
},
{
id: "U3RvcDpIU0w6MTMwMTExMA==",
lat: 60.201797,
lon: 24.858775
},
{
id: "U3RvcDpIU0w6MTMwMTE0MA==",
lat: 60.200391,
lon: 24.863437
},
{
id: "U3RvcDpIU0w6MTMwMTEwOA==",
lat: 60.199587,
lon: 24.864002
},
{
id: "U3RvcDpIU0w6MTMwMTE0MQ==",
lat: 60.198514,
lon: 24.864993
},
{
id: "U3RvcDpIU0w6MTMwMTEwMQ==",
lat: 60.197547,
lon: 24.867328
},
{
id: "U3RvcDpIU0w6MTMwMTE0Mg==",
lat: 60.195112,
lon: 24.870582
},
{
id: "U3RvcDpIU0w6MTMwMTEwNQ==",
lat: 60.19657,
lon: 24.874118
},
{
id: "U3RvcDpIU0w6MTMwMTEyOA==",
lat: 60.199507,
lon: 24.87727
},
{
id: "U3RvcDpIU0w6MTMwMTE0Ng==",
lat: 60.201122,
lon: 24.875988
},
{
id: "U3RvcDpIU0w6MTMwMTE0NA==",
lat: 60.2019,
lon: 24.874432
},
{
id: "U3RvcDpIU0w6MTMwNDE1OQ==",
lat: 60.20391,
lon: 24.87377
}
]
},
{
gtfsId: "HSL:1032",
shortName: "32",
longName: "Pohjois-Haaga-Munkkivuori",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTI5NDE5MQ==",
lat: 60.228558,
lon: 24.885355
},
{
id: "U3RvcDpIU0w6MTI5NDEwMQ==",
lat: 60.229233,
lon: 24.884949
},
{
id: "U3RvcDpIU0w6MTI5NDE0MA==",
lat: 60.229936,
lon: 24.883347
},
{
id: "U3RvcDpIU0w6MTI5NDEzOQ==",
lat: 60.23079,
lon: 24.8821
},
{
id: "U3RvcDpIU0w6MTI5NDEwNA==",
lat: 60.232737,
lon: 24.882643
},
{
id: "U3RvcDpIU0w6MTI5NDEwNg==",
lat: 60.232502,
lon: 24.877133
},
{
id: "U3RvcDpIU0w6MTI5NDEwNw==",
lat: 60.23227,
lon: 24.872952
},
{
id: "U3RvcDpIU0w6MTI5NDEwOA==",
lat: 60.231454,
lon: 24.874598
},
{
id: "U3RvcDpIU0w6MTI5NDEwNQ==",
lat: 60.232475,
lon: 24.877616
},
{
id: "U3RvcDpIU0w6MTI5NDEwMw==",
lat: 60.232546,
lon: 24.883469
},
{
id: "U3RvcDpIU0w6MTI5MzEzOA==",
lat: 60.23275,
lon: 24.88788
},
{
id: "U3RvcDpIU0w6MTMzMTExNA==",
lat: 60.236354,
lon: 24.889709
},
{
id: "U3RvcDpIU0w6MTI5MzEzNg==",
lat: 60.232533,
lon: 24.889442
},
{
id: "U3RvcDpIU0w6MTI5MzEzNQ==",
lat: 60.23103,
lon: 24.89271
},
{
id: "U3RvcDpIU0w6MTI5MzExNQ==",
lat: 60.22942,
lon: 24.89216
},
{
id: "U3RvcDpIU0w6MTI5MzExNw==",
lat: 60.229512,
lon: 24.890307
},
{
id: "U3RvcDpIU0w6MTI5MzExOA==",
lat: 60.230265,
lon: 24.888827
},
{
id: "U3RvcDpIU0w6MTI5MzExNg==",
lat: 60.229336,
lon: 24.89367
},
{
id: "U3RvcDpIU0w6MTI5MzEzMw==",
lat: 60.228672,
lon: 24.894933
},
{
id: "U3RvcDpIU0w6MTI5MzExNA==",
lat: 60.228105,
lon: 24.894975
},
{
id: "U3RvcDpIU0w6MTI5MzExMg==",
lat: 60.22818,
lon: 24.892014
},
{
id: "U3RvcDpIU0w6MTI5MzExMA==",
lat: 60.227987,
lon: 24.88867
},
{
id: "U3RvcDpIU0w6MTI5MzEwOA==",
lat: 60.226521,
lon: 24.887764
},
{
id: "U3RvcDpIU0w6MTI5MzEwNg==",
lat: 60.225299,
lon: 24.891935
},
{
id: "U3RvcDpIU0w6MTI5MzEwMw==",
lat: 60.225255,
lon: 24.895796
},
{
id: "U3RvcDpIU0w6MTI5MzEyNA==",
lat: 60.22408,
lon: 24.89863
},
{
id: "U3RvcDpIU0w6MTI5MzEyMg==",
lat: 60.22399,
lon: 24.90268
},
{
id: "U3RvcDpIU0w6MTI5MzEwMQ==",
lat: 60.223226,
lon: 24.905178
},
{
id: "U3RvcDpIU0w6MTI5MzEwMA==",
lat: 60.222307,
lon: 24.904608
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MTE3MQ==",
lat: 60.219725,
lon: 24.898578
},
{
id: "U3RvcDpIU0w6MTI5MTE3Mw==",
lat: 60.219858,
lon: 24.894173
},
{
id: "U3RvcDpIU0w6MTI5MTE3NA==",
lat: 60.220608,
lon: 24.891903
},
{
id: "U3RvcDpIU0w6MTI5MTE3Mg==",
lat: 60.219671,
lon: 24.894778
},
{
id: "U3RvcDpIU0w6MTI5MTEwOA==",
lat: 60.216,
lon: 24.89718
},
{
id: "U3RvcDpIU0w6MTI5MTExMA==",
lat: 60.21632,
lon: 24.89437
},
{
id: "U3RvcDpIU0w6MTI5MTExMg==",
lat: 60.21766,
lon: 24.89051
},
{
id: "U3RvcDpIU0w6MTI5MTEzMQ==",
lat: 60.21935,
lon: 24.886973
},
{
id: "U3RvcDpIU0w6MTI5MTExNA==",
lat: 60.218612,
lon: 24.886913
},
{
id: "U3RvcDpIU0w6MTI5MTEwMA==",
lat: 60.217263,
lon: 24.887564
},
{
id: "U3RvcDpIU0w6MTI5MTExMw==",
lat: 60.21736,
lon: 24.8909
},
{
id: "U3RvcDpIU0w6MTI5MTE1Mg==",
lat: 60.212695,
lon: 24.893704
},
{
id: "U3RvcDpIU0w6MTI5MTE1MQ==",
lat: 60.21071,
lon: 24.892532
},
{
id: "U3RvcDpIU0w6MTI5MTE0OQ==",
lat: 60.210268,
lon: 24.891564
},
{
id: "U3RvcDpIU0w6MTI5MTE0NQ==",
lat: 60.209844,
lon: 24.890416
},
{
id: "U3RvcDpIU0w6MTI5MTE0Mg==",
lat: 60.209342,
lon: 24.89309
},
{
id: "U3RvcDpIU0w6MTI5MTEzNw==",
lat: 60.20882,
lon: 24.88933
},
{
id: "U3RvcDpIU0w6MTI5MTEyMQ==",
lat: 60.20828,
lon: 24.88484
},
{
id: "U3RvcDpIU0w6MTMwNDEwNQ==",
lat: 60.205858,
lon: 24.87594
},
{
id: "U3RvcDpIU0w6MTMwNTE1MQ==",
lat: 60.20663,
lon: 24.88078
},
{
id: "U3RvcDpIU0w6MTI5MTEyMg==",
lat: 60.20837,
lon: 24.88578
},
{
id: "U3RvcDpIU0w6MTI5MTIyMA==",
lat: 60.21031,
lon: 24.88865
},
{
id: "U3RvcDpIU0w6MTI5MTE0Ng==",
lat: 60.210257,
lon: 24.891565
},
{
id: "U3RvcDpIU0w6MTI5MTE1MA==",
lat: 60.21142,
lon: 24.89337
},
{
id: "U3RvcDpIU0w6MTI5MTE1Mw==",
lat: 60.213062,
lon: 24.893838
},
{
id: "U3RvcDpIU0w6MTI5MTExMQ==",
lat: 60.21624,
lon: 24.89347
},
{
id: "U3RvcDpIU0w6MTI5MTEwNg==",
lat: 60.21582,
lon: 24.898291
},
{
id: "U3RvcDpIU0w6MTI5MTE3MA==",
lat: 60.21966,
lon: 24.898517
},
{
id: "U3RvcDpIU0w6MTI5MTEyNQ==",
lat: 60.21965,
lon: 24.90171
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzEwMg==",
lat: 60.223223,
lon: 24.905342
},
{
id: "U3RvcDpIU0w6MTI5MzEyMw==",
lat: 60.22424,
lon: 24.89852
},
{
id: "U3RvcDpIU0w6MTI5MzEwNA==",
lat: 60.225797,
lon: 24.894952
},
{
id: "U3RvcDpIU0w6MTI5MzEwNQ==",
lat: 60.225235,
lon: 24.89203
},
{
id: "U3RvcDpIU0w6MTI5MzEwNw==",
lat: 60.226617,
lon: 24.887637
},
{
id: "U3RvcDpIU0w6MTI5MzEwOQ==",
lat: 60.22794,
lon: 24.889558
},
{
id: "U3RvcDpIU0w6MTI5MzExMQ==",
lat: 60.228125,
lon: 24.891918
},
{
id: "U3RvcDpIU0w6MTI5MzExMw==",
lat: 60.228064,
lon: 24.894627
},
{
id: "U3RvcDpIU0w6MTI5MzEzMg==",
lat: 60.22999,
lon: 24.895167
},
{
id: "U3RvcDpIU0w6MTI5MzEzNA==",
lat: 60.23137,
lon: 24.89199
},
{
id: "U3RvcDpIU0w6MTI5MzE3Mw==",
lat: 60.232603,
lon: 24.889643
},
{
id: "U3RvcDpIU0w6MTI5NDEzNw==",
lat: 60.23296,
lon: 24.88799
},
{
id: "U3RvcDpIU0w6MTI5NDE0MQ==",
lat: 60.230629,
lon: 24.881719
},
{
id: "U3RvcDpIU0w6MTI5NDEwMg==",
lat: 60.22923,
lon: 24.884431
}
]
},
{
gtfsId: "HSL:2241",
shortName: "241",
longName: "Espoon keskus-Mikkelä-Hirvisuo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYyMTIzMQ==",
lat: 60.21626,
lon: 24.63137
},
{
id: "U3RvcDpIU0w6MjYyMjIwNA==",
lat: 60.21788,
lon: 24.63159
},
{
id: "U3RvcDpIU0w6MjYyMjIwMQ==",
lat: 60.21862,
lon: 24.62903
},
{
id: "U3RvcDpIU0w6MjYyMTIzOQ==",
lat: 60.21535,
lon: 24.62731
},
{
id: "U3RvcDpIU0w6MjYyMTIyMw==",
lat: 60.21355,
lon: 24.6296
},
{
id: "U3RvcDpIU0w6MjYyMTIyMA==",
lat: 60.208709,
lon: 24.634956
},
{
id: "U3RvcDpIU0w6MjYyMTI0OQ==",
lat: 60.207939,
lon: 24.630459
},
{
id: "U3RvcDpIU0w6MjYyMTIzNQ==",
lat: 60.20458,
lon: 24.62526
},
{
id: "U3RvcDpIU0w6MjYyMTIzMw==",
lat: 60.20401,
lon: 24.62729
},
{
id: "U3RvcDpIU0w6MjYyMTIzMg==",
lat: 60.20336,
lon: 24.62896
},
{
id: "U3RvcDpIU0w6MjYyMTIzNA==",
lat: 60.20398,
lon: 24.62708
},
{
id: "U3RvcDpIU0w6MjYyMTIzMA==",
lat: 60.20473,
lon: 24.62518
},
{
id: "U3RvcDpIU0w6MjYyMTIzNg==",
lat: 60.20782,
lon: 24.63026
},
{
id: "U3RvcDpIU0w6MjYyMTIyMQ==",
lat: 60.20858,
lon: 24.63342
},
{
id: "U3RvcDpIU0w6MjYyMTIyNQ==",
lat: 60.20841,
lon: 24.63715
},
{
id: "U3RvcDpIU0w6MjYyMTIxNw==",
lat: 60.20649,
lon: 24.64021
},
{
id: "U3RvcDpIU0w6MjYxMTIxOQ==",
lat: 60.205048,
lon: 24.65511
},
{
id: "U3RvcDpIU0w6MjYxMTI1OA==",
lat: 60.20535,
lon: 24.65686
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYyMTIyNw==",
lat: 60.20734,
lon: 24.63928
},
{
id: "U3RvcDpIU0w6MjYyMTIyOA==",
lat: 60.20933,
lon: 24.63587
},
{
id: "U3RvcDpIU0w6MjYyMTIyNA==",
lat: 60.2142,
lon: 24.62969
},
{
id: "U3RvcDpIU0w6MjYyMTI0Ng==",
lat: 60.21587,
lon: 24.62644
},
{
id: "U3RvcDpIU0w6MjYyMjIwMg==",
lat: 60.21865,
lon: 24.62921
},
{
id: "U3RvcDpIU0w6MjYyMjIwNQ==",
lat: 60.21794,
lon: 24.63165
}
]
},
{
gtfsId: "HSL:1031",
shortName: "31",
longName: "Pohjois-Haaga-Munkkivuori",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTI5NDE5MQ==",
lat: 60.228558,
lon: 24.885355
},
{
id: "U3RvcDpIU0w6MTI5NDEwMQ==",
lat: 60.229233,
lon: 24.884949
},
{
id: "U3RvcDpIU0w6MTI5NDE0MA==",
lat: 60.229936,
lon: 24.883347
},
{
id: "U3RvcDpIU0w6MTI5NDEzOQ==",
lat: 60.23079,
lon: 24.8821
},
{
id: "U3RvcDpIU0w6MTI5MzEzOA==",
lat: 60.23275,
lon: 24.88788
},
{
id: "U3RvcDpIU0w6MTMzMTExNA==",
lat: 60.236354,
lon: 24.889709
},
{
id: "U3RvcDpIU0w6MTI5MzEzNg==",
lat: 60.232533,
lon: 24.889442
},
{
id: "U3RvcDpIU0w6MTI5MzEzNQ==",
lat: 60.23103,
lon: 24.89271
},
{
id: "U3RvcDpIU0w6MTI5MzEyMA==",
lat: 60.230133,
lon: 24.899283
},
{
id: "U3RvcDpIU0w6MTI5MzExOQ==",
lat: 60.229291,
lon: 24.896231
},
{
id: "U3RvcDpIU0w6MTI5MzEzMw==",
lat: 60.228672,
lon: 24.894933
},
{
id: "U3RvcDpIU0w6MTI5MzEzMQ==",
lat: 60.22554,
lon: 24.89532
},
{
id: "U3RvcDpIU0w6MTI5MzE2NQ==",
lat: 60.22498,
lon: 24.89848
},
{
id: "U3RvcDpIU0w6MTI5MzE2Mw==",
lat: 60.22682,
lon: 24.90304
},
{
id: "U3RvcDpIU0w6MTI5MzEyMQ==",
lat: 60.22898,
lon: 24.901535
},
{
id: "U3RvcDpIU0w6MTI5MzE1OQ==",
lat: 60.22425,
lon: 24.90594
},
{
id: "U3RvcDpIU0w6MTI5MzEwMA==",
lat: 60.222307,
lon: 24.904608
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MTE2Ng==",
lat: 60.218707,
lon: 24.900578
},
{
id: "U3RvcDpIU0w6MTI5MTE2NQ==",
lat: 60.21756,
lon: 24.902964
},
{
id: "U3RvcDpIU0w6MTI5MTE2Mw==",
lat: 60.216496,
lon: 24.904956
},
{
id: "U3RvcDpIU0w6MTI5MTE0OA==",
lat: 60.21565,
lon: 24.90568
},
{
id: "U3RvcDpIU0w6MTI5MTE2Mg==",
lat: 60.21446,
lon: 24.903403
},
{
id: "U3RvcDpIU0w6MTI5MTE2MA==",
lat: 60.215385,
lon: 24.900687
},
{
id: "U3RvcDpIU0w6MTI5MTEwNw==",
lat: 60.215112,
lon: 24.898336
},
{
id: "U3RvcDpIU0w6MTI5MTEwMQ==",
lat: 60.212498,
lon: 24.898984
},
{
id: "U3RvcDpIU0w6MTI5MjEwNA==",
lat: 60.211553,
lon: 24.903287
},
{
id: "U3RvcDpIU0w6MTI5MjEwMA==",
lat: 60.210744,
lon: 24.903763
},
{
id: "U3RvcDpIU0w6MTI5MjEwMg==",
lat: 60.209397,
lon: 24.90357
},
{
id: "U3RvcDpIU0w6MTI5MjEyMg==",
lat: 60.208153,
lon: 24.902368
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEzNw==",
lat: 60.20882,
lon: 24.88933
},
{
id: "U3RvcDpIU0w6MTI5MTE5OQ==",
lat: 60.21051,
lon: 24.8858
},
{
id: "U3RvcDpIU0w6MTI5MTEzOQ==",
lat: 60.21066,
lon: 24.8805
},
{
id: "U3RvcDpIU0w6MTMwNDEwNQ==",
lat: 60.205858,
lon: 24.87594
},
{
id: "U3RvcDpIU0w6MTMwNDE1MA==",
lat: 60.20687,
lon: 24.879902
},
{
id: "U3RvcDpIU0w6MTI5MTEzOA==",
lat: 60.21059,
lon: 24.8809
},
{
id: "U3RvcDpIU0w6MTI5MTE5OA==",
lat: 60.210445,
lon: 24.885147
},
{
id: "U3RvcDpIU0w6MTI5MTExOQ==",
lat: 60.209999,
lon: 24.888297
},
{
id: "U3RvcDpIU0w6MTE2MDExOA==",
lat: 60.207853,
lon: 24.900612
},
{
id: "U3RvcDpIU0w6MTI5MjEwMQ==",
lat: 60.209607,
lon: 24.903798
},
{
id: "U3RvcDpIU0w6MTI5MjEwMw==",
lat: 60.210893,
lon: 24.903918
},
{
id: "U3RvcDpIU0w6MTI5MjEwNQ==",
lat: 60.211942,
lon: 24.902868
},
{
id: "U3RvcDpIU0w6MTI5MTEwOQ==",
lat: 60.212396,
lon: 24.898983
},
{
id: "U3RvcDpIU0w6MTI5MTEwNg==",
lat: 60.21582,
lon: 24.898291
},
{
id: "U3RvcDpIU0w6MTI5MTE1OQ==",
lat: 60.21567,
lon: 24.899462
},
{
id: "U3RvcDpIU0w6MTI5MTE2MQ==",
lat: 60.214487,
lon: 24.903331
},
{
id: "U3RvcDpIU0w6MTI5MTE2NA==",
lat: 60.216316,
lon: 24.905322
},
{
id: "U3RvcDpIU0w6MTI5MTE2OQ==",
lat: 60.217809,
lon: 24.902551
},
{
id: "U3RvcDpIU0w6MTI5MTE2OA==",
lat: 60.218671,
lon: 24.900889
},
{
id: "U3RvcDpIU0w6MTI5MTEyNQ==",
lat: 60.21965,
lon: 24.90171
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzE1OA==",
lat: 60.22399,
lon: 24.90612
},
{
id: "U3RvcDpIU0w6MTI5MzE2Mg==",
lat: 60.22686,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE2NA==",
lat: 60.22513,
lon: 24.89841
},
{
id: "U3RvcDpIU0w6MTI5MzEzMA==",
lat: 60.22566,
lon: 24.89553
},
{
id: "U3RvcDpIU0w6MTI5MzEzMg==",
lat: 60.22999,
lon: 24.895167
},
{
id: "U3RvcDpIU0w6MTI5MzEzNA==",
lat: 60.23137,
lon: 24.89199
},
{
id: "U3RvcDpIU0w6MTI5MzE3Mw==",
lat: 60.232603,
lon: 24.889643
},
{
id: "U3RvcDpIU0w6MTI5NDEzNw==",
lat: 60.23296,
lon: 24.88799
},
{
id: "U3RvcDpIU0w6MTI5NDE0MQ==",
lat: 60.230629,
lon: 24.881719
},
{
id: "U3RvcDpIU0w6MTI5NDEwMg==",
lat: 60.22923,
lon: 24.884431
}
]
},
{
gtfsId: "HSL:1085B",
shortName: "85B",
longName: "Herttoniemi(M)-Yliskylä-Jollas",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ5MjE0OQ==",
lat: 60.17061,
lon: 25.07991
},
{
id: "U3RvcDpIU0w6MTQ5MjE0OA==",
lat: 60.16778,
lon: 25.0805
},
{
id: "U3RvcDpIU0w6MTQ5MjE1Mg==",
lat: 60.1661,
lon: 25.07956
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Ng==",
lat: 60.16546,
lon: 25.0758
},
{
id: "U3RvcDpIU0w6MTQ5MjE0NA==",
lat: 60.164,
lon: 25.06984
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Mg==",
lat: 60.16455,
lon: 25.06189
},
{
id: "U3RvcDpIU0w6MTQ5MTEzOA==",
lat: 60.16636,
lon: 25.05391
},
{
id: "U3RvcDpIU0w6MTQ5MTEzNg==",
lat: 60.16864,
lon: 25.04855
},
{
id: "U3RvcDpIU0w6MTQ5MTEzNA==",
lat: 60.17222,
lon: 25.04957
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMg==",
lat: 60.176,
lon: 25.05177
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OQ==",
lat: 60.178132,
lon: 25.053262
},
{
id: "U3RvcDpIU0w6MTQ5MTEyOQ==",
lat: 60.17805,
lon: 25.05738
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNw==",
lat: 60.18081,
lon: 25.0596
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNQ==",
lat: 60.18384,
lon: 25.05705
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMw==",
lat: 60.18389,
lon: 25.05198
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
},
{
id: "U3RvcDpIU0w6MTQzMTEwNg==",
lat: 60.19456,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMg==",
lat: 60.18382,
lon: 25.05227
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNA==",
lat: 60.18367,
lon: 25.05709
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNg==",
lat: 60.18038,
lon: 25.05966
},
{
id: "U3RvcDpIU0w6MTQ5MTEyOA==",
lat: 60.17809,
lon: 25.05687
},
{
id: "U3RvcDpIU0w6MTQ5MTE3MA==",
lat: 60.178258,
lon: 25.0532
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMQ==",
lat: 60.17559,
lon: 25.05111
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMw==",
lat: 60.17203,
lon: 25.04925
},
{
id: "U3RvcDpIU0w6MTQ5NTEzNQ==",
lat: 60.16803,
lon: 25.0489
},
{
id: "U3RvcDpIU0w6MTQ5MjEzNw==",
lat: 60.16596,
lon: 25.05495
},
{
id: "U3RvcDpIU0w6MTQ5MjE0MQ==",
lat: 60.16448,
lon: 25.06189
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Mw==",
lat: 60.16404,
lon: 25.07081
},
{
id: "U3RvcDpIU0w6MTQ5MjE0NQ==",
lat: 60.16544,
lon: 25.07604
},
{
id: "U3RvcDpIU0w6MTQ5MjE1MQ==",
lat: 60.16611,
lon: 25.08049
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Nw==",
lat: 60.16808,
lon: 25.08038
}
]
},
{
gtfsId: "HSL:1097V",
shortName: "97V",
longName: "Itäkeskus(M)-Puotila-Vartioharju-Mellunmäki(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzEzMA==",
lat: 60.20975,
lon: 25.07745
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMQ==",
lat: 60.2075,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6MTQ1NTExMA==",
lat: 60.2067,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ1NTEyOQ==",
lat: 60.2078,
lon: 25.0823
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMQ==",
lat: 60.20916,
lon: 25.08738
},
{
id: "U3RvcDpIU0w6MTQ1MjEzMw==",
lat: 60.21087,
lon: 25.09252
},
{
id: "U3RvcDpIU0w6MTQ1MjE0Mw==",
lat: 60.21244,
lon: 25.09675
},
{
id: "U3RvcDpIU0w6MTQ1MjEzNw==",
lat: 60.21347,
lon: 25.09955
},
{
id: "U3RvcDpIU0w6MTQ1MTE3NA==",
lat: 60.215,
lon: 25.10471
},
{
id: "U3RvcDpIU0w6MTQ1MTExNA==",
lat: 60.21641,
lon: 25.11116
},
{
id: "U3RvcDpIU0w6MTQ1MTEyMg==",
lat: 60.21834,
lon: 25.11409
},
{
id: "U3RvcDpIU0w6MTQ1MTEyMw==",
lat: 60.219729,
lon: 25.114695
},
{
id: "U3RvcDpIU0w6MTQ1MTEyNw==",
lat: 60.220948,
lon: 25.110713
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMQ==",
lat: 60.23339,
lon: 25.12882
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMw==",
lat: 60.23597,
lon: 25.12657
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNQ==",
lat: 60.23705,
lon: 25.11995
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNw==",
lat: 60.23693,
lon: 25.11624
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
},
{
id: "U3RvcDpIU0w6MTQ3MjEwMg==",
lat: 60.23845,
lon: 25.10902
},
{
id: "U3RvcDpIU0w6MTQ3MzExMA==",
lat: 60.23737,
lon: 25.11256
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOA==",
lat: 60.23681,
lon: 25.11628
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNg==",
lat: 60.23692,
lon: 25.12131
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNA==",
lat: 60.23551,
lon: 25.12729
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMg==",
lat: 60.23253,
lon: 25.12857
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTEyOA==",
lat: 60.220913,
lon: 25.110622
},
{
id: "U3RvcDpIU0w6MTQ1MTEyNA==",
lat: 60.219676,
lon: 25.114693
},
{
id: "U3RvcDpIU0w6MTQ1MTExNg==",
lat: 60.21833,
lon: 25.11394
},
{
id: "U3RvcDpIU0w6MTQ1MTExNQ==",
lat: 60.21634,
lon: 25.11096
},
{
id: "U3RvcDpIU0w6MTQ1MTEzOQ==",
lat: 60.21484,
lon: 25.10371
},
{
id: "U3RvcDpIU0w6MTQ1MjEzOA==",
lat: 60.21358,
lon: 25.09962
},
{
id: "U3RvcDpIU0w6MTQ1MjE0NA==",
lat: 60.21241,
lon: 25.09649
},
{
id: "U3RvcDpIU0w6MTQ1MjEzNA==",
lat: 60.21086,
lon: 25.09226
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMg==",
lat: 60.20912,
lon: 25.08664
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMA==",
lat: 60.20779,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1NTEwOQ==",
lat: 60.20635,
lon: 25.07659
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMg==",
lat: 60.20757,
lon: 25.07562
},
{
id: "U3RvcDpIU0w6MTQ1MzExMg==",
lat: 60.210165,
lon: 25.077287
}
]
},
{
gtfsId: "HSL:2119",
shortName: "119",
longName: "Tapiola-Niittykumpu",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDIxNg==",
lat: 60.170927,
lon: 24.765412
},
{
id: "U3RvcDpIU0w6MjIxNDI2MA==",
lat: 60.1731,
lon: 24.76742
},
{
id: "U3RvcDpIU0w6MjIxNDI2Mg==",
lat: 60.17554,
lon: 24.77028
},
{
id: "U3RvcDpIU0w6MjIxNDI2NA==",
lat: 60.17487,
lon: 24.77753
},
{
id: "U3RvcDpIU0w6MjIxNDI0OA==",
lat: 60.17461,
lon: 24.77896
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDIwNQ==",
lat: 60.169787,
lon: 24.781044
},
{
id: "U3RvcDpIU0w6MjIxNDIwOQ==",
lat: 60.171541,
lon: 24.781833
},
{
id: "U3RvcDpIU0w6MjIxNDIwNw==",
lat: 60.1703,
lon: 24.774672
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjIwNQ==",
lat: 60.169747,
lon: 24.791798
},
{
id: "U3RvcDpIU0w6MjIxMjIwNw==",
lat: 60.171459,
lon: 24.792788
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjI4NQ==",
lat: 60.174053,
lon: 24.793932
},
{
id: "U3RvcDpIU0w6MjIxMjIwOA==",
lat: 60.174421,
lon: 24.787575
},
{
id: "U3RvcDpIU0w6MjIxMjIwOQ==",
lat: 60.175355,
lon: 24.787783
},
{
id: "U3RvcDpIU0w6MjIxMjIwMQ==",
lat: 60.176837,
lon: 24.795025
},
{
id: "U3RvcDpIU0w6MjIxMjI5MA==",
lat: 60.175825,
lon: 24.7929
},
{
id: "U3RvcDpIU0w6MjIxMjIwMg==",
lat: 60.17525,
lon: 24.787332
},
{
id: "U3RvcDpIU0w6MjIxMjIwMw==",
lat: 60.174123,
lon: 24.788035
},
{
id: "U3RvcDpIU0w6MjIxMjI4Ng==",
lat: 60.17406,
lon: 24.79352
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIyMA==",
lat: 60.17531,
lon: 24.801599
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMTIwMg==",
lat: 60.177727,
lon: 24.803757
},
{
id: "U3RvcDpIU0w6MjIxMjIwNg==",
lat: 60.178578,
lon: 24.796085
},
{
id: "U3RvcDpIU0w6MjIxMjIxNw==",
lat: 60.17822,
lon: 24.79887
},
{
id: "U3RvcDpIU0w6MjIxMjIxNQ==",
lat: 60.1759,
lon: 24.80008
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMTI5Mg==",
lat: 60.17635,
lon: 24.80671
},
{
id: "U3RvcDpIU0w6MjIxMTIwNA==",
lat: 60.178327,
lon: 24.807795
},
{
id: "U3RvcDpIU0w6MjIxMTIxMQ==",
lat: 60.17718,
lon: 24.81083
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxMjIxMg==",
lat: 60.174583,
lon: 24.779316
},
{
id: "U3RvcDpIU0w6MjIxNDI2NQ==",
lat: 60.17491,
lon: 24.7764
},
{
id: "U3RvcDpIU0w6MjIxNDI2Mw==",
lat: 60.1761,
lon: 24.76991
},
{
id: "U3RvcDpIU0w6MjIxNDI2MQ==",
lat: 60.17339,
lon: 24.76721
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
}
]
},
{
gtfsId: "HSL:2239",
shortName: "239",
longName: "Leppävaara-Viherlaakso-Perusmäki-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIyNw==",
lat: 60.21927,
lon: 24.8107
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwMw==",
lat: 60.22572,
lon: 24.77758
},
{
id: "U3RvcDpIU0w6MjEzMjIwNQ==",
lat: 60.22578,
lon: 24.76438
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwNw==",
lat: 60.22686,
lon: 24.74108
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMQ==",
lat: 60.2317,
lon: 24.74358
},
{
id: "U3RvcDpIU0w6MjE0MTIwMQ==",
lat: 60.23675,
lon: 24.74327
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjcxMzIwMQ==",
lat: 60.25237,
lon: 24.72199
},
{
id: "U3RvcDpIU0w6MjcxMzIwMw==",
lat: 60.25325,
lon: 24.72546
},
{
id: "U3RvcDpIU0w6MjcxMzIwNQ==",
lat: 60.25329,
lon: 24.73325
},
{
id: "U3RvcDpIU0w6MjcxMzIwNw==",
lat: 60.25473,
lon: 24.73674
},
{
id: "U3RvcDpIU0w6MjcxMzIxNw==",
lat: 60.25984,
lon: 24.73473
},
{
id: "U3RvcDpIU0w6MjcxMzIxOA==",
lat: 60.2639,
lon: 24.73096
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxNw==",
lat: 60.26656,
lon: 24.73511
},
{
id: "U3RvcDpIU0w6MjcxNDIxOQ==",
lat: 60.26788,
lon: 24.72915
},
{
id: "U3RvcDpIU0w6MjcxNDIyMQ==",
lat: 60.26755,
lon: 24.7233
},
{
id: "U3RvcDpIU0w6MjcxNDIwOA==",
lat: 60.26922,
lon: 24.72146
},
{
id: "U3RvcDpIU0w6MjcxNDIzMg==",
lat: 60.27336,
lon: 24.72298
},
{
id: "U3RvcDpIU0w6MjcxNDIyNQ==",
lat: 60.27523,
lon: 24.71708
},
{
id: "U3RvcDpIU0w6MjcxNDI4OA==",
lat: 60.27559,
lon: 24.71467
},
{
id: "U3RvcDpIU0w6MjcxNDI3OQ==",
lat: 60.2775,
lon: 24.71419
},
{
id: "U3RvcDpIU0w6MjcxNDI4Ng==",
lat: 60.28103,
lon: 24.71065
},
{
id: "U3RvcDpIU0w6MjcxNDI5OA==",
lat: 60.28568,
lon: 24.70723
},
{
id: "U3RvcDpIU0w6MjcxNDIwNQ==",
lat: 60.28661,
lon: 24.7115
},
{
id: "U3RvcDpIU0w6MjcxNDIwMw==",
lat: 60.28796,
lon: 24.71484
},
{
id: "U3RvcDpIU0w6MjcxNDIxMQ==",
lat: 60.28834,
lon: 24.719273
},
{
id: "U3RvcDpIU0w6MjcxNDI1NQ==",
lat: 60.286994,
lon: 24.725706
},
{
id: "U3RvcDpIU0w6MjcxNDI1NA==",
lat: 60.28594,
lon: 24.73075
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mw==",
lat: 60.28618,
lon: 24.73694
},
{
id: "U3RvcDpIU0w6MjcxNTI1MQ==",
lat: 60.28582,
lon: 24.74113
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
},
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0OQ==",
lat: 60.28471,
lon: 24.74512
},
{
id: "U3RvcDpIU0w6MjcxNTI1MA==",
lat: 60.28549,
lon: 24.74204
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mg==",
lat: 60.28637,
lon: 24.73772
},
{
id: "U3RvcDpIU0w6MjcxNDI5Ng==",
lat: 60.28573,
lon: 24.73092
},
{
id: "U3RvcDpIU0w6MjcxNDI5OQ==",
lat: 60.287706,
lon: 24.722557
},
{
id: "U3RvcDpIU0w6MjcxNDIxMA==",
lat: 60.288488,
lon: 24.719048
},
{
id: "U3RvcDpIU0w6MjcxNDIwMg==",
lat: 60.28834,
lon: 24.7149
},
{
id: "U3RvcDpIU0w6MjcxNDIwNA==",
lat: 60.28652,
lon: 24.71082
},
{
id: "U3RvcDpIU0w6MjcxMTI3Ng==",
lat: 60.28525,
lon: 24.70586
},
{
id: "U3RvcDpIU0w6MjcxNDI4Nw==",
lat: 60.28069,
lon: 24.71109
},
{
id: "U3RvcDpIU0w6MjcxNDI3OA==",
lat: 60.27783,
lon: 24.71334
},
{
id: "U3RvcDpIU0w6MjcxNDIyNw==",
lat: 60.2753,
lon: 24.71506
},
{
id: "U3RvcDpIU0w6MjcxNDIyNg==",
lat: 60.27505,
lon: 24.71838
},
{
id: "U3RvcDpIU0w6MjcxNDIyNA==",
lat: 60.27337,
lon: 24.72279
},
{
id: "U3RvcDpIU0w6MjcxNDIwOQ==",
lat: 60.26933,
lon: 24.72145
},
{
id: "U3RvcDpIU0w6MjcxNDIyMg==",
lat: 60.26794,
lon: 24.72179
},
{
id: "U3RvcDpIU0w6MjcxNDIyMA==",
lat: 60.26766,
lon: 24.73043
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMzIxOQ==",
lat: 60.26278,
lon: 24.73192
},
{
id: "U3RvcDpIU0w6MjcxMzIxNg==",
lat: 60.25885,
lon: 24.73459
},
{
id: "U3RvcDpIU0w6MjcxMzIwOA==",
lat: 60.25466,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjcxMzIwNg==",
lat: 60.25333,
lon: 24.73323
},
{
id: "U3RvcDpIU0w6MjcxMzIwNA==",
lat: 60.25327,
lon: 24.72461
},
{
id: "U3RvcDpIU0w6MjcxMzIwMg==",
lat: 60.25185,
lon: 24.7206
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNA==",
lat: 60.23995,
lon: 24.74098
},
{
id: "U3RvcDpIU0w6MjE1MTIyMg==",
lat: 60.23515,
lon: 24.74405
},
{
id: "U3RvcDpIU0w6MjE1MTIxMg==",
lat: 60.2317,
lon: 24.74328
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIwOA==",
lat: 60.22675,
lon: 24.74088
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMjIwOA==",
lat: 60.225528,
lon: 24.760625
},
{
id: "U3RvcDpIU0w6MjEzMjIwNg==",
lat: 60.225743,
lon: 24.766743
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIxMQ==",
lat: 60.22155,
lon: 24.80653
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:2118",
shortName: "118",
longName: "Tapiola(M)-Suurpelto-Espoon keskus-Kauklahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIxMTIyNQ==",
lat: 60.175006,
lon: 24.804031
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mw==",
lat: 60.17122,
lon: 24.77009
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
},
{
id: "U3RvcDpIU0w6MjMyMjI5NA==",
lat: 60.17555,
lon: 24.75881
},
{
id: "U3RvcDpIU0w6MjMyMjI5Ng==",
lat: 60.17963,
lon: 24.75916
},
{
id: "U3RvcDpIU0w6MjMyMjIwNw==",
lat: 60.18104,
lon: 24.75875
},
{
id: "U3RvcDpIU0w6MjI0MTIzOA==",
lat: 60.18139,
lon: 24.75348
},
{
id: "U3RvcDpIU0w6MjMzMTIwNg==",
lat: 60.18218,
lon: 24.74539
},
{
id: "U3RvcDpIU0w6MjMzMTIwOA==",
lat: 60.184573,
lon: 24.7443
},
{
id: "U3RvcDpIU0w6MjMzMjIxMQ==",
lat: 60.186421,
lon: 24.7434
},
{
id: "U3RvcDpIU0w6MjMzMjIwNw==",
lat: 60.190021,
lon: 24.741632
},
{
id: "U3RvcDpIU0w6MjI0MTIxMQ==",
lat: 60.187875,
lon: 24.750442
},
{
id: "U3RvcDpIU0w6Mjk4ODIwOA==",
lat: 60.20723,
lon: 24.69643
},
{
id: "U3RvcDpIU0w6MjYxMjI2Ng==",
lat: 60.20617,
lon: 24.68758
},
{
id: "U3RvcDpIU0w6MjYxMzI3NA==",
lat: 60.20577,
lon: 24.68168
},
{
id: "U3RvcDpIU0w6MjYxMzI3MQ==",
lat: 60.20622,
lon: 24.67345
},
{
id: "U3RvcDpIU0w6MjYxMzIxNw==",
lat: 60.20508,
lon: 24.67367
},
{
id: "U3RvcDpIU0w6MjYxMzIxNQ==",
lat: 60.20246,
lon: 24.66925
},
{
id: "U3RvcDpIU0w6MjYxMzAwMA==",
lat: 60.201,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxNTIzMA==",
lat: 60.20332,
lon: 24.65198
},
{
id: "U3RvcDpIU0w6MjYxMTI0OQ==",
lat: 60.2057,
lon: 24.65781
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYyMTIyMg==",
lat: 60.21448,
lon: 24.65221
},
{
id: "U3RvcDpIU0w6MjYyMTIwNA==",
lat: 60.21482,
lon: 24.64804
},
{
id: "U3RvcDpIU0w6MjYyMTIwNg==",
lat: 60.21173,
lon: 24.64243
},
{
id: "U3RvcDpIU0w6MjYyMTIwMg==",
lat: 60.20934,
lon: 24.64173
},
{
id: "U3RvcDpIU0w6MjYyMTIxNQ==",
lat: 60.20776,
lon: 24.64132
},
{
id: "U3RvcDpIU0w6MjYyMTIxNg==",
lat: 60.20645,
lon: 24.63912
},
{
id: "U3RvcDpIU0w6MjYyMTIwOQ==",
lat: 60.20362,
lon: 24.63538
},
{
id: "U3RvcDpIU0w6MjYyMTIxOQ==",
lat: 60.20235,
lon: 24.63106
},
{
id: "U3RvcDpIU0w6MjYyMTIxMQ==",
lat: 60.20018,
lon: 24.62665
},
{
id: "U3RvcDpIU0w6MjUxMTIwMQ==",
lat: 60.19825,
lon: 24.62125
},
{
id: "U3RvcDpIU0w6MjUxMTI0MQ==",
lat: 60.19602,
lon: 24.61495
},
{
id: "U3RvcDpIU0w6MjUxMTIwMw==",
lat: 60.193139,
lon: 24.609917
},
{
id: "U3RvcDpIU0w6MjUxMTIwNQ==",
lat: 60.192161,
lon: 24.607148
},
{
id: "U3RvcDpIU0w6MjUxMTIzNQ==",
lat: 60.190312,
lon: 24.601027
},
{
id: "U3RvcDpIU0w6MjUxMTIzNw==",
lat: 60.18797,
lon: 24.59555
},
{
id: "U3RvcDpIU0w6MjUxMTIzMw==",
lat: 60.18683,
lon: 24.59231
},
{
id: "U3RvcDpIU0w6MjUxMTIzOQ==",
lat: 60.186662,
lon: 24.588232
},
{
id: "U3RvcDpIU0w6MjUxMTI1Nw==",
lat: 60.18826,
lon: 24.586646
},
{
id: "U3RvcDpIU0w6MjUxMTI0MA==",
lat: 60.186314,
lon: 24.589023
},
{
id: "U3RvcDpIU0w6MjUxMTIzNA==",
lat: 60.186698,
lon: 24.592018
},
{
id: "U3RvcDpIU0w6MjUxMTIzOA==",
lat: 60.18847,
lon: 24.59719
},
{
id: "U3RvcDpIU0w6MjUxMTIzNg==",
lat: 60.190499,
lon: 24.601866
},
{
id: "U3RvcDpIU0w6MjUxMTIwNg==",
lat: 60.192167,
lon: 24.60752
},
{
id: "U3RvcDpIU0w6MjUxMTIwNA==",
lat: 60.193368,
lon: 24.610889
},
{
id: "U3RvcDpIU0w6MjUxMTI0Mg==",
lat: 60.19635,
lon: 24.61609
},
{
id: "U3RvcDpIU0w6MjUxMTIwMg==",
lat: 60.19834,
lon: 24.62217
},
{
id: "U3RvcDpIU0w6MjYyMTIxMg==",
lat: 60.19974,
lon: 24.62609
},
{
id: "U3RvcDpIU0w6MjYyMTIxOA==",
lat: 60.20277,
lon: 24.63325
},
{
id: "U3RvcDpIU0w6MjYyMTIxMA==",
lat: 60.20425,
lon: 24.63749
},
{
id: "U3RvcDpIU0w6MjYyMTIwOA==",
lat: 60.20759,
lon: 24.64111
},
{
id: "U3RvcDpIU0w6MjYyMTIwMw==",
lat: 60.208636,
lon: 24.642381
},
{
id: "U3RvcDpIU0w6MjYyMTIwNw==",
lat: 60.21239,
lon: 24.64336
},
{
id: "U3RvcDpIU0w6MjYyMTIwNQ==",
lat: 60.21468,
lon: 24.64968
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMzAwOA==",
lat: 60.202736,
lon: 24.661962
},
{
id: "U3RvcDpIU0w6MjYxMzAwMQ==",
lat: 60.20123,
lon: 24.6671
},
{
id: "U3RvcDpIU0w6MjYxMzIxNg==",
lat: 60.2028,
lon: 24.67021
},
{
id: "U3RvcDpIU0w6MjYxMzIxOA==",
lat: 60.20462,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjYxMzI3Mw==",
lat: 60.20667,
lon: 24.67446
},
{
id: "U3RvcDpIU0w6MjYxMzI3NQ==",
lat: 60.20559,
lon: 24.68208
},
{
id: "U3RvcDpIU0w6MjYxMjI2OQ==",
lat: 60.2063,
lon: 24.68963
},
{
id: "U3RvcDpIU0w6MjMzMTIwNw==",
lat: 60.189316,
lon: 24.741816
},
{
id: "U3RvcDpIU0w6MjMzMTIxMQ==",
lat: 60.186573,
lon: 24.743208
},
{
id: "U3RvcDpIU0w6MjMzMTIwOQ==",
lat: 60.18293,
lon: 24.74496
},
{
id: "U3RvcDpIU0w6MjI0MTIzNw==",
lat: 60.18099,
lon: 24.75528
},
{
id: "U3RvcDpIU0w6MjMyMjIxNg==",
lat: 60.18048,
lon: 24.75964
},
{
id: "U3RvcDpIU0w6MjMyMjI5NQ==",
lat: 60.17621,
lon: 24.75872
},
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDI0NA==",
lat: 60.170943,
lon: 24.772035
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
}
]
},
{
gtfsId: "HSL:2238",
shortName: "238",
longName: "Leppävaara-Nupuri-Brobacka-Siikajärvi-Siikaniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjY0MzIyOQ==",
lat: 60.2888,
lon: 24.51592
},
{
id: "U3RvcDpIU0w6MjY0MzIyOA==",
lat: 60.28964,
lon: 24.52164
},
{
id: "U3RvcDpIU0w6MjY0MzIyNg==",
lat: 60.28803,
lon: 24.52747
},
{
id: "U3RvcDpIU0w6MjY0MzIyNA==",
lat: 60.28688,
lon: 24.53132
},
{
id: "U3RvcDpIU0w6MjY0MzIyMg==",
lat: 60.28253,
lon: 24.52684
},
{
id: "U3RvcDpIU0w6MjY0MzIyMA==",
lat: 60.27895,
lon: 24.51624
},
{
id: "U3RvcDpIU0w6MjY0MzIxOA==",
lat: 60.27687,
lon: 24.51393
},
{
id: "U3RvcDpIU0w6MjY0MzIxNg==",
lat: 60.27237,
lon: 24.51821
},
{
id: "U3RvcDpIU0w6MjY0MzI3Mw==",
lat: 60.26872,
lon: 24.52941
},
{
id: "U3RvcDpIU0w6MjY0MzI3MQ==",
lat: 60.26519,
lon: 24.53274
},
{
id: "U3RvcDpIU0w6MjY0MzI2OQ==",
lat: 60.2637,
lon: 24.53957
},
{
id: "U3RvcDpIU0w6MjY0MzI4Mw==",
lat: 60.26238,
lon: 24.54519
},
{
id: "U3RvcDpIU0w6MjY0MzI0Mw==",
lat: 60.26234,
lon: 24.5512
},
{
id: "U3RvcDpIU0w6MjY0MzI0MQ==",
lat: 60.26157,
lon: 24.56307
},
{
id: "U3RvcDpIU0w6MjY0MzI4MQ==",
lat: 60.25745,
lon: 24.57105
},
{
id: "U3RvcDpIU0w6MjY0MjIzOQ==",
lat: 60.25699,
lon: 24.57916
},
{
id: "U3RvcDpIU0w6MjY0MjI3OQ==",
lat: 60.25592,
lon: 24.58477
},
{
id: "U3RvcDpIU0w6MjY0MjI3Nw==",
lat: 60.25288,
lon: 24.5884
},
{
id: "U3RvcDpIU0w6MjY0MjI3NQ==",
lat: 60.24895,
lon: 24.59049
},
{
id: "U3RvcDpIU0w6MjY0MjIzNw==",
lat: 60.24354,
lon: 24.59318
},
{
id: "U3RvcDpIU0w6MjY0MjI4NQ==",
lat: 60.23869,
lon: 24.5967
},
{
id: "U3RvcDpIU0w6MjY0MjIwNg==",
lat: 60.23713,
lon: 24.5973
},
{
id: "U3RvcDpIU0w6MjY0MjIwNA==",
lat: 60.23408,
lon: 24.60218
},
{
id: "U3RvcDpIU0w6MjY0MjIwMg==",
lat: 60.23044,
lon: 24.60938
},
{
id: "U3RvcDpIU0w6MjYzNDIxNA==",
lat: 60.22535,
lon: 24.62021
},
{
id: "U3RvcDpIU0w6MjYzNDIxMg==",
lat: 60.22296,
lon: 24.62769
},
{
id: "U3RvcDpIU0w6MjYzNDIxMA==",
lat: 60.22181,
lon: 24.63336
},
{
id: "U3RvcDpIU0w6MjYzNDIwOA==",
lat: 60.22106,
lon: 24.64406
},
{
id: "U3RvcDpIU0w6MjYzMTIwNg==",
lat: 60.22154,
lon: 24.65273
},
{
id: "U3RvcDpIU0w6MjYzMzIyMg==",
lat: 60.22298,
lon: 24.66
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMTIwNA==",
lat: 60.22248,
lon: 24.67796
},
{
id: "U3RvcDpIU0w6MjYzMTIwMg==",
lat: 60.22336,
lon: 24.68962
},
{
id: "U3RvcDpIU0w6MjE1MjIyNw==",
lat: 60.2235,
lon: 24.69601
},
{
id: "U3RvcDpIU0w6MzE3MDI0MQ==",
lat: 60.2239,
lon: 24.70847
},
{
id: "U3RvcDpIU0w6MjE1MTIwNg==",
lat: 60.22434,
lon: 24.72396
},
{
id: "U3RvcDpIU0w6MjE1MTIwNA==",
lat: 60.22519,
lon: 24.73771
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMjIwOA==",
lat: 60.225528,
lon: 24.760625
},
{
id: "U3RvcDpIU0w6MjEzMjIwNg==",
lat: 60.225743,
lon: 24.766743
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIxMQ==",
lat: 60.22155,
lon: 24.80653
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIzMA==",
lat: 60.21927,
lon: 24.81018
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwMw==",
lat: 60.22572,
lon: 24.77758
},
{
id: "U3RvcDpIU0w6MjEzMjIwNQ==",
lat: 60.22578,
lon: 24.76438
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwMw==",
lat: 60.22521,
lon: 24.73631
},
{
id: "U3RvcDpIU0w6MjE1MTIwNQ==",
lat: 60.22459,
lon: 24.72212
},
{
id: "U3RvcDpIU0w6MjE1MjIyNg==",
lat: 60.22419,
lon: 24.70554
},
{
id: "U3RvcDpIU0w6MjE1MjIyOA==",
lat: 60.22358,
lon: 24.69408
},
{
id: "U3RvcDpIU0w6MjYzMTIwMQ==",
lat: 60.22342,
lon: 24.68808
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMzIyMA==",
lat: 60.22261,
lon: 24.65842
},
{
id: "U3RvcDpIU0w6MjYzMTIwNQ==",
lat: 60.22153,
lon: 24.65084
},
{
id: "U3RvcDpIU0w6MjYzNDIwNw==",
lat: 60.22114,
lon: 24.6424
},
{
id: "U3RvcDpIU0w6MjYzNDIwOQ==",
lat: 60.22177,
lon: 24.63425
},
{
id: "U3RvcDpIU0w6MjYzNDIxMQ==",
lat: 60.22333,
lon: 24.62652
},
{
id: "U3RvcDpIU0w6MjYzNDIxMw==",
lat: 60.22492,
lon: 24.6214
},
{
id: "U3RvcDpIU0w6MjY0MjIwMQ==",
lat: 60.23029,
lon: 24.60998
},
{
id: "U3RvcDpIU0w6MjY0MjIwMw==",
lat: 60.23468,
lon: 24.60146
},
{
id: "U3RvcDpIU0w6MjY0MjIwNQ==",
lat: 60.23769,
lon: 24.59669
},
{
id: "U3RvcDpIU0w6MjY0MjI4NA==",
lat: 60.23911,
lon: 24.59706
},
{
id: "U3RvcDpIU0w6MjY0MjIzOA==",
lat: 60.24476,
lon: 24.59264
},
{
id: "U3RvcDpIU0w6MjY0MjI4MA==",
lat: 60.24947,
lon: 24.59048
},
{
id: "U3RvcDpIU0w6MjY0MjI3Ng==",
lat: 60.2529,
lon: 24.58849
},
{
id: "U3RvcDpIU0w6MjY0MjI3OA==",
lat: 60.25611,
lon: 24.58457
},
{
id: "U3RvcDpIU0w6MjY0MjI0MA==",
lat: 60.25708,
lon: 24.57886
},
{
id: "U3RvcDpIU0w6MjY0MzI4MA==",
lat: 60.25763,
lon: 24.57082
},
{
id: "U3RvcDpIU0w6MjY0MzI0Mg==",
lat: 60.2617,
lon: 24.56271
},
{
id: "U3RvcDpIU0w6MjY0MzI0NA==",
lat: 60.26249,
lon: 24.55054
},
{
id: "U3RvcDpIU0w6MjY0MzI4Mg==",
lat: 60.26253,
lon: 24.54572
},
{
id: "U3RvcDpIU0w6MjY0MzI3MA==",
lat: 60.26378,
lon: 24.5395
},
{
id: "U3RvcDpIU0w6MjY0MzI3Mg==",
lat: 60.26526,
lon: 24.53278
},
{
id: "U3RvcDpIU0w6MjY0MzI3NA==",
lat: 60.26851,
lon: 24.52949
},
{
id: "U3RvcDpIU0w6MjY0MzIxNQ==",
lat: 60.27268,
lon: 24.51765
},
{
id: "U3RvcDpIU0w6MjY0MzIxNw==",
lat: 60.27723,
lon: 24.5142
},
{
id: "U3RvcDpIU0w6MjY0MzIxOQ==",
lat: 60.27917,
lon: 24.51706
},
{
id: "U3RvcDpIU0w6MjY0MzIyMQ==",
lat: 60.28269,
lon: 24.52715
},
{
id: "U3RvcDpIU0w6MjY0MzIyMw==",
lat: 60.28683,
lon: 24.53186
},
{
id: "U3RvcDpIU0w6MjY0MzIyNQ==",
lat: 60.28839,
lon: 24.52685
},
{
id: "U3RvcDpIU0w6MjY0MzIyNw==",
lat: 60.28961,
lon: 24.52204
}
]
},
{
gtfsId: "HSL:2117",
shortName: "117",
longName: "Tapiola-Aarnivalkea-Itäranta-Tapiola",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIxMTIwNA==",
lat: 60.178327,
lon: 24.807795
},
{
id: "U3RvcDpIU0w6MjIxMTIxMQ==",
lat: 60.17718,
lon: 24.81083
},
{
id: "U3RvcDpIU0w6MjIxMTI5Mg==",
lat: 60.17635,
lon: 24.80671
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMTIyMA==",
lat: 60.17531,
lon: 24.801599
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMTIwMg==",
lat: 60.177727,
lon: 24.803757
},
{
id: "U3RvcDpIU0w6MjIxMjIwNg==",
lat: 60.178578,
lon: 24.796085
},
{
id: "U3RvcDpIU0w6MjIxMjIxNg==",
lat: 60.17928,
lon: 24.79851
},
{
id: "U3RvcDpIU0w6MjIxMTIxMA==",
lat: 60.182026,
lon: 24.802099
},
{
id: "U3RvcDpIU0w6MjIxMTIwOA==",
lat: 60.182508,
lon: 24.806869
},
{
id: "U3RvcDpIU0w6MjIxMzIxNg==",
lat: 60.183674,
lon: 24.811407
},
{
id: "U3RvcDpIU0w6MjIxMzIxMw==",
lat: 60.181449,
lon: 24.815654
},
{
id: "U3RvcDpIU0w6MjIxMzIwNw==",
lat: 60.17895,
lon: 24.8207
},
{
id: "U3RvcDpIU0w6MjIxMzIwNQ==",
lat: 60.174905,
lon: 24.825088
},
{
id: "U3RvcDpIU0w6MjIxMzIxMQ==",
lat: 60.177534,
lon: 24.824296
},
{
id: "U3RvcDpIU0w6MjIxMzIwNg==",
lat: 60.17908,
lon: 24.82074
},
{
id: "U3RvcDpIU0w6MjIxMzIwOA==",
lat: 60.17872,
lon: 24.81654
},
{
id: "U3RvcDpIU0w6MjIxMTIxOQ==",
lat: 60.178265,
lon: 24.807971
}
]
},
{
gtfsId: "HSL:1061T",
shortName: "61T",
longName: "Rautatientori-Pukinmäki-Tapaninkylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM5MjE1NA==",
lat: 60.26573,
lon: 25.01614
},
{
id: "U3RvcDpIU0w6MTQwMzE2NA==",
lat: 60.26767,
lon: 25.01355
},
{
id: "U3RvcDpIU0w6MTQwMzE3NQ==",
lat: 60.26745,
lon: 25.00825
},
{
id: "U3RvcDpIU0w6MTQwMzE3Mg==",
lat: 60.26859,
lon: 25.00582
},
{
id: "U3RvcDpIU0w6MTQwMzEzMQ==",
lat: 60.26821,
lon: 25.00048
},
{
id: "U3RvcDpIU0w6MTQwMzEyOQ==",
lat: 60.267496,
lon: 24.995374
},
{
id: "U3RvcDpIU0w6MTQwMzEyNw==",
lat: 60.26665,
lon: 24.99296
},
{
id: "U3RvcDpIU0w6MTM5MTExMw==",
lat: 60.26397,
lon: 24.98368
},
{
id: "U3RvcDpIU0w6MTM5MTEyMw==",
lat: 60.2612,
lon: 24.98378
},
{
id: "U3RvcDpIU0w6MTM5MTEyMQ==",
lat: 60.25907,
lon: 24.98039
},
{
id: "U3RvcDpIU0w6MTM5MTExOQ==",
lat: 60.257,
lon: 24.98152
},
{
id: "U3RvcDpIU0w6MTM5MTExNw==",
lat: 60.25443,
lon: 24.98369
},
{
id: "U3RvcDpIU0w6MTM3MDExNA==",
lat: 60.25075,
lon: 24.98685
},
{
id: "U3RvcDpIU0w6MTM3MDExMg==",
lat: 60.24732,
lon: 24.99163
},
{
id: "U3RvcDpIU0w6MTM3MDExMA==",
lat: 60.24324,
lon: 24.99451
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM3MDEwNA==",
lat: 60.2399,
lon: 24.97954
},
{
id: "U3RvcDpIU0w6MTI4NDE3OA==",
lat: 60.23699,
lon: 24.97454
},
{
id: "U3RvcDpIU0w6MTI4NDE3NA==",
lat: 60.23539,
lon: 24.97034
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEyNw==",
lat: 60.23022,
lon: 24.94776
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDEyMw==",
lat: 60.17134,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDEwMw==",
lat: 60.19531,
lon: 24.95583
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDEyOQ==",
lat: 60.22999,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDE3Mg==",
lat: 60.23425,
lon: 24.96753
},
{
id: "U3RvcDpIU0w6MTI4NDE3NQ==",
lat: 60.23609,
lon: 24.97254
},
{
id: "U3RvcDpIU0w6MTM3MDEwMw==",
lat: 60.23991,
lon: 24.97993
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM3MDEwOQ==",
lat: 60.24398,
lon: 24.99386
},
{
id: "U3RvcDpIU0w6MTM3MDExMQ==",
lat: 60.24716,
lon: 24.99175
},
{
id: "U3RvcDpIU0w6MTM3MDExMw==",
lat: 60.25129,
lon: 24.98678
},
{
id: "U3RvcDpIU0w6MTM5MTExNg==",
lat: 60.25464,
lon: 24.9837
},
{
id: "U3RvcDpIU0w6MTM5MTExOA==",
lat: 60.257215,
lon: 24.981581
},
{
id: "U3RvcDpIU0w6MTM5MTEyMA==",
lat: 60.25975,
lon: 24.98156
},
{
id: "U3RvcDpIU0w6MTM5MTEyMg==",
lat: 60.26134,
lon: 24.98419
},
{
id: "U3RvcDpIU0w6MTM5MTExMg==",
lat: 60.26381,
lon: 24.98384
},
{
id: "U3RvcDpIU0w6MTQwMzEyNg==",
lat: 60.2669,
lon: 24.99344
},
{
id: "U3RvcDpIU0w6MTQwMzEyOA==",
lat: 60.26765,
lon: 24.99661
},
{
id: "U3RvcDpIU0w6MTQwMzEzMA==",
lat: 60.26832,
lon: 25.00157
},
{
id: "U3RvcDpIU0w6MTQwMzE3MQ==",
lat: 60.26855,
lon: 25.00607
},
{
id: "U3RvcDpIU0w6MTM5MTE5Ng==",
lat: 60.26709,
lon: 25.00979
},
{
id: "U3RvcDpIU0w6MTM5MjE4NQ==",
lat: 60.26738,
lon: 25.01464
}
]
},
{
gtfsId: "HSL:2116",
shortName: "116",
longName: "Tapiola-Pohjois-Tapiola",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIxMTIwNA==",
lat: 60.178327,
lon: 24.807795
},
{
id: "U3RvcDpIU0w6MjIxMTIxMQ==",
lat: 60.17718,
lon: 24.81083
},
{
id: "U3RvcDpIU0w6MjIxMTI5Mg==",
lat: 60.17635,
lon: 24.80671
},
{
id: "U3RvcDpIU0w6MjIxMTIzNg==",
lat: 60.17364,
lon: 24.81027
},
{
id: "U3RvcDpIU0w6MjIxMTIwMQ==",
lat: 60.173306,
lon: 24.814533
},
{
id: "U3RvcDpIU0w6MjIxMTIzNQ==",
lat: 60.17359,
lon: 24.81072
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMTI3NA==",
lat: 60.17223,
lon: 24.80195
},
{
id: "U3RvcDpIU0w6MjIxMjIwNA==",
lat: 60.17106,
lon: 24.798125
},
{
id: "U3RvcDpIU0w6MjIxMTI3NQ==",
lat: 60.17197,
lon: 24.80231
},
{
id: "U3RvcDpIU0w6MjIxMTIyMA==",
lat: 60.17531,
lon: 24.801599
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMTIwMg==",
lat: 60.177727,
lon: 24.803757
},
{
id: "U3RvcDpIU0w6MjIxMjIwNg==",
lat: 60.178578,
lon: 24.796085
},
{
id: "U3RvcDpIU0w6MjIxMjIxNg==",
lat: 60.17928,
lon: 24.79851
},
{
id: "U3RvcDpIU0w6MjIxMjIxOA==",
lat: 60.18134,
lon: 24.79634
},
{
id: "U3RvcDpIU0w6MjIxNTIwMQ==",
lat: 60.181031,
lon: 24.793058
},
{
id: "U3RvcDpIU0w6MjIxNTIwNw==",
lat: 60.184222,
lon: 24.792204
},
{
id: "U3RvcDpIU0w6MjIxNTIwOQ==",
lat: 60.185003,
lon: 24.793415
},
{
id: "U3RvcDpIU0w6MjIxNTIyMg==",
lat: 60.18663,
lon: 24.79671
},
{
id: "U3RvcDpIU0w6MjIxNTIxMQ==",
lat: 60.188393,
lon: 24.793605
},
{
id: "U3RvcDpIU0w6MjIxNTIxMA==",
lat: 60.187,
lon: 24.798904
},
{
id: "U3RvcDpIU0w6MjIxNTI4MA==",
lat: 60.18833,
lon: 24.79757
},
{
id: "U3RvcDpIU0w6MjIxNTI4NA==",
lat: 60.18945,
lon: 24.80021
},
{
id: "U3RvcDpIU0w6MjIxNTIwNA==",
lat: 60.18923,
lon: 24.805998
},
{
id: "U3RvcDpIU0w6MjIxNTI4Mg==",
lat: 60.18928,
lon: 24.80221
},
{
id: "U3RvcDpIU0w6MjIxNTI4Mw==",
lat: 60.18986,
lon: 24.80011
},
{
id: "U3RvcDpIU0w6MjIxNTI4MQ==",
lat: 60.18749,
lon: 24.79715
},
{
id: "U3RvcDpIU0w6MjIxNTIwOA==",
lat: 60.185162,
lon: 24.793173
},
{
id: "U3RvcDpIU0w6MjIxNTIwNg==",
lat: 60.183877,
lon: 24.791979
},
{
id: "U3RvcDpIU0w6MjIxNTIwNQ==",
lat: 60.181692,
lon: 24.790207
},
{
id: "U3RvcDpIU0w6MjIxNTIwMw==",
lat: 60.180874,
lon: 24.790718
},
{
id: "U3RvcDpIU0w6MjIxNTIwMg==",
lat: 60.181057,
lon: 24.793064
},
{
id: "U3RvcDpIU0w6MjIxMjIxOQ==",
lat: 60.18154,
lon: 24.79584
},
{
id: "U3RvcDpIU0w6MjIxMjIxNw==",
lat: 60.17822,
lon: 24.79887
},
{
id: "U3RvcDpIU0w6MjIxMjIxNQ==",
lat: 60.1759,
lon: 24.80008
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
}
]
},
{
gtfsId: "HSL:2236",
shortName: "236",
longName: "Leppävaara-Viherlaakso-Kalajärvi-Serena",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIyNw==",
lat: 60.21927,
lon: 24.8107
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwMw==",
lat: 60.22572,
lon: 24.77758
},
{
id: "U3RvcDpIU0w6MjEzMjIwNQ==",
lat: 60.22578,
lon: 24.76438
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwNw==",
lat: 60.22686,
lon: 24.74108
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMQ==",
lat: 60.2317,
lon: 24.74358
},
{
id: "U3RvcDpIU0w6MjE0MTIwMQ==",
lat: 60.23675,
lon: 24.74327
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjcxMzIwMQ==",
lat: 60.25237,
lon: 24.72199
},
{
id: "U3RvcDpIU0w6MjcxMzIwMw==",
lat: 60.25325,
lon: 24.72546
},
{
id: "U3RvcDpIU0w6MjcxMzIwNQ==",
lat: 60.25329,
lon: 24.73325
},
{
id: "U3RvcDpIU0w6MjcxMzIwNw==",
lat: 60.25473,
lon: 24.73674
},
{
id: "U3RvcDpIU0w6MjcxMzIxNw==",
lat: 60.25984,
lon: 24.73473
},
{
id: "U3RvcDpIU0w6MjcxMzIxOA==",
lat: 60.2639,
lon: 24.73096
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxOA==",
lat: 60.26626,
lon: 24.73717
},
{
id: "U3RvcDpIU0w6MjcxNTI5Mw==",
lat: 60.26702,
lon: 24.74761
},
{
id: "U3RvcDpIU0w6MjcxNTIxMw==",
lat: 60.27087,
lon: 24.75311
},
{
id: "U3RvcDpIU0w6MjcxNTIxNA==",
lat: 60.27323,
lon: 24.75052
},
{
id: "U3RvcDpIU0w6MjcxNTIwMg==",
lat: 60.275124,
lon: 24.749747
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
},
{
id: "U3RvcDpIU0w6MjcyMTIxMg==",
lat: 60.305,
lon: 24.74149
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMzIyOQ==",
lat: 60.31776,
lon: 24.71642
},
{
id: "U3RvcDpIU0w6MjcyMzIxMQ==",
lat: 60.32229,
lon: 24.71755
},
{
id: "U3RvcDpIU0w6MjcyMzIzMQ==",
lat: 60.323319,
lon: 24.7162
},
{
id: "U3RvcDpIU0w6MjcyMzI3OA==",
lat: 60.32804,
lon: 24.71869
},
{
id: "U3RvcDpIU0w6MjcyMzI5Mg==",
lat: 60.32493,
lon: 24.72689
},
{
id: "U3RvcDpIU0w6MjcyMzI4Mw==",
lat: 60.32415,
lon: 24.73677
},
{
id: "U3RvcDpIU0w6MjcyMzI5Mw==",
lat: 60.32517,
lon: 24.7268
},
{
id: "U3RvcDpIU0w6MjcyMzI3Nw==",
lat: 60.327726,
lon: 24.717678
},
{
id: "U3RvcDpIU0w6MjcyMzIzMg==",
lat: 60.324161,
lon: 24.714759
},
{
id: "U3RvcDpIU0w6MjcyMzIxMA==",
lat: 60.321463,
lon: 24.717534
},
{
id: "U3RvcDpIU0w6MjcyMzIzMA==",
lat: 60.31757,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIxMw==",
lat: 60.30444,
lon: 24.74096
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOQ==",
lat: 60.27787,
lon: 24.74963
},
{
id: "U3RvcDpIU0w6MjcxNTIxNQ==",
lat: 60.27398,
lon: 24.74953
},
{
id: "U3RvcDpIU0w6MjcxNTI0Nw==",
lat: 60.27007,
lon: 24.75398
},
{
id: "U3RvcDpIU0w6MjcxNTIxMA==",
lat: 60.26655,
lon: 24.74574
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMzIxOQ==",
lat: 60.26278,
lon: 24.73192
},
{
id: "U3RvcDpIU0w6MjcxMzIxNg==",
lat: 60.25885,
lon: 24.73459
},
{
id: "U3RvcDpIU0w6MjcxMzIwOA==",
lat: 60.25466,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjcxMzIwNg==",
lat: 60.25333,
lon: 24.73323
},
{
id: "U3RvcDpIU0w6MjcxMzIwNA==",
lat: 60.25327,
lon: 24.72461
},
{
id: "U3RvcDpIU0w6MjcxMzIwMg==",
lat: 60.25185,
lon: 24.7206
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNA==",
lat: 60.23995,
lon: 24.74098
},
{
id: "U3RvcDpIU0w6MjE1MTIyMg==",
lat: 60.23515,
lon: 24.74405
},
{
id: "U3RvcDpIU0w6MjE1MTIxMg==",
lat: 60.2317,
lon: 24.74328
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIwOA==",
lat: 60.22675,
lon: 24.74088
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMjIwOA==",
lat: 60.225528,
lon: 24.760625
},
{
id: "U3RvcDpIU0w6MjEzMjIwNg==",
lat: 60.225743,
lon: 24.766743
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIxMQ==",
lat: 60.22155,
lon: 24.80653
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:2115",
shortName: "115",
longName: "Tapiola(M)-Mankkaa",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIxMTIyMw==",
lat: 60.175106,
lon: 24.804759
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxMjIxMg==",
lat: 60.174583,
lon: 24.779316
},
{
id: "U3RvcDpIU0w6MjIxNDI4MA==",
lat: 60.17755,
lon: 24.7759
},
{
id: "U3RvcDpIU0w6MjIxNDIxMA==",
lat: 60.18035,
lon: 24.77136
},
{
id: "U3RvcDpIU0w6MjIxNDIwMw==",
lat: 60.18267,
lon: 24.76728
},
{
id: "U3RvcDpIU0w6MjMyMjIwNw==",
lat: 60.18104,
lon: 24.75875
},
{
id: "U3RvcDpIU0w6MjI0MTIzOA==",
lat: 60.18139,
lon: 24.75348
},
{
id: "U3RvcDpIU0w6MjI0MTI4MA==",
lat: 60.18329,
lon: 24.75372
},
{
id: "U3RvcDpIU0w6MjI0MTIxNQ==",
lat: 60.18637,
lon: 24.75837
},
{
id: "U3RvcDpIU0w6MjI0MTIxNw==",
lat: 60.18867,
lon: 24.76093
},
{
id: "U3RvcDpIU0w6MjI0MTIxOQ==",
lat: 60.19164,
lon: 24.76442
},
{
id: "U3RvcDpIU0w6MjI0MTIwNA==",
lat: 60.19414,
lon: 24.76971
},
{
id: "U3RvcDpIU0w6MjI0MTIzNA==",
lat: 60.19408,
lon: 24.76924
},
{
id: "U3RvcDpIU0w6MjI0MTIyMQ==",
lat: 60.19409,
lon: 24.7685
},
{
id: "U3RvcDpIU0w6MjI0MTIyMA==",
lat: 60.19148,
lon: 24.7639
},
{
id: "U3RvcDpIU0w6MjI0MTIxOA==",
lat: 60.18935,
lon: 24.76079
},
{
id: "U3RvcDpIU0w6MjI0MTIxNg==",
lat: 60.18608,
lon: 24.75704
},
{
id: "U3RvcDpIU0w6MjI0MTIxNA==",
lat: 60.18257,
lon: 24.75339
},
{
id: "U3RvcDpIU0w6MjI0MTIzNw==",
lat: 60.18099,
lon: 24.75528
},
{
id: "U3RvcDpIU0w6MjIxNDIwNA==",
lat: 60.18093,
lon: 24.76078
},
{
id: "U3RvcDpIU0w6MjIxNDIwOA==",
lat: 60.18091,
lon: 24.77047
},
{
id: "U3RvcDpIU0w6MjIxNDIwNg==",
lat: 60.17746,
lon: 24.7777
},
{
id: "U3RvcDpIU0w6MjIxNDI0OA==",
lat: 60.17461,
lon: 24.77896
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
}
]
},
{
gtfsId: "HSL:2235",
shortName: "235",
longName: "Elielinaukio-Leppävaara-Espoon keskus",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMTI1OA==",
lat: 60.20535,
lon: 24.65686
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMTIwNA==",
lat: 60.22248,
lon: 24.67796
},
{
id: "U3RvcDpIU0w6MjYzMTIwMg==",
lat: 60.22336,
lon: 24.68962
},
{
id: "U3RvcDpIU0w6MjE1MjIyNw==",
lat: 60.2235,
lon: 24.69601
},
{
id: "U3RvcDpIU0w6MzE3MDI0MQ==",
lat: 60.2239,
lon: 24.70847
},
{
id: "U3RvcDpIU0w6MjE1MTIwNg==",
lat: 60.22434,
lon: 24.72396
},
{
id: "U3RvcDpIU0w6MjE1MTIwNA==",
lat: 60.22519,
lon: 24.73771
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMzIyNQ==",
lat: 60.2266,
lon: 24.75783
},
{
id: "U3RvcDpIU0w6MjEzMzIxNg==",
lat: 60.228636,
lon: 24.764329
},
{
id: "U3RvcDpIU0w6MjEzMzIxNA==",
lat: 60.22959,
lon: 24.76923
},
{
id: "U3RvcDpIU0w6MjEzMzIxMg==",
lat: 60.22916,
lon: 24.77474
},
{
id: "U3RvcDpIU0w6MjEzMzIxOQ==",
lat: 60.22944,
lon: 24.77787
},
{
id: "U3RvcDpIU0w6MjEzMzIxMA==",
lat: 60.22674,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIwMA==",
lat: 60.22015,
lon: 24.80185
},
{
id: "U3RvcDpIU0w6MjExMTIwOA==",
lat: 60.21982,
lon: 24.81298
},
{
id: "U3RvcDpIU0w6MjExMTI1Ng==",
lat: 60.21934,
lon: 24.8217
},
{
id: "U3RvcDpIU0w6MjExMzIwNg==",
lat: 60.22042,
lon: 24.83513
},
{
id: "U3RvcDpIU0w6MjExMzIwNA==",
lat: 60.2211,
lon: 24.84182
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMA==",
lat: 60.224845,
lon: 24.850474
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDEzMQ==",
lat: 60.171741,
lon: 24.939733
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTIyMA==",
lat: 60.21031,
lon: 24.88865
},
{
id: "U3RvcDpIU0w6MTQ2NTE0Mw==",
lat: 60.214064,
lon: 24.880445
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzIxMQ==",
lat: 60.22455,
lon: 24.84853
},
{
id: "U3RvcDpIU0w6MjAwMDIwMw==",
lat: 60.22112,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6MjExMzIwNQ==",
lat: 60.22052,
lon: 24.83286
},
{
id: "U3RvcDpIU0w6MjExMTI4MA==",
lat: 60.21955,
lon: 24.82102
},
{
id: "U3RvcDpIU0w6MjExMTIwOQ==",
lat: 60.22007,
lon: 24.81252
},
{
id: "U3RvcDpIU0w6MjExMTI5OQ==",
lat: 60.22005,
lon: 24.80436
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwOQ==",
lat: 60.22671,
lon: 24.77975
},
{
id: "U3RvcDpIU0w6MjEzMzI2MA==",
lat: 60.22871,
lon: 24.77909
},
{
id: "U3RvcDpIU0w6MjEzMzIzNA==",
lat: 60.22965,
lon: 24.77683
},
{
id: "U3RvcDpIU0w6MjEzMzIxMQ==",
lat: 60.22934,
lon: 24.77365
},
{
id: "U3RvcDpIU0w6MjEzMzIxMw==",
lat: 60.22968,
lon: 24.76792
},
{
id: "U3RvcDpIU0w6MjEzMzIxNw==",
lat: 60.228,
lon: 24.76138
},
{
id: "U3RvcDpIU0w6MjEzMzIyNA==",
lat: 60.22695,
lon: 24.75707
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwMw==",
lat: 60.22521,
lon: 24.73631
},
{
id: "U3RvcDpIU0w6MjE1MTIwNQ==",
lat: 60.22459,
lon: 24.72212
},
{
id: "U3RvcDpIU0w6MjE1MjIyNg==",
lat: 60.22419,
lon: 24.70554
},
{
id: "U3RvcDpIU0w6MjE1MjIyOA==",
lat: 60.22358,
lon: 24.69408
},
{
id: "U3RvcDpIU0w6MjYzMTIwMQ==",
lat: 60.22342,
lon: 24.68808
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTIxOQ==",
lat: 60.205048,
lon: 24.65511
}
]
},
{
gtfsId: "HSL:2114",
shortName: "114",
longName: "Tapiola(M)-Urheilupuisto(M)-Mankkaa-Kilo-Leppävaara",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIzMA==",
lat: 60.21927,
lon: 24.81018
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIzNQ==",
lat: 60.22324,
lon: 24.78682
},
{
id: "U3RvcDpIU0w6MjEzMjI0Ng==",
lat: 60.21935,
lon: 24.78619
},
{
id: "U3RvcDpIU0w6MjEzMjI0NA==",
lat: 60.21692,
lon: 24.78652
},
{
id: "U3RvcDpIU0w6MjEzMjI0Mg==",
lat: 60.21727,
lon: 24.78061
},
{
id: "U3RvcDpIU0w6MjEzMjI0MA==",
lat: 60.21709,
lon: 24.77504
},
{
id: "U3RvcDpIU0w6MjEzMTI0MA==",
lat: 60.21447,
lon: 24.77096
},
{
id: "U3RvcDpIU0w6MjEzMTI0Mg==",
lat: 60.2117,
lon: 24.76733
},
{
id: "U3RvcDpIU0w6MjEzMTI0NA==",
lat: 60.21154,
lon: 24.76284
},
{
id: "U3RvcDpIU0w6MjEzMTI0Ng==",
lat: 60.20944,
lon: 24.75608
},
{
id: "U3RvcDpIU0w6MjEzMTI0OA==",
lat: 60.20843,
lon: 24.75262
},
{
id: "U3RvcDpIU0w6MjEzMTI1MA==",
lat: 60.207094,
lon: 24.752523
},
{
id: "U3RvcDpIU0w6MjI0MjIxMA==",
lat: 60.20325,
lon: 24.76069
},
{
id: "U3RvcDpIU0w6MjI0MjIwOA==",
lat: 60.19894,
lon: 24.76333
},
{
id: "U3RvcDpIU0w6MjI0MTIwNg==",
lat: 60.1964,
lon: 24.76588
},
{
id: "U3RvcDpIU0w6MjI0MTIwNA==",
lat: 60.19414,
lon: 24.76971
},
{
id: "U3RvcDpIU0w6MjI0MTIwMg==",
lat: 60.190816,
lon: 24.776774
},
{
id: "U3RvcDpIU0w6MjIxNTI1NQ==",
lat: 60.18678,
lon: 24.78434
},
{
id: "U3RvcDpIU0w6MjIxNTI1Mg==",
lat: 60.18278,
lon: 24.78483
},
{
id: "U3RvcDpIU0w6MjIxNDI1MQ==",
lat: 60.17792,
lon: 24.77849
},
{
id: "U3RvcDpIU0w6MjIxNDI0OA==",
lat: 60.17461,
lon: 24.77896
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
},
{
id: "U3RvcDpIU0w6MjIxMTIyMw==",
lat: 60.175106,
lon: 24.804759
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxMjIxMg==",
lat: 60.174583,
lon: 24.779316
},
{
id: "U3RvcDpIU0w6MjIxNDI1MA==",
lat: 60.17886,
lon: 24.77873
},
{
id: "U3RvcDpIU0w6MjIxNTI1Mw==",
lat: 60.1837,
lon: 24.78701
},
{
id: "U3RvcDpIU0w6MjIxNTI1NA==",
lat: 60.18768,
lon: 24.78284
},
{
id: "U3RvcDpIU0w6MjI0MTIwMQ==",
lat: 60.19135,
lon: 24.77608
},
{
id: "U3RvcDpIU0w6MjI0MTIwMw==",
lat: 60.19464,
lon: 24.76877
},
{
id: "U3RvcDpIU0w6MjI0MTIwNQ==",
lat: 60.19723,
lon: 24.76565
},
{
id: "U3RvcDpIU0w6MjI0MjIwNw==",
lat: 60.20009,
lon: 24.76279
},
{
id: "U3RvcDpIU0w6MjI0MjIwOQ==",
lat: 60.20413,
lon: 24.75998
},
{
id: "U3RvcDpIU0w6MjEzMTI1Nw==",
lat: 60.207166,
lon: 24.75329
},
{
id: "U3RvcDpIU0w6MjEzMTI0OQ==",
lat: 60.208477,
lon: 24.7532
},
{
id: "U3RvcDpIU0w6MjEzMTI0Nw==",
lat: 60.20968,
lon: 24.75843
},
{
id: "U3RvcDpIU0w6MjEzMTI0NQ==",
lat: 60.21167,
lon: 24.76432
},
{
id: "U3RvcDpIU0w6MjEzMTI0Mw==",
lat: 60.21193,
lon: 24.7701
},
{
id: "U3RvcDpIU0w6MjEzMTI0MQ==",
lat: 60.21501,
lon: 24.77174
},
{
id: "U3RvcDpIU0w6MjEzMjI0MQ==",
lat: 60.217,
lon: 24.77535
},
{
id: "U3RvcDpIU0w6MjEzMjI0Mw==",
lat: 60.21708,
lon: 24.78087
},
{
id: "U3RvcDpIU0w6MjEzMjI0NQ==",
lat: 60.21688,
lon: 24.78694
},
{
id: "U3RvcDpIU0w6MjEzMjI0Nw==",
lat: 60.22037,
lon: 24.7856
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIwMA==",
lat: 60.22015,
lon: 24.80185
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:2113",
shortName: "113",
longName: "Tapiola(M)-Laajalahti-Perkkaa-Leppävaara",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIzNA==",
lat: 60.218887,
lon: 24.812701
},
{
id: "U3RvcDpIU0w6MjExODI4MA==",
lat: 60.2171,
lon: 24.820558
},
{
id: "U3RvcDpIU0w6MjExODI3OA==",
lat: 60.217,
lon: 24.82504
},
{
id: "U3RvcDpIU0w6MjExODI3Ng==",
lat: 60.21489,
lon: 24.82632
},
{
id: "U3RvcDpIU0w6MjExODIwMQ==",
lat: 60.21264,
lon: 24.82623
},
{
id: "U3RvcDpIU0w6MjExODIwNQ==",
lat: 60.21079,
lon: 24.82438
},
{
id: "U3RvcDpIU0w6MjExODIyNA==",
lat: 60.21268,
lon: 24.8189
},
{
id: "U3RvcDpIU0w6MjExMjI2Mw==",
lat: 60.21244,
lon: 24.81549
},
{
id: "U3RvcDpIU0w6MjEyMjIxOQ==",
lat: 60.2061,
lon: 24.81546
},
{
id: "U3RvcDpIU0w6MjEyMjIwNQ==",
lat: 60.20476,
lon: 24.80945
},
{
id: "U3RvcDpIU0w6MjEyMjIwNg==",
lat: 60.20431,
lon: 24.80464
},
{
id: "U3RvcDpIU0w6MjEyMjIwOA==",
lat: 60.20449,
lon: 24.80009
},
{
id: "U3RvcDpIU0w6MjEyMjIxMA==",
lat: 60.20349,
lon: 24.79771
},
{
id: "U3RvcDpIU0w6MjEyMjIxMg==",
lat: 60.20155,
lon: 24.79848
},
{
id: "U3RvcDpIU0w6MjEyMjIyNQ==",
lat: 60.201,
lon: 24.80299
},
{
id: "U3RvcDpIU0w6MjEyMjIxNQ==",
lat: 60.1992,
lon: 24.80309
},
{
id: "U3RvcDpIU0w6MjIxNTIzMw==",
lat: 60.19681,
lon: 24.79966
},
{
id: "U3RvcDpIU0w6MjIxNTIzMQ==",
lat: 60.19519,
lon: 24.79384
},
{
id: "U3RvcDpIU0w6MjIxNTIyOQ==",
lat: 60.19297,
lon: 24.79574
},
{
id: "U3RvcDpIU0w6MjIxNTIyNw==",
lat: 60.19071,
lon: 24.79691
},
{
id: "U3RvcDpIU0w6MjIxNTI4MQ==",
lat: 60.18749,
lon: 24.79715
},
{
id: "U3RvcDpIU0w6MjIxNTIyMQ==",
lat: 60.18401,
lon: 24.7952
},
{
id: "U3RvcDpIU0w6MjIxMjIxOQ==",
lat: 60.18154,
lon: 24.79584
},
{
id: "U3RvcDpIU0w6MjIxMjIxNw==",
lat: 60.17822,
lon: 24.79887
},
{
id: "U3RvcDpIU0w6MjIxMjIxNQ==",
lat: 60.1759,
lon: 24.80008
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
},
{
id: "U3RvcDpIU0w6MjIxMTIyMg==",
lat: 60.175157,
lon: 24.805118
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMjIxNg==",
lat: 60.17928,
lon: 24.79851
},
{
id: "U3RvcDpIU0w6MjIxMjIxOA==",
lat: 60.18134,
lon: 24.79634
},
{
id: "U3RvcDpIU0w6MjIxNTIyMA==",
lat: 60.1836,
lon: 24.79511
},
{
id: "U3RvcDpIU0w6MjIxNTIyMg==",
lat: 60.18663,
lon: 24.79671
},
{
id: "U3RvcDpIU0w6MjIxNTI4MA==",
lat: 60.18833,
lon: 24.79757
},
{
id: "U3RvcDpIU0w6MjIxNTIyNg==",
lat: 60.19079,
lon: 24.79705
},
{
id: "U3RvcDpIU0w6MjIxNTIyOA==",
lat: 60.19361,
lon: 24.79551
},
{
id: "U3RvcDpIU0w6MjIxNTIzMA==",
lat: 60.19613,
lon: 24.79514
},
{
id: "U3RvcDpIU0w6MjIxNTIyNA==",
lat: 60.19701,
lon: 24.80054
},
{
id: "U3RvcDpIU0w6MjEyMjIxNA==",
lat: 60.19969,
lon: 24.80349
},
{
id: "U3RvcDpIU0w6MjEyMjIxMw==",
lat: 60.20105,
lon: 24.80314
},
{
id: "U3RvcDpIU0w6MjEyMjIxMQ==",
lat: 60.20366,
lon: 24.79789
},
{
id: "U3RvcDpIU0w6MjEyMjIwOQ==",
lat: 60.20434,
lon: 24.79998
},
{
id: "U3RvcDpIU0w6MjEyMjIwNw==",
lat: 60.20435,
lon: 24.80615
},
{
id: "U3RvcDpIU0w6MjEyMjIwNA==",
lat: 60.2046,
lon: 24.81092
},
{
id: "U3RvcDpIU0w6MjEyMTIwMg==",
lat: 60.2053,
lon: 24.81595
},
{
id: "U3RvcDpIU0w6MjExODIyMQ==",
lat: 60.21253,
lon: 24.81925
},
{
id: "U3RvcDpIU0w6MjExODIwNA==",
lat: 60.21104,
lon: 24.82569
},
{
id: "U3RvcDpIU0w6MjExODIwMw==",
lat: 60.21222,
lon: 24.8263
},
{
id: "U3RvcDpIU0w6MjExODI3Nw==",
lat: 60.2147,
lon: 24.82653
},
{
id: "U3RvcDpIU0w6MjExODI4NA==",
lat: 60.21716,
lon: 24.825386
},
{
id: "U3RvcDpIU0w6MjExODI4Ng==",
lat: 60.2184,
lon: 24.81792
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:1024",
shortName: "24",
longName: "Merikatu-Seurasaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA3MDEwNA==",
lat: 60.15591,
lon: 24.94897
},
{
id: "U3RvcDpIU0w6MTA3MDEwNQ==",
lat: 60.15751,
lon: 24.94903
},
{
id: "U3RvcDpIU0w6MTA3MDEwNw==",
lat: 60.157425,
lon: 24.945507
},
{
id: "U3RvcDpIU0w6MTA3MDEwOQ==",
lat: 60.15925,
lon: 24.94666
},
{
id: "U3RvcDpIU0w6MTA3MDExMQ==",
lat: 60.16121,
lon: 24.94652
},
{
id: "U3RvcDpIU0w6MTAzMDExMw==",
lat: 60.16332,
lon: 24.94539
},
{
id: "U3RvcDpIU0w6MTAzMDExOQ==",
lat: 60.16522,
lon: 24.94405
},
{
id: "U3RvcDpIU0w6MTAzMDEyMg==",
lat: 60.167459,
lon: 24.942515
},
{
id: "U3RvcDpIU0w6MTAyMDE3NA==",
lat: 60.17033,
lon: 24.93807
},
{
id: "U3RvcDpIU0w6MTEzMDExMw==",
lat: 60.170862,
lon: 24.930898
},
{
id: "U3RvcDpIU0w6MTEzMDExNQ==",
lat: 60.168485,
lon: 24.923568
},
{
id: "U3RvcDpIU0w6MTEzMDE4NA==",
lat: 60.17009,
lon: 24.92008
},
{
id: "U3RvcDpIU0w6MTEzMDE4OA==",
lat: 60.17143,
lon: 24.9157
},
{
id: "U3RvcDpIU0w6MTEzMDE4Mg==",
lat: 60.17281,
lon: 24.91111
},
{
id: "U3RvcDpIU0w6MTEzMDEwMQ==",
lat: 60.175185,
lon: 24.912905
},
{
id: "U3RvcDpIU0w6MTEzMDEyMg==",
lat: 60.17616,
lon: 24.9181
},
{
id: "U3RvcDpIU0w6MTE0MDE1Ng==",
lat: 60.18029,
lon: 24.91622
},
{
id: "U3RvcDpIU0w6MTE0MDE2NQ==",
lat: 60.18363,
lon: 24.91578
},
{
id: "U3RvcDpIU0w6MTE0MDExMQ==",
lat: 60.18523,
lon: 24.9148
},
{
id: "U3RvcDpIU0w6MTE0MDExMw==",
lat: 60.18508,
lon: 24.91015
},
{
id: "U3RvcDpIU0w6MTE1MDExOQ==",
lat: 60.18666,
lon: 24.90587
},
{
id: "U3RvcDpIU0w6MTE1MDEyMg==",
lat: 60.1869,
lon: 24.90153
},
{
id: "U3RvcDpIU0w6MTE1MDEyNA==",
lat: 60.18645,
lon: 24.89917
},
{
id: "U3RvcDpIU0w6MTE1MDEyNg==",
lat: 60.18742,
lon: 24.89573
},
{
id: "U3RvcDpIU0w6MTE1MDEyOA==",
lat: 60.18844,
lon: 24.88912
},
{
id: "U3RvcDpIU0w6MTE1MDEzMA==",
lat: 60.18854,
lon: 24.88575
},
{
id: "U3RvcDpIU0w6MTE1MDEyOQ==",
lat: 60.18835,
lon: 24.88958
},
{
id: "U3RvcDpIU0w6MTE1MDEyNw==",
lat: 60.18734,
lon: 24.89597
},
{
id: "U3RvcDpIU0w6MTE1MDEyNQ==",
lat: 60.18644,
lon: 24.89907
},
{
id: "U3RvcDpIU0w6MTE1MDEyMw==",
lat: 60.1869,
lon: 24.90168
},
{
id: "U3RvcDpIU0w6MTE1MDEyMA==",
lat: 60.18711,
lon: 24.90495
},
{
id: "U3RvcDpIU0w6MTE0MDExNA==",
lat: 60.18493,
lon: 24.91001
},
{
id: "U3RvcDpIU0w6MTE0MDExMg==",
lat: 60.18507,
lon: 24.91445
},
{
id: "U3RvcDpIU0w6MTE0MDE2Ng==",
lat: 60.18318,
lon: 24.91532
},
{
id: "U3RvcDpIU0w6MTE0MDE1Nw==",
lat: 60.179863,
lon: 24.915864
},
{
id: "U3RvcDpIU0w6MTE0MDEyMQ==",
lat: 60.17669,
lon: 24.91687
},
{
id: "U3RvcDpIU0w6MTEzMDEwMg==",
lat: 60.175247,
lon: 24.912978
},
{
id: "U3RvcDpIU0w6MTEzMDE4MQ==",
lat: 60.17273,
lon: 24.91101
},
{
id: "U3RvcDpIU0w6MTEzMDE4Nw==",
lat: 60.17115,
lon: 24.91622
},
{
id: "U3RvcDpIU0w6MTEzMDE4Mw==",
lat: 60.17004,
lon: 24.91991
},
{
id: "U3RvcDpIU0w6MTEzMDExMg==",
lat: 60.16818,
lon: 24.923302
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDEyOQ==",
lat: 60.17112,
lon: 24.93338
},
{
id: "U3RvcDpIU0w6MTAyMDE3Nw==",
lat: 60.170197,
lon: 24.937442
},
{
id: "U3RvcDpIU0w6MTAzMDEwMg==",
lat: 60.16714,
lon: 24.94234
},
{
id: "U3RvcDpIU0w6MTA1MDEyMA==",
lat: 60.16477,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTA3MDExNA==",
lat: 60.1628,
lon: 24.94603
},
{
id: "U3RvcDpIU0w6MTA3MDExMg==",
lat: 60.16075,
lon: 24.94636
},
{
id: "U3RvcDpIU0w6MTA3MDExMA==",
lat: 60.15907,
lon: 24.94652
},
{
id: "U3RvcDpIU0w6MTA3MDEwOA==",
lat: 60.15686,
lon: 24.94528
},
{
id: "U3RvcDpIU0w6MTA3MDEwNg==",
lat: 60.15559,
lon: 24.94633
}
]
},
{
gtfsId: "HSL:2164VA",
shortName: "164VA",
longName: "Kamppi-Kivenlahti-Saunalahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQyMzIwOA==",
lat: 60.168583,
lon: 24.600373
},
{
id: "U3RvcDpIU0w6MjQyMzIyMg==",
lat: 60.169066,
lon: 24.605836
},
{
id: "U3RvcDpIU0w6MjQyMzIxNw==",
lat: 60.168516,
lon: 24.610189
},
{
id: "U3RvcDpIU0w6MjQyMzIxMw==",
lat: 60.16746,
lon: 24.616208
},
{
id: "U3RvcDpIU0w6MjQyMzIyNQ==",
lat: 60.167636,
lon: 24.618041
},
{
id: "U3RvcDpIU0w6MjQyMzIwNA==",
lat: 60.16769,
lon: 24.62229
},
{
id: "U3RvcDpIU0w6MjQyMTIyOQ==",
lat: 60.16471,
lon: 24.62736
},
{
id: "U3RvcDpIU0w6MjQyMTIyNw==",
lat: 60.16219,
lon: 24.6342
},
{
id: "U3RvcDpIU0w6MjQyMTIyNQ==",
lat: 60.1596,
lon: 24.63639
},
{
id: "U3RvcDpIU0w6MjQyMTIyMw==",
lat: 60.1579,
lon: 24.64127
},
{
id: "U3RvcDpIU0w6MjQyMTIxMA==",
lat: 60.155916,
lon: 24.643328
},
{
id: "U3RvcDpIU0w6MjQxMzIwNg==",
lat: 60.15445,
lon: 24.64661
},
{
id: "U3RvcDpIU0w6MjQxMTIwNA==",
lat: 60.15267,
lon: 24.65583
},
{
id: "U3RvcDpIU0w6MjQxMTIwMg==",
lat: 60.152095,
lon: 24.663769
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
},
{
id: "U3RvcDpIU0w6MTA0MDI4Mg==",
lat: 60.16885,
lon: 24.93109
},
{
id: "U3RvcDpIU0w6MTA0MDIzMQ==",
lat: 60.16622,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNA==",
lat: 60.16976,
lon: 24.8242
},
{
id: "U3RvcDpIU0w6MjIxMTI5MA==",
lat: 60.17025,
lon: 24.81115
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIwMQ==",
lat: 60.15214,
lon: 24.66269
},
{
id: "U3RvcDpIU0w6MjQxMTIwMw==",
lat: 60.15338,
lon: 24.65167
},
{
id: "U3RvcDpIU0w6MjQxMzIwNQ==",
lat: 60.1548,
lon: 24.6459
},
{
id: "U3RvcDpIU0w6MjQyMTIwOQ==",
lat: 60.156065,
lon: 24.643868
},
{
id: "U3RvcDpIU0w6MjQyMTIyMg==",
lat: 60.158,
lon: 24.64159
},
{
id: "U3RvcDpIU0w6MjQyMTIyNA==",
lat: 60.16058,
lon: 24.63576
},
{
id: "U3RvcDpIU0w6MjQyMTIyNg==",
lat: 60.16311,
lon: 24.63362
},
{
id: "U3RvcDpIU0w6MjQyMTIyOA==",
lat: 60.16483,
lon: 24.62812
},
{
id: "U3RvcDpIU0w6MjQyMzIwMw==",
lat: 60.168532,
lon: 24.621287
},
{
id: "U3RvcDpIU0w6MjQyMzIyMw==",
lat: 60.168337,
lon: 24.619043
},
{
id: "U3RvcDpIU0w6MjQyMzIwNQ==",
lat: 60.16774,
lon: 24.61602
},
{
id: "U3RvcDpIU0w6MjQyMzIxNg==",
lat: 60.168817,
lon: 24.608176
},
{
id: "U3RvcDpIU0w6MjQyMzIxMg==",
lat: 60.169017,
lon: 24.602997
}
]
},
{
gtfsId: "HSL:2112",
shortName: "112",
longName: "Tapiola (M)-Niittykumpu-Haukilahti-Matinkylä (M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxMA==",
lat: 60.160267,
lon: 24.739005
},
{
id: "U3RvcDpIU0w6MjMxMzIwNA==",
lat: 60.15965,
lon: 24.74802
},
{
id: "U3RvcDpIU0w6MjMxNDIwNA==",
lat: 60.16113,
lon: 24.75527
},
{
id: "U3RvcDpIU0w6MjMxNDIwNg==",
lat: 60.16122,
lon: 24.76094
},
{
id: "U3RvcDpIU0w6MjIzMjIxMA==",
lat: 60.15869,
lon: 24.76397
},
{
id: "U3RvcDpIU0w6MjIzMjIwOA==",
lat: 60.15782,
lon: 24.76818
},
{
id: "U3RvcDpIU0w6MjIzMjIzMA==",
lat: 60.15822,
lon: 24.77103
},
{
id: "U3RvcDpIU0w6MjIzMjIyOA==",
lat: 60.16035,
lon: 24.77435
},
{
id: "U3RvcDpIU0w6MjIzMjIwMg==",
lat: 60.162188,
lon: 24.775302
},
{
id: "U3RvcDpIU0w6MjIzMjIyMw==",
lat: 60.16652,
lon: 24.77253
},
{
id: "U3RvcDpIU0w6MjIxNDI4OQ==",
lat: 60.16826,
lon: 24.76731
},
{
id: "U3RvcDpIU0w6MjIxNDIxNg==",
lat: 60.170927,
lon: 24.765412
},
{
id: "U3RvcDpIU0w6MjIxNDI0NA==",
lat: 60.170943,
lon: 24.772035
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
},
{
id: "U3RvcDpIU0w6MjIxMTIyNw==",
lat: 60.174906,
lon: 24.803302
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mw==",
lat: 60.17122,
lon: 24.77009
},
{
id: "U3RvcDpIU0w6MjIxNDIxNw==",
lat: 60.17006,
lon: 24.764804
},
{
id: "U3RvcDpIU0w6MjIzMjIyNg==",
lat: 60.16709,
lon: 24.77023
},
{
id: "U3RvcDpIU0w6MjIzMjIyNA==",
lat: 60.16542,
lon: 24.77287
},
{
id: "U3RvcDpIU0w6MjIzMjIyMQ==",
lat: 60.16146,
lon: 24.77498
},
{
id: "U3RvcDpIU0w6MjIzMjIyNw==",
lat: 60.15923,
lon: 24.77324
},
{
id: "U3RvcDpIU0w6MjIzMjIyOQ==",
lat: 60.15794,
lon: 24.76957
},
{
id: "U3RvcDpIU0w6MjIzMjIwOQ==",
lat: 60.15822,
lon: 24.76684
},
{
id: "U3RvcDpIU0w6MjIzMjIxMQ==",
lat: 60.15908,
lon: 24.76323
},
{
id: "U3RvcDpIU0w6MjIzMjIxMg==",
lat: 60.16029,
lon: 24.76163
},
{
id: "U3RvcDpIU0w6MjMxNDIwNQ==",
lat: 60.16156,
lon: 24.75989
},
{
id: "U3RvcDpIU0w6MjMxNDIwMw==",
lat: 60.16122,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjMxMzIwMw==",
lat: 60.15936,
lon: 24.74635
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:1023",
shortName: "23",
longName: "Rautatientori-Pasila-Ruskeasuo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTE2MDExMw==",
lat: 60.20294,
lon: 24.9079
},
{
id: "U3RvcDpIU0w6MTE2MDExMg==",
lat: 60.20265,
lon: 24.90444
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTE2MDExOA==",
lat: 60.207853,
lon: 24.900612
},
{
id: "U3RvcDpIU0w6MTI5MjEyMw==",
lat: 60.208,
lon: 24.90581
},
{
id: "U3RvcDpIU0w6MTE3MTEwNA==",
lat: 60.20791,
lon: 24.91521
},
{
id: "U3RvcDpIU0w6MTE3MTEyMQ==",
lat: 60.205915,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE3MTEyNw==",
lat: 60.20309,
lon: 24.91942
},
{
id: "U3RvcDpIU0w6MTE3MTEyNQ==",
lat: 60.20226,
lon: 24.92151
},
{
id: "U3RvcDpIU0w6MTE3MTEzMQ==",
lat: 60.20267,
lon: 24.92511
},
{
id: "U3RvcDpIU0w6MTE3MTE1OA==",
lat: 60.20111,
lon: 24.92664
},
{
id: "U3RvcDpIU0w6MTE3MzE0OA==",
lat: 60.1977,
lon: 24.93506
},
{
id: "U3RvcDpIU0w6MTEyMjEyNw==",
lat: 60.19505,
lon: 24.93578
},
{
id: "U3RvcDpIU0w6MTEyMjExNg==",
lat: 60.19225,
lon: 24.93641
},
{
id: "U3RvcDpIU0w6MTEyMjExNA==",
lat: 60.19117,
lon: 24.94101
},
{
id: "U3RvcDpIU0w6MTEyMjEzNQ==",
lat: 60.18944,
lon: 24.94694
},
{
id: "U3RvcDpIU0w6MTEyMjEzMw==",
lat: 60.18774,
lon: 24.94428
},
{
id: "U3RvcDpIU0w6MTExMjE1NQ==",
lat: 60.18563,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTExMjE1Mw==",
lat: 60.18415,
lon: 24.94172
},
{
id: "U3RvcDpIU0w6MTExMjEwNQ==",
lat: 60.18276,
lon: 24.94536
},
{
id: "U3RvcDpIU0w6MTExMjEwMw==",
lat: 60.181563,
lon: 24.948399
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExNg==",
lat: 60.17108,
lon: 24.94283
},
{
id: "U3RvcDpIU0w6MTAyMDE2OQ==",
lat: 60.173545,
lon: 24.94981
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTExMjEzNw==",
lat: 60.18141,
lon: 24.94897
},
{
id: "U3RvcDpIU0w6MTExMjEwNA==",
lat: 60.18287,
lon: 24.94524
},
{
id: "U3RvcDpIU0w6MTExMjE1Mg==",
lat: 60.18445,
lon: 24.94114
},
{
id: "U3RvcDpIU0w6MTExMjE1NA==",
lat: 60.18556,
lon: 24.94337
},
{
id: "U3RvcDpIU0w6MTEyMjEzMg==",
lat: 60.18724,
lon: 24.94385
},
{
id: "U3RvcDpIU0w6MTEyMjEzNA==",
lat: 60.19007,
lon: 24.94719
},
{
id: "U3RvcDpIU0w6MTEyMjExMw==",
lat: 60.19124,
lon: 24.9406
},
{
id: "U3RvcDpIU0w6MTEyMjExNQ==",
lat: 60.19244,
lon: 24.936076
},
{
id: "U3RvcDpIU0w6MTE3MzEyNw==",
lat: 60.19699,
lon: 24.93584
},
{
id: "U3RvcDpIU0w6MTE3MTE1NA==",
lat: 60.200915,
lon: 24.926832
},
{
id: "U3RvcDpIU0w6MTE3MTEzMA==",
lat: 60.20279,
lon: 24.92483
},
{
id: "U3RvcDpIU0w6MTE3MTEyNA==",
lat: 60.20241,
lon: 24.92193
},
{
id: "U3RvcDpIU0w6MTE3MTEyNg==",
lat: 60.203862,
lon: 24.918633
},
{
id: "U3RvcDpIU0w6MTE3MTE4MA==",
lat: 60.206258,
lon: 24.917854
},
{
id: "U3RvcDpIU0w6MTE3MTEwNQ==",
lat: 60.20793,
lon: 24.91536
},
{
id: "U3RvcDpIU0w6MTI5MjEyMg==",
lat: 60.208153,
lon: 24.902368
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEyNw==",
lat: 60.20293,
lon: 24.90058
},
{
id: "U3RvcDpIU0w6MTE2MDExMQ==",
lat: 60.2026,
lon: 24.90502
},
{
id: "U3RvcDpIU0w6MTExMTExOA==",
lat: 60.179444,
lon: 24.952266
}
]
},
{
gtfsId: "HSL:1097N",
shortName: "97N",
longName: "Rautatient.-Puotila-Mellunmäki-Kontula (Kotikonnuntie)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzMTEwNQ==",
lat: 60.19461,
lon: 25.0322
},
{
id: "U3RvcDpIU0w6MTQzMTE4MQ==",
lat: 60.1991,
lon: 25.03757
},
{
id: "U3RvcDpIU0w6MTQzMzE4Mw==",
lat: 60.20588,
lon: 25.04745
},
{
id: "U3RvcDpIU0w6MTQ1MzEzMA==",
lat: 60.20975,
lon: 25.07745
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMQ==",
lat: 60.2075,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6MTQ1NTExMA==",
lat: 60.2067,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ1NTEyOQ==",
lat: 60.2078,
lon: 25.0823
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMQ==",
lat: 60.20916,
lon: 25.08738
},
{
id: "U3RvcDpIU0w6MTQ1MjEzMw==",
lat: 60.21087,
lon: 25.09252
},
{
id: "U3RvcDpIU0w6MTQ1MjE0Mw==",
lat: 60.21244,
lon: 25.09675
},
{
id: "U3RvcDpIU0w6MTQ1MjEzNw==",
lat: 60.21347,
lon: 25.09955
},
{
id: "U3RvcDpIU0w6MTQ1MTE3NA==",
lat: 60.215,
lon: 25.10471
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Nw==",
lat: 60.21833,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MA==",
lat: 60.22011,
lon: 25.10815
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMQ==",
lat: 60.23339,
lon: 25.12882
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMw==",
lat: 60.23597,
lon: 25.12657
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNQ==",
lat: 60.23705,
lon: 25.11995
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNw==",
lat: 60.23693,
lon: 25.11624
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOQ==",
lat: 60.23783,
lon: 25.10901
},
{
id: "U3RvcDpIU0w6MTQ3MjE5Mw==",
lat: 60.23837,
lon: 25.10701
},
{
id: "U3RvcDpIU0w6MTQ3MjEyOA==",
lat: 60.239,
lon: 25.10109
},
{
id: "U3RvcDpIU0w6MTQ3MjE5OA==",
lat: 60.23892,
lon: 25.09567
},
{
id: "U3RvcDpIU0w6MTQ3MjE5Ng==",
lat: 60.23881,
lon: 25.09099
},
{
id: "U3RvcDpIU0w6MTQ3MTE0OQ==",
lat: 60.23947,
lon: 25.0862
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MQ==",
lat: 60.24156,
lon: 25.08644
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMg==",
lat: 60.243524,
lon: 25.087752
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mg==",
lat: 60.241694,
lon: 25.086211
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MA==",
lat: 60.23846,
lon: 25.0869
},
{
id: "U3RvcDpIU0w6MTQ3MjE5NQ==",
lat: 60.23891,
lon: 25.09051
},
{
id: "U3RvcDpIU0w6MTQ3MjE5Nw==",
lat: 60.23892,
lon: 25.09608
},
{
id: "U3RvcDpIU0w6MTQ3MjE0OA==",
lat: 60.23944,
lon: 25.10283
},
{
id: "U3RvcDpIU0w6MTQ3MjE5NA==",
lat: 60.2382,
lon: 25.10673
},
{
id: "U3RvcDpIU0w6MTQ3MzExMA==",
lat: 60.23737,
lon: 25.11256
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOA==",
lat: 60.23681,
lon: 25.11628
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNg==",
lat: 60.23692,
lon: 25.12131
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNA==",
lat: 60.23551,
lon: 25.12729
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMg==",
lat: 60.23253,
lon: 25.12857
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MQ==",
lat: 60.22017,
lon: 25.10757
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Ng==",
lat: 60.21772,
lon: 25.10377
},
{
id: "U3RvcDpIU0w6MTQ1MTEzOQ==",
lat: 60.21484,
lon: 25.10371
},
{
id: "U3RvcDpIU0w6MTQ1MjEzOA==",
lat: 60.21358,
lon: 25.09962
},
{
id: "U3RvcDpIU0w6MTQ1MjE0NA==",
lat: 60.21241,
lon: 25.09649
},
{
id: "U3RvcDpIU0w6MTQ1MjEzNA==",
lat: 60.21086,
lon: 25.09226
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMg==",
lat: 60.20912,
lon: 25.08664
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMA==",
lat: 60.20779,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1NTEwOQ==",
lat: 60.20635,
lon: 25.07659
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMg==",
lat: 60.20757,
lon: 25.07562
},
{
id: "U3RvcDpIU0w6MTQzMTE4Mg==",
lat: 60.2058,
lon: 25.04504
},
{
id: "U3RvcDpIU0w6MTQzMTE4MA==",
lat: 60.19873,
lon: 25.03652
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4411",
shortName: "411",
longName: "Elielinaukio-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE1MDI2Mg==",
lat: 60.26118,
lon: 24.85559
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIyOA==",
lat: 60.25998,
lon: 24.84341
},
{
id: "U3RvcDpIU0w6NDE1MDIxMg==",
lat: 60.26421,
lon: 24.84306
},
{
id: "U3RvcDpIU0w6NDE1MDIxNA==",
lat: 60.26754,
lon: 24.84198
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDIyMA==",
lat: 60.26371,
lon: 24.85947
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDEzMg==",
lat: 60.171921,
lon: 24.939716
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE1MDIxOQ==",
lat: 60.26394,
lon: 24.85928
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNg==",
lat: 60.26909,
lon: 24.8411
},
{
id: "U3RvcDpIU0w6NDE1MDIxNQ==",
lat: 60.2664,
lon: 24.84209
},
{
id: "U3RvcDpIU0w6NDE1MDIxMw==",
lat: 60.2629,
lon: 24.84286
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDIwNQ==",
lat: 60.26146,
lon: 24.85579
}
]
},
{
gtfsId: "HSL:4412",
shortName: "412",
longName: "Kaivoksela-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE2MDIwNQ==",
lat: 60.26953,
lon: 24.87291
},
{
id: "U3RvcDpIU0w6NDE2MDIwNg==",
lat: 60.26627,
lon: 24.87003
},
{
id: "U3RvcDpIU0w6NDE2MDIwOA==",
lat: 60.26452,
lon: 24.86958
},
{
id: "U3RvcDpIU0w6NDE2MDIxMA==",
lat: 60.26348,
lon: 24.87057
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE1MDIxOQ==",
lat: 60.26394,
lon: 24.85928
},
{
id: "U3RvcDpIU0w6NDE1MDIwNQ==",
lat: 60.26146,
lon: 24.85579
},
{
id: "U3RvcDpIU0w6NDE1MDI2Nw==",
lat: 60.26114,
lon: 24.854962
},
{
id: "U3RvcDpIU0w6NDE1MDIyMA==",
lat: 60.26371,
lon: 24.85947
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6NDE2MDIwOQ==",
lat: 60.26412,
lon: 24.86956
},
{
id: "U3RvcDpIU0w6NDE2MDIwNw==",
lat: 60.26625,
lon: 24.87078
}
]
},
{
gtfsId: "HSL:4413",
shortName: "413",
longName: "Martinlaakso-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE3MDI1MA==",
lat: 60.277713,
lon: 24.840293
},
{
id: "U3RvcDpIU0w6NDE3MDIxMw==",
lat: 60.27618,
lon: 24.83573
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwMA==",
lat: 60.275391,
lon: 24.84478
},
{
id: "U3RvcDpIU0w6NDE3MDI3NA==",
lat: 60.27739,
lon: 24.84948
},
{
id: "U3RvcDpIU0w6NDE3MDI1Mg==",
lat: 60.278057,
lon: 24.852108
},
{
id: "U3RvcDpIU0w6NDE3MDI5NQ==",
lat: 60.27999,
lon: 24.852447
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDI2OQ==",
lat: 60.279367,
lon: 24.840817
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIzMA==",
lat: 60.28075,
lon: 24.85491
},
{
id: "U3RvcDpIU0w6NDE3MDIyOA==",
lat: 60.28318,
lon: 24.86074
},
{
id: "U3RvcDpIU0w6NDE3MDIyNg==",
lat: 60.28204,
lon: 24.86449
},
{
id: "U3RvcDpIU0w6NDE3MDI5Ng==",
lat: 60.279139,
lon: 24.864409
},
{
id: "U3RvcDpIU0w6NDE3MDI4Mg==",
lat: 60.278842,
lon: 24.861262
},
{
id: "U3RvcDpIU0w6NDE3MDIyNA==",
lat: 60.27874,
lon: 24.86524
},
{
id: "U3RvcDpIU0w6NDE4MDIyMg==",
lat: 60.27741,
lon: 24.87247
},
{
id: "U3RvcDpIU0w6NDE4MDIwMQ==",
lat: 60.27415,
lon: 24.87457
},
{
id: "U3RvcDpIU0w6NDE4MDIzNw==",
lat: 60.276752,
lon: 24.877136
},
{
id: "U3RvcDpIU0w6NDE4MDIzNQ==",
lat: 60.278379,
lon: 24.879999
},
{
id: "U3RvcDpIU0w6NDE4MDIzNg==",
lat: 60.275852,
lon: 24.879623
},
{
id: "U3RvcDpIU0w6NDE4MDIwMw==",
lat: 60.27403,
lon: 24.87324
},
{
id: "U3RvcDpIU0w6NDE4MDIyNA==",
lat: 60.27838,
lon: 24.87161
},
{
id: "U3RvcDpIU0w6NDE4MDIzMQ==",
lat: 60.27793,
lon: 24.86877
},
{
id: "U3RvcDpIU0w6NDE3MDIxMA==",
lat: 60.27739,
lon: 24.86505
},
{
id: "U3RvcDpIU0w6NDE3MDI1OA==",
lat: 60.27658,
lon: 24.85892
},
{
id: "U3RvcDpIU0w6NDE3MDIxNQ==",
lat: 60.2772,
lon: 24.85298
},
{
id: "U3RvcDpIU0w6NDE3MDI2Nw==",
lat: 60.275484,
lon: 24.865983
},
{
id: "U3RvcDpIU0w6NDE3MDI5OQ==",
lat: 60.2753,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDE1MDI0MA==",
lat: 60.272774,
lon: 24.856289
},
{
id: "U3RvcDpIU0w6NDE1MDIxOA==",
lat: 60.2703,
lon: 24.85623
},
{
id: "U3RvcDpIU0w6NDE1MDIzMg==",
lat: 60.267683,
lon: 24.856459
},
{
id: "U3RvcDpIU0w6NDE1MDI3NQ==",
lat: 60.268605,
lon: 24.857969
},
{
id: "U3RvcDpIU0w6NDE1MDIzMA==",
lat: 60.26948,
lon: 24.85788
},
{
id: "U3RvcDpIU0w6NDE1MDI1OQ==",
lat: 60.27046,
lon: 24.854602
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDIyMQ==",
lat: 60.263767,
lon: 24.852658
},
{
id: "U3RvcDpIU0w6NDE1MDI3MA==",
lat: 60.264904,
lon: 24.850703
},
{
id: "U3RvcDpIU0w6NDE1MDIzNw==",
lat: 60.262775,
lon: 24.849164
},
{
id: "U3RvcDpIU0w6NDE1MDIyMg==",
lat: 60.263549,
lon: 24.852621
},
{
id: "U3RvcDpIU0w6NDE1MDIwMw==",
lat: 60.26109,
lon: 24.8556
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxNw==",
lat: 60.27172,
lon: 24.85481
},
{
id: "U3RvcDpIU0w6NDE3MDI5Mw==",
lat: 60.275267,
lon: 24.856513
},
{
id: "U3RvcDpIU0w6NDE3MDIwNw==",
lat: 60.27642,
lon: 24.85817
},
{
id: "U3RvcDpIU0w6NDE3MDIwOQ==",
lat: 60.27705,
lon: 24.86407
},
{
id: "U3RvcDpIU0w6NDE3MDIyMw==",
lat: 60.27959,
lon: 24.86557
},
{
id: "U3RvcDpIU0w6NDE3MDIyNQ==",
lat: 60.28239,
lon: 24.86421
},
{
id: "U3RvcDpIU0w6NDE3MDIyNw==",
lat: 60.28305,
lon: 24.85951
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDI5MA==",
lat: 60.280794,
lon: 24.851898
},
{
id: "U3RvcDpIU0w6NDE3MDI2Mg==",
lat: 60.27814,
lon: 24.85204
},
{
id: "U3RvcDpIU0w6NDE3MDI3NQ==",
lat: 60.27739,
lon: 24.84931
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
}
]
},
{
gtfsId: "HSL:1073N",
shortName: "73N",
longName: "Rautatientori-Malmi-Puistolan asema-Ala-Tikkurila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQwMTEyOQ==",
lat: 60.28693,
lon: 25.01495
},
{
id: "U3RvcDpIU0w6MTQwMTEyOA==",
lat: 60.28426,
lon: 25.01348
},
{
id: "U3RvcDpIU0w6MTQwMTEyMw==",
lat: 60.28254,
lon: 25.02771
},
{
id: "U3RvcDpIU0w6MTQwMjExOQ==",
lat: 60.28053,
lon: 25.02847
},
{
id: "U3RvcDpIU0w6MTQwMjEyMg==",
lat: 60.27838,
lon: 25.03171
},
{
id: "U3RvcDpIU0w6MTQwMjE1MA==",
lat: 60.27665,
lon: 25.03432
},
{
id: "U3RvcDpIU0w6MTQwMjE1NQ==",
lat: 60.27502,
lon: 25.03549
},
{
id: "U3RvcDpIU0w6MTQwMjE1Nw==",
lat: 60.27136,
lon: 25.03385
},
{
id: "U3RvcDpIU0w6MTQwMjE3Mw==",
lat: 60.26816,
lon: 25.03245
},
{
id: "U3RvcDpIU0w6MTQwMjE3OQ==",
lat: 60.26814,
lon: 25.02993
},
{
id: "U3RvcDpIU0w6MTQwMjE4MQ==",
lat: 60.26966,
lon: 25.0235
},
{
id: "U3RvcDpIU0w6MTQwMjE4Mw==",
lat: 60.26941,
lon: 25.018925
},
{
id: "U3RvcDpIU0w6MTQwMzE2NA==",
lat: 60.26767,
lon: 25.01355
},
{
id: "U3RvcDpIU0w6MTQwMzE5Nw==",
lat: 60.26694,
lon: 25.00747
},
{
id: "U3RvcDpIU0w6MTQwMzE5NQ==",
lat: 60.26568,
lon: 25.00295
},
{
id: "U3RvcDpIU0w6MTM5MTE5Mw==",
lat: 60.2638,
lon: 25.00456
},
{
id: "U3RvcDpIU0w6MTM5MTE0Mw==",
lat: 60.26131,
lon: 25.00392
},
{
id: "U3RvcDpIU0w6MTM5MTE0MQ==",
lat: 60.25832,
lon: 25.00074
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwMg==",
lat: 60.2502,
lon: 25.00917
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MzExNA==",
lat: 60.23859,
lon: 25.02095
},
{
id: "U3RvcDpIU0w6MTM4MzExMg==",
lat: 60.23595,
lon: 25.02177
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM2MzEwMQ==",
lat: 60.229313,
lon: 25.010037
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjEwNQ==",
lat: 60.22862,
lon: 25.01202
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEwOQ==",
lat: 60.232187,
lon: 25.011714
},
{
id: "U3RvcDpIU0w6MTM4MzExMQ==",
lat: 60.23676,
lon: 25.02225
},
{
id: "U3RvcDpIU0w6MTM4MjExMw==",
lat: 60.240179,
lon: 25.021039
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MTEwMQ==",
lat: 60.25004,
lon: 25.00946
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEzOQ==",
lat: 60.25731,
lon: 24.99923
},
{
id: "U3RvcDpIU0w6MTM5MTE0MA==",
lat: 60.25929,
lon: 25.00169
},
{
id: "U3RvcDpIU0w6MTM5MTE0Mg==",
lat: 60.26103,
lon: 25.00335
},
{
id: "U3RvcDpIU0w6MTM5MTE5Mg==",
lat: 60.26397,
lon: 25.00455
},
{
id: "U3RvcDpIU0w6MTQwMzE5NA==",
lat: 60.26568,
lon: 25.00316
},
{
id: "U3RvcDpIU0w6MTM5MTE5Ng==",
lat: 60.26709,
lon: 25.00979
},
{
id: "U3RvcDpIU0w6MTM5MjE2NQ==",
lat: 60.26788,
lon: 25.01539
},
{
id: "U3RvcDpIU0w6MTM5MjE4NA==",
lat: 60.26934,
lon: 25.01931
},
{
id: "U3RvcDpIU0w6MTQwMjE4Mg==",
lat: 60.26934,
lon: 25.02538
},
{
id: "U3RvcDpIU0w6MTM5MjE4MA==",
lat: 60.26817,
lon: 25.02945
},
{
id: "U3RvcDpIU0w6MTQxMTE3NA==",
lat: 60.2688,
lon: 25.03293
},
{
id: "U3RvcDpIU0w6MTQwMjE1Ng==",
lat: 60.2721,
lon: 25.03447
},
{
id: "U3RvcDpIU0w6MTQwMjE1NA==",
lat: 60.27495,
lon: 25.03572
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mg==",
lat: 60.27697,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6MTQwMjEyMQ==",
lat: 60.27863,
lon: 25.03001
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mw==",
lat: 60.28064,
lon: 25.02876
},
{
id: "U3RvcDpIU0w6MTQwMjEyMA==",
lat: 60.28326,
lon: 25.02772
},
{
id: "U3RvcDpIU0w6MTQwMTEyNw==",
lat: 60.28597,
lon: 25.0151
}
]
},
{
gtfsId: "HSL:1085N",
shortName: "85N",
longName: "Rautatientori-Herttoniemenranta-Yliskylä-Jollas",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMw==",
lat: 60.17134,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDE5MA==",
lat: 60.18993,
lon: 25.02573
},
{
id: "U3RvcDpIU0w6MTQzNDE4Ng==",
lat: 60.18808,
lon: 25.02986
},
{
id: "U3RvcDpIU0w6MTQzNDE4NA==",
lat: 60.186718,
lon: 25.031206
},
{
id: "U3RvcDpIU0w6MTQzNDE4MA==",
lat: 60.187048,
lon: 25.035956
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMg==",
lat: 60.18382,
lon: 25.05227
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNA==",
lat: 60.18367,
lon: 25.05709
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNg==",
lat: 60.18038,
lon: 25.05966
},
{
id: "U3RvcDpIU0w6MTQ5MTEyOA==",
lat: 60.17809,
lon: 25.05687
},
{
id: "U3RvcDpIU0w6MTQ5MTE3MA==",
lat: 60.178258,
lon: 25.0532
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNw==",
lat: 60.17786,
lon: 25.04891
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOQ==",
lat: 60.17566,
lon: 25.0462
},
{
id: "U3RvcDpIU0w6MTQ5MTExMQ==",
lat: 60.174743,
lon: 25.040362
},
{
id: "U3RvcDpIU0w6MTQ5MTExMw==",
lat: 60.17171,
lon: 25.04015
},
{
id: "U3RvcDpIU0w6MTQ5MTExNQ==",
lat: 60.17027,
lon: 25.04299
},
{
id: "U3RvcDpIU0w6MTQ5MTExNw==",
lat: 60.16854,
lon: 25.04599
},
{
id: "U3RvcDpIU0w6MTQ5NTEzNQ==",
lat: 60.16803,
lon: 25.0489
},
{
id: "U3RvcDpIU0w6MTQ5MjEzNw==",
lat: 60.16596,
lon: 25.05495
},
{
id: "U3RvcDpIU0w6MTQ5MjE0MQ==",
lat: 60.16448,
lon: 25.06189
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Mw==",
lat: 60.16404,
lon: 25.07081
},
{
id: "U3RvcDpIU0w6MTQ5MjE0NQ==",
lat: 60.16544,
lon: 25.07604
},
{
id: "U3RvcDpIU0w6MTQ5MjE1MQ==",
lat: 60.16611,
lon: 25.08049
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Nw==",
lat: 60.16808,
lon: 25.08038
},
{
id: "U3RvcDpIU0w6MTQ5MjE0OQ==",
lat: 60.17061,
lon: 25.07991
},
{
id: "U3RvcDpIU0w6MTQ5MjE0OA==",
lat: 60.16778,
lon: 25.0805
},
{
id: "U3RvcDpIU0w6MTQ5MjE1Mg==",
lat: 60.1661,
lon: 25.07956
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Ng==",
lat: 60.16546,
lon: 25.0758
},
{
id: "U3RvcDpIU0w6MTQ5MjE0NA==",
lat: 60.164,
lon: 25.06984
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Mg==",
lat: 60.16455,
lon: 25.06189
},
{
id: "U3RvcDpIU0w6MTQ5MTEzOA==",
lat: 60.16636,
lon: 25.05391
},
{
id: "U3RvcDpIU0w6MTQ5MTExOA==",
lat: 60.16886,
lon: 25.04583
},
{
id: "U3RvcDpIU0w6MTQ5MTExNg==",
lat: 60.17101,
lon: 25.04185
},
{
id: "U3RvcDpIU0w6MTQ5MTE3MQ==",
lat: 60.172362,
lon: 25.039398
},
{
id: "U3RvcDpIU0w6MTQ5MTExMg==",
lat: 60.174846,
lon: 25.041802
},
{
id: "U3RvcDpIU0w6MTQ5MTExMA==",
lat: 60.1756,
lon: 25.04661
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOA==",
lat: 60.17786,
lon: 25.04901
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OQ==",
lat: 60.178132,
lon: 25.053262
},
{
id: "U3RvcDpIU0w6MTQ5MTEyOQ==",
lat: 60.17805,
lon: 25.05738
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNw==",
lat: 60.18081,
lon: 25.0596
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNQ==",
lat: 60.18384,
lon: 25.05705
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMw==",
lat: 60.18389,
lon: 25.05198
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3Ng==",
lat: 60.18833,
lon: 25.04042
},
{
id: "U3RvcDpIU0w6MTQzNDE3OQ==",
lat: 60.186889,
lon: 25.035663
},
{
id: "U3RvcDpIU0w6MTQzNDE4Mw==",
lat: 60.18699,
lon: 25.030746
},
{
id: "U3RvcDpIU0w6MTQzNDE4NQ==",
lat: 60.18818,
lon: 25.02984
},
{
id: "U3RvcDpIU0w6MTQzNDExNA==",
lat: 60.190465,
lon: 25.025627
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4415",
shortName: "415",
longName: "Elielinaukio-Ylästö-Lentoasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDUzMDIzMA==",
lat: 60.317343,
lon: 24.965217
},
{
id: "U3RvcDpIU0w6NDUzMDI1OA==",
lat: 60.313471,
lon: 24.967726
},
{
id: "U3RvcDpIU0w6NDUzMDIyMQ==",
lat: 60.307879,
lon: 24.960343
},
{
id: "U3RvcDpIU0w6NDUyMDI2Nw==",
lat: 60.304895,
lon: 24.957404
},
{
id: "U3RvcDpIU0w6NDUyMDI2NQ==",
lat: 60.303237,
lon: 24.95592
},
{
id: "U3RvcDpIU0w6NDUyMDIzMw==",
lat: 60.302235,
lon: 24.958971
},
{
id: "U3RvcDpIU0w6NDUyMDIyMA==",
lat: 60.297809,
lon: 24.958069
},
{
id: "U3RvcDpIU0w6NDUxMDI2NA==",
lat: 60.295567,
lon: 24.958298
},
{
id: "U3RvcDpIU0w6NDUxMDIwMQ==",
lat: 60.28944,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIxMA==",
lat: 60.28642,
lon: 24.95645
},
{
id: "U3RvcDpIU0w6NDUxMDIxMw==",
lat: 60.286,
lon: 24.94868
},
{
id: "U3RvcDpIU0w6NDUxMDI1Ng==",
lat: 60.285431,
lon: 24.944319
},
{
id: "U3RvcDpIU0w6NDQwMDIxNg==",
lat: 60.28215,
lon: 24.93696
},
{
id: "U3RvcDpIU0w6NDQwMDIxNA==",
lat: 60.28078,
lon: 24.92756
},
{
id: "U3RvcDpIU0w6NDQwMDIxMg==",
lat: 60.28157,
lon: 24.92342
},
{
id: "U3RvcDpIU0w6NDQwMDIxMA==",
lat: 60.28386,
lon: 24.918
},
{
id: "U3RvcDpIU0w6NDQwMDIwOA==",
lat: 60.28435,
lon: 24.91312
},
{
id: "U3RvcDpIU0w6NDQwMDIzMg==",
lat: 60.28534,
lon: 24.90811
},
{
id: "U3RvcDpIU0w6NDQwMDIwNg==",
lat: 60.28615,
lon: 24.90267
},
{
id: "U3RvcDpIU0w6NDQwMDIwNA==",
lat: 60.28642,
lon: 24.89658
},
{
id: "U3RvcDpIU0w6NDQwMDI5OA==",
lat: 60.28786,
lon: 24.89045
},
{
id: "U3RvcDpIU0w6NDE4MDIxMQ==",
lat: 60.2871,
lon: 24.87284
},
{
id: "U3RvcDpIU0w6NDE4MDIyNg==",
lat: 60.28292,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyMg==",
lat: 60.27741,
lon: 24.87247
},
{
id: "U3RvcDpIU0w6NDE4MDIwMg==",
lat: 60.27334,
lon: 24.87505
},
{
id: "U3RvcDpIU0w6NDE2MDIyMQ==",
lat: 60.26918,
lon: 24.87913
},
{
id: "U3RvcDpIU0w6NDE2MDI5OQ==",
lat: 60.265,
lon: 24.88162
},
{
id: "U3RvcDpIU0w6NDE2MDIxOA==",
lat: 60.26389,
lon: 24.87979
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDIzOQ==",
lat: 60.171981,
lon: 24.93971
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxNw==",
lat: 60.26342,
lon: 24.87936
},
{
id: "U3RvcDpIU0w6NDE2MDIxOQ==",
lat: 60.26605,
lon: 24.88205
},
{
id: "U3RvcDpIU0w6NDE2MDIyMA==",
lat: 60.27017,
lon: 24.87906
},
{
id: "U3RvcDpIU0w6NDE4MDIwMw==",
lat: 60.27403,
lon: 24.87324
},
{
id: "U3RvcDpIU0w6NDE4MDIyMw==",
lat: 60.27905,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyNQ==",
lat: 60.284615,
lon: 24.873015
},
{
id: "U3RvcDpIU0w6NDE4MDIzMA==",
lat: 60.28791,
lon: 24.87527
},
{
id: "U3RvcDpIU0w6NDQwMDI5OQ==",
lat: 60.28752,
lon: 24.89207
},
{
id: "U3RvcDpIU0w6NDQwMDIwMw==",
lat: 60.28632,
lon: 24.89784
},
{
id: "U3RvcDpIU0w6NDQwMDIwNQ==",
lat: 60.28585,
lon: 24.90463
},
{
id: "U3RvcDpIU0w6NDQwMDIzMw==",
lat: 60.28471,
lon: 24.91037
},
{
id: "U3RvcDpIU0w6NDQwMDIwNw==",
lat: 60.28403,
lon: 24.91526
},
{
id: "U3RvcDpIU0w6NDQwMDIwOQ==",
lat: 60.28334,
lon: 24.91922
},
{
id: "U3RvcDpIU0w6NDQwMDIxMQ==",
lat: 60.28074,
lon: 24.92412
},
{
id: "U3RvcDpIU0w6NDQwMDIxMw==",
lat: 60.28074,
lon: 24.92886
},
{
id: "U3RvcDpIU0w6NDQwMDIxNQ==",
lat: 60.28249,
lon: 24.93814
},
{
id: "U3RvcDpIU0w6NDUxMDI1Nw==",
lat: 60.28557,
lon: 24.946116
},
{
id: "U3RvcDpIU0w6NDUxMDIxMg==",
lat: 60.286087,
lon: 24.951548
},
{
id: "U3RvcDpIU0w6NDUxMDIxNA==",
lat: 60.28624,
lon: 24.95591
},
{
id: "U3RvcDpIU0w6NDUxMDIyMQ==",
lat: 60.28714,
lon: 24.9578
},
{
id: "U3RvcDpIU0w6NDUxMDIwMg==",
lat: 60.29045,
lon: 24.96052
},
{
id: "U3RvcDpIU0w6NDUxMDI2MA==",
lat: 60.293782,
lon: 24.959314
},
{
id: "U3RvcDpIU0w6NDUxMDI2Mw==",
lat: 60.295453,
lon: 24.958864
},
{
id: "U3RvcDpIU0w6NDUyMDIxNw==",
lat: 60.297895,
lon: 24.959368
},
{
id: "U3RvcDpIU0w6NDUyMDIzOQ==",
lat: 60.301654,
lon: 24.962252
},
{
id: "U3RvcDpIU0w6NDUyMDI2Ng==",
lat: 60.302738,
lon: 24.955727
},
{
id: "U3RvcDpIU0w6NDUyMDI2OA==",
lat: 60.306115,
lon: 24.958895
},
{
id: "U3RvcDpIU0w6NDUzMDIyMg==",
lat: 60.308712,
lon: 24.961988
},
{
id: "U3RvcDpIU0w6NDUzMDIwOQ==",
lat: 60.317071,
lon: 24.966263
}
]
},
{
gtfsId: "HSL:1061N",
shortName: "61N",
longName: "Rautatientori-Pukinmäki-Töyrynummi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMw==",
lat: 60.17134,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDEwMw==",
lat: 60.19531,
lon: 24.95583
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDEyOQ==",
lat: 60.22999,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDE3Mg==",
lat: 60.23425,
lon: 24.96753
},
{
id: "U3RvcDpIU0w6MTI4NDE3NQ==",
lat: 60.23609,
lon: 24.97254
},
{
id: "U3RvcDpIU0w6MTM3MDEwMw==",
lat: 60.23991,
lon: 24.97993
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM3MDEwOQ==",
lat: 60.24398,
lon: 24.99386
},
{
id: "U3RvcDpIU0w6MTM3MDExMQ==",
lat: 60.24716,
lon: 24.99175
},
{
id: "U3RvcDpIU0w6MTM3MDExMw==",
lat: 60.25129,
lon: 24.98678
},
{
id: "U3RvcDpIU0w6MTM5MTExNg==",
lat: 60.25464,
lon: 24.9837
},
{
id: "U3RvcDpIU0w6MTM5MTExOA==",
lat: 60.257215,
lon: 24.981581
},
{
id: "U3RvcDpIU0w6MTM5MTEyMA==",
lat: 60.25975,
lon: 24.98156
},
{
id: "U3RvcDpIU0w6MTM5MTEyMg==",
lat: 60.26134,
lon: 24.98419
},
{
id: "U3RvcDpIU0w6MTM5MTExMg==",
lat: 60.26381,
lon: 24.98384
},
{
id: "U3RvcDpIU0w6MTQwMzEzNQ==",
lat: 60.26514,
lon: 24.98307
},
{
id: "U3RvcDpIU0w6MTQwMTExNA==",
lat: 60.26722,
lon: 24.98012
},
{
id: "U3RvcDpIU0w6MTQwMTEwMQ==",
lat: 60.2693,
lon: 24.98338
},
{
id: "U3RvcDpIU0w6MTQwMTEwMw==",
lat: 60.27145,
lon: 24.99206
},
{
id: "U3RvcDpIU0w6MTQwMTExMA==",
lat: 60.27481,
lon: 24.99852
},
{
id: "U3RvcDpIU0w6MTQwMzE3MA==",
lat: 60.27426,
lon: 25.00182
},
{
id: "U3RvcDpIU0w6MTQwMzE2OA==",
lat: 60.27189,
lon: 25.00451
},
{
id: "U3RvcDpIU0w6MTQwMzEzMw==",
lat: 60.26892,
lon: 25.00956
},
{
id: "U3RvcDpIU0w6MTQwMzE3Mg==",
lat: 60.26859,
lon: 25.00582
},
{
id: "U3RvcDpIU0w6MTQwMzEzMQ==",
lat: 60.26821,
lon: 25.00048
},
{
id: "U3RvcDpIU0w6MTQwMzEyOQ==",
lat: 60.267496,
lon: 24.995374
},
{
id: "U3RvcDpIU0w6MTQwMzEyNw==",
lat: 60.26665,
lon: 24.99296
},
{
id: "U3RvcDpIU0w6MTM5MTExMw==",
lat: 60.26397,
lon: 24.98368
},
{
id: "U3RvcDpIU0w6MTM5MTEyMw==",
lat: 60.2612,
lon: 24.98378
},
{
id: "U3RvcDpIU0w6MTM5MTEyMQ==",
lat: 60.25907,
lon: 24.98039
},
{
id: "U3RvcDpIU0w6MTM5MTExOQ==",
lat: 60.257,
lon: 24.98152
},
{
id: "U3RvcDpIU0w6MTM5MTExNw==",
lat: 60.25443,
lon: 24.98369
},
{
id: "U3RvcDpIU0w6MTM3MDExNA==",
lat: 60.25075,
lon: 24.98685
},
{
id: "U3RvcDpIU0w6MTM3MDExMg==",
lat: 60.24732,
lon: 24.99163
},
{
id: "U3RvcDpIU0w6MTM3MDExMA==",
lat: 60.24324,
lon: 24.99451
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM3MDEwNA==",
lat: 60.2399,
lon: 24.97954
},
{
id: "U3RvcDpIU0w6MTI4NDE3OA==",
lat: 60.23699,
lon: 24.97454
},
{
id: "U3RvcDpIU0w6MTI4NDE3NA==",
lat: 60.23539,
lon: 24.97034
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEyNw==",
lat: 60.23022,
lon: 24.94776
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:2232",
shortName: "232",
longName: "Kirkkotie-Gallträsk-Kasavuori-Kirkkotie",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MzE3MDI2MQ==",
lat: 60.208662,
lon: 24.72185
},
{
id: "U3RvcDpIU0w6MzE3MDIzOQ==",
lat: 60.21096,
lon: 24.72951
},
{
id: "U3RvcDpIU0w6MzE3MDIwNg==",
lat: 60.21262,
lon: 24.72996
},
{
id: "U3RvcDpIU0w6MzE3MDI2NQ==",
lat: 60.213599,
lon: 24.736641
},
{
id: "U3RvcDpIU0w6MzE3MDI1Nw==",
lat: 60.21267,
lon: 24.72825
},
{
id: "U3RvcDpIU0w6MzE3MDI0Ng==",
lat: 60.211811,
lon: 24.718853
},
{
id: "U3RvcDpIU0w6MzE3MDI0OA==",
lat: 60.210073,
lon: 24.707201
},
{
id: "U3RvcDpIU0w6MzE3MDI1Ng==",
lat: 60.211097,
lon: 24.699638
},
{
id: "U3RvcDpIU0w6MzE3MDI1OA==",
lat: 60.215049,
lon: 24.704448
},
{
id: "U3RvcDpIU0w6MzE3MDI2MA==",
lat: 60.216922,
lon: 24.700779
},
{
id: "U3RvcDpIU0w6MzE3MDI2Mg==",
lat: 60.218623,
lon: 24.701788
},
{
id: "U3RvcDpIU0w6MzE3MDI3OA==",
lat: 60.217172,
lon: 24.709371
},
{
id: "U3RvcDpIU0w6MzE3MDIxMw==",
lat: 60.21566,
lon: 24.71209
},
{
id: "U3RvcDpIU0w6MzE3MDI2Mw==",
lat: 60.214695,
lon: 24.716467
},
{
id: "U3RvcDpIU0w6MzE3MDIxMA==",
lat: 60.2139,
lon: 24.7169
},
{
id: "U3RvcDpIU0w6MzE3MDI2OA==",
lat: 60.220051,
lon: 24.726801
},
{
id: "U3RvcDpIU0w6MzE3MDI3MA==",
lat: 60.221327,
lon: 24.73294
},
{
id: "U3RvcDpIU0w6MzE3MDI3Mg==",
lat: 60.217988,
lon: 24.73826
},
{
id: "U3RvcDpIU0w6MzE3MDI0MA==",
lat: 60.21083,
lon: 24.72933
},
{
id: "U3RvcDpIU0w6MzE3MDIzMw==",
lat: 60.20939,
lon: 24.72789
},
{
id: "U3RvcDpIU0w6MzE3MDI3MQ==",
lat: 60.207125,
lon: 24.727055
},
{
id: "U3RvcDpIU0w6MzE3MDI1OQ==",
lat: 60.208662,
lon: 24.72185
},
{
id: "U3RvcDpIU0w6MzE3MDI3NA==",
lat: 60.215566,
lon: 24.736192
},
{
id: "U3RvcDpIU0w6MzE3MDIwNw==",
lat: 60.21235,
lon: 24.72818
},
{
id: "U3RvcDpIU0w6MzE3MDI0Mw==",
lat: 60.215055,
lon: 24.734632
},
{
id: "U3RvcDpIU0w6MzE3MDI0NQ==",
lat: 60.218004,
lon: 24.738297
},
{
id: "U3RvcDpIU0w6MzE3MDI0Nw==",
lat: 60.221381,
lon: 24.733452
},
{
id: "U3RvcDpIU0w6MzE3MDI0OQ==",
lat: 60.220217,
lon: 24.727402
},
{
id: "U3RvcDpIU0w6MzE3MDIxMQ==",
lat: 60.2143,
lon: 24.71582
},
{
id: "U3RvcDpIU0w6MzE3MDIxMg==",
lat: 60.21638,
lon: 24.71126
},
{
id: "U3RvcDpIU0w6MzE3MDI1NQ==",
lat: 60.217438,
lon: 24.70815
},
{
id: "U3RvcDpIU0w6MzE3MDIxNA==",
lat: 60.21882,
lon: 24.70155
},
{
id: "U3RvcDpIU0w6MzE3MDIxNQ==",
lat: 60.21655,
lon: 24.70142
},
{
id: "U3RvcDpIU0w6MzE3MDIxNg==",
lat: 60.21409,
lon: 24.70354
},
{
id: "U3RvcDpIU0w6MzE3MDIxNw==",
lat: 60.21116,
lon: 24.69975
},
{
id: "U3RvcDpIU0w6MzE3MDIxOA==",
lat: 60.20817,
lon: 24.70252
},
{
id: "U3RvcDpIU0w6MzE3MDI1MA==",
lat: 60.210423,
lon: 24.707867
},
{
id: "U3RvcDpIU0w6MzE3MDIyMQ==",
lat: 60.21178,
lon: 24.71897
},
{
id: "U3RvcDpIU0w6MzE3MDIyMg==",
lat: 60.21277,
lon: 24.72321
}
]
},
{
gtfsId: "HSL:2111",
shortName: "111",
longName: "Otaniemi-Tapiola(M)-Westend-Matinkylä(M)-Hyljelahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIyMjIxMA==",
lat: 60.187376,
lon: 24.833901
},
{
id: "U3RvcDpIU0w6MjIyMjIxMQ==",
lat: 60.183984,
lon: 24.829145
},
{
id: "U3RvcDpIU0w6MjIyMjIxNQ==",
lat: 60.18236,
lon: 24.82545
},
{
id: "U3RvcDpIU0w6MjIyMjIyNQ==",
lat: 60.18609,
lon: 24.81291
},
{
id: "U3RvcDpIU0w6MjIxNTI5OQ==",
lat: 60.18474,
lon: 24.80423
},
{
id: "U3RvcDpIU0w6MjIxNTIzNQ==",
lat: 60.18727,
lon: 24.80375
},
{
id: "U3RvcDpIU0w6MjIxNTI4Mg==",
lat: 60.18928,
lon: 24.80221
},
{
id: "U3RvcDpIU0w6MjIxNTI4Mw==",
lat: 60.18986,
lon: 24.80011
},
{
id: "U3RvcDpIU0w6MjIxNTI4MQ==",
lat: 60.18749,
lon: 24.79715
},
{
id: "U3RvcDpIU0w6MjIxNTIyMQ==",
lat: 60.18401,
lon: 24.7952
},
{
id: "U3RvcDpIU0w6MjIxMjIxOQ==",
lat: 60.18154,
lon: 24.79584
},
{
id: "U3RvcDpIU0w6MjIxMjIxNw==",
lat: 60.17822,
lon: 24.79887
},
{
id: "U3RvcDpIU0w6MjIxMjIxNQ==",
lat: 60.1759,
lon: 24.80008
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMTIzNg==",
lat: 60.17364,
lon: 24.81027
},
{
id: "U3RvcDpIU0w6MjIxMTIzOA==",
lat: 60.17046,
lon: 24.81056
},
{
id: "U3RvcDpIU0w6MjIzMTIwMw==",
lat: 60.168,
lon: 24.80632
},
{
id: "U3RvcDpIU0w6MjIzMTIwNA==",
lat: 60.1657,
lon: 24.80552
},
{
id: "U3RvcDpIU0w6MjIzMTIwNg==",
lat: 60.16328,
lon: 24.80276
},
{
id: "U3RvcDpIU0w6MjIzMTIzNQ==",
lat: 60.16293,
lon: 24.79966
},
{
id: "U3RvcDpIU0w6MjIzMTIzMw==",
lat: 60.16402,
lon: 24.7922
},
{
id: "U3RvcDpIU0w6MjIzMTIzNw==",
lat: 60.16331,
lon: 24.79048
},
{
id: "U3RvcDpIU0w6MjIzMTIzMQ==",
lat: 60.16042,
lon: 24.78971
},
{
id: "U3RvcDpIU0w6MjIzMjIxNQ==",
lat: 60.1594,
lon: 24.78585
},
{
id: "U3RvcDpIU0w6MjIzMjIxNw==",
lat: 60.15969,
lon: 24.78236
},
{
id: "U3RvcDpIU0w6MjIzMjIxOQ==",
lat: 60.16206,
lon: 24.78054
},
{
id: "U3RvcDpIU0w6MjIzMjIzNg==",
lat: 60.16262,
lon: 24.77681
},
{
id: "U3RvcDpIU0w6MjIzMjI0MA==",
lat: 60.16331,
lon: 24.77277
},
{
id: "U3RvcDpIU0w6MjIzMjIzOA==",
lat: 60.16245,
lon: 24.76766
},
{
id: "U3RvcDpIU0w6MjMxNDIwNQ==",
lat: 60.16156,
lon: 24.75989
},
{
id: "U3RvcDpIU0w6MjMxNDIwMw==",
lat: 60.16122,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjMxMzIwMQ==",
lat: 60.16176,
lon: 24.74732
},
{
id: "U3RvcDpIU0w6MjMxMzIwNQ==",
lat: 60.161989,
lon: 24.740844
},
{
id: "U3RvcDpIU0w6MjMxMTIwMQ==",
lat: 60.160644,
lon: 24.740316
},
{
id: "U3RvcDpIU0w6MjMxNDIyNA==",
lat: 60.15827,
lon: 24.73214
},
{
id: "U3RvcDpIU0w6MjMxMjIwMg==",
lat: 60.156464,
lon: 24.725221
},
{
id: "U3RvcDpIU0w6MjQ0MjIyNA==",
lat: 60.155586,
lon: 24.713352
},
{
id: "U3RvcDpIU0w6MjQ0MTIwNw==",
lat: 60.15241,
lon: 24.707925
},
{
id: "U3RvcDpIU0w6MjQ0MTIzNg==",
lat: 60.15091,
lon: 24.70911
},
{
id: "U3RvcDpIU0w6MjQ0MTI0Ng==",
lat: 60.14718,
lon: 24.71122
},
{
id: "U3RvcDpIU0w6MjQ0MTI0MA==",
lat: 60.14628,
lon: 24.70725
},
{
id: "U3RvcDpIU0w6MjQ0MTIwOA==",
lat: 60.14553,
lon: 24.70323
},
{
id: "U3RvcDpIU0w6MjQ0MTI0Mg==",
lat: 60.14496,
lon: 24.69971
},
{
id: "U3RvcDpIU0w6MjQ0MTI0NA==",
lat: 60.14464,
lon: 24.69727
},
{
id: "U3RvcDpIU0w6MjQ0MTI0Mw==",
lat: 60.14498,
lon: 24.70064
},
{
id: "U3RvcDpIU0w6MjQ0MTIwMQ==",
lat: 60.14573,
lon: 24.704
},
{
id: "U3RvcDpIU0w6MjQ0MTI0MQ==",
lat: 60.14635,
lon: 24.70844
},
{
id: "U3RvcDpIU0w6MjQ0MTI0NQ==",
lat: 60.14724,
lon: 24.71156
},
{
id: "U3RvcDpIU0w6MjQ0MTIzNQ==",
lat: 60.15081,
lon: 24.70941
},
{
id: "U3RvcDpIU0w6MjQ0MTIzMw==",
lat: 60.15368,
lon: 24.71046
},
{
id: "U3RvcDpIU0w6MjQ0MTIwOQ==",
lat: 60.155789,
lon: 24.714964
},
{
id: "U3RvcDpIU0w6MjMxNDIyNg==",
lat: 60.15706,
lon: 24.72747
},
{
id: "U3RvcDpIU0w6MjMxMTIxOQ==",
lat: 60.15915,
lon: 24.737556
},
{
id: "U3RvcDpIU0w6MjMxNDIwOA==",
lat: 60.161049,
lon: 24.740512
},
{
id: "U3RvcDpIU0w6MjMxMzIwNg==",
lat: 60.161752,
lon: 24.740728
},
{
id: "U3RvcDpIU0w6MjMxMzIwMg==",
lat: 60.16181,
lon: 24.74771
},
{
id: "U3RvcDpIU0w6MjMxNDIwNA==",
lat: 60.16113,
lon: 24.75527
},
{
id: "U3RvcDpIU0w6MjIzMjIxMw==",
lat: 60.16171,
lon: 24.76152
},
{
id: "U3RvcDpIU0w6MjIzMjIzOQ==",
lat: 60.16273,
lon: 24.77108
},
{
id: "U3RvcDpIU0w6MjIzMjIzNw==",
lat: 60.16242,
lon: 24.77648
},
{
id: "U3RvcDpIU0w6MjIzMjIyMA==",
lat: 60.1618,
lon: 24.78046
},
{
id: "U3RvcDpIU0w6MjIzMjIxOA==",
lat: 60.15913,
lon: 24.78368
},
{
id: "U3RvcDpIU0w6MjIzMjIxNg==",
lat: 60.15939,
lon: 24.78739
},
{
id: "U3RvcDpIU0w6MjIzMTIzMg==",
lat: 60.16009,
lon: 24.78992
},
{
id: "U3RvcDpIU0w6MjIzMTIzMA==",
lat: 60.16241,
lon: 24.79113
},
{
id: "U3RvcDpIU0w6MjIzMTIzNA==",
lat: 60.16435,
lon: 24.79435
},
{
id: "U3RvcDpIU0w6MjIzMTIwNw==",
lat: 60.1628,
lon: 24.80236
},
{
id: "U3RvcDpIU0w6MjIzMTIwNQ==",
lat: 60.16634,
lon: 24.80611
},
{
id: "U3RvcDpIU0w6MjIzMTIxMQ==",
lat: 60.16872,
lon: 24.80641
},
{
id: "U3RvcDpIU0w6MjIxMTIzNw==",
lat: 60.17083,
lon: 24.81079
},
{
id: "U3RvcDpIU0w6MjIxMTIzNQ==",
lat: 60.17359,
lon: 24.81072
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMjIxNg==",
lat: 60.17928,
lon: 24.79851
},
{
id: "U3RvcDpIU0w6MjIxMjIxOA==",
lat: 60.18134,
lon: 24.79634
},
{
id: "U3RvcDpIU0w6MjIxNTIyMA==",
lat: 60.1836,
lon: 24.79511
},
{
id: "U3RvcDpIU0w6MjIxNTIyMg==",
lat: 60.18663,
lon: 24.79671
},
{
id: "U3RvcDpIU0w6MjIxNTI4MA==",
lat: 60.18833,
lon: 24.79757
},
{
id: "U3RvcDpIU0w6MjIxNTI4NA==",
lat: 60.18945,
lon: 24.80021
},
{
id: "U3RvcDpIU0w6MjIxNTIzMg==",
lat: 60.187955,
lon: 24.803429
},
{
id: "U3RvcDpIU0w6MjIxNTI3NA==",
lat: 60.18458,
lon: 24.80398
},
{
id: "U3RvcDpIU0w6MjIyMjIyNg==",
lat: 60.185,
lon: 24.81447
},
{
id: "U3RvcDpIU0w6MjIyMjIxNg==",
lat: 60.18244,
lon: 24.82595
},
{
id: "U3RvcDpIU0w6MjIyMjIzNQ==",
lat: 60.183881,
lon: 24.828943
},
{
id: "U3RvcDpIU0w6MjIyMjIwOQ==",
lat: 60.18833,
lon: 24.83492
}
]
},
{
gtfsId: "HSL:1021",
shortName: "21",
longName: "Eira-Lauttasaari(M)-Vattuniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMxMDEzNw==",
lat: 60.149985,
lon: 24.881588
},
{
id: "U3RvcDpIU0w6MTMxMDE0Ng==",
lat: 60.15126,
lon: 24.88587
},
{
id: "U3RvcDpIU0w6MTMxMDE0NQ==",
lat: 60.153338,
lon: 24.88512
},
{
id: "U3RvcDpIU0w6MTMyMDEzNg==",
lat: 60.154238,
lon: 24.882168
},
{
id: "U3RvcDpIU0w6MTMxMDEzMA==",
lat: 60.1539,
lon: 24.8764
},
{
id: "U3RvcDpIU0w6MTMxMDEyOA==",
lat: 60.157265,
lon: 24.874033
},
{
id: "U3RvcDpIU0w6MTMxMDEwOA==",
lat: 60.15927,
lon: 24.877175
},
{
id: "U3RvcDpIU0w6MTMxMDEwNg==",
lat: 60.160297,
lon: 24.881277
},
{
id: "U3RvcDpIU0w6MTMxMDEwMg==",
lat: 60.16113,
lon: 24.89116
},
{
id: "U3RvcDpIU0w6MTIwMTEzMg==",
lat: 60.16338,
lon: 24.90505
},
{
id: "U3RvcDpIU0w6MTIwMTEzNg==",
lat: 60.16335,
lon: 24.91484
},
{
id: "U3RvcDpIU0w6MTIwMTEzNA==",
lat: 60.163533,
lon: 24.920651
},
{
id: "U3RvcDpIU0w6MTA0MDE1Nw==",
lat: 60.1611,
lon: 24.92455
},
{
id: "U3RvcDpIU0w6MTA1MDEzMg==",
lat: 60.162237,
lon: 24.931177
},
{
id: "U3RvcDpIU0w6MTA1MDEwNw==",
lat: 60.162453,
lon: 24.935799
},
{
id: "U3RvcDpIU0w6MTA1MDExMA==",
lat: 60.160876,
lon: 24.938023
},
{
id: "U3RvcDpIU0w6MTA1MDEwOQ==",
lat: 60.16061,
lon: 24.94144
},
{
id: "U3RvcDpIU0w6MTA2MDEwMw==",
lat: 60.15788,
lon: 24.94127
},
{
id: "U3RvcDpIU0w6MTA2MDEyOQ==",
lat: 60.1554,
lon: 24.94244
},
{
id: "U3RvcDpIU0w6MTA2MDEwMQ==",
lat: 60.15562,
lon: 24.9425
},
{
id: "U3RvcDpIU0w6MTA2MDEwNA==",
lat: 60.158277,
lon: 24.94121
},
{
id: "U3RvcDpIU0w6MTA1MDEwNg==",
lat: 60.16288,
lon: 24.93909
},
{
id: "U3RvcDpIU0w6MTA0MDEwMg==",
lat: 60.164261,
lon: 24.936553
},
{
id: "U3RvcDpIU0w6MTA0MDE1Mw==",
lat: 60.16196,
lon: 24.92906
},
{
id: "U3RvcDpIU0w6MTA0MDE1NQ==",
lat: 60.16192,
lon: 24.92366
},
{
id: "U3RvcDpIU0w6MTIwMTEzMw==",
lat: 60.163552,
lon: 24.919945
},
{
id: "U3RvcDpIU0w6MTIwMTEyMQ==",
lat: 60.163396,
lon: 24.914207
},
{
id: "U3RvcDpIU0w6MTIwMTEzMQ==",
lat: 60.16338,
lon: 24.9044
},
{
id: "U3RvcDpIU0w6MTMxMDEwMQ==",
lat: 60.16126,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMxMDEwNQ==",
lat: 60.16055,
lon: 24.87946
},
{
id: "U3RvcDpIU0w6MTMxMDEwNw==",
lat: 60.15877,
lon: 24.87683
},
{
id: "U3RvcDpIU0w6MTMxMDEyNw==",
lat: 60.15759,
lon: 24.87384
},
{
id: "U3RvcDpIU0w6MTMxMDEyOQ==",
lat: 60.15365,
lon: 24.87722
},
{
id: "U3RvcDpIU0w6MTMxMDE0OA==",
lat: 60.154234,
lon: 24.880355
},
{
id: "U3RvcDpIU0w6MTMyMDE5OQ==",
lat: 60.153807,
lon: 24.884731
},
{
id: "U3RvcDpIU0w6MTMxMDIwMA==",
lat: 60.150452,
lon: 24.886015
}
]
},
{
gtfsId: "HSL:1020",
shortName: "20",
longName: "Ruoholahti-Lauttasaari (M)-Katajaharju",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMxMDEyMQ==",
lat: 60.16819,
lon: 24.85737
},
{
id: "U3RvcDpIU0w6MTMxMDEyMA==",
lat: 60.16492,
lon: 24.85843
},
{
id: "U3RvcDpIU0w6MTMxMDExOA==",
lat: 60.16182,
lon: 24.85971
},
{
id: "U3RvcDpIU0w6MTMxMDExNg==",
lat: 60.1583,
lon: 24.86154
},
{
id: "U3RvcDpIU0w6MTMxMDExNA==",
lat: 60.15665,
lon: 24.86538
},
{
id: "U3RvcDpIU0w6MTMxMDExMg==",
lat: 60.15688,
lon: 24.86863
},
{
id: "U3RvcDpIU0w6MTMxMDExMA==",
lat: 60.15794,
lon: 24.87188
},
{
id: "U3RvcDpIU0w6MTMxMDEwOA==",
lat: 60.15927,
lon: 24.877175
},
{
id: "U3RvcDpIU0w6MTMxMDEwNg==",
lat: 60.160297,
lon: 24.881277
},
{
id: "U3RvcDpIU0w6MTMxMDEwMg==",
lat: 60.16113,
lon: 24.89116
},
{
id: "U3RvcDpIU0w6MTIwMTEzMg==",
lat: 60.16338,
lon: 24.90505
},
{
id: "U3RvcDpIU0w6MTIwMTEzNg==",
lat: 60.16335,
lon: 24.91484
},
{
id: "U3RvcDpIU0w6MTIwMTEzNA==",
lat: 60.163533,
lon: 24.920651
},
{
id: "U3RvcDpIU0w6MTA0MDE0Mg==",
lat: 60.162166,
lon: 24.92388
},
{
id: "U3RvcDpIU0w6MTIwMTEzMw==",
lat: 60.163552,
lon: 24.919945
},
{
id: "U3RvcDpIU0w6MTIwMTEyMQ==",
lat: 60.163396,
lon: 24.914207
},
{
id: "U3RvcDpIU0w6MTIwMTEzMQ==",
lat: 60.16338,
lon: 24.9044
},
{
id: "U3RvcDpIU0w6MTMxMDEwMQ==",
lat: 60.16126,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMxMDEwNQ==",
lat: 60.16055,
lon: 24.87946
},
{
id: "U3RvcDpIU0w6MTMxMDEwNw==",
lat: 60.15877,
lon: 24.87683
},
{
id: "U3RvcDpIU0w6MTMxMDEwOQ==",
lat: 60.15817,
lon: 24.87228
},
{
id: "U3RvcDpIU0w6MTMxMDExMQ==",
lat: 60.1568,
lon: 24.86791
},
{
id: "U3RvcDpIU0w6MTMxMDExMw==",
lat: 60.15688,
lon: 24.86445
},
{
id: "U3RvcDpIU0w6MTMxMDExNQ==",
lat: 60.15934,
lon: 24.86085
},
{
id: "U3RvcDpIU0w6MTMxMDExNw==",
lat: 60.16207,
lon: 24.85976
},
{
id: "U3RvcDpIU0w6MTMxMDExOQ==",
lat: 60.165174,
lon: 24.85844
}
]
},
{
gtfsId: "HSL:2229",
shortName: "229",
longName: "Leppävaara-Karakallio-Viherlaakso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIzNw==",
lat: 60.21898,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6MjExMTIyOA==",
lat: 60.22132,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExMTI1Nw==",
lat: 60.221951,
lon: 24.813737
},
{
id: "U3RvcDpIU0w6MjExMTIyOQ==",
lat: 60.22095,
lon: 24.80986
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwOQ==",
lat: 60.22671,
lon: 24.77975
},
{
id: "U3RvcDpIU0w6MjEzMzIwMQ==",
lat: 60.229776,
lon: 24.786597
},
{
id: "U3RvcDpIU0w6MjEzMzI2MA==",
lat: 60.22871,
lon: 24.77909
},
{
id: "U3RvcDpIU0w6MjEzMzIwNg==",
lat: 60.23177,
lon: 24.776349
},
{
id: "U3RvcDpIU0w6MjEzMzIzNA==",
lat: 60.22965,
lon: 24.77683
},
{
id: "U3RvcDpIU0w6MjEzMzIzMA==",
lat: 60.231325,
lon: 24.771423
},
{
id: "U3RvcDpIU0w6MjEzMzIyNg==",
lat: 60.230757,
lon: 24.772592
},
{
id: "U3RvcDpIU0w6MjEzMzIxMQ==",
lat: 60.22934,
lon: 24.77365
},
{
id: "U3RvcDpIU0w6MjEzMzIxMw==",
lat: 60.22968,
lon: 24.76792
},
{
id: "U3RvcDpIU0w6MjEzMzIzMg==",
lat: 60.23027,
lon: 24.76287
},
{
id: "U3RvcDpIU0w6MjEzMzIyOA==",
lat: 60.228735,
lon: 24.762005
},
{
id: "U3RvcDpIU0w6MjEzMzIxNw==",
lat: 60.228,
lon: 24.76138
},
{
id: "U3RvcDpIU0w6MjEzMzIyMw==",
lat: 60.22812,
lon: 24.75623
},
{
id: "U3RvcDpIU0w6MjE0MTIxOQ==",
lat: 60.23245,
lon: 24.75243
},
{
id: "U3RvcDpIU0w6MjE1MTIxMg==",
lat: 60.2317,
lon: 24.74328
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIyMw==",
lat: 60.227552,
lon: 24.741786
},
{
id: "U3RvcDpIU0w6MjE1MTIyOA==",
lat: 60.229382,
lon: 24.743786
},
{
id: "U3RvcDpIU0w6MjE1MTIwMA==",
lat: 60.228797,
lon: 24.750299
},
{
id: "U3RvcDpIU0w6MjE1MTIyNg==",
lat: 60.228875,
lon: 24.744168
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMQ==",
lat: 60.2317,
lon: 24.74358
},
{
id: "U3RvcDpIU0w6MjE0MTIyMA==",
lat: 60.23188,
lon: 24.75277
},
{
id: "U3RvcDpIU0w6MjEzMzIxNg==",
lat: 60.228636,
lon: 24.764329
},
{
id: "U3RvcDpIU0w6MjEzMzIxNA==",
lat: 60.22959,
lon: 24.76923
},
{
id: "U3RvcDpIU0w6MjEzMzIxMg==",
lat: 60.22916,
lon: 24.77474
},
{
id: "U3RvcDpIU0w6MjEzMzIxOQ==",
lat: 60.22944,
lon: 24.77787
},
{
id: "U3RvcDpIU0w6MjEzMzIxMA==",
lat: 60.22674,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIxMQ==",
lat: 60.22155,
lon: 24.80653
},
{
id: "U3RvcDpIU0w6MjExMjIwMg==",
lat: 60.217967,
lon: 24.809035
},
{
id: "U3RvcDpIU0w6MjExMjIwNA==",
lat: 60.217244,
lon: 24.806945
},
{
id: "U3RvcDpIU0w6MjExMjIwNg==",
lat: 60.217333,
lon: 24.804133
},
{
id: "U3RvcDpIU0w6MjExMjIwOA==",
lat: 60.216843,
lon: 24.80041
},
{
id: "U3RvcDpIU0w6MjExMjIyNg==",
lat: 60.21413,
lon: 24.80096
},
{
id: "U3RvcDpIU0w6MjExMjIxNg==",
lat: 60.21408,
lon: 24.80549
},
{
id: "U3RvcDpIU0w6MjExMjIzMQ==",
lat: 60.21428,
lon: 24.81122
},
{
id: "U3RvcDpIU0w6MjExMjIzMg==",
lat: 60.21643,
lon: 24.81222
},
{
id: "U3RvcDpIU0w6MjExMjI5Ng==",
lat: 60.21721,
lon: 24.81279
},
{
id: "U3RvcDpIU0w6MjExMjIxMQ==",
lat: 60.21898,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6MjExMjIwMQ==",
lat: 60.217877,
lon: 24.808812
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:2349",
shortName: "349",
longName: "Lepsämänjoki-Hännikäinen-Serena-Kalajärvi-Perusmäki-Nemlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMjI0OQ==",
lat: 60.31005,
lon: 24.70761
},
{
id: "U3RvcDpIU0w6MjcyMjI2Mw==",
lat: 60.30753,
lon: 24.70552
},
{
id: "U3RvcDpIU0w6MjcyMjI2NQ==",
lat: 60.30363,
lon: 24.70013
},
{
id: "U3RvcDpIU0w6MjcxMjAwMg==",
lat: 60.297265,
lon: 24.691783
},
{
id: "U3RvcDpIU0w6MjcxMTI3NA==",
lat: 60.29655,
lon: 24.69787
},
{
id: "U3RvcDpIU0w6MjcxNDI5OA==",
lat: 60.28568,
lon: 24.70723
},
{
id: "U3RvcDpIU0w6MjcxNDIwNQ==",
lat: 60.28661,
lon: 24.7115
},
{
id: "U3RvcDpIU0w6MjcxNDIwMw==",
lat: 60.28796,
lon: 24.71484
},
{
id: "U3RvcDpIU0w6MjcxNDIxMQ==",
lat: 60.28834,
lon: 24.719273
},
{
id: "U3RvcDpIU0w6MjcxNDI1NQ==",
lat: 60.286994,
lon: 24.725706
},
{
id: "U3RvcDpIU0w6MjcxNDI1NA==",
lat: 60.28594,
lon: 24.73075
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mw==",
lat: 60.28618,
lon: 24.73694
},
{
id: "U3RvcDpIU0w6MjcxNTI1MQ==",
lat: 60.28582,
lon: 24.74113
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
},
{
id: "U3RvcDpIU0w6MjcyMTIxMg==",
lat: 60.305,
lon: 24.74149
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMzIyOQ==",
lat: 60.31776,
lon: 24.71642
},
{
id: "U3RvcDpIU0w6MjcyMzIxMQ==",
lat: 60.32229,
lon: 24.71755
},
{
id: "U3RvcDpIU0w6MjcyMzIzMQ==",
lat: 60.323319,
lon: 24.7162
},
{
id: "U3RvcDpIU0w6MjcyMzI3OA==",
lat: 60.32804,
lon: 24.71869
},
{
id: "U3RvcDpIU0w6MjcyMzI5Mg==",
lat: 60.32493,
lon: 24.72689
},
{
id: "U3RvcDpIU0w6MjcyMzI4Mw==",
lat: 60.32415,
lon: 24.73677
},
{
id: "U3RvcDpIU0w6MjcyMzI5MA==",
lat: 60.32206,
lon: 24.71847
},
{
id: "U3RvcDpIU0w6MjcyMzIzMw==",
lat: 60.32928,
lon: 24.71024
},
{
id: "U3RvcDpIU0w6MjcyMzIzNQ==",
lat: 60.33417,
lon: 24.71006
},
{
id: "U3RvcDpIU0w6MjcyMzIzNw==",
lat: 60.33689,
lon: 24.71032
},
{
id: "U3RvcDpIU0w6MjcyMzIzOQ==",
lat: 60.34191,
lon: 24.71348
},
{
id: "U3RvcDpIU0w6MjcyMzI0MQ==",
lat: 60.3446,
lon: 24.72721
},
{
id: "U3RvcDpIU0w6MjcyMzI0NA==",
lat: 60.34567,
lon: 24.73115
},
{
id: "U3RvcDpIU0w6MjcyMzI0Mg==",
lat: 60.34457,
lon: 24.72664
},
{
id: "U3RvcDpIU0w6MjcyMzI0MA==",
lat: 60.34214,
lon: 24.71353
},
{
id: "U3RvcDpIU0w6MjcyMzI3Ng==",
lat: 60.34047,
lon: 24.70653
},
{
id: "U3RvcDpIU0w6MjcyMzI3Mw==",
lat: 60.34273,
lon: 24.70409
},
{
id: "U3RvcDpIU0w6MjcyMzI3MQ==",
lat: 60.34615,
lon: 24.70234
},
{
id: "U3RvcDpIU0w6MjcyMzI2MQ==",
lat: 60.34888,
lon: 24.69919
},
{
id: "U3RvcDpIU0w6MjcyMzI0Ng==",
lat: 60.35487,
lon: 24.69083
},
{
id: "U3RvcDpIU0w6MjcyMzI4MA==",
lat: 60.35762,
lon: 24.672833
},
{
id: "U3RvcDpIU0w6MjcyMzI4Mg==",
lat: 60.35718,
lon: 24.68554
},
{
id: "U3RvcDpIU0w6MjcyMzI3Mg==",
lat: 60.35454,
lon: 24.69139
},
{
id: "U3RvcDpIU0w6MjcyMzI2Mg==",
lat: 60.3486,
lon: 24.69945
},
{
id: "U3RvcDpIU0w6MjcyMzI3NA==",
lat: 60.34616,
lon: 24.70221
},
{
id: "U3RvcDpIU0w6MjcyMzI3NQ==",
lat: 60.3427,
lon: 24.70397
},
{
id: "U3RvcDpIU0w6MjcyMzI3OQ==",
lat: 60.34035,
lon: 24.70672
},
{
id: "U3RvcDpIU0w6MjcyMzIzOA==",
lat: 60.3368,
lon: 24.71016
},
{
id: "U3RvcDpIU0w6MjcyMzIzNg==",
lat: 60.33429,
lon: 24.70989
},
{
id: "U3RvcDpIU0w6MjcyMzIzNA==",
lat: 60.32961,
lon: 24.70996
},
{
id: "U3RvcDpIU0w6MjcyMzIzMg==",
lat: 60.324161,
lon: 24.714759
},
{
id: "U3RvcDpIU0w6MjcyMzI5MQ==",
lat: 60.32192,
lon: 24.71927
},
{
id: "U3RvcDpIU0w6MjcyMzI5Mw==",
lat: 60.32517,
lon: 24.7268
},
{
id: "U3RvcDpIU0w6MjcyMzI3Nw==",
lat: 60.327726,
lon: 24.717678
},
{
id: "U3RvcDpIU0w6MjcyMzIxMA==",
lat: 60.321463,
lon: 24.717534
},
{
id: "U3RvcDpIU0w6MjcyMzIzMA==",
lat: 60.31757,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIxMw==",
lat: 60.30444,
lon: 24.74096
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0OQ==",
lat: 60.28471,
lon: 24.74512
},
{
id: "U3RvcDpIU0w6MjcxNTI1MA==",
lat: 60.28549,
lon: 24.74204
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mg==",
lat: 60.28637,
lon: 24.73772
},
{
id: "U3RvcDpIU0w6MjcxNDI5Ng==",
lat: 60.28573,
lon: 24.73092
},
{
id: "U3RvcDpIU0w6MjcxNDI5OQ==",
lat: 60.287706,
lon: 24.722557
},
{
id: "U3RvcDpIU0w6MjcxNDIxMA==",
lat: 60.288488,
lon: 24.719048
},
{
id: "U3RvcDpIU0w6MjcxNDIwMg==",
lat: 60.28834,
lon: 24.7149
},
{
id: "U3RvcDpIU0w6MjcxNDIwNA==",
lat: 60.28652,
lon: 24.71082
},
{
id: "U3RvcDpIU0w6MjcxMTI3Nw==",
lat: 60.28582,
lon: 24.70576
},
{
id: "U3RvcDpIU0w6MjcxMTI3NQ==",
lat: 60.29623,
lon: 24.6991
},
{
id: "U3RvcDpIU0w6MjcyMjI2Ng==",
lat: 60.30365,
lon: 24.70047
},
{
id: "U3RvcDpIU0w6MjcyMjI2NA==",
lat: 60.30807,
lon: 24.70643
},
{
id: "U3RvcDpIU0w6MjcyMjI0OA==",
lat: 60.30985,
lon: 24.70757
}
]
},
{
gtfsId: "HSL:1018",
shortName: "18",
longName: "Eira-Kamppi-Munkkivuori",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA2MDEwMQ==",
lat: 60.15562,
lon: 24.9425
},
{
id: "U3RvcDpIU0w6MTA2MDEwNA==",
lat: 60.158277,
lon: 24.94121
},
{
id: "U3RvcDpIU0w6MTA1MDEwNg==",
lat: 60.16288,
lon: 24.93909
},
{
id: "U3RvcDpIU0w6MTA0MDEyMw==",
lat: 60.16494,
lon: 24.93622
},
{
id: "U3RvcDpIU0w6MTA0MDEyNQ==",
lat: 60.167257,
lon: 24.933017
},
{
id: "U3RvcDpIU0w6MTA0MDE0NA==",
lat: 60.169432,
lon: 24.930045
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEyNw==",
lat: 60.180264,
lon: 24.921903
},
{
id: "U3RvcDpIU0w6MTE0MDEyOQ==",
lat: 60.18153,
lon: 24.92058
},
{
id: "U3RvcDpIU0w6MTE0MDEzMQ==",
lat: 60.18341,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE0MDEzMw==",
lat: 60.18581,
lon: 24.91596
},
{
id: "U3RvcDpIU0w6MTE1MDEwNw==",
lat: 60.189912,
lon: 24.909831
},
{
id: "U3RvcDpIU0w6MTE1MDEwOQ==",
lat: 60.19067,
lon: 24.90781
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MTMwNDEyNw==",
lat: 60.20289,
lon: 24.88189
},
{
id: "U3RvcDpIU0w6MTMwNDE0MA==",
lat: 60.20693,
lon: 24.87868
},
{
id: "U3RvcDpIU0w6MTMwNDE0MQ==",
lat: 60.20891,
lon: 24.87561
},
{
id: "U3RvcDpIU0w6MTMwNDE0Mg==",
lat: 60.20934,
lon: 24.86737
},
{
id: "U3RvcDpIU0w6MTMwNDEzOA==",
lat: 60.20749,
lon: 24.85745
},
{
id: "U3RvcDpIU0w6MTMwNDE0Mw==",
lat: 60.20785,
lon: 24.86408
},
{
id: "U3RvcDpIU0w6MTMwNDE1Nw==",
lat: 60.205768,
lon: 24.863507
},
{
id: "U3RvcDpIU0w6MTMwNDE0NA==",
lat: 60.20378,
lon: 24.86971
},
{
id: "U3RvcDpIU0w6MTMwNDE1OQ==",
lat: 60.20391,
lon: 24.87377
},
{
id: "U3RvcDpIU0w6MTMwNDE2MQ==",
lat: 60.20542,
lon: 24.87725
},
{
id: "U3RvcDpIU0w6MTMwNDEwMw==",
lat: 60.205472,
lon: 24.877963
},
{
id: "U3RvcDpIU0w6MTMwNDEyOQ==",
lat: 60.203905,
lon: 24.873805
},
{
id: "U3RvcDpIU0w6MTMwNDEzMA==",
lat: 60.20412,
lon: 24.86842
},
{
id: "U3RvcDpIU0w6MTMwNDEzMQ==",
lat: 60.20569,
lon: 24.8638
},
{
id: "U3RvcDpIU0w6MTMwNDEzMg==",
lat: 60.20745,
lon: 24.86424
},
{
id: "U3RvcDpIU0w6MTMwNDEzMw==",
lat: 60.2091,
lon: 24.86682
},
{
id: "U3RvcDpIU0w6MTMwNDEzNA==",
lat: 60.2091,
lon: 24.8748
},
{
id: "U3RvcDpIU0w6MTMwNDEzNQ==",
lat: 60.20743,
lon: 24.87799
},
{
id: "U3RvcDpIU0w6MTMwNDEzNw==",
lat: 60.206219,
lon: 24.879857
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyNA==",
lat: 60.19618,
lon: 24.88529
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
},
{
id: "U3RvcDpIU0w6MTE1MDEwOA==",
lat: 60.188734,
lon: 24.912259
},
{
id: "U3RvcDpIU0w6MTE0MDEwNQ==",
lat: 60.18479,
lon: 24.91689
},
{
id: "U3RvcDpIU0w6MTE0MDEzMA==",
lat: 60.18142,
lon: 24.92043
},
{
id: "U3RvcDpIU0w6MTE0MDEwMw==",
lat: 60.17966,
lon: 24.92227
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDE0OA==",
lat: 60.169156,
lon: 24.930101
},
{
id: "U3RvcDpIU0w6MTA0MDEyNg==",
lat: 60.165618,
lon: 24.931375
},
{
id: "U3RvcDpIU0w6MTA0MDEyNA==",
lat: 60.163645,
lon: 24.934098
},
{
id: "U3RvcDpIU0w6MTA1MDEwNw==",
lat: 60.162453,
lon: 24.935799
},
{
id: "U3RvcDpIU0w6MTA1MDExMA==",
lat: 60.160876,
lon: 24.938023
},
{
id: "U3RvcDpIU0w6MTA1MDEwOQ==",
lat: 60.16061,
lon: 24.94144
},
{
id: "U3RvcDpIU0w6MTA2MDEwMw==",
lat: 60.15788,
lon: 24.94127
},
{
id: "U3RvcDpIU0w6MTA2MDEyOQ==",
lat: 60.1554,
lon: 24.94244
}
]
},
{
gtfsId: "HSL:2348",
shortName: "348",
longName: "Rinnekoti-Röylä-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTIxMg==",
lat: 60.305,
lon: 24.74149
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMjI4OQ==",
lat: 60.31606,
lon: 24.71495
},
{
id: "U3RvcDpIU0w6MjcyMjI4Nw==",
lat: 60.31253,
lon: 24.71071
},
{
id: "U3RvcDpIU0w6MjcyMjI0OQ==",
lat: 60.31005,
lon: 24.70761
},
{
id: "U3RvcDpIU0w6MjcyMjI2Mw==",
lat: 60.30753,
lon: 24.70552
},
{
id: "U3RvcDpIU0w6MjcyMjI2NQ==",
lat: 60.30363,
lon: 24.70013
},
{
id: "U3RvcDpIU0w6MjcxMjAwMg==",
lat: 60.297265,
lon: 24.691783
},
{
id: "U3RvcDpIU0w6MjcxMTI3Mw==",
lat: 60.303357,
lon: 24.68141
},
{
id: "U3RvcDpIU0w6MjcyMjI2OA==",
lat: 60.31467,
lon: 24.68508
},
{
id: "U3RvcDpIU0w6MjcyMjIxOQ==",
lat: 60.32298,
lon: 24.6786
},
{
id: "U3RvcDpIU0w6MjcyNTIyMQ==",
lat: 60.32553,
lon: 24.66102
},
{
id: "U3RvcDpIU0w6MjcyNTIwMg==",
lat: 60.3221,
lon: 24.64426
},
{
id: "U3RvcDpIU0w6MjcyNTIwMQ==",
lat: 60.31338,
lon: 24.63919
},
{
id: "U3RvcDpIU0w6MjcyNTIwMw==",
lat: 60.32217,
lon: 24.64433
},
{
id: "U3RvcDpIU0w6MjcyNDI1MA==",
lat: 60.32773,
lon: 24.64748
},
{
id: "U3RvcDpIU0w6MjcyNDIwOQ==",
lat: 60.3389,
lon: 24.654
},
{
id: "U3RvcDpIU0w6MjcyNDI3MA==",
lat: 60.34483,
lon: 24.65421
},
{
id: "U3RvcDpIU0w6MjcyNDIwMQ==",
lat: 60.34655,
lon: 24.65505
},
{
id: "U3RvcDpIU0w6MjcyNDI3OQ==",
lat: 60.34895,
lon: 24.65709
},
{
id: "U3RvcDpIU0w6MjcyNDI4MA==",
lat: 60.35094,
lon: 24.65659
},
{
id: "U3RvcDpIU0w6MjcyNDI4MQ==",
lat: 60.35401,
lon: 24.65549
},
{
id: "U3RvcDpIU0w6MjcyNDI4Mw==",
lat: 60.35596,
lon: 24.65378
},
{
id: "U3RvcDpIU0w6MjcyNDI4NQ==",
lat: 60.35751,
lon: 24.65231
},
{
id: "U3RvcDpIU0w6MjcyNDI1NQ==",
lat: 60.35713,
lon: 24.65236
},
{
id: "U3RvcDpIU0w6MjcyNDI1NA==",
lat: 60.35373,
lon: 24.65554
},
{
id: "U3RvcDpIU0w6MjcyNDI1Mw==",
lat: 60.351,
lon: 24.65632
},
{
id: "U3RvcDpIU0w6MjcyNDI1Mg==",
lat: 60.34884,
lon: 24.65696
},
{
id: "U3RvcDpIU0w6MjcyNDIwMg==",
lat: 60.34658,
lon: 24.65489
},
{
id: "U3RvcDpIU0w6MjcyNDI1MQ==",
lat: 60.34397,
lon: 24.654
},
{
id: "U3RvcDpIU0w6MjcyNDIwOA==",
lat: 60.33845,
lon: 24.65381
},
{
id: "U3RvcDpIU0w6MjcyNDI1Nw==",
lat: 60.32917,
lon: 24.64737
},
{
id: "U3RvcDpIU0w6MjcyNTIyNA==",
lat: 60.32614,
lon: 24.64792
},
{
id: "U3RvcDpIU0w6MjcyNTIyMg==",
lat: 60.32546,
lon: 24.66288
},
{
id: "U3RvcDpIU0w6MjcyMjIyMA==",
lat: 60.3231,
lon: 24.67743
},
{
id: "U3RvcDpIU0w6MjcyMjI2Nw==",
lat: 60.3146,
lon: 24.68496
},
{
id: "U3RvcDpIU0w6MjcxMTI3Mg==",
lat: 60.304005,
lon: 24.681398
},
{
id: "U3RvcDpIU0w6MjcxMTIwMw==",
lat: 60.29528,
lon: 24.6864
},
{
id: "U3RvcDpIU0w6MjcyMjI2Ng==",
lat: 60.30365,
lon: 24.70047
},
{
id: "U3RvcDpIU0w6MjcyMjI2NA==",
lat: 60.30807,
lon: 24.70643
},
{
id: "U3RvcDpIU0w6MjcyMjI0OA==",
lat: 60.30985,
lon: 24.70757
},
{
id: "U3RvcDpIU0w6MjcyMjI4Ng==",
lat: 60.31223,
lon: 24.71071
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIxMw==",
lat: 60.30444,
lon: 24.74096
}
]
},
{
gtfsId: "HSL:2227",
shortName: "227",
longName: "Leppävaara-Lippajärvi-Jorvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYzMTI2OQ==",
lat: 60.22126,
lon: 24.68531
},
{
id: "U3RvcDpIU0w6MjYzMjIzMg==",
lat: 60.22308,
lon: 24.6774
},
{
id: "U3RvcDpIU0w6MjYzMjIzNA==",
lat: 60.22558,
lon: 24.68211
},
{
id: "U3RvcDpIU0w6MjYzMjIzNg==",
lat: 60.22601,
lon: 24.68628
},
{
id: "U3RvcDpIU0w6MjYzMjIzOA==",
lat: 60.229,
lon: 24.69282
},
{
id: "U3RvcDpIU0w6MjYzMjI0MA==",
lat: 60.23172,
lon: 24.69809
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mw==",
lat: 60.23605,
lon: 24.7054
},
{
id: "U3RvcDpIU0w6MjYzMjI2MA==",
lat: 60.23844,
lon: 24.70498
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzOA==",
lat: 60.23408,
lon: 24.71654
},
{
id: "U3RvcDpIU0w6MjE1MjIzNg==",
lat: 60.23194,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjE1MjIzNA==",
lat: 60.2298,
lon: 24.71542
},
{
id: "U3RvcDpIU0w6MjE1MjIzMg==",
lat: 60.228,
lon: 24.70977
},
{
id: "U3RvcDpIU0w6MjE1MjIzMA==",
lat: 60.22545,
lon: 24.7065
},
{
id: "U3RvcDpIU0w6MzE3MDI0MQ==",
lat: 60.2239,
lon: 24.70847
},
{
id: "U3RvcDpIU0w6MjE1MTIwNg==",
lat: 60.22434,
lon: 24.72396
},
{
id: "U3RvcDpIU0w6MjE1MTIwNA==",
lat: 60.22519,
lon: 24.73771
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMjIwOA==",
lat: 60.225528,
lon: 24.760625
},
{
id: "U3RvcDpIU0w6MjEzMjIwNg==",
lat: 60.225743,
lon: 24.766743
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIwMA==",
lat: 60.22015,
lon: 24.80185
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIyMg==",
lat: 60.219247,
lon: 24.812767
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwMw==",
lat: 60.22572,
lon: 24.77758
},
{
id: "U3RvcDpIU0w6MjEzMjIwNQ==",
lat: 60.22578,
lon: 24.76438
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwMw==",
lat: 60.22521,
lon: 24.73631
},
{
id: "U3RvcDpIU0w6MjE1MTIwNQ==",
lat: 60.22459,
lon: 24.72212
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mw==",
lat: 60.22459,
lon: 24.70664
},
{
id: "U3RvcDpIU0w6MjE1MjIyOQ==",
lat: 60.22726,
lon: 24.708
},
{
id: "U3RvcDpIU0w6MjE1MjIzMQ==",
lat: 60.22812,
lon: 24.71094
},
{
id: "U3RvcDpIU0w6MjE1MjIzMw==",
lat: 60.23013,
lon: 24.71583
},
{
id: "U3RvcDpIU0w6MjE1MjIzNQ==",
lat: 60.23214,
lon: 24.71632
},
{
id: "U3RvcDpIU0w6MjE1MjI0NQ==",
lat: 60.23402,
lon: 24.71677
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI1OA==",
lat: 60.23912,
lon: 24.70695
},
{
id: "U3RvcDpIU0w6MjYzMjI1OQ==",
lat: 60.23785,
lon: 24.70422
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mg==",
lat: 60.23498,
lon: 24.70481
},
{
id: "U3RvcDpIU0w6MjYzMjI0MQ==",
lat: 60.23238,
lon: 24.69878
},
{
id: "U3RvcDpIU0w6MjYzMjIzOQ==",
lat: 60.23077,
lon: 24.69602
},
{
id: "U3RvcDpIU0w6MjYzMjIzNw==",
lat: 60.22856,
lon: 24.69157
},
{
id: "U3RvcDpIU0w6MjYzMjIzNQ==",
lat: 60.22592,
lon: 24.68556
},
{
id: "U3RvcDpIU0w6MjYzMjIzMw==",
lat: 60.22548,
lon: 24.68117
},
{
id: "U3RvcDpIU0w6MjYzMjI3Mw==",
lat: 60.22305,
lon: 24.67722
},
{
id: "U3RvcDpIU0w6MjYzMTIwNA==",
lat: 60.22248,
lon: 24.67796
}
]
},
{
gtfsId: "HSL:1017",
shortName: "17",
longName: "Kallio - Munkkisaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTIwNDExOA==",
lat: 60.15427,
lon: 24.93177
},
{
id: "U3RvcDpIU0w6MTA3MDExOQ==",
lat: 60.158017,
lon: 24.9419
},
{
id: "U3RvcDpIU0w6MTA3MDEyMg==",
lat: 60.15825,
lon: 24.94543
},
{
id: "U3RvcDpIU0w6MTA3MDEwMw==",
lat: 60.158483,
lon: 24.949833
},
{
id: "U3RvcDpIU0w6MTA3MDExMw==",
lat: 60.15939,
lon: 24.954144
},
{
id: "U3RvcDpIU0w6MTA5MDEwMg==",
lat: 60.160941,
lon: 24.95634
},
{
id: "U3RvcDpIU0w6MTAzMDEwMA==",
lat: 60.166025,
lon: 24.95259
},
{
id: "U3RvcDpIU0w6MTAxMDExNQ==",
lat: 60.16936,
lon: 24.95698
},
{
id: "U3RvcDpIU0w6MTAxMDEwMw==",
lat: 60.17127,
lon: 24.95657
},
{
id: "U3RvcDpIU0w6MTAxMDEwNQ==",
lat: 60.17258,
lon: 24.956554
},
{
id: "U3RvcDpIU0w6MTAxMDEyOA==",
lat: 60.17397,
lon: 24.9562
},
{
id: "U3RvcDpIU0w6MTAxMDEwOQ==",
lat: 60.17428,
lon: 24.96071
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTExMTEzMQ==",
lat: 60.180568,
lon: 24.9498
},
{
id: "U3RvcDpIU0w6MTExMzEyMw==",
lat: 60.1837,
lon: 24.95316
},
{
id: "U3RvcDpIU0w6MTIwNDEwNQ==",
lat: 60.15469,
lon: 24.93129
},
{
id: "U3RvcDpIU0w6MTIwNDEwOQ==",
lat: 60.15611,
lon: 24.93037
},
{
id: "U3RvcDpIU0w6MTIwNDExMQ==",
lat: 60.15744,
lon: 24.932268
},
{
id: "U3RvcDpIU0w6MTA1MDExNQ==",
lat: 60.157802,
lon: 24.935992
},
{
id: "U3RvcDpIU0w6MTExMjEyMg==",
lat: 60.181332,
lon: 24.950069
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTAxMDExMA==",
lat: 60.17433,
lon: 24.96023
},
{
id: "U3RvcDpIU0w6MTAxMDEwOA==",
lat: 60.174297,
lon: 24.956514
},
{
id: "U3RvcDpIU0w6MTAxMDEwNg==",
lat: 60.17299,
lon: 24.95638
},
{
id: "U3RvcDpIU0w6MTAxMDEwNA==",
lat: 60.171229,
lon: 24.95655
},
{
id: "U3RvcDpIU0w6MTAxMDEwMg==",
lat: 60.16946,
lon: 24.95667
},
{
id: "U3RvcDpIU0w6MTAxMDE4MA==",
lat: 60.168,
lon: 24.95403
},
{
id: "U3RvcDpIU0w6MTAzMDExNA==",
lat: 60.165501,
lon: 24.951317
},
{
id: "U3RvcDpIU0w6MTA5MDEwMQ==",
lat: 60.160642,
lon: 24.955804
},
{
id: "U3RvcDpIU0w6MTA3MDExNQ==",
lat: 60.159542,
lon: 24.95471
},
{
id: "U3RvcDpIU0w6MTA3MDEwMg==",
lat: 60.1585,
lon: 24.94946
},
{
id: "U3RvcDpIU0w6MTA3MDEyMQ==",
lat: 60.15823,
lon: 24.94513
},
{
id: "U3RvcDpIU0w6MTA2MDEwMw==",
lat: 60.15788,
lon: 24.94127
},
{
id: "U3RvcDpIU0w6MTIwNDEwNg==",
lat: 60.15405,
lon: 24.93159
}
]
},
{
gtfsId: "HSL:1016",
shortName: "16",
longName: "Rautatientori-Korkeasaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExMg==",
lat: 60.17076,
lon: 24.94268
},
{
id: "U3RvcDpIU0w6MTAyMDE2OQ==",
lat: 60.173545,
lon: 24.94981
},
{
id: "U3RvcDpIU0w6MTAxMDEyNA==",
lat: 60.17401,
lon: 24.95236
},
{
id: "U3RvcDpIU0w6MTAxMDEwNw==",
lat: 60.17418,
lon: 24.95688
},
{
id: "U3RvcDpIU0w6MTAxMDEwOQ==",
lat: 60.17428,
lon: 24.96071
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDEwMQ==",
lat: 60.18556,
lon: 24.99588
},
{
id: "U3RvcDpIU0w6MTQyMDEwMw==",
lat: 60.18505,
lon: 25.0021
},
{
id: "U3RvcDpIU0w6MTQyMDEwNQ==",
lat: 60.18404,
lon: 25.00604
},
{
id: "U3RvcDpIU0w6MTQyMDEwNw==",
lat: 60.1835,
lon: 25.01273
},
{
id: "U3RvcDpIU0w6MTQyMDEwOQ==",
lat: 60.1866,
lon: 25.01566
},
{
id: "U3RvcDpIU0w6MTQyMDEzMg==",
lat: 60.18848,
lon: 25.01476
},
{
id: "U3RvcDpIU0w6MTQyMDEyMw==",
lat: 60.187739,
lon: 25.007994
},
{
id: "U3RvcDpIU0w6MTQyMDExMw==",
lat: 60.18512,
lon: 25.00073
},
{
id: "U3RvcDpIU0w6MTQyMDEyMQ==",
lat: 60.18217,
lon: 24.99317
},
{
id: "U3RvcDpIU0w6MTQyMDEyNQ==",
lat: 60.18036,
lon: 24.99005
},
{
id: "U3RvcDpIU0w6MTQyMDEyMA==",
lat: 60.18011,
lon: 24.98351
},
{
id: "U3RvcDpIU0w6MTQyMDEyNg==",
lat: 60.18032,
lon: 24.99033
},
{
id: "U3RvcDpIU0w6MTQyMDEyMg==",
lat: 60.18212,
lon: 24.99321
},
{
id: "U3RvcDpIU0w6MTQyMDExNA==",
lat: 60.18526,
lon: 25.00113
},
{
id: "U3RvcDpIU0w6MTQyMDEyNA==",
lat: 60.187737,
lon: 25.008072
},
{
id: "U3RvcDpIU0w6MTQyMDExMg==",
lat: 60.1883,
lon: 25.01494
},
{
id: "U3RvcDpIU0w6MTQyMDExMA==",
lat: 60.18561,
lon: 25.01493
},
{
id: "U3RvcDpIU0w6MTQyMDEwOA==",
lat: 60.18362,
lon: 25.01168
},
{
id: "U3RvcDpIU0w6MTQyMDEwNg==",
lat: 60.18426,
lon: 25.00509
},
{
id: "U3RvcDpIU0w6MTQyMDEwNA==",
lat: 60.18584,
lon: 25.00085
},
{
id: "U3RvcDpIU0w6MTQyMDEwMg==",
lat: 60.18566,
lon: 24.99588
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTAxMDExMA==",
lat: 60.17433,
lon: 24.96023
},
{
id: "U3RvcDpIU0w6MTAxMDEwOA==",
lat: 60.174297,
lon: 24.956514
},
{
id: "U3RvcDpIU0w6MTAxMDEyNQ==",
lat: 60.17407,
lon: 24.95208
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:2104",
shortName: "104",
longName: "Lauttasaari(M)-Westend-Haukilahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIzMjIyNA==",
lat: 60.16542,
lon: 24.77287
},
{
id: "U3RvcDpIU0w6MjIzMjIzNw==",
lat: 60.16242,
lon: 24.77648
},
{
id: "U3RvcDpIU0w6MjIzMjIyMA==",
lat: 60.1618,
lon: 24.78046
},
{
id: "U3RvcDpIU0w6MjIzMjIxOA==",
lat: 60.15913,
lon: 24.78368
},
{
id: "U3RvcDpIU0w6MjIzMjIxNg==",
lat: 60.15939,
lon: 24.78739
},
{
id: "U3RvcDpIU0w6MjIzMTIzMg==",
lat: 60.16009,
lon: 24.78992
},
{
id: "U3RvcDpIU0w6MjIzMTIzMA==",
lat: 60.16241,
lon: 24.79113
},
{
id: "U3RvcDpIU0w6MjIzMTIyMA==",
lat: 60.16576,
lon: 24.78978
},
{
id: "U3RvcDpIU0w6MjIzMTIxOA==",
lat: 60.1682,
lon: 24.79658
},
{
id: "U3RvcDpIU0w6MjIzMTIxMg==",
lat: 60.16827,
lon: 24.80474
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTMxMDI5OQ==",
lat: 60.16235,
lon: 24.86092
},
{
id: "U3RvcDpIU0w6MTMxMDIyNQ==",
lat: 60.1614,
lon: 24.87051
},
{
id: "U3RvcDpIU0w6MTMxMDEwNg==",
lat: 60.160297,
lon: 24.881277
},
{
id: "U3RvcDpIU0w6MTMxMDEwNQ==",
lat: 60.16055,
lon: 24.87946
},
{
id: "U3RvcDpIU0w6MTMxMDEyNA==",
lat: 60.16161,
lon: 24.8697
},
{
id: "U3RvcDpIU0w6MTMxMDE5OA==",
lat: 60.16256,
lon: 24.86046
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIzMTIwOA==",
lat: 60.16848,
lon: 24.80438
},
{
id: "U3RvcDpIU0w6MjIzMTIxNw==",
lat: 60.16832,
lon: 24.79658
},
{
id: "U3RvcDpIU0w6MjIzMTIxOQ==",
lat: 60.16499,
lon: 24.78925
},
{
id: "U3RvcDpIU0w6MjIzMTIzNw==",
lat: 60.16331,
lon: 24.79048
},
{
id: "U3RvcDpIU0w6MjIzMTIzMQ==",
lat: 60.16042,
lon: 24.78971
},
{
id: "U3RvcDpIU0w6MjIzMjIxNQ==",
lat: 60.1594,
lon: 24.78585
},
{
id: "U3RvcDpIU0w6MjIzMjIxNw==",
lat: 60.15969,
lon: 24.78236
},
{
id: "U3RvcDpIU0w6MjIzMjIxOQ==",
lat: 60.16206,
lon: 24.78054
},
{
id: "U3RvcDpIU0w6MjIzMjIzNg==",
lat: 60.16262,
lon: 24.77681
},
{
id: "U3RvcDpIU0w6MjIzMjIyMw==",
lat: 60.16652,
lon: 24.77253
}
]
},
{
gtfsId: "HSL:2225",
shortName: "225",
longName: "Leppävaara-Karakallio-Viherlaakso-Lippajärvi-Högnäs",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYzMzIzMQ==",
lat: 60.248381,
lon: 24.684905
},
{
id: "U3RvcDpIU0w6MjYzMzIwNQ==",
lat: 60.24544,
lon: 24.68634
},
{
id: "U3RvcDpIU0w6MjYzMzI1OA==",
lat: 60.24266,
lon: 24.6883
},
{
id: "U3RvcDpIU0w6MjYzMzIwMQ==",
lat: 60.23991,
lon: 24.69065
},
{
id: "U3RvcDpIU0w6MjYzMjI0NQ==",
lat: 60.24055,
lon: 24.70263
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzOA==",
lat: 60.23408,
lon: 24.71654
},
{
id: "U3RvcDpIU0w6MjE1MjIzNg==",
lat: 60.23194,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjE1MjIzNA==",
lat: 60.2298,
lon: 24.71542
},
{
id: "U3RvcDpIU0w6MjE1MjIzMg==",
lat: 60.228,
lon: 24.70977
},
{
id: "U3RvcDpIU0w6MjE1MjIzMA==",
lat: 60.22545,
lon: 24.7065
},
{
id: "U3RvcDpIU0w6MzE3MDI0MQ==",
lat: 60.2239,
lon: 24.70847
},
{
id: "U3RvcDpIU0w6MjE1MTIwNg==",
lat: 60.22434,
lon: 24.72396
},
{
id: "U3RvcDpIU0w6MjE1MTIyMA==",
lat: 60.2264,
lon: 24.73029
},
{
id: "U3RvcDpIU0w6MjE1MTIxNg==",
lat: 60.22903,
lon: 24.73295
},
{
id: "U3RvcDpIU0w6MjE1MTIxNA==",
lat: 60.23065,
lon: 24.73805
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIwOA==",
lat: 60.22675,
lon: 24.74088
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMzIyNQ==",
lat: 60.2266,
lon: 24.75783
},
{
id: "U3RvcDpIU0w6MjEzMzIxNg==",
lat: 60.228636,
lon: 24.764329
},
{
id: "U3RvcDpIU0w6MjEzMzIxNA==",
lat: 60.22959,
lon: 24.76923
},
{
id: "U3RvcDpIU0w6MjEzMzIxMg==",
lat: 60.22916,
lon: 24.77474
},
{
id: "U3RvcDpIU0w6MjEzMzIxOQ==",
lat: 60.22944,
lon: 24.77787
},
{
id: "U3RvcDpIU0w6MjEzMzIxMA==",
lat: 60.22674,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIwMA==",
lat: 60.22015,
lon: 24.80185
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIyMg==",
lat: 60.219247,
lon: 24.812767
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwOQ==",
lat: 60.22671,
lon: 24.77975
},
{
id: "U3RvcDpIU0w6MjEzMzI2MA==",
lat: 60.22871,
lon: 24.77909
},
{
id: "U3RvcDpIU0w6MjEzMzIzNA==",
lat: 60.22965,
lon: 24.77683
},
{
id: "U3RvcDpIU0w6MjEzMzIxMQ==",
lat: 60.22934,
lon: 24.77365
},
{
id: "U3RvcDpIU0w6MjEzMzIxMw==",
lat: 60.22968,
lon: 24.76792
},
{
id: "U3RvcDpIU0w6MjEzMzIxNw==",
lat: 60.228,
lon: 24.76138
},
{
id: "U3RvcDpIU0w6MjEzMzIyNA==",
lat: 60.22695,
lon: 24.75707
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwNw==",
lat: 60.22686,
lon: 24.74108
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMw==",
lat: 60.23084,
lon: 24.7372
},
{
id: "U3RvcDpIU0w6MjE1MTIxNQ==",
lat: 60.22987,
lon: 24.73329
},
{
id: "U3RvcDpIU0w6MjE1MTIyNw==",
lat: 60.22849,
lon: 24.7313
},
{
id: "U3RvcDpIU0w6MjE1MTIyMQ==",
lat: 60.2261,
lon: 24.73074
},
{
id: "U3RvcDpIU0w6MjE1MTIwNQ==",
lat: 60.22459,
lon: 24.72212
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mw==",
lat: 60.22459,
lon: 24.70664
},
{
id: "U3RvcDpIU0w6MjE1MjIyOQ==",
lat: 60.22726,
lon: 24.708
},
{
id: "U3RvcDpIU0w6MjE1MjIzMQ==",
lat: 60.22812,
lon: 24.71094
},
{
id: "U3RvcDpIU0w6MjE1MjIzMw==",
lat: 60.23013,
lon: 24.71583
},
{
id: "U3RvcDpIU0w6MjE1MjIzNQ==",
lat: 60.23214,
lon: 24.71632
},
{
id: "U3RvcDpIU0w6MjE1MjI0NQ==",
lat: 60.23402,
lon: 24.71677
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI1OA==",
lat: 60.23912,
lon: 24.70695
},
{
id: "U3RvcDpIU0w6MjYzMjIwMg==",
lat: 60.24102,
lon: 24.70065
},
{
id: "U3RvcDpIU0w6MjYzMjI2Mg==",
lat: 60.24011,
lon: 24.6906
},
{
id: "U3RvcDpIU0w6MjYzMzI1OQ==",
lat: 60.24277,
lon: 24.6883
},
{
id: "U3RvcDpIU0w6MjYzMzIwNA==",
lat: 60.24502,
lon: 24.68673
}
]
},
{
gtfsId: "HSL:1015",
shortName: "15",
longName: "Ruoholahti-Salmisaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTIwMTEwNw==",
lat: 60.162596,
lon: 24.915995
},
{
id: "U3RvcDpIU0w6MTIwMTEzNQ==",
lat: 60.16338,
lon: 24.91418
},
{
id: "U3RvcDpIU0w6MTIwMTEzMQ==",
lat: 60.16338,
lon: 24.9044
},
{
id: "U3RvcDpIU0w6MTIwMTEyMg==",
lat: 60.165345,
lon: 24.90239
},
{
id: "U3RvcDpIU0w6MTIwMTExMA==",
lat: 60.165035,
lon: 24.90129
},
{
id: "U3RvcDpIU0w6MTIwMTEwOQ==",
lat: 60.16422,
lon: 24.90171
},
{
id: "U3RvcDpIU0w6MTIwMTEzMg==",
lat: 60.16338,
lon: 24.90505
},
{
id: "U3RvcDpIU0w6MTIwMTExMw==",
lat: 60.163335,
lon: 24.915131
}
]
},
{
gtfsId: "HSL:1014",
shortName: "14",
longName: "Hernesaari-Kamppi-Pajamäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ2MTEwOQ==",
lat: 60.21904,
lon: 24.85532
},
{
id: "U3RvcDpIU0w6MTQ2MTEwOA==",
lat: 60.219067,
lon: 24.859797
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTEzOQ==",
lat: 60.21066,
lon: 24.8805
},
{
id: "U3RvcDpIU0w6MTMwNDEzNw==",
lat: 60.206219,
lon: 24.879857
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyNA==",
lat: 60.19618,
lon: 24.88529
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
},
{
id: "U3RvcDpIU0w6MTE1MDEwOA==",
lat: 60.188734,
lon: 24.912259
},
{
id: "U3RvcDpIU0w6MTE0MDEwNQ==",
lat: 60.18479,
lon: 24.91689
},
{
id: "U3RvcDpIU0w6MTE0MDEzMA==",
lat: 60.18142,
lon: 24.92043
},
{
id: "U3RvcDpIU0w6MTE0MDEwMw==",
lat: 60.17966,
lon: 24.92227
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDE0OA==",
lat: 60.169156,
lon: 24.930101
},
{
id: "U3RvcDpIU0w6MTA0MDEyNg==",
lat: 60.165618,
lon: 24.931375
},
{
id: "U3RvcDpIU0w6MTA0MDEyNA==",
lat: 60.163645,
lon: 24.934098
},
{
id: "U3RvcDpIU0w6MTA1MDEwNw==",
lat: 60.162453,
lon: 24.935799
},
{
id: "U3RvcDpIU0w6MTA1MDExMA==",
lat: 60.160876,
lon: 24.938023
},
{
id: "U3RvcDpIU0w6MTA1MDEwOQ==",
lat: 60.16061,
lon: 24.94144
},
{
id: "U3RvcDpIU0w6MTA1MDExMg==",
lat: 60.157973,
lon: 24.939742
},
{
id: "U3RvcDpIU0w6MTA1MDExMw==",
lat: 60.15783,
lon: 24.93573
},
{
id: "U3RvcDpIU0w6MTIwNDExMg==",
lat: 60.15755,
lon: 24.93267
},
{
id: "U3RvcDpIU0w6MTIwNDExMA==",
lat: 60.155956,
lon: 24.93036
},
{
id: "U3RvcDpIU0w6MTIwNDEwNg==",
lat: 60.15405,
lon: 24.93159
},
{
id: "U3RvcDpIU0w6MTIwNDExNA==",
lat: 60.151931,
lon: 24.929466
},
{
id: "U3RvcDpIU0w6MTIwNDExNg==",
lat: 60.149082,
lon: 24.926715
},
{
id: "U3RvcDpIU0w6MTIwNDEwOA==",
lat: 60.14868,
lon: 24.92424
},
{
id: "U3RvcDpIU0w6MTA2MDEwMw==",
lat: 60.15788,
lon: 24.94127
},
{
id: "U3RvcDpIU0w6MTIwNDEwMQ==",
lat: 60.148283,
lon: 24.923295
},
{
id: "U3RvcDpIU0w6MTIwNDExNQ==",
lat: 60.148991,
lon: 24.926635
},
{
id: "U3RvcDpIU0w6MTIwNDExMw==",
lat: 60.15253,
lon: 24.93034
},
{
id: "U3RvcDpIU0w6MTIwNDExOA==",
lat: 60.15427,
lon: 24.93177
},
{
id: "U3RvcDpIU0w6MTIwNDEwOQ==",
lat: 60.15611,
lon: 24.93037
},
{
id: "U3RvcDpIU0w6MTIwNDExMQ==",
lat: 60.15744,
lon: 24.932268
},
{
id: "U3RvcDpIU0w6MTA1MDExNQ==",
lat: 60.157802,
lon: 24.935992
},
{
id: "U3RvcDpIU0w6MTA2MDEwNA==",
lat: 60.158277,
lon: 24.94121
},
{
id: "U3RvcDpIU0w6MTA1MDEwOA==",
lat: 60.161274,
lon: 24.941349
},
{
id: "U3RvcDpIU0w6MTA1MDEwNg==",
lat: 60.16288,
lon: 24.93909
},
{
id: "U3RvcDpIU0w6MTA0MDEyMw==",
lat: 60.16494,
lon: 24.93622
},
{
id: "U3RvcDpIU0w6MTA0MDEyNQ==",
lat: 60.167257,
lon: 24.933017
},
{
id: "U3RvcDpIU0w6MTA0MDE0NA==",
lat: 60.169432,
lon: 24.930045
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEyNw==",
lat: 60.180264,
lon: 24.921903
},
{
id: "U3RvcDpIU0w6MTE0MDEyOQ==",
lat: 60.18153,
lon: 24.92058
},
{
id: "U3RvcDpIU0w6MTE0MDEzMQ==",
lat: 60.18341,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE0MDEzMw==",
lat: 60.18581,
lon: 24.91596
},
{
id: "U3RvcDpIU0w6MTE1MDEwNw==",
lat: 60.189912,
lon: 24.909831
},
{
id: "U3RvcDpIU0w6MTE1MDEwOQ==",
lat: 60.19067,
lon: 24.90781
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MTMwNDEyNw==",
lat: 60.20289,
lon: 24.88189
},
{
id: "U3RvcDpIU0w6MTMwNDEzNg==",
lat: 60.20573,
lon: 24.88058
},
{
id: "U3RvcDpIU0w6MTI5MTEzOA==",
lat: 60.21059,
lon: 24.8809
},
{
id: "U3RvcDpIU0w6MTQ2NTE3Nw==",
lat: 60.213022,
lon: 24.879553
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2MTEwNw==",
lat: 60.219115,
lon: 24.859239
}
]
},
{
gtfsId: "HSL:2224",
shortName: "224",
longName: "Leppävaara-Kauniainen-Espoon keskus-Tuomarila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMTIwNg==",
lat: 60.20654,
lon: 24.68171
},
{
id: "U3RvcDpIU0w6MjYxMTIwNA==",
lat: 60.20808,
lon: 24.6805
},
{
id: "U3RvcDpIU0w6MjYxMTI2Nw==",
lat: 60.20918,
lon: 24.67653
},
{
id: "U3RvcDpIU0w6MjYxMTI2Ng==",
lat: 60.20868,
lon: 24.67197
},
{
id: "U3RvcDpIU0w6MjYxMTI2Mg==",
lat: 60.2082,
lon: 24.66879
},
{
id: "U3RvcDpIU0w6MjYxMTI2MA==",
lat: 60.20741,
lon: 24.66579
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMzAwOA==",
lat: 60.202736,
lon: 24.661962
},
{
id: "U3RvcDpIU0w6MjYxMzAwMQ==",
lat: 60.20123,
lon: 24.6671
},
{
id: "U3RvcDpIU0w6MjYxMzIxNg==",
lat: 60.2028,
lon: 24.67021
},
{
id: "U3RvcDpIU0w6MjYxMzIxOA==",
lat: 60.20462,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjYxMjIxOQ==",
lat: 60.20332,
lon: 24.68024
},
{
id: "U3RvcDpIU0w6MjYxMjIyNg==",
lat: 60.199976,
lon: 24.683783
},
{
id: "U3RvcDpIU0w6MjYxMjIyMQ==",
lat: 60.20047,
lon: 24.68762
},
{
id: "U3RvcDpIU0w6MjYxMjIyNA==",
lat: 60.201328,
lon: 24.69811
},
{
id: "U3RvcDpIU0w6MjYxNDIyNg==",
lat: 60.19976,
lon: 24.70503
},
{
id: "U3RvcDpIU0w6MjYxNDI1Ng==",
lat: 60.19862,
lon: 24.70922
},
{
id: "U3RvcDpIU0w6MjYxNDI1OA==",
lat: 60.198,
lon: 24.71445
},
{
id: "U3RvcDpIU0w6MjYxNDI2MA==",
lat: 60.19729,
lon: 24.71871
},
{
id: "U3RvcDpIU0w6MjYxNDI1Nw==",
lat: 60.19802,
lon: 24.71458
},
{
id: "U3RvcDpIU0w6MjYxNDI1OQ==",
lat: 60.19899,
lon: 24.70857
},
{
id: "U3RvcDpIU0w6MjE2MTIwMg==",
lat: 60.20146,
lon: 24.711945
},
{
id: "U3RvcDpIU0w6MzE3MDIzNw==",
lat: 60.20508,
lon: 24.71828
},
{
id: "U3RvcDpIU0w6MzE3MDIzNQ==",
lat: 60.20684,
lon: 24.72199
},
{
id: "U3RvcDpIU0w6MzE3MDIzMg==",
lat: 60.20912,
lon: 24.72803
},
{
id: "U3RvcDpIU0w6MzE3MDIzOQ==",
lat: 60.21096,
lon: 24.72951
},
{
id: "U3RvcDpIU0w6MzE3MDIwNg==",
lat: 60.21262,
lon: 24.72996
},
{
id: "U3RvcDpIU0w6MzE3MDIwNA==",
lat: 60.21289,
lon: 24.73811
},
{
id: "U3RvcDpIU0w6MzE3MDIwMg==",
lat: 60.21788,
lon: 24.74241
},
{
id: "U3RvcDpIU0w6MjE1MTIyNQ==",
lat: 60.22231,
lon: 24.74345
},
{
id: "U3RvcDpIU0w6MjE1MTIxOA==",
lat: 60.2243,
lon: 24.74286
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMzIyNQ==",
lat: 60.2266,
lon: 24.75783
},
{
id: "U3RvcDpIU0w6MjEzMzIxNg==",
lat: 60.228636,
lon: 24.764329
},
{
id: "U3RvcDpIU0w6MjEzMzIxNA==",
lat: 60.22959,
lon: 24.76923
},
{
id: "U3RvcDpIU0w6MjEzMzIxMg==",
lat: 60.22916,
lon: 24.77474
},
{
id: "U3RvcDpIU0w6MjEzMzIxOQ==",
lat: 60.22944,
lon: 24.77787
},
{
id: "U3RvcDpIU0w6MjEzMzIxMA==",
lat: 60.22674,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIwMA==",
lat: 60.22015,
lon: 24.80185
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIyNA==",
lat: 60.2192,
lon: 24.81161
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwOQ==",
lat: 60.22671,
lon: 24.77975
},
{
id: "U3RvcDpIU0w6MjEzMzI2MA==",
lat: 60.22871,
lon: 24.77909
},
{
id: "U3RvcDpIU0w6MjEzMzIzNA==",
lat: 60.22965,
lon: 24.77683
},
{
id: "U3RvcDpIU0w6MjEzMzIxMQ==",
lat: 60.22934,
lon: 24.77365
},
{
id: "U3RvcDpIU0w6MjEzMzIxMw==",
lat: 60.22968,
lon: 24.76792
},
{
id: "U3RvcDpIU0w6MjEzMzIxNw==",
lat: 60.228,
lon: 24.76138
},
{
id: "U3RvcDpIU0w6MjEzMzIyNA==",
lat: 60.22695,
lon: 24.75707
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIxOQ==",
lat: 60.22457,
lon: 24.74244
},
{
id: "U3RvcDpIU0w6MjE1MTIyNA==",
lat: 60.22173,
lon: 24.74247
},
{
id: "U3RvcDpIU0w6MzE3MDIwMQ==",
lat: 60.21594,
lon: 24.74047
},
{
id: "U3RvcDpIU0w6MzE3MDIwMw==",
lat: 60.21292,
lon: 24.73743
},
{
id: "U3RvcDpIU0w6MzE3MDIwNQ==",
lat: 60.21266,
lon: 24.72851
},
{
id: "U3RvcDpIU0w6MzE3MDI0MA==",
lat: 60.21083,
lon: 24.72933
},
{
id: "U3RvcDpIU0w6MzE3MDIzMw==",
lat: 60.20939,
lon: 24.72789
},
{
id: "U3RvcDpIU0w6MzE3MDIzNA==",
lat: 60.20684,
lon: 24.72166
},
{
id: "U3RvcDpIU0w6MzE3MDIzNg==",
lat: 60.20398,
lon: 24.71752
},
{
id: "U3RvcDpIU0w6MjE2MTIwMQ==",
lat: 60.20136,
lon: 24.71068
},
{
id: "U3RvcDpIU0w6MjYxNDIyNw==",
lat: 60.19996,
lon: 24.70541
},
{
id: "U3RvcDpIU0w6MjYxMjIyNQ==",
lat: 60.201429,
lon: 24.692241
},
{
id: "U3RvcDpIU0w6MjYxMjIyMg==",
lat: 60.20016,
lon: 24.68547
},
{
id: "U3RvcDpIU0w6MjYxMjIyMA==",
lat: 60.20329,
lon: 24.68038
},
{
id: "U3RvcDpIU0w6MjYxMzIxNw==",
lat: 60.20508,
lon: 24.67367
},
{
id: "U3RvcDpIU0w6MjYxMzIxNQ==",
lat: 60.20246,
lon: 24.66925
},
{
id: "U3RvcDpIU0w6MjYxMzAwMA==",
lat: 60.201,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxNTIzMA==",
lat: 60.20332,
lon: 24.65198
},
{
id: "U3RvcDpIU0w6MjYxMTI0OQ==",
lat: 60.2057,
lon: 24.65781
},
{
id: "U3RvcDpIU0w6MjYxMTI2MQ==",
lat: 60.20751,
lon: 24.66737
},
{
id: "U3RvcDpIU0w6MjYxMTI2Mw==",
lat: 60.20811,
lon: 24.66912
},
{
id: "U3RvcDpIU0w6MjYxMTIwNQ==",
lat: 60.20863,
lon: 24.67346
},
{
id: "U3RvcDpIU0w6MjYxMTI2OA==",
lat: 60.20922,
lon: 24.6769
},
{
id: "U3RvcDpIU0w6MjYxMTIwNw==",
lat: 60.20799,
lon: 24.68049
}
]
},
{
gtfsId: "HSL:2345",
shortName: "345",
longName: "Elielinaukio-Rinnekoti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEzMw==",
lat: 60.171801,
lon: 24.939727
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEyMA==",
lat: 60.20988,
lon: 24.88902
},
{
id: "U3RvcDpIU0w6MTI5MTE4MA==",
lat: 60.21517,
lon: 24.88415
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mg==",
lat: 60.21988,
lon: 24.88124
},
{
id: "U3RvcDpIU0w6MTI5NDEyMQ==",
lat: 60.22517,
lon: 24.87707
},
{
id: "U3RvcDpIU0w6MTQ2NDEyMw==",
lat: 60.22792,
lon: 24.87272
},
{
id: "U3RvcDpIU0w6MTQ2MzExNw==",
lat: 60.23393,
lon: 24.862
},
{
id: "U3RvcDpIU0w6MTMyMDExOQ==",
lat: 60.2387,
lon: 24.85418
},
{
id: "U3RvcDpIU0w6MTMyMDI5Nw==",
lat: 60.24435,
lon: 24.84502
},
{
id: "U3RvcDpIU0w6MTMyMDI5NQ==",
lat: 60.24945,
lon: 24.83561
},
{
id: "U3RvcDpIU0w6NDEzMDIwMQ==",
lat: 60.25526,
lon: 24.82217
},
{
id: "U3RvcDpIU0w6NDEzMDIwMw==",
lat: 60.25722,
lon: 24.81692
},
{
id: "U3RvcDpIU0w6NDEzMDIwNQ==",
lat: 60.26044,
lon: 24.81385
},
{
id: "U3RvcDpIU0w6NDE0MDIwMQ==",
lat: 60.26336,
lon: 24.81133
},
{
id: "U3RvcDpIU0w6NDE0MDIwMw==",
lat: 60.26779,
lon: 24.807
},
{
id: "U3RvcDpIU0w6NDE0MDIwNQ==",
lat: 60.27025,
lon: 24.80581
},
{
id: "U3RvcDpIU0w6NDIwMDIwMQ==",
lat: 60.27705,
lon: 24.80344
},
{
id: "U3RvcDpIU0w6NDIwMDIwMw==",
lat: 60.28351,
lon: 24.79137
},
{
id: "U3RvcDpIU0w6NDIwMDIwNQ==",
lat: 60.28806,
lon: 24.78593
},
{
id: "U3RvcDpIU0w6NDIwMDIwNw==",
lat: 60.29149,
lon: 24.78204
},
{
id: "U3RvcDpIU0w6MjcyMTIwMQ==",
lat: 60.3012,
lon: 24.76346
},
{
id: "U3RvcDpIU0w6MjcyMTIwMw==",
lat: 60.30298,
lon: 24.75568
},
{
id: "U3RvcDpIU0w6MjcyMTIwNQ==",
lat: 60.30469,
lon: 24.74827
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMjIxMw==",
lat: 60.31699,
lon: 24.71427
},
{
id: "U3RvcDpIU0w6MjcyMjIxNQ==",
lat: 60.31825,
lon: 24.70452
},
{
id: "U3RvcDpIU0w6MjcyMjIxNw==",
lat: 60.31969,
lon: 24.69525
},
{
id: "U3RvcDpIU0w6MjcyMjIxOQ==",
lat: 60.32298,
lon: 24.6786
},
{
id: "U3RvcDpIU0w6MjcyNTIyMQ==",
lat: 60.32553,
lon: 24.66102
},
{
id: "U3RvcDpIU0w6MjcyNDI1MA==",
lat: 60.32773,
lon: 24.64748
},
{
id: "U3RvcDpIU0w6MjcyNDIwOQ==",
lat: 60.3389,
lon: 24.654
},
{
id: "U3RvcDpIU0w6MjcyNDI3MA==",
lat: 60.34483,
lon: 24.65421
},
{
id: "U3RvcDpIU0w6MjcyNDIwMQ==",
lat: 60.34655,
lon: 24.65505
},
{
id: "U3RvcDpIU0w6MjcyNDI3OQ==",
lat: 60.34895,
lon: 24.65709
},
{
id: "U3RvcDpIU0w6MjcyNDI4MA==",
lat: 60.35094,
lon: 24.65659
},
{
id: "U3RvcDpIU0w6MjcyNDI4MQ==",
lat: 60.35401,
lon: 24.65549
},
{
id: "U3RvcDpIU0w6MjcyNDI4Mw==",
lat: 60.35596,
lon: 24.65378
},
{
id: "U3RvcDpIU0w6MjcyNDI4NQ==",
lat: 60.35751,
lon: 24.65231
},
{
id: "U3RvcDpIU0w6MjcyNDI1NQ==",
lat: 60.35713,
lon: 24.65236
},
{
id: "U3RvcDpIU0w6MjcyNDI1NA==",
lat: 60.35373,
lon: 24.65554
},
{
id: "U3RvcDpIU0w6MjcyNDI1Mw==",
lat: 60.351,
lon: 24.65632
},
{
id: "U3RvcDpIU0w6MjcyNDI1Mg==",
lat: 60.34884,
lon: 24.65696
},
{
id: "U3RvcDpIU0w6MjcyNDIwMg==",
lat: 60.34658,
lon: 24.65489
},
{
id: "U3RvcDpIU0w6MjcyNDI1MQ==",
lat: 60.34397,
lon: 24.654
},
{
id: "U3RvcDpIU0w6MjcyNDIwOA==",
lat: 60.33845,
lon: 24.65381
},
{
id: "U3RvcDpIU0w6MjcyNDI1Nw==",
lat: 60.32917,
lon: 24.64737
},
{
id: "U3RvcDpIU0w6MjcyNTIyNA==",
lat: 60.32614,
lon: 24.64792
},
{
id: "U3RvcDpIU0w6MjcyNTIyMg==",
lat: 60.32546,
lon: 24.66288
},
{
id: "U3RvcDpIU0w6MjcyMjIyMA==",
lat: 60.3231,
lon: 24.67743
},
{
id: "U3RvcDpIU0w6MjcyMjIxOA==",
lat: 60.31928,
lon: 24.69631
},
{
id: "U3RvcDpIU0w6MjcyMjIxNg==",
lat: 60.31804,
lon: 24.70547
},
{
id: "U3RvcDpIU0w6MjcyMjIwMQ==",
lat: 60.317037,
lon: 24.71352
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIwNg==",
lat: 60.30432,
lon: 24.74926
},
{
id: "U3RvcDpIU0w6MjcyMTIwNA==",
lat: 60.30331,
lon: 24.75364
},
{
id: "U3RvcDpIU0w6MjcyMTIxMQ==",
lat: 60.30155,
lon: 24.76128
},
{
id: "U3RvcDpIU0w6MjcyMTIwMg==",
lat: 60.300467,
lon: 24.765783
},
{
id: "U3RvcDpIU0w6NDIwMDIwOA==",
lat: 60.29054,
lon: 24.78286
},
{
id: "U3RvcDpIU0w6NDIwMDIwNg==",
lat: 60.28661,
lon: 24.78718
},
{
id: "U3RvcDpIU0w6NDIwMDIwNA==",
lat: 60.28288,
lon: 24.79207
},
{
id: "U3RvcDpIU0w6NDIwMDIwMg==",
lat: 60.27836,
lon: 24.80175
},
{
id: "U3RvcDpIU0w6NDE0MDIwNg==",
lat: 60.27008,
lon: 24.80541
},
{
id: "U3RvcDpIU0w6NDE0MDIwNA==",
lat: 60.26651,
lon: 24.80758
},
{
id: "U3RvcDpIU0w6NDE0MDIwMg==",
lat: 60.26319,
lon: 24.81097
},
{
id: "U3RvcDpIU0w6NDEzMDIwNg==",
lat: 60.25993,
lon: 24.81378
},
{
id: "U3RvcDpIU0w6NDEzMDIwNA==",
lat: 60.25613,
lon: 24.81857
},
{
id: "U3RvcDpIU0w6NDEzMDIwMg==",
lat: 60.25491,
lon: 24.822517
},
{
id: "U3RvcDpIU0w6MTMyMDI5Mg==",
lat: 60.24917,
lon: 24.83552
},
{
id: "U3RvcDpIU0w6MTMyMDI5NA==",
lat: 60.24309,
lon: 24.84648
},
{
id: "U3RvcDpIU0w6MTMyMDEyMA==",
lat: 60.239267,
lon: 24.852589
},
{
id: "U3RvcDpIU0w6MTQ2MzExOA==",
lat: 60.23293,
lon: 24.86311
},
{
id: "U3RvcDpIU0w6MTI5NDEyNA==",
lat: 60.227,
lon: 24.87358
},
{
id: "U3RvcDpIU0w6MTI5NDEyMg==",
lat: 60.22447,
lon: 24.87771
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mw==",
lat: 60.21865,
lon: 24.8815
},
{
id: "U3RvcDpIU0w6MTI5MTE4MQ==",
lat: 60.215735,
lon: 24.883378
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:1096N",
shortName: "96N",
longName: "Rautatientori-Aurinkolahti-Vuosaari(Porslahdentie)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMg==",
lat: 60.17085,
lon: 24.94333
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzMTEwNQ==",
lat: 60.19461,
lon: 25.0322
},
{
id: "U3RvcDpIU0w6MTQzMTE4MQ==",
lat: 60.1991,
lon: 25.03757
},
{
id: "U3RvcDpIU0w6MTQzMzE4Mw==",
lat: 60.20588,
lon: 25.04745
},
{
id: "U3RvcDpIU0w6MTQ1NzEwNw==",
lat: 60.209231,
lon: 25.079047
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNg==",
lat: 60.20959,
lon: 25.091516
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNA==",
lat: 60.208146,
lon: 25.09688
},
{
id: "U3RvcDpIU0w6MTQ1MjE2OQ==",
lat: 60.207813,
lon: 25.101287
},
{
id: "U3RvcDpIU0w6MTU0MTEzNQ==",
lat: 60.20482,
lon: 25.11821
},
{
id: "U3RvcDpIU0w6MTU0MTE0MQ==",
lat: 60.20228,
lon: 25.11712
},
{
id: "U3RvcDpIU0w6MTU0MTEzNw==",
lat: 60.2001,
lon: 25.11964
},
{
id: "U3RvcDpIU0w6MTU0MTE0Mw==",
lat: 60.20063,
lon: 25.12295
},
{
id: "U3RvcDpIU0w6MTU0MTEzOQ==",
lat: 60.201435,
lon: 25.127873
},
{
id: "U3RvcDpIU0w6MTU0MTE0NQ==",
lat: 60.2022,
lon: 25.1341
},
{
id: "U3RvcDpIU0w6MTU0MTE2Ng==",
lat: 60.20297,
lon: 25.14019
},
{
id: "U3RvcDpIU0w6MTU0MTE2OA==",
lat: 60.20375,
lon: 25.14482
},
{
id: "U3RvcDpIU0w6MTUzMTE2MA==",
lat: 60.204049,
lon: 25.147076
},
{
id: "U3RvcDpIU0w6MTUzMTE1OA==",
lat: 60.20239,
lon: 25.14966
},
{
id: "U3RvcDpIU0w6MTUzMTE1Ng==",
lat: 60.20211,
lon: 25.15324
},
{
id: "U3RvcDpIU0w6MTUzMTE1NA==",
lat: 60.20314,
lon: 25.15917
},
{
id: "U3RvcDpIU0w6MTU0MTE4Mg==",
lat: 60.2056,
lon: 25.15792
},
{
id: "U3RvcDpIU0w6MTU0NjEwMw==",
lat: 60.2083,
lon: 25.1565
},
{
id: "U3RvcDpIU0w6MTU0MTE3Nw==",
lat: 60.2077,
lon: 25.1517
},
{
id: "U3RvcDpIU0w6MTU0MTEyMw==",
lat: 60.21104,
lon: 25.14971
},
{
id: "U3RvcDpIU0w6MTU0MjEyNQ==",
lat: 60.21342,
lon: 25.14796
},
{
id: "U3RvcDpIU0w6MTU0MTEyNw==",
lat: 60.21637,
lon: 25.14786
},
{
id: "U3RvcDpIU0w6MTU0MjEyOQ==",
lat: 60.21902,
lon: 25.14635
},
{
id: "U3RvcDpIU0w6MTU0MTEzMQ==",
lat: 60.22069,
lon: 25.14643
},
{
id: "U3RvcDpIU0w6MTU0MTE0Nw==",
lat: 60.22224,
lon: 25.14915
},
{
id: "U3RvcDpIU0w6MTU0MTEzNA==",
lat: 60.222018,
lon: 25.148524
},
{
id: "U3RvcDpIU0w6MTU0MTEzMg==",
lat: 60.21981,
lon: 25.14579
},
{
id: "U3RvcDpIU0w6MTU0MjEzMA==",
lat: 60.21815,
lon: 25.14657
},
{
id: "U3RvcDpIU0w6MTU0MTEyOA==",
lat: 60.21576,
lon: 25.1474
},
{
id: "U3RvcDpIU0w6MTU0MTEyNg==",
lat: 60.21359,
lon: 25.1474
},
{
id: "U3RvcDpIU0w6MTU0MTEyNA==",
lat: 60.21023,
lon: 25.14905
},
{
id: "U3RvcDpIU0w6MTU0MTE3Ng==",
lat: 60.20762,
lon: 25.15195
},
{
id: "U3RvcDpIU0w6MTU0MTE5MQ==",
lat: 60.20783,
lon: 25.15776
},
{
id: "U3RvcDpIU0w6MTUzMTE1MQ==",
lat: 60.20476,
lon: 25.15814
},
{
id: "U3RvcDpIU0w6MTUzMTE1Mw==",
lat: 60.20318,
lon: 25.15899
},
{
id: "U3RvcDpIU0w6MTUzMTE1NQ==",
lat: 60.20211,
lon: 25.15305
},
{
id: "U3RvcDpIU0w6MTUzMTE1Nw==",
lat: 60.20242,
lon: 25.14968
},
{
id: "U3RvcDpIU0w6MTUzMTE1OQ==",
lat: 60.204132,
lon: 25.147136
},
{
id: "U3RvcDpIU0w6MTU0MTE2OQ==",
lat: 60.20368,
lon: 25.14414
},
{
id: "U3RvcDpIU0w6MTU0MTE2Nw==",
lat: 60.20293,
lon: 25.13906
},
{
id: "U3RvcDpIU0w6MTU0MTE0Ng==",
lat: 60.20222,
lon: 25.1339
},
{
id: "U3RvcDpIU0w6MTU0MTE0MA==",
lat: 60.20136,
lon: 25.12732
},
{
id: "U3RvcDpIU0w6MTU0MTE0NA==",
lat: 60.20061,
lon: 25.12267
},
{
id: "U3RvcDpIU0w6MTU0MTEzOA==",
lat: 60.20029,
lon: 25.11925
},
{
id: "U3RvcDpIU0w6MTU0MTE0Mg==",
lat: 60.20237,
lon: 25.11725
},
{
id: "U3RvcDpIU0w6MTU0MTEzNg==",
lat: 60.20424,
lon: 25.11772
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMQ==",
lat: 60.208349,
lon: 25.104742
},
{
id: "U3RvcDpIU0w6MTQ1MjE3MA==",
lat: 60.208067,
lon: 25.098807
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMw==",
lat: 60.208799,
lon: 25.095008
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNQ==",
lat: 60.210859,
lon: 25.090062
},
{
id: "U3RvcDpIU0w6MTQ1NzEwNg==",
lat: 60.209455,
lon: 25.078313
},
{
id: "U3RvcDpIU0w6MTQzMTE4Mg==",
lat: 60.2058,
lon: 25.04504
},
{
id: "U3RvcDpIU0w6MTQzMTE4MA==",
lat: 60.19873,
lon: 25.03652
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4560",
shortName: "560",
longName: "Rastila (M)-Vuosaari (M)-Kontula (M)-Malmi-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTU0MTE5Mw==",
lat: 60.20562,
lon: 25.12049
},
{
id: "U3RvcDpIU0w6MTU0MTE0MQ==",
lat: 60.20228,
lon: 25.11712
},
{
id: "U3RvcDpIU0w6MTU0MTEzNw==",
lat: 60.2001,
lon: 25.11964
},
{
id: "U3RvcDpIU0w6MTU0MTE0Mw==",
lat: 60.20063,
lon: 25.12295
},
{
id: "U3RvcDpIU0w6MTU0MTEzOQ==",
lat: 60.201435,
lon: 25.127873
},
{
id: "U3RvcDpIU0w6MTU0MTE0NQ==",
lat: 60.2022,
lon: 25.1341
},
{
id: "U3RvcDpIU0w6MTU0MTE2Ng==",
lat: 60.20297,
lon: 25.14019
},
{
id: "U3RvcDpIU0w6MTU0MTE2OA==",
lat: 60.20375,
lon: 25.14482
},
{
id: "U3RvcDpIU0w6MTUzMTExNQ==",
lat: 60.20765,
lon: 25.14419
},
{
id: "U3RvcDpIU0w6MTU0MTExMQ==",
lat: 60.21026,
lon: 25.13588
},
{
id: "U3RvcDpIU0w6MTU0MTIwNw==",
lat: 60.214381,
lon: 25.133902
},
{
id: "U3RvcDpIU0w6MTU0MTEwNQ==",
lat: 60.21844,
lon: 25.13328
},
{
id: "U3RvcDpIU0w6MTU0MTExOA==",
lat: 60.223197,
lon: 25.135699
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMA==",
lat: 60.23124,
lon: 25.12868
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNQ==",
lat: 60.23705,
lon: 25.11995
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOQ==",
lat: 60.23783,
lon: 25.10901
},
{
id: "U3RvcDpIU0w6MTQ3MjExMw==",
lat: 60.23732,
lon: 25.09838
},
{
id: "U3RvcDpIU0w6MTQ3MTExNw==",
lat: 60.23608,
lon: 25.08512
},
{
id: "U3RvcDpIU0w6MTQ1NDEwMA==",
lat: 60.228233,
lon: 25.071988
},
{
id: "U3RvcDpIU0w6MTQ3NDE4OQ==",
lat: 60.23086,
lon: 25.054144
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMQ==",
lat: 60.236942,
lon: 25.045093
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MTEwNQ==",
lat: 60.250516,
lon: 25.009336
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEwOA==",
lat: 60.25877,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM5MTExMg==",
lat: 60.26381,
lon: 24.98384
},
{
id: "U3RvcDpIU0w6NDUwMDIwNg==",
lat: 60.26525,
lon: 24.97251
},
{
id: "U3RvcDpIU0w6MTM1MzEyMQ==",
lat: 60.254992,
lon: 24.952652
},
{
id: "U3RvcDpIU0w6MTM1MjE0NA==",
lat: 60.25706,
lon: 24.94409
},
{
id: "U3RvcDpIU0w6MTM1NDEwMQ==",
lat: 60.255933,
lon: 24.929095
},
{
id: "U3RvcDpIU0w6MTM1NDEwMg==",
lat: 60.255044,
lon: 24.918044
},
{
id: "U3RvcDpIU0w6MTMzNTEwMQ==",
lat: 60.259171,
lon: 24.89265
},
{
id: "U3RvcDpIU0w6MTMzNDE5Mg==",
lat: 60.262201,
lon: 24.886778
},
{
id: "U3RvcDpIU0w6NDE2MDI5OQ==",
lat: 60.265,
lon: 24.88162
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE1MDIwNA==",
lat: 60.26078,
lon: 24.85642
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI2OA==",
lat: 60.258852,
lon: 24.842938
},
{
id: "U3RvcDpIU0w6NDE1MDI2OQ==",
lat: 60.258935,
lon: 24.843145
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDI2NQ==",
lat: 60.260771,
lon: 24.856608
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6NDE2MDIzMg==",
lat: 60.265006,
lon: 24.883116
},
{
id: "U3RvcDpIU0w6MTMzNDE5MQ==",
lat: 60.261947,
lon: 24.887087
},
{
id: "U3RvcDpIU0w6MTMzNTEwMA==",
lat: 60.259206,
lon: 24.893241
},
{
id: "U3RvcDpIU0w6MTM1NDEwMA==",
lat: 60.254856,
lon: 24.917898
},
{
id: "U3RvcDpIU0w6MTM1MTEzMg==",
lat: 60.255889,
lon: 24.930862
},
{
id: "U3RvcDpIU0w6MTM1MjE0Mw==",
lat: 60.25638,
lon: 24.94599
},
{
id: "U3RvcDpIU0w6MTM1MzEyMA==",
lat: 60.25465,
lon: 24.95468
},
{
id: "U3RvcDpIU0w6NDUwMDIxMw==",
lat: 60.26534,
lon: 24.97367
},
{
id: "U3RvcDpIU0w6MTM5MTExMw==",
lat: 60.26397,
lon: 24.98368
},
{
id: "U3RvcDpIU0w6MTM5MTEwOQ==",
lat: 60.2585,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MjEzNQ==",
lat: 60.249973,
lon: 25.008759
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMg==",
lat: 60.236477,
lon: 25.042171
},
{
id: "U3RvcDpIU0w6MTQ1NDEyOQ==",
lat: 60.229685,
lon: 25.055331
},
{
id: "U3RvcDpIU0w6MTQ1NDExNA==",
lat: 60.227923,
lon: 25.071773
},
{
id: "U3RvcDpIU0w6MTQ3MTExOA==",
lat: 60.23638,
lon: 25.08713
},
{
id: "U3RvcDpIU0w6MTQ3MjExNA==",
lat: 60.23702,
lon: 25.09955
},
{
id: "U3RvcDpIU0w6MTQ3MzExMw==",
lat: 60.23762,
lon: 25.110412
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNg==",
lat: 60.23692,
lon: 25.12131
},
{
id: "U3RvcDpIU0w6MTQ3MzExOQ==",
lat: 60.23115,
lon: 25.12893
},
{
id: "U3RvcDpIU0w6MTU0MTA0Nw==",
lat: 60.222273,
lon: 25.134413
},
{
id: "U3RvcDpIU0w6MTU0MTEwNA==",
lat: 60.21717,
lon: 25.13261
},
{
id: "U3RvcDpIU0w6MTU0MTIxOA==",
lat: 60.212982,
lon: 25.134375
},
{
id: "U3RvcDpIU0w6MTU0MTEyMA==",
lat: 60.20957,
lon: 25.13682
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mg==",
lat: 60.20747,
lon: 25.14414
},
{
id: "U3RvcDpIU0w6MTU0MTE2OQ==",
lat: 60.20368,
lon: 25.14414
},
{
id: "U3RvcDpIU0w6MTU0MTE2Nw==",
lat: 60.20293,
lon: 25.13906
},
{
id: "U3RvcDpIU0w6MTU0MTE0Ng==",
lat: 60.20222,
lon: 25.1339
},
{
id: "U3RvcDpIU0w6MTU0MTE0MA==",
lat: 60.20136,
lon: 25.12732
},
{
id: "U3RvcDpIU0w6MTU0MTE0NA==",
lat: 60.20061,
lon: 25.12267
},
{
id: "U3RvcDpIU0w6MTU0MTEzOA==",
lat: 60.20029,
lon: 25.11925
},
{
id: "U3RvcDpIU0w6MTU0MTE0Mg==",
lat: 60.20237,
lon: 25.11725
},
{
id: "U3RvcDpIU0w6MTU0MTE5Mg==",
lat: 60.2058,
lon: 25.11971
}
]
},
{
gtfsId: "HSL:4561",
shortName: "561",
longName: "Itäkeskus (M) - Malmi - Aviapolis - Lentoasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzEwNA==",
lat: 60.21008,
lon: 25.0766
},
{
id: "U3RvcDpIU0w6MTQ1MzE4MQ==",
lat: 60.21211,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMQ==",
lat: 60.21472,
lon: 25.08581
},
{
id: "U3RvcDpIU0w6MTQ1MzEwOQ==",
lat: 60.21775,
lon: 25.08378
},
{
id: "U3RvcDpIU0w6MTQ1NDExNg==",
lat: 60.22127,
lon: 25.08186
},
{
id: "U3RvcDpIU0w6MTQ1NDExMQ==",
lat: 60.225,
lon: 25.07936
},
{
id: "U3RvcDpIU0w6MTQ1NDExMw==",
lat: 60.22808,
lon: 25.0721
},
{
id: "U3RvcDpIU0w6MTQ3NDE4OQ==",
lat: 60.23086,
lon: 25.054144
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMQ==",
lat: 60.236942,
lon: 25.045093
},
{
id: "U3RvcDpIU0w6MTM4MjEwMQ==",
lat: 60.24123,
lon: 25.03104
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MjEzMw==",
lat: 60.250684,
lon: 25.009103
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEwNg==",
lat: 60.25733,
lon: 24.99789
},
{
id: "U3RvcDpIU0w6MTM5MTEwOA==",
lat: 60.25877,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM5MTExMA==",
lat: 60.26129,
lon: 24.98636
},
{
id: "U3RvcDpIU0w6MTM5MTExMg==",
lat: 60.26381,
lon: 24.98384
},
{
id: "U3RvcDpIU0w6MTQwMzEzNA==",
lat: 60.26459,
lon: 24.98221
},
{
id: "U3RvcDpIU0w6NDUwMDIwNQ==",
lat: 60.2661,
lon: 24.97318
},
{
id: "U3RvcDpIU0w6NDUwMDIyNg==",
lat: 60.270607,
lon: 24.96991
},
{
id: "U3RvcDpIU0w6NDUwMDIwNA==",
lat: 60.272907,
lon: 24.969897
},
{
id: "U3RvcDpIU0w6NDUwMDIwMg==",
lat: 60.27777,
lon: 24.97073
},
{
id: "U3RvcDpIU0w6NDUwMDIyMQ==",
lat: 60.27997,
lon: 24.97181
},
{
id: "U3RvcDpIU0w6NDUxMDIwOA==",
lat: 60.28271,
lon: 24.97297
},
{
id: "U3RvcDpIU0w6NDUxMDIwNg==",
lat: 60.2841,
lon: 24.96983
},
{
id: "U3RvcDpIU0w6NDUxMDIzNw==",
lat: 60.28445,
lon: 24.96511
},
{
id: "U3RvcDpIU0w6NDUxMDIwNA==",
lat: 60.28634,
lon: 24.96034
},
{
id: "U3RvcDpIU0w6NDUxMDIyMQ==",
lat: 60.28714,
lon: 24.9578
},
{
id: "U3RvcDpIU0w6NDUxMDIyNA==",
lat: 60.28971,
lon: 24.96089
},
{
id: "U3RvcDpIU0w6NDUxMDIyNg==",
lat: 60.28974,
lon: 24.96626
},
{
id: "U3RvcDpIU0w6NDUxMDIzOA==",
lat: 60.29031,
lon: 24.96765
},
{
id: "U3RvcDpIU0w6NDUyMDI3MQ==",
lat: 60.293869,
lon: 24.971106
},
{
id: "U3RvcDpIU0w6NDUyMDI3Mw==",
lat: 60.294858,
lon: 24.968049
},
{
id: "U3RvcDpIU0w6NDUyMDIxMw==",
lat: 60.29937,
lon: 24.9685
},
{
id: "U3RvcDpIU0w6NDUyMDIzOQ==",
lat: 60.301654,
lon: 24.962252
},
{
id: "U3RvcDpIU0w6NDUyMDI2Ng==",
lat: 60.302738,
lon: 24.955727
},
{
id: "U3RvcDpIU0w6NDUyMDI2OA==",
lat: 60.306115,
lon: 24.958895
},
{
id: "U3RvcDpIU0w6NDUzMDIyMg==",
lat: 60.308712,
lon: 24.961988
},
{
id: "U3RvcDpIU0w6NDUzMDIwOQ==",
lat: 60.317071,
lon: 24.966263
},
{
id: "U3RvcDpIU0w6NDUzMDIzMA==",
lat: 60.317343,
lon: 24.965217
},
{
id: "U3RvcDpIU0w6NDUzMDI1OA==",
lat: 60.313471,
lon: 24.967726
},
{
id: "U3RvcDpIU0w6NDUzMDIyMQ==",
lat: 60.307879,
lon: 24.960343
},
{
id: "U3RvcDpIU0w6NDUyMDI2Nw==",
lat: 60.304895,
lon: 24.957404
},
{
id: "U3RvcDpIU0w6NDUyMDI2OQ==",
lat: 60.302518,
lon: 24.955252
},
{
id: "U3RvcDpIU0w6NDUyMDIzMg==",
lat: 60.301669,
lon: 24.959481
},
{
id: "U3RvcDpIU0w6NDUyMDIzMQ==",
lat: 60.300262,
lon: 24.966312
},
{
id: "U3RvcDpIU0w6NDUyMDI3NA==",
lat: 60.29788,
lon: 24.968544
},
{
id: "U3RvcDpIU0w6NDUyMDI3Mg==",
lat: 60.294892,
lon: 24.96802
},
{
id: "U3RvcDpIU0w6NDUyMDIxMA==",
lat: 60.29319,
lon: 24.97148
},
{
id: "U3RvcDpIU0w6NDUxMDIyNw==",
lat: 60.289917,
lon: 24.965022
},
{
id: "U3RvcDpIU0w6NDUxMDIwMQ==",
lat: 60.28944,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIyMA==",
lat: 60.2865,
lon: 24.95909
},
{
id: "U3RvcDpIU0w6NDUxMDIwMw==",
lat: 60.28515,
lon: 24.96256
},
{
id: "U3RvcDpIU0w6NDUxMDIzOQ==",
lat: 60.2842,
lon: 24.96675
},
{
id: "U3RvcDpIU0w6NDUxMDIwNQ==",
lat: 60.28334,
lon: 24.97145
},
{
id: "U3RvcDpIU0w6NDUxMDIwOQ==",
lat: 60.28201,
lon: 24.97331
},
{
id: "U3RvcDpIU0w6NDUwMDIxNA==",
lat: 60.27911,
lon: 24.9706
},
{
id: "U3RvcDpIU0w6NDUwMDIwMQ==",
lat: 60.27613,
lon: 24.97043
},
{
id: "U3RvcDpIU0w6NDUwMDIwMw==",
lat: 60.272035,
lon: 24.96929
},
{
id: "U3RvcDpIU0w6NDUwMDIxMw==",
lat: 60.26534,
lon: 24.97367
},
{
id: "U3RvcDpIU0w6MTM5MTExMw==",
lat: 60.26397,
lon: 24.98368
},
{
id: "U3RvcDpIU0w6MTM5MTExMQ==",
lat: 60.26071,
lon: 24.9871
},
{
id: "U3RvcDpIU0w6MTM5MTEwOQ==",
lat: 60.2585,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwNA==",
lat: 60.24999,
lon: 25.00914
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MjEwNA==",
lat: 60.24164,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6MTM4MjEwMg==",
lat: 60.241,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMg==",
lat: 60.236477,
lon: 25.042171
},
{
id: "U3RvcDpIU0w6MTQ1NDEyOQ==",
lat: 60.229685,
lon: 25.055331
},
{
id: "U3RvcDpIU0w6MTQ1NDExNA==",
lat: 60.227923,
lon: 25.071773
},
{
id: "U3RvcDpIU0w6MTQ1NDExMg==",
lat: 60.22483,
lon: 25.0789
},
{
id: "U3RvcDpIU0w6MTQ1NDExNw==",
lat: 60.22102,
lon: 25.08156
},
{
id: "U3RvcDpIU0w6MTQ1MzExMA==",
lat: 60.21752,
lon: 25.08351
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzIxNA==",
lat: 60.21033,
lon: 25.07785
}
]
},
{
gtfsId: "HSL:4562",
shortName: "562",
longName: "Mellunmäki - Tikkurila - Aviapolis",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDUyMDI2OQ==",
lat: 60.302518,
lon: 24.955252
},
{
id: "U3RvcDpIU0w6NDUyMDIzNw==",
lat: 60.302312,
lon: 24.952512
},
{
id: "U3RvcDpIU0w6NDUyMDI5MA==",
lat: 60.302239,
lon: 24.940914
},
{
id: "U3RvcDpIU0w6NDUyMDIwNQ==",
lat: 60.299684,
lon: 24.941292
},
{
id: "U3RvcDpIU0w6NDUyMDI5NA==",
lat: 60.296503,
lon: 24.94167
},
{
id: "U3RvcDpIU0w6NDUxMDI0Nw==",
lat: 60.29464,
lon: 24.94259
},
{
id: "U3RvcDpIU0w6NDUxMDI1Mw==",
lat: 60.293552,
lon: 24.94809
},
{
id: "U3RvcDpIU0w6NDUxMDIxNQ==",
lat: 60.293698,
lon: 24.95222
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIyNA==",
lat: 60.28971,
lon: 24.96089
},
{
id: "U3RvcDpIU0w6NDUxMDIyNg==",
lat: 60.28974,
lon: 24.96626
},
{
id: "U3RvcDpIU0w6NDUxMDIzOA==",
lat: 60.29031,
lon: 24.96765
},
{
id: "U3RvcDpIU0w6NDUyMDIxOQ==",
lat: 60.29413,
lon: 24.97213
},
{
id: "U3RvcDpIU0w6NDUyMDI1OQ==",
lat: 60.29643,
lon: 24.9774
},
{
id: "U3RvcDpIU0w6NDUyMDIyNg==",
lat: 60.2954,
lon: 24.98164
},
{
id: "U3RvcDpIU0w6NDY4MDI0NQ==",
lat: 60.29407,
lon: 24.98582
},
{
id: "U3RvcDpIU0w6NDY4MDI0Mw==",
lat: 60.29276,
lon: 24.99154
},
{
id: "U3RvcDpIU0w6NDY4MDIwNQ==",
lat: 60.29238,
lon: 24.9982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMw==",
lat: 60.29196,
lon: 25.00701
},
{
id: "U3RvcDpIU0w6NDY4MDIyNw==",
lat: 60.29201,
lon: 25.01294
},
{
id: "U3RvcDpIU0w6NDYzMDIxOA==",
lat: 60.292663,
lon: 25.017039
},
{
id: "U3RvcDpIU0w6NDYzMDIwMQ==",
lat: 60.29386,
lon: 25.02012
},
{
id: "U3RvcDpIU0w6NDYzMDIwMw==",
lat: 60.29374,
lon: 25.02565
},
{
id: "U3RvcDpIU0w6NDYzMDIwNQ==",
lat: 60.29362,
lon: 25.03007
},
{
id: "U3RvcDpIU0w6NDYxMDIxMA==",
lat: 60.29258,
lon: 25.03557
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI0OA==",
lat: 60.293761,
lon: 25.044375
},
{
id: "U3RvcDpIU0w6NDYxMDIzNg==",
lat: 60.29838,
lon: 25.0454
},
{
id: "U3RvcDpIU0w6NDYyMDIyNw==",
lat: 60.29821,
lon: 25.05193
},
{
id: "U3RvcDpIU0w6NDYyMDIxNw==",
lat: 60.29828,
lon: 25.055708
},
{
id: "U3RvcDpIU0w6NDYyMDIwNQ==",
lat: 60.29549,
lon: 25.0614
},
{
id: "U3RvcDpIU0w6NDY2MDI5OQ==",
lat: 60.29509,
lon: 25.06703
},
{
id: "U3RvcDpIU0w6NDY2MDIwMQ==",
lat: 60.29136,
lon: 25.07367
},
{
id: "U3RvcDpIU0w6NDY2MDIzMA==",
lat: 60.288522,
lon: 25.077184
},
{
id: "U3RvcDpIU0w6NDY2MDIwOA==",
lat: 60.28666,
lon: 25.08042
},
{
id: "U3RvcDpIU0w6NDY0MDIwNw==",
lat: 60.28193,
lon: 25.0804
},
{
id: "U3RvcDpIU0w6NDY0MDIwOQ==",
lat: 60.28153,
lon: 25.0894
},
{
id: "U3RvcDpIU0w6NDk0MDIxMA==",
lat: 60.28073,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6NDk0MDIxMg==",
lat: 60.27969,
lon: 25.10342
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6NDk1MDIwMQ==",
lat: 60.25091,
lon: 25.08784
},
{
id: "U3RvcDpIU0w6NDk1MDIwNQ==",
lat: 60.249921,
lon: 25.096143
},
{
id: "U3RvcDpIU0w6NDk1MDIxMQ==",
lat: 60.24978,
lon: 25.1021
},
{
id: "U3RvcDpIU0w6NDk1MDIxMg==",
lat: 60.250903,
lon: 25.1084
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIxOA==",
lat: 60.24234,
lon: 25.10881
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
},
{
id: "U3RvcDpIU0w6MTQ3MzIyMQ==",
lat: 60.238345,
lon: 25.109191
},
{
id: "U3RvcDpIU0w6NDkxMDIxNw==",
lat: 60.242165,
lon: 25.108975
},
{
id: "U3RvcDpIU0w6NDkxMDIxNQ==",
lat: 60.24494,
lon: 25.11149
},
{
id: "U3RvcDpIU0w6NDkxMDIwMw==",
lat: 60.24755,
lon: 25.11225
},
{
id: "U3RvcDpIU0w6NDkxMDIyMg==",
lat: 60.251153,
lon: 25.110441
},
{
id: "U3RvcDpIU0w6NDk1MDIxMw==",
lat: 60.25071,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk1MDIwNg==",
lat: 60.24998,
lon: 25.09979
},
{
id: "U3RvcDpIU0w6NDk1MDIwNA==",
lat: 60.250182,
lon: 25.093707
},
{
id: "U3RvcDpIU0w6NDk1MDIwMg==",
lat: 60.25108,
lon: 25.08727
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDIxNQ==",
lat: 60.27901,
lon: 25.10592
},
{
id: "U3RvcDpIU0w6NDk0MDIxMw==",
lat: 60.28017,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDk0MDIxMQ==",
lat: 60.280871,
lon: 25.095651
},
{
id: "U3RvcDpIU0w6NDY0MDIxMA==",
lat: 60.28163,
lon: 25.08709
},
{
id: "U3RvcDpIU0w6NDY0MDIwOA==",
lat: 60.2826,
lon: 25.07956
},
{
id: "U3RvcDpIU0w6NDY0MDIwNg==",
lat: 60.28606,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6NDY2MDIwNg==",
lat: 60.28758,
lon: 25.07993
},
{
id: "U3RvcDpIU0w6NDY2MDIwNA==",
lat: 60.28978,
lon: 25.07599
},
{
id: "U3RvcDpIU0w6NDY2MDIwMg==",
lat: 60.29189,
lon: 25.07317
},
{
id: "U3RvcDpIU0w6NDY2MDI5OA==",
lat: 60.29531,
lon: 25.06689
},
{
id: "U3RvcDpIU0w6NDYyMDIwNg==",
lat: 60.29581,
lon: 25.05983
},
{
id: "U3RvcDpIU0w6NDYyMDIyMg==",
lat: 60.29868,
lon: 25.05371
},
{
id: "U3RvcDpIU0w6NDYyMDIzMQ==",
lat: 60.2985,
lon: 25.05011
},
{
id: "U3RvcDpIU0w6NDYxMDIzNw==",
lat: 60.29861,
lon: 25.044342
},
{
id: "U3RvcDpIU0w6NDYxMDIwNw==",
lat: 60.293293,
lon: 25.043366
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMQ==",
lat: 60.292838,
lon: 25.034291
},
{
id: "U3RvcDpIU0w6NDYzMDIwNg==",
lat: 60.29374,
lon: 25.02962
},
{
id: "U3RvcDpIU0w6NDYzMDIwNA==",
lat: 60.29387,
lon: 25.02434
},
{
id: "U3RvcDpIU0w6NDYzMDIwMg==",
lat: 60.29399,
lon: 25.01849
},
{
id: "U3RvcDpIU0w6NDYzMDIxMg==",
lat: 60.29205,
lon: 25.0157
},
{
id: "U3RvcDpIU0w6NDY4MDIyOA==",
lat: 60.29215,
lon: 25.01095
},
{
id: "U3RvcDpIU0w6NDY4MDIwNA==",
lat: 60.29215,
lon: 25.00494
},
{
id: "U3RvcDpIU0w6NDY4MDIwNg==",
lat: 60.29266,
lon: 24.99609
},
{
id: "U3RvcDpIU0w6NDY4MDI0Mg==",
lat: 60.29315,
lon: 24.98939
},
{
id: "U3RvcDpIU0w6NDY4MDI0OA==",
lat: 60.29424,
lon: 24.98574
},
{
id: "U3RvcDpIU0w6NDUyMDI2MA==",
lat: 60.296,
lon: 24.98043
},
{
id: "U3RvcDpIU0w6NDUyMDIyNw==",
lat: 60.29665,
lon: 24.97606
},
{
id: "U3RvcDpIU0w6NDUyMDIxMA==",
lat: 60.29319,
lon: 24.97148
},
{
id: "U3RvcDpIU0w6NDUxMDIyNw==",
lat: 60.289917,
lon: 24.965022
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDI1MQ==",
lat: 60.291725,
lon: 24.95261
},
{
id: "U3RvcDpIU0w6NDUxMDIyOA==",
lat: 60.293334,
lon: 24.946772
},
{
id: "U3RvcDpIU0w6NDUyMDIxNQ==",
lat: 60.29537,
lon: 24.94262
},
{
id: "U3RvcDpIU0w6NDUyMDI5Mw==",
lat: 60.297731,
lon: 24.941936
},
{
id: "U3RvcDpIU0w6NDUyMDIwNg==",
lat: 60.300216,
lon: 24.941409
},
{
id: "U3RvcDpIU0w6NDUyMDI5OQ==",
lat: 60.3027,
lon: 24.9422
},
{
id: "U3RvcDpIU0w6NDUyMDIzOA==",
lat: 60.302153,
lon: 24.952562
},
{
id: "U3RvcDpIU0w6NDUyMDI2Ng==",
lat: 60.302738,
lon: 24.955727
}
]
},
{
gtfsId: "HSL:4322",
shortName: "322",
longName: "Elielinaukio-Vantaankoski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEzNQ==",
lat: 60.171861,
lon: 24.939722
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEyMA==",
lat: 60.20988,
lon: 24.88902
},
{
id: "U3RvcDpIU0w6MTI5MTE4MA==",
lat: 60.21517,
lon: 24.88415
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mg==",
lat: 60.21988,
lon: 24.88124
},
{
id: "U3RvcDpIU0w6MTI5NDEyMQ==",
lat: 60.22517,
lon: 24.87707
},
{
id: "U3RvcDpIU0w6MTQ2NDEyMw==",
lat: 60.22792,
lon: 24.87272
},
{
id: "U3RvcDpIU0w6MTQ2MzExNw==",
lat: 60.23393,
lon: 24.862
},
{
id: "U3RvcDpIU0w6MTMyMDExOQ==",
lat: 60.2387,
lon: 24.85418
},
{
id: "U3RvcDpIU0w6MTMyMDI5Nw==",
lat: 60.24435,
lon: 24.84502
},
{
id: "U3RvcDpIU0w6MTMyMDI5NQ==",
lat: 60.24945,
lon: 24.83561
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNw==",
lat: 60.25811,
lon: 24.80891
},
{
id: "U3RvcDpIU0w6NDEyMDIyOA==",
lat: 60.26293,
lon: 24.805612
},
{
id: "U3RvcDpIU0w6NDEyMDIxOA==",
lat: 60.26444,
lon: 24.80597
},
{
id: "U3RvcDpIU0w6NDEyMDI5OA==",
lat: 60.26687,
lon: 24.80497
},
{
id: "U3RvcDpIU0w6NDEyMDIxOQ==",
lat: 60.26612,
lon: 24.79949
},
{
id: "U3RvcDpIU0w6NDEyMDIyMw==",
lat: 60.26877,
lon: 24.79488
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIzOA==",
lat: 60.27916,
lon: 24.81449
},
{
id: "U3RvcDpIU0w6NDE0MDI0MA==",
lat: 60.28127,
lon: 24.81867
},
{
id: "U3RvcDpIU0w6NDE0MDIzMg==",
lat: 60.28486,
lon: 24.8275
},
{
id: "U3RvcDpIU0w6NDE0MDI0OQ==",
lat: 60.28393,
lon: 24.8332
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDI0MA==",
lat: 60.285613,
lon: 24.849258
},
{
id: "U3RvcDpIU0w6NDE3MDI3Nw==",
lat: 60.285325,
lon: 24.849306
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE3MDIzMQ==",
lat: 60.28247,
lon: 24.83561
},
{
id: "U3RvcDpIU0w6NDE0MDI0OA==",
lat: 60.28426,
lon: 24.83209
},
{
id: "U3RvcDpIU0w6NDE0MDIyNQ==",
lat: 60.28484,
lon: 24.82628
},
{
id: "U3RvcDpIU0w6NDE0MDIzOQ==",
lat: 60.2812,
lon: 24.81829
},
{
id: "U3RvcDpIU0w6NDE0MDIzNw==",
lat: 60.27924,
lon: 24.81431
},
{
id: "U3RvcDpIU0w6NDE0MDIzNg==",
lat: 60.27682,
lon: 24.81537
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDEyMDI5NA==",
lat: 60.27096,
lon: 24.80215
},
{
id: "U3RvcDpIU0w6NDEyMDI4Ng==",
lat: 60.27016,
lon: 24.79557
},
{
id: "U3RvcDpIU0w6NDEyMDIyMg==",
lat: 60.26848,
lon: 24.79489
},
{
id: "U3RvcDpIU0w6NDEyMDIyMA==",
lat: 60.26647,
lon: 24.79868
},
{
id: "U3RvcDpIU0w6NDEyMDI5OQ==",
lat: 60.26695,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDIxMQ==",
lat: 60.26427,
lon: 24.80569
},
{
id: "U3RvcDpIU0w6NDEyMDIxMA==",
lat: 60.26149,
lon: 24.80645
},
{
id: "U3RvcDpIU0w6NDEyMDIwOA==",
lat: 60.25673,
lon: 24.80958
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6MTMyMDI5Mg==",
lat: 60.24917,
lon: 24.83552
},
{
id: "U3RvcDpIU0w6MTMyMDI5NA==",
lat: 60.24309,
lon: 24.84648
},
{
id: "U3RvcDpIU0w6MTMyMDEyMA==",
lat: 60.239267,
lon: 24.852589
},
{
id: "U3RvcDpIU0w6MTQ2MzExOA==",
lat: 60.23293,
lon: 24.86311
},
{
id: "U3RvcDpIU0w6MTI5NDEyNA==",
lat: 60.227,
lon: 24.87358
},
{
id: "U3RvcDpIU0w6MTI5NDEyMg==",
lat: 60.22447,
lon: 24.87771
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mw==",
lat: 60.21865,
lon: 24.8815
},
{
id: "U3RvcDpIU0w6MTI5MTE4MQ==",
lat: 60.215735,
lon: 24.883378
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:4443",
shortName: "443",
longName: "Kivistö-Vestra",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIzMDI0Nw==",
lat: 60.314485,
lon: 24.845366
},
{
id: "U3RvcDpIU0w6NDIzMDIwMg==",
lat: 60.317449,
lon: 24.846159
},
{
id: "U3RvcDpIU0w6NDIzMDIwNA==",
lat: 60.3189,
lon: 24.84368
},
{
id: "U3RvcDpIU0w6NDIzMDIwNg==",
lat: 60.32009,
lon: 24.84231
},
{
id: "U3RvcDpIU0w6NDIzMDIwOA==",
lat: 60.32314,
lon: 24.84034
},
{
id: "U3RvcDpIU0w6NDIzMDIxMQ==",
lat: 60.32644,
lon: 24.83694
},
{
id: "U3RvcDpIU0w6NDIzMDIxMw==",
lat: 60.32981,
lon: 24.83501
},
{
id: "U3RvcDpIU0w6NDIzMDIxNQ==",
lat: 60.33459,
lon: 24.83423
},
{
id: "U3RvcDpIU0w6NDIzMDIxNw==",
lat: 60.33822,
lon: 24.82468
},
{
id: "U3RvcDpIU0w6NDIzMDIxOQ==",
lat: 60.33903,
lon: 24.81895
},
{
id: "U3RvcDpIU0w6NDIyMDIwNA==",
lat: 60.33848,
lon: 24.81626
},
{
id: "U3RvcDpIU0w6NDIyMDIzMw==",
lat: 60.33968,
lon: 24.814
},
{
id: "U3RvcDpIU0w6NDIyMDIyOQ==",
lat: 60.339276,
lon: 24.810279
},
{
id: "U3RvcDpIU0w6NDIyMDIxMw==",
lat: 60.3392,
lon: 24.80562
},
{
id: "U3RvcDpIU0w6NDIyMDIxNQ==",
lat: 60.33872,
lon: 24.79995
},
{
id: "U3RvcDpIU0w6NDIyMDIwMw==",
lat: 60.33745,
lon: 24.79421
},
{
id: "U3RvcDpIU0w6NDIyMDIxNw==",
lat: 60.336625,
lon: 24.789737
},
{
id: "U3RvcDpIU0w6NDIyMDIxOQ==",
lat: 60.33418,
lon: 24.78336
},
{
id: "U3RvcDpIU0w6NDMwMDIwNw==",
lat: 60.33041,
lon: 24.77099
},
{
id: "U3RvcDpIU0w6NDMwMDIwMQ==",
lat: 60.32861,
lon: 24.76833
},
{
id: "U3RvcDpIU0w6NDMwMDIwMw==",
lat: 60.32868,
lon: 24.76315
},
{
id: "U3RvcDpIU0w6NDMwMDIwNQ==",
lat: 60.32931,
lon: 24.75779
},
{
id: "U3RvcDpIU0w6NDMwMDIwNA==",
lat: 60.32861,
lon: 24.76323
},
{
id: "U3RvcDpIU0w6NDMwMDIwMg==",
lat: 60.32879,
lon: 24.76864
},
{
id: "U3RvcDpIU0w6NDMwMDIwNg==",
lat: 60.33047,
lon: 24.77127
},
{
id: "U3RvcDpIU0w6NDIyMDIxOA==",
lat: 60.33406,
lon: 24.78329
},
{
id: "U3RvcDpIU0w6NDIyMDIxNg==",
lat: 60.33661,
lon: 24.79028
},
{
id: "U3RvcDpIU0w6NDIyMDIwNg==",
lat: 60.3375,
lon: 24.79426
},
{
id: "U3RvcDpIU0w6NDIyMDIxNA==",
lat: 60.33857,
lon: 24.79951
},
{
id: "U3RvcDpIU0w6NDIyMDIxMg==",
lat: 60.33916,
lon: 24.80776
},
{
id: "U3RvcDpIU0w6NDIyMDIyOA==",
lat: 60.339205,
lon: 24.810437
},
{
id: "U3RvcDpIU0w6NDIyMDIzMg==",
lat: 60.33963,
lon: 24.81417
},
{
id: "U3RvcDpIU0w6NDIyMDIwNQ==",
lat: 60.33948,
lon: 24.81517
},
{
id: "U3RvcDpIU0w6NDIzMDIyMA==",
lat: 60.33859,
lon: 24.81824
},
{
id: "U3RvcDpIU0w6NDIzMDIxOA==",
lat: 60.3383,
lon: 24.82432
},
{
id: "U3RvcDpIU0w6NDIzMDIxNg==",
lat: 60.33486,
lon: 24.83359
},
{
id: "U3RvcDpIU0w6NDIzMDIxNA==",
lat: 60.32898,
lon: 24.83558
},
{
id: "U3RvcDpIU0w6NDIzMDIxMg==",
lat: 60.32579,
lon: 24.83767
},
{
id: "U3RvcDpIU0w6NDIzMDIwOQ==",
lat: 60.32227,
lon: 24.8409
},
{
id: "U3RvcDpIU0w6NDIzMDIwNw==",
lat: 60.3205,
lon: 24.84192
},
{
id: "U3RvcDpIU0w6NDIzMDIwNQ==",
lat: 60.31832,
lon: 24.84409
},
{
id: "U3RvcDpIU0w6NDIzMDIwMw==",
lat: 60.316588,
lon: 24.847408
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
}
]
},
{
gtfsId: "HSL:1055",
shortName: "55",
longName: "Rautatientori-Koskela",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMQ==",
lat: 60.17164,
lon: 24.94299
},
{
id: "U3RvcDpIU0w6MTAyMDE2OQ==",
lat: 60.173545,
lon: 24.94981
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDE1MQ==",
lat: 60.17892,
lon: 24.96067
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEyMQ==",
lat: 60.186033,
lon: 24.968139
},
{
id: "U3RvcDpIU0w6MTEwMDEyMA==",
lat: 60.18906,
lon: 24.97123
},
{
id: "U3RvcDpIU0w6MTEwMDEzMw==",
lat: 60.18831,
lon: 24.97647
},
{
id: "U3RvcDpIU0w6MTEwMDE2OA==",
lat: 60.19358,
lon: 24.97782
},
{
id: "U3RvcDpIU0w6MTIxMDExMQ==",
lat: 60.19603,
lon: 24.97368
},
{
id: "U3RvcDpIU0w6MTIxMDE2NA==",
lat: 60.19909,
lon: 24.96847
},
{
id: "U3RvcDpIU0w6MTIzMDEwOQ==",
lat: 60.20312,
lon: 24.9673
},
{
id: "U3RvcDpIU0w6MTIzMDExMw==",
lat: 60.20548,
lon: 24.97209
},
{
id: "U3RvcDpIU0w6MTIzMDEwNA==",
lat: 60.20827,
lon: 24.97504
},
{
id: "U3RvcDpIU0w6MTIzMDEwMg==",
lat: 60.21121,
lon: 24.97757
},
{
id: "U3RvcDpIU0w6MTI3MDEwMw==",
lat: 60.21316,
lon: 24.97917
},
{
id: "U3RvcDpIU0w6MTI3MDEwNw==",
lat: 60.21705,
lon: 24.979
},
{
id: "U3RvcDpIU0w6MTI2MDEwMw==",
lat: 60.21668,
lon: 24.96663
},
{
id: "U3RvcDpIU0w6MTI2MDEwNQ==",
lat: 60.21815,
lon: 24.96682
},
{
id: "U3RvcDpIU0w6MTI2MDEwNg==",
lat: 60.21897,
lon: 24.9699
},
{
id: "U3RvcDpIU0w6MTI2MDEwNw==",
lat: 60.21953,
lon: 24.96767
},
{
id: "U3RvcDpIU0w6MTI2MDEwOA==",
lat: 60.2197,
lon: 24.96428
},
{
id: "U3RvcDpIU0w6MTI2MDE4MA==",
lat: 60.21839,
lon: 24.96627
},
{
id: "U3RvcDpIU0w6MTI2MDEwNA==",
lat: 60.21645,
lon: 24.96702
},
{
id: "U3RvcDpIU0w6MTI3MDEwNQ==",
lat: 60.21611,
lon: 24.98016
},
{
id: "U3RvcDpIU0w6MTI3MDEwMg==",
lat: 60.21252,
lon: 24.97844
},
{
id: "U3RvcDpIU0w6MTIzMDEwMQ==",
lat: 60.210234,
lon: 24.976613
},
{
id: "U3RvcDpIU0w6MTIzMDEwMw==",
lat: 60.20808,
lon: 24.97474
},
{
id: "U3RvcDpIU0w6MTIzMDExNA==",
lat: 60.20593,
lon: 24.97255
},
{
id: "U3RvcDpIU0w6MTIzMDExMg==",
lat: 60.20316,
lon: 24.96657
},
{
id: "U3RvcDpIU0w6MTI0MDEwMg==",
lat: 60.202895,
lon: 24.964478
},
{
id: "U3RvcDpIU0w6MTIxMDE2Mw==",
lat: 60.19824,
lon: 24.96938
},
{
id: "U3RvcDpIU0w6MTIxMDExMA==",
lat: 60.19523,
lon: 24.97448
},
{
id: "U3RvcDpIU0w6MTEwMDE2Nw==",
lat: 60.19191,
lon: 24.978519
},
{
id: "U3RvcDpIU0w6MTEwMDEzNA==",
lat: 60.18831,
lon: 24.97661
},
{
id: "U3RvcDpIU0w6MTEwMDExOQ==",
lat: 60.189218,
lon: 24.971152
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTEwMDE0OQ==",
lat: 60.17887,
lon: 24.96059
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:1054",
shortName: "54",
longName: "Itäkeskus(M)- Pitäjänmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ2NTE0OA==",
lat: 60.22054,
lon: 24.87679
},
{
id: "U3RvcDpIU0w6MTQ2NTE0Ng==",
lat: 60.21857,
lon: 24.87877
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2NTEzNg==",
lat: 60.22436,
lon: 24.8672
},
{
id: "U3RvcDpIU0w6MTQ2NTEzNA==",
lat: 60.2258,
lon: 24.8696
},
{
id: "U3RvcDpIU0w6MTI5NDEzMg==",
lat: 60.22769,
lon: 24.87405
},
{
id: "U3RvcDpIU0w6MTI5NDE0Mw==",
lat: 60.22838,
lon: 24.87708
},
{
id: "U3RvcDpIU0w6MTI5NDEzOQ==",
lat: 60.23079,
lon: 24.8821
},
{
id: "U3RvcDpIU0w6MTI5MzEzOA==",
lat: 60.23275,
lon: 24.88788
},
{
id: "U3RvcDpIU0w6MTI5NDE4MA==",
lat: 60.23438,
lon: 24.89275
},
{
id: "U3RvcDpIU0w6MTMzMjEwNg==",
lat: 60.23566,
lon: 24.90215
},
{
id: "U3RvcDpIU0w6MTMzMjEwOA==",
lat: 60.23891,
lon: 24.91547
},
{
id: "U3RvcDpIU0w6MTM0MTEwOA==",
lat: 60.24109,
lon: 24.92844
},
{
id: "U3RvcDpIU0w6MTM0MTEwNA==",
lat: 60.24339,
lon: 24.94503
},
{
id: "U3RvcDpIU0w6MTM0MjEwMg==",
lat: 60.24438,
lon: 24.96024
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM4MjEwNA==",
lat: 60.24164,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6MTM4MjEwMg==",
lat: 60.241,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMg==",
lat: 60.236477,
lon: 25.042171
},
{
id: "U3RvcDpIU0w6MTQ1NDEyOQ==",
lat: 60.229685,
lon: 25.055331
},
{
id: "U3RvcDpIU0w6MTQ1NDExNA==",
lat: 60.227923,
lon: 25.071773
},
{
id: "U3RvcDpIU0w6MTQ1NDExMg==",
lat: 60.22483,
lon: 25.0789
},
{
id: "U3RvcDpIU0w6MTQ1NDExNw==",
lat: 60.22102,
lon: 25.08156
},
{
id: "U3RvcDpIU0w6MTQ1MzExMA==",
lat: 60.21752,
lon: 25.08351
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
},
{
id: "U3RvcDpIU0w6MTQ1MzIwMg==",
lat: 60.20995,
lon: 25.076058
},
{
id: "U3RvcDpIU0w6MTQ1MzE4MQ==",
lat: 60.21211,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMQ==",
lat: 60.21472,
lon: 25.08581
},
{
id: "U3RvcDpIU0w6MTQ1MzEwOQ==",
lat: 60.21775,
lon: 25.08378
},
{
id: "U3RvcDpIU0w6MTQ1NDExNg==",
lat: 60.22127,
lon: 25.08186
},
{
id: "U3RvcDpIU0w6MTQ1NDExMQ==",
lat: 60.225,
lon: 25.07936
},
{
id: "U3RvcDpIU0w6MTQ1NDExMw==",
lat: 60.22808,
lon: 25.0721
},
{
id: "U3RvcDpIU0w6MTQ3NDE4OQ==",
lat: 60.23086,
lon: 25.054144
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMQ==",
lat: 60.236942,
lon: 25.045093
},
{
id: "U3RvcDpIU0w6MTM4MjEwMQ==",
lat: 60.24123,
lon: 25.03104
},
{
id: "U3RvcDpIU0w6MTM4MjEyOA==",
lat: 60.24175,
lon: 25.019695
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM0MjEwMQ==",
lat: 60.24466,
lon: 24.96128
},
{
id: "U3RvcDpIU0w6MTM0MTEwMw==",
lat: 60.24432,
lon: 24.94666
},
{
id: "U3RvcDpIU0w6MTM0MTEwNQ==",
lat: 60.24126,
lon: 24.92653
},
{
id: "U3RvcDpIU0w6MTMzMjEwNw==",
lat: 60.23894,
lon: 24.91321
},
{
id: "U3RvcDpIU0w6MTMzMjEzOA==",
lat: 60.236106,
lon: 24.90268
},
{
id: "U3RvcDpIU0w6MTI5NDI0Mg==",
lat: 60.23468,
lon: 24.89256
},
{
id: "U3RvcDpIU0w6MTI5NDEzNw==",
lat: 60.23296,
lon: 24.88799
},
{
id: "U3RvcDpIU0w6MTI5NDE0MQ==",
lat: 60.230629,
lon: 24.881719
},
{
id: "U3RvcDpIU0w6MTI5NDE0Mg==",
lat: 60.22844,
lon: 24.87667
},
{
id: "U3RvcDpIU0w6MTQ2NTEzMQ==",
lat: 60.22716,
lon: 24.87217
},
{
id: "U3RvcDpIU0w6MTQ2NTEzMw==",
lat: 60.22509,
lon: 24.86806
},
{
id: "U3RvcDpIU0w6MTQ2NDEzNQ==",
lat: 60.22389,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTE0NQ==",
lat: 60.21562,
lon: 24.87617
},
{
id: "U3RvcDpIU0w6MTQ2NTE0Nw==",
lat: 60.21922,
lon: 24.87837
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNg==",
lat: 60.220779,
lon: 24.876585
}
]
},
{
gtfsId: "HSL:2143",
shortName: "143",
longName: "Matinkylä (M)-Soukanniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQxNTI3Mg==",
lat: 60.12895,
lon: 24.68026
},
{
id: "U3RvcDpIU0w6MjQxNTI3NQ==",
lat: 60.12729,
lon: 24.67957
},
{
id: "U3RvcDpIU0w6MjQxNTI2Mw==",
lat: 60.12456,
lon: 24.67649
},
{
id: "U3RvcDpIU0w6MjQxNTI2Ng==",
lat: 60.12457,
lon: 24.67214
},
{
id: "U3RvcDpIU0w6MjQxNTI3OQ==",
lat: 60.12684,
lon: 24.66981
},
{
id: "U3RvcDpIU0w6MjQxNTI3Mw==",
lat: 60.12895,
lon: 24.6673
},
{
id: "U3RvcDpIU0w6MjQxMjI3NQ==",
lat: 60.13244,
lon: 24.6642
},
{
id: "U3RvcDpIU0w6MjQxMjIzOA==",
lat: 60.13528,
lon: 24.67033
},
{
id: "U3RvcDpIU0w6MjQxMjIzNg==",
lat: 60.13606,
lon: 24.67287
},
{
id: "U3RvcDpIU0w6MjQxMjIzNA==",
lat: 60.13805,
lon: 24.67337
},
{
id: "U3RvcDpIU0w6MjQxMjIzMg==",
lat: 60.14018,
lon: 24.6725
},
{
id: "U3RvcDpIU0w6MjQxMjIzMA==",
lat: 60.141527,
lon: 24.671379
},
{
id: "U3RvcDpIU0w6MjQxMjIyNw==",
lat: 60.143373,
lon: 24.673594
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNQ==",
lat: 60.14522,
lon: 24.67967
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMw==",
lat: 60.14759,
lon: 24.68258
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMQ==",
lat: 60.151014,
lon: 24.692223
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMg==",
lat: 60.152988,
lon: 24.698956
},
{
id: "U3RvcDpIU0w6MjQ0MTIxNA==",
lat: 60.152772,
lon: 24.705127
},
{
id: "U3RvcDpIU0w6MjQ0MTIzMw==",
lat: 60.15368,
lon: 24.71046
},
{
id: "U3RvcDpIU0w6MjQ0MTIwOQ==",
lat: 60.155789,
lon: 24.714964
},
{
id: "U3RvcDpIU0w6MjMxNDIyNg==",
lat: 60.15706,
lon: 24.72747
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxMw==",
lat: 60.160241,
lon: 24.738861
},
{
id: "U3RvcDpIU0w6MjMxNDIyNA==",
lat: 60.15827,
lon: 24.73214
},
{
id: "U3RvcDpIU0w6MjMxMjIwMg==",
lat: 60.156464,
lon: 24.725221
},
{
id: "U3RvcDpIU0w6MjQ0MjIyNA==",
lat: 60.155586,
lon: 24.713352
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMw==",
lat: 60.153083,
lon: 24.703151
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNg==",
lat: 60.153001,
lon: 24.696816
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMA==",
lat: 60.15,
lon: 24.68924
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMg==",
lat: 60.14756,
lon: 24.68237
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNA==",
lat: 60.14542,
lon: 24.67975
},
{
id: "U3RvcDpIU0w6MjQxMjIyOA==",
lat: 60.143279,
lon: 24.672656
},
{
id: "U3RvcDpIU0w6MjQxMjIyOQ==",
lat: 60.141393,
lon: 24.67125
},
{
id: "U3RvcDpIU0w6MjQxMjIzMQ==",
lat: 60.13993,
lon: 24.67253
},
{
id: "U3RvcDpIU0w6MjQxMjIzMw==",
lat: 60.13789,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjQxMjIzNQ==",
lat: 60.13617,
lon: 24.67272
},
{
id: "U3RvcDpIU0w6MjQxMjIzNw==",
lat: 60.135128,
lon: 24.669484
},
{
id: "U3RvcDpIU0w6MjQxMjI3Ng==",
lat: 60.13182,
lon: 24.66379
},
{
id: "U3RvcDpIU0w6MjQxNTI3NA==",
lat: 60.12875,
lon: 24.66742
},
{
id: "U3RvcDpIU0w6MjQxNTI4MA==",
lat: 60.1267,
lon: 24.66982
},
{
id: "U3RvcDpIU0w6MjQxNTI0Ng==",
lat: 60.12443,
lon: 24.67228
},
{
id: "U3RvcDpIU0w6MjQxNTI2NA==",
lat: 60.12456,
lon: 24.67677
},
{
id: "U3RvcDpIU0w6MjQxNTI3Ng==",
lat: 60.12733,
lon: 24.67968
}
]
},
{
gtfsId: "HSL:1052",
shortName: "52",
longName: "Arabia-Oulunkylä-Munkkiniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTIzMjEwMg==",
lat: 60.209603,
lon: 24.979491
},
{
id: "U3RvcDpIU0w6MTIzMjEwNA==",
lat: 60.206974,
lon: 24.975029
},
{
id: "U3RvcDpIU0w6MTIzMDExNA==",
lat: 60.20593,
lon: 24.97255
},
{
id: "U3RvcDpIU0w6MTIzMDExMg==",
lat: 60.20316,
lon: 24.96657
},
{
id: "U3RvcDpIU0w6MTI0MDEwNQ==",
lat: 60.20878,
lon: 24.96734
},
{
id: "U3RvcDpIU0w6MTI0MDEwNw==",
lat: 60.20952,
lon: 24.96435
},
{
id: "U3RvcDpIU0w6MTI1MDEwNQ==",
lat: 60.2129,
lon: 24.95926
},
{
id: "U3RvcDpIU0w6MTI1MDEwNw==",
lat: 60.21474,
lon: 24.95885
},
{
id: "U3RvcDpIU0w6MTI2MDEwOQ==",
lat: 60.21713,
lon: 24.95984
},
{
id: "U3RvcDpIU0w6MTI2MDExMA==",
lat: 60.2199,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTI2MDExMg==",
lat: 60.22232,
lon: 24.96484
},
{
id: "U3RvcDpIU0w6MTI2MDExNA==",
lat: 60.22362,
lon: 24.966271
},
{
id: "U3RvcDpIU0w6MTI4NTE1OA==",
lat: 60.22632,
lon: 24.96805
},
{
id: "U3RvcDpIU0w6MTI4NDExNw==",
lat: 60.22996,
lon: 24.96525
},
{
id: "U3RvcDpIU0w6MTI4NDEyMA==",
lat: 60.23192,
lon: 24.96787
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEyNw==",
lat: 60.23022,
lon: 24.94776
},
{
id: "U3RvcDpIU0w6MTI4NDEwMw==",
lat: 60.22972,
lon: 24.94197
},
{
id: "U3RvcDpIU0w6MTI4MjEwMQ==",
lat: 60.2301,
lon: 24.93839
},
{
id: "U3RvcDpIU0w6MTI4MjE0Nw==",
lat: 60.230679,
lon: 24.932013
},
{
id: "U3RvcDpIU0w6MTI4MjE0NQ==",
lat: 60.228725,
lon: 24.927237
},
{
id: "U3RvcDpIU0w6MTI4MjE0MA==",
lat: 60.22883,
lon: 24.92372
},
{
id: "U3RvcDpIU0w6MTI4MTExMg==",
lat: 60.23075,
lon: 24.91943
},
{
id: "U3RvcDpIU0w6MTI4MTExNQ==",
lat: 60.22997,
lon: 24.91637
},
{
id: "U3RvcDpIU0w6MTI4MTE2MA==",
lat: 60.227725,
lon: 24.906583
},
{
id: "U3RvcDpIU0w6MTI5MzE2Mg==",
lat: 60.22686,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzEyNA==",
lat: 60.22408,
lon: 24.89863
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MTEyNA==",
lat: 60.21848,
lon: 24.89938
},
{
id: "U3RvcDpIU0w6MTI5MTEwOA==",
lat: 60.216,
lon: 24.89718
},
{
id: "U3RvcDpIU0w6MTI5MTExMA==",
lat: 60.21632,
lon: 24.89437
},
{
id: "U3RvcDpIU0w6MTI5MTExMg==",
lat: 60.21766,
lon: 24.89051
},
{
id: "U3RvcDpIU0w6MTI5MTExNQ==",
lat: 60.21736,
lon: 24.88825
},
{
id: "U3RvcDpIU0w6MTI5MTExNw==",
lat: 60.21463,
lon: 24.88657
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTI5MTEyMQ==",
lat: 60.20828,
lon: 24.88484
},
{
id: "U3RvcDpIU0w6MTMwNDE0MA==",
lat: 60.20693,
lon: 24.87868
},
{
id: "U3RvcDpIU0w6MTMwNDE0MQ==",
lat: 60.20891,
lon: 24.87561
},
{
id: "U3RvcDpIU0w6MTMwNDE0Mg==",
lat: 60.20934,
lon: 24.86737
},
{
id: "U3RvcDpIU0w6MTMwNDE0Mw==",
lat: 60.20785,
lon: 24.86408
},
{
id: "U3RvcDpIU0w6MTMwNDE1Nw==",
lat: 60.205768,
lon: 24.863507
},
{
id: "U3RvcDpIU0w6MTMwNDE0NA==",
lat: 60.20378,
lon: 24.86971
},
{
id: "U3RvcDpIU0w6MTMwMTE0NQ==",
lat: 60.201432,
lon: 24.87506
},
{
id: "U3RvcDpIU0w6MTMwMTEwMw==",
lat: 60.197903,
lon: 24.876563
},
{
id: "U3RvcDpIU0w6MTMwMTE3MQ==",
lat: 60.19645,
lon: 24.883458
},
{
id: "U3RvcDpIU0w6MTMwMTE0OQ==",
lat: 60.19575,
lon: 24.88538
},
{
id: "U3RvcDpIU0w6MTMwMTE0OA==",
lat: 60.197065,
lon: 24.88267
},
{
id: "U3RvcDpIU0w6MTMwMTE0Nw==",
lat: 60.198302,
lon: 24.876747
},
{
id: "U3RvcDpIU0w6MTMwMTE0Ng==",
lat: 60.201122,
lon: 24.875988
},
{
id: "U3RvcDpIU0w6MTMwNDEzMA==",
lat: 60.20412,
lon: 24.86842
},
{
id: "U3RvcDpIU0w6MTMwNDEzMQ==",
lat: 60.20569,
lon: 24.8638
},
{
id: "U3RvcDpIU0w6MTMwNDEzMg==",
lat: 60.20745,
lon: 24.86424
},
{
id: "U3RvcDpIU0w6MTMwNDEzMw==",
lat: 60.2091,
lon: 24.86682
},
{
id: "U3RvcDpIU0w6MTMwNDEzNA==",
lat: 60.2091,
lon: 24.8748
},
{
id: "U3RvcDpIU0w6MTMwNDEzNQ==",
lat: 60.20743,
lon: 24.87799
},
{
id: "U3RvcDpIU0w6MTMwNTE1MQ==",
lat: 60.20663,
lon: 24.88078
},
{
id: "U3RvcDpIU0w6MTI5MTEyMg==",
lat: 60.20837,
lon: 24.88578
},
{
id: "U3RvcDpIU0w6MTI5MTIyMA==",
lat: 60.21031,
lon: 24.88865
},
{
id: "U3RvcDpIU0w6MTI5MTExOA==",
lat: 60.21475,
lon: 24.88711
},
{
id: "U3RvcDpIU0w6MTI5MTExNg==",
lat: 60.21749,
lon: 24.88834
},
{
id: "U3RvcDpIU0w6MTI5MTExMw==",
lat: 60.21736,
lon: 24.8909
},
{
id: "U3RvcDpIU0w6MTI5MTExMQ==",
lat: 60.21624,
lon: 24.89347
},
{
id: "U3RvcDpIU0w6MTI5MTEwNg==",
lat: 60.21582,
lon: 24.898291
},
{
id: "U3RvcDpIU0w6MTI5MTEyMw==",
lat: 60.21762,
lon: 24.89964
},
{
id: "U3RvcDpIU0w6MTI5MTEyNQ==",
lat: 60.21965,
lon: 24.90171
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzEyMw==",
lat: 60.22424,
lon: 24.89852
},
{
id: "U3RvcDpIU0w6MTI5MzE2Mw==",
lat: 60.22682,
lon: 24.90304
},
{
id: "U3RvcDpIU0w6MTI4NjE4MQ==",
lat: 60.227754,
lon: 24.907305
},
{
id: "U3RvcDpIU0w6MTI4MTExNA==",
lat: 60.23083,
lon: 24.92003
},
{
id: "U3RvcDpIU0w6MTI4MjE0MQ==",
lat: 60.22898,
lon: 24.92337
},
{
id: "U3RvcDpIU0w6MTI4MjE0Mg==",
lat: 60.22827,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTI4MjE0Ng==",
lat: 60.23062,
lon: 24.93342
},
{
id: "U3RvcDpIU0w6MTI4MjEwMg==",
lat: 60.23011,
lon: 24.9378
},
{
id: "U3RvcDpIU0w6MTI4NDEwNA==",
lat: 60.22968,
lon: 24.94452
},
{
id: "U3RvcDpIU0w6MTI4NDEyOQ==",
lat: 60.22999,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDEyMw==",
lat: 60.232717,
lon: 24.967113
},
{
id: "U3RvcDpIU0w6MTI4NDExOA==",
lat: 60.22968,
lon: 24.9646
},
{
id: "U3RvcDpIU0w6MTI4NDEwMg==",
lat: 60.22873,
lon: 24.96421
},
{
id: "U3RvcDpIU0w6MTI4NTE1OQ==",
lat: 60.22592,
lon: 24.96789
},
{
id: "U3RvcDpIU0w6MTI2MDExNQ==",
lat: 60.223569,
lon: 24.966086
},
{
id: "U3RvcDpIU0w6MTI2MDExMw==",
lat: 60.22171,
lon: 24.96391
},
{
id: "U3RvcDpIU0w6MTI2MDExMQ==",
lat: 60.2199,
lon: 24.96186
},
{
id: "U3RvcDpIU0w6MTI1MDE4MA==",
lat: 60.21691,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6MTI1MDEwOA==",
lat: 60.21436,
lon: 24.95852
},
{
id: "U3RvcDpIU0w6MTI1MDEwNg==",
lat: 60.21303,
lon: 24.95897
},
{
id: "U3RvcDpIU0w6MTI0MDEwOA==",
lat: 60.2097,
lon: 24.96382
},
{
id: "U3RvcDpIU0w6MTI0MDEwNA==",
lat: 60.20869,
lon: 24.96735
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTIzMDEwOQ==",
lat: 60.20312,
lon: 24.9673
},
{
id: "U3RvcDpIU0w6MTIzMDExMw==",
lat: 60.20548,
lon: 24.97209
},
{
id: "U3RvcDpIU0w6MTIzMDEwNA==",
lat: 60.20827,
lon: 24.97504
}
]
},
{
gtfsId: "HSL:1051",
shortName: "51",
longName: "Hakaniemi-Malminkartano",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTExMTExOQ==",
lat: 60.178682,
lon: 24.952168
},
{
id: "U3RvcDpIU0w6MTExMTEzMQ==",
lat: 60.180568,
lon: 24.9498
},
{
id: "U3RvcDpIU0w6MTExMzEyMw==",
lat: 60.1837,
lon: 24.95316
},
{
id: "U3RvcDpIU0w6MTExMzEyNQ==",
lat: 60.18528,
lon: 24.95308
},
{
id: "U3RvcDpIU0w6MTEyMTExNw==",
lat: 60.18703,
lon: 24.94856
},
{
id: "U3RvcDpIU0w6MTIyMDEzMA==",
lat: 60.19114,
lon: 24.95004
},
{
id: "U3RvcDpIU0w6MTIyMDEwMQ==",
lat: 60.19302,
lon: 24.95382
},
{
id: "U3RvcDpIU0w6MTIyMDE4MQ==",
lat: 60.19565,
lon: 24.95499
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDE1Mw==",
lat: 60.22125,
lon: 24.94678
},
{
id: "U3RvcDpIU0w6MTI4MzEzMA==",
lat: 60.22153,
lon: 24.94149
},
{
id: "U3RvcDpIU0w6MTI4MzEzMg==",
lat: 60.22103,
lon: 24.93707
},
{
id: "U3RvcDpIU0w6MTI4NjE4MA==",
lat: 60.22089,
lon: 24.92812
},
{
id: "U3RvcDpIU0w6MTI5MzE2OA==",
lat: 60.22044,
lon: 24.90502
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzEyMw==",
lat: 60.22424,
lon: 24.89852
},
{
id: "U3RvcDpIU0w6MTI5MzEzMA==",
lat: 60.22566,
lon: 24.89553
},
{
id: "U3RvcDpIU0w6MTI5MzEzMg==",
lat: 60.22999,
lon: 24.895167
},
{
id: "U3RvcDpIU0w6MTI5MzEzNA==",
lat: 60.23137,
lon: 24.89199
},
{
id: "U3RvcDpIU0w6MTI5NDEzNw==",
lat: 60.23296,
lon: 24.88799
},
{
id: "U3RvcDpIU0w6MTI5NDE0MQ==",
lat: 60.230629,
lon: 24.881719
},
{
id: "U3RvcDpIU0w6MTI5NDE0Mg==",
lat: 60.22844,
lon: 24.87667
},
{
id: "U3RvcDpIU0w6MTQ2NTEzMQ==",
lat: 60.22716,
lon: 24.87217
},
{
id: "U3RvcDpIU0w6MTQ2NTEzMw==",
lat: 60.22509,
lon: 24.86806
},
{
id: "U3RvcDpIU0w6MTQ2NDEzNQ==",
lat: 60.22389,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzExNQ==",
lat: 60.22716,
lon: 24.85318
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MA==",
lat: 60.2288,
lon: 24.84913
},
{
id: "U3RvcDpIU0w6MTMyMDEwMQ==",
lat: 60.23253,
lon: 24.84661
},
{
id: "U3RvcDpIU0w6MTMyMDEwMw==",
lat: 60.23558,
lon: 24.84705
},
{
id: "U3RvcDpIU0w6MTMyMDEwNw==",
lat: 60.239,
lon: 24.84645
},
{
id: "U3RvcDpIU0w6MTMyMDEwOA==",
lat: 60.2415,
lon: 24.84299
},
{
id: "U3RvcDpIU0w6MTMyMDEyMw==",
lat: 60.24408,
lon: 24.8468
},
{
id: "U3RvcDpIU0w6MTMzMzEwMw==",
lat: 60.246561,
lon: 24.852388
},
{
id: "U3RvcDpIU0w6MTMzMzE4NA==",
lat: 60.248666,
lon: 24.854758
},
{
id: "U3RvcDpIU0w6MTMzMzE4MA==",
lat: 60.25018,
lon: 24.85415
},
{
id: "U3RvcDpIU0w6MTMzMzE4Mg==",
lat: 60.25104,
lon: 24.8489
},
{
id: "U3RvcDpIU0w6MTMzMzE4MQ==",
lat: 60.25016,
lon: 24.85356
},
{
id: "U3RvcDpIU0w6MTMzMzE4NQ==",
lat: 60.248694,
lon: 24.854632
},
{
id: "U3RvcDpIU0w6MTMzMzEwMg==",
lat: 60.246671,
lon: 24.852127
},
{
id: "U3RvcDpIU0w6MTMyMDExMQ==",
lat: 60.24432,
lon: 24.8467
},
{
id: "U3RvcDpIU0w6MTMyMDEwOQ==",
lat: 60.24161,
lon: 24.84268
},
{
id: "U3RvcDpIU0w6MTMyMDEwNQ==",
lat: 60.23761,
lon: 24.84672
},
{
id: "U3RvcDpIU0w6MTMyMDEwNA==",
lat: 60.23512,
lon: 24.84651
},
{
id: "U3RvcDpIU0w6MTMyMDEwMg==",
lat: 60.23233,
lon: 24.84636
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MQ==",
lat: 60.22888,
lon: 24.84861
},
{
id: "U3RvcDpIU0w6MTQ2MzExNg==",
lat: 60.22633,
lon: 24.85406
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTEzNg==",
lat: 60.22436,
lon: 24.8672
},
{
id: "U3RvcDpIU0w6MTQ2NTEzNA==",
lat: 60.2258,
lon: 24.8696
},
{
id: "U3RvcDpIU0w6MTI5NDEzMg==",
lat: 60.22769,
lon: 24.87405
},
{
id: "U3RvcDpIU0w6MTI5NDE0Mw==",
lat: 60.22838,
lon: 24.87708
},
{
id: "U3RvcDpIU0w6MTI5NDEzOQ==",
lat: 60.23079,
lon: 24.8821
},
{
id: "U3RvcDpIU0w6MTI5MzEzOA==",
lat: 60.23275,
lon: 24.88788
},
{
id: "U3RvcDpIU0w6MTI5MzEzNQ==",
lat: 60.23103,
lon: 24.89271
},
{
id: "U3RvcDpIU0w6MTI5MzEzMw==",
lat: 60.228672,
lon: 24.894933
},
{
id: "U3RvcDpIU0w6MTI5MzEzMQ==",
lat: 60.22554,
lon: 24.89532
},
{
id: "U3RvcDpIU0w6MTI5MzEyNA==",
lat: 60.22408,
lon: 24.89863
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MTE3Ng==",
lat: 60.22041,
lon: 24.90473
},
{
id: "U3RvcDpIU0w6MTI4NjE3OQ==",
lat: 60.2208,
lon: 24.92997
},
{
id: "U3RvcDpIU0w6MTI4MzEzMw==",
lat: 60.22099,
lon: 24.93806
},
{
id: "U3RvcDpIU0w6MTI4MzEzMQ==",
lat: 60.22105,
lon: 24.9431
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDE4MA==",
lat: 60.19381,
lon: 24.95531
},
{
id: "U3RvcDpIU0w6MTEyMTExMQ==",
lat: 60.18938,
lon: 24.948
},
{
id: "U3RvcDpIU0w6MTEyMTExOA==",
lat: 60.18747,
lon: 24.94834
},
{
id: "U3RvcDpIU0w6MTEyMTEyMA==",
lat: 60.18689,
lon: 24.95221
},
{
id: "U3RvcDpIU0w6MTExMzEyNg==",
lat: 60.18525,
lon: 24.953016
},
{
id: "U3RvcDpIU0w6MTExMzEyNA==",
lat: 60.18397,
lon: 24.95305
},
{
id: "U3RvcDpIU0w6MTExMjEyMg==",
lat: 60.181332,
lon: 24.950069
},
{
id: "U3RvcDpIU0w6MTExMTE1MA==",
lat: 60.178205,
lon: 24.951532
}
]
},
{
gtfsId: "HSL:9788KV",
shortName: "788KV",
longName: "Rautatientori-Kuninkaanmäki-Nikkilä-Hinthaara-Porvoo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIyNQ==",
lat: 60.27255,
lon: 25.09256
},
{
id: "U3RvcDpIU0w6NDkzMDIzMA==",
lat: 60.27502,
lon: 25.09521
},
{
id: "U3RvcDpIU0w6NDk0MDIyMg==",
lat: 60.28128,
lon: 25.102
},
{
id: "U3RvcDpIU0w6NDk2MDIxNA==",
lat: 60.2883,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6NDk2MDI5OA==",
lat: 60.293118,
lon: 25.099951
},
{
id: "U3RvcDpIU0w6NDk2MDIxNg==",
lat: 60.2979,
lon: 25.10244
},
{
id: "U3RvcDpIU0w6NDk3MDI5Nw==",
lat: 60.30293,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6NDk3MDI0NQ==",
lat: 60.304945,
lon: 25.106319
},
{
id: "U3RvcDpIU0w6NDk3MDI5OQ==",
lat: 60.30677,
lon: 25.109677
},
{
id: "U3RvcDpIU0w6NDk3MDIzNw==",
lat: 60.307303,
lon: 25.116067
},
{
id: "U3RvcDpIU0w6NDk3MDIxMQ==",
lat: 60.30996,
lon: 25.12301
},
{
id: "U3RvcDpIU0w6NDk3MDIxMw==",
lat: 60.31868,
lon: 25.12728
},
{
id: "U3RvcDpIU0w6OTIxNDIwOQ==",
lat: 60.324263,
lon: 25.137407
},
{
id: "U3RvcDpIU0w6OTIxNDIwNQ==",
lat: 60.329622,
lon: 25.13404
},
{
id: "U3RvcDpIU0w6NDg2MDIwMQ==",
lat: 60.336937,
lon: 25.131358
},
{
id: "U3RvcDpIU0w6NDg2MDIzNA==",
lat: 60.33946,
lon: 25.13387
},
{
id: "U3RvcDpIU0w6NDg2MDIzMg==",
lat: 60.34099,
lon: 25.14079
},
{
id: "U3RvcDpIU0w6NDg2MDIzMA==",
lat: 60.34199,
lon: 25.14701
},
{
id: "U3RvcDpIU0w6OTIxNDIyNg==",
lat: 60.342592,
lon: 25.152172
},
{
id: "U3RvcDpIU0w6OTIxNDIxNw==",
lat: 60.347115,
lon: 25.152818
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMzIwNw==",
lat: 60.37368,
lon: 25.286597
},
{
id: "U3RvcDpIU0w6OTIyMzIxMA==",
lat: 60.372358,
lon: 25.29282
},
{
id: "U3RvcDpIU0w6OTIyODIwMg==",
lat: 60.370258,
lon: 25.2979
},
{
id: "U3RvcDpIU0w6OTIyODIwNQ==",
lat: 60.36726,
lon: 25.301515
},
{
id: "U3RvcDpIU0w6OTIyMTIwMw==",
lat: 60.367635,
lon: 25.306268
},
{
id: "U3RvcDpIU0w6OTIyMTIwNA==",
lat: 60.368627,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyMTIwNQ==",
lat: 60.370042,
lon: 25.329923
},
{
id: "U3RvcDpIU0w6OTIyMTIwNw==",
lat: 60.37197,
lon: 25.33759
},
{
id: "U3RvcDpIU0w6OTIyMTIwOA==",
lat: 60.374532,
lon: 25.343738
},
{
id: "U3RvcDpIU0w6OTIyMTIwOQ==",
lat: 60.375335,
lon: 25.35389
},
{
id: "U3RvcDpIU0w6OTMwMDI0MA==",
lat: 60.380053,
lon: 25.383648
},
{
id: "U3RvcDpIU0w6OTMwMDI0Mg==",
lat: 60.382138,
lon: 25.395569
},
{
id: "U3RvcDpIU0w6OTMwMDI0NA==",
lat: 60.382916,
lon: 25.399536
},
{
id: "U3RvcDpIU0w6OTMwMDI0Ng==",
lat: 60.386293,
lon: 25.409743
},
{
id: "U3RvcDpIU0w6OTMwMDI0OA==",
lat: 60.391155,
lon: 25.420482
},
{
id: "U3RvcDpIU0w6OTMwMDI1MA==",
lat: 60.393861,
lon: 25.429046
},
{
id: "U3RvcDpIU0w6OTMwMDI1Mg==",
lat: 60.395092,
lon: 25.435522
},
{
id: "U3RvcDpIU0w6OTMwMDI1NA==",
lat: 60.394829,
lon: 25.450753
},
{
id: "U3RvcDpIU0w6OTMwMDI1Ng==",
lat: 60.395981,
lon: 25.460147
},
{
id: "U3RvcDpIU0w6OTMwMDI1OA==",
lat: 60.397453,
lon: 25.473666
},
{
id: "U3RvcDpIU0w6OTMwMDIwMg==",
lat: 60.39983,
lon: 25.480889
},
{
id: "U3RvcDpIU0w6OTMwMDIwNg==",
lat: 60.399468,
lon: 25.490812
},
{
id: "U3RvcDpIU0w6OTMwMDIwOA==",
lat: 60.397968,
lon: 25.504043
},
{
id: "U3RvcDpIU0w6OTMwMDIxMA==",
lat: 60.396853,
lon: 25.518776
},
{
id: "U3RvcDpIU0w6OTMwMDIxMg==",
lat: 60.393409,
lon: 25.533706
},
{
id: "U3RvcDpIU0w6OTMwMDIxNA==",
lat: 60.391172,
lon: 25.541072
},
{
id: "U3RvcDpIU0w6OTMwMDIxNg==",
lat: 60.388057,
lon: 25.546898
},
{
id: "U3RvcDpIU0w6OTMwMDIxOA==",
lat: 60.38933,
lon: 25.559936
},
{
id: "U3RvcDpIU0w6OTMwMDIyMA==",
lat: 60.387681,
lon: 25.570238
},
{
id: "U3RvcDpIU0w6OTMwMDIyMg==",
lat: 60.390226,
lon: 25.579652
},
{
id: "U3RvcDpIU0w6OTMwMDIyNA==",
lat: 60.39098,
lon: 25.592476
},
{
id: "U3RvcDpIU0w6OTMwMDIyNg==",
lat: 60.39204,
lon: 25.606718
},
{
id: "U3RvcDpIU0w6OTMwMDIyOA==",
lat: 60.392303,
lon: 25.609147
},
{
id: "U3RvcDpIU0w6OTMwMDIzMA==",
lat: 60.390359,
lon: 25.617548
},
{
id: "U3RvcDpIU0w6OTMwMDIzMg==",
lat: 60.390138,
lon: 25.625004
},
{
id: "U3RvcDpIU0w6OTMwMDIzNg==",
lat: 60.39104,
lon: 25.647726
},
{
id: "U3RvcDpIU0w6OTMwMDIzOA==",
lat: 60.393042,
lon: 25.655838
},
{
id: "U3RvcDpIU0w6OTMwMDIwMQ==",
lat: 60.392996,
lon: 25.663648
},
{
id: "U3RvcDpIU0w6NDk3MDIxNw==",
lat: 60.30573,
lon: 25.10498
},
{
id: "U3RvcDpIU0w6NDk3MDIxOQ==",
lat: 60.31407,
lon: 25.10985
},
{
id: "U3RvcDpIU0w6NDk3MDIyMQ==",
lat: 60.31937,
lon: 25.11534
},
{
id: "U3RvcDpIU0w6NDk3MDIxNQ==",
lat: 60.32003,
lon: 25.12451
}
]
},
{
gtfsId: "HSL:1050",
shortName: "50",
longName: "Sompasaari-Kalasatama(M)-Pasila-Ilmala-Maunula",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTEwMDEzMA==",
lat: 60.184567,
lon: 24.974413
},
{
id: "U3RvcDpIU0w6MTEwMDEyOA==",
lat: 60.184007,
lon: 24.980304
},
{
id: "U3RvcDpIU0w6MTEwMDEzMQ==",
lat: 60.187162,
lon: 24.977327
},
{
id: "U3RvcDpIU0w6MTEwMDExOQ==",
lat: 60.189218,
lon: 24.971152
},
{
id: "U3RvcDpIU0w6MTIyMDExOQ==",
lat: 60.18964,
lon: 24.96309
},
{
id: "U3RvcDpIU0w6MTIyMDExMg==",
lat: 60.19091,
lon: 24.95609
},
{
id: "U3RvcDpIU0w6MTIyMDEzNA==",
lat: 60.19321,
lon: 24.95005
},
{
id: "U3RvcDpIU0w6MTIyMDExNA==",
lat: 60.194732,
lon: 24.946392
},
{
id: "U3RvcDpIU0w6MTE3MzExMw==",
lat: 60.19669,
lon: 24.941768
},
{
id: "U3RvcDpIU0w6MTE3MzEyMw==",
lat: 60.198626,
lon: 24.937843
},
{
id: "U3RvcDpIU0w6MTE3MTE1NA==",
lat: 60.200915,
lon: 24.926832
},
{
id: "U3RvcDpIU0w6MTE3MTEzMA==",
lat: 60.20279,
lon: 24.92483
},
{
id: "U3RvcDpIU0w6MTE3MTEyNA==",
lat: 60.20241,
lon: 24.92193
},
{
id: "U3RvcDpIU0w6MTE3MTEyNg==",
lat: 60.203862,
lon: 24.918633
},
{
id: "U3RvcDpIU0w6MTE3MTE4MA==",
lat: 60.206258,
lon: 24.917854
},
{
id: "U3RvcDpIU0w6MTE3MTEwNQ==",
lat: 60.20793,
lon: 24.91536
},
{
id: "U3RvcDpIU0w6MTE3NDEwMQ==",
lat: 60.208023,
lon: 24.921068
},
{
id: "U3RvcDpIU0w6MTE3MjExNA==",
lat: 60.21037,
lon: 24.91711
},
{
id: "U3RvcDpIU0w6MTE3MjE0Mw==",
lat: 60.21345,
lon: 24.91755
},
{
id: "U3RvcDpIU0w6MTE3MjE0NQ==",
lat: 60.21683,
lon: 24.91878
},
{
id: "U3RvcDpIU0w6MTI4NjE2MQ==",
lat: 60.21881,
lon: 24.92311
},
{
id: "U3RvcDpIU0w6MTI4NjE3OQ==",
lat: 60.2208,
lon: 24.92997
},
{
id: "U3RvcDpIU0w6MTI4NjEzNA==",
lat: 60.223362,
lon: 24.933546
},
{
id: "U3RvcDpIU0w6MTI4MjEzNg==",
lat: 60.22544,
lon: 24.93073
},
{
id: "U3RvcDpIU0w6MTI4MjE0Mg==",
lat: 60.22827,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTI4MjE0Ng==",
lat: 60.23062,
lon: 24.93342
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MjE0OQ==",
lat: 60.234439,
lon: 24.934112
},
{
id: "U3RvcDpIU0w6MTI4MjEwNg==",
lat: 60.23351,
lon: 24.93171
},
{
id: "U3RvcDpIU0w6MTI4MjEwNA==",
lat: 60.23154,
lon: 24.93381
},
{
id: "U3RvcDpIU0w6MTI4MjE0Nw==",
lat: 60.230679,
lon: 24.932013
},
{
id: "U3RvcDpIU0w6MTI4MjE0NQ==",
lat: 60.228725,
lon: 24.927237
},
{
id: "U3RvcDpIU0w6MTI4MjEzOQ==",
lat: 60.227679,
lon: 24.926687
},
{
id: "U3RvcDpIU0w6MTI4MjEzNw==",
lat: 60.22526,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTI4NjEzNQ==",
lat: 60.2216,
lon: 24.9333
},
{
id: "U3RvcDpIU0w6MTI4NjE4MA==",
lat: 60.22089,
lon: 24.92812
},
{
id: "U3RvcDpIU0w6MTI4NjE2MA==",
lat: 60.2187,
lon: 24.92282
},
{
id: "U3RvcDpIU0w6MTE3MjE0Ng==",
lat: 60.21642,
lon: 24.91783
},
{
id: "U3RvcDpIU0w6MTE3MjE0NA==",
lat: 60.21287,
lon: 24.91677
},
{
id: "U3RvcDpIU0w6MTE3MjE0Mg==",
lat: 60.21009,
lon: 24.91752
},
{
id: "U3RvcDpIU0w6MTE3NDEwMg==",
lat: 60.20796,
lon: 24.92078
},
{
id: "U3RvcDpIU0w6MTE3MTEwNA==",
lat: 60.20791,
lon: 24.91521
},
{
id: "U3RvcDpIU0w6MTE3MTEyMQ==",
lat: 60.205915,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE3MTEyNw==",
lat: 60.20309,
lon: 24.91942
},
{
id: "U3RvcDpIU0w6MTE3MTEyNQ==",
lat: 60.20226,
lon: 24.92151
},
{
id: "U3RvcDpIU0w6MTE3MTEzMQ==",
lat: 60.20267,
lon: 24.92511
},
{
id: "U3RvcDpIU0w6MTE3MTE1OA==",
lat: 60.20111,
lon: 24.92664
},
{
id: "U3RvcDpIU0w6MTE3MzEwNA==",
lat: 60.1983,
lon: 24.937373
},
{
id: "U3RvcDpIU0w6MTIyMDEzMQ==",
lat: 60.196616,
lon: 24.94209
},
{
id: "U3RvcDpIU0w6MTIyMDExNw==",
lat: 60.19528,
lon: 24.94443
},
{
id: "U3RvcDpIU0w6MTIyMDExNQ==",
lat: 60.19326,
lon: 24.94925
},
{
id: "U3RvcDpIU0w6MTIyMDExMw==",
lat: 60.19119,
lon: 24.95434
},
{
id: "U3RvcDpIU0w6MTIyMDEyMA==",
lat: 60.189463,
lon: 24.962315
},
{
id: "U3RvcDpIU0w6MTEwMDEyMA==",
lat: 60.18906,
lon: 24.97123
},
{
id: "U3RvcDpIU0w6MTEwMDEzMg==",
lat: 60.186708,
lon: 24.976782
}
]
},
{
gtfsId: "HSL:2138",
shortName: "138",
longName: "Matinkylä (M)-Nuottaniemi-Matinkallio",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxMA==",
lat: 60.160267,
lon: 24.739005
},
{
id: "U3RvcDpIU0w6MjMxNDIyNA==",
lat: 60.15827,
lon: 24.73214
},
{
id: "U3RvcDpIU0w6MjMxNDIyMQ==",
lat: 60.15638,
lon: 24.72662
},
{
id: "U3RvcDpIU0w6MjMxMjIxOQ==",
lat: 60.15334,
lon: 24.72924
},
{
id: "U3RvcDpIU0w6MjMxMjIxNw==",
lat: 60.15029,
lon: 24.73707
},
{
id: "U3RvcDpIU0w6MjMxNTIxNQ==",
lat: 60.14763,
lon: 24.74306
},
{
id: "U3RvcDpIU0w6MjMxMTIxMw==",
lat: 60.14925,
lon: 24.74849
},
{
id: "U3RvcDpIU0w6MjMxMzIxMQ==",
lat: 60.15182,
lon: 24.74997
},
{
id: "U3RvcDpIU0w6MjMxMTIwOQ==",
lat: 60.15387,
lon: 24.74657
},
{
id: "U3RvcDpIU0w6MjMxMzIwNw==",
lat: 60.155445,
lon: 24.750767
},
{
id: "U3RvcDpIU0w6MjMxMzIwOQ==",
lat: 60.156218,
lon: 24.752724
},
{
id: "U3RvcDpIU0w6MjMxMzIxMw==",
lat: 60.158843,
lon: 24.750541
},
{
id: "U3RvcDpIU0w6MjMxNDIyOQ==",
lat: 60.162888,
lon: 24.748175
},
{
id: "U3RvcDpIU0w6MjMxNDIzMQ==",
lat: 60.163486,
lon: 24.746254
},
{
id: "U3RvcDpIU0w6MjMxNDIzMA==",
lat: 60.162888,
lon: 24.748175
},
{
id: "U3RvcDpIU0w6MjMxMzIxNA==",
lat: 60.15887,
lon: 24.750362
},
{
id: "U3RvcDpIU0w6MjMxMzIxMg==",
lat: 60.156512,
lon: 24.752364
},
{
id: "U3RvcDpIU0w6MjMxMzIwOA==",
lat: 60.155515,
lon: 24.750743
},
{
id: "U3RvcDpIU0w6MjMxMTIwOA==",
lat: 60.15312,
lon: 24.74728
},
{
id: "U3RvcDpIU0w6MjMxMzIxMA==",
lat: 60.15149,
lon: 24.75032
},
{
id: "U3RvcDpIU0w6MjMxMTIxMg==",
lat: 60.14926,
lon: 24.74822
},
{
id: "U3RvcDpIU0w6MjMxMTIxNA==",
lat: 60.14808,
lon: 24.74123
},
{
id: "U3RvcDpIU0w6MjMxMjIxNg==",
lat: 60.15117,
lon: 24.73608
},
{
id: "U3RvcDpIU0w6MjMxMjIxOA==",
lat: 60.15421,
lon: 24.72872
},
{
id: "U3RvcDpIU0w6MjMxNDIyNg==",
lat: 60.15706,
lon: 24.72747
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:2137",
shortName: "137",
longName: "Matinkylä (M)-Matinkallio-Piispankylä-Kuitinmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMyMzIwNA==",
lat: 60.170802,
lon: 24.726667
},
{
id: "U3RvcDpIU0w6MjMyMTIwNA==",
lat: 60.171902,
lon: 24.722296
},
{
id: "U3RvcDpIU0w6MjMyMTIxNQ==",
lat: 60.17308,
lon: 24.72252
},
{
id: "U3RvcDpIU0w6MjMyMzIwMw==",
lat: 60.174326,
lon: 24.723612
},
{
id: "U3RvcDpIU0w6MjMyMTIxNg==",
lat: 60.1729,
lon: 24.72234
},
{
id: "U3RvcDpIU0w6MjMyMzI0Nw==",
lat: 60.17271,
lon: 24.72739
},
{
id: "U3RvcDpIU0w6MjMyMzIwMg==",
lat: 60.175753,
lon: 24.725498
},
{
id: "U3RvcDpIU0w6MjMyMjIzOA==",
lat: 60.17468,
lon: 24.73368
},
{
id: "U3RvcDpIU0w6MjMyMjIzNg==",
lat: 60.17473,
lon: 24.7386
},
{
id: "U3RvcDpIU0w6MjMyMjIzMg==",
lat: 60.17495,
lon: 24.74337
},
{
id: "U3RvcDpIU0w6MjMyMjIwOQ==",
lat: 60.174648,
lon: 24.753351
},
{
id: "U3RvcDpIU0w6MjMyMjIwMw==",
lat: 60.173789,
lon: 24.747468
},
{
id: "U3RvcDpIU0w6MjMyMjIzMQ==",
lat: 60.17256,
lon: 24.74548
},
{
id: "U3RvcDpIU0w6MjMyMjIwNQ==",
lat: 60.167702,
lon: 24.741443
},
{
id: "U3RvcDpIU0w6MjMyMzIwNw==",
lat: 60.16695,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjMyMzIwMQ==",
lat: 60.166976,
lon: 24.7343
},
{
id: "U3RvcDpIU0w6MjMyMjIxMQ==",
lat: 60.16456,
lon: 24.73676
},
{
id: "U3RvcDpIU0w6MjMxMTIxMQ==",
lat: 60.16246,
lon: 24.73833
},
{
id: "U3RvcDpIU0w6MjMxMzIwNg==",
lat: 60.161752,
lon: 24.740728
},
{
id: "U3RvcDpIU0w6MjMxMzIwMg==",
lat: 60.16181,
lon: 24.74771
},
{
id: "U3RvcDpIU0w6MjMxNDIyOQ==",
lat: 60.162888,
lon: 24.748175
},
{
id: "U3RvcDpIU0w6MjMxNDIzMQ==",
lat: 60.163486,
lon: 24.746254
},
{
id: "U3RvcDpIU0w6MjMxNDIzMA==",
lat: 60.162888,
lon: 24.748175
},
{
id: "U3RvcDpIU0w6MjMxMzIwMQ==",
lat: 60.16176,
lon: 24.74732
},
{
id: "U3RvcDpIU0w6MjMxMzIwNQ==",
lat: 60.161989,
lon: 24.740844
},
{
id: "U3RvcDpIU0w6MjMxMTIwMQ==",
lat: 60.160644,
lon: 24.740316
},
{
id: "U3RvcDpIU0w6MjMxMzIwNA==",
lat: 60.15965,
lon: 24.74802
},
{
id: "U3RvcDpIU0w6MjMxMzIxNQ==",
lat: 60.160002,
lon: 24.748796
},
{
id: "U3RvcDpIU0w6MjMxMzIxNA==",
lat: 60.15887,
lon: 24.750362
},
{
id: "U3RvcDpIU0w6MjMxMzIxMg==",
lat: 60.156512,
lon: 24.752364
},
{
id: "U3RvcDpIU0w6MjMxMzIwOA==",
lat: 60.155515,
lon: 24.750743
},
{
id: "U3RvcDpIU0w6MjMxMTIxOA==",
lat: 60.15392,
lon: 24.740226
},
{
id: "U3RvcDpIU0w6MjMxMTIxNw==",
lat: 60.155304,
lon: 24.740507
},
{
id: "U3RvcDpIU0w6MjMxMjIwNg==",
lat: 60.15425,
lon: 24.73606
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxMA==",
lat: 60.160267,
lon: 24.739005
},
{
id: "U3RvcDpIU0w6MjMxMjIwMw==",
lat: 60.157065,
lon: 24.737421
},
{
id: "U3RvcDpIU0w6MjMxMjIwNQ==",
lat: 60.153906,
lon: 24.740077
},
{
id: "U3RvcDpIU0w6MjMxMTIwOQ==",
lat: 60.15387,
lon: 24.74657
},
{
id: "U3RvcDpIU0w6MjMxMzIwNw==",
lat: 60.155445,
lon: 24.750767
},
{
id: "U3RvcDpIU0w6MjMxMzIwOQ==",
lat: 60.156218,
lon: 24.752724
},
{
id: "U3RvcDpIU0w6MjMxMzIxMw==",
lat: 60.158843,
lon: 24.750541
},
{
id: "U3RvcDpIU0w6MjMxMzIwMw==",
lat: 60.15936,
lon: 24.74635
},
{
id: "U3RvcDpIU0w6MjMxNDIwOA==",
lat: 60.161049,
lon: 24.740512
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjMyMjIxMg==",
lat: 60.164558,
lon: 24.737052
},
{
id: "U3RvcDpIU0w6MjMyMzIwOQ==",
lat: 60.16666,
lon: 24.73958
},
{
id: "U3RvcDpIU0w6MjMyMjIwNg==",
lat: 60.168597,
lon: 24.743873
},
{
id: "U3RvcDpIU0w6MjMyMjIzMA==",
lat: 60.17259,
lon: 24.74576
},
{
id: "U3RvcDpIU0w6MjMyMjIzNA==",
lat: 60.17516,
lon: 24.7422
},
{
id: "U3RvcDpIU0w6MjMyMjIzNQ==",
lat: 60.17491,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjMyMjIzNw==",
lat: 60.17479,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjMyMzI0MA==",
lat: 60.17256,
lon: 24.72448
}
]
},
{
gtfsId: "HSL:2136",
shortName: "136",
longName: "Matinkylä(M)-Espoon keskus-Suna-Tuomarila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMjIyNQ==",
lat: 60.201429,
lon: 24.692241
},
{
id: "U3RvcDpIU0w6MjYxMjIyMg==",
lat: 60.20016,
lon: 24.68547
},
{
id: "U3RvcDpIU0w6MjYxMzIyMQ==",
lat: 60.19748,
lon: 24.68729
},
{
id: "U3RvcDpIU0w6MjYxNDI0Ng==",
lat: 60.19475,
lon: 24.68208
},
{
id: "U3RvcDpIU0w6MjYxMzI0NA==",
lat: 60.1943,
lon: 24.67779
},
{
id: "U3RvcDpIU0w6MjYxMzI0Mg==",
lat: 60.19624,
lon: 24.67178
},
{
id: "U3RvcDpIU0w6MjYxMzAwMw==",
lat: 60.19794,
lon: 24.66945
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxNTIzMw==",
lat: 60.2023,
lon: 24.65257
},
{
id: "U3RvcDpIU0w6MjYxMTIzNQ==",
lat: 60.19896,
lon: 24.6548
},
{
id: "U3RvcDpIU0w6MjYxNTIzOQ==",
lat: 60.1952,
lon: 24.66358
},
{
id: "U3RvcDpIU0w6MjYxNTIxNg==",
lat: 60.18792,
lon: 24.66694
},
{
id: "U3RvcDpIU0w6MjQzMTIxNA==",
lat: 60.18073,
lon: 24.67139
},
{
id: "U3RvcDpIU0w6MjQzMzIxMg==",
lat: 60.17993,
lon: 24.67732
},
{
id: "U3RvcDpIU0w6MjQzMzIxMA==",
lat: 60.17515,
lon: 24.68784
},
{
id: "U3RvcDpIU0w6MjQzMjIzMg==",
lat: 60.17263,
lon: 24.68894
},
{
id: "U3RvcDpIU0w6MjQzMjIwNw==",
lat: 60.16914,
lon: 24.69489
},
{
id: "U3RvcDpIU0w6MjQzMjIwNQ==",
lat: 60.164145,
lon: 24.702844
},
{
id: "U3RvcDpIU0w6MjQzMjIwMw==",
lat: 60.16115,
lon: 24.70423
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMg==",
lat: 60.159978,
lon: 24.708063
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxMg==",
lat: 60.160249,
lon: 24.738933
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMg==",
lat: 60.163276,
lon: 24.703633
},
{
id: "U3RvcDpIU0w6MjQzMjIwNA==",
lat: 60.16535,
lon: 24.70225
},
{
id: "U3RvcDpIU0w6MjQzMjIwNg==",
lat: 60.16994,
lon: 24.69269
},
{
id: "U3RvcDpIU0w6MjQzMjI2Mg==",
lat: 60.1735,
lon: 24.68914
},
{
id: "U3RvcDpIU0w6MjQzMzIwOQ==",
lat: 60.17571,
lon: 24.6874
},
{
id: "U3RvcDpIU0w6MjQzMzIxMQ==",
lat: 60.18002,
lon: 24.67472
},
{
id: "U3RvcDpIU0w6MjQzMTIxMw==",
lat: 60.18185,
lon: 24.67064
},
{
id: "U3RvcDpIU0w6MjYxNTIxNQ==",
lat: 60.18836,
lon: 24.6668
},
{
id: "U3RvcDpIU0w6MjYxNTIzNg==",
lat: 60.19542,
lon: 24.66347
},
{
id: "U3RvcDpIU0w6MjYxMTIzNA==",
lat: 60.19898,
lon: 24.65519
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMzAwOA==",
lat: 60.202736,
lon: 24.661962
},
{
id: "U3RvcDpIU0w6MjYxMzAwNw==",
lat: 60.19963,
lon: 24.66454
},
{
id: "U3RvcDpIU0w6MjYxMzAwNA==",
lat: 60.19773,
lon: 24.66941
},
{
id: "U3RvcDpIU0w6MjYxMzI0Mw==",
lat: 60.19576,
lon: 24.67267
},
{
id: "U3RvcDpIU0w6MjYxNDI0NQ==",
lat: 60.19405,
lon: 24.67816
},
{
id: "U3RvcDpIU0w6MjYxNDIzNw==",
lat: 60.19468,
lon: 24.68226
},
{
id: "U3RvcDpIU0w6MjYxMjIwMQ==",
lat: 60.197577,
lon: 24.687232
},
{
id: "U3RvcDpIU0w6MjYxMjIyMQ==",
lat: 60.20047,
lon: 24.68762
},
{
id: "U3RvcDpIU0w6MjYxMjIyMw==",
lat: 60.201411,
lon: 24.695023
}
]
},
{
gtfsId: "HSL:2134",
shortName: "134",
longName: "Matinkylä(M)-Espoon keskus-Suvela-Tuomarila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxMQ==",
lat: 60.160258,
lon: 24.738969
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMg==",
lat: 60.163276,
lon: 24.703633
},
{
id: "U3RvcDpIU0w6MjQzMjIwNA==",
lat: 60.16535,
lon: 24.70225
},
{
id: "U3RvcDpIU0w6MjQzMjIwNg==",
lat: 60.16994,
lon: 24.69269
},
{
id: "U3RvcDpIU0w6MjQzMjI2Mg==",
lat: 60.1735,
lon: 24.68914
},
{
id: "U3RvcDpIU0w6MjQzMzIwOQ==",
lat: 60.17571,
lon: 24.6874
},
{
id: "U3RvcDpIU0w6MjQzMzIxMQ==",
lat: 60.18002,
lon: 24.67472
},
{
id: "U3RvcDpIU0w6MjQzMTIxMw==",
lat: 60.18185,
lon: 24.67064
},
{
id: "U3RvcDpIU0w6MjYxNTIxNQ==",
lat: 60.18836,
lon: 24.6668
},
{
id: "U3RvcDpIU0w6MjYxNTIzNg==",
lat: 60.19542,
lon: 24.66347
},
{
id: "U3RvcDpIU0w6MjYxMTIzNA==",
lat: 60.19898,
lon: 24.65519
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMzAwOA==",
lat: 60.202736,
lon: 24.661962
},
{
id: "U3RvcDpIU0w6MjYxMzAwMQ==",
lat: 60.20123,
lon: 24.6671
},
{
id: "U3RvcDpIU0w6MjYxMzIxNg==",
lat: 60.2028,
lon: 24.67021
},
{
id: "U3RvcDpIU0w6MjYxMzIxOA==",
lat: 60.20462,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjYxMjIxOQ==",
lat: 60.20332,
lon: 24.68024
},
{
id: "U3RvcDpIU0w6MjYxMjIyNg==",
lat: 60.199976,
lon: 24.683783
},
{
id: "U3RvcDpIU0w6MjYxMjIyMQ==",
lat: 60.20047,
lon: 24.68762
},
{
id: "U3RvcDpIU0w6MjYxMjIyMw==",
lat: 60.201411,
lon: 24.695023
},
{
id: "U3RvcDpIU0w6MjYxMjIyNQ==",
lat: 60.201429,
lon: 24.692241
},
{
id: "U3RvcDpIU0w6MjYxMjIyMg==",
lat: 60.20016,
lon: 24.68547
},
{
id: "U3RvcDpIU0w6MjYxMjIyMA==",
lat: 60.20329,
lon: 24.68038
},
{
id: "U3RvcDpIU0w6MjYxMzIxNw==",
lat: 60.20508,
lon: 24.67367
},
{
id: "U3RvcDpIU0w6MjYxMzIxNQ==",
lat: 60.20246,
lon: 24.66925
},
{
id: "U3RvcDpIU0w6MjYxMzAwMA==",
lat: 60.201,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxNTIzMw==",
lat: 60.2023,
lon: 24.65257
},
{
id: "U3RvcDpIU0w6MjYxMTIzNQ==",
lat: 60.19896,
lon: 24.6548
},
{
id: "U3RvcDpIU0w6MjYxNTIzOQ==",
lat: 60.1952,
lon: 24.66358
},
{
id: "U3RvcDpIU0w6MjYxNTIxNg==",
lat: 60.18792,
lon: 24.66694
},
{
id: "U3RvcDpIU0w6MjQzMTIxNA==",
lat: 60.18073,
lon: 24.67139
},
{
id: "U3RvcDpIU0w6MjQzMzIxMg==",
lat: 60.17993,
lon: 24.67732
},
{
id: "U3RvcDpIU0w6MjQzMzIxMA==",
lat: 60.17515,
lon: 24.68784
},
{
id: "U3RvcDpIU0w6MjQzMjIzMg==",
lat: 60.17263,
lon: 24.68894
},
{
id: "U3RvcDpIU0w6MjQzMjIwNw==",
lat: 60.16914,
lon: 24.69489
},
{
id: "U3RvcDpIU0w6MjQzMjIwNQ==",
lat: 60.164145,
lon: 24.702844
},
{
id: "U3RvcDpIU0w6MjQzMjIwMw==",
lat: 60.16115,
lon: 24.70423
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMg==",
lat: 60.159978,
lon: 24.708063
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:4433",
shortName: "433",
longName: "Martinlaakso-Kivistö",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE3MDI0OA==",
lat: 60.27723,
lon: 24.85379
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIzOQ==",
lat: 60.28544,
lon: 24.85111
},
{
id: "U3RvcDpIU0w6NDE3MDI4Nw==",
lat: 60.290477,
lon: 24.844042
},
{
id: "U3RvcDpIU0w6NDI1MDIxMw==",
lat: 60.295045,
lon: 24.845304
},
{
id: "U3RvcDpIU0w6NDI1MDIxNQ==",
lat: 60.294941,
lon: 24.850681
},
{
id: "U3RvcDpIU0w6NDIxMDIwNQ==",
lat: 60.29993,
lon: 24.85925
},
{
id: "U3RvcDpIU0w6NDIxMDI5OQ==",
lat: 60.30173,
lon: 24.8569
},
{
id: "U3RvcDpIU0w6NDIxMDI5Nw==",
lat: 60.30152,
lon: 24.85215
},
{
id: "U3RvcDpIU0w6NDIxMDIyNQ==",
lat: 60.30162,
lon: 24.84876
},
{
id: "U3RvcDpIU0w6NDIxMDIzNw==",
lat: 60.308071,
lon: 24.851351
},
{
id: "U3RvcDpIU0w6NDIxMDIzMw==",
lat: 60.31361,
lon: 24.85587
},
{
id: "U3RvcDpIU0w6NDI0MDIwMQ==",
lat: 60.319222,
lon: 24.869969
},
{
id: "U3RvcDpIU0w6NDI0MDIwMw==",
lat: 60.32273,
lon: 24.86908
},
{
id: "U3RvcDpIU0w6NDI0MDIwNQ==",
lat: 60.32608,
lon: 24.86706
},
{
id: "U3RvcDpIU0w6NDIzMDIzMg==",
lat: 60.32947,
lon: 24.8619
},
{
id: "U3RvcDpIU0w6NDIzMDIzMA==",
lat: 60.32875,
lon: 24.85569
},
{
id: "U3RvcDpIU0w6NDIzMDIyNg==",
lat: 60.32921,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDIzMDIyNA==",
lat: 60.32753,
lon: 24.85013
},
{
id: "U3RvcDpIU0w6NDIzMDIyMg==",
lat: 60.32522,
lon: 24.84962
},
{
id: "U3RvcDpIU0w6NDIzMDIyOA==",
lat: 60.3233,
lon: 24.84578
},
{
id: "U3RvcDpIU0w6NDIzMDIwOQ==",
lat: 60.32227,
lon: 24.8409
},
{
id: "U3RvcDpIU0w6NDIzMDIwNw==",
lat: 60.3205,
lon: 24.84192
},
{
id: "U3RvcDpIU0w6NDIzMDIwNQ==",
lat: 60.31832,
lon: 24.84409
},
{
id: "U3RvcDpIU0w6NDIzMDIwMw==",
lat: 60.316588,
lon: 24.847408
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0Nw==",
lat: 60.314485,
lon: 24.845366
},
{
id: "U3RvcDpIU0w6NDIzMDIwMg==",
lat: 60.317449,
lon: 24.846159
},
{
id: "U3RvcDpIU0w6NDIzMDIwNA==",
lat: 60.3189,
lon: 24.84368
},
{
id: "U3RvcDpIU0w6NDIzMDIwNg==",
lat: 60.32009,
lon: 24.84231
},
{
id: "U3RvcDpIU0w6NDIzMDIyNw==",
lat: 60.32297,
lon: 24.84473
},
{
id: "U3RvcDpIU0w6NDIzMDIyMQ==",
lat: 60.32615,
lon: 24.8498
},
{
id: "U3RvcDpIU0w6NDIzMDIyMw==",
lat: 60.32798,
lon: 24.85087
},
{
id: "U3RvcDpIU0w6NDIzMDIyOQ==",
lat: 60.32945,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDIzMDIzMQ==",
lat: 60.3282,
lon: 24.85841
},
{
id: "U3RvcDpIU0w6NDI0MDIwNg==",
lat: 60.32723,
lon: 24.86575
},
{
id: "U3RvcDpIU0w6NDI0MDIyMA==",
lat: 60.32498,
lon: 24.86777
},
{
id: "U3RvcDpIU0w6NDI0MDIwNA==",
lat: 60.32204,
lon: 24.86887
},
{
id: "U3RvcDpIU0w6NDI0MDIyNw==",
lat: 60.31905,
lon: 24.8698
},
{
id: "U3RvcDpIU0w6NDIxMDI0NQ==",
lat: 60.316659,
lon: 24.867147
},
{
id: "U3RvcDpIU0w6NDIxMDIzNg==",
lat: 60.307648,
lon: 24.850909
},
{
id: "U3RvcDpIU0w6NDIxMDIyNg==",
lat: 60.30299,
lon: 24.84741
},
{
id: "U3RvcDpIU0w6NDIxMDI5OA==",
lat: 60.30157,
lon: 24.8534
},
{
id: "U3RvcDpIU0w6NDIxMDIxNQ==",
lat: 60.30119,
lon: 24.85722
},
{
id: "U3RvcDpIU0w6NDIxMDIwNg==",
lat: 60.29954,
lon: 24.85863
},
{
id: "U3RvcDpIU0w6NDI1MDIxNA==",
lat: 60.295186,
lon: 24.850523
},
{
id: "U3RvcDpIU0w6NDI1MDIxMg==",
lat: 60.295095,
lon: 24.844916
},
{
id: "U3RvcDpIU0w6NDE3MDI4Ng==",
lat: 60.289436,
lon: 24.845115
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxMQ==",
lat: 60.2773,
lon: 24.85304
}
]
},
{
gtfsId: "HSL:4434",
shortName: "434",
longName: "Kivistö-Keimola",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIyMDIzMQ==",
lat: 60.32121,
lon: 24.829201
},
{
id: "U3RvcDpIU0w6NDIyMDIzMA==",
lat: 60.318403,
lon: 24.831006
},
{
id: "U3RvcDpIU0w6NDIyMDIxMA==",
lat: 60.316158,
lon: 24.833969
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIyMDIxMQ==",
lat: 60.316315,
lon: 24.833724
},
{
id: "U3RvcDpIU0w6NDIyMDIwOA==",
lat: 60.319001,
lon: 24.829774
}
]
},
{
gtfsId: "HSL:4555",
shortName: "555",
longName: "Keilaniemi (M)-Martinlaakso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE3MDIxNQ==",
lat: 60.2772,
lon: 24.85298
},
{
id: "U3RvcDpIU0w6NDE3MDI5OQ==",
lat: 60.2753,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDE1MDI1OQ==",
lat: 60.27046,
lon: 24.854602
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDI2NA==",
lat: 60.260577,
lon: 24.856522
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIxMA==",
lat: 60.25875,
lon: 24.83456
},
{
id: "U3RvcDpIU0w6NDEzMDIwOA==",
lat: 60.25622,
lon: 24.82877
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNQ==",
lat: 60.25572,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDI5MQ==",
lat: 60.25508,
lon: 24.79965
},
{
id: "U3RvcDpIU0w6NDEwMDIxMQ==",
lat: 60.25385,
lon: 24.79672
},
{
id: "U3RvcDpIU0w6NDExMDIwMQ==",
lat: 60.24907,
lon: 24.80488
},
{
id: "U3RvcDpIU0w6MjExNzIzMQ==",
lat: 60.24685,
lon: 24.80845
},
{
id: "U3RvcDpIU0w6MjExNzIyOQ==",
lat: 60.24432,
lon: 24.80847
},
{
id: "U3RvcDpIU0w6MjExNzIyNw==",
lat: 60.24119,
lon: 24.80857
},
{
id: "U3RvcDpIU0w6MjExNzIzNQ==",
lat: 60.23933,
lon: 24.80861
},
{
id: "U3RvcDpIU0w6MjExNDIwNg==",
lat: 60.23598,
lon: 24.80932
},
{
id: "U3RvcDpIU0w6MjExNDIyMQ==",
lat: 60.23321,
lon: 24.81357
},
{
id: "U3RvcDpIU0w6MjExNDIxOQ==",
lat: 60.2313,
lon: 24.81365
},
{
id: "U3RvcDpIU0w6MjExMTIxNw==",
lat: 60.22831,
lon: 24.81361
},
{
id: "U3RvcDpIU0w6MjExMTIxMw==",
lat: 60.22433,
lon: 24.81044
},
{
id: "U3RvcDpIU0w6MjExMTIwNA==",
lat: 60.21989,
lon: 24.81219
},
{
id: "U3RvcDpIU0w6MjExMjI2MQ==",
lat: 60.21896,
lon: 24.816
},
{
id: "U3RvcDpIU0w6MjExMjI2Mw==",
lat: 60.21244,
lon: 24.81549
},
{
id: "U3RvcDpIU0w6MjEyMjIxOQ==",
lat: 60.2061,
lon: 24.81546
},
{
id: "U3RvcDpIU0w6MjEyMjIyMQ==",
lat: 60.19943,
lon: 24.80785
},
{
id: "U3RvcDpIU0w6MjIxNTIyMw==",
lat: 60.1952,
lon: 24.80629
},
{
id: "U3RvcDpIU0w6MjIxNTI3NQ==",
lat: 60.18935,
lon: 24.80714
},
{
id: "U3RvcDpIU0w6MjIyMjIyNg==",
lat: 60.185,
lon: 24.81447
},
{
id: "U3RvcDpIU0w6MjIyMjIxNg==",
lat: 60.18244,
lon: 24.82595
},
{
id: "U3RvcDpIU0w6MjIyMjIxMg==",
lat: 60.183766,
lon: 24.828012
},
{
id: "U3RvcDpIU0w6MjIyMjIwNA==",
lat: 60.18274,
lon: 24.83212
},
{
id: "U3RvcDpIU0w6MjIxMzIyMg==",
lat: 60.17772,
lon: 24.83509
},
{
id: "U3RvcDpIU0w6MjIxMzIyMA==",
lat: 60.175011,
lon: 24.829206
},
{
id: "U3RvcDpIU0w6MjIxMzIyMQ==",
lat: 60.175821,
lon: 24.830009
},
{
id: "U3RvcDpIU0w6MjIxMzIyMw==",
lat: 60.178024,
lon: 24.835289
},
{
id: "U3RvcDpIU0w6MjIyMjIwMw==",
lat: 60.18197,
lon: 24.83372
},
{
id: "U3RvcDpIU0w6MjIyMjIzNA==",
lat: 60.18362,
lon: 24.82779
},
{
id: "U3RvcDpIU0w6MjIyMjIxNQ==",
lat: 60.18236,
lon: 24.82545
},
{
id: "U3RvcDpIU0w6MjIyMjIyNQ==",
lat: 60.18609,
lon: 24.81291
},
{
id: "U3RvcDpIU0w6MjIyMjI2OA==",
lat: 60.18712,
lon: 24.80903
},
{
id: "U3RvcDpIU0w6MjEyMjIyMg==",
lat: 60.19656,
lon: 24.80692
},
{
id: "U3RvcDpIU0w6MjEyMjIyMA==",
lat: 60.2002,
lon: 24.80968
},
{
id: "U3RvcDpIU0w6MjEyMTIwMg==",
lat: 60.2053,
lon: 24.81595
},
{
id: "U3RvcDpIU0w6MjExODI2NA==",
lat: 60.21391,
lon: 24.81666
},
{
id: "U3RvcDpIU0w6MjExMjI2Mg==",
lat: 60.219276,
lon: 24.816951
},
{
id: "U3RvcDpIU0w6MjExMTIwNQ==",
lat: 60.22011,
lon: 24.8119
},
{
id: "U3RvcDpIU0w6MjExMTIyOA==",
lat: 60.22132,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExMTIxMg==",
lat: 60.2232,
lon: 24.81071
},
{
id: "U3RvcDpIU0w6MjExMTIyNg==",
lat: 60.2267,
lon: 24.81272
},
{
id: "U3RvcDpIU0w6MjExMTI4MQ==",
lat: 60.22904,
lon: 24.81383
},
{
id: "U3RvcDpIU0w6MjExNDIxOA==",
lat: 60.23154,
lon: 24.8138
},
{
id: "U3RvcDpIU0w6MjExNDIyMA==",
lat: 60.23386,
lon: 24.81376
},
{
id: "U3RvcDpIU0w6MjExNzIzMg==",
lat: 60.236683,
lon: 24.808831
},
{
id: "U3RvcDpIU0w6MjExNzIzNA==",
lat: 60.23959,
lon: 24.80878
},
{
id: "U3RvcDpIU0w6MjExNzIyNg==",
lat: 60.24158,
lon: 24.80869
},
{
id: "U3RvcDpIU0w6MjExNzIyOA==",
lat: 60.24471,
lon: 24.80859
},
{
id: "U3RvcDpIU0w6MjExNzIzMA==",
lat: 60.24707,
lon: 24.80843
},
{
id: "U3RvcDpIU0w6NDExMDIxMA==",
lat: 60.24875,
lon: 24.806
},
{
id: "U3RvcDpIU0w6NDEyMDI5MA==",
lat: 60.25438,
lon: 24.79724
},
{
id: "U3RvcDpIU0w6NDEyMDI4OA==",
lat: 60.25537,
lon: 24.80147
},
{
id: "U3RvcDpIU0w6NDEyMDIwNg==",
lat: 60.25537,
lon: 24.80804
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6NDEzMDIwNw==",
lat: 60.25561,
lon: 24.82723
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDI2Ng==",
lat: 60.260609,
lon: 24.856622
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxNg==",
lat: 60.270447,
lon: 24.855295
},
{
id: "U3RvcDpIU0w6NDE1MDIxNw==",
lat: 60.27172,
lon: 24.85481
},
{
id: "U3RvcDpIU0w6NDE3MDI5Mw==",
lat: 60.275267,
lon: 24.856513
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
}
]
},
{
gtfsId: "HSL:4313",
shortName: "313",
longName: "Kaivoksela-Myyrmäki-Hämeenkylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDEyMDIyNw==",
lat: 60.26612,
lon: 24.786856
},
{
id: "U3RvcDpIU0w6NDEyMDIyMw==",
lat: 60.26877,
lon: 24.79488
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxOA==",
lat: 60.271994,
lon: 24.815
},
{
id: "U3RvcDpIU0w6NDE0MDI1OQ==",
lat: 60.272552,
lon: 24.814468
},
{
id: "U3RvcDpIU0w6NDE0MDIxNQ==",
lat: 60.27126,
lon: 24.81263
},
{
id: "U3RvcDpIU0w6NDE0MDIxMw==",
lat: 60.26827,
lon: 24.81419
},
{
id: "U3RvcDpIU0w6NDE0MDIxMA==",
lat: 60.26616,
lon: 24.81582
},
{
id: "U3RvcDpIU0w6NDE0MDIwOA==",
lat: 60.2649,
lon: 24.81288
},
{
id: "U3RvcDpIU0w6NDEyMDIxOA==",
lat: 60.26444,
lon: 24.80597
},
{
id: "U3RvcDpIU0w6NDEyMDIxMg==",
lat: 60.264592,
lon: 24.802272
},
{
id: "U3RvcDpIU0w6NDEyMDIxMQ==",
lat: 60.26427,
lon: 24.80569
},
{
id: "U3RvcDpIU0w6NDEyMDIxMA==",
lat: 60.26149,
lon: 24.80645
},
{
id: "U3RvcDpIU0w6NDEyMDIwOA==",
lat: 60.25673,
lon: 24.80958
},
{
id: "U3RvcDpIU0w6NDEyMDIwNQ==",
lat: 60.25572,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDIyNQ==",
lat: 60.25654,
lon: 24.805984
},
{
id: "U3RvcDpIU0w6NDEyMDI5MQ==",
lat: 60.25508,
lon: 24.79965
},
{
id: "U3RvcDpIU0w6NDEwMDIxMQ==",
lat: 60.25385,
lon: 24.79672
},
{
id: "U3RvcDpIU0w6NDExMDIwMQ==",
lat: 60.24907,
lon: 24.80488
},
{
id: "U3RvcDpIU0w6NDExMDIxOQ==",
lat: 60.248138,
lon: 24.803986
},
{
id: "U3RvcDpIU0w6NDExMDIwMg==",
lat: 60.249017,
lon: 24.810261
},
{
id: "U3RvcDpIU0w6NDExMDIwNA==",
lat: 60.250415,
lon: 24.814028
},
{
id: "U3RvcDpIU0w6NDExMDIwNg==",
lat: 60.251833,
lon: 24.819093
},
{
id: "U3RvcDpIU0w6NDExMDIxOA==",
lat: 60.253414,
lon: 24.814098
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6NDEzMDIxMQ==",
lat: 60.25685,
lon: 24.82674
},
{
id: "U3RvcDpIU0w6NDEzMDIxMw==",
lat: 60.25839,
lon: 24.82918
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDIwMw==",
lat: 60.26109,
lon: 24.8556
},
{
id: "U3RvcDpIU0w6NDE1MDIyMQ==",
lat: 60.263767,
lon: 24.852658
},
{
id: "U3RvcDpIU0w6NDE1MDIzNw==",
lat: 60.262775,
lon: 24.849164
},
{
id: "U3RvcDpIU0w6NDE1MDIyMg==",
lat: 60.263549,
lon: 24.852621
},
{
id: "U3RvcDpIU0w6NDE1MDIyMA==",
lat: 60.26371,
lon: 24.85947
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6NDE2MDIwMw==",
lat: 60.26506,
lon: 24.87261
},
{
id: "U3RvcDpIU0w6NDE2MDIwMg==",
lat: 60.27121,
lon: 24.87063
},
{
id: "U3RvcDpIU0w6NDE2MDIwMQ==",
lat: 60.27117,
lon: 24.870575
},
{
id: "U3RvcDpIU0w6NDE2MDIwNg==",
lat: 60.26627,
lon: 24.87003
},
{
id: "U3RvcDpIU0w6NDE2MDIwOA==",
lat: 60.26452,
lon: 24.86958
},
{
id: "U3RvcDpIU0w6NDE2MDIxMA==",
lat: 60.26348,
lon: 24.87057
},
{
id: "U3RvcDpIU0w6NDE2MDIzNg==",
lat: 60.259864,
lon: 24.86914
},
{
id: "U3RvcDpIU0w6NDE2MDIyMg==",
lat: 60.26189,
lon: 24.87109
},
{
id: "U3RvcDpIU0w6NDE2MDIzNw==",
lat: 60.257385,
lon: 24.866753
},
{
id: "U3RvcDpIU0w6NDE2MDIyMw==",
lat: 60.26171,
lon: 24.8718
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE1MDIxOQ==",
lat: 60.26394,
lon: 24.85928
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIyOA==",
lat: 60.25939,
lon: 24.83438
},
{
id: "U3RvcDpIU0w6NDEzMDIxNA==",
lat: 60.2588,
lon: 24.8294
},
{
id: "U3RvcDpIU0w6NDEzMDIxMg==",
lat: 60.25755,
lon: 24.82769
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDExMDIxNw==",
lat: 60.253703,
lon: 24.812916
},
{
id: "U3RvcDpIU0w6NDExMDIwNw==",
lat: 60.25266,
lon: 24.81913
},
{
id: "U3RvcDpIU0w6NDExMDIwNQ==",
lat: 60.250489,
lon: 24.814157
},
{
id: "U3RvcDpIU0w6NDExMDIwMw==",
lat: 60.249141,
lon: 24.81035
},
{
id: "U3RvcDpIU0w6NDExMDIyMA==",
lat: 60.247993,
lon: 24.804407
},
{
id: "U3RvcDpIU0w6NDExMDIwOQ==",
lat: 60.24926,
lon: 24.80477
},
{
id: "U3RvcDpIU0w6NDEyMDI5MA==",
lat: 60.25438,
lon: 24.79724
},
{
id: "U3RvcDpIU0w6NDEyMDI4OA==",
lat: 60.25537,
lon: 24.80147
},
{
id: "U3RvcDpIU0w6NDEyMDIwNg==",
lat: 60.25537,
lon: 24.80804
},
{
id: "U3RvcDpIU0w6NDEyMDIwNw==",
lat: 60.25811,
lon: 24.80891
},
{
id: "U3RvcDpIU0w6NDEyMDIyOA==",
lat: 60.26293,
lon: 24.805612
},
{
id: "U3RvcDpIU0w6NDEyMDIzOA==",
lat: 60.26287,
lon: 24.80655
},
{
id: "U3RvcDpIU0w6NDE0MDIwNw==",
lat: 60.26495,
lon: 24.81334
},
{
id: "U3RvcDpIU0w6NDE0MDIxMQ==",
lat: 60.26691,
lon: 24.81622
},
{
id: "U3RvcDpIU0w6NDE0MDIxMg==",
lat: 60.26905,
lon: 24.81434
},
{
id: "U3RvcDpIU0w6NDE0MDIxNA==",
lat: 60.27169,
lon: 24.81122
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDEyMDI5NA==",
lat: 60.27096,
lon: 24.80215
},
{
id: "U3RvcDpIU0w6NDEyMDI4Ng==",
lat: 60.27016,
lon: 24.79557
},
{
id: "U3RvcDpIU0w6NDEyMDIzNw==",
lat: 60.268526,
lon: 24.794078
},
{
id: "U3RvcDpIU0w6NDExMDIxMA==",
lat: 60.24875,
lon: 24.806
}
]
},
{
gtfsId: "HSL:1095N",
shortName: "95N",
longName: "Rautatientori-Tammisalo-Roihuv.-Mellunmäki-Länsimäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MjE5NA==",
lat: 60.2382,
lon: 25.10673
},
{
id: "U3RvcDpIU0w6MTQ3MjEzMw==",
lat: 60.23512,
lon: 25.1004
},
{
id: "U3RvcDpIU0w6MTQ3MjEzMg==",
lat: 60.23268,
lon: 25.0993
},
{
id: "U3RvcDpIU0w6MTQ3MTEzMA==",
lat: 60.22933,
lon: 25.0996
},
{
id: "U3RvcDpIU0w6MTQ1MTEwNA==",
lat: 60.22734,
lon: 25.10319
},
{
id: "U3RvcDpIU0w6MTQ1MTE4NA==",
lat: 60.22472,
lon: 25.10161
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Mg==",
lat: 60.22464,
lon: 25.09719
},
{
id: "U3RvcDpIU0w6MTQ1MTE4MA==",
lat: 60.22278,
lon: 25.09326
},
{
id: "U3RvcDpIU0w6MTQ1MTEyNg==",
lat: 60.22138,
lon: 25.09411
},
{
id: "U3RvcDpIU0w6MTQ1MTE3OA==",
lat: 60.21973,
lon: 25.10042
},
{
id: "U3RvcDpIU0w6MTQ1MTExMw==",
lat: 60.21841,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6MTQ1MzExMQ==",
lat: 60.21633,
lon: 25.09587
},
{
id: "U3RvcDpIU0w6MTQ1MzEzOA==",
lat: 60.21533,
lon: 25.09017
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNg==",
lat: 60.20959,
lon: 25.091516
},
{
id: "U3RvcDpIU0w6MTQ1MjE2OA==",
lat: 60.20809,
lon: 25.09569
},
{
id: "U3RvcDpIU0w6MTQ1NTE2Nw==",
lat: 60.20618,
lon: 25.09335
},
{
id: "U3RvcDpIU0w6MTQ1NTE2NQ==",
lat: 60.20593,
lon: 25.0889
},
{
id: "U3RvcDpIU0w6MTQ1NTE2Mw==",
lat: 60.20378,
lon: 25.08538
},
{
id: "U3RvcDpIU0w6MTQ1NTE2MQ==",
lat: 60.20354,
lon: 25.07957
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mg==",
lat: 60.20392,
lon: 25.07614
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OQ==",
lat: 60.20303,
lon: 25.07354
},
{
id: "U3RvcDpIU0w6MTQzMjE4MQ==",
lat: 60.20187,
lon: 25.0646
},
{
id: "U3RvcDpIU0w6MTQzMjE3OQ==",
lat: 60.20199,
lon: 25.0616
},
{
id: "U3RvcDpIU0w6MTQzMjE2Mg==",
lat: 60.2007,
lon: 25.05952
},
{
id: "U3RvcDpIU0w6MTQzMjE2MA==",
lat: 60.1975,
lon: 25.05482
},
{
id: "U3RvcDpIU0w6MTQzMjE1OA==",
lat: 60.19525,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQzMjE1Mg==",
lat: 60.19461,
lon: 25.05887
},
{
id: "U3RvcDpIU0w6MTQzMjExMA==",
lat: 60.19561,
lon: 25.06393
},
{
id: "U3RvcDpIU0w6MTQ0MDEwOA==",
lat: 60.19187,
lon: 25.0624
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNg==",
lat: 60.19055,
lon: 25.05834
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNA==",
lat: 60.19033,
lon: 25.05429
},
{
id: "U3RvcDpIU0w6MTQ0MDEwMg==",
lat: 60.190011,
lon: 25.049551
},
{
id: "U3RvcDpIU0w6MTQzMzE2Ng==",
lat: 60.19182,
lon: 25.04492
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE1Mw==",
lat: 60.19236,
lon: 25.04061
},
{
id: "U3RvcDpIU0w6MTQzNDE2NQ==",
lat: 60.1913,
lon: 25.04524
},
{
id: "U3RvcDpIU0w6MTQ0MDEwMQ==",
lat: 60.18986,
lon: 25.04989
},
{
id: "U3RvcDpIU0w6MTQ0MDEwMw==",
lat: 60.19022,
lon: 25.05435
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNQ==",
lat: 60.19054,
lon: 25.05932
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNw==",
lat: 60.19178,
lon: 25.06243
},
{
id: "U3RvcDpIU0w6MTQ0MDEwOQ==",
lat: 60.19371,
lon: 25.06513
},
{
id: "U3RvcDpIU0w6MTQzMjExMQ==",
lat: 60.1959,
lon: 25.06273
},
{
id: "U3RvcDpIU0w6MTQzMjE1NQ==",
lat: 60.19456,
lon: 25.05759
},
{
id: "U3RvcDpIU0w6MTQzMjE1Nw==",
lat: 60.19536,
lon: 25.0535
},
{
id: "U3RvcDpIU0w6MTQzMjE1OQ==",
lat: 60.19806,
lon: 25.05587
},
{
id: "U3RvcDpIU0w6MTQzMjE2MQ==",
lat: 60.20088,
lon: 25.05972
},
{
id: "U3RvcDpIU0w6MTQzMjE3OA==",
lat: 60.20195,
lon: 25.06185
},
{
id: "U3RvcDpIU0w6MTQzMjE4MA==",
lat: 60.20174,
lon: 25.0658
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OA==",
lat: 60.20285,
lon: 25.07329
},
{
id: "U3RvcDpIU0w6MTQ1NTE3MQ==",
lat: 60.20428,
lon: 25.07685
},
{
id: "U3RvcDpIU0w6MTQ1NTE2MA==",
lat: 60.20324,
lon: 25.08139
},
{
id: "U3RvcDpIU0w6MTQ1NTE2Mg==",
lat: 60.2043,
lon: 25.0858
},
{
id: "U3RvcDpIU0w6MTQ1NTE2NA==",
lat: 60.2056,
lon: 25.08853
},
{
id: "U3RvcDpIU0w6MTQ1NTE2Ng==",
lat: 60.206,
lon: 25.09324
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMw==",
lat: 60.208799,
lon: 25.095008
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNQ==",
lat: 60.210859,
lon: 25.090062
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MzEwNw==",
lat: 60.21557,
lon: 25.09193
},
{
id: "U3RvcDpIU0w6MTQ1MjExMg==",
lat: 60.2166,
lon: 25.09736
},
{
id: "U3RvcDpIU0w6MTQ1MTE3NQ==",
lat: 60.219834,
lon: 25.100155
},
{
id: "U3RvcDpIU0w6MTQ1MTEyNQ==",
lat: 60.22132,
lon: 25.09444
},
{
id: "U3RvcDpIU0w6MTQ1MTE3OQ==",
lat: 60.22361,
lon: 25.09368
},
{
id: "U3RvcDpIU0w6MTQ1MTE4MQ==",
lat: 60.22455,
lon: 25.09775
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Mw==",
lat: 60.22473,
lon: 25.10201
},
{
id: "U3RvcDpIU0w6MTQ1MTEwMw==",
lat: 60.22724,
lon: 25.10316
},
{
id: "U3RvcDpIU0w6MTQ3MTEyOQ==",
lat: 60.22999,
lon: 25.09946
},
{
id: "U3RvcDpIU0w6MTQ3MjEzMQ==",
lat: 60.23329,
lon: 25.09953
},
{
id: "U3RvcDpIU0w6MTQ3MjEzNA==",
lat: 60.23521,
lon: 25.10082
},
{
id: "U3RvcDpIU0w6MTQ3MjE5Mw==",
lat: 60.23837,
lon: 25.10701
},
{
id: "U3RvcDpIU0w6NDkxMDIxNw==",
lat: 60.242165,
lon: 25.108975
},
{
id: "U3RvcDpIU0w6NDkxMDIxNQ==",
lat: 60.24494,
lon: 25.11149
},
{
id: "U3RvcDpIU0w6NDkxMDIwMw==",
lat: 60.24755,
lon: 25.11225
},
{
id: "U3RvcDpIU0w6NDkxMDIyMg==",
lat: 60.251153,
lon: 25.110441
},
{
id: "U3RvcDpIU0w6NDk1MDIxMw==",
lat: 60.25071,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk1MDIwNw==",
lat: 60.24916,
lon: 25.10035
},
{
id: "U3RvcDpIU0w6NDk1MDIwOQ==",
lat: 60.24565,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDkxMDIwMQ==",
lat: 60.24324,
lon: 25.10666
},
{
id: "U3RvcDpIU0w6NDkxMDIxOA==",
lat: 60.24234,
lon: 25.10881
}
]
},
{
gtfsId: "HSL:6182A",
shortName: "182A",
longName: "Kirkkonummi-Siuntio-Siuntion kylpylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMTAzMg==",
lat: 60.16977,
lon: 24.211382
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
},
{
id: "U3RvcDpIU0w6NjMwMjAxMg==",
lat: 60.138558,
lon: 24.22497
},
{
id: "U3RvcDpIU0w6NjMwMjAxNg==",
lat: 60.133773,
lon: 24.229992
},
{
id: "U3RvcDpIU0w6NjMwMjAwMQ==",
lat: 60.128729,
lon: 24.232488
},
{
id: "U3RvcDpIU0w6NjMwMjAwOQ==",
lat: 60.120639,
lon: 24.239353
},
{
id: "U3RvcDpIU0w6NjMwMjAwNA==",
lat: 60.116061,
lon: 24.241087
},
{
id: "U3RvcDpIU0w6NjMwMjAxOQ==",
lat: 60.110936,
lon: 24.241778
},
{
id: "U3RvcDpIU0w6NjMwNDAwNw==",
lat: 60.102476,
lon: 24.24881
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNzAwNA==",
lat: 60.099132,
lon: 24.303275
},
{
id: "U3RvcDpIU0w6NjMwNzAwOA==",
lat: 60.099232,
lon: 24.331415
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNA==",
lat: 60.106061,
lon: 24.371492
},
{
id: "U3RvcDpIU0w6NjA1MDIwNQ==",
lat: 60.110392,
lon: 24.384672
},
{
id: "U3RvcDpIU0w6NjA0MDIwOQ==",
lat: 60.114941,
lon: 24.414073
},
{
id: "U3RvcDpIU0w6NjA0MDIxMg==",
lat: 60.115939,
lon: 24.426609
},
{
id: "U3RvcDpIU0w6NjA0MDI4NQ==",
lat: 60.118858,
lon: 24.438951
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA0MDI5NQ==",
lat: 60.119658,
lon: 24.441538
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA0MDIxNA==",
lat: 60.117086,
lon: 24.44276
},
{
id: "U3RvcDpIU0w6NjA0MDIxMw==",
lat: 60.116116,
lon: 24.426538
},
{
id: "U3RvcDpIU0w6NjA0MDIxMA==",
lat: 60.114838,
lon: 24.411756
},
{
id: "U3RvcDpIU0w6NjA1MDIwNg==",
lat: 60.110009,
lon: 24.382306
},
{
id: "U3RvcDpIU0w6NjA1MDIwMw==",
lat: 60.105278,
lon: 24.369337
},
{
id: "U3RvcDpIU0w6NjA1MDIwMg==",
lat: 60.103433,
lon: 24.364292
},
{
id: "U3RvcDpIU0w6NjA3MDIyOQ==",
lat: 60.101495,
lon: 24.345007
},
{
id: "U3RvcDpIU0w6NjMwNzAwNw==",
lat: 60.09886,
lon: 24.329275
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwOQ==",
lat: 60.096517,
lon: 24.251887
},
{
id: "U3RvcDpIU0w6NjMwNDAwOA==",
lat: 60.103516,
lon: 24.248267
},
{
id: "U3RvcDpIU0w6NjMwMjAxOA==",
lat: 60.112345,
lon: 24.241337
},
{
id: "U3RvcDpIU0w6NjMwMjAwNQ==",
lat: 60.117387,
lon: 24.241306
},
{
id: "U3RvcDpIU0w6NjMwMjAwOA==",
lat: 60.121106,
lon: 24.239152
},
{
id: "U3RvcDpIU0w6NjMwMjAwMA==",
lat: 60.130476,
lon: 24.232493
},
{
id: "U3RvcDpIU0w6NjMwMjAxNw==",
lat: 60.135228,
lon: 24.228995
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAyMw==",
lat: 60.165141,
lon: 24.197315
}
]
},
{
gtfsId: "HSL:1082B",
shortName: "82B",
longName: "Herttoniemi(M)-Tammisalo-Roihuvuori-Itäkeskus(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTE4OQ==",
lat: 60.19516,
lon: 25.03188
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE1Mw==",
lat: 60.19236,
lon: 25.04061
},
{
id: "U3RvcDpIU0w6MTQzNDE2NQ==",
lat: 60.1913,
lon: 25.04524
},
{
id: "U3RvcDpIU0w6MTQ0MDEwMQ==",
lat: 60.18986,
lon: 25.04989
},
{
id: "U3RvcDpIU0w6MTQ0MDEwMw==",
lat: 60.19022,
lon: 25.05435
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNQ==",
lat: 60.19054,
lon: 25.05932
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNw==",
lat: 60.19178,
lon: 25.06243
},
{
id: "U3RvcDpIU0w6MTQ0MDEwOQ==",
lat: 60.19371,
lon: 25.06513
},
{
id: "U3RvcDpIU0w6MTQzMjExMQ==",
lat: 60.1959,
lon: 25.06273
},
{
id: "U3RvcDpIU0w6MTQzMjE1NQ==",
lat: 60.19456,
lon: 25.05759
},
{
id: "U3RvcDpIU0w6MTQzMjE1Nw==",
lat: 60.19536,
lon: 25.0535
},
{
id: "U3RvcDpIU0w6MTQzMjE1OQ==",
lat: 60.19806,
lon: 25.05587
},
{
id: "U3RvcDpIU0w6MTQzMjE2MQ==",
lat: 60.20088,
lon: 25.05972
},
{
id: "U3RvcDpIU0w6MTQzMjE3OA==",
lat: 60.20195,
lon: 25.06185
},
{
id: "U3RvcDpIU0w6MTQzMjE4MA==",
lat: 60.20174,
lon: 25.0658
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OA==",
lat: 60.20285,
lon: 25.07329
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mw==",
lat: 60.20466,
lon: 25.07662
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMg==",
lat: 60.20757,
lon: 25.07562
},
{
id: "U3RvcDpIU0w6MTQ1MzExMg==",
lat: 60.210165,
lon: 25.077287
},
{
id: "U3RvcDpIU0w6MTQ1MzEyOA==",
lat: 60.20956,
lon: 25.07691
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMQ==",
lat: 60.2075,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mg==",
lat: 60.20392,
lon: 25.07614
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OQ==",
lat: 60.20303,
lon: 25.07354
},
{
id: "U3RvcDpIU0w6MTQzMjE4MQ==",
lat: 60.20187,
lon: 25.0646
},
{
id: "U3RvcDpIU0w6MTQzMjE3OQ==",
lat: 60.20199,
lon: 25.0616
},
{
id: "U3RvcDpIU0w6MTQzMjE2Mg==",
lat: 60.2007,
lon: 25.05952
},
{
id: "U3RvcDpIU0w6MTQzMjE2MA==",
lat: 60.1975,
lon: 25.05482
},
{
id: "U3RvcDpIU0w6MTQzMjE1OA==",
lat: 60.19525,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQzMjE1Mg==",
lat: 60.19461,
lon: 25.05887
},
{
id: "U3RvcDpIU0w6MTQzMjExMA==",
lat: 60.19561,
lon: 25.06393
},
{
id: "U3RvcDpIU0w6MTQ0MDEwOA==",
lat: 60.19187,
lon: 25.0624
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNg==",
lat: 60.19055,
lon: 25.05834
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNA==",
lat: 60.19033,
lon: 25.05429
},
{
id: "U3RvcDpIU0w6MTQ0MDEwMg==",
lat: 60.190011,
lon: 25.049551
},
{
id: "U3RvcDpIU0w6MTQzMzE2Ng==",
lat: 60.19182,
lon: 25.04492
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
}
]
},
{
gtfsId: "HSL:1094B",
shortName: "94B",
longName: "Kivikonlaita-Kontula(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MTEzNw==",
lat: 60.235733,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6MTQ3MTE4MQ==",
lat: 60.23674,
lon: 25.08167
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOQ==",
lat: 60.23797,
lon: 25.07866
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNg==",
lat: 60.23977,
lon: 25.07401
},
{
id: "U3RvcDpIU0w6MTQ3NDEwOA==",
lat: 60.24054,
lon: 25.07018
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNg==",
lat: 60.2387,
lon: 25.0672
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNA==",
lat: 60.23695,
lon: 25.06738
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMg==",
lat: 60.23314,
lon: 25.06215
},
{
id: "U3RvcDpIU0w6MTQ3NDEyNw==",
lat: 60.231617,
lon: 25.055574
},
{
id: "U3RvcDpIU0w6MTQ3NDExNw==",
lat: 60.23455,
lon: 25.04913
},
{
id: "U3RvcDpIU0w6MTQ3NDEyNg==",
lat: 60.240137,
lon: 25.049433
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMA==",
lat: 60.24201,
lon: 25.05473
},
{
id: "U3RvcDpIU0w6MTQ3NDExMA==",
lat: 60.24605,
lon: 25.06228
},
{
id: "U3RvcDpIU0w6MTQ3NDExOQ==",
lat: 60.24201,
lon: 25.05463
},
{
id: "U3RvcDpIU0w6MTQ3NDEyNQ==",
lat: 60.239897,
lon: 25.048488
},
{
id: "U3RvcDpIU0w6MTQ3NDExOA==",
lat: 60.23501,
lon: 25.0484
},
{
id: "U3RvcDpIU0w6MTQ3NDExNg==",
lat: 60.231238,
lon: 25.054796
},
{
id: "U3RvcDpIU0w6MTQ3NDExNA==",
lat: 60.23164,
lon: 25.05878
},
{
id: "U3RvcDpIU0w6MTQ3NDExMg==",
lat: 60.23256,
lon: 25.06251
},
{
id: "U3RvcDpIU0w6MTQ3MTE4Mw==",
lat: 60.2309,
lon: 25.06506
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Nw==",
lat: 60.22886,
lon: 25.06757
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NQ==",
lat: 60.22913,
lon: 25.074
},
{
id: "U3RvcDpIU0w6MTQ3MTE3MQ==",
lat: 60.23145,
lon: 25.07625
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mw==",
lat: 60.23353,
lon: 25.07833
}
]
},
{
gtfsId: "HSL:4431",
shortName: "431",
longName: "Elielinaukio-Kivistö",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIzMDI0NQ==",
lat: 60.314149,
lon: 24.844845
},
{
id: "U3RvcDpIU0w6NDIzMDI0OA==",
lat: 60.315237,
lon: 24.849881
},
{
id: "U3RvcDpIU0w6NDIxMDIzNg==",
lat: 60.307648,
lon: 24.850909
},
{
id: "U3RvcDpIU0w6NDIxMDIyNg==",
lat: 60.30299,
lon: 24.84741
},
{
id: "U3RvcDpIU0w6NDIxMDI5OA==",
lat: 60.30157,
lon: 24.8534
},
{
id: "U3RvcDpIU0w6NDIxMDIxNQ==",
lat: 60.30119,
lon: 24.85722
},
{
id: "U3RvcDpIU0w6NDIxMDIwNg==",
lat: 60.29954,
lon: 24.85863
},
{
id: "U3RvcDpIU0w6NDIxMDIwNA==",
lat: 60.2945,
lon: 24.86104
},
{
id: "U3RvcDpIU0w6NDIxMDIwMg==",
lat: 60.29251,
lon: 24.86391
},
{
id: "U3RvcDpIU0w6NDE4MDIxMw==",
lat: 60.29083,
lon: 24.86782
},
{
id: "U3RvcDpIU0w6NDE4MDIxMQ==",
lat: 60.2871,
lon: 24.87284
},
{
id: "U3RvcDpIU0w6NDE4MDIyNg==",
lat: 60.28292,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyMg==",
lat: 60.27741,
lon: 24.87247
},
{
id: "U3RvcDpIU0w6NDE4MDIwMg==",
lat: 60.27334,
lon: 24.87505
},
{
id: "U3RvcDpIU0w6NDE2MDIyMQ==",
lat: 60.26918,
lon: 24.87913
},
{
id: "U3RvcDpIU0w6NDE2MDI5OQ==",
lat: 60.265,
lon: 24.88162
},
{
id: "U3RvcDpIU0w6NDE2MDIxOA==",
lat: 60.26389,
lon: 24.87979
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDIzOQ==",
lat: 60.171981,
lon: 24.93971
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxNw==",
lat: 60.26342,
lon: 24.87936
},
{
id: "U3RvcDpIU0w6NDE2MDIxOQ==",
lat: 60.26605,
lon: 24.88205
},
{
id: "U3RvcDpIU0w6NDE2MDIyMA==",
lat: 60.27017,
lon: 24.87906
},
{
id: "U3RvcDpIU0w6NDE4MDIwMw==",
lat: 60.27403,
lon: 24.87324
},
{
id: "U3RvcDpIU0w6NDE4MDIyMw==",
lat: 60.27905,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyNQ==",
lat: 60.284615,
lon: 24.873015
},
{
id: "U3RvcDpIU0w6NDE4MDIxMA==",
lat: 60.28857,
lon: 24.8725
},
{
id: "U3RvcDpIU0w6NDE4MDIxMg==",
lat: 60.29113,
lon: 24.86663
},
{
id: "U3RvcDpIU0w6NDIxMDIwMQ==",
lat: 60.29308,
lon: 24.86341
},
{
id: "U3RvcDpIU0w6NDIxMDIwMw==",
lat: 60.29542,
lon: 24.85944
},
{
id: "U3RvcDpIU0w6NDIxMDIwNQ==",
lat: 60.29993,
lon: 24.85925
},
{
id: "U3RvcDpIU0w6NDIxMDI5OQ==",
lat: 60.30173,
lon: 24.8569
},
{
id: "U3RvcDpIU0w6NDIxMDI5Nw==",
lat: 60.30152,
lon: 24.85215
},
{
id: "U3RvcDpIU0w6NDIxMDIyNQ==",
lat: 60.30162,
lon: 24.84876
},
{
id: "U3RvcDpIU0w6NDIxMDIzNw==",
lat: 60.308071,
lon: 24.851351
},
{
id: "U3RvcDpIU0w6NDIxMDIyMg==",
lat: 60.31329,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDIzMDI0OQ==",
lat: 60.316261,
lon: 24.848552
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
}
]
},
{
gtfsId: "HSL:6181K",
shortName: "181K",
longName: "Kirkkonummi-Siuntio",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMjAxMg==",
lat: 60.138558,
lon: 24.22497
},
{
id: "U3RvcDpIU0w6NjMwMjAxNg==",
lat: 60.133773,
lon: 24.229992
},
{
id: "U3RvcDpIU0w6NjMwMjAwMQ==",
lat: 60.128729,
lon: 24.232488
},
{
id: "U3RvcDpIU0w6NjMwMjAwOQ==",
lat: 60.120639,
lon: 24.239353
},
{
id: "U3RvcDpIU0w6NjMwMjAwNA==",
lat: 60.116061,
lon: 24.241087
},
{
id: "U3RvcDpIU0w6NjMwMjAxOQ==",
lat: 60.110936,
lon: 24.241778
},
{
id: "U3RvcDpIU0w6NjMwNDAwNw==",
lat: 60.102476,
lon: 24.24881
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNA==",
lat: 60.080806,
lon: 24.291003
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNjAwNQ==",
lat: 60.105749,
lon: 24.291215
},
{
id: "U3RvcDpIU0w6NjMwNjAwMw==",
lat: 60.114029,
lon: 24.300907
},
{
id: "U3RvcDpIU0w6NjMwNjAwNg==",
lat: 60.116092,
lon: 24.32743
},
{
id: "U3RvcDpIU0w6NjMwNjAwMA==",
lat: 60.114131,
lon: 24.325536
},
{
id: "U3RvcDpIU0w6NjA1MDIwOQ==",
lat: 60.121223,
lon: 24.377082
},
{
id: "U3RvcDpIU0w6NjA1MDIxMQ==",
lat: 60.121985,
lon: 24.386015
},
{
id: "U3RvcDpIU0w6NjA1MDIxMw==",
lat: 60.123857,
lon: 24.399738
},
{
id: "U3RvcDpIU0w6NjA0MDIzNQ==",
lat: 60.123883,
lon: 24.40556
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA0MDIzNg==",
lat: 60.124797,
lon: 24.426783
},
{
id: "U3RvcDpIU0w6NjA0MDIzOQ==",
lat: 60.126123,
lon: 24.435517
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA0MDI5NQ==",
lat: 60.119658,
lon: 24.441538
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDIzOA==",
lat: 60.125828,
lon: 24.433405
},
{
id: "U3RvcDpIU0w6NjA0MDIzNw==",
lat: 60.125218,
lon: 24.42728
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA1MDIxOQ==",
lat: 60.12335,
lon: 24.410108
},
{
id: "U3RvcDpIU0w6NjA1MDIxNQ==",
lat: 60.123878,
lon: 24.404211
},
{
id: "U3RvcDpIU0w6NjA1MDIxNA==",
lat: 60.123608,
lon: 24.39643
},
{
id: "U3RvcDpIU0w6NjA1MDIxMg==",
lat: 60.12206,
lon: 24.385388
},
{
id: "U3RvcDpIU0w6NjA1MDIxMA==",
lat: 60.121138,
lon: 24.376124
},
{
id: "U3RvcDpIU0w6NjA1MDIxNw==",
lat: 60.117976,
lon: 24.362341
},
{
id: "U3RvcDpIU0w6NjMwNjAwMQ==",
lat: 60.114423,
lon: 24.324623
},
{
id: "U3RvcDpIU0w6NjMwNjAwMg==",
lat: 60.11389,
lon: 24.300788
},
{
id: "U3RvcDpIU0w6NjMwNjAwNA==",
lat: 60.106052,
lon: 24.290729
},
{
id: "U3RvcDpIU0w6NjMwNzAwNg==",
lat: 60.09981,
lon: 24.299634
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwOQ==",
lat: 60.096517,
lon: 24.251887
},
{
id: "U3RvcDpIU0w6NjMwNDAwOA==",
lat: 60.103516,
lon: 24.248267
},
{
id: "U3RvcDpIU0w6NjMwMjAxOA==",
lat: 60.112345,
lon: 24.241337
},
{
id: "U3RvcDpIU0w6NjMwMjAwNQ==",
lat: 60.117387,
lon: 24.241306
},
{
id: "U3RvcDpIU0w6NjMwMjAwOA==",
lat: 60.121106,
lon: 24.239152
},
{
id: "U3RvcDpIU0w6NjMwMjAwMA==",
lat: 60.130476,
lon: 24.232493
},
{
id: "U3RvcDpIU0w6NjMwMjAxNw==",
lat: 60.135228,
lon: 24.228995
}
]
},
{
gtfsId: "HSL:4311",
shortName: "311",
longName: "Myyrmäki-Hämeenkylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE1MDI2Mw==",
lat: 60.26109,
lon: 24.856
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIxMA==",
lat: 60.25875,
lon: 24.83456
},
{
id: "U3RvcDpIU0w6NDEzMDIwOA==",
lat: 60.25622,
lon: 24.82877
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNw==",
lat: 60.25811,
lon: 24.80891
},
{
id: "U3RvcDpIU0w6NDEyMDIyOA==",
lat: 60.26293,
lon: 24.805612
},
{
id: "U3RvcDpIU0w6NDEyMDIxOA==",
lat: 60.26444,
lon: 24.80597
},
{
id: "U3RvcDpIU0w6NDEyMDI5OA==",
lat: 60.26687,
lon: 24.80497
},
{
id: "U3RvcDpIU0w6NDEyMDIxOQ==",
lat: 60.26612,
lon: 24.79949
},
{
id: "U3RvcDpIU0w6NDEyMDIyMw==",
lat: 60.26877,
lon: 24.79488
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5Ng==",
lat: 60.27064,
lon: 24.80229
},
{
id: "U3RvcDpIU0w6NDEyMDI5Nw==",
lat: 60.27064,
lon: 24.80229
},
{
id: "U3RvcDpIU0w6NDEyMDI5NA==",
lat: 60.27096,
lon: 24.80215
},
{
id: "U3RvcDpIU0w6NDEyMDI4Ng==",
lat: 60.27016,
lon: 24.79557
},
{
id: "U3RvcDpIU0w6NDEyMDIyMg==",
lat: 60.26848,
lon: 24.79489
},
{
id: "U3RvcDpIU0w6NDEyMDIyMA==",
lat: 60.26647,
lon: 24.79868
},
{
id: "U3RvcDpIU0w6NDEyMDI5OQ==",
lat: 60.26695,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDIxMQ==",
lat: 60.26427,
lon: 24.80569
},
{
id: "U3RvcDpIU0w6NDEyMDIxMA==",
lat: 60.26149,
lon: 24.80645
},
{
id: "U3RvcDpIU0w6NDEyMDIwOA==",
lat: 60.25673,
lon: 24.80958
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6NDEzMDIwNw==",
lat: 60.25561,
lon: 24.82723
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDIwNQ==",
lat: 60.26146,
lon: 24.85579
}
]
},
{
gtfsId: "HSL:4432",
shortName: "432",
longName: "Martinlaakso-Petas-Kivistö-Kirkka",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE3MDI0OA==",
lat: 60.27723,
lon: 24.85379
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOQ==",
lat: 60.28544,
lon: 24.85111
},
{
id: "U3RvcDpIU0w6NDE3MDI4Nw==",
lat: 60.290477,
lon: 24.844042
},
{
id: "U3RvcDpIU0w6NDI1MDIxMw==",
lat: 60.295045,
lon: 24.845304
},
{
id: "U3RvcDpIU0w6NDI1MDIxNQ==",
lat: 60.294941,
lon: 24.850681
},
{
id: "U3RvcDpIU0w6NDIxMDIwNQ==",
lat: 60.29993,
lon: 24.85925
},
{
id: "U3RvcDpIU0w6NDIxMDI5OQ==",
lat: 60.30173,
lon: 24.8569
},
{
id: "U3RvcDpIU0w6NDIxMDI5Nw==",
lat: 60.30152,
lon: 24.85215
},
{
id: "U3RvcDpIU0w6NDI1MDIxMQ==",
lat: 60.30256,
lon: 24.8448
},
{
id: "U3RvcDpIU0w6NDI1MDIwOA==",
lat: 60.3024,
lon: 24.83584
},
{
id: "U3RvcDpIU0w6NDI1MDIwNQ==",
lat: 60.30332,
lon: 24.83012
},
{
id: "U3RvcDpIU0w6NDI1MDIwNw==",
lat: 60.3023,
lon: 24.83559
},
{
id: "U3RvcDpIU0w6NDI1MDIxMA==",
lat: 60.30256,
lon: 24.84578
},
{
id: "U3RvcDpIU0w6NDIxMDIyNQ==",
lat: 60.30162,
lon: 24.84876
},
{
id: "U3RvcDpIU0w6NDIxMDIzNw==",
lat: 60.308071,
lon: 24.851351
},
{
id: "U3RvcDpIU0w6NDIxMDIyMg==",
lat: 60.31329,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDIzMDI0OQ==",
lat: 60.316261,
lon: 24.848552
},
{
id: "U3RvcDpIU0w6NDIzMDIwMg==",
lat: 60.317449,
lon: 24.846159
},
{
id: "U3RvcDpIU0w6NDIzMDIwNA==",
lat: 60.3189,
lon: 24.84368
},
{
id: "U3RvcDpIU0w6NDIzMDIwNg==",
lat: 60.32009,
lon: 24.84231
},
{
id: "U3RvcDpIU0w6NDIzMDIwOA==",
lat: 60.32314,
lon: 24.84034
},
{
id: "U3RvcDpIU0w6NDIzMDIxMQ==",
lat: 60.32644,
lon: 24.83694
},
{
id: "U3RvcDpIU0w6NDIyMDIyNQ==",
lat: 60.32778,
lon: 24.8256
},
{
id: "U3RvcDpIU0w6NDIyMDIwNw==",
lat: 60.32268,
lon: 24.80888
},
{
id: "U3RvcDpIU0w6NDIyMDIyNg==",
lat: 60.33248,
lon: 24.81876
},
{
id: "U3RvcDpIU0w6NDIzMDIxMg==",
lat: 60.32579,
lon: 24.83767
},
{
id: "U3RvcDpIU0w6NDIzMDIwOQ==",
lat: 60.32227,
lon: 24.8409
},
{
id: "U3RvcDpIU0w6NDIzMDIwNw==",
lat: 60.3205,
lon: 24.84192
},
{
id: "U3RvcDpIU0w6NDIzMDIwNQ==",
lat: 60.31832,
lon: 24.84409
},
{
id: "U3RvcDpIU0w6NDIzMDIwMw==",
lat: 60.316588,
lon: 24.847408
},
{
id: "U3RvcDpIU0w6NDIzMDI0OA==",
lat: 60.315237,
lon: 24.849881
},
{
id: "U3RvcDpIU0w6NDIxMDIzNg==",
lat: 60.307648,
lon: 24.850909
},
{
id: "U3RvcDpIU0w6NDIxMDIyNg==",
lat: 60.30299,
lon: 24.84741
},
{
id: "U3RvcDpIU0w6NDIxMDI5OA==",
lat: 60.30157,
lon: 24.8534
},
{
id: "U3RvcDpIU0w6NDIxMDIxNQ==",
lat: 60.30119,
lon: 24.85722
},
{
id: "U3RvcDpIU0w6NDIxMDIwNg==",
lat: 60.29954,
lon: 24.85863
},
{
id: "U3RvcDpIU0w6NDI1MDIxNA==",
lat: 60.295186,
lon: 24.850523
},
{
id: "U3RvcDpIU0w6NDI1MDIxMg==",
lat: 60.295095,
lon: 24.844916
},
{
id: "U3RvcDpIU0w6NDE3MDI4Ng==",
lat: 60.289436,
lon: 24.845115
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxMQ==",
lat: 60.2773,
lon: 24.85304
}
]
},
{
gtfsId: "HSL:2133",
shortName: "133",
longName: "Friisilä-Matinkylä (M)-Henttaa",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMyMTIwMw==",
lat: 60.171087,
lon: 24.711495
},
{
id: "U3RvcDpIU0w6MjMyMTI1Nw==",
lat: 60.16926,
lon: 24.712868
},
{
id: "U3RvcDpIU0w6MjMyMTI2MA==",
lat: 60.16674,
lon: 24.71829
},
{
id: "U3RvcDpIU0w6MjMyMTIyNg==",
lat: 60.16475,
lon: 24.71893
},
{
id: "U3RvcDpIU0w6MjMyMTIwMQ==",
lat: 60.16353,
lon: 24.72093
},
{
id: "U3RvcDpIU0w6MjMyMTIyNw==",
lat: 60.16215,
lon: 24.72297
},
{
id: "U3RvcDpIU0w6MjMxNDIyMw==",
lat: 60.16015,
lon: 24.72536
},
{
id: "U3RvcDpIU0w6MjMxNDIyNg==",
lat: 60.15706,
lon: 24.72747
},
{
id: "U3RvcDpIU0w6MjMxMTIxOQ==",
lat: 60.15915,
lon: 24.737556
},
{
id: "U3RvcDpIU0w6MjMxNDIwOA==",
lat: 60.161049,
lon: 24.740512
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjMyMjIxMg==",
lat: 60.164558,
lon: 24.737052
},
{
id: "U3RvcDpIU0w6MjMyMzIwOQ==",
lat: 60.16666,
lon: 24.73958
},
{
id: "U3RvcDpIU0w6MjMyMjIwNg==",
lat: 60.168597,
lon: 24.743873
},
{
id: "U3RvcDpIU0w6MjMyMjIzMA==",
lat: 60.17259,
lon: 24.74576
},
{
id: "U3RvcDpIU0w6MjMyMjI0OA==",
lat: 60.17565,
lon: 24.74279
},
{
id: "U3RvcDpIU0w6MjMyMjI0MA==",
lat: 60.17783,
lon: 24.74201
},
{
id: "U3RvcDpIU0w6MjMzMTIwNA==",
lat: 60.18081,
lon: 24.74421
},
{
id: "U3RvcDpIU0w6MjMzMTIwNg==",
lat: 60.18218,
lon: 24.74539
},
{
id: "U3RvcDpIU0w6MjMzMTIxMA==",
lat: 60.184128,
lon: 24.743706
},
{
id: "U3RvcDpIU0w6MjMzMTIwMg==",
lat: 60.18609,
lon: 24.73357
},
{
id: "U3RvcDpIU0w6MjMzMTIwMA==",
lat: 60.1875,
lon: 24.72835
},
{
id: "U3RvcDpIU0w6MjMzMTIwMQ==",
lat: 60.1875,
lon: 24.72835
},
{
id: "U3RvcDpIU0w6MjMzMTIwMw==",
lat: 60.18589,
lon: 24.73391
},
{
id: "U3RvcDpIU0w6MjMzMTIwOQ==",
lat: 60.18293,
lon: 24.74496
},
{
id: "U3RvcDpIU0w6MjMzMTIwNQ==",
lat: 60.18102,
lon: 24.74392
},
{
id: "U3RvcDpIU0w6MjMyMjIzOQ==",
lat: 60.17763,
lon: 24.74183
},
{
id: "U3RvcDpIU0w6MjMyMjIzMg==",
lat: 60.17495,
lon: 24.74337
},
{
id: "U3RvcDpIU0w6MjMyMjIzMQ==",
lat: 60.17256,
lon: 24.74548
},
{
id: "U3RvcDpIU0w6MjMyMjIwNQ==",
lat: 60.167702,
lon: 24.741443
},
{
id: "U3RvcDpIU0w6MjMyMjIxMQ==",
lat: 60.16456,
lon: 24.73676
},
{
id: "U3RvcDpIU0w6MjMxMTIxMQ==",
lat: 60.16246,
lon: 24.73833
},
{
id: "U3RvcDpIU0w6MjMxMTIwMQ==",
lat: 60.160644,
lon: 24.740316
},
{
id: "U3RvcDpIU0w6MjMxNDIyNA==",
lat: 60.15827,
lon: 24.73214
},
{
id: "U3RvcDpIU0w6MjMxNDIyMA==",
lat: 60.15719,
lon: 24.7262
},
{
id: "U3RvcDpIU0w6MjMxNDIyMg==",
lat: 60.16089,
lon: 24.72496
},
{
id: "U3RvcDpIU0w6MjMyMTI1Ng==",
lat: 60.16264,
lon: 24.72254
},
{
id: "U3RvcDpIU0w6MjMyMTIyNA==",
lat: 60.16351,
lon: 24.72134
},
{
id: "U3RvcDpIU0w6MjMyMTI1OA==",
lat: 60.165308,
lon: 24.718876
},
{
id: "U3RvcDpIU0w6MjMyMTI1OQ==",
lat: 60.16776,
lon: 24.71709
},
{
id: "U3RvcDpIU0w6MjMyMTIwMg==",
lat: 60.16991,
lon: 24.71221
}
]
},
{
gtfsId: "HSL:1043",
shortName: "43",
longName: "Elielinaukio-Kannelmäki-Kuninkaantammi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMzNDE5MQ==",
lat: 60.261947,
lon: 24.887087
},
{
id: "U3RvcDpIU0w6MTMzNTEwMA==",
lat: 60.259206,
lon: 24.893241
},
{
id: "U3RvcDpIU0w6MTMzNTEwNg==",
lat: 60.258881,
lon: 24.897496
},
{
id: "U3RvcDpIU0w6MTMzNDEwMg==",
lat: 60.256104,
lon: 24.897378
},
{
id: "U3RvcDpIU0w6MTMzNDE3NQ==",
lat: 60.25349,
lon: 24.89715
},
{
id: "U3RvcDpIU0w6MTMzMjE3Mw==",
lat: 60.25083,
lon: 24.89639
},
{
id: "U3RvcDpIU0w6MTMzNDE1OA==",
lat: 60.24811,
lon: 24.89359
},
{
id: "U3RvcDpIU0w6MTMzMjE3MQ==",
lat: 60.24513,
lon: 24.89214
},
{
id: "U3RvcDpIU0w6MTMzMTE2OQ==",
lat: 60.24392,
lon: 24.88774
},
{
id: "U3RvcDpIU0w6MTMzMTEyMQ==",
lat: 60.24193,
lon: 24.88495
},
{
id: "U3RvcDpIU0w6MTMzMTE0NQ==",
lat: 60.24217,
lon: 24.87891
},
{
id: "U3RvcDpIU0w6MTMzMTE0Ng==",
lat: 60.2421,
lon: 24.87657
},
{
id: "U3RvcDpIU0w6MTMzMTE2NA==",
lat: 60.24005,
lon: 24.87327
},
{
id: "U3RvcDpIU0w6MTMzMTE0MA==",
lat: 60.23876,
lon: 24.87507
},
{
id: "U3RvcDpIU0w6MTMzMTE2Nw==",
lat: 60.23711,
lon: 24.87955
},
{
id: "U3RvcDpIU0w6MTMzMTEwNQ==",
lat: 60.23819,
lon: 24.8833
},
{
id: "U3RvcDpIU0w6MTMzMTEwMw==",
lat: 60.23768,
lon: 24.88785
},
{
id: "U3RvcDpIU0w6MTI5MzEzNg==",
lat: 60.232533,
lon: 24.889442
},
{
id: "U3RvcDpIU0w6MTI5MzEzNQ==",
lat: 60.23103,
lon: 24.89271
},
{
id: "U3RvcDpIU0w6MTI5MzEzMw==",
lat: 60.228672,
lon: 24.894933
},
{
id: "U3RvcDpIU0w6MTI5MzEzMQ==",
lat: 60.22554,
lon: 24.89532
},
{
id: "U3RvcDpIU0w6MTI5MzEyNA==",
lat: 60.22408,
lon: 24.89863
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MzE1MQ==",
lat: 60.21912,
lon: 24.90824
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDI0Mw==",
lat: 60.172101,
lon: 24.939698
},
{
id: "U3RvcDpIU0w6MTEzMDExMQ==",
lat: 60.17419,
lon: 24.93349
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE2OA==",
lat: 60.22044,
lon: 24.90502
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzEyMw==",
lat: 60.22424,
lon: 24.89852
},
{
id: "U3RvcDpIU0w6MTI5MzEzMA==",
lat: 60.22566,
lon: 24.89553
},
{
id: "U3RvcDpIU0w6MTI5MzEzMg==",
lat: 60.22999,
lon: 24.895167
},
{
id: "U3RvcDpIU0w6MTI5MzEzNA==",
lat: 60.23137,
lon: 24.89199
},
{
id: "U3RvcDpIU0w6MTI5MzE3Mw==",
lat: 60.232603,
lon: 24.889643
},
{
id: "U3RvcDpIU0w6MTMzMTEwMg==",
lat: 60.23774,
lon: 24.8882
},
{
id: "U3RvcDpIU0w6MTMzMTEwNA==",
lat: 60.23819,
lon: 24.88278
},
{
id: "U3RvcDpIU0w6MTMzMTE2Ng==",
lat: 60.23698,
lon: 24.87849
},
{
id: "U3RvcDpIU0w6MTMzMTE0MQ==",
lat: 60.23908,
lon: 24.87474
},
{
id: "U3RvcDpIU0w6MTMzMTE2NQ==",
lat: 60.24008,
lon: 24.8736
},
{
id: "U3RvcDpIU0w6MTMzMTE0Nw==",
lat: 60.2417,
lon: 24.87604
},
{
id: "U3RvcDpIU0w6MTMzMTEyMA==",
lat: 60.2418,
lon: 24.87913
},
{
id: "U3RvcDpIU0w6MTMzMTEyMg==",
lat: 60.24254,
lon: 24.88549
},
{
id: "U3RvcDpIU0w6MTMzMTE2OA==",
lat: 60.24412,
lon: 24.8884
},
{
id: "U3RvcDpIU0w6MTMzMjEyOQ==",
lat: 60.24566,
lon: 24.89263
},
{
id: "U3RvcDpIU0w6MTMzMjE3MA==",
lat: 60.24874,
lon: 24.8942
},
{
id: "U3RvcDpIU0w6MTMzMjE3Mg==",
lat: 60.25131,
lon: 24.89707
},
{
id: "U3RvcDpIU0w6MTMzNDE3NA==",
lat: 60.25404,
lon: 24.89732
},
{
id: "U3RvcDpIU0w6MTMzNDE4Mw==",
lat: 60.25638,
lon: 24.89763
},
{
id: "U3RvcDpIU0w6MTMzNDEwMw==",
lat: 60.259036,
lon: 24.897553
},
{
id: "U3RvcDpIU0w6MTMzNTEwMQ==",
lat: 60.259171,
lon: 24.89265
},
{
id: "U3RvcDpIU0w6MTMzNDE5Mg==",
lat: 60.262201,
lon: 24.886778
}
]
},
{
gtfsId: "HSL:1042",
shortName: "42",
longName: "Kamppi-Maununneva-Kannelmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI3Mw==",
lat: 60.169066,
lon: 24.931895
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEwMg==",
lat: 60.180739,
lon: 24.921434
},
{
id: "U3RvcDpIU0w6MTE0MDEwNA==",
lat: 60.18484,
lon: 24.917
},
{
id: "U3RvcDpIU0w6MTE1MDEwMQ==",
lat: 60.19064,
lon: 24.91098
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjE1OQ==",
lat: 60.23883,
lon: 24.90236
},
{
id: "U3RvcDpIU0w6MTMzMjE2MQ==",
lat: 60.24445,
lon: 24.89929
},
{
id: "U3RvcDpIU0w6MTMzMjEyOQ==",
lat: 60.24566,
lon: 24.89263
},
{
id: "U3RvcDpIU0w6MTMzNDEyMw==",
lat: 60.24843,
lon: 24.89235
},
{
id: "U3RvcDpIU0w6MTMzNDExNQ==",
lat: 60.24783,
lon: 24.88898
},
{
id: "U3RvcDpIU0w6MTMzMTExNw==",
lat: 60.24651,
lon: 24.8842
},
{
id: "U3RvcDpIU0w6MTMzMTEyNQ==",
lat: 60.24486,
lon: 24.88276
},
{
id: "U3RvcDpIU0w6MTMzMTEyMQ==",
lat: 60.24193,
lon: 24.88495
},
{
id: "U3RvcDpIU0w6MTMzMTE0NQ==",
lat: 60.24217,
lon: 24.87891
},
{
id: "U3RvcDpIU0w6MTMzMTE0Ng==",
lat: 60.2421,
lon: 24.87657
},
{
id: "U3RvcDpIU0w6MTMzMTE1Ng==",
lat: 60.2408,
lon: 24.87316
},
{
id: "U3RvcDpIU0w6MTMzMTE0Nw==",
lat: 60.2417,
lon: 24.87604
},
{
id: "U3RvcDpIU0w6MTMzMTEyMA==",
lat: 60.2418,
lon: 24.87913
},
{
id: "U3RvcDpIU0w6MTMzMTEyMg==",
lat: 60.24254,
lon: 24.88549
},
{
id: "U3RvcDpIU0w6MTMzMTEyNA==",
lat: 60.24517,
lon: 24.88233
},
{
id: "U3RvcDpIU0w6MTMzMTExOA==",
lat: 60.24689,
lon: 24.88549
},
{
id: "U3RvcDpIU0w6MTMzNDExNg==",
lat: 60.24781,
lon: 24.89005
},
{
id: "U3RvcDpIU0w6MTMzNDE1OA==",
lat: 60.24811,
lon: 24.89359
},
{
id: "U3RvcDpIU0w6MTMzMjE2Mw==",
lat: 60.24515,
lon: 24.89424
},
{
id: "U3RvcDpIU0w6MTMzMjE2Mg==",
lat: 60.24347,
lon: 24.89929
},
{
id: "U3RvcDpIU0w6MTMzMjE2MA==",
lat: 60.23833,
lon: 24.90182
},
{
id: "U3RvcDpIU0w6MTMzMjEzOA==",
lat: 60.236106,
lon: 24.90268
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE1MDEwMg==",
lat: 60.19039,
lon: 24.91095
},
{
id: "U3RvcDpIU0w6MTE0MDEwNg==",
lat: 60.18579,
lon: 24.91579
},
{
id: "U3RvcDpIU0w6MTE0MDEyMg==",
lat: 60.17944,
lon: 24.92255
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
}
]
},
{
gtfsId: "HSL:1041",
shortName: "41",
longName: "Kamppi-Haaga-Kannelmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI3Mg==",
lat: 60.169092,
lon: 24.931967
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEwMg==",
lat: 60.180739,
lon: 24.921434
},
{
id: "U3RvcDpIU0w6MTE0MDEwNA==",
lat: 60.18484,
lon: 24.917
},
{
id: "U3RvcDpIU0w6MTE1MDEwMQ==",
lat: 60.19064,
lon: 24.91098
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEwMg==",
lat: 60.20967,
lon: 24.89578
},
{
id: "U3RvcDpIU0w6MTI5MTEwNA==",
lat: 60.2123,
lon: 24.89835
},
{
id: "U3RvcDpIU0w6MTI5MTEwNg==",
lat: 60.21582,
lon: 24.898291
},
{
id: "U3RvcDpIU0w6MTI5MTEyMw==",
lat: 60.21762,
lon: 24.89964
},
{
id: "U3RvcDpIU0w6MTI5MTEyNQ==",
lat: 60.21965,
lon: 24.90171
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzEyMw==",
lat: 60.22424,
lon: 24.89852
},
{
id: "U3RvcDpIU0w6MTI5MzEzMA==",
lat: 60.22566,
lon: 24.89553
},
{
id: "U3RvcDpIU0w6MTI5MzEzMg==",
lat: 60.22999,
lon: 24.895167
},
{
id: "U3RvcDpIU0w6MTI5MzEzNA==",
lat: 60.23137,
lon: 24.89199
},
{
id: "U3RvcDpIU0w6MTI5MzE3Mw==",
lat: 60.232603,
lon: 24.889643
},
{
id: "U3RvcDpIU0w6MTMzMTEwMg==",
lat: 60.23774,
lon: 24.8882
},
{
id: "U3RvcDpIU0w6MTMzMTEwNA==",
lat: 60.23819,
lon: 24.88278
},
{
id: "U3RvcDpIU0w6MTMzMTEwNg==",
lat: 60.23635,
lon: 24.87644
},
{
id: "U3RvcDpIU0w6MTMzMTEwOA==",
lat: 60.23538,
lon: 24.87
},
{
id: "U3RvcDpIU0w6MTMzMTEwNw==",
lat: 60.2363,
lon: 24.8767
},
{
id: "U3RvcDpIU0w6MTMzMTE2Nw==",
lat: 60.23711,
lon: 24.87955
},
{
id: "U3RvcDpIU0w6MTMzMTEwNQ==",
lat: 60.23819,
lon: 24.8833
},
{
id: "U3RvcDpIU0w6MTMzMTEwMw==",
lat: 60.23768,
lon: 24.88785
},
{
id: "U3RvcDpIU0w6MTI5MzEzNg==",
lat: 60.232533,
lon: 24.889442
},
{
id: "U3RvcDpIU0w6MTI5MzEzNQ==",
lat: 60.23103,
lon: 24.89271
},
{
id: "U3RvcDpIU0w6MTI5MzEzMw==",
lat: 60.228672,
lon: 24.894933
},
{
id: "U3RvcDpIU0w6MTI5MzEzMQ==",
lat: 60.22554,
lon: 24.89532
},
{
id: "U3RvcDpIU0w6MTI5MzEyNA==",
lat: 60.22408,
lon: 24.89863
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MTEyNA==",
lat: 60.21848,
lon: 24.89938
},
{
id: "U3RvcDpIU0w6MTI5MTEwNw==",
lat: 60.215112,
lon: 24.898336
},
{
id: "U3RvcDpIU0w6MTI5MTEwNQ==",
lat: 60.21229,
lon: 24.89817
},
{
id: "U3RvcDpIU0w6MTI5MTEwMw==",
lat: 60.20979,
lon: 24.89576
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE1MDEwMg==",
lat: 60.19039,
lon: 24.91095
},
{
id: "U3RvcDpIU0w6MTE0MDEwNg==",
lat: 60.18579,
lon: 24.91579
},
{
id: "U3RvcDpIU0w6MTE0MDEyMg==",
lat: 60.17944,
lon: 24.92255
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
}
]
},
{
gtfsId: "HSL:1040",
shortName: "40",
longName: "Elielinaukio-Pohjois-Haagan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTI5NDE0MA==",
lat: 60.229936,
lon: 24.883347
},
{
id: "U3RvcDpIU0w6MTI5NDEzOQ==",
lat: 60.23079,
lon: 24.8821
},
{
id: "U3RvcDpIU0w6MTI5MzEzNg==",
lat: 60.232533,
lon: 24.889442
},
{
id: "U3RvcDpIU0w6MTI5MzEzNQ==",
lat: 60.23103,
lon: 24.89271
},
{
id: "U3RvcDpIU0w6MTI5MzEzMw==",
lat: 60.228672,
lon: 24.894933
},
{
id: "U3RvcDpIU0w6MTI5MzEzMQ==",
lat: 60.22554,
lon: 24.89532
},
{
id: "U3RvcDpIU0w6MTI5MzEyNA==",
lat: 60.22408,
lon: 24.89863
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MTEyNA==",
lat: 60.21848,
lon: 24.89938
},
{
id: "U3RvcDpIU0w6MTI5MTEwNw==",
lat: 60.215112,
lon: 24.898336
},
{
id: "U3RvcDpIU0w6MTI5MTEwNQ==",
lat: 60.21229,
lon: 24.89817
},
{
id: "U3RvcDpIU0w6MTI5MTEwMw==",
lat: 60.20979,
lon: 24.89576
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDI0MQ==",
lat: 60.172041,
lon: 24.939704
},
{
id: "U3RvcDpIU0w6MTEzMDExMQ==",
lat: 60.17419,
lon: 24.93349
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEwMg==",
lat: 60.20967,
lon: 24.89578
},
{
id: "U3RvcDpIU0w6MTI5MTEwNA==",
lat: 60.2123,
lon: 24.89835
},
{
id: "U3RvcDpIU0w6MTI5MTEwNg==",
lat: 60.21582,
lon: 24.898291
},
{
id: "U3RvcDpIU0w6MTI5MTEyMw==",
lat: 60.21762,
lon: 24.89964
},
{
id: "U3RvcDpIU0w6MTI5MTEyNQ==",
lat: 60.21965,
lon: 24.90171
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzEyMw==",
lat: 60.22424,
lon: 24.89852
},
{
id: "U3RvcDpIU0w6MTI5MzEzMA==",
lat: 60.22566,
lon: 24.89553
},
{
id: "U3RvcDpIU0w6MTI5MzEzMg==",
lat: 60.22999,
lon: 24.895167
},
{
id: "U3RvcDpIU0w6MTI5MzEzNA==",
lat: 60.23137,
lon: 24.89199
},
{
id: "U3RvcDpIU0w6MTI5NDEzNw==",
lat: 60.23296,
lon: 24.88799
},
{
id: "U3RvcDpIU0w6MTI5NDE0MQ==",
lat: 60.230629,
lon: 24.881719
}
]
},
{
gtfsId: "HSL:1094A",
shortName: "94A",
longName: "Kotikonnuntie-Kontula(M)-Kivikko-Kontula(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MTEyMg==",
lat: 60.243524,
lon: 25.087752
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mg==",
lat: 60.241694,
lon: 25.086211
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MA==",
lat: 60.23846,
lon: 25.0869
},
{
id: "U3RvcDpIU0w6MTQ3MTExNw==",
lat: 60.23608,
lon: 25.08512
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOA==",
lat: 60.235943,
lon: 25.080696
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NA==",
lat: 60.23335,
lon: 25.07789
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mg==",
lat: 60.231,
lon: 25.0756
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Ng==",
lat: 60.22852,
lon: 25.07353
},
{
id: "U3RvcDpIU0w6MTQ3MTE3OA==",
lat: 60.22896,
lon: 25.06766
},
{
id: "U3RvcDpIU0w6MTQ3MTE4MA==",
lat: 60.23153,
lon: 25.06444
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMQ==",
lat: 60.23361,
lon: 25.0628
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMw==",
lat: 60.23707,
lon: 25.06766
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNQ==",
lat: 60.23879,
lon: 25.06735
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNw==",
lat: 60.24025,
lon: 25.07194
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mg==",
lat: 60.23916,
lon: 25.07499
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MA==",
lat: 60.23795,
lon: 25.07819
},
{
id: "U3RvcDpIU0w6MTQ3MTE4OQ==",
lat: 60.236731,
lon: 25.081263
},
{
id: "U3RvcDpIU0w6MTQ3MTE3OQ==",
lat: 60.23602,
lon: 25.0822
},
{
id: "U3RvcDpIU0w6MTQ3MTExOA==",
lat: 60.23638,
lon: 25.08713
},
{
id: "U3RvcDpIU0w6MTQ3MTE0OQ==",
lat: 60.23947,
lon: 25.0862
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MQ==",
lat: 60.24156,
lon: 25.08644
},
{
id: "U3RvcDpIU0w6MTQ3MTExMw==",
lat: 60.243553,
lon: 25.087703
}
]
},
{
gtfsId: "HSL:1039",
shortName: "39",
longName: "Kamppi-Munkkiniemi-Konala-Malminkartano-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDE0NA==",
lat: 60.169432,
lon: 24.930045
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEyNw==",
lat: 60.180264,
lon: 24.921903
},
{
id: "U3RvcDpIU0w6MTE0MDEyOQ==",
lat: 60.18153,
lon: 24.92058
},
{
id: "U3RvcDpIU0w6MTE0MDEzMQ==",
lat: 60.18341,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE0MDEzMw==",
lat: 60.18581,
lon: 24.91596
},
{
id: "U3RvcDpIU0w6MTE1MDEwNw==",
lat: 60.189912,
lon: 24.909831
},
{
id: "U3RvcDpIU0w6MTE1MDEwOQ==",
lat: 60.19067,
lon: 24.90781
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MTMwNDEyNw==",
lat: 60.20289,
lon: 24.88189
},
{
id: "U3RvcDpIU0w6MTMwNDEzNg==",
lat: 60.20573,
lon: 24.88058
},
{
id: "U3RvcDpIU0w6MTI5MTEzOA==",
lat: 60.21059,
lon: 24.8809
},
{
id: "U3RvcDpIU0w6MTQ2NTE3Nw==",
lat: 60.213022,
lon: 24.879553
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzExNQ==",
lat: 60.22716,
lon: 24.85318
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MA==",
lat: 60.2288,
lon: 24.84913
},
{
id: "U3RvcDpIU0w6MTMyMDEwMQ==",
lat: 60.23253,
lon: 24.84661
},
{
id: "U3RvcDpIU0w6MTMyMDEwMw==",
lat: 60.23558,
lon: 24.84705
},
{
id: "U3RvcDpIU0w6MTMyMDEwNw==",
lat: 60.239,
lon: 24.84645
},
{
id: "U3RvcDpIU0w6MTMyMDEwOA==",
lat: 60.2415,
lon: 24.84299
},
{
id: "U3RvcDpIU0w6MTMyMDEyMw==",
lat: 60.24408,
lon: 24.8468
},
{
id: "U3RvcDpIU0w6MTMzMzEwMw==",
lat: 60.246561,
lon: 24.852388
},
{
id: "U3RvcDpIU0w6MTMzMzE3Ng==",
lat: 60.24805,
lon: 24.8595
},
{
id: "U3RvcDpIU0w6MTMzMzIzNw==",
lat: 60.25135,
lon: 24.86674
},
{
id: "U3RvcDpIU0w6NDE2MDIzMQ==",
lat: 60.255061,
lon: 24.870703
},
{
id: "U3RvcDpIU0w6NDE2MDIyNQ==",
lat: 60.25685,
lon: 24.87225
},
{
id: "U3RvcDpIU0w6NDE2MDIyMw==",
lat: 60.26171,
lon: 24.8718
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE1MDIxOQ==",
lat: 60.26394,
lon: 24.85928
},
{
id: "U3RvcDpIU0w6NDE1MDIwNQ==",
lat: 60.26146,
lon: 24.85579
},
{
id: "U3RvcDpIU0w6NDE1MDI2Mw==",
lat: 60.26109,
lon: 24.856
},
{
id: "U3RvcDpIU0w6NDE1MDIyMA==",
lat: 60.26371,
lon: 24.85947
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6NDE2MDIyMg==",
lat: 60.26189,
lon: 24.87109
},
{
id: "U3RvcDpIU0w6NDE2MDIyNA==",
lat: 60.25712,
lon: 24.87201
},
{
id: "U3RvcDpIU0w6NDE2MDIzMA==",
lat: 60.254083,
lon: 24.868954
},
{
id: "U3RvcDpIU0w6MTMzMzIzOA==",
lat: 60.25135,
lon: 24.86642
},
{
id: "U3RvcDpIU0w6MTMzMzE3Nw==",
lat: 60.24767,
lon: 24.85723
},
{
id: "U3RvcDpIU0w6MTMzMzEwMg==",
lat: 60.246671,
lon: 24.852127
},
{
id: "U3RvcDpIU0w6MTMyMDExMQ==",
lat: 60.24432,
lon: 24.8467
},
{
id: "U3RvcDpIU0w6MTMyMDEwOQ==",
lat: 60.24161,
lon: 24.84268
},
{
id: "U3RvcDpIU0w6MTMyMDEwNQ==",
lat: 60.23761,
lon: 24.84672
},
{
id: "U3RvcDpIU0w6MTMyMDEwNA==",
lat: 60.23512,
lon: 24.84651
},
{
id: "U3RvcDpIU0w6MTMyMDEwMg==",
lat: 60.23233,
lon: 24.84636
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MQ==",
lat: 60.22888,
lon: 24.84861
},
{
id: "U3RvcDpIU0w6MTQ2MzExNg==",
lat: 60.22633,
lon: 24.85406
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTEzOQ==",
lat: 60.21066,
lon: 24.8805
},
{
id: "U3RvcDpIU0w6MTMwNDEzNw==",
lat: 60.206219,
lon: 24.879857
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyNA==",
lat: 60.19618,
lon: 24.88529
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
},
{
id: "U3RvcDpIU0w6MTE1MDEwOA==",
lat: 60.188734,
lon: 24.912259
},
{
id: "U3RvcDpIU0w6MTE0MDEwNQ==",
lat: 60.18479,
lon: 24.91689
},
{
id: "U3RvcDpIU0w6MTE0MDEzMA==",
lat: 60.18142,
lon: 24.92043
},
{
id: "U3RvcDpIU0w6MTE0MDEwMw==",
lat: 60.17966,
lon: 24.92227
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEwOQ==",
lat: 60.17083,
lon: 24.92517
},
{
id: "U3RvcDpIU0w6MTA0MDExNQ==",
lat: 60.168775,
lon: 24.92859
}
]
},
{
gtfsId: "HSL:1037",
shortName: "37",
longName: "Kamppi - Honkasuo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMzMzEwNA==",
lat: 60.255621,
lon: 24.845597
},
{
id: "U3RvcDpIU0w6MTMzMzEwNQ==",
lat: 60.251343,
lon: 24.85015
},
{
id: "U3RvcDpIU0w6MTMzMzE4MQ==",
lat: 60.25016,
lon: 24.85356
},
{
id: "U3RvcDpIU0w6MTMzMzE4NQ==",
lat: 60.248694,
lon: 24.854632
},
{
id: "U3RvcDpIU0w6MTMzMzE3Ng==",
lat: 60.24805,
lon: 24.8595
},
{
id: "U3RvcDpIU0w6MTMzMzE3OA==",
lat: 60.24943,
lon: 24.86572
},
{
id: "U3RvcDpIU0w6MTMzMzE1Mw==",
lat: 60.24735,
lon: 24.86365
},
{
id: "U3RvcDpIU0w6MTMzMzE1NQ==",
lat: 60.24437,
lon: 24.86564
},
{
id: "U3RvcDpIU0w6MTMzMzE1MQ==",
lat: 60.24296,
lon: 24.86277
},
{
id: "U3RvcDpIU0w6MTMzMzEzNg==",
lat: 60.24158,
lon: 24.85913
},
{
id: "U3RvcDpIU0w6MTMzMzEzNA==",
lat: 60.24337,
lon: 24.85421
},
{
id: "U3RvcDpIU0w6MTMzMzE0OQ==",
lat: 60.24522,
lon: 24.85092
},
{
id: "U3RvcDpIU0w6MTMyMDExMQ==",
lat: 60.24432,
lon: 24.8467
},
{
id: "U3RvcDpIU0w6MTMyMDEyMA==",
lat: 60.239267,
lon: 24.852589
},
{
id: "U3RvcDpIU0w6MTQ2MzExOA==",
lat: 60.23293,
lon: 24.86311
},
{
id: "U3RvcDpIU0w6MTI5NDEyNA==",
lat: 60.227,
lon: 24.87358
},
{
id: "U3RvcDpIU0w6MTI5NDEyMg==",
lat: 60.22447,
lon: 24.87771
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mw==",
lat: 60.21865,
lon: 24.8815
},
{
id: "U3RvcDpIU0w6MTI5MTE4MQ==",
lat: 60.215735,
lon: 24.883378
},
{
id: "U3RvcDpIU0w6MTI5MTExOQ==",
lat: 60.209999,
lon: 24.888297
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE1MDEwMg==",
lat: 60.19039,
lon: 24.91095
},
{
id: "U3RvcDpIU0w6MTE0MDEwNg==",
lat: 60.18579,
lon: 24.91579
},
{
id: "U3RvcDpIU0w6MTE0MDEyMg==",
lat: 60.17944,
lon: 24.92255
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
},
{
id: "U3RvcDpIU0w6MTA0MDI3MQ==",
lat: 60.169119,
lon: 24.932058
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEwMg==",
lat: 60.180739,
lon: 24.921434
},
{
id: "U3RvcDpIU0w6MTE0MDEwNA==",
lat: 60.18484,
lon: 24.917
},
{
id: "U3RvcDpIU0w6MTE1MDEwMQ==",
lat: 60.19064,
lon: 24.91098
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEyMA==",
lat: 60.20988,
lon: 24.88902
},
{
id: "U3RvcDpIU0w6MTI5MTE4MA==",
lat: 60.21517,
lon: 24.88415
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mg==",
lat: 60.21988,
lon: 24.88124
},
{
id: "U3RvcDpIU0w6MTI5NDEyMQ==",
lat: 60.22517,
lon: 24.87707
},
{
id: "U3RvcDpIU0w6MTQ2NDEyMw==",
lat: 60.22792,
lon: 24.87272
},
{
id: "U3RvcDpIU0w6MTQ2MzExNw==",
lat: 60.23393,
lon: 24.862
},
{
id: "U3RvcDpIU0w6MTMyMDExOQ==",
lat: 60.2387,
lon: 24.85418
},
{
id: "U3RvcDpIU0w6MTMyMDEyMw==",
lat: 60.24408,
lon: 24.8468
},
{
id: "U3RvcDpIU0w6MTMzMzE0OA==",
lat: 60.2445,
lon: 24.85189
},
{
id: "U3RvcDpIU0w6MTMzMzEzMw==",
lat: 60.24283,
lon: 24.85485
},
{
id: "U3RvcDpIU0w6MTMzMzEzNQ==",
lat: 60.2417,
lon: 24.86011
},
{
id: "U3RvcDpIU0w6MTMzMzE1MA==",
lat: 60.24376,
lon: 24.86397
},
{
id: "U3RvcDpIU0w6MTMzMzE1NA==",
lat: 60.24486,
lon: 24.86533
},
{
id: "U3RvcDpIU0w6MTMzMzE1Mg==",
lat: 60.24798,
lon: 24.86433
},
{
id: "U3RvcDpIU0w6MTMzMzE3OQ==",
lat: 60.24954,
lon: 24.86576
},
{
id: "U3RvcDpIU0w6MTMzMzE3Nw==",
lat: 60.24767,
lon: 24.85723
},
{
id: "U3RvcDpIU0w6MTMzMzE4NA==",
lat: 60.248666,
lon: 24.854758
},
{
id: "U3RvcDpIU0w6MTMzMzE4MA==",
lat: 60.25018,
lon: 24.85415
},
{
id: "U3RvcDpIU0w6MTMzMzEwNg==",
lat: 60.251215,
lon: 24.849189
},
{
id: "U3RvcDpIU0w6MTMzMzEwNw==",
lat: 60.255644,
lon: 24.844794
}
]
},
{
gtfsId: "HSL:2246",
shortName: "246",
longName: "Espoon keskus-Röylä-Bodom-Espoon keskus",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYxNDI4Ng==",
lat: 60.22219,
lon: 24.66789
},
{
id: "U3RvcDpIU0w6MjYzNDI3OQ==",
lat: 60.22482,
lon: 24.67003
},
{
id: "U3RvcDpIU0w6MjYzMzIwMg==",
lat: 60.22794,
lon: 24.66676
},
{
id: "U3RvcDpIU0w6MjYzNDI3Nw==",
lat: 60.22894,
lon: 24.66508
},
{
id: "U3RvcDpIU0w6MjYzNDI3Ng==",
lat: 60.23321,
lon: 24.65923
},
{
id: "U3RvcDpIU0w6MjYzNDI2MQ==",
lat: 60.23591,
lon: 24.65655
},
{
id: "U3RvcDpIU0w6MjYzNDI3NQ==",
lat: 60.23899,
lon: 24.65577
},
{
id: "U3RvcDpIU0w6MjYzNDI2Mw==",
lat: 60.24418,
lon: 24.65407
},
{
id: "U3RvcDpIU0w6MjYzNTIyMg==",
lat: 60.2502,
lon: 24.65506
},
{
id: "U3RvcDpIU0w6MjYzNTIyNg==",
lat: 60.25515,
lon: 24.65259
},
{
id: "U3RvcDpIU0w6MjYzNTI2NQ==",
lat: 60.26227,
lon: 24.65307
},
{
id: "U3RvcDpIU0w6MjYzNTI2Nw==",
lat: 60.268937,
lon: 24.653134
},
{
id: "U3RvcDpIU0w6MjYzNTIyNA==",
lat: 60.273911,
lon: 24.656377
},
{
id: "U3RvcDpIU0w6MjcxMTI2Ng==",
lat: 60.27479,
lon: 24.66714
},
{
id: "U3RvcDpIU0w6MjcxMTI2OQ==",
lat: 60.2839,
lon: 24.67614
},
{
id: "U3RvcDpIU0w6MjcxMTI3MQ==",
lat: 60.28908,
lon: 24.67804
},
{
id: "U3RvcDpIU0w6MjcxMTIwMw==",
lat: 60.29528,
lon: 24.6864
},
{
id: "U3RvcDpIU0w6MjcxMjAwMg==",
lat: 60.297265,
lon: 24.691783
},
{
id: "U3RvcDpIU0w6MjcxMTI3NA==",
lat: 60.29655,
lon: 24.69787
},
{
id: "U3RvcDpIU0w6MjcxMTI3Ng==",
lat: 60.28525,
lon: 24.70586
},
{
id: "U3RvcDpIU0w6MjcxNDI4Nw==",
lat: 60.28069,
lon: 24.71109
},
{
id: "U3RvcDpIU0w6MjcxNDI3OA==",
lat: 60.27783,
lon: 24.71334
},
{
id: "U3RvcDpIU0w6MjcxNDIwMQ==",
lat: 60.27483,
lon: 24.71475
},
{
id: "U3RvcDpIU0w6MjcxMjIwMw==",
lat: 60.27151,
lon: 24.70998
},
{
id: "U3RvcDpIU0w6MjcxMjIwNQ==",
lat: 60.26756,
lon: 24.70833
},
{
id: "U3RvcDpIU0w6MjcxMjIxMQ==",
lat: 60.26601,
lon: 24.70654
},
{
id: "U3RvcDpIU0w6MjcxMjIxMA==",
lat: 60.26097,
lon: 24.70608
},
{
id: "U3RvcDpIU0w6MjcxMjIwNw==",
lat: 60.25929,
lon: 24.7012
},
{
id: "U3RvcDpIU0w6MjcxMjI1OQ==",
lat: 60.26231,
lon: 24.69151
},
{
id: "U3RvcDpIU0w6MjcxMjIxMg==",
lat: 60.264893,
lon: 24.691065
},
{
id: "U3RvcDpIU0w6MjcxMjI2MQ==",
lat: 60.26783,
lon: 24.69017
},
{
id: "U3RvcDpIU0w6MjcxMjI2Mw==",
lat: 60.27116,
lon: 24.68959
},
{
id: "U3RvcDpIU0w6MjcxMjI2NQ==",
lat: 60.2748,
lon: 24.68059
},
{
id: "U3RvcDpIU0w6MjcxMTI2Nw==",
lat: 60.27483,
lon: 24.66649
},
{
id: "U3RvcDpIU0w6MjcxMTI2OA==",
lat: 60.274001,
lon: 24.656342
},
{
id: "U3RvcDpIU0w6MjYzNTI2Ng==",
lat: 60.268029,
lon: 24.653459
},
{
id: "U3RvcDpIU0w6MjYzNTI2NA==",
lat: 60.2623,
lon: 24.653
},
{
id: "U3RvcDpIU0w6MjYzNTIyNQ==",
lat: 60.25477,
lon: 24.65249
},
{
id: "U3RvcDpIU0w6MjYzNTIyMw==",
lat: 60.25019,
lon: 24.65483
},
{
id: "U3RvcDpIU0w6MjYzNDI2Mg==",
lat: 60.244566,
lon: 24.653642
},
{
id: "U3RvcDpIU0w6MjYzNDI3MA==",
lat: 60.23815,
lon: 24.65545
},
{
id: "U3RvcDpIU0w6MjYzNDI2MA==",
lat: 60.23559,
lon: 24.6576
},
{
id: "U3RvcDpIU0w6MjYzNDI3Mg==",
lat: 60.2328,
lon: 24.65912
},
{
id: "U3RvcDpIU0w6MjYzNDI3NA==",
lat: 60.22863,
lon: 24.66523
},
{
id: "U3RvcDpIU0w6MjYzNDIwMw==",
lat: 60.22727,
lon: 24.6678
},
{
id: "U3RvcDpIU0w6MjYzNDI3OA==",
lat: 60.2243,
lon: 24.66961
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
}
]
},
{
gtfsId: "HSL:1036",
shortName: "36",
longName: "Konala-Kannelmäki-Maununneva-Pirkkola",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTI4MTExMA==",
lat: 60.232525,
lon: 24.909947
},
{
id: "U3RvcDpIU0w6MTMzMjE1OQ==",
lat: 60.23883,
lon: 24.90236
},
{
id: "U3RvcDpIU0w6MTMzMjEyNA==",
lat: 60.243589,
lon: 24.903085
},
{
id: "U3RvcDpIU0w6MTMzMjEyMg==",
lat: 60.246062,
lon: 24.905048
},
{
id: "U3RvcDpIU0w6MTMzMjEyMA==",
lat: 60.249116,
lon: 24.904591
},
{
id: "U3RvcDpIU0w6MTMzMjExOA==",
lat: 60.251925,
lon: 24.90009
},
{
id: "U3RvcDpIU0w6MTMzMjExNg==",
lat: 60.249901,
lon: 24.898707
},
{
id: "U3RvcDpIU0w6MTMzNDE2Ng==",
lat: 60.248988,
lon: 24.892772
},
{
id: "U3RvcDpIU0w6MTMzNDE4OA==",
lat: 60.251335,
lon: 24.888752
},
{
id: "U3RvcDpIU0w6MTMzNDE5MA==",
lat: 60.252857,
lon: 24.885282
},
{
id: "U3RvcDpIU0w6MTMzNDE4OQ==",
lat: 60.250887,
lon: 24.888992
},
{
id: "U3RvcDpIU0w6MTMzNDEyMw==",
lat: 60.24843,
lon: 24.89235
},
{
id: "U3RvcDpIU0w6MTMzNDExNQ==",
lat: 60.24783,
lon: 24.88898
},
{
id: "U3RvcDpIU0w6MTMzMTExNw==",
lat: 60.24651,
lon: 24.8842
},
{
id: "U3RvcDpIU0w6MTMzMTE5Mg==",
lat: 60.246838,
lon: 24.878865
},
{
id: "U3RvcDpIU0w6MTMzMTEyNQ==",
lat: 60.24486,
lon: 24.88276
},
{
id: "U3RvcDpIU0w6MTMzMTEyMQ==",
lat: 60.24193,
lon: 24.88495
},
{
id: "U3RvcDpIU0w6MTMzMTE0NQ==",
lat: 60.24217,
lon: 24.87891
},
{
id: "U3RvcDpIU0w6MTMzMTExMw==",
lat: 60.243568,
lon: 24.872272
},
{
id: "U3RvcDpIU0w6MTMzMTExNg==",
lat: 60.242838,
lon: 24.875765
},
{
id: "U3RvcDpIU0w6MTMzMTE0Ng==",
lat: 60.2421,
lon: 24.87657
},
{
id: "U3RvcDpIU0w6MTMzMTE2NA==",
lat: 60.24005,
lon: 24.87327
},
{
id: "U3RvcDpIU0w6MTMzMTE0MA==",
lat: 60.23876,
lon: 24.87507
},
{
id: "U3RvcDpIU0w6MTMzMTExMQ==",
lat: 60.237441,
lon: 24.877218
},
{
id: "U3RvcDpIU0w6MTMzMTE2Nw==",
lat: 60.23711,
lon: 24.87955
},
{
id: "U3RvcDpIU0w6MTMzMTEwMA==",
lat: 60.23927,
lon: 24.878825
},
{
id: "U3RvcDpIU0w6MTMzMTEwMw==",
lat: 60.23768,
lon: 24.88785
},
{
id: "U3RvcDpIU0w6MTMzMTExNA==",
lat: 60.236354,
lon: 24.889709
},
{
id: "U3RvcDpIU0w6MTI5NDEzNw==",
lat: 60.23296,
lon: 24.88799
},
{
id: "U3RvcDpIU0w6MTI5NDE0MQ==",
lat: 60.230629,
lon: 24.881719
},
{
id: "U3RvcDpIU0w6MTI5NDE0Mg==",
lat: 60.22844,
lon: 24.87667
},
{
id: "U3RvcDpIU0w6MTQ2NTEzMQ==",
lat: 60.22716,
lon: 24.87217
},
{
id: "U3RvcDpIU0w6MTQ2NTEzMw==",
lat: 60.22509,
lon: 24.86806
},
{
id: "U3RvcDpIU0w6MTQ2NDEzNQ==",
lat: 60.22389,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzExNQ==",
lat: 60.22716,
lon: 24.85318
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MA==",
lat: 60.2288,
lon: 24.84913
},
{
id: "U3RvcDpIU0w6MTMyMDEwMQ==",
lat: 60.23253,
lon: 24.84661
},
{
id: "U3RvcDpIU0w6MTMyMDExOA==",
lat: 60.232886,
lon: 24.849148
},
{
id: "U3RvcDpIU0w6MTMyMDEyNQ==",
lat: 60.234563,
lon: 24.853708
},
{
id: "U3RvcDpIU0w6MTMyMDEyNg==",
lat: 60.235462,
lon: 24.850975
},
{
id: "U3RvcDpIU0w6MTMyMDEyOA==",
lat: 60.238051,
lon: 24.845835
},
{
id: "U3RvcDpIU0w6MTMyMDEyOQ==",
lat: 60.237466,
lon: 24.842731
},
{
id: "U3RvcDpIU0w6MTMyMDEzMA==",
lat: 60.23657,
lon: 24.842218
},
{
id: "U3RvcDpIU0w6MTMyMDEzNA==",
lat: 60.238698,
lon: 24.849787
},
{
id: "U3RvcDpIU0w6MTMyMDEzMg==",
lat: 60.243752,
lon: 24.839943
},
{
id: "U3RvcDpIU0w6MTMyMDE5MQ==",
lat: 60.245527,
lon: 24.83805
},
{
id: "U3RvcDpIU0w6MTMyMDEzMQ==",
lat: 60.243767,
lon: 24.839647
},
{
id: "U3RvcDpIU0w6MTMyMDEyMw==",
lat: 60.24408,
lon: 24.8468
},
{
id: "U3RvcDpIU0w6MTMyMDEzMw==",
lat: 60.245633,
lon: 24.84631
},
{
id: "U3RvcDpIU0w6MTMyMDExMQ==",
lat: 60.24432,
lon: 24.8467
},
{
id: "U3RvcDpIU0w6MTMyMDEzNQ==",
lat: 60.238741,
lon: 24.849398
},
{
id: "U3RvcDpIU0w6MTMyMDEwNQ==",
lat: 60.23761,
lon: 24.84672
},
{
id: "U3RvcDpIU0w6MTMyMDEyNw==",
lat: 60.235471,
lon: 24.850569
},
{
id: "U3RvcDpIU0w6MTMyMDEyNA==",
lat: 60.234503,
lon: 24.853478
},
{
id: "U3RvcDpIU0w6MTMyMDExNw==",
lat: 60.232967,
lon: 24.850635
},
{
id: "U3RvcDpIU0w6MTMyMDEwMg==",
lat: 60.23233,
lon: 24.84636
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MQ==",
lat: 60.22888,
lon: 24.84861
},
{
id: "U3RvcDpIU0w6MTQ2MzExNg==",
lat: 60.22633,
lon: 24.85406
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTEzNg==",
lat: 60.22436,
lon: 24.8672
},
{
id: "U3RvcDpIU0w6MTQ2NTEzNA==",
lat: 60.2258,
lon: 24.8696
},
{
id: "U3RvcDpIU0w6MTI5NDEzMg==",
lat: 60.22769,
lon: 24.87405
},
{
id: "U3RvcDpIU0w6MTI5NDE0Mw==",
lat: 60.22838,
lon: 24.87708
},
{
id: "U3RvcDpIU0w6MTI5NDEzOQ==",
lat: 60.23079,
lon: 24.8821
},
{
id: "U3RvcDpIU0w6MTI5MzEzOA==",
lat: 60.23275,
lon: 24.88788
},
{
id: "U3RvcDpIU0w6MTMzMTEwMg==",
lat: 60.23774,
lon: 24.8882
},
{
id: "U3RvcDpIU0w6MTMzMTEwNA==",
lat: 60.23819,
lon: 24.88278
},
{
id: "U3RvcDpIU0w6MTMzMTE2Ng==",
lat: 60.23698,
lon: 24.87849
},
{
id: "U3RvcDpIU0w6MTMzMTExMg==",
lat: 60.237389,
lon: 24.877299
},
{
id: "U3RvcDpIU0w6MTMzMTE0MQ==",
lat: 60.23908,
lon: 24.87474
},
{
id: "U3RvcDpIU0w6MTMzMTE2NQ==",
lat: 60.24008,
lon: 24.8736
},
{
id: "U3RvcDpIU0w6MTMzMTE0Nw==",
lat: 60.2417,
lon: 24.87604
},
{
id: "U3RvcDpIU0w6MTMzMTEyMA==",
lat: 60.2418,
lon: 24.87913
},
{
id: "U3RvcDpIU0w6MTMzMTEyMg==",
lat: 60.24254,
lon: 24.88549
},
{
id: "U3RvcDpIU0w6MTMzMTEyNA==",
lat: 60.24517,
lon: 24.88233
},
{
id: "U3RvcDpIU0w6MTMzMTExOA==",
lat: 60.24689,
lon: 24.88549
},
{
id: "U3RvcDpIU0w6MTMzNDExNg==",
lat: 60.24781,
lon: 24.89005
},
{
id: "U3RvcDpIU0w6MTMzMjE3MA==",
lat: 60.24874,
lon: 24.8942
},
{
id: "U3RvcDpIU0w6MTMzMjExNQ==",
lat: 60.249803,
lon: 24.898572
},
{
id: "U3RvcDpIU0w6MTMzMjExNw==",
lat: 60.251863,
lon: 24.900143
},
{
id: "U3RvcDpIU0w6MTMzMjExOQ==",
lat: 60.248958,
lon: 24.905066
},
{
id: "U3RvcDpIU0w6MTMzMjEyMQ==",
lat: 60.24667,
lon: 24.90539
},
{
id: "U3RvcDpIU0w6MTMzMjEyMw==",
lat: 60.243589,
lon: 24.903067
},
{
id: "U3RvcDpIU0w6MTMzMjE2Mg==",
lat: 60.24347,
lon: 24.89929
},
{
id: "U3RvcDpIU0w6MTMzMjE2MA==",
lat: 60.23833,
lon: 24.90182
}
]
},
{
gtfsId: "HSL:2125",
shortName: "125",
longName: "Tapiola(M)-Niittykumpu(M)-Olari-Nöykkiö-Espoonlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIxMTIyNg==",
lat: 60.174956,
lon: 24.803668
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mw==",
lat: 60.17122,
lon: 24.77009
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
},
{
id: "U3RvcDpIU0w6MjMyMjIwNA==",
lat: 60.16999,
lon: 24.75087
},
{
id: "U3RvcDpIU0w6MjMyMjIzMA==",
lat: 60.17259,
lon: 24.74576
},
{
id: "U3RvcDpIU0w6MjMyMjIzNA==",
lat: 60.17516,
lon: 24.7422
},
{
id: "U3RvcDpIU0w6MjMyMjIzNQ==",
lat: 60.17491,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjMyMjIzNw==",
lat: 60.17479,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjMyMzI0MA==",
lat: 60.17256,
lon: 24.72448
},
{
id: "U3RvcDpIU0w6MjMyMTIxNQ==",
lat: 60.17308,
lon: 24.72252
},
{
id: "U3RvcDpIU0w6MjMyMTIxNw==",
lat: 60.176736,
lon: 24.716377
},
{
id: "U3RvcDpIU0w6MjMyMTI2Mg==",
lat: 60.17488,
lon: 24.70841
},
{
id: "U3RvcDpIU0w6MjMyMTIyMA==",
lat: 60.17429,
lon: 24.70261
},
{
id: "U3RvcDpIU0w6MjQzMzIwNw==",
lat: 60.17298,
lon: 24.6873
},
{
id: "U3RvcDpIU0w6MjQzNDMwMQ==",
lat: 60.17155,
lon: 24.68053
},
{
id: "U3RvcDpIU0w6MjQzNDIzMw==",
lat: 60.17019,
lon: 24.6776
},
{
id: "U3RvcDpIU0w6MjQzMjIxNQ==",
lat: 60.16853,
lon: 24.67787
},
{
id: "U3RvcDpIU0w6MjQzMjIwOQ==",
lat: 60.16639,
lon: 24.67914
},
{
id: "U3RvcDpIU0w6MjQzNDI0NQ==",
lat: 60.1644,
lon: 24.68157
},
{
id: "U3RvcDpIU0w6MjQzNDI1MA==",
lat: 60.16296,
lon: 24.67642
},
{
id: "U3RvcDpIU0w6MjQzNDIwOA==",
lat: 60.16328,
lon: 24.67186
},
{
id: "U3RvcDpIU0w6MjQzNDIwNg==",
lat: 60.16285,
lon: 24.66447
},
{
id: "U3RvcDpIU0w6MjQzNDIwNA==",
lat: 60.16229,
lon: 24.6596
},
{
id: "U3RvcDpIU0w6MjQyMTIwNg==",
lat: 60.15662,
lon: 24.66215
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIyNA==",
lat: 60.15183,
lon: 24.66506
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOQ==",
lat: 60.14867,
lon: 24.66343
},
{
id: "U3RvcDpIU0w6MjQxMTIzOQ==",
lat: 60.14776,
lon: 24.6582
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMTI1NQ==",
lat: 60.15105,
lon: 24.64954
},
{
id: "U3RvcDpIU0w6MjQxMTIwNA==",
lat: 60.15267,
lon: 24.65583
},
{
id: "U3RvcDpIU0w6MjQxMTIwMg==",
lat: 60.152095,
lon: 24.663769
},
{
id: "U3RvcDpIU0w6MjQzNDIwMw==",
lat: 60.156925,
lon: 24.66224
},
{
id: "U3RvcDpIU0w6MjQzNDIwNQ==",
lat: 60.162555,
lon: 24.661038
},
{
id: "U3RvcDpIU0w6MjQzNDIwNw==",
lat: 60.16286,
lon: 24.66467
},
{
id: "U3RvcDpIU0w6MjQzNDIwOQ==",
lat: 60.16319,
lon: 24.67184
},
{
id: "U3RvcDpIU0w6MjQzNDI0NA==",
lat: 60.16295,
lon: 24.67667
},
{
id: "U3RvcDpIU0w6MjQzNDI0Ng==",
lat: 60.16443,
lon: 24.68178
},
{
id: "U3RvcDpIU0w6MjQzMjIxMA==",
lat: 60.16594,
lon: 24.6803
},
{
id: "U3RvcDpIU0w6MjQzMjIyNw==",
lat: 60.16756,
lon: 24.67821
},
{
id: "U3RvcDpIU0w6MjQzMjIyOA==",
lat: 60.16934,
lon: 24.67792
},
{
id: "U3RvcDpIU0w6MjQzNDMwMg==",
lat: 60.17161,
lon: 24.68123
},
{
id: "U3RvcDpIU0w6MjQzMzI0Ng==",
lat: 60.17303,
lon: 24.68987
},
{
id: "U3RvcDpIU0w6MjMyMTIyMQ==",
lat: 60.17427,
lon: 24.70461
},
{
id: "U3RvcDpIU0w6MjMyMTI2MQ==",
lat: 60.17485,
lon: 24.70874
},
{
id: "U3RvcDpIU0w6MjMyMTIxOA==",
lat: 60.176604,
lon: 24.716805
},
{
id: "U3RvcDpIU0w6MjMyMTIxNg==",
lat: 60.1729,
lon: 24.72234
},
{
id: "U3RvcDpIU0w6MjMyMzI0Nw==",
lat: 60.17271,
lon: 24.72739
},
{
id: "U3RvcDpIU0w6MjMyMjIzOA==",
lat: 60.17468,
lon: 24.73368
},
{
id: "U3RvcDpIU0w6MjMyMjIzNg==",
lat: 60.17473,
lon: 24.7386
},
{
id: "U3RvcDpIU0w6MjMyMjIzMg==",
lat: 60.17495,
lon: 24.74337
},
{
id: "U3RvcDpIU0w6MjMyMjIzMQ==",
lat: 60.17256,
lon: 24.74548
},
{
id: "U3RvcDpIU0w6MjMyMjI0Nw==",
lat: 60.16966,
lon: 24.74919
},
{
id: "U3RvcDpIU0w6MjMyMjIyOQ==",
lat: 60.17043,
lon: 24.75535
},
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDI0NA==",
lat: 60.170943,
lon: 24.772035
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
}
]
},
{
gtfsId: "HSL:2124",
shortName: "124",
longName: "Tapiola(M)-Niittykumpu(M)-Espoonlahti-Tillinmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIxMTIyNg==",
lat: 60.174956,
lon: 24.803668
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mw==",
lat: 60.17122,
lon: 24.77009
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
},
{
id: "U3RvcDpIU0w6MjMyMjIwNA==",
lat: 60.16999,
lon: 24.75087
},
{
id: "U3RvcDpIU0w6MjMyMjIwNQ==",
lat: 60.167702,
lon: 24.741443
},
{
id: "U3RvcDpIU0w6MjMyMzIwOA==",
lat: 60.16623,
lon: 24.73758
},
{
id: "U3RvcDpIU0w6MjMyMzIxMA==",
lat: 60.16594,
lon: 24.73119
},
{
id: "U3RvcDpIU0w6MjMyMzIxNA==",
lat: 60.16521,
lon: 24.72609
},
{
id: "U3RvcDpIU0w6MjMyMTIyMw==",
lat: 60.16259,
lon: 24.7208
},
{
id: "U3RvcDpIU0w6MjQzMjIxOA==",
lat: 60.16191,
lon: 24.70958
},
{
id: "U3RvcDpIU0w6MjQzMjI0MA==",
lat: 60.16211,
lon: 24.70565
},
{
id: "U3RvcDpIU0w6MjQzMjIyMA==",
lat: 60.1622,
lon: 24.70074
},
{
id: "U3RvcDpIU0w6MjQzMjIyMQ==",
lat: 60.16172,
lon: 24.6976
},
{
id: "U3RvcDpIU0w6MjQzMjIyOQ==",
lat: 60.15995,
lon: 24.69273
},
{
id: "U3RvcDpIU0w6MjQzMjIyMw==",
lat: 60.15842,
lon: 24.68966
},
{
id: "U3RvcDpIU0w6MjQzNDIyNQ==",
lat: 60.15632,
lon: 24.6807
},
{
id: "U3RvcDpIU0w6MjQzNDIyOA==",
lat: 60.15556,
lon: 24.67205
},
{
id: "U3RvcDpIU0w6MjQzNDIzMA==",
lat: 60.15559,
lon: 24.66702
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIyNA==",
lat: 60.15183,
lon: 24.66506
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOQ==",
lat: 60.14867,
lon: 24.66343
},
{
id: "U3RvcDpIU0w6MjQxMTIzOQ==",
lat: 60.14776,
lon: 24.6582
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOA==",
lat: 60.15638,
lon: 24.63086
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6MjQyMzIxOQ==",
lat: 60.15906,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQyMzIxNQ==",
lat: 60.16269,
lon: 24.61315
},
{
id: "U3RvcDpIU0w6MjQyMzIxMA==",
lat: 60.165995,
lon: 24.615303
},
{
id: "U3RvcDpIU0w6MjQyMzIyNQ==",
lat: 60.167636,
lon: 24.618041
},
{
id: "U3RvcDpIU0w6MjQyMjIwNA==",
lat: 60.168818,
lon: 24.622854
},
{
id: "U3RvcDpIU0w6MjQyMjIxMQ==",
lat: 60.16953,
lon: 24.62751
},
{
id: "U3RvcDpIU0w6MjQyMjIwMg==",
lat: 60.167462,
lon: 24.632485
},
{
id: "U3RvcDpIU0w6MjQyMjIwMQ==",
lat: 60.16644,
lon: 24.632922
},
{
id: "U3RvcDpIU0w6MjQyMTIwOA==",
lat: 60.16673,
lon: 24.633209
},
{
id: "U3RvcDpIU0w6MjQyMjIxMg==",
lat: 60.16961,
lon: 24.62744
},
{
id: "U3RvcDpIU0w6MjQyMjIwMw==",
lat: 60.16895,
lon: 24.622983
},
{
id: "U3RvcDpIU0w6MjQyMzIyMw==",
lat: 60.168337,
lon: 24.619043
},
{
id: "U3RvcDpIU0w6MjQyMzIxMQ==",
lat: 60.165647,
lon: 24.61464
},
{
id: "U3RvcDpIU0w6MjQyMzIxNA==",
lat: 60.16214,
lon: 24.61326
},
{
id: "U3RvcDpIU0w6MjQyMzIyMA==",
lat: 60.15901,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxNQ==",
lat: 60.15301,
lon: 24.63405
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxMTI0MA==",
lat: 60.14766,
lon: 24.65846
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOA==",
lat: 60.14873,
lon: 24.66543
},
{
id: "U3RvcDpIU0w6MjQxMTIyNQ==",
lat: 60.15011,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjQzMjIzMQ==",
lat: 60.15527,
lon: 24.66488
},
{
id: "U3RvcDpIU0w6MjQzNDIyOQ==",
lat: 60.15569,
lon: 24.66917
},
{
id: "U3RvcDpIU0w6MjQzNDIyNw==",
lat: 60.15558,
lon: 24.6744
},
{
id: "U3RvcDpIU0w6MjQzMjIyNg==",
lat: 60.15642,
lon: 24.68264
},
{
id: "U3RvcDpIU0w6MjQzMjIyNA==",
lat: 60.159344,
lon: 24.692096
},
{
id: "U3RvcDpIU0w6MjQzMjIyMg==",
lat: 60.16186,
lon: 24.69937
},
{
id: "U3RvcDpIU0w6MjQzMjIxOQ==",
lat: 60.1618,
lon: 24.7053
},
{
id: "U3RvcDpIU0w6MjQzMjIxNw==",
lat: 60.16173,
lon: 24.71134
},
{
id: "U3RvcDpIU0w6MjMyMTIyMg==",
lat: 60.16315,
lon: 24.72314
},
{
id: "U3RvcDpIU0w6MjMyMzIxMw==",
lat: 60.16583,
lon: 24.73008
},
{
id: "U3RvcDpIU0w6MjMyMzIxMQ==",
lat: 60.16564,
lon: 24.73343
},
{
id: "U3RvcDpIU0w6MjMyMzIwOQ==",
lat: 60.16666,
lon: 24.73958
},
{
id: "U3RvcDpIU0w6MjMyMjIwNg==",
lat: 60.168597,
lon: 24.743873
},
{
id: "U3RvcDpIU0w6MjMyMjI0Nw==",
lat: 60.16966,
lon: 24.74919
},
{
id: "U3RvcDpIU0w6MjMyMjIyOQ==",
lat: 60.17043,
lon: 24.75535
},
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDI0NA==",
lat: 60.170943,
lon: 24.772035
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
}
]
},
{
gtfsId: "HSL:1035",
shortName: "35",
longName: "Niemenmäki-Munkkivuori-Rakuunantie",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMwNDE2MA==",
lat: 60.2055,
lon: 24.879
},
{
id: "U3RvcDpIU0w6MTMwNTE1MQ==",
lat: 60.20663,
lon: 24.88078
},
{
id: "U3RvcDpIU0w6MTMwNTEwMQ==",
lat: 60.205493,
lon: 24.883556
},
{
id: "U3RvcDpIU0w6MTMwNTEwMg==",
lat: 60.204225,
lon: 24.884656
},
{
id: "U3RvcDpIU0w6MTMwNTE5MQ==",
lat: 60.203123,
lon: 24.884535
},
{
id: "U3RvcDpIU0w6MTMwNTEwMw==",
lat: 60.203794,
lon: 24.88356
},
{
id: "U3RvcDpIU0w6MTMwNTEwMA==",
lat: 60.205589,
lon: 24.883581
},
{
id: "U3RvcDpIU0w6MTMwNDE2MQ==",
lat: 60.20542,
lon: 24.87725
},
{
id: "U3RvcDpIU0w6MTMwNDEwMw==",
lat: 60.205472,
lon: 24.877963
},
{
id: "U3RvcDpIU0w6MTMwMTExMw==",
lat: 60.200373,
lon: 24.884701
},
{
id: "U3RvcDpIU0w6MTMwMTE2MA==",
lat: 60.198389,
lon: 24.885561
},
{
id: "U3RvcDpIU0w6MTMwMTExMg==",
lat: 60.200773,
lon: 24.883186
},
{
id: "U3RvcDpIU0w6MTMwNDEyNw==",
lat: 60.20289,
lon: 24.88189
}
]
},
{
gtfsId: "HSL:1034",
shortName: "34",
longName: "Munkkivuori-Kaskisaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMwNDE2MA==",
lat: 60.2055,
lon: 24.879
},
{
id: "U3RvcDpIU0w6MTMwNDEyOQ==",
lat: 60.203905,
lon: 24.873805
},
{
id: "U3RvcDpIU0w6MTMwMTE0NQ==",
lat: 60.201432,
lon: 24.87506
},
{
id: "U3RvcDpIU0w6MTMwMTEyNw==",
lat: 60.199,
lon: 24.8765
},
{
id: "U3RvcDpIU0w6MTMwMTE1Mw==",
lat: 60.195947,
lon: 24.873401
},
{
id: "U3RvcDpIU0w6MTMwMTE0Mw==",
lat: 60.194506,
lon: 24.872621
},
{
id: "U3RvcDpIU0w6MTMwMTEzMQ==",
lat: 60.193566,
lon: 24.876357
},
{
id: "U3RvcDpIU0w6MTMwMTIxNA==",
lat: 60.19223,
lon: 24.87814
},
{
id: "U3RvcDpIU0w6MTMwMjIxNg==",
lat: 60.18696,
lon: 24.8681
},
{
id: "U3RvcDpIU0w6MTMwMjIxOA==",
lat: 60.184553,
lon: 24.857309
},
{
id: "U3RvcDpIU0w6MTMwMzExMw==",
lat: 60.1807,
lon: 24.85064
},
{
id: "U3RvcDpIU0w6MTMwMzEwMg==",
lat: 60.1804,
lon: 24.8493
},
{
id: "U3RvcDpIU0w6MTMwMzExMQ==",
lat: 60.180475,
lon: 24.846967
},
{
id: "U3RvcDpIU0w6MTMwMzEwMA==",
lat: 60.180423,
lon: 24.850458
},
{
id: "U3RvcDpIU0w6MTMwMzEwOQ==",
lat: 60.18053,
lon: 24.8544
},
{
id: "U3RvcDpIU0w6MTMwMzEwNQ==",
lat: 60.17854,
lon: 24.8528
},
{
id: "U3RvcDpIU0w6MTMwMzEwMw==",
lat: 60.177205,
lon: 24.853608
},
{
id: "U3RvcDpIU0w6MTMwMzE5Mg==",
lat: 60.17335,
lon: 24.86018
},
{
id: "U3RvcDpIU0w6MTMwMzEwNA==",
lat: 60.177125,
lon: 24.853385
},
{
id: "U3RvcDpIU0w6MTMwMzEwNw==",
lat: 60.179735,
lon: 24.85213
},
{
id: "U3RvcDpIU0w6MTMwMzEwOA==",
lat: 60.179217,
lon: 24.851467
},
{
id: "U3RvcDpIU0w6MTMwMzEwNg==",
lat: 60.17921,
lon: 24.8547
},
{
id: "U3RvcDpIU0w6MTMwMzExMA==",
lat: 60.180765,
lon: 24.85458
},
{
id: "U3RvcDpIU0w6MTMwMzExMg==",
lat: 60.1807,
lon: 24.85085
},
{
id: "U3RvcDpIU0w6MTMwMjIxOQ==",
lat: 60.18488,
lon: 24.85935
},
{
id: "U3RvcDpIU0w6MTMwMjIxNw==",
lat: 60.18716,
lon: 24.86985
},
{
id: "U3RvcDpIU0w6MTMwMTEzMg==",
lat: 60.193319,
lon: 24.877151
},
{
id: "U3RvcDpIU0w6MTMwMTEzMw==",
lat: 60.193702,
lon: 24.876253
},
{
id: "U3RvcDpIU0w6MTMwMTEwNQ==",
lat: 60.19657,
lon: 24.874118
},
{
id: "U3RvcDpIU0w6MTMwMTEyOA==",
lat: 60.199507,
lon: 24.87727
},
{
id: "U3RvcDpIU0w6MTMwMTE0Ng==",
lat: 60.201122,
lon: 24.875988
},
{
id: "U3RvcDpIU0w6MTMwMTE0NA==",
lat: 60.2019,
lon: 24.874432
},
{
id: "U3RvcDpIU0w6MTMwNDE1OQ==",
lat: 60.20391,
lon: 24.87377
}
]
},
{
gtfsId: "HSL:2244",
shortName: "244",
longName: "Espoon keskus-Nupuri-Brobacka-Siikaniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjY0MzIyOQ==",
lat: 60.2888,
lon: 24.51592
},
{
id: "U3RvcDpIU0w6MjY0MzIyOA==",
lat: 60.28964,
lon: 24.52164
},
{
id: "U3RvcDpIU0w6MjY0MzIyNg==",
lat: 60.28803,
lon: 24.52747
},
{
id: "U3RvcDpIU0w6MjY0MzIyNA==",
lat: 60.28688,
lon: 24.53132
},
{
id: "U3RvcDpIU0w6MjY0MzIyMg==",
lat: 60.28253,
lon: 24.52684
},
{
id: "U3RvcDpIU0w6MjY0MzIyMA==",
lat: 60.27895,
lon: 24.51624
},
{
id: "U3RvcDpIU0w6MjY0MzIxOA==",
lat: 60.27687,
lon: 24.51393
},
{
id: "U3RvcDpIU0w6MjY0MzIxNg==",
lat: 60.27237,
lon: 24.51821
},
{
id: "U3RvcDpIU0w6MjY0MzI3Mw==",
lat: 60.26872,
lon: 24.52941
},
{
id: "U3RvcDpIU0w6MjY0MzI3MQ==",
lat: 60.26519,
lon: 24.53274
},
{
id: "U3RvcDpIU0w6MjY0MzI2OQ==",
lat: 60.2637,
lon: 24.53957
},
{
id: "U3RvcDpIU0w6MjY0MzI4Mw==",
lat: 60.26238,
lon: 24.54519
},
{
id: "U3RvcDpIU0w6MjY0MzI0Mw==",
lat: 60.26234,
lon: 24.5512
},
{
id: "U3RvcDpIU0w6MjY0MzI0MQ==",
lat: 60.26157,
lon: 24.56307
},
{
id: "U3RvcDpIU0w6MjY0MzI4MQ==",
lat: 60.25745,
lon: 24.57105
},
{
id: "U3RvcDpIU0w6MjY0MjIzOQ==",
lat: 60.25699,
lon: 24.57916
},
{
id: "U3RvcDpIU0w6MjY0MjI3OQ==",
lat: 60.25592,
lon: 24.58477
},
{
id: "U3RvcDpIU0w6MjY0MjI3Nw==",
lat: 60.25288,
lon: 24.5884
},
{
id: "U3RvcDpIU0w6MjY0MjI3NQ==",
lat: 60.24895,
lon: 24.59049
},
{
id: "U3RvcDpIU0w6MjY0MjIzNw==",
lat: 60.24354,
lon: 24.59318
},
{
id: "U3RvcDpIU0w6MjY0MjI4NQ==",
lat: 60.23869,
lon: 24.5967
},
{
id: "U3RvcDpIU0w6MjY0MjIwNg==",
lat: 60.23713,
lon: 24.5973
},
{
id: "U3RvcDpIU0w6MjY0MjIwNA==",
lat: 60.23408,
lon: 24.60218
},
{
id: "U3RvcDpIU0w6MjY0MjIwMg==",
lat: 60.23044,
lon: 24.60938
},
{
id: "U3RvcDpIU0w6MjYzNDIxNA==",
lat: 60.22535,
lon: 24.62021
},
{
id: "U3RvcDpIU0w6MjYzNDIxMg==",
lat: 60.22296,
lon: 24.62769
},
{
id: "U3RvcDpIU0w6MjYzNDIxMA==",
lat: 60.22181,
lon: 24.63336
},
{
id: "U3RvcDpIU0w6MjYzNDIwOA==",
lat: 60.22106,
lon: 24.64406
},
{
id: "U3RvcDpIU0w6MjYzMTIwNg==",
lat: 60.22154,
lon: 24.65273
},
{
id: "U3RvcDpIU0w6MjYzMzIyMg==",
lat: 60.22298,
lon: 24.66
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTIxOQ==",
lat: 60.205048,
lon: 24.65511
},
{
id: "U3RvcDpIU0w6MjYxMTI1OA==",
lat: 60.20535,
lon: 24.65686
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMzIyMA==",
lat: 60.22261,
lon: 24.65842
},
{
id: "U3RvcDpIU0w6MjYzMTIwNQ==",
lat: 60.22153,
lon: 24.65084
},
{
id: "U3RvcDpIU0w6MjYzNDIwNw==",
lat: 60.22114,
lon: 24.6424
},
{
id: "U3RvcDpIU0w6MjYzNDIwOQ==",
lat: 60.22177,
lon: 24.63425
},
{
id: "U3RvcDpIU0w6MjYzNDIxMQ==",
lat: 60.22333,
lon: 24.62652
},
{
id: "U3RvcDpIU0w6MjYzNDIxMw==",
lat: 60.22492,
lon: 24.6214
},
{
id: "U3RvcDpIU0w6MjY0MjIwMQ==",
lat: 60.23029,
lon: 24.60998
},
{
id: "U3RvcDpIU0w6MjY0MjIwMw==",
lat: 60.23468,
lon: 24.60146
},
{
id: "U3RvcDpIU0w6MjY0MjIwNQ==",
lat: 60.23769,
lon: 24.59669
},
{
id: "U3RvcDpIU0w6MjY0MjI4NA==",
lat: 60.23911,
lon: 24.59706
},
{
id: "U3RvcDpIU0w6MjY0MjIzOA==",
lat: 60.24476,
lon: 24.59264
},
{
id: "U3RvcDpIU0w6MjY0MjI4MA==",
lat: 60.24947,
lon: 24.59048
},
{
id: "U3RvcDpIU0w6MjY0MjI3Ng==",
lat: 60.2529,
lon: 24.58849
},
{
id: "U3RvcDpIU0w6MjY0MjI3OA==",
lat: 60.25611,
lon: 24.58457
},
{
id: "U3RvcDpIU0w6MjY0MjI0MA==",
lat: 60.25708,
lon: 24.57886
},
{
id: "U3RvcDpIU0w6MjY0MzI4MA==",
lat: 60.25763,
lon: 24.57082
},
{
id: "U3RvcDpIU0w6MjY0MzI0Mg==",
lat: 60.2617,
lon: 24.56271
},
{
id: "U3RvcDpIU0w6MjY0MzI0NA==",
lat: 60.26249,
lon: 24.55054
},
{
id: "U3RvcDpIU0w6MjY0MzI4Mg==",
lat: 60.26253,
lon: 24.54572
},
{
id: "U3RvcDpIU0w6MjY0MzI3MA==",
lat: 60.26378,
lon: 24.5395
},
{
id: "U3RvcDpIU0w6MjY0MzI3Mg==",
lat: 60.26526,
lon: 24.53278
},
{
id: "U3RvcDpIU0w6MjY0MzI3NA==",
lat: 60.26851,
lon: 24.52949
},
{
id: "U3RvcDpIU0w6MjY0MzIxNQ==",
lat: 60.27268,
lon: 24.51765
},
{
id: "U3RvcDpIU0w6MjY0MzIxNw==",
lat: 60.27723,
lon: 24.5142
},
{
id: "U3RvcDpIU0w6MjY0MzIxOQ==",
lat: 60.27917,
lon: 24.51706
},
{
id: "U3RvcDpIU0w6MjY0MzIyMQ==",
lat: 60.28269,
lon: 24.52715
},
{
id: "U3RvcDpIU0w6MjY0MzIyMw==",
lat: 60.28683,
lon: 24.53186
},
{
id: "U3RvcDpIU0w6MjY0MzIyNQ==",
lat: 60.28839,
lon: 24.52685
},
{
id: "U3RvcDpIU0w6MjY0MzIyNw==",
lat: 60.28961,
lon: 24.52204
}
]
},
{
gtfsId: "HSL:1094N",
shortName: "94N",
longName: "Rautatientori-Roihuvuori-Kontulankaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE1Mw==",
lat: 60.19236,
lon: 25.04061
},
{
id: "U3RvcDpIU0w6MTQzMzE3Mw==",
lat: 60.1931,
lon: 25.04642
},
{
id: "U3RvcDpIU0w6MTQzMjE1Nw==",
lat: 60.19536,
lon: 25.0535
},
{
id: "U3RvcDpIU0w6MTQzMjE1OQ==",
lat: 60.19806,
lon: 25.05587
},
{
id: "U3RvcDpIU0w6MTQzMjE2MQ==",
lat: 60.20088,
lon: 25.05972
},
{
id: "U3RvcDpIU0w6MTQzMjE3OA==",
lat: 60.20195,
lon: 25.06185
},
{
id: "U3RvcDpIU0w6MTQzMjE4MA==",
lat: 60.20174,
lon: 25.0658
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OA==",
lat: 60.20285,
lon: 25.07329
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mw==",
lat: 60.20466,
lon: 25.07662
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMg==",
lat: 60.20757,
lon: 25.07562
},
{
id: "U3RvcDpIU0w6MTQ1MzE4Mg==",
lat: 60.21003,
lon: 25.0768
},
{
id: "U3RvcDpIU0w6MTQ1MzE4MQ==",
lat: 60.21211,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMQ==",
lat: 60.21472,
lon: 25.08581
},
{
id: "U3RvcDpIU0w6MTQ1MzEwOQ==",
lat: 60.21775,
lon: 25.08378
},
{
id: "U3RvcDpIU0w6MTQ1NDExNg==",
lat: 60.22127,
lon: 25.08186
},
{
id: "U3RvcDpIU0w6MTQ1NDExMQ==",
lat: 60.225,
lon: 25.07936
},
{
id: "U3RvcDpIU0w6MTQ3MTE5MA==",
lat: 60.23081,
lon: 25.07872
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMA==",
lat: 60.23377,
lon: 25.08125
},
{
id: "U3RvcDpIU0w6MTQ3MTE1OQ==",
lat: 60.23613,
lon: 25.08247
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOQ==",
lat: 60.23797,
lon: 25.07866
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MQ==",
lat: 60.24007,
lon: 25.07459
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mw==",
lat: 60.24255,
lon: 25.07526
},
{
id: "U3RvcDpIU0w6MTQ3MTE0NQ==",
lat: 60.2449,
lon: 25.07744
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNQ==",
lat: 60.24573,
lon: 25.08023
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Nw==",
lat: 60.24645,
lon: 25.0829
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Ng==",
lat: 60.24535,
lon: 25.07797
},
{
id: "U3RvcDpIU0w6MTQ3MTE0NA==",
lat: 60.24251,
lon: 25.07514
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mg==",
lat: 60.23916,
lon: 25.07499
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MA==",
lat: 60.23795,
lon: 25.07819
},
{
id: "U3RvcDpIU0w6MTQ3MTE3OQ==",
lat: 60.23602,
lon: 25.0822
},
{
id: "U3RvcDpIU0w6MTQ3MTExOQ==",
lat: 60.232476,
lon: 25.079913
},
{
id: "U3RvcDpIU0w6MTQ3MTE5MQ==",
lat: 60.23008,
lon: 25.0777
},
{
id: "U3RvcDpIU0w6MTQ1NDExMg==",
lat: 60.22483,
lon: 25.0789
},
{
id: "U3RvcDpIU0w6MTQ1NDExNw==",
lat: 60.22102,
lon: 25.08156
},
{
id: "U3RvcDpIU0w6MTQ1MzExMA==",
lat: 60.21752,
lon: 25.08351
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExNg==",
lat: 60.21035,
lon: 25.07629
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMQ==",
lat: 60.2075,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mg==",
lat: 60.20392,
lon: 25.07614
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OQ==",
lat: 60.20303,
lon: 25.07354
},
{
id: "U3RvcDpIU0w6MTQzMjE4MQ==",
lat: 60.20187,
lon: 25.0646
},
{
id: "U3RvcDpIU0w6MTQzMjE3OQ==",
lat: 60.20199,
lon: 25.0616
},
{
id: "U3RvcDpIU0w6MTQzMjE2Mg==",
lat: 60.2007,
lon: 25.05952
},
{
id: "U3RvcDpIU0w6MTQzMjE2MA==",
lat: 60.1975,
lon: 25.05482
},
{
id: "U3RvcDpIU0w6MTQzMjE1OA==",
lat: 60.19525,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQzMzE1Ng==",
lat: 60.19313,
lon: 25.04621
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:7192K",
shortName: "192K",
longName: "Kamppi-Länsiväylä-Kirkkonummen asema(-Inkoo)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwNDAwMA==",
lat: 60.094333,
lon: 24.242655
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNzAwNA==",
lat: 60.099132,
lon: 24.303275
},
{
id: "U3RvcDpIU0w6NjMwNzAwOA==",
lat: 60.099232,
lon: 24.331415
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNA==",
lat: 60.106061,
lon: 24.371492
},
{
id: "U3RvcDpIU0w6NjA1MDIwNQ==",
lat: 60.110392,
lon: 24.384672
},
{
id: "U3RvcDpIU0w6NjA0MDIwOQ==",
lat: 60.114941,
lon: 24.414073
},
{
id: "U3RvcDpIU0w6NjA0MDIxMg==",
lat: 60.115939,
lon: 24.426609
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5Ng==",
lat: 60.119674,
lon: 24.441337
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA0MDIxMQ==",
lat: 60.1159,
lon: 24.4454
},
{
id: "U3RvcDpIU0w6NjA0MDIxNQ==",
lat: 60.119058,
lon: 24.4813
},
{
id: "U3RvcDpIU0w6NjAzMDIwMQ==",
lat: 60.133472,
lon: 24.512763
},
{
id: "U3RvcDpIU0w6NjAzMDIzMg==",
lat: 60.13751,
lon: 24.537388
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDIwMg==",
lat: 60.147525,
lon: 24.572943
},
{
id: "U3RvcDpIU0w6NjAzMDIwNg==",
lat: 60.137865,
lon: 24.532207
},
{
id: "U3RvcDpIU0w6NjAzMDIwMg==",
lat: 60.133613,
lon: 24.509142
},
{
id: "U3RvcDpIU0w6NjA0MDIxNg==",
lat: 60.119052,
lon: 24.477277
},
{
id: "U3RvcDpIU0w6NjA0MDI5NQ==",
lat: 60.119658,
lon: 24.441538
},
{
id: "U3RvcDpIU0w6NjA0MDIxNA==",
lat: 60.117086,
lon: 24.44276
},
{
id: "U3RvcDpIU0w6NjA0MDIxMw==",
lat: 60.116116,
lon: 24.426538
},
{
id: "U3RvcDpIU0w6NjA0MDIxMA==",
lat: 60.114838,
lon: 24.411756
},
{
id: "U3RvcDpIU0w6NjA1MDIwNg==",
lat: 60.110009,
lon: 24.382306
},
{
id: "U3RvcDpIU0w6NjA1MDIwMw==",
lat: 60.105278,
lon: 24.369337
},
{
id: "U3RvcDpIU0w6NjA1MDIwMg==",
lat: 60.103433,
lon: 24.364292
},
{
id: "U3RvcDpIU0w6NjA3MDIyOQ==",
lat: 60.101495,
lon: 24.345007
},
{
id: "U3RvcDpIU0w6NjMwNzAwNw==",
lat: 60.09886,
lon: 24.329275
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwMQ==",
lat: 60.094172,
lon: 24.241083
}
]
},
{
gtfsId: "HSL:1077N",
shortName: "77N",
longName: "Rautatientori-Arabia-Malmi-Jakomäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQxNDE0OQ==",
lat: 60.26448,
lon: 25.08393
},
{
id: "U3RvcDpIU0w6MTQxNDE1Ng==",
lat: 60.2608,
lon: 25.086
},
{
id: "U3RvcDpIU0w6MTQxNDE1Mw==",
lat: 60.26209,
lon: 25.07929
},
{
id: "U3RvcDpIU0w6MTQxMzExNw==",
lat: 60.26264,
lon: 25.06834
},
{
id: "U3RvcDpIU0w6MTQxMzExNQ==",
lat: 60.25822,
lon: 25.06413
},
{
id: "U3RvcDpIU0w6MTQxMzExOA==",
lat: 60.255113,
lon: 25.063618
},
{
id: "U3RvcDpIU0w6MTQxMzExMw==",
lat: 60.25228,
lon: 25.06229
},
{
id: "U3RvcDpIU0w6MTM4NTE2Mg==",
lat: 60.24766,
lon: 25.05573
},
{
id: "U3RvcDpIU0w6MTM4NTE1Mg==",
lat: 60.24613,
lon: 25.04853
},
{
id: "U3RvcDpIU0w6MTM4NTE1MA==",
lat: 60.24536,
lon: 25.04458
},
{
id: "U3RvcDpIU0w6MTM4NTE0OA==",
lat: 60.2444,
lon: 25.04001
},
{
id: "U3RvcDpIU0w6MTM4NTE3Mg==",
lat: 60.24514,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTM4NTE3OA==",
lat: 60.247106,
lon: 25.033843
},
{
id: "U3RvcDpIU0w6MTM4NTE3NA==",
lat: 60.249379,
lon: 25.031947
},
{
id: "U3RvcDpIU0w6MTM4MjE4Ng==",
lat: 60.25097,
lon: 25.02561
},
{
id: "U3RvcDpIU0w6MTM4MjE0MQ==",
lat: 60.253556,
lon: 25.02109
},
{
id: "U3RvcDpIU0w6MTM4MjE2Ng==",
lat: 60.2526,
lon: 25.01394
},
{
id: "U3RvcDpIU0w6MTM4MjE2Mw==",
lat: 60.25152,
lon: 25.01215
},
{
id: "U3RvcDpIU0w6MTM4MjE3Nw==",
lat: 60.24926,
lon: 25.0077
},
{
id: "U3RvcDpIU0w6MTM3MDEyMQ==",
lat: 60.24617,
lon: 25.00154
},
{
id: "U3RvcDpIU0w6MTM4MjExOQ==",
lat: 60.24318,
lon: 24.99639
},
{
id: "U3RvcDpIU0w6MTM4MzE4MQ==",
lat: 60.24095,
lon: 24.99877
},
{
id: "U3RvcDpIU0w6MTM4MzEzMQ==",
lat: 60.24007,
lon: 25.0027
},
{
id: "U3RvcDpIU0w6MTM4MzEyOQ==",
lat: 60.23702,
lon: 25.00686
},
{
id: "U3RvcDpIU0w6MTM4MzEyNw==",
lat: 60.23419,
lon: 25.01042
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM4MzEzNA==",
lat: 60.230748,
lon: 25.004888
},
{
id: "U3RvcDpIU0w6MTM4MzEzNg==",
lat: 60.23112,
lon: 25.0003
},
{
id: "U3RvcDpIU0w6MTM2NDEwNg==",
lat: 60.229955,
lon: 24.996894
},
{
id: "U3RvcDpIU0w6MTM2NDEwNA==",
lat: 60.227763,
lon: 24.989564
},
{
id: "U3RvcDpIU0w6MTM2NDEwMg==",
lat: 60.224166,
lon: 24.988431
},
{
id: "U3RvcDpIU0w6MTM2MTEwNA==",
lat: 60.21836,
lon: 24.98539
},
{
id: "U3RvcDpIU0w6MTI3MDEwNQ==",
lat: 60.21611,
lon: 24.98016
},
{
id: "U3RvcDpIU0w6MTI3MDEwMg==",
lat: 60.21252,
lon: 24.97844
},
{
id: "U3RvcDpIU0w6MTIzMDEwMQ==",
lat: 60.210234,
lon: 24.976613
},
{
id: "U3RvcDpIU0w6MTIzMDEwMw==",
lat: 60.20808,
lon: 24.97474
},
{
id: "U3RvcDpIU0w6MTIzMDExNA==",
lat: 60.20593,
lon: 24.97255
},
{
id: "U3RvcDpIU0w6MTIzMDExMg==",
lat: 60.20316,
lon: 24.96657
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExMw==",
lat: 60.17072,
lon: 24.94324
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTIzMDEwOQ==",
lat: 60.20312,
lon: 24.9673
},
{
id: "U3RvcDpIU0w6MTIzMDExMw==",
lat: 60.20548,
lon: 24.97209
},
{
id: "U3RvcDpIU0w6MTIzMDEwNA==",
lat: 60.20827,
lon: 24.97504
},
{
id: "U3RvcDpIU0w6MTIzMDEwMg==",
lat: 60.21121,
lon: 24.97757
},
{
id: "U3RvcDpIU0w6MTI3MDEwMw==",
lat: 60.21316,
lon: 24.97917
},
{
id: "U3RvcDpIU0w6MTI3MDEwNA==",
lat: 60.217158,
lon: 24.981087
},
{
id: "U3RvcDpIU0w6MTM2MTEwMw==",
lat: 60.21896,
lon: 24.98699
},
{
id: "U3RvcDpIU0w6MTM2NDEwMQ==",
lat: 60.224023,
lon: 24.988526
},
{
id: "U3RvcDpIU0w6MTM2NDEwMw==",
lat: 60.228033,
lon: 24.989917
},
{
id: "U3RvcDpIU0w6MTM2NDEwNQ==",
lat: 60.230034,
lon: 24.99733
},
{
id: "U3RvcDpIU0w6MTM4MzEzOA==",
lat: 60.23116,
lon: 25.00068
},
{
id: "U3RvcDpIU0w6MTM4MzEzNQ==",
lat: 60.23112,
lon: 25.00417
},
{
id: "U3RvcDpIU0w6MTM4MzE3OQ==",
lat: 60.23017,
lon: 25.00861
},
{
id: "U3RvcDpIU0w6MTM4MzEyNA==",
lat: 60.23317,
lon: 25.01162
},
{
id: "U3RvcDpIU0w6MTM4MzEyNg==",
lat: 60.23436,
lon: 25.010234
},
{
id: "U3RvcDpIU0w6MTM4MzEyOA==",
lat: 60.23739,
lon: 25.00643
},
{
id: "U3RvcDpIU0w6MTM4MzEzMA==",
lat: 60.23986,
lon: 25.00259
},
{
id: "U3RvcDpIU0w6MTM4MzE4MA==",
lat: 60.2408,
lon: 24.99779
},
{
id: "U3RvcDpIU0w6MTM4MjEyMA==",
lat: 60.24328,
lon: 24.99679
},
{
id: "U3RvcDpIU0w6MTM4MjEyMg==",
lat: 60.24685,
lon: 25.00326
},
{
id: "U3RvcDpIU0w6MTM4MjE3OA==",
lat: 60.24924,
lon: 25.00818
},
{
id: "U3RvcDpIU0w6MTM4MjE3Ng==",
lat: 60.25049,
lon: 25.01236
},
{
id: "U3RvcDpIU0w6MTM4MjE2NQ==",
lat: 60.25315,
lon: 25.01507
},
{
id: "U3RvcDpIU0w6MTM4MjE0Mg==",
lat: 60.253395,
lon: 25.020997
},
{
id: "U3RvcDpIU0w6MTM4MjE4Nw==",
lat: 60.25091,
lon: 25.02557
},
{
id: "U3RvcDpIU0w6MTM4MjE3NQ==",
lat: 60.24988,
lon: 25.02981
},
{
id: "U3RvcDpIU0w6MTM4MjE3OQ==",
lat: 60.2469,
lon: 25.03371
},
{
id: "U3RvcDpIU0w6MTM4MjE3Mw==",
lat: 60.24484,
lon: 25.03503
},
{
id: "U3RvcDpIU0w6MTM4NDE0Nw==",
lat: 60.24429,
lon: 25.04056
},
{
id: "U3RvcDpIU0w6MTM4NDE0OQ==",
lat: 60.24534,
lon: 25.04537
},
{
id: "U3RvcDpIU0w6MTM4NDE1MQ==",
lat: 60.24642,
lon: 25.05051
},
{
id: "U3RvcDpIU0w6MTM4NDE2MQ==",
lat: 60.24761,
lon: 25.05617
},
{
id: "U3RvcDpIU0w6MTQxMzExMg==",
lat: 60.25305,
lon: 25.06321
},
{
id: "U3RvcDpIU0w6MTQxMzExOQ==",
lat: 60.256148,
lon: 25.06408
},
{
id: "U3RvcDpIU0w6MTQxMzExNA==",
lat: 60.25933,
lon: 25.06483
},
{
id: "U3RvcDpIU0w6MTQxMzExNg==",
lat: 60.26241,
lon: 25.06838
},
{
id: "U3RvcDpIU0w6MTQxMzE1OA==",
lat: 60.26291,
lon: 25.07017
},
{
id: "U3RvcDpIU0w6MTQxNDE1Mg==",
lat: 60.2619,
lon: 25.08012
},
{
id: "U3RvcDpIU0w6MTQxNDE1NQ==",
lat: 60.26099,
lon: 25.08622
}
]
},
{
gtfsId: "HSL:4617",
shortName: "617",
longName: "Hakaniemi-Lentoasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDUzMDIzMA==",
lat: 60.317343,
lon: 24.965217
},
{
id: "U3RvcDpIU0w6NDUzMDI1OA==",
lat: 60.313471,
lon: 24.967726
},
{
id: "U3RvcDpIU0w6NDUzMDIyMQ==",
lat: 60.307879,
lon: 24.960343
},
{
id: "U3RvcDpIU0w6NDUyMDI2Nw==",
lat: 60.304895,
lon: 24.957404
},
{
id: "U3RvcDpIU0w6NDUyMDI2OQ==",
lat: 60.302518,
lon: 24.955252
},
{
id: "U3RvcDpIU0w6NDUyMDIzMg==",
lat: 60.301669,
lon: 24.959481
},
{
id: "U3RvcDpIU0w6NDUyMDIzMQ==",
lat: 60.300262,
lon: 24.966312
},
{
id: "U3RvcDpIU0w6NDUyMDI3NA==",
lat: 60.29788,
lon: 24.968544
},
{
id: "U3RvcDpIU0w6NDUyMDI3Mg==",
lat: 60.294892,
lon: 24.96802
},
{
id: "U3RvcDpIU0w6NDUyMDI3NQ==",
lat: 60.296872,
lon: 24.961573
},
{
id: "U3RvcDpIU0w6NDUxMDI2NA==",
lat: 60.295567,
lon: 24.958298
},
{
id: "U3RvcDpIU0w6NDUyMDI2Mw==",
lat: 60.293315,
lon: 24.963035
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNA==",
lat: 60.1788,
lon: 24.94977
},
{
id: "U3RvcDpIU0w6MTExMTI2Ng==",
lat: 60.179613,
lon: 24.952783
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDUyMDI2MQ==",
lat: 60.294818,
lon: 24.960031
},
{
id: "U3RvcDpIU0w6NDUyMDI3Ng==",
lat: 60.296767,
lon: 24.962456
},
{
id: "U3RvcDpIU0w6NDUyMDI3Mw==",
lat: 60.294858,
lon: 24.968049
},
{
id: "U3RvcDpIU0w6NDUyMDIxMw==",
lat: 60.29937,
lon: 24.9685
},
{
id: "U3RvcDpIU0w6NDUyMDIzOQ==",
lat: 60.301654,
lon: 24.962252
},
{
id: "U3RvcDpIU0w6NDUyMDI2Ng==",
lat: 60.302738,
lon: 24.955727
},
{
id: "U3RvcDpIU0w6NDUyMDI2OA==",
lat: 60.306115,
lon: 24.958895
},
{
id: "U3RvcDpIU0w6NDUzMDIyMg==",
lat: 60.308712,
lon: 24.961988
},
{
id: "U3RvcDpIU0w6NDUzMDIwOQ==",
lat: 60.317071,
lon: 24.966263
}
]
},
{
gtfsId: "HSL:4618",
shortName: "618",
longName: "Tikkurila-Simonkylä-Leinelä-Peijas",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDcyMDIwOQ==",
lat: 60.33219,
lon: 25.06038
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcyMDIyNw==",
lat: 60.325038,
lon: 25.050357
},
{
id: "U3RvcDpIU0w6NDcwMDIzMg==",
lat: 60.326547,
lon: 25.0421
},
{
id: "U3RvcDpIU0w6NDcwMDIzMw==",
lat: 60.325487,
lon: 25.041647
},
{
id: "U3RvcDpIU0w6NDcwMDIyOQ==",
lat: 60.322323,
lon: 25.042012
},
{
id: "U3RvcDpIU0w6NDcwMDIwMg==",
lat: 60.31968,
lon: 25.03908
},
{
id: "U3RvcDpIU0w6NDY1MDIxMA==",
lat: 60.3149,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6NDY1MDI0Mw==",
lat: 60.313094,
lon: 25.03333
},
{
id: "U3RvcDpIU0w6NDYwMDIxNA==",
lat: 60.31155,
lon: 25.03821
},
{
id: "U3RvcDpIU0w6NDYwMDIxMQ==",
lat: 60.30917,
lon: 25.03277
},
{
id: "U3RvcDpIU0w6NDY1MDIxMw==",
lat: 60.31151,
lon: 25.03043
},
{
id: "U3RvcDpIU0w6NDY1MDIxNw==",
lat: 60.31319,
lon: 25.02649
},
{
id: "U3RvcDpIU0w6NDY1MDI0MQ==",
lat: 60.312044,
lon: 25.025099
},
{
id: "U3RvcDpIU0w6NDY1MDIwNg==",
lat: 60.30949,
lon: 25.02695
},
{
id: "U3RvcDpIU0w6NDY1MDIwNA==",
lat: 60.30635,
lon: 25.02439
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIwNw==",
lat: 60.30182,
lon: 25.02328
},
{
id: "U3RvcDpIU0w6NDYzMDIyNQ==",
lat: 60.30021,
lon: 25.02911
},
{
id: "U3RvcDpIU0w6NDYzMDIwOQ==",
lat: 60.299,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6NDYxMDIwOQ==",
lat: 60.2969,
lon: 25.03573
},
{
id: "U3RvcDpIU0w6NDYxMDIwOA==",
lat: 60.29596,
lon: 25.040142
},
{
id: "U3RvcDpIU0w6NDYxMDI1MA==",
lat: 60.293905,
lon: 25.044436
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIyNg==",
lat: 60.29163,
lon: 25.0366
},
{
id: "U3RvcDpIU0w6NDYxMDIyMQ==",
lat: 60.28932,
lon: 25.03668
},
{
id: "U3RvcDpIU0w6NDYyMDIzNQ==",
lat: 60.291114,
lon: 25.044834
},
{
id: "U3RvcDpIU0w6NDYyMDIwMg==",
lat: 60.29036,
lon: 25.04535
},
{
id: "U3RvcDpIU0w6NDYxMDIyNA==",
lat: 60.28975,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDYxMDIyNQ==",
lat: 60.29093,
lon: 25.03651
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIyOA==",
lat: 60.29661,
lon: 25.03844
},
{
id: "U3RvcDpIU0w6NDYxMDIzMQ==",
lat: 60.29765,
lon: 25.03472
},
{
id: "U3RvcDpIU0w6NDYzMDIxMA==",
lat: 60.29964,
lon: 25.03247
},
{
id: "U3RvcDpIU0w6NDYzMDIyNg==",
lat: 60.30105,
lon: 25.02662
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIwMw==",
lat: 60.30689,
lon: 25.02499
},
{
id: "U3RvcDpIU0w6NDY1MDIxNQ==",
lat: 60.30996,
lon: 25.02734
},
{
id: "U3RvcDpIU0w6NDY1MDI0MA==",
lat: 60.312016,
lon: 25.025025
},
{
id: "U3RvcDpIU0w6NDY1MDIxOA==",
lat: 60.31318,
lon: 25.02678
},
{
id: "U3RvcDpIU0w6NDY1MDIxNA==",
lat: 60.31043,
lon: 25.03091
},
{
id: "U3RvcDpIU0w6NDYwMDIxMw==",
lat: 60.30911,
lon: 25.03456
},
{
id: "U3RvcDpIU0w6NDY1MDIyMw==",
lat: 60.31208,
lon: 25.038425
},
{
id: "U3RvcDpIU0w6NDY1MDI0Mg==",
lat: 60.313078,
lon: 25.034026
},
{
id: "U3RvcDpIU0w6NDY1MDIwOQ==",
lat: 60.31516,
lon: 25.03566
},
{
id: "U3RvcDpIU0w6NDcwMDIwMQ==",
lat: 60.3203,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDcwMDIyOA==",
lat: 60.32246,
lon: 25.042177
},
{
id: "U3RvcDpIU0w6NDcwMDIzNA==",
lat: 60.325902,
lon: 25.041882
},
{
id: "U3RvcDpIU0w6NDcyMDIyNQ==",
lat: 60.326482,
lon: 25.043723
},
{
id: "U3RvcDpIU0w6NDcwMDIwNw==",
lat: 60.3246,
lon: 25.05219
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIxNg==",
lat: 60.33213,
lon: 25.06075
}
]
},
{
gtfsId: "HSL:6916",
shortName: "916",
longName: "Kuntakeskus-Siuntion kk.-Suitia-Pauni",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMTA2MA==",
lat: 60.247101,
lon: 24.187422
},
{
id: "U3RvcDpIU0w6NjMwMTA1OQ==",
lat: 60.235692,
lon: 24.168579
},
{
id: "U3RvcDpIU0w6NjMwMTAwOQ==",
lat: 60.229554,
lon: 24.166076
},
{
id: "U3RvcDpIU0w6NjMwMTAxNA==",
lat: 60.221851,
lon: 24.171776
},
{
id: "U3RvcDpIU0w6NjMwMTAwNQ==",
lat: 60.214682,
lon: 24.175309
},
{
id: "U3RvcDpIU0w6NjMwMTAwNw==",
lat: 60.209686,
lon: 24.179658
},
{
id: "U3RvcDpIU0w6NjMwMTA0NQ==",
lat: 60.202427,
lon: 24.187789
},
{
id: "U3RvcDpIU0w6NjMwMTAyOA==",
lat: 60.197833,
lon: 24.189472
},
{
id: "U3RvcDpIU0w6NjMwMTAzNw==",
lat: 60.193402,
lon: 24.197974
},
{
id: "U3RvcDpIU0w6NjMwMTAyMA==",
lat: 60.190246,
lon: 24.20253
},
{
id: "U3RvcDpIU0w6NjMwMTAzMQ==",
lat: 60.178093,
lon: 24.202822
},
{
id: "U3RvcDpIU0w6NjMwMTAxMQ==",
lat: 60.172765,
lon: 24.206878
},
{
id: "U3RvcDpIU0w6NjMwMTA1Mg==",
lat: 60.170375,
lon: 24.200431
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAyMw==",
lat: 60.165141,
lon: 24.197315
},
{
id: "U3RvcDpIU0w6NjMwMTAzMw==",
lat: 60.171361,
lon: 24.201095
},
{
id: "U3RvcDpIU0w6NjMwMTAxMg==",
lat: 60.173692,
lon: 24.206942
},
{
id: "U3RvcDpIU0w6NjMwMTAzMA==",
lat: 60.179294,
lon: 24.202626
},
{
id: "U3RvcDpIU0w6NjMwMTAxOQ==",
lat: 60.191329,
lon: 24.201499
},
{
id: "U3RvcDpIU0w6NjMwMTAzNg==",
lat: 60.194178,
lon: 24.196475
},
{
id: "U3RvcDpIU0w6NjMwMTAyOQ==",
lat: 60.19734,
lon: 24.190339
},
{
id: "U3RvcDpIU0w6NjMwMTA0NA==",
lat: 60.203399,
lon: 24.187575
},
{
id: "U3RvcDpIU0w6NjMwMTAwNg==",
lat: 60.209324,
lon: 24.180015
},
{
id: "U3RvcDpIU0w6NjMwMTAwNA==",
lat: 60.216663,
lon: 24.17413
},
{
id: "U3RvcDpIU0w6NjMwMTAxMw==",
lat: 60.222396,
lon: 24.171062
},
{
id: "U3RvcDpIU0w6NjMwMTA1OA==",
lat: 60.235362,
lon: 24.168629
}
]
},
{
gtfsId: "HSL:4739",
shortName: "739",
longName: "Rautatientori-Päiväkumpu-Korso-Pohjois-Nikinmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDg2MDIxNg==",
lat: 60.3582,
lon: 25.14771
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mw==",
lat: 60.35602,
lon: 25.13996
},
{
id: "U3RvcDpIU0w6NDg2MDIyMA==",
lat: 60.35607,
lon: 25.13692
},
{
id: "U3RvcDpIU0w6NDg2MDIxOA==",
lat: 60.35661,
lon: 25.12949
},
{
id: "U3RvcDpIU0w6NDg2MDIzNQ==",
lat: 60.35681,
lon: 25.12739
},
{
id: "U3RvcDpIU0w6NDg2MDIzOQ==",
lat: 60.35993,
lon: 25.1261
},
{
id: "U3RvcDpIU0w6NDg1MDIxMQ==",
lat: 60.36036,
lon: 25.11878
},
{
id: "U3RvcDpIU0w6NDg0MDIxOQ==",
lat: 60.35998,
lon: 25.10439
},
{
id: "U3RvcDpIU0w6NDg0MDIwNQ==",
lat: 60.35985,
lon: 25.10057
},
{
id: "U3RvcDpIU0w6NDg0MDIyMg==",
lat: 60.36097,
lon: 25.09653
},
{
id: "U3RvcDpIU0w6NDg0MDIwNw==",
lat: 60.36226,
lon: 25.09425
},
{
id: "U3RvcDpIU0w6NDg0MDIwOQ==",
lat: 60.36134,
lon: 25.09133
},
{
id: "U3RvcDpIU0w6NDg0MDIxNw==",
lat: 60.3588,
lon: 25.0901
},
{
id: "U3RvcDpIU0w6NDg0MDIxNA==",
lat: 60.358662,
lon: 25.086221
},
{
id: "U3RvcDpIU0w6NDgxMDIzNg==",
lat: 60.359299,
lon: 25.079697
},
{
id: "U3RvcDpIU0w6NDgxMDIzNA==",
lat: 60.35686,
lon: 25.078553
},
{
id: "U3RvcDpIU0w6NDgxMDI5NA==",
lat: 60.354391,
lon: 25.078477
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mg==",
lat: 60.3525,
lon: 25.07726
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDI5OA==",
lat: 60.346684,
lon: 25.075914
},
{
id: "U3RvcDpIU0w6NDgwMDIwOA==",
lat: 60.345185,
lon: 25.082611
},
{
id: "U3RvcDpIU0w6NDgwMDIwNg==",
lat: 60.34348,
lon: 25.07869
},
{
id: "U3RvcDpIU0w6NDgwMDIwNA==",
lat: 60.34075,
lon: 25.08005
},
{
id: "U3RvcDpIU0w6NDgwMDIwMg==",
lat: 60.33558,
lon: 25.07705
},
{
id: "U3RvcDpIU0w6NDczMDI5OA==",
lat: 60.33287,
lon: 25.07482
},
{
id: "U3RvcDpIU0w6NDczMDIwMQ==",
lat: 60.33011,
lon: 25.0737
},
{
id: "U3RvcDpIU0w6NDczMDIwNQ==",
lat: 60.32981,
lon: 25.08057
},
{
id: "U3RvcDpIU0w6NDczMDIwNw==",
lat: 60.32951,
lon: 25.08499
},
{
id: "U3RvcDpIU0w6NDczMDIwOQ==",
lat: 60.32853,
lon: 25.08968
},
{
id: "U3RvcDpIU0w6NDc1MDIwMQ==",
lat: 60.3279,
lon: 25.09475
},
{
id: "U3RvcDpIU0w6NDc1MDIwMw==",
lat: 60.32736,
lon: 25.10289
},
{
id: "U3RvcDpIU0w6NDc1MDIwNA==",
lat: 60.32423,
lon: 25.10955
},
{
id: "U3RvcDpIU0w6NDc1MDIwNg==",
lat: 60.32138,
lon: 25.11206
},
{
id: "U3RvcDpIU0w6NDk3MDIyNA==",
lat: 60.31994,
lon: 25.11693
},
{
id: "U3RvcDpIU0w6NDk3MDIyMg==",
lat: 60.31916,
lon: 25.11493
},
{
id: "U3RvcDpIU0w6NDk3MDIyMA==",
lat: 60.31307,
lon: 25.10852
},
{
id: "U3RvcDpIU0w6NDk3MDIxOA==",
lat: 60.304039,
lon: 25.104318
},
{
id: "U3RvcDpIU0w6NDk3MDI5Ng==",
lat: 60.30183,
lon: 25.10375
},
{
id: "U3RvcDpIU0w6NDk2MDIxNw==",
lat: 60.29775,
lon: 25.10205
},
{
id: "U3RvcDpIU0w6NDk2MDI5OQ==",
lat: 60.292049,
lon: 25.099393
},
{
id: "U3RvcDpIU0w6NDk2MDIxNQ==",
lat: 60.28741,
lon: 25.10189
},
{
id: "U3RvcDpIU0w6NDk0MDIyMw==",
lat: 60.2806,
lon: 25.10108
},
{
id: "U3RvcDpIU0w6NDkzMDIyNg==",
lat: 60.27535,
lon: 25.09522
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExNQ==",
lat: 60.17141,
lon: 24.94266
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIyNQ==",
lat: 60.27255,
lon: 25.09256
},
{
id: "U3RvcDpIU0w6NDkzMDIzMA==",
lat: 60.27502,
lon: 25.09521
},
{
id: "U3RvcDpIU0w6NDk0MDIyMg==",
lat: 60.28128,
lon: 25.102
},
{
id: "U3RvcDpIU0w6NDk2MDIxNA==",
lat: 60.2883,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6NDk2MDI5OA==",
lat: 60.293118,
lon: 25.099951
},
{
id: "U3RvcDpIU0w6NDk2MDIxNg==",
lat: 60.2979,
lon: 25.10244
},
{
id: "U3RvcDpIU0w6NDk3MDI5Nw==",
lat: 60.30293,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6NDk3MDIxNw==",
lat: 60.30573,
lon: 25.10498
},
{
id: "U3RvcDpIU0w6NDk3MDIxOQ==",
lat: 60.31407,
lon: 25.10985
},
{
id: "U3RvcDpIU0w6NDk3MDIyMQ==",
lat: 60.31937,
lon: 25.11534
},
{
id: "U3RvcDpIU0w6NDk3MDIyMw==",
lat: 60.32021,
lon: 25.11481
},
{
id: "U3RvcDpIU0w6NDc1MDIwNw==",
lat: 60.32126,
lon: 25.11231
},
{
id: "U3RvcDpIU0w6NDc1MDIwNQ==",
lat: 60.3247,
lon: 25.10919
},
{
id: "U3RvcDpIU0w6NDc1MDI5OQ==",
lat: 60.32767,
lon: 25.10175
},
{
id: "U3RvcDpIU0w6NDc1MDIwMg==",
lat: 60.32803,
lon: 25.09629
},
{
id: "U3RvcDpIU0w6NDczMDIxMA==",
lat: 60.32863,
lon: 25.08983
},
{
id: "U3RvcDpIU0w6NDczMDIwOA==",
lat: 60.32929,
lon: 25.08625
},
{
id: "U3RvcDpIU0w6NDczMDIwNg==",
lat: 60.32987,
lon: 25.07899
},
{
id: "U3RvcDpIU0w6NDczMDI5OQ==",
lat: 60.33099,
lon: 25.07343
},
{
id: "U3RvcDpIU0w6NDczMDI5Nw==",
lat: 60.33371,
lon: 25.07565
},
{
id: "U3RvcDpIU0w6NDgwMDIwMQ==",
lat: 60.3353,
lon: 25.07702
},
{
id: "U3RvcDpIU0w6NDgwMDIwMw==",
lat: 60.33975,
lon: 25.08047
},
{
id: "U3RvcDpIU0w6NDgwMDIwNQ==",
lat: 60.3439,
lon: 25.08007
},
{
id: "U3RvcDpIU0w6NDgzMDIyMw==",
lat: 60.34579,
lon: 25.08404
},
{
id: "U3RvcDpIU0w6NDgzMDIwNA==",
lat: 60.34708,
lon: 25.0832
},
{
id: "U3RvcDpIU0w6NDgzMDI5OQ==",
lat: 60.34672,
lon: 25.08124
},
{
id: "U3RvcDpIU0w6NDgxMDI5OQ==",
lat: 60.34736,
lon: 25.07515
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI5NQ==",
lat: 60.354427,
lon: 25.078612
},
{
id: "U3RvcDpIU0w6NDgxMDIzMw==",
lat: 60.357699,
lon: 25.079007
},
{
id: "U3RvcDpIU0w6NDgxMDIzNw==",
lat: 60.359454,
lon: 25.081307
},
{
id: "U3RvcDpIU0w6NDg0MDIxMw==",
lat: 60.35858,
lon: 25.085945
},
{
id: "U3RvcDpIU0w6NDg0MDIxOA==",
lat: 60.35991,
lon: 25.09024
},
{
id: "U3RvcDpIU0w6NDg0MDIwOA==",
lat: 60.36106,
lon: 25.09133
},
{
id: "U3RvcDpIU0w6NDg0MDIwNg==",
lat: 60.36194,
lon: 25.09498
},
{
id: "U3RvcDpIU0w6NDg0MDIyMw==",
lat: 60.36065,
lon: 25.09661
},
{
id: "U3RvcDpIU0w6NDg0MDIyMQ==",
lat: 60.35971,
lon: 25.09765
},
{
id: "U3RvcDpIU0w6NDg0MDIwMw==",
lat: 60.3599,
lon: 25.10471
},
{
id: "U3RvcDpIU0w6NDg1MDIxMA==",
lat: 60.36021,
lon: 25.11862
},
{
id: "U3RvcDpIU0w6NDg2MDIzOA==",
lat: 60.35978,
lon: 25.12533
},
{
id: "U3RvcDpIU0w6NDg2MDIxMQ==",
lat: 60.35938,
lon: 25.1277
},
{
id: "U3RvcDpIU0w6NDg2MDIxNw==",
lat: 60.35687,
lon: 25.13116
},
{
id: "U3RvcDpIU0w6NDg2MDIxOQ==",
lat: 60.35598,
lon: 25.13691
},
{
id: "U3RvcDpIU0w6NDg2MDI1MA==",
lat: 60.35599,
lon: 25.14148
},
{
id: "U3RvcDpIU0w6NDg2MDI0Nw==",
lat: 60.35822,
lon: 25.14772
}
]
},
{
gtfsId: "HSL:2437",
shortName: "437",
longName: "Martinlaakso-Perusmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcxNDI1NQ==",
lat: 60.286994,
lon: 24.725706
},
{
id: "U3RvcDpIU0w6MjcxNDI1NA==",
lat: 60.28594,
lon: 24.73075
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mw==",
lat: 60.28618,
lon: 24.73694
},
{
id: "U3RvcDpIU0w6MjcxNTI1MQ==",
lat: 60.28582,
lon: 24.74113
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOQ==",
lat: 60.27787,
lon: 24.74963
},
{
id: "U3RvcDpIU0w6MjcxNTIxNQ==",
lat: 60.27398,
lon: 24.74953
},
{
id: "U3RvcDpIU0w6MjcxNTI0Nw==",
lat: 60.27007,
lon: 24.75398
},
{
id: "U3RvcDpIU0w6MjcxNTI5NA==",
lat: 60.26969,
lon: 24.75626
},
{
id: "U3RvcDpIU0w6MjcxNTIzMA==",
lat: 60.26954,
lon: 24.75945
},
{
id: "U3RvcDpIU0w6NDEyMDIxNw==",
lat: 60.27395,
lon: 24.78154
},
{
id: "U3RvcDpIU0w6NDEyMDIzNg==",
lat: 60.272876,
lon: 24.790986
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxMQ==",
lat: 60.2773,
lon: 24.85304
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDEyMDIxNA==",
lat: 60.27342,
lon: 24.7938
},
{
id: "U3RvcDpIU0w6NDEyMDIxNg==",
lat: 60.27395,
lon: 24.77924
},
{
id: "U3RvcDpIU0w6MjcxNTI5NQ==",
lat: 60.269782,
lon: 24.755897
},
{
id: "U3RvcDpIU0w6MjcxNTIxMw==",
lat: 60.27087,
lon: 24.75311
},
{
id: "U3RvcDpIU0w6MjcxNTIxNA==",
lat: 60.27323,
lon: 24.75052
},
{
id: "U3RvcDpIU0w6MjcxNTIwMg==",
lat: 60.275124,
lon: 24.749747
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0OQ==",
lat: 60.28471,
lon: 24.74512
},
{
id: "U3RvcDpIU0w6MjcxNTI1MA==",
lat: 60.28549,
lon: 24.74204
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mg==",
lat: 60.28637,
lon: 24.73772
},
{
id: "U3RvcDpIU0w6MjcxNDI5Ng==",
lat: 60.28573,
lon: 24.73092
}
]
},
{
gtfsId: "HSL:4619",
shortName: "619",
longName: "Tikkurila-Hiekkaharju-Simonsilta",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDY1MDIyMg==",
lat: 60.31593,
lon: 25.0243
},
{
id: "U3RvcDpIU0w6NDY1MDIyMA==",
lat: 60.31364,
lon: 25.02243
},
{
id: "U3RvcDpIU0w6NDY1MDI0MQ==",
lat: 60.312044,
lon: 25.025099
},
{
id: "U3RvcDpIU0w6NDY1MDIwNQ==",
lat: 60.31,
lon: 25.0287
},
{
id: "U3RvcDpIU0w6NDY1MDIwNw==",
lat: 60.31132,
lon: 25.03142
},
{
id: "U3RvcDpIU0w6NDY1MDI0Mw==",
lat: 60.313094,
lon: 25.03333
},
{
id: "U3RvcDpIU0w6NDYwMDIxNA==",
lat: 60.31155,
lon: 25.03821
},
{
id: "U3RvcDpIU0w6NDYwMDIxMg==",
lat: 60.30809,
lon: 25.0336
},
{
id: "U3RvcDpIU0w6NDYwMDIxMA==",
lat: 60.30671,
lon: 25.03683
},
{
id: "U3RvcDpIU0w6NDYwMDIwOA==",
lat: 60.30441,
lon: 25.04265
},
{
id: "U3RvcDpIU0w6NDYwMDIwNg==",
lat: 60.30239,
lon: 25.0452
},
{
id: "U3RvcDpIU0w6NDYwMDIwNA==",
lat: 60.30139,
lon: 25.04087
},
{
id: "U3RvcDpIU0w6NDYxMDIzOQ==",
lat: 60.299,
lon: 25.04094
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI1MQ==",
lat: 60.293975,
lon: 25.044437
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIxNQ==",
lat: 60.29674,
lon: 25.03984
},
{
id: "U3RvcDpIU0w6NDYwMDIwMQ==",
lat: 60.30027,
lon: 25.04059
},
{
id: "U3RvcDpIU0w6NDYwMDIwMw==",
lat: 60.30174,
lon: 25.04301
},
{
id: "U3RvcDpIU0w6NDYwMDIwNQ==",
lat: 60.30359,
lon: 25.04489
},
{
id: "U3RvcDpIU0w6NDYwMDIwNw==",
lat: 60.30492,
lon: 25.0414
},
{
id: "U3RvcDpIU0w6NDYwMDIwOQ==",
lat: 60.30643,
lon: 25.03734
},
{
id: "U3RvcDpIU0w6NDYwMDIxMw==",
lat: 60.30911,
lon: 25.03456
},
{
id: "U3RvcDpIU0w6NDY1MDIyMw==",
lat: 60.31208,
lon: 25.038425
},
{
id: "U3RvcDpIU0w6NDY1MDI0Mg==",
lat: 60.313078,
lon: 25.034026
},
{
id: "U3RvcDpIU0w6NDY1MDIwOA==",
lat: 60.31072,
lon: 25.03015
},
{
id: "U3RvcDpIU0w6NDY1MDIxNQ==",
lat: 60.30996,
lon: 25.02734
},
{
id: "U3RvcDpIU0w6NDY1MDI0MA==",
lat: 60.312016,
lon: 25.025025
},
{
id: "U3RvcDpIU0w6NDY1MDIxOQ==",
lat: 60.31408,
lon: 25.0219
},
{
id: "U3RvcDpIU0w6NDY1MDIyMQ==",
lat: 60.31614,
lon: 25.02505
}
]
},
{
gtfsId: "HSL:2436",
shortName: "436",
longName: "Elielinaukio-Martinlaakso-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOQ==",
lat: 60.27787,
lon: 24.74963
},
{
id: "U3RvcDpIU0w6MjcxNTIxNQ==",
lat: 60.27398,
lon: 24.74953
},
{
id: "U3RvcDpIU0w6MjcxNTI0Nw==",
lat: 60.27007,
lon: 24.75398
},
{
id: "U3RvcDpIU0w6MjcxNTI5NA==",
lat: 60.26969,
lon: 24.75626
},
{
id: "U3RvcDpIU0w6MjcxNTIzMA==",
lat: 60.26954,
lon: 24.75945
},
{
id: "U3RvcDpIU0w6NDEyMDIxNw==",
lat: 60.27395,
lon: 24.78154
},
{
id: "U3RvcDpIU0w6NDEyMDIzNg==",
lat: 60.272876,
lon: 24.790986
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxNQ==",
lat: 60.2772,
lon: 24.85298
},
{
id: "U3RvcDpIU0w6NDE3MDI5OQ==",
lat: 60.2753,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDE1MDIxOA==",
lat: 60.2703,
lon: 24.85623
},
{
id: "U3RvcDpIU0w6NDE1MDIzMQ==",
lat: 60.26866,
lon: 24.85922
},
{
id: "U3RvcDpIU0w6NDE2MDIyNw==",
lat: 60.26541,
lon: 24.86472
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDIzOQ==",
lat: 60.171981,
lon: 24.93971
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE2MDIyNg==",
lat: 60.26548,
lon: 24.86497
},
{
id: "U3RvcDpIU0w6NDE1MDIzMA==",
lat: 60.26948,
lon: 24.85788
},
{
id: "U3RvcDpIU0w6NDE1MDIxNw==",
lat: 60.27172,
lon: 24.85481
},
{
id: "U3RvcDpIU0w6NDE3MDI5Mw==",
lat: 60.275267,
lon: 24.856513
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDEyMDIxNA==",
lat: 60.27342,
lon: 24.7938
},
{
id: "U3RvcDpIU0w6NDEyMDIxNg==",
lat: 60.27395,
lon: 24.77924
},
{
id: "U3RvcDpIU0w6MjcxNTI5NQ==",
lat: 60.269782,
lon: 24.755897
},
{
id: "U3RvcDpIU0w6MjcxNTIxMw==",
lat: 60.27087,
lon: 24.75311
},
{
id: "U3RvcDpIU0w6MjcxNTIxNA==",
lat: 60.27323,
lon: 24.75052
},
{
id: "U3RvcDpIU0w6MjcxNTIwMg==",
lat: 60.275124,
lon: 24.749747
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
}
]
},
{
gtfsId: "HSL:2435",
shortName: "435",
longName: "Elielinaukio-Koskelo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcxMjIxNQ==",
lat: 60.25791,
lon: 24.71676
},
{
id: "U3RvcDpIU0w6MjcxMjIxNw==",
lat: 60.25978,
lon: 24.7193
},
{
id: "U3RvcDpIU0w6MjcxMjIxOQ==",
lat: 60.26365,
lon: 24.72388
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxOA==",
lat: 60.26626,
lon: 24.73717
},
{
id: "U3RvcDpIU0w6MjcxNTI5Mw==",
lat: 60.26702,
lon: 24.74761
},
{
id: "U3RvcDpIU0w6MjcxNTIxMw==",
lat: 60.27087,
lon: 24.75311
},
{
id: "U3RvcDpIU0w6MjcxNTIxNA==",
lat: 60.27323,
lon: 24.75052
},
{
id: "U3RvcDpIU0w6MjcxNTIwMg==",
lat: 60.275124,
lon: 24.749747
},
{
id: "U3RvcDpIU0w6MjcxNTIzOA==",
lat: 60.27823,
lon: 24.75086
},
{
id: "U3RvcDpIU0w6MjcxNTIzNg==",
lat: 60.27871,
lon: 24.75894
},
{
id: "U3RvcDpIU0w6MjcxNTI4OQ==",
lat: 60.28371,
lon: 24.762188
},
{
id: "U3RvcDpIU0w6MjcyMTIxNg==",
lat: 60.292063,
lon: 24.767285
},
{
id: "U3RvcDpIU0w6MjcyMTIxOA==",
lat: 60.296261,
lon: 24.76745
},
{
id: "U3RvcDpIU0w6NDIwMDIwOA==",
lat: 60.29054,
lon: 24.78286
},
{
id: "U3RvcDpIU0w6NDIwMDIwNg==",
lat: 60.28661,
lon: 24.78718
},
{
id: "U3RvcDpIU0w6NDIwMDIwNA==",
lat: 60.28288,
lon: 24.79207
},
{
id: "U3RvcDpIU0w6NDIwMDIwMg==",
lat: 60.27836,
lon: 24.80175
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxNQ==",
lat: 60.2772,
lon: 24.85298
},
{
id: "U3RvcDpIU0w6NDE3MDI5OQ==",
lat: 60.2753,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDE1MDIxOA==",
lat: 60.2703,
lon: 24.85623
},
{
id: "U3RvcDpIU0w6NDE1MDIzMQ==",
lat: 60.26866,
lon: 24.85922
},
{
id: "U3RvcDpIU0w6NDE2MDIyNw==",
lat: 60.26541,
lon: 24.86472
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDIzOQ==",
lat: 60.171981,
lon: 24.93971
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE2MDIyNg==",
lat: 60.26548,
lon: 24.86497
},
{
id: "U3RvcDpIU0w6NDE1MDIzMA==",
lat: 60.26948,
lon: 24.85788
},
{
id: "U3RvcDpIU0w6NDE1MDIxNw==",
lat: 60.27172,
lon: 24.85481
},
{
id: "U3RvcDpIU0w6NDE3MDI5Mw==",
lat: 60.275267,
lon: 24.856513
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDIwMDIwMQ==",
lat: 60.27705,
lon: 24.80344
},
{
id: "U3RvcDpIU0w6NDIwMDIwMw==",
lat: 60.28351,
lon: 24.79137
},
{
id: "U3RvcDpIU0w6NDIwMDIwNQ==",
lat: 60.28806,
lon: 24.78593
},
{
id: "U3RvcDpIU0w6NDIwMDIwNw==",
lat: 60.29149,
lon: 24.78204
},
{
id: "U3RvcDpIU0w6MjcyMTIxNw==",
lat: 60.29538,
lon: 24.767784
},
{
id: "U3RvcDpIU0w6MjcyMTIxNQ==",
lat: 60.291148,
lon: 24.766404
},
{
id: "U3RvcDpIU0w6MjcxNTIwMQ==",
lat: 60.282293,
lon: 24.762207
},
{
id: "U3RvcDpIU0w6MjcxNTIzNQ==",
lat: 60.27888,
lon: 24.7575
},
{
id: "U3RvcDpIU0w6MjcxNTIzOQ==",
lat: 60.27787,
lon: 24.74963
},
{
id: "U3RvcDpIU0w6MjcxNTIxNQ==",
lat: 60.27398,
lon: 24.74953
},
{
id: "U3RvcDpIU0w6MjcxNTI0Nw==",
lat: 60.27007,
lon: 24.75398
},
{
id: "U3RvcDpIU0w6MjcxNTIxMA==",
lat: 60.26655,
lon: 24.74574
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMjIyMA==",
lat: 60.26319,
lon: 24.72306
},
{
id: "U3RvcDpIU0w6MjcxMjIxNg==",
lat: 60.26041,
lon: 24.71996
},
{
id: "U3RvcDpIU0w6MjcxMjIyNA==",
lat: 60.257585,
lon: 24.71617
}
]
},
{
gtfsId: "HSL:2553",
shortName: "553",
longName: "Hakunila-Malmi-Maunula-Leppävaara",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk0MDIzMQ==",
lat: 60.28098,
lon: 25.10949
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNQ==",
lat: 60.27901,
lon: 25.10592
},
{
id: "U3RvcDpIU0w6NDk0MDIxMw==",
lat: 60.28017,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDk0MDIxMQ==",
lat: 60.280871,
lon: 25.095651
},
{
id: "U3RvcDpIU0w6NDY0MDIzMw==",
lat: 60.280881,
lon: 25.087622
},
{
id: "U3RvcDpIU0w6NDY0MDIyOQ==",
lat: 60.277777,
lon: 25.083641
},
{
id: "U3RvcDpIU0w6NDY0MDIzMQ==",
lat: 60.28081,
lon: 25.08328
},
{
id: "U3RvcDpIU0w6NDY0MDIxMQ==",
lat: 60.28169,
lon: 25.07941
},
{
id: "U3RvcDpIU0w6NDY0MDIxMw==",
lat: 60.27837,
lon: 25.07894
},
{
id: "U3RvcDpIU0w6MTQxMjE5Nw==",
lat: 60.27464,
lon: 25.077253
},
{
id: "U3RvcDpIU0w6MTQxMjEzNA==",
lat: 60.27016,
lon: 25.07203
},
{
id: "U3RvcDpIU0w6MTQxMTExOQ==",
lat: 60.26989,
lon: 25.06314
},
{
id: "U3RvcDpIU0w6MTQxMTExMQ==",
lat: 60.26945,
lon: 25.06115
},
{
id: "U3RvcDpIU0w6MTQxMTEwOA==",
lat: 60.26653,
lon: 25.05805
},
{
id: "U3RvcDpIU0w6MTQxMTEwNg==",
lat: 60.26365,
lon: 25.05666
},
{
id: "U3RvcDpIU0w6MTM4NTEwNA==",
lat: 60.26529,
lon: 25.04177
},
{
id: "U3RvcDpIU0w6MTM4NTE2Mw==",
lat: 60.26207,
lon: 25.04015
},
{
id: "U3RvcDpIU0w6MTM4NTE2MQ==",
lat: 60.25598,
lon: 25.03172
},
{
id: "U3RvcDpIU0w6MTM4MjE1OQ==",
lat: 60.25643,
lon: 25.02386
},
{
id: "U3RvcDpIU0w6MTM4MjE2Ng==",
lat: 60.2526,
lon: 25.01394
},
{
id: "U3RvcDpIU0w6MTM4MjE2Mw==",
lat: 60.25152,
lon: 25.01215
},
{
id: "U3RvcDpIU0w6MTM4MjE3Nw==",
lat: 60.24926,
lon: 25.0077
},
{
id: "U3RvcDpIU0w6MTM3MDEyMQ==",
lat: 60.24617,
lon: 25.00154
},
{
id: "U3RvcDpIU0w6MTM4MjExOQ==",
lat: 60.24318,
lon: 24.99639
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM3MDEwNA==",
lat: 60.2399,
lon: 24.97954
},
{
id: "U3RvcDpIU0w6MTI4NDE3OA==",
lat: 60.23699,
lon: 24.97454
},
{
id: "U3RvcDpIU0w6MTI4NDE3NA==",
lat: 60.23539,
lon: 24.97034
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEyNw==",
lat: 60.23022,
lon: 24.94776
},
{
id: "U3RvcDpIU0w6MTI4NDEwMw==",
lat: 60.22972,
lon: 24.94197
},
{
id: "U3RvcDpIU0w6MTI4MjEwMQ==",
lat: 60.2301,
lon: 24.93839
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MTEwNw==",
lat: 60.23472,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTM0MTExOA==",
lat: 60.23743,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTM0MTEyMA==",
lat: 60.23948,
lon: 24.92814
},
{
id: "U3RvcDpIU0w6MTMzMjEwNw==",
lat: 60.23894,
lon: 24.91321
},
{
id: "U3RvcDpIU0w6MTMzMjEzOA==",
lat: 60.236106,
lon: 24.90268
},
{
id: "U3RvcDpIU0w6MTI5NDI0Mg==",
lat: 60.23468,
lon: 24.89256
},
{
id: "U3RvcDpIU0w6MTI5NDI0MQ==",
lat: 60.23476,
lon: 24.879
},
{
id: "U3RvcDpIU0w6MTMyMDIyNw==",
lat: 60.23389,
lon: 24.85886
},
{
id: "U3RvcDpIU0w6MTMyMDIyNQ==",
lat: 60.23054,
lon: 24.8465
},
{
id: "U3RvcDpIU0w6MjExMzI0Mw==",
lat: 60.228005,
lon: 24.826005
},
{
id: "U3RvcDpIU0w6MjExMjI2MQ==",
lat: 60.21896,
lon: 24.816
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIzNg==",
lat: 60.21902,
lon: 24.81092
},
{
id: "U3RvcDpIU0w6MjExMjI2Mg==",
lat: 60.219276,
lon: 24.816951
},
{
id: "U3RvcDpIU0w6MjExMzI0Mg==",
lat: 60.226444,
lon: 24.825385
},
{
id: "U3RvcDpIU0w6MTMyMDIyNA==",
lat: 60.23036,
lon: 24.84689
},
{
id: "U3RvcDpIU0w6MTQ2MzIyNg==",
lat: 60.23445,
lon: 24.86434
},
{
id: "U3RvcDpIU0w6MTI5NDI0MA==",
lat: 60.23449,
lon: 24.87685
},
{
id: "U3RvcDpIU0w6MTI5NDE4MA==",
lat: 60.23438,
lon: 24.89275
},
{
id: "U3RvcDpIU0w6MTMzMjEwNg==",
lat: 60.23566,
lon: 24.90215
},
{
id: "U3RvcDpIU0w6MTMzMjEwOA==",
lat: 60.23891,
lon: 24.91547
},
{
id: "U3RvcDpIU0w6MTM0MTEyMQ==",
lat: 60.23958,
lon: 24.9279
},
{
id: "U3RvcDpIU0w6MTM0MTExOQ==",
lat: 60.23664,
lon: 24.92902
},
{
id: "U3RvcDpIU0w6MTI4MjEwNg==",
lat: 60.23351,
lon: 24.93171
},
{
id: "U3RvcDpIU0w6MTI4MjEwNA==",
lat: 60.23154,
lon: 24.93381
},
{
id: "U3RvcDpIU0w6MTI4MjEwMg==",
lat: 60.23011,
lon: 24.9378
},
{
id: "U3RvcDpIU0w6MTI4NDEwNA==",
lat: 60.22968,
lon: 24.94452
},
{
id: "U3RvcDpIU0w6MTI4NDEyOQ==",
lat: 60.22999,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDE3Mg==",
lat: 60.23425,
lon: 24.96753
},
{
id: "U3RvcDpIU0w6MTI4NDE3NQ==",
lat: 60.23609,
lon: 24.97254
},
{
id: "U3RvcDpIU0w6MTM3MDEwMw==",
lat: 60.23991,
lon: 24.97993
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM4MjEyMA==",
lat: 60.24328,
lon: 24.99679
},
{
id: "U3RvcDpIU0w6MTM4MjEyMg==",
lat: 60.24685,
lon: 25.00326
},
{
id: "U3RvcDpIU0w6MTM4MjE3OA==",
lat: 60.24924,
lon: 25.00818
},
{
id: "U3RvcDpIU0w6MTM4MjE3Ng==",
lat: 60.25049,
lon: 25.01236
},
{
id: "U3RvcDpIU0w6MTM4MjE2NQ==",
lat: 60.25315,
lon: 25.01507
},
{
id: "U3RvcDpIU0w6MTM4MjE1OA==",
lat: 60.25644,
lon: 25.02477
},
{
id: "U3RvcDpIU0w6MTM4NTE2MA==",
lat: 60.25571,
lon: 25.03316
},
{
id: "U3RvcDpIU0w6MTM4NTE4MA==",
lat: 60.26301,
lon: 25.0414
},
{
id: "U3RvcDpIU0w6MTQxMTEwMw==",
lat: 60.26548,
lon: 25.04326
},
{
id: "U3RvcDpIU0w6MTQxMTEwNQ==",
lat: 60.26443,
lon: 25.05769
},
{
id: "U3RvcDpIU0w6MTQxMTEwNw==",
lat: 60.26764,
lon: 25.05906
},
{
id: "U3RvcDpIU0w6MTQxMTExMg==",
lat: 60.26956,
lon: 25.06153
},
{
id: "U3RvcDpIU0w6MTQxMjEyMA==",
lat: 60.26962,
lon: 25.06454
},
{
id: "U3RvcDpIU0w6MTQxMjI5OA==",
lat: 60.270538,
lon: 25.073418
},
{
id: "U3RvcDpIU0w6MTQxMjI5Ng==",
lat: 60.274292,
lon: 25.077007
},
{
id: "U3RvcDpIU0w6NDY0MDIxMg==",
lat: 60.27986,
lon: 25.079974
},
{
id: "U3RvcDpIU0w6NDY0MDIyNw==",
lat: 60.277949,
lon: 25.083092
},
{
id: "U3RvcDpIU0w6NDY0MDIwOQ==",
lat: 60.28153,
lon: 25.0894
},
{
id: "U3RvcDpIU0w6NDk0MDIxMA==",
lat: 60.28073,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6NDk0MDIxMg==",
lat: 60.27969,
lon: 25.10342
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDIzMg==",
lat: 60.28118,
lon: 25.10966
}
]
},
{
gtfsId: "HSL:2552",
shortName: "552",
longName: "Malmi-Maunula-Munkkiniemi-Otaniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIyMjIxMA==",
lat: 60.187376,
lon: 24.833901
},
{
id: "U3RvcDpIU0w6MjIyMjIzNQ==",
lat: 60.183881,
lon: 24.828943
},
{
id: "U3RvcDpIU0w6MjIyMjIwNA==",
lat: 60.18274,
lon: 24.83212
},
{
id: "U3RvcDpIU0w6MjIyMjIwMg==",
lat: 60.1798,
lon: 24.83641
},
{
id: "U3RvcDpIU0w6MTMwMzExNA==",
lat: 60.18153,
lon: 24.849633
},
{
id: "U3RvcDpIU0w6MTMwMjIxOQ==",
lat: 60.18488,
lon: 24.85935
},
{
id: "U3RvcDpIU0w6MTMwMjIxNw==",
lat: 60.18716,
lon: 24.86985
},
{
id: "U3RvcDpIU0w6MTMwMTIxNQ==",
lat: 60.192436,
lon: 24.880264
},
{
id: "U3RvcDpIU0w6MTMwMTI5OQ==",
lat: 60.19581,
lon: 24.8847
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MTMwNDEyNw==",
lat: 60.20289,
lon: 24.88189
},
{
id: "U3RvcDpIU0w6MTMwNDEzNg==",
lat: 60.20573,
lon: 24.88058
},
{
id: "U3RvcDpIU0w6MTI5MTEzOA==",
lat: 60.21059,
lon: 24.8809
},
{
id: "U3RvcDpIU0w6MTI5MTExOA==",
lat: 60.21475,
lon: 24.88711
},
{
id: "U3RvcDpIU0w6MTI5MTExNg==",
lat: 60.21749,
lon: 24.88834
},
{
id: "U3RvcDpIU0w6MTI5MTExMw==",
lat: 60.21736,
lon: 24.8909
},
{
id: "U3RvcDpIU0w6MTI5MTExMQ==",
lat: 60.21624,
lon: 24.89347
},
{
id: "U3RvcDpIU0w6MTI5MTEwNg==",
lat: 60.21582,
lon: 24.898291
},
{
id: "U3RvcDpIU0w6MTI5MTEyMw==",
lat: 60.21762,
lon: 24.89964
},
{
id: "U3RvcDpIU0w6MTI5MTEyNQ==",
lat: 60.21965,
lon: 24.90171
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzEyMw==",
lat: 60.22424,
lon: 24.89852
},
{
id: "U3RvcDpIU0w6MTI5MzE2Mw==",
lat: 60.22682,
lon: 24.90304
},
{
id: "U3RvcDpIU0w6MTI4NjE4MQ==",
lat: 60.227754,
lon: 24.907305
},
{
id: "U3RvcDpIU0w6MTI4MTExNA==",
lat: 60.23083,
lon: 24.92003
},
{
id: "U3RvcDpIU0w6MTI4MjE0MQ==",
lat: 60.22898,
lon: 24.92337
},
{
id: "U3RvcDpIU0w6MTI4MjE0Mg==",
lat: 60.22827,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTI4MjE0Ng==",
lat: 60.23062,
lon: 24.93342
},
{
id: "U3RvcDpIU0w6MTI4MjEwMg==",
lat: 60.23011,
lon: 24.9378
},
{
id: "U3RvcDpIU0w6MTI4NDEwNA==",
lat: 60.22968,
lon: 24.94452
},
{
id: "U3RvcDpIU0w6MTI4NDEyOQ==",
lat: 60.22999,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDE3Mg==",
lat: 60.23425,
lon: 24.96753
},
{
id: "U3RvcDpIU0w6MTI4NDE3NQ==",
lat: 60.23609,
lon: 24.97254
},
{
id: "U3RvcDpIU0w6MTM3MDEwMw==",
lat: 60.23991,
lon: 24.97993
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM4MjEyMA==",
lat: 60.24328,
lon: 24.99679
},
{
id: "U3RvcDpIU0w6MTM4MjEyMg==",
lat: 60.24685,
lon: 25.00326
},
{
id: "U3RvcDpIU0w6MTM4MjE3OA==",
lat: 60.24924,
lon: 25.00818
},
{
id: "U3RvcDpIU0w6MTM4MjE3NA==",
lat: 60.25022,
lon: 25.01237
},
{
id: "U3RvcDpIU0w6MTM4MjE3Nw==",
lat: 60.24926,
lon: 25.0077
},
{
id: "U3RvcDpIU0w6MTM3MDEyMQ==",
lat: 60.24617,
lon: 25.00154
},
{
id: "U3RvcDpIU0w6MTM4MjExOQ==",
lat: 60.24318,
lon: 24.99639
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM3MDEwNA==",
lat: 60.2399,
lon: 24.97954
},
{
id: "U3RvcDpIU0w6MTI4NDE3OA==",
lat: 60.23699,
lon: 24.97454
},
{
id: "U3RvcDpIU0w6MTI4NDE3NA==",
lat: 60.23539,
lon: 24.97034
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEyNw==",
lat: 60.23022,
lon: 24.94776
},
{
id: "U3RvcDpIU0w6MTI4NDEwMw==",
lat: 60.22972,
lon: 24.94197
},
{
id: "U3RvcDpIU0w6MTI4MjEwMQ==",
lat: 60.2301,
lon: 24.93839
},
{
id: "U3RvcDpIU0w6MTI4MjE0Nw==",
lat: 60.230679,
lon: 24.932013
},
{
id: "U3RvcDpIU0w6MTI4MjE0NQ==",
lat: 60.228725,
lon: 24.927237
},
{
id: "U3RvcDpIU0w6MTI4MjE0MA==",
lat: 60.22883,
lon: 24.92372
},
{
id: "U3RvcDpIU0w6MTI4MTExMg==",
lat: 60.23075,
lon: 24.91943
},
{
id: "U3RvcDpIU0w6MTI4MTExNQ==",
lat: 60.22997,
lon: 24.91637
},
{
id: "U3RvcDpIU0w6MTI4MTE2MA==",
lat: 60.227725,
lon: 24.906583
},
{
id: "U3RvcDpIU0w6MTI5MzE2Mg==",
lat: 60.22686,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzEyNA==",
lat: 60.22408,
lon: 24.89863
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MTEyNA==",
lat: 60.21848,
lon: 24.89938
},
{
id: "U3RvcDpIU0w6MTI5MTEwOA==",
lat: 60.216,
lon: 24.89718
},
{
id: "U3RvcDpIU0w6MTI5MTExMA==",
lat: 60.21632,
lon: 24.89437
},
{
id: "U3RvcDpIU0w6MTI5MTExMg==",
lat: 60.21766,
lon: 24.89051
},
{
id: "U3RvcDpIU0w6MTI5MTExNQ==",
lat: 60.21736,
lon: 24.88825
},
{
id: "U3RvcDpIU0w6MTI5MTExNw==",
lat: 60.21463,
lon: 24.88657
},
{
id: "U3RvcDpIU0w6MTI5MTEzOQ==",
lat: 60.21066,
lon: 24.8805
},
{
id: "U3RvcDpIU0w6MTMwNDEzNw==",
lat: 60.206219,
lon: 24.879857
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTIxMg==",
lat: 60.19575,
lon: 24.8846
},
{
id: "U3RvcDpIU0w6MTMwMTIxNA==",
lat: 60.19223,
lon: 24.87814
},
{
id: "U3RvcDpIU0w6MTMwMjIxNg==",
lat: 60.18696,
lon: 24.8681
},
{
id: "U3RvcDpIU0w6MTMwMjIxOA==",
lat: 60.184553,
lon: 24.857309
},
{
id: "U3RvcDpIU0w6MTMwMzI5OA==",
lat: 60.1816,
lon: 24.8493
},
{
id: "U3RvcDpIU0w6MjIyMjIwMQ==",
lat: 60.18023,
lon: 24.8376
},
{
id: "U3RvcDpIU0w6MjIyMjIwMw==",
lat: 60.18197,
lon: 24.83372
},
{
id: "U3RvcDpIU0w6MjIyMjIxMQ==",
lat: 60.183984,
lon: 24.829145
},
{
id: "U3RvcDpIU0w6MjIyMjIwOQ==",
lat: 60.18833,
lon: 24.83492
}
]
},
{
gtfsId: "HSL:4731",
shortName: "731",
longName: "Rautatientori-Kulomäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDgxMDIxNg==",
lat: 60.346583,
lon: 25.057448
},
{
id: "U3RvcDpIU0w6NDgxMDIxNw==",
lat: 60.34571,
lon: 25.05606
},
{
id: "U3RvcDpIU0w6NDgxMDIxNQ==",
lat: 60.34441,
lon: 25.06396
},
{
id: "U3RvcDpIU0w6NDgxMDIxMw==",
lat: 60.34548,
lon: 25.06682
},
{
id: "U3RvcDpIU0w6NDgxMDIyMw==",
lat: 60.34757,
lon: 25.06725
},
{
id: "U3RvcDpIU0w6NDgxMDIxMQ==",
lat: 60.35058,
lon: 25.06713
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDI5OA==",
lat: 60.346684,
lon: 25.075914
},
{
id: "U3RvcDpIU0w6NDgzMDI5OA==",
lat: 60.34554,
lon: 25.08651
},
{
id: "U3RvcDpIU0w6NDgzMDIwMg==",
lat: 60.34514,
lon: 25.09151
},
{
id: "U3RvcDpIU0w6NDgyMDIwMw==",
lat: 60.34321,
lon: 25.09762
},
{
id: "U3RvcDpIU0w6NDgyMDIwNQ==",
lat: 60.34113,
lon: 25.09689
},
{
id: "U3RvcDpIU0w6NDgyMDIxNA==",
lat: 60.33971,
lon: 25.10071
},
{
id: "U3RvcDpIU0w6NDgyMDIyMg==",
lat: 60.33964,
lon: 25.10486
},
{
id: "U3RvcDpIU0w6NDgyMDIyNA==",
lat: 60.34237,
lon: 25.10535
},
{
id: "U3RvcDpIU0w6NDgyMDIxOQ==",
lat: 60.34357,
lon: 25.10374
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExNQ==",
lat: 60.17141,
lon: 24.94266
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDgyMDIxOA==",
lat: 60.34362,
lon: 25.10246
},
{
id: "U3RvcDpIU0w6NDgyMDIyNQ==",
lat: 60.34225,
lon: 25.1052
},
{
id: "U3RvcDpIU0w6NDgyMDIyMw==",
lat: 60.34043,
lon: 25.1051
},
{
id: "U3RvcDpIU0w6NDgyMDIxMA==",
lat: 60.33979,
lon: 25.10148
},
{
id: "U3RvcDpIU0w6NDgyMDIwOA==",
lat: 60.34133,
lon: 25.09714
},
{
id: "U3RvcDpIU0w6NDgyMDIwNA==",
lat: 60.34338,
lon: 25.09789
},
{
id: "U3RvcDpIU0w6NDgyMDIwNg==",
lat: 60.34513,
lon: 25.09491
},
{
id: "U3RvcDpIU0w6NDgzMDIwMQ==",
lat: 60.3453,
lon: 25.08927
},
{
id: "U3RvcDpIU0w6NDgzMDI5OQ==",
lat: 60.34672,
lon: 25.08124
},
{
id: "U3RvcDpIU0w6NDgxMDI5OQ==",
lat: 60.34736,
lon: 25.07515
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIwMw==",
lat: 60.35029,
lon: 25.07671
},
{
id: "U3RvcDpIU0w6NDgxMDIxMA==",
lat: 60.35169,
lon: 25.06696
},
{
id: "U3RvcDpIU0w6NDgxMDIyNA==",
lat: 60.34788,
lon: 25.06706
},
{
id: "U3RvcDpIU0w6NDgxMDIxMg==",
lat: 60.34533,
lon: 25.06672
},
{
id: "U3RvcDpIU0w6NDgxMDIxNA==",
lat: 60.34454,
lon: 25.06311
}
]
},
{
gtfsId: "HSL:6911",
shortName: "911",
longName: "Kauklahti-Masala-Kirkkonummi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjUxMTIzOA==",
lat: 60.18847,
lon: 24.59719
},
{
id: "U3RvcDpIU0w6MjUxMTIzNw==",
lat: 60.18797,
lon: 24.59555
},
{
id: "U3RvcDpIU0w6MjUxMTIzMw==",
lat: 60.18683,
lon: 24.59231
},
{
id: "U3RvcDpIU0w6MjUxMTIzOQ==",
lat: 60.186662,
lon: 24.588232
},
{
id: "U3RvcDpIU0w6MjUxMTI1Nw==",
lat: 60.18826,
lon: 24.586646
},
{
id: "U3RvcDpIU0w6MjUxMTIyNA==",
lat: 60.18794,
lon: 24.583858
},
{
id: "U3RvcDpIU0w6MjUxMTIxNg==",
lat: 60.18905,
lon: 24.58041
},
{
id: "U3RvcDpIU0w6MjUxMjIzMQ==",
lat: 60.190315,
lon: 24.57197
},
{
id: "U3RvcDpIU0w6MjUxMjIzMw==",
lat: 60.18887,
lon: 24.565303
},
{
id: "U3RvcDpIU0w6MjUxMjIzNw==",
lat: 60.184835,
lon: 24.560822
},
{
id: "U3RvcDpIU0w6MjUxMjIzOQ==",
lat: 60.182828,
lon: 24.556403
},
{
id: "U3RvcDpIU0w6NjE3MDIyMg==",
lat: 60.180507,
lon: 24.550487
},
{
id: "U3RvcDpIU0w6NjAyMDI0MQ==",
lat: 60.177925,
lon: 24.547288
},
{
id: "U3RvcDpIU0w6NjAyMDIzOQ==",
lat: 60.172823,
lon: 24.54828
},
{
id: "U3RvcDpIU0w6NjAyMDIzNA==",
lat: 60.16918,
lon: 24.54261
},
{
id: "U3RvcDpIU0w6NjAyMDIzMA==",
lat: 60.166542,
lon: 24.540887
},
{
id: "U3RvcDpIU0w6NjAyMDIyOQ==",
lat: 60.163035,
lon: 24.539265
},
{
id: "U3RvcDpIU0w6NjAyMDIyNw==",
lat: 60.159457,
lon: 24.536668
},
{
id: "U3RvcDpIU0w6NjAyMDIxOA==",
lat: 60.156095,
lon: 24.531702
},
{
id: "U3RvcDpIU0w6NjAyMDIwOQ==",
lat: 60.150418,
lon: 24.527258
},
{
id: "U3RvcDpIU0w6NjAzMDIyNg==",
lat: 60.142742,
lon: 24.520495
},
{
id: "U3RvcDpIU0w6NjAzMDIyNA==",
lat: 60.139088,
lon: 24.51195
},
{
id: "U3RvcDpIU0w6NjAzMDIyMw==",
lat: 60.137172,
lon: 24.507677
},
{
id: "U3RvcDpIU0w6NjAzMDIxOA==",
lat: 60.13512,
lon: 24.503027
},
{
id: "U3RvcDpIU0w6NjAzMDIxNQ==",
lat: 60.132965,
lon: 24.494397
},
{
id: "U3RvcDpIU0w6NjA0MDIyOA==",
lat: 60.130113,
lon: 24.480768
},
{
id: "U3RvcDpIU0w6NjA0MDIyNQ==",
lat: 60.126777,
lon: 24.472177
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI4OA==",
lat: 60.119803,
lon: 24.441526
},
{
id: "U3RvcDpIU0w6NjA0MDI5Mg==",
lat: 60.119723,
lon: 24.441012
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIyMw==",
lat: 60.126372,
lon: 24.471547
},
{
id: "U3RvcDpIU0w6NjA0MDIyNw==",
lat: 60.130182,
lon: 24.48253
},
{
id: "U3RvcDpIU0w6NjAzMDIxNA==",
lat: 60.132453,
lon: 24.492952
},
{
id: "U3RvcDpIU0w6NjAzMDIxNw==",
lat: 60.134682,
lon: 24.50252
},
{
id: "U3RvcDpIU0w6NjAzMDIyMg==",
lat: 60.137063,
lon: 24.507907
},
{
id: "U3RvcDpIU0w6NjAzMDIyNQ==",
lat: 60.139437,
lon: 24.51347
},
{
id: "U3RvcDpIU0w6NjAzMDIyNw==",
lat: 60.143618,
lon: 24.521718
},
{
id: "U3RvcDpIU0w6NjAyMDIxMA==",
lat: 60.151237,
lon: 24.528287
},
{
id: "U3RvcDpIU0w6NjAyMDIxNw==",
lat: 60.155497,
lon: 24.531227
},
{
id: "U3RvcDpIU0w6NjAyMDIyNA==",
lat: 60.1588,
lon: 24.536007
},
{
id: "U3RvcDpIU0w6NjAyMDIyOA==",
lat: 60.161683,
lon: 24.538822
},
{
id: "U3RvcDpIU0w6NjAyMDIzMQ==",
lat: 60.167277,
lon: 24.541513
},
{
id: "U3RvcDpIU0w6NjAyMDIzNQ==",
lat: 60.169593,
lon: 24.543572
},
{
id: "U3RvcDpIU0w6NjAyMDIzOA==",
lat: 60.171893,
lon: 24.547945
},
{
id: "U3RvcDpIU0w6NjAyMDI0MA==",
lat: 60.17751,
lon: 24.547598
},
{
id: "U3RvcDpIU0w6NjE3MDIyMw==",
lat: 60.180826,
lon: 24.552057
},
{
id: "U3RvcDpIU0w6MjUxMjIzNA==",
lat: 60.183375,
lon: 24.557547
},
{
id: "U3RvcDpIU0w6MjUxMjIzMg==",
lat: 60.185341,
lon: 24.5628
},
{
id: "U3RvcDpIU0w6MjUxMjIzMA==",
lat: 60.189078,
lon: 24.566412
},
{
id: "U3RvcDpIU0w6MjUxMjIyOA==",
lat: 60.190127,
lon: 24.571785
},
{
id: "U3RvcDpIU0w6MjUxMjIwNw==",
lat: 60.18996,
lon: 24.57581
},
{
id: "U3RvcDpIU0w6MjUxMTI0MA==",
lat: 60.186314,
lon: 24.589023
},
{
id: "U3RvcDpIU0w6MjUxMTIzNA==",
lat: 60.186698,
lon: 24.592018
}
]
},
{
gtfsId: "HSL:4611",
shortName: "611",
longName: "Rautatientori-Siltamäki-Suutarila-Tikkurila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDYxMDI0Nw==",
lat: 60.293663,
lon: 25.044318
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIyNg==",
lat: 60.29163,
lon: 25.0366
},
{
id: "U3RvcDpIU0w6NDYxMDIyMA==",
lat: 60.28947,
lon: 25.03306
},
{
id: "U3RvcDpIU0w6NDYzMDIxNg==",
lat: 60.28976,
lon: 25.02777
},
{
id: "U3RvcDpIU0w6NDYzMDIxNA==",
lat: 60.2912,
lon: 25.02122
},
{
id: "U3RvcDpIU0w6NDYzMDIxMg==",
lat: 60.29205,
lon: 25.0157
},
{
id: "U3RvcDpIU0w6NDY4MDIyOA==",
lat: 60.29215,
lon: 25.01095
},
{
id: "U3RvcDpIU0w6NDY4MDIwNA==",
lat: 60.29215,
lon: 25.00494
},
{
id: "U3RvcDpIU0w6NDY4MDIzOQ==",
lat: 60.29059,
lon: 24.99697
},
{
id: "U3RvcDpIU0w6NDY4MDI0Nw==",
lat: 60.28851,
lon: 24.99724
},
{
id: "U3RvcDpIU0w6MTQwMTE1Mg==",
lat: 60.281967,
lon: 25.0119
},
{
id: "U3RvcDpIU0w6MTQwMTE4MA==",
lat: 60.27948,
lon: 25.00944
},
{
id: "U3RvcDpIU0w6MTQwMTExMg==",
lat: 60.27823,
lon: 25.00574
},
{
id: "U3RvcDpIU0w6MTQwMTEzNg==",
lat: 60.27982,
lon: 25.00405
},
{
id: "U3RvcDpIU0w6MTQwMTEzNQ==",
lat: 60.27953,
lon: 24.99857
},
{
id: "U3RvcDpIU0w6MTQwMTEzMw==",
lat: 60.27835,
lon: 24.99422
},
{
id: "U3RvcDpIU0w6MTQwMTEzMg==",
lat: 60.276818,
lon: 24.990048
},
{
id: "U3RvcDpIU0w6MTQwMTEwNw==",
lat: 60.27497,
lon: 24.99117
},
{
id: "U3RvcDpIU0w6MTQwMTEwNA==",
lat: 60.27209,
lon: 24.9922
},
{
id: "U3RvcDpIU0w6MTQwMTEwMg==",
lat: 60.26954,
lon: 24.98362
},
{
id: "U3RvcDpIU0w6MTQwMzExNQ==",
lat: 60.26636,
lon: 24.98058
},
{
id: "U3RvcDpIU0w6MTQwMzEzNA==",
lat: 60.26459,
lon: 24.98221
},
{
id: "U3RvcDpIU0w6NDUwMDIwNg==",
lat: 60.26525,
lon: 24.97251
},
{
id: "U3RvcDpIU0w6MTM1MzEyMw==",
lat: 60.25601,
lon: 24.95801
},
{
id: "U3RvcDpIU0w6MTM1MzEyMQ==",
lat: 60.254992,
lon: 24.952652
},
{
id: "U3RvcDpIU0w6MTM1MjExOQ==",
lat: 60.255037,
lon: 24.94895
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEyMA==",
lat: 60.25465,
lon: 24.95468
},
{
id: "U3RvcDpIU0w6MTM1MzEyMg==",
lat: 60.25699,
lon: 24.95927
},
{
id: "U3RvcDpIU0w6NDUwMDIxMw==",
lat: 60.26534,
lon: 24.97367
},
{
id: "U3RvcDpIU0w6MTQwMzEzNQ==",
lat: 60.26514,
lon: 24.98307
},
{
id: "U3RvcDpIU0w6MTQwMTExNA==",
lat: 60.26722,
lon: 24.98012
},
{
id: "U3RvcDpIU0w6MTQwMTEwMQ==",
lat: 60.2693,
lon: 24.98338
},
{
id: "U3RvcDpIU0w6MTQwMTEwMw==",
lat: 60.27145,
lon: 24.99206
},
{
id: "U3RvcDpIU0w6MTQwMTEwNQ==",
lat: 60.27532,
lon: 24.99112
},
{
id: "U3RvcDpIU0w6MTQwMTEwNg==",
lat: 60.2774,
lon: 24.9909
},
{
id: "U3RvcDpIU0w6MTQwMTEzMQ==",
lat: 60.27863,
lon: 24.99518
},
{
id: "U3RvcDpIU0w6MTQwMTEzNA==",
lat: 60.27931,
lon: 24.99788
},
{
id: "U3RvcDpIU0w6MTQwMTEyNA==",
lat: 60.27925,
lon: 25.00451
},
{
id: "U3RvcDpIU0w6MTQwMTExMQ==",
lat: 60.27818,
lon: 25.00693
},
{
id: "U3RvcDpIU0w6MTQwMTExMw==",
lat: 60.28044,
lon: 25.01124
},
{
id: "U3RvcDpIU0w6NDY4MDIzOA==",
lat: 60.29001,
lon: 24.99751
},
{
id: "U3RvcDpIU0w6NDY4MDIwNQ==",
lat: 60.29238,
lon: 24.9982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMw==",
lat: 60.29196,
lon: 25.00701
},
{
id: "U3RvcDpIU0w6NDY4MDIyNw==",
lat: 60.29201,
lon: 25.01294
},
{
id: "U3RvcDpIU0w6NDYzMDIxMQ==",
lat: 60.29154,
lon: 25.01791
},
{
id: "U3RvcDpIU0w6NDYzMDIyNw==",
lat: 60.290493,
lon: 25.023712
},
{
id: "U3RvcDpIU0w6NDYzMDIxNQ==",
lat: 60.2896,
lon: 25.02769
},
{
id: "U3RvcDpIU0w6NDYxMDIxOQ==",
lat: 60.28924,
lon: 25.03163
},
{
id: "U3RvcDpIU0w6NDYxMDIyNQ==",
lat: 60.29093,
lon: 25.03651
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
}
]
},
{
gtfsId: "HSL:4735",
shortName: "735",
longName: "Tikkurila-Korso-Mikkola",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDgyMDIwNw==",
lat: 60.338954,
lon: 25.103429
},
{
id: "U3RvcDpIU0w6NDgyMDIxMA==",
lat: 60.33979,
lon: 25.10148
},
{
id: "U3RvcDpIU0w6NDgyMDIwOA==",
lat: 60.34133,
lon: 25.09714
},
{
id: "U3RvcDpIU0w6NDgyMDIwNA==",
lat: 60.34338,
lon: 25.09789
},
{
id: "U3RvcDpIU0w6NDgyMDIwNg==",
lat: 60.34513,
lon: 25.09491
},
{
id: "U3RvcDpIU0w6NDgzMDIwMQ==",
lat: 60.3453,
lon: 25.08927
},
{
id: "U3RvcDpIU0w6NDgzMDIwMw==",
lat: 60.34701,
lon: 25.08337
},
{
id: "U3RvcDpIU0w6NDgzMDIxOQ==",
lat: 60.35056,
lon: 25.08474
},
{
id: "U3RvcDpIU0w6NDgzMDIxOA==",
lat: 60.35126,
lon: 25.08085
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mg==",
lat: 60.3525,
lon: 25.07726
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDIzMQ==",
lat: 60.34492,
lon: 25.07435
},
{
id: "U3RvcDpIU0w6NDcyMDIwOA==",
lat: 60.34002,
lon: 25.06982
},
{
id: "U3RvcDpIU0w6NDcyMDIwNg==",
lat: 60.3343,
lon: 25.06437
},
{
id: "U3RvcDpIU0w6NDcyMDIwNA==",
lat: 60.33103,
lon: 25.06343
},
{
id: "U3RvcDpIU0w6NDcyMDIxMA==",
lat: 60.3305,
lon: 25.05707
},
{
id: "U3RvcDpIU0w6NDcyMDIwOQ==",
lat: 60.33219,
lon: 25.06038
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNg==",
lat: 60.3233,
lon: 25.06344
},
{
id: "U3RvcDpIU0w6NDc0MDIxOA==",
lat: 60.32491,
lon: 25.06624
},
{
id: "U3RvcDpIU0w6NDc0MDIwMQ==",
lat: 60.32424,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNg==",
lat: 60.3177,
lon: 25.07508
},
{
id: "U3RvcDpIU0w6NDc0MDIyOQ==",
lat: 60.31447,
lon: 25.07107
},
{
id: "U3RvcDpIU0w6NDc0MDIxMQ==",
lat: 60.31012,
lon: 25.06898
},
{
id: "U3RvcDpIU0w6NDYyMDIxMg==",
lat: 60.30182,
lon: 25.0669
},
{
id: "U3RvcDpIU0w6NDYyMDI5OA==",
lat: 60.30035,
lon: 25.06244
},
{
id: "U3RvcDpIU0w6NDYyMDIxOA==",
lat: 60.29967,
lon: 25.05407
},
{
id: "U3RvcDpIU0w6NDYyMDIwOA==",
lat: 60.30118,
lon: 25.05206
},
{
id: "U3RvcDpIU0w6NDYwMDIwNg==",
lat: 60.30239,
lon: 25.0452
},
{
id: "U3RvcDpIU0w6NDYwMDIwNA==",
lat: 60.30139,
lon: 25.04087
},
{
id: "U3RvcDpIU0w6NDYxMDIzOQ==",
lat: 60.299,
lon: 25.04094
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI1NA==",
lat: 60.294179,
lon: 25.044536
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIxNQ==",
lat: 60.29674,
lon: 25.03984
},
{
id: "U3RvcDpIU0w6NDYwMDIwMQ==",
lat: 60.30027,
lon: 25.04059
},
{
id: "U3RvcDpIU0w6NDYwMDIwMw==",
lat: 60.30174,
lon: 25.04301
},
{
id: "U3RvcDpIU0w6NDYwMDIxNw==",
lat: 60.30263,
lon: 25.04706
},
{
id: "U3RvcDpIU0w6NDYyMDIwNw==",
lat: 60.30019,
lon: 25.0531
},
{
id: "U3RvcDpIU0w6NDYyMDI5OQ==",
lat: 60.30026,
lon: 25.06284
},
{
id: "U3RvcDpIU0w6NDYyMDIxMQ==",
lat: 60.30252,
lon: 25.06691
},
{
id: "U3RvcDpIU0w6NDc0MDIxMA==",
lat: 60.31052,
lon: 25.0695
},
{
id: "U3RvcDpIU0w6NDc0MDIxMg==",
lat: 60.31245,
lon: 25.07059
},
{
id: "U3RvcDpIU0w6NDc0MDIwOQ==",
lat: 60.31549,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNw==",
lat: 60.31774,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIwMg==",
lat: 60.32423,
lon: 25.07576
},
{
id: "U3RvcDpIU0w6NDc0MDIxOQ==",
lat: 60.32487,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIzNQ==",
lat: 60.32494,
lon: 25.06439
},
{
id: "U3RvcDpIU0w6NDc0MDIxNw==",
lat: 60.32322,
lon: 25.06293
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIxNg==",
lat: 60.33213,
lon: 25.06075
},
{
id: "U3RvcDpIU0w6NDcyMDIxNw==",
lat: 60.33215,
lon: 25.05751
},
{
id: "U3RvcDpIU0w6NDcyMDIxOA==",
lat: 60.33039,
lon: 25.0572
},
{
id: "U3RvcDpIU0w6NDcyMDIwMw==",
lat: 60.32995,
lon: 25.06272
},
{
id: "U3RvcDpIU0w6NDcyMDIyNA==",
lat: 60.33199,
lon: 25.06424
},
{
id: "U3RvcDpIU0w6NDcyMDIwNQ==",
lat: 60.33399,
lon: 25.06449
},
{
id: "U3RvcDpIU0w6NDcyMDIxMQ==",
lat: 60.33519,
lon: 25.06504
},
{
id: "U3RvcDpIU0w6NDcyMDIwNw==",
lat: 60.33902,
lon: 25.06971
},
{
id: "U3RvcDpIU0w6NDgxMDIzOA==",
lat: 60.34579,
lon: 25.07516
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mw==",
lat: 60.35276,
lon: 25.07843
},
{
id: "U3RvcDpIU0w6NDgzMDIxNg==",
lat: 60.3508,
lon: 25.08228
},
{
id: "U3RvcDpIU0w6NDgzMDIyMA==",
lat: 60.35017,
lon: 25.08447
},
{
id: "U3RvcDpIU0w6NDgzMDI5OA==",
lat: 60.34554,
lon: 25.08651
},
{
id: "U3RvcDpIU0w6NDgzMDIwMg==",
lat: 60.34514,
lon: 25.09151
},
{
id: "U3RvcDpIU0w6NDgyMDIwMw==",
lat: 60.34321,
lon: 25.09762
},
{
id: "U3RvcDpIU0w6NDgyMDIwNQ==",
lat: 60.34113,
lon: 25.09689
},
{
id: "U3RvcDpIU0w6NDgyMDIxNA==",
lat: 60.33971,
lon: 25.10071
},
{
id: "U3RvcDpIU0w6NDgyMDIxMw==",
lat: 60.33849,
lon: 25.10247
}
]
},
{
gtfsId: "HSL:6912",
shortName: "912",
longName: "Kuntakeskus-Störsvik-Pikkala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjA3MDIzMg==",
lat: 60.094845,
lon: 24.34585
},
{
id: "U3RvcDpIU0w6NjA3MDIzMQ==",
lat: 60.097233,
lon: 24.342965
},
{
id: "U3RvcDpIU0w6NjMwNzAwNw==",
lat: 60.09886,
lon: 24.329275
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwOQ==",
lat: 60.096517,
lon: 24.251887
},
{
id: "U3RvcDpIU0w6NjMwNDAwOA==",
lat: 60.103516,
lon: 24.248267
},
{
id: "U3RvcDpIU0w6NjMwMjAxOA==",
lat: 60.112345,
lon: 24.241337
},
{
id: "U3RvcDpIU0w6NjMwMjAwNQ==",
lat: 60.117387,
lon: 24.241306
},
{
id: "U3RvcDpIU0w6NjMwMjAwOA==",
lat: 60.121106,
lon: 24.239152
},
{
id: "U3RvcDpIU0w6NjMwMjAwMA==",
lat: 60.130476,
lon: 24.232493
},
{
id: "U3RvcDpIU0w6NjMwMjAxNw==",
lat: 60.135228,
lon: 24.228995
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAxNg==",
lat: 60.133773,
lon: 24.229992
},
{
id: "U3RvcDpIU0w6NjMwMjAwMQ==",
lat: 60.128729,
lon: 24.232488
},
{
id: "U3RvcDpIU0w6NjMwMjAwOQ==",
lat: 60.120639,
lon: 24.239353
},
{
id: "U3RvcDpIU0w6NjMwMjAwNA==",
lat: 60.116061,
lon: 24.241087
},
{
id: "U3RvcDpIU0w6NjMwMjAxOQ==",
lat: 60.110936,
lon: 24.241778
},
{
id: "U3RvcDpIU0w6NjMwNDAwNw==",
lat: 60.102476,
lon: 24.24881
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNzAwNA==",
lat: 60.099132,
lon: 24.303275
},
{
id: "U3RvcDpIU0w6NjMwNzAwOA==",
lat: 60.099232,
lon: 24.331415
},
{
id: "U3RvcDpIU0w6NjA3MDIzMA==",
lat: 60.097948,
lon: 24.342707
}
]
},
{
gtfsId: "HSL:4614",
shortName: "614",
longName: "Rautatientori-Ylästö",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDQwMDIyMg==",
lat: 60.27924,
lon: 24.91367
},
{
id: "U3RvcDpIU0w6NDQwMDIzMA==",
lat: 60.28031,
lon: 24.90945
},
{
id: "U3RvcDpIU0w6NDQwMDIzNA==",
lat: 60.28367,
lon: 24.90867
},
{
id: "U3RvcDpIU0w6NDQwMDIzMw==",
lat: 60.28471,
lon: 24.91037
},
{
id: "U3RvcDpIU0w6NDQwMDIwNw==",
lat: 60.28403,
lon: 24.91526
},
{
id: "U3RvcDpIU0w6NDQwMDIwOQ==",
lat: 60.28334,
lon: 24.91922
},
{
id: "U3RvcDpIU0w6NDQwMDIxMQ==",
lat: 60.28074,
lon: 24.92412
},
{
id: "U3RvcDpIU0w6NDQwMDIxMw==",
lat: 60.28074,
lon: 24.92886
},
{
id: "U3RvcDpIU0w6NDQwMDIxNQ==",
lat: 60.28249,
lon: 24.93814
},
{
id: "U3RvcDpIU0w6NDUxMDI1Nw==",
lat: 60.28557,
lon: 24.946116
},
{
id: "U3RvcDpIU0w6NDUxMDIyNQ==",
lat: 60.2866,
lon: 24.95006
},
{
id: "U3RvcDpIU0w6NDUxMDIyMw==",
lat: 60.288407,
lon: 24.950263
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIwMQ==",
lat: 60.28944,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIxOQ==",
lat: 60.286,
lon: 24.95769
},
{
id: "U3RvcDpIU0w6NDUxMDIyOQ==",
lat: 60.28446,
lon: 24.95912
},
{
id: "U3RvcDpIU0w6NDUxMDIzMg==",
lat: 60.28104,
lon: 24.95969
},
{
id: "U3RvcDpIU0w6NDUwMDIxNw==",
lat: 60.27289,
lon: 24.96207
},
{
id: "U3RvcDpIU0w6NDUwMDIxOQ==",
lat: 60.26891,
lon: 24.96595
},
{
id: "U3RvcDpIU0w6NDUwMDIxNQ==",
lat: 60.269981,
lon: 24.968844
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExOQ==",
lat: 60.17095,
lon: 24.94308
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIyMg==",
lat: 60.27,
lon: 24.9686
},
{
id: "U3RvcDpIU0w6NDUwMDIxOA==",
lat: 60.26963,
lon: 24.96485
},
{
id: "U3RvcDpIU0w6NDUwMDIxNg==",
lat: 60.2736,
lon: 24.96186
},
{
id: "U3RvcDpIU0w6NDUxMDIzMw==",
lat: 60.27953,
lon: 24.95878
},
{
id: "U3RvcDpIU0w6NDUxMDIzMQ==",
lat: 60.28192,
lon: 24.95957
},
{
id: "U3RvcDpIU0w6NDUxMDIzMA==",
lat: 60.28456,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIyMQ==",
lat: 60.28714,
lon: 24.9578
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDIyMg==",
lat: 60.28878,
lon: 24.949677
},
{
id: "U3RvcDpIU0w6NDUxMDIxMw==",
lat: 60.286,
lon: 24.94868
},
{
id: "U3RvcDpIU0w6NDUxMDI1Ng==",
lat: 60.285431,
lon: 24.944319
},
{
id: "U3RvcDpIU0w6NDQwMDIxNg==",
lat: 60.28215,
lon: 24.93696
},
{
id: "U3RvcDpIU0w6NDQwMDIxNA==",
lat: 60.28078,
lon: 24.92756
},
{
id: "U3RvcDpIU0w6NDQwMDIxMg==",
lat: 60.28157,
lon: 24.92342
},
{
id: "U3RvcDpIU0w6NDQwMDIxMA==",
lat: 60.28386,
lon: 24.918
},
{
id: "U3RvcDpIU0w6NDQwMDIwOA==",
lat: 60.28435,
lon: 24.91312
},
{
id: "U3RvcDpIU0w6NDQwMDIzNw==",
lat: 60.28461,
lon: 24.90906
},
{
id: "U3RvcDpIU0w6NDQwMDIzNg==",
lat: 60.28289,
lon: 24.90792
},
{
id: "U3RvcDpIU0w6NDQwMDIzMQ==",
lat: 60.28004,
lon: 24.90929
}
]
},
{
gtfsId: "HSL:4736",
shortName: "736",
longName: "Tikkurila-Vierumäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDYxMDI1NQ==",
lat: 60.294244,
lon: 25.044551
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIxNQ==",
lat: 60.29674,
lon: 25.03984
},
{
id: "U3RvcDpIU0w6NDYwMDIwMQ==",
lat: 60.30027,
lon: 25.04059
},
{
id: "U3RvcDpIU0w6NDYwMDIwMw==",
lat: 60.30174,
lon: 25.04301
},
{
id: "U3RvcDpIU0w6NDYwMDIwNQ==",
lat: 60.30359,
lon: 25.04489
},
{
id: "U3RvcDpIU0w6NDYwMDIwNw==",
lat: 60.30492,
lon: 25.0414
},
{
id: "U3RvcDpIU0w6NDYwMDIwOQ==",
lat: 60.30643,
lon: 25.03734
},
{
id: "U3RvcDpIU0w6NDYwMDIxMw==",
lat: 60.30911,
lon: 25.03456
},
{
id: "U3RvcDpIU0w6NDYwMDIxNQ==",
lat: 60.31201,
lon: 25.03987
},
{
id: "U3RvcDpIU0w6NDYwMDIxNg==",
lat: 60.31412,
lon: 25.04235
},
{
id: "U3RvcDpIU0w6NDcwMDIxNQ==",
lat: 60.31732,
lon: 25.04971
},
{
id: "U3RvcDpIU0w6NDcwMDIyMw==",
lat: 60.32062,
lon: 25.05047
},
{
id: "U3RvcDpIU0w6NDcwMDIyNA==",
lat: 60.32183,
lon: 25.04486
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
},
{
id: "U3RvcDpIU0w6NDcwMDIzNA==",
lat: 60.325902,
lon: 25.041882
},
{
id: "U3RvcDpIU0w6NDcyMDIyNQ==",
lat: 60.326482,
lon: 25.043723
},
{
id: "U3RvcDpIU0w6NDcwMDIwNw==",
lat: 60.3246,
lon: 25.05219
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNg==",
lat: 60.3233,
lon: 25.06344
},
{
id: "U3RvcDpIU0w6NDc0MDIxOA==",
lat: 60.32491,
lon: 25.06624
},
{
id: "U3RvcDpIU0w6NDc0MDIwMQ==",
lat: 60.32424,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDczMDIwMg==",
lat: 60.32258,
lon: 25.08323
},
{
id: "U3RvcDpIU0w6NDczMDIxMg==",
lat: 60.32542,
lon: 25.08531
},
{
id: "U3RvcDpIU0w6NDczMDIwOQ==",
lat: 60.32853,
lon: 25.08968
},
{
id: "U3RvcDpIU0w6NDc1MDIwMQ==",
lat: 60.3279,
lon: 25.09475
},
{
id: "U3RvcDpIU0w6NDc1MDIwMw==",
lat: 60.32736,
lon: 25.10289
},
{
id: "U3RvcDpIU0w6NDc1MDIwNA==",
lat: 60.32423,
lon: 25.10955
},
{
id: "U3RvcDpIU0w6NDc1MDIwNg==",
lat: 60.32138,
lon: 25.11206
},
{
id: "U3RvcDpIU0w6NDk3MDIyNA==",
lat: 60.31994,
lon: 25.11693
},
{
id: "U3RvcDpIU0w6NDk3MDIxNQ==",
lat: 60.32003,
lon: 25.12451
},
{
id: "U3RvcDpIU0w6NDk3MDIxMw==",
lat: 60.31868,
lon: 25.12728
},
{
id: "U3RvcDpIU0w6OTIxNDIwOQ==",
lat: 60.324263,
lon: 25.137407
},
{
id: "U3RvcDpIU0w6OTIxNDIwNQ==",
lat: 60.329622,
lon: 25.13404
},
{
id: "U3RvcDpIU0w6NDg2MDIwMQ==",
lat: 60.336937,
lon: 25.131358
},
{
id: "U3RvcDpIU0w6NDg2MDIzNA==",
lat: 60.33946,
lon: 25.13387
},
{
id: "U3RvcDpIU0w6NDg2MDIzMg==",
lat: 60.34099,
lon: 25.14079
},
{
id: "U3RvcDpIU0w6NDg2MDIzMA==",
lat: 60.34199,
lon: 25.14701
},
{
id: "U3RvcDpIU0w6NDg2MDIyOA==",
lat: 60.3449,
lon: 25.14691
},
{
id: "U3RvcDpIU0w6NDg2MDIyNg==",
lat: 60.34491,
lon: 25.14009
},
{
id: "U3RvcDpIU0w6NDg2MDIyNA==",
lat: 60.3452,
lon: 25.13308
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMw==",
lat: 60.34529,
lon: 25.11796
},
{
id: "U3RvcDpIU0w6NDg1MDIwNQ==",
lat: 60.346137,
lon: 25.113348
},
{
id: "U3RvcDpIU0w6NDg1MDIwNw==",
lat: 60.35075,
lon: 25.11402
},
{
id: "U3RvcDpIU0w6NDg1MDIwOQ==",
lat: 60.35293,
lon: 25.11242
},
{
id: "U3RvcDpIU0w6NDgzMDIwOQ==",
lat: 60.35221,
lon: 25.10526
},
{
id: "U3RvcDpIU0w6NDgzMDIxNQ==",
lat: 60.35086,
lon: 25.09986
},
{
id: "U3RvcDpIU0w6NDgzMDIxMw==",
lat: 60.3513,
lon: 25.09164
},
{
id: "U3RvcDpIU0w6NDgzMDIxMQ==",
lat: 60.35094,
lon: 25.08546
},
{
id: "U3RvcDpIU0w6NDgzMDIxOA==",
lat: 60.35126,
lon: 25.08085
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mg==",
lat: 60.3525,
lon: 25.07726
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIyOA==",
lat: 60.35035,
lon: 25.07627
},
{
id: "U3RvcDpIU0w6NDgxMDIwNA==",
lat: 60.35271,
lon: 25.06532
},
{
id: "U3RvcDpIU0w6NDgxMDIwNg==",
lat: 60.3531,
lon: 25.06058
},
{
id: "U3RvcDpIU0w6NDgxMDIwOA==",
lat: 60.35364,
lon: 25.05589
},
{
id: "U3RvcDpIU0w6NDg3MDIwMQ==",
lat: 60.35446,
lon: 25.05036
},
{
id: "U3RvcDpIU0w6NDg3MDIwMw==",
lat: 60.35477,
lon: 25.04369
},
{
id: "U3RvcDpIU0w6NDg3MDIwNQ==",
lat: 60.3564,
lon: 25.04229
},
{
id: "U3RvcDpIU0w6NDg3MDIwNw==",
lat: 60.36029,
lon: 25.03591
},
{
id: "U3RvcDpIU0w6NDg3MDI5OQ==",
lat: 60.36186,
lon: 25.03334
},
{
id: "U3RvcDpIU0w6NDg3MDIwOQ==",
lat: 60.36346,
lon: 25.03033
},
{
id: "U3RvcDpIU0w6NDg3MDI5OA==",
lat: 60.36209,
lon: 25.03284
},
{
id: "U3RvcDpIU0w6NDg3MDIwOA==",
lat: 60.35962,
lon: 25.0369
},
{
id: "U3RvcDpIU0w6NDg3MDIwNg==",
lat: 60.35678,
lon: 25.04156
},
{
id: "U3RvcDpIU0w6NDg3MDIwNA==",
lat: 60.35473,
lon: 25.04276
},
{
id: "U3RvcDpIU0w6NDgxMDI0OA==",
lat: 60.35416,
lon: 25.05255
},
{
id: "U3RvcDpIU0w6NDgxMDIwOQ==",
lat: 60.35341,
lon: 25.0565
},
{
id: "U3RvcDpIU0w6NDgxMDIwNw==",
lat: 60.3529,
lon: 25.06141
},
{
id: "U3RvcDpIU0w6NDgxMDIwNQ==",
lat: 60.3526,
lon: 25.06612
},
{
id: "U3RvcDpIU0w6NDgxMDIzMA==",
lat: 60.35022,
lon: 25.07653
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mw==",
lat: 60.35276,
lon: 25.07843
},
{
id: "U3RvcDpIU0w6NDgzMDIxNg==",
lat: 60.3508,
lon: 25.08228
},
{
id: "U3RvcDpIU0w6NDgzMDIxMA==",
lat: 60.35088,
lon: 25.08547
},
{
id: "U3RvcDpIU0w6NDgzMDIxMg==",
lat: 60.35122,
lon: 25.09204
},
{
id: "U3RvcDpIU0w6NDgzMDIxNA==",
lat: 60.35088,
lon: 25.10211
},
{
id: "U3RvcDpIU0w6NDg0MDIxMg==",
lat: 60.35293,
lon: 25.10646
},
{
id: "U3RvcDpIU0w6NDg1MDIwOA==",
lat: 60.35287,
lon: 25.11271
},
{
id: "U3RvcDpIU0w6NDg1MDIwNg==",
lat: 60.35037,
lon: 25.11386
},
{
id: "U3RvcDpIU0w6NDg1MDIwNA==",
lat: 60.346552,
lon: 25.113178
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6NDg2MDIzNw==",
lat: 60.34486,
lon: 25.13346
},
{
id: "U3RvcDpIU0w6NDg2MDIyNQ==",
lat: 60.34486,
lon: 25.14023
},
{
id: "U3RvcDpIU0w6NDg2MDIyNw==",
lat: 60.34492,
lon: 25.14658
},
{
id: "U3RvcDpIU0w6NDg2MDIyOQ==",
lat: 60.342058,
lon: 25.146987
},
{
id: "U3RvcDpIU0w6NDg2MDIzMQ==",
lat: 60.34105,
lon: 25.14113
},
{
id: "U3RvcDpIU0w6NDg2MDIwNw==",
lat: 60.34049,
lon: 25.13834
},
{
id: "U3RvcDpIU0w6NDg2MDIzMw==",
lat: 60.33938,
lon: 25.13317
},
{
id: "U3RvcDpIU0w6NDg2MDIwMg==",
lat: 60.33761,
lon: 25.13086
},
{
id: "U3RvcDpIU0w6OTIxNDIwNg==",
lat: 60.329127,
lon: 25.133099
},
{
id: "U3RvcDpIU0w6OTIxNDIwOA==",
lat: 60.32346,
lon: 25.13657
},
{
id: "U3RvcDpIU0w6NDk3MDIxNg==",
lat: 60.31884,
lon: 25.12654
},
{
id: "U3RvcDpIU0w6NDk3MDIyMw==",
lat: 60.32021,
lon: 25.11481
},
{
id: "U3RvcDpIU0w6NDc1MDIwNw==",
lat: 60.32126,
lon: 25.11231
},
{
id: "U3RvcDpIU0w6NDc1MDIwNQ==",
lat: 60.3247,
lon: 25.10919
},
{
id: "U3RvcDpIU0w6NDc1MDI5OQ==",
lat: 60.32767,
lon: 25.10175
},
{
id: "U3RvcDpIU0w6NDc1MDIwMg==",
lat: 60.32803,
lon: 25.09629
},
{
id: "U3RvcDpIU0w6NDczMDIxMA==",
lat: 60.32863,
lon: 25.08983
},
{
id: "U3RvcDpIU0w6NDczMDIxMQ==",
lat: 60.32466,
lon: 25.0849
},
{
id: "U3RvcDpIU0w6NDc0MDI0NA==",
lat: 60.321734,
lon: 25.081964
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIwMg==",
lat: 60.32423,
lon: 25.07576
},
{
id: "U3RvcDpIU0w6NDc0MDIxOQ==",
lat: 60.32487,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIzNQ==",
lat: 60.32494,
lon: 25.06439
},
{
id: "U3RvcDpIU0w6NDc0MDIxNw==",
lat: 60.32322,
lon: 25.06293
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcyMDIyNw==",
lat: 60.325038,
lon: 25.050357
},
{
id: "U3RvcDpIU0w6NDcwMDIzMg==",
lat: 60.326547,
lon: 25.0421
},
{
id: "U3RvcDpIU0w6NDcwMDIzMw==",
lat: 60.325487,
lon: 25.041647
},
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyMg==",
lat: 60.32129,
lon: 25.04674
},
{
id: "U3RvcDpIU0w6NDcwMDIxNg==",
lat: 60.31977,
lon: 25.05094
},
{
id: "U3RvcDpIU0w6NDcwMDIxNA==",
lat: 60.31738,
lon: 25.04942
},
{
id: "U3RvcDpIU0w6NDY1MDIzMA==",
lat: 60.31343,
lon: 25.04126
},
{
id: "U3RvcDpIU0w6NDYwMDIxNA==",
lat: 60.31155,
lon: 25.03821
},
{
id: "U3RvcDpIU0w6NDYwMDIxMg==",
lat: 60.30809,
lon: 25.0336
},
{
id: "U3RvcDpIU0w6NDYwMDIxMA==",
lat: 60.30671,
lon: 25.03683
},
{
id: "U3RvcDpIU0w6NDYwMDIwOA==",
lat: 60.30441,
lon: 25.04265
},
{
id: "U3RvcDpIU0w6NDYwMDIwNg==",
lat: 60.30239,
lon: 25.0452
},
{
id: "U3RvcDpIU0w6NDYwMDIwNA==",
lat: 60.30139,
lon: 25.04087
},
{
id: "U3RvcDpIU0w6NDYxMDIzOQ==",
lat: 60.299,
lon: 25.04094
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
}
]
},
{
gtfsId: "HSL:4615",
shortName: "615",
longName: "Rautatientori-Kartanonkoski-Lentoasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExOQ==",
lat: 60.17095,
lon: 24.94308
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIyMg==",
lat: 60.27,
lon: 24.9686
},
{
id: "U3RvcDpIU0w6NDUwMDIxOA==",
lat: 60.26963,
lon: 24.96485
},
{
id: "U3RvcDpIU0w6NDUwMDIxNg==",
lat: 60.2736,
lon: 24.96186
},
{
id: "U3RvcDpIU0w6NDUxMDIzMw==",
lat: 60.27953,
lon: 24.95878
},
{
id: "U3RvcDpIU0w6NDUxMDIzMQ==",
lat: 60.28192,
lon: 24.95957
},
{
id: "U3RvcDpIU0w6NDUxMDIzMA==",
lat: 60.28456,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIyMQ==",
lat: 60.28714,
lon: 24.9578
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDI1MQ==",
lat: 60.291725,
lon: 24.95261
},
{
id: "U3RvcDpIU0w6NDUyMDIyOA==",
lat: 60.297688,
lon: 24.9514
},
{
id: "U3RvcDpIU0w6NDUyMDIzOA==",
lat: 60.302153,
lon: 24.952562
},
{
id: "U3RvcDpIU0w6NDUyMDI2Ng==",
lat: 60.302738,
lon: 24.955727
},
{
id: "U3RvcDpIU0w6NDUyMDI2OA==",
lat: 60.306115,
lon: 24.958895
},
{
id: "U3RvcDpIU0w6NDUzMDIyMg==",
lat: 60.308712,
lon: 24.961988
},
{
id: "U3RvcDpIU0w6NDUzMDIwOQ==",
lat: 60.317071,
lon: 24.966263
},
{
id: "U3RvcDpIU0w6NDUzMDIzMA==",
lat: 60.317343,
lon: 24.965217
},
{
id: "U3RvcDpIU0w6NDUzMDI1OA==",
lat: 60.313471,
lon: 24.967726
},
{
id: "U3RvcDpIU0w6NDUzMDIyMQ==",
lat: 60.307879,
lon: 24.960343
},
{
id: "U3RvcDpIU0w6NDUyMDI2Nw==",
lat: 60.304895,
lon: 24.957404
},
{
id: "U3RvcDpIU0w6NDUyMDI2OQ==",
lat: 60.302518,
lon: 24.955252
},
{
id: "U3RvcDpIU0w6NDUyMDIyOQ==",
lat: 60.29784,
lon: 24.95118
},
{
id: "U3RvcDpIU0w6NDUxMDIxNQ==",
lat: 60.293698,
lon: 24.95222
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIwMQ==",
lat: 60.28944,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIxOQ==",
lat: 60.286,
lon: 24.95769
},
{
id: "U3RvcDpIU0w6NDUxMDIyOQ==",
lat: 60.28446,
lon: 24.95912
},
{
id: "U3RvcDpIU0w6NDUxMDIzMg==",
lat: 60.28104,
lon: 24.95969
},
{
id: "U3RvcDpIU0w6NDUwMDIxNw==",
lat: 60.27289,
lon: 24.96207
},
{
id: "U3RvcDpIU0w6NDUwMDIxOQ==",
lat: 60.26891,
lon: 24.96595
},
{
id: "U3RvcDpIU0w6NDUwMDIxNQ==",
lat: 60.269981,
lon: 24.968844
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4737",
shortName: "737",
longName: "Pohjois-Nikinmäki-Nikinmäki-Mikkola-Korso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDg2MDIxNg==",
lat: 60.3582,
lon: 25.14771
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mw==",
lat: 60.35602,
lon: 25.13996
},
{
id: "U3RvcDpIU0w6NDg2MDIyMA==",
lat: 60.35607,
lon: 25.13692
},
{
id: "U3RvcDpIU0w6NDg2MDIxOA==",
lat: 60.35661,
lon: 25.12949
},
{
id: "U3RvcDpIU0w6NDg2MDIzNg==",
lat: 60.35596,
lon: 25.12691
},
{
id: "U3RvcDpIU0w6NDg2MDIxMw==",
lat: 60.35381,
lon: 25.12674
},
{
id: "U3RvcDpIU0w6NDg2MDIxNQ==",
lat: 60.34614,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6NDg2MDIwNg==",
lat: 60.343,
lon: 25.1273
},
{
id: "U3RvcDpIU0w6NDg2MDIwNA==",
lat: 60.33975,
lon: 25.12921
},
{
id: "U3RvcDpIU0w6NDg2MDIzNA==",
lat: 60.33946,
lon: 25.13387
},
{
id: "U3RvcDpIU0w6NDg2MDIzMg==",
lat: 60.34099,
lon: 25.14079
},
{
id: "U3RvcDpIU0w6NDg2MDIzMA==",
lat: 60.34199,
lon: 25.14701
},
{
id: "U3RvcDpIU0w6NDg2MDIyOA==",
lat: 60.3449,
lon: 25.14691
},
{
id: "U3RvcDpIU0w6NDg2MDIyNg==",
lat: 60.34491,
lon: 25.14009
},
{
id: "U3RvcDpIU0w6NDg2MDIyNA==",
lat: 60.3452,
lon: 25.13308
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMQ==",
lat: 60.34501,
lon: 25.11781
},
{
id: "U3RvcDpIU0w6NDgyMDIxOA==",
lat: 60.34362,
lon: 25.10246
},
{
id: "U3RvcDpIU0w6NDgyMDIyNQ==",
lat: 60.34225,
lon: 25.1052
},
{
id: "U3RvcDpIU0w6NDgyMDIyMw==",
lat: 60.34043,
lon: 25.1051
},
{
id: "U3RvcDpIU0w6NDgyMDIxMA==",
lat: 60.33979,
lon: 25.10148
},
{
id: "U3RvcDpIU0w6NDgyMDIwOA==",
lat: 60.34133,
lon: 25.09714
},
{
id: "U3RvcDpIU0w6NDgyMDIwNA==",
lat: 60.34338,
lon: 25.09789
},
{
id: "U3RvcDpIU0w6NDgyMDIwNg==",
lat: 60.34513,
lon: 25.09491
},
{
id: "U3RvcDpIU0w6NDgzMDIwMQ==",
lat: 60.3453,
lon: 25.08927
},
{
id: "U3RvcDpIU0w6NDgzMDI5OQ==",
lat: 60.34672,
lon: 25.08124
},
{
id: "U3RvcDpIU0w6NDgxMDI5OQ==",
lat: 60.34736,
lon: 25.07515
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDI5OA==",
lat: 60.346684,
lon: 25.075914
},
{
id: "U3RvcDpIU0w6NDgzMDI5OA==",
lat: 60.34554,
lon: 25.08651
},
{
id: "U3RvcDpIU0w6NDgzMDIwMg==",
lat: 60.34514,
lon: 25.09151
},
{
id: "U3RvcDpIU0w6NDgyMDIwMw==",
lat: 60.34321,
lon: 25.09762
},
{
id: "U3RvcDpIU0w6NDgyMDIwNQ==",
lat: 60.34113,
lon: 25.09689
},
{
id: "U3RvcDpIU0w6NDgyMDIxNA==",
lat: 60.33971,
lon: 25.10071
},
{
id: "U3RvcDpIU0w6NDgyMDIyMg==",
lat: 60.33964,
lon: 25.10486
},
{
id: "U3RvcDpIU0w6NDgyMDIyNA==",
lat: 60.34237,
lon: 25.10535
},
{
id: "U3RvcDpIU0w6NDgyMDIxOQ==",
lat: 60.34357,
lon: 25.10374
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6NDg2MDIzNw==",
lat: 60.34486,
lon: 25.13346
},
{
id: "U3RvcDpIU0w6NDg2MDIyNQ==",
lat: 60.34486,
lon: 25.14023
},
{
id: "U3RvcDpIU0w6NDg2MDIyNw==",
lat: 60.34492,
lon: 25.14658
},
{
id: "U3RvcDpIU0w6NDg2MDIyOQ==",
lat: 60.342058,
lon: 25.146987
},
{
id: "U3RvcDpIU0w6NDg2MDIzMQ==",
lat: 60.34105,
lon: 25.14113
},
{
id: "U3RvcDpIU0w6NDg2MDIwNw==",
lat: 60.34049,
lon: 25.13834
},
{
id: "U3RvcDpIU0w6NDg2MDIzMw==",
lat: 60.33938,
lon: 25.13317
},
{
id: "U3RvcDpIU0w6NDg2MDIwMw==",
lat: 60.34003,
lon: 25.12899
},
{
id: "U3RvcDpIU0w6NDg2MDIxMA==",
lat: 60.34297,
lon: 25.12747
},
{
id: "U3RvcDpIU0w6NDg2MDIxMg==",
lat: 60.34735,
lon: 25.12712
},
{
id: "U3RvcDpIU0w6NDg2MDIxNA==",
lat: 60.35468,
lon: 25.12701
},
{
id: "U3RvcDpIU0w6NDg2MDIxNw==",
lat: 60.35687,
lon: 25.13116
},
{
id: "U3RvcDpIU0w6NDg2MDIxOQ==",
lat: 60.35598,
lon: 25.13691
},
{
id: "U3RvcDpIU0w6NDg2MDI1MA==",
lat: 60.35599,
lon: 25.14148
},
{
id: "U3RvcDpIU0w6NDg2MDI0Nw==",
lat: 60.35822,
lon: 25.14772
}
]
},
{
gtfsId: "HSL:6914",
shortName: "914",
longName: "Kuntakeskus- Siuntion kk.-Raivio-Bocksintie",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAyMw==",
lat: 60.165141,
lon: 24.197315
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAzMw==",
lat: 60.171361,
lon: 24.201095
},
{
id: "U3RvcDpIU0w6NjMwMTAxMA==",
lat: 60.173575,
lon: 24.210197
},
{
id: "U3RvcDpIU0w6NjMwMTAyNg==",
lat: 60.178262,
lon: 24.223798
},
{
id: "U3RvcDpIU0w6NjMwMTA0Nw==",
lat: 60.179052,
lon: 24.233051
},
{
id: "U3RvcDpIU0w6NjMwMTAwMA==",
lat: 60.184995,
lon: 24.240861
},
{
id: "U3RvcDpIU0w6NjMwMTAxNQ==",
lat: 60.189068,
lon: 24.246139
},
{
id: "U3RvcDpIU0w6NjMwMTAwMw==",
lat: 60.194916,
lon: 24.253819
},
{
id: "U3RvcDpIU0w6NjMwMzAwMQ==",
lat: 60.192339,
lon: 24.262109
},
{
id: "U3RvcDpIU0w6NjMwMzAwMw==",
lat: 60.190393,
lon: 24.271201
},
{
id: "U3RvcDpIU0w6NjMwMzAwNQ==",
lat: 60.188498,
lon: 24.286477
},
{
id: "U3RvcDpIU0w6NjE1MDIwMg==",
lat: 60.187337,
lon: 24.298318
},
{
id: "U3RvcDpIU0w6NjE1MDIwMQ==",
lat: 60.18728,
lon: 24.296465
},
{
id: "U3RvcDpIU0w6NjMwMzAwNg==",
lat: 60.189011,
lon: 24.284748
},
{
id: "U3RvcDpIU0w6NjMwMzAwNA==",
lat: 60.190251,
lon: 24.269025
},
{
id: "U3RvcDpIU0w6NjMwMzAwMg==",
lat: 60.193857,
lon: 24.261159
},
{
id: "U3RvcDpIU0w6NjMwMTAwMg==",
lat: 60.194368,
lon: 24.251792
},
{
id: "U3RvcDpIU0w6NjMwMTAxNg==",
lat: 60.188088,
lon: 24.245
},
{
id: "U3RvcDpIU0w6NjMwMTAwMQ==",
lat: 60.184142,
lon: 24.239233
},
{
id: "U3RvcDpIU0w6NjMwMTA0Ng==",
lat: 60.180368,
lon: 24.234423
},
{
id: "U3RvcDpIU0w6NjMwMTAyNQ==",
lat: 60.178408,
lon: 24.225049
},
{
id: "U3RvcDpIU0w6NjMwMTAxMQ==",
lat: 60.172765,
lon: 24.206878
},
{
id: "U3RvcDpIU0w6NjMwMTA1MQ==",
lat: 60.169203,
lon: 24.191327
},
{
id: "U3RvcDpIU0w6NjMwMTAyMQ==",
lat: 60.16978,
lon: 24.180586
},
{
id: "U3RvcDpIU0w6NjMwMTA0Mw==",
lat: 60.170338,
lon: 24.174548
},
{
id: "U3RvcDpIU0w6NjMwMTAzOA==",
lat: 60.172097,
lon: 24.162584
},
{
id: "U3RvcDpIU0w6NjMwMDAyMw==",
lat: 60.175065,
lon: 24.138551
},
{
id: "U3RvcDpIU0w6NjMwMDAyNg==",
lat: 60.173247,
lon: 24.126355
},
{
id: "U3RvcDpIU0w6NjMwMDAwOA==",
lat: 60.174069,
lon: 24.118695
},
{
id: "U3RvcDpIU0w6NjMwMDAxNQ==",
lat: 60.173856,
lon: 24.107636
},
{
id: "U3RvcDpIU0w6NjMwMDAyMg==",
lat: 60.173231,
lon: 24.100927
},
{
id: "U3RvcDpIU0w6NjMwMDAxMQ==",
lat: 60.176005,
lon: 24.091042
},
{
id: "U3RvcDpIU0w6NjMwMDAxNw==",
lat: 60.176911,
lon: 24.078211
},
{
id: "U3RvcDpIU0w6NjMwMDAxOQ==",
lat: 60.176033,
lon: 24.061181
},
{
id: "U3RvcDpIU0w6NjMwMDAwNw==",
lat: 60.178962,
lon: 24.04697
}
]
},
{
gtfsId: "HSL:4616",
shortName: "616",
longName: "Hakaniemi-Tammisto-Kivistö",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTExMTExNw==",
lat: 60.179463,
lon: 24.952195
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIyNg==",
lat: 60.270607,
lon: 24.96991
},
{
id: "U3RvcDpIU0w6NDUwMDIwNA==",
lat: 60.272907,
lon: 24.969897
},
{
id: "U3RvcDpIU0w6NDUwMDIwMg==",
lat: 60.27777,
lon: 24.97073
},
{
id: "U3RvcDpIU0w6NDUwMDIyMQ==",
lat: 60.27997,
lon: 24.97181
},
{
id: "U3RvcDpIU0w6NDUxMDIwOA==",
lat: 60.28271,
lon: 24.97297
},
{
id: "U3RvcDpIU0w6NDUxMDIwNg==",
lat: 60.2841,
lon: 24.96983
},
{
id: "U3RvcDpIU0w6NDUxMDIzNw==",
lat: 60.28445,
lon: 24.96511
},
{
id: "U3RvcDpIU0w6NDUxMDIwNA==",
lat: 60.28634,
lon: 24.96034
},
{
id: "U3RvcDpIU0w6NDUxMDIyMQ==",
lat: 60.28714,
lon: 24.9578
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDI1MQ==",
lat: 60.291725,
lon: 24.95261
},
{
id: "U3RvcDpIU0w6NDUxMDIyOA==",
lat: 60.293334,
lon: 24.946772
},
{
id: "U3RvcDpIU0w6NDUyMDIxNQ==",
lat: 60.29537,
lon: 24.94262
},
{
id: "U3RvcDpIU0w6NDUxMDI1OA==",
lat: 60.29672,
lon: 24.941369
},
{
id: "U3RvcDpIU0w6NDQxMDI5Ng==",
lat: 60.29726,
lon: 24.92992
},
{
id: "U3RvcDpIU0w6NDQxMDI5OA==",
lat: 60.297203,
lon: 24.916195
},
{
id: "U3RvcDpIU0w6NDQxMDIxNA==",
lat: 60.298535,
lon: 24.901062
},
{
id: "U3RvcDpIU0w6NDQxMDIwOQ==",
lat: 60.2983,
lon: 24.88306
},
{
id: "U3RvcDpIU0w6NDIxMDIwMw==",
lat: 60.29542,
lon: 24.85944
},
{
id: "U3RvcDpIU0w6NDIxMDIwNQ==",
lat: 60.29993,
lon: 24.85925
},
{
id: "U3RvcDpIU0w6NDIxMDIwNw==",
lat: 60.30319,
lon: 24.86046
},
{
id: "U3RvcDpIU0w6NDIxMDIwOQ==",
lat: 60.30546,
lon: 24.86282
},
{
id: "U3RvcDpIU0w6NDIxMDIyMA==",
lat: 60.308,
lon: 24.86569
},
{
id: "U3RvcDpIU0w6NDIxMDIyMg==",
lat: 60.31329,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDIzMDI0OQ==",
lat: 60.316261,
lon: 24.848552
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0NQ==",
lat: 60.314149,
lon: 24.844845
},
{
id: "U3RvcDpIU0w6NDIzMDI0OA==",
lat: 60.315237,
lon: 24.849881
},
{
id: "U3RvcDpIU0w6NDIxMDIxOQ==",
lat: 60.3075,
lon: 24.86598
},
{
id: "U3RvcDpIU0w6NDIxMDIxMA==",
lat: 60.30601,
lon: 24.86369
},
{
id: "U3RvcDpIU0w6NDIxMDIwOA==",
lat: 60.30316,
lon: 24.8602
},
{
id: "U3RvcDpIU0w6NDIxMDIwNg==",
lat: 60.29954,
lon: 24.85863
},
{
id: "U3RvcDpIU0w6NDIxMDIwNA==",
lat: 60.2945,
lon: 24.86104
},
{
id: "U3RvcDpIU0w6NDQxMDIwOA==",
lat: 60.29774,
lon: 24.88346
},
{
id: "U3RvcDpIU0w6NDQxMDIxMw==",
lat: 60.298287,
lon: 24.898963
},
{
id: "U3RvcDpIU0w6NDQxMDI5OQ==",
lat: 60.297001,
lon: 24.916547
},
{
id: "U3RvcDpIU0w6NDQxMDI5Nw==",
lat: 60.29677,
lon: 24.93165
},
{
id: "U3RvcDpIU0w6NDUxMDI0Nw==",
lat: 60.29464,
lon: 24.94259
},
{
id: "U3RvcDpIU0w6NDUxMDI1Mw==",
lat: 60.293552,
lon: 24.94809
},
{
id: "U3RvcDpIU0w6NDUxMDIxNQ==",
lat: 60.293698,
lon: 24.95222
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIwMQ==",
lat: 60.28944,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIyMA==",
lat: 60.2865,
lon: 24.95909
},
{
id: "U3RvcDpIU0w6NDUxMDIwMw==",
lat: 60.28515,
lon: 24.96256
},
{
id: "U3RvcDpIU0w6NDUxMDIzOQ==",
lat: 60.2842,
lon: 24.96675
},
{
id: "U3RvcDpIU0w6NDUxMDIwNQ==",
lat: 60.28334,
lon: 24.97145
},
{
id: "U3RvcDpIU0w6NDUxMDIwOQ==",
lat: 60.28201,
lon: 24.97331
},
{
id: "U3RvcDpIU0w6NDUwMDIxNA==",
lat: 60.27911,
lon: 24.9706
},
{
id: "U3RvcDpIU0w6NDUwMDIwMQ==",
lat: 60.27613,
lon: 24.97043
},
{
id: "U3RvcDpIU0w6NDUwMDIwMw==",
lat: 60.272035,
lon: 24.96929
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTE1MA==",
lat: 60.178205,
lon: 24.951532
}
]
},
{
gtfsId: "HSL:4562N",
shortName: "562N",
longName: "Mellunmäki - Tikkurila - Aviapolis - Lentoasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MzIyMQ==",
lat: 60.238345,
lon: 25.109191
},
{
id: "U3RvcDpIU0w6NDkxMDIxNw==",
lat: 60.242165,
lon: 25.108975
},
{
id: "U3RvcDpIU0w6NDkxMDIxNQ==",
lat: 60.24494,
lon: 25.11149
},
{
id: "U3RvcDpIU0w6NDkxMDIwMw==",
lat: 60.24755,
lon: 25.11225
},
{
id: "U3RvcDpIU0w6NDkxMDIyMg==",
lat: 60.251153,
lon: 25.110441
},
{
id: "U3RvcDpIU0w6NDk1MDIxMw==",
lat: 60.25071,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk1MDIwNg==",
lat: 60.24998,
lon: 25.09979
},
{
id: "U3RvcDpIU0w6NDk1MDIwNA==",
lat: 60.250182,
lon: 25.093707
},
{
id: "U3RvcDpIU0w6NDk1MDIwMg==",
lat: 60.25108,
lon: 25.08727
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDIxNQ==",
lat: 60.27901,
lon: 25.10592
},
{
id: "U3RvcDpIU0w6NDk0MDIxMw==",
lat: 60.28017,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDk0MDIxMQ==",
lat: 60.280871,
lon: 25.095651
},
{
id: "U3RvcDpIU0w6NDY0MDIxMA==",
lat: 60.28163,
lon: 25.08709
},
{
id: "U3RvcDpIU0w6NDY0MDIwOA==",
lat: 60.2826,
lon: 25.07956
},
{
id: "U3RvcDpIU0w6NDY0MDIwNg==",
lat: 60.28606,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6NDY2MDIwNg==",
lat: 60.28758,
lon: 25.07993
},
{
id: "U3RvcDpIU0w6NDY2MDIwNA==",
lat: 60.28978,
lon: 25.07599
},
{
id: "U3RvcDpIU0w6NDY2MDIwMg==",
lat: 60.29189,
lon: 25.07317
},
{
id: "U3RvcDpIU0w6NDY2MDI5OA==",
lat: 60.29531,
lon: 25.06689
},
{
id: "U3RvcDpIU0w6NDYyMDIwNg==",
lat: 60.29581,
lon: 25.05983
},
{
id: "U3RvcDpIU0w6NDYyMDIyMg==",
lat: 60.29868,
lon: 25.05371
},
{
id: "U3RvcDpIU0w6NDYyMDIzMQ==",
lat: 60.2985,
lon: 25.05011
},
{
id: "U3RvcDpIU0w6NDYxMDIzNw==",
lat: 60.29861,
lon: 25.044342
},
{
id: "U3RvcDpIU0w6NDYxMDIwNw==",
lat: 60.293293,
lon: 25.043366
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMQ==",
lat: 60.292838,
lon: 25.034291
},
{
id: "U3RvcDpIU0w6NDYzMDIwNg==",
lat: 60.29374,
lon: 25.02962
},
{
id: "U3RvcDpIU0w6NDYzMDIwNA==",
lat: 60.29387,
lon: 25.02434
},
{
id: "U3RvcDpIU0w6NDYzMDIwMg==",
lat: 60.29399,
lon: 25.01849
},
{
id: "U3RvcDpIU0w6NDYzMDIxMg==",
lat: 60.29205,
lon: 25.0157
},
{
id: "U3RvcDpIU0w6NDY4MDIyOA==",
lat: 60.29215,
lon: 25.01095
},
{
id: "U3RvcDpIU0w6NDY4MDIwNA==",
lat: 60.29215,
lon: 25.00494
},
{
id: "U3RvcDpIU0w6NDY4MDIwNg==",
lat: 60.29266,
lon: 24.99609
},
{
id: "U3RvcDpIU0w6NDY4MDI0Mg==",
lat: 60.29315,
lon: 24.98939
},
{
id: "U3RvcDpIU0w6NDY4MDI0OA==",
lat: 60.29424,
lon: 24.98574
},
{
id: "U3RvcDpIU0w6NDUyMDI2MA==",
lat: 60.296,
lon: 24.98043
},
{
id: "U3RvcDpIU0w6NDUyMDIyNw==",
lat: 60.29665,
lon: 24.97606
},
{
id: "U3RvcDpIU0w6NDUyMDIxMA==",
lat: 60.29319,
lon: 24.97148
},
{
id: "U3RvcDpIU0w6NDUxMDIyNw==",
lat: 60.289917,
lon: 24.965022
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDI1MQ==",
lat: 60.291725,
lon: 24.95261
},
{
id: "U3RvcDpIU0w6NDUxMDIyOA==",
lat: 60.293334,
lon: 24.946772
},
{
id: "U3RvcDpIU0w6NDUyMDIxNQ==",
lat: 60.29537,
lon: 24.94262
},
{
id: "U3RvcDpIU0w6NDUyMDI5Mw==",
lat: 60.297731,
lon: 24.941936
},
{
id: "U3RvcDpIU0w6NDUyMDIwNg==",
lat: 60.300216,
lon: 24.941409
},
{
id: "U3RvcDpIU0w6NDUyMDI5OQ==",
lat: 60.3027,
lon: 24.9422
},
{
id: "U3RvcDpIU0w6NDUyMDIzOA==",
lat: 60.302153,
lon: 24.952562
},
{
id: "U3RvcDpIU0w6NDUyMDI2Ng==",
lat: 60.302738,
lon: 24.955727
},
{
id: "U3RvcDpIU0w6NDUyMDI2OA==",
lat: 60.306115,
lon: 24.958895
},
{
id: "U3RvcDpIU0w6NDUzMDIyMg==",
lat: 60.308712,
lon: 24.961988
},
{
id: "U3RvcDpIU0w6NDUzMDIwOQ==",
lat: 60.317071,
lon: 24.966263
},
{
id: "U3RvcDpIU0w6NDUzMDIzMA==",
lat: 60.317343,
lon: 24.965217
},
{
id: "U3RvcDpIU0w6NDUzMDI1OA==",
lat: 60.313471,
lon: 24.967726
},
{
id: "U3RvcDpIU0w6NDUzMDIyMQ==",
lat: 60.307879,
lon: 24.960343
},
{
id: "U3RvcDpIU0w6NDUyMDI2Nw==",
lat: 60.304895,
lon: 24.957404
},
{
id: "U3RvcDpIU0w6NDUyMDI2OQ==",
lat: 60.302518,
lon: 24.955252
},
{
id: "U3RvcDpIU0w6NDUyMDIzNw==",
lat: 60.302312,
lon: 24.952512
},
{
id: "U3RvcDpIU0w6NDUyMDI5MA==",
lat: 60.302239,
lon: 24.940914
},
{
id: "U3RvcDpIU0w6NDUyMDIwNQ==",
lat: 60.299684,
lon: 24.941292
},
{
id: "U3RvcDpIU0w6NDUyMDI5NA==",
lat: 60.296503,
lon: 24.94167
},
{
id: "U3RvcDpIU0w6NDUxMDI0Nw==",
lat: 60.29464,
lon: 24.94259
},
{
id: "U3RvcDpIU0w6NDUxMDI1Mw==",
lat: 60.293552,
lon: 24.94809
},
{
id: "U3RvcDpIU0w6NDUxMDIxNQ==",
lat: 60.293698,
lon: 24.95222
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIyNA==",
lat: 60.28971,
lon: 24.96089
},
{
id: "U3RvcDpIU0w6NDUxMDIyNg==",
lat: 60.28974,
lon: 24.96626
},
{
id: "U3RvcDpIU0w6NDUxMDIzOA==",
lat: 60.29031,
lon: 24.96765
},
{
id: "U3RvcDpIU0w6NDUyMDIxOQ==",
lat: 60.29413,
lon: 24.97213
},
{
id: "U3RvcDpIU0w6NDUyMDI1OQ==",
lat: 60.29643,
lon: 24.9774
},
{
id: "U3RvcDpIU0w6NDUyMDIyNg==",
lat: 60.2954,
lon: 24.98164
},
{
id: "U3RvcDpIU0w6NDY4MDI0NQ==",
lat: 60.29407,
lon: 24.98582
},
{
id: "U3RvcDpIU0w6NDY4MDI0Mw==",
lat: 60.29276,
lon: 24.99154
},
{
id: "U3RvcDpIU0w6NDY4MDIwNQ==",
lat: 60.29238,
lon: 24.9982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMw==",
lat: 60.29196,
lon: 25.00701
},
{
id: "U3RvcDpIU0w6NDY4MDIyNw==",
lat: 60.29201,
lon: 25.01294
},
{
id: "U3RvcDpIU0w6NDYzMDIxOA==",
lat: 60.292663,
lon: 25.017039
},
{
id: "U3RvcDpIU0w6NDYzMDIwMQ==",
lat: 60.29386,
lon: 25.02012
},
{
id: "U3RvcDpIU0w6NDYzMDIwMw==",
lat: 60.29374,
lon: 25.02565
},
{
id: "U3RvcDpIU0w6NDYzMDIwNQ==",
lat: 60.29362,
lon: 25.03007
},
{
id: "U3RvcDpIU0w6NDYxMDIxMA==",
lat: 60.29258,
lon: 25.03557
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI0OA==",
lat: 60.293761,
lon: 25.044375
},
{
id: "U3RvcDpIU0w6NDYxMDIzNg==",
lat: 60.29838,
lon: 25.0454
},
{
id: "U3RvcDpIU0w6NDYyMDIyNw==",
lat: 60.29821,
lon: 25.05193
},
{
id: "U3RvcDpIU0w6NDYyMDIxNw==",
lat: 60.29828,
lon: 25.055708
},
{
id: "U3RvcDpIU0w6NDYyMDIwNQ==",
lat: 60.29549,
lon: 25.0614
},
{
id: "U3RvcDpIU0w6NDY2MDI5OQ==",
lat: 60.29509,
lon: 25.06703
},
{
id: "U3RvcDpIU0w6NDY2MDIwMQ==",
lat: 60.29136,
lon: 25.07367
},
{
id: "U3RvcDpIU0w6NDY2MDIzMA==",
lat: 60.288522,
lon: 25.077184
},
{
id: "U3RvcDpIU0w6NDY2MDIwOA==",
lat: 60.28666,
lon: 25.08042
},
{
id: "U3RvcDpIU0w6NDY0MDIwNw==",
lat: 60.28193,
lon: 25.0804
},
{
id: "U3RvcDpIU0w6NDY0MDIwOQ==",
lat: 60.28153,
lon: 25.0894
},
{
id: "U3RvcDpIU0w6NDk0MDIxMA==",
lat: 60.28073,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6NDk0MDIxMg==",
lat: 60.27969,
lon: 25.10342
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6NDk1MDIwMQ==",
lat: 60.25091,
lon: 25.08784
},
{
id: "U3RvcDpIU0w6NDk1MDIwNQ==",
lat: 60.249921,
lon: 25.096143
},
{
id: "U3RvcDpIU0w6NDk1MDIxMQ==",
lat: 60.24978,
lon: 25.1021
},
{
id: "U3RvcDpIU0w6NDk1MDIxMg==",
lat: 60.250903,
lon: 25.1084
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIxOA==",
lat: 60.24234,
lon: 25.10881
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
}
]
},
{
gtfsId: "HSL:2165N",
shortName: "165N",
longName: "Kamppi-Saunalahti-Kauklahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjUxMTI1MQ==",
lat: 60.194122,
lon: 24.59296
},
{
id: "U3RvcDpIU0w6MjUxMTI1NA==",
lat: 60.191759,
lon: 24.591303
},
{
id: "U3RvcDpIU0w6MjUxMTI1Nw==",
lat: 60.18826,
lon: 24.586646
},
{
id: "U3RvcDpIU0w6MjUxMTI0MA==",
lat: 60.186314,
lon: 24.589023
},
{
id: "U3RvcDpIU0w6MjUxMTIzNA==",
lat: 60.186698,
lon: 24.592018
},
{
id: "U3RvcDpIU0w6MjUxMTIzOA==",
lat: 60.18847,
lon: 24.59719
},
{
id: "U3RvcDpIU0w6MjUxMTIzNg==",
lat: 60.190499,
lon: 24.601866
},
{
id: "U3RvcDpIU0w6MjUyMjIyMg==",
lat: 60.190149,
lon: 24.60779
},
{
id: "U3RvcDpIU0w6MjUyMjIxNQ==",
lat: 60.18687,
lon: 24.61042
},
{
id: "U3RvcDpIU0w6MjUyMjIwMg==",
lat: 60.185103,
lon: 24.612888
},
{
id: "U3RvcDpIU0w6MjUyMjIzMA==",
lat: 60.18218,
lon: 24.61256
},
{
id: "U3RvcDpIU0w6MjUyMjIxOA==",
lat: 60.18439,
lon: 24.59837
},
{
id: "U3RvcDpIU0w6MjUyMTIxNA==",
lat: 60.182244,
lon: 24.598781
},
{
id: "U3RvcDpIU0w6MjUyMTIwNA==",
lat: 60.17816,
lon: 24.60216
},
{
id: "U3RvcDpIU0w6MjUyMTIwMg==",
lat: 60.17436,
lon: 24.60497
},
{
id: "U3RvcDpIU0w6MjUyMTIxNg==",
lat: 60.172937,
lon: 24.60848
},
{
id: "U3RvcDpIU0w6MjQyMzIwNw==",
lat: 60.169835,
lon: 24.612191
},
{
id: "U3RvcDpIU0w6MjQyMzIxMw==",
lat: 60.16746,
lon: 24.616208
},
{
id: "U3RvcDpIU0w6MjQyMzIxMQ==",
lat: 60.165647,
lon: 24.61464
},
{
id: "U3RvcDpIU0w6MjQyMzIxNA==",
lat: 60.16214,
lon: 24.61326
},
{
id: "U3RvcDpIU0w6MjQyMzIyMA==",
lat: 60.15901,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxMQ==",
lat: 60.15326,
lon: 24.63371
},
{
id: "U3RvcDpIU0w6MjQxMzIxNw==",
lat: 60.15308,
lon: 24.635611
},
{
id: "U3RvcDpIU0w6MjQxMzIwNg==",
lat: 60.15445,
lon: 24.64661
},
{
id: "U3RvcDpIU0w6MjQxMTIwNA==",
lat: 60.15267,
lon: 24.65583
},
{
id: "U3RvcDpIU0w6MjQxMTIwMg==",
lat: 60.152095,
lon: 24.663769
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
},
{
id: "U3RvcDpIU0w6MTA0MDI4Mg==",
lat: 60.16885,
lon: 24.93109
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIwMQ==",
lat: 60.15214,
lon: 24.66269
},
{
id: "U3RvcDpIU0w6MjQxMTIwMw==",
lat: 60.15338,
lon: 24.65167
},
{
id: "U3RvcDpIU0w6MjQxMzIwNQ==",
lat: 60.1548,
lon: 24.6459
},
{
id: "U3RvcDpIU0w6MjQxMzIxOA==",
lat: 60.153422,
lon: 24.636179
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOA==",
lat: 60.15638,
lon: 24.63086
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6MjQyMzIxOQ==",
lat: 60.15906,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQyMzIxNQ==",
lat: 60.16269,
lon: 24.61315
},
{
id: "U3RvcDpIU0w6MjQyMzIxMA==",
lat: 60.165995,
lon: 24.615303
},
{
id: "U3RvcDpIU0w6MjQyMzIwNQ==",
lat: 60.16774,
lon: 24.61602
},
{
id: "U3RvcDpIU0w6MjQyMzIyOA==",
lat: 60.17014,
lon: 24.61163
},
{
id: "U3RvcDpIU0w6MjQyMzIyMQ==",
lat: 60.172893,
lon: 24.608527
},
{
id: "U3RvcDpIU0w6MjUyMTIwMQ==",
lat: 60.17543,
lon: 24.60438
},
{
id: "U3RvcDpIU0w6MjUyMTIwMw==",
lat: 60.17883,
lon: 24.60186
},
{
id: "U3RvcDpIU0w6MjUyMTIxMw==",
lat: 60.182412,
lon: 24.598789
},
{
id: "U3RvcDpIU0w6MjUyMTIxMA==",
lat: 60.18405,
lon: 24.60043
},
{
id: "U3RvcDpIU0w6MjUyMjIxNw==",
lat: 60.18349,
lon: 24.61368
},
{
id: "U3RvcDpIU0w6MjUyMjIwMw==",
lat: 60.18505,
lon: 24.61309
},
{
id: "U3RvcDpIU0w6MjUyMjIxNg==",
lat: 60.18689,
lon: 24.61047
},
{
id: "U3RvcDpIU0w6MjUyMjIyMw==",
lat: 60.19036,
lon: 24.60782
},
{
id: "U3RvcDpIU0w6MjUxMTIzNQ==",
lat: 60.190312,
lon: 24.601027
},
{
id: "U3RvcDpIU0w6MjUxMTIzNw==",
lat: 60.18797,
lon: 24.59555
},
{
id: "U3RvcDpIU0w6MjUxMTIzMw==",
lat: 60.18683,
lon: 24.59231
},
{
id: "U3RvcDpIU0w6MjUxMTIzOQ==",
lat: 60.186662,
lon: 24.588232
},
{
id: "U3RvcDpIU0w6MjUxMTI1Mw==",
lat: 60.191797,
lon: 24.591574
},
{
id: "U3RvcDpIU0w6MjUxMTI1Mg==",
lat: 60.192879,
lon: 24.592886
}
]
},
{
gtfsId: "HSL:2550",
shortName: "550",
longName: "Itäkeskus-Westendinasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzI4Nw==",
lat: 60.20982,
lon: 25.07738
},
{
id: "U3RvcDpIU0w6MTQ1NjExOA==",
lat: 60.2102,
lon: 25.05852
},
{
id: "U3RvcDpIU0w6MTQ1NjEyMg==",
lat: 60.214639,
lon: 25.059063
},
{
id: "U3RvcDpIU0w6MTQ1NDEyMA==",
lat: 60.21841,
lon: 25.04887
},
{
id: "U3RvcDpIU0w6MTM2MjExMg==",
lat: 60.22423,
lon: 25.0203
},
{
id: "U3RvcDpIU0w6MTM2MjE0MA==",
lat: 60.22724,
lon: 25.01184
},
{
id: "U3RvcDpIU0w6MTM4MzEwMQ==",
lat: 60.23021,
lon: 24.99814
},
{
id: "U3RvcDpIU0w6MTI4NTEwMQ==",
lat: 60.2313,
lon: 24.975489
},
{
id: "U3RvcDpIU0w6MTI4NTEwMw==",
lat: 60.228701,
lon: 24.967974
},
{
id: "U3RvcDpIU0w6MTI4NDExNw==",
lat: 60.22996,
lon: 24.96525
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEwMw==",
lat: 60.22972,
lon: 24.94197
},
{
id: "U3RvcDpIU0w6MTI4MjE0Nw==",
lat: 60.230679,
lon: 24.932013
},
{
id: "U3RvcDpIU0w6MTI4MTExMg==",
lat: 60.23075,
lon: 24.91943
},
{
id: "U3RvcDpIU0w6MTI4MTE2MA==",
lat: 60.227725,
lon: 24.906583
},
{
id: "U3RvcDpIU0w6MTI5MzE1Nw==",
lat: 60.22017,
lon: 24.90711
},
{
id: "U3RvcDpIU0w6MTI5MTIyMA==",
lat: 60.21031,
lon: 24.88865
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MjAwMDIwMw==",
lat: 60.22112,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6MjExMzIwNQ==",
lat: 60.22052,
lon: 24.83286
},
{
id: "U3RvcDpIU0w6MjExMTI4MA==",
lat: 60.21955,
lon: 24.82102
},
{
id: "U3RvcDpIU0w6MjExMjI2MQ==",
lat: 60.21896,
lon: 24.816
},
{
id: "U3RvcDpIU0w6MjExMjI2Mw==",
lat: 60.21244,
lon: 24.81549
},
{
id: "U3RvcDpIU0w6MjEyMjIxOQ==",
lat: 60.2061,
lon: 24.81546
},
{
id: "U3RvcDpIU0w6MjEyMjIyMQ==",
lat: 60.19943,
lon: 24.80785
},
{
id: "U3RvcDpIU0w6MjIxNTI3NQ==",
lat: 60.18935,
lon: 24.80714
},
{
id: "U3RvcDpIU0w6MjIyMjIyNg==",
lat: 60.185,
lon: 24.81447
},
{
id: "U3RvcDpIU0w6MjIyMjIxMg==",
lat: 60.183766,
lon: 24.828012
},
{
id: "U3RvcDpIU0w6MjIxMzIwOA==",
lat: 60.17872,
lon: 24.81654
},
{
id: "U3RvcDpIU0w6MjIxMTIxMQ==",
lat: 60.17718,
lon: 24.81083
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMTI3NA==",
lat: 60.17223,
lon: 24.80195
},
{
id: "U3RvcDpIU0w6MjIzMTIxMw==",
lat: 60.16881,
lon: 24.80491
},
{
id: "U3RvcDpIU0w6MjIzMTIyMQ==",
lat: 60.1688,
lon: 24.80383
},
{
id: "U3RvcDpIU0w6MjIxMTI3NQ==",
lat: 60.17197,
lon: 24.80231
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMzIxMA==",
lat: 60.17798,
lon: 24.81266
},
{
id: "U3RvcDpIU0w6MjIxMzIwOQ==",
lat: 60.17862,
lon: 24.81721
},
{
id: "U3RvcDpIU0w6MjIyMjIzNA==",
lat: 60.18362,
lon: 24.82779
},
{
id: "U3RvcDpIU0w6MjIyMjIyNQ==",
lat: 60.18609,
lon: 24.81291
},
{
id: "U3RvcDpIU0w6MjIyMjI2OA==",
lat: 60.18712,
lon: 24.80903
},
{
id: "U3RvcDpIU0w6MjEyMjIyMA==",
lat: 60.2002,
lon: 24.80968
},
{
id: "U3RvcDpIU0w6MjEyMTIwMg==",
lat: 60.2053,
lon: 24.81595
},
{
id: "U3RvcDpIU0w6MjExODI2NA==",
lat: 60.21391,
lon: 24.81666
},
{
id: "U3RvcDpIU0w6MjExMjI2Mg==",
lat: 60.219276,
lon: 24.816951
},
{
id: "U3RvcDpIU0w6MjExMTI1Ng==",
lat: 60.21934,
lon: 24.8217
},
{
id: "U3RvcDpIU0w6MjExMzIwNg==",
lat: 60.22042,
lon: 24.83513
},
{
id: "U3RvcDpIU0w6MjExMzIwNA==",
lat: 60.2211,
lon: 24.84182
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTExOQ==",
lat: 60.209999,
lon: 24.888297
},
{
id: "U3RvcDpIU0w6MTI5MzE1Ng==",
lat: 60.22082,
lon: 24.9071
},
{
id: "U3RvcDpIU0w6MTI4NjE4MQ==",
lat: 60.227754,
lon: 24.907305
},
{
id: "U3RvcDpIU0w6MTI4MTExNA==",
lat: 60.23083,
lon: 24.92003
},
{
id: "U3RvcDpIU0w6MTI4MjE0Ng==",
lat: 60.23062,
lon: 24.93342
},
{
id: "U3RvcDpIU0w6MTI4MjEwMg==",
lat: 60.23011,
lon: 24.9378
},
{
id: "U3RvcDpIU0w6MTI4NDEwNA==",
lat: 60.22968,
lon: 24.94452
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDEwMg==",
lat: 60.22873,
lon: 24.96421
},
{
id: "U3RvcDpIU0w6MTI4NTEwNA==",
lat: 60.228763,
lon: 24.968268
},
{
id: "U3RvcDpIU0w6MTI4NTEwMg==",
lat: 60.231251,
lon: 24.975103
},
{
id: "U3RvcDpIU0w6MTM4MzEwMg==",
lat: 60.22992,
lon: 24.99835
},
{
id: "U3RvcDpIU0w6MTM2MjEzOQ==",
lat: 60.22709,
lon: 25.01242
},
{
id: "U3RvcDpIU0w6MTM2MjExMw==",
lat: 60.22367,
lon: 25.02229
},
{
id: "U3RvcDpIU0w6MTQ1NDEyMQ==",
lat: 60.218421,
lon: 25.047586
},
{
id: "U3RvcDpIU0w6MTQ1NjEyMw==",
lat: 60.214696,
lon: 25.058765
},
{
id: "U3RvcDpIU0w6MTQ1NjE1Mw==",
lat: 60.209323,
lon: 25.056896
},
{
id: "U3RvcDpIU0w6MTQ1MzIxNA==",
lat: 60.21033,
lon: 25.07785
}
]
},
{
gtfsId: "HSL:1088B",
shortName: "88B",
longName: "Herttoniemi(M) - Kruunuvuorenranta",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTE4NQ==",
lat: 60.19483,
lon: 25.03145
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMw==",
lat: 60.18248,
lon: 25.05064
},
{
id: "U3RvcDpIU0w6MTQ5MTE1OA==",
lat: 60.181037,
lon: 25.050729
},
{
id: "U3RvcDpIU0w6MTQ5MTE1NQ==",
lat: 60.178434,
lon: 25.049872
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNw==",
lat: 60.17786,
lon: 25.04891
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOQ==",
lat: 60.17566,
lon: 25.0462
},
{
id: "U3RvcDpIU0w6MTQ5MTExMQ==",
lat: 60.174743,
lon: 25.040362
},
{
id: "U3RvcDpIU0w6MTQ5MzEwMg==",
lat: 60.17215,
lon: 25.033079
},
{
id: "U3RvcDpIU0w6MTQ5NDEwNw==",
lat: 60.168898,
lon: 25.025654
},
{
id: "U3RvcDpIU0w6MTQ5NDEwNQ==",
lat: 60.168987,
lon: 25.020211
},
{
id: "U3RvcDpIU0w6MTQ5NDEwNA==",
lat: 60.1689,
lon: 25.020529
},
{
id: "U3RvcDpIU0w6MTQ5NDE1Nw==",
lat: 60.168892,
lon: 25.026066
},
{
id: "U3RvcDpIU0w6MTQ5MTE2Nw==",
lat: 60.172308,
lon: 25.033506
},
{
id: "U3RvcDpIU0w6MTQ5MTExMg==",
lat: 60.174846,
lon: 25.041802
},
{
id: "U3RvcDpIU0w6MTQ5MTExMA==",
lat: 60.1756,
lon: 25.04661
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOA==",
lat: 60.17786,
lon: 25.04901
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Ng==",
lat: 60.17938,
lon: 25.0509
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OA==",
lat: 60.18142,
lon: 25.05098
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNA==",
lat: 60.18299,
lon: 25.05049
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
}
]
},
{
gtfsId: "HSL:6906",
shortName: "906",
longName: "Luoma-Masala-Kauhala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE0MDIyMA==",
lat: 60.21376,
lon: 24.484233
},
{
id: "U3RvcDpIU0w6NjE0MDIxNg==",
lat: 60.207477,
lon: 24.49102
},
{
id: "U3RvcDpIU0w6NjE0MDIxMg==",
lat: 60.205225,
lon: 24.497413
},
{
id: "U3RvcDpIU0w6NjE0MDI1Mg==",
lat: 60.203833,
lon: 24.501328
},
{
id: "U3RvcDpIU0w6NjE0MDI0OQ==",
lat: 60.202515,
lon: 24.49682
},
{
id: "U3RvcDpIU0w6NjE0MDI0Mg==",
lat: 60.19953,
lon: 24.4918
},
{
id: "U3RvcDpIU0w6NjE0MDI0MA==",
lat: 60.194935,
lon: 24.477863
},
{
id: "U3RvcDpIU0w6NjAxMDIxNw==",
lat: 60.188398,
lon: 24.462162
},
{
id: "U3RvcDpIU0w6NjAxMDIxNA==",
lat: 60.187038,
lon: 24.458358
},
{
id: "U3RvcDpIU0w6NjAxMDIyMA==",
lat: 60.180317,
lon: 24.459108
},
{
id: "U3RvcDpIU0w6NjAxMDIxMQ==",
lat: 60.17575,
lon: 24.460652
},
{
id: "U3RvcDpIU0w6NjAxMDIxMA==",
lat: 60.172493,
lon: 24.4582
},
{
id: "U3RvcDpIU0w6NjAxMDIwNw==",
lat: 60.167792,
lon: 24.458575
},
{
id: "U3RvcDpIU0w6NjAxMDIxOQ==",
lat: 60.163122,
lon: 24.470748
},
{
id: "U3RvcDpIU0w6NjAxMDIwNQ==",
lat: 60.159385,
lon: 24.477312
},
{
id: "U3RvcDpIU0w6NjAyMDIyMg==",
lat: 60.15819,
lon: 24.511563
},
{
id: "U3RvcDpIU0w6NjAyMDIyMw==",
lat: 60.15877,
lon: 24.52273
},
{
id: "U3RvcDpIU0w6NjAyMDI2Ng==",
lat: 60.156964,
lon: 24.530624
},
{
id: "U3RvcDpIU0w6NjAyMDIyNA==",
lat: 60.1588,
lon: 24.536007
},
{
id: "U3RvcDpIU0w6NjAyMDIyOA==",
lat: 60.161683,
lon: 24.538822
},
{
id: "U3RvcDpIU0w6NjAyMDIzMQ==",
lat: 60.167277,
lon: 24.541513
},
{
id: "U3RvcDpIU0w6NjAyMDIzNQ==",
lat: 60.169593,
lon: 24.543572
},
{
id: "U3RvcDpIU0w6NjAyMDIzOA==",
lat: 60.171893,
lon: 24.547945
},
{
id: "U3RvcDpIU0w6NjAyMDI0NA==",
lat: 60.176757,
lon: 24.545682
},
{
id: "U3RvcDpIU0w6NjAyMDIzOQ==",
lat: 60.172823,
lon: 24.54828
},
{
id: "U3RvcDpIU0w6NjAyMDIzNA==",
lat: 60.16918,
lon: 24.54261
},
{
id: "U3RvcDpIU0w6NjAyMDIzMA==",
lat: 60.166542,
lon: 24.540887
},
{
id: "U3RvcDpIU0w6NjAyMDIyOQ==",
lat: 60.163035,
lon: 24.539265
},
{
id: "U3RvcDpIU0w6NjAyMDIyNw==",
lat: 60.159457,
lon: 24.536668
},
{
id: "U3RvcDpIU0w6NjAyMDIxOQ==",
lat: 60.157395,
lon: 24.529775
},
{
id: "U3RvcDpIU0w6NjAyMDIyNg==",
lat: 60.15911,
lon: 24.521842
},
{
id: "U3RvcDpIU0w6NjAyMDIyMA==",
lat: 60.157563,
lon: 24.50914
},
{
id: "U3RvcDpIU0w6NjAxMDIxOA==",
lat: 60.15729,
lon: 24.480627
},
{
id: "U3RvcDpIU0w6NjAxMDIwNg==",
lat: 60.159835,
lon: 24.477522
},
{
id: "U3RvcDpIU0w6NjAxMDIwMg==",
lat: 60.163337,
lon: 24.470142
},
{
id: "U3RvcDpIU0w6NjAxMDIyNA==",
lat: 60.165272,
lon: 24.465028
},
{
id: "U3RvcDpIU0w6NjAxMDIwOA==",
lat: 60.168615,
lon: 24.458743
},
{
id: "U3RvcDpIU0w6NjAxMDIwOQ==",
lat: 60.172357,
lon: 24.458517
},
{
id: "U3RvcDpIU0w6NjAxMDIxMg==",
lat: 60.176553,
lon: 24.460803
},
{
id: "U3RvcDpIU0w6NjAxMDIxMw==",
lat: 60.180033,
lon: 24.459578
},
{
id: "U3RvcDpIU0w6NjAxMDIyMQ==",
lat: 60.18357,
lon: 24.457835
},
{
id: "U3RvcDpIU0w6NjAxMDIyMw==",
lat: 60.187526,
lon: 24.458648
},
{
id: "U3RvcDpIU0w6NjAxMDIxNg==",
lat: 60.188302,
lon: 24.462273
},
{
id: "U3RvcDpIU0w6NjE0MDI0Ng==",
lat: 60.1949,
lon: 24.478328
},
{
id: "U3RvcDpIU0w6NjE0MDI1MQ==",
lat: 60.196122,
lon: 24.487017
},
{
id: "U3RvcDpIU0w6NjE0MDI0MQ==",
lat: 60.19904,
lon: 24.491792
},
{
id: "U3RvcDpIU0w6NjE0MDI1MA==",
lat: 60.202562,
lon: 24.497932
},
{
id: "U3RvcDpIU0w6NjE0MDIxNQ==",
lat: 60.20556,
lon: 24.496107
},
{
id: "U3RvcDpIU0w6NjE0MDIxNw==",
lat: 60.20775,
lon: 24.490838
},
{
id: "U3RvcDpIU0w6NjE0MDIyMQ==",
lat: 60.213307,
lon: 24.485165
}
]
},
{
gtfsId: "HSL:2548",
shortName: "548",
longName: "Tapiola(M)-Mankkaa-Kauniainen-Viherlaakso-Jupperi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjE0MzIwMQ==",
lat: 60.253117,
lon: 24.774669
},
{
id: "U3RvcDpIU0w6MjE0MzIxNw==",
lat: 60.253227,
lon: 24.772518
},
{
id: "U3RvcDpIU0w6MjE0MzIxNQ==",
lat: 60.25198,
lon: 24.7679
},
{
id: "U3RvcDpIU0w6MjE0MzIxMw==",
lat: 60.25041,
lon: 24.76301
},
{
id: "U3RvcDpIU0w6MjE0MzIxMg==",
lat: 60.24895,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjE0MjIxMA==",
lat: 60.24566,
lon: 24.75026
},
{
id: "U3RvcDpIU0w6MjE0MjIwOA==",
lat: 60.24338,
lon: 24.74724
},
{
id: "U3RvcDpIU0w6MjE0MjIwNg==",
lat: 60.2414,
lon: 24.74307
},
{
id: "U3RvcDpIU0w6MjE0MTIwNA==",
lat: 60.23995,
lon: 24.74098
},
{
id: "U3RvcDpIU0w6MjE1MTIyMg==",
lat: 60.23515,
lon: 24.74405
},
{
id: "U3RvcDpIU0w6MjE1MTIxMg==",
lat: 60.2317,
lon: 24.74328
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIwOA==",
lat: 60.22675,
lon: 24.74088
},
{
id: "U3RvcDpIU0w6MjE1MTIxOQ==",
lat: 60.22457,
lon: 24.74244
},
{
id: "U3RvcDpIU0w6MjE1MTIyNA==",
lat: 60.22173,
lon: 24.74247
},
{
id: "U3RvcDpIU0w6MzE3MDIwMQ==",
lat: 60.21594,
lon: 24.74047
},
{
id: "U3RvcDpIU0w6MzE3MDIwMw==",
lat: 60.21292,
lon: 24.73743
},
{
id: "U3RvcDpIU0w6MzE3MDIwNQ==",
lat: 60.21266,
lon: 24.72851
},
{
id: "U3RvcDpIU0w6MzE3MDI0MA==",
lat: 60.21083,
lon: 24.72933
},
{
id: "U3RvcDpIU0w6MzE3MDIzMQ==",
lat: 60.2096,
lon: 24.73197
},
{
id: "U3RvcDpIU0w6MzE3MDIyOQ==",
lat: 60.20949,
lon: 24.73919
},
{
id: "U3RvcDpIU0w6MjEzMTI1MA==",
lat: 60.207094,
lon: 24.752523
},
{
id: "U3RvcDpIU0w6MjI0MjIxMA==",
lat: 60.20325,
lon: 24.76069
},
{
id: "U3RvcDpIU0w6MjI0MjIwOA==",
lat: 60.19894,
lon: 24.76333
},
{
id: "U3RvcDpIU0w6MjI0MTIwNg==",
lat: 60.1964,
lon: 24.76588
},
{
id: "U3RvcDpIU0w6MjI0MTIwNA==",
lat: 60.19414,
lon: 24.76971
},
{
id: "U3RvcDpIU0w6MjI0MTIwMg==",
lat: 60.190816,
lon: 24.776774
},
{
id: "U3RvcDpIU0w6MjIxNTI1NQ==",
lat: 60.18678,
lon: 24.78434
},
{
id: "U3RvcDpIU0w6MjIxNTI1OQ==",
lat: 60.18295,
lon: 24.78943
},
{
id: "U3RvcDpIU0w6MjIxMjIxOQ==",
lat: 60.18154,
lon: 24.79584
},
{
id: "U3RvcDpIU0w6MjIxMjIxNw==",
lat: 60.17822,
lon: 24.79887
},
{
id: "U3RvcDpIU0w6MjIxMjIyMA==",
lat: 60.175457,
lon: 24.800368
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
},
{
id: "U3RvcDpIU0w6MjIxMTIyNA==",
lat: 60.175056,
lon: 24.804395
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMjIxNg==",
lat: 60.17928,
lon: 24.79851
},
{
id: "U3RvcDpIU0w6MjIxMjIxOA==",
lat: 60.18134,
lon: 24.79634
},
{
id: "U3RvcDpIU0w6MjIxNTI1Nw==",
lat: 60.18286,
lon: 24.79364
},
{
id: "U3RvcDpIU0w6MjIxNTI1Mw==",
lat: 60.1837,
lon: 24.78701
},
{
id: "U3RvcDpIU0w6MjIxNTI1NA==",
lat: 60.18768,
lon: 24.78284
},
{
id: "U3RvcDpIU0w6MjI0MTIwMQ==",
lat: 60.19135,
lon: 24.77608
},
{
id: "U3RvcDpIU0w6MjI0MTIwMw==",
lat: 60.19464,
lon: 24.76877
},
{
id: "U3RvcDpIU0w6MjI0MTIwNQ==",
lat: 60.19723,
lon: 24.76565
},
{
id: "U3RvcDpIU0w6MjI0MjIwNw==",
lat: 60.20009,
lon: 24.76279
},
{
id: "U3RvcDpIU0w6MjI0MjIwOQ==",
lat: 60.20413,
lon: 24.75998
},
{
id: "U3RvcDpIU0w6MjEzMTI1Nw==",
lat: 60.207166,
lon: 24.75329
},
{
id: "U3RvcDpIU0w6MzE3MDIyOA==",
lat: 60.20948,
lon: 24.73798
},
{
id: "U3RvcDpIU0w6MzE3MDIzMA==",
lat: 60.20981,
lon: 24.73151
},
{
id: "U3RvcDpIU0w6MzE3MDIzOQ==",
lat: 60.21096,
lon: 24.72951
},
{
id: "U3RvcDpIU0w6MzE3MDIwNg==",
lat: 60.21262,
lon: 24.72996
},
{
id: "U3RvcDpIU0w6MzE3MDIwNA==",
lat: 60.21289,
lon: 24.73811
},
{
id: "U3RvcDpIU0w6MzE3MDIwMg==",
lat: 60.21788,
lon: 24.74241
},
{
id: "U3RvcDpIU0w6MjE1MTIyNQ==",
lat: 60.22231,
lon: 24.74345
},
{
id: "U3RvcDpIU0w6MjE1MTIxOA==",
lat: 60.2243,
lon: 24.74286
},
{
id: "U3RvcDpIU0w6MjE1MTIwNw==",
lat: 60.22686,
lon: 24.74108
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMQ==",
lat: 60.2317,
lon: 24.74358
},
{
id: "U3RvcDpIU0w6MjE0MTIwMQ==",
lat: 60.23675,
lon: 24.74327
},
{
id: "U3RvcDpIU0w6MjE0MTIwNQ==",
lat: 60.24064,
lon: 24.74186
},
{
id: "U3RvcDpIU0w6MjE0MTIwNw==",
lat: 60.24387,
lon: 24.7488
},
{
id: "U3RvcDpIU0w6MjE0MjIwOQ==",
lat: 60.24647,
lon: 24.75143
},
{
id: "U3RvcDpIU0w6MjE0MzIxMQ==",
lat: 60.2493,
lon: 24.7569
},
{
id: "U3RvcDpIU0w6MjE0MzIxNA==",
lat: 60.25059,
lon: 24.76441
},
{
id: "U3RvcDpIU0w6MjE0MzIxNg==",
lat: 60.25233,
lon: 24.76977
}
]
},
{
gtfsId: "HSL:6908",
shortName: "908",
longName: "Kirkkonummi-Evitskog-Kylmälä-Veikkola-Kaislampi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE3MDIzNw==",
lat: 60.288313,
lon: 24.470031
},
{
id: "U3RvcDpIU0w6NjE3MDI2OQ==",
lat: 60.292491,
lon: 24.453375
},
{
id: "U3RvcDpIU0w6NjE3MDI2Ng==",
lat: 60.289289,
lon: 24.445075
},
{
id: "U3RvcDpIU0w6NjE3MDI2NA==",
lat: 60.285963,
lon: 24.442213
},
{
id: "U3RvcDpIU0w6NjE3MDIzNA==",
lat: 60.283833,
lon: 24.432166
},
{
id: "U3RvcDpIU0w6NjE3MDI0NQ==",
lat: 60.285907,
lon: 24.423974
},
{
id: "U3RvcDpIU0w6NjE3MDI0Mw==",
lat: 60.28293,
lon: 24.420906
},
{
id: "U3RvcDpIU0w6NjE3MDI2Mg==",
lat: 60.279897,
lon: 24.415517
},
{
id: "U3RvcDpIU0w6NjE3MDIxMg==",
lat: 60.276707,
lon: 24.416505
},
{
id: "U3RvcDpIU0w6NjE3MDIxMA==",
lat: 60.273982,
lon: 24.422243
},
{
id: "U3RvcDpIU0w6NjE3MDIwOA==",
lat: 60.272485,
lon: 24.427072
},
{
id: "U3RvcDpIU0w6NjE3MDIyOA==",
lat: 60.27056,
lon: 24.439
},
{
id: "U3RvcDpIU0w6NjE3MDIwNg==",
lat: 60.269694,
lon: 24.444329
},
{
id: "U3RvcDpIU0w6NjE3MDIwNw==",
lat: 60.27008,
lon: 24.443606
},
{
id: "U3RvcDpIU0w6NjE3MDI1Ng==",
lat: 60.269183,
lon: 24.439668
},
{
id: "U3RvcDpIU0w6NjEyMDIwMQ==",
lat: 60.259133,
lon: 24.432048
},
{
id: "U3RvcDpIU0w6NjEyMDIyMA==",
lat: 60.257151,
lon: 24.430902
},
{
id: "U3RvcDpIU0w6NjEzMDIyMQ==",
lat: 60.253238,
lon: 24.41394
},
{
id: "U3RvcDpIU0w6NjEzMDIxNg==",
lat: 60.250457,
lon: 24.404192
},
{
id: "U3RvcDpIU0w6NjEzMDIzMg==",
lat: 60.251832,
lon: 24.402355
},
{
id: "U3RvcDpIU0w6NjEzMDIyMw==",
lat: 60.254182,
lon: 24.395288
},
{
id: "U3RvcDpIU0w6NjEzMDIyMA==",
lat: 60.252648,
lon: 24.389433
},
{
id: "U3RvcDpIU0w6NjEzMDIxNQ==",
lat: 60.246065,
lon: 24.381863
},
{
id: "U3RvcDpIU0w6NjEzMDIxMg==",
lat: 60.243068,
lon: 24.37739
},
{
id: "U3RvcDpIU0w6NjEzMDIxMA==",
lat: 60.240475,
lon: 24.377232
},
{
id: "U3RvcDpIU0w6NjEzMDIzMQ==",
lat: 60.240348,
lon: 24.382908
},
{
id: "U3RvcDpIU0w6NjEzMDIwOQ==",
lat: 60.238818,
lon: 24.394375
},
{
id: "U3RvcDpIU0w6NjEzMDIwNg==",
lat: 60.23469,
lon: 24.39721
},
{
id: "U3RvcDpIU0w6NjEzMDIyOQ==",
lat: 60.233227,
lon: 24.39171
},
{
id: "U3RvcDpIU0w6NjEzMDIwNQ==",
lat: 60.22879,
lon: 24.388057
},
{
id: "U3RvcDpIU0w6NjEzMDIwMw==",
lat: 60.227233,
lon: 24.38722
},
{
id: "U3RvcDpIU0w6NjEzMDIwMQ==",
lat: 60.226572,
lon: 24.380312
},
{
id: "U3RvcDpIU0w6NjE1MDIzOQ==",
lat: 60.225725,
lon: 24.37596
},
{
id: "U3RvcDpIU0w6NjE1MDIzMQ==",
lat: 60.225908,
lon: 24.369537
},
{
id: "U3RvcDpIU0w6NjE1MDIzNw==",
lat: 60.222042,
lon: 24.36192
},
{
id: "U3RvcDpIU0w6NjE1MDIyOQ==",
lat: 60.220405,
lon: 24.356558
},
{
id: "U3RvcDpIU0w6NjE1MDIyNw==",
lat: 60.21642,
lon: 24.345717
},
{
id: "U3RvcDpIU0w6NjE1MDIyNA==",
lat: 60.211693,
lon: 24.341255
},
{
id: "U3RvcDpIU0w6NjE1MDIxNQ==",
lat: 60.200862,
lon: 24.338385
},
{
id: "U3RvcDpIU0w6NjE1MDIxNA==",
lat: 60.200958,
lon: 24.340765
},
{
id: "U3RvcDpIU0w6NjE1MDIxOQ==",
lat: 60.202282,
lon: 24.358088
},
{
id: "U3RvcDpIU0w6NjE1MDIxOA==",
lat: 60.201517,
lon: 24.375928
},
{
id: "U3RvcDpIU0w6NjE1MDIxMg==",
lat: 60.19921,
lon: 24.37971
},
{
id: "U3RvcDpIU0w6NjE2MDIwMw==",
lat: 60.196608,
lon: 24.384945
},
{
id: "U3RvcDpIU0w6NjE2MDIyOA==",
lat: 60.190898,
lon: 24.394518
},
{
id: "U3RvcDpIU0w6NjE2MDIyNg==",
lat: 60.188902,
lon: 24.395963
},
{
id: "U3RvcDpIU0w6NjE2MDIyMQ==",
lat: 60.187848,
lon: 24.395802
},
{
id: "U3RvcDpIU0w6NjE2MDIxNg==",
lat: 60.182777,
lon: 24.391645
},
{
id: "U3RvcDpIU0w6NjE2MDIxMw==",
lat: 60.173892,
lon: 24.39646
},
{
id: "U3RvcDpIU0w6NjE2MDIxMg==",
lat: 60.170603,
lon: 24.395889
},
{
id: "U3RvcDpIU0w6NjE2MDIwOQ==",
lat: 60.163052,
lon: 24.394647
},
{
id: "U3RvcDpIU0w6NjE2MDIwNw==",
lat: 60.155722,
lon: 24.399178
},
{
id: "U3RvcDpIU0w6NjE2MDIwNQ==",
lat: 60.150224,
lon: 24.409713
},
{
id: "U3RvcDpIU0w6NjA0MDI1OQ==",
lat: 60.146813,
lon: 24.41485
},
{
id: "U3RvcDpIU0w6NjA0MDI1Mg==",
lat: 60.140684,
lon: 24.420613
},
{
id: "U3RvcDpIU0w6NjA0MDI0OA==",
lat: 60.136687,
lon: 24.421177
},
{
id: "U3RvcDpIU0w6NjA0MDI0NA==",
lat: 60.133633,
lon: 24.429907
},
{
id: "U3RvcDpIU0w6NjA0MDI0Ng==",
lat: 60.134168,
lon: 24.44247
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI5MA==",
lat: 60.120115,
lon: 24.441534
},
{
id: "U3RvcDpIU0w6NjE3MDIyNw==",
lat: 60.271035,
lon: 24.437315
},
{
id: "U3RvcDpIU0w6NjE3MDIwOQ==",
lat: 60.272774,
lon: 24.426463
},
{
id: "U3RvcDpIU0w6NjE3MDIxMQ==",
lat: 60.274747,
lon: 24.421215
},
{
id: "U3RvcDpIU0w6NjE3MDI3NQ==",
lat: 60.280038,
lon: 24.415989
},
{
id: "U3RvcDpIU0w6NjE3MDI3Nw==",
lat: 60.283003,
lon: 24.421107
},
{
id: "U3RvcDpIU0w6NjE3MDI3Mg==",
lat: 60.286008,
lon: 24.425179
},
{
id: "U3RvcDpIU0w6NjE3MDIzMw==",
lat: 60.28374,
lon: 24.432553
},
{
id: "U3RvcDpIU0w6NjE3MDI2Mw==",
lat: 60.286152,
lon: 24.44264
},
{
id: "U3RvcDpIU0w6NjE3MDI3OQ==",
lat: 60.289078,
lon: 24.445167
},
{
id: "U3RvcDpIU0w6NjE3MDI0OA==",
lat: 60.292442,
lon: 24.453521
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI0Nw==",
lat: 60.13445,
lon: 24.44258
},
{
id: "U3RvcDpIU0w6NjA0MDI0NQ==",
lat: 60.1336,
lon: 24.42814
},
{
id: "U3RvcDpIU0w6NjA0MDI0OQ==",
lat: 60.136717,
lon: 24.421545
},
{
id: "U3RvcDpIU0w6NjA0MDI1Mw==",
lat: 60.140893,
lon: 24.420647
},
{
id: "U3RvcDpIU0w6NjA0MDI1Ng==",
lat: 60.145755,
lon: 24.416028
},
{
id: "U3RvcDpIU0w6NjE2MDIwNg==",
lat: 60.151462,
lon: 24.409557
},
{
id: "U3RvcDpIU0w6NjE2MDIwOA==",
lat: 60.15624,
lon: 24.39875
},
{
id: "U3RvcDpIU0w6NjE2MDIxMA==",
lat: 60.163665,
lon: 24.39487
},
{
id: "U3RvcDpIU0w6NjE2MDIxMQ==",
lat: 60.170695,
lon: 24.396358
},
{
id: "U3RvcDpIU0w6NjE2MDIxNA==",
lat: 60.174283,
lon: 24.39658
},
{
id: "U3RvcDpIU0w6NjE2MDIxNw==",
lat: 60.18374,
lon: 24.392752
},
{
id: "U3RvcDpIU0w6NjE2MDIyMA==",
lat: 60.188759,
lon: 24.396284
},
{
id: "U3RvcDpIU0w6NjE2MDIwNA==",
lat: 60.197392,
lon: 24.384462
},
{
id: "U3RvcDpIU0w6NjE1MDIxMQ==",
lat: 60.19985,
lon: 24.378615
},
{
id: "U3RvcDpIU0w6NjE1MDIyMg==",
lat: 60.202258,
lon: 24.374953
},
{
id: "U3RvcDpIU0w6NjE1MDIyMQ==",
lat: 60.20219,
lon: 24.35642
},
{
id: "U3RvcDpIU0w6NjE1MDIxNw==",
lat: 60.20141,
lon: 24.342
},
{
id: "U3RvcDpIU0w6NjE1MDIxNg==",
lat: 60.20103,
lon: 24.33853
},
{
id: "U3RvcDpIU0w6NjE1MDIyNQ==",
lat: 60.212742,
lon: 24.341698
},
{
id: "U3RvcDpIU0w6NjE1MDIyNg==",
lat: 60.216378,
lon: 24.345947
},
{
id: "U3RvcDpIU0w6NjE1MDIyOA==",
lat: 60.220365,
lon: 24.357035
},
{
id: "U3RvcDpIU0w6NjE1MDI0MA==",
lat: 60.221885,
lon: 24.362633
},
{
id: "U3RvcDpIU0w6NjE1MDIzMA==",
lat: 60.225655,
lon: 24.369032
},
{
id: "U3RvcDpIU0w6NjE1MDI0MQ==",
lat: 60.225717,
lon: 24.376338
},
{
id: "U3RvcDpIU0w6NjE1MDIzMg==",
lat: 60.226347,
lon: 24.37974
},
{
id: "U3RvcDpIU0w6NjEzMDIwMg==",
lat: 60.227418,
lon: 24.387623
},
{
id: "U3RvcDpIU0w6NjEzMDIwNA==",
lat: 60.228745,
lon: 24.388292
},
{
id: "U3RvcDpIU0w6NjEzMDIzMA==",
lat: 60.2333,
lon: 24.3919
},
{
id: "U3RvcDpIU0w6NjEzMDIwNw==",
lat: 60.23575,
lon: 24.39796
},
{
id: "U3RvcDpIU0w6NjEzMDIwOA==",
lat: 60.238312,
lon: 24.395777
},
{
id: "U3RvcDpIU0w6NjEzMDIyNg==",
lat: 60.240357,
lon: 24.38128
},
{
id: "U3RvcDpIU0w6NjEzMDIxMQ==",
lat: 60.240567,
lon: 24.377775
},
{
id: "U3RvcDpIU0w6NjEzMDIxMw==",
lat: 60.243057,
lon: 24.377593
},
{
id: "U3RvcDpIU0w6NjEzMDIxNA==",
lat: 60.246205,
lon: 24.38223
},
{
id: "U3RvcDpIU0w6NjEzMDIxOA==",
lat: 60.252639,
lon: 24.3897
},
{
id: "U3RvcDpIU0w6NjEzMDIyMg==",
lat: 60.254055,
lon: 24.395457
},
{
id: "U3RvcDpIU0w6NjEzMDIyOA==",
lat: 60.25181,
lon: 24.402213
},
{
id: "U3RvcDpIU0w6NjEzMDIxNw==",
lat: 60.250195,
lon: 24.403348
},
{
id: "U3RvcDpIU0w6NjEzMDIxOQ==",
lat: 60.252602,
lon: 24.41368
},
{
id: "U3RvcDpIU0w6NjEyMDIyMQ==",
lat: 60.257858,
lon: 24.431903
},
{
id: "U3RvcDpIU0w6NjEyMDIwMg==",
lat: 60.25979,
lon: 24.432345
}
]
},
{
gtfsId: "HSL:6907",
shortName: "907",
longName: "Kirkkonummi-Veklahti-Lapinkylä-Veikkola",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE3MDIyOQ==",
lat: 60.27008,
lon: 24.444067
},
{
id: "U3RvcDpIU0w6NjE3MDI1Mg==",
lat: 60.273048,
lon: 24.438664
},
{
id: "U3RvcDpIU0w6NjE3MDI1NA==",
lat: 60.278095,
lon: 24.44017
},
{
id: "U3RvcDpIU0w6NjE3MDI1Mw==",
lat: 60.282103,
lon: 24.436873
},
{
id: "U3RvcDpIU0w6NjE3MDI0OQ==",
lat: 60.280491,
lon: 24.430717
},
{
id: "U3RvcDpIU0w6NjE3MDI0Nw==",
lat: 60.276531,
lon: 24.422193
},
{
id: "U3RvcDpIU0w6NjE3MDIxMA==",
lat: 60.273982,
lon: 24.422243
},
{
id: "U3RvcDpIU0w6NjE3MDIwOA==",
lat: 60.272485,
lon: 24.427072
},
{
id: "U3RvcDpIU0w6NjE3MDIyOA==",
lat: 60.27056,
lon: 24.439
},
{
id: "U3RvcDpIU0w6NjE3MDIwNg==",
lat: 60.269694,
lon: 24.444329
},
{
id: "U3RvcDpIU0w6NjE3MDIyNA==",
lat: 60.267322,
lon: 24.445708
},
{
id: "U3RvcDpIU0w6NjEyMDIxOA==",
lat: 60.25824,
lon: 24.447203
},
{
id: "U3RvcDpIU0w6NjEyMDIxNg==",
lat: 60.250706,
lon: 24.449823
},
{
id: "U3RvcDpIU0w6NjEyMDIxNQ==",
lat: 60.246252,
lon: 24.444307
},
{
id: "U3RvcDpIU0w6NjEyMDIxMg==",
lat: 60.242267,
lon: 24.452827
},
{
id: "U3RvcDpIU0w6NjEyMDIxMA==",
lat: 60.238305,
lon: 24.458798
},
{
id: "U3RvcDpIU0w6NjEyMDIwOA==",
lat: 60.23477,
lon: 24.458458
},
{
id: "U3RvcDpIU0w6NjE0MDI0NA==",
lat: 60.230252,
lon: 24.462577
},
{
id: "U3RvcDpIU0w6NjE0MDIzOA==",
lat: 60.224747,
lon: 24.464838
},
{
id: "U3RvcDpIU0w6NjE0MDIyNg==",
lat: 60.218712,
lon: 24.474507
},
{
id: "U3RvcDpIU0w6NjE0MDIyMA==",
lat: 60.21376,
lon: 24.484233
},
{
id: "U3RvcDpIU0w6NjE0MDIxNg==",
lat: 60.207477,
lon: 24.49102
},
{
id: "U3RvcDpIU0w6NjE0MDIxMg==",
lat: 60.205225,
lon: 24.497413
},
{
id: "U3RvcDpIU0w6NjE0MDI1Mg==",
lat: 60.203833,
lon: 24.501328
},
{
id: "U3RvcDpIU0w6NjE0MDI0OQ==",
lat: 60.202515,
lon: 24.49682
},
{
id: "U3RvcDpIU0w6NjE0MDI0Mg==",
lat: 60.19953,
lon: 24.4918
},
{
id: "U3RvcDpIU0w6NjE0MDI0MA==",
lat: 60.194935,
lon: 24.477863
},
{
id: "U3RvcDpIU0w6NjAxMDIxNw==",
lat: 60.188398,
lon: 24.462162
},
{
id: "U3RvcDpIU0w6NjAxMDIxNA==",
lat: 60.187038,
lon: 24.458358
},
{
id: "U3RvcDpIU0w6NjAxMDIyMA==",
lat: 60.180317,
lon: 24.459108
},
{
id: "U3RvcDpIU0w6NjAxMDIxMQ==",
lat: 60.17575,
lon: 24.460652
},
{
id: "U3RvcDpIU0w6NjAxMDIxMA==",
lat: 60.172493,
lon: 24.4582
},
{
id: "U3RvcDpIU0w6NjAxMDIwNw==",
lat: 60.167792,
lon: 24.458575
},
{
id: "U3RvcDpIU0w6NjAxMDIxOQ==",
lat: 60.163122,
lon: 24.470748
},
{
id: "U3RvcDpIU0w6NjAxMDIwNQ==",
lat: 60.159385,
lon: 24.477312
},
{
id: "U3RvcDpIU0w6NjAxMDIwNA==",
lat: 60.152962,
lon: 24.46776
},
{
id: "U3RvcDpIU0w6NjAxMDIyNQ==",
lat: 60.151545,
lon: 24.461282
},
{
id: "U3RvcDpIU0w6NjA0MDI1Nw==",
lat: 60.14608,
lon: 24.459687
},
{
id: "U3RvcDpIU0w6NjA0MDI1NQ==",
lat: 60.141587,
lon: 24.459577
},
{
id: "U3RvcDpIU0w6NjA0MDI1MA==",
lat: 60.136902,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI4OQ==",
lat: 60.119965,
lon: 24.441188
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI1MQ==",
lat: 60.137828,
lon: 24.447452
},
{
id: "U3RvcDpIU0w6NjA0MDI1NA==",
lat: 60.141452,
lon: 24.459705
},
{
id: "U3RvcDpIU0w6NjA0MDI1OA==",
lat: 60.14618,
lon: 24.459907
},
{
id: "U3RvcDpIU0w6NjAxMDIwMQ==",
lat: 60.150353,
lon: 24.460595
},
{
id: "U3RvcDpIU0w6NjAxMDIwMw==",
lat: 60.15286,
lon: 24.468175
},
{
id: "U3RvcDpIU0w6NjAxMDIwNg==",
lat: 60.159835,
lon: 24.477522
},
{
id: "U3RvcDpIU0w6NjAxMDIwMg==",
lat: 60.163337,
lon: 24.470142
},
{
id: "U3RvcDpIU0w6NjAxMDIyNA==",
lat: 60.165272,
lon: 24.465028
},
{
id: "U3RvcDpIU0w6NjAxMDIwOA==",
lat: 60.168615,
lon: 24.458743
},
{
id: "U3RvcDpIU0w6NjAxMDIwOQ==",
lat: 60.172357,
lon: 24.458517
},
{
id: "U3RvcDpIU0w6NjAxMDIxMg==",
lat: 60.176553,
lon: 24.460803
},
{
id: "U3RvcDpIU0w6NjAxMDIxMw==",
lat: 60.180033,
lon: 24.459578
},
{
id: "U3RvcDpIU0w6NjAxMDIyMQ==",
lat: 60.18357,
lon: 24.457835
},
{
id: "U3RvcDpIU0w6NjAxMDIyMw==",
lat: 60.187526,
lon: 24.458648
},
{
id: "U3RvcDpIU0w6NjAxMDIxNg==",
lat: 60.188302,
lon: 24.462273
},
{
id: "U3RvcDpIU0w6NjE0MDI0Ng==",
lat: 60.1949,
lon: 24.478328
},
{
id: "U3RvcDpIU0w6NjE0MDI1MQ==",
lat: 60.196122,
lon: 24.487017
},
{
id: "U3RvcDpIU0w6NjE0MDI0MQ==",
lat: 60.19904,
lon: 24.491792
},
{
id: "U3RvcDpIU0w6NjE0MDI1MA==",
lat: 60.202562,
lon: 24.497932
},
{
id: "U3RvcDpIU0w6NjE0MDIxNQ==",
lat: 60.20556,
lon: 24.496107
},
{
id: "U3RvcDpIU0w6NjE0MDIxNw==",
lat: 60.20775,
lon: 24.490838
},
{
id: "U3RvcDpIU0w6NjE0MDIyMQ==",
lat: 60.213307,
lon: 24.485165
},
{
id: "U3RvcDpIU0w6NjE0MDIyNw==",
lat: 60.21922,
lon: 24.474345
},
{
id: "U3RvcDpIU0w6NjE0MDIzOQ==",
lat: 60.225883,
lon: 24.464237
},
{
id: "U3RvcDpIU0w6NjE0MDI0NQ==",
lat: 60.230512,
lon: 24.46255
},
{
id: "U3RvcDpIU0w6NjEyMDIwOQ==",
lat: 60.23508,
lon: 24.458975
},
{
id: "U3RvcDpIU0w6NjEyMDIxMQ==",
lat: 60.23933,
lon: 24.458377
},
{
id: "U3RvcDpIU0w6NjEyMDIxMw==",
lat: 60.242155,
lon: 24.45414
},
{
id: "U3RvcDpIU0w6NjEyMDIxNA==",
lat: 60.247022,
lon: 24.44486
},
{
id: "U3RvcDpIU0w6NjEyMDIxNw==",
lat: 60.251363,
lon: 24.450832
},
{
id: "U3RvcDpIU0w6NjEyMDIxOQ==",
lat: 60.259165,
lon: 24.447645
},
{
id: "U3RvcDpIU0w6NjE3MDIyNg==",
lat: 60.267467,
lon: 24.446232
},
{
id: "U3RvcDpIU0w6NjE3MDIwNw==",
lat: 60.27008,
lon: 24.443606
},
{
id: "U3RvcDpIU0w6NjE3MDIzOA==",
lat: 60.269685,
lon: 24.4439
}
]
},
{
gtfsId: "HSL:2544",
shortName: "544",
longName: "Leppävaara-Nihtisilta-Soukka-Kivenlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMjI2MQ==",
lat: 60.21896,
lon: 24.816
},
{
id: "U3RvcDpIU0w6MjExMjI2Mw==",
lat: 60.21244,
lon: 24.81549
},
{
id: "U3RvcDpIU0w6MjI1MjIwNg==",
lat: 60.207086,
lon: 24.783914
},
{
id: "U3RvcDpIU0w6MjEzMTI1MQ==",
lat: 60.20632,
lon: 24.75354
},
{
id: "U3RvcDpIU0w6MjI0MTIwOQ==",
lat: 60.186993,
lon: 24.748073
},
{
id: "U3RvcDpIU0w6MjI0MTIwNw==",
lat: 60.18367,
lon: 24.748108
},
{
id: "U3RvcDpIU0w6MjMyMjIwOA==",
lat: 60.169298,
lon: 24.751937
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQ0MjIwOA==",
lat: 60.158034,
lon: 24.705641
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNA==",
lat: 60.157017,
lon: 24.703535
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNg==",
lat: 60.153001,
lon: 24.696816
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMA==",
lat: 60.15,
lon: 24.68924
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMg==",
lat: 60.14756,
lon: 24.68237
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNA==",
lat: 60.14542,
lon: 24.67975
},
{
id: "U3RvcDpIU0w6MjQxMjIyOA==",
lat: 60.143279,
lon: 24.672656
},
{
id: "U3RvcDpIU0w6MjQxMjIyNg==",
lat: 60.142484,
lon: 24.669383
},
{
id: "U3RvcDpIU0w6MjQxMjIyNA==",
lat: 60.14102,
lon: 24.66353
},
{
id: "U3RvcDpIU0w6MjQxMjIyMg==",
lat: 60.13979,
lon: 24.65859
},
{
id: "U3RvcDpIU0w6MjQxMTI2NA==",
lat: 60.14202,
lon: 24.65681
},
{
id: "U3RvcDpIU0w6MjQxMTIyMA==",
lat: 60.1451,
lon: 24.65533
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxNQ==",
lat: 60.15301,
lon: 24.63405
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxNDIxOQ==",
lat: 60.14549,
lon: 24.65467
},
{
id: "U3RvcDpIU0w6MjQxNDI2NQ==",
lat: 60.14119,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjQxMjIyMQ==",
lat: 60.13965,
lon: 24.65853
},
{
id: "U3RvcDpIU0w6MjQxMjIyMw==",
lat: 60.14108,
lon: 24.66475
},
{
id: "U3RvcDpIU0w6MjQxMjIyNQ==",
lat: 60.14215,
lon: 24.66883
},
{
id: "U3RvcDpIU0w6MjQxMjIyNw==",
lat: 60.143373,
lon: 24.673594
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNQ==",
lat: 60.14522,
lon: 24.67967
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMw==",
lat: 60.14759,
lon: 24.68258
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMQ==",
lat: 60.151014,
lon: 24.692223
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNw==",
lat: 60.153542,
lon: 24.698029
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNQ==",
lat: 60.157168,
lon: 24.704114
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMg==",
lat: 60.159978,
lon: 24.708063
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjMyMjIwMg==",
lat: 60.17119,
lon: 24.75461
},
{
id: "U3RvcDpIU0w6MjI0MTIwOA==",
lat: 60.18004,
lon: 24.75293
},
{
id: "U3RvcDpIU0w6MjI0MTIxMA==",
lat: 60.189,
lon: 24.748788
},
{
id: "U3RvcDpIU0w6MjI0MjIxMg==",
lat: 60.20552,
lon: 24.75889
},
{
id: "U3RvcDpIU0w6MjI1MjIwNQ==",
lat: 60.206778,
lon: 24.787551
},
{
id: "U3RvcDpIU0w6MjExODI2NA==",
lat: 60.21391,
lon: 24.81666
},
{
id: "U3RvcDpIU0w6MjExMjI2Mg==",
lat: 60.219276,
lon: 24.816951
}
]
},
{
gtfsId: "HSL:2543",
shortName: "543",
longName: "Leppävaara-Mankkaa-Olari-Soukka-Kivenlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIzMg==",
lat: 60.218907,
lon: 24.812232
},
{
id: "U3RvcDpIU0w6MjExMjIyOQ==",
lat: 60.21539,
lon: 24.81197
},
{
id: "U3RvcDpIU0w6MjExMjI2NQ==",
lat: 60.21187,
lon: 24.812591
},
{
id: "U3RvcDpIU0w6MjExMjI2Nw==",
lat: 60.20933,
lon: 24.80927
},
{
id: "U3RvcDpIU0w6MjExMjI2OQ==",
lat: 60.21001,
lon: 24.80458
},
{
id: "U3RvcDpIU0w6MjExMjIwOQ==",
lat: 60.209308,
lon: 24.797923
},
{
id: "U3RvcDpIU0w6MjEzMTIwNQ==",
lat: 60.20922,
lon: 24.79452
},
{
id: "U3RvcDpIU0w6MjEzMTIwMw==",
lat: 60.20864,
lon: 24.78493
},
{
id: "U3RvcDpIU0w6MjEzMTIwOQ==",
lat: 60.20761,
lon: 24.77583
},
{
id: "U3RvcDpIU0w6MjEzMTIxMQ==",
lat: 60.20852,
lon: 24.76843
},
{
id: "U3RvcDpIU0w6MjEzMTI2NA==",
lat: 60.2101,
lon: 24.76262
},
{
id: "U3RvcDpIU0w6MjEzMTI0Ng==",
lat: 60.20944,
lon: 24.75608
},
{
id: "U3RvcDpIU0w6MjEzMTI0OA==",
lat: 60.20843,
lon: 24.75262
},
{
id: "U3RvcDpIU0w6MjEzMTI1MA==",
lat: 60.207094,
lon: 24.752523
},
{
id: "U3RvcDpIU0w6MjI0MjIxMA==",
lat: 60.20325,
lon: 24.76069
},
{
id: "U3RvcDpIU0w6MjI0MjIwOA==",
lat: 60.19894,
lon: 24.76333
},
{
id: "U3RvcDpIU0w6MjI0MTIwNg==",
lat: 60.1964,
lon: 24.76588
},
{
id: "U3RvcDpIU0w6MjI0MTIyMQ==",
lat: 60.19409,
lon: 24.7685
},
{
id: "U3RvcDpIU0w6MjI0MTIyMA==",
lat: 60.19148,
lon: 24.7639
},
{
id: "U3RvcDpIU0w6MjI0MTIxOA==",
lat: 60.18935,
lon: 24.76079
},
{
id: "U3RvcDpIU0w6MjI0MTIxNg==",
lat: 60.18608,
lon: 24.75704
},
{
id: "U3RvcDpIU0w6MjI0MTIxNA==",
lat: 60.18257,
lon: 24.75339
},
{
id: "U3RvcDpIU0w6MjMzMTIwNQ==",
lat: 60.18102,
lon: 24.74392
},
{
id: "U3RvcDpIU0w6MjMyMjIzOQ==",
lat: 60.17763,
lon: 24.74183
},
{
id: "U3RvcDpIU0w6MjMyMjIzNA==",
lat: 60.17516,
lon: 24.7422
},
{
id: "U3RvcDpIU0w6MjMyMjIzNQ==",
lat: 60.17491,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjMyMjIzNw==",
lat: 60.17479,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjMyMzI0MA==",
lat: 60.17256,
lon: 24.72448
},
{
id: "U3RvcDpIU0w6MjMyMTIxNA==",
lat: 60.16958,
lon: 24.72385
},
{
id: "U3RvcDpIU0w6MjMyMTI0OQ==",
lat: 60.16642,
lon: 24.72741
},
{
id: "U3RvcDpIU0w6MjMyMzIxNA==",
lat: 60.16521,
lon: 24.72609
},
{
id: "U3RvcDpIU0w6MjMyMTIyMw==",
lat: 60.16259,
lon: 24.7208
},
{
id: "U3RvcDpIU0w6MjQzMjIxOA==",
lat: 60.16191,
lon: 24.70958
},
{
id: "U3RvcDpIU0w6MjQzMjI0MA==",
lat: 60.16211,
lon: 24.70565
},
{
id: "U3RvcDpIU0w6MjQzMjIwMw==",
lat: 60.16115,
lon: 24.70423
},
{
id: "U3RvcDpIU0w6MjQ0MjIzMA==",
lat: 60.1586,
lon: 24.70848
},
{
id: "U3RvcDpIU0w6MjQ0MjIzMg==",
lat: 60.15641,
lon: 24.71272
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMw==",
lat: 60.153083,
lon: 24.703151
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNg==",
lat: 60.153001,
lon: 24.696816
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMA==",
lat: 60.15,
lon: 24.68924
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMg==",
lat: 60.14756,
lon: 24.68237
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNA==",
lat: 60.14542,
lon: 24.67975
},
{
id: "U3RvcDpIU0w6MjQxMjIyOA==",
lat: 60.143279,
lon: 24.672656
},
{
id: "U3RvcDpIU0w6MjQxMjIyNg==",
lat: 60.142484,
lon: 24.669383
},
{
id: "U3RvcDpIU0w6MjQxMjIyNA==",
lat: 60.14102,
lon: 24.66353
},
{
id: "U3RvcDpIU0w6MjQxMjIyMg==",
lat: 60.13979,
lon: 24.65859
},
{
id: "U3RvcDpIU0w6MjQxMTI2NA==",
lat: 60.14202,
lon: 24.65681
},
{
id: "U3RvcDpIU0w6MjQxMTIyMA==",
lat: 60.1451,
lon: 24.65533
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjExMjI1OQ==",
lat: 60.21358,
lon: 24.81025
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxNQ==",
lat: 60.15301,
lon: 24.63405
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxNDIxOQ==",
lat: 60.14549,
lon: 24.65467
},
{
id: "U3RvcDpIU0w6MjQxNDI2NQ==",
lat: 60.14119,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjQxMjIyMQ==",
lat: 60.13965,
lon: 24.65853
},
{
id: "U3RvcDpIU0w6MjQxMjIyMw==",
lat: 60.14108,
lon: 24.66475
},
{
id: "U3RvcDpIU0w6MjQxMjIyNQ==",
lat: 60.14215,
lon: 24.66883
},
{
id: "U3RvcDpIU0w6MjQxMjIyNw==",
lat: 60.143373,
lon: 24.673594
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNQ==",
lat: 60.14522,
lon: 24.67967
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMw==",
lat: 60.14759,
lon: 24.68258
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMQ==",
lat: 60.151014,
lon: 24.692223
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMg==",
lat: 60.152988,
lon: 24.698956
},
{
id: "U3RvcDpIU0w6MjQ0MTIxNA==",
lat: 60.152772,
lon: 24.705127
},
{
id: "U3RvcDpIU0w6MjQ0MTIzMw==",
lat: 60.15368,
lon: 24.71046
},
{
id: "U3RvcDpIU0w6MjQ0MjIzMQ==",
lat: 60.15639,
lon: 24.71282
},
{
id: "U3RvcDpIU0w6MjQ0MjIzNQ==",
lat: 60.15879,
lon: 24.70867
},
{
id: "U3RvcDpIU0w6MjQzMjIxOQ==",
lat: 60.1618,
lon: 24.7053
},
{
id: "U3RvcDpIU0w6MjQzMjIxNw==",
lat: 60.16173,
lon: 24.71134
},
{
id: "U3RvcDpIU0w6MjMyMTIyMg==",
lat: 60.16315,
lon: 24.72314
},
{
id: "U3RvcDpIU0w6MjMyMTIxMg==",
lat: 60.16719,
lon: 24.72694
},
{
id: "U3RvcDpIU0w6MjMyMTIxMw==",
lat: 60.169217,
lon: 24.72457
},
{
id: "U3RvcDpIU0w6MjMyMzI0Nw==",
lat: 60.17271,
lon: 24.72739
},
{
id: "U3RvcDpIU0w6MjMyMjIzOA==",
lat: 60.17468,
lon: 24.73368
},
{
id: "U3RvcDpIU0w6MjMyMjIzNg==",
lat: 60.17473,
lon: 24.7386
},
{
id: "U3RvcDpIU0w6MjMyMjI0OA==",
lat: 60.17565,
lon: 24.74279
},
{
id: "U3RvcDpIU0w6MjMyMjI0MA==",
lat: 60.17783,
lon: 24.74201
},
{
id: "U3RvcDpIU0w6MjMzMTIwNA==",
lat: 60.18081,
lon: 24.74421
},
{
id: "U3RvcDpIU0w6MjI0MTI4MA==",
lat: 60.18329,
lon: 24.75372
},
{
id: "U3RvcDpIU0w6MjI0MTIxNQ==",
lat: 60.18637,
lon: 24.75837
},
{
id: "U3RvcDpIU0w6MjI0MTIxNw==",
lat: 60.18867,
lon: 24.76093
},
{
id: "U3RvcDpIU0w6MjI0MTIxOQ==",
lat: 60.19164,
lon: 24.76442
},
{
id: "U3RvcDpIU0w6MjI0MTIwMw==",
lat: 60.19464,
lon: 24.76877
},
{
id: "U3RvcDpIU0w6MjI0MTIwNQ==",
lat: 60.19723,
lon: 24.76565
},
{
id: "U3RvcDpIU0w6MjI0MjIwNw==",
lat: 60.20009,
lon: 24.76279
},
{
id: "U3RvcDpIU0w6MjI0MjIwOQ==",
lat: 60.20413,
lon: 24.75998
},
{
id: "U3RvcDpIU0w6MjEzMTI1Nw==",
lat: 60.207166,
lon: 24.75329
},
{
id: "U3RvcDpIU0w6MjEzMTI0OQ==",
lat: 60.208477,
lon: 24.7532
},
{
id: "U3RvcDpIU0w6MjEzMTI0Nw==",
lat: 60.20968,
lon: 24.75843
},
{
id: "U3RvcDpIU0w6MjEzMTI2NQ==",
lat: 60.21023,
lon: 24.76218
},
{
id: "U3RvcDpIU0w6MjEzMTIwNA==",
lat: 60.20862,
lon: 24.76675
},
{
id: "U3RvcDpIU0w6MjEzMTIwOA==",
lat: 60.20744,
lon: 24.77397
},
{
id: "U3RvcDpIU0w6MjEzMTIwMg==",
lat: 60.20844,
lon: 24.78725
},
{
id: "U3RvcDpIU0w6MjEzMTIwNg==",
lat: 60.209328,
lon: 24.79625
},
{
id: "U3RvcDpIU0w6MjExMjIyMg==",
lat: 60.21004,
lon: 24.80413
},
{
id: "U3RvcDpIU0w6MjExMjI2NA==",
lat: 60.21238,
lon: 24.81176
},
{
id: "U3RvcDpIU0w6MjExMjIzMQ==",
lat: 60.21428,
lon: 24.81122
},
{
id: "U3RvcDpIU0w6MjExMjIzMg==",
lat: 60.21643,
lon: 24.81222
},
{
id: "U3RvcDpIU0w6MjExMjI5Ng==",
lat: 60.21721,
lon: 24.81279
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:6909",
shortName: "909",
longName: "Veikkola-Lapinkylä-Kauhala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE0MDIyMQ==",
lat: 60.213307,
lon: 24.485165
},
{
id: "U3RvcDpIU0w6NjE0MDIyNw==",
lat: 60.21922,
lon: 24.474345
},
{
id: "U3RvcDpIU0w6NjE0MDIzNw==",
lat: 60.224522,
lon: 24.461307
},
{
id: "U3RvcDpIU0w6NjE0MDIzNQ==",
lat: 60.22338,
lon: 24.451053
},
{
id: "U3RvcDpIU0w6NjE0MDIzMw==",
lat: 60.222272,
lon: 24.446038
},
{
id: "U3RvcDpIU0w6NjE0MDIyOA==",
lat: 60.220593,
lon: 24.43757
},
{
id: "U3RvcDpIU0w6NjE0MDIyNQ==",
lat: 60.217792,
lon: 24.427582
},
{
id: "U3RvcDpIU0w6NjE0MDIyMg==",
lat: 60.214732,
lon: 24.423875
},
{
id: "U3RvcDpIU0w6NjE0MDIxOA==",
lat: 60.210465,
lon: 24.424472
},
{
id: "U3RvcDpIU0w6NjE0MDIxNA==",
lat: 60.205447,
lon: 24.418357
},
{
id: "U3RvcDpIU0w6NjE0MDIwNw==",
lat: 60.202955,
lon: 24.404218
},
{
id: "U3RvcDpIU0w6NjE1MDIyMw==",
lat: 60.202485,
lon: 24.392585
},
{
id: "U3RvcDpIU0w6NjE1MDIyMg==",
lat: 60.202258,
lon: 24.374953
},
{
id: "U3RvcDpIU0w6NjE1MDIyMQ==",
lat: 60.20219,
lon: 24.35642
},
{
id: "U3RvcDpIU0w6NjE1MDIxNw==",
lat: 60.20141,
lon: 24.342
},
{
id: "U3RvcDpIU0w6NjE1MDIxNg==",
lat: 60.20103,
lon: 24.33853
},
{
id: "U3RvcDpIU0w6NjE1MDIyNQ==",
lat: 60.212742,
lon: 24.341698
},
{
id: "U3RvcDpIU0w6NjE1MDIyNg==",
lat: 60.216378,
lon: 24.345947
},
{
id: "U3RvcDpIU0w6NjE1MDIyOA==",
lat: 60.220365,
lon: 24.357035
},
{
id: "U3RvcDpIU0w6NjE1MDI0MA==",
lat: 60.221885,
lon: 24.362633
},
{
id: "U3RvcDpIU0w6NjE1MDIzMA==",
lat: 60.225655,
lon: 24.369032
},
{
id: "U3RvcDpIU0w6NjE1MDI0MQ==",
lat: 60.225717,
lon: 24.376338
},
{
id: "U3RvcDpIU0w6NjE1MDIzMg==",
lat: 60.226347,
lon: 24.37974
},
{
id: "U3RvcDpIU0w6NjEzMDIwMg==",
lat: 60.227418,
lon: 24.387623
},
{
id: "U3RvcDpIU0w6NjEzMDIwNA==",
lat: 60.228745,
lon: 24.388292
},
{
id: "U3RvcDpIU0w6NjEzMDIzMA==",
lat: 60.2333,
lon: 24.3919
},
{
id: "U3RvcDpIU0w6NjEzMDIwNw==",
lat: 60.23575,
lon: 24.39796
},
{
id: "U3RvcDpIU0w6NjEzMDIwOA==",
lat: 60.238312,
lon: 24.395777
},
{
id: "U3RvcDpIU0w6NjEzMDIyNg==",
lat: 60.240357,
lon: 24.38128
},
{
id: "U3RvcDpIU0w6NjEzMDIxMQ==",
lat: 60.240567,
lon: 24.377775
},
{
id: "U3RvcDpIU0w6NjEzMDIxMw==",
lat: 60.243057,
lon: 24.377593
},
{
id: "U3RvcDpIU0w6NjEzMDIxNA==",
lat: 60.246205,
lon: 24.38223
},
{
id: "U3RvcDpIU0w6NjEzMDIxOA==",
lat: 60.252639,
lon: 24.3897
},
{
id: "U3RvcDpIU0w6NjEzMDIyMg==",
lat: 60.254055,
lon: 24.395457
},
{
id: "U3RvcDpIU0w6NjEzMDIyOA==",
lat: 60.25181,
lon: 24.402213
},
{
id: "U3RvcDpIU0w6NjEzMDIxNw==",
lat: 60.250195,
lon: 24.403348
},
{
id: "U3RvcDpIU0w6NjEzMDIxOQ==",
lat: 60.252602,
lon: 24.41368
},
{
id: "U3RvcDpIU0w6NjEyMDIyMQ==",
lat: 60.257858,
lon: 24.431903
},
{
id: "U3RvcDpIU0w6NjEyMDIwMg==",
lat: 60.25979,
lon: 24.432345
},
{
id: "U3RvcDpIU0w6NjE3MDIwNg==",
lat: 60.269694,
lon: 24.444329
},
{
id: "U3RvcDpIU0w6NjE3MDIwNw==",
lat: 60.27008,
lon: 24.443606
},
{
id: "U3RvcDpIU0w6NjE3MDI1Ng==",
lat: 60.269183,
lon: 24.439668
},
{
id: "U3RvcDpIU0w6NjEyMDIwMQ==",
lat: 60.259133,
lon: 24.432048
},
{
id: "U3RvcDpIU0w6NjEyMDIyMA==",
lat: 60.257151,
lon: 24.430902
},
{
id: "U3RvcDpIU0w6NjEzMDIyMQ==",
lat: 60.253238,
lon: 24.41394
},
{
id: "U3RvcDpIU0w6NjEzMDIxNg==",
lat: 60.250457,
lon: 24.404192
},
{
id: "U3RvcDpIU0w6NjEzMDIzMg==",
lat: 60.251832,
lon: 24.402355
},
{
id: "U3RvcDpIU0w6NjEzMDIyMw==",
lat: 60.254182,
lon: 24.395288
},
{
id: "U3RvcDpIU0w6NjEzMDIyMA==",
lat: 60.252648,
lon: 24.389433
},
{
id: "U3RvcDpIU0w6NjEzMDIxNQ==",
lat: 60.246065,
lon: 24.381863
},
{
id: "U3RvcDpIU0w6NjEzMDIxMg==",
lat: 60.243068,
lon: 24.37739
},
{
id: "U3RvcDpIU0w6NjEzMDIxMA==",
lat: 60.240475,
lon: 24.377232
},
{
id: "U3RvcDpIU0w6NjEzMDIzMQ==",
lat: 60.240348,
lon: 24.382908
},
{
id: "U3RvcDpIU0w6NjEzMDIwOQ==",
lat: 60.238818,
lon: 24.394375
},
{
id: "U3RvcDpIU0w6NjEzMDIwNg==",
lat: 60.23469,
lon: 24.39721
},
{
id: "U3RvcDpIU0w6NjEzMDIyOQ==",
lat: 60.233227,
lon: 24.39171
},
{
id: "U3RvcDpIU0w6NjEzMDIwNQ==",
lat: 60.22879,
lon: 24.388057
},
{
id: "U3RvcDpIU0w6NjEzMDIwMw==",
lat: 60.227233,
lon: 24.38722
},
{
id: "U3RvcDpIU0w6NjEzMDIwMQ==",
lat: 60.226572,
lon: 24.380312
},
{
id: "U3RvcDpIU0w6NjE1MDIzOQ==",
lat: 60.225725,
lon: 24.37596
},
{
id: "U3RvcDpIU0w6NjE1MDIzMQ==",
lat: 60.225908,
lon: 24.369537
},
{
id: "U3RvcDpIU0w6NjE1MDIzNw==",
lat: 60.222042,
lon: 24.36192
},
{
id: "U3RvcDpIU0w6NjE1MDIyOQ==",
lat: 60.220405,
lon: 24.356558
},
{
id: "U3RvcDpIU0w6NjE1MDIyNw==",
lat: 60.21642,
lon: 24.345717
},
{
id: "U3RvcDpIU0w6NjE1MDIyNA==",
lat: 60.211693,
lon: 24.341255
},
{
id: "U3RvcDpIU0w6NjE1MDIxNQ==",
lat: 60.200862,
lon: 24.338385
},
{
id: "U3RvcDpIU0w6NjE1MDIxNA==",
lat: 60.200958,
lon: 24.340765
},
{
id: "U3RvcDpIU0w6NjE1MDIxOQ==",
lat: 60.202282,
lon: 24.358088
},
{
id: "U3RvcDpIU0w6NjE1MDIzNg==",
lat: 60.202072,
lon: 24.376857
},
{
id: "U3RvcDpIU0w6NjE1MDIyMA==",
lat: 60.20238,
lon: 24.394094
},
{
id: "U3RvcDpIU0w6NjE0MDIwNg==",
lat: 60.20307,
lon: 24.40629
},
{
id: "U3RvcDpIU0w6NjE0MDIxMw==",
lat: 60.205567,
lon: 24.420224
},
{
id: "U3RvcDpIU0w6NjE0MDIxOQ==",
lat: 60.21153,
lon: 24.424558
},
{
id: "U3RvcDpIU0w6NjE0MDIyMw==",
lat: 60.215762,
lon: 24.42415
},
{
id: "U3RvcDpIU0w6NjE0MDIyNA==",
lat: 60.218112,
lon: 24.429767
},
{
id: "U3RvcDpIU0w6NjE0MDIyOQ==",
lat: 60.221122,
lon: 24.439463
},
{
id: "U3RvcDpIU0w6NjE0MDIzMg==",
lat: 60.221632,
lon: 24.444954
},
{
id: "U3RvcDpIU0w6NjE0MDIzNA==",
lat: 60.223211,
lon: 24.452488
},
{
id: "U3RvcDpIU0w6NjE0MDIzNg==",
lat: 60.223972,
lon: 24.45995
},
{
id: "U3RvcDpIU0w6NjE0MDIzOA==",
lat: 60.224747,
lon: 24.464838
},
{
id: "U3RvcDpIU0w6NjE0MDIyNg==",
lat: 60.218712,
lon: 24.474507
},
{
id: "U3RvcDpIU0w6NjE0MDIyMA==",
lat: 60.21376,
lon: 24.484233
}
]
},
{
gtfsId: "HSL:2542",
shortName: "542",
longName: "Soukka-Kivenlahti-Latokaski-Espoon keskus-Jorvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYzMTI2OQ==",
lat: 60.22126,
lon: 24.68531
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxNTIzMw==",
lat: 60.2023,
lon: 24.65257
},
{
id: "U3RvcDpIU0w6MjYxMTIzNQ==",
lat: 60.19896,
lon: 24.6548
},
{
id: "U3RvcDpIU0w6MjYxNTIzOQ==",
lat: 60.1952,
lon: 24.66358
},
{
id: "U3RvcDpIU0w6MjYxNTIxNg==",
lat: 60.18792,
lon: 24.66694
},
{
id: "U3RvcDpIU0w6MjQzMTI1Ng==",
lat: 60.18113,
lon: 24.67048
},
{
id: "U3RvcDpIU0w6MjQzMTI1OA==",
lat: 60.17977,
lon: 24.66513
},
{
id: "U3RvcDpIU0w6MjQzMTI2MA==",
lat: 60.17801,
lon: 24.66063
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mg==",
lat: 60.17662,
lon: 24.6562
},
{
id: "U3RvcDpIU0w6MjQzMTI1NA==",
lat: 60.17315,
lon: 24.65509
},
{
id: "U3RvcDpIU0w6MjQzNDIzMg==",
lat: 60.16725,
lon: 24.65983
},
{
id: "U3RvcDpIU0w6MjQyMTIxNg==",
lat: 60.16684,
lon: 24.65354
},
{
id: "U3RvcDpIU0w6MjQyMTIxNA==",
lat: 60.16474,
lon: 24.65108
},
{
id: "U3RvcDpIU0w6MjQyMTIyMA==",
lat: 60.16306,
lon: 24.64959
},
{
id: "U3RvcDpIU0w6MjQyMTIxMg==",
lat: 60.16095,
lon: 24.646428
},
{
id: "U3RvcDpIU0w6MjQyMTIxMA==",
lat: 60.155916,
lon: 24.643328
},
{
id: "U3RvcDpIU0w6MjQxMzIxOA==",
lat: 60.153422,
lon: 24.636179
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxNDIxOQ==",
lat: 60.14549,
lon: 24.65467
},
{
id: "U3RvcDpIU0w6MjQxNDI2NQ==",
lat: 60.14119,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjQxMjIyMQ==",
lat: 60.13965,
lon: 24.65853
},
{
id: "U3RvcDpIU0w6MjQxMjIyMw==",
lat: 60.14108,
lon: 24.66475
},
{
id: "U3RvcDpIU0w6MjQxMjIyNQ==",
lat: 60.14215,
lon: 24.66883
},
{
id: "U3RvcDpIU0w6MjQxMjIyOQ==",
lat: 60.141393,
lon: 24.67125
},
{
id: "U3RvcDpIU0w6MjQxMjIzMQ==",
lat: 60.13993,
lon: 24.67253
},
{
id: "U3RvcDpIU0w6MjQxMjIzMw==",
lat: 60.13789,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjQxMjIzNQ==",
lat: 60.13617,
lon: 24.67272
},
{
id: "U3RvcDpIU0w6MjQxMjIzOA==",
lat: 60.13528,
lon: 24.67033
},
{
id: "U3RvcDpIU0w6MjQxMjIzNg==",
lat: 60.13606,
lon: 24.67287
},
{
id: "U3RvcDpIU0w6MjQxMjIzNA==",
lat: 60.13805,
lon: 24.67337
},
{
id: "U3RvcDpIU0w6MjQxMjIzMg==",
lat: 60.14018,
lon: 24.6725
},
{
id: "U3RvcDpIU0w6MjQxMjIzMA==",
lat: 60.141527,
lon: 24.671379
},
{
id: "U3RvcDpIU0w6MjQxMjIyNg==",
lat: 60.142484,
lon: 24.669383
},
{
id: "U3RvcDpIU0w6MjQxMjIyNA==",
lat: 60.14102,
lon: 24.66353
},
{
id: "U3RvcDpIU0w6MjQxMjIyMg==",
lat: 60.13979,
lon: 24.65859
},
{
id: "U3RvcDpIU0w6MjQxMTI2NA==",
lat: 60.14202,
lon: 24.65681
},
{
id: "U3RvcDpIU0w6MjQxMTIyMA==",
lat: 60.1451,
lon: 24.65533
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxNw==",
lat: 60.15308,
lon: 24.635611
},
{
id: "U3RvcDpIU0w6MjQyMTIwOQ==",
lat: 60.156065,
lon: 24.643868
},
{
id: "U3RvcDpIU0w6MjQyMTIxMQ==",
lat: 60.16094,
lon: 24.64666
},
{
id: "U3RvcDpIU0w6MjQyMTIxOQ==",
lat: 60.16351,
lon: 24.65042
},
{
id: "U3RvcDpIU0w6MjQyMTIxMw==",
lat: 60.16537,
lon: 24.65168
},
{
id: "U3RvcDpIU0w6MjQzNDIxMQ==",
lat: 60.167192,
lon: 24.65716
},
{
id: "U3RvcDpIU0w6MjQzNDIzMQ==",
lat: 60.16823,
lon: 24.66082
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mw==",
lat: 60.17401,
lon: 24.65456
},
{
id: "U3RvcDpIU0w6MjQzMTI1MQ==",
lat: 60.17666,
lon: 24.65685
},
{
id: "U3RvcDpIU0w6MjQzMTI1Nw==",
lat: 60.17786,
lon: 24.66015
},
{
id: "U3RvcDpIU0w6MjQzMTI1NQ==",
lat: 60.17983,
lon: 24.66545
},
{
id: "U3RvcDpIU0w6MjQzMTIxMw==",
lat: 60.18185,
lon: 24.67064
},
{
id: "U3RvcDpIU0w6MjYxNTIxNQ==",
lat: 60.18836,
lon: 24.6668
},
{
id: "U3RvcDpIU0w6MjYxNTIzNg==",
lat: 60.19542,
lon: 24.66347
},
{
id: "U3RvcDpIU0w6MjYxMTIzNA==",
lat: 60.19898,
lon: 24.65519
},
{
id: "U3RvcDpIU0w6MjYxNTIzMA==",
lat: 60.20332,
lon: 24.65198
},
{
id: "U3RvcDpIU0w6MjYxMTI0OQ==",
lat: 60.2057,
lon: 24.65781
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMTIwNA==",
lat: 60.22248,
lon: 24.67796
}
]
},
{
gtfsId: "HSL:4722",
shortName: "722",
longName: "Rautatientori-Honkanummi-Havukoski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDc0MDIyNA==",
lat: 60.31925,
lon: 25.06135
},
{
id: "U3RvcDpIU0w6NDc0MDIxNA==",
lat: 60.32079,
lon: 25.06203
},
{
id: "U3RvcDpIU0w6NDc0MDIxNg==",
lat: 60.3233,
lon: 25.06344
},
{
id: "U3RvcDpIU0w6NDc0MDIxOA==",
lat: 60.32491,
lon: 25.06624
},
{
id: "U3RvcDpIU0w6NDc0MDIwMQ==",
lat: 60.32424,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNg==",
lat: 60.3177,
lon: 25.07508
},
{
id: "U3RvcDpIU0w6NDc0MDIwOA==",
lat: 60.31486,
lon: 25.07312
},
{
id: "U3RvcDpIU0w6NDc0MDIyNg==",
lat: 60.3143,
lon: 25.079
},
{
id: "U3RvcDpIU0w6NDY2MDIxOA==",
lat: 60.30876,
lon: 25.09437
},
{
id: "U3RvcDpIU0w6NDY2MDIxNg==",
lat: 60.30367,
lon: 25.09197
},
{
id: "U3RvcDpIU0w6NDY2MDIxNA==",
lat: 60.29914,
lon: 25.08635
},
{
id: "U3RvcDpIU0w6NDY2MDIyMg==",
lat: 60.29623,
lon: 25.08506
},
{
id: "U3RvcDpIU0w6NDY2MDIxMg==",
lat: 60.29411,
lon: 25.08373
},
{
id: "U3RvcDpIU0w6NDY2MDIxMA==",
lat: 60.28999,
lon: 25.08171
},
{
id: "U3RvcDpIU0w6NDY2MDIwOA==",
lat: 60.28666,
lon: 25.08042
},
{
id: "U3RvcDpIU0w6NDY0MDIxMQ==",
lat: 60.28169,
lon: 25.07941
},
{
id: "U3RvcDpIU0w6NDY0MDIxMw==",
lat: 60.27837,
lon: 25.07894
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDE4Mg==",
lat: 60.17098,
lon: 24.9427
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDY0MDIxMg==",
lat: 60.27986,
lon: 25.079974
},
{
id: "U3RvcDpIU0w6NDY0MDIwOA==",
lat: 60.2826,
lon: 25.07956
},
{
id: "U3RvcDpIU0w6NDY0MDIwNg==",
lat: 60.28606,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6NDY2MDIwNw==",
lat: 60.2879,
lon: 25.08108
},
{
id: "U3RvcDpIU0w6NDY2MDIwOQ==",
lat: 60.29043,
lon: 25.08209
},
{
id: "U3RvcDpIU0w6NDY2MDIxMQ==",
lat: 60.2948,
lon: 25.08456
},
{
id: "U3RvcDpIU0w6NDY2MDIyMw==",
lat: 60.29697,
lon: 25.08562
},
{
id: "U3RvcDpIU0w6NDY2MDIxMw==",
lat: 60.29971,
lon: 25.08719
},
{
id: "U3RvcDpIU0w6NDY2MDIxNQ==",
lat: 60.30463,
lon: 25.09342
},
{
id: "U3RvcDpIU0w6NDY2MDIyMA==",
lat: 60.30781,
lon: 25.09418
},
{
id: "U3RvcDpIU0w6NDY2MDIxNw==",
lat: 60.310227,
lon: 25.094326
},
{
id: "U3RvcDpIU0w6NDc0MDIyNQ==",
lat: 60.31448,
lon: 25.07788
},
{
id: "U3RvcDpIU0w6NDc0MDIwOQ==",
lat: 60.31549,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNw==",
lat: 60.31774,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIwMg==",
lat: 60.32423,
lon: 25.07576
},
{
id: "U3RvcDpIU0w6NDc0MDIxOQ==",
lat: 60.32487,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIzNQ==",
lat: 60.32494,
lon: 25.06439
},
{
id: "U3RvcDpIU0w6NDc0MDIxNw==",
lat: 60.32322,
lon: 25.06293
},
{
id: "U3RvcDpIU0w6NDc0MDIxNQ==",
lat: 60.32133,
lon: 25.06167
},
{
id: "U3RvcDpIU0w6NDc0MDIzMw==",
lat: 60.31833,
lon: 25.05958
}
]
},
{
gtfsId: "HSL:6902",
shortName: "902",
longName: "Pikkalan tehdas-Kirkkonummi-Porkkala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjA5MDIwMQ==",
lat: 59.987483,
lon: 24.430405
},
{
id: "U3RvcDpIU0w6NjA5MDIwMg==",
lat: 59.9922,
lon: 24.440759
},
{
id: "U3RvcDpIU0w6NjA5MDIzMg==",
lat: 59.998753,
lon: 24.449967
},
{
id: "U3RvcDpIU0w6NjA5MDI0Mg==",
lat: 60.00507,
lon: 24.453577
},
{
id: "U3RvcDpIU0w6NjA5MDI0NA==",
lat: 60.007402,
lon: 24.455442
},
{
id: "U3RvcDpIU0w6NjA5MDIzMw==",
lat: 60.009204,
lon: 24.454296
},
{
id: "U3RvcDpIU0w6NjA5MDI0Ng==",
lat: 60.009741,
lon: 24.457476
},
{
id: "U3RvcDpIU0w6NjA5MDI0OA==",
lat: 60.014973,
lon: 24.470458
},
{
id: "U3RvcDpIU0w6NjA5MDIzNA==",
lat: 60.0163,
lon: 24.47546
},
{
id: "U3RvcDpIU0w6NjA5MDIwNw==",
lat: 60.022503,
lon: 24.482725
},
{
id: "U3RvcDpIU0w6NjA5MDIwOA==",
lat: 60.030548,
lon: 24.484473
},
{
id: "U3RvcDpIU0w6NjA5MDI0MA==",
lat: 60.036238,
lon: 24.489898
},
{
id: "U3RvcDpIU0w6NjA5MDIzOA==",
lat: 60.039238,
lon: 24.492443
},
{
id: "U3RvcDpIU0w6NjA5MDIzNw==",
lat: 60.042203,
lon: 24.494565
},
{
id: "U3RvcDpIU0w6NjA5MDIxMQ==",
lat: 60.044468,
lon: 24.497257
},
{
id: "U3RvcDpIU0w6NjA5MDIxMw==",
lat: 60.048112,
lon: 24.503567
},
{
id: "U3RvcDpIU0w6NjA5MDIxNQ==",
lat: 60.052008,
lon: 24.503085
},
{
id: "U3RvcDpIU0w6NjA5MDIxNg==",
lat: 60.054248,
lon: 24.500235
},
{
id: "U3RvcDpIU0w6NjA5MDIxNw==",
lat: 60.058347,
lon: 24.495902
},
{
id: "U3RvcDpIU0w6NjA5MDIxOQ==",
lat: 60.063217,
lon: 24.494603
},
{
id: "U3RvcDpIU0w6NjA5MDIyMQ==",
lat: 60.070387,
lon: 24.496762
},
{
id: "U3RvcDpIU0w6NjA5MDIyNA==",
lat: 60.077937,
lon: 24.501228
},
{
id: "U3RvcDpIU0w6NjA5MDIyNQ==",
lat: 60.081038,
lon: 24.497378
},
{
id: "U3RvcDpIU0w6NjA5MDIyNw==",
lat: 60.085263,
lon: 24.500833
},
{
id: "U3RvcDpIU0w6NjA5MDIyOQ==",
lat: 60.091498,
lon: 24.502918
},
{
id: "U3RvcDpIU0w6NjA2MDIwMg==",
lat: 60.097985,
lon: 24.498815
},
{
id: "U3RvcDpIU0w6NjA2MDIwNQ==",
lat: 60.102485,
lon: 24.486728
},
{
id: "U3RvcDpIU0w6NjA2MDIwNw==",
lat: 60.106565,
lon: 24.479938
},
{
id: "U3RvcDpIU0w6NjA2MDIwOQ==",
lat: 60.11624,
lon: 24.4822
},
{
id: "U3RvcDpIU0w6NjA0MDIxNg==",
lat: 60.119052,
lon: 24.477277
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5NQ==",
lat: 60.119658,
lon: 24.441538
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDIzOA==",
lat: 60.125828,
lon: 24.433405
},
{
id: "U3RvcDpIU0w6NjA0MDIzNw==",
lat: 60.125218,
lon: 24.42728
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA1MDIxOQ==",
lat: 60.12335,
lon: 24.410108
},
{
id: "U3RvcDpIU0w6NjA1MDIxNQ==",
lat: 60.123878,
lon: 24.404211
},
{
id: "U3RvcDpIU0w6NjA1MDIxNA==",
lat: 60.123608,
lon: 24.39643
},
{
id: "U3RvcDpIU0w6NjA1MDIxMg==",
lat: 60.12206,
lon: 24.385388
},
{
id: "U3RvcDpIU0w6NjA1MDIxMA==",
lat: 60.121138,
lon: 24.376124
},
{
id: "U3RvcDpIU0w6NjA1MDIwOA==",
lat: 60.118412,
lon: 24.370543
},
{
id: "U3RvcDpIU0w6NjA1MDIwMw==",
lat: 60.105278,
lon: 24.369337
},
{
id: "U3RvcDpIU0w6NjA1MDIwMg==",
lat: 60.103433,
lon: 24.364292
},
{
id: "U3RvcDpIU0w6NjA3MDIyOQ==",
lat: 60.101495,
lon: 24.345007
},
{
id: "U3RvcDpIU0w6NjA3MDIzMA==",
lat: 60.097948,
lon: 24.342707
},
{
id: "U3RvcDpIU0w6NjA3MDIzMg==",
lat: 60.094845,
lon: 24.34585
},
{
id: "U3RvcDpIU0w6NjA3MDIzMQ==",
lat: 60.097233,
lon: 24.342965
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNw==",
lat: 60.118187,
lon: 24.37067
},
{
id: "U3RvcDpIU0w6NjA1MDIwOQ==",
lat: 60.121223,
lon: 24.377082
},
{
id: "U3RvcDpIU0w6NjA1MDIxMQ==",
lat: 60.121985,
lon: 24.386015
},
{
id: "U3RvcDpIU0w6NjA1MDIxMw==",
lat: 60.123857,
lon: 24.399738
},
{
id: "U3RvcDpIU0w6NjA0MDIzNQ==",
lat: 60.123883,
lon: 24.40556
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA0MDIzNg==",
lat: 60.124797,
lon: 24.426783
},
{
id: "U3RvcDpIU0w6NjA0MDIzOQ==",
lat: 60.126123,
lon: 24.435517
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI4Nw==",
lat: 60.119861,
lon: 24.441108
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA0MDIxMQ==",
lat: 60.1159,
lon: 24.4454
},
{
id: "U3RvcDpIU0w6NjA2MDIwOA==",
lat: 60.11543,
lon: 24.4815
},
{
id: "U3RvcDpIU0w6NjA2MDIwNg==",
lat: 60.105797,
lon: 24.4791
},
{
id: "U3RvcDpIU0w6NjA2MDIwNA==",
lat: 60.102107,
lon: 24.486558
},
{
id: "U3RvcDpIU0w6NjA2MDIwMw==",
lat: 60.098087,
lon: 24.497983
},
{
id: "U3RvcDpIU0w6NjA2MDIwMQ==",
lat: 60.092123,
lon: 24.501967
},
{
id: "U3RvcDpIU0w6NjA5MDIyOA==",
lat: 60.085615,
lon: 24.500817
},
{
id: "U3RvcDpIU0w6NjA5MDIyNg==",
lat: 60.08123,
lon: 24.496783
},
{
id: "U3RvcDpIU0w6NjA5MDIyMw==",
lat: 60.07712,
lon: 24.501165
},
{
id: "U3RvcDpIU0w6NjA5MDIyMg==",
lat: 60.071335,
lon: 24.495877
},
{
id: "U3RvcDpIU0w6NjA5MDIyMA==",
lat: 60.06357,
lon: 24.49424
},
{
id: "U3RvcDpIU0w6NjA5MDIxOA==",
lat: 60.05874,
lon: 24.494908
},
{
id: "U3RvcDpIU0w6NjA5MDIzMA==",
lat: 60.052577,
lon: 24.499713
},
{
id: "U3RvcDpIU0w6NjA5MDIxNA==",
lat: 60.04819,
lon: 24.503337
},
{
id: "U3RvcDpIU0w6NjA5MDIxMg==",
lat: 60.044835,
lon: 24.497432
},
{
id: "U3RvcDpIU0w6NjA5MDIxMA==",
lat: 60.042177,
lon: 24.494337
},
{
id: "U3RvcDpIU0w6NjA5MDIwOQ==",
lat: 60.03919,
lon: 24.492007
},
{
id: "U3RvcDpIU0w6NjA5MDIzOQ==",
lat: 60.036069,
lon: 24.489542
},
{
id: "U3RvcDpIU0w6NjA5MDI0MQ==",
lat: 60.030105,
lon: 24.483945
},
{
id: "U3RvcDpIU0w6NjA5MDIzMQ==",
lat: 60.02247,
lon: 24.482435
},
{
id: "U3RvcDpIU0w6NjA5MDIwNg==",
lat: 60.01759,
lon: 24.476402
},
{
id: "U3RvcDpIU0w6NjA5MDI0OQ==",
lat: 60.014982,
lon: 24.470494
},
{
id: "U3RvcDpIU0w6NjA5MDIwNQ==",
lat: 60.009071,
lon: 24.454008
},
{
id: "U3RvcDpIU0w6NjA5MDI0NQ==",
lat: 60.007047,
lon: 24.455363
},
{
id: "U3RvcDpIU0w6NjA5MDI0Mw==",
lat: 60.005103,
lon: 24.45333
},
{
id: "U3RvcDpIU0w6NjA5MDIwNA==",
lat: 59.998063,
lon: 24.448872
},
{
id: "U3RvcDpIU0w6NjA5MDIwMw==",
lat: 59.99222,
lon: 24.439738
}
]
},
{
gtfsId: "HSL:4723",
shortName: "723",
longName: "Koivukylän palvelulinja",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDc1MDIxNA==",
lat: 60.31573,
lon: 25.10179
},
{
id: "U3RvcDpIU0w6NDc1MDIxNg==",
lat: 60.31682,
lon: 25.10541
},
{
id: "U3RvcDpIU0w6NDc1MDIyMA==",
lat: 60.31855,
lon: 25.10905
},
{
id: "U3RvcDpIU0w6NDc1MDIwNw==",
lat: 60.32126,
lon: 25.11231
},
{
id: "U3RvcDpIU0w6NDc1MDIwNQ==",
lat: 60.3247,
lon: 25.10919
},
{
id: "U3RvcDpIU0w6NDc1MDI5OQ==",
lat: 60.32767,
lon: 25.10175
},
{
id: "U3RvcDpIU0w6NDc1MDIwMg==",
lat: 60.32803,
lon: 25.09629
},
{
id: "U3RvcDpIU0w6NDczMDIxMA==",
lat: 60.32863,
lon: 25.08983
},
{
id: "U3RvcDpIU0w6NDczMDIwOA==",
lat: 60.32929,
lon: 25.08625
},
{
id: "U3RvcDpIU0w6NDczMDIwNg==",
lat: 60.32987,
lon: 25.07899
},
{
id: "U3RvcDpIU0w6NDczMDIwMw==",
lat: 60.32993,
lon: 25.07233
},
{
id: "U3RvcDpIU0w6NDczMDI5Ng==",
lat: 60.32729,
lon: 25.07019
},
{
id: "U3RvcDpIU0w6NDc0MDIyMA==",
lat: 60.3254,
lon: 25.06896
},
{
id: "U3RvcDpIU0w6NDc0MDIwMQ==",
lat: 60.32424,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNg==",
lat: 60.3177,
lon: 25.07508
},
{
id: "U3RvcDpIU0w6NDc0MDIyMg==",
lat: 60.31541,
lon: 25.07132
},
{
id: "U3RvcDpIU0w6NDc0MDIyNw==",
lat: 60.31677,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIyNA==",
lat: 60.31925,
lon: 25.06135
},
{
id: "U3RvcDpIU0w6NDc0MDIzOA==",
lat: 60.319722,
lon: 25.059577
},
{
id: "U3RvcDpIU0w6NDc0MDIxNA==",
lat: 60.32079,
lon: 25.06203
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIxNg==",
lat: 60.33213,
lon: 25.06075
},
{
id: "U3RvcDpIU0w6NDcyMDIwOQ==",
lat: 60.33219,
lon: 25.06038
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNQ==",
lat: 60.32133,
lon: 25.06167
},
{
id: "U3RvcDpIU0w6NDc0MDIyMw==",
lat: 60.31843,
lon: 25.06179
},
{
id: "U3RvcDpIU0w6NDc0MDIwOQ==",
lat: 60.31549,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNw==",
lat: 60.31774,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIwMg==",
lat: 60.32423,
lon: 25.07576
},
{
id: "U3RvcDpIU0w6NDc0MDIyMQ==",
lat: 60.32587,
lon: 25.06965
},
{
id: "U3RvcDpIU0w6NDczMDIwNA==",
lat: 60.32786,
lon: 25.07084
},
{
id: "U3RvcDpIU0w6NDczMDIwMQ==",
lat: 60.33011,
lon: 25.0737
},
{
id: "U3RvcDpIU0w6NDczMDIwNQ==",
lat: 60.32981,
lon: 25.08057
},
{
id: "U3RvcDpIU0w6NDczMDIwNw==",
lat: 60.32951,
lon: 25.08499
},
{
id: "U3RvcDpIU0w6NDczMDIwOQ==",
lat: 60.32853,
lon: 25.08968
},
{
id: "U3RvcDpIU0w6NDc1MDIwMQ==",
lat: 60.3279,
lon: 25.09475
},
{
id: "U3RvcDpIU0w6NDc1MDIwMw==",
lat: 60.32736,
lon: 25.10289
},
{
id: "U3RvcDpIU0w6NDc1MDIwNA==",
lat: 60.32423,
lon: 25.10955
},
{
id: "U3RvcDpIU0w6NDc1MDIwNg==",
lat: 60.32138,
lon: 25.11206
},
{
id: "U3RvcDpIU0w6NDc1MDIyMQ==",
lat: 60.32045,
lon: 25.11164
},
{
id: "U3RvcDpIU0w6NDc1MDIxOQ==",
lat: 60.31804,
lon: 25.10727
},
{
id: "U3RvcDpIU0w6NDc1MDIxNQ==",
lat: 60.31645,
lon: 25.10366
}
]
},
{
gtfsId: "HSL:4724",
shortName: "724",
longName: "Rautatientori-Jokiniemi-Päiväkumpu",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDc1MDIxNw==",
lat: 60.31596,
lon: 25.10011
},
{
id: "U3RvcDpIU0w6NDc1MDIwOA==",
lat: 60.31848,
lon: 25.09669
},
{
id: "U3RvcDpIU0w6NDc1MDIxMA==",
lat: 60.3206,
lon: 25.09284
},
{
id: "U3RvcDpIU0w6NDc1MDIxMg==",
lat: 60.32134,
lon: 25.0874
},
{
id: "U3RvcDpIU0w6NDc0MDIzMA==",
lat: 60.32246,
lon: 25.08175
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNg==",
lat: 60.3177,
lon: 25.07508
},
{
id: "U3RvcDpIU0w6NDc0MDIyOQ==",
lat: 60.31447,
lon: 25.07107
},
{
id: "U3RvcDpIU0w6NDc0MDIxMQ==",
lat: 60.31012,
lon: 25.06898
},
{
id: "U3RvcDpIU0w6NDYyMDIxMg==",
lat: 60.30182,
lon: 25.0669
},
{
id: "U3RvcDpIU0w6NDYyMDI5OA==",
lat: 60.30035,
lon: 25.06244
},
{
id: "U3RvcDpIU0w6NDYyMDIxNw==",
lat: 60.29828,
lon: 25.055708
},
{
id: "U3RvcDpIU0w6NDYyMDIwNQ==",
lat: 60.29549,
lon: 25.0614
},
{
id: "U3RvcDpIU0w6NDY2MDI5OQ==",
lat: 60.29509,
lon: 25.06703
},
{
id: "U3RvcDpIU0w6NDY2MDIwMQ==",
lat: 60.29136,
lon: 25.07367
},
{
id: "U3RvcDpIU0w6NDY2MDI5Nw==",
lat: 60.2872,
lon: 25.072
},
{
id: "U3RvcDpIU0w6NDY0MDIyNQ==",
lat: 60.28286,
lon: 25.06756
},
{
id: "U3RvcDpIU0w6NDY0MDI5NQ==",
lat: 60.28049,
lon: 25.07192
},
{
id: "U3RvcDpIU0w6NDY0MDIxMw==",
lat: 60.27837,
lon: 25.07894
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDE4Mg==",
lat: 60.17098,
lon: 24.9427
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDY0MDI5MA==",
lat: 60.279277,
lon: 25.078762
},
{
id: "U3RvcDpIU0w6NDY0MDI5NA==",
lat: 60.28066,
lon: 25.07098
},
{
id: "U3RvcDpIU0w6NDY0MDIyNg==",
lat: 60.28304,
lon: 25.06759
},
{
id: "U3RvcDpIU0w6NDY2MDI5Ng==",
lat: 60.28518,
lon: 25.06884
},
{
id: "U3RvcDpIU0w6NDY2MDI5NA==",
lat: 60.28757,
lon: 25.07367
},
{
id: "U3RvcDpIU0w6NDY2MDIwNA==",
lat: 60.28978,
lon: 25.07599
},
{
id: "U3RvcDpIU0w6NDY2MDIwMg==",
lat: 60.29189,
lon: 25.07317
},
{
id: "U3RvcDpIU0w6NDY2MDI5OA==",
lat: 60.29531,
lon: 25.06689
},
{
id: "U3RvcDpIU0w6NDYyMDIwNg==",
lat: 60.29581,
lon: 25.05983
},
{
id: "U3RvcDpIU0w6NDYyMDI5OQ==",
lat: 60.30026,
lon: 25.06284
},
{
id: "U3RvcDpIU0w6NDYyMDIxMQ==",
lat: 60.30252,
lon: 25.06691
},
{
id: "U3RvcDpIU0w6NDc0MDIxMA==",
lat: 60.31052,
lon: 25.0695
},
{
id: "U3RvcDpIU0w6NDc0MDIxMg==",
lat: 60.31245,
lon: 25.07059
},
{
id: "U3RvcDpIU0w6NDc0MDIwOQ==",
lat: 60.31549,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNw==",
lat: 60.31774,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIzNA==",
lat: 60.32318,
lon: 25.07886
},
{
id: "U3RvcDpIU0w6NDc0MDIzMQ==",
lat: 60.32183,
lon: 25.08353
},
{
id: "U3RvcDpIU0w6NDc1MDIxMQ==",
lat: 60.32087,
lon: 25.08958
},
{
id: "U3RvcDpIU0w6NDc1MDIwOQ==",
lat: 60.31961,
lon: 25.09455
},
{
id: "U3RvcDpIU0w6NDc1MDIxMw==",
lat: 60.31788,
lon: 25.09712
},
{
id: "U3RvcDpIU0w6NDc1MDIyMg==",
lat: 60.31618,
lon: 25.09939
}
]
},
{
gtfsId: "HSL:6901",
shortName: "901",
longName: "Luoma-Masala-Jorvaksentie-Hirsala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjExMDIwMw==",
lat: 60.071335,
lon: 24.600077
},
{
id: "U3RvcDpIU0w6NjExMDIxOQ==",
lat: 60.078487,
lon: 24.59941
},
{
id: "U3RvcDpIU0w6NjExMDIwNA==",
lat: 60.089557,
lon: 24.588597
},
{
id: "U3RvcDpIU0w6NjExMDIyNA==",
lat: 60.093308,
lon: 24.58309
},
{
id: "U3RvcDpIU0w6NjExMDIxNg==",
lat: 60.094005,
lon: 24.575327
},
{
id: "U3RvcDpIU0w6NjExMDIwNg==",
lat: 60.095577,
lon: 24.5684
},
{
id: "U3RvcDpIU0w6NjExMDIyMA==",
lat: 60.099417,
lon: 24.565767
},
{
id: "U3RvcDpIU0w6NjExMDIwOQ==",
lat: 60.100827,
lon: 24.565322
},
{
id: "U3RvcDpIU0w6NjExMDIxMA==",
lat: 60.104822,
lon: 24.567557
},
{
id: "U3RvcDpIU0w6NjExMDIxMg==",
lat: 60.109715,
lon: 24.569682
},
{
id: "U3RvcDpIU0w6NjExMDIxNQ==",
lat: 60.115187,
lon: 24.552907
},
{
id: "U3RvcDpIU0w6NjAzMDIxMA==",
lat: 60.121708,
lon: 24.530325
},
{
id: "U3RvcDpIU0w6NjAzMDIxMg==",
lat: 60.124132,
lon: 24.520852
},
{
id: "U3RvcDpIU0w6NjAzMDIyOA==",
lat: 60.132833,
lon: 24.512607
},
{
id: "U3RvcDpIU0w6NjAzMDIwMQ==",
lat: 60.133472,
lon: 24.512763
},
{
id: "U3RvcDpIU0w6NjAzMDIzMg==",
lat: 60.13751,
lon: 24.537388
},
{
id: "U3RvcDpIU0w6NjAyMDI2MA==",
lat: 60.148067,
lon: 24.573078
},
{
id: "U3RvcDpIU0w6NjAyMDIwOA==",
lat: 60.149502,
lon: 24.564343
},
{
id: "U3RvcDpIU0w6NjAyMDIxNA==",
lat: 60.153555,
lon: 24.544262
},
{
id: "U3RvcDpIU0w6NjAyMDIxNg==",
lat: 60.154818,
lon: 24.531715
},
{
id: "U3RvcDpIU0w6NjAyMDIxNw==",
lat: 60.155497,
lon: 24.531227
},
{
id: "U3RvcDpIU0w6NjAyMDIyNA==",
lat: 60.1588,
lon: 24.536007
},
{
id: "U3RvcDpIU0w6NjAyMDIyOA==",
lat: 60.161683,
lon: 24.538822
},
{
id: "U3RvcDpIU0w6NjAyMDIzMQ==",
lat: 60.167277,
lon: 24.541513
},
{
id: "U3RvcDpIU0w6NjAyMDIzNQ==",
lat: 60.169593,
lon: 24.543572
},
{
id: "U3RvcDpIU0w6NjAyMDIzOA==",
lat: 60.171893,
lon: 24.547945
},
{
id: "U3RvcDpIU0w6NjAyMDI0NA==",
lat: 60.176757,
lon: 24.545682
},
{
id: "U3RvcDpIU0w6NjAyMDIzOQ==",
lat: 60.172823,
lon: 24.54828
},
{
id: "U3RvcDpIU0w6NjAyMDIzNA==",
lat: 60.16918,
lon: 24.54261
},
{
id: "U3RvcDpIU0w6NjAyMDIzMA==",
lat: 60.166542,
lon: 24.540887
},
{
id: "U3RvcDpIU0w6NjAyMDIyOQ==",
lat: 60.163035,
lon: 24.539265
},
{
id: "U3RvcDpIU0w6NjAyMDIyNw==",
lat: 60.159457,
lon: 24.536668
},
{
id: "U3RvcDpIU0w6NjAyMDIxOA==",
lat: 60.156095,
lon: 24.531702
},
{
id: "U3RvcDpIU0w6NjAyMDIxNQ==",
lat: 60.154503,
lon: 24.532388
},
{
id: "U3RvcDpIU0w6NjAyMDIxMw==",
lat: 60.15282,
lon: 24.545448
},
{
id: "U3RvcDpIU0w6NjAyMDIwNw==",
lat: 60.149187,
lon: 24.56578
},
{
id: "U3RvcDpIU0w6NjAyMDI1OQ==",
lat: 60.14789,
lon: 24.572755
},
{
id: "U3RvcDpIU0w6NjAyMDIwMg==",
lat: 60.147525,
lon: 24.572943
},
{
id: "U3RvcDpIU0w6NjAzMDIwNg==",
lat: 60.137865,
lon: 24.532207
},
{
id: "U3RvcDpIU0w6NjAzMDIxMw==",
lat: 60.131883,
lon: 24.513693
},
{
id: "U3RvcDpIU0w6NjAzMDIxMQ==",
lat: 60.124167,
lon: 24.51922
},
{
id: "U3RvcDpIU0w6NjAzMDIwOQ==",
lat: 60.121192,
lon: 24.5324
},
{
id: "U3RvcDpIU0w6NjExMDIxNA==",
lat: 60.115472,
lon: 24.551775
},
{
id: "U3RvcDpIU0w6NjExMDIxMw==",
lat: 60.110733,
lon: 24.568545
},
{
id: "U3RvcDpIU0w6NjExMDIxMQ==",
lat: 60.105242,
lon: 24.567665
},
{
id: "U3RvcDpIU0w6NjExMDIwOA==",
lat: 60.100745,
lon: 24.564475
},
{
id: "U3RvcDpIU0w6NjExMDIyMQ==",
lat: 60.099545,
lon: 24.565625
},
{
id: "U3RvcDpIU0w6NjExMDIwNw==",
lat: 60.09573,
lon: 24.567762
},
{
id: "U3RvcDpIU0w6NjExMDIyMg==",
lat: 60.093675,
lon: 24.571182
},
{
id: "U3RvcDpIU0w6NjExMDIxNw==",
lat: 60.094023,
lon: 24.574278
},
{
id: "U3RvcDpIU0w6NjExMDIyMw==",
lat: 60.093053,
lon: 24.583542
},
{
id: "U3RvcDpIU0w6NjExMDIwNQ==",
lat: 60.089933,
lon: 24.588155
},
{
id: "U3RvcDpIU0w6NjExMDIyNQ==",
lat: 60.082878,
lon: 24.589508
},
{
id: "U3RvcDpIU0w6NjExMDIxOA==",
lat: 60.077473,
lon: 24.60104
}
]
},
{
gtfsId: "HSL:2549",
shortName: "549",
longName: "Tapiola(M)-Mankkaa-Kauniainen-Jorvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYzMTI2OQ==",
lat: 60.22126,
lon: 24.68531
},
{
id: "U3RvcDpIU0w6MjYzMTIwMg==",
lat: 60.22336,
lon: 24.68962
},
{
id: "U3RvcDpIU0w6MjE1MjIyNw==",
lat: 60.2235,
lon: 24.69601
},
{
id: "U3RvcDpIU0w6MzE3MDIyNw==",
lat: 60.22372,
lon: 24.70727
},
{
id: "U3RvcDpIU0w6MzE3MDIyNg==",
lat: 60.2214,
lon: 24.71551
},
{
id: "U3RvcDpIU0w6MzE3MDIyNA==",
lat: 60.22025,
lon: 24.71118
},
{
id: "U3RvcDpIU0w6MzE3MDIxMw==",
lat: 60.21566,
lon: 24.71209
},
{
id: "U3RvcDpIU0w6MzE3MDIxMA==",
lat: 60.2139,
lon: 24.7169
},
{
id: "U3RvcDpIU0w6MzE3MDIwOQ==",
lat: 60.21369,
lon: 24.72097
},
{
id: "U3RvcDpIU0w6MzE3MDIwNw==",
lat: 60.21235,
lon: 24.72818
},
{
id: "U3RvcDpIU0w6MzE3MDI0MA==",
lat: 60.21083,
lon: 24.72933
},
{
id: "U3RvcDpIU0w6MzE3MDIzMQ==",
lat: 60.2096,
lon: 24.73197
},
{
id: "U3RvcDpIU0w6MjE2MTIwNw==",
lat: 60.20538,
lon: 24.73569
},
{
id: "U3RvcDpIU0w6MjI0MjIyOA==",
lat: 60.2029,
lon: 24.74207
},
{
id: "U3RvcDpIU0w6MjI0MjIzNA==",
lat: 60.20165,
lon: 24.74644
},
{
id: "U3RvcDpIU0w6MjI0MjIyNw==",
lat: 60.20167,
lon: 24.75002
},
{
id: "U3RvcDpIU0w6MjI0MjIzNw==",
lat: 60.19987,
lon: 24.75052
},
{
id: "U3RvcDpIU0w6MjI0MjIyNQ==",
lat: 60.19999,
lon: 24.75501
},
{
id: "U3RvcDpIU0w6MjI0MjIyMw==",
lat: 60.19947,
lon: 24.75976
},
{
id: "U3RvcDpIU0w6MjI0MjIwOA==",
lat: 60.19894,
lon: 24.76333
},
{
id: "U3RvcDpIU0w6MjI0MTIwNg==",
lat: 60.1964,
lon: 24.76588
},
{
id: "U3RvcDpIU0w6MjI0MTIwNA==",
lat: 60.19414,
lon: 24.76971
},
{
id: "U3RvcDpIU0w6MjI0MTIwMg==",
lat: 60.190816,
lon: 24.776774
},
{
id: "U3RvcDpIU0w6MjIxNTI1NQ==",
lat: 60.18678,
lon: 24.78434
},
{
id: "U3RvcDpIU0w6MjIxNTI1OQ==",
lat: 60.18295,
lon: 24.78943
},
{
id: "U3RvcDpIU0w6MjIxMjIxOQ==",
lat: 60.18154,
lon: 24.79584
},
{
id: "U3RvcDpIU0w6MjIxMjIxNw==",
lat: 60.17822,
lon: 24.79887
},
{
id: "U3RvcDpIU0w6MjIxMjIyMA==",
lat: 60.175457,
lon: 24.800368
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
},
{
id: "U3RvcDpIU0w6MjIxMTIyNA==",
lat: 60.175056,
lon: 24.804395
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMjIxNg==",
lat: 60.17928,
lon: 24.79851
},
{
id: "U3RvcDpIU0w6MjIxMjIxOA==",
lat: 60.18134,
lon: 24.79634
},
{
id: "U3RvcDpIU0w6MjIxNTI1Nw==",
lat: 60.18286,
lon: 24.79364
},
{
id: "U3RvcDpIU0w6MjIxNTI1Mw==",
lat: 60.1837,
lon: 24.78701
},
{
id: "U3RvcDpIU0w6MjIxNTI1NA==",
lat: 60.18768,
lon: 24.78284
},
{
id: "U3RvcDpIU0w6MjI0MTIwMQ==",
lat: 60.19135,
lon: 24.77608
},
{
id: "U3RvcDpIU0w6MjI0MTIwMw==",
lat: 60.19464,
lon: 24.76877
},
{
id: "U3RvcDpIU0w6MjI0MTIwNQ==",
lat: 60.19723,
lon: 24.76565
},
{
id: "U3RvcDpIU0w6MjI0MjIyMg==",
lat: 60.19948,
lon: 24.75985
},
{
id: "U3RvcDpIU0w6MjI0MjIyNA==",
lat: 60.20042,
lon: 24.75697
},
{
id: "U3RvcDpIU0w6MjI0MjIzNg==",
lat: 60.20011,
lon: 24.74988
},
{
id: "U3RvcDpIU0w6MjI0MjIyNg==",
lat: 60.20209,
lon: 24.74947
},
{
id: "U3RvcDpIU0w6MjI0MjIzNQ==",
lat: 60.20186,
lon: 24.74457
},
{
id: "U3RvcDpIU0w6MjE2MTIwNQ==",
lat: 60.20431,
lon: 24.73964
},
{
id: "U3RvcDpIU0w6MjE2MTIwNg==",
lat: 60.20545,
lon: 24.73604
},
{
id: "U3RvcDpIU0w6MzE3MDIzMA==",
lat: 60.20981,
lon: 24.73151
},
{
id: "U3RvcDpIU0w6MzE3MDIzOQ==",
lat: 60.21096,
lon: 24.72951
},
{
id: "U3RvcDpIU0w6MzE3MDI1Nw==",
lat: 60.21267,
lon: 24.72825
},
{
id: "U3RvcDpIU0w6MzE3MDIwOA==",
lat: 60.21381,
lon: 24.72083
},
{
id: "U3RvcDpIU0w6MzE3MDIxMQ==",
lat: 60.2143,
lon: 24.71582
},
{
id: "U3RvcDpIU0w6MzE3MDIxMg==",
lat: 60.21638,
lon: 24.71126
},
{
id: "U3RvcDpIU0w6MzE3MDIyMw==",
lat: 60.22007,
lon: 24.71116
},
{
id: "U3RvcDpIU0w6MzE3MDIyNQ==",
lat: 60.22209,
lon: 24.71463
},
{
id: "U3RvcDpIU0w6MjE1MjIyNg==",
lat: 60.22419,
lon: 24.70554
},
{
id: "U3RvcDpIU0w6MjE1MjIyOA==",
lat: 60.22358,
lon: 24.69408
},
{
id: "U3RvcDpIU0w6MjYzMTIwMQ==",
lat: 60.22342,
lon: 24.68808
}
]
},
{
gtfsId: "HSL:6903",
shortName: "903",
longName: "Kirkkonummi-Hila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjA0MDI4OA==",
lat: 60.119803,
lon: 24.441526
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA3MDI0Mw==",
lat: 60.115295,
lon: 24.444255
},
{
id: "U3RvcDpIU0w6NjA0MDIwNw==",
lat: 60.112248,
lon: 24.445382
},
{
id: "U3RvcDpIU0w6NjA0MDIwNQ==",
lat: 60.10854,
lon: 24.44222
},
{
id: "U3RvcDpIU0w6NjA4MDIxNw==",
lat: 60.089493,
lon: 24.457315
},
{
id: "U3RvcDpIU0w6NjA4MDIyNg==",
lat: 60.07995,
lon: 24.447652
},
{
id: "U3RvcDpIU0w6NjA4MDIzMw==",
lat: 60.077633,
lon: 24.445605
},
{
id: "U3RvcDpIU0w6NjA4MDIzMQ==",
lat: 60.069733,
lon: 24.440945
},
{
id: "U3RvcDpIU0w6NjA4MDIyNA==",
lat: 60.066498,
lon: 24.431138
},
{
id: "U3RvcDpIU0w6NjA4MDIyMg==",
lat: 60.060508,
lon: 24.424883
},
{
id: "U3RvcDpIU0w6NjA4MDIyOQ==",
lat: 60.051677,
lon: 24.416898
},
{
id: "U3RvcDpIU0w6NjA4MDIyOA==",
lat: 60.048772,
lon: 24.41683
},
{
id: "U3RvcDpIU0w6NjA4MDIyMA==",
lat: 60.04629,
lon: 24.415462
},
{
id: "U3RvcDpIU0w6NjA4MDIwMQ==",
lat: 60.040332,
lon: 24.415732
},
{
id: "U3RvcDpIU0w6NjA4MDIxOA==",
lat: 60.036183,
lon: 24.402558
},
{
id: "U3RvcDpIU0w6NjA4MDIxOQ==",
lat: 60.040103,
lon: 24.415452
},
{
id: "U3RvcDpIU0w6NjA4MDIyMQ==",
lat: 60.04626,
lon: 24.41565
},
{
id: "U3RvcDpIU0w6NjA4MDIyNw==",
lat: 60.049045,
lon: 24.417257
},
{
id: "U3RvcDpIU0w6NjA4MDIyMw==",
lat: 60.06042,
lon: 24.425005
},
{
id: "U3RvcDpIU0w6NjA4MDIxMQ==",
lat: 60.06665,
lon: 24.431917
},
{
id: "U3RvcDpIU0w6NjA4MDIzMA==",
lat: 60.069492,
lon: 24.440777
},
{
id: "U3RvcDpIU0w6NjA4MDIzMg==",
lat: 60.07481,
lon: 24.443197
},
{
id: "U3RvcDpIU0w6NjA4MDIyNQ==",
lat: 60.080037,
lon: 24.44822
},
{
id: "U3RvcDpIU0w6NjA4MDIxNg==",
lat: 60.088725,
lon: 24.457948
},
{
id: "U3RvcDpIU0w6NjA0MDIwNA==",
lat: 60.106515,
lon: 24.439315
},
{
id: "U3RvcDpIU0w6NjA0MDIwNg==",
lat: 60.109248,
lon: 24.44381
},
{
id: "U3RvcDpIU0w6NjA0MDIwOA==",
lat: 60.113168,
lon: 24.44543
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
}
]
},
{
gtfsId: "HSL:7953A",
shortName: "953A",
longName: "Kivistön asema - Luhtaanmäki ( - Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NTAwMDIyOQ==",
lat: 60.363695,
lon: 24.783214
},
{
id: "U3RvcDpIU0w6NDMxMDIxNQ==",
lat: 60.35648,
lon: 24.79697
},
{
id: "U3RvcDpIU0w6NDMxMDIxNw==",
lat: 60.35337,
lon: 24.8067
},
{
id: "U3RvcDpIU0w6NDMxMDIwNw==",
lat: 60.34856,
lon: 24.80956
},
{
id: "U3RvcDpIU0w6NDIyMDIwNQ==",
lat: 60.33948,
lon: 24.81517
},
{
id: "U3RvcDpIU0w6NDIyMDIyNg==",
lat: 60.33248,
lon: 24.81876
},
{
id: "U3RvcDpIU0w6NDIyMDIyNA==",
lat: 60.326475,
lon: 24.825953
},
{
id: "U3RvcDpIU0w6NDIyMDIyMg==",
lat: 60.321574,
lon: 24.832355
},
{
id: "U3RvcDpIU0w6NDIyMDIyMA==",
lat: 60.316123,
lon: 24.841106
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0NQ==",
lat: 60.314149,
lon: 24.844845
},
{
id: "U3RvcDpIU0w6NDIyMDIyMQ==",
lat: 60.31705,
lon: 24.83873
},
{
id: "U3RvcDpIU0w6NDIyMDIyMw==",
lat: 60.322198,
lon: 24.831557
},
{
id: "U3RvcDpIU0w6NDIyMDIyNQ==",
lat: 60.32778,
lon: 24.8256
},
{
id: "U3RvcDpIU0w6NDIyMDIyNw==",
lat: 60.333449,
lon: 24.81792
},
{
id: "U3RvcDpIU0w6NDIyMDIwNA==",
lat: 60.33848,
lon: 24.81626
},
{
id: "U3RvcDpIU0w6NDMxMDIwOA==",
lat: 60.34986,
lon: 24.80924
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
}
]
},
{
gtfsId: "HSL:1811K",
shortName: "811K",
longName: "Mellunmäki-Länsimäki-Rajakylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk1MDIwMw==",
lat: 60.250739,
lon: 25.089675
},
{
id: "U3RvcDpIU0w6NDk1MDIwNQ==",
lat: 60.249921,
lon: 25.096143
},
{
id: "U3RvcDpIU0w6NDk1MDIxNw==",
lat: 60.251986,
lon: 25.100115
},
{
id: "U3RvcDpIU0w6NDk1MDIxMg==",
lat: 60.250903,
lon: 25.1084
},
{
id: "U3RvcDpIU0w6NDkxMDIxOQ==",
lat: 60.250663,
lon: 25.113953
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIwMg==",
lat: 60.2434,
lon: 25.10626
},
{
id: "U3RvcDpIU0w6NDkxMDIyMw==",
lat: 60.245071,
lon: 25.108564
},
{
id: "U3RvcDpIU0w6NDkxMDIyNQ==",
lat: 60.246755,
lon: 25.110418
},
{
id: "U3RvcDpIU0w6NDkxMDIxMw==",
lat: 60.246658,
lon: 25.113593
},
{
id: "U3RvcDpIU0w6NDkxMDIyOA==",
lat: 60.244558,
lon: 25.116408
},
{
id: "U3RvcDpIU0w6NDkxMDIwOQ==",
lat: 60.242887,
lon: 25.1129
},
{
id: "U3RvcDpIU0w6NDkxMDIyNg==",
lat: 60.242125,
lon: 25.112356
},
{
id: "U3RvcDpIU0w6NDkxMDIyNA==",
lat: 60.242314,
lon: 25.1114
},
{
id: "U3RvcDpIU0w6NDkxMDIxOA==",
lat: 60.24234,
lon: 25.10881
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
}
]
},
{
gtfsId: "HSL:2582",
shortName: "582",
longName: "Espoon keskus-Juvanmalmi-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOQ==",
lat: 60.27787,
lon: 24.74963
},
{
id: "U3RvcDpIU0w6MjcxNTIxNQ==",
lat: 60.27398,
lon: 24.74953
},
{
id: "U3RvcDpIU0w6MjcxNTI0Nw==",
lat: 60.27007,
lon: 24.75398
},
{
id: "U3RvcDpIU0w6MjcxNTIxMA==",
lat: 60.26655,
lon: 24.74574
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMzIxOQ==",
lat: 60.26278,
lon: 24.73192
},
{
id: "U3RvcDpIU0w6MjcxMzIxNg==",
lat: 60.25885,
lon: 24.73459
},
{
id: "U3RvcDpIU0w6MjcxMzIwOA==",
lat: 60.25466,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjcxMzIwNg==",
lat: 60.25333,
lon: 24.73323
},
{
id: "U3RvcDpIU0w6MjcxMzIwNA==",
lat: 60.25327,
lon: 24.72461
},
{
id: "U3RvcDpIU0w6MjcxMzIwMg==",
lat: 60.25185,
lon: 24.7206
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI1OA==",
lat: 60.23912,
lon: 24.70695
},
{
id: "U3RvcDpIU0w6MjYzMjI1OQ==",
lat: 60.23785,
lon: 24.70422
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mg==",
lat: 60.23498,
lon: 24.70481
},
{
id: "U3RvcDpIU0w6MjYzMjI0MQ==",
lat: 60.23238,
lon: 24.69878
},
{
id: "U3RvcDpIU0w6MjYzMjIzOQ==",
lat: 60.23077,
lon: 24.69602
},
{
id: "U3RvcDpIU0w6MjYzMjIzNw==",
lat: 60.22856,
lon: 24.69157
},
{
id: "U3RvcDpIU0w6MjYzMjIzNQ==",
lat: 60.22592,
lon: 24.68556
},
{
id: "U3RvcDpIU0w6MjYzMjIzMw==",
lat: 60.22548,
lon: 24.68117
},
{
id: "U3RvcDpIU0w6MjYzMjI3Mw==",
lat: 60.22305,
lon: 24.67722
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
},
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMjIzMg==",
lat: 60.22308,
lon: 24.6774
},
{
id: "U3RvcDpIU0w6MjYzMjIzNA==",
lat: 60.22558,
lon: 24.68211
},
{
id: "U3RvcDpIU0w6MjYzMjIzNg==",
lat: 60.22601,
lon: 24.68628
},
{
id: "U3RvcDpIU0w6MjYzMjIzOA==",
lat: 60.229,
lon: 24.69282
},
{
id: "U3RvcDpIU0w6MjYzMjI0MA==",
lat: 60.23172,
lon: 24.69809
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mw==",
lat: 60.23605,
lon: 24.7054
},
{
id: "U3RvcDpIU0w6MjYzMjI2MA==",
lat: 60.23844,
lon: 24.70498
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjcxMzIwMQ==",
lat: 60.25237,
lon: 24.72199
},
{
id: "U3RvcDpIU0w6MjcxMzIwMw==",
lat: 60.25325,
lon: 24.72546
},
{
id: "U3RvcDpIU0w6MjcxMzIwNQ==",
lat: 60.25329,
lon: 24.73325
},
{
id: "U3RvcDpIU0w6MjcxMzIwNw==",
lat: 60.25473,
lon: 24.73674
},
{
id: "U3RvcDpIU0w6MjcxMzIxNw==",
lat: 60.25984,
lon: 24.73473
},
{
id: "U3RvcDpIU0w6MjcxMzIxOA==",
lat: 60.2639,
lon: 24.73096
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxOA==",
lat: 60.26626,
lon: 24.73717
},
{
id: "U3RvcDpIU0w6MjcxNTI5Mw==",
lat: 60.26702,
lon: 24.74761
},
{
id: "U3RvcDpIU0w6MjcxNTIxMw==",
lat: 60.27087,
lon: 24.75311
},
{
id: "U3RvcDpIU0w6MjcxNTIxNA==",
lat: 60.27323,
lon: 24.75052
},
{
id: "U3RvcDpIU0w6MjcxNTIwMg==",
lat: 60.275124,
lon: 24.749747
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
}
]
},
{
gtfsId: "HSL:4518",
shortName: "518",
longName: "Ilmala-Pasila-Kuninkaanmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTE3MTE1MA==",
lat: 60.2085,
lon: 24.91885
},
{
id: "U3RvcDpIU0w6MTE3MTEwNA==",
lat: 60.20791,
lon: 24.91521
},
{
id: "U3RvcDpIU0w6MTE3MTEyMQ==",
lat: 60.205915,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE3MTEyNw==",
lat: 60.20309,
lon: 24.91942
},
{
id: "U3RvcDpIU0w6MTE3MTEyNQ==",
lat: 60.20226,
lon: 24.92151
},
{
id: "U3RvcDpIU0w6MTE3MTEzMQ==",
lat: 60.20267,
lon: 24.92511
},
{
id: "U3RvcDpIU0w6MTE3MTE1OA==",
lat: 60.20111,
lon: 24.92664
},
{
id: "U3RvcDpIU0w6MTE3MzEwNA==",
lat: 60.1983,
lon: 24.937373
},
{
id: "U3RvcDpIU0w6MTIyMDEzMQ==",
lat: 60.196616,
lon: 24.94209
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDExMQ==",
lat: 60.20885,
lon: 24.94716
},
{
id: "U3RvcDpIU0w6MTI1MDExMw==",
lat: 60.21096,
lon: 24.95256
},
{
id: "U3RvcDpIU0w6MTI1MDExNQ==",
lat: 60.21249,
lon: 24.95648
},
{
id: "U3RvcDpIU0w6MTI0MDEwMQ==",
lat: 60.2149,
lon: 24.96463
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDIyNw==",
lat: 60.29097,
lon: 25.11945
},
{
id: "U3RvcDpIU0w6NDk2MDIyNQ==",
lat: 60.29152,
lon: 25.11378
},
{
id: "U3RvcDpIU0w6NDk2MDIyMw==",
lat: 60.29266,
lon: 25.1126
},
{
id: "U3RvcDpIU0w6NDk2MDIyMA==",
lat: 60.29456,
lon: 25.10822
},
{
id: "U3RvcDpIU0w6NDk2MDIzNQ==",
lat: 60.29629,
lon: 25.10753
},
{
id: "U3RvcDpIU0w6NDk2MDI5NQ==",
lat: 60.29711,
lon: 25.10977
},
{
id: "U3RvcDpIU0w6NDk2MDIxMg==",
lat: 60.29888,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk3MDIzMw==",
lat: 60.30091,
lon: 25.10537
},
{
id: "U3RvcDpIU0w6NDk3MDIzMg==",
lat: 60.30053,
lon: 25.10575
},
{
id: "U3RvcDpIU0w6NDk2MDIwNQ==",
lat: 60.29786,
lon: 25.10536
},
{
id: "U3RvcDpIU0w6NDk2MDI5NA==",
lat: 60.29714,
lon: 25.10963
},
{
id: "U3RvcDpIU0w6NDk2MDIzOA==",
lat: 60.29628,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk2MDIxOQ==",
lat: 60.29418,
lon: 25.10836
},
{
id: "U3RvcDpIU0w6NDk2MDIyMg==",
lat: 60.2927,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI2MDEwMg==",
lat: 60.21515,
lon: 24.96438
},
{
id: "U3RvcDpIU0w6MTI1MDExNg==",
lat: 60.21238,
lon: 24.95536
},
{
id: "U3RvcDpIU0w6MTI1MDExNA==",
lat: 60.21108,
lon: 24.95203
},
{
id: "U3RvcDpIU0w6MTI1MDExMg==",
lat: 60.20938,
lon: 24.94761
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTE3MzExMw==",
lat: 60.19669,
lon: 24.941768
},
{
id: "U3RvcDpIU0w6MTE3MzEyMw==",
lat: 60.198626,
lon: 24.937843
},
{
id: "U3RvcDpIU0w6MTE3MTE1NA==",
lat: 60.200915,
lon: 24.926832
},
{
id: "U3RvcDpIU0w6MTE3MTEzMA==",
lat: 60.20279,
lon: 24.92483
},
{
id: "U3RvcDpIU0w6MTE3MTEyNA==",
lat: 60.20241,
lon: 24.92193
},
{
id: "U3RvcDpIU0w6MTE3MTEyNg==",
lat: 60.203862,
lon: 24.918633
},
{
id: "U3RvcDpIU0w6MTE3MTE4MA==",
lat: 60.206258,
lon: 24.917854
},
{
id: "U3RvcDpIU0w6MTE3MTEwNQ==",
lat: 60.20793,
lon: 24.91536
},
{
id: "U3RvcDpIU0w6MTE3MTE1MQ==",
lat: 60.207833,
lon: 24.920638
}
]
},
{
gtfsId: "HSL:6913BK",
shortName: "913BK",
longName: "Karskog-Mastkärr",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMzAwOA==",
lat: 60.17316,
lon: 24.28346
},
{
id: "U3RvcDpIU0w6NjMwMzAwNA==",
lat: 60.190251,
lon: 24.269025
}
]
},
{
gtfsId: "HSL:2164A",
shortName: "164A",
longName: "Kamppi-Kivenlahti-Saunalahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQyMzIwOA==",
lat: 60.168583,
lon: 24.600373
},
{
id: "U3RvcDpIU0w6MjQyMzIyMg==",
lat: 60.169066,
lon: 24.605836
},
{
id: "U3RvcDpIU0w6MjQyMzIxNw==",
lat: 60.168516,
lon: 24.610189
},
{
id: "U3RvcDpIU0w6MjQyMzIxMw==",
lat: 60.16746,
lon: 24.616208
},
{
id: "U3RvcDpIU0w6MjQyMzIxMQ==",
lat: 60.165647,
lon: 24.61464
},
{
id: "U3RvcDpIU0w6MjQyMzIxNA==",
lat: 60.16214,
lon: 24.61326
},
{
id: "U3RvcDpIU0w6MjQyMzIyMA==",
lat: 60.15901,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxMQ==",
lat: 60.15326,
lon: 24.63371
},
{
id: "U3RvcDpIU0w6MjQxMzIxNw==",
lat: 60.15308,
lon: 24.635611
},
{
id: "U3RvcDpIU0w6MjQxMzIwNg==",
lat: 60.15445,
lon: 24.64661
},
{
id: "U3RvcDpIU0w6MjQxMTIwNA==",
lat: 60.15267,
lon: 24.65583
},
{
id: "U3RvcDpIU0w6MjQxMTIwMg==",
lat: 60.152095,
lon: 24.663769
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
},
{
id: "U3RvcDpIU0w6MTA0MDI4Mg==",
lat: 60.16885,
lon: 24.93109
},
{
id: "U3RvcDpIU0w6MTA0MDIzMQ==",
lat: 60.16622,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNA==",
lat: 60.16976,
lon: 24.8242
},
{
id: "U3RvcDpIU0w6MjIxMTI5MA==",
lat: 60.17025,
lon: 24.81115
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIwMQ==",
lat: 60.15214,
lon: 24.66269
},
{
id: "U3RvcDpIU0w6MjQxMTIwMw==",
lat: 60.15338,
lon: 24.65167
},
{
id: "U3RvcDpIU0w6MjQxMzIwNQ==",
lat: 60.1548,
lon: 24.6459
},
{
id: "U3RvcDpIU0w6MjQxMzIxOA==",
lat: 60.153422,
lon: 24.636179
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOA==",
lat: 60.15638,
lon: 24.63086
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6MjQyMzIxOQ==",
lat: 60.15906,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQyMzIxNQ==",
lat: 60.16269,
lon: 24.61315
},
{
id: "U3RvcDpIU0w6MjQyMzIxMA==",
lat: 60.165995,
lon: 24.615303
},
{
id: "U3RvcDpIU0w6MjQyMzIwNQ==",
lat: 60.16774,
lon: 24.61602
},
{
id: "U3RvcDpIU0w6MjQyMzIxNg==",
lat: 60.168817,
lon: 24.608176
},
{
id: "U3RvcDpIU0w6MjQyMzIxMg==",
lat: 60.169017,
lon: 24.602997
}
]
},
{
gtfsId: "HSL:2215",
shortName: "215",
longName: "Leppävaara-Jupperi-Lähderanta",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjE0MjIyNg==",
lat: 60.24146,
lon: 24.73949
},
{
id: "U3RvcDpIU0w6MjE0MTIwNQ==",
lat: 60.24064,
lon: 24.74186
},
{
id: "U3RvcDpIU0w6MjE0MTIwNw==",
lat: 60.24387,
lon: 24.7488
},
{
id: "U3RvcDpIU0w6MjE0MTI0OQ==",
lat: 60.24335,
lon: 24.75308
},
{
id: "U3RvcDpIU0w6MjE0MzI2OQ==",
lat: 60.24642,
lon: 24.75991
},
{
id: "U3RvcDpIU0w6MjE0MzI1MQ==",
lat: 60.248837,
lon: 24.768646
},
{
id: "U3RvcDpIU0w6MjE0MzIxNg==",
lat: 60.25233,
lon: 24.76977
},
{
id: "U3RvcDpIU0w6MjE0MzIwMg==",
lat: 60.252831,
lon: 24.774348
},
{
id: "U3RvcDpIU0w6MjE0MzIzMQ==",
lat: 60.24821,
lon: 24.77569
},
{
id: "U3RvcDpIU0w6MjE0MzIyOQ==",
lat: 60.24258,
lon: 24.77378
},
{
id: "U3RvcDpIU0w6MjE0MzIzMg==",
lat: 60.23858,
lon: 24.7725
},
{
id: "U3RvcDpIU0w6MjEzMzIyMg==",
lat: 60.23275,
lon: 24.77329
},
{
id: "U3RvcDpIU0w6MjEzMzIxOQ==",
lat: 60.22944,
lon: 24.77787
},
{
id: "U3RvcDpIU0w6MjEzMzIxMA==",
lat: 60.22674,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIxMQ==",
lat: 60.22155,
lon: 24.80653
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIyMw==",
lat: 60.2192,
lon: 24.812
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwOQ==",
lat: 60.22671,
lon: 24.77975
},
{
id: "U3RvcDpIU0w6MjEzMzI2MA==",
lat: 60.22871,
lon: 24.77909
},
{
id: "U3RvcDpIU0w6MjEzMzIyNw==",
lat: 60.230757,
lon: 24.776361
},
{
id: "U3RvcDpIU0w6MjEzMzIyMQ==",
lat: 60.23311,
lon: 24.77313
},
{
id: "U3RvcDpIU0w6MjE0MzIyOA==",
lat: 60.23866,
lon: 24.77274
},
{
id: "U3RvcDpIU0w6MjE0MzIzMA==",
lat: 60.24333,
lon: 24.77422
},
{
id: "U3RvcDpIU0w6MjE0MzIzNQ==",
lat: 60.2488,
lon: 24.77602
},
{
id: "U3RvcDpIU0w6MjE0MzIxNw==",
lat: 60.253227,
lon: 24.772518
},
{
id: "U3RvcDpIU0w6MjE0MzI3MA==",
lat: 60.25155,
lon: 24.76943
},
{
id: "U3RvcDpIU0w6MjE0MzI1MA==",
lat: 60.248162,
lon: 24.766659
},
{
id: "U3RvcDpIU0w6MjE0MzI3Mg==",
lat: 60.24594,
lon: 24.75867
},
{
id: "U3RvcDpIU0w6MjE0MTI0OA==",
lat: 60.24342,
lon: 24.75303
},
{
id: "U3RvcDpIU0w6MjE0MjIwOA==",
lat: 60.24338,
lon: 24.74724
},
{
id: "U3RvcDpIU0w6MjE0MjIwNg==",
lat: 60.2414,
lon: 24.74307
}
]
},
{
gtfsId: "HSL:2214",
shortName: "214",
longName: "Leppävaara-Karakallio-Rastaala-Jupperi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIyNA==",
lat: 60.2192,
lon: 24.81161
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwOQ==",
lat: 60.22671,
lon: 24.77975
},
{
id: "U3RvcDpIU0w6MjEzMzI2MA==",
lat: 60.22871,
lon: 24.77909
},
{
id: "U3RvcDpIU0w6MjEzMzIzNA==",
lat: 60.22965,
lon: 24.77683
},
{
id: "U3RvcDpIU0w6MjEzMzIxMQ==",
lat: 60.22934,
lon: 24.77365
},
{
id: "U3RvcDpIU0w6MjEzMzIxMw==",
lat: 60.22968,
lon: 24.76792
},
{
id: "U3RvcDpIU0w6MjEzMzIxNw==",
lat: 60.228,
lon: 24.76138
},
{
id: "U3RvcDpIU0w6MjEzMzIyMw==",
lat: 60.22812,
lon: 24.75623
},
{
id: "U3RvcDpIU0w6MjE0MTIxOQ==",
lat: 60.23245,
lon: 24.75243
},
{
id: "U3RvcDpIU0w6MjE0MTIxMA==",
lat: 60.233363,
lon: 24.753317
},
{
id: "U3RvcDpIU0w6MjE0MTIwMw==",
lat: 60.23631,
lon: 24.75944
},
{
id: "U3RvcDpIU0w6MjE0MTIxMw==",
lat: 60.237167,
lon: 24.762355
},
{
id: "U3RvcDpIU0w6MjE0MzIwMw==",
lat: 60.23822,
lon: 24.76948
},
{
id: "U3RvcDpIU0w6MjE0MzIwNQ==",
lat: 60.2409,
lon: 24.76494
},
{
id: "U3RvcDpIU0w6MjE0MzI1OQ==",
lat: 60.2433,
lon: 24.76714
},
{
id: "U3RvcDpIU0w6MjE0MzI2MQ==",
lat: 60.24662,
lon: 24.76946
},
{
id: "U3RvcDpIU0w6MjE0MzI1MQ==",
lat: 60.248837,
lon: 24.768646
},
{
id: "U3RvcDpIU0w6MjE0MzIxNg==",
lat: 60.25233,
lon: 24.76977
},
{
id: "U3RvcDpIU0w6MjE0MzI0Nw==",
lat: 60.253728,
lon: 24.77246
},
{
id: "U3RvcDpIU0w6MjE0MzI1Mw==",
lat: 60.25615,
lon: 24.766
},
{
id: "U3RvcDpIU0w6MjE0MzI1Ng==",
lat: 60.25832,
lon: 24.76474
},
{
id: "U3RvcDpIU0w6MjE0MzI1NA==",
lat: 60.25571,
lon: 24.76639
},
{
id: "U3RvcDpIU0w6MjE0MzI0Ng==",
lat: 60.25448,
lon: 24.77091
},
{
id: "U3RvcDpIU0w6MjE0MzIxNw==",
lat: 60.253227,
lon: 24.772518
},
{
id: "U3RvcDpIU0w6MjE0MzI3MA==",
lat: 60.25155,
lon: 24.76943
},
{
id: "U3RvcDpIU0w6MjE0MzI2Nw==",
lat: 60.24617,
lon: 24.76964
},
{
id: "U3RvcDpIU0w6MjE0MzI2NQ==",
lat: 60.24377,
lon: 24.76749
},
{
id: "U3RvcDpIU0w6MjE0MTIwNg==",
lat: 60.24121,
lon: 24.7645
},
{
id: "U3RvcDpIU0w6MjE0MTIzNA==",
lat: 60.23759,
lon: 24.76911
},
{
id: "U3RvcDpIU0w6MjE0MTIwOA==",
lat: 60.23726,
lon: 24.76284
},
{
id: "U3RvcDpIU0w6MjE0MTIwMg==",
lat: 60.23643,
lon: 24.75938
},
{
id: "U3RvcDpIU0w6MjE0MTIwOQ==",
lat: 60.233593,
lon: 24.753527
},
{
id: "U3RvcDpIU0w6MjE0MTIyMA==",
lat: 60.23188,
lon: 24.75277
},
{
id: "U3RvcDpIU0w6MjEzMzIxNg==",
lat: 60.228636,
lon: 24.764329
},
{
id: "U3RvcDpIU0w6MjEzMzIxNA==",
lat: 60.22959,
lon: 24.76923
},
{
id: "U3RvcDpIU0w6MjEzMzIxMg==",
lat: 60.22916,
lon: 24.77474
},
{
id: "U3RvcDpIU0w6MjEzMzIxOQ==",
lat: 60.22944,
lon: 24.77787
},
{
id: "U3RvcDpIU0w6MjEzMzIxMA==",
lat: 60.22674,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIxMQ==",
lat: 60.22155,
lon: 24.80653
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:2213",
shortName: "213",
longName: "Kamppi-Meilahti-Suvela-Espoon keskus-Kauklahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI3OQ==",
lat: 60.16892,
lon: 24.93137
},
{
id: "U3RvcDpIU0w6MTEzMDExMQ==",
lat: 60.17419,
lon: 24.93349
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE1MDExNg==",
lat: 60.191346,
lon: 24.906254
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MjI1MjIwMg==",
lat: 60.208897,
lon: 24.812408
},
{
id: "U3RvcDpIU0w6MjI1MjIwNg==",
lat: 60.207086,
lon: 24.783914
},
{
id: "U3RvcDpIU0w6MjEzMTI1MQ==",
lat: 60.20632,
lon: 24.75354
},
{
id: "U3RvcDpIU0w6Mjk4ODIwOA==",
lat: 60.20723,
lon: 24.69643
},
{
id: "U3RvcDpIU0w6MjYxMjI2Ng==",
lat: 60.20617,
lon: 24.68758
},
{
id: "U3RvcDpIU0w6MjYxMzI3NA==",
lat: 60.20577,
lon: 24.68168
},
{
id: "U3RvcDpIU0w6MjYxMzI3MQ==",
lat: 60.20622,
lon: 24.67345
},
{
id: "U3RvcDpIU0w6MjYxMzIxNw==",
lat: 60.20508,
lon: 24.67367
},
{
id: "U3RvcDpIU0w6MjYxMzIxNQ==",
lat: 60.20246,
lon: 24.66925
},
{
id: "U3RvcDpIU0w6MjYxMzAwMA==",
lat: 60.201,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxNTIzMA==",
lat: 60.20332,
lon: 24.65198
},
{
id: "U3RvcDpIU0w6MjYxMTI0OQ==",
lat: 60.2057,
lon: 24.65781
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYyMTIyMg==",
lat: 60.21448,
lon: 24.65221
},
{
id: "U3RvcDpIU0w6MjYyMTIwNA==",
lat: 60.21482,
lon: 24.64804
},
{
id: "U3RvcDpIU0w6MjYyMTIwNg==",
lat: 60.21173,
lon: 24.64243
},
{
id: "U3RvcDpIU0w6MjYyMTIwMg==",
lat: 60.20934,
lon: 24.64173
},
{
id: "U3RvcDpIU0w6MjYyMTIxNQ==",
lat: 60.20776,
lon: 24.64132
},
{
id: "U3RvcDpIU0w6MjYyMTIxNg==",
lat: 60.20645,
lon: 24.63912
},
{
id: "U3RvcDpIU0w6MjYyMTIwOQ==",
lat: 60.20362,
lon: 24.63538
},
{
id: "U3RvcDpIU0w6MjYyMTIxOQ==",
lat: 60.20235,
lon: 24.63106
},
{
id: "U3RvcDpIU0w6MjYyMTIxMQ==",
lat: 60.20018,
lon: 24.62665
},
{
id: "U3RvcDpIU0w6MjUxMTIwMQ==",
lat: 60.19825,
lon: 24.62125
},
{
id: "U3RvcDpIU0w6MjUxMTI0MQ==",
lat: 60.19602,
lon: 24.61495
},
{
id: "U3RvcDpIU0w6MjUxMTIwMw==",
lat: 60.193139,
lon: 24.609917
},
{
id: "U3RvcDpIU0w6MjUxMTIwNQ==",
lat: 60.192161,
lon: 24.607148
},
{
id: "U3RvcDpIU0w6MjUxMTIzNQ==",
lat: 60.190312,
lon: 24.601027
},
{
id: "U3RvcDpIU0w6MjUxMTIzNg==",
lat: 60.190499,
lon: 24.601866
},
{
id: "U3RvcDpIU0w6MjUxMTIwNg==",
lat: 60.192167,
lon: 24.60752
},
{
id: "U3RvcDpIU0w6MjUxMTIwNA==",
lat: 60.193368,
lon: 24.610889
},
{
id: "U3RvcDpIU0w6MjUxMTI0Mg==",
lat: 60.19635,
lon: 24.61609
},
{
id: "U3RvcDpIU0w6MjUxMTIwMg==",
lat: 60.19834,
lon: 24.62217
},
{
id: "U3RvcDpIU0w6MjYyMTIxMg==",
lat: 60.19974,
lon: 24.62609
},
{
id: "U3RvcDpIU0w6MjYyMTIxOA==",
lat: 60.20277,
lon: 24.63325
},
{
id: "U3RvcDpIU0w6MjYyMTIxMA==",
lat: 60.20425,
lon: 24.63749
},
{
id: "U3RvcDpIU0w6MjYyMTIwOA==",
lat: 60.20759,
lon: 24.64111
},
{
id: "U3RvcDpIU0w6MjYyMTIwMw==",
lat: 60.208636,
lon: 24.642381
},
{
id: "U3RvcDpIU0w6MjYyMTIwNw==",
lat: 60.21239,
lon: 24.64336
},
{
id: "U3RvcDpIU0w6MjYyMTIwNQ==",
lat: 60.21468,
lon: 24.64968
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMzAwOA==",
lat: 60.202736,
lon: 24.661962
},
{
id: "U3RvcDpIU0w6MjYxMzAwMQ==",
lat: 60.20123,
lon: 24.6671
},
{
id: "U3RvcDpIU0w6MjYxMzIxNg==",
lat: 60.2028,
lon: 24.67021
},
{
id: "U3RvcDpIU0w6MjYxMzIxOA==",
lat: 60.20462,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjYxMzI3Mw==",
lat: 60.20667,
lon: 24.67446
},
{
id: "U3RvcDpIU0w6MjYxMzI3NQ==",
lat: 60.20559,
lon: 24.68208
},
{
id: "U3RvcDpIU0w6MjYxMjI2OQ==",
lat: 60.2063,
lon: 24.68963
},
{
id: "U3RvcDpIU0w6MjI0MjIxMg==",
lat: 60.20552,
lon: 24.75889
},
{
id: "U3RvcDpIU0w6MjI1MjIwNQ==",
lat: 60.206778,
lon: 24.787551
},
{
id: "U3RvcDpIU0w6MjEyMjIwMQ==",
lat: 60.20835,
lon: 24.81254
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyMg==",
lat: 60.196005,
lon: 24.886202
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExOA==",
lat: 60.19113,
lon: 24.90804
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTEzMDExMw==",
lat: 60.170862,
lon: 24.930898
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
}
]
},
{
gtfsId: "HSL:1812B",
shortName: "812B",
longName: "Mellunmäki-Myllypuro",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1NDE5Mg==",
lat: 60.220467,
lon: 25.064765
},
{
id: "U3RvcDpIU0w6MTQ1NDE1MA==",
lat: 60.22192,
lon: 25.05795
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OA==",
lat: 60.22447,
lon: 25.05881
},
{
id: "U3RvcDpIU0w6MTQ1NDEwNg==",
lat: 60.224853,
lon: 25.063299
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Ng==",
lat: 60.22731,
lon: 25.06406
},
{
id: "U3RvcDpIU0w6MTQ1NDEwNw==",
lat: 60.223948,
lon: 25.067693
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NA==",
lat: 60.22739,
lon: 25.07177
},
{
id: "U3RvcDpIU0w6MTQ1NDExMA==",
lat: 60.225633,
lon: 25.077135
},
{
id: "U3RvcDpIU0w6MTQ1NDEzOA==",
lat: 60.225707,
lon: 25.076062
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MQ==",
lat: 60.2236,
lon: 25.07608
},
{
id: "U3RvcDpIU0w6MTQ1NDEwOQ==",
lat: 60.222925,
lon: 25.069883
},
{
id: "U3RvcDpIU0w6MTQ1NDExNQ==",
lat: 60.223549,
lon: 25.082989
},
{
id: "U3RvcDpIU0w6MTQ3MTE2NA==",
lat: 60.225494,
lon: 25.083088
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMw==",
lat: 60.22723,
lon: 25.08458
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNQ==",
lat: 60.22981,
lon: 25.08912
},
{
id: "U3RvcDpIU0w6MTQ3MTExMQ==",
lat: 60.232415,
lon: 25.088397
},
{
id: "U3RvcDpIU0w6MTQ3MTE2MQ==",
lat: 60.23459,
lon: 25.086745
},
{
id: "U3RvcDpIU0w6MTQ3MTExMg==",
lat: 60.232783,
lon: 25.088534
},
{
id: "U3RvcDpIU0w6MTQ3MTE1OA==",
lat: 60.23084,
lon: 25.08527
},
{
id: "U3RvcDpIU0w6MTQ3MTE4NQ==",
lat: 60.2317,
lon: 25.08121
},
{
id: "U3RvcDpIU0w6MTQ3MTE5MQ==",
lat: 60.23008,
lon: 25.0777
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NQ==",
lat: 60.22913,
lon: 25.074
},
{
id: "U3RvcDpIU0w6MTQ3MTE3MQ==",
lat: 60.23145,
lon: 25.07625
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mw==",
lat: 60.23353,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNw==",
lat: 60.235733,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6MTQ3MTExOA==",
lat: 60.23638,
lon: 25.08713
},
{
id: "U3RvcDpIU0w6MTQ3MTEwNQ==",
lat: 60.23883,
lon: 25.084705
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mw==",
lat: 60.237977,
lon: 25.08401
},
{
id: "U3RvcDpIU0w6MTQ3MTEwNg==",
lat: 60.238799,
lon: 25.084924
},
{
id: "U3RvcDpIU0w6MTQ3MTE0OQ==",
lat: 60.23947,
lon: 25.0862
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MQ==",
lat: 60.24156,
lon: 25.08644
},
{
id: "U3RvcDpIU0w6MTQ3MTEwOA==",
lat: 60.243585,
lon: 25.08584
},
{
id: "U3RvcDpIU0w6MTQ3MjE1Mw==",
lat: 60.243574,
lon: 25.088205
},
{
id: "U3RvcDpIU0w6MTQ3MjEwNg==",
lat: 60.2441,
lon: 25.092507
},
{
id: "U3RvcDpIU0w6MTQ3MjEwOA==",
lat: 60.242326,
lon: 25.100387
},
{
id: "U3RvcDpIU0w6MTQ3MjEwNA==",
lat: 60.24155,
lon: 25.102138
},
{
id: "U3RvcDpIU0w6MTQ3MjExMA==",
lat: 60.240835,
lon: 25.100391
},
{
id: "U3RvcDpIU0w6MTQ3MjEwMA==",
lat: 60.23998,
lon: 25.102835
},
{
id: "U3RvcDpIU0w6MTQ3MzExOA==",
lat: 60.23811,
lon: 25.10922
},
{
id: "U3RvcDpIU0w6MTQ3MzEyNA==",
lat: 60.238533,
lon: 25.113694
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOA==",
lat: 60.23681,
lon: 25.11628
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNg==",
lat: 60.23692,
lon: 25.12131
},
{
id: "U3RvcDpIU0w6MTQ3MzExNg==",
lat: 60.23863,
lon: 25.122559
},
{
id: "U3RvcDpIU0w6MTQ3MzExNA==",
lat: 60.239352,
lon: 25.119588
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNA==",
lat: 60.23551,
lon: 25.12729
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMg==",
lat: 60.23253,
lon: 25.12857
},
{
id: "U3RvcDpIU0w6MTQ3MzE5MQ==",
lat: 60.232995,
lon: 25.122397
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMQ==",
lat: 60.23339,
lon: 25.12882
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMw==",
lat: 60.23597,
lon: 25.12657
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNQ==",
lat: 60.23705,
lon: 25.11995
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNw==",
lat: 60.23693,
lon: 25.11624
},
{
id: "U3RvcDpIU0w6MTQ3MzEyNQ==",
lat: 60.238572,
lon: 25.113675
},
{
id: "U3RvcDpIU0w6MTQ3MzE4Mg==",
lat: 60.238195,
lon: 25.109901
},
{
id: "U3RvcDpIU0w6MTQ3MjEzNQ==",
lat: 60.239857,
lon: 25.103392
},
{
id: "U3RvcDpIU0w6MTQ3MjExMQ==",
lat: 60.240887,
lon: 25.10055
},
{
id: "U3RvcDpIU0w6MTQ3MjEwOQ==",
lat: 60.242467,
lon: 25.100397
},
{
id: "U3RvcDpIU0w6MTQ3MjEwNw==",
lat: 60.243747,
lon: 25.094923
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMg==",
lat: 60.243524,
lon: 25.087752
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mg==",
lat: 60.241694,
lon: 25.086211
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MA==",
lat: 60.23846,
lon: 25.0869
},
{
id: "U3RvcDpIU0w6MTQ3MTExNw==",
lat: 60.23608,
lon: 25.08512
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOA==",
lat: 60.235943,
lon: 25.080696
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NA==",
lat: 60.23335,
lon: 25.07789
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mg==",
lat: 60.231,
lon: 25.0756
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Ng==",
lat: 60.22852,
lon: 25.07353
},
{
id: "U3RvcDpIU0w6MTQ3MTE5MA==",
lat: 60.23081,
lon: 25.07872
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Ng==",
lat: 60.23179,
lon: 25.08045
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Nw==",
lat: 60.23065,
lon: 25.0857
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNg==",
lat: 60.2287,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNA==",
lat: 60.22677,
lon: 25.08374
},
{
id: "U3RvcDpIU0w6MTQ3MTExNA==",
lat: 60.224607,
lon: 25.084945
},
{
id: "U3RvcDpIU0w6MTQ1NDEyNw==",
lat: 60.223605,
lon: 25.082473
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MA==",
lat: 60.22444,
lon: 25.07567
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Mw==",
lat: 60.22775,
lon: 25.0709
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NQ==",
lat: 60.227,
lon: 25.06296
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Nw==",
lat: 60.22353,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OQ==",
lat: 60.22198,
lon: 25.05776
}
]
},
{
gtfsId: "HSL:2212",
shortName: "212",
longName: "Kamppi-Meilahti-Laajalahti-Kauniainen",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MzE3MDIxNA==",
lat: 60.21882,
lon: 24.70155
},
{
id: "U3RvcDpIU0w6MzE3MDIxNQ==",
lat: 60.21655,
lon: 24.70142
},
{
id: "U3RvcDpIU0w6MzE3MDIxNg==",
lat: 60.21409,
lon: 24.70354
},
{
id: "U3RvcDpIU0w6MzE3MDIxNw==",
lat: 60.21116,
lon: 24.69975
},
{
id: "U3RvcDpIU0w6MzE3MDI0NA==",
lat: 60.20922,
lon: 24.69547
},
{
id: "U3RvcDpIU0w6MzE3MDIxOA==",
lat: 60.20817,
lon: 24.70252
},
{
id: "U3RvcDpIU0w6MzE3MDIxOQ==",
lat: 60.20878,
lon: 24.70853
},
{
id: "U3RvcDpIU0w6MzE3MDIyMA==",
lat: 60.21059,
lon: 24.71194
},
{
id: "U3RvcDpIU0w6MzE3MDIyMQ==",
lat: 60.21178,
lon: 24.71897
},
{
id: "U3RvcDpIU0w6MzE3MDIyMg==",
lat: 60.21277,
lon: 24.72321
},
{
id: "U3RvcDpIU0w6MzE3MDIwNw==",
lat: 60.21235,
lon: 24.72818
},
{
id: "U3RvcDpIU0w6MzE3MDI0MA==",
lat: 60.21083,
lon: 24.72933
},
{
id: "U3RvcDpIU0w6MzE3MDIzMQ==",
lat: 60.2096,
lon: 24.73197
},
{
id: "U3RvcDpIU0w6MzE3MDIyOQ==",
lat: 60.20949,
lon: 24.73919
},
{
id: "U3RvcDpIU0w6MjEzMTI1MA==",
lat: 60.207094,
lon: 24.752523
},
{
id: "U3RvcDpIU0w6MjI0MjIzMA==",
lat: 60.20359,
lon: 24.76211
},
{
id: "U3RvcDpIU0w6MjI0MjIzMQ==",
lat: 60.20358,
lon: 24.76755
},
{
id: "U3RvcDpIU0w6MjEyMjIzMg==",
lat: 60.20291,
lon: 24.77533
},
{
id: "U3RvcDpIU0w6MjI1MjIwMw==",
lat: 60.201276,
lon: 24.789595
},
{
id: "U3RvcDpIU0w6MjEyMjIyNA==",
lat: 60.2016,
lon: 24.79666
},
{
id: "U3RvcDpIU0w6MjEyMjIxMQ==",
lat: 60.20366,
lon: 24.79789
},
{
id: "U3RvcDpIU0w6MjEyMjIwOQ==",
lat: 60.20434,
lon: 24.79998
},
{
id: "U3RvcDpIU0w6MjEyMjIwNw==",
lat: 60.20435,
lon: 24.80615
},
{
id: "U3RvcDpIU0w6MjEyMjIwNA==",
lat: 60.2046,
lon: 24.81092
},
{
id: "U3RvcDpIU0w6MjEyMTIwMg==",
lat: 60.2053,
lon: 24.81595
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyMg==",
lat: 60.196005,
lon: 24.886202
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExOA==",
lat: 60.19113,
lon: 24.90804
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTEzMDExMw==",
lat: 60.170862,
lon: 24.930898
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
},
{
id: "U3RvcDpIU0w6MTA0MDI3OQ==",
lat: 60.16892,
lon: 24.93137
},
{
id: "U3RvcDpIU0w6MTEzMDExMQ==",
lat: 60.17419,
lon: 24.93349
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE1MDExNg==",
lat: 60.191346,
lon: 24.906254
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MjEyMjIxOQ==",
lat: 60.2061,
lon: 24.81546
},
{
id: "U3RvcDpIU0w6MjEyMjIwNQ==",
lat: 60.20476,
lon: 24.80945
},
{
id: "U3RvcDpIU0w6MjEyMjIwNg==",
lat: 60.20431,
lon: 24.80464
},
{
id: "U3RvcDpIU0w6MjEyMjIwOA==",
lat: 60.20449,
lon: 24.80009
},
{
id: "U3RvcDpIU0w6MjEyMjIxMA==",
lat: 60.20349,
lon: 24.79771
},
{
id: "U3RvcDpIU0w6MjEyMjIyNg==",
lat: 60.20169,
lon: 24.7965
},
{
id: "U3RvcDpIU0w6MjI1MjIwNA==",
lat: 60.201194,
lon: 24.785685
},
{
id: "U3RvcDpIU0w6MjI0MjIzMw==",
lat: 60.20309,
lon: 24.77493
},
{
id: "U3RvcDpIU0w6MjI0MjIyOQ==",
lat: 60.20351,
lon: 24.76572
},
{
id: "U3RvcDpIU0w6MjI0MjIwOQ==",
lat: 60.20413,
lon: 24.75998
},
{
id: "U3RvcDpIU0w6MjEzMTI1Nw==",
lat: 60.207166,
lon: 24.75329
},
{
id: "U3RvcDpIU0w6MzE3MDIyOA==",
lat: 60.20948,
lon: 24.73798
},
{
id: "U3RvcDpIU0w6MzE3MDIzMA==",
lat: 60.20981,
lon: 24.73151
},
{
id: "U3RvcDpIU0w6MzE3MDIzOQ==",
lat: 60.21096,
lon: 24.72951
},
{
id: "U3RvcDpIU0w6MzE3MDI1Nw==",
lat: 60.21267,
lon: 24.72825
},
{
id: "U3RvcDpIU0w6MzE3MDI0Ng==",
lat: 60.211811,
lon: 24.718853
},
{
id: "U3RvcDpIU0w6MzE3MDI3Mw==",
lat: 60.21008,
lon: 24.71094
},
{
id: "U3RvcDpIU0w6MzE3MDI1Mg==",
lat: 60.208069,
lon: 24.700725
},
{
id: "U3RvcDpIU0w6MzE3MDI1NA==",
lat: 60.209135,
lon: 24.695572
},
{
id: "U3RvcDpIU0w6MzE3MDI1Ng==",
lat: 60.211097,
lon: 24.699638
},
{
id: "U3RvcDpIU0w6MzE3MDI1OA==",
lat: 60.215049,
lon: 24.704448
},
{
id: "U3RvcDpIU0w6MzE3MDIxMg==",
lat: 60.21638,
lon: 24.71126
},
{
id: "U3RvcDpIU0w6MzE3MDI1NQ==",
lat: 60.217438,
lon: 24.70815
}
]
},
{
gtfsId: "HSL:4631",
shortName: "631",
longName: "Tikkurila-Kulomäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDYxMDI1Mg==",
lat: 60.294038,
lon: 25.04448
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIyOA==",
lat: 60.29661,
lon: 25.03844
},
{
id: "U3RvcDpIU0w6NDYxMDIzMQ==",
lat: 60.29765,
lon: 25.03472
},
{
id: "U3RvcDpIU0w6NDYzMDIxMA==",
lat: 60.29964,
lon: 25.03247
},
{
id: "U3RvcDpIU0w6NDYzMDIyNg==",
lat: 60.30105,
lon: 25.02662
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIwMw==",
lat: 60.30689,
lon: 25.02499
},
{
id: "U3RvcDpIU0w6NDY1MDIwNQ==",
lat: 60.31,
lon: 25.0287
},
{
id: "U3RvcDpIU0w6NDY1MDIwNw==",
lat: 60.31132,
lon: 25.03142
},
{
id: "U3RvcDpIU0w6NDY1MDIwOQ==",
lat: 60.31516,
lon: 25.03566
},
{
id: "U3RvcDpIU0w6NDcwMDIwMQ==",
lat: 60.3203,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDcwMDIyOA==",
lat: 60.32246,
lon: 25.042177
},
{
id: "U3RvcDpIU0w6NDcwMDIzNA==",
lat: 60.325902,
lon: 25.041882
},
{
id: "U3RvcDpIU0w6NDcyMDIyNQ==",
lat: 60.326482,
lon: 25.043723
},
{
id: "U3RvcDpIU0w6NDcwMDIwNw==",
lat: 60.3246,
lon: 25.05219
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNg==",
lat: 60.3233,
lon: 25.06344
},
{
id: "U3RvcDpIU0w6NDc0MDIxOA==",
lat: 60.32491,
lon: 25.06624
},
{
id: "U3RvcDpIU0w6NDc0MDIyMQ==",
lat: 60.32587,
lon: 25.06965
},
{
id: "U3RvcDpIU0w6NDczMDIwNA==",
lat: 60.32786,
lon: 25.07084
},
{
id: "U3RvcDpIU0w6NDczMDI5OQ==",
lat: 60.33099,
lon: 25.07343
},
{
id: "U3RvcDpIU0w6NDczMDI5Nw==",
lat: 60.33371,
lon: 25.07565
},
{
id: "U3RvcDpIU0w6NDgwMDIwMQ==",
lat: 60.3353,
lon: 25.07702
},
{
id: "U3RvcDpIU0w6NDgwMDIwMw==",
lat: 60.33975,
lon: 25.08047
},
{
id: "U3RvcDpIU0w6NDgwMDIwNQ==",
lat: 60.3439,
lon: 25.08007
},
{
id: "U3RvcDpIU0w6NDgzMDIyMw==",
lat: 60.34579,
lon: 25.08404
},
{
id: "U3RvcDpIU0w6NDgzMDIwNA==",
lat: 60.34708,
lon: 25.0832
},
{
id: "U3RvcDpIU0w6NDgzMDI5OQ==",
lat: 60.34672,
lon: 25.08124
},
{
id: "U3RvcDpIU0w6NDgxMDI5OQ==",
lat: 60.34736,
lon: 25.07515
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIwMw==",
lat: 60.35029,
lon: 25.07671
},
{
id: "U3RvcDpIU0w6NDgxMDIxMA==",
lat: 60.35169,
lon: 25.06696
},
{
id: "U3RvcDpIU0w6NDgxMDIyNA==",
lat: 60.34788,
lon: 25.06706
},
{
id: "U3RvcDpIU0w6NDgxMDIxMg==",
lat: 60.34533,
lon: 25.06672
},
{
id: "U3RvcDpIU0w6NDgxMDIxNA==",
lat: 60.34454,
lon: 25.06311
},
{
id: "U3RvcDpIU0w6NDgxMDIxNg==",
lat: 60.346583,
lon: 25.057448
},
{
id: "U3RvcDpIU0w6NDgxMDIxNw==",
lat: 60.34571,
lon: 25.05606
},
{
id: "U3RvcDpIU0w6NDgxMDIxNQ==",
lat: 60.34441,
lon: 25.06396
},
{
id: "U3RvcDpIU0w6NDgxMDIxMw==",
lat: 60.34548,
lon: 25.06682
},
{
id: "U3RvcDpIU0w6NDgxMDIyMw==",
lat: 60.34757,
lon: 25.06725
},
{
id: "U3RvcDpIU0w6NDgxMDIxMQ==",
lat: 60.35058,
lon: 25.06713
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDI5OA==",
lat: 60.346684,
lon: 25.075914
},
{
id: "U3RvcDpIU0w6NDgwMDIwOA==",
lat: 60.345185,
lon: 25.082611
},
{
id: "U3RvcDpIU0w6NDgwMDIwNg==",
lat: 60.34348,
lon: 25.07869
},
{
id: "U3RvcDpIU0w6NDgwMDIwNA==",
lat: 60.34075,
lon: 25.08005
},
{
id: "U3RvcDpIU0w6NDgwMDIwMg==",
lat: 60.33558,
lon: 25.07705
},
{
id: "U3RvcDpIU0w6NDczMDI5OA==",
lat: 60.33287,
lon: 25.07482
},
{
id: "U3RvcDpIU0w6NDczMDIwMw==",
lat: 60.32993,
lon: 25.07233
},
{
id: "U3RvcDpIU0w6NDczMDI5Ng==",
lat: 60.32729,
lon: 25.07019
},
{
id: "U3RvcDpIU0w6NDc0MDIyMA==",
lat: 60.3254,
lon: 25.06896
},
{
id: "U3RvcDpIU0w6NDc0MDIxOQ==",
lat: 60.32487,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIzNQ==",
lat: 60.32494,
lon: 25.06439
},
{
id: "U3RvcDpIU0w6NDc0MDIxNw==",
lat: 60.32322,
lon: 25.06293
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcyMDIyNw==",
lat: 60.325038,
lon: 25.050357
},
{
id: "U3RvcDpIU0w6NDcwMDIzMg==",
lat: 60.326547,
lon: 25.0421
},
{
id: "U3RvcDpIU0w6NDcwMDIzMw==",
lat: 60.325487,
lon: 25.041647
},
{
id: "U3RvcDpIU0w6NDcwMDIyOQ==",
lat: 60.322323,
lon: 25.042012
},
{
id: "U3RvcDpIU0w6NDcwMDIwMg==",
lat: 60.31968,
lon: 25.03908
},
{
id: "U3RvcDpIU0w6NDY1MDIxMA==",
lat: 60.3149,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6NDY1MDIwOA==",
lat: 60.31072,
lon: 25.03015
},
{
id: "U3RvcDpIU0w6NDY1MDIwNg==",
lat: 60.30949,
lon: 25.02695
},
{
id: "U3RvcDpIU0w6NDY1MDIwNA==",
lat: 60.30635,
lon: 25.02439
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIwNw==",
lat: 60.30182,
lon: 25.02328
},
{
id: "U3RvcDpIU0w6NDYzMDIyNQ==",
lat: 60.30021,
lon: 25.02911
},
{
id: "U3RvcDpIU0w6NDYzMDIwOQ==",
lat: 60.299,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6NDYxMDIwOQ==",
lat: 60.2969,
lon: 25.03573
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
}
]
},
{
gtfsId: "HSL:1087N",
shortName: "87N",
longName: "Rautatientori-Kruunuvuorenranta",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ5NDEwNA==",
lat: 60.1689,
lon: 25.020529
},
{
id: "U3RvcDpIU0w6MTQ5NDE1Nw==",
lat: 60.168892,
lon: 25.026066
},
{
id: "U3RvcDpIU0w6MTQ5MTE2Nw==",
lat: 60.172308,
lon: 25.033506
},
{
id: "U3RvcDpIU0w6MTQ5MTExMg==",
lat: 60.174846,
lon: 25.041802
},
{
id: "U3RvcDpIU0w6MTQ5MTExMA==",
lat: 60.1756,
lon: 25.04661
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOA==",
lat: 60.17786,
lon: 25.04901
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Ng==",
lat: 60.17938,
lon: 25.0509
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OA==",
lat: 60.18142,
lon: 25.05098
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNA==",
lat: 60.18299,
lon: 25.05049
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDEyMw==",
lat: 60.17134,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMw==",
lat: 60.18248,
lon: 25.05064
},
{
id: "U3RvcDpIU0w6MTQ5MTE1OA==",
lat: 60.181037,
lon: 25.050729
},
{
id: "U3RvcDpIU0w6MTQ5MTE1NQ==",
lat: 60.178434,
lon: 25.049872
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNw==",
lat: 60.17786,
lon: 25.04891
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOQ==",
lat: 60.17566,
lon: 25.0462
},
{
id: "U3RvcDpIU0w6MTQ5MTExMQ==",
lat: 60.174743,
lon: 25.040362
},
{
id: "U3RvcDpIU0w6MTQ5MzEwMg==",
lat: 60.17215,
lon: 25.033079
},
{
id: "U3RvcDpIU0w6MTQ5NDEwNw==",
lat: 60.168898,
lon: 25.025654
},
{
id: "U3RvcDpIU0w6MTQ5NDEwNQ==",
lat: 60.168987,
lon: 25.020211
}
]
},
{
gtfsId: "HSL:4633",
shortName: "633",
longName: "Hakaniemi-Ilola-Korso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTExMTExNw==",
lat: 60.179463,
lon: 24.952195
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDY4MDI1MQ==",
lat: 60.28629,
lon: 24.98319
},
{
id: "U3RvcDpIU0w6NDY4MDI0OQ==",
lat: 60.29431,
lon: 24.98431
},
{
id: "U3RvcDpIU0w6NDY4MDIxNw==",
lat: 60.29991,
lon: 24.98982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMg==",
lat: 60.307715,
lon: 24.999454
},
{
id: "U3RvcDpIU0w6NDY3MDIxNg==",
lat: 60.31302,
lon: 24.99868
},
{
id: "U3RvcDpIU0w6NDY3MDIwNQ==",
lat: 60.31623,
lon: 25.0045
},
{
id: "U3RvcDpIU0w6NDY3MDIxMA==",
lat: 60.3158,
lon: 25.01389
},
{
id: "U3RvcDpIU0w6NDY3MDIxMg==",
lat: 60.3198,
lon: 25.01384
},
{
id: "U3RvcDpIU0w6NDY3MDIxNA==",
lat: 60.32302,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDcxMDIwNg==",
lat: 60.32362,
lon: 25.01831
},
{
id: "U3RvcDpIU0w6NDcxMDIwOA==",
lat: 60.32624,
lon: 25.02493
},
{
id: "U3RvcDpIU0w6NDcxMDIxOA==",
lat: 60.32946,
lon: 25.02685
},
{
id: "U3RvcDpIU0w6NDcxMDI0NA==",
lat: 60.334368,
lon: 25.027149
},
{
id: "U3RvcDpIU0w6NDcxMDI0Mg==",
lat: 60.336744,
lon: 25.026228
},
{
id: "U3RvcDpIU0w6OTY3MDUzMg==",
lat: 60.339372,
lon: 25.023015
},
{
id: "U3RvcDpIU0w6OTY3MDUwOQ==",
lat: 60.343606,
lon: 25.022086
},
{
id: "U3RvcDpIU0w6NDgxMDI0NA==",
lat: 60.34678,
lon: 25.04861
},
{
id: "U3RvcDpIU0w6NDgxMDI0MQ==",
lat: 60.34716,
lon: 25.05985
},
{
id: "U3RvcDpIU0w6NDgxMDIyNg==",
lat: 60.34667,
lon: 25.06689
},
{
id: "U3RvcDpIU0w6NDgxMDIzOA==",
lat: 60.34579,
lon: 25.07516
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDIyNQ==",
lat: 60.34683,
lon: 25.074
},
{
id: "U3RvcDpIU0w6NDgxMDIyNw==",
lat: 60.34677,
lon: 25.06812
},
{
id: "U3RvcDpIU0w6NDgxMDIzMg==",
lat: 60.34731,
lon: 25.05984
},
{
id: "U3RvcDpIU0w6OTY3MDUzMA==",
lat: 60.346485,
lon: 25.046648
},
{
id: "U3RvcDpIU0w6OTY3MDUzMw==",
lat: 60.343093,
lon: 25.021248
},
{
id: "U3RvcDpIU0w6OTY3MDUzMQ==",
lat: 60.339383,
lon: 25.022798
},
{
id: "U3RvcDpIU0w6NDcxMDI0Mw==",
lat: 60.336051,
lon: 25.026532
},
{
id: "U3RvcDpIU0w6NDcxMDIzOQ==",
lat: 60.33326,
lon: 25.02735
},
{
id: "U3RvcDpIU0w6NDcxMDIxNw==",
lat: 60.32983,
lon: 25.02648
},
{
id: "U3RvcDpIU0w6NDcxMDIwOQ==",
lat: 60.32633,
lon: 25.02468
},
{
id: "U3RvcDpIU0w6NDcxMDIzMQ==",
lat: 60.32451,
lon: 25.02443
},
{
id: "U3RvcDpIU0w6NDcxMDIwNw==",
lat: 60.32345,
lon: 25.01674
},
{
id: "U3RvcDpIU0w6NDY3MDIxMw==",
lat: 60.32259,
lon: 25.0127
},
{
id: "U3RvcDpIU0w6NDY3MDIxMQ==",
lat: 60.31772,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDY3MDIwNw==",
lat: 60.31545,
lon: 25.01216
},
{
id: "U3RvcDpIU0w6NDY3MDIwNA==",
lat: 60.31644,
lon: 25.00259
},
{
id: "U3RvcDpIU0w6NDY3MDIyMQ==",
lat: 60.31554,
lon: 24.99887
},
{
id: "U3RvcDpIU0w6NDY3MDIxNQ==",
lat: 60.31214,
lon: 24.99851
},
{
id: "U3RvcDpIU0w6NDY4MDIzMw==",
lat: 60.30751,
lon: 24.99824
},
{
id: "U3RvcDpIU0w6NDY4MDIxOA==",
lat: 60.3012,
lon: 24.98972
},
{
id: "U3RvcDpIU0w6NDY4MDI1MA==",
lat: 60.29421,
lon: 24.98286
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mg==",
lat: 60.28722,
lon: 24.97696
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTE1MA==",
lat: 60.178205,
lon: 24.951532
}
]
},
{
gtfsId: "HSL:2207",
shortName: "207",
longName: "Leppävaara-Lintukorpi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIzNw==",
lat: 60.21898,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6MjExMTIyOA==",
lat: 60.22132,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExMTI1Nw==",
lat: 60.221951,
lon: 24.813737
},
{
id: "U3RvcDpIU0w6MjExMTI1NA==",
lat: 60.222934,
lon: 24.81453
},
{
id: "U3RvcDpIU0w6MjExMTI1Mg==",
lat: 60.224535,
lon: 24.812782
},
{
id: "U3RvcDpIU0w6MjExMTI1MA==",
lat: 60.225846,
lon: 24.804139
},
{
id: "U3RvcDpIU0w6MjExMTI0OA==",
lat: 60.226787,
lon: 24.809955
},
{
id: "U3RvcDpIU0w6MjExMTIyNg==",
lat: 60.2267,
lon: 24.81272
},
{
id: "U3RvcDpIU0w6MjExMTI0Ng==",
lat: 60.226573,
lon: 24.814855
},
{
id: "U3RvcDpIU0w6MjExMTI0MA==",
lat: 60.228517,
lon: 24.806927
},
{
id: "U3RvcDpIU0w6MjExMTI0Mg==",
lat: 60.228705,
lon: 24.811597
},
{
id: "U3RvcDpIU0w6MjExMTI0NA==",
lat: 60.228755,
lon: 24.812299
},
{
id: "U3RvcDpIU0w6MjExMTI4MQ==",
lat: 60.22904,
lon: 24.81383
},
{
id: "U3RvcDpIU0w6MjExNDIyMg==",
lat: 60.230872,
lon: 24.812514
},
{
id: "U3RvcDpIU0w6MjExNDIwMg==",
lat: 60.230794,
lon: 24.804733
},
{
id: "U3RvcDpIU0w6MjExNDIwMQ==",
lat: 60.230811,
lon: 24.80543
},
{
id: "U3RvcDpIU0w6MjExNDIwMw==",
lat: 60.230811,
lon: 24.804769
},
{
id: "U3RvcDpIU0w6MjExMTIxOQ==",
lat: 60.230871,
lon: 24.812568
},
{
id: "U3RvcDpIU0w6MjExMTIxOA==",
lat: 60.22868,
lon: 24.81475
},
{
id: "U3RvcDpIU0w6MjExMTIxNQ==",
lat: 60.22864,
lon: 24.81755
},
{
id: "U3RvcDpIU0w6MjExMTIwNw==",
lat: 60.22748,
lon: 24.82092
},
{
id: "U3RvcDpIU0w6MjExMTIwMg==",
lat: 60.22735,
lon: 24.823286
},
{
id: "U3RvcDpIU0w6MjExMTIwMQ==",
lat: 60.225297,
lon: 24.822421
},
{
id: "U3RvcDpIU0w6MjExMTI0NQ==",
lat: 60.224056,
lon: 24.819907
},
{
id: "U3RvcDpIU0w6MjExMzIwOA==",
lat: 60.223816,
lon: 24.82432
},
{
id: "U3RvcDpIU0w6MjExMzIxMA==",
lat: 60.221455,
lon: 24.822288
},
{
id: "U3RvcDpIU0w6MjExMzIxNA==",
lat: 60.221967,
lon: 24.820265
},
{
id: "U3RvcDpIU0w6MjExMTI0Mw==",
lat: 60.221495,
lon: 24.815871
},
{
id: "U3RvcDpIU0w6MjExMTIwMw==",
lat: 60.22452,
lon: 24.812757
},
{
id: "U3RvcDpIU0w6MjExMTIyMQ==",
lat: 60.222908,
lon: 24.814385
},
{
id: "U3RvcDpIU0w6MjExMTI1OA==",
lat: 60.221708,
lon: 24.814133
},
{
id: "U3RvcDpIU0w6MjExMTIyOQ==",
lat: 60.22095,
lon: 24.80986
},
{
id: "U3RvcDpIU0w6MjExMjIwMg==",
lat: 60.217967,
lon: 24.809035
},
{
id: "U3RvcDpIU0w6MjExMjIwNA==",
lat: 60.217244,
lon: 24.806945
},
{
id: "U3RvcDpIU0w6MjExMjIxMA==",
lat: 60.216267,
lon: 24.806777
},
{
id: "U3RvcDpIU0w6MjExMjIxMg==",
lat: 60.21463,
lon: 24.80667
},
{
id: "U3RvcDpIU0w6MjExMjIzMQ==",
lat: 60.21428,
lon: 24.81122
},
{
id: "U3RvcDpIU0w6MjExMjIzMg==",
lat: 60.21643,
lon: 24.81222
},
{
id: "U3RvcDpIU0w6MjExMjI5Ng==",
lat: 60.21721,
lon: 24.81279
},
{
id: "U3RvcDpIU0w6MjExMjIwMQ==",
lat: 60.217877,
lon: 24.808812
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:2203",
shortName: "203",
longName: "Leppävaara-Uusmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIyNQ==",
lat: 60.21929,
lon: 24.81115
},
{
id: "U3RvcDpIU0w6MjExMTIyOA==",
lat: 60.22132,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExMTIxMg==",
lat: 60.2232,
lon: 24.81071
},
{
id: "U3RvcDpIU0w6MjExMTIyNg==",
lat: 60.2267,
lon: 24.81272
},
{
id: "U3RvcDpIU0w6MjExMTIxOA==",
lat: 60.22868,
lon: 24.81475
},
{
id: "U3RvcDpIU0w6MjExMTIxNQ==",
lat: 60.22864,
lon: 24.81755
},
{
id: "U3RvcDpIU0w6MjExMTIwNw==",
lat: 60.22748,
lon: 24.82092
},
{
id: "U3RvcDpIU0w6MjExNTIwMg==",
lat: 60.23094,
lon: 24.82752
},
{
id: "U3RvcDpIU0w6MjExNjIxMQ==",
lat: 60.233286,
lon: 24.831033
},
{
id: "U3RvcDpIU0w6MjExNjIwMg==",
lat: 60.23497,
lon: 24.83189
},
{
id: "U3RvcDpIU0w6MjExNjIwNg==",
lat: 60.23738,
lon: 24.83604
},
{
id: "U3RvcDpIU0w6MjExNjI4Mw==",
lat: 60.23964,
lon: 24.83497
},
{
id: "U3RvcDpIU0w6MjExNjI4NQ==",
lat: 60.240979,
lon: 24.833534
},
{
id: "U3RvcDpIU0w6MjExNjI4Nw==",
lat: 60.245025,
lon: 24.831187
},
{
id: "U3RvcDpIU0w6MjExNjI5MA==",
lat: 60.245497,
lon: 24.831476
},
{
id: "U3RvcDpIU0w6MjExNjI4Ng==",
lat: 60.24519,
lon: 24.8311
},
{
id: "U3RvcDpIU0w6MjExNjIxOA==",
lat: 60.24098,
lon: 24.83331
},
{
id: "U3RvcDpIU0w6MjExNjI4NA==",
lat: 60.23943,
lon: 24.83491
},
{
id: "U3RvcDpIU0w6MjExNjIwMw==",
lat: 60.23735,
lon: 24.8355
},
{
id: "U3RvcDpIU0w6MjExNjIwMQ==",
lat: 60.23513,
lon: 24.83173
},
{
id: "U3RvcDpIU0w6MjExNjIxMg==",
lat: 60.232603,
lon: 24.830631
},
{
id: "U3RvcDpIU0w6MjExNTIwNQ==",
lat: 60.23101,
lon: 24.82706
},
{
id: "U3RvcDpIU0w6MjExMTI0MQ==",
lat: 60.22883,
lon: 24.82451
},
{
id: "U3RvcDpIU0w6MjExMTIwNg==",
lat: 60.22801,
lon: 24.81957
},
{
id: "U3RvcDpIU0w6MjExMTIxNg==",
lat: 60.22881,
lon: 24.81648
},
{
id: "U3RvcDpIU0w6MjExMTIxNw==",
lat: 60.22831,
lon: 24.81361
},
{
id: "U3RvcDpIU0w6MjExMTIxMw==",
lat: 60.22433,
lon: 24.81044
},
{
id: "U3RvcDpIU0w6MjExMTIyOQ==",
lat: 60.22095,
lon: 24.80986
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:2202",
shortName: "202",
longName: "Nuijala-Leppävaara-Helmipöllönmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExNzIwNA==",
lat: 60.243586,
lon: 24.819842
},
{
id: "U3RvcDpIU0w6MjExNzIwNg==",
lat: 60.240682,
lon: 24.819272
},
{
id: "U3RvcDpIU0w6MjExNzIwMg==",
lat: 60.23727,
lon: 24.82241
},
{
id: "U3RvcDpIU0w6MjExNTIwOA==",
lat: 60.23452,
lon: 24.82164
},
{
id: "U3RvcDpIU0w6MjExNTIxMg==",
lat: 60.23437,
lon: 24.81822
},
{
id: "U3RvcDpIU0w6MjExNDIwOA==",
lat: 60.23433,
lon: 24.81456
},
{
id: "U3RvcDpIU0w6MjExNDIyMQ==",
lat: 60.23321,
lon: 24.81357
},
{
id: "U3RvcDpIU0w6MjExNDIxOQ==",
lat: 60.2313,
lon: 24.81365
},
{
id: "U3RvcDpIU0w6MjExMTIxNw==",
lat: 60.22831,
lon: 24.81361
},
{
id: "U3RvcDpIU0w6MjExMTIxMw==",
lat: 60.22433,
lon: 24.81044
},
{
id: "U3RvcDpIU0w6MjExMTIyOQ==",
lat: 60.22095,
lon: 24.80986
},
{
id: "U3RvcDpIU0w6MjExMTIzMg==",
lat: 60.218907,
lon: 24.812232
},
{
id: "U3RvcDpIU0w6MjExODI4MA==",
lat: 60.2171,
lon: 24.820558
},
{
id: "U3RvcDpIU0w6MjExODI3OA==",
lat: 60.217,
lon: 24.82504
},
{
id: "U3RvcDpIU0w6MjExODI3Ng==",
lat: 60.21489,
lon: 24.82632
},
{
id: "U3RvcDpIU0w6MjExODIwMQ==",
lat: 60.21264,
lon: 24.82623
},
{
id: "U3RvcDpIU0w6MjExODIwNQ==",
lat: 60.21079,
lon: 24.82438
},
{
id: "U3RvcDpIU0w6MjExODIyNA==",
lat: 60.21268,
lon: 24.8189
},
{
id: "U3RvcDpIU0w6MjExMjIwMw==",
lat: 60.21399,
lon: 24.81012
},
{
id: "U3RvcDpIU0w6MjExMjIxNA==",
lat: 60.214286,
lon: 24.804602
},
{
id: "U3RvcDpIU0w6MjExMjIwNQ==",
lat: 60.21366,
lon: 24.79984
},
{
id: "U3RvcDpIU0w6MjEzMTIwNQ==",
lat: 60.20922,
lon: 24.79452
},
{
id: "U3RvcDpIU0w6MjEzMTIwMw==",
lat: 60.20864,
lon: 24.78493
},
{
id: "U3RvcDpIU0w6MjEzMTIwOQ==",
lat: 60.20761,
lon: 24.77583
},
{
id: "U3RvcDpIU0w6MjEzMTIxMQ==",
lat: 60.20852,
lon: 24.76843
},
{
id: "U3RvcDpIU0w6MjEzMTI1OA==",
lat: 60.20753,
lon: 24.76544
},
{
id: "U3RvcDpIU0w6MjEzMTIwNA==",
lat: 60.20862,
lon: 24.76675
},
{
id: "U3RvcDpIU0w6MjEzMTIwOA==",
lat: 60.20744,
lon: 24.77397
},
{
id: "U3RvcDpIU0w6MjEzMTIwMg==",
lat: 60.20844,
lon: 24.78725
},
{
id: "U3RvcDpIU0w6MjExMjIxOA==",
lat: 60.21005,
lon: 24.79618
},
{
id: "U3RvcDpIU0w6MjExMjIyNg==",
lat: 60.21413,
lon: 24.80096
},
{
id: "U3RvcDpIU0w6MjExMjIxNg==",
lat: 60.21408,
lon: 24.80549
},
{
id: "U3RvcDpIU0w6MjExMjI2MA==",
lat: 60.21354,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExODIyMQ==",
lat: 60.21253,
lon: 24.81925
},
{
id: "U3RvcDpIU0w6MjExODIwNA==",
lat: 60.21104,
lon: 24.82569
},
{
id: "U3RvcDpIU0w6MjExODIwMw==",
lat: 60.21222,
lon: 24.8263
},
{
id: "U3RvcDpIU0w6MjExODI3Nw==",
lat: 60.2147,
lon: 24.82653
},
{
id: "U3RvcDpIU0w6MjExODI4NA==",
lat: 60.21716,
lon: 24.825386
},
{
id: "U3RvcDpIU0w6MjExODI4Ng==",
lat: 60.2184,
lon: 24.81792
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIyNQ==",
lat: 60.21929,
lon: 24.81115
},
{
id: "U3RvcDpIU0w6MjExMTIyOA==",
lat: 60.22132,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExMTIxMg==",
lat: 60.2232,
lon: 24.81071
},
{
id: "U3RvcDpIU0w6MjExMTIyNg==",
lat: 60.2267,
lon: 24.81272
},
{
id: "U3RvcDpIU0w6MjExMTI4MQ==",
lat: 60.22904,
lon: 24.81383
},
{
id: "U3RvcDpIU0w6MjExNDIxOA==",
lat: 60.23154,
lon: 24.8138
},
{
id: "U3RvcDpIU0w6MjExNDIwOQ==",
lat: 60.23425,
lon: 24.81428
},
{
id: "U3RvcDpIU0w6MjExNTIxMQ==",
lat: 60.23434,
lon: 24.81888
},
{
id: "U3RvcDpIU0w6MjExNTIwOQ==",
lat: 60.23466,
lon: 24.82351
},
{
id: "U3RvcDpIU0w6MjExNzIwMw==",
lat: 60.238384,
lon: 24.821218
},
{
id: "U3RvcDpIU0w6MjExNzIwNQ==",
lat: 60.240975,
lon: 24.81924
}
]
},
{
gtfsId: "HSL:2201",
shortName: "201",
longName: "Leppävaara-Mäkkylä-Pitäjänmäki- Pajamäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ2MTEwNQ==",
lat: 60.218951,
lon: 24.856818
},
{
id: "U3RvcDpIU0w6MTQ2MTEwMA==",
lat: 60.217582,
lon: 24.856695
},
{
id: "U3RvcDpIU0w6MTQ2MTEwOA==",
lat: 60.219067,
lon: 24.859797
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzEwMQ==",
lat: 60.22546,
lon: 24.84836
},
{
id: "U3RvcDpIU0w6MTQ2MzEwMw==",
lat: 60.226049,
lon: 24.843304
},
{
id: "U3RvcDpIU0w6MTQ2MzEwNQ==",
lat: 60.224147,
lon: 24.841875
},
{
id: "U3RvcDpIU0w6MTQ2MzEwNg==",
lat: 60.222702,
lon: 24.842162
},
{
id: "U3RvcDpIU0w6MTQ2MzIwMw==",
lat: 60.22606,
lon: 24.84258
},
{
id: "U3RvcDpIU0w6MjExMzIzOQ==",
lat: 60.22614,
lon: 24.8349
},
{
id: "U3RvcDpIU0w6MjExMzIxNQ==",
lat: 60.227657,
lon: 24.833909
},
{
id: "U3RvcDpIU0w6MjExMzI0MQ==",
lat: 60.22622,
lon: 24.82891
},
{
id: "U3RvcDpIU0w6MjExMzIxMQ==",
lat: 60.22633,
lon: 24.82611
},
{
id: "U3RvcDpIU0w6MjExMTIwMg==",
lat: 60.22735,
lon: 24.823286
},
{
id: "U3RvcDpIU0w6MjExMTIwMQ==",
lat: 60.225297,
lon: 24.822421
},
{
id: "U3RvcDpIU0w6MjExMTI0NQ==",
lat: 60.224056,
lon: 24.819907
},
{
id: "U3RvcDpIU0w6MjExMTI0Mw==",
lat: 60.221495,
lon: 24.815871
},
{
id: "U3RvcDpIU0w6MjExMTI1NA==",
lat: 60.222934,
lon: 24.81453
},
{
id: "U3RvcDpIU0w6MjExMTIxMw==",
lat: 60.22433,
lon: 24.81044
},
{
id: "U3RvcDpIU0w6MjExMTIyOQ==",
lat: 60.22095,
lon: 24.80986
},
{
id: "U3RvcDpIU0w6MjExMTIzNg==",
lat: 60.21902,
lon: 24.81092
},
{
id: "U3RvcDpIU0w6MjExMTIzNw==",
lat: 60.21898,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6MjExMTIyOA==",
lat: 60.22132,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExMTIxMg==",
lat: 60.2232,
lon: 24.81071
},
{
id: "U3RvcDpIU0w6MjExMTIyMQ==",
lat: 60.222908,
lon: 24.814385
},
{
id: "U3RvcDpIU0w6MjExMzIwMQ==",
lat: 60.221533,
lon: 24.81598
},
{
id: "U3RvcDpIU0w6MjExMzIwMw==",
lat: 60.222292,
lon: 24.816539
},
{
id: "U3RvcDpIU0w6MjExMzIwMg==",
lat: 60.224027,
lon: 24.81993
},
{
id: "U3RvcDpIU0w6MjExMTIzOQ==",
lat: 60.225421,
lon: 24.822615
},
{
id: "U3RvcDpIU0w6MjExMzIxMw==",
lat: 60.22633,
lon: 24.82571
},
{
id: "U3RvcDpIU0w6MjExMzI0MA==",
lat: 60.22603,
lon: 24.82795
},
{
id: "U3RvcDpIU0w6MjExMzIzOA==",
lat: 60.22543,
lon: 24.83586
},
{
id: "U3RvcDpIU0w6MTQ2MzEwNA==",
lat: 60.226,
lon: 24.84334
},
{
id: "U3RvcDpIU0w6MTQ2MzEwMg==",
lat: 60.22575,
lon: 24.84729
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMA==",
lat: 60.224845,
lon: 24.850474
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MTEwNw==",
lat: 60.219115,
lon: 24.859239
}
]
},
{
gtfsId: "HSL:1811B",
shortName: "811B",
longName: "Kivikko-Kontula-Mellunmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MzE4Mg==",
lat: 60.238195,
lon: 25.109901
},
{
id: "U3RvcDpIU0w6MTQ3MjExMw==",
lat: 60.23732,
lon: 25.09838
},
{
id: "U3RvcDpIU0w6MTQ3MTExNQ==",
lat: 60.23753,
lon: 25.09072
},
{
id: "U3RvcDpIU0w6MTQ3MjEyMQ==",
lat: 60.238601,
lon: 25.089358
},
{
id: "U3RvcDpIU0w6MTQ3MjEyMw==",
lat: 60.241189,
lon: 25.092224
},
{
id: "U3RvcDpIU0w6MTQ3MjEyNQ==",
lat: 60.242837,
lon: 25.092677
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMg==",
lat: 60.243524,
lon: 25.087752
},
{
id: "U3RvcDpIU0w6MTQ3MTEwOA==",
lat: 60.243585,
lon: 25.08584
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mg==",
lat: 60.241694,
lon: 25.086211
},
{
id: "U3RvcDpIU0w6MTQ3MTEwNQ==",
lat: 60.23883,
lon: 25.084705
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mw==",
lat: 60.237977,
lon: 25.08401
},
{
id: "U3RvcDpIU0w6MTQ3MTEwNg==",
lat: 60.238799,
lon: 25.084924
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MA==",
lat: 60.23846,
lon: 25.0869
},
{
id: "U3RvcDpIU0w6MTQ3MTExNw==",
lat: 60.23608,
lon: 25.08512
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOA==",
lat: 60.235943,
lon: 25.080696
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NA==",
lat: 60.23335,
lon: 25.07789
},
{
id: "U3RvcDpIU0w6MTQ3MTE5Nw==",
lat: 60.232502,
lon: 25.075328
},
{
id: "U3RvcDpIU0w6MTQ3MTE5NQ==",
lat: 60.233183,
lon: 25.072008
},
{
id: "U3RvcDpIU0w6MTQ3MTE5Mw==",
lat: 60.232917,
lon: 25.066373
},
{
id: "U3RvcDpIU0w6MTQ3NDExMQ==",
lat: 60.23268,
lon: 25.062558
},
{
id: "U3RvcDpIU0w6MTQ3NDE4NA==",
lat: 60.231874,
lon: 25.057301
},
{
id: "U3RvcDpIU0w6MTQ3NDEwOQ==",
lat: 60.233448,
lon: 25.056732
},
{
id: "U3RvcDpIU0w6MTQ3NDExNA==",
lat: 60.23164,
lon: 25.05878
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMQ==",
lat: 60.23361,
lon: 25.0628
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMw==",
lat: 60.23707,
lon: 25.06766
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMA==",
lat: 60.237247,
lon: 25.066625
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNQ==",
lat: 60.23879,
lon: 25.06735
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNw==",
lat: 60.24025,
lon: 25.07194
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MQ==",
lat: 60.24007,
lon: 25.07459
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mw==",
lat: 60.24255,
lon: 25.07526
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMw==",
lat: 60.244934,
lon: 25.074437
},
{
id: "U3RvcDpIU0w6MTQ3NDExNQ==",
lat: 60.248572,
lon: 25.078282
},
{
id: "U3RvcDpIU0w6MTQ3NDEyNA==",
lat: 60.245078,
lon: 25.074406
},
{
id: "U3RvcDpIU0w6MTQ3MTE0NA==",
lat: 60.24251,
lon: 25.07514
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNg==",
lat: 60.23977,
lon: 25.07401
},
{
id: "U3RvcDpIU0w6MTQ3NDEwOA==",
lat: 60.24054,
lon: 25.07018
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNg==",
lat: 60.2387,
lon: 25.0672
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNA==",
lat: 60.23695,
lon: 25.06738
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMg==",
lat: 60.23314,
lon: 25.06215
},
{
id: "U3RvcDpIU0w6MTQ3NDExMg==",
lat: 60.23256,
lon: 25.06251
},
{
id: "U3RvcDpIU0w6MTQ3MTE4Mg==",
lat: 60.232998,
lon: 25.066393
},
{
id: "U3RvcDpIU0w6MTQ3MTE4NA==",
lat: 60.233521,
lon: 25.071645
},
{
id: "U3RvcDpIU0w6MTQ3MTE4Ng==",
lat: 60.232621,
lon: 25.075207
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mw==",
lat: 60.23353,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNw==",
lat: 60.235733,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6MTQ3MTExOA==",
lat: 60.23638,
lon: 25.08713
},
{
id: "U3RvcDpIU0w6MTQ3MTE0OQ==",
lat: 60.23947,
lon: 25.0862
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MQ==",
lat: 60.24156,
lon: 25.08644
},
{
id: "U3RvcDpIU0w6MTQ3MjE1Mw==",
lat: 60.243574,
lon: 25.088205
},
{
id: "U3RvcDpIU0w6MTQ3MjEyNg==",
lat: 60.242856,
lon: 25.092587
},
{
id: "U3RvcDpIU0w6MTQ3MjEyNA==",
lat: 60.240677,
lon: 25.091855
},
{
id: "U3RvcDpIU0w6MTQ3MjEyMg==",
lat: 60.238672,
lon: 25.089434
},
{
id: "U3RvcDpIU0w6MTQ3MTExNg==",
lat: 60.23749,
lon: 25.09319
},
{
id: "U3RvcDpIU0w6MTQ3MjExNA==",
lat: 60.23702,
lon: 25.09955
},
{
id: "U3RvcDpIU0w6MTQ3MjExMg==",
lat: 60.23742,
lon: 25.1058
}
]
},
{
gtfsId: "HSL:2321",
shortName: "321",
longName: "Elielinaukio-Jupperi-Vanhakartano",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEzNQ==",
lat: 60.171861,
lon: 24.939722
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEyMA==",
lat: 60.20988,
lon: 24.88902
},
{
id: "U3RvcDpIU0w6MTI5MTE4MA==",
lat: 60.21517,
lon: 24.88415
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mg==",
lat: 60.21988,
lon: 24.88124
},
{
id: "U3RvcDpIU0w6MTI5NDEyMQ==",
lat: 60.22517,
lon: 24.87707
},
{
id: "U3RvcDpIU0w6MTQ2NDEyMw==",
lat: 60.22792,
lon: 24.87272
},
{
id: "U3RvcDpIU0w6MTQ2MzExNw==",
lat: 60.23393,
lon: 24.862
},
{
id: "U3RvcDpIU0w6MTMyMDExOQ==",
lat: 60.2387,
lon: 24.85418
},
{
id: "U3RvcDpIU0w6MTMyMDI5Nw==",
lat: 60.24435,
lon: 24.84502
},
{
id: "U3RvcDpIU0w6MTMyMDI5NQ==",
lat: 60.24945,
lon: 24.83561
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNQ==",
lat: 60.25572,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDI5MQ==",
lat: 60.25508,
lon: 24.79965
},
{
id: "U3RvcDpIU0w6NDEwMDIwNw==",
lat: 60.25419,
lon: 24.79491
},
{
id: "U3RvcDpIU0w6NDEwMDIwOQ==",
lat: 60.25467,
lon: 24.7786
},
{
id: "U3RvcDpIU0w6MjE0MzIxNw==",
lat: 60.253227,
lon: 24.772518
},
{
id: "U3RvcDpIU0w6MjE0MzIxNQ==",
lat: 60.25198,
lon: 24.7679
},
{
id: "U3RvcDpIU0w6MjE0MzIxMw==",
lat: 60.25041,
lon: 24.76301
},
{
id: "U3RvcDpIU0w6MjE0MzIxMg==",
lat: 60.24895,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjE0MjIxMA==",
lat: 60.24566,
lon: 24.75026
},
{
id: "U3RvcDpIU0w6MjE0MjIwOA==",
lat: 60.24338,
lon: 24.74724
},
{
id: "U3RvcDpIU0w6MjE0MjIwNg==",
lat: 60.2414,
lon: 24.74307
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjcxMzIwMQ==",
lat: 60.25237,
lon: 24.72199
},
{
id: "U3RvcDpIU0w6MjcxMzIwMw==",
lat: 60.25325,
lon: 24.72546
},
{
id: "U3RvcDpIU0w6MjcxMzIwNQ==",
lat: 60.25329,
lon: 24.73325
},
{
id: "U3RvcDpIU0w6MjcxMzIyMA==",
lat: 60.25359,
lon: 24.73518
},
{
id: "U3RvcDpIU0w6MjcxMzIwNg==",
lat: 60.25333,
lon: 24.73323
},
{
id: "U3RvcDpIU0w6MjcxMzIwNA==",
lat: 60.25327,
lon: 24.72461
},
{
id: "U3RvcDpIU0w6MjcxMzIwMg==",
lat: 60.25185,
lon: 24.7206
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNQ==",
lat: 60.24064,
lon: 24.74186
},
{
id: "U3RvcDpIU0w6MjE0MTIwNw==",
lat: 60.24387,
lon: 24.7488
},
{
id: "U3RvcDpIU0w6MjE0MjIwOQ==",
lat: 60.24647,
lon: 24.75143
},
{
id: "U3RvcDpIU0w6MjE0MzIxMQ==",
lat: 60.2493,
lon: 24.7569
},
{
id: "U3RvcDpIU0w6MjE0MzIxNA==",
lat: 60.25059,
lon: 24.76441
},
{
id: "U3RvcDpIU0w6MjE0MzIxNg==",
lat: 60.25233,
lon: 24.76977
},
{
id: "U3RvcDpIU0w6MjE0MzIxOA==",
lat: 60.25371,
lon: 24.77507
},
{
id: "U3RvcDpIU0w6NDEwMDIxMA==",
lat: 60.25474,
lon: 24.78064
},
{
id: "U3RvcDpIU0w6NDEyMDI5MA==",
lat: 60.25438,
lon: 24.79724
},
{
id: "U3RvcDpIU0w6NDEyMDI4OA==",
lat: 60.25537,
lon: 24.80147
},
{
id: "U3RvcDpIU0w6NDEyMDIwNg==",
lat: 60.25537,
lon: 24.80804
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6MTMyMDI5Mg==",
lat: 60.24917,
lon: 24.83552
},
{
id: "U3RvcDpIU0w6MTMyMDI5NA==",
lat: 60.24309,
lon: 24.84648
},
{
id: "U3RvcDpIU0w6MTMyMDEyMA==",
lat: 60.239267,
lon: 24.852589
},
{
id: "U3RvcDpIU0w6MTQ2MzExOA==",
lat: 60.23293,
lon: 24.86311
},
{
id: "U3RvcDpIU0w6MTI5NDEyNA==",
lat: 60.227,
lon: 24.87358
},
{
id: "U3RvcDpIU0w6MTI5NDEyMg==",
lat: 60.22447,
lon: 24.87771
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mw==",
lat: 60.21865,
lon: 24.8815
},
{
id: "U3RvcDpIU0w6MTI5MTE4MQ==",
lat: 60.215735,
lon: 24.883378
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:1086N",
shortName: "86N",
longName: "Rautatientori-Kulosaari-Herttoniemi-Santahamina",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTUxMDEwNw==",
lat: 60.14598,
lon: 25.03965
},
{
id: "U3RvcDpIU0w6MTUxMDEwNg==",
lat: 60.15038,
lon: 25.04175
},
{
id: "U3RvcDpIU0w6MTUxMDEwNA==",
lat: 60.15213,
lon: 25.04598
},
{
id: "U3RvcDpIU0w6MTUxMDEwMg==",
lat: 60.15495,
lon: 25.04905
},
{
id: "U3RvcDpIU0w6MTQ5NTE1NQ==",
lat: 60.15924,
lon: 25.04944
},
{
id: "U3RvcDpIU0w6MTQ5NTE1Mw==",
lat: 60.16201,
lon: 25.04776
},
{
id: "U3RvcDpIU0w6MTQ5NTE1MQ==",
lat: 60.16595,
lon: 25.04883
},
{
id: "U3RvcDpIU0w6MTQ5MTEzNg==",
lat: 60.16864,
lon: 25.04855
},
{
id: "U3RvcDpIU0w6MTQ5MTEzNA==",
lat: 60.17222,
lon: 25.04957
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMg==",
lat: 60.176,
lon: 25.05177
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Ng==",
lat: 60.17938,
lon: 25.0509
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OA==",
lat: 60.18142,
lon: 25.05098
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNA==",
lat: 60.18299,
lon: 25.05049
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTE4Ng==",
lat: 60.19132,
lon: 25.01852
},
{
id: "U3RvcDpIU0w6MTQyMDEzNg==",
lat: 60.189673,
lon: 25.013165
},
{
id: "U3RvcDpIU0w6MTQyMDExMg==",
lat: 60.1883,
lon: 25.01494
},
{
id: "U3RvcDpIU0w6MTQyMDExMA==",
lat: 60.18561,
lon: 25.01493
},
{
id: "U3RvcDpIU0w6MTQyMDEwOA==",
lat: 60.18362,
lon: 25.01168
},
{
id: "U3RvcDpIU0w6MTQyMDEwNg==",
lat: 60.18426,
lon: 25.00509
},
{
id: "U3RvcDpIU0w6MTQyMDEwNA==",
lat: 60.18584,
lon: 25.00085
},
{
id: "U3RvcDpIU0w6MTQyMDEwMg==",
lat: 60.18566,
lon: 24.99588
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDEyMw==",
lat: 60.17134,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDEwMQ==",
lat: 60.18556,
lon: 24.99588
},
{
id: "U3RvcDpIU0w6MTQyMDEwMw==",
lat: 60.18505,
lon: 25.0021
},
{
id: "U3RvcDpIU0w6MTQyMDEwNQ==",
lat: 60.18404,
lon: 25.00604
},
{
id: "U3RvcDpIU0w6MTQyMDEwNw==",
lat: 60.1835,
lon: 25.01273
},
{
id: "U3RvcDpIU0w6MTQyMDEwOQ==",
lat: 60.1866,
lon: 25.01566
},
{
id: "U3RvcDpIU0w6MTQyMDExOQ==",
lat: 60.18839,
lon: 25.01582
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMw==",
lat: 60.18248,
lon: 25.05064
},
{
id: "U3RvcDpIU0w6MTQ5MTE1OA==",
lat: 60.181037,
lon: 25.050729
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Nw==",
lat: 60.17822,
lon: 25.05075
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMQ==",
lat: 60.17559,
lon: 25.05111
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMw==",
lat: 60.17203,
lon: 25.04925
},
{
id: "U3RvcDpIU0w6MTQ5NTE1MA==",
lat: 60.16595,
lon: 25.04848
},
{
id: "U3RvcDpIU0w6MTQ5NTE1Nw==",
lat: 60.16414,
lon: 25.04695
},
{
id: "U3RvcDpIU0w6MTQ5NTE1Mg==",
lat: 60.16151,
lon: 25.048
},
{
id: "U3RvcDpIU0w6MTQ5NTE1NA==",
lat: 60.15902,
lon: 25.04939
},
{
id: "U3RvcDpIU0w6MTUxMDEwMQ==",
lat: 60.1551,
lon: 25.04894
},
{
id: "U3RvcDpIU0w6MTUxMDEwMw==",
lat: 60.15202,
lon: 25.04565
},
{
id: "U3RvcDpIU0w6MTUxMDEwNQ==",
lat: 60.14938,
lon: 25.04102
}
]
},
{
gtfsId: "HSL:4572K",
shortName: "572K",
longName: "Mellunmäki-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MzIyMw==",
lat: 60.23831,
lon: 25.109
},
{
id: "U3RvcDpIU0w6NDkxMDIxNw==",
lat: 60.242165,
lon: 25.108975
},
{
id: "U3RvcDpIU0w6NDkxMDIxNQ==",
lat: 60.24494,
lon: 25.11149
},
{
id: "U3RvcDpIU0w6NDkxMDIwMw==",
lat: 60.24755,
lon: 25.11225
},
{
id: "U3RvcDpIU0w6NDkxMDIwNQ==",
lat: 60.251929,
lon: 25.112495
},
{
id: "U3RvcDpIU0w6NDkzMDIxMg==",
lat: 60.25641,
lon: 25.112
},
{
id: "U3RvcDpIU0w6NDkzMDIyMQ==",
lat: 60.2583,
lon: 25.103354
},
{
id: "U3RvcDpIU0w6NDkzMDIxOQ==",
lat: 60.25927,
lon: 25.10128
},
{
id: "U3RvcDpIU0w6NDkzMDIyOQ==",
lat: 60.26043,
lon: 25.09767
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDIxNQ==",
lat: 60.27901,
lon: 25.10592
},
{
id: "U3RvcDpIU0w6NDk0MDIxMw==",
lat: 60.28017,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDk0MDIxMQ==",
lat: 60.280871,
lon: 25.095651
},
{
id: "U3RvcDpIU0w6NDY0MDIxMA==",
lat: 60.28163,
lon: 25.08709
},
{
id: "U3RvcDpIU0w6NDY0MDIxNA==",
lat: 60.28231,
lon: 25.07849
},
{
id: "U3RvcDpIU0w6NDY0MDIwNA==",
lat: 60.28373,
lon: 25.07296
},
{
id: "U3RvcDpIU0w6NDY0MDIyNA==",
lat: 60.28498,
lon: 25.06687
},
{
id: "U3RvcDpIU0w6NDY0MDIyMg==",
lat: 60.28505,
lon: 25.06294
},
{
id: "U3RvcDpIU0w6NDY0MDIyMA==",
lat: 60.28623,
lon: 25.05673
},
{
id: "U3RvcDpIU0w6NDY0MDIxOA==",
lat: 60.28555,
lon: 25.0519
},
{
id: "U3RvcDpIU0w6NDY0MDIxNg==",
lat: 60.28301,
lon: 25.0481
},
{
id: "U3RvcDpIU0w6MTQwMTIyNA==",
lat: 60.28274,
lon: 25.02989
},
{
id: "U3RvcDpIU0w6MTQwMTIyNg==",
lat: 60.28564,
lon: 25.0146
},
{
id: "U3RvcDpIU0w6NDY4MDIzMA==",
lat: 60.28771,
lon: 24.99725
},
{
id: "U3RvcDpIU0w6NDY4MDI1NA==",
lat: 60.28873,
lon: 24.97839
},
{
id: "U3RvcDpIU0w6NDUyMDI2MQ==",
lat: 60.294818,
lon: 24.960031
},
{
id: "U3RvcDpIU0w6NDUxMDI2NA==",
lat: 60.295567,
lon: 24.958298
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDI1MQ==",
lat: 60.291725,
lon: 24.95261
},
{
id: "U3RvcDpIU0w6NDUxMDIyOA==",
lat: 60.293334,
lon: 24.946772
},
{
id: "U3RvcDpIU0w6NDUyMDIxNQ==",
lat: 60.29537,
lon: 24.94262
},
{
id: "U3RvcDpIU0w6NDUxMDI1OA==",
lat: 60.29672,
lon: 24.941369
},
{
id: "U3RvcDpIU0w6NDQxMDI5Ng==",
lat: 60.29726,
lon: 24.92992
},
{
id: "U3RvcDpIU0w6NDQxMDI5OA==",
lat: 60.297203,
lon: 24.916195
},
{
id: "U3RvcDpIU0w6NDQxMDIxNA==",
lat: 60.298535,
lon: 24.901062
},
{
id: "U3RvcDpIU0w6NDQxMDIwOQ==",
lat: 60.2983,
lon: 24.88306
},
{
id: "U3RvcDpIU0w6NDIxMDIwNA==",
lat: 60.2945,
lon: 24.86104
},
{
id: "U3RvcDpIU0w6NDIxMDIwMg==",
lat: 60.29251,
lon: 24.86391
},
{
id: "U3RvcDpIU0w6NDE4MDIyOA==",
lat: 60.28913,
lon: 24.86463
},
{
id: "U3RvcDpIU0w6NDE3MDI3OA==",
lat: 60.287244,
lon: 24.85855
},
{
id: "U3RvcDpIU0w6NDE3MDIzNA==",
lat: 60.28682,
lon: 24.85567
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxNQ==",
lat: 60.2772,
lon: 24.85298
},
{
id: "U3RvcDpIU0w6NDE3MDI5OQ==",
lat: 60.2753,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDE1MDI1OQ==",
lat: 60.27046,
lon: 24.854602
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDIwNQ==",
lat: 60.26146,
lon: 24.85579
},
{
id: "U3RvcDpIU0w6NDE1MDI2MA==",
lat: 60.26146,
lon: 24.85547
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxNg==",
lat: 60.270447,
lon: 24.855295
},
{
id: "U3RvcDpIU0w6NDE1MDIxNw==",
lat: 60.27172,
lon: 24.85481
},
{
id: "U3RvcDpIU0w6NDE3MDI5Mw==",
lat: 60.275267,
lon: 24.856513
},
{
id: "U3RvcDpIU0w6NDE3MDI0NQ==",
lat: 60.27746,
lon: 24.85363
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOQ==",
lat: 60.28544,
lon: 24.85111
},
{
id: "U3RvcDpIU0w6NDE3MDIzMw==",
lat: 60.28679,
lon: 24.85677
},
{
id: "U3RvcDpIU0w6NDE4MDIzMg==",
lat: 60.2876,
lon: 24.86121
},
{
id: "U3RvcDpIU0w6NDE4MDIyNw==",
lat: 60.28906,
lon: 24.86484
},
{
id: "U3RvcDpIU0w6NDE4MDIxMg==",
lat: 60.29113,
lon: 24.86663
},
{
id: "U3RvcDpIU0w6NDIxMDIwMQ==",
lat: 60.29308,
lon: 24.86341
},
{
id: "U3RvcDpIU0w6NDQxMDIwOA==",
lat: 60.29774,
lon: 24.88346
},
{
id: "U3RvcDpIU0w6NDQxMDIxMw==",
lat: 60.298287,
lon: 24.898963
},
{
id: "U3RvcDpIU0w6NDQxMDI5OQ==",
lat: 60.297001,
lon: 24.916547
},
{
id: "U3RvcDpIU0w6NDQxMDI5Nw==",
lat: 60.29677,
lon: 24.93165
},
{
id: "U3RvcDpIU0w6NDUxMDI0Nw==",
lat: 60.29464,
lon: 24.94259
},
{
id: "U3RvcDpIU0w6NDUxMDI1Mw==",
lat: 60.293552,
lon: 24.94809
},
{
id: "U3RvcDpIU0w6NDUxMDIxNQ==",
lat: 60.293698,
lon: 24.95222
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIwMg==",
lat: 60.29045,
lon: 24.96052
},
{
id: "U3RvcDpIU0w6NDUyMDI2Mw==",
lat: 60.293315,
lon: 24.963035
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mw==",
lat: 60.28874,
lon: 24.97647
},
{
id: "U3RvcDpIU0w6NDY4MDIyOQ==",
lat: 60.28726,
lon: 24.99786
},
{
id: "U3RvcDpIU0w6MTQwMTIyNQ==",
lat: 60.28472,
lon: 25.01564
},
{
id: "U3RvcDpIU0w6MTQwMTEyMw==",
lat: 60.28254,
lon: 25.02771
},
{
id: "U3RvcDpIU0w6NDY0MDIxNw==",
lat: 60.28283,
lon: 25.04819
},
{
id: "U3RvcDpIU0w6NDY0MDIxOQ==",
lat: 60.28581,
lon: 25.05395
},
{
id: "U3RvcDpIU0w6NDY0MDIyMQ==",
lat: 60.28585,
lon: 25.05881
},
{
id: "U3RvcDpIU0w6NDY0MDIyMw==",
lat: 60.28491,
lon: 25.06423
},
{
id: "U3RvcDpIU0w6NDY0MDIxNQ==",
lat: 60.2845,
lon: 25.06921
},
{
id: "U3RvcDpIU0w6NDY0MDIwMw==",
lat: 60.28311,
lon: 25.07438
},
{
id: "U3RvcDpIU0w6NDY0MDIwNw==",
lat: 60.28193,
lon: 25.0804
},
{
id: "U3RvcDpIU0w6NDY0MDIwOQ==",
lat: 60.28153,
lon: 25.0894
},
{
id: "U3RvcDpIU0w6NDk0MDIxMA==",
lat: 60.28073,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6NDk0MDIxMg==",
lat: 60.27969,
lon: 25.10342
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxOA==",
lat: 60.25851,
lon: 25.10222
},
{
id: "U3RvcDpIU0w6NDkzMDIyMA==",
lat: 60.25746,
lon: 25.10541
},
{
id: "U3RvcDpIU0w6NDkzMDIxMw==",
lat: 60.25612,
lon: 25.11173
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIxOA==",
lat: 60.24234,
lon: 25.10881
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
}
]
},
{
gtfsId: "HSL:4623",
shortName: "623",
longName: "Hakaniemi-Peijas",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTExMTExNw==",
lat: 60.179463,
lon: 24.952195
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDY4MDI1MQ==",
lat: 60.28629,
lon: 24.98319
},
{
id: "U3RvcDpIU0w6NDY4MDI0OQ==",
lat: 60.29431,
lon: 24.98431
},
{
id: "U3RvcDpIU0w6NDY4MDIxNw==",
lat: 60.29991,
lon: 24.98982
},
{
id: "U3RvcDpIU0w6NDY4MDI5OQ==",
lat: 60.30711,
lon: 24.99971
},
{
id: "U3RvcDpIU0w6NDY4MDIzMQ==",
lat: 60.3064,
lon: 25.00771
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIwMw==",
lat: 60.30689,
lon: 25.02499
},
{
id: "U3RvcDpIU0w6NDY1MDIwNQ==",
lat: 60.31,
lon: 25.0287
},
{
id: "U3RvcDpIU0w6NDY1MDIwNw==",
lat: 60.31132,
lon: 25.03142
},
{
id: "U3RvcDpIU0w6NDY1MDIwOQ==",
lat: 60.31516,
lon: 25.03566
},
{
id: "U3RvcDpIU0w6NDcwMDIwMQ==",
lat: 60.3203,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDcwMDIyOA==",
lat: 60.32246,
lon: 25.042177
},
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyMg==",
lat: 60.32129,
lon: 25.04674
},
{
id: "U3RvcDpIU0w6NDcwMDIxOQ==",
lat: 60.31986,
lon: 25.05256
},
{
id: "U3RvcDpIU0w6NDc0MDIyNA==",
lat: 60.31925,
lon: 25.06135
},
{
id: "U3RvcDpIU0w6NDc0MDIxNA==",
lat: 60.32079,
lon: 25.06203
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIxNg==",
lat: 60.33213,
lon: 25.06075
},
{
id: "U3RvcDpIU0w6NDcyMDIwOQ==",
lat: 60.33219,
lon: 25.06038
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNQ==",
lat: 60.32133,
lon: 25.06167
},
{
id: "U3RvcDpIU0w6NDc0MDIzMg==",
lat: 60.31914,
lon: 25.05967
},
{
id: "U3RvcDpIU0w6NDcwMDIyMw==",
lat: 60.32062,
lon: 25.05047
},
{
id: "U3RvcDpIU0w6NDcwMDIyNA==",
lat: 60.32183,
lon: 25.04486
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
},
{
id: "U3RvcDpIU0w6NDcwMDIyOQ==",
lat: 60.322323,
lon: 25.042012
},
{
id: "U3RvcDpIU0w6NDcwMDIwMg==",
lat: 60.31968,
lon: 25.03908
},
{
id: "U3RvcDpIU0w6NDY1MDIxMA==",
lat: 60.3149,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6NDY1MDIwOA==",
lat: 60.31072,
lon: 25.03015
},
{
id: "U3RvcDpIU0w6NDY1MDIwNg==",
lat: 60.30949,
lon: 25.02695
},
{
id: "U3RvcDpIU0w6NDY1MDIwNA==",
lat: 60.30635,
lon: 25.02439
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIyNA==",
lat: 60.30239,
lon: 25.02178
},
{
id: "U3RvcDpIU0w6NDY4MDIzNA==",
lat: 60.30681,
lon: 25.00587
},
{
id: "U3RvcDpIU0w6NDY4MDIzMw==",
lat: 60.30751,
lon: 24.99824
},
{
id: "U3RvcDpIU0w6NDY4MDIxOA==",
lat: 60.3012,
lon: 24.98972
},
{
id: "U3RvcDpIU0w6NDY4MDI1MA==",
lat: 60.29421,
lon: 24.98286
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mg==",
lat: 60.28722,
lon: 24.97696
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTE1MA==",
lat: 60.178205,
lon: 24.951532
}
]
},
{
gtfsId: "HSL:1074N",
shortName: "74N",
longName: "Rautatientori-Malmi-Tapanila-Puistola-Heikinlaakso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQxMjEzNA==",
lat: 60.27016,
lon: 25.07203
},
{
id: "U3RvcDpIU0w6MTQxMTExOQ==",
lat: 60.26989,
lon: 25.06314
},
{
id: "U3RvcDpIU0w6MTQxMTEyMg==",
lat: 60.26998,
lon: 25.0564
},
{
id: "U3RvcDpIU0w6MTQxMTEyNA==",
lat: 60.27112,
lon: 25.05116
},
{
id: "U3RvcDpIU0w6MTQxMTEwOQ==",
lat: 60.27147,
lon: 25.0461
},
{
id: "U3RvcDpIU0w6MTQxMTEwMQ==",
lat: 60.2738,
lon: 25.04459
},
{
id: "U3RvcDpIU0w6MTQxMTEzMA==",
lat: 60.27665,
lon: 25.03995
},
{
id: "U3RvcDpIU0w6MTQwMjE1MA==",
lat: 60.27665,
lon: 25.03432
},
{
id: "U3RvcDpIU0w6MTQwMjE1NQ==",
lat: 60.27502,
lon: 25.03549
},
{
id: "U3RvcDpIU0w6MTQwMjE1Nw==",
lat: 60.27136,
lon: 25.03385
},
{
id: "U3RvcDpIU0w6MTQwMjE3Mw==",
lat: 60.26816,
lon: 25.03245
},
{
id: "U3RvcDpIU0w6MTQwMjE3OQ==",
lat: 60.26814,
lon: 25.02993
},
{
id: "U3RvcDpIU0w6MTM5MjEzNg==",
lat: 60.26918,
lon: 25.02404
},
{
id: "U3RvcDpIU0w6MTM5MjE1NQ==",
lat: 60.265031,
lon: 25.025645
},
{
id: "U3RvcDpIU0w6MTM5MjE1MQ==",
lat: 60.26301,
lon: 25.02684
},
{
id: "U3RvcDpIU0w6MTM5MjE0OQ==",
lat: 60.26063,
lon: 25.02024
},
{
id: "U3RvcDpIU0w6MTM5MjE0Nw==",
lat: 60.2612,
lon: 25.01662
},
{
id: "U3RvcDpIU0w6MTM5MjE0NA==",
lat: 60.26226,
lon: 25.01209
},
{
id: "U3RvcDpIU0w6MTM5MTE4Nw==",
lat: 60.26077,
lon: 25.01166
},
{
id: "U3RvcDpIU0w6MTM5MjE1OA==",
lat: 60.25751,
lon: 25.01293
},
{
id: "U3RvcDpIU0w6MTM4MTE1Ng==",
lat: 60.25554,
lon: 25.01028
},
{
id: "U3RvcDpIU0w6MTM4MTE1NA==",
lat: 60.25391,
lon: 25.00898
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwMg==",
lat: 60.2502,
lon: 25.00917
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MzExNA==",
lat: 60.23859,
lon: 25.02095
},
{
id: "U3RvcDpIU0w6MTM4MzExMg==",
lat: 60.23595,
lon: 25.02177
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM2MzEwMQ==",
lat: 60.229313,
lon: 25.010037
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjEwNQ==",
lat: 60.22862,
lon: 25.01202
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEwOQ==",
lat: 60.232187,
lon: 25.011714
},
{
id: "U3RvcDpIU0w6MTM4MzExMQ==",
lat: 60.23676,
lon: 25.02225
},
{
id: "U3RvcDpIU0w6MTM4MjExMw==",
lat: 60.240179,
lon: 25.021039
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MTEwMQ==",
lat: 60.25004,
lon: 25.00946
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTE1Mw==",
lat: 60.25366,
lon: 25.00895
},
{
id: "U3RvcDpIU0w6MTM4MTE1NQ==",
lat: 60.2556,
lon: 25.01035
},
{
id: "U3RvcDpIU0w6MTM5MjE1Nw==",
lat: 60.25743,
lon: 25.0132
},
{
id: "U3RvcDpIU0w6MTM5MjE4OA==",
lat: 60.259736,
lon: 25.012365
},
{
id: "U3RvcDpIU0w6MTM5MjE0Mw==",
lat: 60.26215,
lon: 25.01222
},
{
id: "U3RvcDpIU0w6MTM5MjE0Ng==",
lat: 60.2608,
lon: 25.01763
},
{
id: "U3RvcDpIU0w6MTM5MjE0OA==",
lat: 60.26028,
lon: 25.02155
},
{
id: "U3RvcDpIU0w6MTM5MjE1MA==",
lat: 60.26313,
lon: 25.027
},
{
id: "U3RvcDpIU0w6MTM5MjEzOA==",
lat: 60.26512,
lon: 25.02579
},
{
id: "U3RvcDpIU0w6MTQwMjE4Mg==",
lat: 60.26934,
lon: 25.02538
},
{
id: "U3RvcDpIU0w6MTM5MjE4MA==",
lat: 60.26817,
lon: 25.02945
},
{
id: "U3RvcDpIU0w6MTQxMTE3NA==",
lat: 60.2688,
lon: 25.03293
},
{
id: "U3RvcDpIU0w6MTQwMjE1Ng==",
lat: 60.2721,
lon: 25.03447
},
{
id: "U3RvcDpIU0w6MTQwMjE1NA==",
lat: 60.27495,
lon: 25.03572
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mg==",
lat: 60.27697,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6MTQxMTEzMQ==",
lat: 60.27618,
lon: 25.04124
},
{
id: "U3RvcDpIU0w6MTQxMTEyOA==",
lat: 60.27443,
lon: 25.0443
},
{
id: "U3RvcDpIU0w6MTQxMTExMA==",
lat: 60.27135,
lon: 25.04662
},
{
id: "U3RvcDpIU0w6MTQxMTEyNQ==",
lat: 60.27072,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQxMTEyMw==",
lat: 60.2701,
lon: 25.05879
},
{
id: "U3RvcDpIU0w6MTQxMjEyMA==",
lat: 60.26962,
lon: 25.06454
}
]
},
{
gtfsId: "HSL:4624",
shortName: "624",
longName: "Tikkurila-Ilola-Leinelä-Koivukylä-Havukoski-Päiväkumpu",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDc1MDIxNw==",
lat: 60.31596,
lon: 25.10011
},
{
id: "U3RvcDpIU0w6NDc1MDIwOA==",
lat: 60.31848,
lon: 25.09669
},
{
id: "U3RvcDpIU0w6NDc1MDIxMA==",
lat: 60.3206,
lon: 25.09284
},
{
id: "U3RvcDpIU0w6NDc1MDIxMg==",
lat: 60.32134,
lon: 25.0874
},
{
id: "U3RvcDpIU0w6NDc0MDI0NA==",
lat: 60.321734,
lon: 25.081964
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIwMg==",
lat: 60.32423,
lon: 25.07576
},
{
id: "U3RvcDpIU0w6NDc0MDIxOQ==",
lat: 60.32487,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIzNQ==",
lat: 60.32494,
lon: 25.06439
},
{
id: "U3RvcDpIU0w6NDc0MDIxNw==",
lat: 60.32322,
lon: 25.06293
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcyMDIyNw==",
lat: 60.325038,
lon: 25.050357
},
{
id: "U3RvcDpIU0w6NDcwMDIzMg==",
lat: 60.326547,
lon: 25.0421
},
{
id: "U3RvcDpIU0w6NDcwMDIzMw==",
lat: 60.325487,
lon: 25.041647
},
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyNQ==",
lat: 60.32362,
lon: 25.03701
},
{
id: "U3RvcDpIU0w6NDcxMDIwOA==",
lat: 60.32624,
lon: 25.02493
},
{
id: "U3RvcDpIU0w6NDcxMDIxOA==",
lat: 60.32946,
lon: 25.02685
},
{
id: "U3RvcDpIU0w6NDcxMDIzOA==",
lat: 60.33382,
lon: 25.02609
},
{
id: "U3RvcDpIU0w6NDcxMDI0MQ==",
lat: 60.332301,
lon: 25.019994
},
{
id: "U3RvcDpIU0w6NDcxMDIyMg==",
lat: 60.33269,
lon: 25.01633
},
{
id: "U3RvcDpIU0w6NDcxMDIyOQ==",
lat: 60.33346,
lon: 25.01295
},
{
id: "U3RvcDpIU0w6NDcxMDIyOA==",
lat: 60.33221,
lon: 25.00904
},
{
id: "U3RvcDpIU0w6NDcxMDIyNw==",
lat: 60.33016,
lon: 25.00643
},
{
id: "U3RvcDpIU0w6NDcxMDIyNg==",
lat: 60.3295,
lon: 25.00469
},
{
id: "U3RvcDpIU0w6NDY3MDIxOA==",
lat: 60.32319,
lon: 25.00773
},
{
id: "U3RvcDpIU0w6NDY3MDIxMw==",
lat: 60.32259,
lon: 25.0127
},
{
id: "U3RvcDpIU0w6NDY3MDIxMQ==",
lat: 60.31772,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDY3MDIwNg==",
lat: 60.31488,
lon: 25.01453
},
{
id: "U3RvcDpIU0w6NDY3MDIwOA==",
lat: 60.31332,
lon: 25.01609
},
{
id: "U3RvcDpIU0w6NDY1MDIxMg==",
lat: 60.30758,
lon: 25.02169
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIwNw==",
lat: 60.30182,
lon: 25.02328
},
{
id: "U3RvcDpIU0w6NDYzMDIyNQ==",
lat: 60.30021,
lon: 25.02911
},
{
id: "U3RvcDpIU0w6NDYzMDIwOQ==",
lat: 60.299,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6NDYxMDIwOQ==",
lat: 60.2969,
lon: 25.03573
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI1Mw==",
lat: 60.294111,
lon: 25.044463
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIyOA==",
lat: 60.29661,
lon: 25.03844
},
{
id: "U3RvcDpIU0w6NDYxMDIzMQ==",
lat: 60.29765,
lon: 25.03472
},
{
id: "U3RvcDpIU0w6NDYzMDIxMA==",
lat: 60.29964,
lon: 25.03247
},
{
id: "U3RvcDpIU0w6NDYzMDIyNg==",
lat: 60.30105,
lon: 25.02662
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIxMQ==",
lat: 60.30783,
lon: 25.02128
},
{
id: "U3RvcDpIU0w6NDY3MDIwOQ==",
lat: 60.31333,
lon: 25.01636
},
{
id: "U3RvcDpIU0w6NDY3MDIxMA==",
lat: 60.3158,
lon: 25.01389
},
{
id: "U3RvcDpIU0w6NDY3MDIxMg==",
lat: 60.3198,
lon: 25.01384
},
{
id: "U3RvcDpIU0w6NDY3MDIxOQ==",
lat: 60.32314,
lon: 25.01208
},
{
id: "U3RvcDpIU0w6NDY3MDIxNw==",
lat: 60.3234,
lon: 25.00589
},
{
id: "U3RvcDpIU0w6NDcxMDIwNQ==",
lat: 60.32397,
lon: 25.00108
},
{
id: "U3RvcDpIU0w6NDcxMDIwMQ==",
lat: 60.33262,
lon: 25.00988
},
{
id: "U3RvcDpIU0w6NDcxMDIyMw==",
lat: 60.33363,
lon: 25.01447
},
{
id: "U3RvcDpIU0w6NDcxMDIyMQ==",
lat: 60.33191,
lon: 25.01751
},
{
id: "U3RvcDpIU0w6NDcxMDI0MA==",
lat: 60.332042,
lon: 25.019907
},
{
id: "U3RvcDpIU0w6NDcxMDIzOQ==",
lat: 60.33326,
lon: 25.02735
},
{
id: "U3RvcDpIU0w6NDcxMDIxNw==",
lat: 60.32983,
lon: 25.02648
},
{
id: "U3RvcDpIU0w6NDcxMDIwOQ==",
lat: 60.32633,
lon: 25.02468
},
{
id: "U3RvcDpIU0w6NDcwMDIyNw==",
lat: 60.32441,
lon: 25.02678
},
{
id: "U3RvcDpIU0w6NDcwMDIyNg==",
lat: 60.32334,
lon: 25.03762
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
},
{
id: "U3RvcDpIU0w6NDcwMDIzNA==",
lat: 60.325902,
lon: 25.041882
},
{
id: "U3RvcDpIU0w6NDcyMDIyNQ==",
lat: 60.326482,
lon: 25.043723
},
{
id: "U3RvcDpIU0w6NDcwMDIwNw==",
lat: 60.3246,
lon: 25.05219
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNg==",
lat: 60.3233,
lon: 25.06344
},
{
id: "U3RvcDpIU0w6NDc0MDIxOA==",
lat: 60.32491,
lon: 25.06624
},
{
id: "U3RvcDpIU0w6NDc0MDIwMQ==",
lat: 60.32424,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIzMQ==",
lat: 60.32183,
lon: 25.08353
},
{
id: "U3RvcDpIU0w6NDc1MDIxMQ==",
lat: 60.32087,
lon: 25.08958
},
{
id: "U3RvcDpIU0w6NDc1MDIwOQ==",
lat: 60.31961,
lon: 25.09455
},
{
id: "U3RvcDpIU0w6NDc1MDIxMw==",
lat: 60.31788,
lon: 25.09712
},
{
id: "U3RvcDpIU0w6NDc1MDIyMg==",
lat: 60.31618,
lon: 25.09939
}
]
},
{
gtfsId: "HSL:4625",
shortName: "625",
longName: "Leinelä-Koivukylä-Peijas-Rekolanmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyMg==",
lat: 60.32129,
lon: 25.04674
},
{
id: "U3RvcDpIU0w6NDcwMDIxOQ==",
lat: 60.31986,
lon: 25.05256
},
{
id: "U3RvcDpIU0w6NDc0MDIyNA==",
lat: 60.31925,
lon: 25.06135
},
{
id: "U3RvcDpIU0w6NDc0MDIxNA==",
lat: 60.32079,
lon: 25.06203
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIxNg==",
lat: 60.33213,
lon: 25.06075
},
{
id: "U3RvcDpIU0w6NDcyMDIxNw==",
lat: 60.33215,
lon: 25.05751
},
{
id: "U3RvcDpIU0w6NDcyMDIzMQ==",
lat: 60.332118,
lon: 25.056088
},
{
id: "U3RvcDpIU0w6NDcyMDIxMg==",
lat: 60.33666,
lon: 25.05582
},
{
id: "U3RvcDpIU0w6NDcyMDIxOQ==",
lat: 60.33667,
lon: 25.05415
},
{
id: "U3RvcDpIU0w6NDcyMDIxNQ==",
lat: 60.33665,
lon: 25.054
},
{
id: "U3RvcDpIU0w6NDcyMDIzMg==",
lat: 60.331996,
lon: 25.055948
},
{
id: "U3RvcDpIU0w6NDcyMDIwOQ==",
lat: 60.33219,
lon: 25.06038
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNQ==",
lat: 60.32133,
lon: 25.06167
},
{
id: "U3RvcDpIU0w6NDc0MDIzMg==",
lat: 60.31914,
lon: 25.05967
},
{
id: "U3RvcDpIU0w6NDcwMDIyMw==",
lat: 60.32062,
lon: 25.05047
},
{
id: "U3RvcDpIU0w6NDcwMDIyNA==",
lat: 60.32183,
lon: 25.04486
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
}
]
},
{
gtfsId: "HSL:7192V",
shortName: "192V",
longName: "Kamppi-Länsiväylä(-Inkoo)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwNDAwMA==",
lat: 60.094333,
lon: 24.242655
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNzAwNA==",
lat: 60.099132,
lon: 24.303275
},
{
id: "U3RvcDpIU0w6NjMwNzAwOA==",
lat: 60.099232,
lon: 24.331415
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNA==",
lat: 60.106061,
lon: 24.371492
},
{
id: "U3RvcDpIU0w6NjA1MDIwNQ==",
lat: 60.110392,
lon: 24.384672
},
{
id: "U3RvcDpIU0w6NjA0MDIwOQ==",
lat: 60.114941,
lon: 24.414073
},
{
id: "U3RvcDpIU0w6NjA0MDIxMg==",
lat: 60.115939,
lon: 24.426609
},
{
id: "U3RvcDpIU0w6NjA0MDIxMQ==",
lat: 60.1159,
lon: 24.4454
},
{
id: "U3RvcDpIU0w6NjA0MDIxNQ==",
lat: 60.119058,
lon: 24.4813
},
{
id: "U3RvcDpIU0w6NjAzMDIwMQ==",
lat: 60.133472,
lon: 24.512763
},
{
id: "U3RvcDpIU0w6NjAzMDIzMg==",
lat: 60.13751,
lon: 24.537388
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTMxMDI5OQ==",
lat: 60.16235,
lon: 24.86092
},
{
id: "U3RvcDpIU0w6MTMxMDIyNQ==",
lat: 60.1614,
lon: 24.87051
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTEzMDExMg==",
lat: 60.16818,
lon: 24.923302
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDExMw==",
lat: 60.170862,
lon: 24.930898
},
{
id: "U3RvcDpIU0w6MTEzMDExNQ==",
lat: 60.168485,
lon: 24.923568
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MTMxMDEyNA==",
lat: 60.16161,
lon: 24.8697
},
{
id: "U3RvcDpIU0w6MTMxMDE5OA==",
lat: 60.16256,
lon: 24.86046
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDIwMg==",
lat: 60.147525,
lon: 24.572943
},
{
id: "U3RvcDpIU0w6NjAzMDIwNg==",
lat: 60.137865,
lon: 24.532207
},
{
id: "U3RvcDpIU0w6NjAzMDIwMg==",
lat: 60.133613,
lon: 24.509142
},
{
id: "U3RvcDpIU0w6NjA0MDIxNg==",
lat: 60.119052,
lon: 24.477277
},
{
id: "U3RvcDpIU0w6NjA0MDIxNA==",
lat: 60.117086,
lon: 24.44276
},
{
id: "U3RvcDpIU0w6NjA0MDIxMw==",
lat: 60.116116,
lon: 24.426538
},
{
id: "U3RvcDpIU0w6NjA0MDIxMA==",
lat: 60.114838,
lon: 24.411756
},
{
id: "U3RvcDpIU0w6NjA1MDIwNg==",
lat: 60.110009,
lon: 24.382306
},
{
id: "U3RvcDpIU0w6NjA1MDIwMw==",
lat: 60.105278,
lon: 24.369337
},
{
id: "U3RvcDpIU0w6NjA1MDIwMg==",
lat: 60.103433,
lon: 24.364292
},
{
id: "U3RvcDpIU0w6NjA3MDIyOQ==",
lat: 60.101495,
lon: 24.345007
},
{
id: "U3RvcDpIU0w6NjMwNzAwNw==",
lat: 60.09886,
lon: 24.329275
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwMQ==",
lat: 60.094172,
lon: 24.241083
}
]
},
{
gtfsId: "HSL:7955A",
shortName: "955A",
longName: "Kivistön asema - Nurmijärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDMxMDIxMQ==",
lat: 60.373678,
lon: 24.80553
},
{
id: "U3RvcDpIU0w6NDMxMDIwOQ==",
lat: 60.360498,
lon: 24.807107
},
{
id: "U3RvcDpIU0w6NDMxMDIxNw==",
lat: 60.35337,
lon: 24.8067
},
{
id: "U3RvcDpIU0w6NDMxMDIwNw==",
lat: 60.34856,
lon: 24.80956
},
{
id: "U3RvcDpIU0w6NDIyMDIwNQ==",
lat: 60.33948,
lon: 24.81517
},
{
id: "U3RvcDpIU0w6NDIyMDIyNg==",
lat: 60.33248,
lon: 24.81876
},
{
id: "U3RvcDpIU0w6NDIyMDIyNA==",
lat: 60.326475,
lon: 24.825953
},
{
id: "U3RvcDpIU0w6NDIyMDIyMg==",
lat: 60.321574,
lon: 24.832355
},
{
id: "U3RvcDpIU0w6NDIyMDIyMA==",
lat: 60.316123,
lon: 24.841106
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0NQ==",
lat: 60.314149,
lon: 24.844845
},
{
id: "U3RvcDpIU0w6NDIyMDIyMQ==",
lat: 60.31705,
lon: 24.83873
},
{
id: "U3RvcDpIU0w6NDIyMDIyMw==",
lat: 60.322198,
lon: 24.831557
},
{
id: "U3RvcDpIU0w6NDIyMDIyNQ==",
lat: 60.32778,
lon: 24.8256
},
{
id: "U3RvcDpIU0w6NDIyMDIyNw==",
lat: 60.333449,
lon: 24.81792
},
{
id: "U3RvcDpIU0w6NDIyMDIwNA==",
lat: 60.33848,
lon: 24.81626
},
{
id: "U3RvcDpIU0w6NDMxMDIwOA==",
lat: 60.34986,
lon: 24.80924
},
{
id: "U3RvcDpIU0w6NDMxMDIxOA==",
lat: 60.356043,
lon: 24.807018
},
{
id: "U3RvcDpIU0w6NDMxMDIxMA==",
lat: 60.360961,
lon: 24.807177
},
{
id: "U3RvcDpIU0w6NDMxMDIxMg==",
lat: 60.374543,
lon: 24.805901
}
]
},
{
gtfsId: "HSL:7192T",
shortName: "192T",
longName: "Kamppi-Länsiväylä(-Inkoo)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTEyOQ==",
lat: 60.16436,
lon: 24.91112
},
{
id: "U3RvcDpIU0w6MTIwMTEzMQ==",
lat: 60.16338,
lon: 24.9044
},
{
id: "U3RvcDpIU0w6MTMxMDEwMQ==",
lat: 60.16126,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMxMDEwNQ==",
lat: 60.16055,
lon: 24.87946
},
{
id: "U3RvcDpIU0w6MTMxMDEyNA==",
lat: 60.16161,
lon: 24.8697
},
{
id: "U3RvcDpIU0w6MTMxMDE5OA==",
lat: 60.16256,
lon: 24.86046
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDIwMg==",
lat: 60.147525,
lon: 24.572943
},
{
id: "U3RvcDpIU0w6NjAzMDIwNg==",
lat: 60.137865,
lon: 24.532207
},
{
id: "U3RvcDpIU0w6NjAzMDIwMg==",
lat: 60.133613,
lon: 24.509142
},
{
id: "U3RvcDpIU0w6NjA0MDIxNg==",
lat: 60.119052,
lon: 24.477277
},
{
id: "U3RvcDpIU0w6NjA0MDIxNA==",
lat: 60.117086,
lon: 24.44276
},
{
id: "U3RvcDpIU0w6NjA0MDIxMw==",
lat: 60.116116,
lon: 24.426538
},
{
id: "U3RvcDpIU0w6NjA0MDIxMA==",
lat: 60.114838,
lon: 24.411756
},
{
id: "U3RvcDpIU0w6NjA1MDIwNg==",
lat: 60.110009,
lon: 24.382306
},
{
id: "U3RvcDpIU0w6NjA1MDIwMw==",
lat: 60.105278,
lon: 24.369337
},
{
id: "U3RvcDpIU0w6NjA1MDIwMg==",
lat: 60.103433,
lon: 24.364292
},
{
id: "U3RvcDpIU0w6NjA3MDIyOQ==",
lat: 60.101495,
lon: 24.345007
},
{
id: "U3RvcDpIU0w6NjMwNzAwNw==",
lat: 60.09886,
lon: 24.329275
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwMQ==",
lat: 60.094172,
lon: 24.241083
},
{
id: "U3RvcDpIU0w6NjMwNDAwMA==",
lat: 60.094333,
lon: 24.242655
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNzAwNA==",
lat: 60.099132,
lon: 24.303275
},
{
id: "U3RvcDpIU0w6NjMwNzAwOA==",
lat: 60.099232,
lon: 24.331415
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNA==",
lat: 60.106061,
lon: 24.371492
},
{
id: "U3RvcDpIU0w6NjA1MDIwNQ==",
lat: 60.110392,
lon: 24.384672
},
{
id: "U3RvcDpIU0w6NjA0MDIwOQ==",
lat: 60.114941,
lon: 24.414073
},
{
id: "U3RvcDpIU0w6NjA0MDIxMg==",
lat: 60.115939,
lon: 24.426609
},
{
id: "U3RvcDpIU0w6NjA0MDIxMQ==",
lat: 60.1159,
lon: 24.4454
},
{
id: "U3RvcDpIU0w6NjA0MDIxNQ==",
lat: 60.119058,
lon: 24.4813
},
{
id: "U3RvcDpIU0w6NjAzMDIwMQ==",
lat: 60.133472,
lon: 24.512763
},
{
id: "U3RvcDpIU0w6NjAzMDIzMg==",
lat: 60.13751,
lon: 24.537388
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTMxMDI5OQ==",
lat: 60.16235,
lon: 24.86092
},
{
id: "U3RvcDpIU0w6MTMxMDIyNQ==",
lat: 60.1614,
lon: 24.87051
},
{
id: "U3RvcDpIU0w6MTMxMDEwNg==",
lat: 60.160297,
lon: 24.881277
},
{
id: "U3RvcDpIU0w6MTMxMDEwMg==",
lat: 60.16113,
lon: 24.89116
},
{
id: "U3RvcDpIU0w6MTIwMTEzMg==",
lat: 60.16338,
lon: 24.90505
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:2582V",
shortName: "582V",
longName: "Espoon keskus-Juvanmalmi-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOA==",
lat: 60.27823,
lon: 24.75086
},
{
id: "U3RvcDpIU0w6MjcxNTIzNg==",
lat: 60.27871,
lon: 24.75894
},
{
id: "U3RvcDpIU0w6MjcxNTIzNA==",
lat: 60.2784,
lon: 24.76146
},
{
id: "U3RvcDpIU0w6MjcxNTIzMQ==",
lat: 60.2743,
lon: 24.76071
},
{
id: "U3RvcDpIU0w6MjcxNTI5NQ==",
lat: 60.269782,
lon: 24.755897
},
{
id: "U3RvcDpIU0w6MjcxNTIxMA==",
lat: 60.26655,
lon: 24.74574
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMzIxOQ==",
lat: 60.26278,
lon: 24.73192
},
{
id: "U3RvcDpIU0w6MjcxMzIxNg==",
lat: 60.25885,
lon: 24.73459
},
{
id: "U3RvcDpIU0w6MjcxMzIwOA==",
lat: 60.25466,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjcxMzIwNg==",
lat: 60.25333,
lon: 24.73323
},
{
id: "U3RvcDpIU0w6MjcxMzIwNA==",
lat: 60.25327,
lon: 24.72461
},
{
id: "U3RvcDpIU0w6MjcxMzIwMg==",
lat: 60.25185,
lon: 24.7206
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI1OA==",
lat: 60.23912,
lon: 24.70695
},
{
id: "U3RvcDpIU0w6MjYzMjI1OQ==",
lat: 60.23785,
lon: 24.70422
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mg==",
lat: 60.23498,
lon: 24.70481
},
{
id: "U3RvcDpIU0w6MjYzMjI0MQ==",
lat: 60.23238,
lon: 24.69878
},
{
id: "U3RvcDpIU0w6MjYzMjIzOQ==",
lat: 60.23077,
lon: 24.69602
},
{
id: "U3RvcDpIU0w6MjYzMjIzNw==",
lat: 60.22856,
lon: 24.69157
},
{
id: "U3RvcDpIU0w6MjYzMjIzNQ==",
lat: 60.22592,
lon: 24.68556
},
{
id: "U3RvcDpIU0w6MjYzMjIzMw==",
lat: 60.22548,
lon: 24.68117
},
{
id: "U3RvcDpIU0w6MjYzMjI3Mw==",
lat: 60.22305,
lon: 24.67722
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
},
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMjIzMg==",
lat: 60.22308,
lon: 24.6774
},
{
id: "U3RvcDpIU0w6MjYzMjIzNA==",
lat: 60.22558,
lon: 24.68211
},
{
id: "U3RvcDpIU0w6MjYzMjIzNg==",
lat: 60.22601,
lon: 24.68628
},
{
id: "U3RvcDpIU0w6MjYzMjIzOA==",
lat: 60.229,
lon: 24.69282
},
{
id: "U3RvcDpIU0w6MjYzMjI0MA==",
lat: 60.23172,
lon: 24.69809
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mw==",
lat: 60.23605,
lon: 24.7054
},
{
id: "U3RvcDpIU0w6MjYzMjI2MA==",
lat: 60.23844,
lon: 24.70498
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjcxMzIwMQ==",
lat: 60.25237,
lon: 24.72199
},
{
id: "U3RvcDpIU0w6MjcxMzIwMw==",
lat: 60.25325,
lon: 24.72546
},
{
id: "U3RvcDpIU0w6MjcxMzIwNQ==",
lat: 60.25329,
lon: 24.73325
},
{
id: "U3RvcDpIU0w6MjcxMzIwNw==",
lat: 60.25473,
lon: 24.73674
},
{
id: "U3RvcDpIU0w6MjcxMzIxNw==",
lat: 60.25984,
lon: 24.73473
},
{
id: "U3RvcDpIU0w6MjcxMzIxOA==",
lat: 60.2639,
lon: 24.73096
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxOA==",
lat: 60.26626,
lon: 24.73717
},
{
id: "U3RvcDpIU0w6MjcxNTI5Mw==",
lat: 60.26702,
lon: 24.74761
},
{
id: "U3RvcDpIU0w6MjcxNTI5NA==",
lat: 60.26969,
lon: 24.75626
},
{
id: "U3RvcDpIU0w6MjcxNTIyOQ==",
lat: 60.27164,
lon: 24.76011
},
{
id: "U3RvcDpIU0w6MjcxNTIzMg==",
lat: 60.275,
lon: 24.76107
},
{
id: "U3RvcDpIU0w6MjcxNTIzMw==",
lat: 60.278,
lon: 24.76154
},
{
id: "U3RvcDpIU0w6MjcxNTIzNQ==",
lat: 60.27888,
lon: 24.7575
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
}
]
},
{
gtfsId: "HSL:4444T",
shortName: "444T",
longName: "Kivistö-Katriinan sairaala-Tapola-Pirttiranta-Riipilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIzMDIzMw==",
lat: 60.318549,
lon: 24.85235
},
{
id: "U3RvcDpIU0w6NDIzMDIzNw==",
lat: 60.320869,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDIzMDI0MQ==",
lat: 60.322051,
lon: 24.853239
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mw==",
lat: 60.323765,
lon: 24.850455
},
{
id: "U3RvcDpIU0w6NDIzMDIyMQ==",
lat: 60.32615,
lon: 24.8498
},
{
id: "U3RvcDpIU0w6NDIzMDIyMw==",
lat: 60.32798,
lon: 24.85087
},
{
id: "U3RvcDpIU0w6NDIzMDIyOQ==",
lat: 60.32945,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDIzMDIzMQ==",
lat: 60.3282,
lon: 24.85841
},
{
id: "U3RvcDpIU0w6NDI0MDIwNw==",
lat: 60.331,
lon: 24.86291
},
{
id: "U3RvcDpIU0w6NDI0MDIxNw==",
lat: 60.33357,
lon: 24.86305
},
{
id: "U3RvcDpIU0w6NDI0MDIwOQ==",
lat: 60.3372,
lon: 24.86399
},
{
id: "U3RvcDpIU0w6NDI0MDIxOQ==",
lat: 60.34067,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6NDI0MDIxMQ==",
lat: 60.34244,
lon: 24.86512
},
{
id: "U3RvcDpIU0w6NDMzMDIwMw==",
lat: 60.34775,
lon: 24.86668
},
{
id: "U3RvcDpIU0w6NDMzMDIxNA==",
lat: 60.34691,
lon: 24.87292
},
{
id: "U3RvcDpIU0w6NDMzMDIxMw==",
lat: 60.34795,
lon: 24.87113
},
{
id: "U3RvcDpIU0w6NDMzMDIxNQ==",
lat: 60.34813,
lon: 24.86503
},
{
id: "U3RvcDpIU0w6NDMzMDI5OQ==",
lat: 60.34883,
lon: 24.86176
},
{
id: "U3RvcDpIU0w6NDMzMDI5Ng==",
lat: 60.34762,
lon: 24.85347
},
{
id: "U3RvcDpIU0w6NDMzMDIxMA==",
lat: 60.34686,
lon: 24.84891
},
{
id: "U3RvcDpIU0w6NDMzMDIwOQ==",
lat: 60.348902,
lon: 24.846898
},
{
id: "U3RvcDpIU0w6NDMyMDIxOQ==",
lat: 60.357675,
lon: 24.842062
},
{
id: "U3RvcDpIU0w6NDMzMDIyMg==",
lat: 60.34392,
lon: 24.83582
},
{
id: "U3RvcDpIU0w6NDMzMDIyMw==",
lat: 60.34246,
lon: 24.83135
},
{
id: "U3RvcDpIU0w6NDMzMDIyMQ==",
lat: 60.3441,
lon: 24.83743
},
{
id: "U3RvcDpIU0w6NDMzMDIyNQ==",
lat: 60.34566,
lon: 24.83892
},
{
id: "U3RvcDpIU0w6NDMzMDIxMQ==",
lat: 60.34946,
lon: 24.84485
},
{
id: "U3RvcDpIU0w6NDMzMDI5Nw==",
lat: 60.34658,
lon: 24.85121
},
{
id: "U3RvcDpIU0w6NDMzMDI5NA==",
lat: 60.34842,
lon: 24.8547
},
{
id: "U3RvcDpIU0w6NDMzMDIyNw==",
lat: 60.353985,
lon: 24.854893
},
{
id: "U3RvcDpIU0w6NDMzMDIyNA==",
lat: 60.35432,
lon: 24.84972
},
{
id: "U3RvcDpIU0w6NDMzMDIxOQ==",
lat: 60.35829,
lon: 24.85868
},
{
id: "U3RvcDpIU0w6NDMyMDIwMQ==",
lat: 60.36364,
lon: 24.85535
},
{
id: "U3RvcDpIU0w6NDMyMDIwMw==",
lat: 60.36424,
lon: 24.85039
},
{
id: "U3RvcDpIU0w6NDMyMDIxNQ==",
lat: 60.3687,
lon: 24.85191
},
{
id: "U3RvcDpIU0w6NDMyMDIwNg==",
lat: 60.36546,
lon: 24.84818
},
{
id: "U3RvcDpIU0w6NDMyMDIwNA==",
lat: 60.36372,
lon: 24.85136
},
{
id: "U3RvcDpIU0w6NDMyMDIwMg==",
lat: 60.36268,
lon: 24.85646
},
{
id: "U3RvcDpIU0w6NDMzMDIyOA==",
lat: 60.3539,
lon: 24.854886
},
{
id: "U3RvcDpIU0w6NDMzMDI5OA==",
lat: 60.34859,
lon: 24.8611
},
{
id: "U3RvcDpIU0w6NDMzMDIxNg==",
lat: 60.34705,
lon: 24.87288
},
{
id: "U3RvcDpIU0w6NDMzMDIwMg==",
lat: 60.34726,
lon: 24.86524
},
{
id: "U3RvcDpIU0w6NDI0MDIxMg==",
lat: 60.34255,
lon: 24.8648
},
{
id: "U3RvcDpIU0w6NDI0MDIwMg==",
lat: 60.33933,
lon: 24.86453
},
{
id: "U3RvcDpIU0w6NDI0MDIxMA==",
lat: 60.33669,
lon: 24.86352
},
{
id: "U3RvcDpIU0w6NDI0MDIxOA==",
lat: 60.33296,
lon: 24.86257
},
{
id: "U3RvcDpIU0w6NDI0MDIwOA==",
lat: 60.33036,
lon: 24.86273
},
{
id: "U3RvcDpIU0w6NDIzMDIzMg==",
lat: 60.32947,
lon: 24.8619
},
{
id: "U3RvcDpIU0w6NDIzMDIzMA==",
lat: 60.32875,
lon: 24.85569
},
{
id: "U3RvcDpIU0w6NDIzMDIyNg==",
lat: 60.32921,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDIzMDIyNA==",
lat: 60.32753,
lon: 24.85013
},
{
id: "U3RvcDpIU0w6NDIzMDIyMg==",
lat: 60.32522,
lon: 24.84962
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mg==",
lat: 60.323571,
lon: 24.851449
},
{
id: "U3RvcDpIU0w6NDIzMDI0MA==",
lat: 60.321997,
lon: 24.85308
},
{
id: "U3RvcDpIU0w6NDIzMDIzNg==",
lat: 60.320142,
lon: 24.855659
},
{
id: "U3RvcDpIU0w6NDIzMDIzNA==",
lat: 60.317929,
lon: 24.850801
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
}
]
},
{
gtfsId: "HSL:2147A",
shortName: "147A",
longName: "Kamppi-Espoonlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQxMzI1OA==",
lat: 60.151653,
lon: 24.65062
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxNDI3MA==",
lat: 60.14773,
lon: 24.64054
},
{
id: "U3RvcDpIU0w6MjQxNDI2OA==",
lat: 60.144918,
lon: 24.640847
},
{
id: "U3RvcDpIU0w6MjQxNDI1NQ==",
lat: 60.14423,
lon: 24.64796
},
{
id: "U3RvcDpIU0w6MjQxMTI1NA==",
lat: 60.14538,
lon: 24.65272
},
{
id: "U3RvcDpIU0w6MjQxNDIxOQ==",
lat: 60.14549,
lon: 24.65467
},
{
id: "U3RvcDpIU0w6MjQxNDI2NQ==",
lat: 60.14119,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjQxMjIyMQ==",
lat: 60.13965,
lon: 24.65853
},
{
id: "U3RvcDpIU0w6MjQxMjIyMw==",
lat: 60.14108,
lon: 24.66475
},
{
id: "U3RvcDpIU0w6MjQxMjIyNQ==",
lat: 60.14215,
lon: 24.66883
},
{
id: "U3RvcDpIU0w6MjQxMjIyNw==",
lat: 60.143373,
lon: 24.673594
},
{
id: "U3RvcDpIU0w6MjQxMTIyMg==",
lat: 60.14697,
lon: 24.67084
},
{
id: "U3RvcDpIU0w6MjQxMTIyNQ==",
lat: 60.15011,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNg==",
lat: 60.15236,
lon: 24.66626
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
},
{
id: "U3RvcDpIU0w6MTA0MDI4MA==",
lat: 60.1689,
lon: 24.93128
},
{
id: "U3RvcDpIU0w6MTA0MDIzMQ==",
lat: 60.16622,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNA==",
lat: 60.16976,
lon: 24.8242
},
{
id: "U3RvcDpIU0w6MjIxMTI5MA==",
lat: 60.17025,
lon: 24.81115
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIyNA==",
lat: 60.15183,
lon: 24.66506
},
{
id: "U3RvcDpIU0w6MjQxMTIyMw==",
lat: 60.14627,
lon: 24.67182
},
{
id: "U3RvcDpIU0w6MjQxMjIyOA==",
lat: 60.143279,
lon: 24.672656
},
{
id: "U3RvcDpIU0w6MjQxMjIyNg==",
lat: 60.142484,
lon: 24.669383
},
{
id: "U3RvcDpIU0w6MjQxMjIyNA==",
lat: 60.14102,
lon: 24.66353
},
{
id: "U3RvcDpIU0w6MjQxMjIyMg==",
lat: 60.13979,
lon: 24.65859
},
{
id: "U3RvcDpIU0w6MjQxMTI2NA==",
lat: 60.14202,
lon: 24.65681
},
{
id: "U3RvcDpIU0w6MjQxMTIyMA==",
lat: 60.1451,
lon: 24.65533
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mw==",
lat: 60.14491,
lon: 24.65111
},
{
id: "U3RvcDpIU0w6MjQxNDI2Nw==",
lat: 60.14383,
lon: 24.64506
},
{
id: "U3RvcDpIU0w6MjQxNDI2OQ==",
lat: 60.145746,
lon: 24.640377
},
{
id: "U3RvcDpIU0w6MjQxNDI3MQ==",
lat: 60.1482,
lon: 24.64181
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1NQ==",
lat: 60.15105,
lon: 24.64954
}
]
},
{
gtfsId: "HSL:2231N",
shortName: "231N",
longName: "Elielinaukio-Leppävaara-Lintuvaara-Järvenperä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYzMjI2MQ==",
lat: 60.24461,
lon: 24.71319
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNQ==",
lat: 60.24064,
lon: 24.74186
},
{
id: "U3RvcDpIU0w6MjE0MTIwNw==",
lat: 60.24387,
lon: 24.7488
},
{
id: "U3RvcDpIU0w6MjE0MjIwOQ==",
lat: 60.24647,
lon: 24.75143
},
{
id: "U3RvcDpIU0w6MjE0MzIxMQ==",
lat: 60.2493,
lon: 24.7569
},
{
id: "U3RvcDpIU0w6MjE0MzIxNA==",
lat: 60.25059,
lon: 24.76441
},
{
id: "U3RvcDpIU0w6MjE0MzIxNg==",
lat: 60.25233,
lon: 24.76977
},
{
id: "U3RvcDpIU0w6MjE0MzIxOA==",
lat: 60.25371,
lon: 24.77507
},
{
id: "U3RvcDpIU0w6NDEwMDIxMA==",
lat: 60.25474,
lon: 24.78064
},
{
id: "U3RvcDpIU0w6NDEwMDIxMQ==",
lat: 60.25385,
lon: 24.79672
},
{
id: "U3RvcDpIU0w6NDExMDIwMQ==",
lat: 60.24907,
lon: 24.80488
},
{
id: "U3RvcDpIU0w6MjExNzIzMQ==",
lat: 60.24685,
lon: 24.80845
},
{
id: "U3RvcDpIU0w6MjExNzIyOQ==",
lat: 60.24432,
lon: 24.80847
},
{
id: "U3RvcDpIU0w6MjExNzIyNw==",
lat: 60.24119,
lon: 24.80857
},
{
id: "U3RvcDpIU0w6MjExNzIzNQ==",
lat: 60.23933,
lon: 24.80861
},
{
id: "U3RvcDpIU0w6MjExNDIwNg==",
lat: 60.23598,
lon: 24.80932
},
{
id: "U3RvcDpIU0w6MjExNDIwOQ==",
lat: 60.23425,
lon: 24.81428
},
{
id: "U3RvcDpIU0w6MjExNTIxMQ==",
lat: 60.23434,
lon: 24.81888
},
{
id: "U3RvcDpIU0w6MjExNTIxMA==",
lat: 60.23384,
lon: 24.82263
},
{
id: "U3RvcDpIU0w6MjExMTI0MQ==",
lat: 60.22883,
lon: 24.82451
},
{
id: "U3RvcDpIU0w6MjExMTIwNg==",
lat: 60.22801,
lon: 24.81957
},
{
id: "U3RvcDpIU0w6MjExMTIxNg==",
lat: 60.22881,
lon: 24.81648
},
{
id: "U3RvcDpIU0w6MjExMTIxNw==",
lat: 60.22831,
lon: 24.81361
},
{
id: "U3RvcDpIU0w6MjExMTIxMw==",
lat: 60.22433,
lon: 24.81044
},
{
id: "U3RvcDpIU0w6MjExMTIwOA==",
lat: 60.21982,
lon: 24.81298
},
{
id: "U3RvcDpIU0w6MjExMTI1Ng==",
lat: 60.21934,
lon: 24.8217
},
{
id: "U3RvcDpIU0w6MjExMzIwNg==",
lat: 60.22042,
lon: 24.83513
},
{
id: "U3RvcDpIU0w6MjExMzIwNA==",
lat: 60.2211,
lon: 24.84182
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMA==",
lat: 60.224845,
lon: 24.850474
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDEzMQ==",
lat: 60.171741,
lon: 24.939733
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTIyMA==",
lat: 60.21031,
lon: 24.88865
},
{
id: "U3RvcDpIU0w6MTQ2NTE0Mw==",
lat: 60.214064,
lon: 24.880445
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzIxMQ==",
lat: 60.22455,
lon: 24.84853
},
{
id: "U3RvcDpIU0w6MjAwMDIwMw==",
lat: 60.22112,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6MjExMzIwNQ==",
lat: 60.22052,
lon: 24.83286
},
{
id: "U3RvcDpIU0w6MjExMTI4MA==",
lat: 60.21955,
lon: 24.82102
},
{
id: "U3RvcDpIU0w6MjExMTIwNQ==",
lat: 60.22011,
lon: 24.8119
},
{
id: "U3RvcDpIU0w6MjExMTIyOA==",
lat: 60.22132,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExMTIxMg==",
lat: 60.2232,
lon: 24.81071
},
{
id: "U3RvcDpIU0w6MjExMTIyNg==",
lat: 60.2267,
lon: 24.81272
},
{
id: "U3RvcDpIU0w6MjExMTIxOA==",
lat: 60.22868,
lon: 24.81475
},
{
id: "U3RvcDpIU0w6MjExMTIxNQ==",
lat: 60.22864,
lon: 24.81755
},
{
id: "U3RvcDpIU0w6MjExMTIwNw==",
lat: 60.22748,
lon: 24.82092
},
{
id: "U3RvcDpIU0w6MjExNTIxNA==",
lat: 60.23057,
lon: 24.8244
},
{
id: "U3RvcDpIU0w6MjExNTIwOA==",
lat: 60.23452,
lon: 24.82164
},
{
id: "U3RvcDpIU0w6MjExNTIxMg==",
lat: 60.23437,
lon: 24.81822
},
{
id: "U3RvcDpIU0w6MjExNDIwOA==",
lat: 60.23433,
lon: 24.81456
},
{
id: "U3RvcDpIU0w6MjExNzIzMg==",
lat: 60.236683,
lon: 24.808831
},
{
id: "U3RvcDpIU0w6MjExNzIzNA==",
lat: 60.23959,
lon: 24.80878
},
{
id: "U3RvcDpIU0w6MjExNzIyNg==",
lat: 60.24158,
lon: 24.80869
},
{
id: "U3RvcDpIU0w6MjExNzIyOA==",
lat: 60.24471,
lon: 24.80859
},
{
id: "U3RvcDpIU0w6MjExNzIzMA==",
lat: 60.24707,
lon: 24.80843
},
{
id: "U3RvcDpIU0w6NDExMDIxMA==",
lat: 60.24875,
lon: 24.806
},
{
id: "U3RvcDpIU0w6NDEwMDIwNw==",
lat: 60.25419,
lon: 24.79491
},
{
id: "U3RvcDpIU0w6NDEwMDIwOQ==",
lat: 60.25467,
lon: 24.7786
},
{
id: "U3RvcDpIU0w6MjE0MzIxNw==",
lat: 60.253227,
lon: 24.772518
},
{
id: "U3RvcDpIU0w6MjE0MzIxNQ==",
lat: 60.25198,
lon: 24.7679
},
{
id: "U3RvcDpIU0w6MjE0MzIxMw==",
lat: 60.25041,
lon: 24.76301
},
{
id: "U3RvcDpIU0w6MjE0MzIxMg==",
lat: 60.24895,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjE0MjIxMA==",
lat: 60.24566,
lon: 24.75026
},
{
id: "U3RvcDpIU0w6MjE0MjIwOA==",
lat: 60.24338,
lon: 24.74724
},
{
id: "U3RvcDpIU0w6MjE0MjIwNg==",
lat: 60.2414,
lon: 24.74307
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
}
]
},
{
gtfsId: "HSL:1021B",
shortName: "21B",
longName: "Lauttasaari (M)-Vattuniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMxMDEzNw==",
lat: 60.149985,
lon: 24.881588
},
{
id: "U3RvcDpIU0w6MTMxMDE0Ng==",
lat: 60.15126,
lon: 24.88587
},
{
id: "U3RvcDpIU0w6MTMxMDE0NQ==",
lat: 60.153338,
lon: 24.88512
},
{
id: "U3RvcDpIU0w6MTMyMDEzNg==",
lat: 60.154238,
lon: 24.882168
},
{
id: "U3RvcDpIU0w6MTMxMDEzMA==",
lat: 60.1539,
lon: 24.8764
},
{
id: "U3RvcDpIU0w6MTMxMDEyOA==",
lat: 60.157265,
lon: 24.874033
},
{
id: "U3RvcDpIU0w6MTMxMDEwOA==",
lat: 60.15927,
lon: 24.877175
},
{
id: "U3RvcDpIU0w6MTMxMDEwNg==",
lat: 60.160297,
lon: 24.881277
},
{
id: "U3RvcDpIU0w6MTMxMDEwNQ==",
lat: 60.16055,
lon: 24.87946
},
{
id: "U3RvcDpIU0w6MTMxMDEwNw==",
lat: 60.15877,
lon: 24.87683
},
{
id: "U3RvcDpIU0w6MTMxMDEyNw==",
lat: 60.15759,
lon: 24.87384
},
{
id: "U3RvcDpIU0w6MTMxMDEyOQ==",
lat: 60.15365,
lon: 24.87722
},
{
id: "U3RvcDpIU0w6MTMxMDE0OA==",
lat: 60.154234,
lon: 24.880355
},
{
id: "U3RvcDpIU0w6MTMyMDE5OQ==",
lat: 60.153807,
lon: 24.884731
},
{
id: "U3RvcDpIU0w6MTMxMDIwMA==",
lat: 60.150452,
lon: 24.886015
}
]
},
{
gtfsId: "HSL:4335B",
shortName: "335B",
longName: "Myyrmäki-Martinlaakso-Askisto",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE1MDI2MQ==",
lat: 60.26134,
lon: 24.85541
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNQ==",
lat: 60.27027,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDIwMDIwMQ==",
lat: 60.27705,
lon: 24.80344
},
{
id: "U3RvcDpIU0w6NDIwMDIwMw==",
lat: 60.28351,
lon: 24.79137
},
{
id: "U3RvcDpIU0w6NDIwMDIxMQ==",
lat: 60.28576,
lon: 24.78543
},
{
id: "U3RvcDpIU0w6NDIwMDIwOQ==",
lat: 60.28095,
lon: 24.78441
},
{
id: "U3RvcDpIU0w6NDIwMDIxMw==",
lat: 60.27662,
lon: 24.77807
},
{
id: "U3RvcDpIU0w6NDEyMDIyMQ==",
lat: 60.27463,
lon: 24.77941
},
{
id: "U3RvcDpIU0w6NDIwMDIxNA==",
lat: 60.27739,
lon: 24.77876
},
{
id: "U3RvcDpIU0w6NDIwMDIxMA==",
lat: 60.28186,
lon: 24.78524
},
{
id: "U3RvcDpIU0w6NDIwMDIxMg==",
lat: 60.28542,
lon: 24.78564
},
{
id: "U3RvcDpIU0w6NDIwMDIwNg==",
lat: 60.28661,
lon: 24.78718
},
{
id: "U3RvcDpIU0w6NDIwMDIwNA==",
lat: 60.28288,
lon: 24.79207
},
{
id: "U3RvcDpIU0w6NDIwMDIwMg==",
lat: 60.27836,
lon: 24.80175
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDI0NA==",
lat: 60.27712,
lon: 24.85322
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDIwNQ==",
lat: 60.26146,
lon: 24.85579
}
]
},
{
gtfsId: "HSL:4311A",
shortName: "311A",
longName: "Tikkurila-Myyrmäki-Hämeenkylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDEyMDI5Nw==",
lat: 60.27064,
lon: 24.80229
},
{
id: "U3RvcDpIU0w6NDEyMDI5NA==",
lat: 60.27096,
lon: 24.80215
},
{
id: "U3RvcDpIU0w6NDEyMDI4Ng==",
lat: 60.27016,
lon: 24.79557
},
{
id: "U3RvcDpIU0w6NDEyMDIyMg==",
lat: 60.26848,
lon: 24.79489
},
{
id: "U3RvcDpIU0w6NDEyMDIyMA==",
lat: 60.26647,
lon: 24.79868
},
{
id: "U3RvcDpIU0w6NDEyMDI5OQ==",
lat: 60.26695,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDIxMQ==",
lat: 60.26427,
lon: 24.80569
},
{
id: "U3RvcDpIU0w6NDEyMDIxMA==",
lat: 60.26149,
lon: 24.80645
},
{
id: "U3RvcDpIU0w6NDEyMDIwOA==",
lat: 60.25673,
lon: 24.80958
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6NDEzMDIwNw==",
lat: 60.25561,
lon: 24.82723
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDI2NQ==",
lat: 60.260771,
lon: 24.856608
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNQ==",
lat: 60.27027,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0Ng==",
lat: 60.27718,
lon: 24.85344
},
{
id: "U3RvcDpIU0w6NDE3MDIwNw==",
lat: 60.27642,
lon: 24.85817
},
{
id: "U3RvcDpIU0w6NDE3MDIwOQ==",
lat: 60.27705,
lon: 24.86407
},
{
id: "U3RvcDpIU0w6NDE4MDIyMw==",
lat: 60.27905,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyNQ==",
lat: 60.284615,
lon: 24.873015
},
{
id: "U3RvcDpIU0w6NDE4MDIzMA==",
lat: 60.28791,
lon: 24.87527
},
{
id: "U3RvcDpIU0w6NDQwMDI5OQ==",
lat: 60.28752,
lon: 24.89207
},
{
id: "U3RvcDpIU0w6NDQwMDIwMw==",
lat: 60.28632,
lon: 24.89784
},
{
id: "U3RvcDpIU0w6NDQwMDIwNQ==",
lat: 60.28585,
lon: 24.90463
},
{
id: "U3RvcDpIU0w6NDQwMDIzNw==",
lat: 60.28461,
lon: 24.90906
},
{
id: "U3RvcDpIU0w6NDQwMDIzNg==",
lat: 60.28289,
lon: 24.90792
},
{
id: "U3RvcDpIU0w6NDQwMDIzMQ==",
lat: 60.28004,
lon: 24.90929
},
{
id: "U3RvcDpIU0w6NDQwMDIxOQ==",
lat: 60.279784,
lon: 24.918783
},
{
id: "U3RvcDpIU0w6NDQwMDIxMQ==",
lat: 60.28074,
lon: 24.92412
},
{
id: "U3RvcDpIU0w6NDQwMDIxMw==",
lat: 60.28074,
lon: 24.92886
},
{
id: "U3RvcDpIU0w6NDQwMDIxNQ==",
lat: 60.28249,
lon: 24.93814
},
{
id: "U3RvcDpIU0w6NDUxMDI1Nw==",
lat: 60.28557,
lon: 24.946116
},
{
id: "U3RvcDpIU0w6NDUxMDIyNQ==",
lat: 60.2866,
lon: 24.95006
},
{
id: "U3RvcDpIU0w6NDUxMDIyMw==",
lat: 60.288407,
lon: 24.950263
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIwMQ==",
lat: 60.28944,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIyMA==",
lat: 60.2865,
lon: 24.95909
},
{
id: "U3RvcDpIU0w6NDUxMDIwMw==",
lat: 60.28515,
lon: 24.96256
},
{
id: "U3RvcDpIU0w6NDUxMDIzOQ==",
lat: 60.2842,
lon: 24.96675
},
{
id: "U3RvcDpIU0w6NDUxMDIwNQ==",
lat: 60.28334,
lon: 24.97145
},
{
id: "U3RvcDpIU0w6NDUxMDIwNw==",
lat: 60.28228,
lon: 24.97476
},
{
id: "U3RvcDpIU0w6NDUxMDI0OQ==",
lat: 60.28171,
lon: 24.98038
},
{
id: "U3RvcDpIU0w6NDY5MDIwMQ==",
lat: 60.28195,
lon: 24.98314
},
{
id: "U3RvcDpIU0w6NDY5MDIwMw==",
lat: 60.283544,
lon: 24.983526
},
{
id: "U3RvcDpIU0w6NDY4MDIxOQ==",
lat: 60.28786,
lon: 24.99054
},
{
id: "U3RvcDpIU0w6NDY4MDIyMQ==",
lat: 60.28918,
lon: 24.99859
},
{
id: "U3RvcDpIU0w6NDY4MDIyMw==",
lat: 60.28899,
lon: 25.00361
},
{
id: "U3RvcDpIU0w6NDY4MDIyNQ==",
lat: 60.29046,
lon: 25.00808
},
{
id: "U3RvcDpIU0w6NDY4MDIyNw==",
lat: 60.29201,
lon: 25.01294
},
{
id: "U3RvcDpIU0w6NDYzMDIxOA==",
lat: 60.292663,
lon: 25.017039
},
{
id: "U3RvcDpIU0w6NDYzMDIxOQ==",
lat: 60.29612,
lon: 25.01589
},
{
id: "U3RvcDpIU0w6NDYzMDIyMQ==",
lat: 60.29879,
lon: 25.01765
},
{
id: "U3RvcDpIU0w6NDYzMDIwNw==",
lat: 60.30182,
lon: 25.02328
},
{
id: "U3RvcDpIU0w6NDYzMDIyNQ==",
lat: 60.30021,
lon: 25.02911
},
{
id: "U3RvcDpIU0w6NDYzMDIwOQ==",
lat: 60.299,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6NDYxMDIwOQ==",
lat: 60.2969,
lon: 25.03573
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI0NQ==",
lat: 60.293346,
lon: 25.044253
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIyOA==",
lat: 60.29661,
lon: 25.03844
},
{
id: "U3RvcDpIU0w6NDYxMDIzMQ==",
lat: 60.29765,
lon: 25.03472
},
{
id: "U3RvcDpIU0w6NDYzMDIxMA==",
lat: 60.29964,
lon: 25.03247
},
{
id: "U3RvcDpIU0w6NDYzMDIyNg==",
lat: 60.30105,
lon: 25.02662
},
{
id: "U3RvcDpIU0w6NDYzMDIyMw==",
lat: 60.30177,
lon: 25.02167
},
{
id: "U3RvcDpIU0w6NDYzMDIyMg==",
lat: 60.29898,
lon: 25.01768
},
{
id: "U3RvcDpIU0w6NDYzMDIyMA==",
lat: 60.29537,
lon: 25.01572
},
{
id: "U3RvcDpIU0w6NDYzMDIxMg==",
lat: 60.29205,
lon: 25.0157
},
{
id: "U3RvcDpIU0w6NDY4MDIyOA==",
lat: 60.29215,
lon: 25.01095
},
{
id: "U3RvcDpIU0w6NDY4MDIyNg==",
lat: 60.29002,
lon: 25.00693
},
{
id: "U3RvcDpIU0w6NDY4MDIyNA==",
lat: 60.28894,
lon: 25.00227
},
{
id: "U3RvcDpIU0w6NDY4MDIyMg==",
lat: 60.28915,
lon: 24.99601
},
{
id: "U3RvcDpIU0w6NDY4MDIyMA==",
lat: 60.28777,
lon: 24.98909
},
{
id: "U3RvcDpIU0w6NDY5MDIwNA==",
lat: 60.284157,
lon: 24.983147
},
{
id: "U3RvcDpIU0w6NDY5MDIwNQ==",
lat: 60.28158,
lon: 24.98152
},
{
id: "U3RvcDpIU0w6NDUxMDI1MA==",
lat: 60.28225,
lon: 24.97741
},
{
id: "U3RvcDpIU0w6NDUxMDIwOA==",
lat: 60.28271,
lon: 24.97297
},
{
id: "U3RvcDpIU0w6NDUxMDIwNg==",
lat: 60.2841,
lon: 24.96983
},
{
id: "U3RvcDpIU0w6NDUxMDIzNw==",
lat: 60.28445,
lon: 24.96511
},
{
id: "U3RvcDpIU0w6NDUxMDIwNA==",
lat: 60.28634,
lon: 24.96034
},
{
id: "U3RvcDpIU0w6NDUxMDIyMQ==",
lat: 60.28714,
lon: 24.9578
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDIyMg==",
lat: 60.28878,
lon: 24.949677
},
{
id: "U3RvcDpIU0w6NDUxMDIxMw==",
lat: 60.286,
lon: 24.94868
},
{
id: "U3RvcDpIU0w6NDUxMDI1Ng==",
lat: 60.285431,
lon: 24.944319
},
{
id: "U3RvcDpIU0w6NDQwMDIxNg==",
lat: 60.28215,
lon: 24.93696
},
{
id: "U3RvcDpIU0w6NDQwMDIxNA==",
lat: 60.28078,
lon: 24.92756
},
{
id: "U3RvcDpIU0w6NDQwMDIxNw==",
lat: 60.28097,
lon: 24.92297
},
{
id: "U3RvcDpIU0w6NDQwMDIxOA==",
lat: 60.27961,
lon: 24.9164
},
{
id: "U3RvcDpIU0w6NDQwMDIzMA==",
lat: 60.28031,
lon: 24.90945
},
{
id: "U3RvcDpIU0w6NDQwMDIzNA==",
lat: 60.28367,
lon: 24.90867
},
{
id: "U3RvcDpIU0w6NDQwMDIzMg==",
lat: 60.28534,
lon: 24.90811
},
{
id: "U3RvcDpIU0w6NDQwMDIwNg==",
lat: 60.28615,
lon: 24.90267
},
{
id: "U3RvcDpIU0w6NDQwMDIwNA==",
lat: 60.28642,
lon: 24.89658
},
{
id: "U3RvcDpIU0w6NDQwMDI5OA==",
lat: 60.28786,
lon: 24.89045
},
{
id: "U3RvcDpIU0w6NDE4MDIxMQ==",
lat: 60.2871,
lon: 24.87284
},
{
id: "U3RvcDpIU0w6NDE4MDIyNg==",
lat: 60.28292,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyNA==",
lat: 60.27838,
lon: 24.87161
},
{
id: "U3RvcDpIU0w6NDE4MDIzMQ==",
lat: 60.27793,
lon: 24.86877
},
{
id: "U3RvcDpIU0w6NDE3MDIxMA==",
lat: 60.27739,
lon: 24.86505
},
{
id: "U3RvcDpIU0w6NDE3MDI1OA==",
lat: 60.27658,
lon: 24.85892
},
{
id: "U3RvcDpIU0w6NDE3MDI0NA==",
lat: 60.27712,
lon: 24.85322
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDI2Mw==",
lat: 60.26109,
lon: 24.856
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIxMA==",
lat: 60.25875,
lon: 24.83456
},
{
id: "U3RvcDpIU0w6NDEzMDIwOA==",
lat: 60.25622,
lon: 24.82877
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNw==",
lat: 60.25811,
lon: 24.80891
},
{
id: "U3RvcDpIU0w6NDEyMDIyOA==",
lat: 60.26293,
lon: 24.805612
},
{
id: "U3RvcDpIU0w6NDEyMDIxOA==",
lat: 60.26444,
lon: 24.80597
},
{
id: "U3RvcDpIU0w6NDEyMDI5OA==",
lat: 60.26687,
lon: 24.80497
},
{
id: "U3RvcDpIU0w6NDEyMDIxOQ==",
lat: 60.26612,
lon: 24.79949
},
{
id: "U3RvcDpIU0w6NDEyMDIyMw==",
lat: 60.26877,
lon: 24.79488
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5Ng==",
lat: 60.27064,
lon: 24.80229
}
]
},
{
gtfsId: "HSL:9967K",
shortName: "967K",
longName: "Jokela-Nuppulinna-Purola-Linjamäki-Kellokoski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTYyMDEzMA==",
lat: 60.546026,
lon: 25.118111
},
{
id: "U3RvcDpIU0w6OTYyMDEyOA==",
lat: 60.542592,
lon: 25.117474
},
{
id: "U3RvcDpIU0w6OTYyMDEyNg==",
lat: 60.540297,
lon: 25.114163
},
{
id: "U3RvcDpIU0w6OTYyMDExNQ==",
lat: 60.536589,
lon: 25.112111
},
{
id: "U3RvcDpIU0w6OTYyMDEwOQ==",
lat: 60.531432,
lon: 25.109525
},
{
id: "U3RvcDpIU0w6OTYyMDExMQ==",
lat: 60.527961,
lon: 25.104432
},
{
id: "U3RvcDpIU0w6OTYyMDExMw==",
lat: 60.531325,
lon: 25.098307
},
{
id: "U3RvcDpIU0w6OTYyMDEwNg==",
lat: 60.53091,
lon: 25.088879
},
{
id: "U3RvcDpIU0w6OTYyMDMwMQ==",
lat: 60.534088,
lon: 25.068856
},
{
id: "U3RvcDpIU0w6OTYyMDMwNQ==",
lat: 60.537071,
lon: 25.052673
},
{
id: "U3RvcDpIU0w6OTYyMDMwNA==",
lat: 60.539138,
lon: 25.043178
},
{
id: "U3RvcDpIU0w6OTYyMDMwMw==",
lat: 60.538876,
lon: 25.04384
},
{
id: "U3RvcDpIU0w6OTYyMDMwNg==",
lat: 60.536838,
lon: 25.053815
},
{
id: "U3RvcDpIU0w6OTYyMDQwNA==",
lat: 60.534515,
lon: 25.05692
},
{
id: "U3RvcDpIU0w6OTYyMDQwMw==",
lat: 60.532194,
lon: 25.050223
},
{
id: "U3RvcDpIU0w6OTYyMDQwMQ==",
lat: 60.529844,
lon: 25.044256
},
{
id: "U3RvcDpIU0w6OTYzMDIwNQ==",
lat: 60.525256,
lon: 25.021976
},
{
id: "U3RvcDpIU0w6OTYzMDIwMg==",
lat: 60.516966,
lon: 25.022425
},
{
id: "U3RvcDpIU0w6OTYzMDMwOQ==",
lat: 60.510821,
lon: 25.029423
},
{
id: "U3RvcDpIU0w6OTYzMDMwMw==",
lat: 60.505651,
lon: 25.03083
},
{
id: "U3RvcDpIU0w6OTYzMDMwMg==",
lat: 60.502379,
lon: 25.040632
},
{
id: "U3RvcDpIU0w6OTUwOTAwNg==",
lat: 60.499549,
lon: 25.050166
},
{
id: "U3RvcDpIU0w6OTYzMDMwNg==",
lat: 60.496924,
lon: 25.032264
},
{
id: "U3RvcDpIU0w6OTYzMDMwMQ==",
lat: 60.501938,
lon: 25.031371
},
{
id: "U3RvcDpIU0w6OTYzMDMwNA==",
lat: 60.506287,
lon: 25.031116
},
{
id: "U3RvcDpIU0w6OTYzMDMxMA==",
lat: 60.511211,
lon: 25.029018
},
{
id: "U3RvcDpIU0w6OTYzMDIwMw==",
lat: 60.518101,
lon: 25.022312
},
{
id: "U3RvcDpIU0w6OTYzMDIwNA==",
lat: 60.526266,
lon: 25.020897
},
{
id: "U3RvcDpIU0w6OTYzMDIwNg==",
lat: 60.528971,
lon: 25.017467
},
{
id: "U3RvcDpIU0w6OTYxMDMwMA==",
lat: 60.535606,
lon: 25.005515
},
{
id: "U3RvcDpIU0w6OTYxMDMwMg==",
lat: 60.538897,
lon: 24.998461
},
{
id: "U3RvcDpIU0w6OTYxMDMyMg==",
lat: 60.54307,
lon: 24.987469
},
{
id: "U3RvcDpIU0w6OTYxMDIyMA==",
lat: 60.553215,
lon: 24.96926
},
{
id: "U3RvcDpIU0w6OTYxMDIwNQ==",
lat: 60.552142,
lon: 24.97042
},
{
id: "U3RvcDpIU0w6OTYxMDMyMw==",
lat: 60.542261,
lon: 24.989126
},
{
id: "U3RvcDpIU0w6OTYxMDMwMw==",
lat: 60.538583,
lon: 24.999092
},
{
id: "U3RvcDpIU0w6OTYxMDMwMQ==",
lat: 60.535176,
lon: 25.006512
},
{
id: "U3RvcDpIU0w6OTYzMDIwNw==",
lat: 60.528202,
lon: 25.018226
},
{
id: "U3RvcDpIU0w6OTYzMDMwMA==",
lat: 60.500627,
lon: 25.03184
},
{
id: "U3RvcDpIU0w6OTYzMDMwNw==",
lat: 60.496333,
lon: 25.032333
},
{
id: "U3RvcDpIU0w6OTUxMDAwMQ==",
lat: 60.49954,
lon: 25.050187
},
{
id: "U3RvcDpIU0w6OTYyMDQwMA==",
lat: 60.526927,
lon: 25.037865
},
{
id: "U3RvcDpIU0w6OTYyMDMwMg==",
lat: 60.533697,
lon: 25.070858
},
{
id: "U3RvcDpIU0w6OTYyMDEwNw==",
lat: 60.530893,
lon: 25.088768
},
{
id: "U3RvcDpIU0w6OTYyMDExMg==",
lat: 60.531326,
lon: 25.098308
},
{
id: "U3RvcDpIU0w6OTYyMDExMA==",
lat: 60.527828,
lon: 25.104227
},
{
id: "U3RvcDpIU0w6OTYyMDEwOA==",
lat: 60.532741,
lon: 25.110697
},
{
id: "U3RvcDpIU0w6OTYyMDExNA==",
lat: 60.535827,
lon: 25.11185
},
{
id: "U3RvcDpIU0w6OTYyMDEyNQ==",
lat: 60.538881,
lon: 25.113485
},
{
id: "U3RvcDpIU0w6OTYyMDEyNw==",
lat: 60.541235,
lon: 25.114887
}
]
},
{
gtfsId: "HSL:2146A",
shortName: "146A",
longName: "Kamppi-Kivenlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI4MQ==",
lat: 60.16887,
lon: 24.93119
},
{
id: "U3RvcDpIU0w6MTA0MDIzMQ==",
lat: 60.16622,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNA==",
lat: 60.16976,
lon: 24.8242
},
{
id: "U3RvcDpIU0w6MjIxMTI5MA==",
lat: 60.17025,
lon: 24.81115
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIyNA==",
lat: 60.15183,
lon: 24.66506
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOQ==",
lat: 60.14867,
lon: 24.66343
},
{
id: "U3RvcDpIU0w6MjQxMTIzOQ==",
lat: 60.14776,
lon: 24.6582
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxMQ==",
lat: 60.15326,
lon: 24.63371
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxMTI0MA==",
lat: 60.14766,
lon: 24.65846
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOA==",
lat: 60.14873,
lon: 24.66543
},
{
id: "U3RvcDpIU0w6MjQxMTIyNQ==",
lat: 60.15011,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNg==",
lat: 60.15236,
lon: 24.66626
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:2134N",
shortName: "134N",
longName: "Kamppi-Niittykumpu (M)-Espoon keskus-Suvela-Tuomarila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI3OQ==",
lat: 60.16892,
lon: 24.93137
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI4OQ==",
lat: 60.16826,
lon: 24.76731
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
},
{
id: "U3RvcDpIU0w6MjMyMjIwNA==",
lat: 60.16999,
lon: 24.75087
},
{
id: "U3RvcDpIU0w6MjMyMjIwNQ==",
lat: 60.167702,
lon: 24.741443
},
{
id: "U3RvcDpIU0w6MjMyMzIwNw==",
lat: 60.16695,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mg==",
lat: 60.169261,
lon: 24.734193
},
{
id: "U3RvcDpIU0w6MjMyMzI1MA==",
lat: 60.17271,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjMyMzI0MA==",
lat: 60.17256,
lon: 24.72448
},
{
id: "U3RvcDpIU0w6MjMyMTIxNQ==",
lat: 60.17308,
lon: 24.72252
},
{
id: "U3RvcDpIU0w6MjMyMTIxNw==",
lat: 60.176736,
lon: 24.716377
},
{
id: "U3RvcDpIU0w6MjMyMTI2Mg==",
lat: 60.17488,
lon: 24.70841
},
{
id: "U3RvcDpIU0w6MjMyMTIyMA==",
lat: 60.17429,
lon: 24.70261
},
{
id: "U3RvcDpIU0w6MjQzMjI2Mg==",
lat: 60.1735,
lon: 24.68914
},
{
id: "U3RvcDpIU0w6MjQzMzIwOQ==",
lat: 60.17571,
lon: 24.6874
},
{
id: "U3RvcDpIU0w6MjQzMzIxMQ==",
lat: 60.18002,
lon: 24.67472
},
{
id: "U3RvcDpIU0w6MjQzMTIxMw==",
lat: 60.18185,
lon: 24.67064
},
{
id: "U3RvcDpIU0w6MjYxNTIxNQ==",
lat: 60.18836,
lon: 24.6668
},
{
id: "U3RvcDpIU0w6MjYxNTIzNg==",
lat: 60.19542,
lon: 24.66347
},
{
id: "U3RvcDpIU0w6MjYxMTIzNA==",
lat: 60.19898,
lon: 24.65519
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMzAwOA==",
lat: 60.202736,
lon: 24.661962
},
{
id: "U3RvcDpIU0w6MjYxMzAwMQ==",
lat: 60.20123,
lon: 24.6671
},
{
id: "U3RvcDpIU0w6MjYxMzIxNg==",
lat: 60.2028,
lon: 24.67021
},
{
id: "U3RvcDpIU0w6MjYxMzIxOA==",
lat: 60.20462,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjYxMjIxOQ==",
lat: 60.20332,
lon: 24.68024
},
{
id: "U3RvcDpIU0w6MjYxMjIyNg==",
lat: 60.199976,
lon: 24.683783
},
{
id: "U3RvcDpIU0w6MjYxMjIyMQ==",
lat: 60.20047,
lon: 24.68762
},
{
id: "U3RvcDpIU0w6MjYxMjIyMw==",
lat: 60.201411,
lon: 24.695023
},
{
id: "U3RvcDpIU0w6MjYxMjIyNQ==",
lat: 60.201429,
lon: 24.692241
},
{
id: "U3RvcDpIU0w6MjYxMjIyMg==",
lat: 60.20016,
lon: 24.68547
},
{
id: "U3RvcDpIU0w6MjYxMjIyMA==",
lat: 60.20329,
lon: 24.68038
},
{
id: "U3RvcDpIU0w6MjYxMzIxNw==",
lat: 60.20508,
lon: 24.67367
},
{
id: "U3RvcDpIU0w6MjYxMzIxNQ==",
lat: 60.20246,
lon: 24.66925
},
{
id: "U3RvcDpIU0w6MjYxMzAwMA==",
lat: 60.201,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxNTIzMw==",
lat: 60.2023,
lon: 24.65257
},
{
id: "U3RvcDpIU0w6MjYxMTIzNQ==",
lat: 60.19896,
lon: 24.6548
},
{
id: "U3RvcDpIU0w6MjYxNTIzOQ==",
lat: 60.1952,
lon: 24.66358
},
{
id: "U3RvcDpIU0w6MjYxNTIxNg==",
lat: 60.18792,
lon: 24.66694
},
{
id: "U3RvcDpIU0w6MjQzMTIxNA==",
lat: 60.18073,
lon: 24.67139
},
{
id: "U3RvcDpIU0w6MjQzMzIxMg==",
lat: 60.17993,
lon: 24.67732
},
{
id: "U3RvcDpIU0w6MjQzMzIxMA==",
lat: 60.17515,
lon: 24.68784
},
{
id: "U3RvcDpIU0w6MjQzMzI0Ng==",
lat: 60.17303,
lon: 24.68987
},
{
id: "U3RvcDpIU0w6MjMyMTIyMQ==",
lat: 60.17427,
lon: 24.70461
},
{
id: "U3RvcDpIU0w6MjMyMTI2MQ==",
lat: 60.17485,
lon: 24.70874
},
{
id: "U3RvcDpIU0w6MjMyMTIxOA==",
lat: 60.176604,
lon: 24.716805
},
{
id: "U3RvcDpIU0w6MjMyMTIxNg==",
lat: 60.1729,
lon: 24.72234
},
{
id: "U3RvcDpIU0w6MjMyMzI0Nw==",
lat: 60.17271,
lon: 24.72739
},
{
id: "U3RvcDpIU0w6MjMyMzI1MQ==",
lat: 60.17156,
lon: 24.73162
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mw==",
lat: 60.168587,
lon: 24.734538
},
{
id: "U3RvcDpIU0w6MjMyMzIwOQ==",
lat: 60.16666,
lon: 24.73958
},
{
id: "U3RvcDpIU0w6MjMyMjIwNg==",
lat: 60.168597,
lon: 24.743873
},
{
id: "U3RvcDpIU0w6MjMyMjI0Nw==",
lat: 60.16966,
lon: 24.74919
},
{
id: "U3RvcDpIU0w6MjMyMjIyOQ==",
lat: 60.17043,
lon: 24.75535
},
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDIxNw==",
lat: 60.17006,
lon: 24.764804
},
{
id: "U3RvcDpIU0w6MjIzMjIyNg==",
lat: 60.16709,
lon: 24.77023
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:2146N",
shortName: "146N",
longName: "Kamppi-Kivenlahti-Saunalahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI4MA==",
lat: 60.1689,
lon: 24.93128
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIyMA==",
lat: 60.1622,
lon: 24.70074
},
{
id: "U3RvcDpIU0w6MjQzMjIyMQ==",
lat: 60.16172,
lon: 24.6976
},
{
id: "U3RvcDpIU0w6MjQzMjIyOQ==",
lat: 60.15995,
lon: 24.69273
},
{
id: "U3RvcDpIU0w6MjQzMjIyMw==",
lat: 60.15842,
lon: 24.68966
},
{
id: "U3RvcDpIU0w6MjQzNDIyNQ==",
lat: 60.15632,
lon: 24.6807
},
{
id: "U3RvcDpIU0w6MjQzNDIyOA==",
lat: 60.15556,
lon: 24.67205
},
{
id: "U3RvcDpIU0w6MjQzNDIzMA==",
lat: 60.15559,
lon: 24.66702
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIyNA==",
lat: 60.15183,
lon: 24.66506
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOQ==",
lat: 60.14867,
lon: 24.66343
},
{
id: "U3RvcDpIU0w6MjQxMTIzOQ==",
lat: 60.14776,
lon: 24.6582
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOA==",
lat: 60.15638,
lon: 24.63086
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6MjQyMzIxOQ==",
lat: 60.15906,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQyMzIxNQ==",
lat: 60.16269,
lon: 24.61315
},
{
id: "U3RvcDpIU0w6MjQyMzIxMA==",
lat: 60.165995,
lon: 24.615303
},
{
id: "U3RvcDpIU0w6MjQyMzIxMQ==",
lat: 60.165647,
lon: 24.61464
},
{
id: "U3RvcDpIU0w6MjQyMzIxNA==",
lat: 60.16214,
lon: 24.61326
},
{
id: "U3RvcDpIU0w6MjQyMzIyMA==",
lat: 60.15901,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxMQ==",
lat: 60.15326,
lon: 24.63371
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxMTI0MA==",
lat: 60.14766,
lon: 24.65846
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOA==",
lat: 60.14873,
lon: 24.66543
},
{
id: "U3RvcDpIU0w6MjQxMTIyNQ==",
lat: 60.15011,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjQzMjIzMQ==",
lat: 60.15527,
lon: 24.66488
},
{
id: "U3RvcDpIU0w6MjQzNDIyOQ==",
lat: 60.15569,
lon: 24.66917
},
{
id: "U3RvcDpIU0w6MjQzNDIyNw==",
lat: 60.15558,
lon: 24.6744
},
{
id: "U3RvcDpIU0w6MjQzMjIyNg==",
lat: 60.15642,
lon: 24.68264
},
{
id: "U3RvcDpIU0w6MjQzMjIyNA==",
lat: 60.159344,
lon: 24.692096
},
{
id: "U3RvcDpIU0w6MjQzMjIyMg==",
lat: 60.16186,
lon: 24.69937
},
{
id: "U3RvcDpIU0w6MjQzMjIwMw==",
lat: 60.16115,
lon: 24.70423
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMg==",
lat: 60.159978,
lon: 24.708063
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:2158K",
shortName: "158K",
longName: "Matinkylä (M)-Nöykkiö-Latokaski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQzMTI0MA==",
lat: 60.17908,
lon: 24.65491
},
{
id: "U3RvcDpIU0w6MjQzMTIzOA==",
lat: 60.17817,
lon: 24.65898
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mg==",
lat: 60.17662,
lon: 24.6562
},
{
id: "U3RvcDpIU0w6MjQzMTI1NA==",
lat: 60.17315,
lon: 24.65509
},
{
id: "U3RvcDpIU0w6MjQzNDIwMg==",
lat: 60.16658,
lon: 24.66045
},
{
id: "U3RvcDpIU0w6MjQzNDIwNQ==",
lat: 60.162555,
lon: 24.661038
},
{
id: "U3RvcDpIU0w6MjQzNDIwNw==",
lat: 60.16286,
lon: 24.66467
},
{
id: "U3RvcDpIU0w6MjQzNDIwOQ==",
lat: 60.16319,
lon: 24.67184
},
{
id: "U3RvcDpIU0w6MjQzNDI0NA==",
lat: 60.16295,
lon: 24.67667
},
{
id: "U3RvcDpIU0w6MjQzNDI0Ng==",
lat: 60.16443,
lon: 24.68178
},
{
id: "U3RvcDpIU0w6MjQzMjIxMA==",
lat: 60.16594,
lon: 24.6803
},
{
id: "U3RvcDpIU0w6MjQzMjIyNw==",
lat: 60.16756,
lon: 24.67821
},
{
id: "U3RvcDpIU0w6MjQzMjIyOA==",
lat: 60.16934,
lon: 24.67792
},
{
id: "U3RvcDpIU0w6MjQzNDMwMg==",
lat: 60.17161,
lon: 24.68123
},
{
id: "U3RvcDpIU0w6MjQzMjIzMg==",
lat: 60.17263,
lon: 24.68894
},
{
id: "U3RvcDpIU0w6MjQzMjIwNw==",
lat: 60.16914,
lon: 24.69489
},
{
id: "U3RvcDpIU0w6MjQzMjIwNQ==",
lat: 60.164145,
lon: 24.702844
},
{
id: "U3RvcDpIU0w6MjQzMjIxOQ==",
lat: 60.1618,
lon: 24.7053
},
{
id: "U3RvcDpIU0w6MjQzMjIxNw==",
lat: 60.16173,
lon: 24.71134
},
{
id: "U3RvcDpIU0w6MjMyMTIyNw==",
lat: 60.16215,
lon: 24.72297
},
{
id: "U3RvcDpIU0w6MjMxNDIyMw==",
lat: 60.16015,
lon: 24.72536
},
{
id: "U3RvcDpIU0w6MjMxNDIyNg==",
lat: 60.15706,
lon: 24.72747
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxNw==",
lat: 60.160197,
lon: 24.738644
},
{
id: "U3RvcDpIU0w6MjMxNDIyNA==",
lat: 60.15827,
lon: 24.73214
},
{
id: "U3RvcDpIU0w6MjMxNDIyMA==",
lat: 60.15719,
lon: 24.7262
},
{
id: "U3RvcDpIU0w6MjMxNDIyMg==",
lat: 60.16089,
lon: 24.72496
},
{
id: "U3RvcDpIU0w6MjMyMTI1Ng==",
lat: 60.16264,
lon: 24.72254
},
{
id: "U3RvcDpIU0w6MjMyMTIyMw==",
lat: 60.16259,
lon: 24.7208
},
{
id: "U3RvcDpIU0w6MjQzMjIxOA==",
lat: 60.16191,
lon: 24.70958
},
{
id: "U3RvcDpIU0w6MjQzMjI0MA==",
lat: 60.16211,
lon: 24.70565
},
{
id: "U3RvcDpIU0w6MjQzMjIwMg==",
lat: 60.163276,
lon: 24.703633
},
{
id: "U3RvcDpIU0w6MjQzMjIwNA==",
lat: 60.16535,
lon: 24.70225
},
{
id: "U3RvcDpIU0w6MjQzMjIwNg==",
lat: 60.16994,
lon: 24.69269
},
{
id: "U3RvcDpIU0w6MjQzMzIwNw==",
lat: 60.17298,
lon: 24.6873
},
{
id: "U3RvcDpIU0w6MjQzNDMwMQ==",
lat: 60.17155,
lon: 24.68053
},
{
id: "U3RvcDpIU0w6MjQzNDIzMw==",
lat: 60.17019,
lon: 24.6776
},
{
id: "U3RvcDpIU0w6MjQzMjIxNQ==",
lat: 60.16853,
lon: 24.67787
},
{
id: "U3RvcDpIU0w6MjQzMjIwOQ==",
lat: 60.16639,
lon: 24.67914
},
{
id: "U3RvcDpIU0w6MjQzNDI0NQ==",
lat: 60.1644,
lon: 24.68157
},
{
id: "U3RvcDpIU0w6MjQzNDI1MA==",
lat: 60.16296,
lon: 24.67642
},
{
id: "U3RvcDpIU0w6MjQzNDIwOA==",
lat: 60.16328,
lon: 24.67186
},
{
id: "U3RvcDpIU0w6MjQzNDIwNg==",
lat: 60.16285,
lon: 24.66447
},
{
id: "U3RvcDpIU0w6MjQzNDIwMQ==",
lat: 60.16333,
lon: 24.66029
},
{
id: "U3RvcDpIU0w6MjQzNDIzMQ==",
lat: 60.16823,
lon: 24.66082
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mw==",
lat: 60.17401,
lon: 24.65456
},
{
id: "U3RvcDpIU0w6MjQzMTI1MQ==",
lat: 60.17666,
lon: 24.65685
},
{
id: "U3RvcDpIU0w6MjQzMTIzNw==",
lat: 60.17798,
lon: 24.6593
},
{
id: "U3RvcDpIU0w6MjQzMTIzOQ==",
lat: 60.17929,
lon: 24.65678
}
]
},
{
gtfsId: "HSL:2246KT",
shortName: "246KT",
longName: "Espoon keskus-Kellonummi-Bodom-Röylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYxNDI4Ng==",
lat: 60.22219,
lon: 24.66789
},
{
id: "U3RvcDpIU0w6MjYzNDI3OQ==",
lat: 60.22482,
lon: 24.67003
},
{
id: "U3RvcDpIU0w6MjYzMzIwMg==",
lat: 60.22794,
lon: 24.66676
},
{
id: "U3RvcDpIU0w6MjYzNDI3Nw==",
lat: 60.22894,
lon: 24.66508
},
{
id: "U3RvcDpIU0w6MjYzNDI3Ng==",
lat: 60.23321,
lon: 24.65923
},
{
id: "U3RvcDpIU0w6MjYzNDI2MQ==",
lat: 60.23591,
lon: 24.65655
},
{
id: "U3RvcDpIU0w6MjYzNDI3NQ==",
lat: 60.23899,
lon: 24.65577
},
{
id: "U3RvcDpIU0w6MjYzNDI2Mw==",
lat: 60.24418,
lon: 24.65407
},
{
id: "U3RvcDpIU0w6MjYzNDI2NA==",
lat: 60.24003,
lon: 24.64118
},
{
id: "U3RvcDpIU0w6MjYzNTIyMg==",
lat: 60.2502,
lon: 24.65506
},
{
id: "U3RvcDpIU0w6MjYzNTIyNg==",
lat: 60.25515,
lon: 24.65259
},
{
id: "U3RvcDpIU0w6MjYzNTI2NQ==",
lat: 60.26227,
lon: 24.65307
},
{
id: "U3RvcDpIU0w6MjYzNTI2Nw==",
lat: 60.268937,
lon: 24.653134
},
{
id: "U3RvcDpIU0w6MjYzNTIyNA==",
lat: 60.273911,
lon: 24.656377
},
{
id: "U3RvcDpIU0w6MjcxMTI2Ng==",
lat: 60.27479,
lon: 24.66714
},
{
id: "U3RvcDpIU0w6MjcxMjI2NA==",
lat: 60.27472,
lon: 24.68069
},
{
id: "U3RvcDpIU0w6MjcxMjI2Mg==",
lat: 60.2711,
lon: 24.68954
},
{
id: "U3RvcDpIU0w6MjcxMjI2MA==",
lat: 60.26868,
lon: 24.68954
},
{
id: "U3RvcDpIU0w6MjcxMjIwMQ==",
lat: 60.265147,
lon: 24.690918
},
{
id: "U3RvcDpIU0w6MjcxMjI1OA==",
lat: 60.26227,
lon: 24.69153
},
{
id: "U3RvcDpIU0w6MjcxMjIwNg==",
lat: 60.25879,
lon: 24.70164
},
{
id: "U3RvcDpIU0w6MjcxMjIwOQ==",
lat: 60.26129,
lon: 24.7066
},
{
id: "U3RvcDpIU0w6MjcxMjIwOA==",
lat: 60.264194,
lon: 24.706496
},
{
id: "U3RvcDpIU0w6MjcxMjIwNA==",
lat: 60.267951,
lon: 24.708854
},
{
id: "U3RvcDpIU0w6MjcxMjIwMg==",
lat: 60.27125,
lon: 24.71016
},
{
id: "U3RvcDpIU0w6MjcxNDI4OA==",
lat: 60.27559,
lon: 24.71467
},
{
id: "U3RvcDpIU0w6MjcxNDI3OQ==",
lat: 60.2775,
lon: 24.71419
},
{
id: "U3RvcDpIU0w6MjcxNDI4Ng==",
lat: 60.28103,
lon: 24.71065
},
{
id: "U3RvcDpIU0w6MjcxMTI3Nw==",
lat: 60.28582,
lon: 24.70576
},
{
id: "U3RvcDpIU0w6MjcxMTI3NQ==",
lat: 60.29623,
lon: 24.6991
},
{
id: "U3RvcDpIU0w6MjcxMjAwMg==",
lat: 60.297265,
lon: 24.691783
}
]
},
{
gtfsId: "HSL:4445T",
shortName: "445T",
longName: "Kivistö-Katriinan sairaala-Tapola-Reuna",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDMyMDIxOA==",
lat: 60.39327,
lon: 24.83287
},
{
id: "U3RvcDpIU0w6NDMyMDIxNg==",
lat: 60.39227,
lon: 24.83382
},
{
id: "U3RvcDpIU0w6NDMyMDIxNA==",
lat: 60.38507,
lon: 24.8374
},
{
id: "U3RvcDpIU0w6NDMyMDIxMg==",
lat: 60.38217,
lon: 24.83595
},
{
id: "U3RvcDpIU0w6NDMyMDIxMA==",
lat: 60.3766,
lon: 24.83791
},
{
id: "U3RvcDpIU0w6NDMyMDIwOA==",
lat: 60.36877,
lon: 24.84042
},
{
id: "U3RvcDpIU0w6NDMyMDIwNg==",
lat: 60.36546,
lon: 24.84818
},
{
id: "U3RvcDpIU0w6NDMyMDIwNA==",
lat: 60.36372,
lon: 24.85136
},
{
id: "U3RvcDpIU0w6NDMyMDIwMg==",
lat: 60.36268,
lon: 24.85646
},
{
id: "U3RvcDpIU0w6NDMzMDIyOA==",
lat: 60.3539,
lon: 24.854886
},
{
id: "U3RvcDpIU0w6NDMzMDI5Ng==",
lat: 60.34762,
lon: 24.85347
},
{
id: "U3RvcDpIU0w6NDMzMDIxMA==",
lat: 60.34686,
lon: 24.84891
},
{
id: "U3RvcDpIU0w6NDMzMDIwOQ==",
lat: 60.348902,
lon: 24.846898
},
{
id: "U3RvcDpIU0w6NDMzMDIyMg==",
lat: 60.34392,
lon: 24.83582
},
{
id: "U3RvcDpIU0w6NDMzMDIyMw==",
lat: 60.34246,
lon: 24.83135
},
{
id: "U3RvcDpIU0w6NDMzMDIyMQ==",
lat: 60.3441,
lon: 24.83743
},
{
id: "U3RvcDpIU0w6NDMzMDIyNQ==",
lat: 60.34566,
lon: 24.83892
},
{
id: "U3RvcDpIU0w6NDMzMDIxMQ==",
lat: 60.34946,
lon: 24.84485
},
{
id: "U3RvcDpIU0w6NDMzMDI5Nw==",
lat: 60.34658,
lon: 24.85121
},
{
id: "U3RvcDpIU0w6NDMzMDI5NA==",
lat: 60.34842,
lon: 24.8547
},
{
id: "U3RvcDpIU0w6NDMzMDI5OA==",
lat: 60.34859,
lon: 24.8611
},
{
id: "U3RvcDpIU0w6NDMzMDIwMw==",
lat: 60.34775,
lon: 24.86668
},
{
id: "U3RvcDpIU0w6NDMzMDIxNg==",
lat: 60.34705,
lon: 24.87288
},
{
id: "U3RvcDpIU0w6NDMzMDIxMw==",
lat: 60.34795,
lon: 24.87113
},
{
id: "U3RvcDpIU0w6NDMzMDIwMg==",
lat: 60.34726,
lon: 24.86524
},
{
id: "U3RvcDpIU0w6NDI0MDIxMg==",
lat: 60.34255,
lon: 24.8648
},
{
id: "U3RvcDpIU0w6NDI0MDIwMg==",
lat: 60.33933,
lon: 24.86453
},
{
id: "U3RvcDpIU0w6NDI0MDIxMA==",
lat: 60.33669,
lon: 24.86352
},
{
id: "U3RvcDpIU0w6NDI0MDIxOA==",
lat: 60.33296,
lon: 24.86257
},
{
id: "U3RvcDpIU0w6NDI0MDIwOA==",
lat: 60.33036,
lon: 24.86273
},
{
id: "U3RvcDpIU0w6NDIzMDIzMg==",
lat: 60.32947,
lon: 24.8619
},
{
id: "U3RvcDpIU0w6NDIzMDIzMA==",
lat: 60.32875,
lon: 24.85569
},
{
id: "U3RvcDpIU0w6NDIzMDIyNg==",
lat: 60.32921,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDIzMDIyNA==",
lat: 60.32753,
lon: 24.85013
},
{
id: "U3RvcDpIU0w6NDIzMDIyMg==",
lat: 60.32522,
lon: 24.84962
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mg==",
lat: 60.323571,
lon: 24.851449
},
{
id: "U3RvcDpIU0w6NDIzMDI0MA==",
lat: 60.321997,
lon: 24.85308
},
{
id: "U3RvcDpIU0w6NDIzMDIzNg==",
lat: 60.320142,
lon: 24.855659
},
{
id: "U3RvcDpIU0w6NDIzMDIzNA==",
lat: 60.317929,
lon: 24.850801
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIzMDIzMw==",
lat: 60.318549,
lon: 24.85235
},
{
id: "U3RvcDpIU0w6NDIzMDIzNw==",
lat: 60.320869,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDIzMDI0MQ==",
lat: 60.322051,
lon: 24.853239
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mw==",
lat: 60.323765,
lon: 24.850455
},
{
id: "U3RvcDpIU0w6NDIzMDIyMQ==",
lat: 60.32615,
lon: 24.8498
},
{
id: "U3RvcDpIU0w6NDIzMDIyMw==",
lat: 60.32798,
lon: 24.85087
},
{
id: "U3RvcDpIU0w6NDIzMDIyOQ==",
lat: 60.32945,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDIzMDIzMQ==",
lat: 60.3282,
lon: 24.85841
},
{
id: "U3RvcDpIU0w6NDI0MDIwNw==",
lat: 60.331,
lon: 24.86291
},
{
id: "U3RvcDpIU0w6NDI0MDIxNw==",
lat: 60.33357,
lon: 24.86305
},
{
id: "U3RvcDpIU0w6NDI0MDIwOQ==",
lat: 60.3372,
lon: 24.86399
},
{
id: "U3RvcDpIU0w6NDI0MDIxOQ==",
lat: 60.34067,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6NDI0MDIxMQ==",
lat: 60.34244,
lon: 24.86512
},
{
id: "U3RvcDpIU0w6NDMzMDIxNA==",
lat: 60.34691,
lon: 24.87292
},
{
id: "U3RvcDpIU0w6NDMzMDIxNQ==",
lat: 60.34813,
lon: 24.86503
},
{
id: "U3RvcDpIU0w6NDMzMDI5OQ==",
lat: 60.34883,
lon: 24.86176
},
{
id: "U3RvcDpIU0w6NDMzMDIyNw==",
lat: 60.353985,
lon: 24.854893
},
{
id: "U3RvcDpIU0w6NDMzMDIxOQ==",
lat: 60.35829,
lon: 24.85868
},
{
id: "U3RvcDpIU0w6NDMyMDIwMQ==",
lat: 60.36364,
lon: 24.85535
},
{
id: "U3RvcDpIU0w6NDMyMDIwMw==",
lat: 60.36424,
lon: 24.85039
},
{
id: "U3RvcDpIU0w6NDMyMDIwNQ==",
lat: 60.36631,
lon: 24.84726
},
{
id: "U3RvcDpIU0w6NDMyMDIwNw==",
lat: 60.36962,
lon: 24.83928
},
{
id: "U3RvcDpIU0w6NDMyMDIwOQ==",
lat: 60.37713,
lon: 24.8387
},
{
id: "U3RvcDpIU0w6NDMyMDIxMQ==",
lat: 60.3829,
lon: 24.83648
},
{
id: "U3RvcDpIU0w6NDMyMDIxMw==",
lat: 60.38571,
lon: 24.83733
},
{
id: "U3RvcDpIU0w6NDMyMDIxNw==",
lat: 60.39278,
lon: 24.83334
},
{
id: "U3RvcDpIU0w6NDMyMDIyMA==",
lat: 60.39321,
lon: 24.83318
}
]
},
{
gtfsId: "HSL:1020N",
shortName: "20N",
longName: "Asema-aukio-Lauttasaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMxMDEyMQ==",
lat: 60.16819,
lon: 24.85737
},
{
id: "U3RvcDpIU0w6MTMxMDEyMA==",
lat: 60.16492,
lon: 24.85843
},
{
id: "U3RvcDpIU0w6MTMxMDExOA==",
lat: 60.16182,
lon: 24.85971
},
{
id: "U3RvcDpIU0w6MTMxMDExNg==",
lat: 60.1583,
lon: 24.86154
},
{
id: "U3RvcDpIU0w6MTMxMDExNA==",
lat: 60.15665,
lon: 24.86538
},
{
id: "U3RvcDpIU0w6MTMxMDExMg==",
lat: 60.15688,
lon: 24.86863
},
{
id: "U3RvcDpIU0w6MTMxMDExMA==",
lat: 60.15794,
lon: 24.87188
},
{
id: "U3RvcDpIU0w6MTMxMDEyNw==",
lat: 60.15759,
lon: 24.87384
},
{
id: "U3RvcDpIU0w6MTMxMDEyOQ==",
lat: 60.15365,
lon: 24.87722
},
{
id: "U3RvcDpIU0w6MTMxMDE0OA==",
lat: 60.154234,
lon: 24.880355
},
{
id: "U3RvcDpIU0w6MTMxMDEzMw==",
lat: 60.15089,
lon: 24.88264
},
{
id: "U3RvcDpIU0w6MTMxMDE0Ng==",
lat: 60.15126,
lon: 24.88587
},
{
id: "U3RvcDpIU0w6MTMxMDE0NQ==",
lat: 60.153338,
lon: 24.88512
},
{
id: "U3RvcDpIU0w6MTMxMDE0Mw==",
lat: 60.15661,
lon: 24.8856
},
{
id: "U3RvcDpIU0w6MTMxMDE0MQ==",
lat: 60.159713,
lon: 24.887872
},
{
id: "U3RvcDpIU0w6MTMxMDEwMg==",
lat: 60.16113,
lon: 24.89116
},
{
id: "U3RvcDpIU0w6MTIwMTEzMg==",
lat: 60.16338,
lon: 24.90505
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
},
{
id: "U3RvcDpIU0w6MTA0MDEyOQ==",
lat: 60.17112,
lon: 24.93338
},
{
id: "U3RvcDpIU0w6MTAyMDE3MQ==",
lat: 60.170863,
lon: 24.938568
},
{
id: "U3RvcDpIU0w6MTA0MDExNw==",
lat: 60.16875,
lon: 24.9353
},
{
id: "U3RvcDpIU0w6MTA0MDEyNw==",
lat: 60.1684,
lon: 24.93178
},
{
id: "U3RvcDpIU0w6MTA0MDEzMw==",
lat: 60.165495,
lon: 24.9269
},
{
id: "U3RvcDpIU0w6MTIwMTEyOQ==",
lat: 60.16436,
lon: 24.91112
},
{
id: "U3RvcDpIU0w6MTIwMTEzMQ==",
lat: 60.16338,
lon: 24.9044
},
{
id: "U3RvcDpIU0w6MTMxMDEwMQ==",
lat: 60.16126,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMxMDE0MA==",
lat: 60.158869,
lon: 24.886624
},
{
id: "U3RvcDpIU0w6MTMxMDE0Mg==",
lat: 60.15653,
lon: 24.88541
},
{
id: "U3RvcDpIU0w6MTMyMDE5OQ==",
lat: 60.153807,
lon: 24.884731
},
{
id: "U3RvcDpIU0w6MTMxMDIwMA==",
lat: 60.150452,
lon: 24.886015
},
{
id: "U3RvcDpIU0w6MTMxMDEzNw==",
lat: 60.149985,
lon: 24.881588
},
{
id: "U3RvcDpIU0w6MTMxMDEzNA==",
lat: 60.15206,
lon: 24.88245
},
{
id: "U3RvcDpIU0w6MTMxMDEzMA==",
lat: 60.1539,
lon: 24.8764
},
{
id: "U3RvcDpIU0w6MTMxMDEyOA==",
lat: 60.157265,
lon: 24.874033
},
{
id: "U3RvcDpIU0w6MTMxMDEwOQ==",
lat: 60.15817,
lon: 24.87228
},
{
id: "U3RvcDpIU0w6MTMxMDExMQ==",
lat: 60.1568,
lon: 24.86791
},
{
id: "U3RvcDpIU0w6MTMxMDExMw==",
lat: 60.15688,
lon: 24.86445
},
{
id: "U3RvcDpIU0w6MTMxMDExNQ==",
lat: 60.15934,
lon: 24.86085
},
{
id: "U3RvcDpIU0w6MTMxMDExNw==",
lat: 60.16207,
lon: 24.85976
},
{
id: "U3RvcDpIU0w6MTMxMDExOQ==",
lat: 60.165174,
lon: 24.85844
}
]
},
{
gtfsId: "HSL:4433K",
shortName: "433K",
longName: "Martinlaakso-Petas-Kivistö",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE3MDI0OA==",
lat: 60.27723,
lon: 24.85379
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIzOQ==",
lat: 60.28544,
lon: 24.85111
},
{
id: "U3RvcDpIU0w6NDE3MDI4Nw==",
lat: 60.290477,
lon: 24.844042
},
{
id: "U3RvcDpIU0w6NDI1MDIxMw==",
lat: 60.295045,
lon: 24.845304
},
{
id: "U3RvcDpIU0w6NDI1MDIxNQ==",
lat: 60.294941,
lon: 24.850681
},
{
id: "U3RvcDpIU0w6NDIxMDIwNQ==",
lat: 60.29993,
lon: 24.85925
},
{
id: "U3RvcDpIU0w6NDIxMDI5OQ==",
lat: 60.30173,
lon: 24.8569
},
{
id: "U3RvcDpIU0w6NDIxMDI5Nw==",
lat: 60.30152,
lon: 24.85215
},
{
id: "U3RvcDpIU0w6NDI1MDIxMQ==",
lat: 60.30256,
lon: 24.8448
},
{
id: "U3RvcDpIU0w6NDI1MDIwOA==",
lat: 60.3024,
lon: 24.83584
},
{
id: "U3RvcDpIU0w6NDI1MDIwNQ==",
lat: 60.30332,
lon: 24.83012
},
{
id: "U3RvcDpIU0w6NDI1MDIwNw==",
lat: 60.3023,
lon: 24.83559
},
{
id: "U3RvcDpIU0w6NDI1MDIxMA==",
lat: 60.30256,
lon: 24.84578
},
{
id: "U3RvcDpIU0w6NDIxMDIyNQ==",
lat: 60.30162,
lon: 24.84876
},
{
id: "U3RvcDpIU0w6NDIxMDIzNw==",
lat: 60.308071,
lon: 24.851351
},
{
id: "U3RvcDpIU0w6NDIxMDIzMw==",
lat: 60.31361,
lon: 24.85587
},
{
id: "U3RvcDpIU0w6NDI0MDIwMQ==",
lat: 60.319222,
lon: 24.869969
},
{
id: "U3RvcDpIU0w6NDI0MDIwMw==",
lat: 60.32273,
lon: 24.86908
},
{
id: "U3RvcDpIU0w6NDI0MDIwNQ==",
lat: 60.32608,
lon: 24.86706
},
{
id: "U3RvcDpIU0w6NDIzMDIzMg==",
lat: 60.32947,
lon: 24.8619
},
{
id: "U3RvcDpIU0w6NDIzMDIzMA==",
lat: 60.32875,
lon: 24.85569
},
{
id: "U3RvcDpIU0w6NDIzMDIyNg==",
lat: 60.32921,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDIzMDIyNA==",
lat: 60.32753,
lon: 24.85013
},
{
id: "U3RvcDpIU0w6NDIzMDIyMg==",
lat: 60.32522,
lon: 24.84962
},
{
id: "U3RvcDpIU0w6NDIzMDIyOA==",
lat: 60.3233,
lon: 24.84578
},
{
id: "U3RvcDpIU0w6NDIzMDIwOQ==",
lat: 60.32227,
lon: 24.8409
},
{
id: "U3RvcDpIU0w6NDIzMDIwNw==",
lat: 60.3205,
lon: 24.84192
},
{
id: "U3RvcDpIU0w6NDIzMDIwNQ==",
lat: 60.31832,
lon: 24.84409
},
{
id: "U3RvcDpIU0w6NDIzMDIwMw==",
lat: 60.316588,
lon: 24.847408
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0Nw==",
lat: 60.314485,
lon: 24.845366
},
{
id: "U3RvcDpIU0w6NDIzMDIwMg==",
lat: 60.317449,
lon: 24.846159
},
{
id: "U3RvcDpIU0w6NDIzMDIwNA==",
lat: 60.3189,
lon: 24.84368
},
{
id: "U3RvcDpIU0w6NDIzMDIwNg==",
lat: 60.32009,
lon: 24.84231
},
{
id: "U3RvcDpIU0w6NDIzMDIyNw==",
lat: 60.32297,
lon: 24.84473
},
{
id: "U3RvcDpIU0w6NDIzMDIyMQ==",
lat: 60.32615,
lon: 24.8498
},
{
id: "U3RvcDpIU0w6NDIzMDIyMw==",
lat: 60.32798,
lon: 24.85087
},
{
id: "U3RvcDpIU0w6NDIzMDIyOQ==",
lat: 60.32945,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDIzMDIzMQ==",
lat: 60.3282,
lon: 24.85841
},
{
id: "U3RvcDpIU0w6NDI0MDIwNg==",
lat: 60.32723,
lon: 24.86575
},
{
id: "U3RvcDpIU0w6NDI0MDIyMA==",
lat: 60.32498,
lon: 24.86777
},
{
id: "U3RvcDpIU0w6NDI0MDIwNA==",
lat: 60.32204,
lon: 24.86887
},
{
id: "U3RvcDpIU0w6NDI0MDIyNw==",
lat: 60.31905,
lon: 24.8698
},
{
id: "U3RvcDpIU0w6NDIxMDI0NQ==",
lat: 60.316659,
lon: 24.867147
},
{
id: "U3RvcDpIU0w6NDIxMDIzNg==",
lat: 60.307648,
lon: 24.850909
},
{
id: "U3RvcDpIU0w6NDIxMDIyNg==",
lat: 60.30299,
lon: 24.84741
},
{
id: "U3RvcDpIU0w6NDIxMDI5OA==",
lat: 60.30157,
lon: 24.8534
},
{
id: "U3RvcDpIU0w6NDIxMDIxNQ==",
lat: 60.30119,
lon: 24.85722
},
{
id: "U3RvcDpIU0w6NDIxMDIwNg==",
lat: 60.29954,
lon: 24.85863
},
{
id: "U3RvcDpIU0w6NDI1MDIxNA==",
lat: 60.295186,
lon: 24.850523
},
{
id: "U3RvcDpIU0w6NDI1MDIxMg==",
lat: 60.295095,
lon: 24.844916
},
{
id: "U3RvcDpIU0w6NDE3MDI4Ng==",
lat: 60.289436,
lon: 24.845115
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxMQ==",
lat: 60.2773,
lon: 24.85304
}
]
},
{
gtfsId: "HSL:9971",
shortName: "971",
longName: "Kivistö-Ruotsinkylä-Hyrylä-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA0MDIyMA==",
lat: 60.40444,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIwNQ==",
lat: 60.40346,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6OTA0MDIwMw==",
lat: 60.40212,
lon: 25.09875
},
{
id: "U3RvcDpIU0w6OTA5MDIyOA==",
lat: 60.4003,
lon: 25.11
},
{
id: "U3RvcDpIU0w6OTA5MDIyOQ==",
lat: 60.39855,
lon: 25.11187
},
{
id: "U3RvcDpIU0w6OTA5MDIyMQ==",
lat: 60.39441,
lon: 25.11131
},
{
id: "U3RvcDpIU0w6OTA2MDIyNw==",
lat: 60.395655,
lon: 25.094513
},
{
id: "U3RvcDpIU0w6OTY1MDIwNA==",
lat: 60.395166,
lon: 25.080072
},
{
id: "U3RvcDpIU0w6OTY1MDQxMw==",
lat: 60.39496,
lon: 25.069391
},
{
id: "U3RvcDpIU0w6OTY1MDQwNQ==",
lat: 60.395692,
lon: 25.057409
},
{
id: "U3RvcDpIU0w6OTY1MDMzMQ==",
lat: 60.399791,
lon: 25.049256
},
{
id: "U3RvcDpIU0w6OTY1MDEwMg==",
lat: 60.40142,
lon: 25.030759
},
{
id: "U3RvcDpIU0w6OTY1MDEyNA==",
lat: 60.40201,
lon: 25.028074
},
{
id: "U3RvcDpIU0w6OTY1MDExMQ==",
lat: 60.400819,
lon: 25.026307
},
{
id: "U3RvcDpIU0w6OTY1MDEwNQ==",
lat: 60.398721,
lon: 25.02284
},
{
id: "U3RvcDpIU0w6OTY1MDEwMA==",
lat: 60.398035,
lon: 25.020074
},
{
id: "U3RvcDpIU0w6OTY1MTUxMg==",
lat: 60.395856,
lon: 25.015069
},
{
id: "U3RvcDpIU0w6OTY1MTUwOA==",
lat: 60.394413,
lon: 25.017147
},
{
id: "U3RvcDpIU0w6OTY1MTUxMA==",
lat: 60.389878,
lon: 25.018535
},
{
id: "U3RvcDpIU0w6OTY1MTQwMg==",
lat: 60.386483,
lon: 25.013222
},
{
id: "U3RvcDpIU0w6OTY1MTQwMA==",
lat: 60.383973,
lon: 25.010521
},
{
id: "U3RvcDpIU0w6OTY1MTQwNA==",
lat: 60.382054,
lon: 25.014925
},
{
id: "U3RvcDpIU0w6OTY1MTMwOA==",
lat: 60.378836,
lon: 25.012496
},
{
id: "U3RvcDpIU0w6OTY1MTMwMA==",
lat: 60.377481,
lon: 25.013463
},
{
id: "U3RvcDpIU0w6OTY1MTMwNw==",
lat: 60.375437,
lon: 25.013458
},
{
id: "U3RvcDpIU0w6OTY1MTMxNQ==",
lat: 60.374632,
lon: 25.008149
},
{
id: "U3RvcDpIU0w6OTY1MTMxMQ==",
lat: 60.37815,
lon: 25.002709
},
{
id: "U3RvcDpIU0w6OTY1MTMxOA==",
lat: 60.377594,
lon: 24.994208
},
{
id: "U3RvcDpIU0w6OTY1MTIwOQ==",
lat: 60.380164,
lon: 24.985366
},
{
id: "U3RvcDpIU0w6OTY1MTEwMg==",
lat: 60.374658,
lon: 24.972308
},
{
id: "U3RvcDpIU0w6OTY3MDIxMA==",
lat: 60.369358,
lon: 24.97256
},
{
id: "U3RvcDpIU0w6OTY3MDIwNw==",
lat: 60.368434,
lon: 24.97057
},
{
id: "U3RvcDpIU0w6OTY3MDMwNg==",
lat: 60.365909,
lon: 24.959812
},
{
id: "U3RvcDpIU0w6OTY3MDMwNQ==",
lat: 60.362077,
lon: 24.953929
},
{
id: "U3RvcDpIU0w6OTY3MDMxMA==",
lat: 60.359503,
lon: 24.950051
},
{
id: "U3RvcDpIU0w6OTY3MDMwOA==",
lat: 60.351493,
lon: 24.945105
},
{
id: "U3RvcDpIU0w6OTY3MDMwMQ==",
lat: 60.34576,
lon: 24.940626
},
{
id: "U3RvcDpIU0w6NDM0MDIxMw==",
lat: 60.340856,
lon: 24.936105
},
{
id: "U3RvcDpIU0w6NDM0MDIwOQ==",
lat: 60.33572,
lon: 24.92308
},
{
id: "U3RvcDpIU0w6NDQxMDIwMQ==",
lat: 60.32492,
lon: 24.9186
},
{
id: "U3RvcDpIU0w6NDQxMDIwMw==",
lat: 60.32137,
lon: 24.91558
},
{
id: "U3RvcDpIU0w6NDQxMDIwNg==",
lat: 60.31869,
lon: 24.91055
},
{
id: "U3RvcDpIU0w6NDQxMDIwNQ==",
lat: 60.31651,
lon: 24.90261
},
{
id: "U3RvcDpIU0w6NDQxMDI2Mg==",
lat: 60.30795,
lon: 24.88963
},
{
id: "U3RvcDpIU0w6NDQxMDI2NA==",
lat: 60.309264,
lon: 24.891525
},
{
id: "U3RvcDpIU0w6NDIxMDI0NQ==",
lat: 60.316659,
lon: 24.867147
},
{
id: "U3RvcDpIU0w6NDIxMDIyMg==",
lat: 60.31329,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDIzMDI0OQ==",
lat: 60.316261,
lon: 24.848552
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIzMDI0OA==",
lat: 60.315237,
lon: 24.849881
},
{
id: "U3RvcDpIU0w6NDIxMDIzMw==",
lat: 60.31361,
lon: 24.85587
},
{
id: "U3RvcDpIU0w6NDIxMDI0Mg==",
lat: 60.31661,
lon: 24.87129
},
{
id: "U3RvcDpIU0w6NDQxMDI2Mw==",
lat: 60.308548,
lon: 24.889088
},
{
id: "U3RvcDpIU0w6NDUzMDI1NQ==",
lat: 60.31696,
lon: 24.90548
},
{
id: "U3RvcDpIU0w6NDUzMDI1Ng==",
lat: 60.31959,
lon: 24.91317
},
{
id: "U3RvcDpIU0w6NDQxMDIwNA==",
lat: 60.32243,
lon: 24.91681
},
{
id: "U3RvcDpIU0w6NDQxMDIwMg==",
lat: 60.32612,
lon: 24.91986
},
{
id: "U3RvcDpIU0w6NDM0MDIxMQ==",
lat: 60.33653,
lon: 24.92468
},
{
id: "U3RvcDpIU0w6NDM0MDIxMg==",
lat: 60.34141,
lon: 24.93791
},
{
id: "U3RvcDpIU0w6OTY3MDMwMA==",
lat: 60.346246,
lon: 24.940262
},
{
id: "U3RvcDpIU0w6OTY3MDMwNw==",
lat: 60.352663,
lon: 24.946411
},
{
id: "U3RvcDpIU0w6OTY3MDMwOQ==",
lat: 60.360235,
lon: 24.95095
},
{
id: "U3RvcDpIU0w6OTY3MDMwNA==",
lat: 60.363117,
lon: 24.954944
},
{
id: "U3RvcDpIU0w6OTY3MDIxMQ==",
lat: 60.366135,
lon: 24.961567
},
{
id: "U3RvcDpIU0w6OTY3MDIwOA==",
lat: 60.368676,
lon: 24.971486
},
{
id: "U3RvcDpIU0w6OTY3MDIwOQ==",
lat: 60.370096,
lon: 24.972334
},
{
id: "U3RvcDpIU0w6OTY1MTEwMQ==",
lat: 60.376759,
lon: 24.974271
},
{
id: "U3RvcDpIU0w6OTY1MTIwOA==",
lat: 60.380733,
lon: 24.979981
},
{
id: "U3RvcDpIU0w6OTY1MTIxMA==",
lat: 60.379998,
lon: 24.985959
},
{
id: "U3RvcDpIU0w6OTY1MTMwMw==",
lat: 60.377475,
lon: 24.995715
},
{
id: "U3RvcDpIU0w6OTY1MTMxMA==",
lat: 60.378195,
lon: 25.002597
},
{
id: "U3RvcDpIU0w6OTY1MTMxNA==",
lat: 60.374642,
lon: 25.008644
},
{
id: "U3RvcDpIU0w6OTY1MTMwNg==",
lat: 60.375739,
lon: 25.014929
},
{
id: "U3RvcDpIU0w6OTY1MTMwMQ==",
lat: 60.377366,
lon: 25.013702
},
{
id: "U3RvcDpIU0w6OTY1MTMwOQ==",
lat: 60.378562,
lon: 25.012256
},
{
id: "U3RvcDpIU0w6OTY1MTQwNQ==",
lat: 60.381872,
lon: 25.01535
},
{
id: "U3RvcDpIU0w6OTY1MTQwMQ==",
lat: 60.383909,
lon: 25.010676
},
{
id: "U3RvcDpIU0w6OTY1MTQwMw==",
lat: 60.386849,
lon: 25.01417
},
{
id: "U3RvcDpIU0w6OTY1MTUwOQ==",
lat: 60.389759,
lon: 25.018555
},
{
id: "U3RvcDpIU0w6OTY1MTUwNw==",
lat: 60.394369,
lon: 25.017403
},
{
id: "U3RvcDpIU0w6OTY1MTUxMQ==",
lat: 60.396094,
lon: 25.015021
},
{
id: "U3RvcDpIU0w6OTY1MDEwMQ==",
lat: 60.397854,
lon: 25.019908
},
{
id: "U3RvcDpIU0w6OTY1MDEwNA==",
lat: 60.397977,
lon: 25.022502
},
{
id: "U3RvcDpIU0w6OTY1MDExMA==",
lat: 60.400624,
lon: 25.026438
},
{
id: "U3RvcDpIU0w6OTY1MDEyMg==",
lat: 60.401853,
lon: 25.027808
},
{
id: "U3RvcDpIU0w6OTY1MDEwMw==",
lat: 60.401391,
lon: 25.03098
},
{
id: "U3RvcDpIU0w6OTY1MDMxMQ==",
lat: 60.402259,
lon: 25.039112
},
{
id: "U3RvcDpIU0w6OTY1MDMzMA==",
lat: 60.39932,
lon: 25.049803
},
{
id: "U3RvcDpIU0w6OTY1MDQwNA==",
lat: 60.395299,
lon: 25.058995
},
{
id: "U3RvcDpIU0w6OTY1MDQxMg==",
lat: 60.395141,
lon: 25.07203
},
{
id: "U3RvcDpIU0w6OTA2MDIxNw==",
lat: 60.395136,
lon: 25.081267
},
{
id: "U3RvcDpIU0w6OTA2MDIyOA==",
lat: 60.395496,
lon: 25.096575
},
{
id: "U3RvcDpIU0w6OTA5MDIyMw==",
lat: 60.39549,
lon: 25.11139
},
{
id: "U3RvcDpIU0w6OTA5MDIzMA==",
lat: 60.39932,
lon: 25.11249
},
{
id: "U3RvcDpIU0w6OTA0MDIxNA==",
lat: 60.40034,
lon: 25.11154
},
{
id: "U3RvcDpIU0w6OTA0MDIyNg==",
lat: 60.40116,
lon: 25.10171
},
{
id: "U3RvcDpIU0w6OTA0MDIwNA==",
lat: 60.40206,
lon: 25.09889
},
{
id: "U3RvcDpIU0w6OTA0MDIwNg==",
lat: 60.40346,
lon: 25.10141
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
}
]
},
{
gtfsId: "HSL:2241V",
shortName: "241V",
longName: "Espoon keskus-Hirvisuo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYyMTIzMQ==",
lat: 60.21626,
lon: 24.63137
},
{
id: "U3RvcDpIU0w6MjYyMTIyMw==",
lat: 60.21355,
lon: 24.6296
},
{
id: "U3RvcDpIU0w6MjYyMTIyNQ==",
lat: 60.20841,
lon: 24.63715
},
{
id: "U3RvcDpIU0w6MjYyMTIxNw==",
lat: 60.20649,
lon: 24.64021
},
{
id: "U3RvcDpIU0w6MjYxMTIxOQ==",
lat: 60.205048,
lon: 24.65511
},
{
id: "U3RvcDpIU0w6MjYxMTI1OA==",
lat: 60.20535,
lon: 24.65686
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYyMTIyNw==",
lat: 60.20734,
lon: 24.63928
},
{
id: "U3RvcDpIU0w6MjYyMTIyOA==",
lat: 60.20933,
lon: 24.63587
},
{
id: "U3RvcDpIU0w6MjYyMTIyNA==",
lat: 60.2142,
lon: 24.62969
}
]
},
{
gtfsId: "HSL:9972",
shortName: "972",
longName: "Korso-Alikerava-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDgxMDIyOA==",
lat: 60.35035,
lon: 25.07627
},
{
id: "U3RvcDpIU0w6NDgxMDIwNA==",
lat: 60.35271,
lon: 25.06532
},
{
id: "U3RvcDpIU0w6NDgxMDIwNg==",
lat: 60.3531,
lon: 25.06058
},
{
id: "U3RvcDpIU0w6NDgxMDIwOA==",
lat: 60.35364,
lon: 25.05589
},
{
id: "U3RvcDpIU0w6NDgxMDI0Nw==",
lat: 60.35473,
lon: 25.05225
},
{
id: "U3RvcDpIU0w6NDgxMDIxOQ==",
lat: 60.3572,
lon: 25.05523
},
{
id: "U3RvcDpIU0w6NDgxMDIyMQ==",
lat: 60.35993,
lon: 25.06364
},
{
id: "U3RvcDpIU0w6NDgxMDI0NQ==",
lat: 60.36148,
lon: 25.06622
},
{
id: "U3RvcDpIU0w6NDg4MDIwNQ==",
lat: 60.36503,
lon: 25.06885
},
{
id: "U3RvcDpIU0w6NDg4MDIxMw==",
lat: 60.36808,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDg4MDIxMQ==",
lat: 60.36612,
lon: 25.08191
},
{
id: "U3RvcDpIU0w6NDg4MDIxMg==",
lat: 60.36464,
lon: 25.08558
},
{
id: "U3RvcDpIU0w6OTA5MDIwMQ==",
lat: 60.36908,
lon: 25.09159
},
{
id: "U3RvcDpIU0w6OTA5MDIwMg==",
lat: 60.37184,
lon: 25.09374
},
{
id: "U3RvcDpIU0w6OTA5MDIxNA==",
lat: 60.37496,
lon: 25.09514
},
{
id: "U3RvcDpIU0w6OTA5MDIxMQ==",
lat: 60.374866,
lon: 25.103551
},
{
id: "U3RvcDpIU0w6OTA5MDIxMw==",
lat: 60.37996,
lon: 25.10693
},
{
id: "U3RvcDpIU0w6OTA5MDIxNg==",
lat: 60.38229,
lon: 25.10894
},
{
id: "U3RvcDpIU0w6OTA5MDIxOA==",
lat: 60.38732,
lon: 25.10991
},
{
id: "U3RvcDpIU0w6OTA5MDIyMA==",
lat: 60.39162,
lon: 25.11097
},
{
id: "U3RvcDpIU0w6OTA5MDIyMw==",
lat: 60.39549,
lon: 25.11139
},
{
id: "U3RvcDpIU0w6OTA5MDIzMA==",
lat: 60.39932,
lon: 25.11249
},
{
id: "U3RvcDpIU0w6OTA0MDIxNA==",
lat: 60.40034,
lon: 25.11154
},
{
id: "U3RvcDpIU0w6OTA0MDIyNg==",
lat: 60.40116,
lon: 25.10171
},
{
id: "U3RvcDpIU0w6OTA0MDIwNA==",
lat: 60.40206,
lon: 25.09889
},
{
id: "U3RvcDpIU0w6OTA0MDIwNg==",
lat: 60.40346,
lon: 25.10141
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
},
{
id: "U3RvcDpIU0w6OTA0MDIyMA==",
lat: 60.40444,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIwNQ==",
lat: 60.40346,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6OTA0MDIwMw==",
lat: 60.40212,
lon: 25.09875
},
{
id: "U3RvcDpIU0w6OTA5MDIyOA==",
lat: 60.4003,
lon: 25.11
},
{
id: "U3RvcDpIU0w6OTA5MDIyOQ==",
lat: 60.39855,
lon: 25.11187
},
{
id: "U3RvcDpIU0w6OTA5MDIyMQ==",
lat: 60.39441,
lon: 25.11131
},
{
id: "U3RvcDpIU0w6OTA5MDIxOQ==",
lat: 60.39079,
lon: 25.11095
},
{
id: "U3RvcDpIU0w6OTA5MDIxNw==",
lat: 60.38619,
lon: 25.10914
},
{
id: "U3RvcDpIU0w6OTA5MDIxNQ==",
lat: 60.38125,
lon: 25.10798
},
{
id: "U3RvcDpIU0w6OTA5MDIxMg==",
lat: 60.37916,
lon: 25.10598
},
{
id: "U3RvcDpIU0w6OTA5MDIxMA==",
lat: 60.37492,
lon: 25.102521
},
{
id: "U3RvcDpIU0w6OTA2MDIxNg==",
lat: 60.37496,
lon: 25.09478
},
{
id: "U3RvcDpIU0w6OTA2MDIwMg==",
lat: 60.37139,
lon: 25.0933
},
{
id: "U3RvcDpIU0w6OTA2MDIwMQ==",
lat: 60.36877,
lon: 25.09115
},
{
id: "U3RvcDpIU0w6NDg4MDIxMA==",
lat: 60.36471,
lon: 25.08515
},
{
id: "U3RvcDpIU0w6NDg4MDIwOA==",
lat: 60.36658,
lon: 25.08115
},
{
id: "U3RvcDpIU0w6NDg4MDIwMg==",
lat: 60.36804,
lon: 25.07406
},
{
id: "U3RvcDpIU0w6NDg4MDIwNA==",
lat: 60.36436,
lon: 25.06788
},
{
id: "U3RvcDpIU0w6NDgxMDI0Ng==",
lat: 60.3615,
lon: 25.066
},
{
id: "U3RvcDpIU0w6NDgxMDIyMg==",
lat: 60.35894,
lon: 25.06111
},
{
id: "U3RvcDpIU0w6NDgxMDIyMA==",
lat: 60.35668,
lon: 25.05364
},
{
id: "U3RvcDpIU0w6NDgxMDI0OA==",
lat: 60.35416,
lon: 25.05255
},
{
id: "U3RvcDpIU0w6NDgxMDIwOQ==",
lat: 60.35341,
lon: 25.0565
},
{
id: "U3RvcDpIU0w6NDgxMDIwNw==",
lat: 60.3529,
lon: 25.06141
},
{
id: "U3RvcDpIU0w6NDgxMDIwNQ==",
lat: 60.3526,
lon: 25.06612
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
}
]
},
{
gtfsId: "HSL:1079N",
shortName: "79N",
longName: "Rautatientori-Malmi-Siltamäki-Puistolan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQwMjEyNg==",
lat: 60.27529,
lon: 25.03544
},
{
id: "U3RvcDpIU0w6MTQwMjEyMQ==",
lat: 60.27863,
lon: 25.03001
},
{
id: "U3RvcDpIU0w6MTQwMjE0NQ==",
lat: 60.27802,
lon: 25.02428
},
{
id: "U3RvcDpIU0w6MTQwMjEyNw==",
lat: 60.2787,
lon: 25.02038
},
{
id: "U3RvcDpIU0w6MTQwMTEyNQ==",
lat: 60.280803,
lon: 25.017427
},
{
id: "U3RvcDpIU0w6MTQwMTE4MA==",
lat: 60.27948,
lon: 25.00944
},
{
id: "U3RvcDpIU0w6MTQwMTExMg==",
lat: 60.27823,
lon: 25.00574
},
{
id: "U3RvcDpIU0w6MTQwMTEzNg==",
lat: 60.27982,
lon: 25.00405
},
{
id: "U3RvcDpIU0w6MTQwMTEzNQ==",
lat: 60.27953,
lon: 24.99857
},
{
id: "U3RvcDpIU0w6MTQwMTEzMw==",
lat: 60.27835,
lon: 24.99422
},
{
id: "U3RvcDpIU0w6MTQwMTEzMg==",
lat: 60.276818,
lon: 24.990048
},
{
id: "U3RvcDpIU0w6MTQwMTEwNw==",
lat: 60.27497,
lon: 24.99117
},
{
id: "U3RvcDpIU0w6MTQwMTEwNA==",
lat: 60.27209,
lon: 24.9922
},
{
id: "U3RvcDpIU0w6MTQwMzEyNw==",
lat: 60.26665,
lon: 24.99296
},
{
id: "U3RvcDpIU0w6MTM5MTE5MQ==",
lat: 60.26109,
lon: 24.99015
},
{
id: "U3RvcDpIU0w6MTM5MTEwOQ==",
lat: 60.2585,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwMg==",
lat: 60.2502,
lon: 25.00917
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MzExNA==",
lat: 60.23859,
lon: 25.02095
},
{
id: "U3RvcDpIU0w6MTM4MzExMg==",
lat: 60.23595,
lon: 25.02177
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM2MzEwMQ==",
lat: 60.229313,
lon: 25.010037
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjEwNQ==",
lat: 60.22862,
lon: 25.01202
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEwOQ==",
lat: 60.232187,
lon: 25.011714
},
{
id: "U3RvcDpIU0w6MTM4MzExMQ==",
lat: 60.23676,
lon: 25.02225
},
{
id: "U3RvcDpIU0w6MTM4MjExMw==",
lat: 60.240179,
lon: 25.021039
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MTEwMw==",
lat: 60.25015,
lon: 25.00951
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEwNg==",
lat: 60.25733,
lon: 24.99789
},
{
id: "U3RvcDpIU0w6MTM5MTEwOA==",
lat: 60.25877,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM5MTE5MA==",
lat: 60.26154,
lon: 24.99091
},
{
id: "U3RvcDpIU0w6MTQwMzEyNg==",
lat: 60.2669,
lon: 24.99344
},
{
id: "U3RvcDpIU0w6MTQwMTEwMw==",
lat: 60.27145,
lon: 24.99206
},
{
id: "U3RvcDpIU0w6MTQwMTEwNQ==",
lat: 60.27532,
lon: 24.99112
},
{
id: "U3RvcDpIU0w6MTQwMTEwNg==",
lat: 60.2774,
lon: 24.9909
},
{
id: "U3RvcDpIU0w6MTQwMTEzMQ==",
lat: 60.27863,
lon: 24.99518
},
{
id: "U3RvcDpIU0w6MTQwMTEzNA==",
lat: 60.27931,
lon: 24.99788
},
{
id: "U3RvcDpIU0w6MTQwMTEyNA==",
lat: 60.27925,
lon: 25.00451
},
{
id: "U3RvcDpIU0w6MTQwMTExMQ==",
lat: 60.27818,
lon: 25.00693
},
{
id: "U3RvcDpIU0w6MTQwMTExMw==",
lat: 60.28044,
lon: 25.01124
},
{
id: "U3RvcDpIU0w6MTQwMTE1NQ==",
lat: 60.278987,
lon: 25.017328
},
{
id: "U3RvcDpIU0w6MTQwMjEyOA==",
lat: 60.27815,
lon: 25.02228
},
{
id: "U3RvcDpIU0w6MTQwMjEyMg==",
lat: 60.27838,
lon: 25.03171
},
{
id: "U3RvcDpIU0w6MTQwMjE1MA==",
lat: 60.27665,
lon: 25.03432
},
{
id: "U3RvcDpIU0w6MTQwMjEzMg==",
lat: 60.275477,
lon: 25.034827
}
]
},
{
gtfsId: "HSL:9975",
shortName: "975",
longName: "Kerava as.- Kaleva - Mattilanpuisto",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDQwMg==",
lat: 60.404691,
lon: 25.079211
},
{
id: "U3RvcDpIU0w6OTY1MDQxMQ==",
lat: 60.407775,
lon: 25.079545
},
{
id: "U3RvcDpIU0w6OTAxMDIxNg==",
lat: 60.40999,
lon: 25.08438
},
{
id: "U3RvcDpIU0w6OTAxMDIxOA==",
lat: 60.41233,
lon: 25.08319
},
{
id: "U3RvcDpIU0w6OTAxMDIyMA==",
lat: 60.41462,
lon: 25.08157
},
{
id: "U3RvcDpIU0w6OTAxMDIyMg==",
lat: 60.41648,
lon: 25.08081
},
{
id: "U3RvcDpIU0w6OTAxMDIyNA==",
lat: 60.41868,
lon: 25.08654
},
{
id: "U3RvcDpIU0w6OTAxMDIyNg==",
lat: 60.41955,
lon: 25.0891
},
{
id: "U3RvcDpIU0w6OTAxMDIwOA==",
lat: 60.41643,
lon: 25.09163
},
{
id: "U3RvcDpIU0w6OTAxMDIxMA==",
lat: 60.41426,
lon: 25.09428
},
{
id: "U3RvcDpIU0w6OTAxMDIxMg==",
lat: 60.4107,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6OTAxMDIxNA==",
lat: 60.40774,
lon: 25.09777
},
{
id: "U3RvcDpIU0w6OTAyMDIwNw==",
lat: 60.40457,
lon: 25.096
},
{
id: "U3RvcDpIU0w6OTA0MDIwNA==",
lat: 60.40206,
lon: 25.09889
},
{
id: "U3RvcDpIU0w6OTA0MDIwNg==",
lat: 60.40346,
lon: 25.10141
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
},
{
id: "U3RvcDpIU0w6OTA0MDIyMA==",
lat: 60.40444,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIwNQ==",
lat: 60.40346,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6OTA0MDIwMw==",
lat: 60.40212,
lon: 25.09875
},
{
id: "U3RvcDpIU0w6OTA0MDIwMQ==",
lat: 60.4041,
lon: 25.09687
},
{
id: "U3RvcDpIU0w6OTAxMDIxMw==",
lat: 60.40826,
lon: 25.09736
},
{
id: "U3RvcDpIU0w6OTAxMDIxMQ==",
lat: 60.4112,
lon: 25.09594
},
{
id: "U3RvcDpIU0w6OTAxMDIwOQ==",
lat: 60.41408,
lon: 25.09471
},
{
id: "U3RvcDpIU0w6OTAxMDIwNw==",
lat: 60.41618,
lon: 25.09203
},
{
id: "U3RvcDpIU0w6OTAxMDIyNQ==",
lat: 60.41959,
lon: 25.08885
},
{
id: "U3RvcDpIU0w6OTAxMDIyMw==",
lat: 60.41865,
lon: 25.08612
},
{
id: "U3RvcDpIU0w6OTAxMDIyMQ==",
lat: 60.41638,
lon: 25.08067
},
{
id: "U3RvcDpIU0w6OTAxMDIxOQ==",
lat: 60.4145,
lon: 25.08144
},
{
id: "U3RvcDpIU0w6OTAxMDIxNw==",
lat: 60.41262,
lon: 25.0829
},
{
id: "U3RvcDpIU0w6OTAxMDIxNQ==",
lat: 60.40978,
lon: 25.08347
},
{
id: "U3RvcDpIU0w6OTY1MDQxMA==",
lat: 60.407106,
lon: 25.079626
}
]
},
{
gtfsId: "HSL:9976",
shortName: "976",
longName: "Keravan asema-Virrenkulma",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMw==",
lat: 60.40713,
lon: 25.10447
},
{
id: "U3RvcDpIU0w6OTAxMDI0MA==",
lat: 60.40891,
lon: 25.10732
},
{
id: "U3RvcDpIU0w6OTAxMDIzNw==",
lat: 60.41123,
lon: 25.10795
},
{
id: "U3RvcDpIU0w6OTAxMDIzNQ==",
lat: 60.41371,
lon: 25.10426
},
{
id: "U3RvcDpIU0w6OTAxMDIzMw==",
lat: 60.41712,
lon: 25.10289
},
{
id: "U3RvcDpIU0w6OTAxMDIzMQ==",
lat: 60.42022,
lon: 25.10123
},
{
id: "U3RvcDpIU0w6OTAxMDIyOQ==",
lat: 60.422418,
lon: 25.101344
},
{
id: "U3RvcDpIU0w6OTAxMDI0Ng==",
lat: 60.42331,
lon: 25.10508
},
{
id: "U3RvcDpIU0w6OTAxMDIwNg==",
lat: 60.42569,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6OTAxMDIwNA==",
lat: 60.42855,
lon: 25.10095
},
{
id: "U3RvcDpIU0w6OTAxMDIzOA==",
lat: 60.427536,
lon: 25.100113
},
{
id: "U3RvcDpIU0w6OTAxMDIwNQ==",
lat: 60.42558,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6OTAxMDI0NQ==",
lat: 60.42321,
lon: 25.10483
},
{
id: "U3RvcDpIU0w6OTAxMDIzMA==",
lat: 60.42186,
lon: 25.09927
},
{
id: "U3RvcDpIU0w6OTAxMDIzMg==",
lat: 60.41974,
lon: 25.10159
},
{
id: "U3RvcDpIU0w6OTAxMDIzNA==",
lat: 60.41635,
lon: 25.10261
},
{
id: "U3RvcDpIU0w6OTAxMDIzNg==",
lat: 60.41352,
lon: 25.1052
},
{
id: "U3RvcDpIU0w6OTAxMDI1NQ==",
lat: 60.41089,
lon: 25.10773
},
{
id: "U3RvcDpIU0w6OTAxMDIzOQ==",
lat: 60.4085,
lon: 25.10631
},
{
id: "U3RvcDpIU0w6OTA0MDIwNw==",
lat: 60.40696,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
}
]
},
{
gtfsId: "HSL:9973",
shortName: "973",
longName: "Peijas-Korso-Kannisto-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA0MDIyMA==",
lat: 60.40444,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIwNQ==",
lat: 60.40346,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6OTA0MDIwMw==",
lat: 60.40212,
lon: 25.09875
},
{
id: "U3RvcDpIU0w6OTAzMDIxMw==",
lat: 60.39893,
lon: 25.10327
},
{
id: "U3RvcDpIU0w6OTA2MDIwNw==",
lat: 60.39306,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6OTA2MDIzMQ==",
lat: 60.391,
lon: 25.09755
},
{
id: "U3RvcDpIU0w6OTA2MDIyOQ==",
lat: 60.39059,
lon: 25.09295
},
{
id: "U3RvcDpIU0w6OTA2MDIyNQ==",
lat: 60.38845,
lon: 25.0891
},
{
id: "U3RvcDpIU0w6OTA2MDIyMw==",
lat: 60.3851,
lon: 25.08938
},
{
id: "U3RvcDpIU0w6OTA2MDIyMQ==",
lat: 60.38372,
lon: 25.08716
},
{
id: "U3RvcDpIU0w6OTA2MDIxOA==",
lat: 60.38233,
lon: 25.0886
},
{
id: "U3RvcDpIU0w6OTA2MDIxMg==",
lat: 60.38032,
lon: 25.08745
},
{
id: "U3RvcDpIU0w6OTA2MDIxMA==",
lat: 60.37722,
lon: 25.08155
},
{
id: "U3RvcDpIU0w6OTA2MDIwOA==",
lat: 60.37554,
lon: 25.07952
},
{
id: "U3RvcDpIU0w6NDg4MDIwNg==",
lat: 60.37136,
lon: 25.07646
},
{
id: "U3RvcDpIU0w6NDg4MDIwMg==",
lat: 60.36804,
lon: 25.07406
},
{
id: "U3RvcDpIU0w6NDg4MDIwNA==",
lat: 60.36436,
lon: 25.06788
},
{
id: "U3RvcDpIU0w6NDgxMDI0Ng==",
lat: 60.3615,
lon: 25.066
},
{
id: "U3RvcDpIU0w6NDgxMDIyMg==",
lat: 60.35894,
lon: 25.06111
},
{
id: "U3RvcDpIU0w6NDgxMDIyMA==",
lat: 60.35668,
lon: 25.05364
},
{
id: "U3RvcDpIU0w6NDgxMDI0OA==",
lat: 60.35416,
lon: 25.05255
},
{
id: "U3RvcDpIU0w6NDgxMDIwOQ==",
lat: 60.35341,
lon: 25.0565
},
{
id: "U3RvcDpIU0w6NDgxMDIwNw==",
lat: 60.3529,
lon: 25.06141
},
{
id: "U3RvcDpIU0w6NDgxMDIwNQ==",
lat: 60.3526,
lon: 25.06612
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDIzMQ==",
lat: 60.34492,
lon: 25.07435
},
{
id: "U3RvcDpIU0w6NDcyMDIwOA==",
lat: 60.34002,
lon: 25.06982
},
{
id: "U3RvcDpIU0w6NDcyMDIwNg==",
lat: 60.3343,
lon: 25.06437
},
{
id: "U3RvcDpIU0w6NDcyMDIwNA==",
lat: 60.33103,
lon: 25.06343
},
{
id: "U3RvcDpIU0w6NDcyMDIxNg==",
lat: 60.33213,
lon: 25.06075
},
{
id: "U3RvcDpIU0w6NDcyMDIwOQ==",
lat: 60.33219,
lon: 25.06038
},
{
id: "U3RvcDpIU0w6NDcyMDIwMw==",
lat: 60.32995,
lon: 25.06272
},
{
id: "U3RvcDpIU0w6NDcyMDIyNA==",
lat: 60.33199,
lon: 25.06424
},
{
id: "U3RvcDpIU0w6NDcyMDIwNQ==",
lat: 60.33399,
lon: 25.06449
},
{
id: "U3RvcDpIU0w6NDcyMDIxMQ==",
lat: 60.33519,
lon: 25.06504
},
{
id: "U3RvcDpIU0w6NDcyMDIwNw==",
lat: 60.33902,
lon: 25.06971
},
{
id: "U3RvcDpIU0w6NDgxMDIzOA==",
lat: 60.34579,
lon: 25.07516
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIyOA==",
lat: 60.35035,
lon: 25.07627
},
{
id: "U3RvcDpIU0w6NDgxMDIwNA==",
lat: 60.35271,
lon: 25.06532
},
{
id: "U3RvcDpIU0w6NDgxMDIwNg==",
lat: 60.3531,
lon: 25.06058
},
{
id: "U3RvcDpIU0w6NDgxMDIwOA==",
lat: 60.35364,
lon: 25.05589
},
{
id: "U3RvcDpIU0w6NDgxMDI0Nw==",
lat: 60.35473,
lon: 25.05225
},
{
id: "U3RvcDpIU0w6NDgxMDIxOQ==",
lat: 60.3572,
lon: 25.05523
},
{
id: "U3RvcDpIU0w6NDgxMDIyMQ==",
lat: 60.35993,
lon: 25.06364
},
{
id: "U3RvcDpIU0w6NDgxMDI0NQ==",
lat: 60.36148,
lon: 25.06622
},
{
id: "U3RvcDpIU0w6NDg4MDIwNQ==",
lat: 60.36503,
lon: 25.06885
},
{
id: "U3RvcDpIU0w6NDg4MDIwMQ==",
lat: 60.36867,
lon: 25.075262
},
{
id: "U3RvcDpIU0w6NDg4MDIwNw==",
lat: 60.37234,
lon: 25.07747
},
{
id: "U3RvcDpIU0w6OTA2MDIwOQ==",
lat: 60.37598,
lon: 25.08016
},
{
id: "U3RvcDpIU0w6OTA2MDIxMQ==",
lat: 60.37708,
lon: 25.08163
},
{
id: "U3RvcDpIU0w6OTA2MDIxMw==",
lat: 60.37925,
lon: 25.08635
},
{
id: "U3RvcDpIU0w6OTA2MDIxOQ==",
lat: 60.38226,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6OTA2MDIyMg==",
lat: 60.38419,
lon: 25.08743
},
{
id: "U3RvcDpIU0w6OTA2MDIyNA==",
lat: 60.38513,
lon: 25.08958
},
{
id: "U3RvcDpIU0w6OTA2MDIyNg==",
lat: 60.38921,
lon: 25.08957
},
{
id: "U3RvcDpIU0w6OTA2MDIzMA==",
lat: 60.39068,
lon: 25.09484
},
{
id: "U3RvcDpIU0w6OTA2MDIzMg==",
lat: 60.39091,
lon: 25.09869
},
{
id: "U3RvcDpIU0w6OTA5MDIwNw==",
lat: 60.39264,
lon: 25.10139
},
{
id: "U3RvcDpIU0w6OTA0MDIyNg==",
lat: 60.40116,
lon: 25.10171
},
{
id: "U3RvcDpIU0w6OTA0MDIwNA==",
lat: 60.40206,
lon: 25.09889
},
{
id: "U3RvcDpIU0w6OTA0MDIwNg==",
lat: 60.40346,
lon: 25.10141
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
}
]
},
{
gtfsId: "HSL:1067N",
shortName: "67N",
longName: "Rautatientori-Torpparinmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMg==",
lat: 60.17085,
lon: 24.94333
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDExMA==",
lat: 60.19226,
lon: 24.96136
},
{
id: "U3RvcDpIU0w6MTIyMDE4MQ==",
lat: 60.19565,
lon: 24.95499
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDE1Mw==",
lat: 60.22125,
lon: 24.94678
},
{
id: "U3RvcDpIU0w6MTI4MzEzMA==",
lat: 60.22153,
lon: 24.94149
},
{
id: "U3RvcDpIU0w6MTI4MzEzMg==",
lat: 60.22103,
lon: 24.93707
},
{
id: "U3RvcDpIU0w6MTI4NjEzNA==",
lat: 60.223362,
lon: 24.933546
},
{
id: "U3RvcDpIU0w6MTI4MjEzNg==",
lat: 60.22544,
lon: 24.93073
},
{
id: "U3RvcDpIU0w6MTI4MjE0Mg==",
lat: 60.22827,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTI4MjE0Ng==",
lat: 60.23062,
lon: 24.93342
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MTEwNw==",
lat: 60.23472,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTM0MTExOA==",
lat: 60.23743,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTM0MTEyMA==",
lat: 60.23948,
lon: 24.92814
},
{
id: "U3RvcDpIU0w6MTM0MTEyMg==",
lat: 60.24185,
lon: 24.92687
},
{
id: "U3RvcDpIU0w6MTM0MTEyNA==",
lat: 60.24426,
lon: 24.9254
},
{
id: "U3RvcDpIU0w6MTM1MTEwMQ==",
lat: 60.24797,
lon: 24.92389
},
{
id: "U3RvcDpIU0w6MTM1MTEwMw==",
lat: 60.24882,
lon: 24.92861
},
{
id: "U3RvcDpIU0w6MTM1MTEwNQ==",
lat: 60.24935,
lon: 24.93492
},
{
id: "U3RvcDpIU0w6MTM1MTEwNw==",
lat: 60.24962,
lon: 24.94126
},
{
id: "U3RvcDpIU0w6MTM1MTEyNA==",
lat: 60.2527,
lon: 24.94095
},
{
id: "U3RvcDpIU0w6MTM1MTEyNQ==",
lat: 60.255681,
lon: 24.937717
},
{
id: "U3RvcDpIU0w6MTM1MjE0Mw==",
lat: 60.25638,
lon: 24.94599
},
{
id: "U3RvcDpIU0w6MTM1MjEzNA==",
lat: 60.25605,
lon: 24.95008
},
{
id: "U3RvcDpIU0w6MTM1MjEzNg==",
lat: 60.25723,
lon: 24.95164
},
{
id: "U3RvcDpIU0w6MTM1MjEzOQ==",
lat: 60.25954,
lon: 24.95366
},
{
id: "U3RvcDpIU0w6MTM1MjE0NQ==",
lat: 60.26233,
lon: 24.95158
},
{
id: "U3RvcDpIU0w6MTM1MjE0OA==",
lat: 60.26501,
lon: 24.95544
},
{
id: "U3RvcDpIU0w6MTM1MjE0Ng==",
lat: 60.26232,
lon: 24.95123
},
{
id: "U3RvcDpIU0w6MTM1MjEzOA==",
lat: 60.26032,
lon: 24.95306
},
{
id: "U3RvcDpIU0w6MTM1MjE0Mg==",
lat: 60.25901,
lon: 24.95328
},
{
id: "U3RvcDpIU0w6MTM1MjEzNw==",
lat: 60.25725,
lon: 24.95153
},
{
id: "U3RvcDpIU0w6MTM1MjEzNQ==",
lat: 60.25611,
lon: 24.94961
},
{
id: "U3RvcDpIU0w6MTM1MjExOQ==",
lat: 60.255037,
lon: 24.94895
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:1079B",
shortName: "79B",
longName: "Siilitie (M)-Latokartano",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTEyOQ==",
lat: 60.206496,
lon: 25.044421
},
{
id: "U3RvcDpIU0w6MTQzMTEzMQ==",
lat: 60.207053,
lon: 25.041649
},
{
id: "U3RvcDpIU0w6MTQzMTEzMw==",
lat: 60.209329,
lon: 25.037957
},
{
id: "U3RvcDpIU0w6MTQzMTEzNQ==",
lat: 60.21268,
lon: 25.03878
},
{
id: "U3RvcDpIU0w6MTQzMTEzNw==",
lat: 60.21487,
lon: 25.04418
},
{
id: "U3RvcDpIU0w6MTM2MjExOA==",
lat: 60.22445,
lon: 25.02165
},
{
id: "U3RvcDpIU0w6MTM2MjExNQ==",
lat: 60.22567,
lon: 25.02402
},
{
id: "U3RvcDpIU0w6MTM2MjEyNw==",
lat: 60.22806,
lon: 25.02792
},
{
id: "U3RvcDpIU0w6MTM2MjEyOQ==",
lat: 60.23112,
lon: 25.03053
},
{
id: "U3RvcDpIU0w6MTM2MjEzMw==",
lat: 60.23366,
lon: 25.0309
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mw==",
lat: 60.23446,
lon: 25.03309
},
{
id: "U3RvcDpIU0w6MTM2MjEwNA==",
lat: 60.234826,
lon: 25.033872
},
{
id: "U3RvcDpIU0w6MTM2MjE0NA==",
lat: 60.23451,
lon: 25.03253
},
{
id: "U3RvcDpIU0w6MTM2MjExOQ==",
lat: 60.233,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTM2MjEzMA==",
lat: 60.23052,
lon: 25.02988
},
{
id: "U3RvcDpIU0w6MTM2MjEyOA==",
lat: 60.22822,
lon: 25.02787
},
{
id: "U3RvcDpIU0w6MTM2MjExNg==",
lat: 60.22564,
lon: 25.02357
},
{
id: "U3RvcDpIU0w6MTM2MjExMw==",
lat: 60.22367,
lon: 25.02229
},
{
id: "U3RvcDpIU0w6MTQ1NDE4NA==",
lat: 60.21495,
lon: 25.04414
},
{
id: "U3RvcDpIU0w6MTQzMTEzNg==",
lat: 60.2123,
lon: 25.03822
},
{
id: "U3RvcDpIU0w6MTQzMTEzNA==",
lat: 60.209183,
lon: 25.037994
},
{
id: "U3RvcDpIU0w6MTQzMTEwOQ==",
lat: 60.20798,
lon: 25.03966
},
{
id: "U3RvcDpIU0w6MTQzMTEzMA==",
lat: 60.206214,
lon: 25.044957
}
]
},
{
gtfsId: "HSL:9969X",
shortName: "969X",
longName: "Kerava-Ainola-Järvenpää-Saunakallio-Jokela(-Riihimäki)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA0MDIyNA==",
lat: 60.40434,
lon: 25.10494
},
{
id: "U3RvcDpIU0w6OTUwMDIzMA==",
lat: 60.455699,
lon: 25.092057
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwODAwMw==",
lat: 60.488282,
lon: 25.067272
},
{
id: "U3RvcDpIU0w6OTYxMDIwNA==",
lat: 60.552855,
lon: 24.969382
},
{
id: "U3RvcDpIU0w6OTYxMDIwNQ==",
lat: 60.552142,
lon: 24.97042
},
{
id: "U3RvcDpIU0w6OTUwODAwMg==",
lat: 60.487255,
lon: 25.068324
},
{
id: "U3RvcDpIU0w6OTUwMDIzNQ==",
lat: 60.4739,
lon: 25.090104
},
{
id: "U3RvcDpIU0w6OTUwMDIyOQ==",
lat: 60.455724,
lon: 25.096564
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
}
]
},
{
gtfsId: "HSL:5566V",
shortName: "566V",
longName: "Martinlaakso-Järvenperä-Espoon keskus",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMjIzMg==",
lat: 60.22308,
lon: 24.6774
},
{
id: "U3RvcDpIU0w6MjYzMjIzNA==",
lat: 60.22558,
lon: 24.68211
},
{
id: "U3RvcDpIU0w6MjYzMjIzNg==",
lat: 60.22601,
lon: 24.68628
},
{
id: "U3RvcDpIU0w6MjYzMjIzOA==",
lat: 60.229,
lon: 24.69282
},
{
id: "U3RvcDpIU0w6MjYzMjI0MA==",
lat: 60.23172,
lon: 24.69809
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mw==",
lat: 60.23605,
lon: 24.7054
},
{
id: "U3RvcDpIU0w6MjYzMjI2MA==",
lat: 60.23844,
lon: 24.70498
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjYzMjI1Nw==",
lat: 60.25106,
lon: 24.71774
},
{
id: "U3RvcDpIU0w6MjcxMjIyMg==",
lat: 60.25359,
lon: 24.71106
},
{
id: "U3RvcDpIU0w6MjcxMjIxNQ==",
lat: 60.25791,
lon: 24.71676
},
{
id: "U3RvcDpIU0w6MjcxMjIxNw==",
lat: 60.25978,
lon: 24.7193
},
{
id: "U3RvcDpIU0w6MjcxMjIxOQ==",
lat: 60.26365,
lon: 24.72388
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxOA==",
lat: 60.26626,
lon: 24.73717
},
{
id: "U3RvcDpIU0w6MjcxNTI5Mw==",
lat: 60.26702,
lon: 24.74761
},
{
id: "U3RvcDpIU0w6MjcxNTI5NA==",
lat: 60.26969,
lon: 24.75626
},
{
id: "U3RvcDpIU0w6MjcxNTIzMA==",
lat: 60.26954,
lon: 24.75945
},
{
id: "U3RvcDpIU0w6NDEyMDIxNw==",
lat: 60.27395,
lon: 24.78154
},
{
id: "U3RvcDpIU0w6NDEyMDIzNg==",
lat: 60.272876,
lon: 24.790986
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxMQ==",
lat: 60.2773,
lon: 24.85304
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDEyMDIxNA==",
lat: 60.27342,
lon: 24.7938
},
{
id: "U3RvcDpIU0w6NDEyMDIxNg==",
lat: 60.27395,
lon: 24.77924
},
{
id: "U3RvcDpIU0w6MjcxNTI5NQ==",
lat: 60.269782,
lon: 24.755897
},
{
id: "U3RvcDpIU0w6MjcxNTIxMA==",
lat: 60.26655,
lon: 24.74574
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMjIyMA==",
lat: 60.26319,
lon: 24.72306
},
{
id: "U3RvcDpIU0w6MjcxMjIxNg==",
lat: 60.26041,
lon: 24.71996
},
{
id: "U3RvcDpIU0w6MjcxMjIyMw==",
lat: 60.257549,
lon: 24.716212
},
{
id: "U3RvcDpIU0w6MjcxMjIyMQ==",
lat: 60.25376,
lon: 24.71091
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI1OA==",
lat: 60.23912,
lon: 24.70695
},
{
id: "U3RvcDpIU0w6MjYzMjI1OQ==",
lat: 60.23785,
lon: 24.70422
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mg==",
lat: 60.23498,
lon: 24.70481
},
{
id: "U3RvcDpIU0w6MjYzMjI0MQ==",
lat: 60.23238,
lon: 24.69878
},
{
id: "U3RvcDpIU0w6MjYzMjIzOQ==",
lat: 60.23077,
lon: 24.69602
},
{
id: "U3RvcDpIU0w6MjYzMjIzNw==",
lat: 60.22856,
lon: 24.69157
},
{
id: "U3RvcDpIU0w6MjYzMjIzNQ==",
lat: 60.22592,
lon: 24.68556
},
{
id: "U3RvcDpIU0w6MjYzMjIzMw==",
lat: 60.22548,
lon: 24.68117
},
{
id: "U3RvcDpIU0w6MjYzMjI3Mw==",
lat: 60.22305,
lon: 24.67722
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
}
]
},
{
gtfsId: "HSL:9966",
shortName: "966",
longName: "Jokela-Vanhakylän koulu - Saunakallio -Terrisuo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTYxMDIyMA==",
lat: 60.553215,
lon: 24.96926
},
{
id: "U3RvcDpIU0w6OTYxMDIwNQ==",
lat: 60.552142,
lon: 24.97042
},
{
id: "U3RvcDpIU0w6OTYxMDMyMw==",
lat: 60.542261,
lon: 24.989126
},
{
id: "U3RvcDpIU0w6OTYxMDMwMw==",
lat: 60.538583,
lon: 24.999092
},
{
id: "U3RvcDpIU0w6OTYxMDMwMQ==",
lat: 60.535176,
lon: 25.006512
},
{
id: "U3RvcDpIU0w6OTYzMDIwNw==",
lat: 60.528202,
lon: 25.018226
},
{
id: "U3RvcDpIU0w6OTYzMDIwNQ==",
lat: 60.525256,
lon: 25.021976
},
{
id: "U3RvcDpIU0w6OTYzMDIwMg==",
lat: 60.516966,
lon: 25.022425
},
{
id: "U3RvcDpIU0w6OTYzMDMwOQ==",
lat: 60.510821,
lon: 25.029423
},
{
id: "U3RvcDpIU0w6OTYzMDMwMw==",
lat: 60.505651,
lon: 25.03083
},
{
id: "U3RvcDpIU0w6OTYzMDMwMA==",
lat: 60.500627,
lon: 25.03184
},
{
id: "U3RvcDpIU0w6OTYzMDMwNw==",
lat: 60.496333,
lon: 25.032333
},
{
id: "U3RvcDpIU0w6OTYzMDQxMQ==",
lat: 60.492996,
lon: 25.013499
},
{
id: "U3RvcDpIU0w6OTYzMDQwOA==",
lat: 60.49046,
lon: 25.034187
},
{
id: "U3RvcDpIU0w6OTYzMDMxMQ==",
lat: 60.482074,
lon: 25.042546
},
{
id: "U3RvcDpIU0w6OTUwODAwMw==",
lat: 60.488282,
lon: 25.067272
},
{
id: "U3RvcDpIU0w6OTUwODAwMQ==",
lat: 60.490454,
lon: 25.066463
},
{
id: "U3RvcDpIU0w6OTUwOTAwNQ==",
lat: 60.493991,
lon: 25.066238
},
{
id: "U3RvcDpIU0w6OTUwOTAwMw==",
lat: 60.496606,
lon: 25.066005
},
{
id: "U3RvcDpIU0w6OTUwOTAwMQ==",
lat: 60.49892,
lon: 25.065999
},
{
id: "U3RvcDpIU0w6OTUxMDAwMQ==",
lat: 60.49954,
lon: 25.050187
},
{
id: "U3RvcDpIU0w6OTYzMDMwMQ==",
lat: 60.501938,
lon: 25.031371
},
{
id: "U3RvcDpIU0w6OTYzMDMwNA==",
lat: 60.506287,
lon: 25.031116
},
{
id: "U3RvcDpIU0w6OTYzMDMxMA==",
lat: 60.511211,
lon: 25.029018
},
{
id: "U3RvcDpIU0w6OTYzMDIwMw==",
lat: 60.518101,
lon: 25.022312
},
{
id: "U3RvcDpIU0w6OTYzMDIwNA==",
lat: 60.526266,
lon: 25.020897
},
{
id: "U3RvcDpIU0w6OTYzMDIxMg==",
lat: 60.526662,
lon: 25.019225
},
{
id: "U3RvcDpIU0w6OTYzMDIxNA==",
lat: 60.520358,
lon: 25.021923
},
{
id: "U3RvcDpIU0w6OTYzMDIwOQ==",
lat: 60.514559,
lon: 25.012522
},
{
id: "U3RvcDpIU0w6OTYzMDIwMA==",
lat: 60.509824,
lon: 24.995875
},
{
id: "U3RvcDpIU0w6OTYzMDQwMA==",
lat: 60.489264,
lon: 24.969857
},
{
id: "U3RvcDpIU0w6OTYzMDQwMg==",
lat: 60.486189,
lon: 24.972271
},
{
id: "U3RvcDpIU0w6OTYzMDUwMg==",
lat: 60.483192,
lon: 24.974378
},
{
id: "U3RvcDpIU0w6OTY0MDIxMw==",
lat: 60.478699,
lon: 24.951962
},
{
id: "U3RvcDpIU0w6OTY0MDIwNg==",
lat: 60.471909,
lon: 24.945694
},
{
id: "U3RvcDpIU0w6OTY0MDIxMg==",
lat: 60.478303,
lon: 24.953405
},
{
id: "U3RvcDpIU0w6OTYzMDUwNQ==",
lat: 60.477834,
lon: 24.978129
},
{
id: "U3RvcDpIU0w6OTYzMDQxMA==",
lat: 60.483647,
lon: 24.974288
},
{
id: "U3RvcDpIU0w6OTYzMDQwMw==",
lat: 60.486755,
lon: 24.972114
},
{
id: "U3RvcDpIU0w6OTYzMDMwOA==",
lat: 60.500264,
lon: 24.986781
},
{
id: "U3RvcDpIU0w6OTYzMDIxMw==",
lat: 60.520476,
lon: 25.021708
},
{
id: "U3RvcDpIU0w6OTYzMDIxMQ==",
lat: 60.526786,
lon: 25.019575
},
{
id: "U3RvcDpIU0w6OTYzMDMwMg==",
lat: 60.502379,
lon: 25.040632
},
{
id: "U3RvcDpIU0w6OTUwOTAwNg==",
lat: 60.499549,
lon: 25.050166
},
{
id: "U3RvcDpIU0w6OTUwOTAwMA==",
lat: 60.498832,
lon: 25.065813
},
{
id: "U3RvcDpIU0w6OTUwOTAwMg==",
lat: 60.495794,
lon: 25.065977
},
{
id: "U3RvcDpIU0w6OTUwOTAwNA==",
lat: 60.492595,
lon: 25.066152
},
{
id: "U3RvcDpIU0w6OTUwODAwMA==",
lat: 60.489642,
lon: 25.066466
},
{
id: "U3RvcDpIU0w6OTUwMzAwMQ==",
lat: 60.48319,
lon: 25.053788
},
{
id: "U3RvcDpIU0w6OTYzMDQwNg==",
lat: 60.482308,
lon: 25.041084
},
{
id: "U3RvcDpIU0w6OTYzMDQwNw==",
lat: 60.483613,
lon: 25.042616
},
{
id: "U3RvcDpIU0w6OTYzMDQwOQ==",
lat: 60.49141,
lon: 25.033081
},
{
id: "U3RvcDpIU0w6OTYzMDMwNg==",
lat: 60.496924,
lon: 25.032264
},
{
id: "U3RvcDpIU0w6OTYzMDIwNg==",
lat: 60.528971,
lon: 25.017467
},
{
id: "U3RvcDpIU0w6OTYxMDMwMA==",
lat: 60.535606,
lon: 25.005515
},
{
id: "U3RvcDpIU0w6OTYxMDMwMg==",
lat: 60.538897,
lon: 24.998461
},
{
id: "U3RvcDpIU0w6OTYxMDMyMg==",
lat: 60.54307,
lon: 24.987469
}
]
},
{
gtfsId: "HSL:9967",
shortName: "967",
longName: "Jokela-Nuppulinna-Linjamäki-Kellokoski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTYxMDIyMA==",
lat: 60.553215,
lon: 24.96926
},
{
id: "U3RvcDpIU0w6OTYxMDIwNQ==",
lat: 60.552142,
lon: 24.97042
},
{
id: "U3RvcDpIU0w6OTYxMDMyMw==",
lat: 60.542261,
lon: 24.989126
},
{
id: "U3RvcDpIU0w6OTYxMDMwMw==",
lat: 60.538583,
lon: 24.999092
},
{
id: "U3RvcDpIU0w6OTYxMDMwMQ==",
lat: 60.535176,
lon: 25.006512
},
{
id: "U3RvcDpIU0w6OTYzMDIwNw==",
lat: 60.528202,
lon: 25.018226
},
{
id: "U3RvcDpIU0w6OTYyMDQwMA==",
lat: 60.526927,
lon: 25.037865
},
{
id: "U3RvcDpIU0w6OTYyMDMwNQ==",
lat: 60.537071,
lon: 25.052673
},
{
id: "U3RvcDpIU0w6OTYyMDMwNA==",
lat: 60.539138,
lon: 25.043178
},
{
id: "U3RvcDpIU0w6OTYyMDMwMw==",
lat: 60.538876,
lon: 25.04384
},
{
id: "U3RvcDpIU0w6OTYyMDMwNg==",
lat: 60.536838,
lon: 25.053815
},
{
id: "U3RvcDpIU0w6OTYyMDMwMg==",
lat: 60.533697,
lon: 25.070858
},
{
id: "U3RvcDpIU0w6OTYyMDEwNw==",
lat: 60.530893,
lon: 25.088768
},
{
id: "U3RvcDpIU0w6OTYyMDExMg==",
lat: 60.531326,
lon: 25.098308
},
{
id: "U3RvcDpIU0w6OTYyMDExMA==",
lat: 60.527828,
lon: 25.104227
},
{
id: "U3RvcDpIU0w6OTYyMDEwOA==",
lat: 60.532741,
lon: 25.110697
},
{
id: "U3RvcDpIU0w6OTYyMDExNA==",
lat: 60.535827,
lon: 25.11185
},
{
id: "U3RvcDpIU0w6OTYyMDEyNQ==",
lat: 60.538881,
lon: 25.113485
},
{
id: "U3RvcDpIU0w6OTYyMDEyNw==",
lat: 60.541235,
lon: 25.114887
},
{
id: "U3RvcDpIU0w6OTYyMDEzMA==",
lat: 60.546026,
lon: 25.118111
},
{
id: "U3RvcDpIU0w6OTYyMDEyOA==",
lat: 60.542592,
lon: 25.117474
},
{
id: "U3RvcDpIU0w6OTYyMDEyNg==",
lat: 60.540297,
lon: 25.114163
},
{
id: "U3RvcDpIU0w6OTYyMDExNQ==",
lat: 60.536589,
lon: 25.112111
},
{
id: "U3RvcDpIU0w6OTYyMDEwOQ==",
lat: 60.531432,
lon: 25.109525
},
{
id: "U3RvcDpIU0w6OTYyMDExMQ==",
lat: 60.527961,
lon: 25.104432
},
{
id: "U3RvcDpIU0w6OTYyMDExMw==",
lat: 60.531325,
lon: 25.098307
},
{
id: "U3RvcDpIU0w6OTYyMDEwNg==",
lat: 60.53091,
lon: 25.088879
},
{
id: "U3RvcDpIU0w6OTYyMDMwMQ==",
lat: 60.534088,
lon: 25.068856
},
{
id: "U3RvcDpIU0w6OTYyMDQwNA==",
lat: 60.534515,
lon: 25.05692
},
{
id: "U3RvcDpIU0w6OTYyMDQwMw==",
lat: 60.532194,
lon: 25.050223
},
{
id: "U3RvcDpIU0w6OTYyMDQwMQ==",
lat: 60.529844,
lon: 25.044256
},
{
id: "U3RvcDpIU0w6OTYzMDIwNA==",
lat: 60.526266,
lon: 25.020897
},
{
id: "U3RvcDpIU0w6OTYzMDIwNg==",
lat: 60.528971,
lon: 25.017467
},
{
id: "U3RvcDpIU0w6OTYxMDMwMA==",
lat: 60.535606,
lon: 25.005515
},
{
id: "U3RvcDpIU0w6OTYxMDMwMg==",
lat: 60.538897,
lon: 24.998461
},
{
id: "U3RvcDpIU0w6OTYxMDMyMg==",
lat: 60.54307,
lon: 24.987469
}
]
},
{
gtfsId: "HSL:1067V",
shortName: "67V",
longName: "Rautatientori-Torpparinmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExMg==",
lat: 60.17076,
lon: 24.94268
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDExMA==",
lat: 60.19226,
lon: 24.96136
},
{
id: "U3RvcDpIU0w6MTIyMDE4MQ==",
lat: 60.19565,
lon: 24.95499
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEyMQ==",
lat: 60.254992,
lon: 24.952652
},
{
id: "U3RvcDpIU0w6MTM1MjEzNA==",
lat: 60.25605,
lon: 24.95008
},
{
id: "U3RvcDpIU0w6MTM1MjEzNg==",
lat: 60.25723,
lon: 24.95164
},
{
id: "U3RvcDpIU0w6MTM1MjEzOQ==",
lat: 60.25954,
lon: 24.95366
},
{
id: "U3RvcDpIU0w6MTM1MjE0NQ==",
lat: 60.26233,
lon: 24.95158
},
{
id: "U3RvcDpIU0w6MTM1MjE0OA==",
lat: 60.26501,
lon: 24.95544
},
{
id: "U3RvcDpIU0w6MTM1MjE0Ng==",
lat: 60.26232,
lon: 24.95123
},
{
id: "U3RvcDpIU0w6MTM1MjEzOA==",
lat: 60.26032,
lon: 24.95306
},
{
id: "U3RvcDpIU0w6MTM1MjE0Mg==",
lat: 60.25901,
lon: 24.95328
},
{
id: "U3RvcDpIU0w6MTM1MjEzNw==",
lat: 60.25725,
lon: 24.95153
},
{
id: "U3RvcDpIU0w6MTM1MjEzNQ==",
lat: 60.25611,
lon: 24.94961
},
{
id: "U3RvcDpIU0w6MTM1MjExOQ==",
lat: 60.255037,
lon: 24.94895
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:5565B",
shortName: "565B",
longName: "Jupperi-Jorvi-Espoon keskus",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjE0MzIxNw==",
lat: 60.253227,
lon: 24.772518
},
{
id: "U3RvcDpIU0w6MjE0MzIxNQ==",
lat: 60.25198,
lon: 24.7679
},
{
id: "U3RvcDpIU0w6MjE0MzIxMw==",
lat: 60.25041,
lon: 24.76301
},
{
id: "U3RvcDpIU0w6MjE0MzIxMg==",
lat: 60.24895,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjE0MjIxMA==",
lat: 60.24566,
lon: 24.75026
},
{
id: "U3RvcDpIU0w6MjE0MjIwOA==",
lat: 60.24338,
lon: 24.74724
},
{
id: "U3RvcDpIU0w6MjE0MjIwNg==",
lat: 60.2414,
lon: 24.74307
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOA==",
lat: 60.23408,
lon: 24.71654
},
{
id: "U3RvcDpIU0w6MjE1MjIzNg==",
lat: 60.23194,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjE1MjIzNA==",
lat: 60.2298,
lon: 24.71542
},
{
id: "U3RvcDpIU0w6MjE1MjIzMg==",
lat: 60.228,
lon: 24.70977
},
{
id: "U3RvcDpIU0w6MjE1MjIzMA==",
lat: 60.22545,
lon: 24.7065
},
{
id: "U3RvcDpIU0w6MjE1MjIyNg==",
lat: 60.22419,
lon: 24.70554
},
{
id: "U3RvcDpIU0w6MjE1MjIyOA==",
lat: 60.22358,
lon: 24.69408
},
{
id: "U3RvcDpIU0w6MjYzMTIwMQ==",
lat: 60.22342,
lon: 24.68808
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
}
]
},
{
gtfsId: "HSL:9961",
shortName: "961",
longName: "Korso-Sula-Riihikallio-Hyrylä-Nahkela-Palojoki(-Nurmijärvi)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTcwMDIwMA==",
lat: 60.462459,
lon: 24.808147
},
{
id: "U3RvcDpIU0w6OTcwMDIyMA==",
lat: 60.462962,
lon: 24.81105
},
{
id: "U3RvcDpIU0w6OTcwMDIxOA==",
lat: 60.459377,
lon: 24.817558
},
{
id: "U3RvcDpIU0w6OTcwMDIxNg==",
lat: 60.458322,
lon: 24.825765
},
{
id: "U3RvcDpIU0w6OTcwMDIxNA==",
lat: 60.445,
lon: 24.833275
},
{
id: "U3RvcDpIU0w6OTcwMDIxMg==",
lat: 60.437128,
lon: 24.83191
},
{
id: "U3RvcDpIU0w6OTcwMDIxMA==",
lat: 60.435134,
lon: 24.839378
},
{
id: "U3RvcDpIU0w6OTcwMDIwOA==",
lat: 60.431497,
lon: 24.853667
},
{
id: "U3RvcDpIU0w6OTcwMDIwNg==",
lat: 60.424353,
lon: 24.860632
},
{
id: "U3RvcDpIU0w6OTcwMDIwNA==",
lat: 60.420675,
lon: 24.868595
},
{
id: "U3RvcDpIU0w6OTcwMDIwMg==",
lat: 60.412963,
lon: 24.878444
},
{
id: "U3RvcDpIU0w6OTY2MDIwNQ==",
lat: 60.409542,
lon: 24.892344
},
{
id: "U3RvcDpIU0w6OTY2MDIxMg==",
lat: 60.405039,
lon: 24.903468
},
{
id: "U3RvcDpIU0w6OTY2MDIwNA==",
lat: 60.401399,
lon: 24.914879
},
{
id: "U3RvcDpIU0w6OTY2MDIxMw==",
lat: 60.4012,
lon: 24.924711
},
{
id: "U3RvcDpIU0w6OTY2MDIwNw==",
lat: 60.402627,
lon: 24.93522
},
{
id: "U3RvcDpIU0w6OTY2MDIwOQ==",
lat: 60.405709,
lon: 24.945031
},
{
id: "U3RvcDpIU0w6OTY1MTAyMg==",
lat: 60.406567,
lon: 24.958827
},
{
id: "U3RvcDpIU0w6OTY1MTAxOQ==",
lat: 60.405693,
lon: 24.968812
},
{
id: "U3RvcDpIU0w6OTY1MTAxNQ==",
lat: 60.404865,
lon: 24.978019
},
{
id: "U3RvcDpIU0w6OTY1MTAyOA==",
lat: 60.404637,
lon: 24.990663
},
{
id: "U3RvcDpIU0w6OTY1MTAyNg==",
lat: 60.405089,
lon: 24.999478
},
{
id: "U3RvcDpIU0w6OTY1MTAwMQ==",
lat: 60.405361,
lon: 25.002492
},
{
id: "U3RvcDpIU0w6OTY1MDkwMA==",
lat: 60.406062,
lon: 25.009508
},
{
id: "U3RvcDpIU0w6OTY1MDkwMg==",
lat: 60.405499,
lon: 25.012577
},
{
id: "U3RvcDpIU0w6OTY1MDMwMw==",
lat: 60.4033,
lon: 25.02419
},
{
id: "U3RvcDpIU0w6OTY1MDEyNA==",
lat: 60.40201,
lon: 25.028074
},
{
id: "U3RvcDpIU0w6OTY1MDExMQ==",
lat: 60.400819,
lon: 25.026307
},
{
id: "U3RvcDpIU0w6OTY1MDEwNQ==",
lat: 60.398721,
lon: 25.02284
},
{
id: "U3RvcDpIU0w6OTY1MDEwMA==",
lat: 60.398035,
lon: 25.020074
},
{
id: "U3RvcDpIU0w6OTY1MTUxMg==",
lat: 60.395856,
lon: 25.015069
},
{
id: "U3RvcDpIU0w6OTY1MTUwOA==",
lat: 60.394413,
lon: 25.017147
},
{
id: "U3RvcDpIU0w6OTY1MTUxMA==",
lat: 60.389878,
lon: 25.018535
},
{
id: "U3RvcDpIU0w6OTY1MTQwMg==",
lat: 60.386483,
lon: 25.013222
},
{
id: "U3RvcDpIU0w6OTY1MTQwMA==",
lat: 60.383973,
lon: 25.010521
},
{
id: "U3RvcDpIU0w6OTY1MTQwNA==",
lat: 60.382054,
lon: 25.014925
},
{
id: "U3RvcDpIU0w6OTY1MTMwOA==",
lat: 60.378836,
lon: 25.012496
},
{
id: "U3RvcDpIU0w6OTY1MTMwMA==",
lat: 60.377481,
lon: 25.013463
},
{
id: "U3RvcDpIU0w6OTY1MTMxNg==",
lat: 60.374891,
lon: 25.017616
},
{
id: "U3RvcDpIU0w6OTY1MTMxMw==",
lat: 60.375518,
lon: 25.019879
},
{
id: "U3RvcDpIU0w6OTY1MTYwMg==",
lat: 60.379778,
lon: 25.023895
},
{
id: "U3RvcDpIU0w6OTY1MTYxMg==",
lat: 60.382748,
lon: 25.025649
},
{
id: "U3RvcDpIU0w6OTY1MTcxOQ==",
lat: 60.384569,
lon: 25.03016
},
{
id: "U3RvcDpIU0w6OTY1MTcyMA==",
lat: 60.38453,
lon: 25.03546
},
{
id: "U3RvcDpIU0w6OTY1MTcyMQ==",
lat: 60.381626,
lon: 25.043251
},
{
id: "U3RvcDpIU0w6OTY1MTcxMg==",
lat: 60.378112,
lon: 25.052368
},
{
id: "U3RvcDpIU0w6OTY1MTcxNg==",
lat: 60.374666,
lon: 25.059641
},
{
id: "U3RvcDpIU0w6NDg4MDIxNQ==",
lat: 60.370373,
lon: 25.071319
},
{
id: "U3RvcDpIU0w6NDg4MDIxMw==",
lat: 60.36808,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDg4MDIxMQ==",
lat: 60.36612,
lon: 25.08191
},
{
id: "U3RvcDpIU0w6NDg4MDIxMg==",
lat: 60.36464,
lon: 25.08558
},
{
id: "U3RvcDpIU0w6NDgxMDIzNg==",
lat: 60.359299,
lon: 25.079697
},
{
id: "U3RvcDpIU0w6NDgxMDIzNA==",
lat: 60.35686,
lon: 25.078553
},
{
id: "U3RvcDpIU0w6NDgxMDI5NA==",
lat: 60.354391,
lon: 25.078477
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mg==",
lat: 60.3525,
lon: 25.07726
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI5NQ==",
lat: 60.354427,
lon: 25.078612
},
{
id: "U3RvcDpIU0w6NDgxMDIzMw==",
lat: 60.357699,
lon: 25.079007
},
{
id: "U3RvcDpIU0w6NDgxMDIzNQ==",
lat: 60.360146,
lon: 25.081257
},
{
id: "U3RvcDpIU0w6NDg4MDIxMA==",
lat: 60.36471,
lon: 25.08515
},
{
id: "U3RvcDpIU0w6NDg4MDIwOA==",
lat: 60.36658,
lon: 25.08115
},
{
id: "U3RvcDpIU0w6NDg4MDIwMQ==",
lat: 60.36867,
lon: 25.075262
},
{
id: "U3RvcDpIU0w6NDg4MDIxNA==",
lat: 60.370831,
lon: 25.069688
},
{
id: "U3RvcDpIU0w6OTY1MTcxNw==",
lat: 60.375091,
lon: 25.058667
},
{
id: "U3RvcDpIU0w6OTY1MTcxMw==",
lat: 60.379172,
lon: 25.050071
},
{
id: "U3RvcDpIU0w6OTY1MTcwNA==",
lat: 60.382115,
lon: 25.042133
},
{
id: "U3RvcDpIU0w6OTY1MTcwNw==",
lat: 60.385262,
lon: 25.033932
},
{
id: "U3RvcDpIU0w6OTY1MTcxOA==",
lat: 60.38435,
lon: 25.029774
},
{
id: "U3RvcDpIU0w6OTY1MTYxMw==",
lat: 60.382931,
lon: 25.025434
},
{
id: "U3RvcDpIU0w6OTY1MTYwMQ==",
lat: 60.378409,
lon: 25.022339
},
{
id: "U3RvcDpIU0w6OTY1MTMxNw==",
lat: 60.374858,
lon: 25.017726
},
{
id: "U3RvcDpIU0w6OTY1MTMwMQ==",
lat: 60.377366,
lon: 25.013702
},
{
id: "U3RvcDpIU0w6OTY1MTMwOQ==",
lat: 60.378562,
lon: 25.012256
},
{
id: "U3RvcDpIU0w6OTY1MTQwNQ==",
lat: 60.381872,
lon: 25.01535
},
{
id: "U3RvcDpIU0w6OTY1MTQwMQ==",
lat: 60.383909,
lon: 25.010676
},
{
id: "U3RvcDpIU0w6OTY1MTQwMw==",
lat: 60.386849,
lon: 25.01417
},
{
id: "U3RvcDpIU0w6OTY1MTUwOQ==",
lat: 60.389759,
lon: 25.018555
},
{
id: "U3RvcDpIU0w6OTY1MTUwNw==",
lat: 60.394369,
lon: 25.017403
},
{
id: "U3RvcDpIU0w6OTY1MTUxMQ==",
lat: 60.396094,
lon: 25.015021
},
{
id: "U3RvcDpIU0w6OTY1MDEwMQ==",
lat: 60.397854,
lon: 25.019908
},
{
id: "U3RvcDpIU0w6OTY1MDEwNA==",
lat: 60.397977,
lon: 25.022502
},
{
id: "U3RvcDpIU0w6OTY1MDExMA==",
lat: 60.400624,
lon: 25.026438
},
{
id: "U3RvcDpIU0w6OTY1MDEyNQ==",
lat: 60.401958,
lon: 25.028347
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MDkwMQ==",
lat: 60.406126,
lon: 25.009112
},
{
id: "U3RvcDpIU0w6OTY1MTAwMA==",
lat: 60.405733,
lon: 25.004427
},
{
id: "U3RvcDpIU0w6OTY1MTAyNQ==",
lat: 60.405001,
lon: 24.998075
},
{
id: "U3RvcDpIU0w6OTY1MTAyNw==",
lat: 60.404609,
lon: 24.988961
},
{
id: "U3RvcDpIU0w6OTY1MTAxNA==",
lat: 60.405029,
lon: 24.97447
},
{
id: "U3RvcDpIU0w6OTY1MTAyMA==",
lat: 60.405613,
lon: 24.970471
},
{
id: "U3RvcDpIU0w6OTY1MTAyMQ==",
lat: 60.406445,
lon: 24.960584
},
{
id: "U3RvcDpIU0w6OTY2MDIxMA==",
lat: 60.405281,
lon: 24.943853
},
{
id: "U3RvcDpIU0w6OTY2MDIwMA==",
lat: 60.403325,
lon: 24.937819
},
{
id: "U3RvcDpIU0w6OTY2MDIwOA==",
lat: 60.402079,
lon: 24.931301
},
{
id: "U3RvcDpIU0w6OTY2MDIxNA==",
lat: 60.40106,
lon: 24.923386
},
{
id: "U3RvcDpIU0w6OTY2MDIwMw==",
lat: 60.401385,
lon: 24.913329
},
{
id: "U3RvcDpIU0w6OTY2MDIxMQ==",
lat: 60.405621,
lon: 24.902228
},
{
id: "U3RvcDpIU0w6OTY2MDIwNg==",
lat: 60.409555,
lon: 24.891747
},
{
id: "U3RvcDpIU0w6OTcwMDIwMQ==",
lat: 60.413752,
lon: 24.877213
},
{
id: "U3RvcDpIU0w6OTcwMDIwMw==",
lat: 60.42206,
lon: 24.866853
},
{
id: "U3RvcDpIU0w6OTcwMDIwNQ==",
lat: 60.425541,
lon: 24.860156
},
{
id: "U3RvcDpIU0w6OTcwMDIwNw==",
lat: 60.432183,
lon: 24.853176
},
{
id: "U3RvcDpIU0w6OTcwMDIwOQ==",
lat: 60.435463,
lon: 24.838352
},
{
id: "U3RvcDpIU0w6OTcwMDIxMQ==",
lat: 60.437815,
lon: 24.831111
},
{
id: "U3RvcDpIU0w6OTcwMDIxMw==",
lat: 60.445151,
lon: 24.833479
},
{
id: "U3RvcDpIU0w6OTcwMDIxNQ==",
lat: 60.458377,
lon: 24.832817
},
{
id: "U3RvcDpIU0w6OTcwMDIxNw==",
lat: 60.458502,
lon: 24.825751
},
{
id: "U3RvcDpIU0w6OTcwMDIxOQ==",
lat: 60.459546,
lon: 24.817817
}
]
},
{
gtfsId: "HSL:7662",
shortName: "662",
longName: "Kamppi-Maantiekylä-Hyrylä-Hyvinkää",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY0MDEwOQ==",
lat: 60.460279,
lon: 24.948005
},
{
id: "U3RvcDpIU0w6OTY0MDEwNg==",
lat: 60.450695,
lon: 24.958619
},
{
id: "U3RvcDpIU0w6OTY0MDExNQ==",
lat: 60.446269,
lon: 24.966756
},
{
id: "U3RvcDpIU0w6OTY0MDIwNw==",
lat: 60.441703,
lon: 24.975813
},
{
id: "U3RvcDpIU0w6OTY0MDIwMA==",
lat: 60.438756,
lon: 24.980235
},
{
id: "U3RvcDpIU0w6OTY0MDQyMA==",
lat: 60.433934,
lon: 24.987427
},
{
id: "U3RvcDpIU0w6OTY0MDQxMg==",
lat: 60.426842,
lon: 24.995887
},
{
id: "U3RvcDpIU0w6OTY1MTAwNg==",
lat: 60.416793,
lon: 25.000696
},
{
id: "U3RvcDpIU0w6OTY1MTAyOQ==",
lat: 60.411092,
lon: 25.004086
},
{
id: "U3RvcDpIU0w6OTY1MDkwMg==",
lat: 60.405499,
lon: 25.012577
},
{
id: "U3RvcDpIU0w6OTY1MDMwMw==",
lat: 60.4033,
lon: 25.02419
},
{
id: "U3RvcDpIU0w6OTY1MDEyNQ==",
lat: 60.401958,
lon: 25.028347
},
{
id: "U3RvcDpIU0w6OTY1MDExMQ==",
lat: 60.400819,
lon: 25.026307
},
{
id: "U3RvcDpIU0w6OTY1MDEwNQ==",
lat: 60.398721,
lon: 25.02284
},
{
id: "U3RvcDpIU0w6OTY1MTUwNA==",
lat: 60.394205,
lon: 25.021614
},
{
id: "U3RvcDpIU0w6OTY1MTUwMQ==",
lat: 60.390458,
lon: 25.023577
},
{
id: "U3RvcDpIU0w6OTY1MTcwMQ==",
lat: 60.386727,
lon: 25.025077
},
{
id: "U3RvcDpIU0w6OTY1MTYxMw==",
lat: 60.382931,
lon: 25.025434
},
{
id: "U3RvcDpIU0w6OTY1MTYwMQ==",
lat: 60.378409,
lon: 25.022339
},
{
id: "U3RvcDpIU0w6OTY1MTMxMg==",
lat: 60.374001,
lon: 25.018583
},
{
id: "U3RvcDpIU0w6OTY3MDUwMg==",
lat: 60.368227,
lon: 25.010802
},
{
id: "U3RvcDpIU0w6OTY3MDUwNQ==",
lat: 60.364502,
lon: 25.009361
},
{
id: "U3RvcDpIU0w6OTY3MDUyNw==",
lat: 60.353749,
lon: 25.008657
},
{
id: "U3RvcDpIU0w6OTY3MDUyNQ==",
lat: 60.34703,
lon: 25.003354
},
{
id: "U3RvcDpIU0w6OTY3MDUxNA==",
lat: 60.342295,
lon: 25.003129
},
{
id: "U3RvcDpIU0w6OTY3MDUxOA==",
lat: 60.339312,
lon: 25.003986
},
{
id: "U3RvcDpIU0w6OTY3MDUwNw==",
lat: 60.33588,
lon: 25.003993
},
{
id: "U3RvcDpIU0w6NDcxMDIwMg==",
lat: 60.33129,
lon: 25.00324
},
{
id: "U3RvcDpIU0w6NDcxMDIwNA==",
lat: 60.32314,
lon: 25.00089
},
{
id: "U3RvcDpIU0w6NDY3MDIwMQ==",
lat: 60.31931,
lon: 25.00022
},
{
id: "U3RvcDpIU0w6NDY3MDIyMQ==",
lat: 60.31554,
lon: 24.99887
},
{
id: "U3RvcDpIU0w6NDY3MDIxNQ==",
lat: 60.31214,
lon: 24.99851
},
{
id: "U3RvcDpIU0w6NDY4MDIzMw==",
lat: 60.30751,
lon: 24.99824
},
{
id: "U3RvcDpIU0w6NDY4MDIxOA==",
lat: 60.3012,
lon: 24.98972
},
{
id: "U3RvcDpIU0w6NDY4MDI1MA==",
lat: 60.29421,
lon: 24.98286
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mg==",
lat: 60.28722,
lon: 24.97696
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTI1MDEzMw==",
lat: 60.20863,
lon: 24.94408
},
{
id: "U3RvcDpIU0w6MTE3MzEzMw==",
lat: 60.20753,
lon: 24.93986
},
{
id: "U3RvcDpIU0w6MTE3MzEwOA==",
lat: 60.2026,
lon: 24.9329
},
{
id: "U3RvcDpIU0w6MTE3MzEwNg==",
lat: 60.19989,
lon: 24.93402
},
{
id: "U3RvcDpIU0w6MTE3MzE0OA==",
lat: 60.1977,
lon: 24.93506
},
{
id: "U3RvcDpIU0w6MTEyMjEyNw==",
lat: 60.19505,
lon: 24.93578
},
{
id: "U3RvcDpIU0w6MTE3MTEzNQ==",
lat: 60.19232,
lon: 24.92817
},
{
id: "U3RvcDpIU0w6MTE4MDEyMQ==",
lat: 60.19123,
lon: 24.92366
},
{
id: "U3RvcDpIU0w6MTE0MDEyNQ==",
lat: 60.18934,
lon: 24.9197
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDEyNg==",
lat: 60.18928,
lon: 24.92004
},
{
id: "U3RvcDpIU0w6MTE3MTEyMg==",
lat: 60.19145,
lon: 24.92554
},
{
id: "U3RvcDpIU0w6MTE3MTEyMA==",
lat: 60.19249,
lon: 24.93084
},
{
id: "U3RvcDpIU0w6MTE3MzEyNw==",
lat: 60.19699,
lon: 24.93584
},
{
id: "U3RvcDpIU0w6MTE3MzEwNQ==",
lat: 60.19942,
lon: 24.93461
},
{
id: "U3RvcDpIU0w6MTE3MzEwNw==",
lat: 60.20298,
lon: 24.93323
},
{
id: "U3RvcDpIU0w6MTE3MzEzMg==",
lat: 60.20781,
lon: 24.9413
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDY4MDI1MQ==",
lat: 60.28629,
lon: 24.98319
},
{
id: "U3RvcDpIU0w6NDY4MDI0OQ==",
lat: 60.29431,
lon: 24.98431
},
{
id: "U3RvcDpIU0w6NDY4MDIxNw==",
lat: 60.29991,
lon: 24.98982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMg==",
lat: 60.307715,
lon: 24.999454
},
{
id: "U3RvcDpIU0w6NDY3MDIxNg==",
lat: 60.31302,
lon: 24.99868
},
{
id: "U3RvcDpIU0w6NDY3MDIyMA==",
lat: 60.3168,
lon: 24.99965
},
{
id: "U3RvcDpIU0w6NDY3MDIwMg==",
lat: 60.31952,
lon: 25.00066
},
{
id: "U3RvcDpIU0w6NDcxMDIwNQ==",
lat: 60.32397,
lon: 25.00108
},
{
id: "U3RvcDpIU0w6NDcxMDIwMw==",
lat: 60.33233,
lon: 25.00378
},
{
id: "U3RvcDpIU0w6OTY3MDUwNg==",
lat: 60.336877,
lon: 25.004063
},
{
id: "U3RvcDpIU0w6OTY3MDUxNQ==",
lat: 60.340337,
lon: 25.003756
},
{
id: "U3RvcDpIU0w6OTY3MDUxMw==",
lat: 60.343194,
lon: 25.003081
},
{
id: "U3RvcDpIU0w6OTY3MDUyNA==",
lat: 60.347829,
lon: 25.004667
},
{
id: "U3RvcDpIU0w6OTY3MDUyNg==",
lat: 60.354703,
lon: 25.009253
},
{
id: "U3RvcDpIU0w6OTY3MDUwNA==",
lat: 60.365182,
lon: 25.00855
},
{
id: "U3RvcDpIU0w6OTY3MDUwMw==",
lat: 60.368584,
lon: 25.011852
},
{
id: "U3RvcDpIU0w6OTY1MTMxMw==",
lat: 60.375518,
lon: 25.019879
},
{
id: "U3RvcDpIU0w6OTY1MTYwMg==",
lat: 60.379778,
lon: 25.023895
},
{
id: "U3RvcDpIU0w6OTY1MTYxMg==",
lat: 60.382748,
lon: 25.025649
},
{
id: "U3RvcDpIU0w6OTY1MTcwMg==",
lat: 60.385848,
lon: 25.025451
},
{
id: "U3RvcDpIU0w6OTY1MTUwMg==",
lat: 60.391748,
lon: 25.023073
},
{
id: "U3RvcDpIU0w6OTY1MTUwMw==",
lat: 60.394225,
lon: 25.021879
},
{
id: "U3RvcDpIU0w6OTY1MDEwNA==",
lat: 60.397977,
lon: 25.022502
},
{
id: "U3RvcDpIU0w6OTY1MDExMA==",
lat: 60.400624,
lon: 25.026438
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MTAzMA==",
lat: 60.411299,
lon: 25.003959
},
{
id: "U3RvcDpIU0w6OTY1MTAwNw==",
lat: 60.41797,
lon: 25.000294
},
{
id: "U3RvcDpIU0w6OTY0MDQxMw==",
lat: 60.427683,
lon: 24.995212
},
{
id: "U3RvcDpIU0w6OTY0MDIxMQ==",
lat: 60.434771,
lon: 24.986197
},
{
id: "U3RvcDpIU0w6OTY0MDIwMQ==",
lat: 60.439897,
lon: 24.978521
},
{
id: "U3RvcDpIU0w6OTY0MDIwOA==",
lat: 60.442609,
lon: 24.974444
},
{
id: "U3RvcDpIU0w6OTY0MDExNA==",
lat: 60.446903,
lon: 24.965391
},
{
id: "U3RvcDpIU0w6OTY0MDEwNw==",
lat: 60.451698,
lon: 24.957288
},
{
id: "U3RvcDpIU0w6OTY0MDEwOA==",
lat: 60.461184,
lon: 24.947562
}
]
},
{
gtfsId: "HSL:9964",
shortName: "964",
longName: "Hyrylä-Paijala-Rusutjärvi-Rannikonmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY0MDExNg==",
lat: 60.462947,
lon: 24.931136
},
{
id: "U3RvcDpIU0w6OTY0MDExMg==",
lat: 60.460283,
lon: 24.937101
},
{
id: "U3RvcDpIU0w6OTY0MDExMQ==",
lat: 60.45923,
lon: 24.943752
},
{
id: "U3RvcDpIU0w6OTY0MDEwMA==",
lat: 60.454664,
lon: 24.946674
},
{
id: "U3RvcDpIU0w6OTY0MDEwNA==",
lat: 60.449735,
lon: 24.950241
},
{
id: "U3RvcDpIU0w6OTY0MDEwMg==",
lat: 60.445237,
lon: 24.951335
},
{
id: "U3RvcDpIU0w6OTY0MDMwOQ==",
lat: 60.437029,
lon: 24.953767
},
{
id: "U3RvcDpIU0w6OTY0MDMwMg==",
lat: 60.432876,
lon: 24.955259
},
{
id: "U3RvcDpIU0w6OTY0MDQxNA==",
lat: 60.426718,
lon: 24.964944
},
{
id: "U3RvcDpIU0w6OTY0MDQwNA==",
lat: 60.421423,
lon: 24.972399
},
{
id: "U3RvcDpIU0w6OTY0MDQwMA==",
lat: 60.419439,
lon: 24.975251
},
{
id: "U3RvcDpIU0w6OTY0MDQxNg==",
lat: 60.420316,
lon: 24.988401
},
{
id: "U3RvcDpIU0w6OTY1MTAwNg==",
lat: 60.416793,
lon: 25.000696
},
{
id: "U3RvcDpIU0w6OTY1MDgwNA==",
lat: 60.416225,
lon: 25.005537
},
{
id: "U3RvcDpIU0w6OTY1MDgwNQ==",
lat: 60.416767,
lon: 25.018242
},
{
id: "U3RvcDpIU0w6OTY1MDkwNg==",
lat: 60.410065,
lon: 25.014522
},
{
id: "U3RvcDpIU0w6OTY1MDkwMg==",
lat: 60.405499,
lon: 25.012577
},
{
id: "U3RvcDpIU0w6OTY1MDMwMw==",
lat: 60.4033,
lon: 25.02419
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
},
{
id: "U3RvcDpIU0w6OTY1MDEyNA==",
lat: 60.40201,
lon: 25.028074
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MDkwNQ==",
lat: 60.410608,
lon: 25.014965
},
{
id: "U3RvcDpIU0w6OTY1MDgwNg==",
lat: 60.416299,
lon: 25.0182
},
{
id: "U3RvcDpIU0w6OTY1MDgwMw==",
lat: 60.415801,
lon: 25.004147
},
{
id: "U3RvcDpIU0w6OTY1MTAwNw==",
lat: 60.41797,
lon: 25.000294
},
{
id: "U3RvcDpIU0w6OTY0MDQxNw==",
lat: 60.420053,
lon: 24.9876
},
{
id: "U3RvcDpIU0w6OTY0MDQwMQ==",
lat: 60.419096,
lon: 24.976312
},
{
id: "U3RvcDpIU0w6OTY0MDQwMw==",
lat: 60.421918,
lon: 24.971439
},
{
id: "U3RvcDpIU0w6OTY0MDQxNQ==",
lat: 60.426796,
lon: 24.964657
},
{
id: "U3RvcDpIU0w6OTY0MDMxMA==",
lat: 60.433431,
lon: 24.953708
},
{
id: "U3RvcDpIU0w6OTY0MDMwNw==",
lat: 60.431719,
lon: 24.937606
},
{
id: "U3RvcDpIU0w6OTY0MDMwNA==",
lat: 60.434242,
lon: 24.932986
},
{
id: "U3RvcDpIU0w6OTY0MDMwNg==",
lat: 60.43681,
lon: 24.917654
}
]
},
{
gtfsId: "HSL:9843",
shortName: "843",
longName: "Itäkeskus–Söderkulla–Kalkkiranta",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIxMTIwNQ==",
lat: 60.253103,
lon: 25.391623
},
{
id: "U3RvcDpIU0w6OTIxMTIwOA==",
lat: 60.256795,
lon: 25.393053
},
{
id: "U3RvcDpIU0w6OTIxMTIwNA==",
lat: 60.259075,
lon: 25.390903
},
{
id: "U3RvcDpIU0w6OTIxMTIxMQ==",
lat: 60.261828,
lon: 25.39308
},
{
id: "U3RvcDpIU0w6OTIxMTIwOQ==",
lat: 60.264493,
lon: 25.393385
},
{
id: "U3RvcDpIU0w6OTIxMTIxMw==",
lat: 60.26766,
lon: 25.393977
},
{
id: "U3RvcDpIU0w6OTIxMTIwMw==",
lat: 60.27286,
lon: 25.391138
},
{
id: "U3RvcDpIU0w6OTIwOTIwOQ==",
lat: 60.276688,
lon: 25.382672
},
{
id: "U3RvcDpIU0w6OTIwOTIwOA==",
lat: 60.279548,
lon: 25.373815
},
{
id: "U3RvcDpIU0w6OTIwOTIwNQ==",
lat: 60.28254,
lon: 25.37086
},
{
id: "U3RvcDpIU0w6OTIwOTIwNA==",
lat: 60.286737,
lon: 25.368327
},
{
id: "U3RvcDpIU0w6OTIwOTIwMQ==",
lat: 60.290598,
lon: 25.364878
},
{
id: "U3RvcDpIU0w6OTIwODIzMQ==",
lat: 60.297247,
lon: 25.354823
},
{
id: "U3RvcDpIU0w6OTIwODI1Mw==",
lat: 60.298852,
lon: 25.346872
},
{
id: "U3RvcDpIU0w6OTIwODI1Ng==",
lat: 60.298387,
lon: 25.337094
},
{
id: "U3RvcDpIU0w6OTIwODIxNA==",
lat: 60.298227,
lon: 25.329072
},
{
id: "U3RvcDpIU0w6OTIwODIxMA==",
lat: 60.297008,
lon: 25.322927
},
{
id: "U3RvcDpIU0w6OTIxMDIxMQ==",
lat: 60.292553,
lon: 25.311915
},
{
id: "U3RvcDpIU0w6OTIxMDIwOQ==",
lat: 60.290293,
lon: 25.307124
},
{
id: "U3RvcDpIU0w6OTIxMDIwOA==",
lat: 60.287115,
lon: 25.301985
},
{
id: "U3RvcDpIU0w6OTIxMDIwNg==",
lat: 60.284302,
lon: 25.298328
},
{
id: "U3RvcDpIU0w6OTIxMDIwMw==",
lat: 60.279217,
lon: 25.291527
},
{
id: "U3RvcDpIU0w6OTIwNDIwMQ==",
lat: 60.274445,
lon: 25.28587
},
{
id: "U3RvcDpIU0w6OTIwNDIwNw==",
lat: 60.269742,
lon: 25.279478
},
{
id: "U3RvcDpIU0w6OTIwNDIwNQ==",
lat: 60.26741,
lon: 25.275163
},
{
id: "U3RvcDpIU0w6OTIwNDIwMw==",
lat: 60.26462,
lon: 25.269811
},
{
id: "U3RvcDpIU0w6OTIwNTIxMQ==",
lat: 60.262375,
lon: 25.259562
},
{
id: "U3RvcDpIU0w6OTIwNTIwOQ==",
lat: 60.262158,
lon: 25.25394
},
{
id: "U3RvcDpIU0w6OTIwNTIwNA==",
lat: 60.26176,
lon: 25.240666
},
{
id: "U3RvcDpIU0w6OTIwNTIwMQ==",
lat: 60.261618,
lon: 25.232817
},
{
id: "U3RvcDpIU0w6MTYwMDIxOA==",
lat: 60.260228,
lon: 25.218075
},
{
id: "U3RvcDpIU0w6MTYwMDIxNg==",
lat: 60.25977,
lon: 25.208407
},
{
id: "U3RvcDpIU0w6MTYwMDIxNA==",
lat: 60.25475,
lon: 25.190433
},
{
id: "U3RvcDpIU0w6MTYwMDIxMg==",
lat: 60.253138,
lon: 25.183522
},
{
id: "U3RvcDpIU0w6MTYwMDIxMA==",
lat: 60.2514,
lon: 25.173983
},
{
id: "U3RvcDpIU0w6MTYwMDIwOA==",
lat: 60.249428,
lon: 25.163417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNg==",
lat: 60.24737,
lon: 25.156468
},
{
id: "U3RvcDpIU0w6MTYwMDIwNA==",
lat: 60.245817,
lon: 25.152437
},
{
id: "U3RvcDpIU0w6MTYwMDIwMg==",
lat: 60.24422,
lon: 25.142975
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMA==",
lat: 60.23124,
lon: 25.12868
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MQ==",
lat: 60.22017,
lon: 25.10757
},
{
id: "U3RvcDpIU0w6MTQ1MTE4OA==",
lat: 60.21806,
lon: 25.10282
},
{
id: "U3RvcDpIU0w6MTQ1MzEzNA==",
lat: 60.21477,
lon: 25.09232
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
},
{
id: "U3RvcDpIU0w6MTQ1MzE4OQ==",
lat: 60.20987,
lon: 25.07621
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MjExOQ==",
lat: 60.215433,
lon: 25.094638
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Nw==",
lat: 60.21833,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MA==",
lat: 60.22011,
lon: 25.10815
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzExOQ==",
lat: 60.23115,
lon: 25.12893
},
{
id: "U3RvcDpIU0w6MTYwMDIwMQ==",
lat: 60.2431,
lon: 25.14191
},
{
id: "U3RvcDpIU0w6MTYwMDIwMw==",
lat: 60.245348,
lon: 25.151417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNQ==",
lat: 60.246743,
lon: 25.155558
},
{
id: "U3RvcDpIU0w6MTYwMDIwNw==",
lat: 60.249545,
lon: 25.164438
},
{
id: "U3RvcDpIU0w6MTYwMDIwOQ==",
lat: 60.251682,
lon: 25.176211
},
{
id: "U3RvcDpIU0w6MTYwMDIxMQ==",
lat: 60.253477,
lon: 25.185895
},
{
id: "U3RvcDpIU0w6MTYwMDIxMw==",
lat: 60.255158,
lon: 25.192102
},
{
id: "U3RvcDpIU0w6MTYwMDIxNQ==",
lat: 60.259785,
lon: 25.211032
},
{
id: "U3RvcDpIU0w6MTYwMDIzMQ==",
lat: 60.260022,
lon: 25.215462
},
{
id: "U3RvcDpIU0w6MTYwMDIxNw==",
lat: 60.260177,
lon: 25.219923
},
{
id: "U3RvcDpIU0w6OTIwNTIwMg==",
lat: 60.261534,
lon: 25.236805
},
{
id: "U3RvcDpIU0w6OTIwNTIwMw==",
lat: 60.261642,
lon: 25.242721
},
{
id: "U3RvcDpIU0w6OTIwNTIxMA==",
lat: 60.262063,
lon: 25.256016
},
{
id: "U3RvcDpIU0w6OTIwNTIxMg==",
lat: 60.262335,
lon: 25.262876
},
{
id: "U3RvcDpIU0w6OTIwNDIwMg==",
lat: 60.26352,
lon: 25.268045
},
{
id: "U3RvcDpIU0w6OTIwNDIwNA==",
lat: 60.26572,
lon: 25.272465
},
{
id: "U3RvcDpIU0w6OTIwNDIwNg==",
lat: 60.26761,
lon: 25.27612
},
{
id: "U3RvcDpIU0w6OTIwNDIwOA==",
lat: 60.270106,
lon: 25.280453
},
{
id: "U3RvcDpIU0w6OTIwNDIxMg==",
lat: 60.275142,
lon: 25.287136
},
{
id: "U3RvcDpIU0w6OTIxMDIwNA==",
lat: 60.280193,
lon: 25.293077
},
{
id: "U3RvcDpIU0w6OTIxMDIwNw==",
lat: 60.285534,
lon: 25.300471
},
{
id: "U3RvcDpIU0w6OTIxMDIxMA==",
lat: 60.290757,
lon: 25.308611
},
{
id: "U3RvcDpIU0w6OTIxMDIxMg==",
lat: 60.292936,
lon: 25.313265
},
{
id: "U3RvcDpIU0w6OTIwODIxMQ==",
lat: 60.297276,
lon: 25.324799
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1Nw==",
lat: 60.298,
lon: 25.339552
},
{
id: "U3RvcDpIU0w6OTIwODI1Mg==",
lat: 60.298743,
lon: 25.346913
},
{
id: "U3RvcDpIU0w6OTIwODI1MA==",
lat: 60.296725,
lon: 25.350455
},
{
id: "U3RvcDpIU0w6OTIwODIzMA==",
lat: 60.29683,
lon: 25.35423
},
{
id: "U3RvcDpIU0w6OTIwOTIwMg==",
lat: 60.29001,
lon: 25.3648
},
{
id: "U3RvcDpIU0w6OTIwOTIwMw==",
lat: 60.287186,
lon: 25.367533
},
{
id: "U3RvcDpIU0w6OTIwOTIwNg==",
lat: 60.28188,
lon: 25.37125
},
{
id: "U3RvcDpIU0w6OTIwOTIwNw==",
lat: 60.279902,
lon: 25.373073
},
{
id: "U3RvcDpIU0w6OTIwOTIxMA==",
lat: 60.276292,
lon: 25.383408
},
{
id: "U3RvcDpIU0w6OTIxMTIwMQ==",
lat: 60.271607,
lon: 25.391177
},
{
id: "U3RvcDpIU0w6OTIxMTIxMg==",
lat: 60.267235,
lon: 25.393565
},
{
id: "U3RvcDpIU0w6OTIxMTIwNw==",
lat: 60.26471,
lon: 25.392992
},
{
id: "U3RvcDpIU0w6OTIxMTIwNg==",
lat: 60.261228,
lon: 25.392478
},
{
id: "U3RvcDpIU0w6OTIxMTIwMg==",
lat: 60.25943,
lon: 25.390547
},
{
id: "U3RvcDpIU0w6OTIxMTIxMA==",
lat: 60.256199,
lon: 25.39278
}
]
},
{
gtfsId: "HSL:9965",
shortName: "965",
longName: "Hyrylä-Jäniksenlinna-Perttu-Jokela",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTYxMDIyMA==",
lat: 60.553215,
lon: 24.96926
},
{
id: "U3RvcDpIU0w6OTYxMDIxOA==",
lat: 60.550927,
lon: 24.965158
},
{
id: "U3RvcDpIU0w6OTYxMDMxNw==",
lat: 60.544047,
lon: 24.971887
},
{
id: "U3RvcDpIU0w6OTYxMDMxOA==",
lat: 60.54065,
lon: 24.969297
},
{
id: "U3RvcDpIU0w6OTYxMDMxNQ==",
lat: 60.53898,
lon: 24.960716
},
{
id: "U3RvcDpIU0w6OTYxMDMwNQ==",
lat: 60.537836,
lon: 24.958174
},
{
id: "U3RvcDpIU0w6OTYxMDMwOQ==",
lat: 60.535146,
lon: 24.954998
},
{
id: "U3RvcDpIU0w6OTYxMDMxMA==",
lat: 60.528217,
lon: 24.945391
},
{
id: "U3RvcDpIU0w6OTcwMDIzMA==",
lat: 60.524705,
lon: 24.924337
},
{
id: "U3RvcDpIU0w6OTcwMDIyOA==",
lat: 60.518798,
lon: 24.925826
},
{
id: "U3RvcDpIU0w6OTcwMDIyNg==",
lat: 60.50923,
lon: 24.934799
},
{
id: "U3RvcDpIU0w6OTcwMDIyNA==",
lat: 60.504064,
lon: 24.951996
},
{
id: "U3RvcDpIU0w6OTcwMDIyMg==",
lat: 60.493881,
lon: 24.962631
},
{
id: "U3RvcDpIU0w6OTYzMDQwMA==",
lat: 60.489264,
lon: 24.969857
},
{
id: "U3RvcDpIU0w6OTYzMDQwMg==",
lat: 60.486189,
lon: 24.972271
},
{
id: "U3RvcDpIU0w6OTYzMDUwMg==",
lat: 60.483192,
lon: 24.974378
},
{
id: "U3RvcDpIU0w6OTYzMDUwNA==",
lat: 60.477494,
lon: 24.978765
},
{
id: "U3RvcDpIU0w6OTYzMDUwMA==",
lat: 60.471528,
lon: 24.987301
},
{
id: "U3RvcDpIU0w6OTY0MDIwNA==",
lat: 60.457873,
lon: 24.984671
},
{
id: "U3RvcDpIU0w6OTY0MDIwOQ==",
lat: 60.451385,
lon: 24.97701
},
{
id: "U3RvcDpIU0w6OTY0MDIwMw==",
lat: 60.44679,
lon: 24.973925
},
{
id: "U3RvcDpIU0w6OTY0MDIwNw==",
lat: 60.441703,
lon: 24.975813
},
{
id: "U3RvcDpIU0w6OTY0MDIwMA==",
lat: 60.438756,
lon: 24.980235
},
{
id: "U3RvcDpIU0w6OTY0MDQyMA==",
lat: 60.433934,
lon: 24.987427
},
{
id: "U3RvcDpIU0w6OTY0MDQxMg==",
lat: 60.426842,
lon: 24.995887
},
{
id: "U3RvcDpIU0w6OTY1MTAwNg==",
lat: 60.416793,
lon: 25.000696
},
{
id: "U3RvcDpIU0w6OTY1MTAyOQ==",
lat: 60.411092,
lon: 25.004086
},
{
id: "U3RvcDpIU0w6OTY1MDkwMA==",
lat: 60.406062,
lon: 25.009508
},
{
id: "U3RvcDpIU0w6OTY1MDkwMg==",
lat: 60.405499,
lon: 25.012577
},
{
id: "U3RvcDpIU0w6OTY1MDMwMw==",
lat: 60.4033,
lon: 25.02419
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
},
{
id: "U3RvcDpIU0w6OTY1MDEyNA==",
lat: 60.40201,
lon: 25.028074
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MDkwMQ==",
lat: 60.406126,
lon: 25.009112
},
{
id: "U3RvcDpIU0w6OTY1MTAzMA==",
lat: 60.411299,
lon: 25.003959
},
{
id: "U3RvcDpIU0w6OTY1MTAwNw==",
lat: 60.41797,
lon: 25.000294
},
{
id: "U3RvcDpIU0w6OTY0MDQxMw==",
lat: 60.427683,
lon: 24.995212
},
{
id: "U3RvcDpIU0w6OTY0MDIxMQ==",
lat: 60.434771,
lon: 24.986197
},
{
id: "U3RvcDpIU0w6OTY0MDIwMQ==",
lat: 60.439897,
lon: 24.978521
},
{
id: "U3RvcDpIU0w6OTY0MDIwOA==",
lat: 60.442609,
lon: 24.974444
},
{
id: "U3RvcDpIU0w6OTY0MDIwMg==",
lat: 60.446018,
lon: 24.973734
},
{
id: "U3RvcDpIU0w6OTY0MDIxMA==",
lat: 60.450335,
lon: 24.976263
},
{
id: "U3RvcDpIU0w6OTY0MDIwNQ==",
lat: 60.456697,
lon: 24.982749
},
{
id: "U3RvcDpIU0w6OTYzMDUwMw==",
lat: 60.459668,
lon: 24.985308
},
{
id: "U3RvcDpIU0w6OTYzMDUwMQ==",
lat: 60.471422,
lon: 24.987407
},
{
id: "U3RvcDpIU0w6OTYzMDUwNQ==",
lat: 60.477834,
lon: 24.978129
},
{
id: "U3RvcDpIU0w6OTYzMDQxMA==",
lat: 60.483647,
lon: 24.974288
},
{
id: "U3RvcDpIU0w6OTYzMDQwMw==",
lat: 60.486755,
lon: 24.972114
},
{
id: "U3RvcDpIU0w6OTYzMDQwMQ==",
lat: 60.489927,
lon: 24.969136
},
{
id: "U3RvcDpIU0w6OTcwMDIyMQ==",
lat: 60.494212,
lon: 24.962823
},
{
id: "U3RvcDpIU0w6OTcwMDIyMw==",
lat: 60.50457,
lon: 24.951537
},
{
id: "U3RvcDpIU0w6OTcwMDIyNQ==",
lat: 60.509155,
lon: 24.936617
},
{
id: "U3RvcDpIU0w6OTcwMDIyNw==",
lat: 60.511449,
lon: 24.928019
},
{
id: "U3RvcDpIU0w6OTcwMDIyOQ==",
lat: 60.520257,
lon: 24.926359
},
{
id: "U3RvcDpIU0w6OTcwMDIzMQ==",
lat: 60.525824,
lon: 24.926062
},
{
id: "U3RvcDpIU0w6OTYxMDMxMQ==",
lat: 60.528282,
lon: 24.946632
},
{
id: "U3RvcDpIU0w6OTYxMDMwOA==",
lat: 60.535797,
lon: 24.957163
},
{
id: "U3RvcDpIU0w6OTYxMDMwNA==",
lat: 60.538221,
lon: 24.958512
},
{
id: "U3RvcDpIU0w6OTYxMDMxNA==",
lat: 60.539254,
lon: 24.96233
},
{
id: "U3RvcDpIU0w6OTYxMDMxOQ==",
lat: 60.54031,
lon: 24.96755
},
{
id: "U3RvcDpIU0w6OTYxMDMxNg==",
lat: 60.544953,
lon: 24.970892
},
{
id: "U3RvcDpIU0w6OTYxMDIxOQ==",
lat: 60.551364,
lon: 24.965102
}
]
},
{
gtfsId: "HSL:1066K",
shortName: "66K",
longName: "Rautatientori-Metsälä-Maunula-Länsi-Pakila-Paloheinä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMg==",
lat: 60.17085,
lon: 24.94333
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDExMA==",
lat: 60.19226,
lon: 24.96136
},
{
id: "U3RvcDpIU0w6MTIyMDE4MQ==",
lat: 60.19565,
lon: 24.95499
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDE1Mw==",
lat: 60.22125,
lon: 24.94678
},
{
id: "U3RvcDpIU0w6MTI4MzEzMA==",
lat: 60.22153,
lon: 24.94149
},
{
id: "U3RvcDpIU0w6MTI4MzEzMg==",
lat: 60.22103,
lon: 24.93707
},
{
id: "U3RvcDpIU0w6MTI4NjEzNA==",
lat: 60.223362,
lon: 24.933546
},
{
id: "U3RvcDpIU0w6MTI4MjEzNg==",
lat: 60.22544,
lon: 24.93073
},
{
id: "U3RvcDpIU0w6MTI4MjE0Mg==",
lat: 60.22827,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTI4MjE0Ng==",
lat: 60.23062,
lon: 24.93342
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MTEwNw==",
lat: 60.23472,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTM0MTExOA==",
lat: 60.23743,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTM0MTEyMA==",
lat: 60.23948,
lon: 24.92814
},
{
id: "U3RvcDpIU0w6MTM0MTEyMg==",
lat: 60.24185,
lon: 24.92687
},
{
id: "U3RvcDpIU0w6MTM0MTEyNA==",
lat: 60.24426,
lon: 24.9254
},
{
id: "U3RvcDpIU0w6MTM1MTExMw==",
lat: 60.2477,
lon: 24.92264
},
{
id: "U3RvcDpIU0w6MTM1MTExNA==",
lat: 60.25068,
lon: 24.9198
},
{
id: "U3RvcDpIU0w6MTM1MTExNg==",
lat: 60.25305,
lon: 24.9188
},
{
id: "U3RvcDpIU0w6MTM1MTEyOQ==",
lat: 60.253775,
lon: 24.918462
},
{
id: "U3RvcDpIU0w6MTM1MTExNw==",
lat: 60.25285,
lon: 24.91874
},
{
id: "U3RvcDpIU0w6MTM1MTExNQ==",
lat: 60.24994,
lon: 24.91996
},
{
id: "U3RvcDpIU0w6MTM1MTEwMg==",
lat: 60.24687,
lon: 24.9239
},
{
id: "U3RvcDpIU0w6MTM0MTEyNQ==",
lat: 60.24433,
lon: 24.92518
},
{
id: "U3RvcDpIU0w6MTM0MTEyMw==",
lat: 60.24172,
lon: 24.92653
},
{
id: "U3RvcDpIU0w6MTM0MTEyMQ==",
lat: 60.23958,
lon: 24.9279
},
{
id: "U3RvcDpIU0w6MTM0MTExOQ==",
lat: 60.23664,
lon: 24.92902
},
{
id: "U3RvcDpIU0w6MTI4MjEwNg==",
lat: 60.23351,
lon: 24.93171
},
{
id: "U3RvcDpIU0w6MTI4MjEwNA==",
lat: 60.23154,
lon: 24.93381
},
{
id: "U3RvcDpIU0w6MTI4MjE0Nw==",
lat: 60.230679,
lon: 24.932013
},
{
id: "U3RvcDpIU0w6MTI4MjE0NQ==",
lat: 60.228725,
lon: 24.927237
},
{
id: "U3RvcDpIU0w6MTI4MjEzOQ==",
lat: 60.227679,
lon: 24.926687
},
{
id: "U3RvcDpIU0w6MTI4MjEzNw==",
lat: 60.22526,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTI4NjEzNQ==",
lat: 60.2216,
lon: 24.9333
},
{
id: "U3RvcDpIU0w6MTI4MzEzMw==",
lat: 60.22099,
lon: 24.93806
},
{
id: "U3RvcDpIU0w6MTI4MzEzMQ==",
lat: 60.22105,
lon: 24.9431
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4431N",
shortName: "431N",
longName: "Elielinaukio-Myyrmäki-Kannisto-Kivistö",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDIzOQ==",
lat: 60.171981,
lon: 24.93971
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE1MDIxOQ==",
lat: 60.26394,
lon: 24.85928
},
{
id: "U3RvcDpIU0w6NDE1MDI2MA==",
lat: 60.26146,
lon: 24.85547
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNQ==",
lat: 60.27027,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0OA==",
lat: 60.27723,
lon: 24.85379
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOQ==",
lat: 60.28544,
lon: 24.85111
},
{
id: "U3RvcDpIU0w6NDE3MDIzMw==",
lat: 60.28679,
lon: 24.85677
},
{
id: "U3RvcDpIU0w6NDE4MDIzMg==",
lat: 60.2876,
lon: 24.86121
},
{
id: "U3RvcDpIU0w6NDE4MDIyNw==",
lat: 60.28906,
lon: 24.86484
},
{
id: "U3RvcDpIU0w6NDE4MDIxMg==",
lat: 60.29113,
lon: 24.86663
},
{
id: "U3RvcDpIU0w6NDIxMDIwMQ==",
lat: 60.29308,
lon: 24.86341
},
{
id: "U3RvcDpIU0w6NDIxMDIwMw==",
lat: 60.29542,
lon: 24.85944
},
{
id: "U3RvcDpIU0w6NDIxMDIwNQ==",
lat: 60.29993,
lon: 24.85925
},
{
id: "U3RvcDpIU0w6NDIxMDI5OQ==",
lat: 60.30173,
lon: 24.8569
},
{
id: "U3RvcDpIU0w6NDIxMDI5Nw==",
lat: 60.30152,
lon: 24.85215
},
{
id: "U3RvcDpIU0w6NDIxMDIyNQ==",
lat: 60.30162,
lon: 24.84876
},
{
id: "U3RvcDpIU0w6NDIxMDIzNw==",
lat: 60.308071,
lon: 24.851351
},
{
id: "U3RvcDpIU0w6NDIxMDIzMw==",
lat: 60.31361,
lon: 24.85587
},
{
id: "U3RvcDpIU0w6NDI0MDIwMQ==",
lat: 60.319222,
lon: 24.869969
},
{
id: "U3RvcDpIU0w6NDI0MDIwMw==",
lat: 60.32273,
lon: 24.86908
},
{
id: "U3RvcDpIU0w6NDI0MDIwNQ==",
lat: 60.32608,
lon: 24.86706
},
{
id: "U3RvcDpIU0w6NDIzMDIzMg==",
lat: 60.32947,
lon: 24.8619
},
{
id: "U3RvcDpIU0w6NDIzMDIzMA==",
lat: 60.32875,
lon: 24.85569
},
{
id: "U3RvcDpIU0w6NDIzMDIyNg==",
lat: 60.32921,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDIzMDIyNA==",
lat: 60.32753,
lon: 24.85013
},
{
id: "U3RvcDpIU0w6NDIzMDIyMg==",
lat: 60.32522,
lon: 24.84962
},
{
id: "U3RvcDpIU0w6NDIzMDIyOA==",
lat: 60.3233,
lon: 24.84578
},
{
id: "U3RvcDpIU0w6NDIzMDIwOQ==",
lat: 60.32227,
lon: 24.8409
},
{
id: "U3RvcDpIU0w6NDIzMDIwNw==",
lat: 60.3205,
lon: 24.84192
},
{
id: "U3RvcDpIU0w6NDIzMDIwNQ==",
lat: 60.31832,
lon: 24.84409
},
{
id: "U3RvcDpIU0w6NDIzMDIwMw==",
lat: 60.316588,
lon: 24.847408
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0NQ==",
lat: 60.314149,
lon: 24.844845
},
{
id: "U3RvcDpIU0w6NDIzMDIwMg==",
lat: 60.317449,
lon: 24.846159
},
{
id: "U3RvcDpIU0w6NDIzMDIwNA==",
lat: 60.3189,
lon: 24.84368
},
{
id: "U3RvcDpIU0w6NDIzMDIwNg==",
lat: 60.32009,
lon: 24.84231
},
{
id: "U3RvcDpIU0w6NDIzMDIyNw==",
lat: 60.32297,
lon: 24.84473
},
{
id: "U3RvcDpIU0w6NDIzMDIyMQ==",
lat: 60.32615,
lon: 24.8498
},
{
id: "U3RvcDpIU0w6NDIzMDIyMw==",
lat: 60.32798,
lon: 24.85087
},
{
id: "U3RvcDpIU0w6NDIzMDIyOQ==",
lat: 60.32945,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDIzMDIzMQ==",
lat: 60.3282,
lon: 24.85841
},
{
id: "U3RvcDpIU0w6NDI0MDIwNg==",
lat: 60.32723,
lon: 24.86575
},
{
id: "U3RvcDpIU0w6NDI0MDIyMA==",
lat: 60.32498,
lon: 24.86777
},
{
id: "U3RvcDpIU0w6NDI0MDIwNA==",
lat: 60.32204,
lon: 24.86887
},
{
id: "U3RvcDpIU0w6NDI0MDIyNw==",
lat: 60.31905,
lon: 24.8698
},
{
id: "U3RvcDpIU0w6NDIxMDI0NQ==",
lat: 60.316659,
lon: 24.867147
},
{
id: "U3RvcDpIU0w6NDIxMDIzNg==",
lat: 60.307648,
lon: 24.850909
},
{
id: "U3RvcDpIU0w6NDIxMDIyNg==",
lat: 60.30299,
lon: 24.84741
},
{
id: "U3RvcDpIU0w6NDIxMDI5OA==",
lat: 60.30157,
lon: 24.8534
},
{
id: "U3RvcDpIU0w6NDIxMDIxNQ==",
lat: 60.30119,
lon: 24.85722
},
{
id: "U3RvcDpIU0w6NDIxMDIwNg==",
lat: 60.29954,
lon: 24.85863
},
{
id: "U3RvcDpIU0w6NDIxMDIwNA==",
lat: 60.2945,
lon: 24.86104
},
{
id: "U3RvcDpIU0w6NDIxMDIwMg==",
lat: 60.29251,
lon: 24.86391
},
{
id: "U3RvcDpIU0w6NDE4MDIyOA==",
lat: 60.28913,
lon: 24.86463
},
{
id: "U3RvcDpIU0w6NDE3MDI3OA==",
lat: 60.287244,
lon: 24.85855
},
{
id: "U3RvcDpIU0w6NDE3MDIzNA==",
lat: 60.28682,
lon: 24.85567
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mw==",
lat: 60.27737,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDI2Mw==",
lat: 60.26109,
lon: 24.856
},
{
id: "U3RvcDpIU0w6NDE1MDIyMA==",
lat: 60.26371,
lon: 24.85947
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:9841",
shortName: "841",
longName: "Itäkeskus-Östersundom-Söderkulla-Nikkilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzE4OQ==",
lat: 60.20987,
lon: 25.07621
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MjExOQ==",
lat: 60.215433,
lon: 25.094638
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Nw==",
lat: 60.21833,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MA==",
lat: 60.22011,
lon: 25.10815
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzExOQ==",
lat: 60.23115,
lon: 25.12893
},
{
id: "U3RvcDpIU0w6MTYwMDIwMQ==",
lat: 60.2431,
lon: 25.14191
},
{
id: "U3RvcDpIU0w6MTYwMDIwMw==",
lat: 60.245348,
lon: 25.151417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNQ==",
lat: 60.246743,
lon: 25.155558
},
{
id: "U3RvcDpIU0w6MTYwMDIwNw==",
lat: 60.249545,
lon: 25.164438
},
{
id: "U3RvcDpIU0w6MTYwMDIwOQ==",
lat: 60.251682,
lon: 25.176211
},
{
id: "U3RvcDpIU0w6MTYwMDIxMQ==",
lat: 60.253477,
lon: 25.185895
},
{
id: "U3RvcDpIU0w6MTYwMDIxMw==",
lat: 60.255158,
lon: 25.192102
},
{
id: "U3RvcDpIU0w6MTYwMDIxNQ==",
lat: 60.259785,
lon: 25.211032
},
{
id: "U3RvcDpIU0w6MTYwMDIzMQ==",
lat: 60.260022,
lon: 25.215462
},
{
id: "U3RvcDpIU0w6MTYwMDIxNw==",
lat: 60.260177,
lon: 25.219923
},
{
id: "U3RvcDpIU0w6OTIwNTIwMg==",
lat: 60.261534,
lon: 25.236805
},
{
id: "U3RvcDpIU0w6OTIwNTIwMw==",
lat: 60.261642,
lon: 25.242721
},
{
id: "U3RvcDpIU0w6OTIwNTIxMA==",
lat: 60.262063,
lon: 25.256016
},
{
id: "U3RvcDpIU0w6OTIwNTIxMg==",
lat: 60.262335,
lon: 25.262876
},
{
id: "U3RvcDpIU0w6OTIwNDIwMg==",
lat: 60.26352,
lon: 25.268045
},
{
id: "U3RvcDpIU0w6OTIwNDIwNA==",
lat: 60.26572,
lon: 25.272465
},
{
id: "U3RvcDpIU0w6OTIwNDIwNg==",
lat: 60.26761,
lon: 25.27612
},
{
id: "U3RvcDpIU0w6OTIwNDIwOA==",
lat: 60.270106,
lon: 25.280453
},
{
id: "U3RvcDpIU0w6OTIwNDIxMg==",
lat: 60.275142,
lon: 25.287136
},
{
id: "U3RvcDpIU0w6OTIxMDIwNA==",
lat: 60.280193,
lon: 25.293077
},
{
id: "U3RvcDpIU0w6OTIxMDIwNw==",
lat: 60.285534,
lon: 25.300471
},
{
id: "U3RvcDpIU0w6OTIxMDIxMA==",
lat: 60.290757,
lon: 25.308611
},
{
id: "U3RvcDpIU0w6OTIxMDIxMg==",
lat: 60.292936,
lon: 25.313265
},
{
id: "U3RvcDpIU0w6OTIwODIxMQ==",
lat: 60.297276,
lon: 25.324799
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
},
{
id: "U3RvcDpIU0w6OTIwODI1OA==",
lat: 60.302374,
lon: 25.330245
},
{
id: "U3RvcDpIU0w6OTIwODI2Mg==",
lat: 60.303305,
lon: 25.325164
},
{
id: "U3RvcDpIU0w6OTIwODI2NA==",
lat: 60.301314,
lon: 25.319603
},
{
id: "U3RvcDpIU0w6OTIwODIwNQ==",
lat: 60.301773,
lon: 25.307364
},
{
id: "U3RvcDpIU0w6OTIwODIwMw==",
lat: 60.304703,
lon: 25.294687
},
{
id: "U3RvcDpIU0w6OTIwODIwMQ==",
lat: 60.309975,
lon: 25.285867
},
{
id: "U3RvcDpIU0w6OTIyMDIxNw==",
lat: 60.320012,
lon: 25.270045
},
{
id: "U3RvcDpIU0w6OTIyMDIxMA==",
lat: 60.323868,
lon: 25.264845
},
{
id: "U3RvcDpIU0w6OTIyMDIwOA==",
lat: 60.329973,
lon: 25.263783
},
{
id: "U3RvcDpIU0w6OTIyMDIxMQ==",
lat: 60.333691,
lon: 25.265295
},
{
id: "U3RvcDpIU0w6OTIyMDIwNQ==",
lat: 60.340675,
lon: 25.263232
},
{
id: "U3RvcDpIU0w6OTIyMDIwNg==",
lat: 60.347598,
lon: 25.263275
},
{
id: "U3RvcDpIU0w6OTIyMDIxNA==",
lat: 60.353453,
lon: 25.26834
},
{
id: "U3RvcDpIU0w6OTIxNjIxOQ==",
lat: 60.356245,
lon: 25.266868
},
{
id: "U3RvcDpIU0w6OTIxNjIxNA==",
lat: 60.363368,
lon: 25.261563
},
{
id: "U3RvcDpIU0w6OTIyMjI0MA==",
lat: 60.369115,
lon: 25.258614
},
{
id: "U3RvcDpIU0w6OTIyMjIyMg==",
lat: 60.370252,
lon: 25.258915
},
{
id: "U3RvcDpIU0w6OTIyMjIyNQ==",
lat: 60.371527,
lon: 25.262477
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyOQ==",
lat: 60.375727,
lon: 25.267724
},
{
id: "U3RvcDpIU0w6OTIyMjIyNg==",
lat: 60.371818,
lon: 25.262633
},
{
id: "U3RvcDpIU0w6OTIyMjIyMQ==",
lat: 60.37037,
lon: 25.258497
},
{
id: "U3RvcDpIU0w6OTIxNjIxMw==",
lat: 60.363567,
lon: 25.26105
},
{
id: "U3RvcDpIU0w6OTIyMDIxMg==",
lat: 60.354502,
lon: 25.267033
},
{
id: "U3RvcDpIU0w6OTIyMDIxNQ==",
lat: 60.351588,
lon: 25.267842
},
{
id: "U3RvcDpIU0w6OTIyMDIwNA==",
lat: 60.346382,
lon: 25.262063
},
{
id: "U3RvcDpIU0w6OTIyMDIwMw==",
lat: 60.339652,
lon: 25.262577
},
{
id: "U3RvcDpIU0w6OTIyMDIwOQ==",
lat: 60.332812,
lon: 25.264718
},
{
id: "U3RvcDpIU0w6OTIyMDIwNw==",
lat: 60.329111,
lon: 25.263107
},
{
id: "U3RvcDpIU0w6OTIyMDIxMw==",
lat: 60.32271,
lon: 25.266108
},
{
id: "U3RvcDpIU0w6OTIyMDIxOA==",
lat: 60.31899,
lon: 25.27116
},
{
id: "U3RvcDpIU0w6OTIwODIwMg==",
lat: 60.308955,
lon: 25.287228
},
{
id: "U3RvcDpIU0w6OTIwODIwNA==",
lat: 60.303865,
lon: 25.295502
},
{
id: "U3RvcDpIU0w6OTIwODIwNg==",
lat: 60.301678,
lon: 25.308777
},
{
id: "U3RvcDpIU0w6OTIwODI2MQ==",
lat: 60.301293,
lon: 25.319891
},
{
id: "U3RvcDpIU0w6OTIwODI2Mw==",
lat: 60.303028,
lon: 25.324085
},
{
id: "U3RvcDpIU0w6OTIwODI2NQ==",
lat: 60.301032,
lon: 25.330698
},
{
id: "U3RvcDpIU0w6OTIwODIxNA==",
lat: 60.298227,
lon: 25.329072
},
{
id: "U3RvcDpIU0w6OTIwODIxMA==",
lat: 60.297008,
lon: 25.322927
},
{
id: "U3RvcDpIU0w6OTIxMDIxMQ==",
lat: 60.292553,
lon: 25.311915
},
{
id: "U3RvcDpIU0w6OTIxMDIwOQ==",
lat: 60.290293,
lon: 25.307124
},
{
id: "U3RvcDpIU0w6OTIxMDIwOA==",
lat: 60.287115,
lon: 25.301985
},
{
id: "U3RvcDpIU0w6OTIxMDIwNg==",
lat: 60.284302,
lon: 25.298328
},
{
id: "U3RvcDpIU0w6OTIxMDIwMw==",
lat: 60.279217,
lon: 25.291527
},
{
id: "U3RvcDpIU0w6OTIwNDIwMQ==",
lat: 60.274445,
lon: 25.28587
},
{
id: "U3RvcDpIU0w6OTIwNDIwNw==",
lat: 60.269742,
lon: 25.279478
},
{
id: "U3RvcDpIU0w6OTIwNDIwNQ==",
lat: 60.26741,
lon: 25.275163
},
{
id: "U3RvcDpIU0w6OTIwNDIwMw==",
lat: 60.26462,
lon: 25.269811
},
{
id: "U3RvcDpIU0w6OTIwNTIxMQ==",
lat: 60.262375,
lon: 25.259562
},
{
id: "U3RvcDpIU0w6OTIwNTIwOQ==",
lat: 60.262158,
lon: 25.25394
},
{
id: "U3RvcDpIU0w6OTIwNTIwNA==",
lat: 60.26176,
lon: 25.240666
},
{
id: "U3RvcDpIU0w6OTIwNTIwMQ==",
lat: 60.261618,
lon: 25.232817
},
{
id: "U3RvcDpIU0w6MTYwMDIxOA==",
lat: 60.260228,
lon: 25.218075
},
{
id: "U3RvcDpIU0w6MTYwMDIxNg==",
lat: 60.25977,
lon: 25.208407
},
{
id: "U3RvcDpIU0w6MTYwMDIxNA==",
lat: 60.25475,
lon: 25.190433
},
{
id: "U3RvcDpIU0w6MTYwMDIxMg==",
lat: 60.253138,
lon: 25.183522
},
{
id: "U3RvcDpIU0w6MTYwMDIxMA==",
lat: 60.2514,
lon: 25.173983
},
{
id: "U3RvcDpIU0w6MTYwMDIwOA==",
lat: 60.249428,
lon: 25.163417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNg==",
lat: 60.24737,
lon: 25.156468
},
{
id: "U3RvcDpIU0w6MTYwMDIwNA==",
lat: 60.245817,
lon: 25.152437
},
{
id: "U3RvcDpIU0w6MTYwMDIwMg==",
lat: 60.24422,
lon: 25.142975
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMA==",
lat: 60.23124,
lon: 25.12868
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MQ==",
lat: 60.22017,
lon: 25.10757
},
{
id: "U3RvcDpIU0w6MTQ1MTE4OA==",
lat: 60.21806,
lon: 25.10282
},
{
id: "U3RvcDpIU0w6MTQ1MzEzNA==",
lat: 60.21477,
lon: 25.09232
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
}
]
},
{
gtfsId: "HSL:1078N",
shortName: "78N",
longName: "Rautatientori-Viikki-Latokartano",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM2MjE1MQ==",
lat: 60.23057,
lon: 25.0436
},
{
id: "U3RvcDpIU0w6MTM2MjE1MA==",
lat: 60.23253,
lon: 25.04761
},
{
id: "U3RvcDpIU0w6MTM2MjE0OA==",
lat: 60.23443,
lon: 25.04458
},
{
id: "U3RvcDpIU0w6MTM2MjE0Ng==",
lat: 60.23531,
lon: 25.04045
},
{
id: "U3RvcDpIU0w6MTM2MjE0NA==",
lat: 60.23451,
lon: 25.03253
},
{
id: "U3RvcDpIU0w6MTM2MjExOQ==",
lat: 60.233,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTM2MjEzMA==",
lat: 60.23052,
lon: 25.02988
},
{
id: "U3RvcDpIU0w6MTM2MjEyOA==",
lat: 60.22822,
lon: 25.02787
},
{
id: "U3RvcDpIU0w6MTM2MjExNg==",
lat: 60.22564,
lon: 25.02357
},
{
id: "U3RvcDpIU0w6MTM2MjExMg==",
lat: 60.22423,
lon: 25.0203
},
{
id: "U3RvcDpIU0w6MTM2MjEzOA==",
lat: 60.225563,
lon: 25.016455
},
{
id: "U3RvcDpIU0w6MTM2MjE0MA==",
lat: 60.22724,
lon: 25.01184
},
{
id: "U3RvcDpIU0w6MTM2MTEwOA==",
lat: 60.22744,
lon: 25.00263
},
{
id: "U3RvcDpIU0w6MTM2MTEyMA==",
lat: 60.225478,
lon: 24.997258
},
{
id: "U3RvcDpIU0w6MTM2MTEwNg==",
lat: 60.223823,
lon: 24.995055
},
{
id: "U3RvcDpIU0w6MTM2MTEwNA==",
lat: 60.21836,
lon: 24.98539
},
{
id: "U3RvcDpIU0w6MTI3MDEwNQ==",
lat: 60.21611,
lon: 24.98016
},
{
id: "U3RvcDpIU0w6MTI3MDEwMg==",
lat: 60.21252,
lon: 24.97844
},
{
id: "U3RvcDpIU0w6MTIzMDEwMQ==",
lat: 60.210234,
lon: 24.976613
},
{
id: "U3RvcDpIU0w6MTIzMDEwMw==",
lat: 60.20808,
lon: 24.97474
},
{
id: "U3RvcDpIU0w6MTIzMDExNA==",
lat: 60.20593,
lon: 24.97255
},
{
id: "U3RvcDpIU0w6MTIzMDExMg==",
lat: 60.20316,
lon: 24.96657
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExMw==",
lat: 60.17072,
lon: 24.94324
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTIzMDEwOQ==",
lat: 60.20312,
lon: 24.9673
},
{
id: "U3RvcDpIU0w6MTIzMDExMw==",
lat: 60.20548,
lon: 24.97209
},
{
id: "U3RvcDpIU0w6MTIzMDEwNA==",
lat: 60.20827,
lon: 24.97504
},
{
id: "U3RvcDpIU0w6MTIzMDEwMg==",
lat: 60.21121,
lon: 24.97757
},
{
id: "U3RvcDpIU0w6MTI3MDEwMw==",
lat: 60.21316,
lon: 24.97917
},
{
id: "U3RvcDpIU0w6MTI3MDEwNA==",
lat: 60.217158,
lon: 24.981087
},
{
id: "U3RvcDpIU0w6MTM2MTEwMw==",
lat: 60.21896,
lon: 24.98699
},
{
id: "U3RvcDpIU0w6MTM2MTEwNQ==",
lat: 60.22475,
lon: 24.99648
},
{
id: "U3RvcDpIU0w6MTM2MTEwNw==",
lat: 60.22709,
lon: 25.00447
},
{
id: "U3RvcDpIU0w6MTM2MjEzOQ==",
lat: 60.22709,
lon: 25.01242
},
{
id: "U3RvcDpIU0w6MTM2MjEzNw==",
lat: 60.22536,
lon: 25.01653
},
{
id: "U3RvcDpIU0w6MTM2MjExOA==",
lat: 60.22445,
lon: 25.02165
},
{
id: "U3RvcDpIU0w6MTM2MjExNQ==",
lat: 60.22567,
lon: 25.02402
},
{
id: "U3RvcDpIU0w6MTM2MjEyNw==",
lat: 60.22806,
lon: 25.02792
},
{
id: "U3RvcDpIU0w6MTM2MjEyOQ==",
lat: 60.23112,
lon: 25.03053
},
{
id: "U3RvcDpIU0w6MTM2MjEzMw==",
lat: 60.23366,
lon: 25.0309
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mw==",
lat: 60.23446,
lon: 25.03309
},
{
id: "U3RvcDpIU0w6MTM2MjE0NQ==",
lat: 60.23508,
lon: 25.04165
},
{
id: "U3RvcDpIU0w6MTM2MjE0Nw==",
lat: 60.234,
lon: 25.04546
},
{
id: "U3RvcDpIU0w6MTM2MjE0OQ==",
lat: 60.23241,
lon: 25.04725
}
]
},
{
gtfsId: "HSL:9842",
shortName: "842",
longName: "Itäkeskus–Söderkulla–Eriksnäs",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzE4OQ==",
lat: 60.20987,
lon: 25.07621
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MjExOQ==",
lat: 60.215433,
lon: 25.094638
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Nw==",
lat: 60.21833,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MA==",
lat: 60.22011,
lon: 25.10815
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzExOQ==",
lat: 60.23115,
lon: 25.12893
},
{
id: "U3RvcDpIU0w6MTYwMDIwMQ==",
lat: 60.2431,
lon: 25.14191
},
{
id: "U3RvcDpIU0w6MTYwMDIwMw==",
lat: 60.245348,
lon: 25.151417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNQ==",
lat: 60.246743,
lon: 25.155558
},
{
id: "U3RvcDpIU0w6MTYwMDIwNw==",
lat: 60.249545,
lon: 25.164438
},
{
id: "U3RvcDpIU0w6MTYwMDIwOQ==",
lat: 60.251682,
lon: 25.176211
},
{
id: "U3RvcDpIU0w6MTYwMDIxMQ==",
lat: 60.253477,
lon: 25.185895
},
{
id: "U3RvcDpIU0w6MTYwMDIxMw==",
lat: 60.255158,
lon: 25.192102
},
{
id: "U3RvcDpIU0w6MTYwMDIxNQ==",
lat: 60.259785,
lon: 25.211032
},
{
id: "U3RvcDpIU0w6MTYwMDIzMQ==",
lat: 60.260022,
lon: 25.215462
},
{
id: "U3RvcDpIU0w6MTYwMDIxNw==",
lat: 60.260177,
lon: 25.219923
},
{
id: "U3RvcDpIU0w6OTIwNTIwMg==",
lat: 60.261534,
lon: 25.236805
},
{
id: "U3RvcDpIU0w6OTIwNTIwMw==",
lat: 60.261642,
lon: 25.242721
},
{
id: "U3RvcDpIU0w6OTIwNTIxMA==",
lat: 60.262063,
lon: 25.256016
},
{
id: "U3RvcDpIU0w6OTIwNTIxMg==",
lat: 60.262335,
lon: 25.262876
},
{
id: "U3RvcDpIU0w6OTIwNDIwMg==",
lat: 60.26352,
lon: 25.268045
},
{
id: "U3RvcDpIU0w6OTIwNDIwNA==",
lat: 60.26572,
lon: 25.272465
},
{
id: "U3RvcDpIU0w6OTIwNDIwNg==",
lat: 60.26761,
lon: 25.27612
},
{
id: "U3RvcDpIU0w6OTIwNDIwOA==",
lat: 60.270106,
lon: 25.280453
},
{
id: "U3RvcDpIU0w6OTIwNDIxMg==",
lat: 60.275142,
lon: 25.287136
},
{
id: "U3RvcDpIU0w6OTIxMDIwNA==",
lat: 60.280193,
lon: 25.293077
},
{
id: "U3RvcDpIU0w6OTIxMDIwNw==",
lat: 60.285534,
lon: 25.300471
},
{
id: "U3RvcDpIU0w6OTIxMDIxMA==",
lat: 60.290757,
lon: 25.308611
},
{
id: "U3RvcDpIU0w6OTIxMDIxMg==",
lat: 60.292936,
lon: 25.313265
},
{
id: "U3RvcDpIU0w6OTIwODIxMQ==",
lat: 60.297276,
lon: 25.324799
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1Nw==",
lat: 60.298,
lon: 25.339552
},
{
id: "U3RvcDpIU0w6OTIwODI1Mg==",
lat: 60.298743,
lon: 25.346913
},
{
id: "U3RvcDpIU0w6OTIwODI1MA==",
lat: 60.296725,
lon: 25.350455
},
{
id: "U3RvcDpIU0w6OTIwODIzMA==",
lat: 60.29683,
lon: 25.35423
},
{
id: "U3RvcDpIU0w6OTIwODIxOQ==",
lat: 60.286666,
lon: 25.332354
},
{
id: "U3RvcDpIU0w6OTIwODIyMQ==",
lat: 60.283728,
lon: 25.337246
},
{
id: "U3RvcDpIU0w6OTIwODIyNA==",
lat: 60.281193,
lon: 25.339722
},
{
id: "U3RvcDpIU0w6OTIwODI0Mg==",
lat: 60.277488,
lon: 25.343831
},
{
id: "U3RvcDpIU0w6OTIwODIzNw==",
lat: 60.277673,
lon: 25.347028
},
{
id: "U3RvcDpIU0w6OTIwODIzOA==",
lat: 60.280615,
lon: 25.3499
},
{
id: "U3RvcDpIU0w6OTIwODIzOQ==",
lat: 60.2809,
lon: 25.342967
},
{
id: "U3RvcDpIU0w6OTIwODIyMg==",
lat: 60.281302,
lon: 25.339902
},
{
id: "U3RvcDpIU0w6OTIwODIyMA==",
lat: 60.283958,
lon: 25.337303
},
{
id: "U3RvcDpIU0w6OTIwODI0Mw==",
lat: 60.286745,
lon: 25.332647
},
{
id: "U3RvcDpIU0w6OTIwODIzMQ==",
lat: 60.297247,
lon: 25.354823
},
{
id: "U3RvcDpIU0w6OTIwODI1Mw==",
lat: 60.298852,
lon: 25.346872
},
{
id: "U3RvcDpIU0w6OTIwODI1Ng==",
lat: 60.298387,
lon: 25.337094
},
{
id: "U3RvcDpIU0w6OTIwODIxNA==",
lat: 60.298227,
lon: 25.329072
},
{
id: "U3RvcDpIU0w6OTIwODIxMA==",
lat: 60.297008,
lon: 25.322927
},
{
id: "U3RvcDpIU0w6OTIxMDIxMQ==",
lat: 60.292553,
lon: 25.311915
},
{
id: "U3RvcDpIU0w6OTIxMDIwOQ==",
lat: 60.290293,
lon: 25.307124
},
{
id: "U3RvcDpIU0w6OTIxMDIwOA==",
lat: 60.287115,
lon: 25.301985
},
{
id: "U3RvcDpIU0w6OTIxMDIwNg==",
lat: 60.284302,
lon: 25.298328
},
{
id: "U3RvcDpIU0w6OTIxMDIwMw==",
lat: 60.279217,
lon: 25.291527
},
{
id: "U3RvcDpIU0w6OTIwNDIwMQ==",
lat: 60.274445,
lon: 25.28587
},
{
id: "U3RvcDpIU0w6OTIwNDIwNw==",
lat: 60.269742,
lon: 25.279478
},
{
id: "U3RvcDpIU0w6OTIwNDIwNQ==",
lat: 60.26741,
lon: 25.275163
},
{
id: "U3RvcDpIU0w6OTIwNDIwMw==",
lat: 60.26462,
lon: 25.269811
},
{
id: "U3RvcDpIU0w6OTIwNTIxMQ==",
lat: 60.262375,
lon: 25.259562
},
{
id: "U3RvcDpIU0w6OTIwNTIwOQ==",
lat: 60.262158,
lon: 25.25394
},
{
id: "U3RvcDpIU0w6OTIwNTIwNA==",
lat: 60.26176,
lon: 25.240666
},
{
id: "U3RvcDpIU0w6OTIwNTIwMQ==",
lat: 60.261618,
lon: 25.232817
},
{
id: "U3RvcDpIU0w6MTYwMDIxOA==",
lat: 60.260228,
lon: 25.218075
},
{
id: "U3RvcDpIU0w6MTYwMDIxNg==",
lat: 60.25977,
lon: 25.208407
},
{
id: "U3RvcDpIU0w6MTYwMDIxNA==",
lat: 60.25475,
lon: 25.190433
},
{
id: "U3RvcDpIU0w6MTYwMDIxMg==",
lat: 60.253138,
lon: 25.183522
},
{
id: "U3RvcDpIU0w6MTYwMDIxMA==",
lat: 60.2514,
lon: 25.173983
},
{
id: "U3RvcDpIU0w6MTYwMDIwOA==",
lat: 60.249428,
lon: 25.163417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNg==",
lat: 60.24737,
lon: 25.156468
},
{
id: "U3RvcDpIU0w6MTYwMDIwNA==",
lat: 60.245817,
lon: 25.152437
},
{
id: "U3RvcDpIU0w6MTYwMDIwMg==",
lat: 60.24422,
lon: 25.142975
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMA==",
lat: 60.23124,
lon: 25.12868
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MQ==",
lat: 60.22017,
lon: 25.10757
},
{
id: "U3RvcDpIU0w6MTQ1MTE4OA==",
lat: 60.21806,
lon: 25.10282
},
{
id: "U3RvcDpIU0w6MTQ1MzEzNA==",
lat: 60.21477,
lon: 25.09232
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
}
]
},
{
gtfsId: "HSL:2143A",
shortName: "143A",
longName: "Kamppi-Soukka",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQxMjIzOA==",
lat: 60.13528,
lon: 24.67033
},
{
id: "U3RvcDpIU0w6MjQxMjIzNg==",
lat: 60.13606,
lon: 24.67287
},
{
id: "U3RvcDpIU0w6MjQxMjIzNA==",
lat: 60.13805,
lon: 24.67337
},
{
id: "U3RvcDpIU0w6MjQxMjIzMg==",
lat: 60.14018,
lon: 24.6725
},
{
id: "U3RvcDpIU0w6MjQxMjIzMA==",
lat: 60.141527,
lon: 24.671379
},
{
id: "U3RvcDpIU0w6MjQxMjIyNw==",
lat: 60.143373,
lon: 24.673594
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNQ==",
lat: 60.14522,
lon: 24.67967
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMw==",
lat: 60.14759,
lon: 24.68258
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMQ==",
lat: 60.151014,
lon: 24.692223
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNw==",
lat: 60.153542,
lon: 24.698029
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNQ==",
lat: 60.157168,
lon: 24.704114
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMg==",
lat: 60.159978,
lon: 24.708063
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
},
{
id: "U3RvcDpIU0w6MTA0MDI4MA==",
lat: 60.1689,
lon: 24.93128
},
{
id: "U3RvcDpIU0w6MTA0MDIzMQ==",
lat: 60.16622,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNA==",
lat: 60.16976,
lon: 24.8242
},
{
id: "U3RvcDpIU0w6MjIxMTI5MA==",
lat: 60.17025,
lon: 24.81115
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQ0MjIwOA==",
lat: 60.158034,
lon: 24.705641
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNA==",
lat: 60.157017,
lon: 24.703535
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNg==",
lat: 60.153001,
lon: 24.696816
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMA==",
lat: 60.15,
lon: 24.68924
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMg==",
lat: 60.14756,
lon: 24.68237
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNA==",
lat: 60.14542,
lon: 24.67975
},
{
id: "U3RvcDpIU0w6MjQxMjIyOA==",
lat: 60.143279,
lon: 24.672656
},
{
id: "U3RvcDpIU0w6MjQxMjIyOQ==",
lat: 60.141393,
lon: 24.67125
},
{
id: "U3RvcDpIU0w6MjQxMjIzMQ==",
lat: 60.13993,
lon: 24.67253
},
{
id: "U3RvcDpIU0w6MjQxMjIzMw==",
lat: 60.13789,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjQxMjIzNQ==",
lat: 60.13617,
lon: 24.67272
}
]
},
{
gtfsId: "HSL:4588B",
shortName: "588B",
longName: "Länsisalmi-Sotungin koulu",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDkwMDIwMw==",
lat: 60.25638,
lon: 25.14215
},
{
id: "U3RvcDpIU0w6NDkwMDIwMg==",
lat: 60.25511,
lon: 25.12982
},
{
id: "U3RvcDpIU0w6NDkzMDIzMQ==",
lat: 60.26263,
lon: 25.116406
},
{
id: "U3RvcDpIU0w6NDkzMDIxMw==",
lat: 60.25612,
lon: 25.11173
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIwMg==",
lat: 60.2434,
lon: 25.10626
},
{
id: "U3RvcDpIU0w6NDk1MDIxMA==",
lat: 60.24712,
lon: 25.10024
},
{
id: "U3RvcDpIU0w6NDk1MDIwNg==",
lat: 60.24998,
lon: 25.09979
},
{
id: "U3RvcDpIU0w6NDk1MDIwNA==",
lat: 60.250182,
lon: 25.093707
},
{
id: "U3RvcDpIU0w6NDk1MDIwMg==",
lat: 60.25108,
lon: 25.08727
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyOA==",
lat: 60.2815,
lon: 25.12098
},
{
id: "U3RvcDpIU0w6NDk0MDIwMg==",
lat: 60.2793,
lon: 25.12528
},
{
id: "U3RvcDpIU0w6NDk0MDIwMQ==",
lat: 60.27995,
lon: 25.12467
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6NDk1MDIwMQ==",
lat: 60.25091,
lon: 25.08784
},
{
id: "U3RvcDpIU0w6NDk1MDIwNQ==",
lat: 60.249921,
lon: 25.096143
},
{
id: "U3RvcDpIU0w6NDk1MDIwNw==",
lat: 60.24916,
lon: 25.10035
},
{
id: "U3RvcDpIU0w6NDk1MDIwOQ==",
lat: 60.24565,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDkxMDIwMQ==",
lat: 60.24324,
lon: 25.10666
},
{
id: "U3RvcDpIU0w6NDkxMDIxNQ==",
lat: 60.24494,
lon: 25.11149
},
{
id: "U3RvcDpIU0w6NDkxMDIwMw==",
lat: 60.24755,
lon: 25.11225
},
{
id: "U3RvcDpIU0w6NDkxMDIwNQ==",
lat: 60.251929,
lon: 25.112495
},
{
id: "U3RvcDpIU0w6NDkzMDIxMg==",
lat: 60.25641,
lon: 25.112
},
{
id: "U3RvcDpIU0w6NDkzMDIzMg==",
lat: 60.257703,
lon: 25.111718
},
{
id: "U3RvcDpIU0w6NDkzMDIzNA==",
lat: 60.261951,
lon: 25.116112
},
{
id: "U3RvcDpIU0w6NDkwMDIwMQ==",
lat: 60.2549,
lon: 25.13128
}
]
},
{
gtfsId: "HSL:4443K",
shortName: "443K",
longName: "Kivistö-Luhtaanmäki-Vestra",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDMwMDIwNQ==",
lat: 60.32931,
lon: 24.75779
},
{
id: "U3RvcDpIU0w6NDMwMDIwNA==",
lat: 60.32861,
lon: 24.76323
},
{
id: "U3RvcDpIU0w6NDMwMDIwMg==",
lat: 60.32879,
lon: 24.76864
},
{
id: "U3RvcDpIU0w6NDMwMDIwNg==",
lat: 60.33047,
lon: 24.77127
},
{
id: "U3RvcDpIU0w6NDIyMDIxOA==",
lat: 60.33406,
lon: 24.78329
},
{
id: "U3RvcDpIU0w6NDIyMDIxNg==",
lat: 60.33661,
lon: 24.79028
},
{
id: "U3RvcDpIU0w6NDIyMDIwNg==",
lat: 60.3375,
lon: 24.79426
},
{
id: "U3RvcDpIU0w6NDIyMDIxNA==",
lat: 60.33857,
lon: 24.79951
},
{
id: "U3RvcDpIU0w6NDIyMDIxMg==",
lat: 60.33916,
lon: 24.80776
},
{
id: "U3RvcDpIU0w6NDIyMDIyOA==",
lat: 60.339205,
lon: 24.810437
},
{
id: "U3RvcDpIU0w6NDIyMDIzMg==",
lat: 60.33963,
lon: 24.81417
},
{
id: "U3RvcDpIU0w6NDIyMDIzNA==",
lat: 60.34214,
lon: 24.80853
},
{
id: "U3RvcDpIU0w6NDMxMDIwMQ==",
lat: 60.34533,
lon: 24.80527
},
{
id: "U3RvcDpIU0w6NDMxMDIwMw==",
lat: 60.35002,
lon: 24.79507
},
{
id: "U3RvcDpIU0w6NDMxMDIwNg==",
lat: 60.35625,
lon: 24.79544
},
{
id: "U3RvcDpIU0w6NDMxMDIxNQ==",
lat: 60.35648,
lon: 24.79697
},
{
id: "U3RvcDpIU0w6NDMxMDIxNw==",
lat: 60.35337,
lon: 24.8067
},
{
id: "U3RvcDpIU0w6NDMxMDIwNw==",
lat: 60.34856,
lon: 24.80956
},
{
id: "U3RvcDpIU0w6NDIyMDIwNQ==",
lat: 60.33948,
lon: 24.81517
},
{
id: "U3RvcDpIU0w6NDIzMDIyMA==",
lat: 60.33859,
lon: 24.81824
},
{
id: "U3RvcDpIU0w6NDIzMDIxOA==",
lat: 60.3383,
lon: 24.82432
},
{
id: "U3RvcDpIU0w6NDIzMDIxNg==",
lat: 60.33486,
lon: 24.83359
},
{
id: "U3RvcDpIU0w6NDIzMDIxNA==",
lat: 60.32898,
lon: 24.83558
},
{
id: "U3RvcDpIU0w6NDIzMDIxMg==",
lat: 60.32579,
lon: 24.83767
},
{
id: "U3RvcDpIU0w6NDIzMDIwOQ==",
lat: 60.32227,
lon: 24.8409
},
{
id: "U3RvcDpIU0w6NDIzMDIwNw==",
lat: 60.3205,
lon: 24.84192
},
{
id: "U3RvcDpIU0w6NDIzMDIwNQ==",
lat: 60.31832,
lon: 24.84409
},
{
id: "U3RvcDpIU0w6NDIzMDIwMw==",
lat: 60.316588,
lon: 24.847408
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0Nw==",
lat: 60.314485,
lon: 24.845366
},
{
id: "U3RvcDpIU0w6NDIzMDIwMg==",
lat: 60.317449,
lon: 24.846159
},
{
id: "U3RvcDpIU0w6NDIzMDIwNA==",
lat: 60.3189,
lon: 24.84368
},
{
id: "U3RvcDpIU0w6NDIzMDIwNg==",
lat: 60.32009,
lon: 24.84231
},
{
id: "U3RvcDpIU0w6NDIzMDIwOA==",
lat: 60.32314,
lon: 24.84034
},
{
id: "U3RvcDpIU0w6NDIzMDIxMQ==",
lat: 60.32644,
lon: 24.83694
},
{
id: "U3RvcDpIU0w6NDIzMDIxMw==",
lat: 60.32981,
lon: 24.83501
},
{
id: "U3RvcDpIU0w6NDIzMDIxNQ==",
lat: 60.33459,
lon: 24.83423
},
{
id: "U3RvcDpIU0w6NDIzMDIxNw==",
lat: 60.33822,
lon: 24.82468
},
{
id: "U3RvcDpIU0w6NDIzMDIxOQ==",
lat: 60.33903,
lon: 24.81895
},
{
id: "U3RvcDpIU0w6NDIyMDIwNA==",
lat: 60.33848,
lon: 24.81626
},
{
id: "U3RvcDpIU0w6NDMxMDIwOA==",
lat: 60.34986,
lon: 24.80924
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIwNQ==",
lat: 60.35574,
lon: 24.79479
},
{
id: "U3RvcDpIU0w6NDMxMDIwNA==",
lat: 60.34956,
lon: 24.79552
},
{
id: "U3RvcDpIU0w6NDMxMDIwMg==",
lat: 60.34493,
lon: 24.8056
},
{
id: "U3RvcDpIU0w6NDIyMDIzNQ==",
lat: 60.34163,
lon: 24.80917
},
{
id: "U3RvcDpIU0w6NDIyMDIzMw==",
lat: 60.33968,
lon: 24.814
},
{
id: "U3RvcDpIU0w6NDIyMDIyOQ==",
lat: 60.339276,
lon: 24.810279
},
{
id: "U3RvcDpIU0w6NDIyMDIxMw==",
lat: 60.3392,
lon: 24.80562
},
{
id: "U3RvcDpIU0w6NDIyMDIxNQ==",
lat: 60.33872,
lon: 24.79995
},
{
id: "U3RvcDpIU0w6NDIyMDIwMw==",
lat: 60.33745,
lon: 24.79421
},
{
id: "U3RvcDpIU0w6NDIyMDIxNw==",
lat: 60.336625,
lon: 24.789737
},
{
id: "U3RvcDpIU0w6NDIyMDIxOQ==",
lat: 60.33418,
lon: 24.78336
},
{
id: "U3RvcDpIU0w6NDMwMDIwNw==",
lat: 60.33041,
lon: 24.77099
},
{
id: "U3RvcDpIU0w6NDMwMDIwMQ==",
lat: 60.32861,
lon: 24.76833
},
{
id: "U3RvcDpIU0w6NDMwMDIwMw==",
lat: 60.32868,
lon: 24.76315
}
]
},
{
gtfsId: "HSL:2236B",
shortName: "236B",
longName: "Leppävaara-Viherlaakso-Nepperi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcxMzIyMA==",
lat: 60.25359,
lon: 24.73518
},
{
id: "U3RvcDpIU0w6MjcxMzIwNg==",
lat: 60.25333,
lon: 24.73323
},
{
id: "U3RvcDpIU0w6MjcxMzIwNA==",
lat: 60.25327,
lon: 24.72461
},
{
id: "U3RvcDpIU0w6MjcxMzIwMg==",
lat: 60.25185,
lon: 24.7206
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNA==",
lat: 60.23995,
lon: 24.74098
},
{
id: "U3RvcDpIU0w6MjE1MTIyMg==",
lat: 60.23515,
lon: 24.74405
},
{
id: "U3RvcDpIU0w6MjE1MTIxMg==",
lat: 60.2317,
lon: 24.74328
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIwOA==",
lat: 60.22675,
lon: 24.74088
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMjIwOA==",
lat: 60.225528,
lon: 24.760625
},
{
id: "U3RvcDpIU0w6MjEzMjIwNg==",
lat: 60.225743,
lon: 24.766743
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIxMQ==",
lat: 60.22155,
lon: 24.80653
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIyNw==",
lat: 60.21927,
lon: 24.8107
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwMw==",
lat: 60.22572,
lon: 24.77758
},
{
id: "U3RvcDpIU0w6MjEzMjIwNQ==",
lat: 60.22578,
lon: 24.76438
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwNw==",
lat: 60.22686,
lon: 24.74108
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMQ==",
lat: 60.2317,
lon: 24.74358
},
{
id: "U3RvcDpIU0w6MjE0MTIwMQ==",
lat: 60.23675,
lon: 24.74327
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjcxMzIwMQ==",
lat: 60.25237,
lon: 24.72199
},
{
id: "U3RvcDpIU0w6MjcxMzIwMw==",
lat: 60.25325,
lon: 24.72546
},
{
id: "U3RvcDpIU0w6MjcxMzIwNQ==",
lat: 60.25329,
lon: 24.73325
}
]
},
{
gtfsId: "HSL:2166",
shortName: "166",
longName: "Vanttila-Kauklahti-Lasilaakso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjUyMjIyOQ==",
lat: 60.190011,
lon: 24.621951
},
{
id: "U3RvcDpIU0w6MjUyMjIxOQ==",
lat: 60.189676,
lon: 24.618773
},
{
id: "U3RvcDpIU0w6MjUyMjIzMQ==",
lat: 60.189512,
lon: 24.611614
},
{
id: "U3RvcDpIU0w6MjUyMjIyMw==",
lat: 60.19036,
lon: 24.60782
},
{
id: "U3RvcDpIU0w6MjUxMTIzNQ==",
lat: 60.190312,
lon: 24.601027
},
{
id: "U3RvcDpIU0w6MjUxMTIzNw==",
lat: 60.18797,
lon: 24.59555
},
{
id: "U3RvcDpIU0w6MjUxMTIzMw==",
lat: 60.18683,
lon: 24.59231
},
{
id: "U3RvcDpIU0w6MjUxMTIzOQ==",
lat: 60.186662,
lon: 24.588232
},
{
id: "U3RvcDpIU0w6MjUxMTI1Nw==",
lat: 60.18826,
lon: 24.586646
},
{
id: "U3RvcDpIU0w6MjUyMjIxMQ==",
lat: 60.18732,
lon: 24.58529
},
{
id: "U3RvcDpIU0w6MjUyMTIxMQ==",
lat: 60.183653,
lon: 24.585646
},
{
id: "U3RvcDpIU0w6MjUyMTIxNQ==",
lat: 60.184072,
lon: 24.580459
},
{
id: "U3RvcDpIU0w6MjUyMTIwOA==",
lat: 60.18413,
lon: 24.58758
},
{
id: "U3RvcDpIU0w6MjUxMTI0MA==",
lat: 60.186314,
lon: 24.589023
},
{
id: "U3RvcDpIU0w6MjUxMTIzNA==",
lat: 60.186698,
lon: 24.592018
},
{
id: "U3RvcDpIU0w6MjUxMTIzOA==",
lat: 60.18847,
lon: 24.59719
},
{
id: "U3RvcDpIU0w6MjUxMTIzNg==",
lat: 60.190499,
lon: 24.601866
},
{
id: "U3RvcDpIU0w6MjUyMjIyMg==",
lat: 60.190149,
lon: 24.60779
},
{
id: "U3RvcDpIU0w6MjUyMjIxNQ==",
lat: 60.18687,
lon: 24.61042
},
{
id: "U3RvcDpIU0w6MjUyMjIwMg==",
lat: 60.185103,
lon: 24.612888
},
{
id: "U3RvcDpIU0w6MjUyMjIyNA==",
lat: 60.18613,
lon: 24.62001
},
{
id: "U3RvcDpIU0w6MjUyMjIyNg==",
lat: 60.18774,
lon: 24.62287
}
]
},
{
gtfsId: "HSL:1077",
shortName: "77",
longName: "Rautatientori-Tattarisuo-Jakomäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQxNDE0OQ==",
lat: 60.26448,
lon: 25.08393
},
{
id: "U3RvcDpIU0w6MTQxNDE1Ng==",
lat: 60.2608,
lon: 25.086
},
{
id: "U3RvcDpIU0w6MTQxNDE1Mw==",
lat: 60.26209,
lon: 25.07929
},
{
id: "U3RvcDpIU0w6MTQxMzExNw==",
lat: 60.26264,
lon: 25.06834
},
{
id: "U3RvcDpIU0w6MTQxMzExNQ==",
lat: 60.25822,
lon: 25.06413
},
{
id: "U3RvcDpIU0w6MTQxMzExOA==",
lat: 60.255113,
lon: 25.063618
},
{
id: "U3RvcDpIU0w6MTQxMzExMw==",
lat: 60.25228,
lon: 25.06229
},
{
id: "U3RvcDpIU0w6MTM4NTE2Mg==",
lat: 60.24766,
lon: 25.05573
},
{
id: "U3RvcDpIU0w6MTM4NTE1Mg==",
lat: 60.24613,
lon: 25.04853
},
{
id: "U3RvcDpIU0w6MTM4NTE1MA==",
lat: 60.24536,
lon: 25.04458
},
{
id: "U3RvcDpIU0w6MTM4NTE0OA==",
lat: 60.2444,
lon: 25.04001
},
{
id: "U3RvcDpIU0w6MTM4MjE0OA==",
lat: 60.24396,
lon: 25.0344
},
{
id: "U3RvcDpIU0w6MTM4MjE0Ng==",
lat: 60.2426,
lon: 25.02771
},
{
id: "U3RvcDpIU0w6MTM4MjE0NA==",
lat: 60.24263,
lon: 25.01998
},
{
id: "U3RvcDpIU0w6MTM4MzExNA==",
lat: 60.23859,
lon: 25.02095
},
{
id: "U3RvcDpIU0w6MTM4MzExMg==",
lat: 60.23595,
lon: 25.02177
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM2MzEwMQ==",
lat: 60.229313,
lon: 25.010037
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExOA==",
lat: 60.17164,
lon: 24.94276
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjEwNQ==",
lat: 60.22862,
lon: 25.01202
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEwOQ==",
lat: 60.232187,
lon: 25.011714
},
{
id: "U3RvcDpIU0w6MTM4MzExMQ==",
lat: 60.23676,
lon: 25.02225
},
{
id: "U3RvcDpIU0w6MTM4MjExMw==",
lat: 60.240179,
lon: 25.021039
},
{
id: "U3RvcDpIU0w6MTM4MjE0Mw==",
lat: 60.24253,
lon: 25.02026
},
{
id: "U3RvcDpIU0w6MTM4MjE0NQ==",
lat: 60.24243,
lon: 25.02813
},
{
id: "U3RvcDpIU0w6MTM4MjE0Nw==",
lat: 60.24359,
lon: 25.03355
},
{
id: "U3RvcDpIU0w6MTM4NDE0Nw==",
lat: 60.24429,
lon: 25.04056
},
{
id: "U3RvcDpIU0w6MTM4NDE0OQ==",
lat: 60.24534,
lon: 25.04537
},
{
id: "U3RvcDpIU0w6MTM4NDE1MQ==",
lat: 60.24642,
lon: 25.05051
},
{
id: "U3RvcDpIU0w6MTM4NDE2MQ==",
lat: 60.24761,
lon: 25.05617
},
{
id: "U3RvcDpIU0w6MTQxMzExMg==",
lat: 60.25305,
lon: 25.06321
},
{
id: "U3RvcDpIU0w6MTQxMzExOQ==",
lat: 60.256148,
lon: 25.06408
},
{
id: "U3RvcDpIU0w6MTQxMzExNA==",
lat: 60.25933,
lon: 25.06483
},
{
id: "U3RvcDpIU0w6MTQxMzExNg==",
lat: 60.26241,
lon: 25.06838
},
{
id: "U3RvcDpIU0w6MTQxMzE1OA==",
lat: 60.26291,
lon: 25.07017
},
{
id: "U3RvcDpIU0w6MTQxNDE1Mg==",
lat: 60.2619,
lon: 25.08012
},
{
id: "U3RvcDpIU0w6MTQxNDE1NQ==",
lat: 60.26099,
lon: 25.08622
}
]
},
{
gtfsId: "HSL:2165",
shortName: "165",
longName: "Matinkylä(M)-Kivenlahti-Saunalahti-Kauklahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxOA==",
lat: 60.160188,
lon: 24.738571
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIwMQ==",
lat: 60.15214,
lon: 24.66269
},
{
id: "U3RvcDpIU0w6MjQxMTIwMw==",
lat: 60.15338,
lon: 24.65167
},
{
id: "U3RvcDpIU0w6MjQxMzIwNQ==",
lat: 60.1548,
lon: 24.6459
},
{
id: "U3RvcDpIU0w6MjQxMzIxOA==",
lat: 60.153422,
lon: 24.636179
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOA==",
lat: 60.15638,
lon: 24.63086
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6MjQyMzIxOQ==",
lat: 60.15906,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQyMzIxNQ==",
lat: 60.16269,
lon: 24.61315
},
{
id: "U3RvcDpIU0w6MjQyMzIxMA==",
lat: 60.165995,
lon: 24.615303
},
{
id: "U3RvcDpIU0w6MjQyMzIwNQ==",
lat: 60.16774,
lon: 24.61602
},
{
id: "U3RvcDpIU0w6MjQyMzIyOA==",
lat: 60.17014,
lon: 24.61163
},
{
id: "U3RvcDpIU0w6MjQyMzIyMQ==",
lat: 60.172893,
lon: 24.608527
},
{
id: "U3RvcDpIU0w6MjUyMTIwMQ==",
lat: 60.17543,
lon: 24.60438
},
{
id: "U3RvcDpIU0w6MjUyMTIwMw==",
lat: 60.17883,
lon: 24.60186
},
{
id: "U3RvcDpIU0w6MjUyMTIxMw==",
lat: 60.182412,
lon: 24.598789
},
{
id: "U3RvcDpIU0w6MjUyMTIxMA==",
lat: 60.18405,
lon: 24.60043
},
{
id: "U3RvcDpIU0w6MjUyMjIxNw==",
lat: 60.18349,
lon: 24.61368
},
{
id: "U3RvcDpIU0w6MjUyMjIwMw==",
lat: 60.18505,
lon: 24.61309
},
{
id: "U3RvcDpIU0w6MjUyMjIxNg==",
lat: 60.18689,
lon: 24.61047
},
{
id: "U3RvcDpIU0w6MjUyMjIyMw==",
lat: 60.19036,
lon: 24.60782
},
{
id: "U3RvcDpIU0w6MjUxMTIzNQ==",
lat: 60.190312,
lon: 24.601027
},
{
id: "U3RvcDpIU0w6MjUxMTIzNw==",
lat: 60.18797,
lon: 24.59555
},
{
id: "U3RvcDpIU0w6MjUxMTIzMw==",
lat: 60.18683,
lon: 24.59231
},
{
id: "U3RvcDpIU0w6MjUxMTIzOQ==",
lat: 60.186662,
lon: 24.588232
},
{
id: "U3RvcDpIU0w6MjUxMTI1Nw==",
lat: 60.18826,
lon: 24.586646
},
{
id: "U3RvcDpIU0w6MjUxMTI1Mw==",
lat: 60.191797,
lon: 24.591574
},
{
id: "U3RvcDpIU0w6MjUxMTI1Mg==",
lat: 60.192879,
lon: 24.592886
},
{
id: "U3RvcDpIU0w6MjUxMTI1MQ==",
lat: 60.194122,
lon: 24.59296
},
{
id: "U3RvcDpIU0w6MjUxMTI1NA==",
lat: 60.191759,
lon: 24.591303
},
{
id: "U3RvcDpIU0w6MjUxMTI0MA==",
lat: 60.186314,
lon: 24.589023
},
{
id: "U3RvcDpIU0w6MjUxMTIzNA==",
lat: 60.186698,
lon: 24.592018
},
{
id: "U3RvcDpIU0w6MjUxMTIzOA==",
lat: 60.18847,
lon: 24.59719
},
{
id: "U3RvcDpIU0w6MjUxMTIzNg==",
lat: 60.190499,
lon: 24.601866
},
{
id: "U3RvcDpIU0w6MjUyMjIyMg==",
lat: 60.190149,
lon: 24.60779
},
{
id: "U3RvcDpIU0w6MjUyMjIxNQ==",
lat: 60.18687,
lon: 24.61042
},
{
id: "U3RvcDpIU0w6MjUyMjIwMg==",
lat: 60.185103,
lon: 24.612888
},
{
id: "U3RvcDpIU0w6MjUyMjIzMA==",
lat: 60.18218,
lon: 24.61256
},
{
id: "U3RvcDpIU0w6MjUyMjIxOA==",
lat: 60.18439,
lon: 24.59837
},
{
id: "U3RvcDpIU0w6MjUyMTIxNA==",
lat: 60.182244,
lon: 24.598781
},
{
id: "U3RvcDpIU0w6MjUyMTIwNA==",
lat: 60.17816,
lon: 24.60216
},
{
id: "U3RvcDpIU0w6MjUyMTIwMg==",
lat: 60.17436,
lon: 24.60497
},
{
id: "U3RvcDpIU0w6MjUyMTIxNg==",
lat: 60.172937,
lon: 24.60848
},
{
id: "U3RvcDpIU0w6MjQyMzIwNw==",
lat: 60.169835,
lon: 24.612191
},
{
id: "U3RvcDpIU0w6MjQyMzIxMw==",
lat: 60.16746,
lon: 24.616208
},
{
id: "U3RvcDpIU0w6MjQyMzIxMQ==",
lat: 60.165647,
lon: 24.61464
},
{
id: "U3RvcDpIU0w6MjQyMzIxNA==",
lat: 60.16214,
lon: 24.61326
},
{
id: "U3RvcDpIU0w6MjQyMzIyMA==",
lat: 60.15901,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxMQ==",
lat: 60.15326,
lon: 24.63371
},
{
id: "U3RvcDpIU0w6MjQxMzIxNw==",
lat: 60.15308,
lon: 24.635611
},
{
id: "U3RvcDpIU0w6MjQxMzIwNg==",
lat: 60.15445,
lon: 24.64661
},
{
id: "U3RvcDpIU0w6MjQxMTIwNA==",
lat: 60.15267,
lon: 24.65583
},
{
id: "U3RvcDpIU0w6MjQxMTIwMg==",
lat: 60.152095,
lon: 24.663769
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:1075",
shortName: "75",
longName: "Rautatientori-Jakomäki-Puistolan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6MTQxNDE0NA==",
lat: 60.25401,
lon: 25.07816
},
{
id: "U3RvcDpIU0w6MTQxNDE0Mg==",
lat: 60.2538,
lon: 25.07331
},
{
id: "U3RvcDpIU0w6MTQxNDE0MA==",
lat: 60.25535,
lon: 25.06984
},
{
id: "U3RvcDpIU0w6MTQxNDEzOA==",
lat: 60.25918,
lon: 25.07194
},
{
id: "U3RvcDpIU0w6MTQxNDEzNg==",
lat: 60.261686,
lon: 25.075141
},
{
id: "U3RvcDpIU0w6MTQxMjEzMA==",
lat: 60.26363,
lon: 25.06959
},
{
id: "U3RvcDpIU0w6MTQxMjEzMg==",
lat: 60.26757,
lon: 25.0718
},
{
id: "U3RvcDpIU0w6MTQxMjEzNA==",
lat: 60.27016,
lon: 25.07203
},
{
id: "U3RvcDpIU0w6MTQxMTExOQ==",
lat: 60.26989,
lon: 25.06314
},
{
id: "U3RvcDpIU0w6MTQxMTEyMg==",
lat: 60.26998,
lon: 25.0564
},
{
id: "U3RvcDpIU0w6MTQxMTEyNA==",
lat: 60.27112,
lon: 25.05116
},
{
id: "U3RvcDpIU0w6MTQxMTEwOQ==",
lat: 60.27147,
lon: 25.0461
},
{
id: "U3RvcDpIU0w6MTQxMTEwMQ==",
lat: 60.2738,
lon: 25.04459
},
{
id: "U3RvcDpIU0w6MTQxMTEzMA==",
lat: 60.27665,
lon: 25.03995
},
{
id: "U3RvcDpIU0w6MTQwMjE1MA==",
lat: 60.27665,
lon: 25.03432
},
{
id: "U3RvcDpIU0w6MTQwMjEzMg==",
lat: 60.275477,
lon: 25.034827
},
{
id: "U3RvcDpIU0w6MTQwMjEyNQ==",
lat: 60.27528,
lon: 25.0353
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mg==",
lat: 60.27697,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6MTQxMTEzMQ==",
lat: 60.27618,
lon: 25.04124
},
{
id: "U3RvcDpIU0w6MTQxMTEyOA==",
lat: 60.27443,
lon: 25.0443
},
{
id: "U3RvcDpIU0w6MTQxMTExMA==",
lat: 60.27135,
lon: 25.04662
},
{
id: "U3RvcDpIU0w6MTQxMTEyNQ==",
lat: 60.27072,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQxMTEyMw==",
lat: 60.2701,
lon: 25.05879
},
{
id: "U3RvcDpIU0w6MTQxMjEyMA==",
lat: 60.26962,
lon: 25.06454
},
{
id: "U3RvcDpIU0w6MTQxMjExOA==",
lat: 60.26959,
lon: 25.07277
},
{
id: "U3RvcDpIU0w6MTQxMjEzMw==",
lat: 60.26665,
lon: 25.07134
},
{
id: "U3RvcDpIU0w6MTQxMzE1OA==",
lat: 60.26291,
lon: 25.07017
},
{
id: "U3RvcDpIU0w6MTQxNDEzNQ==",
lat: 60.261811,
lon: 25.075388
},
{
id: "U3RvcDpIU0w6MTQxNDEzNw==",
lat: 60.259321,
lon: 25.071821
},
{
id: "U3RvcDpIU0w6MTQxNDEzOQ==",
lat: 60.25497,
lon: 25.06971
},
{
id: "U3RvcDpIU0w6MTQxNDE0MQ==",
lat: 60.25368,
lon: 25.07349
},
{
id: "U3RvcDpIU0w6MTQxNDE0Mw==",
lat: 60.2539,
lon: 25.07806
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:1074",
shortName: "74",
longName: "Hakaniemi-Malmi-Tapanila-Puistola-Heikinlaakso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTExMTE1MQ==",
lat: 60.17913,
lon: 24.952221
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjEwNQ==",
lat: 60.22862,
lon: 25.01202
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEwOQ==",
lat: 60.232187,
lon: 25.011714
},
{
id: "U3RvcDpIU0w6MTM4MzExMQ==",
lat: 60.23676,
lon: 25.02225
},
{
id: "U3RvcDpIU0w6MTM4MjExMw==",
lat: 60.240179,
lon: 25.021039
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MTEwMQ==",
lat: 60.25004,
lon: 25.00946
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTE1Mw==",
lat: 60.25366,
lon: 25.00895
},
{
id: "U3RvcDpIU0w6MTM4MTE1NQ==",
lat: 60.2556,
lon: 25.01035
},
{
id: "U3RvcDpIU0w6MTM5MjE1Nw==",
lat: 60.25743,
lon: 25.0132
},
{
id: "U3RvcDpIU0w6MTM5MjE4OA==",
lat: 60.259736,
lon: 25.012365
},
{
id: "U3RvcDpIU0w6MTM5MjE0Mw==",
lat: 60.26215,
lon: 25.01222
},
{
id: "U3RvcDpIU0w6MTM5MjE0Ng==",
lat: 60.2608,
lon: 25.01763
},
{
id: "U3RvcDpIU0w6MTM5MjE0OA==",
lat: 60.26028,
lon: 25.02155
},
{
id: "U3RvcDpIU0w6MTM5MjE1MA==",
lat: 60.26313,
lon: 25.027
},
{
id: "U3RvcDpIU0w6MTM5MjEzOA==",
lat: 60.26512,
lon: 25.02579
},
{
id: "U3RvcDpIU0w6MTQwMjE4Mg==",
lat: 60.26934,
lon: 25.02538
},
{
id: "U3RvcDpIU0w6MTM5MjE4MA==",
lat: 60.26817,
lon: 25.02945
},
{
id: "U3RvcDpIU0w6MTQxMTE3NA==",
lat: 60.2688,
lon: 25.03293
},
{
id: "U3RvcDpIU0w6MTQwMjE1Ng==",
lat: 60.2721,
lon: 25.03447
},
{
id: "U3RvcDpIU0w6MTQwMjE1NA==",
lat: 60.27495,
lon: 25.03572
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mg==",
lat: 60.27697,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6MTQxMTEzMQ==",
lat: 60.27618,
lon: 25.04124
},
{
id: "U3RvcDpIU0w6MTQxMTEyOA==",
lat: 60.27443,
lon: 25.0443
},
{
id: "U3RvcDpIU0w6MTQxMTExMA==",
lat: 60.27135,
lon: 25.04662
},
{
id: "U3RvcDpIU0w6MTQxMTEyNQ==",
lat: 60.27072,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQxMTEyMw==",
lat: 60.2701,
lon: 25.05879
},
{
id: "U3RvcDpIU0w6MTQxMjEyMA==",
lat: 60.26962,
lon: 25.06454
},
{
id: "U3RvcDpIU0w6MTQxMjEzNA==",
lat: 60.27016,
lon: 25.07203
},
{
id: "U3RvcDpIU0w6MTQxMTExOQ==",
lat: 60.26989,
lon: 25.06314
},
{
id: "U3RvcDpIU0w6MTQxMTEyMg==",
lat: 60.26998,
lon: 25.0564
},
{
id: "U3RvcDpIU0w6MTQxMTEyNA==",
lat: 60.27112,
lon: 25.05116
},
{
id: "U3RvcDpIU0w6MTQxMTEwOQ==",
lat: 60.27147,
lon: 25.0461
},
{
id: "U3RvcDpIU0w6MTQxMTEwMQ==",
lat: 60.2738,
lon: 25.04459
},
{
id: "U3RvcDpIU0w6MTQxMTEzMA==",
lat: 60.27665,
lon: 25.03995
},
{
id: "U3RvcDpIU0w6MTQwMjE1MA==",
lat: 60.27665,
lon: 25.03432
},
{
id: "U3RvcDpIU0w6MTQwMjE1NQ==",
lat: 60.27502,
lon: 25.03549
},
{
id: "U3RvcDpIU0w6MTQwMjE1Nw==",
lat: 60.27136,
lon: 25.03385
},
{
id: "U3RvcDpIU0w6MTQwMjE3Mw==",
lat: 60.26816,
lon: 25.03245
},
{
id: "U3RvcDpIU0w6MTQwMjE3OQ==",
lat: 60.26814,
lon: 25.02993
},
{
id: "U3RvcDpIU0w6MTM5MjEzNg==",
lat: 60.26918,
lon: 25.02404
},
{
id: "U3RvcDpIU0w6MTM5MjE1NQ==",
lat: 60.265031,
lon: 25.025645
},
{
id: "U3RvcDpIU0w6MTM5MjE1MQ==",
lat: 60.26301,
lon: 25.02684
},
{
id: "U3RvcDpIU0w6MTM5MjE0OQ==",
lat: 60.26063,
lon: 25.02024
},
{
id: "U3RvcDpIU0w6MTM5MjE0Nw==",
lat: 60.2612,
lon: 25.01662
},
{
id: "U3RvcDpIU0w6MTM5MjE0NA==",
lat: 60.26226,
lon: 25.01209
},
{
id: "U3RvcDpIU0w6MTM5MTE4Nw==",
lat: 60.26077,
lon: 25.01166
},
{
id: "U3RvcDpIU0w6MTM5MjE1OA==",
lat: 60.25751,
lon: 25.01293
},
{
id: "U3RvcDpIU0w6MTM4MTE1Ng==",
lat: 60.25554,
lon: 25.01028
},
{
id: "U3RvcDpIU0w6MTM4MTE1NA==",
lat: 60.25391,
lon: 25.00898
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwMg==",
lat: 60.2502,
lon: 25.00917
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MzExNA==",
lat: 60.23859,
lon: 25.02095
},
{
id: "U3RvcDpIU0w6MTM4MzExMg==",
lat: 60.23595,
lon: 25.02177
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM2MzEwMQ==",
lat: 60.229313,
lon: 25.010037
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
}
]
},
{
gtfsId: "HSL:1073",
shortName: "73",
longName: "Hakaniemi-Malmi-Puistolan as.-Ala-Tikkurila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQwMTEyOQ==",
lat: 60.28693,
lon: 25.01495
},
{
id: "U3RvcDpIU0w6MTQwMTEyOA==",
lat: 60.28426,
lon: 25.01348
},
{
id: "U3RvcDpIU0w6MTQwMTEyMw==",
lat: 60.28254,
lon: 25.02771
},
{
id: "U3RvcDpIU0w6MTQwMjExOQ==",
lat: 60.28053,
lon: 25.02847
},
{
id: "U3RvcDpIU0w6MTQwMjEyMg==",
lat: 60.27838,
lon: 25.03171
},
{
id: "U3RvcDpIU0w6MTQwMjE1MA==",
lat: 60.27665,
lon: 25.03432
},
{
id: "U3RvcDpIU0w6MTQwMjE1NQ==",
lat: 60.27502,
lon: 25.03549
},
{
id: "U3RvcDpIU0w6MTQwMjE1Nw==",
lat: 60.27136,
lon: 25.03385
},
{
id: "U3RvcDpIU0w6MTQwMjE3Mw==",
lat: 60.26816,
lon: 25.03245
},
{
id: "U3RvcDpIU0w6MTQwMjE3OQ==",
lat: 60.26814,
lon: 25.02993
},
{
id: "U3RvcDpIU0w6MTQwMjE4MQ==",
lat: 60.26966,
lon: 25.0235
},
{
id: "U3RvcDpIU0w6MTQwMjE4Mw==",
lat: 60.26941,
lon: 25.018925
},
{
id: "U3RvcDpIU0w6MTQwMzE2NA==",
lat: 60.26767,
lon: 25.01355
},
{
id: "U3RvcDpIU0w6MTQwMzE5Nw==",
lat: 60.26694,
lon: 25.00747
},
{
id: "U3RvcDpIU0w6MTQwMzE5NQ==",
lat: 60.26568,
lon: 25.00295
},
{
id: "U3RvcDpIU0w6MTM5MTE5Mw==",
lat: 60.2638,
lon: 25.00456
},
{
id: "U3RvcDpIU0w6MTM5MTE0Mw==",
lat: 60.26131,
lon: 25.00392
},
{
id: "U3RvcDpIU0w6MTM5MTE0MQ==",
lat: 60.25832,
lon: 25.00074
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwMg==",
lat: 60.2502,
lon: 25.00917
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MzExNA==",
lat: 60.23859,
lon: 25.02095
},
{
id: "U3RvcDpIU0w6MTM4MzExMg==",
lat: 60.23595,
lon: 25.02177
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM2MzEwMQ==",
lat: 60.229313,
lon: 25.010037
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTExMTE1MQ==",
lat: 60.17913,
lon: 24.952221
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjEwNQ==",
lat: 60.22862,
lon: 25.01202
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEwOQ==",
lat: 60.232187,
lon: 25.011714
},
{
id: "U3RvcDpIU0w6MTM4MzExMQ==",
lat: 60.23676,
lon: 25.02225
},
{
id: "U3RvcDpIU0w6MTM4MjExMw==",
lat: 60.240179,
lon: 25.021039
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MTEwMQ==",
lat: 60.25004,
lon: 25.00946
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEzOQ==",
lat: 60.25731,
lon: 24.99923
},
{
id: "U3RvcDpIU0w6MTM5MTE0MA==",
lat: 60.25929,
lon: 25.00169
},
{
id: "U3RvcDpIU0w6MTM5MTE0Mg==",
lat: 60.26103,
lon: 25.00335
},
{
id: "U3RvcDpIU0w6MTM5MTE5Mg==",
lat: 60.26397,
lon: 25.00455
},
{
id: "U3RvcDpIU0w6MTQwMzE5NA==",
lat: 60.26568,
lon: 25.00316
},
{
id: "U3RvcDpIU0w6MTM5MTE5Ng==",
lat: 60.26709,
lon: 25.00979
},
{
id: "U3RvcDpIU0w6MTM5MjE2NQ==",
lat: 60.26788,
lon: 25.01539
},
{
id: "U3RvcDpIU0w6MTM5MjE4NA==",
lat: 60.26934,
lon: 25.01931
},
{
id: "U3RvcDpIU0w6MTQwMjE4Mg==",
lat: 60.26934,
lon: 25.02538
},
{
id: "U3RvcDpIU0w6MTM5MjE4MA==",
lat: 60.26817,
lon: 25.02945
},
{
id: "U3RvcDpIU0w6MTQxMTE3NA==",
lat: 60.2688,
lon: 25.03293
},
{
id: "U3RvcDpIU0w6MTQwMjE1Ng==",
lat: 60.2721,
lon: 25.03447
},
{
id: "U3RvcDpIU0w6MTQwMjE1NA==",
lat: 60.27495,
lon: 25.03572
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mg==",
lat: 60.27697,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6MTQwMjEyMQ==",
lat: 60.27863,
lon: 25.03001
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mw==",
lat: 60.28064,
lon: 25.02876
},
{
id: "U3RvcDpIU0w6MTQwMjEyMA==",
lat: 60.28326,
lon: 25.02772
},
{
id: "U3RvcDpIU0w6MTQwMTEyNw==",
lat: 60.28597,
lon: 25.0151
}
]
},
{
gtfsId: "HSL:9975N",
shortName: "975N",
longName: "Keravan asema - Kaleva - Hyrylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA0MDIyMA==",
lat: 60.40444,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIwNQ==",
lat: 60.40346,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6OTA0MDIwMw==",
lat: 60.40212,
lon: 25.09875
},
{
id: "U3RvcDpIU0w6OTA0MDIwMQ==",
lat: 60.4041,
lon: 25.09687
},
{
id: "U3RvcDpIU0w6OTAxMDIxMw==",
lat: 60.40826,
lon: 25.09736
},
{
id: "U3RvcDpIU0w6OTAxMDIxMQ==",
lat: 60.4112,
lon: 25.09594
},
{
id: "U3RvcDpIU0w6OTAxMDIwOQ==",
lat: 60.41408,
lon: 25.09471
},
{
id: "U3RvcDpIU0w6OTAxMDIwNw==",
lat: 60.41618,
lon: 25.09203
},
{
id: "U3RvcDpIU0w6OTAxMDIyNQ==",
lat: 60.41959,
lon: 25.08885
},
{
id: "U3RvcDpIU0w6OTAxMDIyMw==",
lat: 60.41865,
lon: 25.08612
},
{
id: "U3RvcDpIU0w6OTAxMDIyMQ==",
lat: 60.41638,
lon: 25.08067
},
{
id: "U3RvcDpIU0w6OTAxMDIxOQ==",
lat: 60.4145,
lon: 25.08144
},
{
id: "U3RvcDpIU0w6OTAxMDIxNw==",
lat: 60.41262,
lon: 25.0829
},
{
id: "U3RvcDpIU0w6OTAxMDIxNQ==",
lat: 60.40978,
lon: 25.08347
},
{
id: "U3RvcDpIU0w6OTY1MDQxOA==",
lat: 60.411005,
lon: 25.076163
},
{
id: "U3RvcDpIU0w6OTY1MDQwMQ==",
lat: 60.412982,
lon: 25.071106
},
{
id: "U3RvcDpIU0w6OTY1MDQxNg==",
lat: 60.415137,
lon: 25.064932
},
{
id: "U3RvcDpIU0w6OTY1MDQyMA==",
lat: 60.414242,
lon: 25.060548
},
{
id: "U3RvcDpIU0w6OTY1MDQwOQ==",
lat: 60.414496,
lon: 25.054166
},
{
id: "U3RvcDpIU0w6OTY1MDQwNg==",
lat: 60.414022,
lon: 25.049991
},
{
id: "U3RvcDpIU0w6OTY1MDMyNQ==",
lat: 60.410933,
lon: 25.045152
},
{
id: "U3RvcDpIU0w6OTY1MDMyNw==",
lat: 60.409244,
lon: 25.042448
},
{
id: "U3RvcDpIU0w6OTY1MDMyMg==",
lat: 60.406367,
lon: 25.041696
},
{
id: "U3RvcDpIU0w6OTY1MDMxOQ==",
lat: 60.404485,
lon: 25.041464
},
{
id: "U3RvcDpIU0w6OTY1MDEwMg==",
lat: 60.40142,
lon: 25.030759
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
},
{
id: "U3RvcDpIU0w6OTY1MDEyMg==",
lat: 60.401853,
lon: 25.027808
},
{
id: "U3RvcDpIU0w6OTY1MDEwMw==",
lat: 60.401391,
lon: 25.03098
},
{
id: "U3RvcDpIU0w6OTY1MDMyNA==",
lat: 60.402958,
lon: 25.039074
},
{
id: "U3RvcDpIU0w6OTY1MDMxOA==",
lat: 60.404662,
lon: 25.041673
},
{
id: "U3RvcDpIU0w6OTY1MDMyMQ==",
lat: 60.407436,
lon: 25.041864
},
{
id: "U3RvcDpIU0w6OTY1MDMyNg==",
lat: 60.409443,
lon: 25.042818
},
{
id: "U3RvcDpIU0w6OTY1MDMwMQ==",
lat: 60.411513,
lon: 25.045253
},
{
id: "U3RvcDpIU0w6OTY1MDQxNA==",
lat: 60.412355,
lon: 25.047274
},
{
id: "U3RvcDpIU0w6OTY1MDQwOA==",
lat: 60.414462,
lon: 25.053068
},
{
id: "U3RvcDpIU0w6OTY1MDQxOQ==",
lat: 60.414541,
lon: 25.062168
},
{
id: "U3RvcDpIU0w6OTY1MDQxNQ==",
lat: 60.414239,
lon: 25.068257
},
{
id: "U3RvcDpIU0w6OTY1MDQwMA==",
lat: 60.412498,
lon: 25.072411
},
{
id: "U3RvcDpIU0w6OTY1MDQxNw==",
lat: 60.410369,
lon: 25.07738
},
{
id: "U3RvcDpIU0w6OTAxMDIxNg==",
lat: 60.40999,
lon: 25.08438
},
{
id: "U3RvcDpIU0w6OTAxMDIxOA==",
lat: 60.41233,
lon: 25.08319
},
{
id: "U3RvcDpIU0w6OTAxMDIyMA==",
lat: 60.41462,
lon: 25.08157
},
{
id: "U3RvcDpIU0w6OTAxMDIyMg==",
lat: 60.41648,
lon: 25.08081
},
{
id: "U3RvcDpIU0w6OTAxMDIyNA==",
lat: 60.41868,
lon: 25.08654
},
{
id: "U3RvcDpIU0w6OTAxMDIyNg==",
lat: 60.41955,
lon: 25.0891
},
{
id: "U3RvcDpIU0w6OTAxMDIwOA==",
lat: 60.41643,
lon: 25.09163
},
{
id: "U3RvcDpIU0w6OTAxMDIxMA==",
lat: 60.41426,
lon: 25.09428
},
{
id: "U3RvcDpIU0w6OTAxMDIxMg==",
lat: 60.4107,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6OTAxMDIxNA==",
lat: 60.40774,
lon: 25.09777
},
{
id: "U3RvcDpIU0w6OTAyMDIwNw==",
lat: 60.40457,
lon: 25.096
},
{
id: "U3RvcDpIU0w6OTA0MDIwNA==",
lat: 60.40206,
lon: 25.09889
},
{
id: "U3RvcDpIU0w6OTA0MDIwNg==",
lat: 60.40346,
lon: 25.10141
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
}
]
},
{
gtfsId: "HSL:1071",
shortName: "71",
longName: "Rautatientori-Pihlajisto-Pihlajamäki-Malmi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM4MjE4OA==",
lat: 60.25018,
lon: 25.01265
},
{
id: "U3RvcDpIU0w6MTM4MjE3Nw==",
lat: 60.24926,
lon: 25.0077
},
{
id: "U3RvcDpIU0w6MTM3MDEyMQ==",
lat: 60.24617,
lon: 25.00154
},
{
id: "U3RvcDpIU0w6MTM4MjExOQ==",
lat: 60.24318,
lon: 24.99639
},
{
id: "U3RvcDpIU0w6MTM4MzE4MQ==",
lat: 60.24095,
lon: 24.99877
},
{
id: "U3RvcDpIU0w6MTM4MzEzMQ==",
lat: 60.24007,
lon: 25.0027
},
{
id: "U3RvcDpIU0w6MTM4MzEyOQ==",
lat: 60.23702,
lon: 25.00686
},
{
id: "U3RvcDpIU0w6MTM4MzEyNw==",
lat: 60.23419,
lon: 25.01042
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM4MzEzNA==",
lat: 60.230748,
lon: 25.004888
},
{
id: "U3RvcDpIU0w6MTM4MzEzNg==",
lat: 60.23112,
lon: 25.0003
},
{
id: "U3RvcDpIU0w6MTM2NDEwNg==",
lat: 60.229955,
lon: 24.996894
},
{
id: "U3RvcDpIU0w6MTM2NDEwNA==",
lat: 60.227763,
lon: 24.989564
},
{
id: "U3RvcDpIU0w6MTM2NDEwMg==",
lat: 60.224166,
lon: 24.988431
},
{
id: "U3RvcDpIU0w6MTM2MTEwNA==",
lat: 60.21836,
lon: 24.98539
},
{
id: "U3RvcDpIU0w6MTI3MDEwNQ==",
lat: 60.21611,
lon: 24.98016
},
{
id: "U3RvcDpIU0w6MTI3MDEwMg==",
lat: 60.21252,
lon: 24.97844
},
{
id: "U3RvcDpIU0w6MTIzMDEwMQ==",
lat: 60.210234,
lon: 24.976613
},
{
id: "U3RvcDpIU0w6MTIzMDEwMw==",
lat: 60.20808,
lon: 24.97474
},
{
id: "U3RvcDpIU0w6MTIzMDExNA==",
lat: 60.20593,
lon: 24.97255
},
{
id: "U3RvcDpIU0w6MTIzMDExMg==",
lat: 60.20316,
lon: 24.96657
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDExMw==",
lat: 60.17072,
lon: 24.94324
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTIzMDEwOQ==",
lat: 60.20312,
lon: 24.9673
},
{
id: "U3RvcDpIU0w6MTIzMDExMw==",
lat: 60.20548,
lon: 24.97209
},
{
id: "U3RvcDpIU0w6MTIzMDEwNA==",
lat: 60.20827,
lon: 24.97504
},
{
id: "U3RvcDpIU0w6MTIzMDEwMg==",
lat: 60.21121,
lon: 24.97757
},
{
id: "U3RvcDpIU0w6MTI3MDEwMw==",
lat: 60.21316,
lon: 24.97917
},
{
id: "U3RvcDpIU0w6MTI3MDEwNA==",
lat: 60.217158,
lon: 24.981087
},
{
id: "U3RvcDpIU0w6MTM2MTEwMw==",
lat: 60.21896,
lon: 24.98699
},
{
id: "U3RvcDpIU0w6MTM2NDEwMQ==",
lat: 60.224023,
lon: 24.988526
},
{
id: "U3RvcDpIU0w6MTM2NDEwMw==",
lat: 60.228033,
lon: 24.989917
},
{
id: "U3RvcDpIU0w6MTM2NDEwNQ==",
lat: 60.230034,
lon: 24.99733
},
{
id: "U3RvcDpIU0w6MTM4MzEzOA==",
lat: 60.23116,
lon: 25.00068
},
{
id: "U3RvcDpIU0w6MTM4MzEzNQ==",
lat: 60.23112,
lon: 25.00417
},
{
id: "U3RvcDpIU0w6MTM4MzE3OQ==",
lat: 60.23017,
lon: 25.00861
},
{
id: "U3RvcDpIU0w6MTM4MzEyNA==",
lat: 60.23317,
lon: 25.01162
},
{
id: "U3RvcDpIU0w6MTM4MzEyNg==",
lat: 60.23436,
lon: 25.010234
},
{
id: "U3RvcDpIU0w6MTM4MzEyOA==",
lat: 60.23739,
lon: 25.00643
},
{
id: "U3RvcDpIU0w6MTM4MzEzMA==",
lat: 60.23986,
lon: 25.00259
},
{
id: "U3RvcDpIU0w6MTM4MzE4MA==",
lat: 60.2408,
lon: 24.99779
},
{
id: "U3RvcDpIU0w6MTM4MjEyMA==",
lat: 60.24328,
lon: 24.99679
},
{
id: "U3RvcDpIU0w6MTM4MjEyMg==",
lat: 60.24685,
lon: 25.00326
},
{
id: "U3RvcDpIU0w6MTM4MjE3OA==",
lat: 60.24924,
lon: 25.00818
}
]
},
{
gtfsId: "HSL:1070",
shortName: "70",
longName: "Kamppi-Töölö-Pihlajamäki-Pukinmäki-Malmi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM4MjE4NQ==",
lat: 60.24996,
lon: 25.01192
},
{
id: "U3RvcDpIU0w6MTM4MjE3MA==",
lat: 60.24865,
lon: 25.01101
},
{
id: "U3RvcDpIU0w6MTM4MTEwMQ==",
lat: 60.25004,
lon: 25.00946
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEwNQ==",
lat: 60.25639,
lon: 24.9975
},
{
id: "U3RvcDpIU0w6MTM5MTEwNA==",
lat: 60.25324,
lon: 24.99371
},
{
id: "U3RvcDpIU0w6MTM3MDEyOA==",
lat: 60.25133,
lon: 24.99443
},
{
id: "U3RvcDpIU0w6MTM3MDExOQ==",
lat: 60.24868,
lon: 24.99755
},
{
id: "U3RvcDpIU0w6MTM3MDExMg==",
lat: 60.24732,
lon: 24.99163
},
{
id: "U3RvcDpIU0w6MTM3MDExMA==",
lat: 60.24324,
lon: 24.99451
},
{
id: "U3RvcDpIU0w6MTM4MzE4MQ==",
lat: 60.24095,
lon: 24.99877
},
{
id: "U3RvcDpIU0w6MTM4MzEzMQ==",
lat: 60.24007,
lon: 25.0027
},
{
id: "U3RvcDpIU0w6MTM4MzEyOQ==",
lat: 60.23702,
lon: 25.00686
},
{
id: "U3RvcDpIU0w6MTM4MzEyNw==",
lat: 60.23419,
lon: 25.01042
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM2MzEwMQ==",
lat: 60.229313,
lon: 25.010037
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEyOA==",
lat: 60.19563,
lon: 24.95916
},
{
id: "U3RvcDpIU0w6MTIyMDE4MA==",
lat: 60.19381,
lon: 24.95531
},
{
id: "U3RvcDpIU0w6MTEyMjEzNQ==",
lat: 60.18944,
lon: 24.94694
},
{
id: "U3RvcDpIU0w6MTEyMjEwMQ==",
lat: 60.18642,
lon: 24.94121
},
{
id: "U3RvcDpIU0w6MTE0MDE5OQ==",
lat: 60.18283,
lon: 24.93003
},
{
id: "U3RvcDpIU0w6MTE0MDE5Nw==",
lat: 60.18161,
lon: 24.92672
},
{
id: "U3RvcDpIU0w6MTE0MDEyMA==",
lat: 60.178585,
lon: 24.922636
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
},
{
id: "U3RvcDpIU0w6MTA0MDI3Ng==",
lat: 60.169,
lon: 24.93164
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDExOQ==",
lat: 60.17995,
lon: 24.92414
},
{
id: "U3RvcDpIU0w6MTE0MDE5Ng==",
lat: 60.18216,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTEyMjEwMg==",
lat: 60.18643,
lon: 24.94185
},
{
id: "U3RvcDpIU0w6MTEyMjE5Ng==",
lat: 60.18917,
lon: 24.94693
},
{
id: "U3RvcDpIU0w6MTIyMDEzMA==",
lat: 60.19114,
lon: 24.95004
},
{
id: "U3RvcDpIU0w6MTIyMDEwMQ==",
lat: 60.19302,
lon: 24.95382
},
{
id: "U3RvcDpIU0w6MTIyMDEyOQ==",
lat: 60.195363,
lon: 24.958996
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjEwNQ==",
lat: 60.22862,
lon: 25.01202
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEyNA==",
lat: 60.23317,
lon: 25.01162
},
{
id: "U3RvcDpIU0w6MTM4MzEyNg==",
lat: 60.23436,
lon: 25.010234
},
{
id: "U3RvcDpIU0w6MTM4MzEyOA==",
lat: 60.23739,
lon: 25.00643
},
{
id: "U3RvcDpIU0w6MTM4MzEzMA==",
lat: 60.23986,
lon: 25.00259
},
{
id: "U3RvcDpIU0w6MTM4MzE4MA==",
lat: 60.2408,
lon: 24.99779
},
{
id: "U3RvcDpIU0w6MTM3MDEwOQ==",
lat: 60.24398,
lon: 24.99386
},
{
id: "U3RvcDpIU0w6MTM3MDExOA==",
lat: 60.2479,
lon: 24.99219
},
{
id: "U3RvcDpIU0w6MTM3MDEyMA==",
lat: 60.24855,
lon: 24.99734
},
{
id: "U3RvcDpIU0w6MTM4MTExMw==",
lat: 60.25161,
lon: 24.99378
},
{
id: "U3RvcDpIU0w6MTM5MTEwMQ==",
lat: 60.25397,
lon: 24.9941
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwNg==",
lat: 60.25027,
lon: 25.0093
},
{
id: "U3RvcDpIU0w6MTM4MjE2OQ==",
lat: 60.24882,
lon: 25.01278
},
{
id: "U3RvcDpIU0w6MTM4MjE4OA==",
lat: 60.25018,
lon: 25.01265
}
]
},
{
gtfsId: "HSL:2235N",
shortName: "235N",
longName: "Elielinaukio-Leppävaara-Espoon keskus-Kuurinniitty",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEzMQ==",
lat: 60.171741,
lon: 24.939733
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTIyMA==",
lat: 60.21031,
lon: 24.88865
},
{
id: "U3RvcDpIU0w6MTQ2NTE0Mw==",
lat: 60.214064,
lon: 24.880445
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzIxMQ==",
lat: 60.22455,
lon: 24.84853
},
{
id: "U3RvcDpIU0w6MjAwMDIwMw==",
lat: 60.22112,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6MjExMzIwNQ==",
lat: 60.22052,
lon: 24.83286
},
{
id: "U3RvcDpIU0w6MjExMTI4MA==",
lat: 60.21955,
lon: 24.82102
},
{
id: "U3RvcDpIU0w6MjExMTIwOQ==",
lat: 60.22007,
lon: 24.81252
},
{
id: "U3RvcDpIU0w6MjExMTI5OQ==",
lat: 60.22005,
lon: 24.80436
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwOQ==",
lat: 60.22671,
lon: 24.77975
},
{
id: "U3RvcDpIU0w6MjEzMzI2MA==",
lat: 60.22871,
lon: 24.77909
},
{
id: "U3RvcDpIU0w6MjEzMzIzNA==",
lat: 60.22965,
lon: 24.77683
},
{
id: "U3RvcDpIU0w6MjEzMzIxMQ==",
lat: 60.22934,
lon: 24.77365
},
{
id: "U3RvcDpIU0w6MjEzMzIxMw==",
lat: 60.22968,
lon: 24.76792
},
{
id: "U3RvcDpIU0w6MjEzMzIxNw==",
lat: 60.228,
lon: 24.76138
},
{
id: "U3RvcDpIU0w6MjEzMzIyNA==",
lat: 60.22695,
lon: 24.75707
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwNw==",
lat: 60.22686,
lon: 24.74108
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMQ==",
lat: 60.2317,
lon: 24.74358
},
{
id: "U3RvcDpIU0w6MjE0MTIwMQ==",
lat: 60.23675,
lon: 24.74327
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI1OA==",
lat: 60.23912,
lon: 24.70695
},
{
id: "U3RvcDpIU0w6MjYzMjI1OQ==",
lat: 60.23785,
lon: 24.70422
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mg==",
lat: 60.23498,
lon: 24.70481
},
{
id: "U3RvcDpIU0w6MjYzMjI0MQ==",
lat: 60.23238,
lon: 24.69878
},
{
id: "U3RvcDpIU0w6MjYzMjIzOQ==",
lat: 60.23077,
lon: 24.69602
},
{
id: "U3RvcDpIU0w6MjYzMjIzNw==",
lat: 60.22856,
lon: 24.69157
},
{
id: "U3RvcDpIU0w6MjYzMjIzNQ==",
lat: 60.22592,
lon: 24.68556
},
{
id: "U3RvcDpIU0w6MjYzMjIzMw==",
lat: 60.22548,
lon: 24.68117
},
{
id: "U3RvcDpIU0w6MjYzMjI3Mw==",
lat: 60.22305,
lon: 24.67722
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYyMTIyMg==",
lat: 60.21448,
lon: 24.65221
},
{
id: "U3RvcDpIU0w6MjYyMTIwNA==",
lat: 60.21482,
lon: 24.64804
},
{
id: "U3RvcDpIU0w6MjYyMTIwNg==",
lat: 60.21173,
lon: 24.64243
},
{
id: "U3RvcDpIU0w6MjYyMTIwMg==",
lat: 60.20934,
lon: 24.64173
},
{
id: "U3RvcDpIU0w6MjYyMTIxNQ==",
lat: 60.20776,
lon: 24.64132
},
{
id: "U3RvcDpIU0w6MjYyMTIxNw==",
lat: 60.20649,
lon: 24.64021
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMzAwOA==",
lat: 60.202736,
lon: 24.661962
},
{
id: "U3RvcDpIU0w6MjYxMzAwMQ==",
lat: 60.20123,
lon: 24.6671
},
{
id: "U3RvcDpIU0w6MjYxMzIxNg==",
lat: 60.2028,
lon: 24.67021
},
{
id: "U3RvcDpIU0w6MjYxMzIxOA==",
lat: 60.20462,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjYxMjIxOQ==",
lat: 60.20332,
lon: 24.68024
},
{
id: "U3RvcDpIU0w6MjYxMjIyNg==",
lat: 60.199976,
lon: 24.683783
},
{
id: "U3RvcDpIU0w6MjYxMjIyMQ==",
lat: 60.20047,
lon: 24.68762
},
{
id: "U3RvcDpIU0w6MjYxMjIyNA==",
lat: 60.201328,
lon: 24.69811
},
{
id: "U3RvcDpIU0w6MjYxNDIyNg==",
lat: 60.19976,
lon: 24.70503
},
{
id: "U3RvcDpIU0w6MjYxNDI1Ng==",
lat: 60.19862,
lon: 24.70922
},
{
id: "U3RvcDpIU0w6MjYxNDI1OA==",
lat: 60.198,
lon: 24.71445
},
{
id: "U3RvcDpIU0w6MjYxNDI2MA==",
lat: 60.19729,
lon: 24.71871
},
{
id: "U3RvcDpIU0w6MjYxNDI1Nw==",
lat: 60.19802,
lon: 24.71458
},
{
id: "U3RvcDpIU0w6MjYxNDI1OQ==",
lat: 60.19899,
lon: 24.70857
},
{
id: "U3RvcDpIU0w6MjYxNDIyNw==",
lat: 60.19996,
lon: 24.70541
},
{
id: "U3RvcDpIU0w6MjYxMjIyNQ==",
lat: 60.201429,
lon: 24.692241
},
{
id: "U3RvcDpIU0w6MjYxMjIyMg==",
lat: 60.20016,
lon: 24.68547
},
{
id: "U3RvcDpIU0w6MjYxMjIyMA==",
lat: 60.20329,
lon: 24.68038
},
{
id: "U3RvcDpIU0w6MjYxMzIxNw==",
lat: 60.20508,
lon: 24.67367
},
{
id: "U3RvcDpIU0w6MjYxMzIxNQ==",
lat: 60.20246,
lon: 24.66925
},
{
id: "U3RvcDpIU0w6MjYxMzAwMA==",
lat: 60.201,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxNTIzMA==",
lat: 60.20332,
lon: 24.65198
},
{
id: "U3RvcDpIU0w6MjYyMTIwOA==",
lat: 60.20759,
lon: 24.64111
},
{
id: "U3RvcDpIU0w6MjYyMTIwMw==",
lat: 60.208636,
lon: 24.642381
},
{
id: "U3RvcDpIU0w6MjYyMTIwNw==",
lat: 60.21239,
lon: 24.64336
},
{
id: "U3RvcDpIU0w6MjYyMTIwNQ==",
lat: 60.21468,
lon: 24.64968
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMjIzMg==",
lat: 60.22308,
lon: 24.6774
},
{
id: "U3RvcDpIU0w6MjYzMjIzNA==",
lat: 60.22558,
lon: 24.68211
},
{
id: "U3RvcDpIU0w6MjYzMjIzNg==",
lat: 60.22601,
lon: 24.68628
},
{
id: "U3RvcDpIU0w6MjYzMjIzOA==",
lat: 60.229,
lon: 24.69282
},
{
id: "U3RvcDpIU0w6MjYzMjI0MA==",
lat: 60.23172,
lon: 24.69809
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mw==",
lat: 60.23605,
lon: 24.7054
},
{
id: "U3RvcDpIU0w6MjYzMjI2MA==",
lat: 60.23844,
lon: 24.70498
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNA==",
lat: 60.23995,
lon: 24.74098
},
{
id: "U3RvcDpIU0w6MjE1MTIyMg==",
lat: 60.23515,
lon: 24.74405
},
{
id: "U3RvcDpIU0w6MjE1MTIxMg==",
lat: 60.2317,
lon: 24.74328
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIwOA==",
lat: 60.22675,
lon: 24.74088
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMzIyNQ==",
lat: 60.2266,
lon: 24.75783
},
{
id: "U3RvcDpIU0w6MjEzMzIxNg==",
lat: 60.228636,
lon: 24.764329
},
{
id: "U3RvcDpIU0w6MjEzMzIxNA==",
lat: 60.22959,
lon: 24.76923
},
{
id: "U3RvcDpIU0w6MjEzMzIxMg==",
lat: 60.22916,
lon: 24.77474
},
{
id: "U3RvcDpIU0w6MjEzMzIxOQ==",
lat: 60.22944,
lon: 24.77787
},
{
id: "U3RvcDpIU0w6MjEzMzIxMA==",
lat: 60.22674,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIwMA==",
lat: 60.22015,
lon: 24.80185
},
{
id: "U3RvcDpIU0w6MjExMTIwOA==",
lat: 60.21982,
lon: 24.81298
},
{
id: "U3RvcDpIU0w6MjExMTI1Ng==",
lat: 60.21934,
lon: 24.8217
},
{
id: "U3RvcDpIU0w6MjExMzIwNg==",
lat: 60.22042,
lon: 24.83513
},
{
id: "U3RvcDpIU0w6MjExMzIwNA==",
lat: 60.2211,
lon: 24.84182
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMA==",
lat: 60.224845,
lon: 24.850474
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:2038",
shortName: "38",
longName: "Elielinaukio-Pitäjänmäki-Uusmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExNjI5MA==",
lat: 60.245497,
lon: 24.831476
},
{
id: "U3RvcDpIU0w6MjExNjI4Ng==",
lat: 60.24519,
lon: 24.8311
},
{
id: "U3RvcDpIU0w6MjExNjIxOA==",
lat: 60.24098,
lon: 24.83331
},
{
id: "U3RvcDpIU0w6MjExNjI4NA==",
lat: 60.23943,
lon: 24.83491
},
{
id: "U3RvcDpIU0w6MTMyMDI5OA==",
lat: 60.23614,
lon: 24.83878
},
{
id: "U3RvcDpIU0w6MTMyMDI4OA==",
lat: 60.23468,
lon: 24.84121
},
{
id: "U3RvcDpIU0w6MTMyMDIwNQ==",
lat: 60.23306,
lon: 24.84472
},
{
id: "U3RvcDpIU0w6MTMyMDEwMg==",
lat: 60.23233,
lon: 24.84636
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MQ==",
lat: 60.22888,
lon: 24.84861
},
{
id: "U3RvcDpIU0w6MTQ2MzExNg==",
lat: 60.22633,
lon: 24.85406
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDEyOQ==",
lat: 60.171681,
lon: 24.939739
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTIyMA==",
lat: 60.21031,
lon: 24.88865
},
{
id: "U3RvcDpIU0w6MTQ2NTE0Mw==",
lat: 60.214064,
lon: 24.880445
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzExNQ==",
lat: 60.22716,
lon: 24.85318
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MA==",
lat: 60.2288,
lon: 24.84913
},
{
id: "U3RvcDpIU0w6MTMyMDIwNg==",
lat: 60.23309,
lon: 24.84555
},
{
id: "U3RvcDpIU0w6MTMyMDI4Nw==",
lat: 60.23465,
lon: 24.8416
},
{
id: "U3RvcDpIU0w6MTMyMDI5OQ==",
lat: 60.23629,
lon: 24.83867
},
{
id: "U3RvcDpIU0w6MjExNjI4Mw==",
lat: 60.23964,
lon: 24.83497
},
{
id: "U3RvcDpIU0w6MjExNjI4NQ==",
lat: 60.240979,
lon: 24.833534
},
{
id: "U3RvcDpIU0w6MjExNjI4Nw==",
lat: 60.245025,
lon: 24.831187
}
]
},
{
gtfsId: "HSL:2159",
shortName: "159",
longName: "Matinkylä (M)-Latokaski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxNg==",
lat: 60.160206,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQzNDIwMw==",
lat: 60.156925,
lon: 24.66224
},
{
id: "U3RvcDpIU0w6MjQzNDIwMQ==",
lat: 60.16333,
lon: 24.66029
},
{
id: "U3RvcDpIU0w6MjQzNDIzMQ==",
lat: 60.16823,
lon: 24.66082
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mw==",
lat: 60.17401,
lon: 24.65456
},
{
id: "U3RvcDpIU0w6MjQzMTI1MQ==",
lat: 60.17666,
lon: 24.65685
},
{
id: "U3RvcDpIU0w6MjQzMTIzNw==",
lat: 60.17798,
lon: 24.6593
},
{
id: "U3RvcDpIU0w6MjQzMTIzOQ==",
lat: 60.17929,
lon: 24.65678
},
{
id: "U3RvcDpIU0w6MjQzMTI0MA==",
lat: 60.17908,
lon: 24.65491
},
{
id: "U3RvcDpIU0w6MjQzMTIzOA==",
lat: 60.17817,
lon: 24.65898
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mg==",
lat: 60.17662,
lon: 24.6562
},
{
id: "U3RvcDpIU0w6MjQzMTI1NA==",
lat: 60.17315,
lon: 24.65509
},
{
id: "U3RvcDpIU0w6MjQzNDIwMg==",
lat: 60.16658,
lon: 24.66045
},
{
id: "U3RvcDpIU0w6MjQzNDIwNA==",
lat: 60.16229,
lon: 24.6596
},
{
id: "U3RvcDpIU0w6MjQyMTIwNg==",
lat: 60.15662,
lon: 24.66215
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:2158",
shortName: "158",
longName: "Matinkylä (M)-Nöykkiö-Kattilalaakso-Kiviruukki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxNw==",
lat: 60.160197,
lon: 24.738644
},
{
id: "U3RvcDpIU0w6MjMxNDIyNA==",
lat: 60.15827,
lon: 24.73214
},
{
id: "U3RvcDpIU0w6MjMxNDIyMA==",
lat: 60.15719,
lon: 24.7262
},
{
id: "U3RvcDpIU0w6MjMxNDIyMg==",
lat: 60.16089,
lon: 24.72496
},
{
id: "U3RvcDpIU0w6MjMyMTI1Ng==",
lat: 60.16264,
lon: 24.72254
},
{
id: "U3RvcDpIU0w6MjMyMTIyMw==",
lat: 60.16259,
lon: 24.7208
},
{
id: "U3RvcDpIU0w6MjQzMjIxOA==",
lat: 60.16191,
lon: 24.70958
},
{
id: "U3RvcDpIU0w6MjQzMjI0MA==",
lat: 60.16211,
lon: 24.70565
},
{
id: "U3RvcDpIU0w6MjQzMjIwMg==",
lat: 60.163276,
lon: 24.703633
},
{
id: "U3RvcDpIU0w6MjQzMjIwNA==",
lat: 60.16535,
lon: 24.70225
},
{
id: "U3RvcDpIU0w6MjQzMjIwNg==",
lat: 60.16994,
lon: 24.69269
},
{
id: "U3RvcDpIU0w6MjQzMzIwNw==",
lat: 60.17298,
lon: 24.6873
},
{
id: "U3RvcDpIU0w6MjQzNDMwMQ==",
lat: 60.17155,
lon: 24.68053
},
{
id: "U3RvcDpIU0w6MjQzNDIzMw==",
lat: 60.17019,
lon: 24.6776
},
{
id: "U3RvcDpIU0w6MjQzMjIxNQ==",
lat: 60.16853,
lon: 24.67787
},
{
id: "U3RvcDpIU0w6MjQzMjIwOQ==",
lat: 60.16639,
lon: 24.67914
},
{
id: "U3RvcDpIU0w6MjQzNDI0NQ==",
lat: 60.1644,
lon: 24.68157
},
{
id: "U3RvcDpIU0w6MjQzNDI1MA==",
lat: 60.16296,
lon: 24.67642
},
{
id: "U3RvcDpIU0w6MjQzNDIwOA==",
lat: 60.16328,
lon: 24.67186
},
{
id: "U3RvcDpIU0w6MjQzNDIwNg==",
lat: 60.16285,
lon: 24.66447
},
{
id: "U3RvcDpIU0w6MjQzNDIwMQ==",
lat: 60.16333,
lon: 24.66029
},
{
id: "U3RvcDpIU0w6MjQzNDIzMg==",
lat: 60.16725,
lon: 24.65983
},
{
id: "U3RvcDpIU0w6MjQyMTIxNg==",
lat: 60.16684,
lon: 24.65354
},
{
id: "U3RvcDpIU0w6MjQyMTIxNA==",
lat: 60.16474,
lon: 24.65108
},
{
id: "U3RvcDpIU0w6MjQyMTIyMA==",
lat: 60.16306,
lon: 24.64959
},
{
id: "U3RvcDpIU0w6MjQyMTIxMg==",
lat: 60.16095,
lon: 24.646428
},
{
id: "U3RvcDpIU0w6MjQyMTIyMg==",
lat: 60.158,
lon: 24.64159
},
{
id: "U3RvcDpIU0w6MjQyMTIyNA==",
lat: 60.16058,
lon: 24.63576
},
{
id: "U3RvcDpIU0w6MjQyMTIyNg==",
lat: 60.16311,
lon: 24.63362
},
{
id: "U3RvcDpIU0w6MjQyMTIyNw==",
lat: 60.16219,
lon: 24.6342
},
{
id: "U3RvcDpIU0w6MjQyMTIyNQ==",
lat: 60.1596,
lon: 24.63639
},
{
id: "U3RvcDpIU0w6MjQyMTIyMw==",
lat: 60.1579,
lon: 24.64127
},
{
id: "U3RvcDpIU0w6MjQyMTIxMQ==",
lat: 60.16094,
lon: 24.64666
},
{
id: "U3RvcDpIU0w6MjQyMTIxOQ==",
lat: 60.16351,
lon: 24.65042
},
{
id: "U3RvcDpIU0w6MjQyMTIxMw==",
lat: 60.16537,
lon: 24.65168
},
{
id: "U3RvcDpIU0w6MjQzNDIxMQ==",
lat: 60.167192,
lon: 24.65716
},
{
id: "U3RvcDpIU0w6MjQzNDIwMg==",
lat: 60.16658,
lon: 24.66045
},
{
id: "U3RvcDpIU0w6MjQzNDIwNQ==",
lat: 60.162555,
lon: 24.661038
},
{
id: "U3RvcDpIU0w6MjQzNDIwNw==",
lat: 60.16286,
lon: 24.66467
},
{
id: "U3RvcDpIU0w6MjQzNDIwOQ==",
lat: 60.16319,
lon: 24.67184
},
{
id: "U3RvcDpIU0w6MjQzNDI0NA==",
lat: 60.16295,
lon: 24.67667
},
{
id: "U3RvcDpIU0w6MjQzNDI0Ng==",
lat: 60.16443,
lon: 24.68178
},
{
id: "U3RvcDpIU0w6MjQzMjIxMA==",
lat: 60.16594,
lon: 24.6803
},
{
id: "U3RvcDpIU0w6MjQzMjIyNw==",
lat: 60.16756,
lon: 24.67821
},
{
id: "U3RvcDpIU0w6MjQzMjIyOA==",
lat: 60.16934,
lon: 24.67792
},
{
id: "U3RvcDpIU0w6MjQzNDMwMg==",
lat: 60.17161,
lon: 24.68123
},
{
id: "U3RvcDpIU0w6MjQzMjIzMg==",
lat: 60.17263,
lon: 24.68894
},
{
id: "U3RvcDpIU0w6MjQzMjIwNw==",
lat: 60.16914,
lon: 24.69489
},
{
id: "U3RvcDpIU0w6MjQzMjIwNQ==",
lat: 60.164145,
lon: 24.702844
},
{
id: "U3RvcDpIU0w6MjQzMjIxOQ==",
lat: 60.1618,
lon: 24.7053
},
{
id: "U3RvcDpIU0w6MjQzMjIxNw==",
lat: 60.16173,
lon: 24.71134
},
{
id: "U3RvcDpIU0w6MjMyMTIyNw==",
lat: 60.16215,
lon: 24.72297
},
{
id: "U3RvcDpIU0w6MjMxNDIyMw==",
lat: 60.16015,
lon: 24.72536
},
{
id: "U3RvcDpIU0w6MjMxNDIyNg==",
lat: 60.15706,
lon: 24.72747
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:1069",
shortName: "69",
longName: "Kamppi-Pasila-Käpylä-Malmi-Jakomäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQxNDE1NA==",
lat: 60.26442,
lon: 25.08409
},
{
id: "U3RvcDpIU0w6MTQxNDE1Ng==",
lat: 60.2608,
lon: 25.086
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6MTQxNDE0NA==",
lat: 60.25401,
lon: 25.07816
},
{
id: "U3RvcDpIU0w6MTQxNDE0Mg==",
lat: 60.2538,
lon: 25.07331
},
{
id: "U3RvcDpIU0w6MTQxNDE0MA==",
lat: 60.25535,
lon: 25.06984
},
{
id: "U3RvcDpIU0w6MTQxNDEzOA==",
lat: 60.25918,
lon: 25.07194
},
{
id: "U3RvcDpIU0w6MTQxNDEzNg==",
lat: 60.261686,
lon: 25.075141
},
{
id: "U3RvcDpIU0w6MTQxMzExNw==",
lat: 60.26264,
lon: 25.06834
},
{
id: "U3RvcDpIU0w6MTQxMzExNQ==",
lat: 60.25822,
lon: 25.06413
},
{
id: "U3RvcDpIU0w6MTQxMzExOA==",
lat: 60.255113,
lon: 25.063618
},
{
id: "U3RvcDpIU0w6MTQxMzExMw==",
lat: 60.25228,
lon: 25.06229
},
{
id: "U3RvcDpIU0w6MTM4NTE2Mg==",
lat: 60.24766,
lon: 25.05573
},
{
id: "U3RvcDpIU0w6MTM4NTE1Mg==",
lat: 60.24613,
lon: 25.04853
},
{
id: "U3RvcDpIU0w6MTM4NTE1MA==",
lat: 60.24536,
lon: 25.04458
},
{
id: "U3RvcDpIU0w6MTM4NTE0OA==",
lat: 60.2444,
lon: 25.04001
},
{
id: "U3RvcDpIU0w6MTM4NTE3Mg==",
lat: 60.24514,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTM4NTE3OA==",
lat: 60.247106,
lon: 25.033843
},
{
id: "U3RvcDpIU0w6MTM4NTE3NA==",
lat: 60.249379,
lon: 25.031947
},
{
id: "U3RvcDpIU0w6MTM4MjE4Ng==",
lat: 60.25097,
lon: 25.02561
},
{
id: "U3RvcDpIU0w6MTM4MjE0MQ==",
lat: 60.253556,
lon: 25.02109
},
{
id: "U3RvcDpIU0w6MTM4MjE2Ng==",
lat: 60.2526,
lon: 25.01394
},
{
id: "U3RvcDpIU0w6MTM4MjE2Mw==",
lat: 60.25152,
lon: 25.01215
},
{
id: "U3RvcDpIU0w6MTM4MjE4NQ==",
lat: 60.24996,
lon: 25.01192
},
{
id: "U3RvcDpIU0w6MTM4MjE3MA==",
lat: 60.24865,
lon: 25.01101
},
{
id: "U3RvcDpIU0w6MTM4MTEwMQ==",
lat: 60.25004,
lon: 25.00946
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEwNQ==",
lat: 60.25639,
lon: 24.9975
},
{
id: "U3RvcDpIU0w6MTM5MTEwNA==",
lat: 60.25324,
lon: 24.99371
},
{
id: "U3RvcDpIU0w6MTM3MDEyOA==",
lat: 60.25133,
lon: 24.99443
},
{
id: "U3RvcDpIU0w6MTM3MDExOQ==",
lat: 60.24868,
lon: 24.99755
},
{
id: "U3RvcDpIU0w6MTM3MDExMg==",
lat: 60.24732,
lon: 24.99163
},
{
id: "U3RvcDpIU0w6MTM3MDExMA==",
lat: 60.24324,
lon: 24.99451
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM3MDEwNA==",
lat: 60.2399,
lon: 24.97954
},
{
id: "U3RvcDpIU0w6MTI4NDE3OA==",
lat: 60.23699,
lon: 24.97454
},
{
id: "U3RvcDpIU0w6MTI4NDE3NA==",
lat: 60.23539,
lon: 24.97034
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDE3MQ==",
lat: 60.23073,
lon: 24.95309
},
{
id: "U3RvcDpIU0w6MTI4NDE3MA==",
lat: 60.22954,
lon: 24.95148
},
{
id: "U3RvcDpIU0w6MTI4NDE2OA==",
lat: 60.2276,
lon: 24.95035
},
{
id: "U3RvcDpIU0w6MTI4NDE1NA==",
lat: 60.224304,
lon: 24.951293
},
{
id: "U3RvcDpIU0w6MTI4NDE1Mg==",
lat: 60.222696,
lon: 24.947854
},
{
id: "U3RvcDpIU0w6MTI4NDE1MA==",
lat: 60.22104,
lon: 24.9476
},
{
id: "U3RvcDpIU0w6MTI1MDEyMA==",
lat: 60.21883,
lon: 24.94982
},
{
id: "U3RvcDpIU0w6MTI1MDExOA==",
lat: 60.21619,
lon: 24.95642
},
{
id: "U3RvcDpIU0w6MTI1MDEwOA==",
lat: 60.21436,
lon: 24.95852
},
{
id: "U3RvcDpIU0w6MTI1MDExNg==",
lat: 60.21238,
lon: 24.95536
},
{
id: "U3RvcDpIU0w6MTI1MDExNA==",
lat: 60.21108,
lon: 24.95203
},
{
id: "U3RvcDpIU0w6MTI1MDExMg==",
lat: 60.20938,
lon: 24.94761
},
{
id: "U3RvcDpIU0w6MTI1MDEzMw==",
lat: 60.20863,
lon: 24.94408
},
{
id: "U3RvcDpIU0w6MTE3MzEzMw==",
lat: 60.20753,
lon: 24.93986
},
{
id: "U3RvcDpIU0w6MTE3MzEwOA==",
lat: 60.2026,
lon: 24.9329
},
{
id: "U3RvcDpIU0w6MTE3MzEwNg==",
lat: 60.19989,
lon: 24.93402
},
{
id: "U3RvcDpIU0w6MTE3MzE0OA==",
lat: 60.1977,
lon: 24.93506
},
{
id: "U3RvcDpIU0w6MTEyMjEyNw==",
lat: 60.19505,
lon: 24.93578
},
{
id: "U3RvcDpIU0w6MTE3MTEzNQ==",
lat: 60.19232,
lon: 24.92817
},
{
id: "U3RvcDpIU0w6MTE4MDEyMQ==",
lat: 60.19123,
lon: 24.92366
},
{
id: "U3RvcDpIU0w6MTE0MDEyNQ==",
lat: 60.18934,
lon: 24.9197
},
{
id: "U3RvcDpIU0w6MTE0MDEwNQ==",
lat: 60.18479,
lon: 24.91689
},
{
id: "U3RvcDpIU0w6MTE0MDEyMg==",
lat: 60.17944,
lon: 24.92255
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
},
{
id: "U3RvcDpIU0w6MTA0MDI3NQ==",
lat: 60.169022,
lon: 24.931713
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEwMg==",
lat: 60.180739,
lon: 24.921434
},
{
id: "U3RvcDpIU0w6MTE0MDEwNA==",
lat: 60.18484,
lon: 24.917
},
{
id: "U3RvcDpIU0w6MTE0MDEyNg==",
lat: 60.18928,
lon: 24.92004
},
{
id: "U3RvcDpIU0w6MTE3MTEyMg==",
lat: 60.19145,
lon: 24.92554
},
{
id: "U3RvcDpIU0w6MTE3MTEyMA==",
lat: 60.19249,
lon: 24.93084
},
{
id: "U3RvcDpIU0w6MTE3MzEyNw==",
lat: 60.19699,
lon: 24.93584
},
{
id: "U3RvcDpIU0w6MTE3MzEwNQ==",
lat: 60.19942,
lon: 24.93461
},
{
id: "U3RvcDpIU0w6MTE3MzEwNw==",
lat: 60.20298,
lon: 24.93323
},
{
id: "U3RvcDpIU0w6MTE3MzEzMg==",
lat: 60.20781,
lon: 24.9413
},
{
id: "U3RvcDpIU0w6MTI1MDExMQ==",
lat: 60.20885,
lon: 24.94716
},
{
id: "U3RvcDpIU0w6MTI1MDExMw==",
lat: 60.21096,
lon: 24.95256
},
{
id: "U3RvcDpIU0w6MTI1MDExNQ==",
lat: 60.21249,
lon: 24.95648
},
{
id: "U3RvcDpIU0w6MTI1MDEwNw==",
lat: 60.21474,
lon: 24.95885
},
{
id: "U3RvcDpIU0w6MTI1MDExNw==",
lat: 60.21644,
lon: 24.95597
},
{
id: "U3RvcDpIU0w6MTI1MDExOQ==",
lat: 60.21922,
lon: 24.94948
},
{
id: "U3RvcDpIU0w6MTI4NDE0OQ==",
lat: 60.2207,
lon: 24.94837
},
{
id: "U3RvcDpIU0w6MTI4NDE1MQ==",
lat: 60.223631,
lon: 24.950064
},
{
id: "U3RvcDpIU0w6MTI4NDE4Mg==",
lat: 60.224861,
lon: 24.952464
},
{
id: "U3RvcDpIU0w6MTI4NDE2Nw==",
lat: 60.22751,
lon: 24.95045
},
{
id: "U3RvcDpIU0w6MTI4NDE2OQ==",
lat: 60.22982,
lon: 24.95254
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDE3Mg==",
lat: 60.23425,
lon: 24.96753
},
{
id: "U3RvcDpIU0w6MTI4NDE3NQ==",
lat: 60.23609,
lon: 24.97254
},
{
id: "U3RvcDpIU0w6MTM3MDEwMw==",
lat: 60.23991,
lon: 24.97993
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM3MDEwOQ==",
lat: 60.24398,
lon: 24.99386
},
{
id: "U3RvcDpIU0w6MTM3MDExOA==",
lat: 60.2479,
lon: 24.99219
},
{
id: "U3RvcDpIU0w6MTM3MDEyMA==",
lat: 60.24855,
lon: 24.99734
},
{
id: "U3RvcDpIU0w6MTM4MTExMw==",
lat: 60.25161,
lon: 24.99378
},
{
id: "U3RvcDpIU0w6MTM5MTEwMQ==",
lat: 60.25397,
lon: 24.9941
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwNg==",
lat: 60.25027,
lon: 25.0093
},
{
id: "U3RvcDpIU0w6MTM4MjE2OQ==",
lat: 60.24882,
lon: 25.01278
},
{
id: "U3RvcDpIU0w6MTM4MjE3Ng==",
lat: 60.25049,
lon: 25.01236
},
{
id: "U3RvcDpIU0w6MTM4MjE2NQ==",
lat: 60.25315,
lon: 25.01507
},
{
id: "U3RvcDpIU0w6MTM4MjE0Mg==",
lat: 60.253395,
lon: 25.020997
},
{
id: "U3RvcDpIU0w6MTM4MjE4Nw==",
lat: 60.25091,
lon: 25.02557
},
{
id: "U3RvcDpIU0w6MTM4MjE3NQ==",
lat: 60.24988,
lon: 25.02981
},
{
id: "U3RvcDpIU0w6MTM4MjE3OQ==",
lat: 60.2469,
lon: 25.03371
},
{
id: "U3RvcDpIU0w6MTM4MjE3Mw==",
lat: 60.24484,
lon: 25.03503
},
{
id: "U3RvcDpIU0w6MTM4NDE0Nw==",
lat: 60.24429,
lon: 25.04056
},
{
id: "U3RvcDpIU0w6MTM4NDE0OQ==",
lat: 60.24534,
lon: 25.04537
},
{
id: "U3RvcDpIU0w6MTM4NDE1MQ==",
lat: 60.24642,
lon: 25.05051
},
{
id: "U3RvcDpIU0w6MTM4NDE2MQ==",
lat: 60.24761,
lon: 25.05617
},
{
id: "U3RvcDpIU0w6MTQxMzExMg==",
lat: 60.25305,
lon: 25.06321
},
{
id: "U3RvcDpIU0w6MTQxMzExOQ==",
lat: 60.256148,
lon: 25.06408
},
{
id: "U3RvcDpIU0w6MTQxMzExNA==",
lat: 60.25933,
lon: 25.06483
},
{
id: "U3RvcDpIU0w6MTQxMzExNg==",
lat: 60.26241,
lon: 25.06838
},
{
id: "U3RvcDpIU0w6MTQxMzE1OA==",
lat: 60.26291,
lon: 25.07017
},
{
id: "U3RvcDpIU0w6MTQxNDEzNQ==",
lat: 60.261811,
lon: 25.075388
},
{
id: "U3RvcDpIU0w6MTQxNDEzNw==",
lat: 60.259321,
lon: 25.071821
},
{
id: "U3RvcDpIU0w6MTQxNDEzOQ==",
lat: 60.25497,
lon: 25.06971
},
{
id: "U3RvcDpIU0w6MTQxNDE0MQ==",
lat: 60.25368,
lon: 25.07349
},
{
id: "U3RvcDpIU0w6MTQxNDE0Mw==",
lat: 60.2539,
lon: 25.07806
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6MTQxNDE1NQ==",
lat: 60.26099,
lon: 25.08622
},
{
id: "U3RvcDpIU0w6MTQxNDE0OQ==",
lat: 60.26448,
lon: 25.08393
}
]
},
{
gtfsId: "HSL:2157",
shortName: "157",
longName: "Matinkylä (M)-Suomenoja-Tillinmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxNw==",
lat: 60.160197,
lon: 24.738644
},
{
id: "U3RvcDpIU0w6MjMxNDIyNA==",
lat: 60.15827,
lon: 24.73214
},
{
id: "U3RvcDpIU0w6MjMxNDIyMA==",
lat: 60.15719,
lon: 24.7262
},
{
id: "U3RvcDpIU0w6MjMxNDIyMg==",
lat: 60.16089,
lon: 24.72496
},
{
id: "U3RvcDpIU0w6MjMyMTI1Ng==",
lat: 60.16264,
lon: 24.72254
},
{
id: "U3RvcDpIU0w6MjMyMTIyMw==",
lat: 60.16259,
lon: 24.7208
},
{
id: "U3RvcDpIU0w6MjQzMjIxOA==",
lat: 60.16191,
lon: 24.70958
},
{
id: "U3RvcDpIU0w6MjQzMjI0MA==",
lat: 60.16211,
lon: 24.70565
},
{
id: "U3RvcDpIU0w6MjQzMjIyMA==",
lat: 60.1622,
lon: 24.70074
},
{
id: "U3RvcDpIU0w6MjQzMjIyMQ==",
lat: 60.16172,
lon: 24.6976
},
{
id: "U3RvcDpIU0w6MjQzMjIyOQ==",
lat: 60.15995,
lon: 24.69273
},
{
id: "U3RvcDpIU0w6MjQzMjIyMw==",
lat: 60.15842,
lon: 24.68966
},
{
id: "U3RvcDpIU0w6MjQzNDIyNQ==",
lat: 60.15632,
lon: 24.6807
},
{
id: "U3RvcDpIU0w6MjQzNDIyOA==",
lat: 60.15556,
lon: 24.67205
},
{
id: "U3RvcDpIU0w6MjQzNDIzMA==",
lat: 60.15559,
lon: 24.66702
},
{
id: "U3RvcDpIU0w6MjQzNDIwMw==",
lat: 60.156925,
lon: 24.66224
},
{
id: "U3RvcDpIU0w6MjQzNDIwMQ==",
lat: 60.16333,
lon: 24.66029
},
{
id: "U3RvcDpIU0w6MjQzNDIzMQ==",
lat: 60.16823,
lon: 24.66082
},
{
id: "U3RvcDpIU0w6MjQzNDIxNA==",
lat: 60.170075,
lon: 24.655339
},
{
id: "U3RvcDpIU0w6MjQzNDIxMg==",
lat: 60.170139,
lon: 24.649762
},
{
id: "U3RvcDpIU0w6MjQyMTIwNA==",
lat: 60.168275,
lon: 24.640142
},
{
id: "U3RvcDpIU0w6MjQyMTIwMg==",
lat: 60.16703,
lon: 24.636461
},
{
id: "U3RvcDpIU0w6MjQyMTIwMQ==",
lat: 60.165789,
lon: 24.634247
},
{
id: "U3RvcDpIU0w6MjQyMTIwMw==",
lat: 60.167073,
lon: 24.63678
},
{
id: "U3RvcDpIU0w6MjQyMTIwNQ==",
lat: 60.1684,
lon: 24.642158
},
{
id: "U3RvcDpIU0w6MjQyMTIwNw==",
lat: 60.169878,
lon: 24.648016
},
{
id: "U3RvcDpIU0w6MjQzNDIxMw==",
lat: 60.170234,
lon: 24.656918
},
{
id: "U3RvcDpIU0w6MjQzNDIwMg==",
lat: 60.16658,
lon: 24.66045
},
{
id: "U3RvcDpIU0w6MjQzNDIwNA==",
lat: 60.16229,
lon: 24.6596
},
{
id: "U3RvcDpIU0w6MjQyMTIwNg==",
lat: 60.15662,
lon: 24.66215
},
{
id: "U3RvcDpIU0w6MjQzMjIzMQ==",
lat: 60.15527,
lon: 24.66488
},
{
id: "U3RvcDpIU0w6MjQzNDIyOQ==",
lat: 60.15569,
lon: 24.66917
},
{
id: "U3RvcDpIU0w6MjQzNDIyNw==",
lat: 60.15558,
lon: 24.6744
},
{
id: "U3RvcDpIU0w6MjQzMjIyNg==",
lat: 60.15642,
lon: 24.68264
},
{
id: "U3RvcDpIU0w6MjQzMjIyNA==",
lat: 60.159344,
lon: 24.692096
},
{
id: "U3RvcDpIU0w6MjQzMjIyMg==",
lat: 60.16186,
lon: 24.69937
},
{
id: "U3RvcDpIU0w6MjQzMjIxOQ==",
lat: 60.1618,
lon: 24.7053
},
{
id: "U3RvcDpIU0w6MjQzMjIxNw==",
lat: 60.16173,
lon: 24.71134
},
{
id: "U3RvcDpIU0w6MjMyMTIyNw==",
lat: 60.16215,
lon: 24.72297
},
{
id: "U3RvcDpIU0w6MjMxNDIyMw==",
lat: 60.16015,
lon: 24.72536
},
{
id: "U3RvcDpIU0w6MjMxNDIyNg==",
lat: 60.15706,
lon: 24.72747
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:1067",
shortName: "67",
longName: "Rautatientori-Maunula-Pakila-Torpparinmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMg==",
lat: 60.17085,
lon: 24.94333
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDExMA==",
lat: 60.19226,
lon: 24.96136
},
{
id: "U3RvcDpIU0w6MTIyMDE4MQ==",
lat: 60.19565,
lon: 24.95499
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDEwMw==",
lat: 60.22972,
lon: 24.94197
},
{
id: "U3RvcDpIU0w6MTI4MjEwMQ==",
lat: 60.2301,
lon: 24.93839
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MTEwNw==",
lat: 60.23472,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTM0MTExOA==",
lat: 60.23743,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTM0MTEyNg==",
lat: 60.238695,
lon: 24.934596
},
{
id: "U3RvcDpIU0w6MTM0MTEyOA==",
lat: 60.23973,
lon: 24.94366
},
{
id: "U3RvcDpIU0w6MTM0MTEzNw==",
lat: 60.24206,
lon: 24.94512
},
{
id: "U3RvcDpIU0w6MTM0MTEzMA==",
lat: 60.24415,
lon: 24.94424
},
{
id: "U3RvcDpIU0w6MTM0MTEzMg==",
lat: 60.2466,
lon: 24.94325
},
{
id: "U3RvcDpIU0w6MTM1MTEwOQ==",
lat: 60.249277,
lon: 24.942139
},
{
id: "U3RvcDpIU0w6MTM1MTEyNA==",
lat: 60.2527,
lon: 24.94095
},
{
id: "U3RvcDpIU0w6MTM1MTEyNQ==",
lat: 60.255681,
lon: 24.937717
},
{
id: "U3RvcDpIU0w6MTM1MjE0Mw==",
lat: 60.25638,
lon: 24.94599
},
{
id: "U3RvcDpIU0w6MTM1MjEzNA==",
lat: 60.25605,
lon: 24.95008
},
{
id: "U3RvcDpIU0w6MTM1MjEzNg==",
lat: 60.25723,
lon: 24.95164
},
{
id: "U3RvcDpIU0w6MTM1MjEzOQ==",
lat: 60.25954,
lon: 24.95366
},
{
id: "U3RvcDpIU0w6MTM1MjE0NQ==",
lat: 60.26233,
lon: 24.95158
},
{
id: "U3RvcDpIU0w6MTM1MjE0OA==",
lat: 60.26501,
lon: 24.95544
},
{
id: "U3RvcDpIU0w6MTM1MjE0Ng==",
lat: 60.26232,
lon: 24.95123
},
{
id: "U3RvcDpIU0w6MTM1MjEzOA==",
lat: 60.26032,
lon: 24.95306
},
{
id: "U3RvcDpIU0w6MTM1MjE0Mg==",
lat: 60.25901,
lon: 24.95328
},
{
id: "U3RvcDpIU0w6MTM1MjEzNw==",
lat: 60.25725,
lon: 24.95153
},
{
id: "U3RvcDpIU0w6MTM1MjEzNQ==",
lat: 60.25611,
lon: 24.94961
},
{
id: "U3RvcDpIU0w6MTM1MjE0NA==",
lat: 60.25706,
lon: 24.94409
},
{
id: "U3RvcDpIU0w6MTM1MTEyNw==",
lat: 60.25581,
lon: 24.93762
},
{
id: "U3RvcDpIU0w6MTM1MTEyMg==",
lat: 60.25289,
lon: 24.94031
},
{
id: "U3RvcDpIU0w6MTM1MTEyMw==",
lat: 60.25147,
lon: 24.94151
},
{
id: "U3RvcDpIU0w6MTM1MTExMA==",
lat: 60.249188,
lon: 24.942028
},
{
id: "U3RvcDpIU0w6MTM0MTEzMw==",
lat: 60.24711,
lon: 24.94298
},
{
id: "U3RvcDpIU0w6MTM0MTEzMQ==",
lat: 60.24408,
lon: 24.94407
},
{
id: "U3RvcDpIU0w6MTM0MTEzOA==",
lat: 60.24199,
lon: 24.94492
},
{
id: "U3RvcDpIU0w6MTM0MTEyOQ==",
lat: 60.2397,
lon: 24.94309
},
{
id: "U3RvcDpIU0w6MTM0MTEyNw==",
lat: 60.23903,
lon: 24.93725
},
{
id: "U3RvcDpIU0w6MTM0MTExOQ==",
lat: 60.23664,
lon: 24.92902
},
{
id: "U3RvcDpIU0w6MTI4MjEwNg==",
lat: 60.23351,
lon: 24.93171
},
{
id: "U3RvcDpIU0w6MTI4MjEwNA==",
lat: 60.23154,
lon: 24.93381
},
{
id: "U3RvcDpIU0w6MTI4MjEwMg==",
lat: 60.23011,
lon: 24.9378
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4576",
shortName: "576",
longName: "Tikkurila-Seutula-Kivistö",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDYxMDI0Ng==",
lat: 60.293577,
lon: 25.044313
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIyNg==",
lat: 60.29163,
lon: 25.0366
},
{
id: "U3RvcDpIU0w6NDYxMDIyMA==",
lat: 60.28947,
lon: 25.03306
},
{
id: "U3RvcDpIU0w6NDYzMDIxNg==",
lat: 60.28976,
lon: 25.02777
},
{
id: "U3RvcDpIU0w6NDYzMDIxNA==",
lat: 60.2912,
lon: 25.02122
},
{
id: "U3RvcDpIU0w6NDYzMDIxMg==",
lat: 60.29205,
lon: 25.0157
},
{
id: "U3RvcDpIU0w6NDY4MDIyOA==",
lat: 60.29215,
lon: 25.01095
},
{
id: "U3RvcDpIU0w6NDY4MDI0Ng==",
lat: 60.29289,
lon: 25.00565
},
{
id: "U3RvcDpIU0w6NDY4MDIxMg==",
lat: 60.2962,
lon: 25.00451
},
{
id: "U3RvcDpIU0w6NDY4MDIxMA==",
lat: 60.298588,
lon: 25.00389
},
{
id: "U3RvcDpIU0w6NDY4MDI0MA==",
lat: 60.30131,
lon: 25.00067
},
{
id: "U3RvcDpIU0w6NDY4MDIzNg==",
lat: 60.29965,
lon: 24.99553
},
{
id: "U3RvcDpIU0w6NDUyMDI0Ng==",
lat: 60.30151,
lon: 24.98797
},
{
id: "U3RvcDpIU0w6NDUyMDI0OA==",
lat: 60.30245,
lon: 24.98202
},
{
id: "U3RvcDpIU0w6NDUzMDIxNA==",
lat: 60.30521,
lon: 24.97639
},
{
id: "U3RvcDpIU0w6NDUzMDIwMw==",
lat: 60.30645,
lon: 24.97014
},
{
id: "U3RvcDpIU0w6NDUzMDIyMQ==",
lat: 60.307879,
lon: 24.960343
},
{
id: "U3RvcDpIU0w6NDUyMDI2Nw==",
lat: 60.304895,
lon: 24.957404
},
{
id: "U3RvcDpIU0w6NDUyMDI2NQ==",
lat: 60.303237,
lon: 24.95592
},
{
id: "U3RvcDpIU0w6NDUyMDIzNw==",
lat: 60.302312,
lon: 24.952512
},
{
id: "U3RvcDpIU0w6NDQxMDIzOA==",
lat: 60.302688,
lon: 24.939267
},
{
id: "U3RvcDpIU0w6NDQxMDI0MA==",
lat: 60.30085,
lon: 24.93199
},
{
id: "U3RvcDpIU0w6NDQxMDI0Mg==",
lat: 60.30218,
lon: 24.92453
},
{
id: "U3RvcDpIU0w6NDQxMDI1NQ==",
lat: 60.303681,
lon: 24.91639
},
{
id: "U3RvcDpIU0w6NDQxMDI0NA==",
lat: 60.30373,
lon: 24.91087
},
{
id: "U3RvcDpIU0w6NDQxMDI0Ng==",
lat: 60.30402,
lon: 24.90662
},
{
id: "U3RvcDpIU0w6NDQxMDI0OA==",
lat: 60.30737,
lon: 24.89704
},
{
id: "U3RvcDpIU0w6NDQxMDI2Mw==",
lat: 60.308548,
lon: 24.889088
},
{
id: "U3RvcDpIU0w6NDUzMDI1NQ==",
lat: 60.31696,
lon: 24.90548
},
{
id: "U3RvcDpIU0w6NDUzMDI1Ng==",
lat: 60.31959,
lon: 24.91317
},
{
id: "U3RvcDpIU0w6NDQxMDIwNA==",
lat: 60.32243,
lon: 24.91681
},
{
id: "U3RvcDpIU0w6NDQxMDIwMg==",
lat: 60.32612,
lon: 24.91986
},
{
id: "U3RvcDpIU0w6NDM0MDIxMA==",
lat: 60.33663,
lon: 24.92258
},
{
id: "U3RvcDpIU0w6NDM0MDIwOA==",
lat: 60.3421,
lon: 24.92019
},
{
id: "U3RvcDpIU0w6NDM0MDIwNg==",
lat: 60.3442,
lon: 24.91788
},
{
id: "U3RvcDpIU0w6NDM0MDIyMA==",
lat: 60.34662,
lon: 24.91441
},
{
id: "U3RvcDpIU0w6NDM0MDIwNA==",
lat: 60.34916,
lon: 24.90328
},
{
id: "U3RvcDpIU0w6NDM0MDIwMg==",
lat: 60.34886,
lon: 24.89715
},
{
id: "U3RvcDpIU0w6NDMzMDIwOA==",
lat: 60.34761,
lon: 24.88353
},
{
id: "U3RvcDpIU0w6NDMzMDIwNg==",
lat: 60.34783,
lon: 24.87616
},
{
id: "U3RvcDpIU0w6NDMzMDIxMw==",
lat: 60.34795,
lon: 24.87113
},
{
id: "U3RvcDpIU0w6NDMzMDIwMg==",
lat: 60.34726,
lon: 24.86524
},
{
id: "U3RvcDpIU0w6NDI0MDIxMg==",
lat: 60.34255,
lon: 24.8648
},
{
id: "U3RvcDpIU0w6NDI0MDIwMg==",
lat: 60.33933,
lon: 24.86453
},
{
id: "U3RvcDpIU0w6NDI0MDIxMA==",
lat: 60.33669,
lon: 24.86352
},
{
id: "U3RvcDpIU0w6NDI0MDIxOA==",
lat: 60.33296,
lon: 24.86257
},
{
id: "U3RvcDpIU0w6NDI0MDIwOA==",
lat: 60.33036,
lon: 24.86273
},
{
id: "U3RvcDpIU0w6NDIzMDIzMg==",
lat: 60.32947,
lon: 24.8619
},
{
id: "U3RvcDpIU0w6NDIzMDIzMA==",
lat: 60.32875,
lon: 24.85569
},
{
id: "U3RvcDpIU0w6NDIzMDIyNg==",
lat: 60.32921,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDIzMDIyNA==",
lat: 60.32753,
lon: 24.85013
},
{
id: "U3RvcDpIU0w6NDIzMDIyMg==",
lat: 60.32522,
lon: 24.84962
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mg==",
lat: 60.323571,
lon: 24.851449
},
{
id: "U3RvcDpIU0w6NDIzMDI0MA==",
lat: 60.321997,
lon: 24.85308
},
{
id: "U3RvcDpIU0w6NDIzMDIzNg==",
lat: 60.320142,
lon: 24.855659
},
{
id: "U3RvcDpIU0w6NDIzMDIzNA==",
lat: 60.317929,
lon: 24.850801
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIzMDIzMw==",
lat: 60.318549,
lon: 24.85235
},
{
id: "U3RvcDpIU0w6NDIzMDIzNw==",
lat: 60.320869,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDIzMDI0MQ==",
lat: 60.322051,
lon: 24.853239
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mw==",
lat: 60.323765,
lon: 24.850455
},
{
id: "U3RvcDpIU0w6NDIzMDIyMQ==",
lat: 60.32615,
lon: 24.8498
},
{
id: "U3RvcDpIU0w6NDIzMDIyMw==",
lat: 60.32798,
lon: 24.85087
},
{
id: "U3RvcDpIU0w6NDIzMDIyOQ==",
lat: 60.32945,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDIzMDIzMQ==",
lat: 60.3282,
lon: 24.85841
},
{
id: "U3RvcDpIU0w6NDI0MDIwNw==",
lat: 60.331,
lon: 24.86291
},
{
id: "U3RvcDpIU0w6NDI0MDIxNw==",
lat: 60.33357,
lon: 24.86305
},
{
id: "U3RvcDpIU0w6NDI0MDIwOQ==",
lat: 60.3372,
lon: 24.86399
},
{
id: "U3RvcDpIU0w6NDI0MDIxOQ==",
lat: 60.34067,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6NDI0MDIxMQ==",
lat: 60.34244,
lon: 24.86512
},
{
id: "U3RvcDpIU0w6NDMzMDIwMw==",
lat: 60.34775,
lon: 24.86668
},
{
id: "U3RvcDpIU0w6NDMzMDIxMg==",
lat: 60.34782,
lon: 24.87282
},
{
id: "U3RvcDpIU0w6NDMzMDIwNQ==",
lat: 60.34765,
lon: 24.87818
},
{
id: "U3RvcDpIU0w6NDMzMDIwNw==",
lat: 60.34752,
lon: 24.88455
},
{
id: "U3RvcDpIU0w6NDM0MDIwMQ==",
lat: 60.34889,
lon: 24.89936
},
{
id: "U3RvcDpIU0w6NDM0MDIwMw==",
lat: 60.34905,
lon: 24.90458
},
{
id: "U3RvcDpIU0w6NDM0MDIyMQ==",
lat: 60.34594,
lon: 24.91468
},
{
id: "U3RvcDpIU0w6NDM0MDIwNQ==",
lat: 60.34367,
lon: 24.91891
},
{
id: "U3RvcDpIU0w6NDM0MDIwNw==",
lat: 60.34124,
lon: 24.92037
},
{
id: "U3RvcDpIU0w6NDM0MDIwOQ==",
lat: 60.33572,
lon: 24.92308
},
{
id: "U3RvcDpIU0w6NDQxMDIwMQ==",
lat: 60.32492,
lon: 24.9186
},
{
id: "U3RvcDpIU0w6NDQxMDIwMw==",
lat: 60.32137,
lon: 24.91558
},
{
id: "U3RvcDpIU0w6NDQxMDIwNg==",
lat: 60.31869,
lon: 24.91055
},
{
id: "U3RvcDpIU0w6NDQxMDIwNQ==",
lat: 60.31651,
lon: 24.90261
},
{
id: "U3RvcDpIU0w6NDQxMDI2Mg==",
lat: 60.30795,
lon: 24.88963
},
{
id: "U3RvcDpIU0w6NDQxMDI2NQ==",
lat: 60.308278,
lon: 24.892956
},
{
id: "U3RvcDpIU0w6NDQxMDI0Nw==",
lat: 60.30673,
lon: 24.89899
},
{
id: "U3RvcDpIU0w6NDQxMDI0NQ==",
lat: 60.30352,
lon: 24.9088
},
{
id: "U3RvcDpIU0w6NDQxMDI0Mw==",
lat: 60.30359,
lon: 24.9132
},
{
id: "U3RvcDpIU0w6NDQxMDI1Ng==",
lat: 60.303559,
lon: 24.917561
},
{
id: "U3RvcDpIU0w6NDQxMDI0MQ==",
lat: 60.30161,
lon: 24.92572
},
{
id: "U3RvcDpIU0w6NDQxMDIzOQ==",
lat: 60.30078,
lon: 24.93357
},
{
id: "U3RvcDpIU0w6NDUyMDI5OQ==",
lat: 60.3027,
lon: 24.9422
},
{
id: "U3RvcDpIU0w6NDUyMDIzOA==",
lat: 60.302153,
lon: 24.952562
},
{
id: "U3RvcDpIU0w6NDUyMDIzNg==",
lat: 60.303301,
lon: 24.956282
},
{
id: "U3RvcDpIU0w6NDUyMDI2OA==",
lat: 60.306115,
lon: 24.958895
},
{
id: "U3RvcDpIU0w6NDUzMDIzOA==",
lat: 60.307855,
lon: 24.962
},
{
id: "U3RvcDpIU0w6NDUzMDIwNA==",
lat: 60.30626,
lon: 24.96955
},
{
id: "U3RvcDpIU0w6NDUzMDIxNQ==",
lat: 60.30483,
lon: 24.97647
},
{
id: "U3RvcDpIU0w6NDUyMDI0Nw==",
lat: 60.30173,
lon: 24.98498
},
{
id: "U3RvcDpIU0w6NDY4MDIzNw==",
lat: 60.30016,
lon: 24.99176
},
{
id: "U3RvcDpIU0w6NDY4MDIzNQ==",
lat: 60.29945,
lon: 24.99539
},
{
id: "U3RvcDpIU0w6NDY4MDI0MQ==",
lat: 60.30123,
lon: 25.00077
},
{
id: "U3RvcDpIU0w6NDY4MDIwOQ==",
lat: 60.298302,
lon: 25.003807
},
{
id: "U3RvcDpIU0w6NDY4MDIxMQ==",
lat: 60.295863,
lon: 25.004585
},
{
id: "U3RvcDpIU0w6NDY4MDI1OA==",
lat: 60.293707,
lon: 25.005245
},
{
id: "U3RvcDpIU0w6NDY4MDIwMw==",
lat: 60.29196,
lon: 25.00701
},
{
id: "U3RvcDpIU0w6NDY4MDIyNw==",
lat: 60.29201,
lon: 25.01294
},
{
id: "U3RvcDpIU0w6NDYzMDIxMQ==",
lat: 60.29154,
lon: 25.01791
},
{
id: "U3RvcDpIU0w6NDYzMDIyNw==",
lat: 60.290493,
lon: 25.023712
},
{
id: "U3RvcDpIU0w6NDYzMDIxNQ==",
lat: 60.2896,
lon: 25.02769
},
{
id: "U3RvcDpIU0w6NDYxMDIxOQ==",
lat: 60.28924,
lon: 25.03163
},
{
id: "U3RvcDpIU0w6NDYxMDIyNQ==",
lat: 60.29093,
lon: 25.03651
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
}
]
},
{
gtfsId: "HSL:4335",
shortName: "335",
longName: "Linnainen-Vapaala-Myyrmäki-Louhela-Martinlaakso-Askisto",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDEwMDIwNg==",
lat: 60.24926,
lon: 24.78093
},
{
id: "U3RvcDpIU0w6NDEwMDIwNA==",
lat: 60.2509,
lon: 24.77951
},
{
id: "U3RvcDpIU0w6NDEwMDIwMg==",
lat: 60.2526,
lon: 24.77889
},
{
id: "U3RvcDpIU0w6NDEwMDIxMA==",
lat: 60.25474,
lon: 24.78064
},
{
id: "U3RvcDpIU0w6NDEyMDI5MA==",
lat: 60.25438,
lon: 24.79724
},
{
id: "U3RvcDpIU0w6NDEyMDI4OA==",
lat: 60.25537,
lon: 24.80147
},
{
id: "U3RvcDpIU0w6NDEyMDIwNg==",
lat: 60.25537,
lon: 24.80804
},
{
id: "U3RvcDpIU0w6NDEyMDIwNw==",
lat: 60.25811,
lon: 24.80891
},
{
id: "U3RvcDpIU0w6NDEyMDIzOA==",
lat: 60.26287,
lon: 24.80655
},
{
id: "U3RvcDpIU0w6NDE0MDIwNw==",
lat: 60.26495,
lon: 24.81334
},
{
id: "U3RvcDpIU0w6NDEzMDI5OA==",
lat: 60.26236,
lon: 24.8164
},
{
id: "U3RvcDpIU0w6NDEzMDIyOQ==",
lat: 60.25891,
lon: 24.81948
},
{
id: "U3RvcDpIU0w6NDEzMDIzMA==",
lat: 60.26087,
lon: 24.82194
},
{
id: "U3RvcDpIU0w6NDEzMDIxOQ==",
lat: 60.26319,
lon: 24.82548
},
{
id: "U3RvcDpIU0w6NDEzMDIyNg==",
lat: 60.26335,
lon: 24.82955
},
{
id: "U3RvcDpIU0w6NDEzMDIxNg==",
lat: 60.26113,
lon: 24.83245
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDI2MQ==",
lat: 60.26134,
lon: 24.85541
},
{
id: "U3RvcDpIU0w6NDE1MDIyMA==",
lat: 60.26371,
lon: 24.85947
},
{
id: "U3RvcDpIU0w6NDE2MDIyNg==",
lat: 60.26548,
lon: 24.86497
},
{
id: "U3RvcDpIU0w6NDE1MDIzMA==",
lat: 60.26948,
lon: 24.85788
},
{
id: "U3RvcDpIU0w6NDE1MDI1OQ==",
lat: 60.27046,
lon: 24.854602
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNQ==",
lat: 60.27027,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDIwMDIwMQ==",
lat: 60.27705,
lon: 24.80344
},
{
id: "U3RvcDpIU0w6NDIwMDIwMw==",
lat: 60.28351,
lon: 24.79137
},
{
id: "U3RvcDpIU0w6NDIwMDIxMQ==",
lat: 60.28576,
lon: 24.78543
},
{
id: "U3RvcDpIU0w6NDIwMDIwOQ==",
lat: 60.28095,
lon: 24.78441
},
{
id: "U3RvcDpIU0w6NDIwMDIxMw==",
lat: 60.27662,
lon: 24.77807
},
{
id: "U3RvcDpIU0w6NDEyMDIyMQ==",
lat: 60.27463,
lon: 24.77941
},
{
id: "U3RvcDpIU0w6NDIwMDIxNA==",
lat: 60.27739,
lon: 24.77876
},
{
id: "U3RvcDpIU0w6NDIwMDIxMA==",
lat: 60.28186,
lon: 24.78524
},
{
id: "U3RvcDpIU0w6NDIwMDIxMg==",
lat: 60.28542,
lon: 24.78564
},
{
id: "U3RvcDpIU0w6NDIwMDIwNg==",
lat: 60.28661,
lon: 24.78718
},
{
id: "U3RvcDpIU0w6NDIwMDIwNA==",
lat: 60.28288,
lon: 24.79207
},
{
id: "U3RvcDpIU0w6NDIwMDIwMg==",
lat: 60.27836,
lon: 24.80175
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDI0NA==",
lat: 60.27712,
lon: 24.85322
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIxNg==",
lat: 60.270447,
lon: 24.855295
},
{
id: "U3RvcDpIU0w6NDE1MDIxOA==",
lat: 60.2703,
lon: 24.85623
},
{
id: "U3RvcDpIU0w6NDE1MDIzMQ==",
lat: 60.26866,
lon: 24.85922
},
{
id: "U3RvcDpIU0w6NDE2MDIyNw==",
lat: 60.26541,
lon: 24.86472
},
{
id: "U3RvcDpIU0w6NDE1MDIxOQ==",
lat: 60.26394,
lon: 24.85928
},
{
id: "U3RvcDpIU0w6NDE1MDI2NA==",
lat: 60.260577,
lon: 24.856522
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIyOA==",
lat: 60.25939,
lon: 24.83438
},
{
id: "U3RvcDpIU0w6NDEzMDIxNQ==",
lat: 60.26118,
lon: 24.83262
},
{
id: "U3RvcDpIU0w6NDEzMDIxNw==",
lat: 60.2627,
lon: 24.83038
},
{
id: "U3RvcDpIU0w6NDEzMDIxOA==",
lat: 60.26395,
lon: 24.82646
},
{
id: "U3RvcDpIU0w6NDEzMDIyNQ==",
lat: 60.2625,
lon: 24.82428
},
{
id: "U3RvcDpIU0w6NDEzMDIyMA==",
lat: 60.26046,
lon: 24.82129
},
{
id: "U3RvcDpIU0w6NDEzMDIyMQ==",
lat: 60.259,
lon: 24.81846
},
{
id: "U3RvcDpIU0w6NDEzMDIyNw==",
lat: 60.26245,
lon: 24.81644
},
{
id: "U3RvcDpIU0w6NDE0MDI5Nw==",
lat: 60.26424,
lon: 24.81541
},
{
id: "U3RvcDpIU0w6NDE0MDIwOA==",
lat: 60.2649,
lon: 24.81288
},
{
id: "U3RvcDpIU0w6NDEyMDIxMA==",
lat: 60.26149,
lon: 24.80645
},
{
id: "U3RvcDpIU0w6NDEyMDIwOA==",
lat: 60.25673,
lon: 24.80958
},
{
id: "U3RvcDpIU0w6NDEyMDIwNQ==",
lat: 60.25572,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDI5MQ==",
lat: 60.25508,
lon: 24.79965
},
{
id: "U3RvcDpIU0w6NDEwMDIwNw==",
lat: 60.25419,
lon: 24.79491
},
{
id: "U3RvcDpIU0w6NDEwMDIwOA==",
lat: 60.25421,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6NDEwMDIwMQ==",
lat: 60.253,
lon: 24.77847
},
{
id: "U3RvcDpIU0w6NDEwMDIwMw==",
lat: 60.25039,
lon: 24.77977
}
]
},
{
gtfsId: "HSL:2114N",
shortName: "114N",
longName: "Kamppi-Leppävaara",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIzMA==",
lat: 60.21927,
lon: 24.81018
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIzNQ==",
lat: 60.22324,
lon: 24.78682
},
{
id: "U3RvcDpIU0w6MjEzMjI0Ng==",
lat: 60.21935,
lon: 24.78619
},
{
id: "U3RvcDpIU0w6MjEzMjI0NA==",
lat: 60.21692,
lon: 24.78652
},
{
id: "U3RvcDpIU0w6MjEzMjI0Mg==",
lat: 60.21727,
lon: 24.78061
},
{
id: "U3RvcDpIU0w6MjEzMjI0MA==",
lat: 60.21709,
lon: 24.77504
},
{
id: "U3RvcDpIU0w6MjEzMTI0MA==",
lat: 60.21447,
lon: 24.77096
},
{
id: "U3RvcDpIU0w6MjEzMTI0Mg==",
lat: 60.2117,
lon: 24.76733
},
{
id: "U3RvcDpIU0w6MjEzMTI0NA==",
lat: 60.21154,
lon: 24.76284
},
{
id: "U3RvcDpIU0w6MjEzMTI0Ng==",
lat: 60.20944,
lon: 24.75608
},
{
id: "U3RvcDpIU0w6MjEzMTI0OA==",
lat: 60.20843,
lon: 24.75262
},
{
id: "U3RvcDpIU0w6MjEzMTI1MA==",
lat: 60.207094,
lon: 24.752523
},
{
id: "U3RvcDpIU0w6MjI0MjIxMA==",
lat: 60.20325,
lon: 24.76069
},
{
id: "U3RvcDpIU0w6MjI0MjIwOA==",
lat: 60.19894,
lon: 24.76333
},
{
id: "U3RvcDpIU0w6MjI0MTIwNg==",
lat: 60.1964,
lon: 24.76588
},
{
id: "U3RvcDpIU0w6MjI0MTIwNA==",
lat: 60.19414,
lon: 24.76971
},
{
id: "U3RvcDpIU0w6MjI0MTIwMg==",
lat: 60.190816,
lon: 24.776774
},
{
id: "U3RvcDpIU0w6MjIxNTI1NQ==",
lat: 60.18678,
lon: 24.78434
},
{
id: "U3RvcDpIU0w6MjIxNTI1OQ==",
lat: 60.18295,
lon: 24.78943
},
{
id: "U3RvcDpIU0w6MjIxMjIxOQ==",
lat: 60.18154,
lon: 24.79584
},
{
id: "U3RvcDpIU0w6MjIxMjIxNw==",
lat: 60.17822,
lon: 24.79887
},
{
id: "U3RvcDpIU0w6MjIxMjIxNQ==",
lat: 60.1759,
lon: 24.80008
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMTIzNg==",
lat: 60.17364,
lon: 24.81027
},
{
id: "U3RvcDpIU0w6MjIxMTIzOA==",
lat: 60.17046,
lon: 24.81056
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
},
{
id: "U3RvcDpIU0w6MTA0MDI3Ng==",
lat: 60.169,
lon: 24.93164
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTIzNw==",
lat: 60.17083,
lon: 24.81079
},
{
id: "U3RvcDpIU0w6MjIxMTIzNQ==",
lat: 60.17359,
lon: 24.81072
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMjIxNg==",
lat: 60.17928,
lon: 24.79851
},
{
id: "U3RvcDpIU0w6MjIxMjIxOA==",
lat: 60.18134,
lon: 24.79634
},
{
id: "U3RvcDpIU0w6MjIxNTI1Nw==",
lat: 60.18286,
lon: 24.79364
},
{
id: "U3RvcDpIU0w6MjIxNTI1Mw==",
lat: 60.1837,
lon: 24.78701
},
{
id: "U3RvcDpIU0w6MjIxNTI1NA==",
lat: 60.18768,
lon: 24.78284
},
{
id: "U3RvcDpIU0w6MjI0MTIwMQ==",
lat: 60.19135,
lon: 24.77608
},
{
id: "U3RvcDpIU0w6MjI0MTIwMw==",
lat: 60.19464,
lon: 24.76877
},
{
id: "U3RvcDpIU0w6MjI0MTIwNQ==",
lat: 60.19723,
lon: 24.76565
},
{
id: "U3RvcDpIU0w6MjI0MjIwNw==",
lat: 60.20009,
lon: 24.76279
},
{
id: "U3RvcDpIU0w6MjI0MjIwOQ==",
lat: 60.20413,
lon: 24.75998
},
{
id: "U3RvcDpIU0w6MjEzMTI1Nw==",
lat: 60.207166,
lon: 24.75329
},
{
id: "U3RvcDpIU0w6MjEzMTI0OQ==",
lat: 60.208477,
lon: 24.7532
},
{
id: "U3RvcDpIU0w6MjEzMTI0Nw==",
lat: 60.20968,
lon: 24.75843
},
{
id: "U3RvcDpIU0w6MjEzMTI0NQ==",
lat: 60.21167,
lon: 24.76432
},
{
id: "U3RvcDpIU0w6MjEzMTI0Mw==",
lat: 60.21193,
lon: 24.7701
},
{
id: "U3RvcDpIU0w6MjEzMTI0MQ==",
lat: 60.21501,
lon: 24.77174
},
{
id: "U3RvcDpIU0w6MjEzMjI0MQ==",
lat: 60.217,
lon: 24.77535
},
{
id: "U3RvcDpIU0w6MjEzMjI0Mw==",
lat: 60.21708,
lon: 24.78087
},
{
id: "U3RvcDpIU0w6MjEzMjI0NQ==",
lat: 60.21688,
lon: 24.78694
},
{
id: "U3RvcDpIU0w6MjEzMjI0Nw==",
lat: 60.22037,
lon: 24.7856
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIwMA==",
lat: 60.22015,
lon: 24.80185
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:7848",
shortName: "848",
longName: "Kamppi-Pasila-Viikki-Söderkulla-Porvoo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDEyNg==",
lat: 60.18928,
lon: 24.92004
},
{
id: "U3RvcDpIU0w6MTE3MTEyMg==",
lat: 60.19145,
lon: 24.92554
},
{
id: "U3RvcDpIU0w6MTE3MTEyMA==",
lat: 60.19249,
lon: 24.93084
},
{
id: "U3RvcDpIU0w6MTE3MzEyNw==",
lat: 60.19699,
lon: 24.93584
},
{
id: "U3RvcDpIU0w6MTE3MzEwNQ==",
lat: 60.19942,
lon: 24.93461
},
{
id: "U3RvcDpIU0w6MTE3MzEwNw==",
lat: 60.20298,
lon: 24.93323
},
{
id: "U3RvcDpIU0w6MTE3MzEzMg==",
lat: 60.20781,
lon: 24.9413
},
{
id: "U3RvcDpIU0w6MTI1MDExMQ==",
lat: 60.20885,
lon: 24.94716
},
{
id: "U3RvcDpIU0w6MTI1MDExMw==",
lat: 60.21096,
lon: 24.95256
},
{
id: "U3RvcDpIU0w6MTI1MDExNQ==",
lat: 60.21249,
lon: 24.95648
},
{
id: "U3RvcDpIU0w6MTI0MDEwMQ==",
lat: 60.2149,
lon: 24.96463
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6OTIxMDIwNA==",
lat: 60.280193,
lon: 25.293077
},
{
id: "U3RvcDpIU0w6OTIxMDIwNw==",
lat: 60.285534,
lon: 25.300471
},
{
id: "U3RvcDpIU0w6OTIxMDIxMA==",
lat: 60.290757,
lon: 25.308611
},
{
id: "U3RvcDpIU0w6OTIxMDIxMg==",
lat: 60.292936,
lon: 25.313265
},
{
id: "U3RvcDpIU0w6OTIwODIxMQ==",
lat: 60.297276,
lon: 25.324799
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1Nw==",
lat: 60.298,
lon: 25.339552
},
{
id: "U3RvcDpIU0w6OTIwODI1MA==",
lat: 60.296725,
lon: 25.350455
},
{
id: "U3RvcDpIU0w6OTIwODIzMA==",
lat: 60.29683,
lon: 25.35423
},
{
id: "U3RvcDpIU0w6OTIwODIzMg==",
lat: 60.29856,
lon: 25.358295
},
{
id: "U3RvcDpIU0w6OTIxMzIwNA==",
lat: 60.30139,
lon: 25.364787
},
{
id: "U3RvcDpIU0w6OTIxMzIwNg==",
lat: 60.304287,
lon: 25.371417
},
{
id: "U3RvcDpIU0w6OTIxMzIxMg==",
lat: 60.307833,
lon: 25.379585
},
{
id: "U3RvcDpIU0w6OTIxMzIzMg==",
lat: 60.311137,
lon: 25.38733
},
{
id: "U3RvcDpIU0w6OTIxMzIyMg==",
lat: 60.313973,
lon: 25.396065
},
{
id: "U3RvcDpIU0w6OTIxMzIyNQ==",
lat: 60.316917,
lon: 25.404262
},
{
id: "U3RvcDpIU0w6OTIxMzIyOQ==",
lat: 60.324018,
lon: 25.426659
},
{
id: "U3RvcDpIU0w6OTMwMDIwNA==",
lat: 60.39315,
lon: 25.664254
},
{
id: "U3RvcDpIU0w6OTIxMzIyOA==",
lat: 60.323612,
lon: 25.42363
},
{
id: "U3RvcDpIU0w6OTIxMzIyNA==",
lat: 60.316917,
lon: 25.402539
},
{
id: "U3RvcDpIU0w6OTIxMzIyMA==",
lat: 60.313969,
lon: 25.394391
},
{
id: "U3RvcDpIU0w6OTIxMzIxMw==",
lat: 60.311393,
lon: 25.38738
},
{
id: "U3RvcDpIU0w6OTIxMzIxMA==",
lat: 60.307273,
lon: 25.377832
},
{
id: "U3RvcDpIU0w6OTIxMzIwNw==",
lat: 60.304748,
lon: 25.372035
},
{
id: "U3RvcDpIU0w6OTIxMzIwMw==",
lat: 60.301112,
lon: 25.36366
},
{
id: "U3RvcDpIU0w6OTIwODIzMw==",
lat: 60.299153,
lon: 25.359143
},
{
id: "U3RvcDpIU0w6OTIwODIzMQ==",
lat: 60.297247,
lon: 25.354823
},
{
id: "U3RvcDpIU0w6OTIwODI1MQ==",
lat: 60.297067,
lon: 25.347959
},
{
id: "U3RvcDpIU0w6OTIwODI1Ng==",
lat: 60.298387,
lon: 25.337094
},
{
id: "U3RvcDpIU0w6OTIwODIxNA==",
lat: 60.298227,
lon: 25.329072
},
{
id: "U3RvcDpIU0w6OTIwODIxMA==",
lat: 60.297008,
lon: 25.322927
},
{
id: "U3RvcDpIU0w6OTIxMDIxMQ==",
lat: 60.292553,
lon: 25.311915
},
{
id: "U3RvcDpIU0w6OTIxMDIwOQ==",
lat: 60.290293,
lon: 25.307124
},
{
id: "U3RvcDpIU0w6OTIxMDIwOA==",
lat: 60.287115,
lon: 25.301985
},
{
id: "U3RvcDpIU0w6OTIxMDIwNg==",
lat: 60.284302,
lon: 25.298328
},
{
id: "U3RvcDpIU0w6OTIxMDIwMw==",
lat: 60.279217,
lon: 25.291527
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI2MDEwMg==",
lat: 60.21515,
lon: 24.96438
},
{
id: "U3RvcDpIU0w6MTI1MDExNg==",
lat: 60.21238,
lon: 24.95536
},
{
id: "U3RvcDpIU0w6MTI1MDExNA==",
lat: 60.21108,
lon: 24.95203
},
{
id: "U3RvcDpIU0w6MTI1MDExMg==",
lat: 60.20938,
lon: 24.94761
},
{
id: "U3RvcDpIU0w6MTI1MDEzMw==",
lat: 60.20863,
lon: 24.94408
},
{
id: "U3RvcDpIU0w6MTE3MzEzMw==",
lat: 60.20753,
lon: 24.93986
},
{
id: "U3RvcDpIU0w6MTE3MzEwOA==",
lat: 60.2026,
lon: 24.9329
},
{
id: "U3RvcDpIU0w6MTE3MzEwNg==",
lat: 60.19989,
lon: 24.93402
},
{
id: "U3RvcDpIU0w6MTE3MzE0OA==",
lat: 60.1977,
lon: 24.93506
},
{
id: "U3RvcDpIU0w6MTEyMjEyNw==",
lat: 60.19505,
lon: 24.93578
},
{
id: "U3RvcDpIU0w6MTE3MTEzNQ==",
lat: 60.19232,
lon: 24.92817
},
{
id: "U3RvcDpIU0w6MTE4MDEyMQ==",
lat: 60.19123,
lon: 24.92366
},
{
id: "U3RvcDpIU0w6MTE0MDEyNQ==",
lat: 60.18934,
lon: 24.9197
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
}
]
},
{
gtfsId: "HSL:9987B",
shortName: "987B",
longName: "Nikkilä-Pornainen",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyMjI1OQ==",
lat: 60.375139,
lon: 25.267128
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwOA==",
lat: 60.386435,
lon: 25.282542
},
{
id: "U3RvcDpIU0w6OTIyOTIwMw==",
lat: 60.390658,
lon: 25.291292
},
{
id: "U3RvcDpIU0w6OTIyOTIwNg==",
lat: 60.393408,
lon: 25.296543
},
{
id: "U3RvcDpIU0w6OTIyOTIwOA==",
lat: 60.396172,
lon: 25.298523
},
{
id: "U3RvcDpIU0w6OTIyNTIwMw==",
lat: 60.402635,
lon: 25.299295
},
{
id: "U3RvcDpIU0w6OTIyNTIwNQ==",
lat: 60.406127,
lon: 25.30665
},
{
id: "U3RvcDpIU0w6OTIyNTIwNg==",
lat: 60.40681,
lon: 25.315015
},
{
id: "U3RvcDpIU0w6OTIyNTIwOA==",
lat: 60.40889,
lon: 25.318735
},
{
id: "U3RvcDpIU0w6OTIyNTIwOQ==",
lat: 60.410377,
lon: 25.321968
},
{
id: "U3RvcDpIU0w6OTIyNTIxMg==",
lat: 60.41308,
lon: 25.328807
},
{
id: "U3RvcDpIU0w6OTIyNTIxNA==",
lat: 60.416008,
lon: 25.330725
},
{
id: "U3RvcDpIU0w6OTIyNTIxNQ==",
lat: 60.418978,
lon: 25.332633
},
{
id: "U3RvcDpIU0w6OTIyNTIxOA==",
lat: 60.425025,
lon: 25.338565
},
{
id: "U3RvcDpIU0w6OTQwMDIxMQ==",
lat: 60.435523,
lon: 25.368753
},
{
id: "U3RvcDpIU0w6OTQwMDIwNQ==",
lat: 60.432417,
lon: 25.399457
},
{
id: "U3RvcDpIU0w6OTQwMDIwOA==",
lat: 60.477653,
lon: 25.374435
},
{
id: "U3RvcDpIU0w6OTQwMDIwMQ==",
lat: 60.484347,
lon: 25.368078
},
{
id: "U3RvcDpIU0w6OTQwMDIwMg==",
lat: 60.483505,
lon: 25.368993
},
{
id: "U3RvcDpIU0w6OTQwMDIwOQ==",
lat: 60.47742,
lon: 25.374157
},
{
id: "U3RvcDpIU0w6OTQwMDIxMA==",
lat: 60.434959,
lon: 25.367006
},
{
id: "U3RvcDpIU0w6OTIyNTIxNw==",
lat: 60.42515,
lon: 25.338463
},
{
id: "U3RvcDpIU0w6OTIyNTIxNg==",
lat: 60.41998,
lon: 25.332845
},
{
id: "U3RvcDpIU0w6OTIyNTIxMw==",
lat: 60.41603,
lon: 25.33023
},
{
id: "U3RvcDpIU0w6OTIyNTIxMQ==",
lat: 60.412957,
lon: 25.328448
},
{
id: "U3RvcDpIU0w6OTIyNTIxMA==",
lat: 60.410613,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyNTIwMQ==",
lat: 60.408782,
lon: 25.318287
},
{
id: "U3RvcDpIU0w6OTIyNTIwNw==",
lat: 60.406928,
lon: 25.314803
},
{
id: "U3RvcDpIU0w6OTIyNTIwNA==",
lat: 60.405853,
lon: 25.305318
},
{
id: "U3RvcDpIU0w6OTIyNTIwMg==",
lat: 60.401832,
lon: 25.298322
},
{
id: "U3RvcDpIU0w6OTIyOTIwNw==",
lat: 60.395527,
lon: 25.298033
},
{
id: "U3RvcDpIU0w6OTIyOTIwNQ==",
lat: 60.392832,
lon: 25.295147
},
{
id: "U3RvcDpIU0w6OTIyOTIwNA==",
lat: 60.390917,
lon: 25.291257
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
}
]
},
{
gtfsId: "HSL:4571",
shortName: "571",
longName: "Tikkurila-Myyrmäki-Varisto",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDYxMDI0NQ==",
lat: 60.293346,
lon: 25.044253
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIyOA==",
lat: 60.29661,
lon: 25.03844
},
{
id: "U3RvcDpIU0w6NDYxMDIzMQ==",
lat: 60.29765,
lon: 25.03472
},
{
id: "U3RvcDpIU0w6NDYzMDIxMA==",
lat: 60.29964,
lon: 25.03247
},
{
id: "U3RvcDpIU0w6NDYzMDIyNg==",
lat: 60.30105,
lon: 25.02662
},
{
id: "U3RvcDpIU0w6NDYzMDIyMw==",
lat: 60.30177,
lon: 25.02167
},
{
id: "U3RvcDpIU0w6NDYzMDIyMg==",
lat: 60.29898,
lon: 25.01768
},
{
id: "U3RvcDpIU0w6NDYzMDIyMA==",
lat: 60.29537,
lon: 25.01572
},
{
id: "U3RvcDpIU0w6NDYzMDIxMg==",
lat: 60.29205,
lon: 25.0157
},
{
id: "U3RvcDpIU0w6NDY4MDIyOA==",
lat: 60.29215,
lon: 25.01095
},
{
id: "U3RvcDpIU0w6NDY4MDIyNg==",
lat: 60.29002,
lon: 25.00693
},
{
id: "U3RvcDpIU0w6NDY4MDIyNA==",
lat: 60.28894,
lon: 25.00227
},
{
id: "U3RvcDpIU0w6NDY4MDIyMg==",
lat: 60.28915,
lon: 24.99601
},
{
id: "U3RvcDpIU0w6NDY4MDIyMA==",
lat: 60.28777,
lon: 24.98909
},
{
id: "U3RvcDpIU0w6NDY5MDIwNA==",
lat: 60.284157,
lon: 24.983147
},
{
id: "U3RvcDpIU0w6NDY5MDIwNQ==",
lat: 60.28158,
lon: 24.98152
},
{
id: "U3RvcDpIU0w6NDUxMDI1MA==",
lat: 60.28225,
lon: 24.97741
},
{
id: "U3RvcDpIU0w6NDUxMDIwOA==",
lat: 60.28271,
lon: 24.97297
},
{
id: "U3RvcDpIU0w6NDUxMDIwNg==",
lat: 60.2841,
lon: 24.96983
},
{
id: "U3RvcDpIU0w6NDUxMDIzNw==",
lat: 60.28445,
lon: 24.96511
},
{
id: "U3RvcDpIU0w6NDUxMDIwNA==",
lat: 60.28634,
lon: 24.96034
},
{
id: "U3RvcDpIU0w6NDUxMDIyMQ==",
lat: 60.28714,
lon: 24.9578
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDIyMg==",
lat: 60.28878,
lon: 24.949677
},
{
id: "U3RvcDpIU0w6NDUxMDIxMw==",
lat: 60.286,
lon: 24.94868
},
{
id: "U3RvcDpIU0w6NDUxMDI1Ng==",
lat: 60.285431,
lon: 24.944319
},
{
id: "U3RvcDpIU0w6NDQwMDIxNg==",
lat: 60.28215,
lon: 24.93696
},
{
id: "U3RvcDpIU0w6NDQwMDIxNA==",
lat: 60.28078,
lon: 24.92756
},
{
id: "U3RvcDpIU0w6NDQwMDIxNw==",
lat: 60.28097,
lon: 24.92297
},
{
id: "U3RvcDpIU0w6NDQwMDIxOA==",
lat: 60.27961,
lon: 24.9164
},
{
id: "U3RvcDpIU0w6NDQwMDIzMA==",
lat: 60.28031,
lon: 24.90945
},
{
id: "U3RvcDpIU0w6NDQwMDIzNA==",
lat: 60.28367,
lon: 24.90867
},
{
id: "U3RvcDpIU0w6NDQwMDIzMg==",
lat: 60.28534,
lon: 24.90811
},
{
id: "U3RvcDpIU0w6NDQwMDIwNg==",
lat: 60.28615,
lon: 24.90267
},
{
id: "U3RvcDpIU0w6NDQwMDIwNA==",
lat: 60.28642,
lon: 24.89658
},
{
id: "U3RvcDpIU0w6NDQwMDI5OA==",
lat: 60.28786,
lon: 24.89045
},
{
id: "U3RvcDpIU0w6NDE4MDIxMQ==",
lat: 60.2871,
lon: 24.87284
},
{
id: "U3RvcDpIU0w6NDE4MDIyNg==",
lat: 60.28292,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyNA==",
lat: 60.27838,
lon: 24.87161
},
{
id: "U3RvcDpIU0w6NDE4MDIzMQ==",
lat: 60.27793,
lon: 24.86877
},
{
id: "U3RvcDpIU0w6NDE3MDIxMA==",
lat: 60.27739,
lon: 24.86505
},
{
id: "U3RvcDpIU0w6NDE3MDI1OA==",
lat: 60.27658,
lon: 24.85892
},
{
id: "U3RvcDpIU0w6NDE3MDI0NA==",
lat: 60.27712,
lon: 24.85322
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDI2Mw==",
lat: 60.26109,
lon: 24.856
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIxMA==",
lat: 60.25875,
lon: 24.83456
},
{
id: "U3RvcDpIU0w6NDEzMDIwOA==",
lat: 60.25622,
lon: 24.82877
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNw==",
lat: 60.25811,
lon: 24.80891
},
{
id: "U3RvcDpIU0w6NDEyMDIzOA==",
lat: 60.26287,
lon: 24.80655
},
{
id: "U3RvcDpIU0w6NDE0MDIwNw==",
lat: 60.26495,
lon: 24.81334
},
{
id: "U3RvcDpIU0w6NDE0MDIwOQ==",
lat: 60.26666,
lon: 24.81781
},
{
id: "U3RvcDpIU0w6NDE0MDIzNQ==",
lat: 60.26769,
lon: 24.82189
},
{
id: "U3RvcDpIU0w6NDE0MDIzNA==",
lat: 60.26828,
lon: 24.82453
},
{
id: "U3RvcDpIU0w6NDE0MDIzMw==",
lat: 60.26844,
lon: 24.82479
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mg==",
lat: 60.26736,
lon: 24.81986
},
{
id: "U3RvcDpIU0w6NDE0MDIxMA==",
lat: 60.26616,
lon: 24.81582
},
{
id: "U3RvcDpIU0w6NDE0MDIwOA==",
lat: 60.2649,
lon: 24.81288
},
{
id: "U3RvcDpIU0w6NDEyMDIxMA==",
lat: 60.26149,
lon: 24.80645
},
{
id: "U3RvcDpIU0w6NDEyMDIwOA==",
lat: 60.25673,
lon: 24.80958
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6NDEzMDIwNw==",
lat: 60.25561,
lon: 24.82723
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDI2NQ==",
lat: 60.260771,
lon: 24.856608
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNQ==",
lat: 60.27027,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0Ng==",
lat: 60.27718,
lon: 24.85344
},
{
id: "U3RvcDpIU0w6NDE3MDIwNw==",
lat: 60.27642,
lon: 24.85817
},
{
id: "U3RvcDpIU0w6NDE3MDIwOQ==",
lat: 60.27705,
lon: 24.86407
},
{
id: "U3RvcDpIU0w6NDE4MDIyMw==",
lat: 60.27905,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyNQ==",
lat: 60.284615,
lon: 24.873015
},
{
id: "U3RvcDpIU0w6NDE4MDIzMA==",
lat: 60.28791,
lon: 24.87527
},
{
id: "U3RvcDpIU0w6NDQwMDI5OQ==",
lat: 60.28752,
lon: 24.89207
},
{
id: "U3RvcDpIU0w6NDQwMDIwMw==",
lat: 60.28632,
lon: 24.89784
},
{
id: "U3RvcDpIU0w6NDQwMDIwNQ==",
lat: 60.28585,
lon: 24.90463
},
{
id: "U3RvcDpIU0w6NDQwMDIzNw==",
lat: 60.28461,
lon: 24.90906
},
{
id: "U3RvcDpIU0w6NDQwMDIzNg==",
lat: 60.28289,
lon: 24.90792
},
{
id: "U3RvcDpIU0w6NDQwMDIzMQ==",
lat: 60.28004,
lon: 24.90929
},
{
id: "U3RvcDpIU0w6NDQwMDIxOQ==",
lat: 60.279784,
lon: 24.918783
},
{
id: "U3RvcDpIU0w6NDQwMDIxMQ==",
lat: 60.28074,
lon: 24.92412
},
{
id: "U3RvcDpIU0w6NDQwMDIxMw==",
lat: 60.28074,
lon: 24.92886
},
{
id: "U3RvcDpIU0w6NDQwMDIxNQ==",
lat: 60.28249,
lon: 24.93814
},
{
id: "U3RvcDpIU0w6NDUxMDI1Nw==",
lat: 60.28557,
lon: 24.946116
},
{
id: "U3RvcDpIU0w6NDUxMDIyNQ==",
lat: 60.2866,
lon: 24.95006
},
{
id: "U3RvcDpIU0w6NDUxMDIyMw==",
lat: 60.288407,
lon: 24.950263
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIwMQ==",
lat: 60.28944,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIyMA==",
lat: 60.2865,
lon: 24.95909
},
{
id: "U3RvcDpIU0w6NDUxMDIwMw==",
lat: 60.28515,
lon: 24.96256
},
{
id: "U3RvcDpIU0w6NDUxMDIzOQ==",
lat: 60.2842,
lon: 24.96675
},
{
id: "U3RvcDpIU0w6NDUxMDIwNQ==",
lat: 60.28334,
lon: 24.97145
},
{
id: "U3RvcDpIU0w6NDUxMDIwNw==",
lat: 60.28228,
lon: 24.97476
},
{
id: "U3RvcDpIU0w6NDUxMDI0OQ==",
lat: 60.28171,
lon: 24.98038
},
{
id: "U3RvcDpIU0w6NDY5MDIwMQ==",
lat: 60.28195,
lon: 24.98314
},
{
id: "U3RvcDpIU0w6NDY5MDIwMw==",
lat: 60.283544,
lon: 24.983526
},
{
id: "U3RvcDpIU0w6NDY4MDIxOQ==",
lat: 60.28786,
lon: 24.99054
},
{
id: "U3RvcDpIU0w6NDY4MDIyMQ==",
lat: 60.28918,
lon: 24.99859
},
{
id: "U3RvcDpIU0w6NDY4MDIyMw==",
lat: 60.28899,
lon: 25.00361
},
{
id: "U3RvcDpIU0w6NDY4MDIyNQ==",
lat: 60.29046,
lon: 25.00808
},
{
id: "U3RvcDpIU0w6NDY4MDIyNw==",
lat: 60.29201,
lon: 25.01294
},
{
id: "U3RvcDpIU0w6NDYzMDIxOA==",
lat: 60.292663,
lon: 25.017039
},
{
id: "U3RvcDpIU0w6NDYzMDIxOQ==",
lat: 60.29612,
lon: 25.01589
},
{
id: "U3RvcDpIU0w6NDYzMDIyMQ==",
lat: 60.29879,
lon: 25.01765
},
{
id: "U3RvcDpIU0w6NDYzMDIwNw==",
lat: 60.30182,
lon: 25.02328
},
{
id: "U3RvcDpIU0w6NDYzMDIyNQ==",
lat: 60.30021,
lon: 25.02911
},
{
id: "U3RvcDpIU0w6NDYzMDIwOQ==",
lat: 60.299,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6NDYxMDIwOQ==",
lat: 60.2969,
lon: 25.03573
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
}
]
},
{
gtfsId: "HSL:4572",
shortName: "572",
longName: "Mellunmäki-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE1MDI2MA==",
lat: 60.26146,
lon: 24.85547
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxNg==",
lat: 60.270447,
lon: 24.855295
},
{
id: "U3RvcDpIU0w6NDE1MDIxNw==",
lat: 60.27172,
lon: 24.85481
},
{
id: "U3RvcDpIU0w6NDE3MDI5Mw==",
lat: 60.275267,
lon: 24.856513
},
{
id: "U3RvcDpIU0w6NDE3MDI0NQ==",
lat: 60.27746,
lon: 24.85363
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOQ==",
lat: 60.28544,
lon: 24.85111
},
{
id: "U3RvcDpIU0w6NDE3MDIzMw==",
lat: 60.28679,
lon: 24.85677
},
{
id: "U3RvcDpIU0w6NDE4MDIzMg==",
lat: 60.2876,
lon: 24.86121
},
{
id: "U3RvcDpIU0w6NDE4MDIyNw==",
lat: 60.28906,
lon: 24.86484
},
{
id: "U3RvcDpIU0w6NDE4MDIxMg==",
lat: 60.29113,
lon: 24.86663
},
{
id: "U3RvcDpIU0w6NDIxMDIwMQ==",
lat: 60.29308,
lon: 24.86341
},
{
id: "U3RvcDpIU0w6NDQxMDIwOA==",
lat: 60.29774,
lon: 24.88346
},
{
id: "U3RvcDpIU0w6NDQxMDIxMw==",
lat: 60.298287,
lon: 24.898963
},
{
id: "U3RvcDpIU0w6NDQxMDI5OQ==",
lat: 60.297001,
lon: 24.916547
},
{
id: "U3RvcDpIU0w6NDQxMDI5Nw==",
lat: 60.29677,
lon: 24.93165
},
{
id: "U3RvcDpIU0w6NDUxMDI0Nw==",
lat: 60.29464,
lon: 24.94259
},
{
id: "U3RvcDpIU0w6NDUxMDI1Mw==",
lat: 60.293552,
lon: 24.94809
},
{
id: "U3RvcDpIU0w6NDUxMDIxNQ==",
lat: 60.293698,
lon: 24.95222
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIwMg==",
lat: 60.29045,
lon: 24.96052
},
{
id: "U3RvcDpIU0w6NDUyMDI2Mw==",
lat: 60.293315,
lon: 24.963035
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mw==",
lat: 60.28874,
lon: 24.97647
},
{
id: "U3RvcDpIU0w6NDY4MDIyOQ==",
lat: 60.28726,
lon: 24.99786
},
{
id: "U3RvcDpIU0w6MTQwMTIyNQ==",
lat: 60.28472,
lon: 25.01564
},
{
id: "U3RvcDpIU0w6MTQwMTEyMw==",
lat: 60.28254,
lon: 25.02771
},
{
id: "U3RvcDpIU0w6NDY0MDIxNw==",
lat: 60.28283,
lon: 25.04819
},
{
id: "U3RvcDpIU0w6NDY0MDIxOQ==",
lat: 60.28581,
lon: 25.05395
},
{
id: "U3RvcDpIU0w6NDY0MDIyMQ==",
lat: 60.28585,
lon: 25.05881
},
{
id: "U3RvcDpIU0w6NDY0MDIyMw==",
lat: 60.28491,
lon: 25.06423
},
{
id: "U3RvcDpIU0w6NDY0MDIxNQ==",
lat: 60.2845,
lon: 25.06921
},
{
id: "U3RvcDpIU0w6NDY0MDIwMw==",
lat: 60.28311,
lon: 25.07438
},
{
id: "U3RvcDpIU0w6NDY0MDIwNw==",
lat: 60.28193,
lon: 25.0804
},
{
id: "U3RvcDpIU0w6NDY0MDIwOQ==",
lat: 60.28153,
lon: 25.0894
},
{
id: "U3RvcDpIU0w6NDk0MDIxMA==",
lat: 60.28073,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6NDk0MDIxMg==",
lat: 60.27969,
lon: 25.10342
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6NDk1MDIwMQ==",
lat: 60.25091,
lon: 25.08784
},
{
id: "U3RvcDpIU0w6NDk1MDIwNQ==",
lat: 60.249921,
lon: 25.096143
},
{
id: "U3RvcDpIU0w6NDk1MDIxMQ==",
lat: 60.24978,
lon: 25.1021
},
{
id: "U3RvcDpIU0w6NDk1MDIxMg==",
lat: 60.250903,
lon: 25.1084
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIxOA==",
lat: 60.24234,
lon: 25.10881
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
},
{
id: "U3RvcDpIU0w6MTQ3MzIyMw==",
lat: 60.23831,
lon: 25.109
},
{
id: "U3RvcDpIU0w6NDkxMDIxNw==",
lat: 60.242165,
lon: 25.108975
},
{
id: "U3RvcDpIU0w6NDkxMDIxNQ==",
lat: 60.24494,
lon: 25.11149
},
{
id: "U3RvcDpIU0w6NDkxMDIwMw==",
lat: 60.24755,
lon: 25.11225
},
{
id: "U3RvcDpIU0w6NDkxMDIyMg==",
lat: 60.251153,
lon: 25.110441
},
{
id: "U3RvcDpIU0w6NDk1MDIxMw==",
lat: 60.25071,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk1MDIwNg==",
lat: 60.24998,
lon: 25.09979
},
{
id: "U3RvcDpIU0w6NDk1MDIwNA==",
lat: 60.250182,
lon: 25.093707
},
{
id: "U3RvcDpIU0w6NDk1MDIwMg==",
lat: 60.25108,
lon: 25.08727
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDIxNQ==",
lat: 60.27901,
lon: 25.10592
},
{
id: "U3RvcDpIU0w6NDk0MDIxMw==",
lat: 60.28017,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDk0MDIxMQ==",
lat: 60.280871,
lon: 25.095651
},
{
id: "U3RvcDpIU0w6NDY0MDIxMA==",
lat: 60.28163,
lon: 25.08709
},
{
id: "U3RvcDpIU0w6NDY0MDIxNA==",
lat: 60.28231,
lon: 25.07849
},
{
id: "U3RvcDpIU0w6NDY0MDIwNA==",
lat: 60.28373,
lon: 25.07296
},
{
id: "U3RvcDpIU0w6NDY0MDIyNA==",
lat: 60.28498,
lon: 25.06687
},
{
id: "U3RvcDpIU0w6NDY0MDIyMg==",
lat: 60.28505,
lon: 25.06294
},
{
id: "U3RvcDpIU0w6NDY0MDIyMA==",
lat: 60.28623,
lon: 25.05673
},
{
id: "U3RvcDpIU0w6NDY0MDIxOA==",
lat: 60.28555,
lon: 25.0519
},
{
id: "U3RvcDpIU0w6NDY0MDIxNg==",
lat: 60.28301,
lon: 25.0481
},
{
id: "U3RvcDpIU0w6MTQwMTIyNA==",
lat: 60.28274,
lon: 25.02989
},
{
id: "U3RvcDpIU0w6MTQwMTIyNg==",
lat: 60.28564,
lon: 25.0146
},
{
id: "U3RvcDpIU0w6NDY4MDIzMA==",
lat: 60.28771,
lon: 24.99725
},
{
id: "U3RvcDpIU0w6NDY4MDI1NA==",
lat: 60.28873,
lon: 24.97839
},
{
id: "U3RvcDpIU0w6NDUyMDI2MQ==",
lat: 60.294818,
lon: 24.960031
},
{
id: "U3RvcDpIU0w6NDUxMDI2NA==",
lat: 60.295567,
lon: 24.958298
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDI1MQ==",
lat: 60.291725,
lon: 24.95261
},
{
id: "U3RvcDpIU0w6NDUxMDIyOA==",
lat: 60.293334,
lon: 24.946772
},
{
id: "U3RvcDpIU0w6NDUyMDIxNQ==",
lat: 60.29537,
lon: 24.94262
},
{
id: "U3RvcDpIU0w6NDUxMDI1OA==",
lat: 60.29672,
lon: 24.941369
},
{
id: "U3RvcDpIU0w6NDQxMDI5Ng==",
lat: 60.29726,
lon: 24.92992
},
{
id: "U3RvcDpIU0w6NDQxMDI5OA==",
lat: 60.297203,
lon: 24.916195
},
{
id: "U3RvcDpIU0w6NDQxMDIxNA==",
lat: 60.298535,
lon: 24.901062
},
{
id: "U3RvcDpIU0w6NDQxMDIwOQ==",
lat: 60.2983,
lon: 24.88306
},
{
id: "U3RvcDpIU0w6NDIxMDIwNA==",
lat: 60.2945,
lon: 24.86104
},
{
id: "U3RvcDpIU0w6NDIxMDIwMg==",
lat: 60.29251,
lon: 24.86391
},
{
id: "U3RvcDpIU0w6NDE4MDIyOA==",
lat: 60.28913,
lon: 24.86463
},
{
id: "U3RvcDpIU0w6NDE3MDI3OA==",
lat: 60.287244,
lon: 24.85855
},
{
id: "U3RvcDpIU0w6NDE3MDIzNA==",
lat: 60.28682,
lon: 24.85567
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxNQ==",
lat: 60.2772,
lon: 24.85298
},
{
id: "U3RvcDpIU0w6NDE3MDI5OQ==",
lat: 60.2753,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDE1MDI1OQ==",
lat: 60.27046,
lon: 24.854602
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDIwNQ==",
lat: 60.26146,
lon: 24.85579
}
]
},
{
gtfsId: "HSL:4332",
shortName: "332",
longName: "Elielinaukio-Varisto-Askisto",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEzMw==",
lat: 60.171801,
lon: 24.939727
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEyMA==",
lat: 60.20988,
lon: 24.88902
},
{
id: "U3RvcDpIU0w6MTI5MTE4MA==",
lat: 60.21517,
lon: 24.88415
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mg==",
lat: 60.21988,
lon: 24.88124
},
{
id: "U3RvcDpIU0w6MTI5NDEyMQ==",
lat: 60.22517,
lon: 24.87707
},
{
id: "U3RvcDpIU0w6MTQ2NDEyMw==",
lat: 60.22792,
lon: 24.87272
},
{
id: "U3RvcDpIU0w6MTQ2MzExNw==",
lat: 60.23393,
lon: 24.862
},
{
id: "U3RvcDpIU0w6MTMyMDExOQ==",
lat: 60.2387,
lon: 24.85418
},
{
id: "U3RvcDpIU0w6MTMyMDI5Nw==",
lat: 60.24435,
lon: 24.84502
},
{
id: "U3RvcDpIU0w6MTMyMDI5NQ==",
lat: 60.24945,
lon: 24.83561
},
{
id: "U3RvcDpIU0w6NDEzMDIxMQ==",
lat: 60.25685,
lon: 24.82674
},
{
id: "U3RvcDpIU0w6NDEzMDIxMw==",
lat: 60.25839,
lon: 24.82918
},
{
id: "U3RvcDpIU0w6NDEzMDIxNQ==",
lat: 60.26118,
lon: 24.83262
},
{
id: "U3RvcDpIU0w6NDEzMDIxNw==",
lat: 60.2627,
lon: 24.83038
},
{
id: "U3RvcDpIU0w6NDEzMDIxOA==",
lat: 60.26395,
lon: 24.82646
},
{
id: "U3RvcDpIU0w6NDEzMDIyNQ==",
lat: 60.2625,
lon: 24.82428
},
{
id: "U3RvcDpIU0w6NDEzMDIyMA==",
lat: 60.26046,
lon: 24.82129
},
{
id: "U3RvcDpIU0w6NDEzMDIyMQ==",
lat: 60.259,
lon: 24.81846
},
{
id: "U3RvcDpIU0w6NDEzMDIyNw==",
lat: 60.26245,
lon: 24.81644
},
{
id: "U3RvcDpIU0w6NDE0MDI5Nw==",
lat: 60.26424,
lon: 24.81541
},
{
id: "U3RvcDpIU0w6NDE0MDIwOQ==",
lat: 60.26666,
lon: 24.81781
},
{
id: "U3RvcDpIU0w6NDE0MDIzNQ==",
lat: 60.26769,
lon: 24.82189
},
{
id: "U3RvcDpIU0w6NDE0MDIzMw==",
lat: 60.26844,
lon: 24.82479
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mg==",
lat: 60.26736,
lon: 24.81986
},
{
id: "U3RvcDpIU0w6NDE0MDIxMQ==",
lat: 60.26691,
lon: 24.81622
},
{
id: "U3RvcDpIU0w6NDE0MDIxMg==",
lat: 60.26905,
lon: 24.81434
},
{
id: "U3RvcDpIU0w6NDE0MDIxNA==",
lat: 60.27169,
lon: 24.81122
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDIwMDIwMQ==",
lat: 60.27705,
lon: 24.80344
},
{
id: "U3RvcDpIU0w6NDIwMDIwMw==",
lat: 60.28351,
lon: 24.79137
},
{
id: "U3RvcDpIU0w6NDIwMDIxMQ==",
lat: 60.28576,
lon: 24.78543
},
{
id: "U3RvcDpIU0w6NDIwMDIwOQ==",
lat: 60.28095,
lon: 24.78441
},
{
id: "U3RvcDpIU0w6NDIwMDIxMw==",
lat: 60.27662,
lon: 24.77807
},
{
id: "U3RvcDpIU0w6NDEyMDIyMQ==",
lat: 60.27463,
lon: 24.77941
},
{
id: "U3RvcDpIU0w6NDIwMDIxNA==",
lat: 60.27739,
lon: 24.77876
},
{
id: "U3RvcDpIU0w6NDIwMDIxMA==",
lat: 60.28186,
lon: 24.78524
},
{
id: "U3RvcDpIU0w6NDIwMDIxMg==",
lat: 60.28542,
lon: 24.78564
},
{
id: "U3RvcDpIU0w6NDIwMDIwNg==",
lat: 60.28661,
lon: 24.78718
},
{
id: "U3RvcDpIU0w6NDIwMDIwNA==",
lat: 60.28288,
lon: 24.79207
},
{
id: "U3RvcDpIU0w6NDIwMDIwMg==",
lat: 60.27836,
lon: 24.80175
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNQ==",
lat: 60.27126,
lon: 24.81263
},
{
id: "U3RvcDpIU0w6NDE0MDIxMw==",
lat: 60.26827,
lon: 24.81419
},
{
id: "U3RvcDpIU0w6NDE0MDIxMA==",
lat: 60.26616,
lon: 24.81582
},
{
id: "U3RvcDpIU0w6NDEzMDI5OA==",
lat: 60.26236,
lon: 24.8164
},
{
id: "U3RvcDpIU0w6NDEzMDIyOQ==",
lat: 60.25891,
lon: 24.81948
},
{
id: "U3RvcDpIU0w6NDEzMDIzMA==",
lat: 60.26087,
lon: 24.82194
},
{
id: "U3RvcDpIU0w6NDEzMDIxOQ==",
lat: 60.26319,
lon: 24.82548
},
{
id: "U3RvcDpIU0w6NDEzMDIyNg==",
lat: 60.26335,
lon: 24.82955
},
{
id: "U3RvcDpIU0w6NDEzMDIxNg==",
lat: 60.26113,
lon: 24.83245
},
{
id: "U3RvcDpIU0w6NDEzMDIxNA==",
lat: 60.2588,
lon: 24.8294
},
{
id: "U3RvcDpIU0w6NDEzMDIxMg==",
lat: 60.25755,
lon: 24.82769
},
{
id: "U3RvcDpIU0w6MTMyMDI5Mg==",
lat: 60.24917,
lon: 24.83552
},
{
id: "U3RvcDpIU0w6MTMyMDI5NA==",
lat: 60.24309,
lon: 24.84648
},
{
id: "U3RvcDpIU0w6MTMyMDEyMA==",
lat: 60.239267,
lon: 24.852589
},
{
id: "U3RvcDpIU0w6MTQ2MzExOA==",
lat: 60.23293,
lon: 24.86311
},
{
id: "U3RvcDpIU0w6MTI5NDEyNA==",
lat: 60.227,
lon: 24.87358
},
{
id: "U3RvcDpIU0w6MTI5NDEyMg==",
lat: 60.22447,
lon: 24.87771
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mw==",
lat: 60.21865,
lon: 24.8815
},
{
id: "U3RvcDpIU0w6MTI5MTE4MQ==",
lat: 60.215735,
lon: 24.883378
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:4574",
shortName: "574",
longName: "Peijas-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDcyMDIwOQ==",
lat: 60.33219,
lon: 25.06038
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNQ==",
lat: 60.32133,
lon: 25.06167
},
{
id: "U3RvcDpIU0w6NDc0MDIzMg==",
lat: 60.31914,
lon: 25.05967
},
{
id: "U3RvcDpIU0w6NDcwMDIyMw==",
lat: 60.32062,
lon: 25.05047
},
{
id: "U3RvcDpIU0w6NDcwMDIyNA==",
lat: 60.32183,
lon: 25.04486
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
},
{
id: "U3RvcDpIU0w6NDcwMDIyOQ==",
lat: 60.322323,
lon: 25.042012
},
{
id: "U3RvcDpIU0w6NDcwMDIwMg==",
lat: 60.31968,
lon: 25.03908
},
{
id: "U3RvcDpIU0w6NDY1MDIxMA==",
lat: 60.3149,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6NDY1MDIwOA==",
lat: 60.31072,
lon: 25.03015
},
{
id: "U3RvcDpIU0w6NDY1MDIwNg==",
lat: 60.30949,
lon: 25.02695
},
{
id: "U3RvcDpIU0w6NDY1MDIwNA==",
lat: 60.30635,
lon: 25.02439
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIyNA==",
lat: 60.30239,
lon: 25.02178
},
{
id: "U3RvcDpIU0w6NDY4MDIzMg==",
lat: 60.30616,
lon: 25.00627
},
{
id: "U3RvcDpIU0w6NDY4MDIwNw==",
lat: 60.30333,
lon: 25.00264
},
{
id: "U3RvcDpIU0w6NDY4MDI0MA==",
lat: 60.30131,
lon: 25.00067
},
{
id: "U3RvcDpIU0w6NDY4MDIzNg==",
lat: 60.29965,
lon: 24.99553
},
{
id: "U3RvcDpIU0w6NDUyMDI0Ng==",
lat: 60.30151,
lon: 24.98797
},
{
id: "U3RvcDpIU0w6NDUyMDI0OA==",
lat: 60.30245,
lon: 24.98202
},
{
id: "U3RvcDpIU0w6NDUzMDIxNA==",
lat: 60.30521,
lon: 24.97639
},
{
id: "U3RvcDpIU0w6NDUzMDIwMw==",
lat: 60.30645,
lon: 24.97014
},
{
id: "U3RvcDpIU0w6NDUzMDIyMQ==",
lat: 60.307879,
lon: 24.960343
},
{
id: "U3RvcDpIU0w6NDUyMDI2Nw==",
lat: 60.304895,
lon: 24.957404
},
{
id: "U3RvcDpIU0w6NDUyMDI2NQ==",
lat: 60.303237,
lon: 24.95592
},
{
id: "U3RvcDpIU0w6NDUyMDIzMw==",
lat: 60.302235,
lon: 24.958971
},
{
id: "U3RvcDpIU0w6NDUyMDIyMA==",
lat: 60.297809,
lon: 24.958069
},
{
id: "U3RvcDpIU0w6NDUxMDI2NA==",
lat: 60.295567,
lon: 24.958298
},
{
id: "U3RvcDpIU0w6NDUxMDIxNg==",
lat: 60.28994,
lon: 24.95934
},
{
id: "U3RvcDpIU0w6NDUxMDI1NQ==",
lat: 60.28992,
lon: 24.954023
},
{
id: "U3RvcDpIU0w6NDUxMDI1MQ==",
lat: 60.291725,
lon: 24.95261
},
{
id: "U3RvcDpIU0w6NDUxMDIyOA==",
lat: 60.293334,
lon: 24.946772
},
{
id: "U3RvcDpIU0w6NDUyMDIxNQ==",
lat: 60.29537,
lon: 24.94262
},
{
id: "U3RvcDpIU0w6NDUxMDI1OA==",
lat: 60.29672,
lon: 24.941369
},
{
id: "U3RvcDpIU0w6NDQxMDI5Ng==",
lat: 60.29726,
lon: 24.92992
},
{
id: "U3RvcDpIU0w6NDQxMDI5OA==",
lat: 60.297203,
lon: 24.916195
},
{
id: "U3RvcDpIU0w6NDQxMDIxNA==",
lat: 60.298535,
lon: 24.901062
},
{
id: "U3RvcDpIU0w6NDQxMDIwOQ==",
lat: 60.2983,
lon: 24.88306
},
{
id: "U3RvcDpIU0w6NDIxMDIwNA==",
lat: 60.2945,
lon: 24.86104
},
{
id: "U3RvcDpIU0w6NDIxMDIwMg==",
lat: 60.29251,
lon: 24.86391
},
{
id: "U3RvcDpIU0w6NDE4MDIyOA==",
lat: 60.28913,
lon: 24.86463
},
{
id: "U3RvcDpIU0w6NDE3MDI3OA==",
lat: 60.287244,
lon: 24.85855
},
{
id: "U3RvcDpIU0w6NDE3MDIzNA==",
lat: 60.28682,
lon: 24.85567
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDI0NA==",
lat: 60.27712,
lon: 24.85322
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDIwNQ==",
lat: 60.26146,
lon: 24.85579
},
{
id: "U3RvcDpIU0w6NDE1MDI2MA==",
lat: 60.26146,
lon: 24.85547
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNQ==",
lat: 60.27027,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0NQ==",
lat: 60.27746,
lon: 24.85363
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOQ==",
lat: 60.28544,
lon: 24.85111
},
{
id: "U3RvcDpIU0w6NDE3MDIzMw==",
lat: 60.28679,
lon: 24.85677
},
{
id: "U3RvcDpIU0w6NDE4MDIzMg==",
lat: 60.2876,
lon: 24.86121
},
{
id: "U3RvcDpIU0w6NDE4MDIyNw==",
lat: 60.28906,
lon: 24.86484
},
{
id: "U3RvcDpIU0w6NDE4MDIxMg==",
lat: 60.29113,
lon: 24.86663
},
{
id: "U3RvcDpIU0w6NDIxMDIwMQ==",
lat: 60.29308,
lon: 24.86341
},
{
id: "U3RvcDpIU0w6NDQxMDIwOA==",
lat: 60.29774,
lon: 24.88346
},
{
id: "U3RvcDpIU0w6NDQxMDIxMw==",
lat: 60.298287,
lon: 24.898963
},
{
id: "U3RvcDpIU0w6NDQxMDI5OQ==",
lat: 60.297001,
lon: 24.916547
},
{
id: "U3RvcDpIU0w6NDQxMDI5Nw==",
lat: 60.29677,
lon: 24.93165
},
{
id: "U3RvcDpIU0w6NDUxMDI0Nw==",
lat: 60.29464,
lon: 24.94259
},
{
id: "U3RvcDpIU0w6NDUxMDI1Mw==",
lat: 60.293552,
lon: 24.94809
},
{
id: "U3RvcDpIU0w6NDUxMDIxNQ==",
lat: 60.293698,
lon: 24.95222
},
{
id: "U3RvcDpIU0w6NDUxMDI1NA==",
lat: 60.289753,
lon: 24.953248
},
{
id: "U3RvcDpIU0w6NDUxMDIwMg==",
lat: 60.29045,
lon: 24.96052
},
{
id: "U3RvcDpIU0w6NDUxMDI2MA==",
lat: 60.293782,
lon: 24.959314
},
{
id: "U3RvcDpIU0w6NDUxMDI2Mw==",
lat: 60.295453,
lon: 24.958864
},
{
id: "U3RvcDpIU0w6NDUyMDIxNw==",
lat: 60.297895,
lon: 24.959368
},
{
id: "U3RvcDpIU0w6NDUyMDIzOQ==",
lat: 60.301654,
lon: 24.962252
},
{
id: "U3RvcDpIU0w6NDUyMDIzNg==",
lat: 60.303301,
lon: 24.956282
},
{
id: "U3RvcDpIU0w6NDUyMDI2OA==",
lat: 60.306115,
lon: 24.958895
},
{
id: "U3RvcDpIU0w6NDUzMDIzOA==",
lat: 60.307855,
lon: 24.962
},
{
id: "U3RvcDpIU0w6NDUzMDIwNA==",
lat: 60.30626,
lon: 24.96955
},
{
id: "U3RvcDpIU0w6NDUzMDIxNQ==",
lat: 60.30483,
lon: 24.97647
},
{
id: "U3RvcDpIU0w6NDUyMDI0Nw==",
lat: 60.30173,
lon: 24.98498
},
{
id: "U3RvcDpIU0w6NDY4MDIzNw==",
lat: 60.30016,
lon: 24.99176
},
{
id: "U3RvcDpIU0w6NDY4MDIzNQ==",
lat: 60.29945,
lon: 24.99539
},
{
id: "U3RvcDpIU0w6NDY4MDI0MQ==",
lat: 60.30123,
lon: 25.00077
},
{
id: "U3RvcDpIU0w6NDY4MDIwOA==",
lat: 60.30321,
lon: 25.00294
},
{
id: "U3RvcDpIU0w6NDY4MDIzMQ==",
lat: 60.3064,
lon: 25.00771
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIwMw==",
lat: 60.30689,
lon: 25.02499
},
{
id: "U3RvcDpIU0w6NDY1MDIwNQ==",
lat: 60.31,
lon: 25.0287
},
{
id: "U3RvcDpIU0w6NDY1MDIwNw==",
lat: 60.31132,
lon: 25.03142
},
{
id: "U3RvcDpIU0w6NDY1MDIwOQ==",
lat: 60.31516,
lon: 25.03566
},
{
id: "U3RvcDpIU0w6NDcwMDIwMQ==",
lat: 60.3203,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDcwMDIyOA==",
lat: 60.32246,
lon: 25.042177
},
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyMg==",
lat: 60.32129,
lon: 25.04674
},
{
id: "U3RvcDpIU0w6NDcwMDIxOQ==",
lat: 60.31986,
lon: 25.05256
},
{
id: "U3RvcDpIU0w6NDc0MDIyNA==",
lat: 60.31925,
lon: 25.06135
},
{
id: "U3RvcDpIU0w6NDc0MDIxNA==",
lat: 60.32079,
lon: 25.06203
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIxNg==",
lat: 60.33213,
lon: 25.06075
}
]
},
{
gtfsId: "HSL:4575",
shortName: "575",
longName: "Tikkurila-Martinlaakso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDYxMDI0Ng==",
lat: 60.293577,
lon: 25.044313
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIyNg==",
lat: 60.29163,
lon: 25.0366
},
{
id: "U3RvcDpIU0w6NDYxMDIyMA==",
lat: 60.28947,
lon: 25.03306
},
{
id: "U3RvcDpIU0w6NDYzMDIxNg==",
lat: 60.28976,
lon: 25.02777
},
{
id: "U3RvcDpIU0w6NDYzMDIxNA==",
lat: 60.2912,
lon: 25.02122
},
{
id: "U3RvcDpIU0w6NDYzMDIxMg==",
lat: 60.29205,
lon: 25.0157
},
{
id: "U3RvcDpIU0w6NDY4MDIyOA==",
lat: 60.29215,
lon: 25.01095
},
{
id: "U3RvcDpIU0w6NDY4MDIwNA==",
lat: 60.29215,
lon: 25.00494
},
{
id: "U3RvcDpIU0w6NDY4MDIwNg==",
lat: 60.29266,
lon: 24.99609
},
{
id: "U3RvcDpIU0w6NDY4MDI0Mg==",
lat: 60.29315,
lon: 24.98939
},
{
id: "U3RvcDpIU0w6NDY4MDI0OA==",
lat: 60.29424,
lon: 24.98574
},
{
id: "U3RvcDpIU0w6NDUyMDI2MA==",
lat: 60.296,
lon: 24.98043
},
{
id: "U3RvcDpIU0w6NDUyMDIyNw==",
lat: 60.29665,
lon: 24.97606
},
{
id: "U3RvcDpIU0w6NDUyMDIxMw==",
lat: 60.29937,
lon: 24.9685
},
{
id: "U3RvcDpIU0w6NDUyMDIzOQ==",
lat: 60.301654,
lon: 24.962252
},
{
id: "U3RvcDpIU0w6NDUyMDIzNw==",
lat: 60.302312,
lon: 24.952512
},
{
id: "U3RvcDpIU0w6NDQxMDIzOA==",
lat: 60.302688,
lon: 24.939267
},
{
id: "U3RvcDpIU0w6NDQxMDI0MA==",
lat: 60.30085,
lon: 24.93199
},
{
id: "U3RvcDpIU0w6NDQxMDI0Mg==",
lat: 60.30218,
lon: 24.92453
},
{
id: "U3RvcDpIU0w6NDQxMDI1NA==",
lat: 60.3031,
lon: 24.916725
},
{
id: "U3RvcDpIU0w6NDQxMDI1Mw==",
lat: 60.297738,
lon: 24.916777
},
{
id: "U3RvcDpIU0w6NDQxMDI1OA==",
lat: 60.295925,
lon: 24.91664
},
{
id: "U3RvcDpIU0w6NDQxMDIzMg==",
lat: 60.29461,
lon: 24.91559
},
{
id: "U3RvcDpIU0w6NDQxMDIzMA==",
lat: 60.29517,
lon: 24.90614
},
{
id: "U3RvcDpIU0w6NDQxMDIyOA==",
lat: 60.29602,
lon: 24.90186
},
{
id: "U3RvcDpIU0w6NDQxMDIyNg==",
lat: 60.29541,
lon: 24.89639
},
{
id: "U3RvcDpIU0w6NDQxMDIyNA==",
lat: 60.2967,
lon: 24.89034
},
{
id: "U3RvcDpIU0w6NDQxMDIxMg==",
lat: 60.29877,
lon: 24.88314
},
{
id: "U3RvcDpIU0w6NDIxMDIwNA==",
lat: 60.2945,
lon: 24.86104
},
{
id: "U3RvcDpIU0w6NDIxMDIwMg==",
lat: 60.29251,
lon: 24.86391
},
{
id: "U3RvcDpIU0w6NDE4MDIyOA==",
lat: 60.28913,
lon: 24.86463
},
{
id: "U3RvcDpIU0w6NDE3MDI3OA==",
lat: 60.287244,
lon: 24.85855
},
{
id: "U3RvcDpIU0w6NDE3MDIzNA==",
lat: 60.28682,
lon: 24.85567
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxMQ==",
lat: 60.2773,
lon: 24.85304
},
{
id: "U3RvcDpIU0w6NDE3MDI0NQ==",
lat: 60.27746,
lon: 24.85363
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOQ==",
lat: 60.28544,
lon: 24.85111
},
{
id: "U3RvcDpIU0w6NDE3MDIzMw==",
lat: 60.28679,
lon: 24.85677
},
{
id: "U3RvcDpIU0w6NDE4MDIzMg==",
lat: 60.2876,
lon: 24.86121
},
{
id: "U3RvcDpIU0w6NDE4MDIyNw==",
lat: 60.28906,
lon: 24.86484
},
{
id: "U3RvcDpIU0w6NDE4MDIxMg==",
lat: 60.29113,
lon: 24.86663
},
{
id: "U3RvcDpIU0w6NDIxMDIwMQ==",
lat: 60.29308,
lon: 24.86341
},
{
id: "U3RvcDpIU0w6NDQxMDIzNw==",
lat: 60.2965,
lon: 24.88491
},
{
id: "U3RvcDpIU0w6NDQxMDIyMw==",
lat: 60.29612,
lon: 24.89142
},
{
id: "U3RvcDpIU0w6NDQxMDIyNQ==",
lat: 60.29547,
lon: 24.89793
},
{
id: "U3RvcDpIU0w6NDQxMDIyNw==",
lat: 60.2957,
lon: 24.90325
},
{
id: "U3RvcDpIU0w6NDQxMDIyOQ==",
lat: 60.29468,
lon: 24.90762
},
{
id: "U3RvcDpIU0w6NDQxMDI1Mg==",
lat: 60.29656,
lon: 24.91714
},
{
id: "U3RvcDpIU0w6NDQxMDI1Nw==",
lat: 60.298335,
lon: 24.917
},
{
id: "U3RvcDpIU0w6NDQxMDI1Ng==",
lat: 60.303559,
lon: 24.917561
},
{
id: "U3RvcDpIU0w6NDQxMDI0MQ==",
lat: 60.30161,
lon: 24.92572
},
{
id: "U3RvcDpIU0w6NDQxMDIzOQ==",
lat: 60.30078,
lon: 24.93357
},
{
id: "U3RvcDpIU0w6NDUyMDI5OQ==",
lat: 60.3027,
lon: 24.9422
},
{
id: "U3RvcDpIU0w6NDUyMDIzOA==",
lat: 60.302153,
lon: 24.952562
},
{
id: "U3RvcDpIU0w6NDUyMDIzMg==",
lat: 60.301669,
lon: 24.959481
},
{
id: "U3RvcDpIU0w6NDUyMDIzMQ==",
lat: 60.300262,
lon: 24.966312
},
{
id: "U3RvcDpIU0w6NDUyMDIxMg==",
lat: 60.29822,
lon: 24.96976
},
{
id: "U3RvcDpIU0w6NDUyMDI1OQ==",
lat: 60.29643,
lon: 24.9774
},
{
id: "U3RvcDpIU0w6NDUyMDIyNg==",
lat: 60.2954,
lon: 24.98164
},
{
id: "U3RvcDpIU0w6NDY4MDI0NQ==",
lat: 60.29407,
lon: 24.98582
},
{
id: "U3RvcDpIU0w6NDY4MDI0Mw==",
lat: 60.29276,
lon: 24.99154
},
{
id: "U3RvcDpIU0w6NDY4MDIwNQ==",
lat: 60.29238,
lon: 24.9982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMw==",
lat: 60.29196,
lon: 25.00701
},
{
id: "U3RvcDpIU0w6NDY4MDIyNw==",
lat: 60.29201,
lon: 25.01294
},
{
id: "U3RvcDpIU0w6NDYzMDIxMQ==",
lat: 60.29154,
lon: 25.01791
},
{
id: "U3RvcDpIU0w6NDYzMDIyNw==",
lat: 60.290493,
lon: 25.023712
},
{
id: "U3RvcDpIU0w6NDYzMDIxNQ==",
lat: 60.2896,
lon: 25.02769
},
{
id: "U3RvcDpIU0w6NDYxMDIxOQ==",
lat: 60.28924,
lon: 25.03163
},
{
id: "U3RvcDpIU0w6NDYxMDIyNQ==",
lat: 60.29093,
lon: 25.03651
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
}
]
},
{
gtfsId: "HSL:1066",
shortName: "66",
longName: "Rautatientori-Maunula-Länsi-Pakila-Paloheinä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMg==",
lat: 60.17085,
lon: 24.94333
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDExMA==",
lat: 60.19226,
lon: 24.96136
},
{
id: "U3RvcDpIU0w6MTIyMDE4MQ==",
lat: 60.19565,
lon: 24.95499
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDEwMw==",
lat: 60.22972,
lon: 24.94197
},
{
id: "U3RvcDpIU0w6MTI4MjEwMQ==",
lat: 60.2301,
lon: 24.93839
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MTEwNw==",
lat: 60.23472,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTM0MTExOA==",
lat: 60.23743,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTM0MTEyMA==",
lat: 60.23948,
lon: 24.92814
},
{
id: "U3RvcDpIU0w6MTM0MTEyMg==",
lat: 60.24185,
lon: 24.92687
},
{
id: "U3RvcDpIU0w6MTM0MTEyNA==",
lat: 60.24426,
lon: 24.9254
},
{
id: "U3RvcDpIU0w6MTM1MTExMw==",
lat: 60.2477,
lon: 24.92264
},
{
id: "U3RvcDpIU0w6MTM1MTExNA==",
lat: 60.25068,
lon: 24.9198
},
{
id: "U3RvcDpIU0w6MTM1MTExNg==",
lat: 60.25305,
lon: 24.9188
},
{
id: "U3RvcDpIU0w6MTM1MTEyOQ==",
lat: 60.253775,
lon: 24.918462
},
{
id: "U3RvcDpIU0w6MTM1MTExNw==",
lat: 60.25285,
lon: 24.91874
},
{
id: "U3RvcDpIU0w6MTM1MTExNQ==",
lat: 60.24994,
lon: 24.91996
},
{
id: "U3RvcDpIU0w6MTM1MTEwMg==",
lat: 60.24687,
lon: 24.9239
},
{
id: "U3RvcDpIU0w6MTM0MTEyNQ==",
lat: 60.24433,
lon: 24.92518
},
{
id: "U3RvcDpIU0w6MTM0MTEyMw==",
lat: 60.24172,
lon: 24.92653
},
{
id: "U3RvcDpIU0w6MTM0MTEyMQ==",
lat: 60.23958,
lon: 24.9279
},
{
id: "U3RvcDpIU0w6MTM0MTExOQ==",
lat: 60.23664,
lon: 24.92902
},
{
id: "U3RvcDpIU0w6MTI4MjEwNg==",
lat: 60.23351,
lon: 24.93171
},
{
id: "U3RvcDpIU0w6MTI4MjEwNA==",
lat: 60.23154,
lon: 24.93381
},
{
id: "U3RvcDpIU0w6MTI4MjEwMg==",
lat: 60.23011,
lon: 24.9378
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:1065",
shortName: "65",
longName: "Rautatientori-Käpylä-Veräjälaakso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMg==",
lat: 60.17085,
lon: 24.94333
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDEwMw==",
lat: 60.19531,
lon: 24.95583
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI0MDExMg==",
lat: 60.20265,
lon: 24.94642
},
{
id: "U3RvcDpIU0w6MTI0MDExNA==",
lat: 60.20398,
lon: 24.95037
},
{
id: "U3RvcDpIU0w6MTI0MDE4MA==",
lat: 60.20663,
lon: 24.94786
},
{
id: "U3RvcDpIU0w6MTI1MDExMQ==",
lat: 60.20885,
lon: 24.94716
},
{
id: "U3RvcDpIU0w6MTI1MDExMw==",
lat: 60.21096,
lon: 24.95256
},
{
id: "U3RvcDpIU0w6MTI1MDExNQ==",
lat: 60.21249,
lon: 24.95648
},
{
id: "U3RvcDpIU0w6MTI1MDEwNw==",
lat: 60.21474,
lon: 24.95885
},
{
id: "U3RvcDpIU0w6MTI2MDEwOQ==",
lat: 60.21713,
lon: 24.95984
},
{
id: "U3RvcDpIU0w6MTI2MDExMA==",
lat: 60.2199,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTI2MDExMg==",
lat: 60.22232,
lon: 24.96484
},
{
id: "U3RvcDpIU0w6MTI2MDExNA==",
lat: 60.22362,
lon: 24.966271
},
{
id: "U3RvcDpIU0w6MTI4NTE2MA==",
lat: 60.22494,
lon: 24.97197
},
{
id: "U3RvcDpIU0w6MTI4NTE2Mg==",
lat: 60.22654,
lon: 24.9729
},
{
id: "U3RvcDpIU0w6MTI4NTE2NA==",
lat: 60.22964,
lon: 24.97434
},
{
id: "U3RvcDpIU0w6MTI4NTE4NA==",
lat: 60.23169,
lon: 24.97747
},
{
id: "U3RvcDpIU0w6MTI4NTE2Ng==",
lat: 60.23337,
lon: 24.978521
},
{
id: "U3RvcDpIU0w6MTI4NTE4Mw==",
lat: 60.23209,
lon: 24.97778
},
{
id: "U3RvcDpIU0w6MTI4NTE2NQ==",
lat: 60.22927,
lon: 24.9736
},
{
id: "U3RvcDpIU0w6MTI4NTE2Mw==",
lat: 60.22675,
lon: 24.97256
},
{
id: "U3RvcDpIU0w6MTI4NTE2MQ==",
lat: 60.22493,
lon: 24.97096
},
{
id: "U3RvcDpIU0w6MTI2MDExNQ==",
lat: 60.223569,
lon: 24.966086
},
{
id: "U3RvcDpIU0w6MTI2MDExMw==",
lat: 60.22171,
lon: 24.96391
},
{
id: "U3RvcDpIU0w6MTI2MDExMQ==",
lat: 60.2199,
lon: 24.96186
},
{
id: "U3RvcDpIU0w6MTI1MDE4MA==",
lat: 60.21691,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6MTI1MDEwOA==",
lat: 60.21436,
lon: 24.95852
},
{
id: "U3RvcDpIU0w6MTI1MDExNg==",
lat: 60.21238,
lon: 24.95536
},
{
id: "U3RvcDpIU0w6MTI1MDExNA==",
lat: 60.21108,
lon: 24.95203
},
{
id: "U3RvcDpIU0w6MTI1MDExMg==",
lat: 60.20938,
lon: 24.94761
},
{
id: "U3RvcDpIU0w6MTI0MDE4MQ==",
lat: 60.20649,
lon: 24.94781
},
{
id: "U3RvcDpIU0w6MTI0MDExNQ==",
lat: 60.20371,
lon: 24.95046
},
{
id: "U3RvcDpIU0w6MTI0MDExMw==",
lat: 60.2027,
lon: 24.94639
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:2246T",
shortName: "246T",
longName: "Espoon keskus-Bodom-Röylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcxMjAwMg==",
lat: 60.297265,
lon: 24.691783
},
{
id: "U3RvcDpIU0w6MjcxMTIwMg==",
lat: 60.29497,
lon: 24.6855
},
{
id: "U3RvcDpIU0w6MjcxMTI3MA==",
lat: 60.28965,
lon: 24.67744
},
{
id: "U3RvcDpIU0w6MjcxMTI4MQ==",
lat: 60.28358,
lon: 24.67581
},
{
id: "U3RvcDpIU0w6MjcxMTI2Nw==",
lat: 60.27483,
lon: 24.66649
},
{
id: "U3RvcDpIU0w6MjcxMTI2OA==",
lat: 60.274001,
lon: 24.656342
},
{
id: "U3RvcDpIU0w6MjYzNTI2Ng==",
lat: 60.268029,
lon: 24.653459
},
{
id: "U3RvcDpIU0w6MjYzNTI2NA==",
lat: 60.2623,
lon: 24.653
},
{
id: "U3RvcDpIU0w6MjYzNTIyNQ==",
lat: 60.25477,
lon: 24.65249
},
{
id: "U3RvcDpIU0w6MjYzNTIyMw==",
lat: 60.25019,
lon: 24.65483
},
{
id: "U3RvcDpIU0w6MjYzNDI2Mg==",
lat: 60.244566,
lon: 24.653642
},
{
id: "U3RvcDpIU0w6MjYzNDI3MA==",
lat: 60.23815,
lon: 24.65545
},
{
id: "U3RvcDpIU0w6MjYzNDI2MA==",
lat: 60.23559,
lon: 24.6576
},
{
id: "U3RvcDpIU0w6MjYzNDI3Mg==",
lat: 60.2328,
lon: 24.65912
},
{
id: "U3RvcDpIU0w6MjYzNDI3NA==",
lat: 60.22863,
lon: 24.66523
},
{
id: "U3RvcDpIU0w6MjYzNDIwMw==",
lat: 60.22727,
lon: 24.6678
},
{
id: "U3RvcDpIU0w6MjYzNDI3OA==",
lat: 60.2243,
lon: 24.66961
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
},
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYxNDI4Ng==",
lat: 60.22219,
lon: 24.66789
},
{
id: "U3RvcDpIU0w6MjYzNDI3OQ==",
lat: 60.22482,
lon: 24.67003
},
{
id: "U3RvcDpIU0w6MjYzMzIwMg==",
lat: 60.22794,
lon: 24.66676
},
{
id: "U3RvcDpIU0w6MjYzNDI3Nw==",
lat: 60.22894,
lon: 24.66508
},
{
id: "U3RvcDpIU0w6MjYzNDI3Ng==",
lat: 60.23321,
lon: 24.65923
},
{
id: "U3RvcDpIU0w6MjYzNDI2MQ==",
lat: 60.23591,
lon: 24.65655
},
{
id: "U3RvcDpIU0w6MjYzNDI3NQ==",
lat: 60.23899,
lon: 24.65577
},
{
id: "U3RvcDpIU0w6MjYzNDI2Mw==",
lat: 60.24418,
lon: 24.65407
},
{
id: "U3RvcDpIU0w6MjYzNTIyMg==",
lat: 60.2502,
lon: 24.65506
},
{
id: "U3RvcDpIU0w6MjYzNTIyNg==",
lat: 60.25515,
lon: 24.65259
},
{
id: "U3RvcDpIU0w6MjYzNTI2NQ==",
lat: 60.26227,
lon: 24.65307
},
{
id: "U3RvcDpIU0w6MjYzNTI2Nw==",
lat: 60.268937,
lon: 24.653134
},
{
id: "U3RvcDpIU0w6MjYzNTIyNA==",
lat: 60.273911,
lon: 24.656377
},
{
id: "U3RvcDpIU0w6MjcxMTI2Ng==",
lat: 60.27479,
lon: 24.66714
},
{
id: "U3RvcDpIU0w6MjcxMjI2NA==",
lat: 60.27472,
lon: 24.68069
},
{
id: "U3RvcDpIU0w6MjcxMjI2Mg==",
lat: 60.2711,
lon: 24.68954
},
{
id: "U3RvcDpIU0w6MjcxMjI2MA==",
lat: 60.26868,
lon: 24.68954
},
{
id: "U3RvcDpIU0w6MjcxMjIwMQ==",
lat: 60.265147,
lon: 24.690918
},
{
id: "U3RvcDpIU0w6MjcxMjI1OA==",
lat: 60.26227,
lon: 24.69153
},
{
id: "U3RvcDpIU0w6MjcxMjIwNg==",
lat: 60.25879,
lon: 24.70164
},
{
id: "U3RvcDpIU0w6MjcxMjIwOQ==",
lat: 60.26129,
lon: 24.7066
},
{
id: "U3RvcDpIU0w6MjcxMjIwOA==",
lat: 60.264194,
lon: 24.706496
},
{
id: "U3RvcDpIU0w6MjcxMjIwNA==",
lat: 60.267951,
lon: 24.708854
},
{
id: "U3RvcDpIU0w6MjcxMjIwMg==",
lat: 60.27125,
lon: 24.71016
},
{
id: "U3RvcDpIU0w6MjcxNDI4OA==",
lat: 60.27559,
lon: 24.71467
},
{
id: "U3RvcDpIU0w6MjcxNDI3OQ==",
lat: 60.2775,
lon: 24.71419
},
{
id: "U3RvcDpIU0w6MjcxNDI4Ng==",
lat: 60.28103,
lon: 24.71065
},
{
id: "U3RvcDpIU0w6MjcxMTI3Nw==",
lat: 60.28582,
lon: 24.70576
},
{
id: "U3RvcDpIU0w6MjcxMTI3NQ==",
lat: 60.29623,
lon: 24.6991
}
]
},
{
gtfsId: "HSL:1064",
shortName: "64",
longName: "Rautatientori-Oulunkylä-Itä-Pakila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM1MzExNw==",
lat: 60.25122,
lon: 24.96204
},
{
id: "U3RvcDpIU0w6MTM0MjExNg==",
lat: 60.24864,
lon: 24.95813
},
{
id: "U3RvcDpIU0w6MTM0MjExNA==",
lat: 60.2455,
lon: 24.95834
},
{
id: "U3RvcDpIU0w6MTM0MjExMg==",
lat: 60.24213,
lon: 24.95947
},
{
id: "U3RvcDpIU0w6MTM0MjExMA==",
lat: 60.24024,
lon: 24.96031
},
{
id: "U3RvcDpIU0w6MTI4NDE1OQ==",
lat: 60.23735,
lon: 24.96367
},
{
id: "U3RvcDpIU0w6MTI4NDEyMw==",
lat: 60.232717,
lon: 24.967113
},
{
id: "U3RvcDpIU0w6MTI4NDExOA==",
lat: 60.22968,
lon: 24.9646
},
{
id: "U3RvcDpIU0w6MTI4NDE4OQ==",
lat: 60.22882,
lon: 24.96222
},
{
id: "U3RvcDpIU0w6MTI4NDE1Ng==",
lat: 60.22702,
lon: 24.95606
},
{
id: "U3RvcDpIU0w6MTI4NDE1NA==",
lat: 60.224304,
lon: 24.951293
},
{
id: "U3RvcDpIU0w6MTI4NDE1Mg==",
lat: 60.222696,
lon: 24.947854
},
{
id: "U3RvcDpIU0w6MTI4MzEzMQ==",
lat: 60.22105,
lon: 24.9431
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDEyMw==",
lat: 60.17134,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDEwMw==",
lat: 60.19531,
lon: 24.95583
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDE1Mw==",
lat: 60.22125,
lon: 24.94678
},
{
id: "U3RvcDpIU0w6MTI4NDE1MQ==",
lat: 60.223631,
lon: 24.950064
},
{
id: "U3RvcDpIU0w6MTI4NDE4Mg==",
lat: 60.224861,
lon: 24.952464
},
{
id: "U3RvcDpIU0w6MTI4NDE1NQ==",
lat: 60.22748,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTI4NDE4OA==",
lat: 60.2288,
lon: 24.96248
},
{
id: "U3RvcDpIU0w6MTI4NDExNw==",
lat: 60.22996,
lon: 24.96525
},
{
id: "U3RvcDpIU0w6MTI4NDEyMA==",
lat: 60.23192,
lon: 24.96787
},
{
id: "U3RvcDpIU0w6MTI4NDE1Nw==",
lat: 60.23479,
lon: 24.9657
},
{
id: "U3RvcDpIU0w6MTI4NDE1OA==",
lat: 60.23752,
lon: 24.96372
},
{
id: "U3RvcDpIU0w6MTI4NDEwOQ==",
lat: 60.23981,
lon: 24.96122
},
{
id: "U3RvcDpIU0w6MTM0MjExMQ==",
lat: 60.24291,
lon: 24.95924
},
{
id: "U3RvcDpIU0w6MTM0MjExMw==",
lat: 60.24581,
lon: 24.95838
},
{
id: "U3RvcDpIU0w6MTM0MjExNQ==",
lat: 60.24861,
lon: 24.95825
}
]
},
{
gtfsId: "HSL:1063",
shortName: "63",
longName: "Kamppi-Ruskeasuo-Maunula-Paloheinä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM1MTExMg==",
lat: 60.24888,
lon: 24.94679
},
{
id: "U3RvcDpIU0w6MTM1MTEwOA==",
lat: 60.24969,
lon: 24.94116
},
{
id: "U3RvcDpIU0w6MTM1MTEwNg==",
lat: 60.24933,
lon: 24.93426
},
{
id: "U3RvcDpIU0w6MTM1MTEwNA==",
lat: 60.24872,
lon: 24.92689
},
{
id: "U3RvcDpIU0w6MTM1MTEwMg==",
lat: 60.24687,
lon: 24.9239
},
{
id: "U3RvcDpIU0w6MTM0MTEyNQ==",
lat: 60.24433,
lon: 24.92518
},
{
id: "U3RvcDpIU0w6MTM0MTEyMw==",
lat: 60.24172,
lon: 24.92653
},
{
id: "U3RvcDpIU0w6MTM0MTEyMQ==",
lat: 60.23958,
lon: 24.9279
},
{
id: "U3RvcDpIU0w6MTM0MTExOQ==",
lat: 60.23664,
lon: 24.92902
},
{
id: "U3RvcDpIU0w6MTI4MjEwNg==",
lat: 60.23351,
lon: 24.93171
},
{
id: "U3RvcDpIU0w6MTI4MjEwNA==",
lat: 60.23154,
lon: 24.93381
},
{
id: "U3RvcDpIU0w6MTI4MjE0Nw==",
lat: 60.230679,
lon: 24.932013
},
{
id: "U3RvcDpIU0w6MTI4MjE0NQ==",
lat: 60.228725,
lon: 24.927237
},
{
id: "U3RvcDpIU0w6MTI4MjEzOQ==",
lat: 60.227679,
lon: 24.926687
},
{
id: "U3RvcDpIU0w6MTI4MjEzNw==",
lat: 60.22526,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTI4NjEzNQ==",
lat: 60.2216,
lon: 24.9333
},
{
id: "U3RvcDpIU0w6MTI4NjE4MA==",
lat: 60.22089,
lon: 24.92812
},
{
id: "U3RvcDpIU0w6MTI5MTE0OA==",
lat: 60.21565,
lon: 24.90568
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTEzMDExMw==",
lat: 60.170862,
lon: 24.930898
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
},
{
id: "U3RvcDpIU0w6MTA0MDI3NA==",
lat: 60.16904,
lon: 24.931804
},
{
id: "U3RvcDpIU0w6MTEzMDExMQ==",
lat: 60.17419,
lon: 24.93349
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEwMg==",
lat: 60.20967,
lon: 24.89578
},
{
id: "U3RvcDpIU0w6MTI5MTEwNA==",
lat: 60.2123,
lon: 24.89835
},
{
id: "U3RvcDpIU0w6MTI5MTE0Nw==",
lat: 60.21282,
lon: 24.90247
},
{
id: "U3RvcDpIU0w6MTI5MjE0OQ==",
lat: 60.21642,
lon: 24.9066
},
{
id: "U3RvcDpIU0w6MTI4NjE3OQ==",
lat: 60.2208,
lon: 24.92997
},
{
id: "U3RvcDpIU0w6MTI4NjEzNA==",
lat: 60.223362,
lon: 24.933546
},
{
id: "U3RvcDpIU0w6MTI4MjEzNg==",
lat: 60.22544,
lon: 24.93073
},
{
id: "U3RvcDpIU0w6MTI4MjE0Mg==",
lat: 60.22827,
lon: 24.92673
},
{
id: "U3RvcDpIU0w6MTI4MjE0Ng==",
lat: 60.23062,
lon: 24.93342
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MTEwNw==",
lat: 60.23472,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTM0MTExOA==",
lat: 60.23743,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTM0MTEyMA==",
lat: 60.23948,
lon: 24.92814
},
{
id: "U3RvcDpIU0w6MTM0MTEyMg==",
lat: 60.24185,
lon: 24.92687
},
{
id: "U3RvcDpIU0w6MTM0MTEyNA==",
lat: 60.24426,
lon: 24.9254
},
{
id: "U3RvcDpIU0w6MTM1MTEwMQ==",
lat: 60.24797,
lon: 24.92389
},
{
id: "U3RvcDpIU0w6MTM1MTEwMw==",
lat: 60.24882,
lon: 24.92861
},
{
id: "U3RvcDpIU0w6MTM1MTEwNQ==",
lat: 60.24935,
lon: 24.93492
},
{
id: "U3RvcDpIU0w6MTM1MTEwNw==",
lat: 60.24962,
lon: 24.94126
}
]
},
{
gtfsId: "HSL:1061",
shortName: "61",
longName: "Rautatientori-Pukinmäki-Siltamäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMw==",
lat: 60.17134,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDEwMw==",
lat: 60.19531,
lon: 24.95583
},
{
id: "U3RvcDpIU0w6MTIyMDEwNg==",
lat: 60.19773,
lon: 24.94984
},
{
id: "U3RvcDpIU0w6MTI0MDEwOQ==",
lat: 60.20115,
lon: 24.94529
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDEwMw==",
lat: 60.21246,
lon: 24.9439
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDEyOQ==",
lat: 60.22999,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDE3Mg==",
lat: 60.23425,
lon: 24.96753
},
{
id: "U3RvcDpIU0w6MTI4NDE3NQ==",
lat: 60.23609,
lon: 24.97254
},
{
id: "U3RvcDpIU0w6MTM3MDEwMw==",
lat: 60.23991,
lon: 24.97993
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM3MDEwOQ==",
lat: 60.24398,
lon: 24.99386
},
{
id: "U3RvcDpIU0w6MTM3MDExMQ==",
lat: 60.24716,
lon: 24.99175
},
{
id: "U3RvcDpIU0w6MTM3MDExMw==",
lat: 60.25129,
lon: 24.98678
},
{
id: "U3RvcDpIU0w6MTM5MTExNg==",
lat: 60.25464,
lon: 24.9837
},
{
id: "U3RvcDpIU0w6MTM5MTExOA==",
lat: 60.257215,
lon: 24.981581
},
{
id: "U3RvcDpIU0w6MTM5MTEyMA==",
lat: 60.25975,
lon: 24.98156
},
{
id: "U3RvcDpIU0w6MTM5MTEyMg==",
lat: 60.26134,
lon: 24.98419
},
{
id: "U3RvcDpIU0w6MTM5MTExMg==",
lat: 60.26381,
lon: 24.98384
},
{
id: "U3RvcDpIU0w6MTQwMzEyNg==",
lat: 60.2669,
lon: 24.99344
},
{
id: "U3RvcDpIU0w6MTQwMTEwMw==",
lat: 60.27145,
lon: 24.99206
},
{
id: "U3RvcDpIU0w6MTQwMTEwNQ==",
lat: 60.27532,
lon: 24.99112
},
{
id: "U3RvcDpIU0w6MTQwMTEzMA==",
lat: 60.27739,
lon: 24.98963
},
{
id: "U3RvcDpIU0w6MTQwMTEzMg==",
lat: 60.276818,
lon: 24.990048
},
{
id: "U3RvcDpIU0w6MTQwMTEwNw==",
lat: 60.27497,
lon: 24.99117
},
{
id: "U3RvcDpIU0w6MTQwMTEwNA==",
lat: 60.27209,
lon: 24.9922
},
{
id: "U3RvcDpIU0w6MTQwMzEyNw==",
lat: 60.26665,
lon: 24.99296
},
{
id: "U3RvcDpIU0w6MTM5MTExMw==",
lat: 60.26397,
lon: 24.98368
},
{
id: "U3RvcDpIU0w6MTM5MTEyMw==",
lat: 60.2612,
lon: 24.98378
},
{
id: "U3RvcDpIU0w6MTM5MTEyMQ==",
lat: 60.25907,
lon: 24.98039
},
{
id: "U3RvcDpIU0w6MTM5MTExOQ==",
lat: 60.257,
lon: 24.98152
},
{
id: "U3RvcDpIU0w6MTM5MTExNw==",
lat: 60.25443,
lon: 24.98369
},
{
id: "U3RvcDpIU0w6MTM3MDExNA==",
lat: 60.25075,
lon: 24.98685
},
{
id: "U3RvcDpIU0w6MTM3MDExMg==",
lat: 60.24732,
lon: 24.99163
},
{
id: "U3RvcDpIU0w6MTM3MDExMA==",
lat: 60.24324,
lon: 24.99451
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM3MDEwNA==",
lat: 60.2399,
lon: 24.97954
},
{
id: "U3RvcDpIU0w6MTI4NDE3OA==",
lat: 60.23699,
lon: 24.97454
},
{
id: "U3RvcDpIU0w6MTI4NDE3NA==",
lat: 60.23539,
lon: 24.97034
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEyNw==",
lat: 60.23022,
lon: 24.94776
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:9964K",
shortName: "964K",
longName: "Rannikonmäki-Rusutjärvi-Paijala-Hyrylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY0MDExNg==",
lat: 60.462947,
lon: 24.931136
},
{
id: "U3RvcDpIU0w6OTY0MDExMg==",
lat: 60.460283,
lon: 24.937101
},
{
id: "U3RvcDpIU0w6OTY0MDExMQ==",
lat: 60.45923,
lon: 24.943752
},
{
id: "U3RvcDpIU0w6OTY0MDEwMA==",
lat: 60.454664,
lon: 24.946674
},
{
id: "U3RvcDpIU0w6OTY0MDEwNA==",
lat: 60.449735,
lon: 24.950241
},
{
id: "U3RvcDpIU0w6OTY0MDEwMg==",
lat: 60.445237,
lon: 24.951335
},
{
id: "U3RvcDpIU0w6OTY0MDMwOQ==",
lat: 60.437029,
lon: 24.953767
},
{
id: "U3RvcDpIU0w6OTY0MDMwMg==",
lat: 60.432876,
lon: 24.955259
},
{
id: "U3RvcDpIU0w6OTY0MDQxNA==",
lat: 60.426718,
lon: 24.964944
},
{
id: "U3RvcDpIU0w6OTY0MDQxOQ==",
lat: 60.426939,
lon: 24.966471
},
{
id: "U3RvcDpIU0w6OTY0MDQxMA==",
lat: 60.432069,
lon: 24.968641
},
{
id: "U3RvcDpIU0w6OTY0MDQwOA==",
lat: 60.435641,
lon: 24.967833
},
{
id: "U3RvcDpIU0w6OTY0MDQwNg==",
lat: 60.437584,
lon: 24.970678
},
{
id: "U3RvcDpIU0w6OTY0MDIwMA==",
lat: 60.438756,
lon: 24.980235
},
{
id: "U3RvcDpIU0w6OTY0MDQyMA==",
lat: 60.433934,
lon: 24.987427
},
{
id: "U3RvcDpIU0w6OTY0MDQxMg==",
lat: 60.426842,
lon: 24.995887
},
{
id: "U3RvcDpIU0w6OTY1MTAwNg==",
lat: 60.416793,
lon: 25.000696
},
{
id: "U3RvcDpIU0w6OTY1MDgwNA==",
lat: 60.416225,
lon: 25.005537
},
{
id: "U3RvcDpIU0w6OTY1MDgwNQ==",
lat: 60.416767,
lon: 25.018242
},
{
id: "U3RvcDpIU0w6OTY1MDkwNg==",
lat: 60.410065,
lon: 25.014522
},
{
id: "U3RvcDpIU0w6OTY1MDkwMg==",
lat: 60.405499,
lon: 25.012577
},
{
id: "U3RvcDpIU0w6OTY1MDMwMw==",
lat: 60.4033,
lon: 25.02419
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
}
]
},
{
gtfsId: "HSL:2246K",
shortName: "246K",
longName: "Espoon keskus-Kellonummi-Röylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcxMjAwMg==",
lat: 60.297265,
lon: 24.691783
},
{
id: "U3RvcDpIU0w6MjcxMTI3NA==",
lat: 60.29655,
lon: 24.69787
},
{
id: "U3RvcDpIU0w6MjcxMTI3Ng==",
lat: 60.28525,
lon: 24.70586
},
{
id: "U3RvcDpIU0w6MjcxNDI4Nw==",
lat: 60.28069,
lon: 24.71109
},
{
id: "U3RvcDpIU0w6MjcxNDI3OA==",
lat: 60.27783,
lon: 24.71334
},
{
id: "U3RvcDpIU0w6MjcxNDIwMQ==",
lat: 60.27483,
lon: 24.71475
},
{
id: "U3RvcDpIU0w6MjcxMjIwMw==",
lat: 60.27151,
lon: 24.70998
},
{
id: "U3RvcDpIU0w6MjcxMjIwNQ==",
lat: 60.26756,
lon: 24.70833
},
{
id: "U3RvcDpIU0w6MjcxMjIxMQ==",
lat: 60.26601,
lon: 24.70654
},
{
id: "U3RvcDpIU0w6MjcxMjIxMA==",
lat: 60.26097,
lon: 24.70608
},
{
id: "U3RvcDpIU0w6MjcxMjIwNw==",
lat: 60.25929,
lon: 24.7012
},
{
id: "U3RvcDpIU0w6MjcxMjI1OQ==",
lat: 60.26231,
lon: 24.69151
},
{
id: "U3RvcDpIU0w6MjcxMjIxMg==",
lat: 60.264893,
lon: 24.691065
},
{
id: "U3RvcDpIU0w6MjcxMjI2MQ==",
lat: 60.26783,
lon: 24.69017
},
{
id: "U3RvcDpIU0w6MjcxMjI2Mw==",
lat: 60.27116,
lon: 24.68959
},
{
id: "U3RvcDpIU0w6MjcxMjI2NQ==",
lat: 60.2748,
lon: 24.68059
},
{
id: "U3RvcDpIU0w6MjcxMTI2Nw==",
lat: 60.27483,
lon: 24.66649
},
{
id: "U3RvcDpIU0w6MjcxMTI2OA==",
lat: 60.274001,
lon: 24.656342
},
{
id: "U3RvcDpIU0w6MjYzNTI2Ng==",
lat: 60.268029,
lon: 24.653459
},
{
id: "U3RvcDpIU0w6MjYzNTI2NA==",
lat: 60.2623,
lon: 24.653
},
{
id: "U3RvcDpIU0w6MjYzNTIyNQ==",
lat: 60.25477,
lon: 24.65249
},
{
id: "U3RvcDpIU0w6MjYzNTIyMw==",
lat: 60.25019,
lon: 24.65483
},
{
id: "U3RvcDpIU0w6MjYzNDI2Mg==",
lat: 60.244566,
lon: 24.653642
},
{
id: "U3RvcDpIU0w6MjYzNDI2NQ==",
lat: 60.23961,
lon: 24.64079
},
{
id: "U3RvcDpIU0w6MjYzNDI3MA==",
lat: 60.23815,
lon: 24.65545
},
{
id: "U3RvcDpIU0w6MjYzNDI2MA==",
lat: 60.23559,
lon: 24.6576
},
{
id: "U3RvcDpIU0w6MjYzNDI3Mg==",
lat: 60.2328,
lon: 24.65912
},
{
id: "U3RvcDpIU0w6MjYzNDI3NA==",
lat: 60.22863,
lon: 24.66523
},
{
id: "U3RvcDpIU0w6MjYzNDIwMw==",
lat: 60.22727,
lon: 24.6678
},
{
id: "U3RvcDpIU0w6MjYzNDI3OA==",
lat: 60.2243,
lon: 24.66961
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
},
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYxNDI4Ng==",
lat: 60.22219,
lon: 24.66789
},
{
id: "U3RvcDpIU0w6MjYzNDI3OQ==",
lat: 60.22482,
lon: 24.67003
},
{
id: "U3RvcDpIU0w6MjYzMzIwMg==",
lat: 60.22794,
lon: 24.66676
},
{
id: "U3RvcDpIU0w6MjYzNDI3Nw==",
lat: 60.22894,
lon: 24.66508
},
{
id: "U3RvcDpIU0w6MjYzNDI3Ng==",
lat: 60.23321,
lon: 24.65923
},
{
id: "U3RvcDpIU0w6MjYzNDI2MQ==",
lat: 60.23591,
lon: 24.65655
},
{
id: "U3RvcDpIU0w6MjYzNDI3NQ==",
lat: 60.23899,
lon: 24.65577
},
{
id: "U3RvcDpIU0w6MjYzNDI2Mw==",
lat: 60.24418,
lon: 24.65407
},
{
id: "U3RvcDpIU0w6MjYzNDI2NA==",
lat: 60.24003,
lon: 24.64118
},
{
id: "U3RvcDpIU0w6MjYzNTIyMg==",
lat: 60.2502,
lon: 24.65506
},
{
id: "U3RvcDpIU0w6MjYzNTIyNg==",
lat: 60.25515,
lon: 24.65259
},
{
id: "U3RvcDpIU0w6MjYzNTI2NQ==",
lat: 60.26227,
lon: 24.65307
},
{
id: "U3RvcDpIU0w6MjYzNTI2Nw==",
lat: 60.268937,
lon: 24.653134
},
{
id: "U3RvcDpIU0w6MjYzNTIyNA==",
lat: 60.273911,
lon: 24.656377
},
{
id: "U3RvcDpIU0w6MjcxMTI2Ng==",
lat: 60.27479,
lon: 24.66714
},
{
id: "U3RvcDpIU0w6MjcxMTI2OQ==",
lat: 60.2839,
lon: 24.67614
},
{
id: "U3RvcDpIU0w6MjcxMTI3MQ==",
lat: 60.28908,
lon: 24.67804
},
{
id: "U3RvcDpIU0w6MjcxMTIwMw==",
lat: 60.29528,
lon: 24.6864
}
]
},
{
gtfsId: "HSL:2149",
shortName: "149",
longName: "Espoonlahden keskus-Kivenlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQxMTIwNQ==",
lat: 60.14667,
lon: 24.658885
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMTI1NQ==",
lat: 60.15105,
lon: 24.64954
},
{
id: "U3RvcDpIU0w6MjQxMTIwMw==",
lat: 60.15338,
lon: 24.65167
},
{
id: "U3RvcDpIU0w6MjQxMzIyNA==",
lat: 60.154012,
lon: 24.643547
},
{
id: "U3RvcDpIU0w6MjQxMzIyNQ==",
lat: 60.153837,
lon: 24.646038
},
{
id: "U3RvcDpIU0w6MjQxMzIyNg==",
lat: 60.151704,
lon: 24.646537
},
{
id: "U3RvcDpIU0w6MjQxNDI3MA==",
lat: 60.14773,
lon: 24.64054
},
{
id: "U3RvcDpIU0w6MjQxMzIyMw==",
lat: 60.14918,
lon: 24.63589
},
{
id: "U3RvcDpIU0w6MjQxNDI3MQ==",
lat: 60.1482,
lon: 24.64181
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIyMA==",
lat: 60.150591,
lon: 24.63885
},
{
id: "U3RvcDpIU0w6MjQxMzIxOQ==",
lat: 60.152333,
lon: 24.639868
},
{
id: "U3RvcDpIU0w6MjQxMzIyMQ==",
lat: 60.150527,
lon: 24.638932
},
{
id: "U3RvcDpIU0w6MjQxMzIyMg==",
lat: 60.149884,
lon: 24.638477
},
{
id: "U3RvcDpIU0w6MjQxMzIxNw==",
lat: 60.15308,
lon: 24.635611
},
{
id: "U3RvcDpIU0w6MjQxMzIxNg==",
lat: 60.154657,
lon: 24.641723
},
{
id: "U3RvcDpIU0w6MjQxMzIxOA==",
lat: 60.153422,
lon: 24.636179
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIwNA==",
lat: 60.154232,
lon: 24.633898
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIwMQ==",
lat: 60.155223,
lon: 24.62771
},
{
id: "U3RvcDpIU0w6MjQxMzIwMw==",
lat: 60.154946,
lon: 24.62963
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwMg==",
lat: 60.154205,
lon: 24.633862
},
{
id: "U3RvcDpIU0w6MjQxMzIxNQ==",
lat: 60.15301,
lon: 24.63405
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzIyNw==",
lat: 60.151748,
lon: 24.646597
},
{
id: "U3RvcDpIU0w6MjQxMTIxMA==",
lat: 60.152591,
lon: 24.653972
},
{
id: "U3RvcDpIU0w6MjQxMTIxMg==",
lat: 60.15133,
lon: 24.663707
},
{
id: "U3RvcDpIU0w6MjQxMTIwOQ==",
lat: 60.149106,
lon: 24.66174
},
{
id: "U3RvcDpIU0w6MjQxMTIwNg==",
lat: 60.148998,
lon: 24.660094
},
{
id: "U3RvcDpIU0w6MjQxMTIzOQ==",
lat: 60.14776,
lon: 24.6582
}
]
},
{
gtfsId: "HSL:1059",
shortName: "59",
longName: "Sompasaari-Kalasatama(M)-Pasila-Pajamäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTEwMDEzMA==",
lat: 60.184567,
lon: 24.974413
},
{
id: "U3RvcDpIU0w6MTEwMDEyOA==",
lat: 60.184007,
lon: 24.980304
},
{
id: "U3RvcDpIU0w6MTEwMDEzMQ==",
lat: 60.187162,
lon: 24.977327
},
{
id: "U3RvcDpIU0w6MTEwMDExOQ==",
lat: 60.189218,
lon: 24.971152
},
{
id: "U3RvcDpIU0w6MTIyMDExOQ==",
lat: 60.18964,
lon: 24.96309
},
{
id: "U3RvcDpIU0w6MTIyMDExMg==",
lat: 60.19091,
lon: 24.95609
},
{
id: "U3RvcDpIU0w6MTIyMDEzNA==",
lat: 60.19321,
lon: 24.95005
},
{
id: "U3RvcDpIU0w6MTIyMDExNA==",
lat: 60.194732,
lon: 24.946392
},
{
id: "U3RvcDpIU0w6MTE3MzExMw==",
lat: 60.19669,
lon: 24.941768
},
{
id: "U3RvcDpIU0w6MTE3MzEyMw==",
lat: 60.198626,
lon: 24.937843
},
{
id: "U3RvcDpIU0w6MTE3MTE1NA==",
lat: 60.200915,
lon: 24.926832
},
{
id: "U3RvcDpIU0w6MTE3MTEzMA==",
lat: 60.20279,
lon: 24.92483
},
{
id: "U3RvcDpIU0w6MTE3MTEyNA==",
lat: 60.20241,
lon: 24.92193
},
{
id: "U3RvcDpIU0w6MTE3MTEyNg==",
lat: 60.203862,
lon: 24.918633
},
{
id: "U3RvcDpIU0w6MTE3MTE4MA==",
lat: 60.206258,
lon: 24.917854
},
{
id: "U3RvcDpIU0w6MTE3MTEwNQ==",
lat: 60.20793,
lon: 24.91536
},
{
id: "U3RvcDpIU0w6MTI5MjEyMg==",
lat: 60.208153,
lon: 24.902368
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTIyMA==",
lat: 60.21031,
lon: 24.88865
},
{
id: "U3RvcDpIU0w6MTQ2NTE0Mw==",
lat: 60.214064,
lon: 24.880445
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2MTEwNw==",
lat: 60.219115,
lon: 24.859239
},
{
id: "U3RvcDpIU0w6MTQ2MTEwOQ==",
lat: 60.21904,
lon: 24.85532
},
{
id: "U3RvcDpIU0w6MTQ2MTExMA==",
lat: 60.21884,
lon: 24.85662
},
{
id: "U3RvcDpIU0w6MTQ2MTEwOA==",
lat: 60.219067,
lon: 24.859797
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTExOQ==",
lat: 60.209999,
lon: 24.888297
},
{
id: "U3RvcDpIU0w6MTE2MDExOA==",
lat: 60.207853,
lon: 24.900612
},
{
id: "U3RvcDpIU0w6MTI5MjEyMw==",
lat: 60.208,
lon: 24.90581
},
{
id: "U3RvcDpIU0w6MTE3MTEwNA==",
lat: 60.20791,
lon: 24.91521
},
{
id: "U3RvcDpIU0w6MTE3MTEyMQ==",
lat: 60.205915,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE3MTEyNw==",
lat: 60.20309,
lon: 24.91942
},
{
id: "U3RvcDpIU0w6MTE3MTEyNQ==",
lat: 60.20226,
lon: 24.92151
},
{
id: "U3RvcDpIU0w6MTE3MTEzMQ==",
lat: 60.20267,
lon: 24.92511
},
{
id: "U3RvcDpIU0w6MTE3MTE1OA==",
lat: 60.20111,
lon: 24.92664
},
{
id: "U3RvcDpIU0w6MTE3MzEwNA==",
lat: 60.1983,
lon: 24.937373
},
{
id: "U3RvcDpIU0w6MTIyMDEzMQ==",
lat: 60.196616,
lon: 24.94209
},
{
id: "U3RvcDpIU0w6MTIyMDExNw==",
lat: 60.19528,
lon: 24.94443
},
{
id: "U3RvcDpIU0w6MTIyMDExNQ==",
lat: 60.19326,
lon: 24.94925
},
{
id: "U3RvcDpIU0w6MTIyMDExMw==",
lat: 60.19119,
lon: 24.95434
},
{
id: "U3RvcDpIU0w6MTIyMDEyMA==",
lat: 60.189463,
lon: 24.962315
},
{
id: "U3RvcDpIU0w6MTEwMDEyMA==",
lat: 60.18906,
lon: 24.97123
},
{
id: "U3RvcDpIU0w6MTEwMDEzMg==",
lat: 60.186708,
lon: 24.976782
}
]
},
{
gtfsId: "HSL:2148",
shortName: "148",
longName: "Espoonlahden keskus-Soukka-Iivisniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQxMTIwNQ==",
lat: 60.14667,
lon: 24.658885
},
{
id: "U3RvcDpIU0w6MjQxMTI0MA==",
lat: 60.14766,
lon: 24.65846
},
{
id: "U3RvcDpIU0w6MjQxMTIwOA==",
lat: 60.149163,
lon: 24.658562
},
{
id: "U3RvcDpIU0w6MjQxMTIwNw==",
lat: 60.148961,
lon: 24.661566
},
{
id: "U3RvcDpIU0w6MjQxMTIxMw==",
lat: 60.151333,
lon: 24.664015
},
{
id: "U3RvcDpIU0w6MjQxMTIxMQ==",
lat: 60.152576,
lon: 24.653668
},
{
id: "U3RvcDpIU0w6MjQxMzI1OA==",
lat: 60.151653,
lon: 24.65062
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxNDIxOQ==",
lat: 60.14549,
lon: 24.65467
},
{
id: "U3RvcDpIU0w6MjQxNDI2NQ==",
lat: 60.14119,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjQxMjIyMQ==",
lat: 60.13965,
lon: 24.65853
},
{
id: "U3RvcDpIU0w6MjQxMjIwMg==",
lat: 60.139885,
lon: 24.664542
},
{
id: "U3RvcDpIU0w6MjQxMjIyMw==",
lat: 60.14108,
lon: 24.66475
},
{
id: "U3RvcDpIU0w6MjQxMjIyNQ==",
lat: 60.14215,
lon: 24.66883
},
{
id: "U3RvcDpIU0w6MjQxMjIyOQ==",
lat: 60.141393,
lon: 24.67125
},
{
id: "U3RvcDpIU0w6MjQxMjIwMQ==",
lat: 60.140625,
lon: 24.669925
},
{
id: "U3RvcDpIU0w6MjQxMjIzMQ==",
lat: 60.13993,
lon: 24.67253
},
{
id: "U3RvcDpIU0w6MjQxMjIwNA==",
lat: 60.137723,
lon: 24.670397
},
{
id: "U3RvcDpIU0w6MjQxMjIwNw==",
lat: 60.138814,
lon: 24.673537
},
{
id: "U3RvcDpIU0w6MjQxMjIzMw==",
lat: 60.13789,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjQxNTIwMw==",
lat: 60.136514,
lon: 24.679891
},
{
id: "U3RvcDpIU0w6MjQ0MzIyMQ==",
lat: 60.138376,
lon: 24.682687
},
{
id: "U3RvcDpIU0w6MjQ0MzIxOQ==",
lat: 60.14071,
lon: 24.68362
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNw==",
lat: 60.14333,
lon: 24.68226
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMw==",
lat: 60.14759,
lon: 24.68258
},
{
id: "U3RvcDpIU0w6MjQ0MTIwNA==",
lat: 60.149311,
lon: 24.695355
},
{
id: "U3RvcDpIU0w6MjQ0MTIwNQ==",
lat: 60.148547,
lon: 24.691343
},
{
id: "U3RvcDpIU0w6MjQ0MTIwMg==",
lat: 60.147515,
lon: 24.69261
},
{
id: "U3RvcDpIU0w6MjQ0MTIwNg==",
lat: 60.148233,
lon: 24.691838
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMA==",
lat: 60.15,
lon: 24.68924
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMg==",
lat: 60.14756,
lon: 24.68237
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNg==",
lat: 60.14261,
lon: 24.68242
},
{
id: "U3RvcDpIU0w6MjQ0MzIxOA==",
lat: 60.14097,
lon: 24.68357
},
{
id: "U3RvcDpIU0w6MjQ0MzIwMg==",
lat: 60.137719,
lon: 24.682444
},
{
id: "U3RvcDpIU0w6MjQ0MzI4Mg==",
lat: 60.136453,
lon: 24.678871
},
{
id: "U3RvcDpIU0w6MjQxMjIzNA==",
lat: 60.13805,
lon: 24.67337
},
{
id: "U3RvcDpIU0w6MjQxMjIzMg==",
lat: 60.14018,
lon: 24.6725
},
{
id: "U3RvcDpIU0w6MjQxMjIzMA==",
lat: 60.141527,
lon: 24.671379
},
{
id: "U3RvcDpIU0w6MjQxMjIyNg==",
lat: 60.142484,
lon: 24.669383
},
{
id: "U3RvcDpIU0w6MjQxMjIyNA==",
lat: 60.14102,
lon: 24.66353
},
{
id: "U3RvcDpIU0w6MjQxMjIyMg==",
lat: 60.13979,
lon: 24.65859
},
{
id: "U3RvcDpIU0w6MjQxMTI2NA==",
lat: 60.14202,
lon: 24.65681
},
{
id: "U3RvcDpIU0w6MjQxMTIyMA==",
lat: 60.1451,
lon: 24.65533
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMTI1NQ==",
lat: 60.15105,
lon: 24.64954
},
{
id: "U3RvcDpIU0w6MjQxMTIxMA==",
lat: 60.152591,
lon: 24.653972
},
{
id: "U3RvcDpIU0w6MjQxMTIxMg==",
lat: 60.15133,
lon: 24.663707
},
{
id: "U3RvcDpIU0w6MjQxMTIwOQ==",
lat: 60.149106,
lon: 24.66174
},
{
id: "U3RvcDpIU0w6MjQxMTIwNg==",
lat: 60.148998,
lon: 24.660094
},
{
id: "U3RvcDpIU0w6MjQxMTIzOQ==",
lat: 60.14776,
lon: 24.6582
}
]
},
{
gtfsId: "HSL:2147",
shortName: "147",
longName: "Matinkylä (M)-Iivisniemi-Soukka-Laurinlahti-Kivenlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxMQ==",
lat: 60.15326,
lon: 24.63371
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxNDI3MA==",
lat: 60.14773,
lon: 24.64054
},
{
id: "U3RvcDpIU0w6MjQxNDI2OA==",
lat: 60.144918,
lon: 24.640847
},
{
id: "U3RvcDpIU0w6MjQxNDI1NQ==",
lat: 60.14423,
lon: 24.64796
},
{
id: "U3RvcDpIU0w6MjQxMTI1NA==",
lat: 60.14538,
lon: 24.65272
},
{
id: "U3RvcDpIU0w6MjQxNDIxOQ==",
lat: 60.14549,
lon: 24.65467
},
{
id: "U3RvcDpIU0w6MjQxNDI2NQ==",
lat: 60.14119,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjQxMjIyMQ==",
lat: 60.13965,
lon: 24.65853
},
{
id: "U3RvcDpIU0w6MjQxMjIyMw==",
lat: 60.14108,
lon: 24.66475
},
{
id: "U3RvcDpIU0w6MjQxMjIyNQ==",
lat: 60.14215,
lon: 24.66883
},
{
id: "U3RvcDpIU0w6MjQxMjIyNw==",
lat: 60.143373,
lon: 24.673594
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNQ==",
lat: 60.14522,
lon: 24.67967
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMw==",
lat: 60.14759,
lon: 24.68258
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMQ==",
lat: 60.151014,
lon: 24.692223
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMg==",
lat: 60.152988,
lon: 24.698956
},
{
id: "U3RvcDpIU0w6MjQ0MTIxNA==",
lat: 60.152772,
lon: 24.705127
},
{
id: "U3RvcDpIU0w6MjQ0MTIzMw==",
lat: 60.15368,
lon: 24.71046
},
{
id: "U3RvcDpIU0w6MjQ0MTIwOQ==",
lat: 60.155789,
lon: 24.714964
},
{
id: "U3RvcDpIU0w6MjMxNDIyNg==",
lat: 60.15706,
lon: 24.72747
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxNA==",
lat: 60.160223,
lon: 24.738806
},
{
id: "U3RvcDpIU0w6MjMxNDIyNA==",
lat: 60.15827,
lon: 24.73214
},
{
id: "U3RvcDpIU0w6MjMxMjIwMg==",
lat: 60.156464,
lon: 24.725221
},
{
id: "U3RvcDpIU0w6MjQ0MjIyNA==",
lat: 60.155586,
lon: 24.713352
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMw==",
lat: 60.153083,
lon: 24.703151
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNg==",
lat: 60.153001,
lon: 24.696816
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMA==",
lat: 60.15,
lon: 24.68924
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMg==",
lat: 60.14756,
lon: 24.68237
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNA==",
lat: 60.14542,
lon: 24.67975
},
{
id: "U3RvcDpIU0w6MjQxMjIyOA==",
lat: 60.143279,
lon: 24.672656
},
{
id: "U3RvcDpIU0w6MjQxMjIyNg==",
lat: 60.142484,
lon: 24.669383
},
{
id: "U3RvcDpIU0w6MjQxMjIyNA==",
lat: 60.14102,
lon: 24.66353
},
{
id: "U3RvcDpIU0w6MjQxMjIyMg==",
lat: 60.13979,
lon: 24.65859
},
{
id: "U3RvcDpIU0w6MjQxMTI2NA==",
lat: 60.14202,
lon: 24.65681
},
{
id: "U3RvcDpIU0w6MjQxMTIyMA==",
lat: 60.1451,
lon: 24.65533
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mw==",
lat: 60.14491,
lon: 24.65111
},
{
id: "U3RvcDpIU0w6MjQxNDI2Nw==",
lat: 60.14383,
lon: 24.64506
},
{
id: "U3RvcDpIU0w6MjQxNDI2OQ==",
lat: 60.145746,
lon: 24.640377
},
{
id: "U3RvcDpIU0w6MjQxNDI3MQ==",
lat: 60.1482,
lon: 24.64181
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
}
]
},
{
gtfsId: "HSL:2146",
shortName: "146",
longName: "Matinkylä (M)-Espoonlahti-Kivenlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxMQ==",
lat: 60.15326,
lon: 24.63371
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxMTI0MA==",
lat: 60.14766,
lon: 24.65846
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOA==",
lat: 60.14873,
lon: 24.66543
},
{
id: "U3RvcDpIU0w6MjQxMTIyNQ==",
lat: 60.15011,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNg==",
lat: 60.15236,
lon: 24.66626
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxNQ==",
lat: 60.160214,
lon: 24.738752
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIyNA==",
lat: 60.15183,
lon: 24.66506
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOQ==",
lat: 60.14867,
lon: 24.66343
},
{
id: "U3RvcDpIU0w6MjQxMTIzOQ==",
lat: 60.14776,
lon: 24.6582
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
}
]
},
{
gtfsId: "HSL:1057",
shortName: "57",
longName: "Kontula(M) - Viikki - Koskela - Ruskeasuo - Munkkiniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MTEzNw==",
lat: 60.235733,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6MTQ3MTE4MQ==",
lat: 60.23674,
lon: 25.08167
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOQ==",
lat: 60.23797,
lon: 25.07866
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNg==",
lat: 60.23977,
lon: 25.07401
},
{
id: "U3RvcDpIU0w6MTQ3NDEwOA==",
lat: 60.24054,
lon: 25.07018
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNg==",
lat: 60.2387,
lon: 25.0672
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNA==",
lat: 60.23695,
lon: 25.06738
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMg==",
lat: 60.23314,
lon: 25.06215
},
{
id: "U3RvcDpIU0w6MTQ3NDEyNw==",
lat: 60.231617,
lon: 25.055574
},
{
id: "U3RvcDpIU0w6MTQ1NDEzMQ==",
lat: 60.229615,
lon: 25.052542
},
{
id: "U3RvcDpIU0w6MTM2MjEwMg==",
lat: 60.232588,
lon: 25.048672
},
{
id: "U3RvcDpIU0w6MTM2MjE0OA==",
lat: 60.23443,
lon: 25.04458
},
{
id: "U3RvcDpIU0w6MTM2MjE0Ng==",
lat: 60.23531,
lon: 25.04045
},
{
id: "U3RvcDpIU0w6MTM2MjE0NA==",
lat: 60.23451,
lon: 25.03253
},
{
id: "U3RvcDpIU0w6MTM2MjExOQ==",
lat: 60.233,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTM2MjEzMA==",
lat: 60.23052,
lon: 25.02988
},
{
id: "U3RvcDpIU0w6MTM2MjEyOA==",
lat: 60.22822,
lon: 25.02787
},
{
id: "U3RvcDpIU0w6MTM2MjExNg==",
lat: 60.22564,
lon: 25.02357
},
{
id: "U3RvcDpIU0w6MTM2MjExMg==",
lat: 60.22423,
lon: 25.0203
},
{
id: "U3RvcDpIU0w6MTM2MjEzOA==",
lat: 60.225563,
lon: 25.016455
},
{
id: "U3RvcDpIU0w6MTM2MjE0MA==",
lat: 60.22724,
lon: 25.01184
},
{
id: "U3RvcDpIU0w6MTM2MTEwOA==",
lat: 60.22744,
lon: 25.00263
},
{
id: "U3RvcDpIU0w6MTM2MTEyMA==",
lat: 60.225478,
lon: 24.997258
},
{
id: "U3RvcDpIU0w6MTM2MTEwNg==",
lat: 60.223823,
lon: 24.995055
},
{
id: "U3RvcDpIU0w6MTM2MTEwNA==",
lat: 60.21836,
lon: 24.98539
},
{
id: "U3RvcDpIU0w6MTI3MDEwNw==",
lat: 60.21705,
lon: 24.979
},
{
id: "U3RvcDpIU0w6MTI2MDEwMg==",
lat: 60.21515,
lon: 24.96438
},
{
id: "U3RvcDpIU0w6MTI1MDExNg==",
lat: 60.21238,
lon: 24.95536
},
{
id: "U3RvcDpIU0w6MTI1MDExNA==",
lat: 60.21108,
lon: 24.95203
},
{
id: "U3RvcDpIU0w6MTI1MDExMg==",
lat: 60.20938,
lon: 24.94761
},
{
id: "U3RvcDpIU0w6MTI1MDEzMw==",
lat: 60.20863,
lon: 24.94408
},
{
id: "U3RvcDpIU0w6MTE3MzEzMw==",
lat: 60.20753,
lon: 24.93986
},
{
id: "U3RvcDpIU0w6MTE3NDE0OQ==",
lat: 60.20694,
lon: 24.92919
},
{
id: "U3RvcDpIU0w6MTE3MTE1MA==",
lat: 60.2085,
lon: 24.91885
},
{
id: "U3RvcDpIU0w6MTI5MjEyMg==",
lat: 60.208153,
lon: 24.902368
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEzNw==",
lat: 60.20882,
lon: 24.88933
},
{
id: "U3RvcDpIU0w6MTI5MTEyMQ==",
lat: 60.20828,
lon: 24.88484
},
{
id: "U3RvcDpIU0w6MTMwNDEzNw==",
lat: 60.206219,
lon: 24.879857
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTE0OQ==",
lat: 60.19575,
lon: 24.88538
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MTMwNDEyNw==",
lat: 60.20289,
lon: 24.88189
},
{
id: "U3RvcDpIU0w6MTMwNDEzNg==",
lat: 60.20573,
lon: 24.88058
},
{
id: "U3RvcDpIU0w6MTI5MTEyMg==",
lat: 60.20837,
lon: 24.88578
},
{
id: "U3RvcDpIU0w6MTI5MTEyNg==",
lat: 60.2087,
lon: 24.88968
},
{
id: "U3RvcDpIU0w6MTE2MDExOA==",
lat: 60.207853,
lon: 24.900612
},
{
id: "U3RvcDpIU0w6MTI5MjEyMw==",
lat: 60.208,
lon: 24.90581
},
{
id: "U3RvcDpIU0w6MTE3MTE1MQ==",
lat: 60.207833,
lon: 24.920638
},
{
id: "U3RvcDpIU0w6MTE3NDExMg==",
lat: 60.20661,
lon: 24.92968
},
{
id: "U3RvcDpIU0w6MTE3MzEzMg==",
lat: 60.20781,
lon: 24.9413
},
{
id: "U3RvcDpIU0w6MTI1MDExMQ==",
lat: 60.20885,
lon: 24.94716
},
{
id: "U3RvcDpIU0w6MTI1MDExMw==",
lat: 60.21096,
lon: 24.95256
},
{
id: "U3RvcDpIU0w6MTI1MDExNQ==",
lat: 60.21249,
lon: 24.95648
},
{
id: "U3RvcDpIU0w6MTI0MDEwMQ==",
lat: 60.2149,
lon: 24.96463
},
{
id: "U3RvcDpIU0w6MTI3MDEwNA==",
lat: 60.217158,
lon: 24.981087
},
{
id: "U3RvcDpIU0w6MTM2MTEwMw==",
lat: 60.21896,
lon: 24.98699
},
{
id: "U3RvcDpIU0w6MTM2MTEwNQ==",
lat: 60.22475,
lon: 24.99648
},
{
id: "U3RvcDpIU0w6MTM2MTEwNw==",
lat: 60.22709,
lon: 25.00447
},
{
id: "U3RvcDpIU0w6MTM2MjEzOQ==",
lat: 60.22709,
lon: 25.01242
},
{
id: "U3RvcDpIU0w6MTM2MjEzNw==",
lat: 60.22536,
lon: 25.01653
},
{
id: "U3RvcDpIU0w6MTM2MjExOA==",
lat: 60.22445,
lon: 25.02165
},
{
id: "U3RvcDpIU0w6MTM2MjExNQ==",
lat: 60.22567,
lon: 25.02402
},
{
id: "U3RvcDpIU0w6MTM2MjEyNw==",
lat: 60.22806,
lon: 25.02792
},
{
id: "U3RvcDpIU0w6MTM2MjEyOQ==",
lat: 60.23112,
lon: 25.03053
},
{
id: "U3RvcDpIU0w6MTM2MjEzMw==",
lat: 60.23366,
lon: 25.0309
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mw==",
lat: 60.23446,
lon: 25.03309
},
{
id: "U3RvcDpIU0w6MTM2MjE0NQ==",
lat: 60.23508,
lon: 25.04165
},
{
id: "U3RvcDpIU0w6MTM2MjE0Nw==",
lat: 60.234,
lon: 25.04546
},
{
id: "U3RvcDpIU0w6MTM2MjEwMw==",
lat: 60.232415,
lon: 25.048574
},
{
id: "U3RvcDpIU0w6MTQ1NDEzMw==",
lat: 60.229547,
lon: 25.053197
},
{
id: "U3RvcDpIU0w6MTQ3NDEyOA==",
lat: 60.230858,
lon: 25.055657
},
{
id: "U3RvcDpIU0w6MTQ3NDExNA==",
lat: 60.23164,
lon: 25.05878
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMQ==",
lat: 60.23361,
lon: 25.0628
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMw==",
lat: 60.23707,
lon: 25.06766
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNQ==",
lat: 60.23879,
lon: 25.06735
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNw==",
lat: 60.24025,
lon: 25.07194
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mg==",
lat: 60.23916,
lon: 25.07499
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MA==",
lat: 60.23795,
lon: 25.07819
},
{
id: "U3RvcDpIU0w6MTQ3MTE4OQ==",
lat: 60.236731,
lon: 25.081263
}
]
},
{
gtfsId: "HSL:1056",
shortName: "56",
longName: "Kalasatama(M)-Käpylä-Kannelmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMzMTE1Ng==",
lat: 60.2408,
lon: 24.87316
},
{
id: "U3RvcDpIU0w6MTMzMTE2NA==",
lat: 60.24005,
lon: 24.87327
},
{
id: "U3RvcDpIU0w6MTMzMTE0MA==",
lat: 60.23876,
lon: 24.87507
},
{
id: "U3RvcDpIU0w6MTMzMTE2Nw==",
lat: 60.23711,
lon: 24.87955
},
{
id: "U3RvcDpIU0w6MTMzMTEwNQ==",
lat: 60.23819,
lon: 24.8833
},
{
id: "U3RvcDpIU0w6MTMzMTEwMw==",
lat: 60.23768,
lon: 24.88785
},
{
id: "U3RvcDpIU0w6MTI5MzEzNg==",
lat: 60.232533,
lon: 24.889442
},
{
id: "U3RvcDpIU0w6MTI5MzEzNQ==",
lat: 60.23103,
lon: 24.89271
},
{
id: "U3RvcDpIU0w6MTI5MzEzMw==",
lat: 60.228672,
lon: 24.894933
},
{
id: "U3RvcDpIU0w6MTI5MzEzMQ==",
lat: 60.22554,
lon: 24.89532
},
{
id: "U3RvcDpIU0w6MTI5MzEyNA==",
lat: 60.22408,
lon: 24.89863
},
{
id: "U3RvcDpIU0w6MTI5MzEyNw==",
lat: 60.22122,
lon: 24.90266
},
{
id: "U3RvcDpIU0w6MTI5MTE3Ng==",
lat: 60.22041,
lon: 24.90473
},
{
id: "U3RvcDpIU0w6MTI4NjE3OQ==",
lat: 60.2208,
lon: 24.92997
},
{
id: "U3RvcDpIU0w6MTI4MzEzMw==",
lat: 60.22099,
lon: 24.93806
},
{
id: "U3RvcDpIU0w6MTI4NDE1MA==",
lat: 60.22104,
lon: 24.9476
},
{
id: "U3RvcDpIU0w6MTI1MDEyMA==",
lat: 60.21883,
lon: 24.94982
},
{
id: "U3RvcDpIU0w6MTI1MDExOA==",
lat: 60.21619,
lon: 24.95642
},
{
id: "U3RvcDpIU0w6MTI1MDEwOA==",
lat: 60.21436,
lon: 24.95852
},
{
id: "U3RvcDpIU0w6MTI1MDEwNg==",
lat: 60.21303,
lon: 24.95897
},
{
id: "U3RvcDpIU0w6MTI0MDEwOA==",
lat: 60.2097,
lon: 24.96382
},
{
id: "U3RvcDpIU0w6MTI0MDEzMQ==",
lat: 60.20816,
lon: 24.96606
},
{
id: "U3RvcDpIU0w6MTI0MDEzMw==",
lat: 60.20488,
lon: 24.96385
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIxMDE2Mw==",
lat: 60.19824,
lon: 24.96938
},
{
id: "U3RvcDpIU0w6MTIxMDExMA==",
lat: 60.19523,
lon: 24.97448
},
{
id: "U3RvcDpIU0w6MTEwMDE2Nw==",
lat: 60.19191,
lon: 24.978519
},
{
id: "U3RvcDpIU0w6MTEwMDEzNA==",
lat: 60.18831,
lon: 24.97661
},
{
id: "U3RvcDpIU0w6MTEwMDEwNg==",
lat: 60.188557,
lon: 24.9729
},
{
id: "U3RvcDpIU0w6MTEwMDEyMA==",
lat: 60.18906,
lon: 24.97123
},
{
id: "U3RvcDpIU0w6MTEwMDEzMw==",
lat: 60.18831,
lon: 24.97647
},
{
id: "U3RvcDpIU0w6MTEwMDE2OA==",
lat: 60.19358,
lon: 24.97782
},
{
id: "U3RvcDpIU0w6MTIxMDExMQ==",
lat: 60.19603,
lon: 24.97368
},
{
id: "U3RvcDpIU0w6MTIxMDE2NA==",
lat: 60.19909,
lon: 24.96847
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEzNA==",
lat: 60.20583,
lon: 24.96293
},
{
id: "U3RvcDpIU0w6MTI0MDEzMg==",
lat: 60.20808,
lon: 24.96621
},
{
id: "U3RvcDpIU0w6MTI0MDEwNw==",
lat: 60.20952,
lon: 24.96435
},
{
id: "U3RvcDpIU0w6MTI1MDEwNQ==",
lat: 60.2129,
lon: 24.95926
},
{
id: "U3RvcDpIU0w6MTI1MDEwNw==",
lat: 60.21474,
lon: 24.95885
},
{
id: "U3RvcDpIU0w6MTI1MDExNw==",
lat: 60.21644,
lon: 24.95597
},
{
id: "U3RvcDpIU0w6MTI1MDExOQ==",
lat: 60.21922,
lon: 24.94948
},
{
id: "U3RvcDpIU0w6MTI4NDE0OQ==",
lat: 60.2207,
lon: 24.94837
},
{
id: "U3RvcDpIU0w6MTI4MzEzMA==",
lat: 60.22153,
lon: 24.94149
},
{
id: "U3RvcDpIU0w6MTI4MzEzMg==",
lat: 60.22103,
lon: 24.93707
},
{
id: "U3RvcDpIU0w6MTI4NjE4MA==",
lat: 60.22089,
lon: 24.92812
},
{
id: "U3RvcDpIU0w6MTI5MzE2OA==",
lat: 60.22044,
lon: 24.90502
},
{
id: "U3RvcDpIU0w6MTI5MzEyNg==",
lat: 60.221528,
lon: 24.902893
},
{
id: "U3RvcDpIU0w6MTI5MzEyMw==",
lat: 60.22424,
lon: 24.89852
},
{
id: "U3RvcDpIU0w6MTI5MzEzMA==",
lat: 60.22566,
lon: 24.89553
},
{
id: "U3RvcDpIU0w6MTI5MzEzMg==",
lat: 60.22999,
lon: 24.895167
},
{
id: "U3RvcDpIU0w6MTI5MzEzNA==",
lat: 60.23137,
lon: 24.89199
},
{
id: "U3RvcDpIU0w6MTI5MzE3Mw==",
lat: 60.232603,
lon: 24.889643
},
{
id: "U3RvcDpIU0w6MTMzMTEwMg==",
lat: 60.23774,
lon: 24.8882
},
{
id: "U3RvcDpIU0w6MTMzMTEwNA==",
lat: 60.23819,
lon: 24.88278
},
{
id: "U3RvcDpIU0w6MTMzMTE2Ng==",
lat: 60.23698,
lon: 24.87849
},
{
id: "U3RvcDpIU0w6MTMzMTE0MQ==",
lat: 60.23908,
lon: 24.87474
},
{
id: "U3RvcDpIU0w6MTMzMTE2NQ==",
lat: 60.24008,
lon: 24.8736
}
]
},
{
gtfsId: "HSL:2145",
shortName: "145",
longName: "Matinkylä (M)-Soukka-Suvisaaristo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxMw==",
lat: 60.160241,
lon: 24.738861
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIyNA==",
lat: 60.15183,
lon: 24.66506
},
{
id: "U3RvcDpIU0w6MjQxMTIyMw==",
lat: 60.14627,
lon: 24.67182
},
{
id: "U3RvcDpIU0w6MjQxMjIyOA==",
lat: 60.143279,
lon: 24.672656
},
{
id: "U3RvcDpIU0w6MjQxMjIyOQ==",
lat: 60.141393,
lon: 24.67125
},
{
id: "U3RvcDpIU0w6MjQxMjIzMQ==",
lat: 60.13993,
lon: 24.67253
},
{
id: "U3RvcDpIU0w6MjQxMjIzMw==",
lat: 60.13789,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjQxMjI4MQ==",
lat: 60.136098,
lon: 24.679014
},
{
id: "U3RvcDpIU0w6MjQxNTI0MQ==",
lat: 60.13248,
lon: 24.68105
},
{
id: "U3RvcDpIU0w6MjQxNTI0Mw==",
lat: 60.13011,
lon: 24.68134
},
{
id: "U3RvcDpIU0w6MjQxNTIwMQ==",
lat: 60.12835,
lon: 24.69503
},
{
id: "U3RvcDpIU0w6MjQ1MTIwMw==",
lat: 60.12718,
lon: 24.69826
},
{
id: "U3RvcDpIU0w6MjQ1MTIwNQ==",
lat: 60.127873,
lon: 24.70312
},
{
id: "U3RvcDpIU0w6MjQ1MTIwNw==",
lat: 60.12737,
lon: 24.70882
},
{
id: "U3RvcDpIU0w6MjQ1MTIwOQ==",
lat: 60.12466,
lon: 24.71353
},
{
id: "U3RvcDpIU0w6MjQ1MTIxMQ==",
lat: 60.12112,
lon: 24.71671
},
{
id: "U3RvcDpIU0w6MjQ1MTIxMw==",
lat: 60.11713,
lon: 24.71655
},
{
id: "U3RvcDpIU0w6MjQ1MTIxNQ==",
lat: 60.11427,
lon: 24.71102
},
{
id: "U3RvcDpIU0w6MjQ1MTIxNw==",
lat: 60.11328,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQ1MTIyMg==",
lat: 60.11452,
lon: 24.70043
},
{
id: "U3RvcDpIU0w6MjQ1MTIyMA==",
lat: 60.11372,
lon: 24.69712
},
{
id: "U3RvcDpIU0w6MjQ1MTIxOQ==",
lat: 60.11452,
lon: 24.70018
},
{
id: "U3RvcDpIU0w6MjQ1MTIxOA==",
lat: 60.11322,
lon: 24.70343
},
{
id: "U3RvcDpIU0w6MjQ1MTIxNg==",
lat: 60.11435,
lon: 24.71184
},
{
id: "U3RvcDpIU0w6MjQ1MTIxNA==",
lat: 60.11735,
lon: 24.71709
},
{
id: "U3RvcDpIU0w6MjQ1MTIxMg==",
lat: 60.12108,
lon: 24.71695
},
{
id: "U3RvcDpIU0w6MjQ1MTIxMA==",
lat: 60.12488,
lon: 24.71342
},
{
id: "U3RvcDpIU0w6MjQ1MTIwOA==",
lat: 60.12776,
lon: 24.70841
},
{
id: "U3RvcDpIU0w6MjQ1MTIwNg==",
lat: 60.1282,
lon: 24.70521
},
{
id: "U3RvcDpIU0w6MjQ1MTIwNA==",
lat: 60.12721,
lon: 24.69832
},
{
id: "U3RvcDpIU0w6MjQxNTIwMg==",
lat: 60.12894,
lon: 24.69474
},
{
id: "U3RvcDpIU0w6MjQxNTI0NA==",
lat: 60.1302,
lon: 24.68148
},
{
id: "U3RvcDpIU0w6MjQxNTI0Mg==",
lat: 60.13338,
lon: 24.68143
},
{
id: "U3RvcDpIU0w6MjQ0MzI4Mg==",
lat: 60.136453,
lon: 24.678871
},
{
id: "U3RvcDpIU0w6MjQxMjIzNA==",
lat: 60.13805,
lon: 24.67337
},
{
id: "U3RvcDpIU0w6MjQxMjIzMg==",
lat: 60.14018,
lon: 24.6725
},
{
id: "U3RvcDpIU0w6MjQxMjIzMA==",
lat: 60.141527,
lon: 24.671379
},
{
id: "U3RvcDpIU0w6MjQxMjIyNw==",
lat: 60.143373,
lon: 24.673594
},
{
id: "U3RvcDpIU0w6MjQxMTIyMg==",
lat: 60.14697,
lon: 24.67084
},
{
id: "U3RvcDpIU0w6MjQxMTIyNQ==",
lat: 60.15011,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNg==",
lat: 60.15236,
lon: 24.66626
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:4444",
shortName: "444",
longName: "Kivistö-Katriinan sairaala-Tapola-Riipilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDMyMDIxNQ==",
lat: 60.3687,
lon: 24.85191
},
{
id: "U3RvcDpIU0w6NDMyMDIwNg==",
lat: 60.36546,
lon: 24.84818
},
{
id: "U3RvcDpIU0w6NDMyMDIwNA==",
lat: 60.36372,
lon: 24.85136
},
{
id: "U3RvcDpIU0w6NDMyMDIwMg==",
lat: 60.36268,
lon: 24.85646
},
{
id: "U3RvcDpIU0w6NDMzMDIyOA==",
lat: 60.3539,
lon: 24.854886
},
{
id: "U3RvcDpIU0w6NDMzMDI5Ng==",
lat: 60.34762,
lon: 24.85347
},
{
id: "U3RvcDpIU0w6NDMzMDIxMA==",
lat: 60.34686,
lon: 24.84891
},
{
id: "U3RvcDpIU0w6NDMzMDIwOQ==",
lat: 60.348902,
lon: 24.846898
},
{
id: "U3RvcDpIU0w6NDMzMDIyMg==",
lat: 60.34392,
lon: 24.83582
},
{
id: "U3RvcDpIU0w6NDMzMDIyMw==",
lat: 60.34246,
lon: 24.83135
},
{
id: "U3RvcDpIU0w6NDMzMDIyMQ==",
lat: 60.3441,
lon: 24.83743
},
{
id: "U3RvcDpIU0w6NDMzMDIyNQ==",
lat: 60.34566,
lon: 24.83892
},
{
id: "U3RvcDpIU0w6NDMzMDIxMQ==",
lat: 60.34946,
lon: 24.84485
},
{
id: "U3RvcDpIU0w6NDMzMDI5Nw==",
lat: 60.34658,
lon: 24.85121
},
{
id: "U3RvcDpIU0w6NDMzMDI5NA==",
lat: 60.34842,
lon: 24.8547
},
{
id: "U3RvcDpIU0w6NDMzMDI5OA==",
lat: 60.34859,
lon: 24.8611
},
{
id: "U3RvcDpIU0w6NDMzMDIwMw==",
lat: 60.34775,
lon: 24.86668
},
{
id: "U3RvcDpIU0w6NDMzMDIxNg==",
lat: 60.34705,
lon: 24.87288
},
{
id: "U3RvcDpIU0w6NDMzMDIxMw==",
lat: 60.34795,
lon: 24.87113
},
{
id: "U3RvcDpIU0w6NDMzMDIwMg==",
lat: 60.34726,
lon: 24.86524
},
{
id: "U3RvcDpIU0w6NDI0MDIxMg==",
lat: 60.34255,
lon: 24.8648
},
{
id: "U3RvcDpIU0w6NDI0MDIwMg==",
lat: 60.33933,
lon: 24.86453
},
{
id: "U3RvcDpIU0w6NDI0MDIxMA==",
lat: 60.33669,
lon: 24.86352
},
{
id: "U3RvcDpIU0w6NDI0MDIxOA==",
lat: 60.33296,
lon: 24.86257
},
{
id: "U3RvcDpIU0w6NDI0MDIwOA==",
lat: 60.33036,
lon: 24.86273
},
{
id: "U3RvcDpIU0w6NDIzMDIzMg==",
lat: 60.32947,
lon: 24.8619
},
{
id: "U3RvcDpIU0w6NDIzMDIzMA==",
lat: 60.32875,
lon: 24.85569
},
{
id: "U3RvcDpIU0w6NDIzMDIyNg==",
lat: 60.32921,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDIzMDIyNA==",
lat: 60.32753,
lon: 24.85013
},
{
id: "U3RvcDpIU0w6NDIzMDIyMg==",
lat: 60.32522,
lon: 24.84962
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mg==",
lat: 60.323571,
lon: 24.851449
},
{
id: "U3RvcDpIU0w6NDIzMDI0MA==",
lat: 60.321997,
lon: 24.85308
},
{
id: "U3RvcDpIU0w6NDIzMDIzNg==",
lat: 60.320142,
lon: 24.855659
},
{
id: "U3RvcDpIU0w6NDIzMDIzNA==",
lat: 60.317929,
lon: 24.850801
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
},
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIzMDIzMw==",
lat: 60.318549,
lon: 24.85235
},
{
id: "U3RvcDpIU0w6NDIzMDIzNw==",
lat: 60.320869,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDIzMDI0MQ==",
lat: 60.322051,
lon: 24.853239
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mw==",
lat: 60.323765,
lon: 24.850455
},
{
id: "U3RvcDpIU0w6NDIzMDIyMQ==",
lat: 60.32615,
lon: 24.8498
},
{
id: "U3RvcDpIU0w6NDIzMDIyMw==",
lat: 60.32798,
lon: 24.85087
},
{
id: "U3RvcDpIU0w6NDIzMDIyOQ==",
lat: 60.32945,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDIzMDIzMQ==",
lat: 60.3282,
lon: 24.85841
},
{
id: "U3RvcDpIU0w6NDI0MDIwNw==",
lat: 60.331,
lon: 24.86291
},
{
id: "U3RvcDpIU0w6NDI0MDIxNw==",
lat: 60.33357,
lon: 24.86305
},
{
id: "U3RvcDpIU0w6NDI0MDIwOQ==",
lat: 60.3372,
lon: 24.86399
},
{
id: "U3RvcDpIU0w6NDI0MDIxOQ==",
lat: 60.34067,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6NDI0MDIxMQ==",
lat: 60.34244,
lon: 24.86512
},
{
id: "U3RvcDpIU0w6NDMzMDIxNA==",
lat: 60.34691,
lon: 24.87292
},
{
id: "U3RvcDpIU0w6NDMzMDIxNQ==",
lat: 60.34813,
lon: 24.86503
},
{
id: "U3RvcDpIU0w6NDMzMDI5OQ==",
lat: 60.34883,
lon: 24.86176
},
{
id: "U3RvcDpIU0w6NDMzMDIyNw==",
lat: 60.353985,
lon: 24.854893
},
{
id: "U3RvcDpIU0w6NDMzMDIxOQ==",
lat: 60.35829,
lon: 24.85868
},
{
id: "U3RvcDpIU0w6NDMyMDIwMQ==",
lat: 60.36364,
lon: 24.85535
},
{
id: "U3RvcDpIU0w6NDMyMDIwMw==",
lat: 60.36424,
lon: 24.85039
}
]
},
{
gtfsId: "HSL:4445",
shortName: "445",
longName: "Kivistö-Katriinan sairaala-Reuna",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIzMDIzMw==",
lat: 60.318549,
lon: 24.85235
},
{
id: "U3RvcDpIU0w6NDIzMDIzNw==",
lat: 60.320869,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDIzMDI0MQ==",
lat: 60.322051,
lon: 24.853239
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mw==",
lat: 60.323765,
lon: 24.850455
},
{
id: "U3RvcDpIU0w6NDIzMDIyMQ==",
lat: 60.32615,
lon: 24.8498
},
{
id: "U3RvcDpIU0w6NDIzMDIyMw==",
lat: 60.32798,
lon: 24.85087
},
{
id: "U3RvcDpIU0w6NDIzMDIyOQ==",
lat: 60.32945,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDIzMDIzMQ==",
lat: 60.3282,
lon: 24.85841
},
{
id: "U3RvcDpIU0w6NDI0MDIwNw==",
lat: 60.331,
lon: 24.86291
},
{
id: "U3RvcDpIU0w6NDI0MDIxNw==",
lat: 60.33357,
lon: 24.86305
},
{
id: "U3RvcDpIU0w6NDI0MDIwOQ==",
lat: 60.3372,
lon: 24.86399
},
{
id: "U3RvcDpIU0w6NDI0MDIxOQ==",
lat: 60.34067,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6NDI0MDIxMQ==",
lat: 60.34244,
lon: 24.86512
},
{
id: "U3RvcDpIU0w6NDMzMDIwMw==",
lat: 60.34775,
lon: 24.86668
},
{
id: "U3RvcDpIU0w6NDMzMDIxNA==",
lat: 60.34691,
lon: 24.87292
},
{
id: "U3RvcDpIU0w6NDMzMDIxMw==",
lat: 60.34795,
lon: 24.87113
},
{
id: "U3RvcDpIU0w6NDMzMDIxNQ==",
lat: 60.34813,
lon: 24.86503
},
{
id: "U3RvcDpIU0w6NDMzMDIxNw==",
lat: 60.35209,
lon: 24.86243
},
{
id: "U3RvcDpIU0w6NDMzMDIxOQ==",
lat: 60.35829,
lon: 24.85868
},
{
id: "U3RvcDpIU0w6NDMyMDIwMQ==",
lat: 60.36364,
lon: 24.85535
},
{
id: "U3RvcDpIU0w6NDMyMDIwMw==",
lat: 60.36424,
lon: 24.85039
},
{
id: "U3RvcDpIU0w6NDMyMDIwNQ==",
lat: 60.36631,
lon: 24.84726
},
{
id: "U3RvcDpIU0w6NDMyMDIwNw==",
lat: 60.36962,
lon: 24.83928
},
{
id: "U3RvcDpIU0w6NDMyMDIwOQ==",
lat: 60.37713,
lon: 24.8387
},
{
id: "U3RvcDpIU0w6NDMyMDIxMQ==",
lat: 60.3829,
lon: 24.83648
},
{
id: "U3RvcDpIU0w6NDMyMDIxMw==",
lat: 60.38571,
lon: 24.83733
},
{
id: "U3RvcDpIU0w6NDMyMDIxNw==",
lat: 60.39278,
lon: 24.83334
},
{
id: "U3RvcDpIU0w6NDMyMDIyMA==",
lat: 60.39321,
lon: 24.83318
},
{
id: "U3RvcDpIU0w6NDMyMDIxOA==",
lat: 60.39327,
lon: 24.83287
},
{
id: "U3RvcDpIU0w6NDMyMDIxNg==",
lat: 60.39227,
lon: 24.83382
},
{
id: "U3RvcDpIU0w6NDMyMDIxNA==",
lat: 60.38507,
lon: 24.8374
},
{
id: "U3RvcDpIU0w6NDMyMDIxMg==",
lat: 60.38217,
lon: 24.83595
},
{
id: "U3RvcDpIU0w6NDMyMDIxMA==",
lat: 60.3766,
lon: 24.83791
},
{
id: "U3RvcDpIU0w6NDMyMDIwOA==",
lat: 60.36877,
lon: 24.84042
},
{
id: "U3RvcDpIU0w6NDMyMDIwNg==",
lat: 60.36546,
lon: 24.84818
},
{
id: "U3RvcDpIU0w6NDMyMDIwNA==",
lat: 60.36372,
lon: 24.85136
},
{
id: "U3RvcDpIU0w6NDMyMDIwMg==",
lat: 60.36268,
lon: 24.85646
},
{
id: "U3RvcDpIU0w6NDMzMDIyMA==",
lat: 60.35754,
lon: 24.85893
},
{
id: "U3RvcDpIU0w6NDMzMDIxOA==",
lat: 60.35141,
lon: 24.8624
},
{
id: "U3RvcDpIU0w6NDMzMDIxNg==",
lat: 60.34705,
lon: 24.87288
},
{
id: "U3RvcDpIU0w6NDMzMDIwMg==",
lat: 60.34726,
lon: 24.86524
},
{
id: "U3RvcDpIU0w6NDI0MDIxMg==",
lat: 60.34255,
lon: 24.8648
},
{
id: "U3RvcDpIU0w6NDI0MDIwMg==",
lat: 60.33933,
lon: 24.86453
},
{
id: "U3RvcDpIU0w6NDI0MDIxMA==",
lat: 60.33669,
lon: 24.86352
},
{
id: "U3RvcDpIU0w6NDI0MDIxOA==",
lat: 60.33296,
lon: 24.86257
},
{
id: "U3RvcDpIU0w6NDI0MDIwOA==",
lat: 60.33036,
lon: 24.86273
},
{
id: "U3RvcDpIU0w6NDIzMDIzMg==",
lat: 60.32947,
lon: 24.8619
},
{
id: "U3RvcDpIU0w6NDIzMDIzMA==",
lat: 60.32875,
lon: 24.85569
},
{
id: "U3RvcDpIU0w6NDIzMDIyNg==",
lat: 60.32921,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDIzMDIyNA==",
lat: 60.32753,
lon: 24.85013
},
{
id: "U3RvcDpIU0w6NDIzMDIyMg==",
lat: 60.32522,
lon: 24.84962
},
{
id: "U3RvcDpIU0w6NDIzMDI0Mg==",
lat: 60.323571,
lon: 24.851449
},
{
id: "U3RvcDpIU0w6NDIzMDI0MA==",
lat: 60.321997,
lon: 24.85308
},
{
id: "U3RvcDpIU0w6NDIzMDIzNg==",
lat: 60.320142,
lon: 24.855659
},
{
id: "U3RvcDpIU0w6NDIzMDIzNA==",
lat: 60.317929,
lon: 24.850801
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
}
]
},
{
gtfsId: "HSL:9964B",
shortName: "964B",
longName: "Hyrylä-Paijala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDgwNA==",
lat: 60.416225,
lon: 25.005537
},
{
id: "U3RvcDpIU0w6OTY1MDgwNQ==",
lat: 60.416767,
lon: 25.018242
},
{
id: "U3RvcDpIU0w6OTY1MDkwNg==",
lat: 60.410065,
lon: 25.014522
},
{
id: "U3RvcDpIU0w6OTY1MDkwMg==",
lat: 60.405499,
lon: 25.012577
},
{
id: "U3RvcDpIU0w6OTY1MDMwMw==",
lat: 60.4033,
lon: 25.02419
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
},
{
id: "U3RvcDpIU0w6OTY1MDEyNA==",
lat: 60.40201,
lon: 25.028074
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MDkwNQ==",
lat: 60.410608,
lon: 25.014965
},
{
id: "U3RvcDpIU0w6OTY1MDgwNg==",
lat: 60.416299,
lon: 25.0182
},
{
id: "U3RvcDpIU0w6OTY1MDgwMw==",
lat: 60.415801,
lon: 25.004147
}
]
},
{
gtfsId: "HSL:7953",
shortName: "953",
longName: "Kivistön asema - Luhtaanmäki ( - Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIzMDI0NQ==",
lat: 60.314149,
lon: 24.844845
},
{
id: "U3RvcDpIU0w6NDIyMDIyMQ==",
lat: 60.31705,
lon: 24.83873
},
{
id: "U3RvcDpIU0w6NDIyMDIyMw==",
lat: 60.322198,
lon: 24.831557
},
{
id: "U3RvcDpIU0w6NDIyMDIyNQ==",
lat: 60.32778,
lon: 24.8256
},
{
id: "U3RvcDpIU0w6NDIyMDIyNw==",
lat: 60.333449,
lon: 24.81792
},
{
id: "U3RvcDpIU0w6NDIyMDIwNA==",
lat: 60.33848,
lon: 24.81626
},
{
id: "U3RvcDpIU0w6NDMxMDIwOA==",
lat: 60.34986,
lon: 24.80924
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
}
]
},
{
gtfsId: "HSL:4446",
shortName: "446",
longName: "Kivistö-Koivupää-Katriinan sairaala-Kesäkylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIzMDI0OA==",
lat: 60.315237,
lon: 24.849881
},
{
id: "U3RvcDpIU0w6NDIxMDIzMw==",
lat: 60.31361,
lon: 24.85587
},
{
id: "U3RvcDpIU0w6NDI0MDIwMQ==",
lat: 60.319222,
lon: 24.869969
},
{
id: "U3RvcDpIU0w6NDI0MDIyMw==",
lat: 60.32244,
lon: 24.86956
},
{
id: "U3RvcDpIU0w6NDI0MDIxMw==",
lat: 60.32171,
lon: 24.87494
},
{
id: "U3RvcDpIU0w6NDI0MDIxNQ==",
lat: 60.31954,
lon: 24.8813
},
{
id: "U3RvcDpIU0w6NDI0MDIyMQ==",
lat: 60.31839,
lon: 24.88736
},
{
id: "U3RvcDpIU0w6NDI0MDIxNg==",
lat: 60.31967,
lon: 24.88082
},
{
id: "U3RvcDpIU0w6NDI0MDIxNA==",
lat: 60.32185,
lon: 24.87485
},
{
id: "U3RvcDpIU0w6NDI0MDIwMw==",
lat: 60.32273,
lon: 24.86908
},
{
id: "U3RvcDpIU0w6NDI0MDIwNQ==",
lat: 60.32608,
lon: 24.86706
},
{
id: "U3RvcDpIU0w6NDI0MDIwNw==",
lat: 60.331,
lon: 24.86291
},
{
id: "U3RvcDpIU0w6NDI0MDIxNw==",
lat: 60.33357,
lon: 24.86305
},
{
id: "U3RvcDpIU0w6NDI0MDIwOQ==",
lat: 60.3372,
lon: 24.86399
},
{
id: "U3RvcDpIU0w6NDI0MDIxOQ==",
lat: 60.34067,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6NDI0MDIxMQ==",
lat: 60.34244,
lon: 24.86512
},
{
id: "U3RvcDpIU0w6NDMzMDIwMw==",
lat: 60.34775,
lon: 24.86668
},
{
id: "U3RvcDpIU0w6NDMzMDIwMQ==",
lat: 60.34675,
lon: 24.87285
},
{
id: "U3RvcDpIU0w6NDMzMDIxMg==",
lat: 60.34782,
lon: 24.87282
},
{
id: "U3RvcDpIU0w6NDMzMDIwNQ==",
lat: 60.34765,
lon: 24.87818
},
{
id: "U3RvcDpIU0w6NDMzMDIwNw==",
lat: 60.34752,
lon: 24.88455
},
{
id: "U3RvcDpIU0w6NDM0MDIwMQ==",
lat: 60.34889,
lon: 24.89936
},
{
id: "U3RvcDpIU0w6NDM0MDIxNA==",
lat: 60.3494,
lon: 24.90408
},
{
id: "U3RvcDpIU0w6NDM0MDIxNg==",
lat: 60.35707,
lon: 24.90705
},
{
id: "U3RvcDpIU0w6NDM0MDIxNw==",
lat: 60.35861,
lon: 24.91013
},
{
id: "U3RvcDpIU0w6NDM0MDIxNQ==",
lat: 60.35696,
lon: 24.90668
},
{
id: "U3RvcDpIU0w6NDM0MDIwNA==",
lat: 60.34916,
lon: 24.90328
},
{
id: "U3RvcDpIU0w6NDM0MDIwMg==",
lat: 60.34886,
lon: 24.89715
},
{
id: "U3RvcDpIU0w6NDMzMDIwOA==",
lat: 60.34761,
lon: 24.88353
},
{
id: "U3RvcDpIU0w6NDMzMDIwNg==",
lat: 60.34783,
lon: 24.87616
},
{
id: "U3RvcDpIU0w6NDMzMDIxNg==",
lat: 60.34705,
lon: 24.87288
},
{
id: "U3RvcDpIU0w6NDMzMDIxMw==",
lat: 60.34795,
lon: 24.87113
},
{
id: "U3RvcDpIU0w6NDMzMDIwMg==",
lat: 60.34726,
lon: 24.86524
},
{
id: "U3RvcDpIU0w6NDI0MDIxMg==",
lat: 60.34255,
lon: 24.8648
},
{
id: "U3RvcDpIU0w6NDI0MDIwMg==",
lat: 60.33933,
lon: 24.86453
},
{
id: "U3RvcDpIU0w6NDI0MDIxMA==",
lat: 60.33669,
lon: 24.86352
},
{
id: "U3RvcDpIU0w6NDI0MDIxOA==",
lat: 60.33296,
lon: 24.86257
},
{
id: "U3RvcDpIU0w6NDI0MDIwOA==",
lat: 60.33036,
lon: 24.86273
},
{
id: "U3RvcDpIU0w6NDI0MDIwNg==",
lat: 60.32723,
lon: 24.86575
},
{
id: "U3RvcDpIU0w6NDI0MDIyMA==",
lat: 60.32498,
lon: 24.86777
},
{
id: "U3RvcDpIU0w6NDI0MDIwNA==",
lat: 60.32204,
lon: 24.86887
},
{
id: "U3RvcDpIU0w6NDI0MDIyNw==",
lat: 60.31905,
lon: 24.8698
},
{
id: "U3RvcDpIU0w6NDIxMDI0NQ==",
lat: 60.316659,
lon: 24.867147
},
{
id: "U3RvcDpIU0w6NDIxMDIyMg==",
lat: 60.31329,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDIzMDI0OQ==",
lat: 60.316261,
lon: 24.848552
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
}
]
},
{
gtfsId: "HSL:2113N",
shortName: "113N",
longName: "Kamppi-Tapiola (M)-Laajalahti-Perkkaa-Leppävaara",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI3Ng==",
lat: 60.169,
lon: 24.93164
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTIzNw==",
lat: 60.17083,
lon: 24.81079
},
{
id: "U3RvcDpIU0w6MjIxMTIzNQ==",
lat: 60.17359,
lon: 24.81072
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMjIxNA==",
lat: 60.17615,
lon: 24.80035
},
{
id: "U3RvcDpIU0w6MjIxMjIxNg==",
lat: 60.17928,
lon: 24.79851
},
{
id: "U3RvcDpIU0w6MjIxMjIxOA==",
lat: 60.18134,
lon: 24.79634
},
{
id: "U3RvcDpIU0w6MjIxNTIyMA==",
lat: 60.1836,
lon: 24.79511
},
{
id: "U3RvcDpIU0w6MjIxNTIyMg==",
lat: 60.18663,
lon: 24.79671
},
{
id: "U3RvcDpIU0w6MjIxNTI4MA==",
lat: 60.18833,
lon: 24.79757
},
{
id: "U3RvcDpIU0w6MjIxNTIyNg==",
lat: 60.19079,
lon: 24.79705
},
{
id: "U3RvcDpIU0w6MjIxNTIyOA==",
lat: 60.19361,
lon: 24.79551
},
{
id: "U3RvcDpIU0w6MjIxNTIzMA==",
lat: 60.19613,
lon: 24.79514
},
{
id: "U3RvcDpIU0w6MjIxNTIyNA==",
lat: 60.19701,
lon: 24.80054
},
{
id: "U3RvcDpIU0w6MjEyMjIxNA==",
lat: 60.19969,
lon: 24.80349
},
{
id: "U3RvcDpIU0w6MjEyMjIxMw==",
lat: 60.20105,
lon: 24.80314
},
{
id: "U3RvcDpIU0w6MjEyMjIxMQ==",
lat: 60.20366,
lon: 24.79789
},
{
id: "U3RvcDpIU0w6MjEyMjIwOQ==",
lat: 60.20434,
lon: 24.79998
},
{
id: "U3RvcDpIU0w6MjEyMjIwNw==",
lat: 60.20435,
lon: 24.80615
},
{
id: "U3RvcDpIU0w6MjEyMjIwNA==",
lat: 60.2046,
lon: 24.81092
},
{
id: "U3RvcDpIU0w6MjEyMTIwMg==",
lat: 60.2053,
lon: 24.81595
},
{
id: "U3RvcDpIU0w6MjExODIyMQ==",
lat: 60.21253,
lon: 24.81925
},
{
id: "U3RvcDpIU0w6MjExODIwNA==",
lat: 60.21104,
lon: 24.82569
},
{
id: "U3RvcDpIU0w6MjExODIwMw==",
lat: 60.21222,
lon: 24.8263
},
{
id: "U3RvcDpIU0w6MjExODI3Nw==",
lat: 60.2147,
lon: 24.82653
},
{
id: "U3RvcDpIU0w6MjExODI4NA==",
lat: 60.21716,
lon: 24.825386
},
{
id: "U3RvcDpIU0w6MjExODI4Ng==",
lat: 60.2184,
lon: 24.81792
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIzNA==",
lat: 60.218887,
lon: 24.812701
},
{
id: "U3RvcDpIU0w6MjExODI4MA==",
lat: 60.2171,
lon: 24.820558
},
{
id: "U3RvcDpIU0w6MjExODI3OA==",
lat: 60.217,
lon: 24.82504
},
{
id: "U3RvcDpIU0w6MjExODI3Ng==",
lat: 60.21489,
lon: 24.82632
},
{
id: "U3RvcDpIU0w6MjExODIwMQ==",
lat: 60.21264,
lon: 24.82623
},
{
id: "U3RvcDpIU0w6MjExODIwNQ==",
lat: 60.21079,
lon: 24.82438
},
{
id: "U3RvcDpIU0w6MjExODIyNA==",
lat: 60.21268,
lon: 24.8189
},
{
id: "U3RvcDpIU0w6MjExMjI2Mw==",
lat: 60.21244,
lon: 24.81549
},
{
id: "U3RvcDpIU0w6MjEyMjIxOQ==",
lat: 60.2061,
lon: 24.81546
},
{
id: "U3RvcDpIU0w6MjEyMjIwNQ==",
lat: 60.20476,
lon: 24.80945
},
{
id: "U3RvcDpIU0w6MjEyMjIwNg==",
lat: 60.20431,
lon: 24.80464
},
{
id: "U3RvcDpIU0w6MjEyMjIwOA==",
lat: 60.20449,
lon: 24.80009
},
{
id: "U3RvcDpIU0w6MjEyMjIxMA==",
lat: 60.20349,
lon: 24.79771
},
{
id: "U3RvcDpIU0w6MjEyMjIxMg==",
lat: 60.20155,
lon: 24.79848
},
{
id: "U3RvcDpIU0w6MjEyMjIyNQ==",
lat: 60.201,
lon: 24.80299
},
{
id: "U3RvcDpIU0w6MjEyMjIxNQ==",
lat: 60.1992,
lon: 24.80309
},
{
id: "U3RvcDpIU0w6MjIxNTIzMw==",
lat: 60.19681,
lon: 24.79966
},
{
id: "U3RvcDpIU0w6MjIxNTIzMQ==",
lat: 60.19519,
lon: 24.79384
},
{
id: "U3RvcDpIU0w6MjIxNTIyOQ==",
lat: 60.19297,
lon: 24.79574
},
{
id: "U3RvcDpIU0w6MjIxNTIyNw==",
lat: 60.19071,
lon: 24.79691
},
{
id: "U3RvcDpIU0w6MjIxNTI4MQ==",
lat: 60.18749,
lon: 24.79715
},
{
id: "U3RvcDpIU0w6MjIxNTIyMQ==",
lat: 60.18401,
lon: 24.7952
},
{
id: "U3RvcDpIU0w6MjIxMjIxOQ==",
lat: 60.18154,
lon: 24.79584
},
{
id: "U3RvcDpIU0w6MjIxMjIxNw==",
lat: 60.17822,
lon: 24.79887
},
{
id: "U3RvcDpIU0w6MjIxMjIxNQ==",
lat: 60.1759,
lon: 24.80008
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMTIzNg==",
lat: 60.17364,
lon: 24.81027
},
{
id: "U3RvcDpIU0w6MjIxMTIzOA==",
lat: 60.17046,
lon: 24.81056
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:2125N",
shortName: "125N",
longName: "Kamppi-Tapiola (M)-Niittykumpu (M)-Olari- Latokaski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI3OA==",
lat: 60.16895,
lon: 24.93146
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTIzNw==",
lat: 60.17083,
lon: 24.81079
},
{
id: "U3RvcDpIU0w6MjIxMTIzNQ==",
lat: 60.17359,
lon: 24.81072
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mw==",
lat: 60.17122,
lon: 24.77009
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
},
{
id: "U3RvcDpIU0w6MjMyMjIwNA==",
lat: 60.16999,
lon: 24.75087
},
{
id: "U3RvcDpIU0w6MjMyMjIzMA==",
lat: 60.17259,
lon: 24.74576
},
{
id: "U3RvcDpIU0w6MjMyMjIzNA==",
lat: 60.17516,
lon: 24.7422
},
{
id: "U3RvcDpIU0w6MjMyMjIzNQ==",
lat: 60.17491,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjMyMjIzNw==",
lat: 60.17479,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjMyMzI0MA==",
lat: 60.17256,
lon: 24.72448
},
{
id: "U3RvcDpIU0w6MjMyMTIxNQ==",
lat: 60.17308,
lon: 24.72252
},
{
id: "U3RvcDpIU0w6MjMyMTIxNw==",
lat: 60.176736,
lon: 24.716377
},
{
id: "U3RvcDpIU0w6MjMyMTI2Mg==",
lat: 60.17488,
lon: 24.70841
},
{
id: "U3RvcDpIU0w6MjMyMTIyMA==",
lat: 60.17429,
lon: 24.70261
},
{
id: "U3RvcDpIU0w6MjQzMzIwNw==",
lat: 60.17298,
lon: 24.6873
},
{
id: "U3RvcDpIU0w6MjQzNDMwMQ==",
lat: 60.17155,
lon: 24.68053
},
{
id: "U3RvcDpIU0w6MjQzNDIzMw==",
lat: 60.17019,
lon: 24.6776
},
{
id: "U3RvcDpIU0w6MjQzMjIxNQ==",
lat: 60.16853,
lon: 24.67787
},
{
id: "U3RvcDpIU0w6MjQzMjIwOQ==",
lat: 60.16639,
lon: 24.67914
},
{
id: "U3RvcDpIU0w6MjQzNDI0NQ==",
lat: 60.1644,
lon: 24.68157
},
{
id: "U3RvcDpIU0w6MjQzNDI1MA==",
lat: 60.16296,
lon: 24.67642
},
{
id: "U3RvcDpIU0w6MjQzNDIwOA==",
lat: 60.16328,
lon: 24.67186
},
{
id: "U3RvcDpIU0w6MjQzNDIwNg==",
lat: 60.16285,
lon: 24.66447
},
{
id: "U3RvcDpIU0w6MjQzNDIwMQ==",
lat: 60.16333,
lon: 24.66029
},
{
id: "U3RvcDpIU0w6MjQzNDIzMQ==",
lat: 60.16823,
lon: 24.66082
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mw==",
lat: 60.17401,
lon: 24.65456
},
{
id: "U3RvcDpIU0w6MjQzMTI1MQ==",
lat: 60.17666,
lon: 24.65685
},
{
id: "U3RvcDpIU0w6MjQzMTIzNw==",
lat: 60.17798,
lon: 24.6593
},
{
id: "U3RvcDpIU0w6MjQzMTIzOQ==",
lat: 60.17929,
lon: 24.65678
},
{
id: "U3RvcDpIU0w6MjQzMTI0MA==",
lat: 60.17908,
lon: 24.65491
},
{
id: "U3RvcDpIU0w6MjQzMTIzOA==",
lat: 60.17817,
lon: 24.65898
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mg==",
lat: 60.17662,
lon: 24.6562
},
{
id: "U3RvcDpIU0w6MjQzMTI1NA==",
lat: 60.17315,
lon: 24.65509
},
{
id: "U3RvcDpIU0w6MjQzNDIwMg==",
lat: 60.16658,
lon: 24.66045
},
{
id: "U3RvcDpIU0w6MjQzNDIwNQ==",
lat: 60.162555,
lon: 24.661038
},
{
id: "U3RvcDpIU0w6MjQzNDIwNw==",
lat: 60.16286,
lon: 24.66467
},
{
id: "U3RvcDpIU0w6MjQzNDIwOQ==",
lat: 60.16319,
lon: 24.67184
},
{
id: "U3RvcDpIU0w6MjQzNDI0NA==",
lat: 60.16295,
lon: 24.67667
},
{
id: "U3RvcDpIU0w6MjQzNDI0Ng==",
lat: 60.16443,
lon: 24.68178
},
{
id: "U3RvcDpIU0w6MjQzMjIxMA==",
lat: 60.16594,
lon: 24.6803
},
{
id: "U3RvcDpIU0w6MjQzMjIyNw==",
lat: 60.16756,
lon: 24.67821
},
{
id: "U3RvcDpIU0w6MjQzMjIyOA==",
lat: 60.16934,
lon: 24.67792
},
{
id: "U3RvcDpIU0w6MjQzNDMwMg==",
lat: 60.17161,
lon: 24.68123
},
{
id: "U3RvcDpIU0w6MjQzMzI0Ng==",
lat: 60.17303,
lon: 24.68987
},
{
id: "U3RvcDpIU0w6MjMyMTIyMQ==",
lat: 60.17427,
lon: 24.70461
},
{
id: "U3RvcDpIU0w6MjMyMTI2MQ==",
lat: 60.17485,
lon: 24.70874
},
{
id: "U3RvcDpIU0w6MjMyMTIxOA==",
lat: 60.176604,
lon: 24.716805
},
{
id: "U3RvcDpIU0w6MjMyMTIxNg==",
lat: 60.1729,
lon: 24.72234
},
{
id: "U3RvcDpIU0w6MjMyMzI0Nw==",
lat: 60.17271,
lon: 24.72739
},
{
id: "U3RvcDpIU0w6MjMyMjIzOA==",
lat: 60.17468,
lon: 24.73368
},
{
id: "U3RvcDpIU0w6MjMyMjIzNg==",
lat: 60.17473,
lon: 24.7386
},
{
id: "U3RvcDpIU0w6MjMyMjIzMg==",
lat: 60.17495,
lon: 24.74337
},
{
id: "U3RvcDpIU0w6MjMyMjIzMQ==",
lat: 60.17256,
lon: 24.74548
},
{
id: "U3RvcDpIU0w6MjMyMjI0Nw==",
lat: 60.16966,
lon: 24.74919
},
{
id: "U3RvcDpIU0w6MjMyMjIyOQ==",
lat: 60.17043,
lon: 24.75535
},
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDI0NA==",
lat: 60.170943,
lon: 24.772035
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMTIzNg==",
lat: 60.17364,
lon: 24.81027
},
{
id: "U3RvcDpIU0w6MjIxMTIzOA==",
lat: 60.17046,
lon: 24.81056
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:7955",
shortName: "955",
longName: "Kivistön asema - Nurmijärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIzMDI0NQ==",
lat: 60.314149,
lon: 24.844845
},
{
id: "U3RvcDpIU0w6NDIyMDIyMQ==",
lat: 60.31705,
lon: 24.83873
},
{
id: "U3RvcDpIU0w6NDIyMDIyMw==",
lat: 60.322198,
lon: 24.831557
},
{
id: "U3RvcDpIU0w6NDIyMDIyNQ==",
lat: 60.32778,
lon: 24.8256
},
{
id: "U3RvcDpIU0w6NDIyMDIyNw==",
lat: 60.333449,
lon: 24.81792
},
{
id: "U3RvcDpIU0w6NDIyMDIwNA==",
lat: 60.33848,
lon: 24.81626
},
{
id: "U3RvcDpIU0w6NDMxMDIwOA==",
lat: 60.34986,
lon: 24.80924
},
{
id: "U3RvcDpIU0w6NDMxMDIxOA==",
lat: 60.356043,
lon: 24.807018
},
{
id: "U3RvcDpIU0w6NDMxMDIxMA==",
lat: 60.360961,
lon: 24.807177
},
{
id: "U3RvcDpIU0w6NDMxMDIxMg==",
lat: 60.374543,
lon: 24.805901
},
{
id: "U3RvcDpIU0w6NDMxMDIxMQ==",
lat: 60.373678,
lon: 24.80553
},
{
id: "U3RvcDpIU0w6NDMxMDIwOQ==",
lat: 60.360498,
lon: 24.807107
},
{
id: "U3RvcDpIU0w6NDMxMDIxNw==",
lat: 60.35337,
lon: 24.8067
},
{
id: "U3RvcDpIU0w6NDMxMDIwNw==",
lat: 60.34856,
lon: 24.80956
},
{
id: "U3RvcDpIU0w6NDIyMDIwNQ==",
lat: 60.33948,
lon: 24.81517
},
{
id: "U3RvcDpIU0w6NDIyMDIyNg==",
lat: 60.33248,
lon: 24.81876
},
{
id: "U3RvcDpIU0w6NDIyMDIyNA==",
lat: 60.326475,
lon: 24.825953
},
{
id: "U3RvcDpIU0w6NDIyMDIyMg==",
lat: 60.321574,
lon: 24.832355
},
{
id: "U3RvcDpIU0w6NDIyMDIyMA==",
lat: 60.316123,
lon: 24.841106
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
}
]
},
{
gtfsId: "HSL:4447",
shortName: "447",
longName: "Kivistö-Viinikanmetsä-Kesäkylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDIzMDI0Ng==",
lat: 60.314593,
lon: 24.845113
},
{
id: "U3RvcDpIU0w6NDIzMDI0OA==",
lat: 60.315237,
lon: 24.849881
},
{
id: "U3RvcDpIU0w6NDIxMDIzMw==",
lat: 60.31361,
lon: 24.85587
},
{
id: "U3RvcDpIU0w6NDIxMDI0Mg==",
lat: 60.31661,
lon: 24.87129
},
{
id: "U3RvcDpIU0w6NDQxMDI2Mw==",
lat: 60.308548,
lon: 24.889088
},
{
id: "U3RvcDpIU0w6NDUzMDI1NQ==",
lat: 60.31696,
lon: 24.90548
},
{
id: "U3RvcDpIU0w6NDUzMDI1Ng==",
lat: 60.31959,
lon: 24.91317
},
{
id: "U3RvcDpIU0w6NDQxMDIwNA==",
lat: 60.32243,
lon: 24.91681
},
{
id: "U3RvcDpIU0w6NDQxMDIwMg==",
lat: 60.32612,
lon: 24.91986
},
{
id: "U3RvcDpIU0w6NDM0MDIxMA==",
lat: 60.33663,
lon: 24.92258
},
{
id: "U3RvcDpIU0w6NDM0MDIwOA==",
lat: 60.3421,
lon: 24.92019
},
{
id: "U3RvcDpIU0w6NDM0MDIwNg==",
lat: 60.3442,
lon: 24.91788
},
{
id: "U3RvcDpIU0w6NDM0MDIyMA==",
lat: 60.34662,
lon: 24.91441
},
{
id: "U3RvcDpIU0w6NDM0MDIxNA==",
lat: 60.3494,
lon: 24.90408
},
{
id: "U3RvcDpIU0w6NDM0MDIxNg==",
lat: 60.35707,
lon: 24.90705
},
{
id: "U3RvcDpIU0w6NDM0MDIxNw==",
lat: 60.35861,
lon: 24.91013
},
{
id: "U3RvcDpIU0w6NDM0MDIxNQ==",
lat: 60.35696,
lon: 24.90668
},
{
id: "U3RvcDpIU0w6NDM0MDIwMw==",
lat: 60.34905,
lon: 24.90458
},
{
id: "U3RvcDpIU0w6NDM0MDIyMQ==",
lat: 60.34594,
lon: 24.91468
},
{
id: "U3RvcDpIU0w6NDM0MDIwNQ==",
lat: 60.34367,
lon: 24.91891
},
{
id: "U3RvcDpIU0w6NDM0MDIwNw==",
lat: 60.34124,
lon: 24.92037
},
{
id: "U3RvcDpIU0w6NDM0MDIwOQ==",
lat: 60.33572,
lon: 24.92308
},
{
id: "U3RvcDpIU0w6NDQxMDIwMQ==",
lat: 60.32492,
lon: 24.9186
},
{
id: "U3RvcDpIU0w6NDQxMDIwMw==",
lat: 60.32137,
lon: 24.91558
},
{
id: "U3RvcDpIU0w6NDQxMDIwNg==",
lat: 60.31869,
lon: 24.91055
},
{
id: "U3RvcDpIU0w6NDQxMDIwNQ==",
lat: 60.31651,
lon: 24.90261
},
{
id: "U3RvcDpIU0w6NDQxMDI2Mg==",
lat: 60.30795,
lon: 24.88963
},
{
id: "U3RvcDpIU0w6NDQxMDI2NA==",
lat: 60.309264,
lon: 24.891525
},
{
id: "U3RvcDpIU0w6NDIxMDI0NQ==",
lat: 60.316659,
lon: 24.867147
},
{
id: "U3RvcDpIU0w6NDIxMDIyMg==",
lat: 60.31329,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDIzMDI0OQ==",
lat: 60.316261,
lon: 24.848552
},
{
id: "U3RvcDpIU0w6NDIzMDI0NA==",
lat: 60.314273,
lon: 24.844619
}
]
},
{
gtfsId: "HSL:2125K",
shortName: "125K",
longName: "Tapiola (M)-Niittykumpu (M)-Olari-Latokaski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjQzMTI0MA==",
lat: 60.17908,
lon: 24.65491
},
{
id: "U3RvcDpIU0w6MjQzMTIzOA==",
lat: 60.17817,
lon: 24.65898
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mg==",
lat: 60.17662,
lon: 24.6562
},
{
id: "U3RvcDpIU0w6MjQzMTI1NA==",
lat: 60.17315,
lon: 24.65509
},
{
id: "U3RvcDpIU0w6MjQzMTIzMw==",
lat: 60.17191,
lon: 24.65856
},
{
id: "U3RvcDpIU0w6MjQzMTIzNQ==",
lat: 60.17382,
lon: 24.66296
},
{
id: "U3RvcDpIU0w6MjQzMzIxNA==",
lat: 60.17678,
lon: 24.67
},
{
id: "U3RvcDpIU0w6MjQzMzIxMg==",
lat: 60.17993,
lon: 24.67732
},
{
id: "U3RvcDpIU0w6MjQzMzIxMA==",
lat: 60.17515,
lon: 24.68784
},
{
id: "U3RvcDpIU0w6MjQzMzI0Ng==",
lat: 60.17303,
lon: 24.68987
},
{
id: "U3RvcDpIU0w6MjMyMTIyMQ==",
lat: 60.17427,
lon: 24.70461
},
{
id: "U3RvcDpIU0w6MjMyMTI2MQ==",
lat: 60.17485,
lon: 24.70874
},
{
id: "U3RvcDpIU0w6MjMyMTIxOA==",
lat: 60.176604,
lon: 24.716805
},
{
id: "U3RvcDpIU0w6MjMyMTIxNg==",
lat: 60.1729,
lon: 24.72234
},
{
id: "U3RvcDpIU0w6MjMyMzI0Nw==",
lat: 60.17271,
lon: 24.72739
},
{
id: "U3RvcDpIU0w6MjMyMjIzOA==",
lat: 60.17468,
lon: 24.73368
},
{
id: "U3RvcDpIU0w6MjMyMjIzNg==",
lat: 60.17473,
lon: 24.7386
},
{
id: "U3RvcDpIU0w6MjMyMjIzMg==",
lat: 60.17495,
lon: 24.74337
},
{
id: "U3RvcDpIU0w6MjMyMjIzMQ==",
lat: 60.17256,
lon: 24.74548
},
{
id: "U3RvcDpIU0w6MjMyMjI0Nw==",
lat: 60.16966,
lon: 24.74919
},
{
id: "U3RvcDpIU0w6MjMyMjIyOQ==",
lat: 60.17043,
lon: 24.75535
},
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDI0NA==",
lat: 60.170943,
lon: 24.772035
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
},
{
id: "U3RvcDpIU0w6MjIxMTIyNg==",
lat: 60.174956,
lon: 24.803668
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mw==",
lat: 60.17122,
lon: 24.77009
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
},
{
id: "U3RvcDpIU0w6MjMyMjIwNA==",
lat: 60.16999,
lon: 24.75087
},
{
id: "U3RvcDpIU0w6MjMyMjIzMA==",
lat: 60.17259,
lon: 24.74576
},
{
id: "U3RvcDpIU0w6MjMyMjIzNA==",
lat: 60.17516,
lon: 24.7422
},
{
id: "U3RvcDpIU0w6MjMyMjIzNQ==",
lat: 60.17491,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjMyMjIzNw==",
lat: 60.17479,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjMyMzI0MA==",
lat: 60.17256,
lon: 24.72448
},
{
id: "U3RvcDpIU0w6MjMyMTIxNQ==",
lat: 60.17308,
lon: 24.72252
},
{
id: "U3RvcDpIU0w6MjMyMTIxNw==",
lat: 60.176736,
lon: 24.716377
},
{
id: "U3RvcDpIU0w6MjMyMTI2Mg==",
lat: 60.17488,
lon: 24.70841
},
{
id: "U3RvcDpIU0w6MjMyMTIyMA==",
lat: 60.17429,
lon: 24.70261
},
{
id: "U3RvcDpIU0w6MjQzMjI2Mg==",
lat: 60.1735,
lon: 24.68914
},
{
id: "U3RvcDpIU0w6MjQzMzIwOQ==",
lat: 60.17571,
lon: 24.6874
},
{
id: "U3RvcDpIU0w6MjQzMTIwMw==",
lat: 60.17931,
lon: 24.67499
},
{
id: "U3RvcDpIU0w6MjQzMTIwMQ==",
lat: 60.17612,
lon: 24.66795
},
{
id: "U3RvcDpIU0w6MjQzMTIzNg==",
lat: 60.17335,
lon: 24.66156
},
{
id: "U3RvcDpIU0w6MjQzMTIzNA==",
lat: 60.17182,
lon: 24.65802
},
{
id: "U3RvcDpIU0w6MjQzMTI1Mw==",
lat: 60.17401,
lon: 24.65456
},
{
id: "U3RvcDpIU0w6MjQzMTI1MQ==",
lat: 60.17666,
lon: 24.65685
},
{
id: "U3RvcDpIU0w6MjQzMTIzNw==",
lat: 60.17798,
lon: 24.6593
},
{
id: "U3RvcDpIU0w6MjQzMTIzOQ==",
lat: 60.17929,
lon: 24.65678
}
]
},
{
gtfsId: "HSL:1091",
shortName: "91",
longName: "Rapuojantie-Östersundom-Puroniitty",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDkyMDIwNw==",
lat: 60.265003,
lon: 25.140218
},
{
id: "U3RvcDpIU0w6MTYwMjEyMg==",
lat: 60.255705,
lon: 25.154408
},
{
id: "U3RvcDpIU0w6MTYwMDIwOQ==",
lat: 60.251682,
lon: 25.176211
},
{
id: "U3RvcDpIU0w6MTYwMDIxMQ==",
lat: 60.253477,
lon: 25.185895
},
{
id: "U3RvcDpIU0w6MTYwMDIxMw==",
lat: 60.255158,
lon: 25.192102
},
{
id: "U3RvcDpIU0w6MTYwMDIxNQ==",
lat: 60.259785,
lon: 25.211032
},
{
id: "U3RvcDpIU0w6MTYwMDIzMQ==",
lat: 60.260022,
lon: 25.215462
},
{
id: "U3RvcDpIU0w6MTYwMDIxNw==",
lat: 60.260177,
lon: 25.219923
},
{
id: "U3RvcDpIU0w6MTYwMjEwMQ==",
lat: 60.29232,
lon: 25.240888
},
{
id: "U3RvcDpIU0w6MTYwMDIxOA==",
lat: 60.260228,
lon: 25.218075
},
{
id: "U3RvcDpIU0w6MTYwMDIxNg==",
lat: 60.25977,
lon: 25.208407
},
{
id: "U3RvcDpIU0w6MTYwMDIxNA==",
lat: 60.25475,
lon: 25.190433
},
{
id: "U3RvcDpIU0w6MTYwMDIxMg==",
lat: 60.253138,
lon: 25.183522
},
{
id: "U3RvcDpIU0w6MTYwMDIxMA==",
lat: 60.2514,
lon: 25.173983
},
{
id: "U3RvcDpIU0w6MTYwMjEyMQ==",
lat: 60.255762,
lon: 25.154099
},
{
id: "U3RvcDpIU0w6NDkwMDIwOA==",
lat: 60.25836,
lon: 25.14474
},
{
id: "U3RvcDpIU0w6NDkyMDIwOA==",
lat: 60.26487,
lon: 25.14023
}
]
},
{
gtfsId: "HSL:1090",
shortName: "90",
longName: "Vuosaari (M)-Aurinkolahti-Vuosaaren satama",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTU0ODEwNA==",
lat: 60.221504,
lon: 25.175434
},
{
id: "U3RvcDpIU0w6MTU0ODEwMQ==",
lat: 60.21917,
lon: 25.17245
},
{
id: "U3RvcDpIU0w6MTU0MjEzNw==",
lat: 60.2176,
lon: 25.1638
},
{
id: "U3RvcDpIU0w6MTU0MjEwNA==",
lat: 60.213157,
lon: 25.167747
},
{
id: "U3RvcDpIU0w6MTU0MjEwMg==",
lat: 60.210102,
lon: 25.162402
},
{
id: "U3RvcDpIU0w6MTU0MTE5MQ==",
lat: 60.20783,
lon: 25.15776
},
{
id: "U3RvcDpIU0w6MTUzMTE1MQ==",
lat: 60.20476,
lon: 25.15814
},
{
id: "U3RvcDpIU0w6MTUzMTE1Mw==",
lat: 60.20318,
lon: 25.15899
},
{
id: "U3RvcDpIU0w6MTUzMTE1NQ==",
lat: 60.20211,
lon: 25.15305
},
{
id: "U3RvcDpIU0w6MTUzMTE1Nw==",
lat: 60.20242,
lon: 25.14968
},
{
id: "U3RvcDpIU0w6MTUzMTE1OQ==",
lat: 60.204132,
lon: 25.147136
},
{
id: "U3RvcDpIU0w6MTU0MTE2MQ==",
lat: 60.20717,
lon: 25.14455
},
{
id: "U3RvcDpIU0w6MTUzMTExNg==",
lat: 60.20706,
lon: 25.14456
},
{
id: "U3RvcDpIU0w6MTUzMTE2MA==",
lat: 60.204049,
lon: 25.147076
},
{
id: "U3RvcDpIU0w6MTUzMTE1OA==",
lat: 60.20239,
lon: 25.14966
},
{
id: "U3RvcDpIU0w6MTUzMTE1Ng==",
lat: 60.20211,
lon: 25.15324
},
{
id: "U3RvcDpIU0w6MTUzMTE1NA==",
lat: 60.20314,
lon: 25.15917
},
{
id: "U3RvcDpIU0w6MTU0MTE4Mg==",
lat: 60.2056,
lon: 25.15792
},
{
id: "U3RvcDpIU0w6MTU0MTE3NA==",
lat: 60.20854,
lon: 25.15843
},
{
id: "U3RvcDpIU0w6MTU0MjEwMQ==",
lat: 60.21077,
lon: 25.163977
},
{
id: "U3RvcDpIU0w6MTU0MjEwMw==",
lat: 60.21407,
lon: 25.16823
},
{
id: "U3RvcDpIU0w6MTU0MjEzOA==",
lat: 60.21651,
lon: 25.16496
},
{
id: "U3RvcDpIU0w6MTU0ODEwMA==",
lat: 60.21917,
lon: 25.1732
},
{
id: "U3RvcDpIU0w6MTU0ODEwOQ==",
lat: 60.221504,
lon: 25.175434
}
]
},
{
gtfsId: "HSL:1023N",
shortName: "23N",
longName: "Länsiterminaali-Kamppi-Kallio-Pasila-Ilmala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTE3MTEwNA==",
lat: 60.20791,
lon: 24.91521
},
{
id: "U3RvcDpIU0w6MTE3MTEyMQ==",
lat: 60.205915,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE3MTEyNw==",
lat: 60.20309,
lon: 24.91942
},
{
id: "U3RvcDpIU0w6MTE3MTEyNQ==",
lat: 60.20226,
lon: 24.92151
},
{
id: "U3RvcDpIU0w6MTE3MTEzMQ==",
lat: 60.20267,
lon: 24.92511
},
{
id: "U3RvcDpIU0w6MTE3MTE1OA==",
lat: 60.20111,
lon: 24.92664
},
{
id: "U3RvcDpIU0w6MTE3MzE0OA==",
lat: 60.1977,
lon: 24.93506
},
{
id: "U3RvcDpIU0w6MTEyMjEyOA==",
lat: 60.19545,
lon: 24.93699
},
{
id: "U3RvcDpIU0w6MTEyMjEyNg==",
lat: 60.1942,
lon: 24.94076
},
{
id: "U3RvcDpIU0w6MTEyMjExMg==",
lat: 60.192558,
lon: 24.944612
},
{
id: "U3RvcDpIU0w6MTEyMjExMA==",
lat: 60.190835,
lon: 24.948841
},
{
id: "U3RvcDpIU0w6MTEyMTEwOA==",
lat: 60.1889,
lon: 24.95285
},
{
id: "U3RvcDpIU0w6MTExMzEyNg==",
lat: 60.18525,
lon: 24.953016
},
{
id: "U3RvcDpIU0w6MTExMzEyNA==",
lat: 60.18397,
lon: 24.95305
},
{
id: "U3RvcDpIU0w6MTExMjEyMg==",
lat: 60.181332,
lon: 24.950069
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDE3NQ==",
lat: 60.17113,
lon: 24.9448
},
{
id: "U3RvcDpIU0w6MTA0MDExNw==",
lat: 60.16875,
lon: 24.9353
},
{
id: "U3RvcDpIU0w6MTA0MDEyNw==",
lat: 60.1684,
lon: 24.93178
},
{
id: "U3RvcDpIU0w6MTA0MDEyNg==",
lat: 60.165618,
lon: 24.931375
},
{
id: "U3RvcDpIU0w6MTA0MDEyNA==",
lat: 60.163645,
lon: 24.934098
},
{
id: "U3RvcDpIU0w6MTA0MDE1Mw==",
lat: 60.16196,
lon: 24.92906
},
{
id: "U3RvcDpIU0w6MTA0MDE1NQ==",
lat: 60.16192,
lon: 24.92366
},
{
id: "U3RvcDpIU0w6MTIwMzEwNw==",
lat: 60.160225,
lon: 24.920807
},
{
id: "U3RvcDpIU0w6MTIwMzE5MQ==",
lat: 60.158836,
lon: 24.91513
},
{
id: "U3RvcDpIU0w6MTIwMTExNQ==",
lat: 60.157327,
lon: 24.911334
},
{
id: "U3RvcDpIU0w6MTIwMzEwOA==",
lat: 60.154609,
lon: 24.920494
},
{
id: "U3RvcDpIU0w6MTIwMzExMg==",
lat: 60.1599,
lon: 24.92135
},
{
id: "U3RvcDpIU0w6MTA0MDE1Nw==",
lat: 60.1611,
lon: 24.92455
},
{
id: "U3RvcDpIU0w6MTA1MDEzMg==",
lat: 60.162237,
lon: 24.931177
},
{
id: "U3RvcDpIU0w6MTA0MDEzNg==",
lat: 60.163603,
lon: 24.935071
},
{
id: "U3RvcDpIU0w6MTA0MDEyMw==",
lat: 60.16494,
lon: 24.93622
},
{
id: "U3RvcDpIU0w6MTA0MDEyNQ==",
lat: 60.167257,
lon: 24.933017
},
{
id: "U3RvcDpIU0w6MTA0MDE5Ng==",
lat: 60.168381,
lon: 24.93238
},
{
id: "U3RvcDpIU0w6MTA0MDExNg==",
lat: 60.168809,
lon: 24.935728
},
{
id: "U3RvcDpIU0w6MTAyMDE0MA==",
lat: 60.17022,
lon: 24.93943
},
{
id: "U3RvcDpIU0w6MTAyMDEwNA==",
lat: 60.17034,
lon: 24.94382
},
{
id: "U3RvcDpIU0w6MTAyMDE2OQ==",
lat: 60.173545,
lon: 24.94981
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTExMTEzMQ==",
lat: 60.180568,
lon: 24.9498
},
{
id: "U3RvcDpIU0w6MTExMzEyMw==",
lat: 60.1837,
lon: 24.95316
},
{
id: "U3RvcDpIU0w6MTExMzEyNQ==",
lat: 60.18528,
lon: 24.95308
},
{
id: "U3RvcDpIU0w6MTEyMTEwNQ==",
lat: 60.187467,
lon: 24.95313
},
{
id: "U3RvcDpIU0w6MTIyMDEwNw==",
lat: 60.18983,
lon: 24.9519
},
{
id: "U3RvcDpIU0w6MTIyMDEwOQ==",
lat: 60.191078,
lon: 24.948312
},
{
id: "U3RvcDpIU0w6MTIyMDEyNA==",
lat: 60.19351,
lon: 24.94278
},
{
id: "U3RvcDpIU0w6MTIyMDEyNQ==",
lat: 60.194439,
lon: 24.940817
},
{
id: "U3RvcDpIU0w6MTE3MzEyNw==",
lat: 60.19699,
lon: 24.93584
},
{
id: "U3RvcDpIU0w6MTE3MTE1NA==",
lat: 60.200915,
lon: 24.926832
},
{
id: "U3RvcDpIU0w6MTE3MTEzMA==",
lat: 60.20279,
lon: 24.92483
},
{
id: "U3RvcDpIU0w6MTE3MTEyNA==",
lat: 60.20241,
lon: 24.92193
},
{
id: "U3RvcDpIU0w6MTE3MTEyNg==",
lat: 60.203862,
lon: 24.918633
},
{
id: "U3RvcDpIU0w6MTE3MTE4MA==",
lat: 60.206258,
lon: 24.917854
},
{
id: "U3RvcDpIU0w6MTE3MTEwNQ==",
lat: 60.20793,
lon: 24.91536
}
]
},
{
gtfsId: "HSL:1098",
shortName: "98",
longName: "Itäkeskus(M)-Marjaniemi-Rastila(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzEyNg==",
lat: 60.20942,
lon: 25.07634
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMQ==",
lat: 60.2075,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6MTQ1NTE3MQ==",
lat: 60.20428,
lon: 25.07685
},
{
id: "U3RvcDpIU0w6MTQ1NTE2MA==",
lat: 60.20324,
lon: 25.08139
},
{
id: "U3RvcDpIU0w6MTQ1NTE2Mg==",
lat: 60.2043,
lon: 25.0858
},
{
id: "U3RvcDpIU0w6MTQ1NTE2NA==",
lat: 60.2056,
lon: 25.08853
},
{
id: "U3RvcDpIU0w6MTQ1NTE2Ng==",
lat: 60.206,
lon: 25.09324
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNA==",
lat: 60.208146,
lon: 25.09688
},
{
id: "U3RvcDpIU0w6MTQ1MjE2OQ==",
lat: 60.207813,
lon: 25.101287
},
{
id: "U3RvcDpIU0w6MTU0MTE5Mg==",
lat: 60.2058,
lon: 25.11971
},
{
id: "U3RvcDpIU0w6MTU0MTE5Ng==",
lat: 60.2054,
lon: 25.1199
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMQ==",
lat: 60.208349,
lon: 25.104742
},
{
id: "U3RvcDpIU0w6MTQ1MjE3MA==",
lat: 60.208067,
lon: 25.098807
},
{
id: "U3RvcDpIU0w6MTQ1MjE2OA==",
lat: 60.20809,
lon: 25.09569
},
{
id: "U3RvcDpIU0w6MTQ1NTE2Nw==",
lat: 60.20618,
lon: 25.09335
},
{
id: "U3RvcDpIU0w6MTQ1NTE2NQ==",
lat: 60.20593,
lon: 25.0889
},
{
id: "U3RvcDpIU0w6MTQ1NTE2Mw==",
lat: 60.20378,
lon: 25.08538
},
{
id: "U3RvcDpIU0w6MTQ1NTE2MQ==",
lat: 60.20354,
lon: 25.07957
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mw==",
lat: 60.20466,
lon: 25.07662
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMg==",
lat: 60.20757,
lon: 25.07562
},
{
id: "U3RvcDpIU0w6MTQ1MzExMg==",
lat: 60.210165,
lon: 25.077287
}
]
},
{
gtfsId: "HSL:1097",
shortName: "97",
longName: "Itäkeskus(M)-Vartioharju-Mellunmäki(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MjEwMg==",
lat: 60.23845,
lon: 25.10902
},
{
id: "U3RvcDpIU0w6MTQ3MzExMA==",
lat: 60.23737,
lon: 25.11256
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOA==",
lat: 60.23681,
lon: 25.11628
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNg==",
lat: 60.23692,
lon: 25.12131
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNA==",
lat: 60.23551,
lon: 25.12729
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMg==",
lat: 60.23253,
lon: 25.12857
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MQ==",
lat: 60.22017,
lon: 25.10757
},
{
id: "U3RvcDpIU0w6MTQ1MTExMw==",
lat: 60.21841,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6MTQ1MzExMQ==",
lat: 60.21633,
lon: 25.09587
},
{
id: "U3RvcDpIU0w6MTQ1MzEzOA==",
lat: 60.21533,
lon: 25.09017
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExMg==",
lat: 60.210165,
lon: 25.077287
},
{
id: "U3RvcDpIU0w6MTQ1MzEzMA==",
lat: 60.20975,
lon: 25.07745
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MzEwNw==",
lat: 60.21557,
lon: 25.09193
},
{
id: "U3RvcDpIU0w6MTQ1MjExMg==",
lat: 60.2166,
lon: 25.09736
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Nw==",
lat: 60.21833,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MA==",
lat: 60.22011,
lon: 25.10815
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMQ==",
lat: 60.23339,
lon: 25.12882
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMw==",
lat: 60.23597,
lon: 25.12657
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNQ==",
lat: 60.23705,
lon: 25.11995
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNw==",
lat: 60.23693,
lon: 25.11624
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
}
]
},
{
gtfsId: "HSL:1096",
shortName: "96",
longName: "Vuosaari(M)-Porslahdentie",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTU0MTEzNA==",
lat: 60.222018,
lon: 25.148524
},
{
id: "U3RvcDpIU0w6MTU0MTEzMg==",
lat: 60.21981,
lon: 25.14579
},
{
id: "U3RvcDpIU0w6MTU0MjEzMA==",
lat: 60.21815,
lon: 25.14657
},
{
id: "U3RvcDpIU0w6MTU0MTEyOA==",
lat: 60.21576,
lon: 25.1474
},
{
id: "U3RvcDpIU0w6MTU0MTEyNg==",
lat: 60.21359,
lon: 25.1474
},
{
id: "U3RvcDpIU0w6MTU0MTEyNA==",
lat: 60.21023,
lon: 25.14905
},
{
id: "U3RvcDpIU0w6MTU0MTE2NA==",
lat: 60.209178,
lon: 25.142691
},
{
id: "U3RvcDpIU0w6MTUzMTExNg==",
lat: 60.20706,
lon: 25.14456
},
{
id: "U3RvcDpIU0w6MTU0MTE2MQ==",
lat: 60.20717,
lon: 25.14455
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mw==",
lat: 60.2094,
lon: 25.14272
},
{
id: "U3RvcDpIU0w6MTU0MTEyMw==",
lat: 60.21104,
lon: 25.14971
},
{
id: "U3RvcDpIU0w6MTU0MjEyNQ==",
lat: 60.21342,
lon: 25.14796
},
{
id: "U3RvcDpIU0w6MTU0MTEyNw==",
lat: 60.21637,
lon: 25.14786
},
{
id: "U3RvcDpIU0w6MTU0MjEyOQ==",
lat: 60.21902,
lon: 25.14635
},
{
id: "U3RvcDpIU0w6MTU0MTEzMQ==",
lat: 60.22069,
lon: 25.14643
},
{
id: "U3RvcDpIU0w6MTU0MTE0Nw==",
lat: 60.22224,
lon: 25.14915
}
]
},
{
gtfsId: "HSL:9977V",
shortName: "977V",
longName: "Ylikerava-Keravan sema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA3MDIxOA==",
lat: 60.42273,
lon: 25.12829
},
{
id: "U3RvcDpIU0w6OTA3MDIyMA==",
lat: 60.42435,
lon: 25.12763
},
{
id: "U3RvcDpIU0w6OTA3MDIxNQ==",
lat: 60.42408,
lon: 25.12011
},
{
id: "U3RvcDpIU0w6OTA3MDIwOQ==",
lat: 60.41879,
lon: 25.11785
},
{
id: "U3RvcDpIU0w6OTA3MDIxMQ==",
lat: 60.41532,
lon: 25.11773
},
{
id: "U3RvcDpIU0w6OTA3MDIxMw==",
lat: 60.40933,
lon: 25.11725
},
{
id: "U3RvcDpIU0w6OTA0MDIxOA==",
lat: 60.40565,
lon: 25.115
},
{
id: "U3RvcDpIU0w6OTA0MDIxNQ==",
lat: 60.40475,
lon: 25.11062
},
{
id: "U3RvcDpIU0w6OTA0MDIwOQ==",
lat: 60.40329,
lon: 25.10603
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
},
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMA==",
lat: 60.40314,
lon: 25.10726
},
{
id: "U3RvcDpIU0w6OTA0MDIxNw==",
lat: 60.405,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6OTA0MDIxOQ==",
lat: 60.4059,
lon: 25.11659
},
{
id: "U3RvcDpIU0w6OTA3MDIxMg==",
lat: 60.41014,
lon: 25.11753
},
{
id: "U3RvcDpIU0w6OTA3MDIxMA==",
lat: 60.41611,
lon: 25.1177
},
{
id: "U3RvcDpIU0w6OTA3MDIwOA==",
lat: 60.41952,
lon: 25.11757
},
{
id: "U3RvcDpIU0w6OTA3MDIxNA==",
lat: 60.42406,
lon: 25.12042
},
{
id: "U3RvcDpIU0w6OTA3MDIxNg==",
lat: 60.423727,
lon: 25.128088
}
]
},
{
gtfsId: "HSL:1095",
shortName: "95",
longName: "Itäkeskus(M)-Mellunmäki(M)-Kontula(M)-Keinutie",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MTE1NQ==",
lat: 60.23607,
lon: 25.0716
},
{
id: "U3RvcDpIU0w6MTQ3MTEzMw==",
lat: 60.23795,
lon: 25.07195
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mg==",
lat: 60.23916,
lon: 25.07499
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MA==",
lat: 60.23795,
lon: 25.07819
},
{
id: "U3RvcDpIU0w6MTQ3MTE3OQ==",
lat: 60.23602,
lon: 25.0822
},
{
id: "U3RvcDpIU0w6MTQ3MTExOA==",
lat: 60.23638,
lon: 25.08713
},
{
id: "U3RvcDpIU0w6MTQ3MjE5NQ==",
lat: 60.23891,
lon: 25.09051
},
{
id: "U3RvcDpIU0w6MTQ3MjE5Nw==",
lat: 60.23892,
lon: 25.09608
},
{
id: "U3RvcDpIU0w6MTQ3MjE0OA==",
lat: 60.23944,
lon: 25.10283
},
{
id: "U3RvcDpIU0w6MTQ3MzExOA==",
lat: 60.23811,
lon: 25.10922
},
{
id: "U3RvcDpIU0w6MTQ3MjEzMw==",
lat: 60.23512,
lon: 25.1004
},
{
id: "U3RvcDpIU0w6MTQ3MjEzMg==",
lat: 60.23268,
lon: 25.0993
},
{
id: "U3RvcDpIU0w6MTQ3MTEzMA==",
lat: 60.22933,
lon: 25.0996
},
{
id: "U3RvcDpIU0w6MTQ1MTEwNA==",
lat: 60.22734,
lon: 25.10319
},
{
id: "U3RvcDpIU0w6MTQ1MTE4NA==",
lat: 60.22472,
lon: 25.10161
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Mg==",
lat: 60.22464,
lon: 25.09719
},
{
id: "U3RvcDpIU0w6MTQ1MTE4MA==",
lat: 60.22278,
lon: 25.09326
},
{
id: "U3RvcDpIU0w6MTQ1MTEyNg==",
lat: 60.22138,
lon: 25.09411
},
{
id: "U3RvcDpIU0w6MTQ1MTE3OA==",
lat: 60.21973,
lon: 25.10042
},
{
id: "U3RvcDpIU0w6MTQ1MTExMw==",
lat: 60.21841,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6MTQ1MzExMQ==",
lat: 60.21633,
lon: 25.09587
},
{
id: "U3RvcDpIU0w6MTQ1MzEzOA==",
lat: 60.21533,
lon: 25.09017
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
},
{
id: "U3RvcDpIU0w6MTQ1MzE4Mg==",
lat: 60.21003,
lon: 25.0768
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MzEwNw==",
lat: 60.21557,
lon: 25.09193
},
{
id: "U3RvcDpIU0w6MTQ1MjExMg==",
lat: 60.2166,
lon: 25.09736
},
{
id: "U3RvcDpIU0w6MTQ1MTE3NQ==",
lat: 60.219834,
lon: 25.100155
},
{
id: "U3RvcDpIU0w6MTQ1MTEyNQ==",
lat: 60.22132,
lon: 25.09444
},
{
id: "U3RvcDpIU0w6MTQ1MTE3OQ==",
lat: 60.22361,
lon: 25.09368
},
{
id: "U3RvcDpIU0w6MTQ1MTE4MQ==",
lat: 60.22455,
lon: 25.09775
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Mw==",
lat: 60.22473,
lon: 25.10201
},
{
id: "U3RvcDpIU0w6MTQ1MTEwMw==",
lat: 60.22724,
lon: 25.10316
},
{
id: "U3RvcDpIU0w6MTQ3MTEyOQ==",
lat: 60.22999,
lon: 25.09946
},
{
id: "U3RvcDpIU0w6MTQ3MjEzMQ==",
lat: 60.23329,
lon: 25.09953
},
{
id: "U3RvcDpIU0w6MTQ3MjEzNA==",
lat: 60.23521,
lon: 25.10082
},
{
id: "U3RvcDpIU0w6MTQ3MjExMg==",
lat: 60.23742,
lon: 25.1058
},
{
id: "U3RvcDpIU0w6MTQ3MjEwMQ==",
lat: 60.2383,
lon: 25.10849
},
{
id: "U3RvcDpIU0w6MTQ3MjEyOA==",
lat: 60.239,
lon: 25.10109
},
{
id: "U3RvcDpIU0w6MTQ3MjE5OA==",
lat: 60.23892,
lon: 25.09567
},
{
id: "U3RvcDpIU0w6MTQ3MjE5Ng==",
lat: 60.23881,
lon: 25.09099
},
{
id: "U3RvcDpIU0w6MTQ3MTExNw==",
lat: 60.23608,
lon: 25.08512
},
{
id: "U3RvcDpIU0w6MTQ3MTE1OQ==",
lat: 60.23613,
lon: 25.08247
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOQ==",
lat: 60.23797,
lon: 25.07866
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNg==",
lat: 60.23977,
lon: 25.07401
},
{
id: "U3RvcDpIU0w6MTQ3MTE1NA==",
lat: 60.238443,
lon: 25.071928
}
]
},
{
gtfsId: "HSL:1094",
shortName: "94",
longName: "Itäkeskus(M)-Porttitie-Kontula(M)-Kontulankaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzE4Mg==",
lat: 60.21003,
lon: 25.0768
},
{
id: "U3RvcDpIU0w6MTQ1MzE4MQ==",
lat: 60.21211,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMQ==",
lat: 60.21472,
lon: 25.08581
},
{
id: "U3RvcDpIU0w6MTQ1MzEwOQ==",
lat: 60.21775,
lon: 25.08378
},
{
id: "U3RvcDpIU0w6MTQ1NDExNg==",
lat: 60.22127,
lon: 25.08186
},
{
id: "U3RvcDpIU0w6MTQ1NDExNQ==",
lat: 60.223549,
lon: 25.082989
},
{
id: "U3RvcDpIU0w6MTQ3MTE2NA==",
lat: 60.225494,
lon: 25.083088
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMw==",
lat: 60.22723,
lon: 25.08458
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNQ==",
lat: 60.22981,
lon: 25.08912
},
{
id: "U3RvcDpIU0w6MTQ3MTE1OA==",
lat: 60.23084,
lon: 25.08527
},
{
id: "U3RvcDpIU0w6MTQ3MTE4NQ==",
lat: 60.2317,
lon: 25.08121
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMA==",
lat: 60.23377,
lon: 25.08125
},
{
id: "U3RvcDpIU0w6MTQ3MTE1OQ==",
lat: 60.23613,
lon: 25.08247
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOQ==",
lat: 60.23797,
lon: 25.07866
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MQ==",
lat: 60.24007,
lon: 25.07459
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mw==",
lat: 60.24255,
lon: 25.07526
},
{
id: "U3RvcDpIU0w6MTQ3MTE0NQ==",
lat: 60.2449,
lon: 25.07744
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNQ==",
lat: 60.24573,
lon: 25.08023
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Nw==",
lat: 60.24645,
lon: 25.0829
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Ng==",
lat: 60.24535,
lon: 25.07797
},
{
id: "U3RvcDpIU0w6MTQ3MTE0NA==",
lat: 60.24251,
lon: 25.07514
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mg==",
lat: 60.23916,
lon: 25.07499
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MA==",
lat: 60.23795,
lon: 25.07819
},
{
id: "U3RvcDpIU0w6MTQ3MTE3OQ==",
lat: 60.23602,
lon: 25.0822
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Ng==",
lat: 60.23179,
lon: 25.08045
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Nw==",
lat: 60.23065,
lon: 25.0857
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNg==",
lat: 60.2287,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNA==",
lat: 60.22677,
lon: 25.08374
},
{
id: "U3RvcDpIU0w6MTQ3MTExNA==",
lat: 60.224607,
lon: 25.084945
},
{
id: "U3RvcDpIU0w6MTQ1NDEyNw==",
lat: 60.223605,
lon: 25.082473
},
{
id: "U3RvcDpIU0w6MTQ1NDExNw==",
lat: 60.22102,
lon: 25.08156
},
{
id: "U3RvcDpIU0w6MTQ1MzExMA==",
lat: 60.21752,
lon: 25.08351
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
}
]
},
{
gtfsId: "HSL:1093",
shortName: "93",
longName: "Itäkeskus(M)-Östersundom-Landbo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTYwMjIwMw==",
lat: 60.270892,
lon: 25.201837
},
{
id: "U3RvcDpIU0w6MTYwMjEwOQ==",
lat: 60.268693,
lon: 25.197693
},
{
id: "U3RvcDpIU0w6MTYwMjExMA==",
lat: 60.26958,
lon: 25.19261
},
{
id: "U3RvcDpIU0w6MTYwMjExMQ==",
lat: 60.271778,
lon: 25.194812
},
{
id: "U3RvcDpIU0w6MTYwMjEwMg==",
lat: 60.270765,
lon: 25.201473
},
{
id: "U3RvcDpIU0w6MTYwMjIwNA==",
lat: 60.265179,
lon: 25.209755
},
{
id: "U3RvcDpIU0w6MTYwMjIwMg==",
lat: 60.261023,
lon: 25.209925
},
{
id: "U3RvcDpIU0w6MTYwMDIxNg==",
lat: 60.25977,
lon: 25.208407
},
{
id: "U3RvcDpIU0w6MTYwMDIxNA==",
lat: 60.25475,
lon: 25.190433
},
{
id: "U3RvcDpIU0w6MTYwMDIxMg==",
lat: 60.253138,
lon: 25.183522
},
{
id: "U3RvcDpIU0w6MTYwMDIxMA==",
lat: 60.2514,
lon: 25.173983
},
{
id: "U3RvcDpIU0w6MTYwMDIwOA==",
lat: 60.249428,
lon: 25.163417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNg==",
lat: 60.24737,
lon: 25.156468
},
{
id: "U3RvcDpIU0w6MTYwMDIwNA==",
lat: 60.245817,
lon: 25.152437
},
{
id: "U3RvcDpIU0w6MTYwMDIwMg==",
lat: 60.24422,
lon: 25.142975
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMA==",
lat: 60.23124,
lon: 25.12868
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MQ==",
lat: 60.22017,
lon: 25.10757
},
{
id: "U3RvcDpIU0w6MTQ1MTE4OA==",
lat: 60.21806,
lon: 25.10282
},
{
id: "U3RvcDpIU0w6MTQ1MzEzNA==",
lat: 60.21477,
lon: 25.09232
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzE4OQ==",
lat: 60.20987,
lon: 25.07621
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MjExOQ==",
lat: 60.215433,
lon: 25.094638
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Nw==",
lat: 60.21833,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MA==",
lat: 60.22011,
lon: 25.10815
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzExOQ==",
lat: 60.23115,
lon: 25.12893
},
{
id: "U3RvcDpIU0w6MTYwMDIwMQ==",
lat: 60.2431,
lon: 25.14191
},
{
id: "U3RvcDpIU0w6MTYwMDIwMw==",
lat: 60.245348,
lon: 25.151417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNQ==",
lat: 60.246743,
lon: 25.155558
},
{
id: "U3RvcDpIU0w6MTYwMDIwNw==",
lat: 60.249545,
lon: 25.164438
},
{
id: "U3RvcDpIU0w6MTYwMDIwOQ==",
lat: 60.251682,
lon: 25.176211
},
{
id: "U3RvcDpIU0w6MTYwMDIxMQ==",
lat: 60.253477,
lon: 25.185895
},
{
id: "U3RvcDpIU0w6MTYwMDIxMw==",
lat: 60.255158,
lon: 25.192102
},
{
id: "U3RvcDpIU0w6MTYwMjIwMQ==",
lat: 60.26087,
lon: 25.20992
}
]
},
{
gtfsId: "HSL:1092",
shortName: "92",
longName: "Itäkeskus(M)-Myllypuro",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzE4Ng==",
lat: 60.20964,
lon: 25.07681
},
{
id: "U3RvcDpIU0w6MTQ1NjExOA==",
lat: 60.2102,
lon: 25.05852
},
{
id: "U3RvcDpIU0w6MTQ1NjEwMQ==",
lat: 60.215588,
lon: 25.060236
},
{
id: "U3RvcDpIU0w6MTQ1NDExOA==",
lat: 60.218648,
lon: 25.058152
},
{
id: "U3RvcDpIU0w6MTQ1NDE1Ng==",
lat: 60.21997,
lon: 25.05752
},
{
id: "U3RvcDpIU0w6MTQ1NDE1MA==",
lat: 60.22192,
lon: 25.05795
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OA==",
lat: 60.22447,
lon: 25.05881
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Ng==",
lat: 60.22731,
lon: 25.06406
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NA==",
lat: 60.22739,
lon: 25.07177
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MQ==",
lat: 60.2236,
lon: 25.07608
},
{
id: "U3RvcDpIU0w6MTQ1NDEyNA==",
lat: 60.22127,
lon: 25.07884
},
{
id: "U3RvcDpIU0w6MTQ1NDEyOA==",
lat: 60.2197,
lon: 25.07435
},
{
id: "U3RvcDpIU0w6MTQ1NDEyMw==",
lat: 60.22169,
lon: 25.07862
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MA==",
lat: 60.22444,
lon: 25.07567
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Mw==",
lat: 60.22775,
lon: 25.0709
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NQ==",
lat: 60.227,
lon: 25.06296
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Nw==",
lat: 60.22353,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OQ==",
lat: 60.22198,
lon: 25.05776
},
{
id: "U3RvcDpIU0w6MTQ1NDE1Nw==",
lat: 60.22014,
lon: 25.05738
},
{
id: "U3RvcDpIU0w6MTQ1NDExOQ==",
lat: 60.218012,
lon: 25.059017
},
{
id: "U3RvcDpIU0w6MTQ1NjEwMg==",
lat: 60.215364,
lon: 25.059164
},
{
id: "U3RvcDpIU0w6MTQ1NjE1Mw==",
lat: 60.209323,
lon: 25.056896
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
}
]
},
{
gtfsId: "HSL:9965K",
shortName: "965K",
longName: "Hyrylä-Jäniksenlinna-Perttu-Jokela",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDEyNA==",
lat: 60.40201,
lon: 25.028074
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MDkwNQ==",
lat: 60.410608,
lon: 25.014965
},
{
id: "U3RvcDpIU0w6OTY1MDgwNg==",
lat: 60.416299,
lon: 25.0182
},
{
id: "U3RvcDpIU0w6OTY1MDgwMw==",
lat: 60.415801,
lon: 25.004147
},
{
id: "U3RvcDpIU0w6OTY1MTAwNw==",
lat: 60.41797,
lon: 25.000294
},
{
id: "U3RvcDpIU0w6OTY0MDQxMw==",
lat: 60.427683,
lon: 24.995212
},
{
id: "U3RvcDpIU0w6OTY0MDIxMQ==",
lat: 60.434771,
lon: 24.986197
},
{
id: "U3RvcDpIU0w6OTY0MDIwMQ==",
lat: 60.439897,
lon: 24.978521
},
{
id: "U3RvcDpIU0w6OTY0MDIwOA==",
lat: 60.442609,
lon: 24.974444
},
{
id: "U3RvcDpIU0w6OTY0MDIwMg==",
lat: 60.446018,
lon: 24.973734
},
{
id: "U3RvcDpIU0w6OTY0MDIxMA==",
lat: 60.450335,
lon: 24.976263
},
{
id: "U3RvcDpIU0w6OTY0MDIwNQ==",
lat: 60.456697,
lon: 24.982749
},
{
id: "U3RvcDpIU0w6OTYzMDUwMw==",
lat: 60.459668,
lon: 24.985308
},
{
id: "U3RvcDpIU0w6OTYzMDUwMQ==",
lat: 60.471422,
lon: 24.987407
},
{
id: "U3RvcDpIU0w6OTYzMDUwNQ==",
lat: 60.477834,
lon: 24.978129
},
{
id: "U3RvcDpIU0w6OTYzMDQxMA==",
lat: 60.483647,
lon: 24.974288
},
{
id: "U3RvcDpIU0w6OTYzMDQwMw==",
lat: 60.486755,
lon: 24.972114
},
{
id: "U3RvcDpIU0w6OTYzMDQwMQ==",
lat: 60.489927,
lon: 24.969136
},
{
id: "U3RvcDpIU0w6OTcwMDIyMQ==",
lat: 60.494212,
lon: 24.962823
},
{
id: "U3RvcDpIU0w6OTcwMDIyMw==",
lat: 60.50457,
lon: 24.951537
},
{
id: "U3RvcDpIU0w6OTcwMDIyNQ==",
lat: 60.509155,
lon: 24.936617
},
{
id: "U3RvcDpIU0w6OTcwMDIyNw==",
lat: 60.511449,
lon: 24.928019
},
{
id: "U3RvcDpIU0w6OTcwMDIyOQ==",
lat: 60.520257,
lon: 24.926359
},
{
id: "U3RvcDpIU0w6OTcwMDIzMQ==",
lat: 60.525824,
lon: 24.926062
},
{
id: "U3RvcDpIU0w6OTYxMDMxMQ==",
lat: 60.528282,
lon: 24.946632
},
{
id: "U3RvcDpIU0w6OTYxMDMwOA==",
lat: 60.535797,
lon: 24.957163
},
{
id: "U3RvcDpIU0w6OTYxMDMwNA==",
lat: 60.538221,
lon: 24.958512
},
{
id: "U3RvcDpIU0w6OTYxMDMxNA==",
lat: 60.539254,
lon: 24.96233
},
{
id: "U3RvcDpIU0w6OTYxMDMxOQ==",
lat: 60.54031,
lon: 24.96755
},
{
id: "U3RvcDpIU0w6OTYxMDMxNg==",
lat: 60.544953,
lon: 24.970892
},
{
id: "U3RvcDpIU0w6OTYxMDIxOQ==",
lat: 60.551364,
lon: 24.965102
},
{
id: "U3RvcDpIU0w6OTYxMDIyMA==",
lat: 60.553215,
lon: 24.96926
}
]
},
{
gtfsId: "HSL:6917AK",
shortName: "917AK",
longName: "Hästböle-Lappers",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMTA2MQ==",
lat: 60.153436,
lon: 24.056342
},
{
id: "U3RvcDpIU0w6NjMwMDA0OA==",
lat: 60.169385,
lon: 24.031931
},
{
id: "U3RvcDpIU0w6NjMwMDAwNg==",
lat: 60.178044,
lon: 24.049176
},
{
id: "U3RvcDpIU0w6NjMwMDAxOA==",
lat: 60.176004,
lon: 24.062917
},
{
id: "U3RvcDpIU0w6NjMwMDAxNg==",
lat: 60.176563,
lon: 24.076933
},
{
id: "U3RvcDpIU0w6NjMwMDAxMA==",
lat: 60.174555,
lon: 24.093479
},
{
id: "U3RvcDpIU0w6NjMwMDAyMQ==",
lat: 60.173292,
lon: 24.101885
},
{
id: "U3RvcDpIU0w6NjMwMDAxNA==",
lat: 60.173985,
lon: 24.109245
}
]
},
{
gtfsId: "HSL:9989J",
shortName: "989J",
longName: "Jokimäki-Pornainen-Järvenpää as.",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwNw==",
lat: 60.482216,
lon: 25.085202
},
{
id: "U3RvcDpIU0w6OTUwMDIxMw==",
lat: 60.465162,
lon: 25.119466
},
{
id: "U3RvcDpIU0w6OTUwMDIxNQ==",
lat: 60.468319,
lon: 25.130789
},
{
id: "U3RvcDpIU0w6OTUwMDIxNw==",
lat: 60.470208,
lon: 25.140627
},
{
id: "U3RvcDpIU0w6OTIyNzIwMw==",
lat: 60.470235,
lon: 25.153188
},
{
id: "U3RvcDpIU0w6OTIyNzIwMQ==",
lat: 60.470105,
lon: 25.158263
},
{
id: "U3RvcDpIU0w6OTIyNzIwMg==",
lat: 60.469752,
lon: 25.171968
},
{
id: "U3RvcDpIU0w6OTIyNzIwNw==",
lat: 60.469552,
lon: 25.191689
},
{
id: "U3RvcDpIU0w6OTIyNzIwOQ==",
lat: 60.47042,
lon: 25.197325
},
{
id: "U3RvcDpIU0w6OTIyNzIxMA==",
lat: 60.4712,
lon: 25.202058
},
{
id: "U3RvcDpIU0w6OTIyNzIxMw==",
lat: 60.473458,
lon: 25.211468
},
{
id: "U3RvcDpIU0w6OTIyNzIxOQ==",
lat: 60.4755,
lon: 25.217918
},
{
id: "U3RvcDpIU0w6OTIyNzIyMw==",
lat: 60.475468,
lon: 25.22686
},
{
id: "U3RvcDpIU0w6OTIyNjIxNA==",
lat: 60.469845,
lon: 25.250117
},
{
id: "U3RvcDpIU0w6OTIyNjIyNQ==",
lat: 60.470257,
lon: 25.262365
},
{
id: "U3RvcDpIU0w6OTQwMDIxOA==",
lat: 60.467015,
lon: 25.28387
},
{
id: "U3RvcDpIU0w6OTQwMDIwMg==",
lat: 60.483505,
lon: 25.368993
},
{
id: "U3RvcDpIU0w6OTQwMDIwOQ==",
lat: 60.47742,
lon: 25.374157
},
{
id: "U3RvcDpIU0w6OTQwMDIxMA==",
lat: 60.434959,
lon: 25.367006
}
]
},
{
gtfsId: "HSL:4555B",
shortName: "555B",
longName: "Leppävaara-Hämevaara-Myyrmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIyNQ==",
lat: 60.21929,
lon: 24.81115
},
{
id: "U3RvcDpIU0w6MjExMTIyOA==",
lat: 60.22132,
lon: 24.81134
},
{
id: "U3RvcDpIU0w6MjExMTIxMg==",
lat: 60.2232,
lon: 24.81071
},
{
id: "U3RvcDpIU0w6MjExMTIyNg==",
lat: 60.2267,
lon: 24.81272
},
{
id: "U3RvcDpIU0w6MjExMTI4MQ==",
lat: 60.22904,
lon: 24.81383
},
{
id: "U3RvcDpIU0w6MjExNDIxOA==",
lat: 60.23154,
lon: 24.8138
},
{
id: "U3RvcDpIU0w6MjExNDIyMA==",
lat: 60.23386,
lon: 24.81376
},
{
id: "U3RvcDpIU0w6MjExNzIzMg==",
lat: 60.236683,
lon: 24.808831
},
{
id: "U3RvcDpIU0w6MjExNzIzNA==",
lat: 60.23959,
lon: 24.80878
},
{
id: "U3RvcDpIU0w6MjExNzIyNg==",
lat: 60.24158,
lon: 24.80869
},
{
id: "U3RvcDpIU0w6MjExNzIyOA==",
lat: 60.24471,
lon: 24.80859
},
{
id: "U3RvcDpIU0w6MjExNzIzMA==",
lat: 60.24707,
lon: 24.80843
},
{
id: "U3RvcDpIU0w6NDExMDIxMA==",
lat: 60.24875,
lon: 24.806
},
{
id: "U3RvcDpIU0w6NDEyMDI5MA==",
lat: 60.25438,
lon: 24.79724
},
{
id: "U3RvcDpIU0w6NDEyMDI4OA==",
lat: 60.25537,
lon: 24.80147
},
{
id: "U3RvcDpIU0w6NDEyMDIwNg==",
lat: 60.25537,
lon: 24.80804
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6NDEzMDIwNw==",
lat: 60.25561,
lon: 24.82723
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDIwMw==",
lat: 60.26109,
lon: 24.8556
},
{
id: "U3RvcDpIU0w6NDE1MDI2NA==",
lat: 60.260577,
lon: 24.856522
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIxMA==",
lat: 60.25875,
lon: 24.83456
},
{
id: "U3RvcDpIU0w6NDEzMDIwOA==",
lat: 60.25622,
lon: 24.82877
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNQ==",
lat: 60.25572,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDI5MQ==",
lat: 60.25508,
lon: 24.79965
},
{
id: "U3RvcDpIU0w6NDEwMDIxMQ==",
lat: 60.25385,
lon: 24.79672
},
{
id: "U3RvcDpIU0w6NDExMDIwMQ==",
lat: 60.24907,
lon: 24.80488
},
{
id: "U3RvcDpIU0w6MjExNzIzMQ==",
lat: 60.24685,
lon: 24.80845
},
{
id: "U3RvcDpIU0w6MjExNzIyOQ==",
lat: 60.24432,
lon: 24.80847
},
{
id: "U3RvcDpIU0w6MjExNzIyNw==",
lat: 60.24119,
lon: 24.80857
},
{
id: "U3RvcDpIU0w6MjExNzIzNQ==",
lat: 60.23933,
lon: 24.80861
},
{
id: "U3RvcDpIU0w6MjExNDIwNg==",
lat: 60.23598,
lon: 24.80932
},
{
id: "U3RvcDpIU0w6MjExNDIyMQ==",
lat: 60.23321,
lon: 24.81357
},
{
id: "U3RvcDpIU0w6MjExNDIxOQ==",
lat: 60.2313,
lon: 24.81365
},
{
id: "U3RvcDpIU0w6MjExMTIxNw==",
lat: 60.22831,
lon: 24.81361
},
{
id: "U3RvcDpIU0w6MjExMTIxMw==",
lat: 60.22433,
lon: 24.81044
},
{
id: "U3RvcDpIU0w6MjExMTIyOQ==",
lat: 60.22095,
lon: 24.80986
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:1089",
shortName: "89",
longName: "Herttoniemi (M)-Yliskylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTEwNg==",
lat: 60.19456,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMg==",
lat: 60.18382,
lon: 25.05227
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNA==",
lat: 60.18367,
lon: 25.05709
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNg==",
lat: 60.18038,
lon: 25.05966
},
{
id: "U3RvcDpIU0w6MTQ5MTEyOA==",
lat: 60.17809,
lon: 25.05687
},
{
id: "U3RvcDpIU0w6MTQ5MTE3MA==",
lat: 60.178258,
lon: 25.0532
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OQ==",
lat: 60.178132,
lon: 25.053262
},
{
id: "U3RvcDpIU0w6MTQ5MTEyOQ==",
lat: 60.17805,
lon: 25.05738
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNw==",
lat: 60.18081,
lon: 25.0596
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNQ==",
lat: 60.18384,
lon: 25.05705
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMw==",
lat: 60.18389,
lon: 25.05198
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
}
]
},
{
gtfsId: "HSL:2245A",
shortName: "245A",
longName: "Espoon keskus-Nuuksionpää-Kattila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjY0NDIwMQ==",
lat: 60.32752,
lon: 24.49536
},
{
id: "U3RvcDpIU0w6MjY0NDIwNg==",
lat: 60.322744,
lon: 24.510589
},
{
id: "U3RvcDpIU0w6MjY0NDIwNA==",
lat: 60.320215,
lon: 24.520398
},
{
id: "U3RvcDpIU0w6MjY0NDIzMg==",
lat: 60.31662,
lon: 24.53793
},
{
id: "U3RvcDpIU0w6MjY0NDI2NQ==",
lat: 60.31489,
lon: 24.54317
},
{
id: "U3RvcDpIU0w6MjY0NDI2Mw==",
lat: 60.30818,
lon: 24.54797
},
{
id: "U3RvcDpIU0w6MjY0NDI1Nw==",
lat: 60.30237,
lon: 24.55154
},
{
id: "U3RvcDpIU0w6MjY0NDI1NQ==",
lat: 60.29776,
lon: 24.55168
},
{
id: "U3RvcDpIU0w6MjY0NDIzMQ==",
lat: 60.294402,
lon: 24.556703
},
{
id: "U3RvcDpIU0w6MjY0NDI1OQ==",
lat: 60.29053,
lon: 24.56258
},
{
id: "U3RvcDpIU0w6MjY0NDI1Mw==",
lat: 60.28811,
lon: 24.57362
},
{
id: "U3RvcDpIU0w6MjY0NDI1MQ==",
lat: 60.2828,
lon: 24.58396
},
{
id: "U3RvcDpIU0w6MjY0NDI0OQ==",
lat: 60.27654,
lon: 24.5897
},
{
id: "U3RvcDpIU0w6MjY0NDI0Nw==",
lat: 60.26876,
lon: 24.59526
},
{
id: "U3RvcDpIU0w6MjY0MjI0NQ==",
lat: 60.26318,
lon: 24.5992
},
{
id: "U3RvcDpIU0w6MjY0MjI2MQ==",
lat: 60.25344,
lon: 24.59528
},
{
id: "U3RvcDpIU0w6MjY0MjI2Nw==",
lat: 60.24893,
lon: 24.593
},
{
id: "U3RvcDpIU0w6MjY0MjIzNw==",
lat: 60.24354,
lon: 24.59318
},
{
id: "U3RvcDpIU0w6MjY0MjI4NQ==",
lat: 60.23869,
lon: 24.5967
},
{
id: "U3RvcDpIU0w6MjY0MjIwNg==",
lat: 60.23713,
lon: 24.5973
},
{
id: "U3RvcDpIU0w6MjY0MjIwNA==",
lat: 60.23408,
lon: 24.60218
},
{
id: "U3RvcDpIU0w6MjY0MjIwMg==",
lat: 60.23044,
lon: 24.60938
},
{
id: "U3RvcDpIU0w6MjYzNDIxNA==",
lat: 60.22535,
lon: 24.62021
},
{
id: "U3RvcDpIU0w6MjYzNDIxMg==",
lat: 60.22296,
lon: 24.62769
},
{
id: "U3RvcDpIU0w6MjYzNDIxMA==",
lat: 60.22181,
lon: 24.63336
},
{
id: "U3RvcDpIU0w6MjYzNDIwOA==",
lat: 60.22106,
lon: 24.64406
},
{
id: "U3RvcDpIU0w6MjYzMTIwNg==",
lat: 60.22154,
lon: 24.65273
},
{
id: "U3RvcDpIU0w6MjYzMzIyMg==",
lat: 60.22298,
lon: 24.66
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTIxOQ==",
lat: 60.205048,
lon: 24.65511
},
{
id: "U3RvcDpIU0w6MjYxMTI1OA==",
lat: 60.20535,
lon: 24.65686
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMzIyMA==",
lat: 60.22261,
lon: 24.65842
},
{
id: "U3RvcDpIU0w6MjYzMTIwNQ==",
lat: 60.22153,
lon: 24.65084
},
{
id: "U3RvcDpIU0w6MjYzNDIwNw==",
lat: 60.22114,
lon: 24.6424
},
{
id: "U3RvcDpIU0w6MjYzNDIwOQ==",
lat: 60.22177,
lon: 24.63425
},
{
id: "U3RvcDpIU0w6MjYzNDIxMQ==",
lat: 60.22333,
lon: 24.62652
},
{
id: "U3RvcDpIU0w6MjYzNDIxMw==",
lat: 60.22492,
lon: 24.6214
},
{
id: "U3RvcDpIU0w6MjY0MjIwMQ==",
lat: 60.23029,
lon: 24.60998
},
{
id: "U3RvcDpIU0w6MjY0MjIwMw==",
lat: 60.23468,
lon: 24.60146
},
{
id: "U3RvcDpIU0w6MjY0MjIwNQ==",
lat: 60.23769,
lon: 24.59669
},
{
id: "U3RvcDpIU0w6MjY0MjI4NA==",
lat: 60.23911,
lon: 24.59706
},
{
id: "U3RvcDpIU0w6MjY0MjIzOA==",
lat: 60.24476,
lon: 24.59264
},
{
id: "U3RvcDpIU0w6MjY0MjI2OA==",
lat: 60.24972,
lon: 24.59311
},
{
id: "U3RvcDpIU0w6MjY0MjI2Mg==",
lat: 60.25472,
lon: 24.59539
},
{
id: "U3RvcDpIU0w6MjY0MjI0Ng==",
lat: 60.26348,
lon: 24.59932
},
{
id: "U3RvcDpIU0w6MjY0NDI0OA==",
lat: 60.26953,
lon: 24.59526
},
{
id: "U3RvcDpIU0w6MjY0NDI1MA==",
lat: 60.27743,
lon: 24.58949
},
{
id: "U3RvcDpIU0w6MjY0NDI1Mg==",
lat: 60.28244,
lon: 24.58403
},
{
id: "U3RvcDpIU0w6MjY0NDI1NA==",
lat: 60.28819,
lon: 24.5739
},
{
id: "U3RvcDpIU0w6MjY0NDI2MA==",
lat: 60.29109,
lon: 24.56217
},
{
id: "U3RvcDpIU0w6MjY0NDIzMA==",
lat: 60.293557,
lon: 24.558697
},
{
id: "U3RvcDpIU0w6MjY0NDI1Ng==",
lat: 60.29848,
lon: 24.55157
},
{
id: "U3RvcDpIU0w6MjY0NDI1OA==",
lat: 60.30167,
lon: 24.55163
},
{
id: "U3RvcDpIU0w6MjY0NDI2NA==",
lat: 60.30871,
lon: 24.54733
},
{
id: "U3RvcDpIU0w6MjY0NDI2Ng==",
lat: 60.31409,
lon: 24.54462
},
{
id: "U3RvcDpIU0w6MjY0NDIwMw==",
lat: 60.320237,
lon: 24.521678
},
{
id: "U3RvcDpIU0w6MjY0NDIwNQ==",
lat: 60.323028,
lon: 24.510185
}
]
},
{
gtfsId: "HSL:5566",
shortName: "566",
longName: "Martinlaakso-Koskelo-Espoon keskus",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDEyMDIxNA==",
lat: 60.27342,
lon: 24.7938
},
{
id: "U3RvcDpIU0w6NDEyMDIxNg==",
lat: 60.27395,
lon: 24.77924
},
{
id: "U3RvcDpIU0w6MjcxNTI5NQ==",
lat: 60.269782,
lon: 24.755897
},
{
id: "U3RvcDpIU0w6MjcxNTIxMA==",
lat: 60.26655,
lon: 24.74574
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMjIyMA==",
lat: 60.26319,
lon: 24.72306
},
{
id: "U3RvcDpIU0w6MjcxMjIxNg==",
lat: 60.26041,
lon: 24.71996
},
{
id: "U3RvcDpIU0w6MjcxMjIyMw==",
lat: 60.257549,
lon: 24.716212
},
{
id: "U3RvcDpIU0w6MjcxMjIyMQ==",
lat: 60.25376,
lon: 24.71091
},
{
id: "U3RvcDpIU0w6MjYzMjIxMQ==",
lat: 60.2401,
lon: 24.69561
},
{
id: "U3RvcDpIU0w6MjYzNDI3OA==",
lat: 60.2243,
lon: 24.66961
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
},
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYxNDI4Ng==",
lat: 60.22219,
lon: 24.66789
},
{
id: "U3RvcDpIU0w6MjYzMjIxMA==",
lat: 60.241825,
lon: 24.699687
},
{
id: "U3RvcDpIU0w6MjcxMjIyMg==",
lat: 60.25359,
lon: 24.71106
},
{
id: "U3RvcDpIU0w6MjcxMjIxNQ==",
lat: 60.25791,
lon: 24.71676
},
{
id: "U3RvcDpIU0w6MjcxMjIxNw==",
lat: 60.25978,
lon: 24.7193
},
{
id: "U3RvcDpIU0w6MjcxMjIxOQ==",
lat: 60.26365,
lon: 24.72388
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxOA==",
lat: 60.26626,
lon: 24.73717
},
{
id: "U3RvcDpIU0w6MjcxNTI5Mw==",
lat: 60.26702,
lon: 24.74761
},
{
id: "U3RvcDpIU0w6MjcxNTI5NA==",
lat: 60.26969,
lon: 24.75626
},
{
id: "U3RvcDpIU0w6MjcxNTIzMA==",
lat: 60.26954,
lon: 24.75945
},
{
id: "U3RvcDpIU0w6NDEyMDIxNw==",
lat: 60.27395,
lon: 24.78154
},
{
id: "U3RvcDpIU0w6NDEyMDIzNg==",
lat: 60.272876,
lon: 24.790986
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxMQ==",
lat: 60.2773,
lon: 24.85304
}
]
},
{
gtfsId: "HSL:2112N",
shortName: "112N",
longName: "Kamppi-Lauttasaari (M)-Westend-Matinkylä(M)-Friisilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI3Mw==",
lat: 60.169066,
lon: 24.931895
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTEyOQ==",
lat: 60.16436,
lon: 24.91112
},
{
id: "U3RvcDpIU0w6MTIwMTEzMQ==",
lat: 60.16338,
lon: 24.9044
},
{
id: "U3RvcDpIU0w6MTMxMDEwMQ==",
lat: 60.16126,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMxMDEwNQ==",
lat: 60.16055,
lon: 24.87946
},
{
id: "U3RvcDpIU0w6MTMxMDEyNA==",
lat: 60.16161,
lon: 24.8697
},
{
id: "U3RvcDpIU0w6MTMxMDE5OA==",
lat: 60.16256,
lon: 24.86046
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIzMTIwMw==",
lat: 60.168,
lon: 24.80632
},
{
id: "U3RvcDpIU0w6MjIzMTIwNA==",
lat: 60.1657,
lon: 24.80552
},
{
id: "U3RvcDpIU0w6MjIzMTIwNg==",
lat: 60.16328,
lon: 24.80276
},
{
id: "U3RvcDpIU0w6MjIzMTIzNQ==",
lat: 60.16293,
lon: 24.79966
},
{
id: "U3RvcDpIU0w6MjIzMTIzMw==",
lat: 60.16402,
lon: 24.7922
},
{
id: "U3RvcDpIU0w6MjIzMTIzNw==",
lat: 60.16331,
lon: 24.79048
},
{
id: "U3RvcDpIU0w6MjIzMTIzMQ==",
lat: 60.16042,
lon: 24.78971
},
{
id: "U3RvcDpIU0w6MjIzMjIxNQ==",
lat: 60.1594,
lon: 24.78585
},
{
id: "U3RvcDpIU0w6MjIzMjIxNw==",
lat: 60.15969,
lon: 24.78236
},
{
id: "U3RvcDpIU0w6MjIzMjIxOQ==",
lat: 60.16206,
lon: 24.78054
},
{
id: "U3RvcDpIU0w6MjIzMjIzNg==",
lat: 60.16262,
lon: 24.77681
},
{
id: "U3RvcDpIU0w6MjIzMjIyMQ==",
lat: 60.16146,
lon: 24.77498
},
{
id: "U3RvcDpIU0w6MjIzMjIyNw==",
lat: 60.15923,
lon: 24.77324
},
{
id: "U3RvcDpIU0w6MjIzMjIyOQ==",
lat: 60.15794,
lon: 24.76957
},
{
id: "U3RvcDpIU0w6MjIzMjIwOQ==",
lat: 60.15822,
lon: 24.76684
},
{
id: "U3RvcDpIU0w6MjIzMjIxMQ==",
lat: 60.15908,
lon: 24.76323
},
{
id: "U3RvcDpIU0w6MjIzMjIxMg==",
lat: 60.16029,
lon: 24.76163
},
{
id: "U3RvcDpIU0w6MjMxNDIwNQ==",
lat: 60.16156,
lon: 24.75989
},
{
id: "U3RvcDpIU0w6MjMxNDIwMw==",
lat: 60.16122,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjMxMzIwMQ==",
lat: 60.16176,
lon: 24.74732
},
{
id: "U3RvcDpIU0w6MjMxMzIwNQ==",
lat: 60.161989,
lon: 24.740844
},
{
id: "U3RvcDpIU0w6MjMxMTIwMQ==",
lat: 60.160644,
lon: 24.740316
},
{
id: "U3RvcDpIU0w6MjMxMTIwNQ==",
lat: 60.15791,
lon: 24.74276
},
{
id: "U3RvcDpIU0w6MjMxMTIwNw==",
lat: 60.15533,
lon: 24.745
},
{
id: "U3RvcDpIU0w6MjMxMTIwOA==",
lat: 60.15312,
lon: 24.74728
},
{
id: "U3RvcDpIU0w6MjMxMzIxMA==",
lat: 60.15149,
lon: 24.75032
},
{
id: "U3RvcDpIU0w6MjMxMTIxMg==",
lat: 60.14926,
lon: 24.74822
},
{
id: "U3RvcDpIU0w6MjMxMTIxNA==",
lat: 60.14808,
lon: 24.74123
},
{
id: "U3RvcDpIU0w6MjMxMjIxNg==",
lat: 60.15117,
lon: 24.73608
},
{
id: "U3RvcDpIU0w6MjMxMjIxOA==",
lat: 60.15421,
lon: 24.72872
},
{
id: "U3RvcDpIU0w6MjMxNDIyMA==",
lat: 60.15719,
lon: 24.7262
},
{
id: "U3RvcDpIU0w6MjMxNDIyMg==",
lat: 60.16089,
lon: 24.72496
},
{
id: "U3RvcDpIU0w6MjMyMTI1Ng==",
lat: 60.16264,
lon: 24.72254
},
{
id: "U3RvcDpIU0w6MjMyMTIyNA==",
lat: 60.16351,
lon: 24.72134
},
{
id: "U3RvcDpIU0w6MjMyMTIyNQ==",
lat: 60.16288,
lon: 24.72094
},
{
id: "U3RvcDpIU0w6MjMyMTIyNw==",
lat: 60.16215,
lon: 24.72297
},
{
id: "U3RvcDpIU0w6MjMxNDIyMw==",
lat: 60.16015,
lon: 24.72536
},
{
id: "U3RvcDpIU0w6MjMxNDIyMQ==",
lat: 60.15638,
lon: 24.72662
},
{
id: "U3RvcDpIU0w6MjMxMjIxOQ==",
lat: 60.15334,
lon: 24.72924
},
{
id: "U3RvcDpIU0w6MjMxMjIxNw==",
lat: 60.15029,
lon: 24.73707
},
{
id: "U3RvcDpIU0w6MjMxNTIxNQ==",
lat: 60.14763,
lon: 24.74306
},
{
id: "U3RvcDpIU0w6MjMxMTIxMw==",
lat: 60.14925,
lon: 24.74849
},
{
id: "U3RvcDpIU0w6MjMxMzIxMQ==",
lat: 60.15182,
lon: 24.74997
},
{
id: "U3RvcDpIU0w6MjMxMTIwOQ==",
lat: 60.15387,
lon: 24.74657
},
{
id: "U3RvcDpIU0w6MjMxMTIwNg==",
lat: 60.1563,
lon: 24.74446
},
{
id: "U3RvcDpIU0w6MjMxNDIwOA==",
lat: 60.161049,
lon: 24.740512
},
{
id: "U3RvcDpIU0w6MjMxMzIwNg==",
lat: 60.161752,
lon: 24.740728
},
{
id: "U3RvcDpIU0w6MjMxMzIwMg==",
lat: 60.16181,
lon: 24.74771
},
{
id: "U3RvcDpIU0w6MjMxNDIwNA==",
lat: 60.16113,
lon: 24.75527
},
{
id: "U3RvcDpIU0w6MjMxNDIwNg==",
lat: 60.16122,
lon: 24.76094
},
{
id: "U3RvcDpIU0w6MjIzMjIxMA==",
lat: 60.15869,
lon: 24.76397
},
{
id: "U3RvcDpIU0w6MjIzMjIwOA==",
lat: 60.15782,
lon: 24.76818
},
{
id: "U3RvcDpIU0w6MjIzMjIzMA==",
lat: 60.15822,
lon: 24.77103
},
{
id: "U3RvcDpIU0w6MjIzMjIyOA==",
lat: 60.16035,
lon: 24.77435
},
{
id: "U3RvcDpIU0w6MjIzMjIwMg==",
lat: 60.162188,
lon: 24.775302
},
{
id: "U3RvcDpIU0w6MjIzMjIzNw==",
lat: 60.16242,
lon: 24.77648
},
{
id: "U3RvcDpIU0w6MjIzMjIyMA==",
lat: 60.1618,
lon: 24.78046
},
{
id: "U3RvcDpIU0w6MjIzMjIxOA==",
lat: 60.15913,
lon: 24.78368
},
{
id: "U3RvcDpIU0w6MjIzMjIxNg==",
lat: 60.15939,
lon: 24.78739
},
{
id: "U3RvcDpIU0w6MjIzMTIzMg==",
lat: 60.16009,
lon: 24.78992
},
{
id: "U3RvcDpIU0w6MjIzMTIzMA==",
lat: 60.16241,
lon: 24.79113
},
{
id: "U3RvcDpIU0w6MjIzMTIzNA==",
lat: 60.16435,
lon: 24.79435
},
{
id: "U3RvcDpIU0w6MjIzMTIwNw==",
lat: 60.1628,
lon: 24.80236
},
{
id: "U3RvcDpIU0w6MjIzMTIwNQ==",
lat: 60.16634,
lon: 24.80611
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTMxMDI5OQ==",
lat: 60.16235,
lon: 24.86092
},
{
id: "U3RvcDpIU0w6MTMxMDIyNQ==",
lat: 60.1614,
lon: 24.87051
},
{
id: "U3RvcDpIU0w6MTMxMDEwNg==",
lat: 60.160297,
lon: 24.881277
},
{
id: "U3RvcDpIU0w6MTMxMDEwMg==",
lat: 60.16113,
lon: 24.89116
},
{
id: "U3RvcDpIU0w6MTIwMTEzMg==",
lat: 60.16338,
lon: 24.90505
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:9989A",
shortName: "989A",
longName: "Monninkylä-Pornainen-Järvenpää",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwNw==",
lat: 60.482216,
lon: 25.085202
},
{
id: "U3RvcDpIU0w6OTUwMDIxMw==",
lat: 60.465162,
lon: 25.119466
},
{
id: "U3RvcDpIU0w6OTUwMDIxNQ==",
lat: 60.468319,
lon: 25.130789
},
{
id: "U3RvcDpIU0w6OTUwMDIxNw==",
lat: 60.470208,
lon: 25.140627
},
{
id: "U3RvcDpIU0w6OTIyNzIwMw==",
lat: 60.470235,
lon: 25.153188
},
{
id: "U3RvcDpIU0w6OTIyNzIwMQ==",
lat: 60.470105,
lon: 25.158263
},
{
id: "U3RvcDpIU0w6OTIyNzIwMg==",
lat: 60.469752,
lon: 25.171968
},
{
id: "U3RvcDpIU0w6OTIyNzIwNw==",
lat: 60.469552,
lon: 25.191689
},
{
id: "U3RvcDpIU0w6OTIyNzIwOQ==",
lat: 60.47042,
lon: 25.197325
},
{
id: "U3RvcDpIU0w6OTIyNzIxMA==",
lat: 60.4712,
lon: 25.202058
},
{
id: "U3RvcDpIU0w6OTIyNzIxMw==",
lat: 60.473458,
lon: 25.211468
},
{
id: "U3RvcDpIU0w6OTIyNzIxOQ==",
lat: 60.4755,
lon: 25.217918
},
{
id: "U3RvcDpIU0w6OTIyNzIyMw==",
lat: 60.475468,
lon: 25.22686
},
{
id: "U3RvcDpIU0w6OTIyNjIxNA==",
lat: 60.469845,
lon: 25.250117
},
{
id: "U3RvcDpIU0w6OTIyNjIyNQ==",
lat: 60.470257,
lon: 25.262365
},
{
id: "U3RvcDpIU0w6OTQwMDIxOA==",
lat: 60.467015,
lon: 25.28387
},
{
id: "U3RvcDpIU0w6OTQwMDIwMg==",
lat: 60.483505,
lon: 25.368993
},
{
id: "U3RvcDpIU0w6OTQwMDIwOQ==",
lat: 60.47742,
lon: 25.374157
},
{
id: "U3RvcDpIU0w6OTQwMDIwOA==",
lat: 60.477653,
lon: 25.374435
},
{
id: "U3RvcDpIU0w6OTQwMDIwNg==",
lat: 60.495482,
lon: 25.535926
},
{
id: "U3RvcDpIU0w6OTQwMDIwNw==",
lat: 60.495796,
lon: 25.536724
},
{
id: "U3RvcDpIU0w6OTQwMDIxNg==",
lat: 60.475649,
lon: 25.374388
},
{
id: "U3RvcDpIU0w6OTQwMDIwMw==",
lat: 60.484878,
lon: 25.36799
},
{
id: "U3RvcDpIU0w6OTQwMDIxNw==",
lat: 60.467104,
lon: 25.28211
},
{
id: "U3RvcDpIU0w6OTIyNjIyNA==",
lat: 60.470385,
lon: 25.260995
},
{
id: "U3RvcDpIU0w6OTIyNjIxMw==",
lat: 60.47014,
lon: 25.24792
},
{
id: "U3RvcDpIU0w6OTIyNzIyMg==",
lat: 60.475795,
lon: 25.226008
},
{
id: "U3RvcDpIU0w6OTIyNzIxOA==",
lat: 60.475422,
lon: 25.216608
},
{
id: "U3RvcDpIU0w6OTIyNzIxMg==",
lat: 60.472927,
lon: 25.209372
},
{
id: "U3RvcDpIU0w6OTIyNzIxMQ==",
lat: 60.471717,
lon: 25.203932
},
{
id: "U3RvcDpIU0w6OTIyNzIwOA==",
lat: 60.470497,
lon: 25.19664
},
{
id: "U3RvcDpIU0w6OTIyNzIwNg==",
lat: 60.469533,
lon: 25.189673
},
{
id: "U3RvcDpIU0w6OTIyNzIwNQ==",
lat: 60.469993,
lon: 25.169843
},
{
id: "U3RvcDpIU0w6OTIyNzIwNA==",
lat: 60.470315,
lon: 25.157247
},
{
id: "U3RvcDpIU0w6OTUwMDIyNA==",
lat: 60.470406,
lon: 25.150845
},
{
id: "U3RvcDpIU0w6OTUwMDIwNA==",
lat: 60.470263,
lon: 25.139763
},
{
id: "U3RvcDpIU0w6OTUwMDIwNg==",
lat: 60.46899,
lon: 25.132184
},
{
id: "U3RvcDpIU0w6OTUwMDIyNg==",
lat: 60.467716,
lon: 25.129178
},
{
id: "U3RvcDpIU0w6OTUwMDIyOA==",
lat: 60.465217,
lon: 25.119395
},
{
id: "U3RvcDpIU0w6OTUwMDIxOQ==",
lat: 60.465756,
lon: 25.117527
},
{
id: "U3RvcDpIU0w6OTUwMDIxMQ==",
lat: 60.482336,
lon: 25.098393
},
{
id: "U3RvcDpIU0w6OTUwMDIwOA==",
lat: 60.484409,
lon: 25.090334
},
{
id: "U3RvcDpIU0w6OTUwMDIxMA==",
lat: 60.482476,
lon: 25.085652
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIwMA==",
lat: 60.47372,
lon: 25.090098
}
]
},
{
gtfsId: "HSL:2124K",
shortName: "124K",
longName: "Tapiola(M)-Niittykumpu(M)-Espoonlahti-Saunalahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIxMTIyNg==",
lat: 60.174956,
lon: 24.803668
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mw==",
lat: 60.17122,
lon: 24.77009
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
},
{
id: "U3RvcDpIU0w6MjMyMjIwNA==",
lat: 60.16999,
lon: 24.75087
},
{
id: "U3RvcDpIU0w6MjMyMjIwNQ==",
lat: 60.167702,
lon: 24.741443
},
{
id: "U3RvcDpIU0w6MjMyMzIwOA==",
lat: 60.16623,
lon: 24.73758
},
{
id: "U3RvcDpIU0w6MjMyMzIxMA==",
lat: 60.16594,
lon: 24.73119
},
{
id: "U3RvcDpIU0w6MjMyMzIxNA==",
lat: 60.16521,
lon: 24.72609
},
{
id: "U3RvcDpIU0w6MjMyMTIyMw==",
lat: 60.16259,
lon: 24.7208
},
{
id: "U3RvcDpIU0w6MjQzMjIxOA==",
lat: 60.16191,
lon: 24.70958
},
{
id: "U3RvcDpIU0w6MjQzMjI0MA==",
lat: 60.16211,
lon: 24.70565
},
{
id: "U3RvcDpIU0w6MjQzMjIyMA==",
lat: 60.1622,
lon: 24.70074
},
{
id: "U3RvcDpIU0w6MjQzMjIyMQ==",
lat: 60.16172,
lon: 24.6976
},
{
id: "U3RvcDpIU0w6MjQzMjIyOQ==",
lat: 60.15995,
lon: 24.69273
},
{
id: "U3RvcDpIU0w6MjQzMjIyMw==",
lat: 60.15842,
lon: 24.68966
},
{
id: "U3RvcDpIU0w6MjQzNDIyNQ==",
lat: 60.15632,
lon: 24.6807
},
{
id: "U3RvcDpIU0w6MjQzNDIyOA==",
lat: 60.15556,
lon: 24.67205
},
{
id: "U3RvcDpIU0w6MjQzNDIzMA==",
lat: 60.15559,
lon: 24.66702
},
{
id: "U3RvcDpIU0w6MjQyMTIxOA==",
lat: 60.15429,
lon: 24.66413
},
{
id: "U3RvcDpIU0w6MjQxMTIyNA==",
lat: 60.15183,
lon: 24.66506
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOQ==",
lat: 60.14867,
lon: 24.66343
},
{
id: "U3RvcDpIU0w6MjQxMTIzOQ==",
lat: 60.14776,
lon: 24.6582
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOA==",
lat: 60.15638,
lon: 24.63086
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6MjQyMzIxOQ==",
lat: 60.15906,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQyMzIxNQ==",
lat: 60.16269,
lon: 24.61315
},
{
id: "U3RvcDpIU0w6MjQyMzIxMA==",
lat: 60.165995,
lon: 24.615303
},
{
id: "U3RvcDpIU0w6MjQyMzIwNQ==",
lat: 60.16774,
lon: 24.61602
},
{
id: "U3RvcDpIU0w6MjQyMzIxNg==",
lat: 60.168817,
lon: 24.608176
},
{
id: "U3RvcDpIU0w6MjQyMzIxMg==",
lat: 60.169017,
lon: 24.602997
},
{
id: "U3RvcDpIU0w6MjQyMzIwOA==",
lat: 60.168583,
lon: 24.600373
},
{
id: "U3RvcDpIU0w6MjQyMzIyMg==",
lat: 60.169066,
lon: 24.605836
},
{
id: "U3RvcDpIU0w6MjQyMzIxNw==",
lat: 60.168516,
lon: 24.610189
},
{
id: "U3RvcDpIU0w6MjQyMzIxMw==",
lat: 60.16746,
lon: 24.616208
},
{
id: "U3RvcDpIU0w6MjQyMzIxMQ==",
lat: 60.165647,
lon: 24.61464
},
{
id: "U3RvcDpIU0w6MjQyMzIxNA==",
lat: 60.16214,
lon: 24.61326
},
{
id: "U3RvcDpIU0w6MjQyMzIyMA==",
lat: 60.15901,
lon: 24.6135
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxNQ==",
lat: 60.15301,
lon: 24.63405
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxMTI0MA==",
lat: 60.14766,
lon: 24.65846
},
{
id: "U3RvcDpIU0w6MjQ0MzIyOA==",
lat: 60.14873,
lon: 24.66543
},
{
id: "U3RvcDpIU0w6MjQxMTIyNQ==",
lat: 60.15011,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjQzMjIzMQ==",
lat: 60.15527,
lon: 24.66488
},
{
id: "U3RvcDpIU0w6MjQzNDIyOQ==",
lat: 60.15569,
lon: 24.66917
},
{
id: "U3RvcDpIU0w6MjQzNDIyNw==",
lat: 60.15558,
lon: 24.6744
},
{
id: "U3RvcDpIU0w6MjQzMjIyNg==",
lat: 60.15642,
lon: 24.68264
},
{
id: "U3RvcDpIU0w6MjQzMjIyNA==",
lat: 60.159344,
lon: 24.692096
},
{
id: "U3RvcDpIU0w6MjQzMjIyMg==",
lat: 60.16186,
lon: 24.69937
},
{
id: "U3RvcDpIU0w6MjQzMjIxOQ==",
lat: 60.1618,
lon: 24.7053
},
{
id: "U3RvcDpIU0w6MjQzMjIxNw==",
lat: 60.16173,
lon: 24.71134
},
{
id: "U3RvcDpIU0w6MjMyMTIyMg==",
lat: 60.16315,
lon: 24.72314
},
{
id: "U3RvcDpIU0w6MjMyMzIxMw==",
lat: 60.16583,
lon: 24.73008
},
{
id: "U3RvcDpIU0w6MjMyMzIxMQ==",
lat: 60.16564,
lon: 24.73343
},
{
id: "U3RvcDpIU0w6MjMyMzIwOQ==",
lat: 60.16666,
lon: 24.73958
},
{
id: "U3RvcDpIU0w6MjMyMjIwNg==",
lat: 60.168597,
lon: 24.743873
},
{
id: "U3RvcDpIU0w6MjMyMjI0Nw==",
lat: 60.16966,
lon: 24.74919
},
{
id: "U3RvcDpIU0w6MjMyMjIyOQ==",
lat: 60.17043,
lon: 24.75535
},
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDI0NA==",
lat: 60.170943,
lon: 24.772035
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
}
]
},
{
gtfsId: "HSL:1080",
shortName: "80",
longName: "Herttoniemi(M)-Roihuvuori-Itäkeskus(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzEyOA==",
lat: 60.20956,
lon: 25.07691
},
{
id: "U3RvcDpIU0w6MTQzMjEyMg==",
lat: 60.20641,
lon: 25.0571
},
{
id: "U3RvcDpIU0w6MTQzMjE2NA==",
lat: 60.203,
lon: 25.05946
},
{
id: "U3RvcDpIU0w6MTQzMjE2Mg==",
lat: 60.2007,
lon: 25.05952
},
{
id: "U3RvcDpIU0w6MTQzMjE2MA==",
lat: 60.1975,
lon: 25.05482
},
{
id: "U3RvcDpIU0w6MTQzMjE1OA==",
lat: 60.19525,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQzMzE1Ng==",
lat: 60.19313,
lon: 25.04621
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
},
{
id: "U3RvcDpIU0w6MTQzMTE4OQ==",
lat: 60.19516,
lon: 25.03188
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE1Mw==",
lat: 60.19236,
lon: 25.04061
},
{
id: "U3RvcDpIU0w6MTQzMzE3Mw==",
lat: 60.1931,
lon: 25.04642
},
{
id: "U3RvcDpIU0w6MTQzMjE1Nw==",
lat: 60.19536,
lon: 25.0535
},
{
id: "U3RvcDpIU0w6MTQzMjE1OQ==",
lat: 60.19806,
lon: 25.05587
},
{
id: "U3RvcDpIU0w6MTQzMjE2MQ==",
lat: 60.20088,
lon: 25.05972
},
{
id: "U3RvcDpIU0w6MTQzMjEyNQ==",
lat: 60.20352,
lon: 25.05932
},
{
id: "U3RvcDpIU0w6MTQzMjEyMw==",
lat: 60.206284,
lon: 25.057458
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
}
]
},
{
gtfsId: "HSL:7983",
shortName: "983",
longName: "Keravan asema-Nikkilä-Kilpilahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTMwMDIwNQ==",
lat: 60.310357,
lon: 25.504196
},
{
id: "U3RvcDpIU0w6OTIyMTIxMA==",
lat: 60.364281,
lon: 25.364847
},
{
id: "U3RvcDpIU0w6OTIyODIwOA==",
lat: 60.37081,
lon: 25.33492
},
{
id: "U3RvcDpIU0w6OTIyODIwNw==",
lat: 60.36993,
lon: 25.328368
},
{
id: "U3RvcDpIU0w6OTIyODIwNg==",
lat: 60.368545,
lon: 25.320832
},
{
id: "U3RvcDpIU0w6OTIyODIwNA==",
lat: 60.367617,
lon: 25.301282
},
{
id: "U3RvcDpIU0w6OTIyODIwMQ==",
lat: 60.370982,
lon: 25.297348
},
{
id: "U3RvcDpIU0w6OTIyMzIwOQ==",
lat: 60.372798,
lon: 25.29157
},
{
id: "U3RvcDpIU0w6OTIyMzIwNg==",
lat: 60.374383,
lon: 25.284143
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxOTIwNA==",
lat: 60.375665,
lon: 25.21708
},
{
id: "U3RvcDpIU0w6OTIxOTIwMQ==",
lat: 60.377612,
lon: 25.197257
},
{
id: "U3RvcDpIU0w6OTIxODIwMw==",
lat: 60.383794,
lon: 25.165494
},
{
id: "U3RvcDpIU0w6OTA1MDIwNg==",
lat: 60.38642,
lon: 25.14572
},
{
id: "U3RvcDpIU0w6OTA1MDIwOQ==",
lat: 60.38965,
lon: 25.14576
},
{
id: "U3RvcDpIU0w6OTA1MDIxMQ==",
lat: 60.39214,
lon: 25.14665
},
{
id: "U3RvcDpIU0w6OTA1MDIxMw==",
lat: 60.39432,
lon: 25.14548
},
{
id: "U3RvcDpIU0w6OTA1MDIxNQ==",
lat: 60.39715,
lon: 25.14532
},
{
id: "U3RvcDpIU0w6OTA1MDIxNw==",
lat: 60.4001,
lon: 25.1452
},
{
id: "U3RvcDpIU0w6OTA1MDIzMg==",
lat: 60.40087,
lon: 25.13935
},
{
id: "U3RvcDpIU0w6OTA1MDIzMA==",
lat: 60.40239,
lon: 25.13575
},
{
id: "U3RvcDpIU0w6OTA0MDIyMw==",
lat: 60.4015,
lon: 25.11788
},
{
id: "U3RvcDpIU0w6OTA0MDIxNA==",
lat: 60.40034,
lon: 25.11154
},
{
id: "U3RvcDpIU0w6OTA0MDIxMg==",
lat: 60.40166,
lon: 25.11056
},
{
id: "U3RvcDpIU0w6OTA0MDIwOQ==",
lat: 60.40329,
lon: 25.10603
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
},
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMA==",
lat: 60.40314,
lon: 25.10726
},
{
id: "U3RvcDpIU0w6OTA0MDIxMQ==",
lat: 60.40156,
lon: 25.11015
},
{
id: "U3RvcDpIU0w6OTA5MDIyOA==",
lat: 60.4003,
lon: 25.11
},
{
id: "U3RvcDpIU0w6OTA5MDIzMw==",
lat: 60.40176,
lon: 25.1191
},
{
id: "U3RvcDpIU0w6OTA1MDIzMQ==",
lat: 60.40229,
lon: 25.13579
},
{
id: "U3RvcDpIU0w6OTA1MDIzMw==",
lat: 60.40055,
lon: 25.14017
},
{
id: "U3RvcDpIU0w6OTA1MDIxNg==",
lat: 60.40003,
lon: 25.14512
},
{
id: "U3RvcDpIU0w6OTA1MDIxNA==",
lat: 60.39609,
lon: 25.14491
},
{
id: "U3RvcDpIU0w6OTA1MDIxMg==",
lat: 60.39415,
lon: 25.14529
},
{
id: "U3RvcDpIU0w6OTA1MDIxMA==",
lat: 60.39164,
lon: 25.14634
},
{
id: "U3RvcDpIU0w6OTA1MDIwOA==",
lat: 60.38884,
lon: 25.14521
},
{
id: "U3RvcDpIU0w6OTEwMDIwMA==",
lat: 60.385814,
lon: 25.145422
},
{
id: "U3RvcDpIU0w6OTIxODIwNA==",
lat: 60.383265,
lon: 25.165469
},
{
id: "U3RvcDpIU0w6OTIxNjIwNA==",
lat: 60.377218,
lon: 25.198547
},
{
id: "U3RvcDpIU0w6OTIxOTIwNQ==",
lat: 60.375226,
lon: 25.218328
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMzIwNw==",
lat: 60.37368,
lon: 25.286597
},
{
id: "U3RvcDpIU0w6OTIyMzIxMA==",
lat: 60.372358,
lon: 25.29282
},
{
id: "U3RvcDpIU0w6OTIyODIwMg==",
lat: 60.370258,
lon: 25.2979
},
{
id: "U3RvcDpIU0w6OTIyODIwNQ==",
lat: 60.36726,
lon: 25.301515
},
{
id: "U3RvcDpIU0w6OTIyMTIwMw==",
lat: 60.367635,
lon: 25.306268
},
{
id: "U3RvcDpIU0w6OTIyMTIwNA==",
lat: 60.368627,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyMTIwNQ==",
lat: 60.370042,
lon: 25.329923
},
{
id: "U3RvcDpIU0w6OTIyMTIwNg==",
lat: 60.370624,
lon: 25.337426
},
{
id: "U3RvcDpIU0w6OTIyMTIwMQ==",
lat: 60.363648,
lon: 25.365342
}
]
},
{
gtfsId: "HSL:5565",
shortName: "565",
longName: "Vantaankoski-Myyrmäki-Jupperi-Jorvi-Espoon keskus",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMTIwNA==",
lat: 60.22248,
lon: 24.67796
},
{
id: "U3RvcDpIU0w6MjYzMTIwMg==",
lat: 60.22336,
lon: 24.68962
},
{
id: "U3RvcDpIU0w6MjE1MjIyNw==",
lat: 60.2235,
lon: 24.69601
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mw==",
lat: 60.22459,
lon: 24.70664
},
{
id: "U3RvcDpIU0w6MjE1MjIyOQ==",
lat: 60.22726,
lon: 24.708
},
{
id: "U3RvcDpIU0w6MjE1MjIzMQ==",
lat: 60.22812,
lon: 24.71094
},
{
id: "U3RvcDpIU0w6MjE1MjIzMw==",
lat: 60.23013,
lon: 24.71583
},
{
id: "U3RvcDpIU0w6MjE1MjIzNQ==",
lat: 60.23214,
lon: 24.71632
},
{
id: "U3RvcDpIU0w6MjE1MjI0NQ==",
lat: 60.23402,
lon: 24.71677
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNQ==",
lat: 60.24064,
lon: 24.74186
},
{
id: "U3RvcDpIU0w6MjE0MTIwNw==",
lat: 60.24387,
lon: 24.7488
},
{
id: "U3RvcDpIU0w6MjE0MjIwOQ==",
lat: 60.24647,
lon: 24.75143
},
{
id: "U3RvcDpIU0w6MjE0MzIxMQ==",
lat: 60.2493,
lon: 24.7569
},
{
id: "U3RvcDpIU0w6MjE0MzIxNA==",
lat: 60.25059,
lon: 24.76441
},
{
id: "U3RvcDpIU0w6MjE0MzIxNg==",
lat: 60.25233,
lon: 24.76977
},
{
id: "U3RvcDpIU0w6MjE0MzIxOA==",
lat: 60.25371,
lon: 24.77507
},
{
id: "U3RvcDpIU0w6NDEwMDIxMA==",
lat: 60.25474,
lon: 24.78064
},
{
id: "U3RvcDpIU0w6NDEyMDI5MA==",
lat: 60.25438,
lon: 24.79724
},
{
id: "U3RvcDpIU0w6NDEyMDI4OA==",
lat: 60.25537,
lon: 24.80147
},
{
id: "U3RvcDpIU0w6NDEyMDIwNg==",
lat: 60.25537,
lon: 24.80804
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6NDEzMDIwNw==",
lat: 60.25561,
lon: 24.82723
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDI2Ng==",
lat: 60.260609,
lon: 24.856622
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNQ==",
lat: 60.27027,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0NQ==",
lat: 60.27746,
lon: 24.85363
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDIxOQ==",
lat: 60.28188,
lon: 24.84819
},
{
id: "U3RvcDpIU0w6NDE3MDIxNw==",
lat: 60.28175,
lon: 24.8449
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDI0MA==",
lat: 60.285613,
lon: 24.849258
},
{
id: "U3RvcDpIU0w6NDE3MDI3Nw==",
lat: 60.285325,
lon: 24.849306
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIwOA==",
lat: 60.28282,
lon: 24.84202
},
{
id: "U3RvcDpIU0w6NDE3MDIxNg==",
lat: 60.28164,
lon: 24.84497
},
{
id: "U3RvcDpIU0w6NDE3MDIxOA==",
lat: 60.28175,
lon: 24.84811
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDI0NA==",
lat: 60.27712,
lon: 24.85322
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDI2NA==",
lat: 60.260577,
lon: 24.856522
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIxMA==",
lat: 60.25875,
lon: 24.83456
},
{
id: "U3RvcDpIU0w6NDEzMDIwOA==",
lat: 60.25622,
lon: 24.82877
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNQ==",
lat: 60.25572,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDI5MQ==",
lat: 60.25508,
lon: 24.79965
},
{
id: "U3RvcDpIU0w6NDEwMDIwNw==",
lat: 60.25419,
lon: 24.79491
},
{
id: "U3RvcDpIU0w6NDEwMDIwOQ==",
lat: 60.25467,
lon: 24.7786
},
{
id: "U3RvcDpIU0w6MjE0MzIxNw==",
lat: 60.253227,
lon: 24.772518
},
{
id: "U3RvcDpIU0w6MjE0MzIxNQ==",
lat: 60.25198,
lon: 24.7679
},
{
id: "U3RvcDpIU0w6MjE0MzIxMw==",
lat: 60.25041,
lon: 24.76301
},
{
id: "U3RvcDpIU0w6MjE0MzIxMg==",
lat: 60.24895,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjE0MjIxMA==",
lat: 60.24566,
lon: 24.75026
},
{
id: "U3RvcDpIU0w6MjE0MjIwOA==",
lat: 60.24338,
lon: 24.74724
},
{
id: "U3RvcDpIU0w6MjE0MjIwNg==",
lat: 60.2414,
lon: 24.74307
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOA==",
lat: 60.23408,
lon: 24.71654
},
{
id: "U3RvcDpIU0w6MjE1MjIzNg==",
lat: 60.23194,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjE1MjIzNA==",
lat: 60.2298,
lon: 24.71542
},
{
id: "U3RvcDpIU0w6MjE1MjIzMg==",
lat: 60.228,
lon: 24.70977
},
{
id: "U3RvcDpIU0w6MjE1MjIzMA==",
lat: 60.22545,
lon: 24.7065
},
{
id: "U3RvcDpIU0w6MjE1MjIyNg==",
lat: 60.22419,
lon: 24.70554
},
{
id: "U3RvcDpIU0w6MjE1MjIyOA==",
lat: 60.22358,
lon: 24.69408
},
{
id: "U3RvcDpIU0w6MjYzMTIwMQ==",
lat: 60.22342,
lon: 24.68808
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
}
]
},
{
gtfsId: "HSL:1088",
shortName: "88",
longName: "Herttoniemi(M) - Kaitalahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTE4NQ==",
lat: 60.19483,
lon: 25.03145
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMw==",
lat: 60.18248,
lon: 25.05064
},
{
id: "U3RvcDpIU0w6MTQ5MTE1OA==",
lat: 60.181037,
lon: 25.050729
},
{
id: "U3RvcDpIU0w6MTQ5MTE1NQ==",
lat: 60.178434,
lon: 25.049872
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNw==",
lat: 60.17786,
lon: 25.04891
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOQ==",
lat: 60.17566,
lon: 25.0462
},
{
id: "U3RvcDpIU0w6MTQ5MTExMQ==",
lat: 60.174743,
lon: 25.040362
},
{
id: "U3RvcDpIU0w6MTQ5MzEwMg==",
lat: 60.17215,
lon: 25.033079
},
{
id: "U3RvcDpIU0w6MTQ5NDEwNw==",
lat: 60.168898,
lon: 25.025654
},
{
id: "U3RvcDpIU0w6MTQ5NDEwNQ==",
lat: 60.168987,
lon: 25.020211
},
{
id: "U3RvcDpIU0w6MTQ5NDEwMw==",
lat: 60.170677,
lon: 25.01994
},
{
id: "U3RvcDpIU0w6MTQ5NDE2Nw==",
lat: 60.173651,
lon: 25.021703
},
{
id: "U3RvcDpIU0w6MTQ5NDEwMg==",
lat: 60.170748,
lon: 25.02075
},
{
id: "U3RvcDpIU0w6MTQ5NDEwNA==",
lat: 60.1689,
lon: 25.020529
},
{
id: "U3RvcDpIU0w6MTQ5NDE1Nw==",
lat: 60.168892,
lon: 25.026066
},
{
id: "U3RvcDpIU0w6MTQ5MTE2Nw==",
lat: 60.172308,
lon: 25.033506
},
{
id: "U3RvcDpIU0w6MTQ5MTExMg==",
lat: 60.174846,
lon: 25.041802
},
{
id: "U3RvcDpIU0w6MTQ5MTExMA==",
lat: 60.1756,
lon: 25.04661
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOA==",
lat: 60.17786,
lon: 25.04901
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Ng==",
lat: 60.17938,
lon: 25.0509
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OA==",
lat: 60.18142,
lon: 25.05098
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNA==",
lat: 60.18299,
lon: 25.05049
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
}
]
},
{
gtfsId: "HSL:1086",
shortName: "86",
longName: "Herttoniemi(M)-Santahamina",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTUxMDEwNw==",
lat: 60.14598,
lon: 25.03965
},
{
id: "U3RvcDpIU0w6MTUxMDEwNg==",
lat: 60.15038,
lon: 25.04175
},
{
id: "U3RvcDpIU0w6MTUxMDEwNA==",
lat: 60.15213,
lon: 25.04598
},
{
id: "U3RvcDpIU0w6MTUxMDEwMg==",
lat: 60.15495,
lon: 25.04905
},
{
id: "U3RvcDpIU0w6MTQ5NTE1NQ==",
lat: 60.15924,
lon: 25.04944
},
{
id: "U3RvcDpIU0w6MTQ5NTE1Mw==",
lat: 60.16201,
lon: 25.04776
},
{
id: "U3RvcDpIU0w6MTQ5NTE1MQ==",
lat: 60.16595,
lon: 25.04883
},
{
id: "U3RvcDpIU0w6MTQ5MTEzNg==",
lat: 60.16864,
lon: 25.04855
},
{
id: "U3RvcDpIU0w6MTQ5MTEzNA==",
lat: 60.17222,
lon: 25.04957
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMg==",
lat: 60.176,
lon: 25.05177
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Ng==",
lat: 60.17938,
lon: 25.0509
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OA==",
lat: 60.18142,
lon: 25.05098
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNA==",
lat: 60.18299,
lon: 25.05049
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
},
{
id: "U3RvcDpIU0w6MTQzMTE4Mw==",
lat: 60.19472,
lon: 25.03124
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMw==",
lat: 60.18248,
lon: 25.05064
},
{
id: "U3RvcDpIU0w6MTQ5MTE1OA==",
lat: 60.181037,
lon: 25.050729
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Nw==",
lat: 60.17822,
lon: 25.05075
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMQ==",
lat: 60.17559,
lon: 25.05111
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMw==",
lat: 60.17203,
lon: 25.04925
},
{
id: "U3RvcDpIU0w6MTQ5NTE1MA==",
lat: 60.16595,
lon: 25.04848
},
{
id: "U3RvcDpIU0w6MTQ5NTE1Nw==",
lat: 60.16414,
lon: 25.04695
},
{
id: "U3RvcDpIU0w6MTQ5NTE1Mg==",
lat: 60.16151,
lon: 25.048
},
{
id: "U3RvcDpIU0w6MTQ5NTE1NA==",
lat: 60.15902,
lon: 25.04939
},
{
id: "U3RvcDpIU0w6MTUxMDEwMQ==",
lat: 60.1551,
lon: 25.04894
},
{
id: "U3RvcDpIU0w6MTUxMDEwMw==",
lat: 60.15202,
lon: 25.04565
},
{
id: "U3RvcDpIU0w6MTUxMDEwNQ==",
lat: 60.14938,
lon: 25.04102
}
]
},
{
gtfsId: "HSL:1085",
shortName: "85",
longName: "Herttoniemi(M)-Jollas",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTE4Mw==",
lat: 60.19472,
lon: 25.03124
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMw==",
lat: 60.18248,
lon: 25.05064
},
{
id: "U3RvcDpIU0w6MTQ5MTE1OA==",
lat: 60.181037,
lon: 25.050729
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Nw==",
lat: 60.17822,
lon: 25.05075
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMQ==",
lat: 60.17559,
lon: 25.05111
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMw==",
lat: 60.17203,
lon: 25.04925
},
{
id: "U3RvcDpIU0w6MTQ5NTEzNQ==",
lat: 60.16803,
lon: 25.0489
},
{
id: "U3RvcDpIU0w6MTQ5MjEzNw==",
lat: 60.16596,
lon: 25.05495
},
{
id: "U3RvcDpIU0w6MTQ5MjE0MQ==",
lat: 60.16448,
lon: 25.06189
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Mw==",
lat: 60.16404,
lon: 25.07081
},
{
id: "U3RvcDpIU0w6MTQ5MjE0NQ==",
lat: 60.16544,
lon: 25.07604
},
{
id: "U3RvcDpIU0w6MTQ5MjE1MQ==",
lat: 60.16611,
lon: 25.08049
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Nw==",
lat: 60.16808,
lon: 25.08038
},
{
id: "U3RvcDpIU0w6MTQ5MjE0OQ==",
lat: 60.17061,
lon: 25.07991
},
{
id: "U3RvcDpIU0w6MTQ5MjE0OA==",
lat: 60.16778,
lon: 25.0805
},
{
id: "U3RvcDpIU0w6MTQ5MjE1Mg==",
lat: 60.1661,
lon: 25.07956
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Ng==",
lat: 60.16546,
lon: 25.0758
},
{
id: "U3RvcDpIU0w6MTQ5MjE0NA==",
lat: 60.164,
lon: 25.06984
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Mg==",
lat: 60.16455,
lon: 25.06189
},
{
id: "U3RvcDpIU0w6MTQ5MTEzOA==",
lat: 60.16636,
lon: 25.05391
},
{
id: "U3RvcDpIU0w6MTQ5MTEzNg==",
lat: 60.16864,
lon: 25.04855
},
{
id: "U3RvcDpIU0w6MTQ5MTEzNA==",
lat: 60.17222,
lon: 25.04957
},
{
id: "U3RvcDpIU0w6MTQ5MTEzMg==",
lat: 60.176,
lon: 25.05177
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Ng==",
lat: 60.17938,
lon: 25.0509
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OA==",
lat: 60.18142,
lon: 25.05098
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNA==",
lat: 60.18299,
lon: 25.05049
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
}
]
},
{
gtfsId: "HSL:1084",
shortName: "84",
longName: "Herttoniemi(M)-Gunillankallio",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTE4OA==",
lat: 60.19499,
lon: 25.03171
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2OQ==",
lat: 60.19133,
lon: 25.03976
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMw==",
lat: 60.18248,
lon: 25.05064
},
{
id: "U3RvcDpIU0w6MTQ5MTE1OA==",
lat: 60.181037,
lon: 25.050729
},
{
id: "U3RvcDpIU0w6MTQ5MTE1NQ==",
lat: 60.178434,
lon: 25.049872
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNw==",
lat: 60.17786,
lon: 25.04891
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOQ==",
lat: 60.17566,
lon: 25.0462
},
{
id: "U3RvcDpIU0w6MTQ5MTExMQ==",
lat: 60.174743,
lon: 25.040362
},
{
id: "U3RvcDpIU0w6MTQ5MTExMw==",
lat: 60.17171,
lon: 25.04015
},
{
id: "U3RvcDpIU0w6MTQ5MTExNQ==",
lat: 60.17027,
lon: 25.04299
},
{
id: "U3RvcDpIU0w6MTQ5MTExNw==",
lat: 60.16854,
lon: 25.04599
},
{
id: "U3RvcDpIU0w6MTQ5MTExOQ==",
lat: 60.16787,
lon: 25.04265
},
{
id: "U3RvcDpIU0w6MTQ5MTE2MQ==",
lat: 60.168113,
lon: 25.037082
},
{
id: "U3RvcDpIU0w6MTQ5MTE2Mw==",
lat: 60.169383,
lon: 25.033152
},
{
id: "U3RvcDpIU0w6MTQ5MTE2NQ==",
lat: 60.171555,
lon: 25.032876
},
{
id: "U3RvcDpIU0w6MTQ5MTE2Ng==",
lat: 60.17124,
lon: 25.0326
},
{
id: "U3RvcDpIU0w6MTQ5MTE2NA==",
lat: 60.169332,
lon: 25.032906
},
{
id: "U3RvcDpIU0w6MTQ5MTE2Mg==",
lat: 60.167965,
lon: 25.036693
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMA==",
lat: 60.1679,
lon: 25.04305
},
{
id: "U3RvcDpIU0w6MTQ5MTExOA==",
lat: 60.16886,
lon: 25.04583
},
{
id: "U3RvcDpIU0w6MTQ5MTExNg==",
lat: 60.17101,
lon: 25.04185
},
{
id: "U3RvcDpIU0w6MTQ5MTE3MQ==",
lat: 60.172362,
lon: 25.039398
},
{
id: "U3RvcDpIU0w6MTQ5MTExMg==",
lat: 60.174846,
lon: 25.041802
},
{
id: "U3RvcDpIU0w6MTQ5MTExMA==",
lat: 60.1756,
lon: 25.04661
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOA==",
lat: 60.17786,
lon: 25.04901
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Ng==",
lat: 60.17938,
lon: 25.0509
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OA==",
lat: 60.18142,
lon: 25.05098
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNA==",
lat: 60.18299,
lon: 25.05049
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3MQ==",
lat: 60.18881,
lon: 25.04106
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
}
]
},
{
gtfsId: "HSL:1083",
shortName: "83",
longName: "Herttoniemi(M)-Tammisalo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ0MDEwMQ==",
lat: 60.18986,
lon: 25.04989
},
{
id: "U3RvcDpIU0w6MTQ0MDEwMw==",
lat: 60.19022,
lon: 25.05435
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNQ==",
lat: 60.19054,
lon: 25.05932
},
{
id: "U3RvcDpIU0w6MTQ0MDEwNw==",
lat: 60.19178,
lon: 25.06243
},
{
id: "U3RvcDpIU0w6MTQ0MDEwOQ==",
lat: 60.19371,
lon: 25.06513
},
{
id: "U3RvcDpIU0w6MTQzMjExMQ==",
lat: 60.1959,
lon: 25.06273
},
{
id: "U3RvcDpIU0w6MTQzMjE1NQ==",
lat: 60.19456,
lon: 25.05759
},
{
id: "U3RvcDpIU0w6MTQzMjE1MQ==",
lat: 60.19416,
lon: 25.05217
},
{
id: "U3RvcDpIU0w6MTQzMzE1Ng==",
lat: 60.19313,
lon: 25.04621
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTEwNw==",
lat: 60.19473,
lon: 25.03036
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE1Mw==",
lat: 60.19236,
lon: 25.04061
},
{
id: "U3RvcDpIU0w6MTQzNDE2NQ==",
lat: 60.1913,
lon: 25.04524
}
]
},
{
gtfsId: "HSL:1082",
shortName: "82",
longName: "Herttoniemi(M)-Roihuvuori-Itäkeskus(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTE4OQ==",
lat: 60.19516,
lon: 25.03188
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE1Mw==",
lat: 60.19236,
lon: 25.04061
},
{
id: "U3RvcDpIU0w6MTQzMzE3Mw==",
lat: 60.1931,
lon: 25.04642
},
{
id: "U3RvcDpIU0w6MTQzMjE1Nw==",
lat: 60.19536,
lon: 25.0535
},
{
id: "U3RvcDpIU0w6MTQzMjE1OQ==",
lat: 60.19806,
lon: 25.05587
},
{
id: "U3RvcDpIU0w6MTQzMjE2MQ==",
lat: 60.20088,
lon: 25.05972
},
{
id: "U3RvcDpIU0w6MTQzMjE3OA==",
lat: 60.20195,
lon: 25.06185
},
{
id: "U3RvcDpIU0w6MTQzMjE4MA==",
lat: 60.20174,
lon: 25.0658
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OA==",
lat: 60.20285,
lon: 25.07329
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mw==",
lat: 60.20466,
lon: 25.07662
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMg==",
lat: 60.20757,
lon: 25.07562
},
{
id: "U3RvcDpIU0w6MTQ1MzExMg==",
lat: 60.210165,
lon: 25.077287
},
{
id: "U3RvcDpIU0w6MTQ1MzEyOA==",
lat: 60.20956,
lon: 25.07691
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMQ==",
lat: 60.2075,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mg==",
lat: 60.20392,
lon: 25.07614
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OQ==",
lat: 60.20303,
lon: 25.07354
},
{
id: "U3RvcDpIU0w6MTQzMjE4MQ==",
lat: 60.20187,
lon: 25.0646
},
{
id: "U3RvcDpIU0w6MTQzMjE3OQ==",
lat: 60.20199,
lon: 25.0616
},
{
id: "U3RvcDpIU0w6MTQzMjE2Mg==",
lat: 60.2007,
lon: 25.05952
},
{
id: "U3RvcDpIU0w6MTQzMjE2MA==",
lat: 60.1975,
lon: 25.05482
},
{
id: "U3RvcDpIU0w6MTQzMjE1OA==",
lat: 60.19525,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQzMzE1Ng==",
lat: 60.19313,
lon: 25.04621
},
{
id: "U3RvcDpIU0w6MTQzNDE1NA==",
lat: 60.19273,
lon: 25.03804
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
}
]
},
{
gtfsId: "HSL:1081",
shortName: "81",
longName: "Kulosaari-Herttoniemi(M)-Länsi-Herttoniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQyMDEyMw==",
lat: 60.187739,
lon: 25.007994
},
{
id: "U3RvcDpIU0w6MTQyMDEyNw==",
lat: 60.185983,
lon: 25.01179
},
{
id: "U3RvcDpIU0w6MTQyMDEwOQ==",
lat: 60.1866,
lon: 25.01566
},
{
id: "U3RvcDpIU0w6MTQyMDExOQ==",
lat: 60.18839,
lon: 25.01582
},
{
id: "U3RvcDpIU0w6MTQzNDE5MA==",
lat: 60.18993,
lon: 25.02573
},
{
id: "U3RvcDpIU0w6MTQzNDE4Ng==",
lat: 60.18808,
lon: 25.02986
},
{
id: "U3RvcDpIU0w6MTQzNDE4NA==",
lat: 60.186718,
lon: 25.031206
},
{
id: "U3RvcDpIU0w6MTQzNDE4MA==",
lat: 60.187048,
lon: 25.035956
},
{
id: "U3RvcDpIU0w6MTQzNDE3OA==",
lat: 60.189238,
lon: 25.037143
},
{
id: "U3RvcDpIU0w6MTQzNDE2OA==",
lat: 60.19153,
lon: 25.03457
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTEzOQ==",
lat: 60.19542,
lon: 25.03125
},
{
id: "U3RvcDpIU0w6MTQzMTE0MQ==",
lat: 60.19795,
lon: 25.03163
},
{
id: "U3RvcDpIU0w6MTQzMTE0Mw==",
lat: 60.20234,
lon: 25.03197
},
{
id: "U3RvcDpIU0w6MTQzMTE0NQ==",
lat: 60.20462,
lon: 25.03467
},
{
id: "U3RvcDpIU0w6MTQzMTE0Nw==",
lat: 60.20579,
lon: 25.03667
},
{
id: "U3RvcDpIU0w6MTQzMTE1MA==",
lat: 60.20742,
lon: 25.03925
},
{
id: "U3RvcDpIU0w6MTQzMTEzMw==",
lat: 60.209329,
lon: 25.037957
},
{
id: "U3RvcDpIU0w6MTQzMTEzNQ==",
lat: 60.21268,
lon: 25.03878
},
{
id: "U3RvcDpIU0w6MTQzMTEzNw==",
lat: 60.21487,
lon: 25.04418
},
{
id: "U3RvcDpIU0w6MTQzMTEzOA==",
lat: 60.21504,
lon: 25.04395
},
{
id: "U3RvcDpIU0w6MTQzMTEzNg==",
lat: 60.2123,
lon: 25.03822
},
{
id: "U3RvcDpIU0w6MTQzMTEzNA==",
lat: 60.209183,
lon: 25.037994
},
{
id: "U3RvcDpIU0w6MTQzMTEwOQ==",
lat: 60.20798,
lon: 25.03966
},
{
id: "U3RvcDpIU0w6MTQzMTE0OA==",
lat: 60.20553,
lon: 25.03599
},
{
id: "U3RvcDpIU0w6MTQzMTE0Ng==",
lat: 60.20423,
lon: 25.03388
},
{
id: "U3RvcDpIU0w6MTQzMTE0NA==",
lat: 60.20156,
lon: 25.03135
},
{
id: "U3RvcDpIU0w6MTQzMTE0Mg==",
lat: 60.19926,
lon: 25.03136
},
{
id: "U3RvcDpIU0w6MTQzMTEwNA==",
lat: 60.194181,
lon: 25.030182
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2Nw==",
lat: 60.19142,
lon: 25.03411
},
{
id: "U3RvcDpIU0w6MTQzNDE3Nw==",
lat: 60.188834,
lon: 25.037202
},
{
id: "U3RvcDpIU0w6MTQzNDE3OQ==",
lat: 60.186889,
lon: 25.035663
},
{
id: "U3RvcDpIU0w6MTQzNDE4Mw==",
lat: 60.18699,
lon: 25.030746
},
{
id: "U3RvcDpIU0w6MTQzNDE4NQ==",
lat: 60.18818,
lon: 25.02984
},
{
id: "U3RvcDpIU0w6MTQzNDExNA==",
lat: 60.190465,
lon: 25.025627
},
{
id: "U3RvcDpIU0w6MTQzMTE4Ng==",
lat: 60.19132,
lon: 25.01852
},
{
id: "U3RvcDpIU0w6MTQyMDEzNg==",
lat: 60.189673,
lon: 25.013165
}
]
},
{
gtfsId: "HSL:6917BK",
shortName: "917BK",
longName: "Lappers-Hästböle",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMDAxNQ==",
lat: 60.173856,
lon: 24.107636
},
{
id: "U3RvcDpIU0w6NjMwMDAyMg==",
lat: 60.173231,
lon: 24.100927
},
{
id: "U3RvcDpIU0w6NjMwMDAxMQ==",
lat: 60.176005,
lon: 24.091042
},
{
id: "U3RvcDpIU0w6NjMwMDAxNw==",
lat: 60.176911,
lon: 24.078211
},
{
id: "U3RvcDpIU0w6NjMwMDAxOQ==",
lat: 60.176033,
lon: 24.061181
},
{
id: "U3RvcDpIU0w6NjMwMDA0NQ==",
lat: 60.178602,
lon: 24.047017
},
{
id: "U3RvcDpIU0w6NjMwMDA0Nw==",
lat: 60.169277,
lon: 24.031715
},
{
id: "U3RvcDpIU0w6NjMwMTA2Mg==",
lat: 60.153368,
lon: 24.056415
}
]
},
{
gtfsId: "HSL:2244K",
shortName: "244K",
longName: "Espoon keskus-Nupuri-Kolmperä-Siikaniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjY0MzIyOQ==",
lat: 60.2888,
lon: 24.51592
},
{
id: "U3RvcDpIU0w6MjY0MzIyOA==",
lat: 60.28964,
lon: 24.52164
},
{
id: "U3RvcDpIU0w6MjY0MzIyNg==",
lat: 60.28803,
lon: 24.52747
},
{
id: "U3RvcDpIU0w6MjY0MzIyNA==",
lat: 60.28688,
lon: 24.53132
},
{
id: "U3RvcDpIU0w6MjY0MzIyMg==",
lat: 60.28253,
lon: 24.52684
},
{
id: "U3RvcDpIU0w6MjY0MzIyMA==",
lat: 60.27895,
lon: 24.51624
},
{
id: "U3RvcDpIU0w6MjY0MzIxOA==",
lat: 60.27687,
lon: 24.51393
},
{
id: "U3RvcDpIU0w6MjY0MzIxNg==",
lat: 60.27237,
lon: 24.51821
},
{
id: "U3RvcDpIU0w6MjY0MzI3NQ==",
lat: 60.2688,
lon: 24.5288
},
{
id: "U3RvcDpIU0w6MjY0MzIzMw==",
lat: 60.2652,
lon: 24.5211
},
{
id: "U3RvcDpIU0w6MjY0MzIwNQ==",
lat: 60.26235,
lon: 24.52179
},
{
id: "U3RvcDpIU0w6MjY0MTIxOA==",
lat: 60.25249,
lon: 24.52427
},
{
id: "U3RvcDpIU0w6MjY0MTIxMg==",
lat: 60.24904,
lon: 24.53423
},
{
id: "U3RvcDpIU0w6MjY0NTIwMg==",
lat: 60.247725,
lon: 24.542425
},
{
id: "U3RvcDpIU0w6MjY0MjIxMA==",
lat: 60.24449,
lon: 24.57063
},
{
id: "U3RvcDpIU0w6MjY0MjIwOA==",
lat: 60.24355,
lon: 24.57839
},
{
id: "U3RvcDpIU0w6MjY0MjIwNg==",
lat: 60.23713,
lon: 24.5973
},
{
id: "U3RvcDpIU0w6MjY0MjIwNA==",
lat: 60.23408,
lon: 24.60218
},
{
id: "U3RvcDpIU0w6MjY0MjIwMg==",
lat: 60.23044,
lon: 24.60938
},
{
id: "U3RvcDpIU0w6MjYzNDIxNA==",
lat: 60.22535,
lon: 24.62021
},
{
id: "U3RvcDpIU0w6MjYzNDIxMg==",
lat: 60.22296,
lon: 24.62769
},
{
id: "U3RvcDpIU0w6MjYzNDIxMA==",
lat: 60.22181,
lon: 24.63336
},
{
id: "U3RvcDpIU0w6MjYzNDIwOA==",
lat: 60.22106,
lon: 24.64406
},
{
id: "U3RvcDpIU0w6MjYzMTIwNg==",
lat: 60.22154,
lon: 24.65273
},
{
id: "U3RvcDpIU0w6MjYzMzIyMg==",
lat: 60.22298,
lon: 24.66
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTIxOQ==",
lat: 60.205048,
lon: 24.65511
},
{
id: "U3RvcDpIU0w6MjYxMTI1OA==",
lat: 60.20535,
lon: 24.65686
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMzIyMA==",
lat: 60.22261,
lon: 24.65842
},
{
id: "U3RvcDpIU0w6MjYzMTIwNQ==",
lat: 60.22153,
lon: 24.65084
},
{
id: "U3RvcDpIU0w6MjYzNDIwNw==",
lat: 60.22114,
lon: 24.6424
},
{
id: "U3RvcDpIU0w6MjYzNDIwOQ==",
lat: 60.22177,
lon: 24.63425
},
{
id: "U3RvcDpIU0w6MjYzNDIxMQ==",
lat: 60.22333,
lon: 24.62652
},
{
id: "U3RvcDpIU0w6MjYzNDIxMw==",
lat: 60.22492,
lon: 24.6214
},
{
id: "U3RvcDpIU0w6MjY0MjIwMQ==",
lat: 60.23029,
lon: 24.60998
},
{
id: "U3RvcDpIU0w6MjY0MjIwMw==",
lat: 60.23468,
lon: 24.60146
},
{
id: "U3RvcDpIU0w6MjY0MjIwNQ==",
lat: 60.23769,
lon: 24.59669
},
{
id: "U3RvcDpIU0w6MjY0MjIwNw==",
lat: 60.24339,
lon: 24.57975
},
{
id: "U3RvcDpIU0w6MjY0MjIwOQ==",
lat: 60.24446,
lon: 24.56828
},
{
id: "U3RvcDpIU0w6MjY0NTIwMQ==",
lat: 60.248088,
lon: 24.540307
},
{
id: "U3RvcDpIU0w6MjY0MTIxMQ==",
lat: 60.24935,
lon: 24.53317
},
{
id: "U3RvcDpIU0w6MjY0MTIxNw==",
lat: 60.25268,
lon: 24.52441
},
{
id: "U3RvcDpIU0w6MjY0MzIwNA==",
lat: 60.26244,
lon: 24.52187
},
{
id: "U3RvcDpIU0w6MjY0MzIzNA==",
lat: 60.26547,
lon: 24.52138
},
{
id: "U3RvcDpIU0w6MjY0MzI3Ng==",
lat: 60.26869,
lon: 24.5287
},
{
id: "U3RvcDpIU0w6MjY0MzIxNQ==",
lat: 60.27268,
lon: 24.51765
},
{
id: "U3RvcDpIU0w6MjY0MzIxNw==",
lat: 60.27723,
lon: 24.5142
},
{
id: "U3RvcDpIU0w6MjY0MzIxOQ==",
lat: 60.27917,
lon: 24.51706
},
{
id: "U3RvcDpIU0w6MjY0MzIyMQ==",
lat: 60.28269,
lon: 24.52715
},
{
id: "U3RvcDpIU0w6MjY0MzIyMw==",
lat: 60.28683,
lon: 24.53186
},
{
id: "U3RvcDpIU0w6MjY0MzIyNQ==",
lat: 60.28839,
lon: 24.52685
},
{
id: "U3RvcDpIU0w6MjY0MzIyNw==",
lat: 60.28961,
lon: 24.52204
}
]
},
{
gtfsId: "HSL:2169",
shortName: "169",
longName: "Espoon keskus-Suvela",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMzIyMw==",
lat: 60.20186,
lon: 24.67518
},
{
id: "U3RvcDpIU0w6MjYxMzIxNQ==",
lat: 60.20246,
lon: 24.66925
},
{
id: "U3RvcDpIU0w6MjYxMzIwOA==",
lat: 60.203918,
lon: 24.666443
},
{
id: "U3RvcDpIU0w6MjYxMzIyMg==",
lat: 60.201941,
lon: 24.665815
},
{
id: "U3RvcDpIU0w6MjYxMzIyNA==",
lat: 60.20084,
lon: 24.670982
},
{
id: "U3RvcDpIU0w6MjYxMzIwNg==",
lat: 60.19927,
lon: 24.671148
},
{
id: "U3RvcDpIU0w6MjYxMzIwNA==",
lat: 60.197857,
lon: 24.671501
},
{
id: "U3RvcDpIU0w6MjYxMzAwMw==",
lat: 60.19794,
lon: 24.66945
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
},
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTIxMg==",
lat: 60.210619,
lon: 24.659208
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIxNA==",
lat: 60.207317,
lon: 24.654988
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTIxNg==",
lat: 60.206323,
lon: 24.653206
},
{
id: "U3RvcDpIU0w6MjYxMzIwMQ==",
lat: 60.202185,
lon: 24.653898
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMTIwOQ==",
lat: 60.204793,
lon: 24.663368
},
{
id: "U3RvcDpIU0w6MjYxMzI1Mw==",
lat: 60.20667,
lon: 24.665568
},
{
id: "U3RvcDpIU0w6MjYxMzI3MQ==",
lat: 60.20622,
lon: 24.67345
},
{
id: "U3RvcDpIU0w6MjYxMzIxNw==",
lat: 60.20508,
lon: 24.67367
},
{
id: "U3RvcDpIU0w6MjYxMzIwOQ==",
lat: 60.205402,
lon: 24.670374
}
]
},
{
gtfsId: "HSL:1079",
shortName: "79",
longName: "Herttoniemi (M)-Latokartano-Malmi-Siltamäki-Puistolan asem",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQwMjEyNg==",
lat: 60.27529,
lon: 25.03544
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mg==",
lat: 60.27697,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6MTQwMjEyMQ==",
lat: 60.27863,
lon: 25.03001
},
{
id: "U3RvcDpIU0w6MTQwMjE0NQ==",
lat: 60.27802,
lon: 25.02428
},
{
id: "U3RvcDpIU0w6MTQwMjEyNw==",
lat: 60.2787,
lon: 25.02038
},
{
id: "U3RvcDpIU0w6MTQwMTEyNQ==",
lat: 60.280803,
lon: 25.017427
},
{
id: "U3RvcDpIU0w6MTQwMTE4MA==",
lat: 60.27948,
lon: 25.00944
},
{
id: "U3RvcDpIU0w6MTQwMTExMg==",
lat: 60.27823,
lon: 25.00574
},
{
id: "U3RvcDpIU0w6MTQwMTEzNg==",
lat: 60.27982,
lon: 25.00405
},
{
id: "U3RvcDpIU0w6MTQwMTEzNQ==",
lat: 60.27953,
lon: 24.99857
},
{
id: "U3RvcDpIU0w6MTQwMTEzMw==",
lat: 60.27835,
lon: 24.99422
},
{
id: "U3RvcDpIU0w6MTQwMTEzMg==",
lat: 60.276818,
lon: 24.990048
},
{
id: "U3RvcDpIU0w6MTQwMTEwNw==",
lat: 60.27497,
lon: 24.99117
},
{
id: "U3RvcDpIU0w6MTQwMTEwNA==",
lat: 60.27209,
lon: 24.9922
},
{
id: "U3RvcDpIU0w6MTQwMzEyNw==",
lat: 60.26665,
lon: 24.99296
},
{
id: "U3RvcDpIU0w6MTM5MTE5MQ==",
lat: 60.26109,
lon: 24.99015
},
{
id: "U3RvcDpIU0w6MTM5MTEwOQ==",
lat: 60.2585,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwMg==",
lat: 60.2502,
lon: 25.00917
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MzExNA==",
lat: 60.23859,
lon: 25.02095
},
{
id: "U3RvcDpIU0w6MTM4MzExMg==",
lat: 60.23595,
lon: 25.02177
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM2MjEyNQ==",
lat: 60.2285,
lon: 25.01423
},
{
id: "U3RvcDpIU0w6MTM2MjEzMg==",
lat: 60.2306,
lon: 25.02125
},
{
id: "U3RvcDpIU0w6MTM2MjExOQ==",
lat: 60.233,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTM2MjEzMA==",
lat: 60.23052,
lon: 25.02988
},
{
id: "U3RvcDpIU0w6MTM2MjEyOA==",
lat: 60.22822,
lon: 25.02787
},
{
id: "U3RvcDpIU0w6MTM2MjExNg==",
lat: 60.22564,
lon: 25.02357
},
{
id: "U3RvcDpIU0w6MTM2MjExMw==",
lat: 60.22367,
lon: 25.02229
},
{
id: "U3RvcDpIU0w6MTQ1NDE4NA==",
lat: 60.21495,
lon: 25.04414
},
{
id: "U3RvcDpIU0w6MTQzMTEzNg==",
lat: 60.2123,
lon: 25.03822
},
{
id: "U3RvcDpIU0w6MTQzMTEzNA==",
lat: 60.209183,
lon: 25.037994
},
{
id: "U3RvcDpIU0w6MTQzMTEwOQ==",
lat: 60.20798,
lon: 25.03966
},
{
id: "U3RvcDpIU0w6MTQzMTEzMA==",
lat: 60.206214,
lon: 25.044957
},
{
id: "U3RvcDpIU0w6MTQzMzEyOA==",
lat: 60.20521,
lon: 25.04774
},
{
id: "U3RvcDpIU0w6MTQzMzEwNA==",
lat: 60.20248,
lon: 25.04501
},
{
id: "U3RvcDpIU0w6MTQzMzEwNQ==",
lat: 60.19848,
lon: 25.04089
},
{
id: "U3RvcDpIU0w6MTQzMzEwNw==",
lat: 60.19604,
lon: 25.03875
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTExMQ==",
lat: 60.19508,
lon: 25.03083
},
{
id: "U3RvcDpIU0w6MTQzMTEwOA==",
lat: 60.19547,
lon: 25.03161
},
{
id: "U3RvcDpIU0w6MTQzMzEwOA==",
lat: 60.19382,
lon: 25.03673
},
{
id: "U3RvcDpIU0w6MTQzMzEwNg==",
lat: 60.198894,
lon: 25.041099
},
{
id: "U3RvcDpIU0w6MTQzMzEwMw==",
lat: 60.202472,
lon: 25.045383
},
{
id: "U3RvcDpIU0w6MTQzMzEyNw==",
lat: 60.2052,
lon: 25.04822
},
{
id: "U3RvcDpIU0w6MTQzMTEyOQ==",
lat: 60.206496,
lon: 25.044421
},
{
id: "U3RvcDpIU0w6MTQzMTEzMQ==",
lat: 60.207053,
lon: 25.041649
},
{
id: "U3RvcDpIU0w6MTQzMTEzMw==",
lat: 60.209329,
lon: 25.037957
},
{
id: "U3RvcDpIU0w6MTQzMTEzNQ==",
lat: 60.21268,
lon: 25.03878
},
{
id: "U3RvcDpIU0w6MTQzMTEzNw==",
lat: 60.21487,
lon: 25.04418
},
{
id: "U3RvcDpIU0w6MTM2MjExOA==",
lat: 60.22445,
lon: 25.02165
},
{
id: "U3RvcDpIU0w6MTM2MjExNQ==",
lat: 60.22567,
lon: 25.02402
},
{
id: "U3RvcDpIU0w6MTM2MjEyNw==",
lat: 60.22806,
lon: 25.02792
},
{
id: "U3RvcDpIU0w6MTM2MjEyOQ==",
lat: 60.23112,
lon: 25.03053
},
{
id: "U3RvcDpIU0w6MTM2MjEzMw==",
lat: 60.23366,
lon: 25.0309
},
{
id: "U3RvcDpIU0w6MTM2MjEzMQ==",
lat: 60.23078,
lon: 25.02139
},
{
id: "U3RvcDpIU0w6MTM2MjEwNQ==",
lat: 60.22862,
lon: 25.01202
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEwOQ==",
lat: 60.232187,
lon: 25.011714
},
{
id: "U3RvcDpIU0w6MTM4MzExMQ==",
lat: 60.23676,
lon: 25.02225
},
{
id: "U3RvcDpIU0w6MTM4MjExMw==",
lat: 60.240179,
lon: 25.021039
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MTEwMw==",
lat: 60.25015,
lon: 25.00951
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEwNg==",
lat: 60.25733,
lon: 24.99789
},
{
id: "U3RvcDpIU0w6MTM5MTEwOA==",
lat: 60.25877,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM5MTE5MA==",
lat: 60.26154,
lon: 24.99091
},
{
id: "U3RvcDpIU0w6MTQwMzEyNg==",
lat: 60.2669,
lon: 24.99344
},
{
id: "U3RvcDpIU0w6MTQwMTEwMw==",
lat: 60.27145,
lon: 24.99206
},
{
id: "U3RvcDpIU0w6MTQwMTEwNQ==",
lat: 60.27532,
lon: 24.99112
},
{
id: "U3RvcDpIU0w6MTQwMTEwNg==",
lat: 60.2774,
lon: 24.9909
},
{
id: "U3RvcDpIU0w6MTQwMTEzMQ==",
lat: 60.27863,
lon: 24.99518
},
{
id: "U3RvcDpIU0w6MTQwMTEzNA==",
lat: 60.27931,
lon: 24.99788
},
{
id: "U3RvcDpIU0w6MTQwMTEyNA==",
lat: 60.27925,
lon: 25.00451
},
{
id: "U3RvcDpIU0w6MTQwMTExMQ==",
lat: 60.27818,
lon: 25.00693
},
{
id: "U3RvcDpIU0w6MTQwMTExMw==",
lat: 60.28044,
lon: 25.01124
},
{
id: "U3RvcDpIU0w6MTQwMTE1NQ==",
lat: 60.278987,
lon: 25.017328
},
{
id: "U3RvcDpIU0w6MTQwMjEyOA==",
lat: 60.27815,
lon: 25.02228
},
{
id: "U3RvcDpIU0w6MTQwMjEyMg==",
lat: 60.27838,
lon: 25.03171
},
{
id: "U3RvcDpIU0w6MTQwMjE1MA==",
lat: 60.27665,
lon: 25.03432
},
{
id: "U3RvcDpIU0w6MTQwMjEzMg==",
lat: 60.275477,
lon: 25.034827
}
]
},
{
gtfsId: "HSL:2168",
shortName: "168",
longName: "Espoon keskus-Mikkelä-Kauklahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYxMTIxMg==",
lat: 60.210619,
lon: 24.659208
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMzIwNQ==",
lat: 60.205708,
lon: 24.661453
},
{
id: "U3RvcDpIU0w6MjYxMTI3MQ==",
lat: 60.205035,
lon: 24.657695
},
{
id: "U3RvcDpIU0w6MjYxMTI3MA==",
lat: 60.20496,
lon: 24.65858
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxMzIwMQ==",
lat: 60.202185,
lon: 24.653898
},
{
id: "U3RvcDpIU0w6MjYxNTIzMA==",
lat: 60.20332,
lon: 24.65198
},
{
id: "U3RvcDpIU0w6MjYyMTIyNw==",
lat: 60.20734,
lon: 24.63928
},
{
id: "U3RvcDpIU0w6MjYyMTIyMA==",
lat: 60.208709,
lon: 24.634956
},
{
id: "U3RvcDpIU0w6MjYyMTI0OQ==",
lat: 60.207939,
lon: 24.630459
},
{
id: "U3RvcDpIU0w6MjYyMTIzNQ==",
lat: 60.20458,
lon: 24.62526
},
{
id: "U3RvcDpIU0w6MjYyMTIzMw==",
lat: 60.20401,
lon: 24.62729
},
{
id: "U3RvcDpIU0w6MjYyMTIzMg==",
lat: 60.20336,
lon: 24.62896
},
{
id: "U3RvcDpIU0w6MjYyMTIzNA==",
lat: 60.20398,
lon: 24.62708
},
{
id: "U3RvcDpIU0w6MjYyMTIzMA==",
lat: 60.20473,
lon: 24.62518
},
{
id: "U3RvcDpIU0w6MjYyMTIzNg==",
lat: 60.20782,
lon: 24.63026
},
{
id: "U3RvcDpIU0w6MjYyMTIyMQ==",
lat: 60.20858,
lon: 24.63342
},
{
id: "U3RvcDpIU0w6MjYyMTIyNQ==",
lat: 60.20841,
lon: 24.63715
},
{
id: "U3RvcDpIU0w6MjYyMTIxNg==",
lat: 60.20645,
lon: 24.63912
},
{
id: "U3RvcDpIU0w6MjYyMTIwOQ==",
lat: 60.20362,
lon: 24.63538
},
{
id: "U3RvcDpIU0w6MjYyMTIxOQ==",
lat: 60.20235,
lon: 24.63106
},
{
id: "U3RvcDpIU0w6MjYyMTIxMQ==",
lat: 60.20018,
lon: 24.62665
},
{
id: "U3RvcDpIU0w6MjUxMTIwMQ==",
lat: 60.19825,
lon: 24.62125
},
{
id: "U3RvcDpIU0w6MjUxMTI0MQ==",
lat: 60.19602,
lon: 24.61495
},
{
id: "U3RvcDpIU0w6MjUxMTIwMw==",
lat: 60.193139,
lon: 24.609917
},
{
id: "U3RvcDpIU0w6MjUxMTIwNQ==",
lat: 60.192161,
lon: 24.607148
},
{
id: "U3RvcDpIU0w6MjUxMTIxNA==",
lat: 60.19287,
lon: 24.59966
},
{
id: "U3RvcDpIU0w6MjUxMTIxOA==",
lat: 60.19031,
lon: 24.5988
},
{
id: "U3RvcDpIU0w6MjUxMTI0OA==",
lat: 60.189503,
lon: 24.598148
},
{
id: "U3RvcDpIU0w6MjUxMTIzNw==",
lat: 60.18797,
lon: 24.59555
},
{
id: "U3RvcDpIU0w6MjUxMTIzMw==",
lat: 60.18683,
lon: 24.59231
},
{
id: "U3RvcDpIU0w6MjUxMTIzOQ==",
lat: 60.186662,
lon: 24.588232
},
{
id: "U3RvcDpIU0w6MjUxMTI1Nw==",
lat: 60.18826,
lon: 24.586646
},
{
id: "U3RvcDpIU0w6MjUxMTI1MA==",
lat: 60.189087,
lon: 24.586821
},
{
id: "U3RvcDpIU0w6MjUxMTI1OQ==",
lat: 60.190534,
lon: 24.588704
},
{
id: "U3RvcDpIU0w6MjUxMTI1Mw==",
lat: 60.191797,
lon: 24.591574
},
{
id: "U3RvcDpIU0w6MjUxMTI1Mg==",
lat: 60.192879,
lon: 24.592886
},
{
id: "U3RvcDpIU0w6MjUxMTIwOA==",
lat: 60.19465,
lon: 24.59387
},
{
id: "U3RvcDpIU0w6MjUxMTIxMA==",
lat: 60.1939,
lon: 24.59782
},
{
id: "U3RvcDpIU0w6MjUxMTIxOQ==",
lat: 60.198485,
lon: 24.602397
},
{
id: "U3RvcDpIU0w6MjUxMTIyMQ==",
lat: 60.200253,
lon: 24.606007
},
{
id: "U3RvcDpIU0w6MjUxMTIyMw==",
lat: 60.202052,
lon: 24.606298
},
{
id: "U3RvcDpIU0w6MjUxMTIyNQ==",
lat: 60.201898,
lon: 24.603895
},
{
id: "U3RvcDpIU0w6MjUxMTIyNw==",
lat: 60.200237,
lon: 24.601602
},
{
id: "U3RvcDpIU0w6MjUxMTIxNQ==",
lat: 60.19744,
lon: 24.60087
},
{
id: "U3RvcDpIU0w6MjUxMTIwNw==",
lat: 60.1954,
lon: 24.60008
},
{
id: "U3RvcDpIU0w6MjUxMTIwOQ==",
lat: 60.19443,
lon: 24.59572
},
{
id: "U3RvcDpIU0w6MjUxMTI1MQ==",
lat: 60.194122,
lon: 24.59296
},
{
id: "U3RvcDpIU0w6MjUxMTI1NA==",
lat: 60.191759,
lon: 24.591303
},
{
id: "U3RvcDpIU0w6MjUxMTI2MA==",
lat: 60.191062,
lon: 24.588494
},
{
id: "U3RvcDpIU0w6MjUxMTI1OA==",
lat: 60.189538,
lon: 24.5874
},
{
id: "U3RvcDpIU0w6MjUxMTI0MA==",
lat: 60.186314,
lon: 24.589023
},
{
id: "U3RvcDpIU0w6MjUxMTIzNA==",
lat: 60.186698,
lon: 24.592018
},
{
id: "U3RvcDpIU0w6MjUxMTIzOA==",
lat: 60.18847,
lon: 24.59719
},
{
id: "U3RvcDpIU0w6MjUxMTIxNw==",
lat: 60.19126,
lon: 24.59772
},
{
id: "U3RvcDpIU0w6MjUxMTIxMw==",
lat: 60.1931,
lon: 24.59981
},
{
id: "U3RvcDpIU0w6MjUxMTIwNg==",
lat: 60.192167,
lon: 24.60752
},
{
id: "U3RvcDpIU0w6MjUxMTIwNA==",
lat: 60.193368,
lon: 24.610889
},
{
id: "U3RvcDpIU0w6MjUxMTI0Mg==",
lat: 60.19635,
lon: 24.61609
},
{
id: "U3RvcDpIU0w6MjUxMTIwMg==",
lat: 60.19834,
lon: 24.62217
},
{
id: "U3RvcDpIU0w6MjYyMTIxMg==",
lat: 60.19974,
lon: 24.62609
},
{
id: "U3RvcDpIU0w6MjYyMTIxOA==",
lat: 60.20277,
lon: 24.63325
},
{
id: "U3RvcDpIU0w6MjYyMTIxMA==",
lat: 60.20425,
lon: 24.63749
},
{
id: "U3RvcDpIU0w6MjYyMTIxNw==",
lat: 60.20649,
lon: 24.64021
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMTI0Mw==",
lat: 60.20513,
lon: 24.662109
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
}
]
},
{
gtfsId: "HSL:9978K",
shortName: "978K",
longName: "Bastukärr-Sorsakorpi-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIxODIxNg==",
lat: 60.375582,
lon: 25.152177
},
{
id: "U3RvcDpIU0w6OTIxODIwMw==",
lat: 60.383794,
lon: 25.165494
},
{
id: "U3RvcDpIU0w6OTA1MDIwNg==",
lat: 60.38642,
lon: 25.14572
},
{
id: "U3RvcDpIU0w6OTA1MDIwOQ==",
lat: 60.38965,
lon: 25.14576
},
{
id: "U3RvcDpIU0w6OTA1MDIxMQ==",
lat: 60.39214,
lon: 25.14665
},
{
id: "U3RvcDpIU0w6OTA1MDIxMw==",
lat: 60.39432,
lon: 25.14548
},
{
id: "U3RvcDpIU0w6OTA1MDIxNQ==",
lat: 60.39715,
lon: 25.14532
},
{
id: "U3RvcDpIU0w6OTA1MDIxNw==",
lat: 60.4001,
lon: 25.1452
},
{
id: "U3RvcDpIU0w6OTA1MDIzMg==",
lat: 60.40087,
lon: 25.13935
},
{
id: "U3RvcDpIU0w6OTA1MDIzNQ==",
lat: 60.4028,
lon: 25.14068
},
{
id: "U3RvcDpIU0w6OTA1MDIyNg==",
lat: 60.40598,
lon: 25.13959
},
{
id: "U3RvcDpIU0w6OTA1MDIyNw==",
lat: 60.40562,
lon: 25.13303
},
{
id: "U3RvcDpIU0w6OTA0MDIxOA==",
lat: 60.40565,
lon: 25.115
},
{
id: "U3RvcDpIU0w6OTA0MDIxNQ==",
lat: 60.40475,
lon: 25.11062
},
{
id: "U3RvcDpIU0w6OTA0MDIwOQ==",
lat: 60.40329,
lon: 25.10603
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
},
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMA==",
lat: 60.40314,
lon: 25.10726
},
{
id: "U3RvcDpIU0w6OTA0MDIxNw==",
lat: 60.405,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6OTA0MDIxOQ==",
lat: 60.4059,
lon: 25.11659
},
{
id: "U3RvcDpIU0w6OTA1MDIyOQ==",
lat: 60.40502,
lon: 25.13488
},
{
id: "U3RvcDpIU0w6OTA1MDIyNQ==",
lat: 60.40554,
lon: 25.14059
},
{
id: "U3RvcDpIU0w6OTA1MDIzNA==",
lat: 60.40252,
lon: 25.14004
},
{
id: "U3RvcDpIU0w6OTA1MDIzMw==",
lat: 60.40055,
lon: 25.14017
},
{
id: "U3RvcDpIU0w6OTA1MDIxNg==",
lat: 60.40003,
lon: 25.14512
},
{
id: "U3RvcDpIU0w6OTA1MDIxNA==",
lat: 60.39609,
lon: 25.14491
},
{
id: "U3RvcDpIU0w6OTA1MDIxMg==",
lat: 60.39415,
lon: 25.14529
},
{
id: "U3RvcDpIU0w6OTA1MDIxMA==",
lat: 60.39164,
lon: 25.14634
},
{
id: "U3RvcDpIU0w6OTA1MDIwOA==",
lat: 60.38884,
lon: 25.14521
},
{
id: "U3RvcDpIU0w6OTEwMDIwMA==",
lat: 60.385814,
lon: 25.145422
},
{
id: "U3RvcDpIU0w6OTIxODIxMg==",
lat: 60.382292,
lon: 25.160828
}
]
},
{
gtfsId: "HSL:1078",
shortName: "78",
longName: "Rautatientori-Viikki-Latokartano",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExMw==",
lat: 60.17072,
lon: 24.94324
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMg==",
lat: 60.188283,
lon: 24.963806
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDEwNQ==",
lat: 60.19842,
lon: 24.96205
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTI3MDEwNA==",
lat: 60.217158,
lon: 24.981087
},
{
id: "U3RvcDpIU0w6MTM2MTEwMw==",
lat: 60.21896,
lon: 24.98699
},
{
id: "U3RvcDpIU0w6MTM2MTEwNQ==",
lat: 60.22475,
lon: 24.99648
},
{
id: "U3RvcDpIU0w6MTM2MTEwNw==",
lat: 60.22709,
lon: 25.00447
},
{
id: "U3RvcDpIU0w6MTM2MjEzOQ==",
lat: 60.22709,
lon: 25.01242
},
{
id: "U3RvcDpIU0w6MTM2MjEzNw==",
lat: 60.22536,
lon: 25.01653
},
{
id: "U3RvcDpIU0w6MTM2MjExOA==",
lat: 60.22445,
lon: 25.02165
},
{
id: "U3RvcDpIU0w6MTM2MjExNQ==",
lat: 60.22567,
lon: 25.02402
},
{
id: "U3RvcDpIU0w6MTM2MjEyNw==",
lat: 60.22806,
lon: 25.02792
},
{
id: "U3RvcDpIU0w6MTM2MjEyOQ==",
lat: 60.23112,
lon: 25.03053
},
{
id: "U3RvcDpIU0w6MTM2MjEzMw==",
lat: 60.23366,
lon: 25.0309
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mw==",
lat: 60.23446,
lon: 25.03309
},
{
id: "U3RvcDpIU0w6MTM2MjE0NQ==",
lat: 60.23508,
lon: 25.04165
},
{
id: "U3RvcDpIU0w6MTM2MjE0Nw==",
lat: 60.234,
lon: 25.04546
},
{
id: "U3RvcDpIU0w6MTM2MjE0OQ==",
lat: 60.23241,
lon: 25.04725
},
{
id: "U3RvcDpIU0w6MTM2MjE1MQ==",
lat: 60.23057,
lon: 25.0436
},
{
id: "U3RvcDpIU0w6MTM2MjE1MA==",
lat: 60.23253,
lon: 25.04761
},
{
id: "U3RvcDpIU0w6MTM2MjE0OA==",
lat: 60.23443,
lon: 25.04458
},
{
id: "U3RvcDpIU0w6MTM2MjE0Ng==",
lat: 60.23531,
lon: 25.04045
},
{
id: "U3RvcDpIU0w6MTM2MjE0NA==",
lat: 60.23451,
lon: 25.03253
},
{
id: "U3RvcDpIU0w6MTM2MjExOQ==",
lat: 60.233,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTM2MjEzMA==",
lat: 60.23052,
lon: 25.02988
},
{
id: "U3RvcDpIU0w6MTM2MjEyOA==",
lat: 60.22822,
lon: 25.02787
},
{
id: "U3RvcDpIU0w6MTM2MjExNg==",
lat: 60.22564,
lon: 25.02357
},
{
id: "U3RvcDpIU0w6MTM2MjExMg==",
lat: 60.22423,
lon: 25.0203
},
{
id: "U3RvcDpIU0w6MTM2MjEzOA==",
lat: 60.225563,
lon: 25.016455
},
{
id: "U3RvcDpIU0w6MTM2MjE0MA==",
lat: 60.22724,
lon: 25.01184
},
{
id: "U3RvcDpIU0w6MTM2MTEwOA==",
lat: 60.22744,
lon: 25.00263
},
{
id: "U3RvcDpIU0w6MTM2MTEyMA==",
lat: 60.225478,
lon: 24.997258
},
{
id: "U3RvcDpIU0w6MTM2MTEwNg==",
lat: 60.223823,
lon: 24.995055
},
{
id: "U3RvcDpIU0w6MTM2MTEwNA==",
lat: 60.21836,
lon: 24.98539
},
{
id: "U3RvcDpIU0w6MTI3MDEwNw==",
lat: 60.21705,
lon: 24.979
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEyNw==",
lat: 60.19817,
lon: 24.96153
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:2167",
shortName: "167",
longName: "Vanttila-Kauklahti-Järvikylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjUxMjIxOQ==",
lat: 60.19935,
lon: 24.55625
},
{
id: "U3RvcDpIU0w6MjUxMjIxOA==",
lat: 60.19803,
lon: 24.56186
},
{
id: "U3RvcDpIU0w6MjUxMjIxNg==",
lat: 60.19684,
lon: 24.57175
},
{
id: "U3RvcDpIU0w6MjUxMjIxNA==",
lat: 60.19811,
lon: 24.58061
},
{
id: "U3RvcDpIU0w6MjUxMTIxMg==",
lat: 60.19554,
lon: 24.58963
},
{
id: "U3RvcDpIU0w6MjUxMTIwOA==",
lat: 60.19465,
lon: 24.59387
},
{
id: "U3RvcDpIU0w6MjUxMTIxMA==",
lat: 60.1939,
lon: 24.59782
},
{
id: "U3RvcDpIU0w6MjUxMTIxNA==",
lat: 60.19287,
lon: 24.59966
},
{
id: "U3RvcDpIU0w6MjUxMTIxOA==",
lat: 60.19031,
lon: 24.5988
},
{
id: "U3RvcDpIU0w6MjUxMTIzNg==",
lat: 60.190499,
lon: 24.601866
},
{
id: "U3RvcDpIU0w6MjUyMjIyMg==",
lat: 60.190149,
lon: 24.60779
},
{
id: "U3RvcDpIU0w6MjUyMjIxNQ==",
lat: 60.18687,
lon: 24.61042
},
{
id: "U3RvcDpIU0w6MjUyMjIwMg==",
lat: 60.185103,
lon: 24.612888
},
{
id: "U3RvcDpIU0w6MjUyMjIyNA==",
lat: 60.18613,
lon: 24.62001
},
{
id: "U3RvcDpIU0w6MjUyMjIyNg==",
lat: 60.18774,
lon: 24.62287
},
{
id: "U3RvcDpIU0w6MjUyMjIyOQ==",
lat: 60.190011,
lon: 24.621951
},
{
id: "U3RvcDpIU0w6MjUyMjIxOQ==",
lat: 60.189676,
lon: 24.618773
},
{
id: "U3RvcDpIU0w6MjUyMjIzMQ==",
lat: 60.189512,
lon: 24.611614
},
{
id: "U3RvcDpIU0w6MjUyMjIyMw==",
lat: 60.19036,
lon: 24.60782
},
{
id: "U3RvcDpIU0w6MjUxMTIzNQ==",
lat: 60.190312,
lon: 24.601027
},
{
id: "U3RvcDpIU0w6MjUxMTIxNw==",
lat: 60.19126,
lon: 24.59772
},
{
id: "U3RvcDpIU0w6MjUxMTIxMw==",
lat: 60.1931,
lon: 24.59981
},
{
id: "U3RvcDpIU0w6MjUxMTIwOQ==",
lat: 60.19443,
lon: 24.59572
},
{
id: "U3RvcDpIU0w6MjUxMTIxMQ==",
lat: 60.19485,
lon: 24.59269
},
{
id: "U3RvcDpIU0w6MjUxMTIyOQ==",
lat: 60.19617,
lon: 24.58877
},
{
id: "U3RvcDpIU0w6MjUxMjIxMw==",
lat: 60.198,
lon: 24.5793
},
{
id: "U3RvcDpIU0w6MjUxMjIxNQ==",
lat: 60.19705,
lon: 24.56971
},
{
id: "U3RvcDpIU0w6MjUxMjIxNw==",
lat: 60.19829,
lon: 24.56102
}
]
},
{
gtfsId: "HSL:4587",
shortName: "587",
longName: "Mellunmäki-Leppäkorpi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MzIyMw==",
lat: 60.23831,
lon: 25.109
},
{
id: "U3RvcDpIU0w6NDkxMDIxNw==",
lat: 60.242165,
lon: 25.108975
},
{
id: "U3RvcDpIU0w6NDkxMDIxNQ==",
lat: 60.24494,
lon: 25.11149
},
{
id: "U3RvcDpIU0w6NDkxMDIwMw==",
lat: 60.24755,
lon: 25.11225
},
{
id: "U3RvcDpIU0w6NDkxMDIwNQ==",
lat: 60.251929,
lon: 25.112495
},
{
id: "U3RvcDpIU0w6NDkzMDIxMg==",
lat: 60.25641,
lon: 25.112
},
{
id: "U3RvcDpIU0w6NDkzMDIyMQ==",
lat: 60.2583,
lon: 25.103354
},
{
id: "U3RvcDpIU0w6NDkzMDIxOQ==",
lat: 60.25927,
lon: 25.10128
},
{
id: "U3RvcDpIU0w6NDkzMDIyOQ==",
lat: 60.26043,
lon: 25.09767
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDIyNw==",
lat: 60.29097,
lon: 25.11945
},
{
id: "U3RvcDpIU0w6NDk2MDIyNQ==",
lat: 60.29152,
lon: 25.11378
},
{
id: "U3RvcDpIU0w6NDk2MDIyMw==",
lat: 60.29266,
lon: 25.1126
},
{
id: "U3RvcDpIU0w6NDk2MDIyMA==",
lat: 60.29456,
lon: 25.10822
},
{
id: "U3RvcDpIU0w6NDk2MDIwMg==",
lat: 60.29575,
lon: 25.10275
},
{
id: "U3RvcDpIU0w6NDk2MDIzNA==",
lat: 60.296906,
lon: 25.09927
},
{
id: "U3RvcDpIU0w6NDk2MDI5Ng==",
lat: 60.2938,
lon: 25.09667
},
{
id: "U3RvcDpIU0w6NDY2MDIwNQ==",
lat: 60.29378,
lon: 25.089652
},
{
id: "U3RvcDpIU0w6NDY2MDIxMQ==",
lat: 60.2948,
lon: 25.08456
},
{
id: "U3RvcDpIU0w6NDY2MDIyMw==",
lat: 60.29697,
lon: 25.08562
},
{
id: "U3RvcDpIU0w6NDY2MDIxMw==",
lat: 60.29971,
lon: 25.08719
},
{
id: "U3RvcDpIU0w6NDY2MDIxNQ==",
lat: 60.30463,
lon: 25.09342
},
{
id: "U3RvcDpIU0w6NDY2MDIyMA==",
lat: 60.30781,
lon: 25.09418
},
{
id: "U3RvcDpIU0w6NDY2MDIxNw==",
lat: 60.310227,
lon: 25.094326
},
{
id: "U3RvcDpIU0w6NDc0MDIyNQ==",
lat: 60.31448,
lon: 25.07788
},
{
id: "U3RvcDpIU0w6NDc0MDIwOQ==",
lat: 60.31549,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNw==",
lat: 60.31774,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIwMg==",
lat: 60.32423,
lon: 25.07576
},
{
id: "U3RvcDpIU0w6NDc0MDIxOQ==",
lat: 60.32487,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIzNQ==",
lat: 60.32494,
lon: 25.06439
},
{
id: "U3RvcDpIU0w6NDc0MDIxNw==",
lat: 60.32322,
lon: 25.06293
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIwMw==",
lat: 60.32995,
lon: 25.06272
},
{
id: "U3RvcDpIU0w6NDcyMDIyNA==",
lat: 60.33199,
lon: 25.06424
},
{
id: "U3RvcDpIU0w6NDcyMDIwNQ==",
lat: 60.33399,
lon: 25.06449
},
{
id: "U3RvcDpIU0w6NDcyMDIxMQ==",
lat: 60.33519,
lon: 25.06504
},
{
id: "U3RvcDpIU0w6NDcyMDIwNw==",
lat: 60.33902,
lon: 25.06971
},
{
id: "U3RvcDpIU0w6NDgxMDIzOA==",
lat: 60.34579,
lon: 25.07516
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mw==",
lat: 60.35276,
lon: 25.07843
},
{
id: "U3RvcDpIU0w6NDgzMDIyMg==",
lat: 60.35267,
lon: 25.0813
},
{
id: "U3RvcDpIU0w6NDgzMDIwNw==",
lat: 60.35331,
lon: 25.08471
},
{
id: "U3RvcDpIU0w6NDgzMDIwNQ==",
lat: 60.35501,
lon: 25.08764
},
{
id: "U3RvcDpIU0w6NDg0MDIxNg==",
lat: 60.35728,
lon: 25.09013
},
{
id: "U3RvcDpIU0w6NDg0MDIxOA==",
lat: 60.35991,
lon: 25.09024
},
{
id: "U3RvcDpIU0w6NDg0MDIwOA==",
lat: 60.36106,
lon: 25.09133
},
{
id: "U3RvcDpIU0w6NDg0MDIwNg==",
lat: 60.36194,
lon: 25.09498
},
{
id: "U3RvcDpIU0w6NDg0MDIyMw==",
lat: 60.36065,
lon: 25.09661
},
{
id: "U3RvcDpIU0w6NDg0MDIyMQ==",
lat: 60.35971,
lon: 25.09765
},
{
id: "U3RvcDpIU0w6NDg0MDIyMA==",
lat: 60.35954,
lon: 25.10494
},
{
id: "U3RvcDpIU0w6NDg0MDIxOQ==",
lat: 60.35998,
lon: 25.10439
},
{
id: "U3RvcDpIU0w6NDg0MDIwNQ==",
lat: 60.35985,
lon: 25.10057
},
{
id: "U3RvcDpIU0w6NDg0MDIyMg==",
lat: 60.36097,
lon: 25.09653
},
{
id: "U3RvcDpIU0w6NDg0MDIwNw==",
lat: 60.36226,
lon: 25.09425
},
{
id: "U3RvcDpIU0w6NDg0MDIwOQ==",
lat: 60.36134,
lon: 25.09133
},
{
id: "U3RvcDpIU0w6NDg0MDIxNw==",
lat: 60.3588,
lon: 25.0901
},
{
id: "U3RvcDpIU0w6NDg0MDIxMQ==",
lat: 60.35667,
lon: 25.09026
},
{
id: "U3RvcDpIU0w6NDgzMDIwNg==",
lat: 60.35443,
lon: 25.0863
},
{
id: "U3RvcDpIU0w6NDgzMDIyMQ==",
lat: 60.35275,
lon: 25.08161
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mg==",
lat: 60.3525,
lon: 25.07726
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDIzMQ==",
lat: 60.34492,
lon: 25.07435
},
{
id: "U3RvcDpIU0w6NDcyMDIwOA==",
lat: 60.34002,
lon: 25.06982
},
{
id: "U3RvcDpIU0w6NDcyMDIwNg==",
lat: 60.3343,
lon: 25.06437
},
{
id: "U3RvcDpIU0w6NDcyMDIwNA==",
lat: 60.33103,
lon: 25.06343
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNg==",
lat: 60.3233,
lon: 25.06344
},
{
id: "U3RvcDpIU0w6NDc0MDIxOA==",
lat: 60.32491,
lon: 25.06624
},
{
id: "U3RvcDpIU0w6NDc0MDIwMQ==",
lat: 60.32424,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNg==",
lat: 60.3177,
lon: 25.07508
},
{
id: "U3RvcDpIU0w6NDc0MDIwOA==",
lat: 60.31486,
lon: 25.07312
},
{
id: "U3RvcDpIU0w6NDc0MDIyNg==",
lat: 60.3143,
lon: 25.079
},
{
id: "U3RvcDpIU0w6NDY2MDIxOA==",
lat: 60.30876,
lon: 25.09437
},
{
id: "U3RvcDpIU0w6NDY2MDIxNg==",
lat: 60.30367,
lon: 25.09197
},
{
id: "U3RvcDpIU0w6NDY2MDIxNA==",
lat: 60.29914,
lon: 25.08635
},
{
id: "U3RvcDpIU0w6NDY2MDIyMg==",
lat: 60.29623,
lon: 25.08506
},
{
id: "U3RvcDpIU0w6NDY2MDIyMQ==",
lat: 60.29429,
lon: 25.08505
},
{
id: "U3RvcDpIU0w6NDY2MDIyOQ==",
lat: 60.293636,
lon: 25.091242
},
{
id: "U3RvcDpIU0w6NDk2MDIwOA==",
lat: 60.294405,
lon: 25.097644
},
{
id: "U3RvcDpIU0w6NDk2MDIyMQ==",
lat: 60.296912,
lon: 25.099394
},
{
id: "U3RvcDpIU0w6NDk2MDIwMQ==",
lat: 60.29577,
lon: 25.10332
},
{
id: "U3RvcDpIU0w6NDk2MDIxOQ==",
lat: 60.29418,
lon: 25.10836
},
{
id: "U3RvcDpIU0w6NDk2MDIyMg==",
lat: 60.2927,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxOA==",
lat: 60.25851,
lon: 25.10222
},
{
id: "U3RvcDpIU0w6NDkzMDIyMA==",
lat: 60.25746,
lon: 25.10541
},
{
id: "U3RvcDpIU0w6NDkzMDIxMw==",
lat: 60.25612,
lon: 25.11173
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIxOA==",
lat: 60.24234,
lon: 25.10881
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
}
]
},
{
gtfsId: "HSL:4588",
shortName: "588",
longName: "Länsisalmi-Sotungin koulu",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk0MDIwMg==",
lat: 60.2793,
lon: 25.12528
},
{
id: "U3RvcDpIU0w6NDk4MDIxNA==",
lat: 60.27794,
lon: 25.13378
},
{
id: "U3RvcDpIU0w6NDk4MDIxMg==",
lat: 60.28507,
lon: 25.13526
},
{
id: "U3RvcDpIU0w6NDk4MDIxMA==",
lat: 60.2892,
lon: 25.13926
},
{
id: "U3RvcDpIU0w6NDk4MDIxOA==",
lat: 60.29201,
lon: 25.13969
},
{
id: "U3RvcDpIU0w6NDk4MDIwOA==",
lat: 60.29297,
lon: 25.13781
},
{
id: "U3RvcDpIU0w6NDk4MDIwNg==",
lat: 60.29396,
lon: 25.13554
},
{
id: "U3RvcDpIU0w6NDk4MDIwNA==",
lat: 60.29711,
lon: 25.12958
},
{
id: "U3RvcDpIU0w6NDk4MDIwMg==",
lat: 60.29776,
lon: 25.12568
},
{
id: "U3RvcDpIU0w6NDk2MDIxMw==",
lat: 60.29795,
lon: 25.12205
},
{
id: "U3RvcDpIU0w6NDk2MDI0MQ==",
lat: 60.29773,
lon: 25.11143
},
{
id: "U3RvcDpIU0w6NDk2MDIzMA==",
lat: 60.29761,
lon: 25.10883
},
{
id: "U3RvcDpIU0w6NDk2MDIyOQ==",
lat: 60.29727,
lon: 25.10411
},
{
id: "U3RvcDpIU0w6NDk2MDIwMQ==",
lat: 60.29577,
lon: 25.10332
},
{
id: "U3RvcDpIU0w6NDk2MDIxOQ==",
lat: 60.29418,
lon: 25.10836
},
{
id: "U3RvcDpIU0w6NDk2MDIyMg==",
lat: 60.2927,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6NDk1MDIwMQ==",
lat: 60.25091,
lon: 25.08784
},
{
id: "U3RvcDpIU0w6NDk1MDIwNQ==",
lat: 60.249921,
lon: 25.096143
},
{
id: "U3RvcDpIU0w6NDk1MDIwNw==",
lat: 60.24916,
lon: 25.10035
},
{
id: "U3RvcDpIU0w6NDk1MDIwOQ==",
lat: 60.24565,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDkxMDIwMQ==",
lat: 60.24324,
lon: 25.10666
},
{
id: "U3RvcDpIU0w6NDkxMDIxNQ==",
lat: 60.24494,
lon: 25.11149
},
{
id: "U3RvcDpIU0w6NDkxMDIwMw==",
lat: 60.24755,
lon: 25.11225
},
{
id: "U3RvcDpIU0w6NDkxMDIwNQ==",
lat: 60.251929,
lon: 25.112495
},
{
id: "U3RvcDpIU0w6NDkzMDIxMg==",
lat: 60.25641,
lon: 25.112
},
{
id: "U3RvcDpIU0w6NDkzMDIzMg==",
lat: 60.257703,
lon: 25.111718
},
{
id: "U3RvcDpIU0w6NDkzMDIzNA==",
lat: 60.261951,
lon: 25.116112
},
{
id: "U3RvcDpIU0w6NDkwMDIwMQ==",
lat: 60.2549,
lon: 25.13128
},
{
id: "U3RvcDpIU0w6NDkwMDIwMw==",
lat: 60.25638,
lon: 25.14215
},
{
id: "U3RvcDpIU0w6NDkwMDIwMg==",
lat: 60.25511,
lon: 25.12982
},
{
id: "U3RvcDpIU0w6NDkzMDIzMQ==",
lat: 60.26263,
lon: 25.116406
},
{
id: "U3RvcDpIU0w6NDkzMDIxMw==",
lat: 60.25612,
lon: 25.11173
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIwMg==",
lat: 60.2434,
lon: 25.10626
},
{
id: "U3RvcDpIU0w6NDk1MDIxMA==",
lat: 60.24712,
lon: 25.10024
},
{
id: "U3RvcDpIU0w6NDk1MDIwNg==",
lat: 60.24998,
lon: 25.09979
},
{
id: "U3RvcDpIU0w6NDk1MDIwNA==",
lat: 60.250182,
lon: 25.093707
},
{
id: "U3RvcDpIU0w6NDk1MDIwMg==",
lat: 60.25108,
lon: 25.08727
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDIyNw==",
lat: 60.29097,
lon: 25.11945
},
{
id: "U3RvcDpIU0w6NDk2MDIyNQ==",
lat: 60.29152,
lon: 25.11378
},
{
id: "U3RvcDpIU0w6NDk2MDIyMw==",
lat: 60.29266,
lon: 25.1126
},
{
id: "U3RvcDpIU0w6NDk2MDIyMA==",
lat: 60.29456,
lon: 25.10822
},
{
id: "U3RvcDpIU0w6NDk2MDIwMg==",
lat: 60.29575,
lon: 25.10275
},
{
id: "U3RvcDpIU0w6NDk2MDIxOA==",
lat: 60.29722,
lon: 25.10454
},
{
id: "U3RvcDpIU0w6NDk2MDIwNg==",
lat: 60.29764,
lon: 25.11134
},
{
id: "U3RvcDpIU0w6NDk2MDIwNw==",
lat: 60.29731,
lon: 25.11392
},
{
id: "U3RvcDpIU0w6NDk2MDIxMQ==",
lat: 60.29767,
lon: 25.12152
},
{
id: "U3RvcDpIU0w6NDk4MDIwMQ==",
lat: 60.2977,
lon: 25.12546
},
{
id: "U3RvcDpIU0w6NDk4MDIwMw==",
lat: 60.297,
lon: 25.12953
},
{
id: "U3RvcDpIU0w6NDk4MDIwNQ==",
lat: 60.29406,
lon: 25.13442
},
{
id: "U3RvcDpIU0w6NDk4MDIxOQ==",
lat: 60.29327,
lon: 25.13677
},
{
id: "U3RvcDpIU0w6NDk4MDIwNw==",
lat: 60.29198,
lon: 25.13955
},
{
id: "U3RvcDpIU0w6NDk4MDIwOQ==",
lat: 60.28843,
lon: 25.13889
},
{
id: "U3RvcDpIU0w6NDk4MDIxMQ==",
lat: 60.28449,
lon: 25.13485
},
{
id: "U3RvcDpIU0w6NDk4MDIxMw==",
lat: 60.27735,
lon: 25.13335
},
{
id: "U3RvcDpIU0w6NDk0MDIwMQ==",
lat: 60.27995,
lon: 25.12467
}
]
},
{
gtfsId: "HSL:2147N",
shortName: "147N",
longName: "Kamppi-Kivenlahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI4MQ==",
lat: 60.16887,
lon: 24.93119
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQ0MjIwOA==",
lat: 60.158034,
lon: 24.705641
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNA==",
lat: 60.157017,
lon: 24.703535
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNg==",
lat: 60.153001,
lon: 24.696816
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMA==",
lat: 60.15,
lon: 24.68924
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMg==",
lat: 60.14756,
lon: 24.68237
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNA==",
lat: 60.14542,
lon: 24.67975
},
{
id: "U3RvcDpIU0w6MjQxMjI2MA==",
lat: 60.14343,
lon: 24.67543
},
{
id: "U3RvcDpIU0w6MjQxMjI1OA==",
lat: 60.13846,
lon: 24.67709
},
{
id: "U3RvcDpIU0w6MjQxMjIzNA==",
lat: 60.13805,
lon: 24.67337
},
{
id: "U3RvcDpIU0w6MjQxMjIzMg==",
lat: 60.14018,
lon: 24.6725
},
{
id: "U3RvcDpIU0w6MjQxMjIzMA==",
lat: 60.141527,
lon: 24.671379
},
{
id: "U3RvcDpIU0w6MjQxMjIyNg==",
lat: 60.142484,
lon: 24.669383
},
{
id: "U3RvcDpIU0w6MjQxMjIyNA==",
lat: 60.14102,
lon: 24.66353
},
{
id: "U3RvcDpIU0w6MjQxMjIyMg==",
lat: 60.13979,
lon: 24.65859
},
{
id: "U3RvcDpIU0w6MjQxMTI2NA==",
lat: 60.14202,
lon: 24.65681
},
{
id: "U3RvcDpIU0w6MjQxMTIyMA==",
lat: 60.1451,
lon: 24.65533
},
{
id: "U3RvcDpIU0w6MjQxMTI1MQ==",
lat: 60.14806,
lon: 24.65383
},
{
id: "U3RvcDpIU0w6MjQxMTI0OQ==",
lat: 60.14988,
lon: 24.64988
},
{
id: "U3RvcDpIU0w6MjQxMzI1Ng==",
lat: 60.150238,
lon: 24.646349
},
{
id: "U3RvcDpIU0w6MjQxMzIxNA==",
lat: 60.150238,
lon: 24.641184
},
{
id: "U3RvcDpIU0w6MjQxMzIxMg==",
lat: 60.1532,
lon: 24.63399
},
{
id: "U3RvcDpIU0w6MjQxMzIxMA==",
lat: 60.15539,
lon: 24.63183
},
{
id: "U3RvcDpIU0w6MjQxMzIwOQ==",
lat: 60.155076,
lon: 24.631288
},
{
id: "U3RvcDpIU0w6MjQxMzIxMQ==",
lat: 60.15326,
lon: 24.63371
},
{
id: "U3RvcDpIU0w6MjQxMzIxMw==",
lat: 60.15006,
lon: 24.64119
},
{
id: "U3RvcDpIU0w6MjQxMzI1Nw==",
lat: 60.15027,
lon: 24.64639
},
{
id: "U3RvcDpIU0w6MjQxMTI1MA==",
lat: 60.14945,
lon: 24.65039
},
{
id: "U3RvcDpIU0w6MjQxMTI1Mg==",
lat: 60.14746,
lon: 24.65465
},
{
id: "U3RvcDpIU0w6MjQxNDIxOQ==",
lat: 60.14549,
lon: 24.65467
},
{
id: "U3RvcDpIU0w6MjQxNDI2NQ==",
lat: 60.14119,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjQxMjIyMQ==",
lat: 60.13965,
lon: 24.65853
},
{
id: "U3RvcDpIU0w6MjQxMjIyMw==",
lat: 60.14108,
lon: 24.66475
},
{
id: "U3RvcDpIU0w6MjQxMjIyNQ==",
lat: 60.14215,
lon: 24.66883
},
{
id: "U3RvcDpIU0w6MjQxMjIyOQ==",
lat: 60.141393,
lon: 24.67125
},
{
id: "U3RvcDpIU0w6MjQxMjIzMQ==",
lat: 60.13993,
lon: 24.67253
},
{
id: "U3RvcDpIU0w6MjQxMjIzMw==",
lat: 60.13789,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjQxMjI1OQ==",
lat: 60.13867,
lon: 24.67729
},
{
id: "U3RvcDpIU0w6MjQ0MzIxNQ==",
lat: 60.14522,
lon: 24.67967
},
{
id: "U3RvcDpIU0w6MjQ0MzIxMw==",
lat: 60.14759,
lon: 24.68258
},
{
id: "U3RvcDpIU0w6MjQ0MjIxMQ==",
lat: 60.151014,
lon: 24.692223
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNw==",
lat: 60.153542,
lon: 24.698029
},
{
id: "U3RvcDpIU0w6MjQ0MjIwNQ==",
lat: 60.157168,
lon: 24.704114
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMg==",
lat: 60.159978,
lon: 24.708063
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:2349B",
shortName: "349B",
longName: "Lepsämänjoki-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTIxMg==",
lat: 60.305,
lon: 24.74149
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMzIyOQ==",
lat: 60.31776,
lon: 24.71642
},
{
id: "U3RvcDpIU0w6MjcyMzIxMQ==",
lat: 60.32229,
lon: 24.71755
},
{
id: "U3RvcDpIU0w6MjcyMzIzMQ==",
lat: 60.323319,
lon: 24.7162
},
{
id: "U3RvcDpIU0w6MjcyMzIzMw==",
lat: 60.32928,
lon: 24.71024
},
{
id: "U3RvcDpIU0w6MjcyMzIzNQ==",
lat: 60.33417,
lon: 24.71006
},
{
id: "U3RvcDpIU0w6MjcyMzIzNw==",
lat: 60.33689,
lon: 24.71032
},
{
id: "U3RvcDpIU0w6MjcyMzI3Ng==",
lat: 60.34047,
lon: 24.70653
},
{
id: "U3RvcDpIU0w6MjcyMzI3Mw==",
lat: 60.34273,
lon: 24.70409
},
{
id: "U3RvcDpIU0w6MjcyMzI3MQ==",
lat: 60.34615,
lon: 24.70234
},
{
id: "U3RvcDpIU0w6MjcyMzI2MQ==",
lat: 60.34888,
lon: 24.69919
},
{
id: "U3RvcDpIU0w6MjcyMzI0Ng==",
lat: 60.35487,
lon: 24.69083
},
{
id: "U3RvcDpIU0w6MjcyMzI4MA==",
lat: 60.35762,
lon: 24.672833
},
{
id: "U3RvcDpIU0w6MjcyMzI4Mg==",
lat: 60.35718,
lon: 24.68554
},
{
id: "U3RvcDpIU0w6MjcyMzI3Mg==",
lat: 60.35454,
lon: 24.69139
},
{
id: "U3RvcDpIU0w6MjcyMzI2Mg==",
lat: 60.3486,
lon: 24.69945
},
{
id: "U3RvcDpIU0w6MjcyMzI3NA==",
lat: 60.34616,
lon: 24.70221
},
{
id: "U3RvcDpIU0w6MjcyMzI3NQ==",
lat: 60.3427,
lon: 24.70397
},
{
id: "U3RvcDpIU0w6MjcyMzI3OQ==",
lat: 60.34035,
lon: 24.70672
},
{
id: "U3RvcDpIU0w6MjcyMzIzOA==",
lat: 60.3368,
lon: 24.71016
},
{
id: "U3RvcDpIU0w6MjcyMzIzNg==",
lat: 60.33429,
lon: 24.70989
},
{
id: "U3RvcDpIU0w6MjcyMzIzNA==",
lat: 60.32961,
lon: 24.70996
},
{
id: "U3RvcDpIU0w6MjcyMzIzMg==",
lat: 60.324161,
lon: 24.714759
},
{
id: "U3RvcDpIU0w6MjcyMzIxMA==",
lat: 60.321463,
lon: 24.717534
},
{
id: "U3RvcDpIU0w6MjcyMzIzMA==",
lat: 60.31757,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIxMw==",
lat: 60.30444,
lon: 24.74096
}
]
},
{
gtfsId: "HSL:6909K",
shortName: "909K",
longName: "Veikkola-Lapinkylä-Kauhala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE0MDIyMQ==",
lat: 60.213307,
lon: 24.485165
},
{
id: "U3RvcDpIU0w6NjE0MDIyNw==",
lat: 60.21922,
lon: 24.474345
},
{
id: "U3RvcDpIU0w6NjE0MDIzNw==",
lat: 60.224522,
lon: 24.461307
},
{
id: "U3RvcDpIU0w6NjE0MDIzNQ==",
lat: 60.22338,
lon: 24.451053
},
{
id: "U3RvcDpIU0w6NjE0MDIzMw==",
lat: 60.222272,
lon: 24.446038
},
{
id: "U3RvcDpIU0w6NjE0MDIyOA==",
lat: 60.220593,
lon: 24.43757
},
{
id: "U3RvcDpIU0w6NjE0MDIyNQ==",
lat: 60.217792,
lon: 24.427582
},
{
id: "U3RvcDpIU0w6NjE0MDIyMg==",
lat: 60.214732,
lon: 24.423875
},
{
id: "U3RvcDpIU0w6NjE0MDIxOA==",
lat: 60.210465,
lon: 24.424472
},
{
id: "U3RvcDpIU0w6NjE0MDIxNA==",
lat: 60.205447,
lon: 24.418357
},
{
id: "U3RvcDpIU0w6NjE0MDIwNw==",
lat: 60.202955,
lon: 24.404218
},
{
id: "U3RvcDpIU0w6NjE1MDIyMw==",
lat: 60.202485,
lon: 24.392585
},
{
id: "U3RvcDpIU0w6NjE1MDIyMg==",
lat: 60.202258,
lon: 24.374953
},
{
id: "U3RvcDpIU0w6NjE1MDIyMQ==",
lat: 60.20219,
lon: 24.35642
},
{
id: "U3RvcDpIU0w6NjE1MDIxNw==",
lat: 60.20141,
lon: 24.342
},
{
id: "U3RvcDpIU0w6NjE1MDIxNg==",
lat: 60.20103,
lon: 24.33853
},
{
id: "U3RvcDpIU0w6NjE1MDIyNQ==",
lat: 60.212742,
lon: 24.341698
},
{
id: "U3RvcDpIU0w6NjE1MDIyNg==",
lat: 60.216378,
lon: 24.345947
},
{
id: "U3RvcDpIU0w6NjE1MDIyOA==",
lat: 60.220365,
lon: 24.357035
},
{
id: "U3RvcDpIU0w6NjE1MDI0MA==",
lat: 60.221885,
lon: 24.362633
},
{
id: "U3RvcDpIU0w6NjE1MDIzMA==",
lat: 60.225655,
lon: 24.369032
},
{
id: "U3RvcDpIU0w6NjE1MDI0MQ==",
lat: 60.225717,
lon: 24.376338
},
{
id: "U3RvcDpIU0w6NjE1MDIzMg==",
lat: 60.226347,
lon: 24.37974
},
{
id: "U3RvcDpIU0w6NjEzMDIwMg==",
lat: 60.227418,
lon: 24.387623
},
{
id: "U3RvcDpIU0w6NjEzMDIwNA==",
lat: 60.228745,
lon: 24.388292
},
{
id: "U3RvcDpIU0w6NjEzMDIzMA==",
lat: 60.2333,
lon: 24.3919
},
{
id: "U3RvcDpIU0w6NjEzMDIyNA==",
lat: 60.233922,
lon: 24.399915
},
{
id: "U3RvcDpIU0w6NjEzMDIwNw==",
lat: 60.23575,
lon: 24.39796
},
{
id: "U3RvcDpIU0w6NjEzMDIwOA==",
lat: 60.238312,
lon: 24.395777
},
{
id: "U3RvcDpIU0w6NjEzMDIyNg==",
lat: 60.240357,
lon: 24.38128
},
{
id: "U3RvcDpIU0w6NjEzMDIxMQ==",
lat: 60.240567,
lon: 24.377775
},
{
id: "U3RvcDpIU0w6NjEzMDIxMw==",
lat: 60.243057,
lon: 24.377593
},
{
id: "U3RvcDpIU0w6NjEzMDIxNA==",
lat: 60.246205,
lon: 24.38223
},
{
id: "U3RvcDpIU0w6NjEzMDIxOA==",
lat: 60.252639,
lon: 24.3897
},
{
id: "U3RvcDpIU0w6NjEzMDIyMg==",
lat: 60.254055,
lon: 24.395457
},
{
id: "U3RvcDpIU0w6NjEzMDIyOA==",
lat: 60.25181,
lon: 24.402213
},
{
id: "U3RvcDpIU0w6NjEzMDIxNw==",
lat: 60.250195,
lon: 24.403348
},
{
id: "U3RvcDpIU0w6NjEzMDIxOQ==",
lat: 60.252602,
lon: 24.41368
},
{
id: "U3RvcDpIU0w6NjEyMDIyMQ==",
lat: 60.257858,
lon: 24.431903
},
{
id: "U3RvcDpIU0w6NjEyMDIwMg==",
lat: 60.25979,
lon: 24.432345
},
{
id: "U3RvcDpIU0w6NjE3MDIwNg==",
lat: 60.269694,
lon: 24.444329
},
{
id: "U3RvcDpIU0w6NjE3MDIwNw==",
lat: 60.27008,
lon: 24.443606
},
{
id: "U3RvcDpIU0w6NjE3MDI1Ng==",
lat: 60.269183,
lon: 24.439668
},
{
id: "U3RvcDpIU0w6NjEyMDIwMQ==",
lat: 60.259133,
lon: 24.432048
},
{
id: "U3RvcDpIU0w6NjEyMDIyMA==",
lat: 60.257151,
lon: 24.430902
},
{
id: "U3RvcDpIU0w6NjEzMDIyMQ==",
lat: 60.253238,
lon: 24.41394
},
{
id: "U3RvcDpIU0w6NjEzMDIxNg==",
lat: 60.250457,
lon: 24.404192
},
{
id: "U3RvcDpIU0w6NjEzMDIzMg==",
lat: 60.251832,
lon: 24.402355
},
{
id: "U3RvcDpIU0w6NjEzMDIyMw==",
lat: 60.254182,
lon: 24.395288
},
{
id: "U3RvcDpIU0w6NjEzMDIyMA==",
lat: 60.252648,
lon: 24.389433
},
{
id: "U3RvcDpIU0w6NjEzMDIxNQ==",
lat: 60.246065,
lon: 24.381863
},
{
id: "U3RvcDpIU0w6NjEzMDIxMg==",
lat: 60.243068,
lon: 24.37739
},
{
id: "U3RvcDpIU0w6NjEzMDIxMA==",
lat: 60.240475,
lon: 24.377232
},
{
id: "U3RvcDpIU0w6NjEzMDIzMQ==",
lat: 60.240348,
lon: 24.382908
},
{
id: "U3RvcDpIU0w6NjEzMDIwOQ==",
lat: 60.238818,
lon: 24.394375
},
{
id: "U3RvcDpIU0w6NjEzMDIwNg==",
lat: 60.23469,
lon: 24.39721
},
{
id: "U3RvcDpIU0w6NjEzMDIyOQ==",
lat: 60.233227,
lon: 24.39171
},
{
id: "U3RvcDpIU0w6NjEzMDIwNQ==",
lat: 60.22879,
lon: 24.388057
},
{
id: "U3RvcDpIU0w6NjEzMDIwMw==",
lat: 60.227233,
lon: 24.38722
},
{
id: "U3RvcDpIU0w6NjEzMDIwMQ==",
lat: 60.226572,
lon: 24.380312
},
{
id: "U3RvcDpIU0w6NjE1MDIzOQ==",
lat: 60.225725,
lon: 24.37596
},
{
id: "U3RvcDpIU0w6NjE1MDIzMQ==",
lat: 60.225908,
lon: 24.369537
},
{
id: "U3RvcDpIU0w6NjE1MDIzNw==",
lat: 60.222042,
lon: 24.36192
},
{
id: "U3RvcDpIU0w6NjE1MDIyOQ==",
lat: 60.220405,
lon: 24.356558
},
{
id: "U3RvcDpIU0w6NjE1MDIyNw==",
lat: 60.21642,
lon: 24.345717
},
{
id: "U3RvcDpIU0w6NjE1MDIyNA==",
lat: 60.211693,
lon: 24.341255
},
{
id: "U3RvcDpIU0w6NjE1MDIxNQ==",
lat: 60.200862,
lon: 24.338385
},
{
id: "U3RvcDpIU0w6NjE1MDIxNA==",
lat: 60.200958,
lon: 24.340765
},
{
id: "U3RvcDpIU0w6NjE1MDIxOQ==",
lat: 60.202282,
lon: 24.358088
},
{
id: "U3RvcDpIU0w6NjE1MDIzNg==",
lat: 60.202072,
lon: 24.376857
},
{
id: "U3RvcDpIU0w6NjE1MDIyMA==",
lat: 60.20238,
lon: 24.394094
},
{
id: "U3RvcDpIU0w6NjE0MDIwNg==",
lat: 60.20307,
lon: 24.40629
},
{
id: "U3RvcDpIU0w6NjE0MDIxMw==",
lat: 60.205567,
lon: 24.420224
},
{
id: "U3RvcDpIU0w6NjE0MDIxOQ==",
lat: 60.21153,
lon: 24.424558
},
{
id: "U3RvcDpIU0w6NjE0MDIyMw==",
lat: 60.215762,
lon: 24.42415
},
{
id: "U3RvcDpIU0w6NjE0MDIyNA==",
lat: 60.218112,
lon: 24.429767
},
{
id: "U3RvcDpIU0w6NjE0MDIyOQ==",
lat: 60.221122,
lon: 24.439463
},
{
id: "U3RvcDpIU0w6NjE0MDIzMg==",
lat: 60.221632,
lon: 24.444954
},
{
id: "U3RvcDpIU0w6NjE0MDIzNA==",
lat: 60.223211,
lon: 24.452488
},
{
id: "U3RvcDpIU0w6NjE0MDIzNg==",
lat: 60.223972,
lon: 24.45995
},
{
id: "U3RvcDpIU0w6NjE0MDIzOA==",
lat: 60.224747,
lon: 24.464838
},
{
id: "U3RvcDpIU0w6NjE0MDIyNg==",
lat: 60.218712,
lon: 24.474507
},
{
id: "U3RvcDpIU0w6NjE0MDIyMA==",
lat: 60.21376,
lon: 24.484233
}
]
},
{
gtfsId: "HSL:1701",
shortName: "701",
longName: "Viikki-Pihlajamäki-Malmi-Suutarila-Siltamäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM2MjEwMQ==",
lat: 60.232398,
lon: 25.035738
},
{
id: "U3RvcDpIU0w6MTM2MjE0NA==",
lat: 60.23451,
lon: 25.03253
},
{
id: "U3RvcDpIU0w6MTM2MjExOQ==",
lat: 60.233,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTM2MjEzMA==",
lat: 60.23052,
lon: 25.02988
},
{
id: "U3RvcDpIU0w6MTM2MjEzMQ==",
lat: 60.23078,
lon: 25.02139
},
{
id: "U3RvcDpIU0w6MTM2MjEwOA==",
lat: 60.22768,
lon: 25.01111
},
{
id: "U3RvcDpIU0w6MTM2MTEwOA==",
lat: 60.22744,
lon: 25.00263
},
{
id: "U3RvcDpIU0w6MTM2MTEyMA==",
lat: 60.225478,
lon: 24.997258
},
{
id: "U3RvcDpIU0w6MTM2MTEwNg==",
lat: 60.223823,
lon: 24.995055
},
{
id: "U3RvcDpIU0w6MTM2MTExNQ==",
lat: 60.22507,
lon: 24.99407
},
{
id: "U3RvcDpIU0w6MTM2MTExNw==",
lat: 60.22757,
lon: 24.99957
},
{
id: "U3RvcDpIU0w6MTM4MzExOQ==",
lat: 60.22944,
lon: 25.0006
},
{
id: "U3RvcDpIU0w6MTM4MzE5Mg==",
lat: 60.233412,
lon: 24.997172
},
{
id: "U3RvcDpIU0w6MTM4NjEwMA==",
lat: 60.231738,
lon: 25.000287
},
{
id: "U3RvcDpIU0w6MTM4MzEzNQ==",
lat: 60.23112,
lon: 25.00417
},
{
id: "U3RvcDpIU0w6MTM4MzE3OQ==",
lat: 60.23017,
lon: 25.00861
},
{
id: "U3RvcDpIU0w6MTM4MzEwNw==",
lat: 60.23092,
lon: 25.01018
},
{
id: "U3RvcDpIU0w6MTM4MzEyNA==",
lat: 60.23317,
lon: 25.01162
},
{
id: "U3RvcDpIU0w6MTM4MzEyNg==",
lat: 60.23436,
lon: 25.010234
},
{
id: "U3RvcDpIU0w6MTM4MzExNw==",
lat: 60.236923,
lon: 25.002798
},
{
id: "U3RvcDpIU0w6MTM4MzEyMA==",
lat: 60.235035,
lon: 25.002602
},
{
id: "U3RvcDpIU0w6MTM4MzExOA==",
lat: 60.23685,
lon: 25.002575
},
{
id: "U3RvcDpIU0w6MTM4MzEwMA==",
lat: 60.235524,
lon: 25.010897
},
{
id: "U3RvcDpIU0w6MTM4MzEwMw==",
lat: 60.237582,
lon: 25.00916
},
{
id: "U3RvcDpIU0w6MTM4MzEwNQ==",
lat: 60.234625,
lon: 25.014551
},
{
id: "U3RvcDpIU0w6MTM4MzExMw==",
lat: 60.237275,
lon: 25.018725
},
{
id: "U3RvcDpIU0w6MTM4MzExNg==",
lat: 60.239169,
lon: 25.018953
},
{
id: "U3RvcDpIU0w6MTM4MjExMw==",
lat: 60.240179,
lon: 25.021039
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MjE2OQ==",
lat: 60.24882,
lon: 25.01278
},
{
id: "U3RvcDpIU0w6MTM4MjE2NA==",
lat: 60.250635,
lon: 25.012082
},
{
id: "U3RvcDpIU0w6MTM4MjE3MA==",
lat: 60.24865,
lon: 25.01101
},
{
id: "U3RvcDpIU0w6MTM4MjEzMw==",
lat: 60.250684,
lon: 25.009103
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM4MTEyNA==",
lat: 60.253848,
lon: 25.000627
},
{
id: "U3RvcDpIU0w6MTM5MTEwNg==",
lat: 60.25733,
lon: 24.99789
},
{
id: "U3RvcDpIU0w6MTM5MTEwOA==",
lat: 60.25877,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM5MTE5MA==",
lat: 60.26154,
lon: 24.99091
},
{
id: "U3RvcDpIU0w6MTQwMzEyNg==",
lat: 60.2669,
lon: 24.99344
},
{
id: "U3RvcDpIU0w6MTQwMzEyOA==",
lat: 60.26765,
lon: 24.99661
},
{
id: "U3RvcDpIU0w6MTQwMzEzMA==",
lat: 60.26832,
lon: 25.00157
},
{
id: "U3RvcDpIU0w6MTQwMzE3MQ==",
lat: 60.26855,
lon: 25.00607
},
{
id: "U3RvcDpIU0w6MTQwMzE2Ng==",
lat: 60.26941,
lon: 25.00959
},
{
id: "U3RvcDpIU0w6MTQwMzE2Nw==",
lat: 60.27149,
lon: 25.00543
},
{
id: "U3RvcDpIU0w6MTQwMzE2OQ==",
lat: 60.27504,
lon: 25.0013
},
{
id: "U3RvcDpIU0w6MTQwMTExMQ==",
lat: 60.27818,
lon: 25.00693
},
{
id: "U3RvcDpIU0w6MTQwMTExMw==",
lat: 60.28044,
lon: 25.01124
},
{
id: "U3RvcDpIU0w6MTQwMTExNQ==",
lat: 60.282497,
lon: 25.001177
},
{
id: "U3RvcDpIU0w6MTQwMTEzNQ==",
lat: 60.27953,
lon: 24.99857
},
{
id: "U3RvcDpIU0w6MTQwMTEzMw==",
lat: 60.27835,
lon: 24.99422
},
{
id: "U3RvcDpIU0w6MTQwMTEzMg==",
lat: 60.276818,
lon: 24.990048
},
{
id: "U3RvcDpIU0w6MTQwMTEwNw==",
lat: 60.27497,
lon: 24.99117
},
{
id: "U3RvcDpIU0w6MTQwMTE1Ng==",
lat: 60.275363,
lon: 24.99604
},
{
id: "U3RvcDpIU0w6MTQwMTExNw==",
lat: 60.274739,
lon: 24.9919
},
{
id: "U3RvcDpIU0w6MTQwMTE0NQ==",
lat: 60.274517,
lon: 24.990394
},
{
id: "U3RvcDpIU0w6MTQwMTE1MQ==",
lat: 60.273883,
lon: 24.986218
},
{
id: "U3RvcDpIU0w6MTQwMTEwNQ==",
lat: 60.27532,
lon: 24.99112
},
{
id: "U3RvcDpIU0w6MTQwMTEwNg==",
lat: 60.2774,
lon: 24.9909
},
{
id: "U3RvcDpIU0w6MTQwMTEzMQ==",
lat: 60.27863,
lon: 24.99518
},
{
id: "U3RvcDpIU0w6MTQwMTEzNA==",
lat: 60.27931,
lon: 24.99788
},
{
id: "U3RvcDpIU0w6MTQwMTE4MA==",
lat: 60.27948,
lon: 25.00944
},
{
id: "U3RvcDpIU0w6MTQwMTExOQ==",
lat: 60.27763,
lon: 25.0053
},
{
id: "U3RvcDpIU0w6MTQwMzE3MA==",
lat: 60.27426,
lon: 25.00182
},
{
id: "U3RvcDpIU0w6MTQwMzE2OA==",
lat: 60.27189,
lon: 25.00451
},
{
id: "U3RvcDpIU0w6MTQwMzEzMw==",
lat: 60.26892,
lon: 25.00956
},
{
id: "U3RvcDpIU0w6MTQwMzE3Mg==",
lat: 60.26859,
lon: 25.00582
},
{
id: "U3RvcDpIU0w6MTQwMzEzMQ==",
lat: 60.26821,
lon: 25.00048
},
{
id: "U3RvcDpIU0w6MTQwMzEyOQ==",
lat: 60.267496,
lon: 24.995374
},
{
id: "U3RvcDpIU0w6MTQwMzEyNw==",
lat: 60.26665,
lon: 24.99296
},
{
id: "U3RvcDpIU0w6MTM5MTE5MQ==",
lat: 60.26109,
lon: 24.99015
},
{
id: "U3RvcDpIU0w6MTM5MTEwOQ==",
lat: 60.2585,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwNg==",
lat: 60.25027,
lon: 25.0093
},
{
id: "U3RvcDpIU0w6MTM4MjE4OA==",
lat: 60.25018,
lon: 25.01265
},
{
id: "U3RvcDpIU0w6MTM4MjE4NQ==",
lat: 60.24996,
lon: 25.01192
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MzExNQ==",
lat: 60.239347,
lon: 25.019102
},
{
id: "U3RvcDpIU0w6MTM4MzEwNg==",
lat: 60.237071,
lon: 25.01858
},
{
id: "U3RvcDpIU0w6MTM4MzEwNA==",
lat: 60.23482,
lon: 25.014985
},
{
id: "U3RvcDpIU0w6MTM4MzEyNw==",
lat: 60.23419,
lon: 25.01042
},
{
id: "U3RvcDpIU0w6MTM4MzEwOA==",
lat: 60.232351,
lon: 25.011485
},
{
id: "U3RvcDpIU0w6MTM4MzEzNA==",
lat: 60.230748,
lon: 25.004888
},
{
id: "U3RvcDpIU0w6MTM4NjEwMQ==",
lat: 60.231462,
lon: 25.000737
},
{
id: "U3RvcDpIU0w6MTM4MzE1OQ==",
lat: 60.22954,
lon: 25.00021
},
{
id: "U3RvcDpIU0w6MTM2MTExNg==",
lat: 60.22742,
lon: 24.99892
},
{
id: "U3RvcDpIU0w6MTM2MTExNA==",
lat: 60.22495,
lon: 24.99355
},
{
id: "U3RvcDpIU0w6MTM2MTExMg==",
lat: 60.223924,
lon: 24.991016
},
{
id: "U3RvcDpIU0w6MTM2MTEwNQ==",
lat: 60.22475,
lon: 24.99648
},
{
id: "U3RvcDpIU0w6MTM2MTEwNw==",
lat: 60.22709,
lon: 25.00447
},
{
id: "U3RvcDpIU0w6MTM2MjEwNw==",
lat: 60.22769,
lon: 25.01156
},
{
id: "U3RvcDpIU0w6MTM2MjEyNQ==",
lat: 60.2285,
lon: 25.01423
},
{
id: "U3RvcDpIU0w6MTM2MjEzMg==",
lat: 60.2306,
lon: 25.02125
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mw==",
lat: 60.23446,
lon: 25.03309
}
]
},
{
gtfsId: "HSL:6908K",
shortName: "908K",
longName: "Kirkkonummi-Evitskog-Kylmälä-Veikkola-Kaislampi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE3MDIzNw==",
lat: 60.288313,
lon: 24.470031
},
{
id: "U3RvcDpIU0w6NjE3MDI2OQ==",
lat: 60.292491,
lon: 24.453375
},
{
id: "U3RvcDpIU0w6NjE3MDI2Ng==",
lat: 60.289289,
lon: 24.445075
},
{
id: "U3RvcDpIU0w6NjE3MDI2NA==",
lat: 60.285963,
lon: 24.442213
},
{
id: "U3RvcDpIU0w6NjE3MDIzNA==",
lat: 60.283833,
lon: 24.432166
},
{
id: "U3RvcDpIU0w6NjE3MDI0NQ==",
lat: 60.285907,
lon: 24.423974
},
{
id: "U3RvcDpIU0w6NjE3MDI0Mw==",
lat: 60.28293,
lon: 24.420906
},
{
id: "U3RvcDpIU0w6NjE3MDI2Mg==",
lat: 60.279897,
lon: 24.415517
},
{
id: "U3RvcDpIU0w6NjE3MDIxMg==",
lat: 60.276707,
lon: 24.416505
},
{
id: "U3RvcDpIU0w6NjE3MDIxMA==",
lat: 60.273982,
lon: 24.422243
},
{
id: "U3RvcDpIU0w6NjE3MDIwOA==",
lat: 60.272485,
lon: 24.427072
},
{
id: "U3RvcDpIU0w6NjE3MDIyOA==",
lat: 60.27056,
lon: 24.439
},
{
id: "U3RvcDpIU0w6NjE3MDIwNg==",
lat: 60.269694,
lon: 24.444329
},
{
id: "U3RvcDpIU0w6NjE3MDIwNw==",
lat: 60.27008,
lon: 24.443606
},
{
id: "U3RvcDpIU0w6NjE3MDI1Ng==",
lat: 60.269183,
lon: 24.439668
},
{
id: "U3RvcDpIU0w6NjEyMDIwMQ==",
lat: 60.259133,
lon: 24.432048
},
{
id: "U3RvcDpIU0w6NjEyMDIyMA==",
lat: 60.257151,
lon: 24.430902
},
{
id: "U3RvcDpIU0w6NjEzMDIyMQ==",
lat: 60.253238,
lon: 24.41394
},
{
id: "U3RvcDpIU0w6NjEzMDIxNg==",
lat: 60.250457,
lon: 24.404192
},
{
id: "U3RvcDpIU0w6NjEzMDIzMg==",
lat: 60.251832,
lon: 24.402355
},
{
id: "U3RvcDpIU0w6NjEzMDIyMw==",
lat: 60.254182,
lon: 24.395288
},
{
id: "U3RvcDpIU0w6NjEzMDIyMA==",
lat: 60.252648,
lon: 24.389433
},
{
id: "U3RvcDpIU0w6NjEzMDIxNQ==",
lat: 60.246065,
lon: 24.381863
},
{
id: "U3RvcDpIU0w6NjEzMDIxMg==",
lat: 60.243068,
lon: 24.37739
},
{
id: "U3RvcDpIU0w6NjEzMDIxMA==",
lat: 60.240475,
lon: 24.377232
},
{
id: "U3RvcDpIU0w6NjEzMDIzMQ==",
lat: 60.240348,
lon: 24.382908
},
{
id: "U3RvcDpIU0w6NjEzMDIwOQ==",
lat: 60.238818,
lon: 24.394375
},
{
id: "U3RvcDpIU0w6NjEzMDIyNA==",
lat: 60.233922,
lon: 24.399915
},
{
id: "U3RvcDpIU0w6NjEzMDIwNg==",
lat: 60.23469,
lon: 24.39721
},
{
id: "U3RvcDpIU0w6NjEzMDIyOQ==",
lat: 60.233227,
lon: 24.39171
},
{
id: "U3RvcDpIU0w6NjEzMDIwNQ==",
lat: 60.22879,
lon: 24.388057
},
{
id: "U3RvcDpIU0w6NjEzMDIwMw==",
lat: 60.227233,
lon: 24.38722
},
{
id: "U3RvcDpIU0w6NjEzMDIwMQ==",
lat: 60.226572,
lon: 24.380312
},
{
id: "U3RvcDpIU0w6NjE1MDIzOQ==",
lat: 60.225725,
lon: 24.37596
},
{
id: "U3RvcDpIU0w6NjE1MDIzMQ==",
lat: 60.225908,
lon: 24.369537
},
{
id: "U3RvcDpIU0w6NjE1MDIzNw==",
lat: 60.222042,
lon: 24.36192
},
{
id: "U3RvcDpIU0w6NjE1MDIyOQ==",
lat: 60.220405,
lon: 24.356558
},
{
id: "U3RvcDpIU0w6NjE1MDIyNw==",
lat: 60.21642,
lon: 24.345717
},
{
id: "U3RvcDpIU0w6NjE1MDIyNA==",
lat: 60.211693,
lon: 24.341255
},
{
id: "U3RvcDpIU0w6NjE1MDIxNQ==",
lat: 60.200862,
lon: 24.338385
},
{
id: "U3RvcDpIU0w6NjE1MDIxNA==",
lat: 60.200958,
lon: 24.340765
},
{
id: "U3RvcDpIU0w6NjE1MDIxOQ==",
lat: 60.202282,
lon: 24.358088
},
{
id: "U3RvcDpIU0w6NjE1MDIxOA==",
lat: 60.201517,
lon: 24.375928
},
{
id: "U3RvcDpIU0w6NjE1MDIxMg==",
lat: 60.19921,
lon: 24.37971
},
{
id: "U3RvcDpIU0w6NjE2MDIwMw==",
lat: 60.196608,
lon: 24.384945
},
{
id: "U3RvcDpIU0w6NjE2MDIyOA==",
lat: 60.190898,
lon: 24.394518
},
{
id: "U3RvcDpIU0w6NjE2MDIyNg==",
lat: 60.188902,
lon: 24.395963
},
{
id: "U3RvcDpIU0w6NjE2MDIyMQ==",
lat: 60.187848,
lon: 24.395802
},
{
id: "U3RvcDpIU0w6NjE2MDIxNg==",
lat: 60.182777,
lon: 24.391645
},
{
id: "U3RvcDpIU0w6NjE2MDIxMw==",
lat: 60.173892,
lon: 24.39646
},
{
id: "U3RvcDpIU0w6NjE2MDIxMg==",
lat: 60.170603,
lon: 24.395889
},
{
id: "U3RvcDpIU0w6NjE2MDIwOQ==",
lat: 60.163052,
lon: 24.394647
},
{
id: "U3RvcDpIU0w6NjE2MDIwNw==",
lat: 60.155722,
lon: 24.399178
},
{
id: "U3RvcDpIU0w6NjE2MDIwNQ==",
lat: 60.150224,
lon: 24.409713
},
{
id: "U3RvcDpIU0w6NjA0MDI1OQ==",
lat: 60.146813,
lon: 24.41485
},
{
id: "U3RvcDpIU0w6NjA0MDI1Mg==",
lat: 60.140684,
lon: 24.420613
},
{
id: "U3RvcDpIU0w6NjA0MDI0OA==",
lat: 60.136687,
lon: 24.421177
},
{
id: "U3RvcDpIU0w6NjA0MDI0NA==",
lat: 60.133633,
lon: 24.429907
},
{
id: "U3RvcDpIU0w6NjA0MDI0Ng==",
lat: 60.134168,
lon: 24.44247
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI5MA==",
lat: 60.120115,
lon: 24.441534
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI0Nw==",
lat: 60.13445,
lon: 24.44258
},
{
id: "U3RvcDpIU0w6NjA0MDI0NQ==",
lat: 60.1336,
lon: 24.42814
},
{
id: "U3RvcDpIU0w6NjA0MDI0OQ==",
lat: 60.136717,
lon: 24.421545
},
{
id: "U3RvcDpIU0w6NjA0MDI1Mw==",
lat: 60.140893,
lon: 24.420647
},
{
id: "U3RvcDpIU0w6NjA0MDI1Ng==",
lat: 60.145755,
lon: 24.416028
},
{
id: "U3RvcDpIU0w6NjE2MDIwNg==",
lat: 60.151462,
lon: 24.409557
},
{
id: "U3RvcDpIU0w6NjE2MDIwOA==",
lat: 60.15624,
lon: 24.39875
},
{
id: "U3RvcDpIU0w6NjE2MDIxMA==",
lat: 60.163665,
lon: 24.39487
},
{
id: "U3RvcDpIU0w6NjE2MDIxMQ==",
lat: 60.170695,
lon: 24.396358
},
{
id: "U3RvcDpIU0w6NjE2MDIxNA==",
lat: 60.174283,
lon: 24.39658
},
{
id: "U3RvcDpIU0w6NjE2MDIxNw==",
lat: 60.18374,
lon: 24.392752
},
{
id: "U3RvcDpIU0w6NjE2MDIyMA==",
lat: 60.188759,
lon: 24.396284
},
{
id: "U3RvcDpIU0w6NjE2MDIwNA==",
lat: 60.197392,
lon: 24.384462
},
{
id: "U3RvcDpIU0w6NjE1MDIxMQ==",
lat: 60.19985,
lon: 24.378615
},
{
id: "U3RvcDpIU0w6NjE1MDIyMg==",
lat: 60.202258,
lon: 24.374953
},
{
id: "U3RvcDpIU0w6NjE1MDIyMQ==",
lat: 60.20219,
lon: 24.35642
},
{
id: "U3RvcDpIU0w6NjE1MDIxNw==",
lat: 60.20141,
lon: 24.342
},
{
id: "U3RvcDpIU0w6NjE1MDIxNg==",
lat: 60.20103,
lon: 24.33853
},
{
id: "U3RvcDpIU0w6NjE1MDIyNQ==",
lat: 60.212742,
lon: 24.341698
},
{
id: "U3RvcDpIU0w6NjE1MDIyNg==",
lat: 60.216378,
lon: 24.345947
},
{
id: "U3RvcDpIU0w6NjE1MDIyOA==",
lat: 60.220365,
lon: 24.357035
},
{
id: "U3RvcDpIU0w6NjE1MDI0MA==",
lat: 60.221885,
lon: 24.362633
},
{
id: "U3RvcDpIU0w6NjE1MDIzMA==",
lat: 60.225655,
lon: 24.369032
},
{
id: "U3RvcDpIU0w6NjE1MDI0MQ==",
lat: 60.225717,
lon: 24.376338
},
{
id: "U3RvcDpIU0w6NjE1MDIzMg==",
lat: 60.226347,
lon: 24.37974
},
{
id: "U3RvcDpIU0w6NjEzMDIwMg==",
lat: 60.227418,
lon: 24.387623
},
{
id: "U3RvcDpIU0w6NjEzMDIwNA==",
lat: 60.228745,
lon: 24.388292
},
{
id: "U3RvcDpIU0w6NjEzMDIzMA==",
lat: 60.2333,
lon: 24.3919
},
{
id: "U3RvcDpIU0w6NjEzMDIwNw==",
lat: 60.23575,
lon: 24.39796
},
{
id: "U3RvcDpIU0w6NjEzMDIwOA==",
lat: 60.238312,
lon: 24.395777
},
{
id: "U3RvcDpIU0w6NjEzMDIyNg==",
lat: 60.240357,
lon: 24.38128
},
{
id: "U3RvcDpIU0w6NjEzMDIxMQ==",
lat: 60.240567,
lon: 24.377775
},
{
id: "U3RvcDpIU0w6NjEzMDIxMw==",
lat: 60.243057,
lon: 24.377593
},
{
id: "U3RvcDpIU0w6NjEzMDIxNA==",
lat: 60.246205,
lon: 24.38223
},
{
id: "U3RvcDpIU0w6NjEzMDIxOA==",
lat: 60.252639,
lon: 24.3897
},
{
id: "U3RvcDpIU0w6NjEzMDIyMg==",
lat: 60.254055,
lon: 24.395457
},
{
id: "U3RvcDpIU0w6NjEzMDIyOA==",
lat: 60.25181,
lon: 24.402213
},
{
id: "U3RvcDpIU0w6NjEzMDIxNw==",
lat: 60.250195,
lon: 24.403348
},
{
id: "U3RvcDpIU0w6NjEzMDIxOQ==",
lat: 60.252602,
lon: 24.41368
},
{
id: "U3RvcDpIU0w6NjEyMDIyMQ==",
lat: 60.257858,
lon: 24.431903
},
{
id: "U3RvcDpIU0w6NjEyMDIwMg==",
lat: 60.25979,
lon: 24.432345
},
{
id: "U3RvcDpIU0w6NjE3MDIyNw==",
lat: 60.271035,
lon: 24.437315
},
{
id: "U3RvcDpIU0w6NjE3MDIwOQ==",
lat: 60.272774,
lon: 24.426463
},
{
id: "U3RvcDpIU0w6NjE3MDIxMQ==",
lat: 60.274747,
lon: 24.421215
},
{
id: "U3RvcDpIU0w6NjE3MDI3NQ==",
lat: 60.280038,
lon: 24.415989
},
{
id: "U3RvcDpIU0w6NjE3MDI3Nw==",
lat: 60.283003,
lon: 24.421107
},
{
id: "U3RvcDpIU0w6NjE3MDI3Mg==",
lat: 60.286008,
lon: 24.425179
},
{
id: "U3RvcDpIU0w6NjE3MDIzMw==",
lat: 60.28374,
lon: 24.432553
},
{
id: "U3RvcDpIU0w6NjE3MDI2Mw==",
lat: 60.286152,
lon: 24.44264
},
{
id: "U3RvcDpIU0w6NjE3MDI3OQ==",
lat: 60.289078,
lon: 24.445167
},
{
id: "U3RvcDpIU0w6NjE3MDI0OA==",
lat: 60.292442,
lon: 24.453521
}
]
},
{
gtfsId: "HSL:4731N",
shortName: "731N",
longName: "Rautatientori-Kulomäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExNQ==",
lat: 60.17141,
lon: 24.94266
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIyNQ==",
lat: 60.27255,
lon: 25.09256
},
{
id: "U3RvcDpIU0w6NDkzMDIzMA==",
lat: 60.27502,
lon: 25.09521
},
{
id: "U3RvcDpIU0w6NDk0MDIyMg==",
lat: 60.28128,
lon: 25.102
},
{
id: "U3RvcDpIU0w6NDk2MDIxNA==",
lat: 60.2883,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6NDk2MDI5OA==",
lat: 60.293118,
lon: 25.099951
},
{
id: "U3RvcDpIU0w6NDk2MDIxNg==",
lat: 60.2979,
lon: 25.10244
},
{
id: "U3RvcDpIU0w6NDk3MDI5Nw==",
lat: 60.30293,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6NDk3MDIxNw==",
lat: 60.30573,
lon: 25.10498
},
{
id: "U3RvcDpIU0w6NDk3MDIxOQ==",
lat: 60.31407,
lon: 25.10985
},
{
id: "U3RvcDpIU0w6NDk3MDIyMQ==",
lat: 60.31937,
lon: 25.11534
},
{
id: "U3RvcDpIU0w6OTIxNDIwMQ==",
lat: 60.327397,
lon: 25.12172
},
{
id: "U3RvcDpIU0w6OTIxNDIwMw==",
lat: 60.337124,
lon: 25.125071
},
{
id: "U3RvcDpIU0w6NDg2MDI0OQ==",
lat: 60.34036,
lon: 25.12565
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMQ==",
lat: 60.34501,
lon: 25.11781
},
{
id: "U3RvcDpIU0w6NDgyMDIxOA==",
lat: 60.34362,
lon: 25.10246
},
{
id: "U3RvcDpIU0w6NDgyMDIyNQ==",
lat: 60.34225,
lon: 25.1052
},
{
id: "U3RvcDpIU0w6NDgyMDIyMw==",
lat: 60.34043,
lon: 25.1051
},
{
id: "U3RvcDpIU0w6NDgyMDIxMA==",
lat: 60.33979,
lon: 25.10148
},
{
id: "U3RvcDpIU0w6NDgyMDIwOA==",
lat: 60.34133,
lon: 25.09714
},
{
id: "U3RvcDpIU0w6NDgyMDIwNA==",
lat: 60.34338,
lon: 25.09789
},
{
id: "U3RvcDpIU0w6NDgyMDIwNg==",
lat: 60.34513,
lon: 25.09491
},
{
id: "U3RvcDpIU0w6NDgzMDIwMQ==",
lat: 60.3453,
lon: 25.08927
},
{
id: "U3RvcDpIU0w6NDgzMDIwMw==",
lat: 60.34701,
lon: 25.08337
},
{
id: "U3RvcDpIU0w6NDgzMDIxOQ==",
lat: 60.35056,
lon: 25.08474
},
{
id: "U3RvcDpIU0w6NDgzMDIwNw==",
lat: 60.35331,
lon: 25.08471
},
{
id: "U3RvcDpIU0w6NDgzMDIwNQ==",
lat: 60.35501,
lon: 25.08764
},
{
id: "U3RvcDpIU0w6NDg0MDIxNg==",
lat: 60.35728,
lon: 25.09013
},
{
id: "U3RvcDpIU0w6NDg0MDIxNA==",
lat: 60.358662,
lon: 25.086221
},
{
id: "U3RvcDpIU0w6NDgxMDIzNg==",
lat: 60.359299,
lon: 25.079697
},
{
id: "U3RvcDpIU0w6NDgxMDIzNA==",
lat: 60.35686,
lon: 25.078553
},
{
id: "U3RvcDpIU0w6NDgxMDI5NA==",
lat: 60.354391,
lon: 25.078477
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mg==",
lat: 60.3525,
lon: 25.07726
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMw==",
lat: 60.35029,
lon: 25.07671
},
{
id: "U3RvcDpIU0w6NDgxMDIxMA==",
lat: 60.35169,
lon: 25.06696
},
{
id: "U3RvcDpIU0w6NDgxMDIyNA==",
lat: 60.34788,
lon: 25.06706
},
{
id: "U3RvcDpIU0w6NDgxMDIxMg==",
lat: 60.34533,
lon: 25.06672
},
{
id: "U3RvcDpIU0w6NDgxMDIxNA==",
lat: 60.34454,
lon: 25.06311
},
{
id: "U3RvcDpIU0w6NDgxMDIxNg==",
lat: 60.346583,
lon: 25.057448
},
{
id: "U3RvcDpIU0w6NDgxMDIxNw==",
lat: 60.34571,
lon: 25.05606
},
{
id: "U3RvcDpIU0w6NDgxMDIxNQ==",
lat: 60.34441,
lon: 25.06396
},
{
id: "U3RvcDpIU0w6NDgxMDIxMw==",
lat: 60.34548,
lon: 25.06682
},
{
id: "U3RvcDpIU0w6NDgxMDIyMw==",
lat: 60.34757,
lon: 25.06725
},
{
id: "U3RvcDpIU0w6NDgxMDIxMQ==",
lat: 60.35058,
lon: 25.06713
},
{
id: "U3RvcDpIU0w6NDgxMDIzMA==",
lat: 60.35022,
lon: 25.07653
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI5NQ==",
lat: 60.354427,
lon: 25.078612
},
{
id: "U3RvcDpIU0w6NDgxMDIzMw==",
lat: 60.357699,
lon: 25.079007
},
{
id: "U3RvcDpIU0w6NDgxMDIzNw==",
lat: 60.359454,
lon: 25.081307
},
{
id: "U3RvcDpIU0w6NDg0MDIxMw==",
lat: 60.35858,
lon: 25.085945
},
{
id: "U3RvcDpIU0w6NDg0MDIxMQ==",
lat: 60.35667,
lon: 25.09026
},
{
id: "U3RvcDpIU0w6NDgzMDIwNg==",
lat: 60.35443,
lon: 25.0863
},
{
id: "U3RvcDpIU0w6NDgzMDIyMA==",
lat: 60.35017,
lon: 25.08447
},
{
id: "U3RvcDpIU0w6NDgzMDI5OA==",
lat: 60.34554,
lon: 25.08651
},
{
id: "U3RvcDpIU0w6NDgzMDIwMg==",
lat: 60.34514,
lon: 25.09151
},
{
id: "U3RvcDpIU0w6NDgyMDIwMw==",
lat: 60.34321,
lon: 25.09762
},
{
id: "U3RvcDpIU0w6NDgyMDIwNQ==",
lat: 60.34113,
lon: 25.09689
},
{
id: "U3RvcDpIU0w6NDgyMDIxNA==",
lat: 60.33971,
lon: 25.10071
},
{
id: "U3RvcDpIU0w6NDgyMDIyMg==",
lat: 60.33964,
lon: 25.10486
},
{
id: "U3RvcDpIU0w6NDgyMDIyNA==",
lat: 60.34237,
lon: 25.10535
},
{
id: "U3RvcDpIU0w6NDgyMDIxOQ==",
lat: 60.34357,
lon: 25.10374
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDIwOA==",
lat: 60.34618,
lon: 25.12936
},
{
id: "U3RvcDpIU0w6NDg2MDIxNQ==",
lat: 60.34614,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6OTIxNDIwNA==",
lat: 60.33975,
lon: 25.12525
},
{
id: "U3RvcDpIU0w6NDg2MDI0MA==",
lat: 60.33591,
lon: 25.12451
},
{
id: "U3RvcDpIU0w6OTIxNDIwMg==",
lat: 60.327533,
lon: 25.121072
},
{
id: "U3RvcDpIU0w6NDk3MDIyMg==",
lat: 60.31916,
lon: 25.11493
},
{
id: "U3RvcDpIU0w6NDk3MDIyMA==",
lat: 60.31307,
lon: 25.10852
},
{
id: "U3RvcDpIU0w6NDk3MDIxOA==",
lat: 60.304039,
lon: 25.104318
},
{
id: "U3RvcDpIU0w6NDk3MDI5Ng==",
lat: 60.30183,
lon: 25.10375
},
{
id: "U3RvcDpIU0w6NDk2MDIxNw==",
lat: 60.29775,
lon: 25.10205
},
{
id: "U3RvcDpIU0w6NDk2MDI5OQ==",
lat: 60.292049,
lon: 25.099393
},
{
id: "U3RvcDpIU0w6NDk2MDIxNQ==",
lat: 60.28741,
lon: 25.10189
},
{
id: "U3RvcDpIU0w6NDk0MDIyMw==",
lat: 60.2806,
lon: 25.10108
},
{
id: "U3RvcDpIU0w6NDkzMDIyNg==",
lat: 60.27535,
lon: 25.09522
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:7455A",
shortName: "455A",
longName: "Kamppi-Keimola-Luhtaanmäki (-Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NTAwMDIyOQ==",
lat: 60.363695,
lon: 24.783214
},
{
id: "U3RvcDpIU0w6NDMxMDIxNQ==",
lat: 60.35648,
lon: 24.79697
},
{
id: "U3RvcDpIU0w6NDMxMDIxMw==",
lat: 60.354738,
lon: 24.805117
},
{
id: "U3RvcDpIU0w6NDIyMDIwMg==",
lat: 60.313429,
lon: 24.840766
},
{
id: "U3RvcDpIU0w6NDE4MDIyMQ==",
lat: 60.288826,
lon: 24.861242
},
{
id: "U3RvcDpIU0w6NDE4MDIxOQ==",
lat: 60.28404,
lon: 24.86467
},
{
id: "U3RvcDpIU0w6NDE4MDIxNw==",
lat: 60.2782,
lon: 24.86844
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
}
]
},
{
gtfsId: "HSL:1704",
shortName: "704",
longName: "Malmi-Sepänmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM4MjE3Ng==",
lat: 60.25049,
lon: 25.01236
},
{
id: "U3RvcDpIU0w6MTM4MjE2OA==",
lat: 60.25127,
lon: 25.01796
},
{
id: "U3RvcDpIU0w6MTM4MjEzOQ==",
lat: 60.25005,
lon: 25.02018
},
{
id: "U3RvcDpIU0w6MTM4MjE4Nw==",
lat: 60.25091,
lon: 25.02557
},
{
id: "U3RvcDpIU0w6MTM4MjE3NQ==",
lat: 60.24988,
lon: 25.02981
},
{
id: "U3RvcDpIU0w6MTM4MjE3OQ==",
lat: 60.2469,
lon: 25.03371
},
{
id: "U3RvcDpIU0w6MTM4MjE3Mw==",
lat: 60.24484,
lon: 25.03503
},
{
id: "U3RvcDpIU0w6MTM4NTE3Mg==",
lat: 60.24514,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTM4NTE3OA==",
lat: 60.247106,
lon: 25.033843
},
{
id: "U3RvcDpIU0w6MTM4NTE3NA==",
lat: 60.249379,
lon: 25.031947
},
{
id: "U3RvcDpIU0w6MTM4MjE4Ng==",
lat: 60.25097,
lon: 25.02561
},
{
id: "U3RvcDpIU0w6MTM4MjE0MA==",
lat: 60.25008,
lon: 25.01998
},
{
id: "U3RvcDpIU0w6MTM4MjE2Nw==",
lat: 60.251471,
lon: 25.017874
},
{
id: "U3RvcDpIU0w6MTM4MjE2Ng==",
lat: 60.2526,
lon: 25.01394
},
{
id: "U3RvcDpIU0w6MTM4MjE2Mw==",
lat: 60.25152,
lon: 25.01215
}
]
},
{
gtfsId: "HSL:2348K",
shortName: "348K",
longName: "Rinnekoti-Lahnus-Hännikäinen-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyNDI1NQ==",
lat: 60.35713,
lon: 24.65236
},
{
id: "U3RvcDpIU0w6MjcyNDI1NA==",
lat: 60.35373,
lon: 24.65554
},
{
id: "U3RvcDpIU0w6MjcyNDI1Mw==",
lat: 60.351,
lon: 24.65632
},
{
id: "U3RvcDpIU0w6MjcyNDI1Mg==",
lat: 60.34884,
lon: 24.65696
},
{
id: "U3RvcDpIU0w6MjcyNDIwMg==",
lat: 60.34658,
lon: 24.65489
},
{
id: "U3RvcDpIU0w6MjcyNDI1MQ==",
lat: 60.34397,
lon: 24.654
},
{
id: "U3RvcDpIU0w6MjcyNDIwOA==",
lat: 60.33845,
lon: 24.65381
},
{
id: "U3RvcDpIU0w6MjcyNDI1Nw==",
lat: 60.32917,
lon: 24.64737
},
{
id: "U3RvcDpIU0w6MjcyNTIyNA==",
lat: 60.32614,
lon: 24.64792
},
{
id: "U3RvcDpIU0w6MjcyNTIyMg==",
lat: 60.32546,
lon: 24.66288
},
{
id: "U3RvcDpIU0w6MjcyMjIyMA==",
lat: 60.3231,
lon: 24.67743
},
{
id: "U3RvcDpIU0w6MjcyMjIxOA==",
lat: 60.31928,
lon: 24.69631
},
{
id: "U3RvcDpIU0w6MjcyMjIxNg==",
lat: 60.31804,
lon: 24.70547
},
{
id: "U3RvcDpIU0w6MjcyMjIwMQ==",
lat: 60.317037,
lon: 24.71352
},
{
id: "U3RvcDpIU0w6MjcyMzIyOQ==",
lat: 60.31776,
lon: 24.71642
},
{
id: "U3RvcDpIU0w6MjcyMzIxMQ==",
lat: 60.32229,
lon: 24.71755
},
{
id: "U3RvcDpIU0w6MjcyMzIzMQ==",
lat: 60.323319,
lon: 24.7162
},
{
id: "U3RvcDpIU0w6MjcyMzIzMw==",
lat: 60.32928,
lon: 24.71024
},
{
id: "U3RvcDpIU0w6MjcyMzIzNQ==",
lat: 60.33417,
lon: 24.71006
},
{
id: "U3RvcDpIU0w6MjcyMzIzNw==",
lat: 60.33689,
lon: 24.71032
},
{
id: "U3RvcDpIU0w6MjcyMzIzOQ==",
lat: 60.34191,
lon: 24.71348
},
{
id: "U3RvcDpIU0w6MjcyMzI0MQ==",
lat: 60.3446,
lon: 24.72721
},
{
id: "U3RvcDpIU0w6MjcyMzI0Mw==",
lat: 60.34598,
lon: 24.7317
},
{
id: "U3RvcDpIU0w6MjcyMzI0NA==",
lat: 60.34567,
lon: 24.73115
},
{
id: "U3RvcDpIU0w6MjcyMzI0Mg==",
lat: 60.34457,
lon: 24.72664
},
{
id: "U3RvcDpIU0w6MjcyMzI0MA==",
lat: 60.34214,
lon: 24.71353
},
{
id: "U3RvcDpIU0w6MjcyMzIzOA==",
lat: 60.3368,
lon: 24.71016
},
{
id: "U3RvcDpIU0w6MjcyMzIzNg==",
lat: 60.33429,
lon: 24.70989
},
{
id: "U3RvcDpIU0w6MjcyMzIzNA==",
lat: 60.32961,
lon: 24.70996
},
{
id: "U3RvcDpIU0w6MjcyMzIzMg==",
lat: 60.324161,
lon: 24.714759
},
{
id: "U3RvcDpIU0w6MjcyMzIxMA==",
lat: 60.321463,
lon: 24.717534
},
{
id: "U3RvcDpIU0w6MjcyMzIzMA==",
lat: 60.31757,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIxMw==",
lat: 60.30444,
lon: 24.74096
},
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTIxMg==",
lat: 60.305,
lon: 24.74149
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMjIxMw==",
lat: 60.31699,
lon: 24.71427
},
{
id: "U3RvcDpIU0w6MjcyMjIxNQ==",
lat: 60.31825,
lon: 24.70452
},
{
id: "U3RvcDpIU0w6MjcyMjIxNw==",
lat: 60.31969,
lon: 24.69525
},
{
id: "U3RvcDpIU0w6MjcyMjIxOQ==",
lat: 60.32298,
lon: 24.6786
},
{
id: "U3RvcDpIU0w6MjcyNTIyMQ==",
lat: 60.32553,
lon: 24.66102
},
{
id: "U3RvcDpIU0w6MjcyNDI1MA==",
lat: 60.32773,
lon: 24.64748
},
{
id: "U3RvcDpIU0w6MjcyNDIwOQ==",
lat: 60.3389,
lon: 24.654
},
{
id: "U3RvcDpIU0w6MjcyNDI3MA==",
lat: 60.34483,
lon: 24.65421
},
{
id: "U3RvcDpIU0w6MjcyNDIwMQ==",
lat: 60.34655,
lon: 24.65505
},
{
id: "U3RvcDpIU0w6MjcyNDI3OQ==",
lat: 60.34895,
lon: 24.65709
},
{
id: "U3RvcDpIU0w6MjcyNDI4MA==",
lat: 60.35094,
lon: 24.65659
},
{
id: "U3RvcDpIU0w6MjcyNDI4MQ==",
lat: 60.35401,
lon: 24.65549
},
{
id: "U3RvcDpIU0w6MjcyNDI4Mw==",
lat: 60.35596,
lon: 24.65378
},
{
id: "U3RvcDpIU0w6MjcyNDI4NQ==",
lat: 60.35751,
lon: 24.65231
}
]
},
{
gtfsId: "HSL:1702",
shortName: "702",
longName: "Jakomäki-Puistola-Malmi-Tapaninvainio-Savela",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQxNDE5MQ==",
lat: 60.260503,
lon: 25.074245
},
{
id: "U3RvcDpIU0w6MTQxNDEzNg==",
lat: 60.261686,
lon: 25.075141
},
{
id: "U3RvcDpIU0w6MTQxNDEwMg==",
lat: 60.265905,
lon: 25.079641
},
{
id: "U3RvcDpIU0w6MTQxMjEzMA==",
lat: 60.26363,
lon: 25.06959
},
{
id: "U3RvcDpIU0w6MTQxMjEzMg==",
lat: 60.26757,
lon: 25.0718
},
{
id: "U3RvcDpIU0w6MTQxMjEzNA==",
lat: 60.27016,
lon: 25.07203
},
{
id: "U3RvcDpIU0w6MTQxMjEwMQ==",
lat: 60.268319,
lon: 25.069092
},
{
id: "U3RvcDpIU0w6MTQxMTEzNw==",
lat: 60.267743,
lon: 25.064307
},
{
id: "U3RvcDpIU0w6MTQxMTEwNw==",
lat: 60.26764,
lon: 25.05906
},
{
id: "U3RvcDpIU0w6MTQxMTExMg==",
lat: 60.26956,
lon: 25.06153
},
{
id: "U3RvcDpIU0w6MTQxMTEyMg==",
lat: 60.26998,
lon: 25.0564
},
{
id: "U3RvcDpIU0w6MTQxMTEyNA==",
lat: 60.27112,
lon: 25.05116
},
{
id: "U3RvcDpIU0w6MTQxMTEwOQ==",
lat: 60.27147,
lon: 25.0461
},
{
id: "U3RvcDpIU0w6MTQxMTEwMQ==",
lat: 60.2738,
lon: 25.04459
},
{
id: "U3RvcDpIU0w6MTQxMTEzMA==",
lat: 60.27665,
lon: 25.03995
},
{
id: "U3RvcDpIU0w6MTQwMjE1MA==",
lat: 60.27665,
lon: 25.03432
},
{
id: "U3RvcDpIU0w6MTQwMjE1NQ==",
lat: 60.27502,
lon: 25.03549
},
{
id: "U3RvcDpIU0w6MTQwMjE1Nw==",
lat: 60.27136,
lon: 25.03385
},
{
id: "U3RvcDpIU0w6MTQwMjE3Mw==",
lat: 60.26816,
lon: 25.03245
},
{
id: "U3RvcDpIU0w6MTM4NTEwNA==",
lat: 60.26529,
lon: 25.04177
},
{
id: "U3RvcDpIU0w6MTM4NTEwMg==",
lat: 60.262717,
lon: 25.039394
},
{
id: "U3RvcDpIU0w6MTM4NTEwMA==",
lat: 60.263688,
lon: 25.037575
},
{
id: "U3RvcDpIU0w6MTM5MjEwOA==",
lat: 60.263815,
lon: 25.031948
},
{
id: "U3RvcDpIU0w6MTM5MjEwNg==",
lat: 60.262934,
lon: 25.030945
},
{
id: "U3RvcDpIU0w6MTM5MjEwNA==",
lat: 60.261369,
lon: 25.029054
},
{
id: "U3RvcDpIU0w6MTM5MjEwMg==",
lat: 60.258862,
lon: 25.028527
},
{
id: "U3RvcDpIU0w6MTM4MjExMQ==",
lat: 60.257578,
lon: 25.026081
},
{
id: "U3RvcDpIU0w6MTM4MjE1OQ==",
lat: 60.25643,
lon: 25.02386
},
{
id: "U3RvcDpIU0w6MTM4MjExMg==",
lat: 60.254287,
lon: 25.019157
},
{
id: "U3RvcDpIU0w6MTM4MjE0Mg==",
lat: 60.253395,
lon: 25.020997
},
{
id: "U3RvcDpIU0w6MTM4MjE0MA==",
lat: 60.25008,
lon: 25.01998
},
{
id: "U3RvcDpIU0w6MTM4MjE2Nw==",
lat: 60.251471,
lon: 25.017874
},
{
id: "U3RvcDpIU0w6MTM4MjE2Ng==",
lat: 60.2526,
lon: 25.01394
},
{
id: "U3RvcDpIU0w6MTM4MjE2Mw==",
lat: 60.25152,
lon: 25.01215
},
{
id: "U3RvcDpIU0w6MTM4MjE2NA==",
lat: 60.250635,
lon: 25.012082
},
{
id: "U3RvcDpIU0w6MTM4MjE3MA==",
lat: 60.24865,
lon: 25.01101
},
{
id: "U3RvcDpIU0w6MTM4MjEzMw==",
lat: 60.250684,
lon: 25.009103
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM4MTEyNA==",
lat: 60.253848,
lon: 25.000627
},
{
id: "U3RvcDpIU0w6MTM5MTEwNg==",
lat: 60.25733,
lon: 24.99789
},
{
id: "U3RvcDpIU0w6MTM5MTEwOA==",
lat: 60.25877,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM5MTEzNQ==",
lat: 60.259128,
lon: 24.987292
},
{
id: "U3RvcDpIU0w6MTM5MTEyNA==",
lat: 60.258496,
lon: 24.984184
},
{
id: "U3RvcDpIU0w6MTM5MTEyNQ==",
lat: 60.259985,
lon: 24.981934
},
{
id: "U3RvcDpIU0w6MTM5MTEyMQ==",
lat: 60.25907,
lon: 24.98039
},
{
id: "U3RvcDpIU0w6MTM5MTExOQ==",
lat: 60.257,
lon: 24.98152
},
{
id: "U3RvcDpIU0w6MTM5MTExNw==",
lat: 60.25443,
lon: 24.98369
},
{
id: "U3RvcDpIU0w6MTM3MDExNA==",
lat: 60.25075,
lon: 24.98685
},
{
id: "U3RvcDpIU0w6MTM3MDEzMA==",
lat: 60.246373,
lon: 24.988623
},
{
id: "U3RvcDpIU0w6MTM3MDEyOQ==",
lat: 60.247555,
lon: 24.98781
},
{
id: "U3RvcDpIU0w6MTM3MDEwMg==",
lat: 60.247101,
lon: 24.986081
},
{
id: "U3RvcDpIU0w6MTM3MDExNQ==",
lat: 60.244228,
lon: 24.987497
},
{
id: "U3RvcDpIU0w6MTM3MDExNw==",
lat: 60.242867,
lon: 24.990507
},
{
id: "U3RvcDpIU0w6MTM3MDExMA==",
lat: 60.24324,
lon: 24.99451
},
{
id: "U3RvcDpIU0w6MTM3MDEyNQ==",
lat: 60.237547,
lon: 24.987565
},
{
id: "U3RvcDpIU0w6MTM3MDEyNg==",
lat: 60.239235,
lon: 24.991308
},
{
id: "U3RvcDpIU0w6MTM3MDEyNw==",
lat: 60.240134,
lon: 24.994556
},
{
id: "U3RvcDpIU0w6MTM3MDEyMg==",
lat: 60.242963,
lon: 24.990814
},
{
id: "U3RvcDpIU0w6MTM3MDExNg==",
lat: 60.244934,
lon: 24.986522
},
{
id: "U3RvcDpIU0w6MTM3MDEwNg==",
lat: 60.245953,
lon: 24.986158
},
{
id: "U3RvcDpIU0w6MTM3MDExMw==",
lat: 60.25129,
lon: 24.98678
},
{
id: "U3RvcDpIU0w6MTM5MTExNg==",
lat: 60.25464,
lon: 24.9837
},
{
id: "U3RvcDpIU0w6MTM5MTExOA==",
lat: 60.257215,
lon: 24.981581
},
{
id: "U3RvcDpIU0w6MTM5MTEyMA==",
lat: 60.25975,
lon: 24.98156
},
{
id: "U3RvcDpIU0w6MTM5MTEzNg==",
lat: 60.258468,
lon: 24.984023
},
{
id: "U3RvcDpIU0w6MTM5MTEzNA==",
lat: 60.259102,
lon: 24.987201
},
{
id: "U3RvcDpIU0w6MTM5MTEwOQ==",
lat: 60.2585,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwNg==",
lat: 60.25027,
lon: 25.0093
},
{
id: "U3RvcDpIU0w6MTM4MjE2OQ==",
lat: 60.24882,
lon: 25.01278
},
{
id: "U3RvcDpIU0w6MTM4MjE3Ng==",
lat: 60.25049,
lon: 25.01236
},
{
id: "U3RvcDpIU0w6MTM4MjE2OA==",
lat: 60.25127,
lon: 25.01796
},
{
id: "U3RvcDpIU0w6MTM4MjEzOQ==",
lat: 60.25005,
lon: 25.02018
},
{
id: "U3RvcDpIU0w6MTM4MjE0MQ==",
lat: 60.253556,
lon: 25.02109
},
{
id: "U3RvcDpIU0w6MTM4MjE1OA==",
lat: 60.25644,
lon: 25.02477
},
{
id: "U3RvcDpIU0w6MTM5MjEwMA==",
lat: 60.257354,
lon: 25.026002
},
{
id: "U3RvcDpIU0w6MTM5MjEwMQ==",
lat: 60.258842,
lon: 25.028559
},
{
id: "U3RvcDpIU0w6MTM5MjEwMw==",
lat: 60.261308,
lon: 25.028908
},
{
id: "U3RvcDpIU0w6MTM5MjEwNQ==",
lat: 60.262863,
lon: 25.030925
},
{
id: "U3RvcDpIU0w6MTM5MjEwNw==",
lat: 60.263859,
lon: 25.032058
},
{
id: "U3RvcDpIU0w6MTM4NTEwMQ==",
lat: 60.26374,
lon: 25.037096
},
{
id: "U3RvcDpIU0w6MTM4NTE4MA==",
lat: 60.26301,
lon: 25.0414
},
{
id: "U3RvcDpIU0w6MTQxMTEwMg==",
lat: 60.26595,
lon: 25.04092
},
{
id: "U3RvcDpIU0w6MTQxMTE3NA==",
lat: 60.2688,
lon: 25.03293
},
{
id: "U3RvcDpIU0w6MTQwMjE1Ng==",
lat: 60.2721,
lon: 25.03447
},
{
id: "U3RvcDpIU0w6MTQwMjE1NA==",
lat: 60.27495,
lon: 25.03572
},
{
id: "U3RvcDpIU0w6MTQwMjE1Mg==",
lat: 60.27697,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6MTQxMTEzMQ==",
lat: 60.27618,
lon: 25.04124
},
{
id: "U3RvcDpIU0w6MTQxMTEyOA==",
lat: 60.27443,
lon: 25.0443
},
{
id: "U3RvcDpIU0w6MTQxMTExMA==",
lat: 60.27135,
lon: 25.04662
},
{
id: "U3RvcDpIU0w6MTQxMTEyNQ==",
lat: 60.27072,
lon: 25.05336
},
{
id: "U3RvcDpIU0w6MTQxMTEyMw==",
lat: 60.2701,
lon: 25.05879
},
{
id: "U3RvcDpIU0w6MTQxMTExMQ==",
lat: 60.26945,
lon: 25.06115
},
{
id: "U3RvcDpIU0w6MTQxMTEwOA==",
lat: 60.26653,
lon: 25.05805
},
{
id: "U3RvcDpIU0w6MTQxMjEwMA==",
lat: 60.267652,
lon: 25.064395
},
{
id: "U3RvcDpIU0w6MTQxMjEwMg==",
lat: 60.26813,
lon: 25.068924
},
{
id: "U3RvcDpIU0w6MTQxMjExOA==",
lat: 60.26959,
lon: 25.07277
},
{
id: "U3RvcDpIU0w6MTQxMjEzMw==",
lat: 60.26665,
lon: 25.07134
},
{
id: "U3RvcDpIU0w6MTQxMzE1OA==",
lat: 60.26291,
lon: 25.07017
},
{
id: "U3RvcDpIU0w6MTQxNDEzNQ==",
lat: 60.261811,
lon: 25.075388
},
{
id: "U3RvcDpIU0w6MTQxNDE5Mg==",
lat: 60.260503,
lon: 25.074245
}
]
},
{
gtfsId: "HSL:2118N",
shortName: "118N",
longName: "Kamppi-Tapiola (M)-Suurpelto-Kauniainen-Jorvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI3Nw==",
lat: 60.16898,
lon: 24.93155
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTIzNw==",
lat: 60.17083,
lon: 24.81079
},
{
id: "U3RvcDpIU0w6MjIxMTIzNQ==",
lat: 60.17359,
lon: 24.81072
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxMjIxMg==",
lat: 60.174583,
lon: 24.779316
},
{
id: "U3RvcDpIU0w6MjIxNDI4MA==",
lat: 60.17755,
lon: 24.7759
},
{
id: "U3RvcDpIU0w6MjIxNDIxMA==",
lat: 60.18035,
lon: 24.77136
},
{
id: "U3RvcDpIU0w6MjIxNDIwMw==",
lat: 60.18267,
lon: 24.76728
},
{
id: "U3RvcDpIU0w6MjMyMjIwNw==",
lat: 60.18104,
lon: 24.75875
},
{
id: "U3RvcDpIU0w6MjI0MTIzOA==",
lat: 60.18139,
lon: 24.75348
},
{
id: "U3RvcDpIU0w6MjMzMTIwNg==",
lat: 60.18218,
lon: 24.74539
},
{
id: "U3RvcDpIU0w6MjMzMTIwOA==",
lat: 60.184573,
lon: 24.7443
},
{
id: "U3RvcDpIU0w6MjMzMjIxMQ==",
lat: 60.186421,
lon: 24.7434
},
{
id: "U3RvcDpIU0w6MjMzMjIwNw==",
lat: 60.190021,
lon: 24.741632
},
{
id: "U3RvcDpIU0w6MjI0MTIxMQ==",
lat: 60.187875,
lon: 24.750442
},
{
id: "U3RvcDpIU0w6MjEzMTI1Nw==",
lat: 60.207166,
lon: 24.75329
},
{
id: "U3RvcDpIU0w6MzE3MDIyOA==",
lat: 60.20948,
lon: 24.73798
},
{
id: "U3RvcDpIU0w6MzE3MDIzMA==",
lat: 60.20981,
lon: 24.73151
},
{
id: "U3RvcDpIU0w6MzE3MDIzOQ==",
lat: 60.21096,
lon: 24.72951
},
{
id: "U3RvcDpIU0w6MzE3MDI1Nw==",
lat: 60.21267,
lon: 24.72825
},
{
id: "U3RvcDpIU0w6MzE3MDIwOA==",
lat: 60.21381,
lon: 24.72083
},
{
id: "U3RvcDpIU0w6MzE3MDIxMQ==",
lat: 60.2143,
lon: 24.71582
},
{
id: "U3RvcDpIU0w6MzE3MDIxMg==",
lat: 60.21638,
lon: 24.71126
},
{
id: "U3RvcDpIU0w6MzE3MDIyMw==",
lat: 60.22007,
lon: 24.71116
},
{
id: "U3RvcDpIU0w6MzE3MDIyNQ==",
lat: 60.22209,
lon: 24.71463
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mw==",
lat: 60.22459,
lon: 24.70664
},
{
id: "U3RvcDpIU0w6MjE1MjIyOQ==",
lat: 60.22726,
lon: 24.708
},
{
id: "U3RvcDpIU0w6MjE1MjIzMQ==",
lat: 60.22812,
lon: 24.71094
},
{
id: "U3RvcDpIU0w6MjE1MjIzMw==",
lat: 60.23013,
lon: 24.71583
},
{
id: "U3RvcDpIU0w6MjE1MjIzNQ==",
lat: 60.23214,
lon: 24.71632
},
{
id: "U3RvcDpIU0w6MjE1MjI0NQ==",
lat: 60.23402,
lon: 24.71677
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI1OA==",
lat: 60.23912,
lon: 24.70695
},
{
id: "U3RvcDpIU0w6MjYzMjI1OQ==",
lat: 60.23785,
lon: 24.70422
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mg==",
lat: 60.23498,
lon: 24.70481
},
{
id: "U3RvcDpIU0w6MjYzMjI0MQ==",
lat: 60.23238,
lon: 24.69878
},
{
id: "U3RvcDpIU0w6MjYzMjIzOQ==",
lat: 60.23077,
lon: 24.69602
},
{
id: "U3RvcDpIU0w6MjYzMjIzNw==",
lat: 60.22856,
lon: 24.69157
},
{
id: "U3RvcDpIU0w6MjYzMjIzNQ==",
lat: 60.22592,
lon: 24.68556
},
{
id: "U3RvcDpIU0w6MjYzMjIzMw==",
lat: 60.22548,
lon: 24.68117
},
{
id: "U3RvcDpIU0w6MjYzMjI3Mw==",
lat: 60.22305,
lon: 24.67722
},
{
id: "U3RvcDpIU0w6MjYzMTIwNA==",
lat: 60.22248,
lon: 24.67796
},
{
id: "U3RvcDpIU0w6MjYzMTI2OQ==",
lat: 60.22126,
lon: 24.68531
},
{
id: "U3RvcDpIU0w6MjYzMjIzMg==",
lat: 60.22308,
lon: 24.6774
},
{
id: "U3RvcDpIU0w6MjYzMjIzNA==",
lat: 60.22558,
lon: 24.68211
},
{
id: "U3RvcDpIU0w6MjYzMjIzNg==",
lat: 60.22601,
lon: 24.68628
},
{
id: "U3RvcDpIU0w6MjYzMjIzOA==",
lat: 60.229,
lon: 24.69282
},
{
id: "U3RvcDpIU0w6MjYzMjI0MA==",
lat: 60.23172,
lon: 24.69809
},
{
id: "U3RvcDpIU0w6MjYzMjI0Mw==",
lat: 60.23605,
lon: 24.7054
},
{
id: "U3RvcDpIU0w6MjYzMjI2MA==",
lat: 60.23844,
lon: 24.70498
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzOA==",
lat: 60.23408,
lon: 24.71654
},
{
id: "U3RvcDpIU0w6MjE1MjIzNA==",
lat: 60.2298,
lon: 24.71542
},
{
id: "U3RvcDpIU0w6MjE1MjIzMg==",
lat: 60.228,
lon: 24.70977
},
{
id: "U3RvcDpIU0w6MjE1MjIzMA==",
lat: 60.22545,
lon: 24.7065
},
{
id: "U3RvcDpIU0w6MzE3MDIyNw==",
lat: 60.22372,
lon: 24.70727
},
{
id: "U3RvcDpIU0w6MzE3MDIyNg==",
lat: 60.2214,
lon: 24.71551
},
{
id: "U3RvcDpIU0w6MzE3MDIyNA==",
lat: 60.22025,
lon: 24.71118
},
{
id: "U3RvcDpIU0w6MzE3MDIxMw==",
lat: 60.21566,
lon: 24.71209
},
{
id: "U3RvcDpIU0w6MzE3MDIxMA==",
lat: 60.2139,
lon: 24.7169
},
{
id: "U3RvcDpIU0w6MzE3MDIwOQ==",
lat: 60.21369,
lon: 24.72097
},
{
id: "U3RvcDpIU0w6MzE3MDIwNw==",
lat: 60.21235,
lon: 24.72818
},
{
id: "U3RvcDpIU0w6MzE3MDI0MA==",
lat: 60.21083,
lon: 24.72933
},
{
id: "U3RvcDpIU0w6MzE3MDIzMQ==",
lat: 60.2096,
lon: 24.73197
},
{
id: "U3RvcDpIU0w6MzE3MDIyOQ==",
lat: 60.20949,
lon: 24.73919
},
{
id: "U3RvcDpIU0w6MjEzMTI1MA==",
lat: 60.207094,
lon: 24.752523
},
{
id: "U3RvcDpIU0w6MjEzMTI1MQ==",
lat: 60.20632,
lon: 24.75354
},
{
id: "U3RvcDpIU0w6MjMzMTIwNw==",
lat: 60.189316,
lon: 24.741816
},
{
id: "U3RvcDpIU0w6MjMzMTIxMQ==",
lat: 60.186573,
lon: 24.743208
},
{
id: "U3RvcDpIU0w6MjMzMTIwOQ==",
lat: 60.18293,
lon: 24.74496
},
{
id: "U3RvcDpIU0w6MjI0MTIzNw==",
lat: 60.18099,
lon: 24.75528
},
{
id: "U3RvcDpIU0w6MjIxNDIwNA==",
lat: 60.18093,
lon: 24.76078
},
{
id: "U3RvcDpIU0w6MjIxNDIwOA==",
lat: 60.18091,
lon: 24.77047
},
{
id: "U3RvcDpIU0w6MjIxNDIwNg==",
lat: 60.17746,
lon: 24.7777
},
{
id: "U3RvcDpIU0w6MjIxNDI0OA==",
lat: 60.17461,
lon: 24.77896
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMTIzNg==",
lat: 60.17364,
lon: 24.81027
},
{
id: "U3RvcDpIU0w6MjIxMTIzOA==",
lat: 60.17046,
lon: 24.81056
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:9785",
shortName: "785",
longName: "Rautatientori-Jokivarsi-Nikkilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyNDIxMA==",
lat: 60.391625,
lon: 25.276295
},
{
id: "U3RvcDpIU0w6OTIyNDIwNA==",
lat: 60.390328,
lon: 25.27607
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxNjIxMQ==",
lat: 60.368428,
lon: 25.230412
},
{
id: "U3RvcDpIU0w6OTIxNjIwOQ==",
lat: 60.365565,
lon: 25.224187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNw==",
lat: 60.361667,
lon: 25.213187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNQ==",
lat: 60.361128,
lon: 25.205277
},
{
id: "U3RvcDpIU0w6OTIxNjIwMg==",
lat: 60.36037,
lon: 25.193757
},
{
id: "U3RvcDpIU0w6OTIxNDIyNA==",
lat: 60.359773,
lon: 25.180833
},
{
id: "U3RvcDpIU0w6OTIxNDIyMg==",
lat: 60.358407,
lon: 25.176255
},
{
id: "U3RvcDpIU0w6OTIxNDIyMA==",
lat: 60.357083,
lon: 25.167383
},
{
id: "U3RvcDpIU0w6OTIxNDIxOA==",
lat: 60.354335,
lon: 25.157322
},
{
id: "U3RvcDpIU0w6OTIxNDIxMg==",
lat: 60.34823,
lon: 25.139113
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMQ==",
lat: 60.34501,
lon: 25.11781
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwMA==",
lat: 60.173091,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6OTIxNDIxMw==",
lat: 60.348392,
lon: 25.141493
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwNg==",
lat: 60.387638,
lon: 25.28011
}
]
},
{
gtfsId: "HSL:9788",
shortName: "788",
longName: "Rautatientori-Jokivarsi-Nikkilä-Hinthaara-Porvoo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTMwMDIwMQ==",
lat: 60.392996,
lon: 25.663648
},
{
id: "U3RvcDpIU0w6OTMwMDIzNw==",
lat: 60.392675,
lon: 25.65431
},
{
id: "U3RvcDpIU0w6OTMwMDIzNQ==",
lat: 60.3913,
lon: 25.648302
},
{
id: "U3RvcDpIU0w6OTMwMDIzMw==",
lat: 60.390603,
lon: 25.637555
},
{
id: "U3RvcDpIU0w6OTMwMDIzMQ==",
lat: 60.390549,
lon: 25.629824
},
{
id: "U3RvcDpIU0w6OTMwMDIyOQ==",
lat: 60.39233,
lon: 25.609066
},
{
id: "U3RvcDpIU0w6OTMwMDIyNw==",
lat: 60.391679,
lon: 25.605135
},
{
id: "U3RvcDpIU0w6OTMwMDIyNQ==",
lat: 60.391167,
lon: 25.591857
},
{
id: "U3RvcDpIU0w6OTMwMDIyMw==",
lat: 60.390711,
lon: 25.58157
},
{
id: "U3RvcDpIU0w6OTMwMDIyMQ==",
lat: 60.388313,
lon: 25.5731
},
{
id: "U3RvcDpIU0w6OTMwMDIxOQ==",
lat: 60.389326,
lon: 25.559222
},
{
id: "U3RvcDpIU0w6OTMwMDIxNw==",
lat: 60.387959,
lon: 25.547971
},
{
id: "U3RvcDpIU0w6OTMwMDIxNQ==",
lat: 60.391696,
lon: 25.540238
},
{
id: "U3RvcDpIU0w6OTMwMDIxMw==",
lat: 60.393414,
lon: 25.534173
},
{
id: "U3RvcDpIU0w6OTMwMDIxMQ==",
lat: 60.397024,
lon: 25.51819
},
{
id: "U3RvcDpIU0w6OTMwMDIwOQ==",
lat: 60.398088,
lon: 25.509397
},
{
id: "U3RvcDpIU0w6OTMwMDIwNw==",
lat: 60.399488,
lon: 25.492408
},
{
id: "U3RvcDpIU0w6OTMwMDIwMw==",
lat: 60.399923,
lon: 25.48041
},
{
id: "U3RvcDpIU0w6OTMwMDI1Nw==",
lat: 60.397593,
lon: 25.473874
},
{
id: "U3RvcDpIU0w6OTMwMDI1NQ==",
lat: 60.395964,
lon: 25.459858
},
{
id: "U3RvcDpIU0w6OTMwMDI1Mw==",
lat: 60.3948,
lon: 25.44965
},
{
id: "U3RvcDpIU0w6OTMwMDI1MQ==",
lat: 60.395104,
lon: 25.436971
},
{
id: "U3RvcDpIU0w6OTMwMDI0OQ==",
lat: 60.393263,
lon: 25.426317
},
{
id: "U3RvcDpIU0w6OTMwMDI0Nw==",
lat: 60.390545,
lon: 25.419174
},
{
id: "U3RvcDpIU0w6OTMwMDI0NQ==",
lat: 60.386483,
lon: 25.410225
},
{
id: "U3RvcDpIU0w6OTMwMDI0Mw==",
lat: 60.383481,
lon: 25.401751
},
{
id: "U3RvcDpIU0w6OTMwMDI0MQ==",
lat: 60.382141,
lon: 25.394954
},
{
id: "U3RvcDpIU0w6OTMwMDIzOQ==",
lat: 60.380604,
lon: 25.385213
},
{
id: "U3RvcDpIU0w6OTIyODIxMQ==",
lat: 60.375512,
lon: 25.353321
},
{
id: "U3RvcDpIU0w6OTIyODIxMA==",
lat: 60.374632,
lon: 25.343212
},
{
id: "U3RvcDpIU0w6OTIyODIwOQ==",
lat: 60.372538,
lon: 25.338537
},
{
id: "U3RvcDpIU0w6OTIyODIwOA==",
lat: 60.37081,
lon: 25.33492
},
{
id: "U3RvcDpIU0w6OTIyODIwNw==",
lat: 60.36993,
lon: 25.328368
},
{
id: "U3RvcDpIU0w6OTIyODIwNg==",
lat: 60.368545,
lon: 25.320832
},
{
id: "U3RvcDpIU0w6OTIyODIwNA==",
lat: 60.367617,
lon: 25.301282
},
{
id: "U3RvcDpIU0w6OTIyODIwMQ==",
lat: 60.370982,
lon: 25.297348
},
{
id: "U3RvcDpIU0w6OTIyMzIwOQ==",
lat: 60.372798,
lon: 25.29157
},
{
id: "U3RvcDpIU0w6OTIyMzIwNg==",
lat: 60.374383,
lon: 25.284143
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxNjIxMQ==",
lat: 60.368428,
lon: 25.230412
},
{
id: "U3RvcDpIU0w6OTIxNjIwOQ==",
lat: 60.365565,
lon: 25.224187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNw==",
lat: 60.361667,
lon: 25.213187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNQ==",
lat: 60.361128,
lon: 25.205277
},
{
id: "U3RvcDpIU0w6OTIxNjIwMg==",
lat: 60.36037,
lon: 25.193757
},
{
id: "U3RvcDpIU0w6OTIxNDIyNA==",
lat: 60.359773,
lon: 25.180833
},
{
id: "U3RvcDpIU0w6OTIxNDIyMg==",
lat: 60.358407,
lon: 25.176255
},
{
id: "U3RvcDpIU0w6OTIxNDIyMA==",
lat: 60.357083,
lon: 25.167383
},
{
id: "U3RvcDpIU0w6OTIxNDIxOA==",
lat: 60.354335,
lon: 25.157322
},
{
id: "U3RvcDpIU0w6OTIxNDIxMg==",
lat: 60.34823,
lon: 25.139113
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMQ==",
lat: 60.34501,
lon: 25.11781
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwMA==",
lat: 60.173091,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6OTIxNDIxMw==",
lat: 60.348392,
lon: 25.141493
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMzIwNw==",
lat: 60.37368,
lon: 25.286597
},
{
id: "U3RvcDpIU0w6OTIyMzIxMA==",
lat: 60.372358,
lon: 25.29282
},
{
id: "U3RvcDpIU0w6OTIyODIwMg==",
lat: 60.370258,
lon: 25.2979
},
{
id: "U3RvcDpIU0w6OTIyODIwNQ==",
lat: 60.36726,
lon: 25.301515
},
{
id: "U3RvcDpIU0w6OTIyMTIwMw==",
lat: 60.367635,
lon: 25.306268
},
{
id: "U3RvcDpIU0w6OTIyMTIwNA==",
lat: 60.368627,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyMTIwNQ==",
lat: 60.370042,
lon: 25.329923
},
{
id: "U3RvcDpIU0w6OTIyMTIwNw==",
lat: 60.37197,
lon: 25.33759
},
{
id: "U3RvcDpIU0w6OTIyMTIwOA==",
lat: 60.374532,
lon: 25.343738
},
{
id: "U3RvcDpIU0w6OTIyMTIwOQ==",
lat: 60.375335,
lon: 25.35389
},
{
id: "U3RvcDpIU0w6OTMwMDI0MA==",
lat: 60.380053,
lon: 25.383648
},
{
id: "U3RvcDpIU0w6OTMwMDI0Mg==",
lat: 60.382138,
lon: 25.395569
},
{
id: "U3RvcDpIU0w6OTMwMDI0NA==",
lat: 60.382916,
lon: 25.399536
},
{
id: "U3RvcDpIU0w6OTMwMDI0Ng==",
lat: 60.386293,
lon: 25.409743
},
{
id: "U3RvcDpIU0w6OTMwMDI0OA==",
lat: 60.391155,
lon: 25.420482
},
{
id: "U3RvcDpIU0w6OTMwMDI1MA==",
lat: 60.393861,
lon: 25.429046
},
{
id: "U3RvcDpIU0w6OTMwMDI1Mg==",
lat: 60.395092,
lon: 25.435522
},
{
id: "U3RvcDpIU0w6OTMwMDI1NA==",
lat: 60.394829,
lon: 25.450753
},
{
id: "U3RvcDpIU0w6OTMwMDI1Ng==",
lat: 60.395981,
lon: 25.460147
},
{
id: "U3RvcDpIU0w6OTMwMDI1OA==",
lat: 60.397453,
lon: 25.473666
},
{
id: "U3RvcDpIU0w6OTMwMDIwMg==",
lat: 60.39983,
lon: 25.480889
},
{
id: "U3RvcDpIU0w6OTMwMDIwNg==",
lat: 60.399468,
lon: 25.490812
},
{
id: "U3RvcDpIU0w6OTMwMDIwOA==",
lat: 60.397968,
lon: 25.504043
},
{
id: "U3RvcDpIU0w6OTMwMDIxMA==",
lat: 60.396853,
lon: 25.518776
},
{
id: "U3RvcDpIU0w6OTMwMDIxMg==",
lat: 60.393409,
lon: 25.533706
},
{
id: "U3RvcDpIU0w6OTMwMDIxNA==",
lat: 60.391172,
lon: 25.541072
},
{
id: "U3RvcDpIU0w6OTMwMDIxNg==",
lat: 60.388057,
lon: 25.546898
},
{
id: "U3RvcDpIU0w6OTMwMDIxOA==",
lat: 60.38933,
lon: 25.559936
},
{
id: "U3RvcDpIU0w6OTMwMDIyMA==",
lat: 60.387681,
lon: 25.570238
},
{
id: "U3RvcDpIU0w6OTMwMDIyMg==",
lat: 60.390226,
lon: 25.579652
},
{
id: "U3RvcDpIU0w6OTMwMDIyNA==",
lat: 60.39098,
lon: 25.592476
},
{
id: "U3RvcDpIU0w6OTMwMDIyNg==",
lat: 60.39204,
lon: 25.606718
},
{
id: "U3RvcDpIU0w6OTMwMDIyOA==",
lat: 60.392303,
lon: 25.609147
},
{
id: "U3RvcDpIU0w6OTMwMDIzMA==",
lat: 60.390359,
lon: 25.617548
},
{
id: "U3RvcDpIU0w6OTMwMDIzMg==",
lat: 60.390138,
lon: 25.625004
},
{
id: "U3RvcDpIU0w6OTMwMDIzNA==",
lat: 60.390487,
lon: 25.639308
},
{
id: "U3RvcDpIU0w6OTMwMDIzNg==",
lat: 60.39104,
lon: 25.647726
},
{
id: "U3RvcDpIU0w6OTMwMDIzOA==",
lat: 60.393042,
lon: 25.655838
}
]
},
{
gtfsId: "HSL:9786",
shortName: "786",
longName: "Rautatientori-Jokivarsi-Nikkilä-Järvenpään asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6OTIxNDIxMw==",
lat: 60.348392,
lon: 25.141493
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwNg==",
lat: 60.387638,
lon: 25.28011
},
{
id: "U3RvcDpIU0w6OTIyNDIwMw==",
lat: 60.392063,
lon: 25.274625
},
{
id: "U3RvcDpIU0w6OTIyNDIwMg==",
lat: 60.393787,
lon: 25.274147
},
{
id: "U3RvcDpIU0w6OTIyOTIwMg==",
lat: 60.398647,
lon: 25.269158
},
{
id: "U3RvcDpIU0w6OTIyNjIyOA==",
lat: 60.408537,
lon: 25.268675
},
{
id: "U3RvcDpIU0w6OTIyNjIyNg==",
lat: 60.413232,
lon: 25.263592
},
{
id: "U3RvcDpIU0w6OTIyNjIyMw==",
lat: 60.415632,
lon: 25.25889
},
{
id: "U3RvcDpIU0w6OTIyNjIxNw==",
lat: 60.420212,
lon: 25.254323
},
{
id: "U3RvcDpIU0w6OTIyNjIzMA==",
lat: 60.421925,
lon: 25.255975
},
{
id: "U3RvcDpIU0w6OTIyNjIxOQ==",
lat: 60.426023,
lon: 25.254642
},
{
id: "U3RvcDpIU0w6OTIyNjIyMA==",
lat: 60.430535,
lon: 25.254848
},
{
id: "U3RvcDpIU0w6OTIyNjIxMg==",
lat: 60.43706,
lon: 25.24765
},
{
id: "U3RvcDpIU0w6OTIyNjIwNw==",
lat: 60.441348,
lon: 25.24349
},
{
id: "U3RvcDpIU0w6OTIyNjIxMA==",
lat: 60.444093,
lon: 25.24524
},
{
id: "U3RvcDpIU0w6OTIyNjIwNg==",
lat: 60.447018,
lon: 25.243005
},
{
id: "U3RvcDpIU0w6OTIyNjIwNA==",
lat: 60.452095,
lon: 25.234323
},
{
id: "U3RvcDpIU0w6OTIyNjIwMQ==",
lat: 60.455432,
lon: 25.227765
},
{
id: "U3RvcDpIU0w6OTIyNzIyMQ==",
lat: 60.461243,
lon: 25.218707
},
{
id: "U3RvcDpIU0w6OTIyNzIxNg==",
lat: 60.467624,
lon: 25.216748
},
{
id: "U3RvcDpIU0w6OTIyNzIxNQ==",
lat: 60.471467,
lon: 25.213445
},
{
id: "U3RvcDpIU0w6OTIyNzIxMg==",
lat: 60.472927,
lon: 25.209372
},
{
id: "U3RvcDpIU0w6OTIyNzIxMQ==",
lat: 60.471717,
lon: 25.203932
},
{
id: "U3RvcDpIU0w6OTIyNzIwOA==",
lat: 60.470497,
lon: 25.19664
},
{
id: "U3RvcDpIU0w6OTIyNzIwNg==",
lat: 60.469533,
lon: 25.189673
},
{
id: "U3RvcDpIU0w6OTIyNzIwNQ==",
lat: 60.469993,
lon: 25.169843
},
{
id: "U3RvcDpIU0w6OTIyNzIwNA==",
lat: 60.470315,
lon: 25.157247
},
{
id: "U3RvcDpIU0w6OTUwMDIyNA==",
lat: 60.470406,
lon: 25.150845
},
{
id: "U3RvcDpIU0w6OTUwMDIwNA==",
lat: 60.470263,
lon: 25.139763
},
{
id: "U3RvcDpIU0w6OTUwMDIwNg==",
lat: 60.46899,
lon: 25.132184
},
{
id: "U3RvcDpIU0w6OTUwMDIyNg==",
lat: 60.467716,
lon: 25.129178
},
{
id: "U3RvcDpIU0w6OTUwMDIyOA==",
lat: 60.465217,
lon: 25.119395
},
{
id: "U3RvcDpIU0w6OTUwMDIxOQ==",
lat: 60.465756,
lon: 25.117527
},
{
id: "U3RvcDpIU0w6OTUwMDIxMQ==",
lat: 60.482336,
lon: 25.098393
},
{
id: "U3RvcDpIU0w6OTUwMDIwOA==",
lat: 60.484409,
lon: 25.090334
},
{
id: "U3RvcDpIU0w6OTUwMDIxMA==",
lat: 60.482476,
lon: 25.085652
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
}
]
},
{
gtfsId: "HSL:9665",
shortName: "665",
longName: "Hyrylä-Järvenpää-Kellokoski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDEyMw==",
lat: 60.401866,
lon: 25.028215
},
{
id: "U3RvcDpIU0w6OTY1MDEwMw==",
lat: 60.401391,
lon: 25.03098
},
{
id: "U3RvcDpIU0w6OTY1MDMyNA==",
lat: 60.402958,
lon: 25.039074
},
{
id: "U3RvcDpIU0w6OTY1MDMxOA==",
lat: 60.404662,
lon: 25.041673
},
{
id: "U3RvcDpIU0w6OTY1MDMyMQ==",
lat: 60.407436,
lon: 25.041864
},
{
id: "U3RvcDpIU0w6OTY1MDMyNg==",
lat: 60.409443,
lon: 25.042818
},
{
id: "U3RvcDpIU0w6OTY1MDMwMQ==",
lat: 60.411513,
lon: 25.045253
},
{
id: "U3RvcDpIU0w6OTY1MDQxNA==",
lat: 60.412355,
lon: 25.047274
},
{
id: "U3RvcDpIU0w6OTY1MDQwNw==",
lat: 60.415198,
lon: 25.051276
},
{
id: "U3RvcDpIU0w6OTY1MDUwNg==",
lat: 60.420609,
lon: 25.05311
},
{
id: "U3RvcDpIU0w6OTY1MDYxMQ==",
lat: 60.425178,
lon: 25.05372
},
{
id: "U3RvcDpIU0w6OTY1MDYwMQ==",
lat: 60.428092,
lon: 25.05419
},
{
id: "U3RvcDpIU0w6OTY1MDYwNA==",
lat: 60.431718,
lon: 25.057703
},
{
id: "U3RvcDpIU0w6OTY1MDYyMQ==",
lat: 60.434687,
lon: 25.063428
},
{
id: "U3RvcDpIU0w6OTY1MDYxOQ==",
lat: 60.438392,
lon: 25.06956
},
{
id: "U3RvcDpIU0w6OTY1MDYwNg==",
lat: 60.44401,
lon: 25.076555
},
{
id: "U3RvcDpIU0w6OTUyMzAwMQ==",
lat: 60.447028,
lon: 25.07805
},
{
id: "U3RvcDpIU0w6OTUyMjAwMA==",
lat: 60.45396,
lon: 25.082381
},
{
id: "U3RvcDpIU0w6OTUyMjAwNQ==",
lat: 60.456167,
lon: 25.083647
},
{
id: "U3RvcDpIU0w6OTUyMjAwNg==",
lat: 60.460369,
lon: 25.085854
},
{
id: "U3RvcDpIU0w6OTUwMTAxMQ==",
lat: 60.465908,
lon: 25.085926
},
{
id: "U3RvcDpIU0w6OTUwMTAxMg==",
lat: 60.467521,
lon: 25.08613
},
{
id: "U3RvcDpIU0w6OTUwMTAxMw==",
lat: 60.470591,
lon: 25.088868
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwNw==",
lat: 60.482216,
lon: 25.085202
},
{
id: "U3RvcDpIU0w6OTUwNzAwMQ==",
lat: 60.48585,
lon: 25.093673
},
{
id: "U3RvcDpIU0w6OTUxMjAwMQ==",
lat: 60.490279,
lon: 25.091075
},
{
id: "U3RvcDpIU0w6OTUxMjAwMw==",
lat: 60.494203,
lon: 25.091896
},
{
id: "U3RvcDpIU0w6OTUxMjAwNA==",
lat: 60.497842,
lon: 25.091761
},
{
id: "U3RvcDpIU0w6OTUxMTAxMw==",
lat: 60.501186,
lon: 25.091998
},
{
id: "U3RvcDpIU0w6OTYyMDYwMA==",
lat: 60.506744,
lon: 25.098604
},
{
id: "U3RvcDpIU0w6OTYyMDEwMA==",
lat: 60.517041,
lon: 25.100046
},
{
id: "U3RvcDpIU0w6OTYyMDExOQ==",
lat: 60.521574,
lon: 25.097913
},
{
id: "U3RvcDpIU0w6OTYyMDEyMw==",
lat: 60.524016,
lon: 25.099343
},
{
id: "U3RvcDpIU0w6OTYyMDExMA==",
lat: 60.527828,
lon: 25.104227
},
{
id: "U3RvcDpIU0w6OTYyMDEwOA==",
lat: 60.532741,
lon: 25.110697
},
{
id: "U3RvcDpIU0w6OTYyMDExNA==",
lat: 60.535827,
lon: 25.11185
},
{
id: "U3RvcDpIU0w6OTYyMDEyNQ==",
lat: 60.538881,
lon: 25.113485
},
{
id: "U3RvcDpIU0w6OTYyMDEyNw==",
lat: 60.541235,
lon: 25.114887
},
{
id: "U3RvcDpIU0w6OTYyMDEyOQ==",
lat: 60.546809,
lon: 25.119181
},
{
id: "U3RvcDpIU0w6OTYyMDEzMA==",
lat: 60.546026,
lon: 25.118111
},
{
id: "U3RvcDpIU0w6OTYyMDEyOA==",
lat: 60.542592,
lon: 25.117474
},
{
id: "U3RvcDpIU0w6OTYyMDEyNg==",
lat: 60.540297,
lon: 25.114163
},
{
id: "U3RvcDpIU0w6OTYyMDExNQ==",
lat: 60.536589,
lon: 25.112111
},
{
id: "U3RvcDpIU0w6OTYyMDEwOQ==",
lat: 60.531432,
lon: 25.109525
},
{
id: "U3RvcDpIU0w6OTYyMDExMQ==",
lat: 60.527961,
lon: 25.104432
},
{
id: "U3RvcDpIU0w6OTYyMDEyMQ==",
lat: 60.5271,
lon: 25.102984
},
{
id: "U3RvcDpIU0w6OTYyMDEyMg==",
lat: 60.524806,
lon: 25.100191
},
{
id: "U3RvcDpIU0w6OTYyMDEyMA==",
lat: 60.520712,
lon: 25.097855
},
{
id: "U3RvcDpIU0w6OTYyMDEwMQ==",
lat: 60.516602,
lon: 25.100577
},
{
id: "U3RvcDpIU0w6OTUxMTAwMA==",
lat: 60.505717,
lon: 25.097145
},
{
id: "U3RvcDpIU0w6OTUxMTAxNA==",
lat: 60.501876,
lon: 25.092309
},
{
id: "U3RvcDpIU0w6OTUxMjAwNQ==",
lat: 60.496901,
lon: 25.092005
},
{
id: "U3RvcDpIU0w6OTUxMjAwMg==",
lat: 60.493273,
lon: 25.091476
},
{
id: "U3RvcDpIU0w6OTUxMjAwMA==",
lat: 60.489363,
lon: 25.091271
},
{
id: "U3RvcDpIU0w6OTUwMDIwOA==",
lat: 60.484409,
lon: 25.090334
},
{
id: "U3RvcDpIU0w6OTUwMDIxMA==",
lat: 60.482476,
lon: 25.085652
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIwMA==",
lat: 60.47372,
lon: 25.090098
},
{
id: "U3RvcDpIU0w6OTUwMTAwOA==",
lat: 60.470457,
lon: 25.088669
},
{
id: "U3RvcDpIU0w6OTUwMTAwOQ==",
lat: 60.46858,
lon: 25.086553
},
{
id: "U3RvcDpIU0w6OTUwMTAxMA==",
lat: 60.464957,
lon: 25.086094
},
{
id: "U3RvcDpIU0w6OTUyMjAwMw==",
lat: 60.4594,
lon: 25.085262
},
{
id: "U3RvcDpIU0w6OTUyMjAwNA==",
lat: 60.456397,
lon: 25.083441
},
{
id: "U3RvcDpIU0w6OTUyMzAwMA==",
lat: 60.453127,
lon: 25.081499
},
{
id: "U3RvcDpIU0w6OTUwNjAwMg==",
lat: 60.445708,
lon: 25.077829
},
{
id: "U3RvcDpIU0w6OTY1MDYwNQ==",
lat: 60.443133,
lon: 25.07554
},
{
id: "U3RvcDpIU0w6OTY1MDYxOA==",
lat: 60.437911,
lon: 25.068885
},
{
id: "U3RvcDpIU0w6OTY1MDYyMA==",
lat: 60.434359,
lon: 25.06276
},
{
id: "U3RvcDpIU0w6OTY1MDYwMw==",
lat: 60.430897,
lon: 25.05647
},
{
id: "U3RvcDpIU0w6OTY1MDYwMA==",
lat: 60.426754,
lon: 25.053925
},
{
id: "U3RvcDpIU0w6OTY1MDYxMA==",
lat: 60.42385,
lon: 25.053545
},
{
id: "U3RvcDpIU0w6OTY1MDUwNQ==",
lat: 60.417916,
lon: 25.05271
},
{
id: "U3RvcDpIU0w6OTY1MDQwNg==",
lat: 60.414022,
lon: 25.049991
},
{
id: "U3RvcDpIU0w6OTY1MDMyNQ==",
lat: 60.410933,
lon: 25.045152
},
{
id: "U3RvcDpIU0w6OTY1MDMyNw==",
lat: 60.409244,
lon: 25.042448
},
{
id: "U3RvcDpIU0w6OTY1MDMyMg==",
lat: 60.406367,
lon: 25.041696
},
{
id: "U3RvcDpIU0w6OTY1MDMxOQ==",
lat: 60.404485,
lon: 25.041464
},
{
id: "U3RvcDpIU0w6OTY1MDEwMg==",
lat: 60.40142,
lon: 25.030759
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
}
]
},
{
gtfsId: "HSL:9787",
shortName: "787",
longName: "Rautatientori-Jokivarsi-Nikkilä-Pornainen",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTQwMDIwMg==",
lat: 60.483505,
lon: 25.368993
},
{
id: "U3RvcDpIU0w6OTQwMDIwOQ==",
lat: 60.47742,
lon: 25.374157
},
{
id: "U3RvcDpIU0w6OTQwMDIxMA==",
lat: 60.434959,
lon: 25.367006
},
{
id: "U3RvcDpIU0w6OTIyNTIxNw==",
lat: 60.42515,
lon: 25.338463
},
{
id: "U3RvcDpIU0w6OTIyNTIxNg==",
lat: 60.41998,
lon: 25.332845
},
{
id: "U3RvcDpIU0w6OTIyNTIxMw==",
lat: 60.41603,
lon: 25.33023
},
{
id: "U3RvcDpIU0w6OTIyNTIxMQ==",
lat: 60.412957,
lon: 25.328448
},
{
id: "U3RvcDpIU0w6OTIyNTIxMA==",
lat: 60.410613,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyNTIwMQ==",
lat: 60.408782,
lon: 25.318287
},
{
id: "U3RvcDpIU0w6OTIyNTIwNw==",
lat: 60.406928,
lon: 25.314803
},
{
id: "U3RvcDpIU0w6OTIyNTIwNA==",
lat: 60.405853,
lon: 25.305318
},
{
id: "U3RvcDpIU0w6OTIyNTIwMg==",
lat: 60.401832,
lon: 25.298322
},
{
id: "U3RvcDpIU0w6OTIyOTIwNw==",
lat: 60.395527,
lon: 25.298033
},
{
id: "U3RvcDpIU0w6OTIyOTIwNQ==",
lat: 60.392832,
lon: 25.295147
},
{
id: "U3RvcDpIU0w6OTIyOTIwNA==",
lat: 60.390917,
lon: 25.291257
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxNjIxMQ==",
lat: 60.368428,
lon: 25.230412
},
{
id: "U3RvcDpIU0w6OTIxNjIwOQ==",
lat: 60.365565,
lon: 25.224187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNw==",
lat: 60.361667,
lon: 25.213187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNQ==",
lat: 60.361128,
lon: 25.205277
},
{
id: "U3RvcDpIU0w6OTIxNjIwMg==",
lat: 60.36037,
lon: 25.193757
},
{
id: "U3RvcDpIU0w6OTIxNDIyNA==",
lat: 60.359773,
lon: 25.180833
},
{
id: "U3RvcDpIU0w6OTIxNDIyMg==",
lat: 60.358407,
lon: 25.176255
},
{
id: "U3RvcDpIU0w6OTIxNDIyMA==",
lat: 60.357083,
lon: 25.167383
},
{
id: "U3RvcDpIU0w6OTIxNDIxOA==",
lat: 60.354335,
lon: 25.157322
},
{
id: "U3RvcDpIU0w6OTIxNDIxMg==",
lat: 60.34823,
lon: 25.139113
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMQ==",
lat: 60.34501,
lon: 25.11781
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwMA==",
lat: 60.173091,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6OTIxNDIxMw==",
lat: 60.348392,
lon: 25.141493
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwOA==",
lat: 60.386435,
lon: 25.282542
},
{
id: "U3RvcDpIU0w6OTIyOTIwMw==",
lat: 60.390658,
lon: 25.291292
},
{
id: "U3RvcDpIU0w6OTIyOTIwNg==",
lat: 60.393408,
lon: 25.296543
},
{
id: "U3RvcDpIU0w6OTIyOTIwOA==",
lat: 60.396172,
lon: 25.298523
},
{
id: "U3RvcDpIU0w6OTIyNTIwMw==",
lat: 60.402635,
lon: 25.299295
},
{
id: "U3RvcDpIU0w6OTIyNTIwNQ==",
lat: 60.406127,
lon: 25.30665
},
{
id: "U3RvcDpIU0w6OTIyNTIwNg==",
lat: 60.40681,
lon: 25.315015
},
{
id: "U3RvcDpIU0w6OTIyNTIwOA==",
lat: 60.40889,
lon: 25.318735
},
{
id: "U3RvcDpIU0w6OTIyNTIwOQ==",
lat: 60.410377,
lon: 25.321968
},
{
id: "U3RvcDpIU0w6OTIyNTIxMg==",
lat: 60.41308,
lon: 25.328807
},
{
id: "U3RvcDpIU0w6OTIyNTIxNA==",
lat: 60.416008,
lon: 25.330725
},
{
id: "U3RvcDpIU0w6OTIyNTIxNQ==",
lat: 60.418978,
lon: 25.332633
},
{
id: "U3RvcDpIU0w6OTIyNTIxOA==",
lat: 60.425025,
lon: 25.338565
},
{
id: "U3RvcDpIU0w6OTQwMDIxMQ==",
lat: 60.435523,
lon: 25.368753
},
{
id: "U3RvcDpIU0w6OTQwMDIwOA==",
lat: 60.477653,
lon: 25.374435
},
{
id: "U3RvcDpIU0w6OTQwMDIwMQ==",
lat: 60.484347,
lon: 25.368078
}
]
},
{
gtfsId: "HSL:2118B",
shortName: "118B",
longName: "Tapiola(M)-Suurpelto",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMzMTIwNw==",
lat: 60.189316,
lon: 24.741816
},
{
id: "U3RvcDpIU0w6MjMzMTIxMQ==",
lat: 60.186573,
lon: 24.743208
},
{
id: "U3RvcDpIU0w6MjMzMTIwOQ==",
lat: 60.18293,
lon: 24.74496
},
{
id: "U3RvcDpIU0w6MjI0MTIzNw==",
lat: 60.18099,
lon: 24.75528
},
{
id: "U3RvcDpIU0w6MjMyMjIxNg==",
lat: 60.18048,
lon: 24.75964
},
{
id: "U3RvcDpIU0w6MjMyMjI5NQ==",
lat: 60.17621,
lon: 24.75872
},
{
id: "U3RvcDpIU0w6MjIxNDIzOA==",
lat: 60.170739,
lon: 24.762938
},
{
id: "U3RvcDpIU0w6MjIxNDI0NA==",
lat: 60.170943,
lon: 24.772035
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mg==",
lat: 60.17243,
lon: 24.78077
},
{
id: "U3RvcDpIU0w6MjIxMjI0NA==",
lat: 60.17352,
lon: 24.78602
},
{
id: "U3RvcDpIU0w6MjIxMjI0MA==",
lat: 60.17341,
lon: 24.79319
},
{
id: "U3RvcDpIU0w6MjIxMjIzOA==",
lat: 60.17429,
lon: 24.79727
},
{
id: "U3RvcDpIU0w6MjIxMTIxNw==",
lat: 60.174735,
lon: 24.803657
},
{
id: "U3RvcDpIU0w6MjIxMTIyNQ==",
lat: 60.175006,
lon: 24.804031
},
{
id: "U3RvcDpIU0w6MjIxMjIzNw==",
lat: 60.174422,
lon: 24.797134
},
{
id: "U3RvcDpIU0w6MjIxMjIzOQ==",
lat: 60.17353,
lon: 24.79135
},
{
id: "U3RvcDpIU0w6MjIxMjI0NQ==",
lat: 60.17362,
lon: 24.78545
},
{
id: "U3RvcDpIU0w6MjIxNDI0MQ==",
lat: 60.17207,
lon: 24.77845
},
{
id: "U3RvcDpIU0w6MjIxNDI0Mw==",
lat: 60.17122,
lon: 24.77009
},
{
id: "U3RvcDpIU0w6MjIxNDIzOQ==",
lat: 60.171014,
lon: 24.763151
},
{
id: "U3RvcDpIU0w6MjMyMjI5NA==",
lat: 60.17555,
lon: 24.75881
},
{
id: "U3RvcDpIU0w6MjMyMjI5Ng==",
lat: 60.17963,
lon: 24.75916
},
{
id: "U3RvcDpIU0w6MjMyMjIwNw==",
lat: 60.18104,
lon: 24.75875
},
{
id: "U3RvcDpIU0w6MjI0MTIzOA==",
lat: 60.18139,
lon: 24.75348
},
{
id: "U3RvcDpIU0w6MjMzMTIwNg==",
lat: 60.18218,
lon: 24.74539
},
{
id: "U3RvcDpIU0w6MjMzMTIwOA==",
lat: 60.184573,
lon: 24.7443
},
{
id: "U3RvcDpIU0w6MjMzMjIxMQ==",
lat: 60.186421,
lon: 24.7434
},
{
id: "U3RvcDpIU0w6MjMzMjIwNw==",
lat: 60.190021,
lon: 24.741632
}
]
},
{
gtfsId: "HSL:9633N",
shortName: "633N",
longName: "Rautatientori-Simonkylä-Leinelä-Korso-Ahjo-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDIwNA==",
lat: 60.17165,
lon: 24.94327
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDY4MDIzOA==",
lat: 60.29001,
lon: 24.99751
},
{
id: "U3RvcDpIU0w6NDY4MDIwNQ==",
lat: 60.29238,
lon: 24.9982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMw==",
lat: 60.29196,
lon: 25.00701
},
{
id: "U3RvcDpIU0w6NDY4MDIyNw==",
lat: 60.29201,
lon: 25.01294
},
{
id: "U3RvcDpIU0w6NDYzMDIxOA==",
lat: 60.292663,
lon: 25.017039
},
{
id: "U3RvcDpIU0w6NDYzMDIxOQ==",
lat: 60.29612,
lon: 25.01589
},
{
id: "U3RvcDpIU0w6NDYzMDIyMQ==",
lat: 60.29879,
lon: 25.01765
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIwMw==",
lat: 60.30689,
lon: 25.02499
},
{
id: "U3RvcDpIU0w6NDY1MDIwNQ==",
lat: 60.31,
lon: 25.0287
},
{
id: "U3RvcDpIU0w6NDY1MDIwNw==",
lat: 60.31132,
lon: 25.03142
},
{
id: "U3RvcDpIU0w6NDY1MDIwOQ==",
lat: 60.31516,
lon: 25.03566
},
{
id: "U3RvcDpIU0w6NDcwMDIwMQ==",
lat: 60.3203,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDcwMDIyOA==",
lat: 60.32246,
lon: 25.042177
},
{
id: "U3RvcDpIU0w6NDcwMDIzNA==",
lat: 60.325902,
lon: 25.041882
},
{
id: "U3RvcDpIU0w6NDcyMDIyNQ==",
lat: 60.326482,
lon: 25.043723
},
{
id: "U3RvcDpIU0w6NDcwMDIwNw==",
lat: 60.3246,
lon: 25.05219
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIwMw==",
lat: 60.32995,
lon: 25.06272
},
{
id: "U3RvcDpIU0w6NDcyMDIyNA==",
lat: 60.33199,
lon: 25.06424
},
{
id: "U3RvcDpIU0w6NDcyMDIwNQ==",
lat: 60.33399,
lon: 25.06449
},
{
id: "U3RvcDpIU0w6NDcyMDIxMQ==",
lat: 60.33519,
lon: 25.06504
},
{
id: "U3RvcDpIU0w6NDcyMDIwNw==",
lat: 60.33902,
lon: 25.06971
},
{
id: "U3RvcDpIU0w6NDgxMDIzOA==",
lat: 60.34579,
lon: 25.07516
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIyOA==",
lat: 60.35035,
lon: 25.07627
},
{
id: "U3RvcDpIU0w6NDgxMDIwNA==",
lat: 60.35271,
lon: 25.06532
},
{
id: "U3RvcDpIU0w6NDgxMDIwNg==",
lat: 60.3531,
lon: 25.06058
},
{
id: "U3RvcDpIU0w6NDgxMDIwOA==",
lat: 60.35364,
lon: 25.05589
},
{
id: "U3RvcDpIU0w6NDgxMDI0Nw==",
lat: 60.35473,
lon: 25.05225
},
{
id: "U3RvcDpIU0w6NDgxMDIxOQ==",
lat: 60.3572,
lon: 25.05523
},
{
id: "U3RvcDpIU0w6NDgxMDIyMQ==",
lat: 60.35993,
lon: 25.06364
},
{
id: "U3RvcDpIU0w6NDgxMDI0NQ==",
lat: 60.36148,
lon: 25.06622
},
{
id: "U3RvcDpIU0w6NDg4MDIwNQ==",
lat: 60.36503,
lon: 25.06885
},
{
id: "U3RvcDpIU0w6NDg4MDIwMQ==",
lat: 60.36867,
lon: 25.075262
},
{
id: "U3RvcDpIU0w6NDg4MDIwNw==",
lat: 60.37234,
lon: 25.07747
},
{
id: "U3RvcDpIU0w6OTA2MDIwOQ==",
lat: 60.37598,
lon: 25.08016
},
{
id: "U3RvcDpIU0w6OTA2MDIxMQ==",
lat: 60.37708,
lon: 25.08163
},
{
id: "U3RvcDpIU0w6OTA2MDIxMw==",
lat: 60.37925,
lon: 25.08635
},
{
id: "U3RvcDpIU0w6OTA2MDIxOQ==",
lat: 60.38226,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6OTA2MDIyMg==",
lat: 60.38419,
lon: 25.08743
},
{
id: "U3RvcDpIU0w6OTA2MDIyNA==",
lat: 60.38513,
lon: 25.08958
},
{
id: "U3RvcDpIU0w6OTA2MDIyNg==",
lat: 60.38921,
lon: 25.08957
},
{
id: "U3RvcDpIU0w6OTA2MDIzMA==",
lat: 60.39068,
lon: 25.09484
},
{
id: "U3RvcDpIU0w6OTA2MDIzMg==",
lat: 60.39091,
lon: 25.09869
},
{
id: "U3RvcDpIU0w6OTA5MDIwNw==",
lat: 60.39264,
lon: 25.10139
},
{
id: "U3RvcDpIU0w6OTEwMDIwOA==",
lat: 60.38598,
lon: 25.12815
},
{
id: "U3RvcDpIU0w6OTEwMDIwOQ==",
lat: 60.38645,
lon: 25.13528
},
{
id: "U3RvcDpIU0w6OTA1MDIwNg==",
lat: 60.38642,
lon: 25.14572
},
{
id: "U3RvcDpIU0w6OTA1MDIwOQ==",
lat: 60.38965,
lon: 25.14576
},
{
id: "U3RvcDpIU0w6OTA1MDIxMQ==",
lat: 60.39214,
lon: 25.14665
},
{
id: "U3RvcDpIU0w6OTA1MDIxMw==",
lat: 60.39432,
lon: 25.14548
},
{
id: "U3RvcDpIU0w6OTA1MDIxNQ==",
lat: 60.39715,
lon: 25.14532
},
{
id: "U3RvcDpIU0w6OTA1MDIxNw==",
lat: 60.4001,
lon: 25.1452
},
{
id: "U3RvcDpIU0w6OTA1MDIzMg==",
lat: 60.40087,
lon: 25.13935
},
{
id: "U3RvcDpIU0w6OTA1MDIzNQ==",
lat: 60.4028,
lon: 25.14068
},
{
id: "U3RvcDpIU0w6OTA1MDIyNg==",
lat: 60.40598,
lon: 25.13959
},
{
id: "U3RvcDpIU0w6OTA1MDIyNw==",
lat: 60.40562,
lon: 25.13303
},
{
id: "U3RvcDpIU0w6OTA0MDIxOA==",
lat: 60.40565,
lon: 25.115
},
{
id: "U3RvcDpIU0w6OTA0MDIxNQ==",
lat: 60.40475,
lon: 25.11062
},
{
id: "U3RvcDpIU0w6OTA0MDIwOQ==",
lat: 60.40329,
lon: 25.10603
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
},
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMA==",
lat: 60.40314,
lon: 25.10726
},
{
id: "U3RvcDpIU0w6OTA0MDIxNw==",
lat: 60.405,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6OTA0MDIxOQ==",
lat: 60.4059,
lon: 25.11659
},
{
id: "U3RvcDpIU0w6OTA1MDIyOQ==",
lat: 60.40502,
lon: 25.13488
},
{
id: "U3RvcDpIU0w6OTA1MDIyNQ==",
lat: 60.40554,
lon: 25.14059
},
{
id: "U3RvcDpIU0w6OTA1MDIzNA==",
lat: 60.40252,
lon: 25.14004
},
{
id: "U3RvcDpIU0w6OTA1MDIzMw==",
lat: 60.40055,
lon: 25.14017
},
{
id: "U3RvcDpIU0w6OTA1MDIxNg==",
lat: 60.40003,
lon: 25.14512
},
{
id: "U3RvcDpIU0w6OTA1MDIxNA==",
lat: 60.39609,
lon: 25.14491
},
{
id: "U3RvcDpIU0w6OTA1MDIxMg==",
lat: 60.39415,
lon: 25.14529
},
{
id: "U3RvcDpIU0w6OTA1MDIxMA==",
lat: 60.39164,
lon: 25.14634
},
{
id: "U3RvcDpIU0w6OTA1MDIwOA==",
lat: 60.38884,
lon: 25.14521
},
{
id: "U3RvcDpIU0w6OTA1MDIwNQ==",
lat: 60.38618,
lon: 25.14439
},
{
id: "U3RvcDpIU0w6OTEwMDIxMQ==",
lat: 60.3867,
lon: 25.13719
},
{
id: "U3RvcDpIU0w6OTEwMDIxMg==",
lat: 60.38642,
lon: 25.12459
},
{
id: "U3RvcDpIU0w6OTA2MDIwNw==",
lat: 60.39306,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6OTA2MDIzMQ==",
lat: 60.391,
lon: 25.09755
},
{
id: "U3RvcDpIU0w6OTA2MDIyOQ==",
lat: 60.39059,
lon: 25.09295
},
{
id: "U3RvcDpIU0w6OTA2MDIyNQ==",
lat: 60.38845,
lon: 25.0891
},
{
id: "U3RvcDpIU0w6OTA2MDIyMw==",
lat: 60.3851,
lon: 25.08938
},
{
id: "U3RvcDpIU0w6OTA2MDIyMQ==",
lat: 60.38372,
lon: 25.08716
},
{
id: "U3RvcDpIU0w6OTA2MDIxOA==",
lat: 60.38233,
lon: 25.0886
},
{
id: "U3RvcDpIU0w6OTA2MDIxMg==",
lat: 60.38032,
lon: 25.08745
},
{
id: "U3RvcDpIU0w6OTA2MDIxMA==",
lat: 60.37722,
lon: 25.08155
},
{
id: "U3RvcDpIU0w6OTA2MDIwOA==",
lat: 60.37554,
lon: 25.07952
},
{
id: "U3RvcDpIU0w6NDg4MDIwNg==",
lat: 60.37136,
lon: 25.07646
},
{
id: "U3RvcDpIU0w6NDg4MDIwMg==",
lat: 60.36804,
lon: 25.07406
},
{
id: "U3RvcDpIU0w6NDg4MDIwNA==",
lat: 60.36436,
lon: 25.06788
},
{
id: "U3RvcDpIU0w6NDgxMDI0Ng==",
lat: 60.3615,
lon: 25.066
},
{
id: "U3RvcDpIU0w6NDgxMDIyMg==",
lat: 60.35894,
lon: 25.06111
},
{
id: "U3RvcDpIU0w6NDgxMDIyMA==",
lat: 60.35668,
lon: 25.05364
},
{
id: "U3RvcDpIU0w6NDgxMDI0OA==",
lat: 60.35416,
lon: 25.05255
},
{
id: "U3RvcDpIU0w6NDgxMDIwOQ==",
lat: 60.35341,
lon: 25.0565
},
{
id: "U3RvcDpIU0w6NDgxMDIwNw==",
lat: 60.3529,
lon: 25.06141
},
{
id: "U3RvcDpIU0w6NDgxMDIwNQ==",
lat: 60.3526,
lon: 25.06612
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDIzMQ==",
lat: 60.34492,
lon: 25.07435
},
{
id: "U3RvcDpIU0w6NDcyMDIwOA==",
lat: 60.34002,
lon: 25.06982
},
{
id: "U3RvcDpIU0w6NDcyMDIwNg==",
lat: 60.3343,
lon: 25.06437
},
{
id: "U3RvcDpIU0w6NDcyMDIwNA==",
lat: 60.33103,
lon: 25.06343
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcyMDIyNw==",
lat: 60.325038,
lon: 25.050357
},
{
id: "U3RvcDpIU0w6NDcwMDIzMg==",
lat: 60.326547,
lon: 25.0421
},
{
id: "U3RvcDpIU0w6NDcwMDIzMw==",
lat: 60.325487,
lon: 25.041647
},
{
id: "U3RvcDpIU0w6NDcwMDIyOQ==",
lat: 60.322323,
lon: 25.042012
},
{
id: "U3RvcDpIU0w6NDcwMDIwMg==",
lat: 60.31968,
lon: 25.03908
},
{
id: "U3RvcDpIU0w6NDY1MDIxMA==",
lat: 60.3149,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6NDY1MDIwOA==",
lat: 60.31072,
lon: 25.03015
},
{
id: "U3RvcDpIU0w6NDY1MDIwNg==",
lat: 60.30949,
lon: 25.02695
},
{
id: "U3RvcDpIU0w6NDY1MDIwNA==",
lat: 60.30635,
lon: 25.02439
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIyMw==",
lat: 60.30177,
lon: 25.02167
},
{
id: "U3RvcDpIU0w6NDYzMDIyMg==",
lat: 60.29898,
lon: 25.01768
},
{
id: "U3RvcDpIU0w6NDYzMDIyMA==",
lat: 60.29537,
lon: 25.01572
},
{
id: "U3RvcDpIU0w6NDYzMDIxMg==",
lat: 60.29205,
lon: 25.0157
},
{
id: "U3RvcDpIU0w6NDY4MDIyOA==",
lat: 60.29215,
lon: 25.01095
},
{
id: "U3RvcDpIU0w6NDY4MDIwNA==",
lat: 60.29215,
lon: 25.00494
},
{
id: "U3RvcDpIU0w6NDY4MDIzOQ==",
lat: 60.29059,
lon: 24.99697
},
{
id: "U3RvcDpIU0w6NDY4MDI0Nw==",
lat: 60.28851,
lon: 24.99724
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mg==",
lat: 60.28722,
lon: 24.97696
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:1811",
shortName: "811",
longName: "Kivikko-Kontula-Mellunmäki-Länsimäki-Rajakylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk1MDIwMw==",
lat: 60.250739,
lon: 25.089675
},
{
id: "U3RvcDpIU0w6NDk1MDIwNQ==",
lat: 60.249921,
lon: 25.096143
},
{
id: "U3RvcDpIU0w6NDk1MDIxNw==",
lat: 60.251986,
lon: 25.100115
},
{
id: "U3RvcDpIU0w6NDk1MDIxMg==",
lat: 60.250903,
lon: 25.1084
},
{
id: "U3RvcDpIU0w6NDkxMDIxOQ==",
lat: 60.250663,
lon: 25.113953
},
{
id: "U3RvcDpIU0w6NDkxMDIyMQ==",
lat: 60.250117,
lon: 25.1122
},
{
id: "U3RvcDpIU0w6NDkxMDIwNA==",
lat: 60.24714,
lon: 25.11196
},
{
id: "U3RvcDpIU0w6NDkxMDIxNg==",
lat: 60.24414,
lon: 25.11054
},
{
id: "U3RvcDpIU0w6NDkxMDIwMg==",
lat: 60.2434,
lon: 25.10626
},
{
id: "U3RvcDpIU0w6NDkxMDIyMw==",
lat: 60.245071,
lon: 25.108564
},
{
id: "U3RvcDpIU0w6NDkxMDIyNQ==",
lat: 60.246755,
lon: 25.110418
},
{
id: "U3RvcDpIU0w6NDkxMDIxMw==",
lat: 60.246658,
lon: 25.113593
},
{
id: "U3RvcDpIU0w6NDkxMDIyOA==",
lat: 60.244558,
lon: 25.116408
},
{
id: "U3RvcDpIU0w6NDkxMDIwOQ==",
lat: 60.242887,
lon: 25.1129
},
{
id: "U3RvcDpIU0w6NDkxMDIyNg==",
lat: 60.242125,
lon: 25.112356
},
{
id: "U3RvcDpIU0w6NDkxMDIyNA==",
lat: 60.242314,
lon: 25.1114
},
{
id: "U3RvcDpIU0w6NDkxMDIxOA==",
lat: 60.24234,
lon: 25.10881
},
{
id: "U3RvcDpIU0w6MTQ3MzE4Mg==",
lat: 60.238195,
lon: 25.109901
},
{
id: "U3RvcDpIU0w6MTQ3MjExMw==",
lat: 60.23732,
lon: 25.09838
},
{
id: "U3RvcDpIU0w6MTQ3MTExNQ==",
lat: 60.23753,
lon: 25.09072
},
{
id: "U3RvcDpIU0w6MTQ3MjEyMQ==",
lat: 60.238601,
lon: 25.089358
},
{
id: "U3RvcDpIU0w6MTQ3MjEyMw==",
lat: 60.241189,
lon: 25.092224
},
{
id: "U3RvcDpIU0w6MTQ3MjEyNQ==",
lat: 60.242837,
lon: 25.092677
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMg==",
lat: 60.243524,
lon: 25.087752
},
{
id: "U3RvcDpIU0w6MTQ3MTEwOA==",
lat: 60.243585,
lon: 25.08584
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mg==",
lat: 60.241694,
lon: 25.086211
},
{
id: "U3RvcDpIU0w6MTQ3MTEwNQ==",
lat: 60.23883,
lon: 25.084705
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mw==",
lat: 60.237977,
lon: 25.08401
},
{
id: "U3RvcDpIU0w6MTQ3MTEwNg==",
lat: 60.238799,
lon: 25.084924
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MA==",
lat: 60.23846,
lon: 25.0869
},
{
id: "U3RvcDpIU0w6MTQ3MTExNw==",
lat: 60.23608,
lon: 25.08512
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOA==",
lat: 60.235943,
lon: 25.080696
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NA==",
lat: 60.23335,
lon: 25.07789
},
{
id: "U3RvcDpIU0w6MTQ3MTE5Nw==",
lat: 60.232502,
lon: 25.075328
},
{
id: "U3RvcDpIU0w6MTQ3MTE5NQ==",
lat: 60.233183,
lon: 25.072008
},
{
id: "U3RvcDpIU0w6MTQ3MTE5Mw==",
lat: 60.232917,
lon: 25.066373
},
{
id: "U3RvcDpIU0w6MTQ3NDExMQ==",
lat: 60.23268,
lon: 25.062558
},
{
id: "U3RvcDpIU0w6MTQ3NDE4NA==",
lat: 60.231874,
lon: 25.057301
},
{
id: "U3RvcDpIU0w6MTQ3NDEwOQ==",
lat: 60.233448,
lon: 25.056732
},
{
id: "U3RvcDpIU0w6MTQ3NDExNA==",
lat: 60.23164,
lon: 25.05878
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMQ==",
lat: 60.23361,
lon: 25.0628
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMw==",
lat: 60.23707,
lon: 25.06766
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMA==",
lat: 60.237247,
lon: 25.066625
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNQ==",
lat: 60.23879,
lon: 25.06735
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNw==",
lat: 60.24025,
lon: 25.07194
},
{
id: "U3RvcDpIU0w6MTQ3MTE0MQ==",
lat: 60.24007,
lon: 25.07459
},
{
id: "U3RvcDpIU0w6MTQ3MTE0Mw==",
lat: 60.24255,
lon: 25.07526
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMw==",
lat: 60.244934,
lon: 25.074437
},
{
id: "U3RvcDpIU0w6MTQ3NDExNQ==",
lat: 60.248572,
lon: 25.078282
},
{
id: "U3RvcDpIU0w6MTQ3NDEyNA==",
lat: 60.245078,
lon: 25.074406
},
{
id: "U3RvcDpIU0w6MTQ3MTE0NA==",
lat: 60.24251,
lon: 25.07514
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNg==",
lat: 60.23977,
lon: 25.07401
},
{
id: "U3RvcDpIU0w6MTQ3NDEwOA==",
lat: 60.24054,
lon: 25.07018
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNg==",
lat: 60.2387,
lon: 25.0672
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNA==",
lat: 60.23695,
lon: 25.06738
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMg==",
lat: 60.23314,
lon: 25.06215
},
{
id: "U3RvcDpIU0w6MTQ3NDExMg==",
lat: 60.23256,
lon: 25.06251
},
{
id: "U3RvcDpIU0w6MTQ3MTE4Mg==",
lat: 60.232998,
lon: 25.066393
},
{
id: "U3RvcDpIU0w6MTQ3MTE4NA==",
lat: 60.233521,
lon: 25.071645
},
{
id: "U3RvcDpIU0w6MTQ3MTE4Ng==",
lat: 60.232621,
lon: 25.075207
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mw==",
lat: 60.23353,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNw==",
lat: 60.235733,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6MTQ3MTExOA==",
lat: 60.23638,
lon: 25.08713
},
{
id: "U3RvcDpIU0w6MTQ3MTE0OQ==",
lat: 60.23947,
lon: 25.0862
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MQ==",
lat: 60.24156,
lon: 25.08644
},
{
id: "U3RvcDpIU0w6MTQ3MjE1Mw==",
lat: 60.243574,
lon: 25.088205
},
{
id: "U3RvcDpIU0w6MTQ3MjEyNg==",
lat: 60.242856,
lon: 25.092587
},
{
id: "U3RvcDpIU0w6MTQ3MjEyNA==",
lat: 60.240677,
lon: 25.091855
},
{
id: "U3RvcDpIU0w6MTQ3MjEyMg==",
lat: 60.238672,
lon: 25.089434
},
{
id: "U3RvcDpIU0w6MTQ3MTExNg==",
lat: 60.23749,
lon: 25.09319
},
{
id: "U3RvcDpIU0w6MTQ3MjExNA==",
lat: 60.23702,
lon: 25.09955
},
{
id: "U3RvcDpIU0w6MTQ3MjExMg==",
lat: 60.23742,
lon: 25.1058
},
{
id: "U3RvcDpIU0w6NDkxMDIxNw==",
lat: 60.242165,
lon: 25.108975
},
{
id: "U3RvcDpIU0w6NDkxMDIwNw==",
lat: 60.24237,
lon: 25.111167
},
{
id: "U3RvcDpIU0w6NDkxMDIxMQ==",
lat: 60.24202,
lon: 25.112356
},
{
id: "U3RvcDpIU0w6NDkxMDIxNA==",
lat: 60.243919,
lon: 25.116047
},
{
id: "U3RvcDpIU0w6NDkxMDIxMg==",
lat: 60.246573,
lon: 25.115825
},
{
id: "U3RvcDpIU0w6NDkxMDIyMA==",
lat: 60.24671,
lon: 25.109947
},
{
id: "U3RvcDpIU0w6NDkxMDIwOA==",
lat: 60.244632,
lon: 25.108015
},
{
id: "U3RvcDpIU0w6NDk1MDIxNA==",
lat: 60.243876,
lon: 25.105215
},
{
id: "U3RvcDpIU0w6NDk1MDIxMA==",
lat: 60.24712,
lon: 25.10024
},
{
id: "U3RvcDpIU0w6NDk1MDIwNg==",
lat: 60.24998,
lon: 25.09979
},
{
id: "U3RvcDpIU0w6NDk1MDIwNA==",
lat: 60.250182,
lon: 25.093707
}
]
},
{
gtfsId: "HSL:9984K",
shortName: "984K",
longName: "Hindsby (Knuters)-Nikkilä- Mårsbackantie-Talma",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIxNzIxOQ==",
lat: 60.410142,
lon: 25.17315
},
{
id: "U3RvcDpIU0w6OTIxNzIxNA==",
lat: 60.407043,
lon: 25.171219
},
{
id: "U3RvcDpIU0w6OTIxNzIyMQ==",
lat: 60.406233,
lon: 25.177323
},
{
id: "U3RvcDpIU0w6OTIxNzIyMw==",
lat: 60.401692,
lon: 25.192712
},
{
id: "U3RvcDpIU0w6OTIxODIxMA==",
lat: 60.399888,
lon: 25.20157
},
{
id: "U3RvcDpIU0w6OTIxOTIwOA==",
lat: 60.395,
lon: 25.22465
},
{
id: "U3RvcDpIU0w6OTIxOTIxMw==",
lat: 60.3906,
lon: 25.234893
},
{
id: "U3RvcDpIU0w6OTIxOTIxMQ==",
lat: 60.386438,
lon: 25.230305
},
{
id: "U3RvcDpIU0w6OTIxOTIxMg==",
lat: 60.38082,
lon: 25.23395
},
{
id: "U3RvcDpIU0w6OTIyMjIwMw==",
lat: 60.378025,
lon: 25.238145
},
{
id: "U3RvcDpIU0w6OTIyMjIxMA==",
lat: 60.374977,
lon: 25.249123
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjIyOQ==",
lat: 60.375727,
lon: 25.267724
},
{
id: "U3RvcDpIU0w6OTIyMjIyNg==",
lat: 60.371818,
lon: 25.262633
},
{
id: "U3RvcDpIU0w6OTIyMjIyMQ==",
lat: 60.37037,
lon: 25.258497
},
{
id: "U3RvcDpIU0w6OTIxNjIxMw==",
lat: 60.363567,
lon: 25.26105
},
{
id: "U3RvcDpIU0w6OTIxNjIxOA==",
lat: 60.35467,
lon: 25.265408
},
{
id: "U3RvcDpIU0w6OTIxNjIxNQ==",
lat: 60.350546,
lon: 25.2606
},
{
id: "U3RvcDpIU0w6OTIxNTIwNw==",
lat: 60.347407,
lon: 25.257307
},
{
id: "U3RvcDpIU0w6OTIxNTIwMw==",
lat: 60.340095,
lon: 25.246608
},
{
id: "U3RvcDpIU0w6OTIxNTIwMg==",
lat: 60.338485,
lon: 25.241048
},
{
id: "U3RvcDpIU0w6OTIxNTIwMQ==",
lat: 60.333942,
lon: 25.223853
},
{
id: "U3RvcDpIU0w6OTIxNTIwNA==",
lat: 60.339568,
lon: 25.245693
},
{
id: "U3RvcDpIU0w6OTIxNTIwNQ==",
lat: 60.340412,
lon: 25.248128
},
{
id: "U3RvcDpIU0w6OTIxNTIwOA==",
lat: 60.347518,
lon: 25.257662
},
{
id: "U3RvcDpIU0w6OTIxNjIxNg==",
lat: 60.350672,
lon: 25.261497
},
{
id: "U3RvcDpIU0w6OTIxNjIxOQ==",
lat: 60.356245,
lon: 25.266868
},
{
id: "U3RvcDpIU0w6OTIxNjIxNA==",
lat: 60.363368,
lon: 25.261563
},
{
id: "U3RvcDpIU0w6OTIyMjI0MA==",
lat: 60.369115,
lon: 25.258614
},
{
id: "U3RvcDpIU0w6OTIyMjIyMg==",
lat: 60.370252,
lon: 25.258915
},
{
id: "U3RvcDpIU0w6OTIyMjIyNQ==",
lat: 60.371527,
lon: 25.262477
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMQ==",
lat: 60.375065,
lon: 25.249352
},
{
id: "U3RvcDpIU0w6OTIyMjIwNA==",
lat: 60.378962,
lon: 25.237448
},
{
id: "U3RvcDpIU0w6OTIxOTIxNQ==",
lat: 60.381683,
lon: 25.23422
},
{
id: "U3RvcDpIU0w6OTIxOTIxNA==",
lat: 60.390622,
lon: 25.235358
},
{
id: "U3RvcDpIU0w6OTIxOTIwOQ==",
lat: 60.394913,
lon: 25.224953
},
{
id: "U3RvcDpIU0w6OTIxODIwOQ==",
lat: 60.400255,
lon: 25.200552
},
{
id: "U3RvcDpIU0w6OTIxNzIyMg==",
lat: 60.402442,
lon: 25.190088
},
{
id: "U3RvcDpIU0w6OTIxNzIyMA==",
lat: 60.406852,
lon: 25.175837
},
{
id: "U3RvcDpIU0w6OTIxNzIxMQ==",
lat: 60.40764,
lon: 25.169534
},
{
id: "U3RvcDpIU0w6OTIxNzIwNA==",
lat: 60.408213,
lon: 25.157368
},
{
id: "U3RvcDpIU0w6OTIxNzIwOQ==",
lat: 60.410837,
lon: 25.165923
},
{
id: "U3RvcDpIU0w6OTIxNzIxMw==",
lat: 60.41258,
lon: 25.171132
}
]
},
{
gtfsId: "HSL:2553K",
shortName: "553K",
longName: "Hakunila-Malmi-Maunula-Leppävaara",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk0MDIzMQ==",
lat: 60.28098,
lon: 25.10949
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNQ==",
lat: 60.27901,
lon: 25.10592
},
{
id: "U3RvcDpIU0w6NDk0MDIxMw==",
lat: 60.28017,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDk0MDIxMQ==",
lat: 60.280871,
lon: 25.095651
},
{
id: "U3RvcDpIU0w6NDY0MDIzMw==",
lat: 60.280881,
lon: 25.087622
},
{
id: "U3RvcDpIU0w6NDY0MDIyOQ==",
lat: 60.277777,
lon: 25.083641
},
{
id: "U3RvcDpIU0w6NDY0MDIzMQ==",
lat: 60.28081,
lon: 25.08328
},
{
id: "U3RvcDpIU0w6NDY0MDIxMQ==",
lat: 60.28169,
lon: 25.07941
},
{
id: "U3RvcDpIU0w6NDY0MDIxMw==",
lat: 60.27837,
lon: 25.07894
},
{
id: "U3RvcDpIU0w6MTQxMjE5Nw==",
lat: 60.27464,
lon: 25.077253
},
{
id: "U3RvcDpIU0w6MTQxMjEzNA==",
lat: 60.27016,
lon: 25.07203
},
{
id: "U3RvcDpIU0w6MTQxMTExOQ==",
lat: 60.26989,
lon: 25.06314
},
{
id: "U3RvcDpIU0w6MTQxMTExMQ==",
lat: 60.26945,
lon: 25.06115
},
{
id: "U3RvcDpIU0w6MTQxMTEwOA==",
lat: 60.26653,
lon: 25.05805
},
{
id: "U3RvcDpIU0w6MTQxMTEwNg==",
lat: 60.26365,
lon: 25.05666
},
{
id: "U3RvcDpIU0w6MTM4NTEwNA==",
lat: 60.26529,
lon: 25.04177
},
{
id: "U3RvcDpIU0w6MTM4NTE2Mw==",
lat: 60.26207,
lon: 25.04015
},
{
id: "U3RvcDpIU0w6MTM4NTE2MQ==",
lat: 60.25598,
lon: 25.03172
},
{
id: "U3RvcDpIU0w6MTM4MjE1OQ==",
lat: 60.25643,
lon: 25.02386
},
{
id: "U3RvcDpIU0w6MTM4MjE2Ng==",
lat: 60.2526,
lon: 25.01394
},
{
id: "U3RvcDpIU0w6MTM4MjE2Mw==",
lat: 60.25152,
lon: 25.01215
},
{
id: "U3RvcDpIU0w6MTM4MjE3Nw==",
lat: 60.24926,
lon: 25.0077
},
{
id: "U3RvcDpIU0w6MTM3MDEyMQ==",
lat: 60.24617,
lon: 25.00154
},
{
id: "U3RvcDpIU0w6MTM4MjExOQ==",
lat: 60.24318,
lon: 24.99639
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM3MDEwNA==",
lat: 60.2399,
lon: 24.97954
},
{
id: "U3RvcDpIU0w6MTI4NDE3OA==",
lat: 60.23699,
lon: 24.97454
},
{
id: "U3RvcDpIU0w6MTI4NDE3NA==",
lat: 60.23539,
lon: 24.97034
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEyNA==",
lat: 60.23238,
lon: 24.95772
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEyNw==",
lat: 60.23022,
lon: 24.94776
},
{
id: "U3RvcDpIU0w6MTI4NDEwMw==",
lat: 60.22972,
lon: 24.94197
},
{
id: "U3RvcDpIU0w6MTI4MjEwMQ==",
lat: 60.2301,
lon: 24.93839
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MTEwNw==",
lat: 60.23472,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTM0MTExOA==",
lat: 60.23743,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTM0MTEyMA==",
lat: 60.23948,
lon: 24.92814
},
{
id: "U3RvcDpIU0w6MTMzMjEwNw==",
lat: 60.23894,
lon: 24.91321
},
{
id: "U3RvcDpIU0w6MTMzMjEzOA==",
lat: 60.236106,
lon: 24.90268
},
{
id: "U3RvcDpIU0w6MTI5NDI0Mg==",
lat: 60.23468,
lon: 24.89256
},
{
id: "U3RvcDpIU0w6MTI5NDEzNw==",
lat: 60.23296,
lon: 24.88799
},
{
id: "U3RvcDpIU0w6MTI5NDE0MQ==",
lat: 60.230629,
lon: 24.881719
},
{
id: "U3RvcDpIU0w6MTI5NDE0Mg==",
lat: 60.22844,
lon: 24.87667
},
{
id: "U3RvcDpIU0w6MTQ2NTEzMQ==",
lat: 60.22716,
lon: 24.87217
},
{
id: "U3RvcDpIU0w6MTQ2NTEzMw==",
lat: 60.22509,
lon: 24.86806
},
{
id: "U3RvcDpIU0w6MTQ2NDEzNQ==",
lat: 60.22389,
lon: 24.86523
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzIxMQ==",
lat: 60.22455,
lon: 24.84853
},
{
id: "U3RvcDpIU0w6MjAwMDIwMw==",
lat: 60.22112,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6MjExMzIwNQ==",
lat: 60.22052,
lon: 24.83286
},
{
id: "U3RvcDpIU0w6MjExMTI4MA==",
lat: 60.21955,
lon: 24.82102
},
{
id: "U3RvcDpIU0w6MjExMjI2MQ==",
lat: 60.21896,
lon: 24.816
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIzNg==",
lat: 60.21902,
lon: 24.81092
},
{
id: "U3RvcDpIU0w6MjExMjI2Mg==",
lat: 60.219276,
lon: 24.816951
},
{
id: "U3RvcDpIU0w6MjExMTI1Ng==",
lat: 60.21934,
lon: 24.8217
},
{
id: "U3RvcDpIU0w6MjExMzIwNg==",
lat: 60.22042,
lon: 24.83513
},
{
id: "U3RvcDpIU0w6MjExMzIwNA==",
lat: 60.2211,
lon: 24.84182
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMA==",
lat: 60.224845,
lon: 24.850474
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTEzNg==",
lat: 60.22436,
lon: 24.8672
},
{
id: "U3RvcDpIU0w6MTQ2NTEzNA==",
lat: 60.2258,
lon: 24.8696
},
{
id: "U3RvcDpIU0w6MTI5NDEzMg==",
lat: 60.22769,
lon: 24.87405
},
{
id: "U3RvcDpIU0w6MTI5NDE0Mw==",
lat: 60.22838,
lon: 24.87708
},
{
id: "U3RvcDpIU0w6MTI5NDEzOQ==",
lat: 60.23079,
lon: 24.8821
},
{
id: "U3RvcDpIU0w6MTI5MzEzOA==",
lat: 60.23275,
lon: 24.88788
},
{
id: "U3RvcDpIU0w6MTI5NDE4MA==",
lat: 60.23438,
lon: 24.89275
},
{
id: "U3RvcDpIU0w6MTMzMjEwNg==",
lat: 60.23566,
lon: 24.90215
},
{
id: "U3RvcDpIU0w6MTMzMjEwOA==",
lat: 60.23891,
lon: 24.91547
},
{
id: "U3RvcDpIU0w6MTM0MTEyMQ==",
lat: 60.23958,
lon: 24.9279
},
{
id: "U3RvcDpIU0w6MTM0MTExOQ==",
lat: 60.23664,
lon: 24.92902
},
{
id: "U3RvcDpIU0w6MTI4MjEwNg==",
lat: 60.23351,
lon: 24.93171
},
{
id: "U3RvcDpIU0w6MTI4MjEwNA==",
lat: 60.23154,
lon: 24.93381
},
{
id: "U3RvcDpIU0w6MTI4MjEwMg==",
lat: 60.23011,
lon: 24.9378
},
{
id: "U3RvcDpIU0w6MTI4NDEwNA==",
lat: 60.22968,
lon: 24.94452
},
{
id: "U3RvcDpIU0w6MTI4NDEyOQ==",
lat: 60.22999,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4NDEyOA==",
lat: 60.23133,
lon: 24.95398
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDE3Mg==",
lat: 60.23425,
lon: 24.96753
},
{
id: "U3RvcDpIU0w6MTI4NDE3NQ==",
lat: 60.23609,
lon: 24.97254
},
{
id: "U3RvcDpIU0w6MTM3MDEwMw==",
lat: 60.23991,
lon: 24.97993
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM4MjEyMA==",
lat: 60.24328,
lon: 24.99679
},
{
id: "U3RvcDpIU0w6MTM4MjEyMg==",
lat: 60.24685,
lon: 25.00326
},
{
id: "U3RvcDpIU0w6MTM4MjE3OA==",
lat: 60.24924,
lon: 25.00818
},
{
id: "U3RvcDpIU0w6MTM4MjE3Ng==",
lat: 60.25049,
lon: 25.01236
},
{
id: "U3RvcDpIU0w6MTM4MjE2NQ==",
lat: 60.25315,
lon: 25.01507
},
{
id: "U3RvcDpIU0w6MTM4MjE1OA==",
lat: 60.25644,
lon: 25.02477
},
{
id: "U3RvcDpIU0w6MTM4NTE2MA==",
lat: 60.25571,
lon: 25.03316
},
{
id: "U3RvcDpIU0w6MTM4NTE4MA==",
lat: 60.26301,
lon: 25.0414
},
{
id: "U3RvcDpIU0w6MTQxMTEwMw==",
lat: 60.26548,
lon: 25.04326
},
{
id: "U3RvcDpIU0w6MTQxMTEwNQ==",
lat: 60.26443,
lon: 25.05769
},
{
id: "U3RvcDpIU0w6MTQxMTEwNw==",
lat: 60.26764,
lon: 25.05906
},
{
id: "U3RvcDpIU0w6MTQxMTExMg==",
lat: 60.26956,
lon: 25.06153
},
{
id: "U3RvcDpIU0w6MTQxMjEyMA==",
lat: 60.26962,
lon: 25.06454
},
{
id: "U3RvcDpIU0w6MTQxMjI5OA==",
lat: 60.270538,
lon: 25.073418
},
{
id: "U3RvcDpIU0w6MTQxMjI5Ng==",
lat: 60.274292,
lon: 25.077007
},
{
id: "U3RvcDpIU0w6NDY0MDIxMg==",
lat: 60.27986,
lon: 25.079974
},
{
id: "U3RvcDpIU0w6NDY0MDIyNw==",
lat: 60.277949,
lon: 25.083092
},
{
id: "U3RvcDpIU0w6NDY0MDIwOQ==",
lat: 60.28153,
lon: 25.0894
},
{
id: "U3RvcDpIU0w6NDk0MDIxMA==",
lat: 60.28073,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6NDk0MDIxMg==",
lat: 60.27969,
lon: 25.10342
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDIzMg==",
lat: 60.28118,
lon: 25.10966
}
]
},
{
gtfsId: "HSL:4611B",
shortName: "611B",
longName: "Rautatientori-Siltamäki-Suutarila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEyMA==",
lat: 60.25465,
lon: 24.95468
},
{
id: "U3RvcDpIU0w6MTM1MzEyMg==",
lat: 60.25699,
lon: 24.95927
},
{
id: "U3RvcDpIU0w6NDUwMDIxMw==",
lat: 60.26534,
lon: 24.97367
},
{
id: "U3RvcDpIU0w6MTQwMzEzNQ==",
lat: 60.26514,
lon: 24.98307
},
{
id: "U3RvcDpIU0w6MTQwMTExNA==",
lat: 60.26722,
lon: 24.98012
},
{
id: "U3RvcDpIU0w6MTQwMTEwMQ==",
lat: 60.2693,
lon: 24.98338
},
{
id: "U3RvcDpIU0w6MTQwMTEwMw==",
lat: 60.27145,
lon: 24.99206
},
{
id: "U3RvcDpIU0w6MTQwMTEwNQ==",
lat: 60.27532,
lon: 24.99112
},
{
id: "U3RvcDpIU0w6MTQwMTEwNg==",
lat: 60.2774,
lon: 24.9909
},
{
id: "U3RvcDpIU0w6MTQwMTEzMQ==",
lat: 60.27863,
lon: 24.99518
},
{
id: "U3RvcDpIU0w6MTQwMTEzNA==",
lat: 60.27931,
lon: 24.99788
},
{
id: "U3RvcDpIU0w6MTQwMTEyNA==",
lat: 60.27925,
lon: 25.00451
},
{
id: "U3RvcDpIU0w6MTQwMTExMQ==",
lat: 60.27818,
lon: 25.00693
},
{
id: "U3RvcDpIU0w6MTQwMTExMw==",
lat: 60.28044,
lon: 25.01124
},
{
id: "U3RvcDpIU0w6MTQwMTEzOA==",
lat: 60.2822,
lon: 25.0134
},
{
id: "U3RvcDpIU0w6MTQwMTE0Nw==",
lat: 60.281115,
lon: 25.017071
},
{
id: "U3RvcDpIU0w6MTQwMTE0OQ==",
lat: 60.28278,
lon: 25.01751
},
{
id: "U3RvcDpIU0w6MTQwMTE1Mg==",
lat: 60.281967,
lon: 25.0119
},
{
id: "U3RvcDpIU0w6MTQwMTE4MA==",
lat: 60.27948,
lon: 25.00944
},
{
id: "U3RvcDpIU0w6MTQwMTExMg==",
lat: 60.27823,
lon: 25.00574
},
{
id: "U3RvcDpIU0w6MTQwMTEzNg==",
lat: 60.27982,
lon: 25.00405
},
{
id: "U3RvcDpIU0w6MTQwMTEzNQ==",
lat: 60.27953,
lon: 24.99857
},
{
id: "U3RvcDpIU0w6MTQwMTEzMw==",
lat: 60.27835,
lon: 24.99422
},
{
id: "U3RvcDpIU0w6MTQwMTEzMg==",
lat: 60.276818,
lon: 24.990048
},
{
id: "U3RvcDpIU0w6MTQwMTEwNw==",
lat: 60.27497,
lon: 24.99117
},
{
id: "U3RvcDpIU0w6MTQwMTEwNA==",
lat: 60.27209,
lon: 24.9922
},
{
id: "U3RvcDpIU0w6MTQwMTEwMg==",
lat: 60.26954,
lon: 24.98362
},
{
id: "U3RvcDpIU0w6MTQwMzExNQ==",
lat: 60.26636,
lon: 24.98058
},
{
id: "U3RvcDpIU0w6MTQwMzEzNA==",
lat: 60.26459,
lon: 24.98221
},
{
id: "U3RvcDpIU0w6NDUwMDIwNg==",
lat: 60.26525,
lon: 24.97251
},
{
id: "U3RvcDpIU0w6MTM1MzEyMw==",
lat: 60.25601,
lon: 24.95801
},
{
id: "U3RvcDpIU0w6MTM1MzEyMQ==",
lat: 60.254992,
lon: 24.952652
},
{
id: "U3RvcDpIU0w6MTM1MjExOQ==",
lat: 60.255037,
lon: 24.94895
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:1819",
shortName: "819",
longName: "Vuosaari(M)-Uutela",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTUzMTEwMg==",
lat: 60.206736,
lon: 25.144743
},
{
id: "U3RvcDpIU0w6MTU0NTEwMA==",
lat: 60.204815,
lon: 25.145696
},
{
id: "U3RvcDpIU0w6MTUzMTE2MA==",
lat: 60.204049,
lon: 25.147076
},
{
id: "U3RvcDpIU0w6MTU0MTE3MA==",
lat: 60.204292,
lon: 25.14943
},
{
id: "U3RvcDpIU0w6MTUzMTEyMA==",
lat: 60.204834,
lon: 25.154242
},
{
id: "U3RvcDpIU0w6MTU0MTE3Mg==",
lat: 60.205074,
lon: 25.155317
},
{
id: "U3RvcDpIU0w6MTUzMTE1MQ==",
lat: 60.20476,
lon: 25.15814
},
{
id: "U3RvcDpIU0w6MTU0MzEwMA==",
lat: 60.200119,
lon: 25.176799
},
{
id: "U3RvcDpIU0w6MTUzMTExNw==",
lat: 60.205191,
lon: 25.156313
},
{
id: "U3RvcDpIU0w6MTU0MTE3Mw==",
lat: 60.205016,
lon: 25.154828
},
{
id: "U3RvcDpIU0w6MTUzMTExOQ==",
lat: 60.20463,
lon: 25.151767
},
{
id: "U3RvcDpIU0w6MTU0MTE3MQ==",
lat: 60.204255,
lon: 25.149602
},
{
id: "U3RvcDpIU0w6MTUzMTE1OQ==",
lat: 60.204132,
lon: 25.147136
},
{
id: "U3RvcDpIU0w6MTU0NjEwMQ==",
lat: 60.204239,
lon: 25.146
},
{
id: "U3RvcDpIU0w6MTUzMjEyNQ==",
lat: 60.206672,
lon: 25.144948
},
{
id: "U3RvcDpIU0w6MTUzMTEyMQ==",
lat: 60.207775,
lon: 25.144066
}
]
},
{
gtfsId: "HSL:1818",
shortName: "818",
longName: "Vuosaari (M)-Vuosaaren satama-Mellunmäki (M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MjEwMg==",
lat: 60.23845,
lon: 25.10902
},
{
id: "U3RvcDpIU0w6MTQ3MzExMA==",
lat: 60.23737,
lon: 25.11256
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOA==",
lat: 60.23681,
lon: 25.11628
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNg==",
lat: 60.23692,
lon: 25.12131
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNA==",
lat: 60.23551,
lon: 25.12729
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMg==",
lat: 60.23253,
lon: 25.12857
},
{
id: "U3RvcDpIU0w6MTQ3MzExOQ==",
lat: 60.23115,
lon: 25.12893
},
{
id: "U3RvcDpIU0w6MTQ3MzE2OA==",
lat: 60.2323,
lon: 25.13321
},
{
id: "U3RvcDpIU0w6MTQ3MzExMg==",
lat: 60.22892,
lon: 25.13384
},
{
id: "U3RvcDpIU0w6MTU0MTE0OQ==",
lat: 60.22453,
lon: 25.1384
},
{
id: "U3RvcDpIU0w6MTU0MTEzMw==",
lat: 60.22233,
lon: 25.15061
},
{
id: "U3RvcDpIU0w6MTU0MTEyOQ==",
lat: 60.22125,
lon: 25.15398
},
{
id: "U3RvcDpIU0w6MTU0MjEzNg==",
lat: 60.221142,
lon: 25.161385
},
{
id: "U3RvcDpIU0w6MTU0ODEwNQ==",
lat: 60.22386,
lon: 25.17079
},
{
id: "U3RvcDpIU0w6MTU0ODEwNA==",
lat: 60.221504,
lon: 25.175434
},
{
id: "U3RvcDpIU0w6MTU0ODEwMQ==",
lat: 60.21917,
lon: 25.17245
},
{
id: "U3RvcDpIU0w6MTU0MjEzNw==",
lat: 60.2176,
lon: 25.1638
},
{
id: "U3RvcDpIU0w6MTU0MzEzOQ==",
lat: 60.21246,
lon: 25.17106
},
{
id: "U3RvcDpIU0w6MTU0MzE4MQ==",
lat: 60.2103,
lon: 25.17386
},
{
id: "U3RvcDpIU0w6MTU0MzE0MQ==",
lat: 60.21065,
lon: 25.17753
},
{
id: "U3RvcDpIU0w6MTU0ODEwMg==",
lat: 60.21151,
lon: 25.1751
},
{
id: "U3RvcDpIU0w6MTU0MzE0OQ==",
lat: 60.213712,
lon: 25.17587
},
{
id: "U3RvcDpIU0w6MTU0MzE0OA==",
lat: 60.21435,
lon: 25.18174
},
{
id: "U3RvcDpIU0w6MTU0ODEwNw==",
lat: 60.212649,
lon: 25.171193
},
{
id: "U3RvcDpIU0w6MTU0MjEwNA==",
lat: 60.213157,
lon: 25.167747
},
{
id: "U3RvcDpIU0w6MTU0MjEwMg==",
lat: 60.210102,
lon: 25.162402
},
{
id: "U3RvcDpIU0w6MTU0NjEwMw==",
lat: 60.2083,
lon: 25.1565
},
{
id: "U3RvcDpIU0w6MTU0MTE3Nw==",
lat: 60.2077,
lon: 25.1517
},
{
id: "U3RvcDpIU0w6MTUzMTE2Mw==",
lat: 60.20717,
lon: 25.14455
},
{
id: "U3RvcDpIU0w6MTUzMTExNg==",
lat: 60.20706,
lon: 25.14456
},
{
id: "U3RvcDpIU0w6MTU0MzEwMQ==",
lat: 60.20712,
lon: 25.14335
},
{
id: "U3RvcDpIU0w6MTU0MTE3Ng==",
lat: 60.20762,
lon: 25.15195
},
{
id: "U3RvcDpIU0w6MTU0MTE3NA==",
lat: 60.20854,
lon: 25.15843
},
{
id: "U3RvcDpIU0w6MTU0MjEwMQ==",
lat: 60.21077,
lon: 25.163977
},
{
id: "U3RvcDpIU0w6MTU0MjEwMw==",
lat: 60.21407,
lon: 25.16823
},
{
id: "U3RvcDpIU0w6MTU0MjEzOA==",
lat: 60.21651,
lon: 25.16496
},
{
id: "U3RvcDpIU0w6MTU0ODEwMA==",
lat: 60.21917,
lon: 25.1732
},
{
id: "U3RvcDpIU0w6MTU0ODEwOA==",
lat: 60.22231,
lon: 25.1734
},
{
id: "U3RvcDpIU0w6MTU0ODEwNg==",
lat: 60.224603,
lon: 25.168557
},
{
id: "U3RvcDpIU0w6MTU0ODExMg==",
lat: 60.220652,
lon: 25.159942
},
{
id: "U3RvcDpIU0w6MTU0MTEzMA==",
lat: 60.22181,
lon: 25.15238
},
{
id: "U3RvcDpIU0w6MTU0MTE0OA==",
lat: 60.22311,
lon: 25.14858
},
{
id: "U3RvcDpIU0w6MTU0MTE1MA==",
lat: 60.22475,
lon: 25.13828
},
{
id: "U3RvcDpIU0w6MTQ3MzExMQ==",
lat: 60.22977,
lon: 25.13386
},
{
id: "U3RvcDpIU0w6MTQ3MzE4Mw==",
lat: 60.23213,
lon: 25.1339
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMA==",
lat: 60.23124,
lon: 25.12868
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMQ==",
lat: 60.23339,
lon: 25.12882
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMw==",
lat: 60.23597,
lon: 25.12657
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNQ==",
lat: 60.23705,
lon: 25.11995
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNw==",
lat: 60.23693,
lon: 25.11624
},
{
id: "U3RvcDpIU0w6MTQ3MzE4MA==",
lat: 60.23855,
lon: 25.10968
}
]
},
{
gtfsId: "HSL:1817",
shortName: "817",
longName: "Vuosaari(M)-Kallahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTUzMTEwMg==",
lat: 60.206736,
lon: 25.144743
},
{
id: "U3RvcDpIU0w6MTU0NTEwMA==",
lat: 60.204815,
lon: 25.145696
},
{
id: "U3RvcDpIU0w6MTU0MTE2OQ==",
lat: 60.20368,
lon: 25.14414
},
{
id: "U3RvcDpIU0w6MTU0NTEwNg==",
lat: 60.202555,
lon: 25.142788
},
{
id: "U3RvcDpIU0w6MTU0NTEwNw==",
lat: 60.201034,
lon: 25.144987
},
{
id: "U3RvcDpIU0w6MTUzMTExMQ==",
lat: 60.200158,
lon: 25.145418
},
{
id: "U3RvcDpIU0w6MTU0NTEwMw==",
lat: 60.199849,
lon: 25.143384
},
{
id: "U3RvcDpIU0w6MTU0NTEwOQ==",
lat: 60.20142,
lon: 25.142413
},
{
id: "U3RvcDpIU0w6MTU0MTE2OA==",
lat: 60.20375,
lon: 25.14482
},
{
id: "U3RvcDpIU0w6MTU0NjEwMQ==",
lat: 60.204239,
lon: 25.146
},
{
id: "U3RvcDpIU0w6MTUzMjEyNQ==",
lat: 60.206672,
lon: 25.144948
},
{
id: "U3RvcDpIU0w6MTUzMTEyMQ==",
lat: 60.207775,
lon: 25.144066
}
]
},
{
gtfsId: "HSL:1816",
shortName: "816",
longName: "Vuosaari(M)-Ramsinniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTUzMTEwMg==",
lat: 60.206736,
lon: 25.144743
},
{
id: "U3RvcDpIU0w6MTU0NTEwMA==",
lat: 60.204815,
lon: 25.145696
},
{
id: "U3RvcDpIU0w6MTU0MTE2OQ==",
lat: 60.20368,
lon: 25.14414
},
{
id: "U3RvcDpIU0w6MTU0MTE2Nw==",
lat: 60.20293,
lon: 25.13906
},
{
id: "U3RvcDpIU0w6MTU0MTE0Ng==",
lat: 60.20222,
lon: 25.1339
},
{
id: "U3RvcDpIU0w6MTU0NTEwMQ==",
lat: 60.189967,
lon: 25.135518
},
{
id: "U3RvcDpIU0w6MTU0MTE0MA==",
lat: 60.20136,
lon: 25.12732
},
{
id: "U3RvcDpIU0w6MTU0MTE0NA==",
lat: 60.20061,
lon: 25.12267
},
{
id: "U3RvcDpIU0w6MTU0NDEwMQ==",
lat: 60.197813,
lon: 25.117414
},
{
id: "U3RvcDpIU0w6MTU0NDEwMw==",
lat: 60.196925,
lon: 25.11273
},
{
id: "U3RvcDpIU0w6MTU0NDE1NQ==",
lat: 60.195111,
lon: 25.114296
},
{
id: "U3RvcDpIU0w6MTU0NDEwMg==",
lat: 60.196874,
lon: 25.112749
},
{
id: "U3RvcDpIU0w6MTU0NDEwMA==",
lat: 60.197792,
lon: 25.117625
},
{
id: "U3RvcDpIU0w6MTU0MTE0Mw==",
lat: 60.20063,
lon: 25.12295
},
{
id: "U3RvcDpIU0w6MTU0MTEzOQ==",
lat: 60.201435,
lon: 25.127873
},
{
id: "U3RvcDpIU0w6MTU0MTE0NQ==",
lat: 60.2022,
lon: 25.1341
},
{
id: "U3RvcDpIU0w6MTU0MTE2Ng==",
lat: 60.20297,
lon: 25.14019
},
{
id: "U3RvcDpIU0w6MTU0MTE2OA==",
lat: 60.20375,
lon: 25.14482
},
{
id: "U3RvcDpIU0w6MTU0NjEwMQ==",
lat: 60.204239,
lon: 25.146
},
{
id: "U3RvcDpIU0w6MTUzMjEyNQ==",
lat: 60.206672,
lon: 25.144948
},
{
id: "U3RvcDpIU0w6MTUzMTEyMQ==",
lat: 60.207775,
lon: 25.144066
}
]
},
{
gtfsId: "HSL:1815",
shortName: "815",
longName: "Vuosaari(M)-Isonvillasaarentie",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTUzMTEyMQ==",
lat: 60.207775,
lon: 25.144066
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mw==",
lat: 60.2094,
lon: 25.14272
},
{
id: "U3RvcDpIU0w6MTU0MTEwMA==",
lat: 60.210532,
lon: 25.143965
},
{
id: "U3RvcDpIU0w6MTUzMTEwMw==",
lat: 60.211633,
lon: 25.143192
},
{
id: "U3RvcDpIU0w6MTU0MTE1Mw==",
lat: 60.214096,
lon: 25.144882
},
{
id: "U3RvcDpIU0w6MTU0MTEyNw==",
lat: 60.21637,
lon: 25.14786
},
{
id: "U3RvcDpIU0w6MTU0MjEyOQ==",
lat: 60.21902,
lon: 25.14635
},
{
id: "U3RvcDpIU0w6MTUzMjEwNw==",
lat: 60.220418,
lon: 25.14541
},
{
id: "U3RvcDpIU0w6MTUzMTEwNg==",
lat: 60.22115,
lon: 25.14206
},
{
id: "U3RvcDpIU0w6MTUzMjEwOA==",
lat: 60.220448,
lon: 25.145267
},
{
id: "U3RvcDpIU0w6MTU0MTEzMg==",
lat: 60.21981,
lon: 25.14579
},
{
id: "U3RvcDpIU0w6MTUzMTExOA==",
lat: 60.218699,
lon: 25.142167
},
{
id: "U3RvcDpIU0w6MTU0MjEzMA==",
lat: 60.21815,
lon: 25.14657
},
{
id: "U3RvcDpIU0w6MTU0MTEyOA==",
lat: 60.21576,
lon: 25.1474
},
{
id: "U3RvcDpIU0w6MTU0MTE1NA==",
lat: 60.214106,
lon: 25.144756
},
{
id: "U3RvcDpIU0w6MTUzMTEwNA==",
lat: 60.21211,
lon: 25.143058
},
{
id: "U3RvcDpIU0w6MTU0MTEyMQ==",
lat: 60.20962,
lon: 25.143453
},
{
id: "U3RvcDpIU0w6MTU0MTEyMg==",
lat: 60.209612,
lon: 25.143424
},
{
id: "U3RvcDpIU0w6MTU0MTE2NA==",
lat: 60.209178,
lon: 25.142691
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mg==",
lat: 60.20747,
lon: 25.14414
}
]
},
{
gtfsId: "HSL:1814",
shortName: "814",
longName: "Vuosaari(M)-Koukkusaarentie",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTUzMTEyMg==",
lat: 60.216697,
lon: 25.134118
},
{
id: "U3RvcDpIU0w6MTUzMTEyMw==",
lat: 60.215763,
lon: 25.134552
},
{
id: "U3RvcDpIU0w6MTU0MTIxOA==",
lat: 60.212982,
lon: 25.134375
},
{
id: "U3RvcDpIU0w6MTU0MTEwOA==",
lat: 60.21147,
lon: 25.13517
},
{
id: "U3RvcDpIU0w6MTU0MTExMA==",
lat: 60.20909,
lon: 25.13594
},
{
id: "U3RvcDpIU0w6MTUzMjEwMA==",
lat: 60.20718,
lon: 25.136948
},
{
id: "U3RvcDpIU0w6MTU0MTE1Nw==",
lat: 60.20344,
lon: 25.13657
},
{
id: "U3RvcDpIU0w6MTU0MTE2Ng==",
lat: 60.20297,
lon: 25.14019
},
{
id: "U3RvcDpIU0w6MTU0MTE2OA==",
lat: 60.20375,
lon: 25.14482
},
{
id: "U3RvcDpIU0w6MTU0NjEwMQ==",
lat: 60.204239,
lon: 25.146
},
{
id: "U3RvcDpIU0w6MTUzMjEyNQ==",
lat: 60.206672,
lon: 25.144948
},
{
id: "U3RvcDpIU0w6MTUzMTEyMQ==",
lat: 60.207775,
lon: 25.144066
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mw==",
lat: 60.2094,
lon: 25.14272
},
{
id: "U3RvcDpIU0w6MTUzMjEwOQ==",
lat: 60.210036,
lon: 25.137796
},
{
id: "U3RvcDpIU0w6MTUzMjEwMQ==",
lat: 60.211752,
lon: 25.137133
},
{
id: "U3RvcDpIU0w6MTUzMTExMA==",
lat: 60.212913,
lon: 25.139195
},
{
id: "U3RvcDpIU0w6MTU0MTEwOQ==",
lat: 60.21247,
lon: 25.13492
}
]
},
{
gtfsId: "HSL:1016X",
shortName: "16X",
longName: "Rautatientori - Korkeasaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQyMDEyMA==",
lat: 60.18011,
lon: 24.98351
},
{
id: "U3RvcDpIU0w6MTQyMDEyNg==",
lat: 60.18032,
lon: 24.99033
},
{
id: "U3RvcDpIU0w6MTQyMDEyMg==",
lat: 60.18212,
lon: 24.99321
},
{
id: "U3RvcDpIU0w6MTQyMDExNA==",
lat: 60.18526,
lon: 25.00113
},
{
id: "U3RvcDpIU0w6MTQyMDEwNA==",
lat: 60.18584,
lon: 25.00085
},
{
id: "U3RvcDpIU0w6MTQyMDEwMg==",
lat: 60.18566,
lon: 24.99588
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTAxMDExMA==",
lat: 60.17433,
lon: 24.96023
},
{
id: "U3RvcDpIU0w6MTAxMDEwOA==",
lat: 60.174297,
lon: 24.956514
},
{
id: "U3RvcDpIU0w6MTAxMDEyNQ==",
lat: 60.17407,
lon: 24.95208
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:1813",
shortName: "813",
longName: "Vuosaari(M)-Pohjoinen ostoskeskus",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTU0MTE4NQ==",
lat: 60.22182,
lon: 25.140423
},
{
id: "U3RvcDpIU0w6MTU0MTE4NA==",
lat: 60.222197,
lon: 25.136017
},
{
id: "U3RvcDpIU0w6MTU0MTA0Nw==",
lat: 60.222273,
lon: 25.134413
},
{
id: "U3RvcDpIU0w6MTUzMjExMQ==",
lat: 60.222205,
lon: 25.131903
},
{
id: "U3RvcDpIU0w6MTUzMjExMw==",
lat: 60.221195,
lon: 25.12927
},
{
id: "U3RvcDpIU0w6MTUzMjExNQ==",
lat: 60.219952,
lon: 25.127712
},
{
id: "U3RvcDpIU0w6MTUzMjExNw==",
lat: 60.217976,
lon: 25.125623
},
{
id: "U3RvcDpIU0w6MTUzMjExNg==",
lat: 60.220103,
lon: 25.127933
},
{
id: "U3RvcDpIU0w6MTUzMjExNA==",
lat: 60.22156,
lon: 25.129716
},
{
id: "U3RvcDpIU0w6MTUzMjExMg==",
lat: 60.222174,
lon: 25.132425
},
{
id: "U3RvcDpIU0w6MTUzMjExOA==",
lat: 60.220471,
lon: 25.133173
},
{
id: "U3RvcDpIU0w6MTUzMjEyMA==",
lat: 60.219949,
lon: 25.130183
},
{
id: "U3RvcDpIU0w6MTUzMTEwNw==",
lat: 60.218662,
lon: 25.12939
},
{
id: "U3RvcDpIU0w6MTUzMTEwOQ==",
lat: 60.216127,
lon: 25.128913
},
{
id: "U3RvcDpIU0w6MTU0MTEwNA==",
lat: 60.21717,
lon: 25.13261
},
{
id: "U3RvcDpIU0w6MTU0MTEwNg==",
lat: 60.21508,
lon: 25.13342
},
{
id: "U3RvcDpIU0w6MTUzMjEyMw==",
lat: 60.213508,
lon: 25.132622
},
{
id: "U3RvcDpIU0w6MTU0MTE5OQ==",
lat: 60.213172,
lon: 25.130205
},
{
id: "U3RvcDpIU0w6MTU0MTE5Nw==",
lat: 60.21215,
lon: 25.126443
},
{
id: "U3RvcDpIU0w6MTU0MTE4OQ==",
lat: 60.210968,
lon: 25.124372
},
{
id: "U3RvcDpIU0w6MTU0MTE2NQ==",
lat: 60.209622,
lon: 25.130578
},
{
id: "U3RvcDpIU0w6MTU0MTE1Mg==",
lat: 60.209607,
lon: 25.134998
},
{
id: "U3RvcDpIU0w6MTU0MTEyMA==",
lat: 60.20957,
lon: 25.13682
},
{
id: "U3RvcDpIU0w6MTU0MTE2NA==",
lat: 60.209178,
lon: 25.142691
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mg==",
lat: 60.20747,
lon: 25.14414
},
{
id: "U3RvcDpIU0w6MTUzMTEyMQ==",
lat: 60.207775,
lon: 25.144066
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mw==",
lat: 60.2094,
lon: 25.14272
},
{
id: "U3RvcDpIU0w6MTU0MTE1MQ==",
lat: 60.209652,
lon: 25.135162
},
{
id: "U3RvcDpIU0w6MTU0MTE1OQ==",
lat: 60.209697,
lon: 25.12993
},
{
id: "U3RvcDpIU0w6MTU0MTE4Ng==",
lat: 60.210867,
lon: 25.124432
},
{
id: "U3RvcDpIU0w6MTU0MTE5NA==",
lat: 60.212043,
lon: 25.12635
},
{
id: "U3RvcDpIU0w6MTU0MTE5OA==",
lat: 60.21326,
lon: 25.131213
},
{
id: "U3RvcDpIU0w6MTUzMjEyNA==",
lat: 60.213566,
lon: 25.133355
},
{
id: "U3RvcDpIU0w6MTU0MTIwNw==",
lat: 60.214381,
lon: 25.133902
},
{
id: "U3RvcDpIU0w6MTU0MTEwNw==",
lat: 60.21597,
lon: 25.13316
},
{
id: "U3RvcDpIU0w6MTUzMjEyMg==",
lat: 60.217769,
lon: 25.132165
},
{
id: "U3RvcDpIU0w6MTUzMTEwOA==",
lat: 60.218564,
lon: 25.129396
},
{
id: "U3RvcDpIU0w6MTUzMjEyMQ==",
lat: 60.219903,
lon: 25.130642
},
{
id: "U3RvcDpIU0w6MTUzMjExOQ==",
lat: 60.22049,
lon: 25.132235
},
{
id: "U3RvcDpIU0w6MTU0MTEwMw==",
lat: 60.22095,
lon: 25.13417
},
{
id: "U3RvcDpIU0w6MTU0MTE4Mw==",
lat: 60.222218,
lon: 25.135912
}
]
},
{
gtfsId: "HSL:4623K",
shortName: "623K",
longName: "Hakaniemi-Peijas",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTExMTExNw==",
lat: 60.179463,
lon: 24.952195
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDY4MDI1MQ==",
lat: 60.28629,
lon: 24.98319
},
{
id: "U3RvcDpIU0w6NDY4MDI0OQ==",
lat: 60.29431,
lon: 24.98431
},
{
id: "U3RvcDpIU0w6NDY4MDIxNw==",
lat: 60.29991,
lon: 24.98982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMg==",
lat: 60.307715,
lon: 24.999454
},
{
id: "U3RvcDpIU0w6NDY3MDIxNg==",
lat: 60.31302,
lon: 24.99868
},
{
id: "U3RvcDpIU0w6NDY3MDIwNQ==",
lat: 60.31623,
lon: 25.0045
},
{
id: "U3RvcDpIU0w6NDY3MDIwNg==",
lat: 60.31488,
lon: 25.01453
},
{
id: "U3RvcDpIU0w6NDY3MDIwOA==",
lat: 60.31332,
lon: 25.01609
},
{
id: "U3RvcDpIU0w6NDY1MDIxMg==",
lat: 60.30758,
lon: 25.02169
},
{
id: "U3RvcDpIU0w6NDY1MDIwMw==",
lat: 60.30689,
lon: 25.02499
},
{
id: "U3RvcDpIU0w6NDY1MDIwNQ==",
lat: 60.31,
lon: 25.0287
},
{
id: "U3RvcDpIU0w6NDY1MDIwNw==",
lat: 60.31132,
lon: 25.03142
},
{
id: "U3RvcDpIU0w6NDY1MDIwOQ==",
lat: 60.31516,
lon: 25.03566
},
{
id: "U3RvcDpIU0w6NDcwMDIwMQ==",
lat: 60.3203,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDcwMDIyOA==",
lat: 60.32246,
lon: 25.042177
},
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyMg==",
lat: 60.32129,
lon: 25.04674
},
{
id: "U3RvcDpIU0w6NDcwMDIxOQ==",
lat: 60.31986,
lon: 25.05256
},
{
id: "U3RvcDpIU0w6NDc0MDIyNA==",
lat: 60.31925,
lon: 25.06135
},
{
id: "U3RvcDpIU0w6NDc0MDIxNA==",
lat: 60.32079,
lon: 25.06203
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcwMDIxMg==",
lat: 60.32442,
lon: 25.05655
},
{
id: "U3RvcDpIU0w6NDcyMDIyMg==",
lat: 60.32719,
lon: 25.05898
},
{
id: "U3RvcDpIU0w6NDcyMDIwMQ==",
lat: 60.32842,
lon: 25.06048
},
{
id: "U3RvcDpIU0w6NDcyMDIxNg==",
lat: 60.33213,
lon: 25.06075
},
{
id: "U3RvcDpIU0w6NDcyMDIwOQ==",
lat: 60.33219,
lon: 25.06038
},
{
id: "U3RvcDpIU0w6NDcyMDIwMg==",
lat: 60.32859,
lon: 25.06035
},
{
id: "U3RvcDpIU0w6NDcyMDIyMw==",
lat: 60.32621,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNQ==",
lat: 60.32133,
lon: 25.06167
},
{
id: "U3RvcDpIU0w6NDc0MDIzMg==",
lat: 60.31914,
lon: 25.05967
},
{
id: "U3RvcDpIU0w6NDcwMDIyMw==",
lat: 60.32062,
lon: 25.05047
},
{
id: "U3RvcDpIU0w6NDcwMDIyNA==",
lat: 60.32183,
lon: 25.04486
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
},
{
id: "U3RvcDpIU0w6NDcwMDIyOQ==",
lat: 60.322323,
lon: 25.042012
},
{
id: "U3RvcDpIU0w6NDcwMDIwMg==",
lat: 60.31968,
lon: 25.03908
},
{
id: "U3RvcDpIU0w6NDY1MDIxMA==",
lat: 60.3149,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6NDY1MDIwOA==",
lat: 60.31072,
lon: 25.03015
},
{
id: "U3RvcDpIU0w6NDY1MDIwNg==",
lat: 60.30949,
lon: 25.02695
},
{
id: "U3RvcDpIU0w6NDY1MDIwNA==",
lat: 60.30635,
lon: 25.02439
},
{
id: "U3RvcDpIU0w6NDY1MDIxMQ==",
lat: 60.30783,
lon: 25.02128
},
{
id: "U3RvcDpIU0w6NDY3MDIwOQ==",
lat: 60.31333,
lon: 25.01636
},
{
id: "U3RvcDpIU0w6NDY3MDIwNw==",
lat: 60.31545,
lon: 25.01216
},
{
id: "U3RvcDpIU0w6NDY3MDIwNA==",
lat: 60.31644,
lon: 25.00259
},
{
id: "U3RvcDpIU0w6NDY3MDIyMQ==",
lat: 60.31554,
lon: 24.99887
},
{
id: "U3RvcDpIU0w6NDY3MDIxNQ==",
lat: 60.31214,
lon: 24.99851
},
{
id: "U3RvcDpIU0w6NDY4MDIzMw==",
lat: 60.30751,
lon: 24.99824
},
{
id: "U3RvcDpIU0w6NDY4MDIxOA==",
lat: 60.3012,
lon: 24.98972
},
{
id: "U3RvcDpIU0w6NDY4MDI1MA==",
lat: 60.29421,
lon: 24.98286
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mg==",
lat: 60.28722,
lon: 24.97696
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTE1MA==",
lat: 60.178205,
lon: 24.951532
}
]
},
{
gtfsId: "HSL:1812",
shortName: "812",
longName: "Mellunmäki-Herttoniemi(M)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ3MzE5MQ==",
lat: 60.232995,
lon: 25.122397
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMQ==",
lat: 60.23339,
lon: 25.12882
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMw==",
lat: 60.23597,
lon: 25.12657
},
{
id: "U3RvcDpIU0w6MTQ3MzExNg==",
lat: 60.23863,
lon: 25.122559
},
{
id: "U3RvcDpIU0w6MTQ3MzExNA==",
lat: 60.239352,
lon: 25.119588
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNQ==",
lat: 60.23705,
lon: 25.11995
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNw==",
lat: 60.23693,
lon: 25.11624
},
{
id: "U3RvcDpIU0w6MTQ3MzEyNQ==",
lat: 60.238572,
lon: 25.113675
},
{
id: "U3RvcDpIU0w6MTQ3MzE4Mg==",
lat: 60.238195,
lon: 25.109901
},
{
id: "U3RvcDpIU0w6MTQ3MjEzNQ==",
lat: 60.239857,
lon: 25.103392
},
{
id: "U3RvcDpIU0w6MTQ3MjExMQ==",
lat: 60.240887,
lon: 25.10055
},
{
id: "U3RvcDpIU0w6MTQ3MjEwNA==",
lat: 60.24155,
lon: 25.102138
},
{
id: "U3RvcDpIU0w6MTQ3MjEwOQ==",
lat: 60.242467,
lon: 25.100397
},
{
id: "U3RvcDpIU0w6MTQ3MjEwNw==",
lat: 60.243747,
lon: 25.094923
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMg==",
lat: 60.243524,
lon: 25.087752
},
{
id: "U3RvcDpIU0w6MTQ3MTEwOA==",
lat: 60.243585,
lon: 25.08584
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mg==",
lat: 60.241694,
lon: 25.086211
},
{
id: "U3RvcDpIU0w6MTQ3MTEwNQ==",
lat: 60.23883,
lon: 25.084705
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Mw==",
lat: 60.237977,
lon: 25.08401
},
{
id: "U3RvcDpIU0w6MTQ3MTEwNg==",
lat: 60.238799,
lon: 25.084924
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MA==",
lat: 60.23846,
lon: 25.0869
},
{
id: "U3RvcDpIU0w6MTQ3MTExNw==",
lat: 60.23608,
lon: 25.08512
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOA==",
lat: 60.235943,
lon: 25.080696
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NA==",
lat: 60.23335,
lon: 25.07789
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mg==",
lat: 60.231,
lon: 25.0756
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Ng==",
lat: 60.22852,
lon: 25.07353
},
{
id: "U3RvcDpIU0w6MTQ3MTE5MA==",
lat: 60.23081,
lon: 25.07872
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Ng==",
lat: 60.23179,
lon: 25.08045
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Nw==",
lat: 60.23065,
lon: 25.0857
},
{
id: "U3RvcDpIU0w6MTQ3MTExMQ==",
lat: 60.232415,
lon: 25.088397
},
{
id: "U3RvcDpIU0w6MTQ3MTE2MQ==",
lat: 60.23459,
lon: 25.086745
},
{
id: "U3RvcDpIU0w6MTQ3MTExMg==",
lat: 60.232783,
lon: 25.088534
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNg==",
lat: 60.2287,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNA==",
lat: 60.22677,
lon: 25.08374
},
{
id: "U3RvcDpIU0w6MTQ3MTExNA==",
lat: 60.224607,
lon: 25.084945
},
{
id: "U3RvcDpIU0w6MTQ1NDEyNw==",
lat: 60.223605,
lon: 25.082473
},
{
id: "U3RvcDpIU0w6MTQ1NDEwOQ==",
lat: 60.222925,
lon: 25.069883
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MA==",
lat: 60.22444,
lon: 25.07567
},
{
id: "U3RvcDpIU0w6MTQ1NDExMA==",
lat: 60.225633,
lon: 25.077135
},
{
id: "U3RvcDpIU0w6MTQ1NDEzOA==",
lat: 60.225707,
lon: 25.076062
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Mw==",
lat: 60.22775,
lon: 25.0709
},
{
id: "U3RvcDpIU0w6MTQ1NDEwNw==",
lat: 60.223948,
lon: 25.067693
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NQ==",
lat: 60.227,
lon: 25.06296
},
{
id: "U3RvcDpIU0w6MTQ1NDEwNg==",
lat: 60.224853,
lon: 25.063299
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Nw==",
lat: 60.22353,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OQ==",
lat: 60.22198,
lon: 25.05776
},
{
id: "U3RvcDpIU0w6MTQ1NDE1Nw==",
lat: 60.22014,
lon: 25.05738
},
{
id: "U3RvcDpIU0w6MTQ1NDExOQ==",
lat: 60.218012,
lon: 25.059017
},
{
id: "U3RvcDpIU0w6MTQ1NDEyMA==",
lat: 60.21841,
lon: 25.04887
},
{
id: "U3RvcDpIU0w6MTQ1NDE4NA==",
lat: 60.21495,
lon: 25.04414
},
{
id: "U3RvcDpIU0w6MTQzMTEzNg==",
lat: 60.2123,
lon: 25.03822
},
{
id: "U3RvcDpIU0w6MTQzMTEzNA==",
lat: 60.209183,
lon: 25.037994
},
{
id: "U3RvcDpIU0w6MTQzMTE1MQ==",
lat: 60.207202,
lon: 25.036953
},
{
id: "U3RvcDpIU0w6MTQzMTE0OA==",
lat: 60.20553,
lon: 25.03599
},
{
id: "U3RvcDpIU0w6MTQzMTE0Ng==",
lat: 60.20423,
lon: 25.03388
},
{
id: "U3RvcDpIU0w6MTQzMTE0NA==",
lat: 60.20156,
lon: 25.03135
},
{
id: "U3RvcDpIU0w6MTQzMTE0Mg==",
lat: 60.19926,
lon: 25.03136
},
{
id: "U3RvcDpIU0w6MTQzMTEyMQ==",
lat: 60.194648,
lon: 25.029453
},
{
id: "U3RvcDpIU0w6MTQzMTEzOQ==",
lat: 60.19542,
lon: 25.03125
},
{
id: "U3RvcDpIU0w6MTQzMTE0MQ==",
lat: 60.19795,
lon: 25.03163
},
{
id: "U3RvcDpIU0w6MTQzMTE0Mw==",
lat: 60.20234,
lon: 25.03197
},
{
id: "U3RvcDpIU0w6MTQzMTE0NQ==",
lat: 60.20462,
lon: 25.03467
},
{
id: "U3RvcDpIU0w6MTQzMTE0Nw==",
lat: 60.20579,
lon: 25.03667
},
{
id: "U3RvcDpIU0w6MTQzMTE1Mg==",
lat: 60.207652,
lon: 25.037388
},
{
id: "U3RvcDpIU0w6MTQzMTEzMw==",
lat: 60.209329,
lon: 25.037957
},
{
id: "U3RvcDpIU0w6MTQzMTEzNQ==",
lat: 60.21268,
lon: 25.03878
},
{
id: "U3RvcDpIU0w6MTQzMTEzNw==",
lat: 60.21487,
lon: 25.04418
},
{
id: "U3RvcDpIU0w6MTQ1NDEyMQ==",
lat: 60.218421,
lon: 25.047586
},
{
id: "U3RvcDpIU0w6MTQ1NDExOA==",
lat: 60.218648,
lon: 25.058152
},
{
id: "U3RvcDpIU0w6MTQ1NDE1Ng==",
lat: 60.21997,
lon: 25.05752
},
{
id: "U3RvcDpIU0w6MTQ1NDE1MA==",
lat: 60.22192,
lon: 25.05795
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OA==",
lat: 60.22447,
lon: 25.05881
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Ng==",
lat: 60.22731,
lon: 25.06406
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NA==",
lat: 60.22739,
lon: 25.07177
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MQ==",
lat: 60.2236,
lon: 25.07608
},
{
id: "U3RvcDpIU0w6MTQ1NDExNQ==",
lat: 60.223549,
lon: 25.082989
},
{
id: "U3RvcDpIU0w6MTQ3MTE2NA==",
lat: 60.225494,
lon: 25.083088
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMw==",
lat: 60.22723,
lon: 25.08458
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNQ==",
lat: 60.22981,
lon: 25.08912
},
{
id: "U3RvcDpIU0w6MTQ3MTE1OA==",
lat: 60.23084,
lon: 25.08527
},
{
id: "U3RvcDpIU0w6MTQ3MTE4NQ==",
lat: 60.2317,
lon: 25.08121
},
{
id: "U3RvcDpIU0w6MTQ3MTE5MQ==",
lat: 60.23008,
lon: 25.0777
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NQ==",
lat: 60.22913,
lon: 25.074
},
{
id: "U3RvcDpIU0w6MTQ3MTE3MQ==",
lat: 60.23145,
lon: 25.07625
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mw==",
lat: 60.23353,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNw==",
lat: 60.235733,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6MTQ3MTExOA==",
lat: 60.23638,
lon: 25.08713
},
{
id: "U3RvcDpIU0w6MTQ3MTE0OQ==",
lat: 60.23947,
lon: 25.0862
},
{
id: "U3RvcDpIU0w6MTQ3MTE1MQ==",
lat: 60.24156,
lon: 25.08644
},
{
id: "U3RvcDpIU0w6MTQ3MjE1Mw==",
lat: 60.243574,
lon: 25.088205
},
{
id: "U3RvcDpIU0w6MTQ3MjEwNg==",
lat: 60.2441,
lon: 25.092507
},
{
id: "U3RvcDpIU0w6MTQ3MjEwOA==",
lat: 60.242326,
lon: 25.100387
},
{
id: "U3RvcDpIU0w6MTQ3MjExMA==",
lat: 60.240835,
lon: 25.100391
},
{
id: "U3RvcDpIU0w6MTQ3MjEwMA==",
lat: 60.23998,
lon: 25.102835
},
{
id: "U3RvcDpIU0w6MTQ3MzExOA==",
lat: 60.23811,
lon: 25.10922
},
{
id: "U3RvcDpIU0w6MTQ3MzEyNA==",
lat: 60.238533,
lon: 25.113694
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOA==",
lat: 60.23681,
lon: 25.11628
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNg==",
lat: 60.23692,
lon: 25.12131
},
{
id: "U3RvcDpIU0w6MTQ3MzEwNA==",
lat: 60.23551,
lon: 25.12729
},
{
id: "U3RvcDpIU0w6MTQ3MzEwMg==",
lat: 60.23253,
lon: 25.12857
}
]
},
{
gtfsId: "HSL:1039N",
shortName: "39N",
longName: "Asema-aukio-Munkkiniemi-Konala-Malminkartano-Honkasuo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDE3MQ==",
lat: 60.170863,
lon: 24.938568
},
{
id: "U3RvcDpIU0w6MTA0MDExNw==",
lat: 60.16875,
lon: 24.9353
},
{
id: "U3RvcDpIU0w6MTA0MDE0NA==",
lat: 60.169432,
lon: 24.930045
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEyNw==",
lat: 60.180264,
lon: 24.921903
},
{
id: "U3RvcDpIU0w6MTE0MDEyOQ==",
lat: 60.18153,
lon: 24.92058
},
{
id: "U3RvcDpIU0w6MTE0MDEzMQ==",
lat: 60.18341,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE0MDEzMw==",
lat: 60.18581,
lon: 24.91596
},
{
id: "U3RvcDpIU0w6MTE1MDEwNw==",
lat: 60.189912,
lon: 24.909831
},
{
id: "U3RvcDpIU0w6MTE1MDEwOQ==",
lat: 60.19067,
lon: 24.90781
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MTMwNDEyNw==",
lat: 60.20289,
lon: 24.88189
},
{
id: "U3RvcDpIU0w6MTMwNDEzNg==",
lat: 60.20573,
lon: 24.88058
},
{
id: "U3RvcDpIU0w6MTI5MTEzOA==",
lat: 60.21059,
lon: 24.8809
},
{
id: "U3RvcDpIU0w6MTQ2NTE3Nw==",
lat: 60.213022,
lon: 24.879553
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzExNQ==",
lat: 60.22716,
lon: 24.85318
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MA==",
lat: 60.2288,
lon: 24.84913
},
{
id: "U3RvcDpIU0w6MTMyMDEwMQ==",
lat: 60.23253,
lon: 24.84661
},
{
id: "U3RvcDpIU0w6MTMyMDEwMw==",
lat: 60.23558,
lon: 24.84705
},
{
id: "U3RvcDpIU0w6MTMyMDEwNw==",
lat: 60.239,
lon: 24.84645
},
{
id: "U3RvcDpIU0w6MTMyMDEwOA==",
lat: 60.2415,
lon: 24.84299
},
{
id: "U3RvcDpIU0w6MTMyMDEyMw==",
lat: 60.24408,
lon: 24.8468
},
{
id: "U3RvcDpIU0w6MTMzMzE0OA==",
lat: 60.2445,
lon: 24.85189
},
{
id: "U3RvcDpIU0w6MTMzMzEzMw==",
lat: 60.24283,
lon: 24.85485
},
{
id: "U3RvcDpIU0w6MTMzMzEzNQ==",
lat: 60.2417,
lon: 24.86011
},
{
id: "U3RvcDpIU0w6MTMzMzE1MA==",
lat: 60.24376,
lon: 24.86397
},
{
id: "U3RvcDpIU0w6MTMzMzE1NA==",
lat: 60.24486,
lon: 24.86533
},
{
id: "U3RvcDpIU0w6MTMzMzE1Mg==",
lat: 60.24798,
lon: 24.86433
},
{
id: "U3RvcDpIU0w6MTMzMzE3OQ==",
lat: 60.24954,
lon: 24.86576
},
{
id: "U3RvcDpIU0w6MTMzMzE3Nw==",
lat: 60.24767,
lon: 24.85723
},
{
id: "U3RvcDpIU0w6MTMzMzE4NA==",
lat: 60.248666,
lon: 24.854758
},
{
id: "U3RvcDpIU0w6MTMzMzE4MA==",
lat: 60.25018,
lon: 24.85415
},
{
id: "U3RvcDpIU0w6MTMzMzEwNg==",
lat: 60.251215,
lon: 24.849189
},
{
id: "U3RvcDpIU0w6MTMzMzEwNw==",
lat: 60.255644,
lon: 24.844794
},
{
id: "U3RvcDpIU0w6MTMzMzEwNA==",
lat: 60.255621,
lon: 24.845597
},
{
id: "U3RvcDpIU0w6MTMzMzEwNQ==",
lat: 60.251343,
lon: 24.85015
},
{
id: "U3RvcDpIU0w6MTMzMzE4MQ==",
lat: 60.25016,
lon: 24.85356
},
{
id: "U3RvcDpIU0w6MTMzMzE4NQ==",
lat: 60.248694,
lon: 24.854632
},
{
id: "U3RvcDpIU0w6MTMzMzE3Ng==",
lat: 60.24805,
lon: 24.8595
},
{
id: "U3RvcDpIU0w6MTMzMzE3OA==",
lat: 60.24943,
lon: 24.86572
},
{
id: "U3RvcDpIU0w6MTMzMzE1Mw==",
lat: 60.24735,
lon: 24.86365
},
{
id: "U3RvcDpIU0w6MTMzMzE1NQ==",
lat: 60.24437,
lon: 24.86564
},
{
id: "U3RvcDpIU0w6MTMzMzE1MQ==",
lat: 60.24296,
lon: 24.86277
},
{
id: "U3RvcDpIU0w6MTMzMzEzNg==",
lat: 60.24158,
lon: 24.85913
},
{
id: "U3RvcDpIU0w6MTMzMzEzNA==",
lat: 60.24337,
lon: 24.85421
},
{
id: "U3RvcDpIU0w6MTMzMzE0OQ==",
lat: 60.24522,
lon: 24.85092
},
{
id: "U3RvcDpIU0w6MTMyMDExMQ==",
lat: 60.24432,
lon: 24.8467
},
{
id: "U3RvcDpIU0w6MTMyMDEwOQ==",
lat: 60.24161,
lon: 24.84268
},
{
id: "U3RvcDpIU0w6MTMyMDEwNQ==",
lat: 60.23761,
lon: 24.84672
},
{
id: "U3RvcDpIU0w6MTMyMDEwNA==",
lat: 60.23512,
lon: 24.84651
},
{
id: "U3RvcDpIU0w6MTMyMDEwMg==",
lat: 60.23233,
lon: 24.84636
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MQ==",
lat: 60.22888,
lon: 24.84861
},
{
id: "U3RvcDpIU0w6MTQ2MzExNg==",
lat: 60.22633,
lon: 24.85406
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTEzOQ==",
lat: 60.21066,
lon: 24.8805
},
{
id: "U3RvcDpIU0w6MTMwNDEzNw==",
lat: 60.206219,
lon: 24.879857
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyNA==",
lat: 60.19618,
lon: 24.88529
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
},
{
id: "U3RvcDpIU0w6MTE1MDEwOA==",
lat: 60.188734,
lon: 24.912259
},
{
id: "U3RvcDpIU0w6MTE0MDEwNQ==",
lat: 60.18479,
lon: 24.91689
},
{
id: "U3RvcDpIU0w6MTE0MDEzMA==",
lat: 60.18142,
lon: 24.92043
},
{
id: "U3RvcDpIU0w6MTE0MDEwMw==",
lat: 60.17966,
lon: 24.92227
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEwOQ==",
lat: 60.17083,
lon: 24.92517
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDEyOQ==",
lat: 60.17112,
lon: 24.93338
}
]
},
{
gtfsId: "HSL:7275",
shortName: "275",
longName: "Leppävaara-Nihtisilta-Turunväylä-Veikkola",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE3MDIxNg==",
lat: 60.282955,
lon: 24.40827
},
{
id: "U3RvcDpIU0w6NjE3MDIxNA==",
lat: 60.279164,
lon: 24.411463
},
{
id: "U3RvcDpIU0w6NjE3MDIxMg==",
lat: 60.276707,
lon: 24.416505
},
{
id: "U3RvcDpIU0w6NjE3MDIxMA==",
lat: 60.273982,
lon: 24.422243
},
{
id: "U3RvcDpIU0w6NjE3MDIwOA==",
lat: 60.272485,
lon: 24.427072
},
{
id: "U3RvcDpIU0w6NjE3MDIyOA==",
lat: 60.27056,
lon: 24.439
},
{
id: "U3RvcDpIU0w6NjE3MDIwNg==",
lat: 60.269694,
lon: 24.444329
},
{
id: "U3RvcDpIU0w6MjYxMTIxNQ==",
lat: 60.215458,
lon: 24.660593
},
{
id: "U3RvcDpIU0w6MjI0MjIxMg==",
lat: 60.20552,
lon: 24.75889
},
{
id: "U3RvcDpIU0w6MjI1MjIwNQ==",
lat: 60.206778,
lon: 24.787551
},
{
id: "U3RvcDpIU0w6MjExODI2NA==",
lat: 60.21391,
lon: 24.81666
},
{
id: "U3RvcDpIU0w6MjExMjI2Mg==",
lat: 60.219276,
lon: 24.816951
},
{
id: "U3RvcDpIU0w6MjExMjI2MQ==",
lat: 60.21896,
lon: 24.816
},
{
id: "U3RvcDpIU0w6MjExMjI2Mw==",
lat: 60.21244,
lon: 24.81549
},
{
id: "U3RvcDpIU0w6MjI1MjIwNg==",
lat: 60.207086,
lon: 24.783914
},
{
id: "U3RvcDpIU0w6MjEzMTI1MQ==",
lat: 60.20632,
lon: 24.75354
},
{
id: "U3RvcDpIU0w6MjYxMTI4OQ==",
lat: 60.215959,
lon: 24.661282
},
{
id: "U3RvcDpIU0w6NjE3MDIwNw==",
lat: 60.27008,
lon: 24.443606
},
{
id: "U3RvcDpIU0w6NjE3MDIyNw==",
lat: 60.271035,
lon: 24.437315
},
{
id: "U3RvcDpIU0w6NjE3MDIwOQ==",
lat: 60.272774,
lon: 24.426463
},
{
id: "U3RvcDpIU0w6NjE3MDIxMQ==",
lat: 60.274747,
lon: 24.421215
},
{
id: "U3RvcDpIU0w6NjE3MDIxMw==",
lat: 60.277579,
lon: 24.41515
},
{
id: "U3RvcDpIU0w6NjE3MDIxNQ==",
lat: 60.278958,
lon: 24.412177
},
{
id: "U3RvcDpIU0w6NjE3MDIxNw==",
lat: 60.283153,
lon: 24.408507
}
]
},
{
gtfsId: "HSL:6182",
shortName: "182",
longName: "Kirkkonummi-Siuntio",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMjAxMg==",
lat: 60.138558,
lon: 24.22497
},
{
id: "U3RvcDpIU0w6NjMwMjAxNg==",
lat: 60.133773,
lon: 24.229992
},
{
id: "U3RvcDpIU0w6NjMwMjAwMQ==",
lat: 60.128729,
lon: 24.232488
},
{
id: "U3RvcDpIU0w6NjMwMjAwOQ==",
lat: 60.120639,
lon: 24.239353
},
{
id: "U3RvcDpIU0w6NjMwMjAwNA==",
lat: 60.116061,
lon: 24.241087
},
{
id: "U3RvcDpIU0w6NjMwMjAxOQ==",
lat: 60.110936,
lon: 24.241778
},
{
id: "U3RvcDpIU0w6NjMwNDAwNw==",
lat: 60.102476,
lon: 24.24881
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNzAwNA==",
lat: 60.099132,
lon: 24.303275
},
{
id: "U3RvcDpIU0w6NjMwNzAwOA==",
lat: 60.099232,
lon: 24.331415
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNA==",
lat: 60.106061,
lon: 24.371492
},
{
id: "U3RvcDpIU0w6NjA1MDIwNQ==",
lat: 60.110392,
lon: 24.384672
},
{
id: "U3RvcDpIU0w6NjA0MDIwOQ==",
lat: 60.114941,
lon: 24.414073
},
{
id: "U3RvcDpIU0w6NjA0MDIxMg==",
lat: 60.115939,
lon: 24.426609
},
{
id: "U3RvcDpIU0w6NjA0MDI4NQ==",
lat: 60.118858,
lon: 24.438951
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
}
]
},
{
gtfsId: "HSL:6181",
shortName: "181",
longName: "Kirkkonummi-Siuntio",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMjAxMg==",
lat: 60.138558,
lon: 24.22497
},
{
id: "U3RvcDpIU0w6NjMwMjAxNg==",
lat: 60.133773,
lon: 24.229992
},
{
id: "U3RvcDpIU0w6NjMwMjAwMQ==",
lat: 60.128729,
lon: 24.232488
},
{
id: "U3RvcDpIU0w6NjMwMjAwOQ==",
lat: 60.120639,
lon: 24.239353
},
{
id: "U3RvcDpIU0w6NjMwMjAwNA==",
lat: 60.116061,
lon: 24.241087
},
{
id: "U3RvcDpIU0w6NjMwMjAxOQ==",
lat: 60.110936,
lon: 24.241778
},
{
id: "U3RvcDpIU0w6NjMwNDAwNw==",
lat: 60.102476,
lon: 24.24881
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNA==",
lat: 60.080806,
lon: 24.291003
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNjAwNQ==",
lat: 60.105749,
lon: 24.291215
},
{
id: "U3RvcDpIU0w6NjMwNjAwMw==",
lat: 60.114029,
lon: 24.300907
},
{
id: "U3RvcDpIU0w6NjMwNjAwMA==",
lat: 60.114131,
lon: 24.325536
},
{
id: "U3RvcDpIU0w6NjA1MDIwOQ==",
lat: 60.121223,
lon: 24.377082
},
{
id: "U3RvcDpIU0w6NjA1MDIxMQ==",
lat: 60.121985,
lon: 24.386015
},
{
id: "U3RvcDpIU0w6NjA1MDIxMw==",
lat: 60.123857,
lon: 24.399738
},
{
id: "U3RvcDpIU0w6NjA0MDIzNQ==",
lat: 60.123883,
lon: 24.40556
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA0MDIzNg==",
lat: 60.124797,
lon: 24.426783
},
{
id: "U3RvcDpIU0w6NjA0MDIzOQ==",
lat: 60.126123,
lon: 24.435517
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA0MDI5NQ==",
lat: 60.119658,
lon: 24.441538
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDIzOA==",
lat: 60.125828,
lon: 24.433405
},
{
id: "U3RvcDpIU0w6NjA0MDIzNw==",
lat: 60.125218,
lon: 24.42728
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA1MDIxOQ==",
lat: 60.12335,
lon: 24.410108
},
{
id: "U3RvcDpIU0w6NjA1MDIxNQ==",
lat: 60.123878,
lon: 24.404211
},
{
id: "U3RvcDpIU0w6NjA1MDIxNA==",
lat: 60.123608,
lon: 24.39643
},
{
id: "U3RvcDpIU0w6NjA1MDIxMg==",
lat: 60.12206,
lon: 24.385388
},
{
id: "U3RvcDpIU0w6NjA1MDIxMA==",
lat: 60.121138,
lon: 24.376124
},
{
id: "U3RvcDpIU0w6NjA1MDIxNw==",
lat: 60.117976,
lon: 24.362341
},
{
id: "U3RvcDpIU0w6NjMwNjAwMQ==",
lat: 60.114423,
lon: 24.324623
},
{
id: "U3RvcDpIU0w6NjMwNjAwMg==",
lat: 60.11389,
lon: 24.300788
},
{
id: "U3RvcDpIU0w6NjMwNjAwNA==",
lat: 60.106052,
lon: 24.290729
},
{
id: "U3RvcDpIU0w6NjMwNzAwNg==",
lat: 60.09981,
lon: 24.299634
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwOQ==",
lat: 60.096517,
lon: 24.251887
},
{
id: "U3RvcDpIU0w6NjMwNDAwOA==",
lat: 60.103516,
lon: 24.248267
},
{
id: "U3RvcDpIU0w6NjMwMjAxOA==",
lat: 60.112345,
lon: 24.241337
},
{
id: "U3RvcDpIU0w6NjMwMjAwNQ==",
lat: 60.117387,
lon: 24.241306
},
{
id: "U3RvcDpIU0w6NjMwMjAwOA==",
lat: 60.121106,
lon: 24.239152
},
{
id: "U3RvcDpIU0w6NjMwMjAwMA==",
lat: 60.130476,
lon: 24.232493
},
{
id: "U3RvcDpIU0w6NjMwMjAxNw==",
lat: 60.135228,
lon: 24.228995
}
]
},
{
gtfsId: "HSL:2225K",
shortName: "225K",
longName: "Leppävaara-Kilo-Karakallio-Viherlaakso-Lippajärvi-Högnäs",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYzMzIzMQ==",
lat: 60.248381,
lon: 24.684905
},
{
id: "U3RvcDpIU0w6MjYzMzIwNQ==",
lat: 60.24544,
lon: 24.68634
},
{
id: "U3RvcDpIU0w6MjYzMzI1OA==",
lat: 60.24266,
lon: 24.6883
},
{
id: "U3RvcDpIU0w6MjYzMzIwMQ==",
lat: 60.23991,
lon: 24.69065
},
{
id: "U3RvcDpIU0w6MjYzMjI0NQ==",
lat: 60.24055,
lon: 24.70263
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzOA==",
lat: 60.23408,
lon: 24.71654
},
{
id: "U3RvcDpIU0w6MjE1MjIzNg==",
lat: 60.23194,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjE1MjIzNA==",
lat: 60.2298,
lon: 24.71542
},
{
id: "U3RvcDpIU0w6MjE1MjIzMg==",
lat: 60.228,
lon: 24.70977
},
{
id: "U3RvcDpIU0w6MjE1MjIzMA==",
lat: 60.22545,
lon: 24.7065
},
{
id: "U3RvcDpIU0w6MzE3MDI0MQ==",
lat: 60.2239,
lon: 24.70847
},
{
id: "U3RvcDpIU0w6MjE1MTIwNg==",
lat: 60.22434,
lon: 24.72396
},
{
id: "U3RvcDpIU0w6MjE1MTIyMA==",
lat: 60.2264,
lon: 24.73029
},
{
id: "U3RvcDpIU0w6MjE1MTIxNg==",
lat: 60.22903,
lon: 24.73295
},
{
id: "U3RvcDpIU0w6MjE1MTIxNA==",
lat: 60.23065,
lon: 24.73805
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIwOA==",
lat: 60.22675,
lon: 24.74088
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMzIyNQ==",
lat: 60.2266,
lon: 24.75783
},
{
id: "U3RvcDpIU0w6MjEzMzIxNg==",
lat: 60.228636,
lon: 24.764329
},
{
id: "U3RvcDpIU0w6MjEzMzIxNA==",
lat: 60.22959,
lon: 24.76923
},
{
id: "U3RvcDpIU0w6MjEzMzIxMg==",
lat: 60.22916,
lon: 24.77474
},
{
id: "U3RvcDpIU0w6MjEzMzIxOQ==",
lat: 60.22944,
lon: 24.77787
},
{
id: "U3RvcDpIU0w6MjEzMzIxMA==",
lat: 60.22674,
lon: 24.7796
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIzNQ==",
lat: 60.22324,
lon: 24.78682
},
{
id: "U3RvcDpIU0w6MjEzMjI0Ng==",
lat: 60.21935,
lon: 24.78619
},
{
id: "U3RvcDpIU0w6MjEzMjI0NA==",
lat: 60.21692,
lon: 24.78652
},
{
id: "U3RvcDpIU0w6MjEzMjI0Mg==",
lat: 60.21727,
lon: 24.78061
},
{
id: "U3RvcDpIU0w6MjEzMjI0MA==",
lat: 60.21709,
lon: 24.77504
},
{
id: "U3RvcDpIU0w6MjEzMTI0MA==",
lat: 60.21447,
lon: 24.77096
},
{
id: "U3RvcDpIU0w6MjEzMTI0Mg==",
lat: 60.2117,
lon: 24.76733
},
{
id: "U3RvcDpIU0w6MjEzMTI0NA==",
lat: 60.21154,
lon: 24.76284
},
{
id: "U3RvcDpIU0w6MjEzMTI2NQ==",
lat: 60.21023,
lon: 24.76218
},
{
id: "U3RvcDpIU0w6MjEzMTIwNA==",
lat: 60.20862,
lon: 24.76675
},
{
id: "U3RvcDpIU0w6MjEzMTIwOA==",
lat: 60.20744,
lon: 24.77397
},
{
id: "U3RvcDpIU0w6MjEzMTIwMg==",
lat: 60.20844,
lon: 24.78725
},
{
id: "U3RvcDpIU0w6MjExMjIxOA==",
lat: 60.21005,
lon: 24.79618
},
{
id: "U3RvcDpIU0w6MjExMjIyNg==",
lat: 60.21413,
lon: 24.80096
},
{
id: "U3RvcDpIU0w6MjExMjIxNg==",
lat: 60.21408,
lon: 24.80549
},
{
id: "U3RvcDpIU0w6MjExMjIzMQ==",
lat: 60.21428,
lon: 24.81122
},
{
id: "U3RvcDpIU0w6MjExMjIzMg==",
lat: 60.21643,
lon: 24.81222
},
{
id: "U3RvcDpIU0w6MjExMjI5Ng==",
lat: 60.21721,
lon: 24.81279
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIyMg==",
lat: 60.219247,
lon: 24.812767
},
{
id: "U3RvcDpIU0w6MjExMjIyOQ==",
lat: 60.21539,
lon: 24.81197
},
{
id: "U3RvcDpIU0w6MjExMjIwMw==",
lat: 60.21399,
lon: 24.81012
},
{
id: "U3RvcDpIU0w6MjExMjIxNA==",
lat: 60.214286,
lon: 24.804602
},
{
id: "U3RvcDpIU0w6MjExMjIwNQ==",
lat: 60.21366,
lon: 24.79984
},
{
id: "U3RvcDpIU0w6MjEzMTIwNQ==",
lat: 60.20922,
lon: 24.79452
},
{
id: "U3RvcDpIU0w6MjEzMTIwMw==",
lat: 60.20864,
lon: 24.78493
},
{
id: "U3RvcDpIU0w6MjEzMTIwOQ==",
lat: 60.20761,
lon: 24.77583
},
{
id: "U3RvcDpIU0w6MjEzMTIxMQ==",
lat: 60.20852,
lon: 24.76843
},
{
id: "U3RvcDpIU0w6MjEzMTI2NA==",
lat: 60.2101,
lon: 24.76262
},
{
id: "U3RvcDpIU0w6MjEzMTI0NQ==",
lat: 60.21167,
lon: 24.76432
},
{
id: "U3RvcDpIU0w6MjEzMTI0Mw==",
lat: 60.21193,
lon: 24.7701
},
{
id: "U3RvcDpIU0w6MjEzMTI0MQ==",
lat: 60.21501,
lon: 24.77174
},
{
id: "U3RvcDpIU0w6MjEzMjI0MQ==",
lat: 60.217,
lon: 24.77535
},
{
id: "U3RvcDpIU0w6MjEzMjI0Mw==",
lat: 60.21708,
lon: 24.78087
},
{
id: "U3RvcDpIU0w6MjEzMjI0NQ==",
lat: 60.21688,
lon: 24.78694
},
{
id: "U3RvcDpIU0w6MjEzMjI0Nw==",
lat: 60.22037,
lon: 24.7856
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwOQ==",
lat: 60.22671,
lon: 24.77975
},
{
id: "U3RvcDpIU0w6MjEzMzI2MA==",
lat: 60.22871,
lon: 24.77909
},
{
id: "U3RvcDpIU0w6MjEzMzIzNA==",
lat: 60.22965,
lon: 24.77683
},
{
id: "U3RvcDpIU0w6MjEzMzIxMQ==",
lat: 60.22934,
lon: 24.77365
},
{
id: "U3RvcDpIU0w6MjEzMzIxMw==",
lat: 60.22968,
lon: 24.76792
},
{
id: "U3RvcDpIU0w6MjEzMzIxNw==",
lat: 60.228,
lon: 24.76138
},
{
id: "U3RvcDpIU0w6MjEzMzIyNA==",
lat: 60.22695,
lon: 24.75707
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwNw==",
lat: 60.22686,
lon: 24.74108
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMw==",
lat: 60.23084,
lon: 24.7372
},
{
id: "U3RvcDpIU0w6MjE1MTIxNQ==",
lat: 60.22987,
lon: 24.73329
},
{
id: "U3RvcDpIU0w6MjE1MTIyNw==",
lat: 60.22849,
lon: 24.7313
},
{
id: "U3RvcDpIU0w6MjE1MTIyMQ==",
lat: 60.2261,
lon: 24.73074
},
{
id: "U3RvcDpIU0w6MjE1MTIwNQ==",
lat: 60.22459,
lon: 24.72212
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mw==",
lat: 60.22459,
lon: 24.70664
},
{
id: "U3RvcDpIU0w6MjE1MjIyOQ==",
lat: 60.22726,
lon: 24.708
},
{
id: "U3RvcDpIU0w6MjE1MjIzMQ==",
lat: 60.22812,
lon: 24.71094
},
{
id: "U3RvcDpIU0w6MjE1MjIzMw==",
lat: 60.23013,
lon: 24.71583
},
{
id: "U3RvcDpIU0w6MjE1MjIzNQ==",
lat: 60.23214,
lon: 24.71632
},
{
id: "U3RvcDpIU0w6MjE1MjI0NQ==",
lat: 60.23402,
lon: 24.71677
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI1OA==",
lat: 60.23912,
lon: 24.70695
},
{
id: "U3RvcDpIU0w6MjYzMjIwMg==",
lat: 60.24102,
lon: 24.70065
},
{
id: "U3RvcDpIU0w6MjYzMjI2Mg==",
lat: 60.24011,
lon: 24.6906
},
{
id: "U3RvcDpIU0w6MjYzMzI1OQ==",
lat: 60.24277,
lon: 24.6883
},
{
id: "U3RvcDpIU0w6MjYzMzIwNA==",
lat: 60.24502,
lon: 24.68673
}
]
},
{
gtfsId: "HSL:2213N",
shortName: "213N",
longName: "Kamppi-Meilahti-Laajalahti-Suvela-Espoon keskus-Kauklahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjUxMTIzNg==",
lat: 60.190499,
lon: 24.601866
},
{
id: "U3RvcDpIU0w6MjUxMTIwNg==",
lat: 60.192167,
lon: 24.60752
},
{
id: "U3RvcDpIU0w6MjUxMTIwNA==",
lat: 60.193368,
lon: 24.610889
},
{
id: "U3RvcDpIU0w6MjUxMTI0Mg==",
lat: 60.19635,
lon: 24.61609
},
{
id: "U3RvcDpIU0w6MjUxMTIwMg==",
lat: 60.19834,
lon: 24.62217
},
{
id: "U3RvcDpIU0w6MjYyMTIxMg==",
lat: 60.19974,
lon: 24.62609
},
{
id: "U3RvcDpIU0w6MjYyMTIxOA==",
lat: 60.20277,
lon: 24.63325
},
{
id: "U3RvcDpIU0w6MjYyMTIxMA==",
lat: 60.20425,
lon: 24.63749
},
{
id: "U3RvcDpIU0w6MjYyMTIwOA==",
lat: 60.20759,
lon: 24.64111
},
{
id: "U3RvcDpIU0w6MjYyMTIwMw==",
lat: 60.208636,
lon: 24.642381
},
{
id: "U3RvcDpIU0w6MjYyMTIwNw==",
lat: 60.21239,
lon: 24.64336
},
{
id: "U3RvcDpIU0w6MjYyMTIwNQ==",
lat: 60.21468,
lon: 24.64968
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTI1Ng==",
lat: 60.20307,
lon: 24.6541
},
{
id: "U3RvcDpIU0w6MjYxMTI1NQ==",
lat: 60.20354,
lon: 24.65667
},
{
id: "U3RvcDpIU0w6MjYxMzAwOA==",
lat: 60.202736,
lon: 24.661962
},
{
id: "U3RvcDpIU0w6MjYxMzAwMQ==",
lat: 60.20123,
lon: 24.6671
},
{
id: "U3RvcDpIU0w6MjYxMzIxNg==",
lat: 60.2028,
lon: 24.67021
},
{
id: "U3RvcDpIU0w6MjYxMzIxOA==",
lat: 60.20462,
lon: 24.67328
},
{
id: "U3RvcDpIU0w6MjYxMzI3Mw==",
lat: 60.20667,
lon: 24.67446
},
{
id: "U3RvcDpIU0w6MjYxMzI3NQ==",
lat: 60.20559,
lon: 24.68208
},
{
id: "U3RvcDpIU0w6MjYxMjI2OQ==",
lat: 60.2063,
lon: 24.68963
},
{
id: "U3RvcDpIU0w6MjI0MjIzMA==",
lat: 60.20359,
lon: 24.76211
},
{
id: "U3RvcDpIU0w6MjI0MjIzMQ==",
lat: 60.20358,
lon: 24.76755
},
{
id: "U3RvcDpIU0w6MjEyMjIzMg==",
lat: 60.20291,
lon: 24.77533
},
{
id: "U3RvcDpIU0w6MjI1MjIwMw==",
lat: 60.201276,
lon: 24.789595
},
{
id: "U3RvcDpIU0w6MjEyMjIyNA==",
lat: 60.2016,
lon: 24.79666
},
{
id: "U3RvcDpIU0w6MjEyMjIxMQ==",
lat: 60.20366,
lon: 24.79789
},
{
id: "U3RvcDpIU0w6MjEyMjIwOQ==",
lat: 60.20434,
lon: 24.79998
},
{
id: "U3RvcDpIU0w6MjEyMjIwNw==",
lat: 60.20435,
lon: 24.80615
},
{
id: "U3RvcDpIU0w6MjEyMjIwNA==",
lat: 60.2046,
lon: 24.81092
},
{
id: "U3RvcDpIU0w6MjEyMTIwMg==",
lat: 60.2053,
lon: 24.81595
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyMg==",
lat: 60.196005,
lon: 24.886202
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExOA==",
lat: 60.19113,
lon: 24.90804
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTEzMDExMw==",
lat: 60.170862,
lon: 24.930898
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
},
{
id: "U3RvcDpIU0w6MTA0MDI3OQ==",
lat: 60.16892,
lon: 24.93137
},
{
id: "U3RvcDpIU0w6MTEzMDExMQ==",
lat: 60.17419,
lon: 24.93349
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE1MDExNg==",
lat: 60.191346,
lon: 24.906254
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MjEyMjIxOQ==",
lat: 60.2061,
lon: 24.81546
},
{
id: "U3RvcDpIU0w6MjEyMjIwNQ==",
lat: 60.20476,
lon: 24.80945
},
{
id: "U3RvcDpIU0w6MjEyMjIwNg==",
lat: 60.20431,
lon: 24.80464
},
{
id: "U3RvcDpIU0w6MjEyMjIwOA==",
lat: 60.20449,
lon: 24.80009
},
{
id: "U3RvcDpIU0w6MjEyMjIxMA==",
lat: 60.20349,
lon: 24.79771
},
{
id: "U3RvcDpIU0w6MjEyMjIyNg==",
lat: 60.20169,
lon: 24.7965
},
{
id: "U3RvcDpIU0w6MjI1MjIwNA==",
lat: 60.201194,
lon: 24.785685
},
{
id: "U3RvcDpIU0w6MjI0MjIzMw==",
lat: 60.20309,
lon: 24.77493
},
{
id: "U3RvcDpIU0w6MjI0MjIyOQ==",
lat: 60.20351,
lon: 24.76572
},
{
id: "U3RvcDpIU0w6MjI0MjIwOQ==",
lat: 60.20413,
lon: 24.75998
},
{
id: "U3RvcDpIU0w6MjEzMTI1MQ==",
lat: 60.20632,
lon: 24.75354
},
{
id: "U3RvcDpIU0w6Mjk4ODIwOA==",
lat: 60.20723,
lon: 24.69643
},
{
id: "U3RvcDpIU0w6MjYxMjI2Ng==",
lat: 60.20617,
lon: 24.68758
},
{
id: "U3RvcDpIU0w6MjYxMzI3NA==",
lat: 60.20577,
lon: 24.68168
},
{
id: "U3RvcDpIU0w6MjYxMzI3MQ==",
lat: 60.20622,
lon: 24.67345
},
{
id: "U3RvcDpIU0w6MjYxMzIxNw==",
lat: 60.20508,
lon: 24.67367
},
{
id: "U3RvcDpIU0w6MjYxMzIxNQ==",
lat: 60.20246,
lon: 24.66925
},
{
id: "U3RvcDpIU0w6MjYxMzAwMA==",
lat: 60.201,
lon: 24.66629
},
{
id: "U3RvcDpIU0w6MjYxMzAxMQ==",
lat: 60.20037,
lon: 24.66339
},
{
id: "U3RvcDpIU0w6MjYxMzAwOQ==",
lat: 60.202778,
lon: 24.66221
},
{
id: "U3RvcDpIU0w6MjYxMTI1NA==",
lat: 60.20371,
lon: 24.65633
},
{
id: "U3RvcDpIU0w6MjYxNTIzMA==",
lat: 60.20332,
lon: 24.65198
},
{
id: "U3RvcDpIU0w6MjYxMTI0OQ==",
lat: 60.2057,
lon: 24.65781
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYyMTIyMg==",
lat: 60.21448,
lon: 24.65221
},
{
id: "U3RvcDpIU0w6MjYyMTIwNA==",
lat: 60.21482,
lon: 24.64804
},
{
id: "U3RvcDpIU0w6MjYyMTIwNg==",
lat: 60.21173,
lon: 24.64243
},
{
id: "U3RvcDpIU0w6MjYyMTIwMg==",
lat: 60.20934,
lon: 24.64173
},
{
id: "U3RvcDpIU0w6MjYyMTIxNQ==",
lat: 60.20776,
lon: 24.64132
},
{
id: "U3RvcDpIU0w6MjYyMTIxNg==",
lat: 60.20645,
lon: 24.63912
},
{
id: "U3RvcDpIU0w6MjYyMTIwOQ==",
lat: 60.20362,
lon: 24.63538
},
{
id: "U3RvcDpIU0w6MjYyMTIxOQ==",
lat: 60.20235,
lon: 24.63106
},
{
id: "U3RvcDpIU0w6MjYyMTIxMQ==",
lat: 60.20018,
lon: 24.62665
},
{
id: "U3RvcDpIU0w6MjUxMTIwMQ==",
lat: 60.19825,
lon: 24.62125
},
{
id: "U3RvcDpIU0w6MjUxMTI0MQ==",
lat: 60.19602,
lon: 24.61495
},
{
id: "U3RvcDpIU0w6MjUxMTIwMw==",
lat: 60.193139,
lon: 24.609917
},
{
id: "U3RvcDpIU0w6MjUxMTIwNQ==",
lat: 60.192161,
lon: 24.607148
},
{
id: "U3RvcDpIU0w6MjUxMTIzNQ==",
lat: 60.190312,
lon: 24.601027
}
]
},
{
gtfsId: "HSL:2201B",
shortName: "201B",
longName: "Leppävaara-Mäkkylä-Pitäjänmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzEwMQ==",
lat: 60.22546,
lon: 24.84836
},
{
id: "U3RvcDpIU0w6MTQ2MzIwMw==",
lat: 60.22606,
lon: 24.84258
},
{
id: "U3RvcDpIU0w6MjExMzIzOQ==",
lat: 60.22614,
lon: 24.8349
},
{
id: "U3RvcDpIU0w6MjExMzI0MQ==",
lat: 60.22622,
lon: 24.82891
},
{
id: "U3RvcDpIU0w6MjExMzI5Mg==",
lat: 60.223525,
lon: 24.82698
},
{
id: "U3RvcDpIU0w6MjExMzIwNQ==",
lat: 60.22052,
lon: 24.83286
},
{
id: "U3RvcDpIU0w6MjExMTI4MA==",
lat: 60.21955,
lon: 24.82102
},
{
id: "U3RvcDpIU0w6MjExMjI2MQ==",
lat: 60.21896,
lon: 24.816
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MjExMTIzNw==",
lat: 60.21898,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6MjExMjI2Mg==",
lat: 60.219276,
lon: 24.816951
},
{
id: "U3RvcDpIU0w6MjExMTI1Ng==",
lat: 60.21934,
lon: 24.8217
},
{
id: "U3RvcDpIU0w6MjExMzI0NQ==",
lat: 60.221897,
lon: 24.831842
},
{
id: "U3RvcDpIU0w6MjExMzI5MQ==",
lat: 60.22373,
lon: 24.82685
},
{
id: "U3RvcDpIU0w6MjExMzI0MA==",
lat: 60.22603,
lon: 24.82795
},
{
id: "U3RvcDpIU0w6MjExMzIzOA==",
lat: 60.22543,
lon: 24.83586
},
{
id: "U3RvcDpIU0w6MTQ2MzEwNA==",
lat: 60.226,
lon: 24.84334
},
{
id: "U3RvcDpIU0w6MTQ2MzEwMg==",
lat: 60.22575,
lon: 24.84729
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMA==",
lat: 60.224845,
lon: 24.850474
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
}
]
},
{
gtfsId: "HSL:9961B",
shortName: "961B",
longName: "Korso-Sula-Riihikallio-Hyrylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDEyNA==",
lat: 60.40201,
lon: 25.028074
},
{
id: "U3RvcDpIU0w6OTY1MDExMQ==",
lat: 60.400819,
lon: 25.026307
},
{
id: "U3RvcDpIU0w6OTY1MDEwNQ==",
lat: 60.398721,
lon: 25.02284
},
{
id: "U3RvcDpIU0w6OTY1MDEwMA==",
lat: 60.398035,
lon: 25.020074
},
{
id: "U3RvcDpIU0w6OTY1MTUxMg==",
lat: 60.395856,
lon: 25.015069
},
{
id: "U3RvcDpIU0w6OTY1MTUwOA==",
lat: 60.394413,
lon: 25.017147
},
{
id: "U3RvcDpIU0w6OTY1MTUxMA==",
lat: 60.389878,
lon: 25.018535
},
{
id: "U3RvcDpIU0w6OTY1MTQwMg==",
lat: 60.386483,
lon: 25.013222
},
{
id: "U3RvcDpIU0w6OTY1MTQwMA==",
lat: 60.383973,
lon: 25.010521
},
{
id: "U3RvcDpIU0w6OTY1MTQwNA==",
lat: 60.382054,
lon: 25.014925
},
{
id: "U3RvcDpIU0w6OTY1MTMwOA==",
lat: 60.378836,
lon: 25.012496
},
{
id: "U3RvcDpIU0w6OTY1MTMwMA==",
lat: 60.377481,
lon: 25.013463
},
{
id: "U3RvcDpIU0w6OTY1MTMxNg==",
lat: 60.374891,
lon: 25.017616
},
{
id: "U3RvcDpIU0w6OTY1MTMxMw==",
lat: 60.375518,
lon: 25.019879
},
{
id: "U3RvcDpIU0w6OTY1MTYwMg==",
lat: 60.379778,
lon: 25.023895
},
{
id: "U3RvcDpIU0w6OTY1MTYxMg==",
lat: 60.382748,
lon: 25.025649
},
{
id: "U3RvcDpIU0w6OTY1MTcxOQ==",
lat: 60.384569,
lon: 25.03016
},
{
id: "U3RvcDpIU0w6OTY1MTcyMA==",
lat: 60.38453,
lon: 25.03546
},
{
id: "U3RvcDpIU0w6OTY1MTcyMQ==",
lat: 60.381626,
lon: 25.043251
},
{
id: "U3RvcDpIU0w6OTY1MTcxMg==",
lat: 60.378112,
lon: 25.052368
},
{
id: "U3RvcDpIU0w6OTY1MTcxNg==",
lat: 60.374666,
lon: 25.059641
},
{
id: "U3RvcDpIU0w6NDg4MDIxNQ==",
lat: 60.370373,
lon: 25.071319
},
{
id: "U3RvcDpIU0w6NDg4MDIxMw==",
lat: 60.36808,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDg4MDIxMQ==",
lat: 60.36612,
lon: 25.08191
},
{
id: "U3RvcDpIU0w6NDg4MDIxMg==",
lat: 60.36464,
lon: 25.08558
},
{
id: "U3RvcDpIU0w6NDgxMDIzNg==",
lat: 60.359299,
lon: 25.079697
},
{
id: "U3RvcDpIU0w6NDgxMDIzNA==",
lat: 60.35686,
lon: 25.078553
},
{
id: "U3RvcDpIU0w6NDgxMDI5NA==",
lat: 60.354391,
lon: 25.078477
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mg==",
lat: 60.3525,
lon: 25.07726
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI5NQ==",
lat: 60.354427,
lon: 25.078612
},
{
id: "U3RvcDpIU0w6NDgxMDIzMw==",
lat: 60.357699,
lon: 25.079007
},
{
id: "U3RvcDpIU0w6NDgxMDIzNQ==",
lat: 60.360146,
lon: 25.081257
},
{
id: "U3RvcDpIU0w6NDg4MDIxMA==",
lat: 60.36471,
lon: 25.08515
},
{
id: "U3RvcDpIU0w6NDg4MDIwOA==",
lat: 60.36658,
lon: 25.08115
},
{
id: "U3RvcDpIU0w6NDg4MDIwMQ==",
lat: 60.36867,
lon: 25.075262
},
{
id: "U3RvcDpIU0w6NDg4MDIxNA==",
lat: 60.370831,
lon: 25.069688
},
{
id: "U3RvcDpIU0w6OTY1MTcxNw==",
lat: 60.375091,
lon: 25.058667
},
{
id: "U3RvcDpIU0w6OTY1MTcxMw==",
lat: 60.379172,
lon: 25.050071
},
{
id: "U3RvcDpIU0w6OTY1MTcwNA==",
lat: 60.382115,
lon: 25.042133
},
{
id: "U3RvcDpIU0w6OTY1MTcwNw==",
lat: 60.385262,
lon: 25.033932
},
{
id: "U3RvcDpIU0w6OTY1MTcxOA==",
lat: 60.38435,
lon: 25.029774
},
{
id: "U3RvcDpIU0w6OTY1MTYxMw==",
lat: 60.382931,
lon: 25.025434
},
{
id: "U3RvcDpIU0w6OTY1MTYwMQ==",
lat: 60.378409,
lon: 25.022339
},
{
id: "U3RvcDpIU0w6OTY1MTMxNw==",
lat: 60.374858,
lon: 25.017726
},
{
id: "U3RvcDpIU0w6OTY1MTMwMQ==",
lat: 60.377366,
lon: 25.013702
},
{
id: "U3RvcDpIU0w6OTY1MTMwOQ==",
lat: 60.378562,
lon: 25.012256
},
{
id: "U3RvcDpIU0w6OTY1MTQwNQ==",
lat: 60.381872,
lon: 25.01535
},
{
id: "U3RvcDpIU0w6OTY1MTQwMQ==",
lat: 60.383909,
lon: 25.010676
},
{
id: "U3RvcDpIU0w6OTY1MTQwMw==",
lat: 60.386849,
lon: 25.01417
},
{
id: "U3RvcDpIU0w6OTY1MTUwOQ==",
lat: 60.389759,
lon: 25.018555
},
{
id: "U3RvcDpIU0w6OTY1MTUwNw==",
lat: 60.394369,
lon: 25.017403
},
{
id: "U3RvcDpIU0w6OTY1MTUxMQ==",
lat: 60.396094,
lon: 25.015021
},
{
id: "U3RvcDpIU0w6OTY1MDEwMQ==",
lat: 60.397854,
lon: 25.019908
},
{
id: "U3RvcDpIU0w6OTY1MDEwNA==",
lat: 60.397977,
lon: 25.022502
},
{
id: "U3RvcDpIU0w6OTY1MDExMA==",
lat: 60.400624,
lon: 25.026438
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
}
]
},
{
gtfsId: "HSL:7457A",
shortName: "457A",
longName: "Kamppi-Keimola-Luhtaanmäki (-Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NTAwMDIyOQ==",
lat: 60.363695,
lon: 24.783214
},
{
id: "U3RvcDpIU0w6NDMxMDIxNQ==",
lat: 60.35648,
lon: 24.79697
},
{
id: "U3RvcDpIU0w6NDMxMDIxMw==",
lat: 60.354738,
lon: 24.805117
},
{
id: "U3RvcDpIU0w6NDIyMDIwMg==",
lat: 60.313429,
lon: 24.840766
},
{
id: "U3RvcDpIU0w6NDE4MDIyMQ==",
lat: 60.288826,
lon: 24.861242
},
{
id: "U3RvcDpIU0w6NDE4MDIxOQ==",
lat: 60.28404,
lon: 24.86467
},
{
id: "U3RvcDpIU0w6NDE4MDIxNw==",
lat: 60.2782,
lon: 24.86844
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
}
]
},
{
gtfsId: "HSL:1603",
shortName: "603",
longName: "Malmi-Oulunkylä-Koskela-Käpylä-Maunula-Pakila-Paloheinä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM4MTEyNA==",
lat: 60.253848,
lon: 25.000627
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwNg==",
lat: 60.25027,
lon: 25.0093
},
{
id: "U3RvcDpIU0w6MTM4MjE2OQ==",
lat: 60.24882,
lon: 25.01278
},
{
id: "U3RvcDpIU0w6MTM4MjE3NA==",
lat: 60.25022,
lon: 25.01237
},
{
id: "U3RvcDpIU0w6MTM4MjE3Nw==",
lat: 60.24926,
lon: 25.0077
},
{
id: "U3RvcDpIU0w6MTM3MDEyMQ==",
lat: 60.24617,
lon: 25.00154
},
{
id: "U3RvcDpIU0w6MTM4MjExOQ==",
lat: 60.24318,
lon: 24.99639
},
{
id: "U3RvcDpIU0w6MTM3MDEwNw==",
lat: 60.242171,
lon: 24.993044
},
{
id: "U3RvcDpIU0w6MTM3MDEwNA==",
lat: 60.2399,
lon: 24.97954
},
{
id: "U3RvcDpIU0w6MTI4NDE3OA==",
lat: 60.23699,
lon: 24.97454
},
{
id: "U3RvcDpIU0w6MTI4NDE3NA==",
lat: 60.23539,
lon: 24.97034
},
{
id: "U3RvcDpIU0w6MTI4NDEyMg==",
lat: 60.23385,
lon: 24.96508
},
{
id: "U3RvcDpIU0w6MTI4NDEzOQ==",
lat: 60.232928,
lon: 24.958345
},
{
id: "U3RvcDpIU0w6MTI4NDEzNw==",
lat: 60.234425,
lon: 24.956856
},
{
id: "U3RvcDpIU0w6MTI4NDEzNQ==",
lat: 60.233768,
lon: 24.951153
},
{
id: "U3RvcDpIU0w6MTI4NDEzMg==",
lat: 60.231298,
lon: 24.951032
},
{
id: "U3RvcDpIU0w6MTI4NDE3MQ==",
lat: 60.23073,
lon: 24.95309
},
{
id: "U3RvcDpIU0w6MTI4NDE3MA==",
lat: 60.22954,
lon: 24.95148
},
{
id: "U3RvcDpIU0w6MTI4NDE2OA==",
lat: 60.2276,
lon: 24.95035
},
{
id: "U3RvcDpIU0w6MTI4NDEwNQ==",
lat: 60.226223,
lon: 24.955391
},
{
id: "U3RvcDpIU0w6MTI4NDEwOA==",
lat: 60.227878,
lon: 24.964075
},
{
id: "U3RvcDpIU0w6MTI4NDE4OA==",
lat: 60.2288,
lon: 24.96248
},
{
id: "U3RvcDpIU0w6MTI4NDEwMg==",
lat: 60.22873,
lon: 24.96421
},
{
id: "U3RvcDpIU0w6MTI4NTE1OQ==",
lat: 60.22592,
lon: 24.96789
},
{
id: "U3RvcDpIU0w6MTI2MDExNQ==",
lat: 60.223569,
lon: 24.966086
},
{
id: "U3RvcDpIU0w6MTI2MDExMw==",
lat: 60.22171,
lon: 24.96391
},
{
id: "U3RvcDpIU0w6MTI2MDExMQ==",
lat: 60.2199,
lon: 24.96186
},
{
id: "U3RvcDpIU0w6MTI2MDEwNQ==",
lat: 60.21815,
lon: 24.96682
},
{
id: "U3RvcDpIU0w6MTI2MDEwNg==",
lat: 60.21897,
lon: 24.9699
},
{
id: "U3RvcDpIU0w6MTI2MDEwNw==",
lat: 60.21953,
lon: 24.96767
},
{
id: "U3RvcDpIU0w6MTI2MDE4MA==",
lat: 60.21839,
lon: 24.96627
},
{
id: "U3RvcDpIU0w6MTI2MDE5Mg==",
lat: 60.216647,
lon: 24.962482
},
{
id: "U3RvcDpIU0w6MTI1MDExNw==",
lat: 60.21644,
lon: 24.95597
},
{
id: "U3RvcDpIU0w6MTI1MDExOQ==",
lat: 60.21922,
lon: 24.94948
},
{
id: "U3RvcDpIU0w6MTI4NDE0OQ==",
lat: 60.2207,
lon: 24.94837
},
{
id: "U3RvcDpIU0w6MTI4MzEzMA==",
lat: 60.22153,
lon: 24.94149
},
{
id: "U3RvcDpIU0w6MTI4MzEzMg==",
lat: 60.22103,
lon: 24.93707
},
{
id: "U3RvcDpIU0w6MTI4NjEzNA==",
lat: 60.223362,
lon: 24.933546
},
{
id: "U3RvcDpIU0w6MTI4MjEzNg==",
lat: 60.22544,
lon: 24.93073
},
{
id: "U3RvcDpIU0w6MTI4MjEwMA==",
lat: 60.225264,
lon: 24.929829
},
{
id: "U3RvcDpIU0w6MTI4MjEwNQ==",
lat: 60.226509,
lon: 24.9264
},
{
id: "U3RvcDpIU0w6MTI4MjEwMw==",
lat: 60.23179,
lon: 24.93386
},
{
id: "U3RvcDpIU0w6MTI4MjE0OA==",
lat: 60.23168,
lon: 24.935298
},
{
id: "U3RvcDpIU0w6MTI4MjE1MA==",
lat: 60.23407,
lon: 24.93797
},
{
id: "U3RvcDpIU0w6MTI4MjE0OQ==",
lat: 60.234439,
lon: 24.934112
},
{
id: "U3RvcDpIU0w6MTI4MTEwNw==",
lat: 60.23472,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTM0MTExOA==",
lat: 60.23743,
lon: 24.92894
},
{
id: "U3RvcDpIU0w6MTM0MTEyMA==",
lat: 60.23948,
lon: 24.92814
},
{
id: "U3RvcDpIU0w6MTM0MTEyMg==",
lat: 60.24185,
lon: 24.92687
},
{
id: "U3RvcDpIU0w6MTM0MTExNw==",
lat: 60.242551,
lon: 24.922285
},
{
id: "U3RvcDpIU0w6MTM0MTEwOQ==",
lat: 60.240714,
lon: 24.916193
},
{
id: "U3RvcDpIU0w6MTM0MTEzNQ==",
lat: 60.244077,
lon: 24.916928
},
{
id: "U3RvcDpIU0w6MTM0MTE0MA==",
lat: 60.245656,
lon: 24.931346
},
{
id: "U3RvcDpIU0w6MTM0MTE0NA==",
lat: 60.246368,
lon: 24.938198
},
{
id: "U3RvcDpIU0w6MTM0MTEzNg==",
lat: 60.24718,
lon: 24.942999
},
{
id: "U3RvcDpIU0w6MTM1MTEwOQ==",
lat: 60.249277,
lon: 24.942139
},
{
id: "U3RvcDpIU0w6MTM1MTExMg==",
lat: 60.24888,
lon: 24.94679
},
{
id: "U3RvcDpIU0w6MTM1MTExMA==",
lat: 60.249188,
lon: 24.942028
},
{
id: "U3RvcDpIU0w6MTM0MTEzMw==",
lat: 60.24711,
lon: 24.94298
},
{
id: "U3RvcDpIU0w6MTM0MTE0Mw==",
lat: 60.246229,
lon: 24.93838
},
{
id: "U3RvcDpIU0w6MTM0MTEzOQ==",
lat: 60.245676,
lon: 24.931484
},
{
id: "U3RvcDpIU0w6MTM0MTExNg==",
lat: 60.242559,
lon: 24.922357
},
{
id: "U3RvcDpIU0w6MTM0MTEyMw==",
lat: 60.24172,
lon: 24.92653
},
{
id: "U3RvcDpIU0w6MTM0MTEyMQ==",
lat: 60.23958,
lon: 24.9279
},
{
id: "U3RvcDpIU0w6MTM0MTExOQ==",
lat: 60.23664,
lon: 24.92902
},
{
id: "U3RvcDpIU0w6MTI4MjEwNA==",
lat: 60.23154,
lon: 24.93381
},
{
id: "U3RvcDpIU0w6MTI4MjEwOA==",
lat: 60.227132,
lon: 24.933918
},
{
id: "U3RvcDpIU0w6MTI4MjEwNw==",
lat: 60.226491,
lon: 24.926345
},
{
id: "U3RvcDpIU0w6MTI4NjEwMA==",
lat: 60.224753,
lon: 24.928389
},
{
id: "U3RvcDpIU0w6MTI4MjEzNw==",
lat: 60.22526,
lon: 24.9307
},
{
id: "U3RvcDpIU0w6MTI4NjEzNQ==",
lat: 60.2216,
lon: 24.9333
},
{
id: "U3RvcDpIU0w6MTI4MzEzMw==",
lat: 60.22099,
lon: 24.93806
},
{
id: "U3RvcDpIU0w6MTI4NDE1MA==",
lat: 60.22104,
lon: 24.9476
},
{
id: "U3RvcDpIU0w6MTI1MDEyMA==",
lat: 60.21883,
lon: 24.94982
},
{
id: "U3RvcDpIU0w6MTI1MDExOA==",
lat: 60.21619,
lon: 24.95642
},
{
id: "U3RvcDpIU0w6MTI2MDEwOQ==",
lat: 60.21713,
lon: 24.95984
},
{
id: "U3RvcDpIU0w6MTI2MDExMA==",
lat: 60.2199,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTI2MDExMg==",
lat: 60.22232,
lon: 24.96484
},
{
id: "U3RvcDpIU0w6MTI2MDExNA==",
lat: 60.22362,
lon: 24.966271
},
{
id: "U3RvcDpIU0w6MTI4NTE1OA==",
lat: 60.22632,
lon: 24.96805
},
{
id: "U3RvcDpIU0w6MTI4NDEwMA==",
lat: 60.226195,
lon: 24.9556
},
{
id: "U3RvcDpIU0w6MTI4NDE2Nw==",
lat: 60.22751,
lon: 24.95045
},
{
id: "U3RvcDpIU0w6MTI4NDE2OQ==",
lat: 60.22982,
lon: 24.95254
},
{
id: "U3RvcDpIU0w6MTI4NDEyNg==",
lat: 60.23108,
lon: 24.9522
},
{
id: "U3RvcDpIU0w6MTI4NDEzMw==",
lat: 60.231063,
lon: 24.951344
},
{
id: "U3RvcDpIU0w6MTI4NDEzNA==",
lat: 60.233756,
lon: 24.951206
},
{
id: "U3RvcDpIU0w6MTI4NDEzNg==",
lat: 60.234382,
lon: 24.956845
},
{
id: "U3RvcDpIU0w6MTI4NDEzOA==",
lat: 60.232753,
lon: 24.95845
},
{
id: "U3RvcDpIU0w6MTI4NDEyNQ==",
lat: 60.23268,
lon: 24.95962
},
{
id: "U3RvcDpIU0w6MTI4NDE3Mg==",
lat: 60.23425,
lon: 24.96753
},
{
id: "U3RvcDpIU0w6MTI4NDE3NQ==",
lat: 60.23609,
lon: 24.97254
},
{
id: "U3RvcDpIU0w6MTM3MDEwMw==",
lat: 60.23991,
lon: 24.97993
},
{
id: "U3RvcDpIU0w6MTM3MDEwOA==",
lat: 60.24167,
lon: 24.9931
},
{
id: "U3RvcDpIU0w6MTM4MjEyMA==",
lat: 60.24328,
lon: 24.99679
},
{
id: "U3RvcDpIU0w6MTM4MjEyMg==",
lat: 60.24685,
lon: 25.00326
},
{
id: "U3RvcDpIU0w6MTM4MjE3OA==",
lat: 60.24924,
lon: 25.00818
},
{
id: "U3RvcDpIU0w6MTM4MjE2NA==",
lat: 60.250635,
lon: 25.012082
},
{
id: "U3RvcDpIU0w6MTM4MjE3MA==",
lat: 60.24865,
lon: 25.01101
},
{
id: "U3RvcDpIU0w6MTM4MjEzMw==",
lat: 60.250684,
lon: 25.009103
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
}
]
},
{
gtfsId: "HSL:2236V",
shortName: "236V",
longName: "Leppävaara-Viherlaakso-Koskelo-Kalajärvi-Serena",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIyNw==",
lat: 60.21927,
lon: 24.8107
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwMw==",
lat: 60.22572,
lon: 24.77758
},
{
id: "U3RvcDpIU0w6MjEzMjIwNQ==",
lat: 60.22578,
lon: 24.76438
},
{
id: "U3RvcDpIU0w6MjEzMjIwNw==",
lat: 60.22572,
lon: 24.75756
},
{
id: "U3RvcDpIU0w6MjE1MTIwMQ==",
lat: 60.22565,
lon: 24.74736
},
{
id: "U3RvcDpIU0w6MjE1MTIwNw==",
lat: 60.22686,
lon: 24.74108
},
{
id: "U3RvcDpIU0w6MjE1MTIwOQ==",
lat: 60.22972,
lon: 24.74127
},
{
id: "U3RvcDpIU0w6MjE1MTIxMQ==",
lat: 60.2317,
lon: 24.74358
},
{
id: "U3RvcDpIU0w6MjE0MTIwMQ==",
lat: 60.23675,
lon: 24.74327
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjYzMjI1Nw==",
lat: 60.25106,
lon: 24.71774
},
{
id: "U3RvcDpIU0w6MjcxMjIyMg==",
lat: 60.25359,
lon: 24.71106
},
{
id: "U3RvcDpIU0w6MjcxMjIxNQ==",
lat: 60.25791,
lon: 24.71676
},
{
id: "U3RvcDpIU0w6MjcxMjIxNw==",
lat: 60.25978,
lon: 24.7193
},
{
id: "U3RvcDpIU0w6MjcxMjIxOQ==",
lat: 60.26365,
lon: 24.72388
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxOA==",
lat: 60.26626,
lon: 24.73717
},
{
id: "U3RvcDpIU0w6MjcxNTI5Mw==",
lat: 60.26702,
lon: 24.74761
},
{
id: "U3RvcDpIU0w6MjcxNTI5NA==",
lat: 60.26969,
lon: 24.75626
},
{
id: "U3RvcDpIU0w6MjcxNTIyOQ==",
lat: 60.27164,
lon: 24.76011
},
{
id: "U3RvcDpIU0w6MjcxNTIzMg==",
lat: 60.275,
lon: 24.76107
},
{
id: "U3RvcDpIU0w6MjcxNTIzMw==",
lat: 60.278,
lon: 24.76154
},
{
id: "U3RvcDpIU0w6MjcxNTIzNQ==",
lat: 60.27888,
lon: 24.7575
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
},
{
id: "U3RvcDpIU0w6MjcyMTIxMg==",
lat: 60.305,
lon: 24.74149
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMzIyOQ==",
lat: 60.31776,
lon: 24.71642
},
{
id: "U3RvcDpIU0w6MjcyMzIxMQ==",
lat: 60.32229,
lon: 24.71755
},
{
id: "U3RvcDpIU0w6MjcyMzIzMQ==",
lat: 60.323319,
lon: 24.7162
},
{
id: "U3RvcDpIU0w6MjcyMzI3OA==",
lat: 60.32804,
lon: 24.71869
},
{
id: "U3RvcDpIU0w6MjcyMzI5Mg==",
lat: 60.32493,
lon: 24.72689
},
{
id: "U3RvcDpIU0w6MjcyMzI4Mw==",
lat: 60.32415,
lon: 24.73677
},
{
id: "U3RvcDpIU0w6MjcyMzI5Mw==",
lat: 60.32517,
lon: 24.7268
},
{
id: "U3RvcDpIU0w6MjcyMzI3Nw==",
lat: 60.327726,
lon: 24.717678
},
{
id: "U3RvcDpIU0w6MjcyMzIzMg==",
lat: 60.324161,
lon: 24.714759
},
{
id: "U3RvcDpIU0w6MjcyMzIxMA==",
lat: 60.321463,
lon: 24.717534
},
{
id: "U3RvcDpIU0w6MjcyMzIzMA==",
lat: 60.31757,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIxMw==",
lat: 60.30444,
lon: 24.74096
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOA==",
lat: 60.27823,
lon: 24.75086
},
{
id: "U3RvcDpIU0w6MjcxNTIzNg==",
lat: 60.27871,
lon: 24.75894
},
{
id: "U3RvcDpIU0w6MjcxNTIzNA==",
lat: 60.2784,
lon: 24.76146
},
{
id: "U3RvcDpIU0w6MjcxNTIzMQ==",
lat: 60.2743,
lon: 24.76071
},
{
id: "U3RvcDpIU0w6MjcxNTI5NQ==",
lat: 60.269782,
lon: 24.755897
},
{
id: "U3RvcDpIU0w6MjcxNTIxMA==",
lat: 60.26655,
lon: 24.74574
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMjIyMA==",
lat: 60.26319,
lon: 24.72306
},
{
id: "U3RvcDpIU0w6MjcxMjIxNg==",
lat: 60.26041,
lon: 24.71996
},
{
id: "U3RvcDpIU0w6MjcxMjIyMw==",
lat: 60.257549,
lon: 24.716212
},
{
id: "U3RvcDpIU0w6MjcxMjIyMQ==",
lat: 60.25376,
lon: 24.71091
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNA==",
lat: 60.23995,
lon: 24.74098
},
{
id: "U3RvcDpIU0w6MjE1MTIyMg==",
lat: 60.23515,
lon: 24.74405
},
{
id: "U3RvcDpIU0w6MjE1MTIxMg==",
lat: 60.2317,
lon: 24.74328
},
{
id: "U3RvcDpIU0w6MjE1MTIxMA==",
lat: 60.22965,
lon: 24.741
},
{
id: "U3RvcDpIU0w6MjE1MTIwOA==",
lat: 60.22675,
lon: 24.74088
},
{
id: "U3RvcDpIU0w6MjE1MTIwMg==",
lat: 60.22548,
lon: 24.74776
},
{
id: "U3RvcDpIU0w6MjEzMjIwOA==",
lat: 60.225528,
lon: 24.760625
},
{
id: "U3RvcDpIU0w6MjEzMjIwNg==",
lat: 60.225743,
lon: 24.766743
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIxMQ==",
lat: 60.22155,
lon: 24.80653
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:6171",
shortName: "171",
longName: "Matinkylä (M)-Masala-Kirkkonummi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA1MDI1NA==",
lat: 60.122759,
lon: 24.427463
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA0MDI3MA==",
lat: 60.124332,
lon: 24.411187
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mg==",
lat: 60.127002,
lon: 24.416042
},
{
id: "U3RvcDpIU0w6NjA0MDI3Ng==",
lat: 60.129328,
lon: 24.419208
},
{
id: "U3RvcDpIU0w6NjA0MDI3OA==",
lat: 60.130365,
lon: 24.425962
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mg==",
lat: 60.132354,
lon: 24.430257
},
{
id: "U3RvcDpIU0w6NjA0MDI0NA==",
lat: 60.133633,
lon: 24.429907
},
{
id: "U3RvcDpIU0w6NjA0MDI0Ng==",
lat: 60.134168,
lon: 24.44247
},
{
id: "U3RvcDpIU0w6NjA0MDI4NA==",
lat: 60.137257,
lon: 24.447662
},
{
id: "U3RvcDpIU0w6NjA0MDI1MA==",
lat: 60.136902,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIyMw==",
lat: 60.126372,
lon: 24.471547
},
{
id: "U3RvcDpIU0w6NjA0MDIyNw==",
lat: 60.130182,
lon: 24.48253
},
{
id: "U3RvcDpIU0w6NjAzMDIxNA==",
lat: 60.132453,
lon: 24.492952
},
{
id: "U3RvcDpIU0w6NjAzMDIxNw==",
lat: 60.134682,
lon: 24.50252
},
{
id: "U3RvcDpIU0w6NjAzMDIyMg==",
lat: 60.137063,
lon: 24.507907
},
{
id: "U3RvcDpIU0w6NjAzMDIyNQ==",
lat: 60.139437,
lon: 24.51347
},
{
id: "U3RvcDpIU0w6NjAzMDIyNw==",
lat: 60.143618,
lon: 24.521718
},
{
id: "U3RvcDpIU0w6NjAyMDIxMA==",
lat: 60.151237,
lon: 24.528287
},
{
id: "U3RvcDpIU0w6NjAyMDIxNQ==",
lat: 60.154503,
lon: 24.532388
},
{
id: "U3RvcDpIU0w6NjAyMDIxMw==",
lat: 60.15282,
lon: 24.545448
},
{
id: "U3RvcDpIU0w6NjAyMDIwNw==",
lat: 60.149187,
lon: 24.56578
},
{
id: "U3RvcDpIU0w6NjAyMDI1OQ==",
lat: 60.14789,
lon: 24.572755
},
{
id: "U3RvcDpIU0w6NjAyMDI0OQ==",
lat: 60.146723,
lon: 24.580065
},
{
id: "U3RvcDpIU0w6NjAyMDI1MQ==",
lat: 60.148718,
lon: 24.588332
},
{
id: "U3RvcDpIU0w6NjAyMDI1Mw==",
lat: 60.151257,
lon: 24.595448
},
{
id: "U3RvcDpIU0w6NjAyMDI1NQ==",
lat: 60.152969,
lon: 24.599857
},
{
id: "U3RvcDpIU0w6NjAyMDI1Nw==",
lat: 60.155509,
lon: 24.606553
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxOQ==",
lat: 60.160171,
lon: 24.738517
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6NjAyMDI1OA==",
lat: 60.155162,
lon: 24.605287
},
{
id: "U3RvcDpIU0w6NjAyMDI1Ng==",
lat: 60.152433,
lon: 24.59821
},
{
id: "U3RvcDpIU0w6NjAyMDI1NA==",
lat: 60.150785,
lon: 24.5936
},
{
id: "U3RvcDpIU0w6NjAyMDI1Mg==",
lat: 60.148407,
lon: 24.586327
},
{
id: "U3RvcDpIU0w6NjAyMDI1MA==",
lat: 60.14632,
lon: 24.578854
},
{
id: "U3RvcDpIU0w6NjAyMDI2MA==",
lat: 60.148067,
lon: 24.573078
},
{
id: "U3RvcDpIU0w6NjAyMDIwOA==",
lat: 60.149502,
lon: 24.564343
},
{
id: "U3RvcDpIU0w6NjAyMDIxNA==",
lat: 60.153555,
lon: 24.544262
},
{
id: "U3RvcDpIU0w6NjAyMDIxNg==",
lat: 60.154818,
lon: 24.531715
},
{
id: "U3RvcDpIU0w6NjAyMDIwOQ==",
lat: 60.150418,
lon: 24.527258
},
{
id: "U3RvcDpIU0w6NjAzMDIyNg==",
lat: 60.142742,
lon: 24.520495
},
{
id: "U3RvcDpIU0w6NjAzMDIyNA==",
lat: 60.139088,
lon: 24.51195
},
{
id: "U3RvcDpIU0w6NjAzMDIyMw==",
lat: 60.137172,
lon: 24.507677
},
{
id: "U3RvcDpIU0w6NjAzMDIxOA==",
lat: 60.13512,
lon: 24.503027
},
{
id: "U3RvcDpIU0w6NjAzMDIxNQ==",
lat: 60.132965,
lon: 24.494397
},
{
id: "U3RvcDpIU0w6NjA0MDIyOA==",
lat: 60.130113,
lon: 24.480768
},
{
id: "U3RvcDpIU0w6NjA0MDIyNQ==",
lat: 60.126777,
lon: 24.472177
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI0Nw==",
lat: 60.13445,
lon: 24.44258
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mw==",
lat: 60.13286,
lon: 24.429452
},
{
id: "U3RvcDpIU0w6NjA0MDI4MA==",
lat: 60.130422,
lon: 24.425053
},
{
id: "U3RvcDpIU0w6NjA0MDI3NA==",
lat: 60.129002,
lon: 24.41859
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mw==",
lat: 60.126575,
lon: 24.415172
},
{
id: "U3RvcDpIU0w6NjA0MDI2OQ==",
lat: 60.12398,
lon: 24.410722
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mw==",
lat: 60.122346,
lon: 24.427386
}
]
},
{
gtfsId: "HSL:6173",
shortName: "173",
longName: "Matinkylä (M)-Masala-Kirkkonummi-Upinniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjEwMDIwNg==",
lat: 60.032892,
lon: 24.366045
},
{
id: "U3RvcDpIU0w6NjEwMDIwMw==",
lat: 60.029863,
lon: 24.366433
},
{
id: "U3RvcDpIU0w6NjEwMDIwMQ==",
lat: 60.028168,
lon: 24.367202
},
{
id: "U3RvcDpIU0w6NjEwMDIwMg==",
lat: 60.028482,
lon: 24.357707
},
{
id: "U3RvcDpIU0w6NjEwMDIwNQ==",
lat: 60.031298,
lon: 24.354285
},
{
id: "U3RvcDpIU0w6NjEwMDIwNw==",
lat: 60.034112,
lon: 24.362122
},
{
id: "U3RvcDpIU0w6NjEwMDIwOA==",
lat: 60.036892,
lon: 24.369562
},
{
id: "U3RvcDpIU0w6NjEwMDIxMQ==",
lat: 60.042207,
lon: 24.370552
},
{
id: "U3RvcDpIU0w6NjA4MDIwMg==",
lat: 60.048668,
lon: 24.37264
},
{
id: "U3RvcDpIU0w6NjA4MDIwNA==",
lat: 60.054922,
lon: 24.376973
},
{
id: "U3RvcDpIU0w6NjA4MDIwNg==",
lat: 60.05687,
lon: 24.379203
},
{
id: "U3RvcDpIU0w6NjA4MDIwNw==",
lat: 60.059462,
lon: 24.382783
},
{
id: "U3RvcDpIU0w6NjA4MDIwOQ==",
lat: 60.063675,
lon: 24.385032
},
{
id: "U3RvcDpIU0w6NjA3MDIwMQ==",
lat: 60.068838,
lon: 24.389293
},
{
id: "U3RvcDpIU0w6NjA3MDIwNA==",
lat: 60.076112,
lon: 24.395513
},
{
id: "U3RvcDpIU0w6NjA3MDIwNg==",
lat: 60.080733,
lon: 24.400545
},
{
id: "U3RvcDpIU0w6NjA3MDIwNw==",
lat: 60.084103,
lon: 24.405502
},
{
id: "U3RvcDpIU0w6NjA3MDIxMg==",
lat: 60.086772,
lon: 24.408497
},
{
id: "U3RvcDpIU0w6NjA3MDIxNw==",
lat: 60.091925,
lon: 24.410829
},
{
id: "U3RvcDpIU0w6NjA3MDIyMw==",
lat: 60.094627,
lon: 24.40926
},
{
id: "U3RvcDpIU0w6NjA3MDIyMA==",
lat: 60.093213,
lon: 24.401212
},
{
id: "U3RvcDpIU0w6NjA3MDIzNw==",
lat: 60.092233,
lon: 24.396735
},
{
id: "U3RvcDpIU0w6NjA3MDIxNA==",
lat: 60.090353,
lon: 24.387245
},
{
id: "U3RvcDpIU0w6NjA3MDIxMw==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIxNg==",
lat: 60.090662,
lon: 24.38842
},
{
id: "U3RvcDpIU0w6NjA3MDIxOA==",
lat: 60.09218,
lon: 24.39843
},
{
id: "U3RvcDpIU0w6NjA3MDIxOQ==",
lat: 60.09339,
lon: 24.402122
},
{
id: "U3RvcDpIU0w6NjA3MDIyMg==",
lat: 60.094425,
lon: 24.410103
},
{
id: "U3RvcDpIU0w6NjA3MDIyNA==",
lat: 60.094795,
lon: 24.412478
},
{
id: "U3RvcDpIU0w6NjA3MDIyNg==",
lat: 60.097217,
lon: 24.415857
},
{
id: "U3RvcDpIU0w6NjA3MDIyNw==",
lat: 60.100692,
lon: 24.42214
},
{
id: "U3RvcDpIU0w6NjA0MDIwMQ==",
lat: 60.103107,
lon: 24.432607
},
{
id: "U3RvcDpIU0w6NjA0MDIwNA==",
lat: 60.106515,
lon: 24.439315
},
{
id: "U3RvcDpIU0w6NjA0MDIwNg==",
lat: 60.109248,
lon: 24.44381
},
{
id: "U3RvcDpIU0w6NjA0MDIwOA==",
lat: 60.113168,
lon: 24.44543
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA1MDI1NA==",
lat: 60.122759,
lon: 24.427463
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA0MDI3MA==",
lat: 60.124332,
lon: 24.411187
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mg==",
lat: 60.127002,
lon: 24.416042
},
{
id: "U3RvcDpIU0w6NjA0MDI3Ng==",
lat: 60.129328,
lon: 24.419208
},
{
id: "U3RvcDpIU0w6NjA0MDI3OA==",
lat: 60.130365,
lon: 24.425962
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mg==",
lat: 60.132354,
lon: 24.430257
},
{
id: "U3RvcDpIU0w6NjA0MDI0NA==",
lat: 60.133633,
lon: 24.429907
},
{
id: "U3RvcDpIU0w6NjA0MDI0Ng==",
lat: 60.134168,
lon: 24.44247
},
{
id: "U3RvcDpIU0w6NjA0MDI4NA==",
lat: 60.137257,
lon: 24.447662
},
{
id: "U3RvcDpIU0w6NjA0MDI1MA==",
lat: 60.136902,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIyMw==",
lat: 60.126372,
lon: 24.471547
},
{
id: "U3RvcDpIU0w6NjA0MDIyNw==",
lat: 60.130182,
lon: 24.48253
},
{
id: "U3RvcDpIU0w6NjAzMDIxNA==",
lat: 60.132453,
lon: 24.492952
},
{
id: "U3RvcDpIU0w6NjAzMDIxNw==",
lat: 60.134682,
lon: 24.50252
},
{
id: "U3RvcDpIU0w6NjAzMDIyMg==",
lat: 60.137063,
lon: 24.507907
},
{
id: "U3RvcDpIU0w6NjAzMDIyNQ==",
lat: 60.139437,
lon: 24.51347
},
{
id: "U3RvcDpIU0w6NjAzMDIyNw==",
lat: 60.143618,
lon: 24.521718
},
{
id: "U3RvcDpIU0w6NjAyMDIxMA==",
lat: 60.151237,
lon: 24.528287
},
{
id: "U3RvcDpIU0w6NjAyMDIxNQ==",
lat: 60.154503,
lon: 24.532388
},
{
id: "U3RvcDpIU0w6NjAyMDIxMw==",
lat: 60.15282,
lon: 24.545448
},
{
id: "U3RvcDpIU0w6NjAyMDIwNw==",
lat: 60.149187,
lon: 24.56578
},
{
id: "U3RvcDpIU0w6NjAyMDI1OQ==",
lat: 60.14789,
lon: 24.572755
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxOQ==",
lat: 60.160171,
lon: 24.738517
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDI2MA==",
lat: 60.148067,
lon: 24.573078
},
{
id: "U3RvcDpIU0w6NjAyMDIwOA==",
lat: 60.149502,
lon: 24.564343
},
{
id: "U3RvcDpIU0w6NjAyMDIxNA==",
lat: 60.153555,
lon: 24.544262
},
{
id: "U3RvcDpIU0w6NjAyMDIxNg==",
lat: 60.154818,
lon: 24.531715
},
{
id: "U3RvcDpIU0w6NjAyMDIwOQ==",
lat: 60.150418,
lon: 24.527258
},
{
id: "U3RvcDpIU0w6NjAzMDIyNg==",
lat: 60.142742,
lon: 24.520495
},
{
id: "U3RvcDpIU0w6NjAzMDIyNA==",
lat: 60.139088,
lon: 24.51195
},
{
id: "U3RvcDpIU0w6NjAzMDIyMw==",
lat: 60.137172,
lon: 24.507677
},
{
id: "U3RvcDpIU0w6NjAzMDIxOA==",
lat: 60.13512,
lon: 24.503027
},
{
id: "U3RvcDpIU0w6NjAzMDIxNQ==",
lat: 60.132965,
lon: 24.494397
},
{
id: "U3RvcDpIU0w6NjA0MDIyOA==",
lat: 60.130113,
lon: 24.480768
},
{
id: "U3RvcDpIU0w6NjA0MDIyNQ==",
lat: 60.126777,
lon: 24.472177
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI0Nw==",
lat: 60.13445,
lon: 24.44258
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mw==",
lat: 60.13286,
lon: 24.429452
},
{
id: "U3RvcDpIU0w6NjA0MDI4MA==",
lat: 60.130422,
lon: 24.425053
},
{
id: "U3RvcDpIU0w6NjA0MDI3NA==",
lat: 60.129002,
lon: 24.41859
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mw==",
lat: 60.126575,
lon: 24.415172
},
{
id: "U3RvcDpIU0w6NjA0MDI2OQ==",
lat: 60.12398,
lon: 24.410722
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mw==",
lat: 60.122346,
lon: 24.427386
},
{
id: "U3RvcDpIU0w6NjA0MDI5Mw==",
lat: 60.119659,
lon: 24.441186
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA3MDI0Mw==",
lat: 60.115295,
lon: 24.444255
},
{
id: "U3RvcDpIU0w6NjA0MDIwNw==",
lat: 60.112248,
lon: 24.445382
},
{
id: "U3RvcDpIU0w6NjA0MDIwNQ==",
lat: 60.10854,
lon: 24.44222
},
{
id: "U3RvcDpIU0w6NjA0MDIwMw==",
lat: 60.106028,
lon: 24.43808
},
{
id: "U3RvcDpIU0w6NjA0MDIwMg==",
lat: 60.102843,
lon: 24.43134
},
{
id: "U3RvcDpIU0w6NjA3MDI0MQ==",
lat: 60.100687,
lon: 24.421182
},
{
id: "U3RvcDpIU0w6NjA3MDIyNQ==",
lat: 60.096573,
lon: 24.414515
},
{
id: "U3RvcDpIU0w6NjA3MDIzNA==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIyMQ==",
lat: 60.094098,
lon: 24.411655
},
{
id: "U3RvcDpIU0w6NjA3MDIxNQ==",
lat: 60.090597,
lon: 24.409795
},
{
id: "U3RvcDpIU0w6NjA3MDIxMA==",
lat: 60.087858,
lon: 24.408618
},
{
id: "U3RvcDpIU0w6NjA3MDIwOA==",
lat: 60.083508,
lon: 24.403963
},
{
id: "U3RvcDpIU0w6NjA3MDIwNQ==",
lat: 60.080148,
lon: 24.399735
},
{
id: "U3RvcDpIU0w6NjA3MDIwMw==",
lat: 60.075464,
lon: 24.394231
},
{
id: "U3RvcDpIU0w6NjA3MDIwMg==",
lat: 60.069282,
lon: 24.388602
},
{
id: "U3RvcDpIU0w6NjA4MDIxMA==",
lat: 60.064062,
lon: 24.385022
},
{
id: "U3RvcDpIU0w6NjA4MDIwOA==",
lat: 60.060075,
lon: 24.38244
},
{
id: "U3RvcDpIU0w6NjA4MDIwNQ==",
lat: 60.055292,
lon: 24.376925
},
{
id: "U3RvcDpIU0w6NjA4MDIwMw==",
lat: 60.049887,
lon: 24.373005
},
{
id: "U3RvcDpIU0w6NjEwMDIxMA==",
lat: 60.042432,
lon: 24.3699
},
{
id: "U3RvcDpIU0w6NjEwMDIwOQ==",
lat: 60.037182,
lon: 24.369817
}
]
},
{
gtfsId: "HSL:9841N",
shortName: "841N",
longName: "Rautatientori-Östersundom-Söderkulla-Nikkilä-Jokimäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyMjIyOQ==",
lat: 60.375727,
lon: 25.267724
},
{
id: "U3RvcDpIU0w6OTIyMjIyNg==",
lat: 60.371818,
lon: 25.262633
},
{
id: "U3RvcDpIU0w6OTIyMjIyMQ==",
lat: 60.37037,
lon: 25.258497
},
{
id: "U3RvcDpIU0w6OTIxNjIxMw==",
lat: 60.363567,
lon: 25.26105
},
{
id: "U3RvcDpIU0w6OTIyMDIxMg==",
lat: 60.354502,
lon: 25.267033
},
{
id: "U3RvcDpIU0w6OTIyMDIxNQ==",
lat: 60.351588,
lon: 25.267842
},
{
id: "U3RvcDpIU0w6OTIyMDIwNA==",
lat: 60.346382,
lon: 25.262063
},
{
id: "U3RvcDpIU0w6OTIyMDIwMw==",
lat: 60.339652,
lon: 25.262577
},
{
id: "U3RvcDpIU0w6OTIyMDIwOQ==",
lat: 60.332812,
lon: 25.264718
},
{
id: "U3RvcDpIU0w6OTIyMDIwNw==",
lat: 60.329111,
lon: 25.263107
},
{
id: "U3RvcDpIU0w6OTIyMDIxMw==",
lat: 60.32271,
lon: 25.266108
},
{
id: "U3RvcDpIU0w6OTIyMDIxOA==",
lat: 60.31899,
lon: 25.27116
},
{
id: "U3RvcDpIU0w6OTIwODIwMg==",
lat: 60.308955,
lon: 25.287228
},
{
id: "U3RvcDpIU0w6OTIwODIwNA==",
lat: 60.303865,
lon: 25.295502
},
{
id: "U3RvcDpIU0w6OTIwODIwNg==",
lat: 60.301678,
lon: 25.308777
},
{
id: "U3RvcDpIU0w6OTIwODI2MQ==",
lat: 60.301293,
lon: 25.319891
},
{
id: "U3RvcDpIU0w6OTIwODI2Mw==",
lat: 60.303028,
lon: 25.324085
},
{
id: "U3RvcDpIU0w6OTIwODI2NQ==",
lat: 60.301032,
lon: 25.330698
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1Nw==",
lat: 60.298,
lon: 25.339552
},
{
id: "U3RvcDpIU0w6OTIwODI1Mw==",
lat: 60.298852,
lon: 25.346872
},
{
id: "U3RvcDpIU0w6OTIwODI1Ng==",
lat: 60.298387,
lon: 25.337094
},
{
id: "U3RvcDpIU0w6OTIwODIxNA==",
lat: 60.298227,
lon: 25.329072
},
{
id: "U3RvcDpIU0w6OTIwODIxMA==",
lat: 60.297008,
lon: 25.322927
},
{
id: "U3RvcDpIU0w6OTIxMDIxMQ==",
lat: 60.292553,
lon: 25.311915
},
{
id: "U3RvcDpIU0w6OTIxMDIwOQ==",
lat: 60.290293,
lon: 25.307124
},
{
id: "U3RvcDpIU0w6OTIxMDIwOA==",
lat: 60.287115,
lon: 25.301985
},
{
id: "U3RvcDpIU0w6OTIxMDIwNg==",
lat: 60.284302,
lon: 25.298328
},
{
id: "U3RvcDpIU0w6OTIxMDIwMw==",
lat: 60.279217,
lon: 25.291527
},
{
id: "U3RvcDpIU0w6OTIwNDIwMQ==",
lat: 60.274445,
lon: 25.28587
},
{
id: "U3RvcDpIU0w6OTIwNDIwNw==",
lat: 60.269742,
lon: 25.279478
},
{
id: "U3RvcDpIU0w6OTIwNDIwNQ==",
lat: 60.26741,
lon: 25.275163
},
{
id: "U3RvcDpIU0w6OTIwNDIwMw==",
lat: 60.26462,
lon: 25.269811
},
{
id: "U3RvcDpIU0w6OTIwNTIxMQ==",
lat: 60.262375,
lon: 25.259562
},
{
id: "U3RvcDpIU0w6OTIwNTIwOQ==",
lat: 60.262158,
lon: 25.25394
},
{
id: "U3RvcDpIU0w6OTIwNTIwNA==",
lat: 60.26176,
lon: 25.240666
},
{
id: "U3RvcDpIU0w6OTIwNTIwMQ==",
lat: 60.261618,
lon: 25.232817
},
{
id: "U3RvcDpIU0w6MTYwMDIxOA==",
lat: 60.260228,
lon: 25.218075
},
{
id: "U3RvcDpIU0w6MTYwMDIxNg==",
lat: 60.25977,
lon: 25.208407
},
{
id: "U3RvcDpIU0w6MTYwMDIxNA==",
lat: 60.25475,
lon: 25.190433
},
{
id: "U3RvcDpIU0w6MTYwMDIxMg==",
lat: 60.253138,
lon: 25.183522
},
{
id: "U3RvcDpIU0w6MTYwMDIxMA==",
lat: 60.2514,
lon: 25.173983
},
{
id: "U3RvcDpIU0w6MTYwMDIwOA==",
lat: 60.249428,
lon: 25.163417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNg==",
lat: 60.24737,
lon: 25.156468
},
{
id: "U3RvcDpIU0w6MTYwMDIwNA==",
lat: 60.245817,
lon: 25.152437
},
{
id: "U3RvcDpIU0w6MTYwMDIwMg==",
lat: 60.24422,
lon: 25.142975
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMA==",
lat: 60.23124,
lon: 25.12868
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MQ==",
lat: 60.22017,
lon: 25.10757
},
{
id: "U3RvcDpIU0w6MTQ1MTE4OA==",
lat: 60.21806,
lon: 25.10282
},
{
id: "U3RvcDpIU0w6MTQ1MzEzNA==",
lat: 60.21477,
lon: 25.09232
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExNg==",
lat: 60.21035,
lon: 25.07629
},
{
id: "U3RvcDpIU0w6MTQzMTE4Mg==",
lat: 60.2058,
lon: 25.04504
},
{
id: "U3RvcDpIU0w6MTQzMTE4MA==",
lat: 60.19873,
lon: 25.03652
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzMTEwNQ==",
lat: 60.19461,
lon: 25.0322
},
{
id: "U3RvcDpIU0w6MTQzMTE4MQ==",
lat: 60.1991,
lon: 25.03757
},
{
id: "U3RvcDpIU0w6MTQzMzE4Mw==",
lat: 60.20588,
lon: 25.04745
},
{
id: "U3RvcDpIU0w6MTQ1MzE4OQ==",
lat: 60.20987,
lon: 25.07621
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MjExOQ==",
lat: 60.215433,
lon: 25.094638
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Nw==",
lat: 60.21833,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MA==",
lat: 60.22011,
lon: 25.10815
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzExOQ==",
lat: 60.23115,
lon: 25.12893
},
{
id: "U3RvcDpIU0w6MTYwMDIwMQ==",
lat: 60.2431,
lon: 25.14191
},
{
id: "U3RvcDpIU0w6MTYwMDIwMw==",
lat: 60.245348,
lon: 25.151417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNQ==",
lat: 60.246743,
lon: 25.155558
},
{
id: "U3RvcDpIU0w6MTYwMDIwNw==",
lat: 60.249545,
lon: 25.164438
},
{
id: "U3RvcDpIU0w6MTYwMDIwOQ==",
lat: 60.251682,
lon: 25.176211
},
{
id: "U3RvcDpIU0w6MTYwMDIxMQ==",
lat: 60.253477,
lon: 25.185895
},
{
id: "U3RvcDpIU0w6MTYwMDIxMw==",
lat: 60.255158,
lon: 25.192102
},
{
id: "U3RvcDpIU0w6MTYwMDIxNQ==",
lat: 60.259785,
lon: 25.211032
},
{
id: "U3RvcDpIU0w6MTYwMDIzMQ==",
lat: 60.260022,
lon: 25.215462
},
{
id: "U3RvcDpIU0w6MTYwMDIxNw==",
lat: 60.260177,
lon: 25.219923
},
{
id: "U3RvcDpIU0w6OTIwNTIwMg==",
lat: 60.261534,
lon: 25.236805
},
{
id: "U3RvcDpIU0w6OTIwNTIwMw==",
lat: 60.261642,
lon: 25.242721
},
{
id: "U3RvcDpIU0w6OTIwNTIxMA==",
lat: 60.262063,
lon: 25.256016
},
{
id: "U3RvcDpIU0w6OTIwNTIxMg==",
lat: 60.262335,
lon: 25.262876
},
{
id: "U3RvcDpIU0w6OTIwNDIwMg==",
lat: 60.26352,
lon: 25.268045
},
{
id: "U3RvcDpIU0w6OTIwNDIwNA==",
lat: 60.26572,
lon: 25.272465
},
{
id: "U3RvcDpIU0w6OTIwNDIwNg==",
lat: 60.26761,
lon: 25.27612
},
{
id: "U3RvcDpIU0w6OTIwNDIwOA==",
lat: 60.270106,
lon: 25.280453
},
{
id: "U3RvcDpIU0w6OTIwNDIxMg==",
lat: 60.275142,
lon: 25.287136
},
{
id: "U3RvcDpIU0w6OTIxMDIwNA==",
lat: 60.280193,
lon: 25.293077
},
{
id: "U3RvcDpIU0w6OTIxMDIwNw==",
lat: 60.285534,
lon: 25.300471
},
{
id: "U3RvcDpIU0w6OTIxMDIxMA==",
lat: 60.290757,
lon: 25.308611
},
{
id: "U3RvcDpIU0w6OTIxMDIxMg==",
lat: 60.292936,
lon: 25.313265
},
{
id: "U3RvcDpIU0w6OTIwODIxMQ==",
lat: 60.297276,
lon: 25.324799
},
{
id: "U3RvcDpIU0w6OTIwODI1Mg==",
lat: 60.298743,
lon: 25.346913
},
{
id: "U3RvcDpIU0w6OTIwODI1MQ==",
lat: 60.297067,
lon: 25.347959
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
},
{
id: "U3RvcDpIU0w6OTIwODI1OA==",
lat: 60.302374,
lon: 25.330245
},
{
id: "U3RvcDpIU0w6OTIwODI2Mg==",
lat: 60.303305,
lon: 25.325164
},
{
id: "U3RvcDpIU0w6OTIwODI2NA==",
lat: 60.301314,
lon: 25.319603
},
{
id: "U3RvcDpIU0w6OTIwODIwNQ==",
lat: 60.301773,
lon: 25.307364
},
{
id: "U3RvcDpIU0w6OTIwODIwMw==",
lat: 60.304703,
lon: 25.294687
},
{
id: "U3RvcDpIU0w6OTIwODIwMQ==",
lat: 60.309975,
lon: 25.285867
},
{
id: "U3RvcDpIU0w6OTIyMDIxNw==",
lat: 60.320012,
lon: 25.270045
},
{
id: "U3RvcDpIU0w6OTIyMDIxMA==",
lat: 60.323868,
lon: 25.264845
},
{
id: "U3RvcDpIU0w6OTIyMDIwOA==",
lat: 60.329973,
lon: 25.263783
},
{
id: "U3RvcDpIU0w6OTIyMDIxMQ==",
lat: 60.333691,
lon: 25.265295
},
{
id: "U3RvcDpIU0w6OTIyMDIwNQ==",
lat: 60.340675,
lon: 25.263232
},
{
id: "U3RvcDpIU0w6OTIyMDIwNg==",
lat: 60.347598,
lon: 25.263275
},
{
id: "U3RvcDpIU0w6OTIyMDIxNA==",
lat: 60.353453,
lon: 25.26834
},
{
id: "U3RvcDpIU0w6OTIxNjIxOQ==",
lat: 60.356245,
lon: 25.266868
},
{
id: "U3RvcDpIU0w6OTIxNjIxNA==",
lat: 60.363368,
lon: 25.261563
},
{
id: "U3RvcDpIU0w6OTIyMjI0MA==",
lat: 60.369115,
lon: 25.258614
},
{
id: "U3RvcDpIU0w6OTIyMjIyMg==",
lat: 60.370252,
lon: 25.258915
},
{
id: "U3RvcDpIU0w6OTIyMjIyNQ==",
lat: 60.371527,
lon: 25.262477
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwOA==",
lat: 60.386435,
lon: 25.282542
},
{
id: "U3RvcDpIU0w6OTIyOTIwMw==",
lat: 60.390658,
lon: 25.291292
},
{
id: "U3RvcDpIU0w6OTIyOTIwNg==",
lat: 60.393408,
lon: 25.296543
},
{
id: "U3RvcDpIU0w6OTIyOTIwOA==",
lat: 60.396172,
lon: 25.298523
},
{
id: "U3RvcDpIU0w6OTIyNTIwMw==",
lat: 60.402635,
lon: 25.299295
},
{
id: "U3RvcDpIU0w6OTIyNTIwNQ==",
lat: 60.406127,
lon: 25.30665
},
{
id: "U3RvcDpIU0w6OTIyNTIwNg==",
lat: 60.40681,
lon: 25.315015
},
{
id: "U3RvcDpIU0w6OTIyNTIwOA==",
lat: 60.40889,
lon: 25.318735
},
{
id: "U3RvcDpIU0w6OTIyNTIwOQ==",
lat: 60.410377,
lon: 25.321968
},
{
id: "U3RvcDpIU0w6OTIyNTIxMg==",
lat: 60.41308,
lon: 25.328807
},
{
id: "U3RvcDpIU0w6OTIyNTIxNA==",
lat: 60.416008,
lon: 25.330725
},
{
id: "U3RvcDpIU0w6OTIyNTIxNQ==",
lat: 60.418978,
lon: 25.332633
},
{
id: "U3RvcDpIU0w6OTIyNTIxOA==",
lat: 60.425025,
lon: 25.338565
},
{
id: "U3RvcDpIU0w6OTQwMDIxMQ==",
lat: 60.435523,
lon: 25.368753
}
]
},
{
gtfsId: "HSL:6172",
shortName: "172",
longName: "Matinkylä (M)-Masala-Kirkkonummi-Kantvik",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxOQ==",
lat: 60.160171,
lon: 24.738517
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDI2MA==",
lat: 60.148067,
lon: 24.573078
},
{
id: "U3RvcDpIU0w6NjAyMDIwOA==",
lat: 60.149502,
lon: 24.564343
},
{
id: "U3RvcDpIU0w6NjAyMDIxNA==",
lat: 60.153555,
lon: 24.544262
},
{
id: "U3RvcDpIU0w6NjAyMDIxNg==",
lat: 60.154818,
lon: 24.531715
},
{
id: "U3RvcDpIU0w6NjAyMDIwOQ==",
lat: 60.150418,
lon: 24.527258
},
{
id: "U3RvcDpIU0w6NjAzMDIyNg==",
lat: 60.142742,
lon: 24.520495
},
{
id: "U3RvcDpIU0w6NjAzMDIyNA==",
lat: 60.139088,
lon: 24.51195
},
{
id: "U3RvcDpIU0w6NjAzMDIyMw==",
lat: 60.137172,
lon: 24.507677
},
{
id: "U3RvcDpIU0w6NjAzMDIxOA==",
lat: 60.13512,
lon: 24.503027
},
{
id: "U3RvcDpIU0w6NjAzMDIxNQ==",
lat: 60.132965,
lon: 24.494397
},
{
id: "U3RvcDpIU0w6NjA0MDIyOA==",
lat: 60.130113,
lon: 24.480768
},
{
id: "U3RvcDpIU0w6NjA0MDIyNQ==",
lat: 60.126777,
lon: 24.472177
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI4NA==",
lat: 60.137257,
lon: 24.447662
},
{
id: "U3RvcDpIU0w6NjA0MDI1MA==",
lat: 60.136902,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI0Nw==",
lat: 60.13445,
lon: 24.44258
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mw==",
lat: 60.13286,
lon: 24.429452
},
{
id: "U3RvcDpIU0w6NjA0MDI4MA==",
lat: 60.130422,
lon: 24.425053
},
{
id: "U3RvcDpIU0w6NjA0MDI3NA==",
lat: 60.129002,
lon: 24.41859
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mw==",
lat: 60.126575,
lon: 24.415172
},
{
id: "U3RvcDpIU0w6NjA0MDI2OQ==",
lat: 60.12398,
lon: 24.410722
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mw==",
lat: 60.122346,
lon: 24.427386
},
{
id: "U3RvcDpIU0w6NjA0MDI5Mw==",
lat: 60.119659,
lon: 24.441186
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA3MDI0Mw==",
lat: 60.115295,
lon: 24.444255
},
{
id: "U3RvcDpIU0w6NjA0MDIwNw==",
lat: 60.112248,
lon: 24.445382
},
{
id: "U3RvcDpIU0w6NjA0MDIwNQ==",
lat: 60.10854,
lon: 24.44222
},
{
id: "U3RvcDpIU0w6NjA0MDIwMw==",
lat: 60.106028,
lon: 24.43808
},
{
id: "U3RvcDpIU0w6NjA0MDIwMg==",
lat: 60.102843,
lon: 24.43134
},
{
id: "U3RvcDpIU0w6NjA3MDI0MQ==",
lat: 60.100687,
lon: 24.421182
},
{
id: "U3RvcDpIU0w6NjA3MDIyNQ==",
lat: 60.096573,
lon: 24.414515
},
{
id: "U3RvcDpIU0w6NjA3MDIyMw==",
lat: 60.094627,
lon: 24.40926
},
{
id: "U3RvcDpIU0w6NjA3MDIyMA==",
lat: 60.093213,
lon: 24.401212
},
{
id: "U3RvcDpIU0w6NjA3MDIzNw==",
lat: 60.092233,
lon: 24.396735
},
{
id: "U3RvcDpIU0w6NjA3MDIxNA==",
lat: 60.090353,
lon: 24.387245
},
{
id: "U3RvcDpIU0w6NjA3MDIxMw==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIxNg==",
lat: 60.090662,
lon: 24.38842
},
{
id: "U3RvcDpIU0w6NjA3MDIxOA==",
lat: 60.09218,
lon: 24.39843
},
{
id: "U3RvcDpIU0w6NjA3MDIxOQ==",
lat: 60.09339,
lon: 24.402122
},
{
id: "U3RvcDpIU0w6NjA3MDIyMg==",
lat: 60.094425,
lon: 24.410103
},
{
id: "U3RvcDpIU0w6NjA3MDIyNA==",
lat: 60.094795,
lon: 24.412478
},
{
id: "U3RvcDpIU0w6NjA3MDIyNg==",
lat: 60.097217,
lon: 24.415857
},
{
id: "U3RvcDpIU0w6NjA3MDIyNw==",
lat: 60.100692,
lon: 24.42214
},
{
id: "U3RvcDpIU0w6NjA0MDIwMQ==",
lat: 60.103107,
lon: 24.432607
},
{
id: "U3RvcDpIU0w6NjA0MDIwNA==",
lat: 60.106515,
lon: 24.439315
},
{
id: "U3RvcDpIU0w6NjA0MDIwNg==",
lat: 60.109248,
lon: 24.44381
},
{
id: "U3RvcDpIU0w6NjA0MDIwOA==",
lat: 60.113168,
lon: 24.44543
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA1MDI1NA==",
lat: 60.122759,
lon: 24.427463
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA0MDI3MA==",
lat: 60.124332,
lon: 24.411187
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mg==",
lat: 60.127002,
lon: 24.416042
},
{
id: "U3RvcDpIU0w6NjA0MDI3Ng==",
lat: 60.129328,
lon: 24.419208
},
{
id: "U3RvcDpIU0w6NjA0MDI3OA==",
lat: 60.130365,
lon: 24.425962
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mg==",
lat: 60.132354,
lon: 24.430257
},
{
id: "U3RvcDpIU0w6NjA0MDI0NA==",
lat: 60.133633,
lon: 24.429907
},
{
id: "U3RvcDpIU0w6NjA0MDI0Ng==",
lat: 60.134168,
lon: 24.44247
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIyMw==",
lat: 60.126372,
lon: 24.471547
},
{
id: "U3RvcDpIU0w6NjA0MDIyNw==",
lat: 60.130182,
lon: 24.48253
},
{
id: "U3RvcDpIU0w6NjAzMDIxNA==",
lat: 60.132453,
lon: 24.492952
},
{
id: "U3RvcDpIU0w6NjAzMDIxNw==",
lat: 60.134682,
lon: 24.50252
},
{
id: "U3RvcDpIU0w6NjAzMDIyMg==",
lat: 60.137063,
lon: 24.507907
},
{
id: "U3RvcDpIU0w6NjAzMDIyNQ==",
lat: 60.139437,
lon: 24.51347
},
{
id: "U3RvcDpIU0w6NjAzMDIyNw==",
lat: 60.143618,
lon: 24.521718
},
{
id: "U3RvcDpIU0w6NjAyMDIxMA==",
lat: 60.151237,
lon: 24.528287
},
{
id: "U3RvcDpIU0w6NjAyMDIxNQ==",
lat: 60.154503,
lon: 24.532388
},
{
id: "U3RvcDpIU0w6NjAyMDIxMw==",
lat: 60.15282,
lon: 24.545448
},
{
id: "U3RvcDpIU0w6NjAyMDIwNw==",
lat: 60.149187,
lon: 24.56578
},
{
id: "U3RvcDpIU0w6NjAyMDI1OQ==",
lat: 60.14789,
lon: 24.572755
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:7456N",
shortName: "456N",
longName: "Kamppi-Keimola-Luhtaanmäki (-Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
},
{
id: "U3RvcDpIU0w6NTAwMDIyOQ==",
lat: 60.363695,
lon: 24.783214
},
{
id: "U3RvcDpIU0w6NDMxMDIxNQ==",
lat: 60.35648,
lon: 24.79697
},
{
id: "U3RvcDpIU0w6NDMxMDIxMw==",
lat: 60.354738,
lon: 24.805117
},
{
id: "U3RvcDpIU0w6NDIyMDIwMg==",
lat: 60.313429,
lon: 24.840766
},
{
id: "U3RvcDpIU0w6NDE4MDIyMQ==",
lat: 60.288826,
lon: 24.861242
},
{
id: "U3RvcDpIU0w6NDE4MDIxOQ==",
lat: 60.28404,
lon: 24.86467
},
{
id: "U3RvcDpIU0w6NDE4MDIxNw==",
lat: 60.2782,
lon: 24.86844
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
}
]
},
{
gtfsId: "HSL:1039B",
shortName: "39B",
longName: "Kamppi-Munkkiniemi-Konala (teollisuusalue)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMyMDExNQ==",
lat: 60.24876,
lon: 24.8385
},
{
id: "U3RvcDpIU0w6MTMyMDExMw==",
lat: 60.24711,
lon: 24.84333
},
{
id: "U3RvcDpIU0w6MTMyMDExMQ==",
lat: 60.24432,
lon: 24.8467
},
{
id: "U3RvcDpIU0w6MTMyMDEwOQ==",
lat: 60.24161,
lon: 24.84268
},
{
id: "U3RvcDpIU0w6MTMyMDEwNQ==",
lat: 60.23761,
lon: 24.84672
},
{
id: "U3RvcDpIU0w6MTMyMDEwNA==",
lat: 60.23512,
lon: 24.84651
},
{
id: "U3RvcDpIU0w6MTMyMDEwMg==",
lat: 60.23233,
lon: 24.84636
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MQ==",
lat: 60.22888,
lon: 24.84861
},
{
id: "U3RvcDpIU0w6MTQ2MzExNg==",
lat: 60.22633,
lon: 24.85406
},
{
id: "U3RvcDpIU0w6MTQ2MzExNA==",
lat: 60.22425,
lon: 24.85844
},
{
id: "U3RvcDpIU0w6MTQ2NTExMQ==",
lat: 60.22108,
lon: 24.86157
},
{
id: "U3RvcDpIU0w6MTQ2MjEwNg==",
lat: 60.21957,
lon: 24.86324
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNA==",
lat: 60.217308,
lon: 24.869366
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMg==",
lat: 60.214819,
lon: 24.876593
},
{
id: "U3RvcDpIU0w6MTI5MTEzOQ==",
lat: 60.21066,
lon: 24.8805
},
{
id: "U3RvcDpIU0w6MTMwNDEzNw==",
lat: 60.206219,
lon: 24.879857
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyNA==",
lat: 60.19618,
lon: 24.88529
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
},
{
id: "U3RvcDpIU0w6MTE1MDEwOA==",
lat: 60.188734,
lon: 24.912259
},
{
id: "U3RvcDpIU0w6MTE0MDEwNQ==",
lat: 60.18479,
lon: 24.91689
},
{
id: "U3RvcDpIU0w6MTE0MDEzMA==",
lat: 60.18142,
lon: 24.92043
},
{
id: "U3RvcDpIU0w6MTE0MDEwMw==",
lat: 60.17966,
lon: 24.92227
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEwOQ==",
lat: 60.17083,
lon: 24.92517
},
{
id: "U3RvcDpIU0w6MTA0MDExNQ==",
lat: 60.168775,
lon: 24.92859
},
{
id: "U3RvcDpIU0w6MTA0MDE0NA==",
lat: 60.169432,
lon: 24.930045
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEyNw==",
lat: 60.180264,
lon: 24.921903
},
{
id: "U3RvcDpIU0w6MTE0MDEyOQ==",
lat: 60.18153,
lon: 24.92058
},
{
id: "U3RvcDpIU0w6MTE0MDEzMQ==",
lat: 60.18341,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE0MDEzMw==",
lat: 60.18581,
lon: 24.91596
},
{
id: "U3RvcDpIU0w6MTE1MDEwNw==",
lat: 60.189912,
lon: 24.909831
},
{
id: "U3RvcDpIU0w6MTE1MDEwOQ==",
lat: 60.19067,
lon: 24.90781
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MTMwNDEyNw==",
lat: 60.20289,
lon: 24.88189
},
{
id: "U3RvcDpIU0w6MTMwNDEzNg==",
lat: 60.20573,
lon: 24.88058
},
{
id: "U3RvcDpIU0w6MTI5MTEzOA==",
lat: 60.21059,
lon: 24.8809
},
{
id: "U3RvcDpIU0w6MTQ2NTE3Nw==",
lat: 60.213022,
lon: 24.879553
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMQ==",
lat: 60.21574,
lon: 24.87448
},
{
id: "U3RvcDpIU0w6MTQ2NTEwMw==",
lat: 60.21776,
lon: 24.86884
},
{
id: "U3RvcDpIU0w6MTQ2NTEwNQ==",
lat: 60.21991,
lon: 24.86304
},
{
id: "U3RvcDpIU0w6MTQ2NTExMg==",
lat: 60.22245,
lon: 24.86279
},
{
id: "U3RvcDpIU0w6MTQ2MzExMw==",
lat: 60.22448,
lon: 24.85743
},
{
id: "U3RvcDpIU0w6MTQ2MzExNQ==",
lat: 60.22716,
lon: 24.85318
},
{
id: "U3RvcDpIU0w6MTQ2MzE4MA==",
lat: 60.2288,
lon: 24.84913
},
{
id: "U3RvcDpIU0w6MTMyMDEwMQ==",
lat: 60.23253,
lon: 24.84661
},
{
id: "U3RvcDpIU0w6MTMyMDEwMw==",
lat: 60.23558,
lon: 24.84705
},
{
id: "U3RvcDpIU0w6MTMyMDEwNw==",
lat: 60.239,
lon: 24.84645
},
{
id: "U3RvcDpIU0w6MTMyMDEwOA==",
lat: 60.2415,
lon: 24.84299
},
{
id: "U3RvcDpIU0w6MTMyMDEyMw==",
lat: 60.24408,
lon: 24.8468
},
{
id: "U3RvcDpIU0w6MTMyMDExMg==",
lat: 60.24735,
lon: 24.84315
}
]
},
{
gtfsId: "HSL:2345N",
shortName: "345N",
longName: "Elielinaukio-Hämeenkylä-Rinnekoti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEzMw==",
lat: 60.171801,
lon: 24.939727
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEyMA==",
lat: 60.20988,
lon: 24.88902
},
{
id: "U3RvcDpIU0w6MTI5MTE4MA==",
lat: 60.21517,
lon: 24.88415
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mg==",
lat: 60.21988,
lon: 24.88124
},
{
id: "U3RvcDpIU0w6MTI5NDEyMQ==",
lat: 60.22517,
lon: 24.87707
},
{
id: "U3RvcDpIU0w6MTQ2NDEyMw==",
lat: 60.22792,
lon: 24.87272
},
{
id: "U3RvcDpIU0w6MTQ2MzExNw==",
lat: 60.23393,
lon: 24.862
},
{
id: "U3RvcDpIU0w6MTMyMDExOQ==",
lat: 60.2387,
lon: 24.85418
},
{
id: "U3RvcDpIU0w6MTMyMDI5Nw==",
lat: 60.24435,
lon: 24.84502
},
{
id: "U3RvcDpIU0w6MTMyMDI5NQ==",
lat: 60.24945,
lon: 24.83561
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNw==",
lat: 60.25811,
lon: 24.80891
},
{
id: "U3RvcDpIU0w6NDEyMDIyOA==",
lat: 60.26293,
lon: 24.805612
},
{
id: "U3RvcDpIU0w6NDEyMDIxOA==",
lat: 60.26444,
lon: 24.80597
},
{
id: "U3RvcDpIU0w6NDEyMDI5OA==",
lat: 60.26687,
lon: 24.80497
},
{
id: "U3RvcDpIU0w6NDEyMDIxOQ==",
lat: 60.26612,
lon: 24.79949
},
{
id: "U3RvcDpIU0w6NDEyMDIyMw==",
lat: 60.26877,
lon: 24.79488
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDIwMDIwMQ==",
lat: 60.27705,
lon: 24.80344
},
{
id: "U3RvcDpIU0w6NDIwMDIwMw==",
lat: 60.28351,
lon: 24.79137
},
{
id: "U3RvcDpIU0w6NDIwMDIwNQ==",
lat: 60.28806,
lon: 24.78593
},
{
id: "U3RvcDpIU0w6NDIwMDIwNw==",
lat: 60.29149,
lon: 24.78204
},
{
id: "U3RvcDpIU0w6MjcyMTIwMQ==",
lat: 60.3012,
lon: 24.76346
},
{
id: "U3RvcDpIU0w6MjcyMTIwMw==",
lat: 60.30298,
lon: 24.75568
},
{
id: "U3RvcDpIU0w6MjcyMTIwNQ==",
lat: 60.30469,
lon: 24.74827
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMjIxMw==",
lat: 60.31699,
lon: 24.71427
},
{
id: "U3RvcDpIU0w6MjcyMjIxNQ==",
lat: 60.31825,
lon: 24.70452
},
{
id: "U3RvcDpIU0w6MjcyMjIxNw==",
lat: 60.31969,
lon: 24.69525
},
{
id: "U3RvcDpIU0w6MjcyMjIxOQ==",
lat: 60.32298,
lon: 24.6786
},
{
id: "U3RvcDpIU0w6MjcyNTIyMQ==",
lat: 60.32553,
lon: 24.66102
},
{
id: "U3RvcDpIU0w6MjcyNDI1MA==",
lat: 60.32773,
lon: 24.64748
},
{
id: "U3RvcDpIU0w6MjcyNDIwOQ==",
lat: 60.3389,
lon: 24.654
},
{
id: "U3RvcDpIU0w6MjcyNDI3MA==",
lat: 60.34483,
lon: 24.65421
},
{
id: "U3RvcDpIU0w6MjcyNDIwMQ==",
lat: 60.34655,
lon: 24.65505
},
{
id: "U3RvcDpIU0w6MjcyNDI3OQ==",
lat: 60.34895,
lon: 24.65709
},
{
id: "U3RvcDpIU0w6MjcyNDI4MA==",
lat: 60.35094,
lon: 24.65659
},
{
id: "U3RvcDpIU0w6MjcyNDI4MQ==",
lat: 60.35401,
lon: 24.65549
},
{
id: "U3RvcDpIU0w6MjcyNDI4Mw==",
lat: 60.35596,
lon: 24.65378
},
{
id: "U3RvcDpIU0w6MjcyNDI4NQ==",
lat: 60.35751,
lon: 24.65231
},
{
id: "U3RvcDpIU0w6MjcyNDI1NQ==",
lat: 60.35713,
lon: 24.65236
},
{
id: "U3RvcDpIU0w6MjcyNDI1NA==",
lat: 60.35373,
lon: 24.65554
},
{
id: "U3RvcDpIU0w6MjcyNDI1Mw==",
lat: 60.351,
lon: 24.65632
},
{
id: "U3RvcDpIU0w6MjcyNDI1Mg==",
lat: 60.34884,
lon: 24.65696
},
{
id: "U3RvcDpIU0w6MjcyNDIwMg==",
lat: 60.34658,
lon: 24.65489
},
{
id: "U3RvcDpIU0w6MjcyNDI1MQ==",
lat: 60.34397,
lon: 24.654
},
{
id: "U3RvcDpIU0w6MjcyNDIwOA==",
lat: 60.33845,
lon: 24.65381
},
{
id: "U3RvcDpIU0w6MjcyNDI1Nw==",
lat: 60.32917,
lon: 24.64737
},
{
id: "U3RvcDpIU0w6MjcyNTIyNA==",
lat: 60.32614,
lon: 24.64792
},
{
id: "U3RvcDpIU0w6MjcyNTIyMg==",
lat: 60.32546,
lon: 24.66288
},
{
id: "U3RvcDpIU0w6MjcyMjIyMA==",
lat: 60.3231,
lon: 24.67743
},
{
id: "U3RvcDpIU0w6MjcyMjIxOA==",
lat: 60.31928,
lon: 24.69631
},
{
id: "U3RvcDpIU0w6MjcyMjIxNg==",
lat: 60.31804,
lon: 24.70547
},
{
id: "U3RvcDpIU0w6MjcyMjIwMQ==",
lat: 60.317037,
lon: 24.71352
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIwNg==",
lat: 60.30432,
lon: 24.74926
},
{
id: "U3RvcDpIU0w6MjcyMTIwNA==",
lat: 60.30331,
lon: 24.75364
},
{
id: "U3RvcDpIU0w6MjcyMTIxMQ==",
lat: 60.30155,
lon: 24.76128
},
{
id: "U3RvcDpIU0w6MjcyMTIwMg==",
lat: 60.300467,
lon: 24.765783
},
{
id: "U3RvcDpIU0w6NDIwMDIwOA==",
lat: 60.29054,
lon: 24.78286
},
{
id: "U3RvcDpIU0w6NDIwMDIwNg==",
lat: 60.28661,
lon: 24.78718
},
{
id: "U3RvcDpIU0w6NDIwMDIwNA==",
lat: 60.28288,
lon: 24.79207
},
{
id: "U3RvcDpIU0w6NDIwMDIwMg==",
lat: 60.27836,
lon: 24.80175
},
{
id: "U3RvcDpIU0w6NDEyMDI5NA==",
lat: 60.27096,
lon: 24.80215
},
{
id: "U3RvcDpIU0w6NDEyMDI4Ng==",
lat: 60.27016,
lon: 24.79557
},
{
id: "U3RvcDpIU0w6NDEyMDIyMg==",
lat: 60.26848,
lon: 24.79489
},
{
id: "U3RvcDpIU0w6NDEyMDIyMA==",
lat: 60.26647,
lon: 24.79868
},
{
id: "U3RvcDpIU0w6NDEyMDI5OQ==",
lat: 60.26695,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDIxMQ==",
lat: 60.26427,
lon: 24.80569
},
{
id: "U3RvcDpIU0w6NDEyMDIxMA==",
lat: 60.26149,
lon: 24.80645
},
{
id: "U3RvcDpIU0w6NDEyMDIwOA==",
lat: 60.25673,
lon: 24.80958
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6MTMyMDI5Mg==",
lat: 60.24917,
lon: 24.83552
},
{
id: "U3RvcDpIU0w6MTMyMDI5NA==",
lat: 60.24309,
lon: 24.84648
},
{
id: "U3RvcDpIU0w6MTMyMDEyMA==",
lat: 60.239267,
lon: 24.852589
},
{
id: "U3RvcDpIU0w6MTQ2MzExOA==",
lat: 60.23293,
lon: 24.86311
},
{
id: "U3RvcDpIU0w6MTI5NDEyNA==",
lat: 60.227,
lon: 24.87358
},
{
id: "U3RvcDpIU0w6MTI5NDEyMg==",
lat: 60.22447,
lon: 24.87771
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mw==",
lat: 60.21865,
lon: 24.8815
},
{
id: "U3RvcDpIU0w6MTI5MTE4MQ==",
lat: 60.215735,
lon: 24.883378
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:2321N",
shortName: "321N",
longName: "Elielinaukio-Jupperi-Vanhakartano-Niipperi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcxNTI0OQ==",
lat: 60.28471,
lon: 24.74512
},
{
id: "U3RvcDpIU0w6MjcxNTI1MA==",
lat: 60.28549,
lon: 24.74204
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mg==",
lat: 60.28637,
lon: 24.73772
},
{
id: "U3RvcDpIU0w6MjcxNDI5Ng==",
lat: 60.28573,
lon: 24.73092
},
{
id: "U3RvcDpIU0w6MjcxNDI5OQ==",
lat: 60.287706,
lon: 24.722557
},
{
id: "U3RvcDpIU0w6MjcxNDIxMA==",
lat: 60.288488,
lon: 24.719048
},
{
id: "U3RvcDpIU0w6MjcxNDIwMg==",
lat: 60.28834,
lon: 24.7149
},
{
id: "U3RvcDpIU0w6MjcxNDIwNA==",
lat: 60.28652,
lon: 24.71082
},
{
id: "U3RvcDpIU0w6MjcxNDI5OA==",
lat: 60.28568,
lon: 24.70723
},
{
id: "U3RvcDpIU0w6MjcxMTI3Ng==",
lat: 60.28525,
lon: 24.70586
},
{
id: "U3RvcDpIU0w6MjcxNDI4Nw==",
lat: 60.28069,
lon: 24.71109
},
{
id: "U3RvcDpIU0w6MjcxNDI3OA==",
lat: 60.27783,
lon: 24.71334
},
{
id: "U3RvcDpIU0w6MjcxNDIyNw==",
lat: 60.2753,
lon: 24.71506
},
{
id: "U3RvcDpIU0w6MjcxNDIyNg==",
lat: 60.27505,
lon: 24.71838
},
{
id: "U3RvcDpIU0w6MjcxNDIyNA==",
lat: 60.27337,
lon: 24.72279
},
{
id: "U3RvcDpIU0w6MjcxNDIwOQ==",
lat: 60.26933,
lon: 24.72145
},
{
id: "U3RvcDpIU0w6MjcxNDIyMg==",
lat: 60.26794,
lon: 24.72179
},
{
id: "U3RvcDpIU0w6MjcxNDIyMA==",
lat: 60.26766,
lon: 24.73043
},
{
id: "U3RvcDpIU0w6MjcxNDIzMA==",
lat: 60.26637,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjcxNDIzMw==",
lat: 60.26541,
lon: 24.73065
},
{
id: "U3RvcDpIU0w6MjcxMzIxOQ==",
lat: 60.26278,
lon: 24.73192
},
{
id: "U3RvcDpIU0w6MjcxMzIxNg==",
lat: 60.25885,
lon: 24.73459
},
{
id: "U3RvcDpIU0w6MjcxMzIwOA==",
lat: 60.25466,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjcxMzIyMA==",
lat: 60.25359,
lon: 24.73518
},
{
id: "U3RvcDpIU0w6MjcxMzIwNg==",
lat: 60.25333,
lon: 24.73323
},
{
id: "U3RvcDpIU0w6MjcxMzIwNA==",
lat: 60.25327,
lon: 24.72461
},
{
id: "U3RvcDpIU0w6MjcxMzIwMg==",
lat: 60.25185,
lon: 24.7206
},
{
id: "U3RvcDpIU0w6MjYzMjI1NA==",
lat: 60.2496,
lon: 24.71569
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mg==",
lat: 60.24641,
lon: 24.71263
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzNw==",
lat: 60.234621,
lon: 24.717954
},
{
id: "U3RvcDpIU0w6MjE1MjI0MQ==",
lat: 60.23562,
lon: 24.72505
},
{
id: "U3RvcDpIU0w6MjE0MjIyNA==",
lat: 60.23709,
lon: 24.73153
},
{
id: "U3RvcDpIU0w6MjE0MjIyMg==",
lat: 60.23921,
lon: 24.73476
},
{
id: "U3RvcDpIU0w6MjE0MTIwNQ==",
lat: 60.24064,
lon: 24.74186
},
{
id: "U3RvcDpIU0w6MjE0MTIwNw==",
lat: 60.24387,
lon: 24.7488
},
{
id: "U3RvcDpIU0w6MjE0MjIwOQ==",
lat: 60.24647,
lon: 24.75143
},
{
id: "U3RvcDpIU0w6MjE0MzIxMQ==",
lat: 60.2493,
lon: 24.7569
},
{
id: "U3RvcDpIU0w6MjE0MzIxNA==",
lat: 60.25059,
lon: 24.76441
},
{
id: "U3RvcDpIU0w6MjE0MzIxNg==",
lat: 60.25233,
lon: 24.76977
},
{
id: "U3RvcDpIU0w6MjE0MzIxOA==",
lat: 60.25371,
lon: 24.77507
},
{
id: "U3RvcDpIU0w6NDEwMDIxMA==",
lat: 60.25474,
lon: 24.78064
},
{
id: "U3RvcDpIU0w6NDEyMDI5MA==",
lat: 60.25438,
lon: 24.79724
},
{
id: "U3RvcDpIU0w6NDEyMDI4OA==",
lat: 60.25537,
lon: 24.80147
},
{
id: "U3RvcDpIU0w6NDEyMDIwNg==",
lat: 60.25537,
lon: 24.80804
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6MTMyMDI5Mg==",
lat: 60.24917,
lon: 24.83552
},
{
id: "U3RvcDpIU0w6MTMyMDI5NA==",
lat: 60.24309,
lon: 24.84648
},
{
id: "U3RvcDpIU0w6MTMyMDEyMA==",
lat: 60.239267,
lon: 24.852589
},
{
id: "U3RvcDpIU0w6MTQ2MzExOA==",
lat: 60.23293,
lon: 24.86311
},
{
id: "U3RvcDpIU0w6MTI5NDEyNA==",
lat: 60.227,
lon: 24.87358
},
{
id: "U3RvcDpIU0w6MTI5NDEyMg==",
lat: 60.22447,
lon: 24.87771
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mw==",
lat: 60.21865,
lon: 24.8815
},
{
id: "U3RvcDpIU0w6MTI5MTE4MQ==",
lat: 60.215735,
lon: 24.883378
},
{
id: "U3RvcDpIU0w6MTI5MTIxOQ==",
lat: 60.20973,
lon: 24.88874
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDEzNQ==",
lat: 60.171861,
lon: 24.939722
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDExMw==",
lat: 60.19157,
lon: 24.91246
},
{
id: "U3RvcDpIU0w6MTE4MDEwMw==",
lat: 60.1949,
lon: 24.90303
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDEwNQ==",
lat: 60.20414,
lon: 24.89932
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEyMA==",
lat: 60.20988,
lon: 24.88902
},
{
id: "U3RvcDpIU0w6MTI5MTE4MA==",
lat: 60.21517,
lon: 24.88415
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mg==",
lat: 60.21988,
lon: 24.88124
},
{
id: "U3RvcDpIU0w6MTI5NDEyMQ==",
lat: 60.22517,
lon: 24.87707
},
{
id: "U3RvcDpIU0w6MTQ2NDEyMw==",
lat: 60.22792,
lon: 24.87272
},
{
id: "U3RvcDpIU0w6MTQ2MzExNw==",
lat: 60.23393,
lon: 24.862
},
{
id: "U3RvcDpIU0w6MTMyMDExOQ==",
lat: 60.2387,
lon: 24.85418
},
{
id: "U3RvcDpIU0w6MTMyMDI5Nw==",
lat: 60.24435,
lon: 24.84502
},
{
id: "U3RvcDpIU0w6MTMyMDI5NQ==",
lat: 60.24945,
lon: 24.83561
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNQ==",
lat: 60.25572,
lon: 24.80591
},
{
id: "U3RvcDpIU0w6NDEyMDI5MQ==",
lat: 60.25508,
lon: 24.79965
},
{
id: "U3RvcDpIU0w6NDEwMDIwNw==",
lat: 60.25419,
lon: 24.79491
},
{
id: "U3RvcDpIU0w6NDEwMDIwOQ==",
lat: 60.25467,
lon: 24.7786
},
{
id: "U3RvcDpIU0w6MjE0MzIxNw==",
lat: 60.253227,
lon: 24.772518
},
{
id: "U3RvcDpIU0w6MjE0MzIxNQ==",
lat: 60.25198,
lon: 24.7679
},
{
id: "U3RvcDpIU0w6MjE0MzIxMw==",
lat: 60.25041,
lon: 24.76301
},
{
id: "U3RvcDpIU0w6MjE0MzIxMg==",
lat: 60.24895,
lon: 24.75508
},
{
id: "U3RvcDpIU0w6MjE0MjIxMA==",
lat: 60.24566,
lon: 24.75026
},
{
id: "U3RvcDpIU0w6MjE0MjIwOA==",
lat: 60.24338,
lon: 24.74724
},
{
id: "U3RvcDpIU0w6MjE0MjIwNg==",
lat: 60.2414,
lon: 24.74307
},
{
id: "U3RvcDpIU0w6MjE0MjIyNQ==",
lat: 60.24003,
lon: 24.7383
},
{
id: "U3RvcDpIU0w6MjE0MjIyMQ==",
lat: 60.23899,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjE0MjIyMw==",
lat: 60.23689,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mg==",
lat: 60.23536,
lon: 24.72211
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
},
{
id: "U3RvcDpIU0w6MjYzMjI1MQ==",
lat: 60.24653,
lon: 24.71277
},
{
id: "U3RvcDpIU0w6MjYzMjI1Mw==",
lat: 60.24994,
lon: 24.7166
},
{
id: "U3RvcDpIU0w6MjcxMzIwMQ==",
lat: 60.25237,
lon: 24.72199
},
{
id: "U3RvcDpIU0w6MjcxMzIwMw==",
lat: 60.25325,
lon: 24.72546
},
{
id: "U3RvcDpIU0w6MjcxMzIwNQ==",
lat: 60.25329,
lon: 24.73325
},
{
id: "U3RvcDpIU0w6MjcxMzIwNw==",
lat: 60.25473,
lon: 24.73674
},
{
id: "U3RvcDpIU0w6MjcxMzIxNw==",
lat: 60.25984,
lon: 24.73473
},
{
id: "U3RvcDpIU0w6MjcxMzIxOA==",
lat: 60.2639,
lon: 24.73096
},
{
id: "U3RvcDpIU0w6MjcxNDIyOQ==",
lat: 60.26585,
lon: 24.73251
},
{
id: "U3RvcDpIU0w6MjcxNDIxNw==",
lat: 60.26656,
lon: 24.73511
},
{
id: "U3RvcDpIU0w6MjcxNDIxOQ==",
lat: 60.26788,
lon: 24.72915
},
{
id: "U3RvcDpIU0w6MjcxNDIyMQ==",
lat: 60.26755,
lon: 24.7233
},
{
id: "U3RvcDpIU0w6MjcxNDIwOA==",
lat: 60.26922,
lon: 24.72146
},
{
id: "U3RvcDpIU0w6MjcxNDIzMg==",
lat: 60.27336,
lon: 24.72298
},
{
id: "U3RvcDpIU0w6MjcxNDIyNQ==",
lat: 60.27523,
lon: 24.71708
},
{
id: "U3RvcDpIU0w6MjcxNDI4OA==",
lat: 60.27559,
lon: 24.71467
},
{
id: "U3RvcDpIU0w6MjcxNDI3OQ==",
lat: 60.2775,
lon: 24.71419
},
{
id: "U3RvcDpIU0w6MjcxNDI4Ng==",
lat: 60.28103,
lon: 24.71065
},
{
id: "U3RvcDpIU0w6MjcxNDIwNQ==",
lat: 60.28661,
lon: 24.7115
},
{
id: "U3RvcDpIU0w6MjcxNDIwMw==",
lat: 60.28796,
lon: 24.71484
},
{
id: "U3RvcDpIU0w6MjcxNDIxMQ==",
lat: 60.28834,
lon: 24.719273
},
{
id: "U3RvcDpIU0w6MjcxNDI1NQ==",
lat: 60.286994,
lon: 24.725706
},
{
id: "U3RvcDpIU0w6MjcxNDI1NA==",
lat: 60.28594,
lon: 24.73075
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mw==",
lat: 60.28618,
lon: 24.73694
},
{
id: "U3RvcDpIU0w6MjcxNTI1MQ==",
lat: 60.28582,
lon: 24.74113
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
}
]
},
{
gtfsId: "HSL:9986B",
shortName: "986B",
longName: "Nikkilä-Etelä-Paippinen-Rajakulma",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyMjI0Nw==",
lat: 60.374422,
lon: 25.253161
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI1OQ==",
lat: 60.375139,
lon: 25.267128
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwNg==",
lat: 60.387638,
lon: 25.28011
},
{
id: "U3RvcDpIU0w6OTIyNDIwMw==",
lat: 60.392063,
lon: 25.274625
},
{
id: "U3RvcDpIU0w6OTIyNDIwMg==",
lat: 60.393787,
lon: 25.274147
},
{
id: "U3RvcDpIU0w6OTIyOTIwMg==",
lat: 60.398647,
lon: 25.269158
},
{
id: "U3RvcDpIU0w6OTIyNjIyOA==",
lat: 60.408537,
lon: 25.268675
},
{
id: "U3RvcDpIU0w6OTIyNjIyNg==",
lat: 60.413232,
lon: 25.263592
},
{
id: "U3RvcDpIU0w6OTIyNjIyMw==",
lat: 60.415632,
lon: 25.25889
},
{
id: "U3RvcDpIU0w6OTIyNjIxNw==",
lat: 60.420212,
lon: 25.254323
},
{
id: "U3RvcDpIU0w6OTIyNjIzMA==",
lat: 60.421925,
lon: 25.255975
},
{
id: "U3RvcDpIU0w6OTIyNjIxOQ==",
lat: 60.426023,
lon: 25.254642
},
{
id: "U3RvcDpIU0w6OTIyNjIyMA==",
lat: 60.430535,
lon: 25.254848
},
{
id: "U3RvcDpIU0w6OTIyNjIxMg==",
lat: 60.43706,
lon: 25.24765
},
{
id: "U3RvcDpIU0w6OTIyNjIwNw==",
lat: 60.441348,
lon: 25.24349
},
{
id: "U3RvcDpIU0w6OTIyNjIxMA==",
lat: 60.444093,
lon: 25.24524
},
{
id: "U3RvcDpIU0w6OTIyNjIwNg==",
lat: 60.447018,
lon: 25.243005
},
{
id: "U3RvcDpIU0w6OTIyNjIwNA==",
lat: 60.452095,
lon: 25.234323
},
{
id: "U3RvcDpIU0w6OTIyNjIwMQ==",
lat: 60.455432,
lon: 25.227765
},
{
id: "U3RvcDpIU0w6OTIyNzIyMQ==",
lat: 60.461243,
lon: 25.218707
},
{
id: "U3RvcDpIU0w6OTIyNzIxNg==",
lat: 60.467624,
lon: 25.216748
},
{
id: "U3RvcDpIU0w6OTIyNzIxNQ==",
lat: 60.471467,
lon: 25.213445
},
{
id: "U3RvcDpIU0w6OTIyNzIxMg==",
lat: 60.472927,
lon: 25.209372
},
{
id: "U3RvcDpIU0w6OTIyNzIxMQ==",
lat: 60.471717,
lon: 25.203932
},
{
id: "U3RvcDpIU0w6OTIyNzIwOA==",
lat: 60.470497,
lon: 25.19664
},
{
id: "U3RvcDpIU0w6OTIyNzIwNg==",
lat: 60.469533,
lon: 25.189673
},
{
id: "U3RvcDpIU0w6OTIyNzIwNQ==",
lat: 60.469993,
lon: 25.169843
},
{
id: "U3RvcDpIU0w6OTIyNzIwNA==",
lat: 60.470315,
lon: 25.157247
},
{
id: "U3RvcDpIU0w6OTIyNzIwMw==",
lat: 60.470235,
lon: 25.153188
},
{
id: "U3RvcDpIU0w6OTIyNzIwMQ==",
lat: 60.470105,
lon: 25.158263
},
{
id: "U3RvcDpIU0w6OTIyNzIwMg==",
lat: 60.469752,
lon: 25.171968
},
{
id: "U3RvcDpIU0w6OTIyNzIwNw==",
lat: 60.469552,
lon: 25.191689
},
{
id: "U3RvcDpIU0w6OTIyNzIwOQ==",
lat: 60.47042,
lon: 25.197325
},
{
id: "U3RvcDpIU0w6OTIyNzIxMA==",
lat: 60.4712,
lon: 25.202058
},
{
id: "U3RvcDpIU0w6OTIyNzIxNA==",
lat: 60.47113,
lon: 25.213387
},
{
id: "U3RvcDpIU0w6OTIyNzIxNw==",
lat: 60.466915,
lon: 25.21712
},
{
id: "U3RvcDpIU0w6OTIyNzIyMA==",
lat: 60.461053,
lon: 25.21862
},
{
id: "U3RvcDpIU0w6OTIyNjIwMg==",
lat: 60.455297,
lon: 25.22762
},
{
id: "U3RvcDpIU0w6OTIyNjIwMw==",
lat: 60.452169,
lon: 25.234042
},
{
id: "U3RvcDpIU0w6OTIyNjIwNQ==",
lat: 60.447078,
lon: 25.242497
},
{
id: "U3RvcDpIU0w6OTIyNjIwOQ==",
lat: 60.443535,
lon: 25.24445
},
{
id: "U3RvcDpIU0w6OTIyNjIwOA==",
lat: 60.440662,
lon: 25.24323
},
{
id: "U3RvcDpIU0w6OTIyNjIxMQ==",
lat: 60.436636,
lon: 25.247597
},
{
id: "U3RvcDpIU0w6OTIyNjIxNQ==",
lat: 60.430718,
lon: 25.254243
},
{
id: "U3RvcDpIU0w6OTIyNjIxNg==",
lat: 60.426205,
lon: 25.254507
},
{
id: "U3RvcDpIU0w6OTIyNjIxOA==",
lat: 60.422542,
lon: 25.25485
},
{
id: "U3RvcDpIU0w6OTIyNjIyMQ==",
lat: 60.419297,
lon: 25.254857
},
{
id: "U3RvcDpIU0w6OTIyNjIyMg==",
lat: 60.415777,
lon: 25.257725
},
{
id: "U3RvcDpIU0w6OTIyNjIyNw==",
lat: 60.412108,
lon: 25.26331
},
{
id: "U3RvcDpIU0w6OTIyNjIyOQ==",
lat: 60.40789,
lon: 25.268195
},
{
id: "U3RvcDpIU0w6OTIyOTIwMQ==",
lat: 60.39883,
lon: 25.268908
},
{
id: "U3RvcDpIU0w6OTIyNDIwMQ==",
lat: 60.394237,
lon: 25.273913
},
{
id: "U3RvcDpIU0w6OTIyNDIwNA==",
lat: 60.390328,
lon: 25.27607
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
}
]
},
{
gtfsId: "HSL:7456A",
shortName: "456A",
longName: "Kamppi-Keimola-Luhtaanmäki (-Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
}
]
},
{
gtfsId: "HSL:4415N",
shortName: "415N",
longName: "Elielinaukio-Myyrmäki-Ylästö-Lentoasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDUzMDIzMA==",
lat: 60.317343,
lon: 24.965217
},
{
id: "U3RvcDpIU0w6NDUzMDI1OA==",
lat: 60.313471,
lon: 24.967726
},
{
id: "U3RvcDpIU0w6NDUzMDIyMQ==",
lat: 60.307879,
lon: 24.960343
},
{
id: "U3RvcDpIU0w6NDUyMDI2Nw==",
lat: 60.304895,
lon: 24.957404
},
{
id: "U3RvcDpIU0w6NDUyMDI2NQ==",
lat: 60.303237,
lon: 24.95592
},
{
id: "U3RvcDpIU0w6NDUyMDIzMw==",
lat: 60.302235,
lon: 24.958971
},
{
id: "U3RvcDpIU0w6NDUyMDIyMA==",
lat: 60.297809,
lon: 24.958069
},
{
id: "U3RvcDpIU0w6NDUxMDI2NA==",
lat: 60.295567,
lon: 24.958298
},
{
id: "U3RvcDpIU0w6NDUxMDIwMQ==",
lat: 60.28944,
lon: 24.9594
},
{
id: "U3RvcDpIU0w6NDUxMDIxMA==",
lat: 60.28642,
lon: 24.95645
},
{
id: "U3RvcDpIU0w6NDUxMDIxMw==",
lat: 60.286,
lon: 24.94868
},
{
id: "U3RvcDpIU0w6NDUxMDI1Ng==",
lat: 60.285431,
lon: 24.944319
},
{
id: "U3RvcDpIU0w6NDQwMDIxNg==",
lat: 60.28215,
lon: 24.93696
},
{
id: "U3RvcDpIU0w6NDQwMDIxNA==",
lat: 60.28078,
lon: 24.92756
},
{
id: "U3RvcDpIU0w6NDQwMDIxMg==",
lat: 60.28157,
lon: 24.92342
},
{
id: "U3RvcDpIU0w6NDQwMDIxMA==",
lat: 60.28386,
lon: 24.918
},
{
id: "U3RvcDpIU0w6NDQwMDIwOA==",
lat: 60.28435,
lon: 24.91312
},
{
id: "U3RvcDpIU0w6NDQwMDIzMg==",
lat: 60.28534,
lon: 24.90811
},
{
id: "U3RvcDpIU0w6NDQwMDIwNg==",
lat: 60.28615,
lon: 24.90267
},
{
id: "U3RvcDpIU0w6NDQwMDIwNA==",
lat: 60.28642,
lon: 24.89658
},
{
id: "U3RvcDpIU0w6NDQwMDI5OA==",
lat: 60.28786,
lon: 24.89045
},
{
id: "U3RvcDpIU0w6NDE4MDIxMQ==",
lat: 60.2871,
lon: 24.87284
},
{
id: "U3RvcDpIU0w6NDE4MDIyNg==",
lat: 60.28292,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyNA==",
lat: 60.27838,
lon: 24.87161
},
{
id: "U3RvcDpIU0w6NDE4MDIzMQ==",
lat: 60.27793,
lon: 24.86877
},
{
id: "U3RvcDpIU0w6NDE3MDIxMA==",
lat: 60.27739,
lon: 24.86505
},
{
id: "U3RvcDpIU0w6NDE3MDI1OA==",
lat: 60.27658,
lon: 24.85892
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mw==",
lat: 60.27737,
lon: 24.85337
},
{
id: "U3RvcDpIU0w6NDE3MDIwNQ==",
lat: 60.276283,
lon: 24.847923
},
{
id: "U3RvcDpIU0w6NDE3MDIwMw==",
lat: 60.27482,
lon: 24.84181
},
{
id: "U3RvcDpIU0w6NDE1MDIyNw==",
lat: 60.2696,
lon: 24.84185
},
{
id: "U3RvcDpIU0w6NDE1MDIxMQ==",
lat: 60.26976,
lon: 24.84728
},
{
id: "U3RvcDpIU0w6NDE1MDIwOQ==",
lat: 60.26865,
lon: 24.85357
},
{
id: "U3RvcDpIU0w6NDE1MDIwNw==",
lat: 60.26548,
lon: 24.85381
},
{
id: "U3RvcDpIU0w6NDE1MDI2Mw==",
lat: 60.26109,
lon: 24.856
},
{
id: "U3RvcDpIU0w6NDE1MDIyMA==",
lat: 60.26371,
lon: 24.85947
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDIzOQ==",
lat: 60.171981,
lon: 24.93971
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE1MDIxOQ==",
lat: 60.26394,
lon: 24.85928
},
{
id: "U3RvcDpIU0w6NDE1MDI2MA==",
lat: 60.26146,
lon: 24.85547
},
{
id: "U3RvcDpIU0w6NDE1MDIwNg==",
lat: 60.26489,
lon: 24.85412
},
{
id: "U3RvcDpIU0w6NDE1MDIwOA==",
lat: 60.26808,
lon: 24.85378
},
{
id: "U3RvcDpIU0w6NDE1MDIxMA==",
lat: 60.26983,
lon: 24.84594
},
{
id: "U3RvcDpIU0w6NDE1MDIyNQ==",
lat: 60.27027,
lon: 24.84099
},
{
id: "U3RvcDpIU0w6NDE3MDIwMQ==",
lat: 60.2741,
lon: 24.83948
},
{
id: "U3RvcDpIU0w6NDE3MDIwMg==",
lat: 60.27501,
lon: 24.84308
},
{
id: "U3RvcDpIU0w6NDE3MDIwNA==",
lat: 60.27658,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDI0Ng==",
lat: 60.27718,
lon: 24.85344
},
{
id: "U3RvcDpIU0w6NDE3MDIwNw==",
lat: 60.27642,
lon: 24.85817
},
{
id: "U3RvcDpIU0w6NDE3MDIwOQ==",
lat: 60.27705,
lon: 24.86407
},
{
id: "U3RvcDpIU0w6NDE4MDIyMw==",
lat: 60.27905,
lon: 24.87266
},
{
id: "U3RvcDpIU0w6NDE4MDIyNQ==",
lat: 60.284615,
lon: 24.873015
},
{
id: "U3RvcDpIU0w6NDE4MDIzMA==",
lat: 60.28791,
lon: 24.87527
},
{
id: "U3RvcDpIU0w6NDQwMDI5OQ==",
lat: 60.28752,
lon: 24.89207
},
{
id: "U3RvcDpIU0w6NDQwMDIwMw==",
lat: 60.28632,
lon: 24.89784
},
{
id: "U3RvcDpIU0w6NDQwMDIwNQ==",
lat: 60.28585,
lon: 24.90463
},
{
id: "U3RvcDpIU0w6NDQwMDIzMw==",
lat: 60.28471,
lon: 24.91037
},
{
id: "U3RvcDpIU0w6NDQwMDIwNw==",
lat: 60.28403,
lon: 24.91526
},
{
id: "U3RvcDpIU0w6NDQwMDIwOQ==",
lat: 60.28334,
lon: 24.91922
},
{
id: "U3RvcDpIU0w6NDQwMDIxMQ==",
lat: 60.28074,
lon: 24.92412
},
{
id: "U3RvcDpIU0w6NDQwMDIxMw==",
lat: 60.28074,
lon: 24.92886
},
{
id: "U3RvcDpIU0w6NDQwMDIxNQ==",
lat: 60.28249,
lon: 24.93814
},
{
id: "U3RvcDpIU0w6NDUxMDI1Nw==",
lat: 60.28557,
lon: 24.946116
},
{
id: "U3RvcDpIU0w6NDUxMDIxMg==",
lat: 60.286087,
lon: 24.951548
},
{
id: "U3RvcDpIU0w6NDUxMDIxNA==",
lat: 60.28624,
lon: 24.95591
},
{
id: "U3RvcDpIU0w6NDUxMDIyMQ==",
lat: 60.28714,
lon: 24.9578
},
{
id: "U3RvcDpIU0w6NDUxMDIwMg==",
lat: 60.29045,
lon: 24.96052
},
{
id: "U3RvcDpIU0w6NDUxMDI2MA==",
lat: 60.293782,
lon: 24.959314
},
{
id: "U3RvcDpIU0w6NDUxMDI2Mw==",
lat: 60.295453,
lon: 24.958864
},
{
id: "U3RvcDpIU0w6NDUyMDIxNw==",
lat: 60.297895,
lon: 24.959368
},
{
id: "U3RvcDpIU0w6NDUyMDIzOQ==",
lat: 60.301654,
lon: 24.962252
},
{
id: "U3RvcDpIU0w6NDUyMDI2Ng==",
lat: 60.302738,
lon: 24.955727
},
{
id: "U3RvcDpIU0w6NDUyMDI2OA==",
lat: 60.306115,
lon: 24.958895
},
{
id: "U3RvcDpIU0w6NDUzMDIyMg==",
lat: 60.308712,
lon: 24.961988
},
{
id: "U3RvcDpIU0w6NDUzMDIwOQ==",
lat: 60.317071,
lon: 24.966263
}
]
},
{
gtfsId: "HSL:1014X",
shortName: "14X",
longName: "Hernesaari-Kamppi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTIwNDEwMQ==",
lat: 60.148283,
lon: 24.923295
},
{
id: "U3RvcDpIU0w6MTIwNDExNQ==",
lat: 60.148991,
lon: 24.926635
},
{
id: "U3RvcDpIU0w6MTIwNDExMw==",
lat: 60.15253,
lon: 24.93034
},
{
id: "U3RvcDpIU0w6MTIwNDExOA==",
lat: 60.15427,
lon: 24.93177
},
{
id: "U3RvcDpIU0w6MTIwNDEwOQ==",
lat: 60.15611,
lon: 24.93037
},
{
id: "U3RvcDpIU0w6MTIwNDExMQ==",
lat: 60.15744,
lon: 24.932268
},
{
id: "U3RvcDpIU0w6MTA1MDExNQ==",
lat: 60.157802,
lon: 24.935992
},
{
id: "U3RvcDpIU0w6MTA2MDEwNA==",
lat: 60.158277,
lon: 24.94121
},
{
id: "U3RvcDpIU0w6MTA1MDEwOA==",
lat: 60.161274,
lon: 24.941349
},
{
id: "U3RvcDpIU0w6MTA1MDEwNg==",
lat: 60.16288,
lon: 24.93909
},
{
id: "U3RvcDpIU0w6MTA0MDEyMw==",
lat: 60.16494,
lon: 24.93622
},
{
id: "U3RvcDpIU0w6MTA0MDEyNQ==",
lat: 60.167257,
lon: 24.933017
},
{
id: "U3RvcDpIU0w6MTA0MDE0NA==",
lat: 60.169432,
lon: 24.930045
},
{
id: "U3RvcDpIU0w6MTA0MDE0OA==",
lat: 60.169156,
lon: 24.930101
},
{
id: "U3RvcDpIU0w6MTA0MDEyNg==",
lat: 60.165618,
lon: 24.931375
},
{
id: "U3RvcDpIU0w6MTA0MDEyNA==",
lat: 60.163645,
lon: 24.934098
},
{
id: "U3RvcDpIU0w6MTA1MDEwNw==",
lat: 60.162453,
lon: 24.935799
},
{
id: "U3RvcDpIU0w6MTA1MDExMA==",
lat: 60.160876,
lon: 24.938023
},
{
id: "U3RvcDpIU0w6MTA1MDEwOQ==",
lat: 60.16061,
lon: 24.94144
},
{
id: "U3RvcDpIU0w6MTA2MDEwMw==",
lat: 60.15788,
lon: 24.94127
},
{
id: "U3RvcDpIU0w6MTIwNDEwNg==",
lat: 60.15405,
lon: 24.93159
},
{
id: "U3RvcDpIU0w6MTIwNDExNA==",
lat: 60.151931,
lon: 24.929466
},
{
id: "U3RvcDpIU0w6MTIwNDExNg==",
lat: 60.149082,
lon: 24.926715
},
{
id: "U3RvcDpIU0w6MTIwNDEwOA==",
lat: 60.14868,
lon: 24.92424
}
]
},
{
gtfsId: "HSL:9993",
shortName: "993",
longName: "Söderkulla-Box-Gesterby-Nikkilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIwODIxMw==",
lat: 60.301052,
lon: 25.327132
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1NQ==",
lat: 60.298851,
lon: 25.337327
},
{
id: "U3RvcDpIU0w6OTIwODI1Nw==",
lat: 60.298,
lon: 25.339552
},
{
id: "U3RvcDpIU0w6OTIwODI1MA==",
lat: 60.296725,
lon: 25.350455
},
{
id: "U3RvcDpIU0w6OTIwODIzMA==",
lat: 60.29683,
lon: 25.35423
},
{
id: "U3RvcDpIU0w6OTIwODIzMg==",
lat: 60.29856,
lon: 25.358295
},
{
id: "U3RvcDpIU0w6OTIxMzIwNA==",
lat: 60.30139,
lon: 25.364787
},
{
id: "U3RvcDpIU0w6OTIxMzIwNg==",
lat: 60.304287,
lon: 25.371417
},
{
id: "U3RvcDpIU0w6OTIxMzIxMg==",
lat: 60.307833,
lon: 25.379585
},
{
id: "U3RvcDpIU0w6OTIxMzIzMg==",
lat: 60.311137,
lon: 25.38733
},
{
id: "U3RvcDpIU0w6OTIxMzIxNA==",
lat: 60.312295,
lon: 25.38889
},
{
id: "U3RvcDpIU0w6OTIxMzIwOQ==",
lat: 60.320625,
lon: 25.378695
},
{
id: "U3RvcDpIU0w6OTIxMzIwNQ==",
lat: 60.323652,
lon: 25.372752
},
{
id: "U3RvcDpIU0w6OTIxMzIwMg==",
lat: 60.325059,
lon: 25.364011
},
{
id: "U3RvcDpIU0w6OTIyMDIyOA==",
lat: 60.32928,
lon: 25.356063
},
{
id: "U3RvcDpIU0w6OTIyMDIyNQ==",
lat: 60.333433,
lon: 25.345335
},
{
id: "U3RvcDpIU0w6OTIyMDIzMw==",
lat: 60.336445,
lon: 25.322073
},
{
id: "U3RvcDpIU0w6OTIyMDIzMQ==",
lat: 60.338087,
lon: 25.314405
},
{
id: "U3RvcDpIU0w6OTIyMDIyOQ==",
lat: 60.339222,
lon: 25.305938
},
{
id: "U3RvcDpIU0w6OTIyMDIyNA==",
lat: 60.343604,
lon: 25.298369
},
{
id: "U3RvcDpIU0w6OTIyMDIyMA==",
lat: 60.334865,
lon: 25.280292
},
{
id: "U3RvcDpIU0w6OTIyMDIxMQ==",
lat: 60.333691,
lon: 25.265295
},
{
id: "U3RvcDpIU0w6OTIyMDIwNQ==",
lat: 60.340675,
lon: 25.263232
},
{
id: "U3RvcDpIU0w6OTIyMDIwNg==",
lat: 60.347598,
lon: 25.263275
},
{
id: "U3RvcDpIU0w6OTIyMDIxNA==",
lat: 60.353453,
lon: 25.26834
},
{
id: "U3RvcDpIU0w6OTIxNjIxOQ==",
lat: 60.356245,
lon: 25.266868
},
{
id: "U3RvcDpIU0w6OTIxNjIxNA==",
lat: 60.363368,
lon: 25.261563
},
{
id: "U3RvcDpIU0w6OTIyMjI0MA==",
lat: 60.369115,
lon: 25.258614
},
{
id: "U3RvcDpIU0w6OTIyMjIyMg==",
lat: 60.370252,
lon: 25.258915
},
{
id: "U3RvcDpIU0w6OTIyMjIyNQ==",
lat: 60.371527,
lon: 25.262477
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjI0Nw==",
lat: 60.374422,
lon: 25.253161
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjIyOQ==",
lat: 60.375727,
lon: 25.267724
},
{
id: "U3RvcDpIU0w6OTIyMjIyNg==",
lat: 60.371818,
lon: 25.262633
},
{
id: "U3RvcDpIU0w6OTIyMjIyMQ==",
lat: 60.37037,
lon: 25.258497
},
{
id: "U3RvcDpIU0w6OTIxNjIxMw==",
lat: 60.363567,
lon: 25.26105
},
{
id: "U3RvcDpIU0w6OTIyMDIxMg==",
lat: 60.354502,
lon: 25.267033
},
{
id: "U3RvcDpIU0w6OTIyMDIxNQ==",
lat: 60.351588,
lon: 25.267842
},
{
id: "U3RvcDpIU0w6OTIyMDIwNA==",
lat: 60.346382,
lon: 25.262063
},
{
id: "U3RvcDpIU0w6OTIyMDIwMw==",
lat: 60.339652,
lon: 25.262577
},
{
id: "U3RvcDpIU0w6OTIyMDIxOQ==",
lat: 60.334703,
lon: 25.278488
},
{
id: "U3RvcDpIU0w6OTIyMDIzMA==",
lat: 60.338982,
lon: 25.30602
},
{
id: "U3RvcDpIU0w6OTIyMDIzMg==",
lat: 60.337962,
lon: 25.314433
},
{
id: "U3RvcDpIU0w6OTIyMDIzNA==",
lat: 60.33629,
lon: 25.322145
},
{
id: "U3RvcDpIU0w6OTIyMDIyNg==",
lat: 60.333225,
lon: 25.345593
},
{
id: "U3RvcDpIU0w6OTIyMDIyNw==",
lat: 60.329183,
lon: 25.355528
},
{
id: "U3RvcDpIU0w6OTIxMzIwMQ==",
lat: 60.324762,
lon: 25.364348
},
{
id: "U3RvcDpIU0w6OTIxMzIwOA==",
lat: 60.323312,
lon: 25.373127
},
{
id: "U3RvcDpIU0w6OTIxMzIxMQ==",
lat: 60.320253,
lon: 25.379077
},
{
id: "U3RvcDpIU0w6OTIxMzIxMw==",
lat: 60.311393,
lon: 25.38738
},
{
id: "U3RvcDpIU0w6OTIxMzIxMA==",
lat: 60.307273,
lon: 25.377832
},
{
id: "U3RvcDpIU0w6OTIxMzIwNw==",
lat: 60.304748,
lon: 25.372035
},
{
id: "U3RvcDpIU0w6OTIxMzIwMw==",
lat: 60.301112,
lon: 25.36366
},
{
id: "U3RvcDpIU0w6OTIwODIzMw==",
lat: 60.299153,
lon: 25.359143
},
{
id: "U3RvcDpIU0w6OTIwODIzMQ==",
lat: 60.297247,
lon: 25.354823
},
{
id: "U3RvcDpIU0w6OTIwODI1MQ==",
lat: 60.297067,
lon: 25.347959
},
{
id: "U3RvcDpIU0w6OTIwODI1Ng==",
lat: 60.298387,
lon: 25.337094
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
}
]
},
{
gtfsId: "HSL:9994",
shortName: "994",
longName: "Söderkulla-Immersby-Gumbostrand",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIwODI1NQ==",
lat: 60.298851,
lon: 25.337327
},
{
id: "U3RvcDpIU0w6OTIwODIxNA==",
lat: 60.298227,
lon: 25.329072
},
{
id: "U3RvcDpIU0w6OTIwODIxMA==",
lat: 60.297008,
lon: 25.322927
},
{
id: "U3RvcDpIU0w6OTIxMDIxNQ==",
lat: 60.293106,
lon: 25.311242
},
{
id: "U3RvcDpIU0w6OTIxMDIxNw==",
lat: 60.296997,
lon: 25.303465
},
{
id: "U3RvcDpIU0w6OTIxMDIxMw==",
lat: 60.299633,
lon: 25.29339
},
{
id: "U3RvcDpIU0w6OTIxMDIwMQ==",
lat: 60.301505,
lon: 25.291138
},
{
id: "U3RvcDpIU0w6OTIwNjIxMQ==",
lat: 60.308734,
lon: 25.274715
},
{
id: "U3RvcDpIU0w6OTIwNjIwOQ==",
lat: 60.304884,
lon: 25.269237
},
{
id: "U3RvcDpIU0w6OTIwNjIwNw==",
lat: 60.298598,
lon: 25.2664
},
{
id: "U3RvcDpIU0w6OTIwNjIxNg==",
lat: 60.294149,
lon: 25.2651
},
{
id: "U3RvcDpIU0w6OTIwNjIwNQ==",
lat: 60.289662,
lon: 25.264373
},
{
id: "U3RvcDpIU0w6OTIwNjIwMw==",
lat: 60.281402,
lon: 25.254999
},
{
id: "U3RvcDpIU0w6OTIwNjIwMQ==",
lat: 60.276078,
lon: 25.254173
},
{
id: "U3RvcDpIU0w6OTIwNTIwNw==",
lat: 60.269785,
lon: 25.249705
},
{
id: "U3RvcDpIU0w6OTIwNTIwNQ==",
lat: 60.264545,
lon: 25.246093
},
{
id: "U3RvcDpIU0w6OTIwNTIwMg==",
lat: 60.261534,
lon: 25.236805
},
{
id: "U3RvcDpIU0w6OTIwNTIwMw==",
lat: 60.261642,
lon: 25.242721
},
{
id: "U3RvcDpIU0w6OTIwNTIxMA==",
lat: 60.262063,
lon: 25.256016
},
{
id: "U3RvcDpIU0w6OTIwNTIxMg==",
lat: 60.262335,
lon: 25.262876
},
{
id: "U3RvcDpIU0w6OTIwNDIwMg==",
lat: 60.26352,
lon: 25.268045
},
{
id: "U3RvcDpIU0w6OTIwNDIwNA==",
lat: 60.26572,
lon: 25.272465
},
{
id: "U3RvcDpIU0w6OTIwNDIwNg==",
lat: 60.26761,
lon: 25.27612
},
{
id: "U3RvcDpIU0w6OTIwNDIwOA==",
lat: 60.270106,
lon: 25.280453
},
{
id: "U3RvcDpIU0w6OTIwNDIxMA==",
lat: 60.269652,
lon: 25.285145
},
{
id: "U3RvcDpIU0w6OTIwNDIxMQ==",
lat: 60.262999,
lon: 25.285848
},
{
id: "U3RvcDpIU0w6OTIwNDIxNQ==",
lat: 60.258807,
lon: 25.288242
},
{
id: "U3RvcDpIU0w6OTIwNDIxNg==",
lat: 60.2558,
lon: 25.294289
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
},
{
id: "U3RvcDpIU0w6OTIwODIxMw==",
lat: 60.301052,
lon: 25.327132
},
{
id: "U3RvcDpIU0w6OTIwNDIxNA==",
lat: 60.259268,
lon: 25.287866
},
{
id: "U3RvcDpIU0w6OTIwNDIxMw==",
lat: 60.263888,
lon: 25.287839
},
{
id: "U3RvcDpIU0w6OTIwNDIwOQ==",
lat: 60.27005,
lon: 25.285327
},
{
id: "U3RvcDpIU0w6OTIwNDIwNw==",
lat: 60.269742,
lon: 25.279478
},
{
id: "U3RvcDpIU0w6OTIwNDIwNQ==",
lat: 60.26741,
lon: 25.275163
},
{
id: "U3RvcDpIU0w6OTIwNDIwMw==",
lat: 60.26462,
lon: 25.269811
},
{
id: "U3RvcDpIU0w6OTIwNTIxMQ==",
lat: 60.262375,
lon: 25.259562
},
{
id: "U3RvcDpIU0w6OTIwNTIwOQ==",
lat: 60.262158,
lon: 25.25394
},
{
id: "U3RvcDpIU0w6OTIwNTIwNA==",
lat: 60.26176,
lon: 25.240666
},
{
id: "U3RvcDpIU0w6OTIwNTIwNg==",
lat: 60.26459,
lon: 25.244993
},
{
id: "U3RvcDpIU0w6OTIwNTIwOA==",
lat: 60.269718,
lon: 25.24996
},
{
id: "U3RvcDpIU0w6OTIwNjIwMg==",
lat: 60.2761,
lon: 25.25433
},
{
id: "U3RvcDpIU0w6OTIwNjIwNA==",
lat: 60.28118,
lon: 25.255807
},
{
id: "U3RvcDpIU0w6OTIwNjIwNg==",
lat: 60.2891,
lon: 25.264402
},
{
id: "U3RvcDpIU0w6OTIwNjIxNQ==",
lat: 60.293778,
lon: 25.265185
},
{
id: "U3RvcDpIU0w6OTIwNjIwOA==",
lat: 60.297918,
lon: 25.267018
},
{
id: "U3RvcDpIU0w6OTIwNjIxMA==",
lat: 60.304835,
lon: 25.269837
},
{
id: "U3RvcDpIU0w6OTIxMDIwMg==",
lat: 60.301235,
lon: 25.291525
},
{
id: "U3RvcDpIU0w6OTIxMDIxNA==",
lat: 60.299623,
lon: 25.29316
},
{
id: "U3RvcDpIU0w6OTIxMDIxNg==",
lat: 60.296127,
lon: 25.304678
},
{
id: "U3RvcDpIU0w6OTIxMDIxMg==",
lat: 60.292936,
lon: 25.313265
},
{
id: "U3RvcDpIU0w6OTIwODIxMQ==",
lat: 60.297276,
lon: 25.324799
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODIxMg==",
lat: 60.300798,
lon: 25.32663
}
]
},
{
gtfsId: "HSL:7453",
shortName: "453",
longName: "Kamppi-Keimola-Luhtaanmäki (-Klaukkala-Lepsämä)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
}
]
},
{
gtfsId: "HSL:6243",
shortName: "243",
longName: "Espoon keskus-Muurala-Kolmperä-Kolmiranta-Veikkola",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE3MDI1Mw==",
lat: 60.282103,
lon: 24.436873
},
{
id: "U3RvcDpIU0w6NjE3MDI0OQ==",
lat: 60.280491,
lon: 24.430717
},
{
id: "U3RvcDpIU0w6NjE3MDI0Nw==",
lat: 60.276531,
lon: 24.422193
},
{
id: "U3RvcDpIU0w6NjE3MDIxMA==",
lat: 60.273982,
lon: 24.422243
},
{
id: "U3RvcDpIU0w6NjE3MDIwOA==",
lat: 60.272485,
lon: 24.427072
},
{
id: "U3RvcDpIU0w6NjE3MDIyOA==",
lat: 60.27056,
lon: 24.439
},
{
id: "U3RvcDpIU0w6NjE3MDIwNg==",
lat: 60.269694,
lon: 24.444329
},
{
id: "U3RvcDpIU0w6NjE3MDIwNA==",
lat: 60.26733,
lon: 24.45881
},
{
id: "U3RvcDpIU0w6NjE3MDIwMg==",
lat: 60.265087,
lon: 24.467145
},
{
id: "U3RvcDpIU0w6NjEyMDIwNw==",
lat: 60.261485,
lon: 24.476687
},
{
id: "U3RvcDpIU0w6NjEyMDIwNg==",
lat: 60.258358,
lon: 24.49241
},
{
id: "U3RvcDpIU0w6NjEyMDIwNA==",
lat: 60.255067,
lon: 24.504023
},
{
id: "U3RvcDpIU0w6MjY0MzIwNg==",
lat: 60.260402,
lon: 24.506295
},
{
id: "U3RvcDpIU0w6MjY0MzIwMg==",
lat: 60.25259,
lon: 24.51035
},
{
id: "U3RvcDpIU0w6MjY0MTIxNA==",
lat: 60.25265,
lon: 24.52128
},
{
id: "U3RvcDpIU0w6MjY0MTIxMg==",
lat: 60.24904,
lon: 24.53423
},
{
id: "U3RvcDpIU0w6MjY0NTIwMg==",
lat: 60.247725,
lon: 24.542425
},
{
id: "U3RvcDpIU0w6MjY0MjIxMA==",
lat: 60.24449,
lon: 24.57063
},
{
id: "U3RvcDpIU0w6MjY0MjIwOA==",
lat: 60.24355,
lon: 24.57839
},
{
id: "U3RvcDpIU0w6MjY0MjIwNg==",
lat: 60.23713,
lon: 24.5973
},
{
id: "U3RvcDpIU0w6MjY0MjIwNA==",
lat: 60.23408,
lon: 24.60218
},
{
id: "U3RvcDpIU0w6MjY0MjIwMg==",
lat: 60.23044,
lon: 24.60938
},
{
id: "U3RvcDpIU0w6MjYzNDIxNQ==",
lat: 60.22458,
lon: 24.62003
},
{
id: "U3RvcDpIU0w6MjYyMTIzOQ==",
lat: 60.21535,
lon: 24.62731
},
{
id: "U3RvcDpIU0w6MjYyMTIyMw==",
lat: 60.21355,
lon: 24.6296
},
{
id: "U3RvcDpIU0w6MjYyMTIyNQ==",
lat: 60.20841,
lon: 24.63715
},
{
id: "U3RvcDpIU0w6MjYyMTIwOA==",
lat: 60.20759,
lon: 24.64111
},
{
id: "U3RvcDpIU0w6MjYyMTIwMw==",
lat: 60.208636,
lon: 24.642381
},
{
id: "U3RvcDpIU0w6MjYyMTIwNw==",
lat: 60.21239,
lon: 24.64336
},
{
id: "U3RvcDpIU0w6MjYyMTIwNQ==",
lat: 60.21468,
lon: 24.64968
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxMTIxOQ==",
lat: 60.205048,
lon: 24.65511
},
{
id: "U3RvcDpIU0w6MjYxMTI1OA==",
lat: 60.20535,
lon: 24.65686
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYyMTIyMg==",
lat: 60.21448,
lon: 24.65221
},
{
id: "U3RvcDpIU0w6MjYyMTIwNA==",
lat: 60.21482,
lon: 24.64804
},
{
id: "U3RvcDpIU0w6MjYyMTIwNg==",
lat: 60.21173,
lon: 24.64243
},
{
id: "U3RvcDpIU0w6MjYyMTIwMg==",
lat: 60.20934,
lon: 24.64173
},
{
id: "U3RvcDpIU0w6MjYyMTIxNQ==",
lat: 60.20776,
lon: 24.64132
},
{
id: "U3RvcDpIU0w6MjYyMTIyNw==",
lat: 60.20734,
lon: 24.63928
},
{
id: "U3RvcDpIU0w6MjYyMTIyOA==",
lat: 60.20933,
lon: 24.63587
},
{
id: "U3RvcDpIU0w6MjYyMTIyNA==",
lat: 60.2142,
lon: 24.62969
},
{
id: "U3RvcDpIU0w6MjYyMTIzOA==",
lat: 60.21599,
lon: 24.6254
},
{
id: "U3RvcDpIU0w6MjYyMTIyNg==",
lat: 60.22471,
lon: 24.62008
},
{
id: "U3RvcDpIU0w6MjY0MjIwMQ==",
lat: 60.23029,
lon: 24.60998
},
{
id: "U3RvcDpIU0w6MjY0MjIwMw==",
lat: 60.23468,
lon: 24.60146
},
{
id: "U3RvcDpIU0w6MjY0MjIwNQ==",
lat: 60.23769,
lon: 24.59669
},
{
id: "U3RvcDpIU0w6MjY0MjIwNw==",
lat: 60.24339,
lon: 24.57975
},
{
id: "U3RvcDpIU0w6MjY0MjIwOQ==",
lat: 60.24446,
lon: 24.56828
},
{
id: "U3RvcDpIU0w6MjY0NTIwMQ==",
lat: 60.248088,
lon: 24.540307
},
{
id: "U3RvcDpIU0w6MjY0MTIxMQ==",
lat: 60.24935,
lon: 24.53317
},
{
id: "U3RvcDpIU0w6MjY0MTIxMw==",
lat: 60.25229,
lon: 24.52353
},
{
id: "U3RvcDpIU0w6MjY0MzIwMQ==",
lat: 60.25291,
lon: 24.50925
},
{
id: "U3RvcDpIU0w6NjEyMDIwMw==",
lat: 60.255567,
lon: 24.503348
},
{
id: "U3RvcDpIU0w6NjEyMDIwNQ==",
lat: 60.258547,
lon: 24.491167
},
{
id: "U3RvcDpIU0w6NjE3MDIwMQ==",
lat: 60.262065,
lon: 24.476103
},
{
id: "U3RvcDpIU0w6NjE3MDIwMw==",
lat: 60.265107,
lon: 24.46762
},
{
id: "U3RvcDpIU0w6NjE3MDIwNQ==",
lat: 60.267927,
lon: 24.456598
},
{
id: "U3RvcDpIU0w6NjE3MDIwNw==",
lat: 60.27008,
lon: 24.443606
},
{
id: "U3RvcDpIU0w6NjE3MDI1Mg==",
lat: 60.273048,
lon: 24.438664
},
{
id: "U3RvcDpIU0w6NjE3MDI1NA==",
lat: 60.278095,
lon: 24.44017
}
]
},
{
gtfsId: "HSL:9992",
shortName: "992",
longName: "Eriksnäs-Söderkulla-Massby-Hindsby-Nikkilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIwODI0Mg==",
lat: 60.277488,
lon: 25.343831
},
{
id: "U3RvcDpIU0w6OTIwODIzNw==",
lat: 60.277673,
lon: 25.347028
},
{
id: "U3RvcDpIU0w6OTIwODIzOA==",
lat: 60.280615,
lon: 25.3499
},
{
id: "U3RvcDpIU0w6OTIwODIzOQ==",
lat: 60.2809,
lon: 25.342967
},
{
id: "U3RvcDpIU0w6OTIwODIyMg==",
lat: 60.281302,
lon: 25.339902
},
{
id: "U3RvcDpIU0w6OTIwODIyMA==",
lat: 60.283958,
lon: 25.337303
},
{
id: "U3RvcDpIU0w6OTIwODI0Mw==",
lat: 60.286745,
lon: 25.332647
},
{
id: "U3RvcDpIU0w6OTIwODI0NQ==",
lat: 60.289431,
lon: 25.326682
},
{
id: "U3RvcDpIU0w6OTIwODI0Nw==",
lat: 60.293312,
lon: 25.324106
},
{
id: "U3RvcDpIU0w6OTIwODIxMQ==",
lat: 60.297276,
lon: 25.324799
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1NQ==",
lat: 60.298851,
lon: 25.337327
},
{
id: "U3RvcDpIU0w6OTIwODIxNA==",
lat: 60.298227,
lon: 25.329072
},
{
id: "U3RvcDpIU0w6OTIwODIxMA==",
lat: 60.297008,
lon: 25.322927
},
{
id: "U3RvcDpIU0w6OTIxMDIxNQ==",
lat: 60.293106,
lon: 25.311242
},
{
id: "U3RvcDpIU0w6OTIxMDIxNw==",
lat: 60.296997,
lon: 25.303465
},
{
id: "U3RvcDpIU0w6OTIxMDIxMw==",
lat: 60.299633,
lon: 25.29339
},
{
id: "U3RvcDpIU0w6OTIxMDIwMQ==",
lat: 60.301505,
lon: 25.291138
},
{
id: "U3RvcDpIU0w6OTIwNjIxMg==",
lat: 60.30921,
lon: 25.275717
},
{
id: "U3RvcDpIU0w6OTIwNjIxMw==",
lat: 60.313497,
lon: 25.273792
},
{
id: "U3RvcDpIU0w6OTIyMDIwMg==",
lat: 60.325852,
lon: 25.260437
},
{
id: "U3RvcDpIU0w6OTIxNTIwOQ==",
lat: 60.336688,
lon: 25.247502
},
{
id: "U3RvcDpIU0w6OTIxNTIwNA==",
lat: 60.339568,
lon: 25.245693
},
{
id: "U3RvcDpIU0w6OTIxNTIwNQ==",
lat: 60.340412,
lon: 25.248128
},
{
id: "U3RvcDpIU0w6OTIxNTIwOA==",
lat: 60.347518,
lon: 25.257662
},
{
id: "U3RvcDpIU0w6OTIxNjIxNg==",
lat: 60.350672,
lon: 25.261497
},
{
id: "U3RvcDpIU0w6OTIxNjIxOQ==",
lat: 60.356245,
lon: 25.266868
},
{
id: "U3RvcDpIU0w6OTIxNjIxNA==",
lat: 60.363368,
lon: 25.261563
},
{
id: "U3RvcDpIU0w6OTIyMjI0MA==",
lat: 60.369115,
lon: 25.258614
},
{
id: "U3RvcDpIU0w6OTIyMjIyMg==",
lat: 60.370252,
lon: 25.258915
},
{
id: "U3RvcDpIU0w6OTIyMjIyNQ==",
lat: 60.371527,
lon: 25.262477
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
},
{
id: "U3RvcDpIU0w6OTIwODIxMw==",
lat: 60.301052,
lon: 25.327132
},
{
id: "U3RvcDpIU0w6OTIyMjI0Nw==",
lat: 60.374422,
lon: 25.253161
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjIyOQ==",
lat: 60.375727,
lon: 25.267724
},
{
id: "U3RvcDpIU0w6OTIyMjIyNg==",
lat: 60.371818,
lon: 25.262633
},
{
id: "U3RvcDpIU0w6OTIyMjIyMQ==",
lat: 60.37037,
lon: 25.258497
},
{
id: "U3RvcDpIU0w6OTIxNjIxMw==",
lat: 60.363567,
lon: 25.26105
},
{
id: "U3RvcDpIU0w6OTIxNjIxOA==",
lat: 60.35467,
lon: 25.265408
},
{
id: "U3RvcDpIU0w6OTIxNjIxNQ==",
lat: 60.350546,
lon: 25.2606
},
{
id: "U3RvcDpIU0w6OTIxNTIwNw==",
lat: 60.347407,
lon: 25.257307
},
{
id: "U3RvcDpIU0w6OTIxNTIwMw==",
lat: 60.340095,
lon: 25.246608
},
{
id: "U3RvcDpIU0w6OTIxNTIxMA==",
lat: 60.336647,
lon: 25.246978
},
{
id: "U3RvcDpIU0w6OTIxNTIwNg==",
lat: 60.325803,
lon: 25.260235
},
{
id: "U3RvcDpIU0w6OTIwNjIxNA==",
lat: 60.313272,
lon: 25.27353
},
{
id: "U3RvcDpIU0w6OTIxMDIwMg==",
lat: 60.301235,
lon: 25.291525
},
{
id: "U3RvcDpIU0w6OTIxMDIxNA==",
lat: 60.299623,
lon: 25.29316
},
{
id: "U3RvcDpIU0w6OTIxMDIxNg==",
lat: 60.296127,
lon: 25.304678
},
{
id: "U3RvcDpIU0w6OTIxMDIxMg==",
lat: 60.292936,
lon: 25.313265
},
{
id: "U3RvcDpIU0w6OTIwODI1NA==",
lat: 60.298833,
lon: 25.337783
},
{
id: "U3RvcDpIU0w6OTIwODI0OQ==",
lat: 60.296766,
lon: 25.324194
},
{
id: "U3RvcDpIU0w6OTIwODI0OA==",
lat: 60.293385,
lon: 25.323918
},
{
id: "U3RvcDpIU0w6OTIwODI0Ng==",
lat: 60.289269,
lon: 25.326676
},
{
id: "U3RvcDpIU0w6OTIwODIxOQ==",
lat: 60.286666,
lon: 25.332354
},
{
id: "U3RvcDpIU0w6OTIwODIyMQ==",
lat: 60.283728,
lon: 25.337246
},
{
id: "U3RvcDpIU0w6OTIwODIyNA==",
lat: 60.281193,
lon: 25.339722
},
{
id: "U3RvcDpIU0w6OTIwODIxMg==",
lat: 60.300798,
lon: 25.32663
}
]
},
{
gtfsId: "HSL:7455",
shortName: "455",
longName: "Kamppi-Keimola-Luhtaanmäki (-Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
},
{
id: "U3RvcDpIU0w6NTAwMDIyOQ==",
lat: 60.363695,
lon: 24.783214
},
{
id: "U3RvcDpIU0w6NDMxMDIxNQ==",
lat: 60.35648,
lon: 24.79697
},
{
id: "U3RvcDpIU0w6NDMxMDIxMw==",
lat: 60.354738,
lon: 24.805117
},
{
id: "U3RvcDpIU0w6NDIyMDIwMg==",
lat: 60.313429,
lon: 24.840766
},
{
id: "U3RvcDpIU0w6NDE4MDIyMQ==",
lat: 60.288826,
lon: 24.861242
},
{
id: "U3RvcDpIU0w6NDE4MDIxOQ==",
lat: 60.28404,
lon: 24.86467
},
{
id: "U3RvcDpIU0w6NDE4MDIxNw==",
lat: 60.2782,
lon: 24.86844
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
}
]
},
{
gtfsId: "HSL:9995",
shortName: "995",
longName: "Söderkulla-Kalkkiranta",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIwODIxMg==",
lat: 60.300798,
lon: 25.32663
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1NQ==",
lat: 60.298851,
lon: 25.337327
},
{
id: "U3RvcDpIU0w6OTIwODI1Nw==",
lat: 60.298,
lon: 25.339552
},
{
id: "U3RvcDpIU0w6OTIwODI1MA==",
lat: 60.296725,
lon: 25.350455
},
{
id: "U3RvcDpIU0w6OTIwODIzMA==",
lat: 60.29683,
lon: 25.35423
},
{
id: "U3RvcDpIU0w6OTIwOTIwMg==",
lat: 60.29001,
lon: 25.3648
},
{
id: "U3RvcDpIU0w6OTIwOTIwMw==",
lat: 60.287186,
lon: 25.367533
},
{
id: "U3RvcDpIU0w6OTIwOTIwNg==",
lat: 60.28188,
lon: 25.37125
},
{
id: "U3RvcDpIU0w6OTIwOTIwNw==",
lat: 60.279902,
lon: 25.373073
},
{
id: "U3RvcDpIU0w6OTIwOTIxMA==",
lat: 60.276292,
lon: 25.383408
},
{
id: "U3RvcDpIU0w6OTIxMTIwMQ==",
lat: 60.271607,
lon: 25.391177
},
{
id: "U3RvcDpIU0w6OTIxMTIxMg==",
lat: 60.267235,
lon: 25.393565
},
{
id: "U3RvcDpIU0w6OTIxMTIwNw==",
lat: 60.26471,
lon: 25.392992
},
{
id: "U3RvcDpIU0w6OTIxMTIwNg==",
lat: 60.261228,
lon: 25.392478
},
{
id: "U3RvcDpIU0w6OTIxMTIwMg==",
lat: 60.25943,
lon: 25.390547
},
{
id: "U3RvcDpIU0w6OTIxMTIxMA==",
lat: 60.256199,
lon: 25.39278
},
{
id: "U3RvcDpIU0w6OTIxMTIwNQ==",
lat: 60.253103,
lon: 25.391623
},
{
id: "U3RvcDpIU0w6OTIxMTIwOA==",
lat: 60.256795,
lon: 25.393053
},
{
id: "U3RvcDpIU0w6OTIxMTIwNA==",
lat: 60.259075,
lon: 25.390903
},
{
id: "U3RvcDpIU0w6OTIxMTIxMQ==",
lat: 60.261828,
lon: 25.39308
},
{
id: "U3RvcDpIU0w6OTIxMTIwOQ==",
lat: 60.264493,
lon: 25.393385
},
{
id: "U3RvcDpIU0w6OTIxMTIxMw==",
lat: 60.26766,
lon: 25.393977
},
{
id: "U3RvcDpIU0w6OTIxMTIwMw==",
lat: 60.27286,
lon: 25.391138
},
{
id: "U3RvcDpIU0w6OTIwOTIwOQ==",
lat: 60.276688,
lon: 25.382672
},
{
id: "U3RvcDpIU0w6OTIwOTIwOA==",
lat: 60.279548,
lon: 25.373815
},
{
id: "U3RvcDpIU0w6OTIwOTIwNQ==",
lat: 60.28254,
lon: 25.37086
},
{
id: "U3RvcDpIU0w6OTIwOTIwNA==",
lat: 60.286737,
lon: 25.368327
},
{
id: "U3RvcDpIU0w6OTIwOTIwMQ==",
lat: 60.290598,
lon: 25.364878
},
{
id: "U3RvcDpIU0w6OTIwODIzMQ==",
lat: 60.297247,
lon: 25.354823
},
{
id: "U3RvcDpIU0w6OTIwODI1MQ==",
lat: 60.297067,
lon: 25.347959
},
{
id: "U3RvcDpIU0w6OTIwODI1Ng==",
lat: 60.298387,
lon: 25.337094
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
},
{
id: "U3RvcDpIU0w6OTIwODIxMw==",
lat: 60.301052,
lon: 25.327132
}
]
},
{
gtfsId: "HSL:7457",
shortName: "457",
longName: "Kamppi-Keimola-Luhtaanmäki (-Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NTAwMDIyOQ==",
lat: 60.363695,
lon: 24.783214
},
{
id: "U3RvcDpIU0w6NDMxMDIxNQ==",
lat: 60.35648,
lon: 24.79697
},
{
id: "U3RvcDpIU0w6NDMxMDIxMw==",
lat: 60.354738,
lon: 24.805117
},
{
id: "U3RvcDpIU0w6NDIyMDIwMg==",
lat: 60.313429,
lon: 24.840766
},
{
id: "U3RvcDpIU0w6NDE4MDIyMQ==",
lat: 60.288826,
lon: 24.861242
},
{
id: "U3RvcDpIU0w6NDE4MDIxOQ==",
lat: 60.28404,
lon: 24.86467
},
{
id: "U3RvcDpIU0w6NDE4MDIxNw==",
lat: 60.2782,
lon: 24.86844
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
}
]
},
{
gtfsId: "HSL:9996",
shortName: "996",
longName: "Söderkulla-Box-Spjutsund-Kitö",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIwODIxMg==",
lat: 60.300798,
lon: 25.32663
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1NQ==",
lat: 60.298851,
lon: 25.337327
},
{
id: "U3RvcDpIU0w6OTIwODI1Nw==",
lat: 60.298,
lon: 25.339552
},
{
id: "U3RvcDpIU0w6OTIwODI1MA==",
lat: 60.296725,
lon: 25.350455
},
{
id: "U3RvcDpIU0w6OTIwODIzMA==",
lat: 60.29683,
lon: 25.35423
},
{
id: "U3RvcDpIU0w6OTIwODIzMg==",
lat: 60.29856,
lon: 25.358295
},
{
id: "U3RvcDpIU0w6OTIxMzIwNA==",
lat: 60.30139,
lon: 25.364787
},
{
id: "U3RvcDpIU0w6OTIxMzIwNg==",
lat: 60.304287,
lon: 25.371417
},
{
id: "U3RvcDpIU0w6OTIxMzIxMg==",
lat: 60.307833,
lon: 25.379585
},
{
id: "U3RvcDpIU0w6OTIxMzIzMg==",
lat: 60.311137,
lon: 25.38733
},
{
id: "U3RvcDpIU0w6OTIxMzIxNg==",
lat: 60.30948,
lon: 25.392305
},
{
id: "U3RvcDpIU0w6OTIxMzIxOQ==",
lat: 60.30575,
lon: 25.393793
},
{
id: "U3RvcDpIU0w6OTIxMzIyMQ==",
lat: 60.303047,
lon: 25.395147
},
{
id: "U3RvcDpIU0w6OTIxMzIyNw==",
lat: 60.296998,
lon: 25.406437
},
{
id: "U3RvcDpIU0w6OTIxMjIwMQ==",
lat: 60.292188,
lon: 25.423855
},
{
id: "U3RvcDpIU0w6OTIxMjIwNg==",
lat: 60.290148,
lon: 25.431147
},
{
id: "U3RvcDpIU0w6OTIxMjIwOA==",
lat: 60.288982,
lon: 25.451786
},
{
id: "U3RvcDpIU0w6OTIxMjIxMA==",
lat: 60.288708,
lon: 25.469377
},
{
id: "U3RvcDpIU0w6OTIxMjIyNw==",
lat: 60.286088,
lon: 25.475258
},
{
id: "U3RvcDpIU0w6OTIxMjIxMg==",
lat: 60.275892,
lon: 25.481237
},
{
id: "U3RvcDpIU0w6OTIxMjIyMg==",
lat: 60.276007,
lon: 25.497185
},
{
id: "U3RvcDpIU0w6OTIxMjIyMQ==",
lat: 60.26736,
lon: 25.497347
},
{
id: "U3RvcDpIU0w6OTIxMjIyOQ==",
lat: 60.264368,
lon: 25.498797
},
{
id: "U3RvcDpIU0w6OTIxMjIyMA==",
lat: 60.258608,
lon: 25.494585
},
{
id: "U3RvcDpIU0w6OTIxMjIxMw==",
lat: 60.256825,
lon: 25.490902
},
{
id: "U3RvcDpIU0w6OTIxMjIxNw==",
lat: 60.254905,
lon: 25.49179
},
{
id: "U3RvcDpIU0w6OTIxMjIxNg==",
lat: 60.25213,
lon: 25.491102
},
{
id: "U3RvcDpIU0w6OTIxMjIxNA==",
lat: 60.249553,
lon: 25.491188
},
{
id: "U3RvcDpIU0w6OTIwMzIwNw==",
lat: 60.246117,
lon: 25.481498
},
{
id: "U3RvcDpIU0w6OTIwMzIwNQ==",
lat: 60.246708,
lon: 25.46968
},
{
id: "U3RvcDpIU0w6OTIwMzIwNA==",
lat: 60.244462,
lon: 25.460215
},
{
id: "U3RvcDpIU0w6OTIwMzIwMw==",
lat: 60.237163,
lon: 25.448733
},
{
id: "U3RvcDpIU0w6OTIwMzIwMg==",
lat: 60.244302,
lon: 25.459988
},
{
id: "U3RvcDpIU0w6OTIwMzIwNg==",
lat: 60.246427,
lon: 25.469128
},
{
id: "U3RvcDpIU0w6OTIwMzIwOA==",
lat: 60.245843,
lon: 25.483147
},
{
id: "U3RvcDpIU0w6OTIxMjIxOA==",
lat: 60.249555,
lon: 25.491298
},
{
id: "U3RvcDpIU0w6OTIxMjIxNQ==",
lat: 60.251958,
lon: 25.491348
},
{
id: "U3RvcDpIU0w6OTIxMjIxOQ==",
lat: 60.254592,
lon: 25.49182
},
{
id: "U3RvcDpIU0w6OTIxMjIwMg==",
lat: 60.256775,
lon: 25.491107
},
{
id: "U3RvcDpIU0w6OTIxMjIwMw==",
lat: 60.258547,
lon: 25.494788
},
{
id: "U3RvcDpIU0w6OTIxMjIyOA==",
lat: 60.264198,
lon: 25.498818
},
{
id: "U3RvcDpIU0w6OTIxMjIyMw==",
lat: 60.26754,
lon: 25.497573
},
{
id: "U3RvcDpIU0w6OTIxMjIyNA==",
lat: 60.275407,
lon: 25.49965
},
{
id: "U3RvcDpIU0w6OTIxMjIxMQ==",
lat: 60.276043,
lon: 25.481262
},
{
id: "U3RvcDpIU0w6OTIxMjIyNg==",
lat: 60.286448,
lon: 25.475165
},
{
id: "U3RvcDpIU0w6OTIxMjIwOQ==",
lat: 60.288988,
lon: 25.469313
},
{
id: "U3RvcDpIU0w6OTIxMjIwNw==",
lat: 60.289198,
lon: 25.450927
},
{
id: "U3RvcDpIU0w6OTIxMjIwNQ==",
lat: 60.290288,
lon: 25.430853
},
{
id: "U3RvcDpIU0w6OTIxMjIwNA==",
lat: 60.292646,
lon: 25.423446
},
{
id: "U3RvcDpIU0w6OTIxMzIyNg==",
lat: 60.297702,
lon: 25.405513
},
{
id: "U3RvcDpIU0w6OTIxMzIyMw==",
lat: 60.302875,
lon: 25.395385
},
{
id: "U3RvcDpIU0w6OTIxMzIxOA==",
lat: 60.30665,
lon: 25.393678
},
{
id: "U3RvcDpIU0w6OTIxMzIxNw==",
lat: 60.309948,
lon: 25.392422
},
{
id: "U3RvcDpIU0w6OTIxMzIxMw==",
lat: 60.311393,
lon: 25.38738
},
{
id: "U3RvcDpIU0w6OTIxMzIxMA==",
lat: 60.307273,
lon: 25.377832
},
{
id: "U3RvcDpIU0w6OTIxMzIwNw==",
lat: 60.304748,
lon: 25.372035
},
{
id: "U3RvcDpIU0w6OTIxMzIwMw==",
lat: 60.301112,
lon: 25.36366
},
{
id: "U3RvcDpIU0w6OTIwODIzMw==",
lat: 60.299153,
lon: 25.359143
},
{
id: "U3RvcDpIU0w6OTIwODIzMQ==",
lat: 60.297247,
lon: 25.354823
},
{
id: "U3RvcDpIU0w6OTIwODI1MQ==",
lat: 60.297067,
lon: 25.347959
},
{
id: "U3RvcDpIU0w6OTIwODI1Ng==",
lat: 60.298387,
lon: 25.337094
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
},
{
id: "U3RvcDpIU0w6OTIwODIxMw==",
lat: 60.301052,
lon: 25.327132
}
]
},
{
gtfsId: "HSL:7456",
shortName: "456",
longName: "Kamppi-Keimola-Luhtaanmäki (-Klaukkala)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxNA==",
lat: 60.35501,
lon: 24.80292
},
{
id: "U3RvcDpIU0w6NDMxMDIxNg==",
lat: 60.357291,
lon: 24.795849
},
{
id: "U3RvcDpIU0w6NTAwMDIzMA==",
lat: 60.364919,
lon: 24.782644
},
{
id: "U3RvcDpIU0w6NTAwMDIyOQ==",
lat: 60.363695,
lon: 24.783214
},
{
id: "U3RvcDpIU0w6NDMxMDIxNQ==",
lat: 60.35648,
lon: 24.79697
},
{
id: "U3RvcDpIU0w6NDMxMDIxMw==",
lat: 60.354738,
lon: 24.805117
},
{
id: "U3RvcDpIU0w6NDIyMDIwMg==",
lat: 60.313429,
lon: 24.840766
},
{
id: "U3RvcDpIU0w6NDE4MDIyMQ==",
lat: 60.288826,
lon: 24.861242
},
{
id: "U3RvcDpIU0w6NDE4MDIxOQ==",
lat: 60.28404,
lon: 24.86467
},
{
id: "U3RvcDpIU0w6NDE4MDIxNw==",
lat: 60.2782,
lon: 24.86844
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
}
]
},
{
gtfsId: "HSL:6917B",
shortName: "917B",
longName: "Kuntakeskus- Siuntion kk.-Hästböle",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMTA2Mg==",
lat: 60.153368,
lon: 24.056415
},
{
id: "U3RvcDpIU0w6NjMwMTA1NA==",
lat: 60.15476,
lon: 24.108385
},
{
id: "U3RvcDpIU0w6NjMwMDAyNQ==",
lat: 60.172955,
lon: 24.128346
},
{
id: "U3RvcDpIU0w6NjMwMDAyNA==",
lat: 60.175433,
lon: 24.14095
},
{
id: "U3RvcDpIU0w6NjMwMTAzOQ==",
lat: 60.171287,
lon: 24.163422
},
{
id: "U3RvcDpIU0w6NjMwMTA0Mg==",
lat: 60.169831,
lon: 24.177081
},
{
id: "U3RvcDpIU0w6NjMwMTAxNw==",
lat: 60.169201,
lon: 24.183381
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAzNQ==",
lat: 60.164811,
lon: 24.195876
},
{
id: "U3RvcDpIU0w6NjMwMTAyMQ==",
lat: 60.16978,
lon: 24.180586
},
{
id: "U3RvcDpIU0w6NjMwMTA0Mw==",
lat: 60.170338,
lon: 24.174548
},
{
id: "U3RvcDpIU0w6NjMwMTAzOA==",
lat: 60.172097,
lon: 24.162584
},
{
id: "U3RvcDpIU0w6NjMwMDAyMw==",
lat: 60.175065,
lon: 24.138551
},
{
id: "U3RvcDpIU0w6NjMwMDAyNg==",
lat: 60.173247,
lon: 24.126355
},
{
id: "U3RvcDpIU0w6NjMwMDAwOA==",
lat: 60.174069,
lon: 24.118695
},
{
id: "U3RvcDpIU0w6NjMwMDAxNQ==",
lat: 60.173856,
lon: 24.107636
},
{
id: "U3RvcDpIU0w6NjMwMDAyMg==",
lat: 60.173231,
lon: 24.100927
},
{
id: "U3RvcDpIU0w6NjMwMDAxMQ==",
lat: 60.176005,
lon: 24.091042
},
{
id: "U3RvcDpIU0w6NjMwMDAxNw==",
lat: 60.176911,
lon: 24.078211
},
{
id: "U3RvcDpIU0w6NjMwMDAxOQ==",
lat: 60.176033,
lon: 24.061181
},
{
id: "U3RvcDpIU0w6NjMwMDA0NQ==",
lat: 60.178602,
lon: 24.047017
},
{
id: "U3RvcDpIU0w6NjMwMDA0Nw==",
lat: 60.169277,
lon: 24.031715
}
]
},
{
gtfsId: "HSL:6917A",
shortName: "917A",
longName: "Kuntakeskus- Siuntion kk.- Hästböle",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAzNQ==",
lat: 60.164811,
lon: 24.195876
},
{
id: "U3RvcDpIU0w6NjMwMTAyMQ==",
lat: 60.16978,
lon: 24.180586
},
{
id: "U3RvcDpIU0w6NjMwMTA0Mw==",
lat: 60.170338,
lon: 24.174548
},
{
id: "U3RvcDpIU0w6NjMwMTAzOA==",
lat: 60.172097,
lon: 24.162584
},
{
id: "U3RvcDpIU0w6NjMwMDAyMw==",
lat: 60.175065,
lon: 24.138551
},
{
id: "U3RvcDpIU0w6NjMwMDAyNg==",
lat: 60.173247,
lon: 24.126355
},
{
id: "U3RvcDpIU0w6NjMwMTA1Mw==",
lat: 60.155434,
lon: 24.107037
},
{
id: "U3RvcDpIU0w6NjMwMTA2MQ==",
lat: 60.153436,
lon: 24.056342
},
{
id: "U3RvcDpIU0w6NjMwMDA0OA==",
lat: 60.169385,
lon: 24.031931
},
{
id: "U3RvcDpIU0w6NjMwMDAwNg==",
lat: 60.178044,
lon: 24.049176
},
{
id: "U3RvcDpIU0w6NjMwMDAxOA==",
lat: 60.176004,
lon: 24.062917
},
{
id: "U3RvcDpIU0w6NjMwMDAxNg==",
lat: 60.176563,
lon: 24.076933
},
{
id: "U3RvcDpIU0w6NjMwMDAxMA==",
lat: 60.174555,
lon: 24.093479
},
{
id: "U3RvcDpIU0w6NjMwMDAyMQ==",
lat: 60.173292,
lon: 24.101885
},
{
id: "U3RvcDpIU0w6NjMwMDAxNA==",
lat: 60.173985,
lon: 24.109245
},
{
id: "U3RvcDpIU0w6NjMwMDAwOQ==",
lat: 60.173839,
lon: 24.120039
},
{
id: "U3RvcDpIU0w6NjMwMDAyNQ==",
lat: 60.172955,
lon: 24.128346
},
{
id: "U3RvcDpIU0w6NjMwMDAyNA==",
lat: 60.175433,
lon: 24.14095
},
{
id: "U3RvcDpIU0w6NjMwMTAzOQ==",
lat: 60.171287,
lon: 24.163422
},
{
id: "U3RvcDpIU0w6NjMwMTA0Mg==",
lat: 60.169831,
lon: 24.177081
},
{
id: "U3RvcDpIU0w6NjMwMTAxNw==",
lat: 60.169201,
lon: 24.183381
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
}
]
},
{
gtfsId: "HSL:4736A",
shortName: "736A",
longName: "Jokiniemi-Tikkurila-Korso-Vierumäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDg3MDIwOQ==",
lat: 60.36346,
lon: 25.03033
},
{
id: "U3RvcDpIU0w6NDg3MDI5OA==",
lat: 60.36209,
lon: 25.03284
},
{
id: "U3RvcDpIU0w6NDg3MDIwOA==",
lat: 60.35962,
lon: 25.0369
},
{
id: "U3RvcDpIU0w6NDg3MDIwNg==",
lat: 60.35678,
lon: 25.04156
},
{
id: "U3RvcDpIU0w6NDg3MDIwNA==",
lat: 60.35473,
lon: 25.04276
},
{
id: "U3RvcDpIU0w6NDgxMDI0OA==",
lat: 60.35416,
lon: 25.05255
},
{
id: "U3RvcDpIU0w6NDgxMDIwOQ==",
lat: 60.35341,
lon: 25.0565
},
{
id: "U3RvcDpIU0w6NDgxMDIwNw==",
lat: 60.3529,
lon: 25.06141
},
{
id: "U3RvcDpIU0w6NDgxMDIwNQ==",
lat: 60.3526,
lon: 25.06612
},
{
id: "U3RvcDpIU0w6NDgxMDIzMA==",
lat: 60.35022,
lon: 25.07653
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mw==",
lat: 60.35276,
lon: 25.07843
},
{
id: "U3RvcDpIU0w6NDgzMDIxNg==",
lat: 60.3508,
lon: 25.08228
},
{
id: "U3RvcDpIU0w6NDgzMDIxMA==",
lat: 60.35088,
lon: 25.08547
},
{
id: "U3RvcDpIU0w6NDgzMDIxMg==",
lat: 60.35122,
lon: 25.09204
},
{
id: "U3RvcDpIU0w6NDgzMDIxNA==",
lat: 60.35088,
lon: 25.10211
},
{
id: "U3RvcDpIU0w6NDg0MDIxMg==",
lat: 60.35293,
lon: 25.10646
},
{
id: "U3RvcDpIU0w6NDg1MDIwOA==",
lat: 60.35287,
lon: 25.11271
},
{
id: "U3RvcDpIU0w6NDg1MDIwNg==",
lat: 60.35037,
lon: 25.11386
},
{
id: "U3RvcDpIU0w6NDg1MDIwNA==",
lat: 60.346552,
lon: 25.113178
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6NDg2MDIzNw==",
lat: 60.34486,
lon: 25.13346
},
{
id: "U3RvcDpIU0w6NDg2MDIyNQ==",
lat: 60.34486,
lon: 25.14023
},
{
id: "U3RvcDpIU0w6NDg2MDIyNw==",
lat: 60.34492,
lon: 25.14658
},
{
id: "U3RvcDpIU0w6NDg2MDIyOQ==",
lat: 60.342058,
lon: 25.146987
},
{
id: "U3RvcDpIU0w6NDg2MDIzMQ==",
lat: 60.34105,
lon: 25.14113
},
{
id: "U3RvcDpIU0w6NDg2MDIwNw==",
lat: 60.34049,
lon: 25.13834
},
{
id: "U3RvcDpIU0w6NDg2MDIzMw==",
lat: 60.33938,
lon: 25.13317
},
{
id: "U3RvcDpIU0w6NDg2MDIwMg==",
lat: 60.33761,
lon: 25.13086
},
{
id: "U3RvcDpIU0w6OTIxNDIwNg==",
lat: 60.329127,
lon: 25.133099
},
{
id: "U3RvcDpIU0w6OTIxNDIwOA==",
lat: 60.32346,
lon: 25.13657
},
{
id: "U3RvcDpIU0w6NDk3MDIxNg==",
lat: 60.31884,
lon: 25.12654
},
{
id: "U3RvcDpIU0w6NDk3MDIyMw==",
lat: 60.32021,
lon: 25.11481
},
{
id: "U3RvcDpIU0w6NDc1MDIwNw==",
lat: 60.32126,
lon: 25.11231
},
{
id: "U3RvcDpIU0w6NDc1MDIwNQ==",
lat: 60.3247,
lon: 25.10919
},
{
id: "U3RvcDpIU0w6NDc1MDI5OQ==",
lat: 60.32767,
lon: 25.10175
},
{
id: "U3RvcDpIU0w6NDc1MDIwMg==",
lat: 60.32803,
lon: 25.09629
},
{
id: "U3RvcDpIU0w6NDczMDIxMA==",
lat: 60.32863,
lon: 25.08983
},
{
id: "U3RvcDpIU0w6NDczMDIxMQ==",
lat: 60.32466,
lon: 25.0849
},
{
id: "U3RvcDpIU0w6NDc0MDI0NA==",
lat: 60.321734,
lon: 25.081964
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIwMg==",
lat: 60.32423,
lon: 25.07576
},
{
id: "U3RvcDpIU0w6NDc0MDIxOQ==",
lat: 60.32487,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIzNQ==",
lat: 60.32494,
lon: 25.06439
},
{
id: "U3RvcDpIU0w6NDc0MDIxNw==",
lat: 60.32322,
lon: 25.06293
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcyMDIyNw==",
lat: 60.325038,
lon: 25.050357
},
{
id: "U3RvcDpIU0w6NDcwMDIzMg==",
lat: 60.326547,
lon: 25.0421
},
{
id: "U3RvcDpIU0w6NDcwMDIzMw==",
lat: 60.325487,
lon: 25.041647
},
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyMg==",
lat: 60.32129,
lon: 25.04674
},
{
id: "U3RvcDpIU0w6NDcwMDIxNg==",
lat: 60.31977,
lon: 25.05094
},
{
id: "U3RvcDpIU0w6NDcwMDIxNA==",
lat: 60.31738,
lon: 25.04942
},
{
id: "U3RvcDpIU0w6NDY1MDIzMA==",
lat: 60.31343,
lon: 25.04126
},
{
id: "U3RvcDpIU0w6NDYwMDIxNA==",
lat: 60.31155,
lon: 25.03821
},
{
id: "U3RvcDpIU0w6NDYwMDIxMg==",
lat: 60.30809,
lon: 25.0336
},
{
id: "U3RvcDpIU0w6NDYwMDIxMA==",
lat: 60.30671,
lon: 25.03683
},
{
id: "U3RvcDpIU0w6NDYwMDIwOA==",
lat: 60.30441,
lon: 25.04265
},
{
id: "U3RvcDpIU0w6NDYwMDIwNg==",
lat: 60.30239,
lon: 25.0452
},
{
id: "U3RvcDpIU0w6NDYwMDIwNA==",
lat: 60.30139,
lon: 25.04087
},
{
id: "U3RvcDpIU0w6NDYxMDIzOQ==",
lat: 60.299,
lon: 25.04094
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI0OQ==",
lat: 60.293842,
lon: 25.044378
},
{
id: "U3RvcDpIU0w6NDYxMDIzNg==",
lat: 60.29838,
lon: 25.0454
},
{
id: "U3RvcDpIU0w6NDYyMDIyNw==",
lat: 60.29821,
lon: 25.05193
},
{
id: "U3RvcDpIU0w6NDYyMDIxNw==",
lat: 60.29828,
lon: 25.055708
},
{
id: "U3RvcDpIU0w6NDYyMDIwOQ==",
lat: 60.29521,
lon: 25.05924
},
{
id: "U3RvcDpIU0w6NDYyMDIyOA==",
lat: 60.29393,
lon: 25.05428
},
{
id: "U3RvcDpIU0w6NDYyMDIyMw==",
lat: 60.2934,
lon: 25.05029
},
{
id: "U3RvcDpIU0w6NDYyMDIyNQ==",
lat: 60.29529,
lon: 25.04892
},
{
id: "U3RvcDpIU0w6NDYyMDIzMQ==",
lat: 60.2985,
lon: 25.05011
},
{
id: "U3RvcDpIU0w6NDYxMDIzNw==",
lat: 60.29861,
lon: 25.044342
},
{
id: "U3RvcDpIU0w6NDYxMDI1NQ==",
lat: 60.294244,
lon: 25.044551
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIxNQ==",
lat: 60.29674,
lon: 25.03984
},
{
id: "U3RvcDpIU0w6NDYwMDIwMQ==",
lat: 60.30027,
lon: 25.04059
},
{
id: "U3RvcDpIU0w6NDYwMDIwMw==",
lat: 60.30174,
lon: 25.04301
},
{
id: "U3RvcDpIU0w6NDYwMDIwNQ==",
lat: 60.30359,
lon: 25.04489
},
{
id: "U3RvcDpIU0w6NDYwMDIwNw==",
lat: 60.30492,
lon: 25.0414
},
{
id: "U3RvcDpIU0w6NDYwMDIwOQ==",
lat: 60.30643,
lon: 25.03734
},
{
id: "U3RvcDpIU0w6NDYwMDIxMw==",
lat: 60.30911,
lon: 25.03456
},
{
id: "U3RvcDpIU0w6NDYwMDIxNQ==",
lat: 60.31201,
lon: 25.03987
},
{
id: "U3RvcDpIU0w6NDYwMDIxNg==",
lat: 60.31412,
lon: 25.04235
},
{
id: "U3RvcDpIU0w6NDcwMDIxNQ==",
lat: 60.31732,
lon: 25.04971
},
{
id: "U3RvcDpIU0w6NDcwMDIyMw==",
lat: 60.32062,
lon: 25.05047
},
{
id: "U3RvcDpIU0w6NDcwMDIyNA==",
lat: 60.32183,
lon: 25.04486
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
},
{
id: "U3RvcDpIU0w6NDcwMDIzNA==",
lat: 60.325902,
lon: 25.041882
},
{
id: "U3RvcDpIU0w6NDcyMDIyNQ==",
lat: 60.326482,
lon: 25.043723
},
{
id: "U3RvcDpIU0w6NDcwMDIwNw==",
lat: 60.3246,
lon: 25.05219
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNg==",
lat: 60.3233,
lon: 25.06344
},
{
id: "U3RvcDpIU0w6NDc0MDIxOA==",
lat: 60.32491,
lon: 25.06624
},
{
id: "U3RvcDpIU0w6NDc0MDIwMQ==",
lat: 60.32424,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDczMDIwMg==",
lat: 60.32258,
lon: 25.08323
},
{
id: "U3RvcDpIU0w6NDczMDIxMg==",
lat: 60.32542,
lon: 25.08531
},
{
id: "U3RvcDpIU0w6NDczMDIwOQ==",
lat: 60.32853,
lon: 25.08968
},
{
id: "U3RvcDpIU0w6NDc1MDIwMQ==",
lat: 60.3279,
lon: 25.09475
},
{
id: "U3RvcDpIU0w6NDc1MDIwMw==",
lat: 60.32736,
lon: 25.10289
},
{
id: "U3RvcDpIU0w6NDc1MDIwNA==",
lat: 60.32423,
lon: 25.10955
},
{
id: "U3RvcDpIU0w6NDc1MDIwNg==",
lat: 60.32138,
lon: 25.11206
},
{
id: "U3RvcDpIU0w6NDk3MDIyNA==",
lat: 60.31994,
lon: 25.11693
},
{
id: "U3RvcDpIU0w6NDk3MDIxNQ==",
lat: 60.32003,
lon: 25.12451
},
{
id: "U3RvcDpIU0w6NDk3MDIxMw==",
lat: 60.31868,
lon: 25.12728
},
{
id: "U3RvcDpIU0w6OTIxNDIwOQ==",
lat: 60.324263,
lon: 25.137407
},
{
id: "U3RvcDpIU0w6OTIxNDIwNQ==",
lat: 60.329622,
lon: 25.13404
},
{
id: "U3RvcDpIU0w6NDg2MDIwMQ==",
lat: 60.336937,
lon: 25.131358
},
{
id: "U3RvcDpIU0w6NDg2MDIzNA==",
lat: 60.33946,
lon: 25.13387
},
{
id: "U3RvcDpIU0w6NDg2MDIzMg==",
lat: 60.34099,
lon: 25.14079
},
{
id: "U3RvcDpIU0w6NDg2MDIzMA==",
lat: 60.34199,
lon: 25.14701
},
{
id: "U3RvcDpIU0w6NDg2MDIyOA==",
lat: 60.3449,
lon: 25.14691
},
{
id: "U3RvcDpIU0w6NDg2MDIyNg==",
lat: 60.34491,
lon: 25.14009
},
{
id: "U3RvcDpIU0w6NDg2MDIyNA==",
lat: 60.3452,
lon: 25.13308
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMw==",
lat: 60.34529,
lon: 25.11796
},
{
id: "U3RvcDpIU0w6NDg1MDIwNQ==",
lat: 60.346137,
lon: 25.113348
},
{
id: "U3RvcDpIU0w6NDg1MDIwNw==",
lat: 60.35075,
lon: 25.11402
},
{
id: "U3RvcDpIU0w6NDg1MDIwOQ==",
lat: 60.35293,
lon: 25.11242
},
{
id: "U3RvcDpIU0w6NDgzMDIwOQ==",
lat: 60.35221,
lon: 25.10526
},
{
id: "U3RvcDpIU0w6NDgzMDIxNQ==",
lat: 60.35086,
lon: 25.09986
},
{
id: "U3RvcDpIU0w6NDgzMDIxMw==",
lat: 60.3513,
lon: 25.09164
},
{
id: "U3RvcDpIU0w6NDgzMDIxMQ==",
lat: 60.35094,
lon: 25.08546
},
{
id: "U3RvcDpIU0w6NDgzMDIxOA==",
lat: 60.35126,
lon: 25.08085
},
{
id: "U3RvcDpIU0w6NDgxMDI0Mg==",
lat: 60.3525,
lon: 25.07726
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIyOA==",
lat: 60.35035,
lon: 25.07627
},
{
id: "U3RvcDpIU0w6NDgxMDIwNA==",
lat: 60.35271,
lon: 25.06532
},
{
id: "U3RvcDpIU0w6NDgxMDIwNg==",
lat: 60.3531,
lon: 25.06058
},
{
id: "U3RvcDpIU0w6NDgxMDIwOA==",
lat: 60.35364,
lon: 25.05589
},
{
id: "U3RvcDpIU0w6NDg3MDIwMQ==",
lat: 60.35446,
lon: 25.05036
},
{
id: "U3RvcDpIU0w6NDg3MDIwMw==",
lat: 60.35477,
lon: 25.04369
},
{
id: "U3RvcDpIU0w6NDg3MDIwNQ==",
lat: 60.3564,
lon: 25.04229
},
{
id: "U3RvcDpIU0w6NDg3MDIwNw==",
lat: 60.36029,
lon: 25.03591
},
{
id: "U3RvcDpIU0w6NDg3MDI5OQ==",
lat: 60.36186,
lon: 25.03334
}
]
},
{
gtfsId: "HSL:9785K",
shortName: "785K",
longName: "Rautatientori-Kuninkaanmäki-Nikkilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyNDIxMA==",
lat: 60.391625,
lon: 25.276295
},
{
id: "U3RvcDpIU0w6OTIyNDIwNA==",
lat: 60.390328,
lon: 25.27607
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxNjIxMQ==",
lat: 60.368428,
lon: 25.230412
},
{
id: "U3RvcDpIU0w6OTIxNjIwOQ==",
lat: 60.365565,
lon: 25.224187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNw==",
lat: 60.361667,
lon: 25.213187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNQ==",
lat: 60.361128,
lon: 25.205277
},
{
id: "U3RvcDpIU0w6OTIxNjIwMg==",
lat: 60.36037,
lon: 25.193757
},
{
id: "U3RvcDpIU0w6OTIxNDIyNA==",
lat: 60.359773,
lon: 25.180833
},
{
id: "U3RvcDpIU0w6OTIxNDIyMg==",
lat: 60.358407,
lon: 25.176255
},
{
id: "U3RvcDpIU0w6OTIxNDIyMA==",
lat: 60.357083,
lon: 25.167383
},
{
id: "U3RvcDpIU0w6OTIxNDIyNw==",
lat: 60.354067,
lon: 25.158408
},
{
id: "U3RvcDpIU0w6OTIxNDIxNg==",
lat: 60.34661,
lon: 25.152565
},
{
id: "U3RvcDpIU0w6OTIxNDIyNQ==",
lat: 60.342921,
lon: 25.152253
},
{
id: "U3RvcDpIU0w6NDg2MDIyOQ==",
lat: 60.342058,
lon: 25.146987
},
{
id: "U3RvcDpIU0w6NDg2MDIzMQ==",
lat: 60.34105,
lon: 25.14113
},
{
id: "U3RvcDpIU0w6NDg2MDIwNw==",
lat: 60.34049,
lon: 25.13834
},
{
id: "U3RvcDpIU0w6NDg2MDIzMw==",
lat: 60.33938,
lon: 25.13317
},
{
id: "U3RvcDpIU0w6NDg2MDIwMg==",
lat: 60.33761,
lon: 25.13086
},
{
id: "U3RvcDpIU0w6OTIxNDIwNg==",
lat: 60.329127,
lon: 25.133099
},
{
id: "U3RvcDpIU0w6OTIxNDIwOA==",
lat: 60.32346,
lon: 25.13657
},
{
id: "U3RvcDpIU0w6NDk3MDIxNA==",
lat: 60.31839,
lon: 25.12634
},
{
id: "U3RvcDpIU0w6NDk3MDIxMg==",
lat: 60.3094,
lon: 25.1222
},
{
id: "U3RvcDpIU0w6NDk3MDIxMA==",
lat: 60.307773,
lon: 25.114235
},
{
id: "U3RvcDpIU0w6NDk3MDI5OA==",
lat: 60.307177,
lon: 25.109792
},
{
id: "U3RvcDpIU0w6NDk3MDIxOA==",
lat: 60.304039,
lon: 25.104318
},
{
id: "U3RvcDpIU0w6NDk3MDI5Ng==",
lat: 60.30183,
lon: 25.10375
},
{
id: "U3RvcDpIU0w6NDk2MDIxNw==",
lat: 60.29775,
lon: 25.10205
},
{
id: "U3RvcDpIU0w6NDk2MDI5OQ==",
lat: 60.292049,
lon: 25.099393
},
{
id: "U3RvcDpIU0w6NDk2MDIxNQ==",
lat: 60.28741,
lon: 25.10189
},
{
id: "U3RvcDpIU0w6NDk0MDIyMw==",
lat: 60.2806,
lon: 25.10108
},
{
id: "U3RvcDpIU0w6NDkzMDIyNg==",
lat: 60.27535,
lon: 25.09522
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwMA==",
lat: 60.173091,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6NDk3MDIxNg==",
lat: 60.31884,
lon: 25.12654
},
{
id: "U3RvcDpIU0w6NDk3MDIyMg==",
lat: 60.31916,
lon: 25.11493
},
{
id: "U3RvcDpIU0w6NDk3MDIyMA==",
lat: 60.31307,
lon: 25.10852
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIyNQ==",
lat: 60.27255,
lon: 25.09256
},
{
id: "U3RvcDpIU0w6NDkzMDIzMA==",
lat: 60.27502,
lon: 25.09521
},
{
id: "U3RvcDpIU0w6NDk0MDIyMg==",
lat: 60.28128,
lon: 25.102
},
{
id: "U3RvcDpIU0w6NDk2MDIxNA==",
lat: 60.2883,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6NDk2MDI5OA==",
lat: 60.293118,
lon: 25.099951
},
{
id: "U3RvcDpIU0w6NDk2MDIxNg==",
lat: 60.2979,
lon: 25.10244
},
{
id: "U3RvcDpIU0w6NDk3MDI5Nw==",
lat: 60.30293,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6NDk3MDI0NQ==",
lat: 60.304945,
lon: 25.106319
},
{
id: "U3RvcDpIU0w6NDk3MDI5OQ==",
lat: 60.30677,
lon: 25.109677
},
{
id: "U3RvcDpIU0w6NDk3MDIzNw==",
lat: 60.307303,
lon: 25.116067
},
{
id: "U3RvcDpIU0w6NDk3MDIxMQ==",
lat: 60.30996,
lon: 25.12301
},
{
id: "U3RvcDpIU0w6NDk3MDIxMw==",
lat: 60.31868,
lon: 25.12728
},
{
id: "U3RvcDpIU0w6OTIxNDIwOQ==",
lat: 60.324263,
lon: 25.137407
},
{
id: "U3RvcDpIU0w6OTIxNDIwNQ==",
lat: 60.329622,
lon: 25.13404
},
{
id: "U3RvcDpIU0w6NDg2MDIwMQ==",
lat: 60.336937,
lon: 25.131358
},
{
id: "U3RvcDpIU0w6NDg2MDIzNA==",
lat: 60.33946,
lon: 25.13387
},
{
id: "U3RvcDpIU0w6NDg2MDIzMg==",
lat: 60.34099,
lon: 25.14079
},
{
id: "U3RvcDpIU0w6NDg2MDIzMA==",
lat: 60.34199,
lon: 25.14701
},
{
id: "U3RvcDpIU0w6OTIxNDIyNg==",
lat: 60.342592,
lon: 25.152172
},
{
id: "U3RvcDpIU0w6OTIxNDIxNw==",
lat: 60.347115,
lon: 25.152818
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwNg==",
lat: 60.387638,
lon: 25.28011
},
{
id: "U3RvcDpIU0w6NDk3MDIxNw==",
lat: 60.30573,
lon: 25.10498
},
{
id: "U3RvcDpIU0w6NDk3MDIxOQ==",
lat: 60.31407,
lon: 25.10985
},
{
id: "U3RvcDpIU0w6NDk3MDIyMQ==",
lat: 60.31937,
lon: 25.11534
},
{
id: "U3RvcDpIU0w6NDk3MDIxNQ==",
lat: 60.32003,
lon: 25.12451
}
]
},
{
gtfsId: "HSL:9989",
shortName: "989",
longName: "Pornainen-Järvenpää as.",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTQwMDIxNg==",
lat: 60.475649,
lon: 25.374388
},
{
id: "U3RvcDpIU0w6OTQwMDIwOA==",
lat: 60.477653,
lon: 25.374435
},
{
id: "U3RvcDpIU0w6OTQwMDIwMw==",
lat: 60.484878,
lon: 25.36799
},
{
id: "U3RvcDpIU0w6OTQwMDIxNw==",
lat: 60.467104,
lon: 25.28211
},
{
id: "U3RvcDpIU0w6OTIyNjIyNA==",
lat: 60.470385,
lon: 25.260995
},
{
id: "U3RvcDpIU0w6OTIyNjIxMw==",
lat: 60.47014,
lon: 25.24792
},
{
id: "U3RvcDpIU0w6OTIyNzIyMg==",
lat: 60.475795,
lon: 25.226008
},
{
id: "U3RvcDpIU0w6OTIyNzIxOA==",
lat: 60.475422,
lon: 25.216608
},
{
id: "U3RvcDpIU0w6OTIyNzIxMg==",
lat: 60.472927,
lon: 25.209372
},
{
id: "U3RvcDpIU0w6OTIyNzIxMQ==",
lat: 60.471717,
lon: 25.203932
},
{
id: "U3RvcDpIU0w6OTIyNzIwOA==",
lat: 60.470497,
lon: 25.19664
},
{
id: "U3RvcDpIU0w6OTIyNzIwNg==",
lat: 60.469533,
lon: 25.189673
},
{
id: "U3RvcDpIU0w6OTIyNzIwNQ==",
lat: 60.469993,
lon: 25.169843
},
{
id: "U3RvcDpIU0w6OTIyNzIwNA==",
lat: 60.470315,
lon: 25.157247
},
{
id: "U3RvcDpIU0w6OTUwMDIyNA==",
lat: 60.470406,
lon: 25.150845
},
{
id: "U3RvcDpIU0w6OTUwMDIwNA==",
lat: 60.470263,
lon: 25.139763
},
{
id: "U3RvcDpIU0w6OTUwMDIwNg==",
lat: 60.46899,
lon: 25.132184
},
{
id: "U3RvcDpIU0w6OTUwMDIyNg==",
lat: 60.467716,
lon: 25.129178
},
{
id: "U3RvcDpIU0w6OTUwMDIyOA==",
lat: 60.465217,
lon: 25.119395
},
{
id: "U3RvcDpIU0w6OTUwMDIxOQ==",
lat: 60.465756,
lon: 25.117527
},
{
id: "U3RvcDpIU0w6OTUwMDIxMQ==",
lat: 60.482336,
lon: 25.098393
},
{
id: "U3RvcDpIU0w6OTUwMDIwOA==",
lat: 60.484409,
lon: 25.090334
},
{
id: "U3RvcDpIU0w6OTUwMDIxMA==",
lat: 60.482476,
lon: 25.085652
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIwMA==",
lat: 60.47372,
lon: 25.090098
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwMg==",
lat: 60.482417,
lon: 25.077775
},
{
id: "U3RvcDpIU0w6OTUwNzAwNw==",
lat: 60.482216,
lon: 25.085202
},
{
id: "U3RvcDpIU0w6OTUwMDIxMw==",
lat: 60.465162,
lon: 25.119466
},
{
id: "U3RvcDpIU0w6OTUwMDIxNQ==",
lat: 60.468319,
lon: 25.130789
},
{
id: "U3RvcDpIU0w6OTUwMDIxNw==",
lat: 60.470208,
lon: 25.140627
},
{
id: "U3RvcDpIU0w6OTIyNzIwMw==",
lat: 60.470235,
lon: 25.153188
},
{
id: "U3RvcDpIU0w6OTIyNzIwMQ==",
lat: 60.470105,
lon: 25.158263
},
{
id: "U3RvcDpIU0w6OTIyNzIwMg==",
lat: 60.469752,
lon: 25.171968
},
{
id: "U3RvcDpIU0w6OTIyNzIwNw==",
lat: 60.469552,
lon: 25.191689
},
{
id: "U3RvcDpIU0w6OTIyNzIwOQ==",
lat: 60.47042,
lon: 25.197325
},
{
id: "U3RvcDpIU0w6OTIyNzIxMA==",
lat: 60.4712,
lon: 25.202058
},
{
id: "U3RvcDpIU0w6OTIyNzIxMw==",
lat: 60.473458,
lon: 25.211468
},
{
id: "U3RvcDpIU0w6OTIyNzIxOQ==",
lat: 60.4755,
lon: 25.217918
},
{
id: "U3RvcDpIU0w6OTIyNzIyMw==",
lat: 60.475468,
lon: 25.22686
},
{
id: "U3RvcDpIU0w6OTIyNjIxNA==",
lat: 60.469845,
lon: 25.250117
},
{
id: "U3RvcDpIU0w6OTIyNjIyNQ==",
lat: 60.470257,
lon: 25.262365
},
{
id: "U3RvcDpIU0w6OTQwMDIxOA==",
lat: 60.467015,
lon: 25.28387
},
{
id: "U3RvcDpIU0w6OTQwMDIwMg==",
lat: 60.483505,
lon: 25.368993
},
{
id: "U3RvcDpIU0w6OTQwMDIwOQ==",
lat: 60.47742,
lon: 25.374157
}
]
},
{
gtfsId: "HSL:2437K",
shortName: "437K",
longName: "Martinlaakso-Juvanmalmi-Perusmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcxNDI1NQ==",
lat: 60.286994,
lon: 24.725706
},
{
id: "U3RvcDpIU0w6MjcxNDI1NA==",
lat: 60.28594,
lon: 24.73075
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mw==",
lat: 60.28618,
lon: 24.73694
},
{
id: "U3RvcDpIU0w6MjcxNTI1MQ==",
lat: 60.28582,
lon: 24.74113
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOA==",
lat: 60.27823,
lon: 24.75086
},
{
id: "U3RvcDpIU0w6MjcxNTIzNg==",
lat: 60.27871,
lon: 24.75894
},
{
id: "U3RvcDpIU0w6MjcxNTIzNA==",
lat: 60.2784,
lon: 24.76146
},
{
id: "U3RvcDpIU0w6MjcxNTIzMQ==",
lat: 60.2743,
lon: 24.76071
},
{
id: "U3RvcDpIU0w6MjcxNTIzMA==",
lat: 60.26954,
lon: 24.75945
},
{
id: "U3RvcDpIU0w6NDEyMDIxNw==",
lat: 60.27395,
lon: 24.78154
},
{
id: "U3RvcDpIU0w6NDEyMDIzNg==",
lat: 60.272876,
lon: 24.790986
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxMQ==",
lat: 60.2773,
lon: 24.85304
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDEyMDIxNA==",
lat: 60.27342,
lon: 24.7938
},
{
id: "U3RvcDpIU0w6NDEyMDIxNg==",
lat: 60.27395,
lon: 24.77924
},
{
id: "U3RvcDpIU0w6MjcxNTIyOQ==",
lat: 60.27164,
lon: 24.76011
},
{
id: "U3RvcDpIU0w6MjcxNTIzMg==",
lat: 60.275,
lon: 24.76107
},
{
id: "U3RvcDpIU0w6MjcxNTIzMw==",
lat: 60.278,
lon: 24.76154
},
{
id: "U3RvcDpIU0w6MjcxNTIzNQ==",
lat: 60.27888,
lon: 24.7575
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0OQ==",
lat: 60.28471,
lon: 24.74512
},
{
id: "U3RvcDpIU0w6MjcxNTI1MA==",
lat: 60.28549,
lon: 24.74204
},
{
id: "U3RvcDpIU0w6MjcxNDI1Mg==",
lat: 60.28637,
lon: 24.73772
},
{
id: "U3RvcDpIU0w6MjcxNDI5Ng==",
lat: 60.28573,
lon: 24.73092
}
]
},
{
gtfsId: "HSL:4711K",
shortName: "711K",
longName: "Kuninkaanmäki-Sotunki-Tikkurila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk3MDIzMg==",
lat: 60.30053,
lon: 25.10575
},
{
id: "U3RvcDpIU0w6NDk2MDIwNQ==",
lat: 60.29786,
lon: 25.10536
},
{
id: "U3RvcDpIU0w6NDk2MDIwNg==",
lat: 60.29764,
lon: 25.11134
},
{
id: "U3RvcDpIU0w6NDk2MDIwNw==",
lat: 60.29731,
lon: 25.11392
},
{
id: "U3RvcDpIU0w6NDk2MDIxMQ==",
lat: 60.29767,
lon: 25.12152
},
{
id: "U3RvcDpIU0w6NDk4MDIwMQ==",
lat: 60.2977,
lon: 25.12546
},
{
id: "U3RvcDpIU0w6NDk4MDIwMw==",
lat: 60.297,
lon: 25.12953
},
{
id: "U3RvcDpIU0w6NDk4MDIwNQ==",
lat: 60.29406,
lon: 25.13442
},
{
id: "U3RvcDpIU0w6NDk4MDIxOQ==",
lat: 60.29327,
lon: 25.13677
},
{
id: "U3RvcDpIU0w6NDk4MDIwNw==",
lat: 60.29198,
lon: 25.13955
},
{
id: "U3RvcDpIU0w6NDk4MDIwOQ==",
lat: 60.28843,
lon: 25.13889
},
{
id: "U3RvcDpIU0w6NDk4MDIxMQ==",
lat: 60.28449,
lon: 25.13485
},
{
id: "U3RvcDpIU0w6NDk4MDIxMw==",
lat: 60.27735,
lon: 25.13335
},
{
id: "U3RvcDpIU0w6NDk0MDIwMQ==",
lat: 60.27995,
lon: 25.12467
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNQ==",
lat: 60.27901,
lon: 25.10592
},
{
id: "U3RvcDpIU0w6NDk0MDIxMw==",
lat: 60.28017,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDk0MDIxMQ==",
lat: 60.280871,
lon: 25.095651
},
{
id: "U3RvcDpIU0w6NDY0MDIxMA==",
lat: 60.28163,
lon: 25.08709
},
{
id: "U3RvcDpIU0w6NDY0MDIxMQ==",
lat: 60.28169,
lon: 25.07941
},
{
id: "U3RvcDpIU0w6NDY0MDI5MA==",
lat: 60.279277,
lon: 25.078762
},
{
id: "U3RvcDpIU0w6NDY0MDI5NA==",
lat: 60.28066,
lon: 25.07098
},
{
id: "U3RvcDpIU0w6NDY0MDIyNg==",
lat: 60.28304,
lon: 25.06759
},
{
id: "U3RvcDpIU0w6NDY0MDIyNA==",
lat: 60.28498,
lon: 25.06687
},
{
id: "U3RvcDpIU0w6NDY0MDIyMg==",
lat: 60.28505,
lon: 25.06294
},
{
id: "U3RvcDpIU0w6NDY0MDIyMA==",
lat: 60.28623,
lon: 25.05673
},
{
id: "U3RvcDpIU0w6NDY0MDIxOA==",
lat: 60.28555,
lon: 25.0519
},
{
id: "U3RvcDpIU0w6NDY0MDIxNg==",
lat: 60.28301,
lon: 25.0481
},
{
id: "U3RvcDpIU0w6NDY0MDI5Mg==",
lat: 60.28589,
lon: 25.04432
},
{
id: "U3RvcDpIU0w6NDY0MDIwMg==",
lat: 60.28895,
lon: 25.04713
},
{
id: "U3RvcDpIU0w6NDYyMDIwMQ==",
lat: 60.29099,
lon: 25.04725
},
{
id: "U3RvcDpIU0w6NDYyMDIyMw==",
lat: 60.2934,
lon: 25.05029
},
{
id: "U3RvcDpIU0w6NDYyMDIyNQ==",
lat: 60.29529,
lon: 25.04892
},
{
id: "U3RvcDpIU0w6NDYyMDIzMQ==",
lat: 60.2985,
lon: 25.05011
},
{
id: "U3RvcDpIU0w6NDYxMDIzNw==",
lat: 60.29861,
lon: 25.044342
},
{
id: "U3RvcDpIU0w6NDYxMDIwNw==",
lat: 60.293293,
lon: 25.043366
},
{
id: "U3RvcDpIU0w6NDYxMDI0OQ==",
lat: 60.293842,
lon: 25.044378
},
{
id: "U3RvcDpIU0w6NDYxMDIzNg==",
lat: 60.29838,
lon: 25.0454
},
{
id: "U3RvcDpIU0w6NDYyMDIyNg==",
lat: 60.29803,
lon: 25.0506
},
{
id: "U3RvcDpIU0w6NDYyMDIyNA==",
lat: 60.29566,
lon: 25.04876
},
{
id: "U3RvcDpIU0w6NDYyMDIwNA==",
lat: 60.29256,
lon: 25.05016
},
{
id: "U3RvcDpIU0w6NDY0MDIwMQ==",
lat: 60.28954,
lon: 25.04697
},
{
id: "U3RvcDpIU0w6NDY0MDI5Mw==",
lat: 60.28541,
lon: 25.04517
},
{
id: "U3RvcDpIU0w6NDY0MDIxNw==",
lat: 60.28283,
lon: 25.04819
},
{
id: "U3RvcDpIU0w6NDY0MDIxOQ==",
lat: 60.28581,
lon: 25.05395
},
{
id: "U3RvcDpIU0w6NDY0MDIyMQ==",
lat: 60.28585,
lon: 25.05881
},
{
id: "U3RvcDpIU0w6NDY0MDIyMw==",
lat: 60.28491,
lon: 25.06423
},
{
id: "U3RvcDpIU0w6NDY0MDIyNQ==",
lat: 60.28286,
lon: 25.06756
},
{
id: "U3RvcDpIU0w6NDY0MDI5NQ==",
lat: 60.28049,
lon: 25.07192
},
{
id: "U3RvcDpIU0w6NDY0MDI5MQ==",
lat: 60.27915,
lon: 25.078957
},
{
id: "U3RvcDpIU0w6NDY0MDIxMg==",
lat: 60.27986,
lon: 25.079974
},
{
id: "U3RvcDpIU0w6NDY0MDIwNw==",
lat: 60.28193,
lon: 25.0804
},
{
id: "U3RvcDpIU0w6NDY0MDIwOQ==",
lat: 60.28153,
lon: 25.0894
},
{
id: "U3RvcDpIU0w6NDk0MDIxMA==",
lat: 60.28073,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6NDk0MDIxMg==",
lat: 60.27969,
lon: 25.10342
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyOA==",
lat: 60.2815,
lon: 25.12098
},
{
id: "U3RvcDpIU0w6NDk0MDIwMg==",
lat: 60.2793,
lon: 25.12528
},
{
id: "U3RvcDpIU0w6NDk4MDIxNA==",
lat: 60.27794,
lon: 25.13378
},
{
id: "U3RvcDpIU0w6NDk4MDIxMg==",
lat: 60.28507,
lon: 25.13526
},
{
id: "U3RvcDpIU0w6NDk4MDIxMA==",
lat: 60.2892,
lon: 25.13926
},
{
id: "U3RvcDpIU0w6NDk4MDIxOA==",
lat: 60.29201,
lon: 25.13969
},
{
id: "U3RvcDpIU0w6NDk4MDIwOA==",
lat: 60.29297,
lon: 25.13781
},
{
id: "U3RvcDpIU0w6NDk4MDIwNg==",
lat: 60.29396,
lon: 25.13554
},
{
id: "U3RvcDpIU0w6NDk4MDIwNA==",
lat: 60.29711,
lon: 25.12958
},
{
id: "U3RvcDpIU0w6NDk4MDIwMg==",
lat: 60.29776,
lon: 25.12568
},
{
id: "U3RvcDpIU0w6NDk2MDIxMw==",
lat: 60.29795,
lon: 25.12205
},
{
id: "U3RvcDpIU0w6NDk2MDI0MQ==",
lat: 60.29773,
lon: 25.11143
},
{
id: "U3RvcDpIU0w6NDk2MDIzMA==",
lat: 60.29761,
lon: 25.10883
},
{
id: "U3RvcDpIU0w6NDk2MDIxMg==",
lat: 60.29888,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk3MDIzMw==",
lat: 60.30091,
lon: 25.10537
}
]
},
{
gtfsId: "HSL:9982",
shortName: "982",
longName: "Nikkilä-Neulasniitty-Talma",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIxNzIxOQ==",
lat: 60.410142,
lon: 25.17315
},
{
id: "U3RvcDpIU0w6OTIxNzIxNA==",
lat: 60.407043,
lon: 25.171219
},
{
id: "U3RvcDpIU0w6OTIxNzIyMQ==",
lat: 60.406233,
lon: 25.177323
},
{
id: "U3RvcDpIU0w6OTIxNzIxNQ==",
lat: 60.398158,
lon: 25.173505
},
{
id: "U3RvcDpIU0w6OTIxNzIwNw==",
lat: 60.394252,
lon: 25.157717
},
{
id: "U3RvcDpIU0w6OTIxODIxMQ==",
lat: 60.392501,
lon: 25.156707
},
{
id: "U3RvcDpIU0w6OTIxODIwNw==",
lat: 60.3889,
lon: 25.168335
},
{
id: "U3RvcDpIU0w6OTIxODIxNA==",
lat: 60.38417,
lon: 25.166616
},
{
id: "U3RvcDpIU0w6OTIxNjIwNA==",
lat: 60.377218,
lon: 25.198547
},
{
id: "U3RvcDpIU0w6OTIxOTIwNQ==",
lat: 60.375226,
lon: 25.218328
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjIyOQ==",
lat: 60.375727,
lon: 25.267724
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxOTIwNA==",
lat: 60.375665,
lon: 25.21708
},
{
id: "U3RvcDpIU0w6OTIxOTIwMQ==",
lat: 60.377612,
lon: 25.197257
},
{
id: "U3RvcDpIU0w6OTIxODIxMw==",
lat: 60.384348,
lon: 25.166671
},
{
id: "U3RvcDpIU0w6OTIxODIwOA==",
lat: 60.389152,
lon: 25.16883
},
{
id: "U3RvcDpIU0w6OTIxODIwMg==",
lat: 60.391667,
lon: 25.163828
},
{
id: "U3RvcDpIU0w6OTIxODIwMQ==",
lat: 60.391825,
lon: 25.15709
},
{
id: "U3RvcDpIU0w6OTIxNzIwOA==",
lat: 60.39438,
lon: 25.15819
},
{
id: "U3RvcDpIU0w6OTIxNzIxNg==",
lat: 60.398057,
lon: 25.17341
},
{
id: "U3RvcDpIU0w6OTIxNzIyMA==",
lat: 60.406852,
lon: 25.175837
},
{
id: "U3RvcDpIU0w6OTIxNzIxMQ==",
lat: 60.40764,
lon: 25.169534
},
{
id: "U3RvcDpIU0w6OTIxNzIwNA==",
lat: 60.408213,
lon: 25.157368
},
{
id: "U3RvcDpIU0w6OTIxNzIwOQ==",
lat: 60.410837,
lon: 25.165923
},
{
id: "U3RvcDpIU0w6OTIxNzIxMw==",
lat: 60.41258,
lon: 25.171132
}
]
},
{
gtfsId: "HSL:9986",
shortName: "986",
longName: "Nikkilä-Etelä-Paippinen-Järvenpään asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyMjI0Nw==",
lat: 60.374422,
lon: 25.253161
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI1OQ==",
lat: 60.375139,
lon: 25.267128
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwNg==",
lat: 60.387638,
lon: 25.28011
},
{
id: "U3RvcDpIU0w6OTIyNDIwMw==",
lat: 60.392063,
lon: 25.274625
},
{
id: "U3RvcDpIU0w6OTIyNDIwMg==",
lat: 60.393787,
lon: 25.274147
},
{
id: "U3RvcDpIU0w6OTIyOTIwMg==",
lat: 60.398647,
lon: 25.269158
},
{
id: "U3RvcDpIU0w6OTIyNjIyOA==",
lat: 60.408537,
lon: 25.268675
},
{
id: "U3RvcDpIU0w6OTIyNjIyNg==",
lat: 60.413232,
lon: 25.263592
},
{
id: "U3RvcDpIU0w6OTIyNjIyMw==",
lat: 60.415632,
lon: 25.25889
},
{
id: "U3RvcDpIU0w6OTIyNjIxNw==",
lat: 60.420212,
lon: 25.254323
},
{
id: "U3RvcDpIU0w6OTIyNjIzMA==",
lat: 60.421925,
lon: 25.255975
},
{
id: "U3RvcDpIU0w6OTIyNjIxOQ==",
lat: 60.426023,
lon: 25.254642
},
{
id: "U3RvcDpIU0w6OTIyNjIyMA==",
lat: 60.430535,
lon: 25.254848
},
{
id: "U3RvcDpIU0w6OTIyNjIxMg==",
lat: 60.43706,
lon: 25.24765
},
{
id: "U3RvcDpIU0w6OTIyNjIwNw==",
lat: 60.441348,
lon: 25.24349
},
{
id: "U3RvcDpIU0w6OTIyNjIxMA==",
lat: 60.444093,
lon: 25.24524
},
{
id: "U3RvcDpIU0w6OTIyNjIwNg==",
lat: 60.447018,
lon: 25.243005
},
{
id: "U3RvcDpIU0w6OTIyNjIwNA==",
lat: 60.452095,
lon: 25.234323
},
{
id: "U3RvcDpIU0w6OTIyNjIwMQ==",
lat: 60.455432,
lon: 25.227765
},
{
id: "U3RvcDpIU0w6OTIyNzIyMQ==",
lat: 60.461243,
lon: 25.218707
},
{
id: "U3RvcDpIU0w6OTIyNzIxNg==",
lat: 60.467624,
lon: 25.216748
},
{
id: "U3RvcDpIU0w6OTIyNzIxNQ==",
lat: 60.471467,
lon: 25.213445
},
{
id: "U3RvcDpIU0w6OTIyNzIxMg==",
lat: 60.472927,
lon: 25.209372
},
{
id: "U3RvcDpIU0w6OTIyNzIxMQ==",
lat: 60.471717,
lon: 25.203932
},
{
id: "U3RvcDpIU0w6OTIyNzIwOA==",
lat: 60.470497,
lon: 25.19664
},
{
id: "U3RvcDpIU0w6OTIyNzIwNg==",
lat: 60.469533,
lon: 25.189673
},
{
id: "U3RvcDpIU0w6OTIyNzIwNQ==",
lat: 60.469993,
lon: 25.169843
},
{
id: "U3RvcDpIU0w6OTIyNzIwNA==",
lat: 60.470315,
lon: 25.157247
},
{
id: "U3RvcDpIU0w6OTUwMDIyNA==",
lat: 60.470406,
lon: 25.150845
},
{
id: "U3RvcDpIU0w6OTUwMDIwNA==",
lat: 60.470263,
lon: 25.139763
},
{
id: "U3RvcDpIU0w6OTUwMDIwNg==",
lat: 60.46899,
lon: 25.132184
},
{
id: "U3RvcDpIU0w6OTUwMDIyNg==",
lat: 60.467716,
lon: 25.129178
},
{
id: "U3RvcDpIU0w6OTUwMDIyOA==",
lat: 60.465217,
lon: 25.119395
},
{
id: "U3RvcDpIU0w6OTUwMDIxOQ==",
lat: 60.465756,
lon: 25.117527
},
{
id: "U3RvcDpIU0w6OTUwMDIxMQ==",
lat: 60.482336,
lon: 25.098393
},
{
id: "U3RvcDpIU0w6OTUwMDIwOA==",
lat: 60.484409,
lon: 25.090334
},
{
id: "U3RvcDpIU0w6OTUwMDIxMA==",
lat: 60.482476,
lon: 25.085652
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIwMA==",
lat: 60.47372,
lon: 25.090098
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwNw==",
lat: 60.482216,
lon: 25.085202
},
{
id: "U3RvcDpIU0w6OTUwMDIxMw==",
lat: 60.465162,
lon: 25.119466
},
{
id: "U3RvcDpIU0w6OTUwMDIxNQ==",
lat: 60.468319,
lon: 25.130789
},
{
id: "U3RvcDpIU0w6OTUwMDIxNw==",
lat: 60.470208,
lon: 25.140627
},
{
id: "U3RvcDpIU0w6OTIyNzIwMw==",
lat: 60.470235,
lon: 25.153188
},
{
id: "U3RvcDpIU0w6OTIyNzIwMQ==",
lat: 60.470105,
lon: 25.158263
},
{
id: "U3RvcDpIU0w6OTIyNzIwMg==",
lat: 60.469752,
lon: 25.171968
},
{
id: "U3RvcDpIU0w6OTIyNzIwNw==",
lat: 60.469552,
lon: 25.191689
},
{
id: "U3RvcDpIU0w6OTIyNzIwOQ==",
lat: 60.47042,
lon: 25.197325
},
{
id: "U3RvcDpIU0w6OTIyNzIxMA==",
lat: 60.4712,
lon: 25.202058
},
{
id: "U3RvcDpIU0w6OTIyNzIxNA==",
lat: 60.47113,
lon: 25.213387
},
{
id: "U3RvcDpIU0w6OTIyNzIxNw==",
lat: 60.466915,
lon: 25.21712
},
{
id: "U3RvcDpIU0w6OTIyNzIyMA==",
lat: 60.461053,
lon: 25.21862
},
{
id: "U3RvcDpIU0w6OTIyNjIwMg==",
lat: 60.455297,
lon: 25.22762
},
{
id: "U3RvcDpIU0w6OTIyNjIwMw==",
lat: 60.452169,
lon: 25.234042
},
{
id: "U3RvcDpIU0w6OTIyNjIwNQ==",
lat: 60.447078,
lon: 25.242497
},
{
id: "U3RvcDpIU0w6OTIyNjIwOQ==",
lat: 60.443535,
lon: 25.24445
},
{
id: "U3RvcDpIU0w6OTIyNjIwOA==",
lat: 60.440662,
lon: 25.24323
},
{
id: "U3RvcDpIU0w6OTIyNjIxMQ==",
lat: 60.436636,
lon: 25.247597
},
{
id: "U3RvcDpIU0w6OTIyNjIxNQ==",
lat: 60.430718,
lon: 25.254243
},
{
id: "U3RvcDpIU0w6OTIyNjIxNg==",
lat: 60.426205,
lon: 25.254507
},
{
id: "U3RvcDpIU0w6OTIyNjIxOA==",
lat: 60.422542,
lon: 25.25485
},
{
id: "U3RvcDpIU0w6OTIyNjIyMQ==",
lat: 60.419297,
lon: 25.254857
},
{
id: "U3RvcDpIU0w6OTIyNjIyMg==",
lat: 60.415777,
lon: 25.257725
},
{
id: "U3RvcDpIU0w6OTIyNjIyNw==",
lat: 60.412108,
lon: 25.26331
},
{
id: "U3RvcDpIU0w6OTIyNjIyOQ==",
lat: 60.40789,
lon: 25.268195
},
{
id: "U3RvcDpIU0w6OTIyOTIwMQ==",
lat: 60.39883,
lon: 25.268908
},
{
id: "U3RvcDpIU0w6OTIyNDIwMQ==",
lat: 60.394237,
lon: 25.273913
},
{
id: "U3RvcDpIU0w6OTIyNDIwNA==",
lat: 60.390328,
lon: 25.27607
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
}
]
},
{
gtfsId: "HSL:9987",
shortName: "987",
longName: "Nikkilä-Pornainen-Järvenpään asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyMjI1OQ==",
lat: 60.375139,
lon: 25.267128
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwOA==",
lat: 60.386435,
lon: 25.282542
},
{
id: "U3RvcDpIU0w6OTIyOTIwMw==",
lat: 60.390658,
lon: 25.291292
},
{
id: "U3RvcDpIU0w6OTIyOTIwNg==",
lat: 60.393408,
lon: 25.296543
},
{
id: "U3RvcDpIU0w6OTIyOTIwOA==",
lat: 60.396172,
lon: 25.298523
},
{
id: "U3RvcDpIU0w6OTIyNTIwMw==",
lat: 60.402635,
lon: 25.299295
},
{
id: "U3RvcDpIU0w6OTIyNTIwNQ==",
lat: 60.406127,
lon: 25.30665
},
{
id: "U3RvcDpIU0w6OTIyNTIwNg==",
lat: 60.40681,
lon: 25.315015
},
{
id: "U3RvcDpIU0w6OTIyNTIwOA==",
lat: 60.40889,
lon: 25.318735
},
{
id: "U3RvcDpIU0w6OTIyNTIwOQ==",
lat: 60.410377,
lon: 25.321968
},
{
id: "U3RvcDpIU0w6OTIyNTIxMg==",
lat: 60.41308,
lon: 25.328807
},
{
id: "U3RvcDpIU0w6OTIyNTIxNA==",
lat: 60.416008,
lon: 25.330725
},
{
id: "U3RvcDpIU0w6OTIyNTIxNQ==",
lat: 60.418978,
lon: 25.332633
},
{
id: "U3RvcDpIU0w6OTIyNTIxOA==",
lat: 60.425025,
lon: 25.338565
},
{
id: "U3RvcDpIU0w6OTQwMDIxMQ==",
lat: 60.435523,
lon: 25.368753
},
{
id: "U3RvcDpIU0w6OTQwMDIwOA==",
lat: 60.477653,
lon: 25.374435
},
{
id: "U3RvcDpIU0w6OTQwMDIwMw==",
lat: 60.484878,
lon: 25.36799
},
{
id: "U3RvcDpIU0w6OTQwMDIxNw==",
lat: 60.467104,
lon: 25.28211
},
{
id: "U3RvcDpIU0w6OTIyNjIyNA==",
lat: 60.470385,
lon: 25.260995
},
{
id: "U3RvcDpIU0w6OTIyNjIxMw==",
lat: 60.47014,
lon: 25.24792
},
{
id: "U3RvcDpIU0w6OTIyNzIyMg==",
lat: 60.475795,
lon: 25.226008
},
{
id: "U3RvcDpIU0w6OTIyNzIxOA==",
lat: 60.475422,
lon: 25.216608
},
{
id: "U3RvcDpIU0w6OTIyNzIxMg==",
lat: 60.472927,
lon: 25.209372
},
{
id: "U3RvcDpIU0w6OTIyNzIxMQ==",
lat: 60.471717,
lon: 25.203932
},
{
id: "U3RvcDpIU0w6OTIyNzIwOA==",
lat: 60.470497,
lon: 25.19664
},
{
id: "U3RvcDpIU0w6OTIyNzIwNg==",
lat: 60.469533,
lon: 25.189673
},
{
id: "U3RvcDpIU0w6OTIyNzIwNQ==",
lat: 60.469993,
lon: 25.169843
},
{
id: "U3RvcDpIU0w6OTIyNzIwNA==",
lat: 60.470315,
lon: 25.157247
},
{
id: "U3RvcDpIU0w6OTUwMDIyNA==",
lat: 60.470406,
lon: 25.150845
},
{
id: "U3RvcDpIU0w6OTUwMDIwNA==",
lat: 60.470263,
lon: 25.139763
},
{
id: "U3RvcDpIU0w6OTUwMDIwNg==",
lat: 60.46899,
lon: 25.132184
},
{
id: "U3RvcDpIU0w6OTUwMDIyNg==",
lat: 60.467716,
lon: 25.129178
},
{
id: "U3RvcDpIU0w6OTUwMDIyOA==",
lat: 60.465217,
lon: 25.119395
},
{
id: "U3RvcDpIU0w6OTUwMDIxOQ==",
lat: 60.465756,
lon: 25.117527
},
{
id: "U3RvcDpIU0w6OTUwMDIxMQ==",
lat: 60.482336,
lon: 25.098393
},
{
id: "U3RvcDpIU0w6OTUwMDIwOA==",
lat: 60.484409,
lon: 25.090334
},
{
id: "U3RvcDpIU0w6OTUwMDIxMA==",
lat: 60.482476,
lon: 25.085652
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIwMA==",
lat: 60.47372,
lon: 25.090098
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwNw==",
lat: 60.482216,
lon: 25.085202
},
{
id: "U3RvcDpIU0w6OTUwMDIxMw==",
lat: 60.465162,
lon: 25.119466
},
{
id: "U3RvcDpIU0w6OTUwMDIxNQ==",
lat: 60.468319,
lon: 25.130789
},
{
id: "U3RvcDpIU0w6OTUwMDIxNw==",
lat: 60.470208,
lon: 25.140627
},
{
id: "U3RvcDpIU0w6OTIyNzIwMw==",
lat: 60.470235,
lon: 25.153188
},
{
id: "U3RvcDpIU0w6OTIyNzIwMQ==",
lat: 60.470105,
lon: 25.158263
},
{
id: "U3RvcDpIU0w6OTIyNzIwMg==",
lat: 60.469752,
lon: 25.171968
},
{
id: "U3RvcDpIU0w6OTIyNzIwNw==",
lat: 60.469552,
lon: 25.191689
},
{
id: "U3RvcDpIU0w6OTIyNzIwOQ==",
lat: 60.47042,
lon: 25.197325
},
{
id: "U3RvcDpIU0w6OTIyNzIxMA==",
lat: 60.4712,
lon: 25.202058
},
{
id: "U3RvcDpIU0w6OTIyNzIxMw==",
lat: 60.473458,
lon: 25.211468
},
{
id: "U3RvcDpIU0w6OTIyNzIxOQ==",
lat: 60.4755,
lon: 25.217918
},
{
id: "U3RvcDpIU0w6OTIyNzIyMw==",
lat: 60.475468,
lon: 25.22686
},
{
id: "U3RvcDpIU0w6OTIyNjIxNA==",
lat: 60.469845,
lon: 25.250117
},
{
id: "U3RvcDpIU0w6OTIyNjIyNQ==",
lat: 60.470257,
lon: 25.262365
},
{
id: "U3RvcDpIU0w6OTQwMDIxOA==",
lat: 60.467015,
lon: 25.28387
},
{
id: "U3RvcDpIU0w6OTQwMDIwMg==",
lat: 60.483505,
lon: 25.368993
},
{
id: "U3RvcDpIU0w6OTQwMDIwOQ==",
lat: 60.47742,
lon: 25.374157
},
{
id: "U3RvcDpIU0w6OTQwMDIxMA==",
lat: 60.434959,
lon: 25.367006
},
{
id: "U3RvcDpIU0w6OTIyNTIxNw==",
lat: 60.42515,
lon: 25.338463
},
{
id: "U3RvcDpIU0w6OTIyNTIxNg==",
lat: 60.41998,
lon: 25.332845
},
{
id: "U3RvcDpIU0w6OTIyNTIxMw==",
lat: 60.41603,
lon: 25.33023
},
{
id: "U3RvcDpIU0w6OTIyNTIxMQ==",
lat: 60.412957,
lon: 25.328448
},
{
id: "U3RvcDpIU0w6OTIyNTIxMA==",
lat: 60.410613,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyNTIwMQ==",
lat: 60.408782,
lon: 25.318287
},
{
id: "U3RvcDpIU0w6OTIyNTIwNw==",
lat: 60.406928,
lon: 25.314803
},
{
id: "U3RvcDpIU0w6OTIyNTIwNA==",
lat: 60.405853,
lon: 25.305318
},
{
id: "U3RvcDpIU0w6OTIyNTIwMg==",
lat: 60.401832,
lon: 25.298322
},
{
id: "U3RvcDpIU0w6OTIyOTIwNw==",
lat: 60.395527,
lon: 25.298033
},
{
id: "U3RvcDpIU0w6OTIyOTIwNQ==",
lat: 60.392832,
lon: 25.295147
},
{
id: "U3RvcDpIU0w6OTIyOTIwNA==",
lat: 60.390917,
lon: 25.291257
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
}
]
},
{
gtfsId: "HSL:9984",
shortName: "984",
longName: "Hindsby (Knuters)-Nikkilä-Talma",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIxNzIxOQ==",
lat: 60.410142,
lon: 25.17315
},
{
id: "U3RvcDpIU0w6OTIxNzIxNA==",
lat: 60.407043,
lon: 25.171219
},
{
id: "U3RvcDpIU0w6OTIxNzIyMQ==",
lat: 60.406233,
lon: 25.177323
},
{
id: "U3RvcDpIU0w6OTIxNzIyMw==",
lat: 60.401692,
lon: 25.192712
},
{
id: "U3RvcDpIU0w6OTIxODIxMA==",
lat: 60.399888,
lon: 25.20157
},
{
id: "U3RvcDpIU0w6OTIxOTIwMw==",
lat: 60.398423,
lon: 25.211735
},
{
id: "U3RvcDpIU0w6OTIxOTIwNw==",
lat: 60.39325,
lon: 25.220033
},
{
id: "U3RvcDpIU0w6OTIxOTIxMQ==",
lat: 60.386438,
lon: 25.230305
},
{
id: "U3RvcDpIU0w6OTIxOTIxMg==",
lat: 60.38082,
lon: 25.23395
},
{
id: "U3RvcDpIU0w6OTIyMjIwMw==",
lat: 60.378025,
lon: 25.238145
},
{
id: "U3RvcDpIU0w6OTIyMjIxMA==",
lat: 60.374977,
lon: 25.249123
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjIyOQ==",
lat: 60.375727,
lon: 25.267724
},
{
id: "U3RvcDpIU0w6OTIyMjIyNg==",
lat: 60.371818,
lon: 25.262633
},
{
id: "U3RvcDpIU0w6OTIyMjIyMQ==",
lat: 60.37037,
lon: 25.258497
},
{
id: "U3RvcDpIU0w6OTIxNjIxMw==",
lat: 60.363567,
lon: 25.26105
},
{
id: "U3RvcDpIU0w6OTIxNjIxOA==",
lat: 60.35467,
lon: 25.265408
},
{
id: "U3RvcDpIU0w6OTIxNjIxNQ==",
lat: 60.350546,
lon: 25.2606
},
{
id: "U3RvcDpIU0w6OTIxNTIwNw==",
lat: 60.347407,
lon: 25.257307
},
{
id: "U3RvcDpIU0w6OTIxNTIwMw==",
lat: 60.340095,
lon: 25.246608
},
{
id: "U3RvcDpIU0w6OTIxNTIwMg==",
lat: 60.338485,
lon: 25.241048
},
{
id: "U3RvcDpIU0w6OTIxNTIwMQ==",
lat: 60.333942,
lon: 25.223853
},
{
id: "U3RvcDpIU0w6OTIxNTIwNA==",
lat: 60.339568,
lon: 25.245693
},
{
id: "U3RvcDpIU0w6OTIxNTIwNQ==",
lat: 60.340412,
lon: 25.248128
},
{
id: "U3RvcDpIU0w6OTIxNTIwOA==",
lat: 60.347518,
lon: 25.257662
},
{
id: "U3RvcDpIU0w6OTIxNjIxNg==",
lat: 60.350672,
lon: 25.261497
},
{
id: "U3RvcDpIU0w6OTIxNjIxOQ==",
lat: 60.356245,
lon: 25.266868
},
{
id: "U3RvcDpIU0w6OTIxNjIxNA==",
lat: 60.363368,
lon: 25.261563
},
{
id: "U3RvcDpIU0w6OTIyMjI0MA==",
lat: 60.369115,
lon: 25.258614
},
{
id: "U3RvcDpIU0w6OTIyMjIyMg==",
lat: 60.370252,
lon: 25.258915
},
{
id: "U3RvcDpIU0w6OTIyMjIyNQ==",
lat: 60.371527,
lon: 25.262477
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMQ==",
lat: 60.375065,
lon: 25.249352
},
{
id: "U3RvcDpIU0w6OTIyMjIwNA==",
lat: 60.378962,
lon: 25.237448
},
{
id: "U3RvcDpIU0w6OTIxOTIxNQ==",
lat: 60.381683,
lon: 25.23422
},
{
id: "U3RvcDpIU0w6OTIxOTIxMA==",
lat: 60.387075,
lon: 25.229622
},
{
id: "U3RvcDpIU0w6OTIxOTIwNg==",
lat: 60.393047,
lon: 25.220702
},
{
id: "U3RvcDpIU0w6OTIxOTIwMg==",
lat: 60.399023,
lon: 25.210833
},
{
id: "U3RvcDpIU0w6OTIxODIwOQ==",
lat: 60.400255,
lon: 25.200552
},
{
id: "U3RvcDpIU0w6OTIxNzIyMg==",
lat: 60.402442,
lon: 25.190088
},
{
id: "U3RvcDpIU0w6OTIxNzIyMA==",
lat: 60.406852,
lon: 25.175837
},
{
id: "U3RvcDpIU0w6OTIxNzIxMQ==",
lat: 60.40764,
lon: 25.169534
},
{
id: "U3RvcDpIU0w6OTIxNzIwNA==",
lat: 60.408213,
lon: 25.157368
},
{
id: "U3RvcDpIU0w6OTIxNzIwOQ==",
lat: 60.410837,
lon: 25.165923
},
{
id: "U3RvcDpIU0w6OTIxNzIxMw==",
lat: 60.41258,
lon: 25.171132
}
]
},
{
gtfsId: "HSL:9985",
shortName: "985",
longName: "Nikkilä-Talma-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyNDIxMA==",
lat: 60.391625,
lon: 25.276295
},
{
id: "U3RvcDpIU0w6OTIyNDIwNA==",
lat: 60.390328,
lon: 25.27607
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjIzMA==",
lat: 60.375777,
lon: 25.268002
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMQ==",
lat: 60.375065,
lon: 25.249352
},
{
id: "U3RvcDpIU0w6OTIyMjIwNA==",
lat: 60.378962,
lon: 25.237448
},
{
id: "U3RvcDpIU0w6OTIxOTIxNQ==",
lat: 60.381683,
lon: 25.23422
},
{
id: "U3RvcDpIU0w6OTIxOTIxMA==",
lat: 60.387075,
lon: 25.229622
},
{
id: "U3RvcDpIU0w6OTIxOTIwNg==",
lat: 60.393047,
lon: 25.220702
},
{
id: "U3RvcDpIU0w6OTIxOTIwMg==",
lat: 60.399023,
lon: 25.210833
},
{
id: "U3RvcDpIU0w6OTIxODIwOQ==",
lat: 60.400255,
lon: 25.200552
},
{
id: "U3RvcDpIU0w6OTIxNzIyMg==",
lat: 60.402442,
lon: 25.190088
},
{
id: "U3RvcDpIU0w6OTIxNzIyMA==",
lat: 60.406852,
lon: 25.175837
},
{
id: "U3RvcDpIU0w6OTIxNzIxOA==",
lat: 60.409925,
lon: 25.173275
},
{
id: "U3RvcDpIU0w6OTIxNzIxMg==",
lat: 60.412913,
lon: 25.170423
},
{
id: "U3RvcDpIU0w6OTIxNzIxMA==",
lat: 60.411197,
lon: 25.166242
},
{
id: "U3RvcDpIU0w6OTIxNzIwNQ==",
lat: 60.408772,
lon: 25.157585
},
{
id: "U3RvcDpIU0w6OTIxNzIwMw==",
lat: 60.407992,
lon: 25.156518
},
{
id: "U3RvcDpIU0w6OTIxNzIwMQ==",
lat: 60.4078,
lon: 25.152217
},
{
id: "U3RvcDpIU0w6OTA1MDIwMQ==",
lat: 60.406755,
lon: 25.145383
},
{
id: "U3RvcDpIU0w6OTA1MDIyNg==",
lat: 60.40598,
lon: 25.13959
},
{
id: "U3RvcDpIU0w6OTA1MDIyNw==",
lat: 60.40562,
lon: 25.13303
},
{
id: "U3RvcDpIU0w6OTA0MDIxOA==",
lat: 60.40565,
lon: 25.115
},
{
id: "U3RvcDpIU0w6OTA0MDIxNQ==",
lat: 60.40475,
lon: 25.11062
},
{
id: "U3RvcDpIU0w6OTA0MDIwOQ==",
lat: 60.40329,
lon: 25.10603
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
},
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMA==",
lat: 60.40314,
lon: 25.10726
},
{
id: "U3RvcDpIU0w6OTA0MDIxNw==",
lat: 60.405,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6OTA0MDIxOQ==",
lat: 60.4059,
lon: 25.11659
},
{
id: "U3RvcDpIU0w6OTA1MDIyOQ==",
lat: 60.40502,
lon: 25.13488
},
{
id: "U3RvcDpIU0w6OTA1MDIyNA==",
lat: 60.40645,
lon: 25.14283
},
{
id: "U3RvcDpIU0w6OTIxNzIwMg==",
lat: 60.407475,
lon: 25.152232
},
{
id: "U3RvcDpIU0w6OTIxNzIwNA==",
lat: 60.408213,
lon: 25.157368
},
{
id: "U3RvcDpIU0w6OTIxNzIwOQ==",
lat: 60.410837,
lon: 25.165923
},
{
id: "U3RvcDpIU0w6OTIxNzIxMw==",
lat: 60.41258,
lon: 25.171132
},
{
id: "U3RvcDpIU0w6OTIxNzIxOQ==",
lat: 60.410142,
lon: 25.17315
},
{
id: "U3RvcDpIU0w6OTIxNzIxNA==",
lat: 60.407043,
lon: 25.171219
},
{
id: "U3RvcDpIU0w6OTIxNzIyMQ==",
lat: 60.406233,
lon: 25.177323
},
{
id: "U3RvcDpIU0w6OTIxNzIyMw==",
lat: 60.401692,
lon: 25.192712
},
{
id: "U3RvcDpIU0w6OTIxODIxMA==",
lat: 60.399888,
lon: 25.20157
},
{
id: "U3RvcDpIU0w6OTIxOTIwMw==",
lat: 60.398423,
lon: 25.211735
},
{
id: "U3RvcDpIU0w6OTIxOTIwNw==",
lat: 60.39325,
lon: 25.220033
},
{
id: "U3RvcDpIU0w6OTIxOTIxMQ==",
lat: 60.386438,
lon: 25.230305
},
{
id: "U3RvcDpIU0w6OTIxOTIxMg==",
lat: 60.38082,
lon: 25.23395
},
{
id: "U3RvcDpIU0w6OTIyMjIwMw==",
lat: 60.378025,
lon: 25.238145
},
{
id: "U3RvcDpIU0w6OTIyMjIxMA==",
lat: 60.374977,
lon: 25.249123
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwNg==",
lat: 60.387638,
lon: 25.28011
}
]
},
{
gtfsId: "HSL:4717AK",
shortName: "717AK",
longName: "Sotunki-Hakunila-Jakomäki-Rautatientori",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk0MDIwMg==",
lat: 60.2793,
lon: 25.12528
},
{
id: "U3RvcDpIU0w6NDk4MDIxNA==",
lat: 60.27794,
lon: 25.13378
},
{
id: "U3RvcDpIU0w6NDk4MDIxMg==",
lat: 60.28507,
lon: 25.13526
},
{
id: "U3RvcDpIU0w6NDk4MDIxMA==",
lat: 60.2892,
lon: 25.13926
},
{
id: "U3RvcDpIU0w6NDk4MDIxOA==",
lat: 60.29201,
lon: 25.13969
},
{
id: "U3RvcDpIU0w6NDk4MDIwOA==",
lat: 60.29297,
lon: 25.13781
},
{
id: "U3RvcDpIU0w6NDk4MDIwNg==",
lat: 60.29396,
lon: 25.13554
},
{
id: "U3RvcDpIU0w6NDk4MDIwNA==",
lat: 60.29711,
lon: 25.12958
},
{
id: "U3RvcDpIU0w6NDk4MDIwMg==",
lat: 60.29776,
lon: 25.12568
},
{
id: "U3RvcDpIU0w6NDk2MDIxMw==",
lat: 60.29795,
lon: 25.12205
},
{
id: "U3RvcDpIU0w6NDk2MDI0MQ==",
lat: 60.29773,
lon: 25.11143
},
{
id: "U3RvcDpIU0w6NDk2MDI5NA==",
lat: 60.29714,
lon: 25.10963
},
{
id: "U3RvcDpIU0w6NDk2MDIzOA==",
lat: 60.29628,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk2MDIxOQ==",
lat: 60.29418,
lon: 25.10836
},
{
id: "U3RvcDpIU0w6NDk2MDIyMg==",
lat: 60.2927,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxOA==",
lat: 60.25851,
lon: 25.10222
},
{
id: "U3RvcDpIU0w6NDkzMDIyMA==",
lat: 60.25746,
lon: 25.10541
},
{
id: "U3RvcDpIU0w6NDkzMDIyMQ==",
lat: 60.2583,
lon: 25.103354
},
{
id: "U3RvcDpIU0w6NDkzMDIxOQ==",
lat: 60.25927,
lon: 25.10128
},
{
id: "U3RvcDpIU0w6NDkzMDIyOQ==",
lat: 60.26043,
lon: 25.09767
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4713B",
shortName: "713B",
longName: "Hakunilan palvelulinja",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk3MDI4OA==",
lat: 60.305612,
lon: 25.116163
},
{
id: "U3RvcDpIU0w6NDk3MDI5NA==",
lat: 60.302686,
lon: 25.116353
},
{
id: "U3RvcDpIU0w6NDk3MDI0Mg==",
lat: 60.300034,
lon: 25.118128
},
{
id: "U3RvcDpIU0w6NDk3MDI0Mw==",
lat: 60.299145,
lon: 25.119169
},
{
id: "U3RvcDpIU0w6NDk2MDIxMw==",
lat: 60.29795,
lon: 25.12205
},
{
id: "U3RvcDpIU0w6NDk2MDI0MQ==",
lat: 60.29773,
lon: 25.11143
},
{
id: "U3RvcDpIU0w6NDk2MDI5NA==",
lat: 60.29714,
lon: 25.10963
},
{
id: "U3RvcDpIU0w6NDk2MDIzOA==",
lat: 60.29628,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk2MDIwMg==",
lat: 60.29575,
lon: 25.10275
},
{
id: "U3RvcDpIU0w6NDk2MDIwOQ==",
lat: 60.293237,
lon: 25.105682
},
{
id: "U3RvcDpIU0w6NDk2MDIxMA==",
lat: 60.291354,
lon: 25.106714
},
{
id: "U3RvcDpIU0w6NDk2MDIwNA==",
lat: 60.288998,
lon: 25.111356
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDI0Mg==",
lat: 60.283594,
lon: 25.118571
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDIwMA==",
lat: 60.280406,
lon: 25.119604
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIzMA==",
lat: 60.27698,
lon: 25.10402
}
]
},
{
gtfsId: "HSL:9665N",
shortName: "665N",
longName: "Rautatientori-Hyrylä-Järvenpää-Jamppa-Kellokoski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTYyMDEzMA==",
lat: 60.546026,
lon: 25.118111
},
{
id: "U3RvcDpIU0w6OTYyMDEyOA==",
lat: 60.542592,
lon: 25.117474
},
{
id: "U3RvcDpIU0w6OTYyMDEyNg==",
lat: 60.540297,
lon: 25.114163
},
{
id: "U3RvcDpIU0w6OTYyMDExNQ==",
lat: 60.536589,
lon: 25.112111
},
{
id: "U3RvcDpIU0w6OTYyMDEwOQ==",
lat: 60.531432,
lon: 25.109525
},
{
id: "U3RvcDpIU0w6OTYyMDExMQ==",
lat: 60.527961,
lon: 25.104432
},
{
id: "U3RvcDpIU0w6OTYyMDEyMQ==",
lat: 60.5271,
lon: 25.102984
},
{
id: "U3RvcDpIU0w6OTYyMDEyMg==",
lat: 60.524806,
lon: 25.100191
},
{
id: "U3RvcDpIU0w6OTYyMDEyMA==",
lat: 60.520712,
lon: 25.097855
},
{
id: "U3RvcDpIU0w6OTYyMDEwMQ==",
lat: 60.516602,
lon: 25.100577
},
{
id: "U3RvcDpIU0w6OTUxMTAwMQ==",
lat: 60.50772,
lon: 25.096213
},
{
id: "U3RvcDpIU0w6OTUxMTAwMw==",
lat: 60.509916,
lon: 25.091717
},
{
id: "U3RvcDpIU0w6OTUxMTAxMg==",
lat: 60.510486,
lon: 25.0864
},
{
id: "U3RvcDpIU0w6OTUxMTAxMA==",
lat: 60.506932,
lon: 25.077499
},
{
id: "U3RvcDpIU0w6OTUxMTAwOA==",
lat: 60.504068,
lon: 25.076276
},
{
id: "U3RvcDpIU0w6OTUxMTAwNg==",
lat: 60.500433,
lon: 25.075997
},
{
id: "U3RvcDpIU0w6OTUwOTAwMA==",
lat: 60.498832,
lon: 25.065813
},
{
id: "U3RvcDpIU0w6OTUwOTAwMg==",
lat: 60.495794,
lon: 25.065977
},
{
id: "U3RvcDpIU0w6OTUwOTAwNA==",
lat: 60.492595,
lon: 25.066152
},
{
id: "U3RvcDpIU0w6OTUwODAwMA==",
lat: 60.489642,
lon: 25.066466
},
{
id: "U3RvcDpIU0w6OTUwODAwMg==",
lat: 60.487255,
lon: 25.068324
},
{
id: "U3RvcDpIU0w6OTUwODAwNA==",
lat: 60.484272,
lon: 25.074902
},
{
id: "U3RvcDpIU0w6OTUwNzAwMg==",
lat: 60.482417,
lon: 25.077775
},
{
id: "U3RvcDpIU0w6OTUwNzAwNA==",
lat: 60.480454,
lon: 25.081172
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIwMA==",
lat: 60.47372,
lon: 25.090098
},
{
id: "U3RvcDpIU0w6OTUwMTAwOA==",
lat: 60.470457,
lon: 25.088669
},
{
id: "U3RvcDpIU0w6OTUwMTAwOQ==",
lat: 60.46858,
lon: 25.086553
},
{
id: "U3RvcDpIU0w6OTUwMTAxMA==",
lat: 60.464957,
lon: 25.086094
},
{
id: "U3RvcDpIU0w6OTUyMjAwMw==",
lat: 60.4594,
lon: 25.085262
},
{
id: "U3RvcDpIU0w6OTUyMjAwNA==",
lat: 60.456397,
lon: 25.083441
},
{
id: "U3RvcDpIU0w6OTUyMzAwMA==",
lat: 60.453127,
lon: 25.081499
},
{
id: "U3RvcDpIU0w6OTUwNjAwMg==",
lat: 60.445708,
lon: 25.077829
},
{
id: "U3RvcDpIU0w6OTY1MDYwNQ==",
lat: 60.443133,
lon: 25.07554
},
{
id: "U3RvcDpIU0w6OTY1MDYxOA==",
lat: 60.437911,
lon: 25.068885
},
{
id: "U3RvcDpIU0w6OTY1MDYyMA==",
lat: 60.434359,
lon: 25.06276
},
{
id: "U3RvcDpIU0w6OTY1MDYwMw==",
lat: 60.430897,
lon: 25.05647
},
{
id: "U3RvcDpIU0w6OTY1MDYwMA==",
lat: 60.426754,
lon: 25.053925
},
{
id: "U3RvcDpIU0w6OTY1MDYxMA==",
lat: 60.42385,
lon: 25.053545
},
{
id: "U3RvcDpIU0w6OTY1MDUwNQ==",
lat: 60.417916,
lon: 25.05271
},
{
id: "U3RvcDpIU0w6OTY1MDQwNg==",
lat: 60.414022,
lon: 25.049991
},
{
id: "U3RvcDpIU0w6OTY1MDMyNQ==",
lat: 60.410933,
lon: 25.045152
},
{
id: "U3RvcDpIU0w6OTY1MDMyNw==",
lat: 60.409244,
lon: 25.042448
},
{
id: "U3RvcDpIU0w6OTY1MDMyMg==",
lat: 60.406367,
lon: 25.041696
},
{
id: "U3RvcDpIU0w6OTY1MDMxOQ==",
lat: 60.404485,
lon: 25.041464
},
{
id: "U3RvcDpIU0w6OTY1MDEwMg==",
lat: 60.40142,
lon: 25.030759
},
{
id: "U3RvcDpIU0w6OTY1MDEyMQ==",
lat: 60.401747,
lon: 25.028205
},
{
id: "U3RvcDpIU0w6OTY1MDExMQ==",
lat: 60.400819,
lon: 25.026307
},
{
id: "U3RvcDpIU0w6OTY1MDEwNQ==",
lat: 60.398721,
lon: 25.02284
},
{
id: "U3RvcDpIU0w6OTY1MTUwNA==",
lat: 60.394205,
lon: 25.021614
},
{
id: "U3RvcDpIU0w6OTY1MTUwMQ==",
lat: 60.390458,
lon: 25.023577
},
{
id: "U3RvcDpIU0w6OTY1MTcwMQ==",
lat: 60.386727,
lon: 25.025077
},
{
id: "U3RvcDpIU0w6OTY1MTYxMw==",
lat: 60.382931,
lon: 25.025434
},
{
id: "U3RvcDpIU0w6OTY1MTYwMQ==",
lat: 60.378409,
lon: 25.022339
},
{
id: "U3RvcDpIU0w6OTY1MTMxMg==",
lat: 60.374001,
lon: 25.018583
},
{
id: "U3RvcDpIU0w6OTY3MDUwMg==",
lat: 60.368227,
lon: 25.010802
},
{
id: "U3RvcDpIU0w6OTY3MDUwMA==",
lat: 60.358509,
lon: 25.000551
},
{
id: "U3RvcDpIU0w6OTY3MDUxMQ==",
lat: 60.341781,
lon: 25.004458
},
{
id: "U3RvcDpIU0w6OTY3MDUzMw==",
lat: 60.343093,
lon: 25.021248
},
{
id: "U3RvcDpIU0w6OTY3MDUzMQ==",
lat: 60.339383,
lon: 25.022798
},
{
id: "U3RvcDpIU0w6NDcxMDI0Mw==",
lat: 60.336051,
lon: 25.026532
},
{
id: "U3RvcDpIU0w6NDcxMDIzOQ==",
lat: 60.33326,
lon: 25.02735
},
{
id: "U3RvcDpIU0w6NDcxMDIxNw==",
lat: 60.32983,
lon: 25.02648
},
{
id: "U3RvcDpIU0w6NDcxMDIwOQ==",
lat: 60.32633,
lon: 25.02468
},
{
id: "U3RvcDpIU0w6NDcxMDIzMQ==",
lat: 60.32451,
lon: 25.02443
},
{
id: "U3RvcDpIU0w6NDcxMDIwNw==",
lat: 60.32345,
lon: 25.01674
},
{
id: "U3RvcDpIU0w6NDY3MDIxMw==",
lat: 60.32259,
lon: 25.0127
},
{
id: "U3RvcDpIU0w6NDY3MDIxMQ==",
lat: 60.31772,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDY3MDIwNw==",
lat: 60.31545,
lon: 25.01216
},
{
id: "U3RvcDpIU0w6NDY3MDIwNA==",
lat: 60.31644,
lon: 25.00259
},
{
id: "U3RvcDpIU0w6NDY3MDIyMQ==",
lat: 60.31554,
lon: 24.99887
},
{
id: "U3RvcDpIU0w6NDY3MDIxNQ==",
lat: 60.31214,
lon: 24.99851
},
{
id: "U3RvcDpIU0w6NDY4MDIzMw==",
lat: 60.30751,
lon: 24.99824
},
{
id: "U3RvcDpIU0w6NDY4MDIxOA==",
lat: 60.3012,
lon: 24.98972
},
{
id: "U3RvcDpIU0w6NDY4MDI1MA==",
lat: 60.29421,
lon: 24.98286
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mg==",
lat: 60.28722,
lon: 24.97696
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDIwNA==",
lat: 60.17165,
lon: 24.94327
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDY4MDI1MQ==",
lat: 60.28629,
lon: 24.98319
},
{
id: "U3RvcDpIU0w6NDY4MDI0OQ==",
lat: 60.29431,
lon: 24.98431
},
{
id: "U3RvcDpIU0w6NDY4MDIxNw==",
lat: 60.29991,
lon: 24.98982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMg==",
lat: 60.307715,
lon: 24.999454
},
{
id: "U3RvcDpIU0w6NDY3MDIxNg==",
lat: 60.31302,
lon: 24.99868
},
{
id: "U3RvcDpIU0w6NDY3MDIwNQ==",
lat: 60.31623,
lon: 25.0045
},
{
id: "U3RvcDpIU0w6NDY3MDIxMA==",
lat: 60.3158,
lon: 25.01389
},
{
id: "U3RvcDpIU0w6NDY3MDIxMg==",
lat: 60.3198,
lon: 25.01384
},
{
id: "U3RvcDpIU0w6NDY3MDIxNA==",
lat: 60.32302,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDcxMDIwNg==",
lat: 60.32362,
lon: 25.01831
},
{
id: "U3RvcDpIU0w6NDcxMDIwOA==",
lat: 60.32624,
lon: 25.02493
},
{
id: "U3RvcDpIU0w6NDcxMDIxOA==",
lat: 60.32946,
lon: 25.02685
},
{
id: "U3RvcDpIU0w6NDcxMDI0NA==",
lat: 60.334368,
lon: 25.027149
},
{
id: "U3RvcDpIU0w6NDcxMDI0Mg==",
lat: 60.336744,
lon: 25.026228
},
{
id: "U3RvcDpIU0w6OTY3MDUzMg==",
lat: 60.339372,
lon: 25.023015
},
{
id: "U3RvcDpIU0w6OTY3MDUwOA==",
lat: 60.343363,
lon: 25.020459
},
{
id: "U3RvcDpIU0w6OTY3MDUxMg==",
lat: 60.342071,
lon: 25.005156
},
{
id: "U3RvcDpIU0w6OTY3MDUyMw==",
lat: 60.342142,
lon: 25.002158
},
{
id: "U3RvcDpIU0w6OTY3MDUwMQ==",
lat: 60.358831,
lon: 25.001472
},
{
id: "U3RvcDpIU0w6OTY3MDUwMw==",
lat: 60.368584,
lon: 25.011852
},
{
id: "U3RvcDpIU0w6OTY1MTMxMw==",
lat: 60.375518,
lon: 25.019879
},
{
id: "U3RvcDpIU0w6OTY1MTYwMg==",
lat: 60.379778,
lon: 25.023895
},
{
id: "U3RvcDpIU0w6OTY1MTYxMg==",
lat: 60.382748,
lon: 25.025649
},
{
id: "U3RvcDpIU0w6OTY1MTcwMg==",
lat: 60.385848,
lon: 25.025451
},
{
id: "U3RvcDpIU0w6OTY1MTUwMg==",
lat: 60.391748,
lon: 25.023073
},
{
id: "U3RvcDpIU0w6OTY1MTUwMw==",
lat: 60.394225,
lon: 25.021879
},
{
id: "U3RvcDpIU0w6OTY1MDEwNA==",
lat: 60.397977,
lon: 25.022502
},
{
id: "U3RvcDpIU0w6OTY1MDExMA==",
lat: 60.400624,
lon: 25.026438
},
{
id: "U3RvcDpIU0w6OTY1MDEyMw==",
lat: 60.401866,
lon: 25.028215
},
{
id: "U3RvcDpIU0w6OTY1MDEwMw==",
lat: 60.401391,
lon: 25.03098
},
{
id: "U3RvcDpIU0w6OTY1MDMyNA==",
lat: 60.402958,
lon: 25.039074
},
{
id: "U3RvcDpIU0w6OTY1MDMxOA==",
lat: 60.404662,
lon: 25.041673
},
{
id: "U3RvcDpIU0w6OTY1MDMyMQ==",
lat: 60.407436,
lon: 25.041864
},
{
id: "U3RvcDpIU0w6OTY1MDMyNg==",
lat: 60.409443,
lon: 25.042818
},
{
id: "U3RvcDpIU0w6OTY1MDMwMQ==",
lat: 60.411513,
lon: 25.045253
},
{
id: "U3RvcDpIU0w6OTY1MDQxNA==",
lat: 60.412355,
lon: 25.047274
},
{
id: "U3RvcDpIU0w6OTY1MDQwNw==",
lat: 60.415198,
lon: 25.051276
},
{
id: "U3RvcDpIU0w6OTY1MDUwNg==",
lat: 60.420609,
lon: 25.05311
},
{
id: "U3RvcDpIU0w6OTY1MDYxMQ==",
lat: 60.425178,
lon: 25.05372
},
{
id: "U3RvcDpIU0w6OTY1MDYwMQ==",
lat: 60.428092,
lon: 25.05419
},
{
id: "U3RvcDpIU0w6OTY1MDYwNA==",
lat: 60.431718,
lon: 25.057703
},
{
id: "U3RvcDpIU0w6OTY1MDYyMQ==",
lat: 60.434687,
lon: 25.063428
},
{
id: "U3RvcDpIU0w6OTY1MDYxOQ==",
lat: 60.438392,
lon: 25.06956
},
{
id: "U3RvcDpIU0w6OTY1MDYwNg==",
lat: 60.44401,
lon: 25.076555
},
{
id: "U3RvcDpIU0w6OTUyMzAwMQ==",
lat: 60.447028,
lon: 25.07805
},
{
id: "U3RvcDpIU0w6OTUyMjAwMA==",
lat: 60.45396,
lon: 25.082381
},
{
id: "U3RvcDpIU0w6OTUyMjAwNQ==",
lat: 60.456167,
lon: 25.083647
},
{
id: "U3RvcDpIU0w6OTUyMjAwNg==",
lat: 60.460369,
lon: 25.085854
},
{
id: "U3RvcDpIU0w6OTUwMTAxMQ==",
lat: 60.465908,
lon: 25.085926
},
{
id: "U3RvcDpIU0w6OTUwMTAxMg==",
lat: 60.467521,
lon: 25.08613
},
{
id: "U3RvcDpIU0w6OTUwMTAxMw==",
lat: 60.470591,
lon: 25.088868
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwNQ==",
lat: 60.480631,
lon: 25.080989
},
{
id: "U3RvcDpIU0w6OTUwNzAwMw==",
lat: 60.483054,
lon: 25.076795
},
{
id: "U3RvcDpIU0w6OTUwODAwNQ==",
lat: 60.484745,
lon: 25.073685
},
{
id: "U3RvcDpIU0w6OTUwODAwMw==",
lat: 60.488282,
lon: 25.067272
},
{
id: "U3RvcDpIU0w6OTUwODAwMQ==",
lat: 60.490454,
lon: 25.066463
},
{
id: "U3RvcDpIU0w6OTUwOTAwNQ==",
lat: 60.493991,
lon: 25.066238
},
{
id: "U3RvcDpIU0w6OTUwOTAwMw==",
lat: 60.496606,
lon: 25.066005
},
{
id: "U3RvcDpIU0w6OTUwOTAwMQ==",
lat: 60.49892,
lon: 25.065999
},
{
id: "U3RvcDpIU0w6OTUxMTAwNQ==",
lat: 60.500855,
lon: 25.076028
},
{
id: "U3RvcDpIU0w6OTUxMTAwNw==",
lat: 60.504289,
lon: 25.07639
},
{
id: "U3RvcDpIU0w6OTUxMTAwOQ==",
lat: 60.507099,
lon: 25.077688
},
{
id: "U3RvcDpIU0w6OTUxMTAxMQ==",
lat: 60.509911,
lon: 25.084424
},
{
id: "U3RvcDpIU0w6OTUxMTAwNA==",
lat: 60.511391,
lon: 25.088732
},
{
id: "U3RvcDpIU0w6OTUxMTAwMg==",
lat: 60.508469,
lon: 25.094484
},
{
id: "U3RvcDpIU0w6OTYyMDEwMA==",
lat: 60.517041,
lon: 25.100046
},
{
id: "U3RvcDpIU0w6OTYyMDExOQ==",
lat: 60.521574,
lon: 25.097913
},
{
id: "U3RvcDpIU0w6OTYyMDEyMw==",
lat: 60.524016,
lon: 25.099343
},
{
id: "U3RvcDpIU0w6OTYyMDExMA==",
lat: 60.527828,
lon: 25.104227
},
{
id: "U3RvcDpIU0w6OTYyMDEwOA==",
lat: 60.532741,
lon: 25.110697
},
{
id: "U3RvcDpIU0w6OTYyMDExNA==",
lat: 60.535827,
lon: 25.11185
},
{
id: "U3RvcDpIU0w6OTYyMDEyNQ==",
lat: 60.538881,
lon: 25.113485
},
{
id: "U3RvcDpIU0w6OTYyMDEyNw==",
lat: 60.541235,
lon: 25.114887
},
{
id: "U3RvcDpIU0w6OTYyMDEyOQ==",
lat: 60.546809,
lon: 25.119181
}
]
},
{
gtfsId: "HSL:2436N",
shortName: "436N",
longName: "Elielinaukio-Myyrmäki-Pähkinärinne-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOQ==",
lat: 60.27787,
lon: 24.74963
},
{
id: "U3RvcDpIU0w6MjcxNTIxNQ==",
lat: 60.27398,
lon: 24.74953
},
{
id: "U3RvcDpIU0w6MjcxNTI0Nw==",
lat: 60.27007,
lon: 24.75398
},
{
id: "U3RvcDpIU0w6MjcxNTI5NA==",
lat: 60.26969,
lon: 24.75626
},
{
id: "U3RvcDpIU0w6MjcxNTIzMA==",
lat: 60.26954,
lon: 24.75945
},
{
id: "U3RvcDpIU0w6NDEyMDIxNw==",
lat: 60.27395,
lon: 24.78154
},
{
id: "U3RvcDpIU0w6NDEyMDIxNQ==",
lat: 60.27313,
lon: 24.7939
},
{
id: "U3RvcDpIU0w6NDE0MDIwNg==",
lat: 60.27008,
lon: 24.80541
},
{
id: "U3RvcDpIU0w6NDE0MDIwNA==",
lat: 60.26651,
lon: 24.80758
},
{
id: "U3RvcDpIU0w6NDEyMDIxMA==",
lat: 60.26149,
lon: 24.80645
},
{
id: "U3RvcDpIU0w6NDEyMDIwOA==",
lat: 60.25673,
lon: 24.80958
},
{
id: "U3RvcDpIU0w6NDEyMDIwNA==",
lat: 60.25419,
lon: 24.81581
},
{
id: "U3RvcDpIU0w6NDEyMDIwMg==",
lat: 60.2538,
lon: 24.82244
},
{
id: "U3RvcDpIU0w6NDEzMDIwNw==",
lat: 60.25561,
lon: 24.82723
},
{
id: "U3RvcDpIU0w6NDEzMDIwOQ==",
lat: 60.259,
lon: 24.83637
},
{
id: "U3RvcDpIU0w6NDE1MDIwMQ==",
lat: 60.258993,
lon: 24.84688
},
{
id: "U3RvcDpIU0w6NDE1MDI5Nw==",
lat: 60.25909,
lon: 24.85276
},
{
id: "U3RvcDpIU0w6NDE1MDI2Mw==",
lat: 60.26109,
lon: 24.856
},
{
id: "U3RvcDpIU0w6NDE1MDIyMA==",
lat: 60.26371,
lon: 24.85947
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
},
{
id: "U3RvcDpIU0w6MTAyMDIzOQ==",
lat: 60.171981,
lon: 24.93971
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE1MDIxOQ==",
lat: 60.26394,
lon: 24.85928
},
{
id: "U3RvcDpIU0w6NDE1MDI2MA==",
lat: 60.26146,
lon: 24.85547
},
{
id: "U3RvcDpIU0w6NDE1MDI5OA==",
lat: 60.25926,
lon: 24.85224
},
{
id: "U3RvcDpIU0w6NDE1MDI5Ng==",
lat: 60.25919,
lon: 24.84605
},
{
id: "U3RvcDpIU0w6NDE1MDIwMg==",
lat: 60.25945,
lon: 24.84224
},
{
id: "U3RvcDpIU0w6NDEzMDIxMA==",
lat: 60.25875,
lon: 24.83456
},
{
id: "U3RvcDpIU0w6NDEzMDIwOA==",
lat: 60.25622,
lon: 24.82877
},
{
id: "U3RvcDpIU0w6NDEyMDIwMQ==",
lat: 60.25397,
lon: 24.81982
},
{
id: "U3RvcDpIU0w6NDEyMDIwMw==",
lat: 60.25461,
lon: 24.81418
},
{
id: "U3RvcDpIU0w6NDEyMDIwNw==",
lat: 60.25811,
lon: 24.80891
},
{
id: "U3RvcDpIU0w6NDEyMDIzOA==",
lat: 60.26287,
lon: 24.80655
},
{
id: "U3RvcDpIU0w6NDE0MDIwMw==",
lat: 60.26779,
lon: 24.807
},
{
id: "U3RvcDpIU0w6NDE0MDIwNQ==",
lat: 60.27025,
lon: 24.80581
},
{
id: "U3RvcDpIU0w6NDEyMDIxNA==",
lat: 60.27342,
lon: 24.7938
},
{
id: "U3RvcDpIU0w6NDEyMDIxNg==",
lat: 60.27395,
lon: 24.77924
},
{
id: "U3RvcDpIU0w6MjcxNTI5NQ==",
lat: 60.269782,
lon: 24.755897
},
{
id: "U3RvcDpIU0w6MjcxNTIxMw==",
lat: 60.27087,
lon: 24.75311
},
{
id: "U3RvcDpIU0w6MjcxNTIxNA==",
lat: 60.27323,
lon: 24.75052
},
{
id: "U3RvcDpIU0w6MjcxNTIwMg==",
lat: 60.275124,
lon: 24.749747
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
}
]
},
{
gtfsId: "HSL:9665K",
shortName: "665K",
longName: "Hyrylä-Järvenpää-Jamppa-Kellokoski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDEyMw==",
lat: 60.401866,
lon: 25.028215
},
{
id: "U3RvcDpIU0w6OTY1MDEwMw==",
lat: 60.401391,
lon: 25.03098
},
{
id: "U3RvcDpIU0w6OTY1MDMyNA==",
lat: 60.402958,
lon: 25.039074
},
{
id: "U3RvcDpIU0w6OTY1MDMxOA==",
lat: 60.404662,
lon: 25.041673
},
{
id: "U3RvcDpIU0w6OTY1MDMyMQ==",
lat: 60.407436,
lon: 25.041864
},
{
id: "U3RvcDpIU0w6OTY1MDMyNg==",
lat: 60.409443,
lon: 25.042818
},
{
id: "U3RvcDpIU0w6OTY1MDMwMQ==",
lat: 60.411513,
lon: 25.045253
},
{
id: "U3RvcDpIU0w6OTY1MDQxNA==",
lat: 60.412355,
lon: 25.047274
},
{
id: "U3RvcDpIU0w6OTY1MDQwNw==",
lat: 60.415198,
lon: 25.051276
},
{
id: "U3RvcDpIU0w6OTY1MDUwNg==",
lat: 60.420609,
lon: 25.05311
},
{
id: "U3RvcDpIU0w6OTY1MDYxMQ==",
lat: 60.425178,
lon: 25.05372
},
{
id: "U3RvcDpIU0w6OTY1MDYwMQ==",
lat: 60.428092,
lon: 25.05419
},
{
id: "U3RvcDpIU0w6OTY1MDYwNA==",
lat: 60.431718,
lon: 25.057703
},
{
id: "U3RvcDpIU0w6OTY1MDYyMQ==",
lat: 60.434687,
lon: 25.063428
},
{
id: "U3RvcDpIU0w6OTY1MDYxOQ==",
lat: 60.438392,
lon: 25.06956
},
{
id: "U3RvcDpIU0w6OTY1MDYwNg==",
lat: 60.44401,
lon: 25.076555
},
{
id: "U3RvcDpIU0w6OTUyMzAwMQ==",
lat: 60.447028,
lon: 25.07805
},
{
id: "U3RvcDpIU0w6OTUyMjAwMA==",
lat: 60.45396,
lon: 25.082381
},
{
id: "U3RvcDpIU0w6OTUyMjAwNQ==",
lat: 60.456167,
lon: 25.083647
},
{
id: "U3RvcDpIU0w6OTUyMjAwNg==",
lat: 60.460369,
lon: 25.085854
},
{
id: "U3RvcDpIU0w6OTUwMTAxMQ==",
lat: 60.465908,
lon: 25.085926
},
{
id: "U3RvcDpIU0w6OTUwMTAxMg==",
lat: 60.467521,
lon: 25.08613
},
{
id: "U3RvcDpIU0w6OTUwMTAxMw==",
lat: 60.470591,
lon: 25.088868
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwNQ==",
lat: 60.480631,
lon: 25.080989
},
{
id: "U3RvcDpIU0w6OTUwNzAwMw==",
lat: 60.483054,
lon: 25.076795
},
{
id: "U3RvcDpIU0w6OTUwODAwNQ==",
lat: 60.484745,
lon: 25.073685
},
{
id: "U3RvcDpIU0w6OTUwODAwMw==",
lat: 60.488282,
lon: 25.067272
},
{
id: "U3RvcDpIU0w6OTUwODAwMQ==",
lat: 60.490454,
lon: 25.066463
},
{
id: "U3RvcDpIU0w6OTUwOTAwNQ==",
lat: 60.493991,
lon: 25.066238
},
{
id: "U3RvcDpIU0w6OTUwOTAwMw==",
lat: 60.496606,
lon: 25.066005
},
{
id: "U3RvcDpIU0w6OTUwOTAwMQ==",
lat: 60.49892,
lon: 25.065999
},
{
id: "U3RvcDpIU0w6OTUxMTAwNQ==",
lat: 60.500855,
lon: 25.076028
},
{
id: "U3RvcDpIU0w6OTUxMTAwNw==",
lat: 60.504289,
lon: 25.07639
},
{
id: "U3RvcDpIU0w6OTUxMTAwOQ==",
lat: 60.507099,
lon: 25.077688
},
{
id: "U3RvcDpIU0w6OTUxMTAxMQ==",
lat: 60.509911,
lon: 25.084424
},
{
id: "U3RvcDpIU0w6OTUxMTAwNA==",
lat: 60.511391,
lon: 25.088732
},
{
id: "U3RvcDpIU0w6OTUxMTAwMg==",
lat: 60.508469,
lon: 25.094484
},
{
id: "U3RvcDpIU0w6OTYyMDEwMA==",
lat: 60.517041,
lon: 25.100046
},
{
id: "U3RvcDpIU0w6OTYyMDExOQ==",
lat: 60.521574,
lon: 25.097913
},
{
id: "U3RvcDpIU0w6OTYyMDEyMw==",
lat: 60.524016,
lon: 25.099343
},
{
id: "U3RvcDpIU0w6OTYyMDExMA==",
lat: 60.527828,
lon: 25.104227
},
{
id: "U3RvcDpIU0w6OTYyMDEwOA==",
lat: 60.532741,
lon: 25.110697
},
{
id: "U3RvcDpIU0w6OTYyMDExNA==",
lat: 60.535827,
lon: 25.11185
},
{
id: "U3RvcDpIU0w6OTYyMDEyNQ==",
lat: 60.538881,
lon: 25.113485
},
{
id: "U3RvcDpIU0w6OTYyMDEyNw==",
lat: 60.541235,
lon: 25.114887
},
{
id: "U3RvcDpIU0w6OTYyMDEyOQ==",
lat: 60.546809,
lon: 25.119181
},
{
id: "U3RvcDpIU0w6OTYyMDEzMA==",
lat: 60.546026,
lon: 25.118111
},
{
id: "U3RvcDpIU0w6OTYyMDEyOA==",
lat: 60.542592,
lon: 25.117474
},
{
id: "U3RvcDpIU0w6OTYyMDEyNg==",
lat: 60.540297,
lon: 25.114163
},
{
id: "U3RvcDpIU0w6OTYyMDExNQ==",
lat: 60.536589,
lon: 25.112111
},
{
id: "U3RvcDpIU0w6OTYyMDEwOQ==",
lat: 60.531432,
lon: 25.109525
},
{
id: "U3RvcDpIU0w6OTYyMDExMQ==",
lat: 60.527961,
lon: 25.104432
},
{
id: "U3RvcDpIU0w6OTYyMDEyMQ==",
lat: 60.5271,
lon: 25.102984
},
{
id: "U3RvcDpIU0w6OTYyMDEyMg==",
lat: 60.524806,
lon: 25.100191
},
{
id: "U3RvcDpIU0w6OTYyMDEyMA==",
lat: 60.520712,
lon: 25.097855
},
{
id: "U3RvcDpIU0w6OTYyMDEwMQ==",
lat: 60.516602,
lon: 25.100577
},
{
id: "U3RvcDpIU0w6OTUxMTAwMQ==",
lat: 60.50772,
lon: 25.096213
},
{
id: "U3RvcDpIU0w6OTUxMTAwMw==",
lat: 60.509916,
lon: 25.091717
},
{
id: "U3RvcDpIU0w6OTUxMTAxMg==",
lat: 60.510486,
lon: 25.0864
},
{
id: "U3RvcDpIU0w6OTUxMTAxMA==",
lat: 60.506932,
lon: 25.077499
},
{
id: "U3RvcDpIU0w6OTUxMTAwOA==",
lat: 60.504068,
lon: 25.076276
},
{
id: "U3RvcDpIU0w6OTUxMTAwNg==",
lat: 60.500433,
lon: 25.075997
},
{
id: "U3RvcDpIU0w6OTUwOTAwMA==",
lat: 60.498832,
lon: 25.065813
},
{
id: "U3RvcDpIU0w6OTUwOTAwMg==",
lat: 60.495794,
lon: 25.065977
},
{
id: "U3RvcDpIU0w6OTUwOTAwNA==",
lat: 60.492595,
lon: 25.066152
},
{
id: "U3RvcDpIU0w6OTUwODAwMA==",
lat: 60.489642,
lon: 25.066466
},
{
id: "U3RvcDpIU0w6OTUwODAwMg==",
lat: 60.487255,
lon: 25.068324
},
{
id: "U3RvcDpIU0w6OTUwODAwNA==",
lat: 60.484272,
lon: 25.074902
},
{
id: "U3RvcDpIU0w6OTUwNzAwMg==",
lat: 60.482417,
lon: 25.077775
},
{
id: "U3RvcDpIU0w6OTUwNzAwNA==",
lat: 60.480454,
lon: 25.081172
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIwMA==",
lat: 60.47372,
lon: 25.090098
},
{
id: "U3RvcDpIU0w6OTUwMTAwOA==",
lat: 60.470457,
lon: 25.088669
},
{
id: "U3RvcDpIU0w6OTUwMTAwOQ==",
lat: 60.46858,
lon: 25.086553
},
{
id: "U3RvcDpIU0w6OTUwMTAxMA==",
lat: 60.464957,
lon: 25.086094
},
{
id: "U3RvcDpIU0w6OTUyMjAwMw==",
lat: 60.4594,
lon: 25.085262
},
{
id: "U3RvcDpIU0w6OTUyMjAwNA==",
lat: 60.456397,
lon: 25.083441
},
{
id: "U3RvcDpIU0w6OTUyMzAwMA==",
lat: 60.453127,
lon: 25.081499
},
{
id: "U3RvcDpIU0w6OTUwNjAwMg==",
lat: 60.445708,
lon: 25.077829
},
{
id: "U3RvcDpIU0w6OTY1MDYwNQ==",
lat: 60.443133,
lon: 25.07554
},
{
id: "U3RvcDpIU0w6OTY1MDYxOA==",
lat: 60.437911,
lon: 25.068885
},
{
id: "U3RvcDpIU0w6OTY1MDYyMA==",
lat: 60.434359,
lon: 25.06276
},
{
id: "U3RvcDpIU0w6OTY1MDYwMw==",
lat: 60.430897,
lon: 25.05647
},
{
id: "U3RvcDpIU0w6OTY1MDYwMA==",
lat: 60.426754,
lon: 25.053925
},
{
id: "U3RvcDpIU0w6OTY1MDYxMA==",
lat: 60.42385,
lon: 25.053545
},
{
id: "U3RvcDpIU0w6OTY1MDUwNQ==",
lat: 60.417916,
lon: 25.05271
},
{
id: "U3RvcDpIU0w6OTY1MDQwNg==",
lat: 60.414022,
lon: 25.049991
},
{
id: "U3RvcDpIU0w6OTY1MDMyNQ==",
lat: 60.410933,
lon: 25.045152
},
{
id: "U3RvcDpIU0w6OTY1MDMyNw==",
lat: 60.409244,
lon: 25.042448
},
{
id: "U3RvcDpIU0w6OTY1MDMyMg==",
lat: 60.406367,
lon: 25.041696
},
{
id: "U3RvcDpIU0w6OTY1MDMxOQ==",
lat: 60.404485,
lon: 25.041464
},
{
id: "U3RvcDpIU0w6OTY1MDEwMg==",
lat: 60.40142,
lon: 25.030759
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
}
]
},
{
gtfsId: "HSL:6903K",
shortName: "903K",
longName: "Kirkkonummi-Kantvik-Hila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjA4MDIxOA==",
lat: 60.036183,
lon: 24.402558
},
{
id: "U3RvcDpIU0w6NjA4MDIxOQ==",
lat: 60.040103,
lon: 24.415452
},
{
id: "U3RvcDpIU0w6NjA4MDIyMQ==",
lat: 60.04626,
lon: 24.41565
},
{
id: "U3RvcDpIU0w6NjA4MDIyNw==",
lat: 60.049045,
lon: 24.417257
},
{
id: "U3RvcDpIU0w6NjA4MDIyMw==",
lat: 60.06042,
lon: 24.425005
},
{
id: "U3RvcDpIU0w6NjA4MDIxMQ==",
lat: 60.06665,
lon: 24.431917
},
{
id: "U3RvcDpIU0w6NjA4MDIzMA==",
lat: 60.069492,
lon: 24.440777
},
{
id: "U3RvcDpIU0w6NjA4MDIzMg==",
lat: 60.07481,
lon: 24.443197
},
{
id: "U3RvcDpIU0w6NjA4MDIyNQ==",
lat: 60.080037,
lon: 24.44822
},
{
id: "U3RvcDpIU0w6NjA4MDIxMw==",
lat: 60.08318,
lon: 24.451565
},
{
id: "U3RvcDpIU0w6NjA4MDIxNQ==",
lat: 60.08485,
lon: 24.433555
},
{
id: "U3RvcDpIU0w6NjA4MDIzNA==",
lat: 60.084371,
lon: 24.428774
},
{
id: "U3RvcDpIU0w6NjA3MDIxMQ==",
lat: 60.085443,
lon: 24.419278
},
{
id: "U3RvcDpIU0w6NjA3MDIzOQ==",
lat: 60.086303,
lon: 24.414335
},
{
id: "U3RvcDpIU0w6NjA3MDIzNQ==",
lat: 60.086695,
lon: 24.410655
},
{
id: "U3RvcDpIU0w6NjA3MDIxMg==",
lat: 60.086772,
lon: 24.408497
},
{
id: "U3RvcDpIU0w6NjA3MDIxNw==",
lat: 60.091925,
lon: 24.410829
},
{
id: "U3RvcDpIU0w6NjA3MDIyMw==",
lat: 60.094627,
lon: 24.40926
},
{
id: "U3RvcDpIU0w6NjA3MDIyMA==",
lat: 60.093213,
lon: 24.401212
},
{
id: "U3RvcDpIU0w6NjA3MDIzNw==",
lat: 60.092233,
lon: 24.396735
},
{
id: "U3RvcDpIU0w6NjA3MDIxNA==",
lat: 60.090353,
lon: 24.387245
},
{
id: "U3RvcDpIU0w6NjA3MDIxMw==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIxNg==",
lat: 60.090662,
lon: 24.38842
},
{
id: "U3RvcDpIU0w6NjA3MDIxOA==",
lat: 60.09218,
lon: 24.39843
},
{
id: "U3RvcDpIU0w6NjA3MDIxOQ==",
lat: 60.09339,
lon: 24.402122
},
{
id: "U3RvcDpIU0w6NjA3MDIyMg==",
lat: 60.094425,
lon: 24.410103
},
{
id: "U3RvcDpIU0w6NjA3MDIyNA==",
lat: 60.094795,
lon: 24.412478
},
{
id: "U3RvcDpIU0w6NjA3MDIyNg==",
lat: 60.097217,
lon: 24.415857
},
{
id: "U3RvcDpIU0w6NjA3MDIyNw==",
lat: 60.100692,
lon: 24.42214
},
{
id: "U3RvcDpIU0w6NjA0MDIwMQ==",
lat: 60.103107,
lon: 24.432607
},
{
id: "U3RvcDpIU0w6NjA0MDIwNA==",
lat: 60.106515,
lon: 24.439315
},
{
id: "U3RvcDpIU0w6NjA0MDIwNg==",
lat: 60.109248,
lon: 24.44381
},
{
id: "U3RvcDpIU0w6NjA0MDIwOA==",
lat: 60.113168,
lon: 24.44543
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI4OA==",
lat: 60.119803,
lon: 24.441526
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA3MDI0Mw==",
lat: 60.115295,
lon: 24.444255
},
{
id: "U3RvcDpIU0w6NjA0MDIwNw==",
lat: 60.112248,
lon: 24.445382
},
{
id: "U3RvcDpIU0w6NjA0MDIwNQ==",
lat: 60.10854,
lon: 24.44222
},
{
id: "U3RvcDpIU0w6NjA0MDIwMw==",
lat: 60.106028,
lon: 24.43808
},
{
id: "U3RvcDpIU0w6NjA0MDIwMg==",
lat: 60.102843,
lon: 24.43134
},
{
id: "U3RvcDpIU0w6NjA3MDI0MQ==",
lat: 60.100687,
lon: 24.421182
},
{
id: "U3RvcDpIU0w6NjA3MDIyNQ==",
lat: 60.096573,
lon: 24.414515
},
{
id: "U3RvcDpIU0w6NjA3MDIzNA==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIyMQ==",
lat: 60.094098,
lon: 24.411655
},
{
id: "U3RvcDpIU0w6NjA3MDIxNQ==",
lat: 60.090597,
lon: 24.409795
},
{
id: "U3RvcDpIU0w6NjA3MDIxMA==",
lat: 60.087858,
lon: 24.408618
},
{
id: "U3RvcDpIU0w6NjA3MDIzNg==",
lat: 60.086525,
lon: 24.410243
},
{
id: "U3RvcDpIU0w6NjA3MDIwOQ==",
lat: 60.085333,
lon: 24.419147
},
{
id: "U3RvcDpIU0w6NjA4MDIxNA==",
lat: 60.084727,
lon: 24.433527
},
{
id: "U3RvcDpIU0w6NjA4MDIxMg==",
lat: 60.082848,
lon: 24.45193
},
{
id: "U3RvcDpIU0w6NjA4MDIyNg==",
lat: 60.07995,
lon: 24.447652
},
{
id: "U3RvcDpIU0w6NjA4MDIzMw==",
lat: 60.077633,
lon: 24.445605
},
{
id: "U3RvcDpIU0w6NjA4MDIzMQ==",
lat: 60.069733,
lon: 24.440945
},
{
id: "U3RvcDpIU0w6NjA4MDIyNA==",
lat: 60.066498,
lon: 24.431138
},
{
id: "U3RvcDpIU0w6NjA4MDIyMg==",
lat: 60.060508,
lon: 24.424883
},
{
id: "U3RvcDpIU0w6NjA4MDIyOQ==",
lat: 60.051677,
lon: 24.416898
},
{
id: "U3RvcDpIU0w6NjA4MDIyOA==",
lat: 60.048772,
lon: 24.41683
},
{
id: "U3RvcDpIU0w6NjA4MDIyMA==",
lat: 60.04629,
lon: 24.415462
},
{
id: "U3RvcDpIU0w6NjA4MDIwMQ==",
lat: 60.040332,
lon: 24.415732
}
]
},
{
gtfsId: "HSL:9738",
shortName: "738",
longName: "Kalasatama (M)-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMA==",
lat: 60.40314,
lon: 25.10726
},
{
id: "U3RvcDpIU0w6OTA0MDIxMQ==",
lat: 60.40156,
lon: 25.11015
},
{
id: "U3RvcDpIU0w6OTA5MDIyOA==",
lat: 60.4003,
lon: 25.11
},
{
id: "U3RvcDpIU0w6OTA5MDIzMw==",
lat: 60.40176,
lon: 25.1191
},
{
id: "U3RvcDpIU0w6OTA1MDIzMQ==",
lat: 60.40229,
lon: 25.13579
},
{
id: "U3RvcDpIU0w6OTA1MDIzMw==",
lat: 60.40055,
lon: 25.14017
},
{
id: "U3RvcDpIU0w6OTA1MDIxNg==",
lat: 60.40003,
lon: 25.14512
},
{
id: "U3RvcDpIU0w6OTA1MDIxNA==",
lat: 60.39609,
lon: 25.14491
},
{
id: "U3RvcDpIU0w6OTA1MDIxMg==",
lat: 60.39415,
lon: 25.14529
},
{
id: "U3RvcDpIU0w6OTA1MDIxMA==",
lat: 60.39164,
lon: 25.14634
},
{
id: "U3RvcDpIU0w6OTA1MDIwOA==",
lat: 60.38884,
lon: 25.14521
},
{
id: "U3RvcDpIU0w6OTA1MDIwNQ==",
lat: 60.38618,
lon: 25.14439
},
{
id: "U3RvcDpIU0w6OTEwMDIxMQ==",
lat: 60.3867,
lon: 25.13719
},
{
id: "U3RvcDpIU0w6OTEwMDIwNQ==",
lat: 60.38567,
lon: 25.12616
},
{
id: "U3RvcDpIU0w6OTEwMDIwMw==",
lat: 60.37911,
lon: 25.12673
},
{
id: "U3RvcDpIU0w6OTEwMDIxMA==",
lat: 60.37064,
lon: 25.12891
},
{
id: "U3RvcDpIU0w6NDg2MDIxMQ==",
lat: 60.35938,
lon: 25.1277
},
{
id: "U3RvcDpIU0w6NDg2MDIzNg==",
lat: 60.35596,
lon: 25.12691
},
{
id: "U3RvcDpIU0w6NDg2MDIxMw==",
lat: 60.35381,
lon: 25.12674
},
{
id: "U3RvcDpIU0w6NDg2MDIxNQ==",
lat: 60.34614,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6OTIxNDIwNA==",
lat: 60.33975,
lon: 25.12525
},
{
id: "U3RvcDpIU0w6NDg2MDI0MA==",
lat: 60.33591,
lon: 25.12451
},
{
id: "U3RvcDpIU0w6OTIxNDIwMg==",
lat: 60.327533,
lon: 25.121072
},
{
id: "U3RvcDpIU0w6NDk3MDIyMg==",
lat: 60.31916,
lon: 25.11493
},
{
id: "U3RvcDpIU0w6NDk3MDIyMA==",
lat: 60.31307,
lon: 25.10852
},
{
id: "U3RvcDpIU0w6NDk3MDIxOA==",
lat: 60.304039,
lon: 25.104318
},
{
id: "U3RvcDpIU0w6NDk3MDI5Ng==",
lat: 60.30183,
lon: 25.10375
},
{
id: "U3RvcDpIU0w6NDk2MDIxNw==",
lat: 60.29775,
lon: 25.10205
},
{
id: "U3RvcDpIU0w6NDk2MDI5OQ==",
lat: 60.292049,
lon: 25.099393
},
{
id: "U3RvcDpIU0w6NDk2MDIxNQ==",
lat: 60.28741,
lon: 25.10189
},
{
id: "U3RvcDpIU0w6NDk0MDIyMw==",
lat: 60.2806,
lon: 25.10108
},
{
id: "U3RvcDpIU0w6NDkzMDIyNg==",
lat: 60.27535,
lon: 25.09522
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIxMDE2Mw==",
lat: 60.19824,
lon: 24.96938
},
{
id: "U3RvcDpIU0w6MTIxMDExMA==",
lat: 60.19523,
lon: 24.97448
},
{
id: "U3RvcDpIU0w6MTEwMDE2Nw==",
lat: 60.19191,
lon: 24.978519
},
{
id: "U3RvcDpIU0w6MTEwMDEzMg==",
lat: 60.186708,
lon: 24.976782
},
{
id: "U3RvcDpIU0w6MTEwMDEzMA==",
lat: 60.184567,
lon: 24.974413
},
{
id: "U3RvcDpIU0w6MTEwMDEzMQ==",
lat: 60.187162,
lon: 24.977327
},
{
id: "U3RvcDpIU0w6MTEwMDE2OA==",
lat: 60.19358,
lon: 24.97782
},
{
id: "U3RvcDpIU0w6MTIxMDExMQ==",
lat: 60.19603,
lon: 24.97368
},
{
id: "U3RvcDpIU0w6MTIxMDE2NA==",
lat: 60.19909,
lon: 24.96847
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIyNQ==",
lat: 60.27255,
lon: 25.09256
},
{
id: "U3RvcDpIU0w6NDkzMDIzMA==",
lat: 60.27502,
lon: 25.09521
},
{
id: "U3RvcDpIU0w6NDk0MDIyMg==",
lat: 60.28128,
lon: 25.102
},
{
id: "U3RvcDpIU0w6NDk2MDIxNA==",
lat: 60.2883,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6NDk2MDI5OA==",
lat: 60.293118,
lon: 25.099951
},
{
id: "U3RvcDpIU0w6NDk2MDIxNg==",
lat: 60.2979,
lon: 25.10244
},
{
id: "U3RvcDpIU0w6NDk3MDI5Nw==",
lat: 60.30293,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6NDk3MDIxNw==",
lat: 60.30573,
lon: 25.10498
},
{
id: "U3RvcDpIU0w6NDk3MDIxOQ==",
lat: 60.31407,
lon: 25.10985
},
{
id: "U3RvcDpIU0w6NDk3MDIyMQ==",
lat: 60.31937,
lon: 25.11534
},
{
id: "U3RvcDpIU0w6OTIxNDIwMQ==",
lat: 60.327397,
lon: 25.12172
},
{
id: "U3RvcDpIU0w6OTIxNDIwMw==",
lat: 60.337124,
lon: 25.125071
},
{
id: "U3RvcDpIU0w6NDg2MDI0OQ==",
lat: 60.34036,
lon: 25.12565
},
{
id: "U3RvcDpIU0w6NDg2MDIxMg==",
lat: 60.34735,
lon: 25.12712
},
{
id: "U3RvcDpIU0w6NDg2MDIxNA==",
lat: 60.35468,
lon: 25.12701
},
{
id: "U3RvcDpIU0w6NDg2MDIzNQ==",
lat: 60.35681,
lon: 25.12739
},
{
id: "U3RvcDpIU0w6OTEwMDIwMQ==",
lat: 60.36058,
lon: 25.12828
},
{
id: "U3RvcDpIU0w6OTEwMDIwMg==",
lat: 60.37176,
lon: 25.12882
},
{
id: "U3RvcDpIU0w6OTEwMDIwNA==",
lat: 60.38067,
lon: 25.12701
},
{
id: "U3RvcDpIU0w6OTEwMDIwOA==",
lat: 60.38598,
lon: 25.12815
},
{
id: "U3RvcDpIU0w6OTEwMDIwOQ==",
lat: 60.38645,
lon: 25.13528
},
{
id: "U3RvcDpIU0w6OTA1MDIwNg==",
lat: 60.38642,
lon: 25.14572
},
{
id: "U3RvcDpIU0w6OTA1MDIwOQ==",
lat: 60.38965,
lon: 25.14576
},
{
id: "U3RvcDpIU0w6OTA1MDIxMQ==",
lat: 60.39214,
lon: 25.14665
},
{
id: "U3RvcDpIU0w6OTA1MDIxMw==",
lat: 60.39432,
lon: 25.14548
},
{
id: "U3RvcDpIU0w6OTA1MDIxNQ==",
lat: 60.39715,
lon: 25.14532
},
{
id: "U3RvcDpIU0w6OTA1MDIxNw==",
lat: 60.4001,
lon: 25.1452
},
{
id: "U3RvcDpIU0w6OTA1MDIzMg==",
lat: 60.40087,
lon: 25.13935
},
{
id: "U3RvcDpIU0w6OTA1MDIzMA==",
lat: 60.40239,
lon: 25.13575
},
{
id: "U3RvcDpIU0w6OTA0MDIyMw==",
lat: 60.4015,
lon: 25.11788
},
{
id: "U3RvcDpIU0w6OTA0MDIxNA==",
lat: 60.40034,
lon: 25.11154
},
{
id: "U3RvcDpIU0w6OTA0MDIxMg==",
lat: 60.40166,
lon: 25.11056
},
{
id: "U3RvcDpIU0w6OTA0MDIwOQ==",
lat: 60.40329,
lon: 25.10603
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
}
]
},
{
gtfsId: "HSL:9665A",
shortName: "665A",
longName: "Hyrylä-Järvenpää-Kellokoski(-Mäntsälä)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDEyMw==",
lat: 60.401866,
lon: 25.028215
},
{
id: "U3RvcDpIU0w6OTY1MDEwMw==",
lat: 60.401391,
lon: 25.03098
},
{
id: "U3RvcDpIU0w6OTY1MDMyNA==",
lat: 60.402958,
lon: 25.039074
},
{
id: "U3RvcDpIU0w6OTY1MDMxOA==",
lat: 60.404662,
lon: 25.041673
},
{
id: "U3RvcDpIU0w6OTY1MDMyMQ==",
lat: 60.407436,
lon: 25.041864
},
{
id: "U3RvcDpIU0w6OTY1MDMyNg==",
lat: 60.409443,
lon: 25.042818
},
{
id: "U3RvcDpIU0w6OTY1MDMwMQ==",
lat: 60.411513,
lon: 25.045253
},
{
id: "U3RvcDpIU0w6OTY1MDQxNA==",
lat: 60.412355,
lon: 25.047274
},
{
id: "U3RvcDpIU0w6OTY1MDQwNw==",
lat: 60.415198,
lon: 25.051276
},
{
id: "U3RvcDpIU0w6OTY1MDUwNg==",
lat: 60.420609,
lon: 25.05311
},
{
id: "U3RvcDpIU0w6OTY1MDYxMQ==",
lat: 60.425178,
lon: 25.05372
},
{
id: "U3RvcDpIU0w6OTY1MDYwMQ==",
lat: 60.428092,
lon: 25.05419
},
{
id: "U3RvcDpIU0w6OTY1MDYwNA==",
lat: 60.431718,
lon: 25.057703
},
{
id: "U3RvcDpIU0w6OTY1MDYyMQ==",
lat: 60.434687,
lon: 25.063428
},
{
id: "U3RvcDpIU0w6OTY1MDYxOQ==",
lat: 60.438392,
lon: 25.06956
},
{
id: "U3RvcDpIU0w6OTY1MDYwNg==",
lat: 60.44401,
lon: 25.076555
},
{
id: "U3RvcDpIU0w6OTUyMzAwMQ==",
lat: 60.447028,
lon: 25.07805
},
{
id: "U3RvcDpIU0w6OTUyMjAwMA==",
lat: 60.45396,
lon: 25.082381
},
{
id: "U3RvcDpIU0w6OTUyMjAwNQ==",
lat: 60.456167,
lon: 25.083647
},
{
id: "U3RvcDpIU0w6OTUyMjAwNg==",
lat: 60.460369,
lon: 25.085854
},
{
id: "U3RvcDpIU0w6OTUwMTAxMQ==",
lat: 60.465908,
lon: 25.085926
},
{
id: "U3RvcDpIU0w6OTUwMTAxMg==",
lat: 60.467521,
lon: 25.08613
},
{
id: "U3RvcDpIU0w6OTUwMTAxMw==",
lat: 60.470591,
lon: 25.088868
},
{
id: "U3RvcDpIU0w6OTUwMDIzNg==",
lat: 60.473945,
lon: 25.090106
},
{
id: "U3RvcDpIU0w6OTUwMTAwMQ==",
lat: 60.47319,
lon: 25.086826
},
{
id: "U3RvcDpIU0w6OTUwMjAwMA==",
lat: 60.476178,
lon: 25.087684
},
{
id: "U3RvcDpIU0w6OTUwNzAwNg==",
lat: 60.478981,
lon: 25.084815
},
{
id: "U3RvcDpIU0w6OTUwNzAwNw==",
lat: 60.482216,
lon: 25.085202
},
{
id: "U3RvcDpIU0w6OTUwNzAwMQ==",
lat: 60.48585,
lon: 25.093673
},
{
id: "U3RvcDpIU0w6OTUxMjAwMQ==",
lat: 60.490279,
lon: 25.091075
},
{
id: "U3RvcDpIU0w6OTUxMjAwMw==",
lat: 60.494203,
lon: 25.091896
},
{
id: "U3RvcDpIU0w6OTUxMjAwNA==",
lat: 60.497842,
lon: 25.091761
},
{
id: "U3RvcDpIU0w6OTUxMTAxMw==",
lat: 60.501186,
lon: 25.091998
},
{
id: "U3RvcDpIU0w6OTYyMDYwMA==",
lat: 60.506744,
lon: 25.098604
},
{
id: "U3RvcDpIU0w6OTYyMDEwMA==",
lat: 60.517041,
lon: 25.100046
},
{
id: "U3RvcDpIU0w6OTYyMDExOQ==",
lat: 60.521574,
lon: 25.097913
},
{
id: "U3RvcDpIU0w6OTYyMDEyMw==",
lat: 60.524016,
lon: 25.099343
},
{
id: "U3RvcDpIU0w6OTYyMDExMA==",
lat: 60.527828,
lon: 25.104227
},
{
id: "U3RvcDpIU0w6OTYyMDEwOA==",
lat: 60.532741,
lon: 25.110697
},
{
id: "U3RvcDpIU0w6OTYyMDExNA==",
lat: 60.535827,
lon: 25.11185
},
{
id: "U3RvcDpIU0w6OTYyMDEyNQ==",
lat: 60.538881,
lon: 25.113485
},
{
id: "U3RvcDpIU0w6OTYyMDEyNw==",
lat: 60.541235,
lon: 25.114887
},
{
id: "U3RvcDpIU0w6OTYyMDEyOQ==",
lat: 60.546809,
lon: 25.119181
},
{
id: "U3RvcDpIU0w6OTgwMDIwMQ==",
lat: 60.549132,
lon: 25.12287
},
{
id: "U3RvcDpIU0w6OTgwMDIwMw==",
lat: 60.555939,
lon: 25.126751
},
{
id: "U3RvcDpIU0w6OTgwMDIwNQ==",
lat: 60.560741,
lon: 25.136326
},
{
id: "U3RvcDpIU0w6OTgwMDIwNw==",
lat: 60.564301,
lon: 25.136652
},
{
id: "U3RvcDpIU0w6OTgwMDIwOQ==",
lat: 60.566688,
lon: 25.140966
},
{
id: "U3RvcDpIU0w6OTgwMDIxMQ==",
lat: 60.569082,
lon: 25.145519
},
{
id: "U3RvcDpIU0w6OTgwMDIxMw==",
lat: 60.571451,
lon: 25.148685
},
{
id: "U3RvcDpIU0w6OTgwMDIxNQ==",
lat: 60.574804,
lon: 25.154385
},
{
id: "U3RvcDpIU0w6OTgwMDIxNw==",
lat: 60.576926,
lon: 25.160152
},
{
id: "U3RvcDpIU0w6OTgwMDIxOQ==",
lat: 60.579892,
lon: 25.163779
},
{
id: "U3RvcDpIU0w6OTgwMDIyMQ==",
lat: 60.582742,
lon: 25.170468
},
{
id: "U3RvcDpIU0w6OTgwMDIyMw==",
lat: 60.593781,
lon: 25.194977
},
{
id: "U3RvcDpIU0w6OTgwMDIyNQ==",
lat: 60.601979,
lon: 25.203623
},
{
id: "U3RvcDpIU0w6OTgwMDIyNw==",
lat: 60.605954,
lon: 25.203898
},
{
id: "U3RvcDpIU0w6OTgwMDIyOQ==",
lat: 60.610513,
lon: 25.211883
},
{
id: "U3RvcDpIU0w6OTgwMDIzMQ==",
lat: 60.612871,
lon: 25.215077
},
{
id: "U3RvcDpIU0w6OTgwMDIzMw==",
lat: 60.614015,
lon: 25.227374
},
{
id: "U3RvcDpIU0w6OTgwMDIzNQ==",
lat: 60.617266,
lon: 25.24083
},
{
id: "U3RvcDpIU0w6OTgwMDIzNw==",
lat: 60.618431,
lon: 25.25072
},
{
id: "U3RvcDpIU0w6OTgwMDIzOQ==",
lat: 60.618001,
lon: 25.261206
},
{
id: "U3RvcDpIU0w6OTgwMDI0MQ==",
lat: 60.623288,
lon: 25.275351
},
{
id: "U3RvcDpIU0w6OTgwMDI0Mw==",
lat: 60.62181,
lon: 25.286216
},
{
id: "U3RvcDpIU0w6OTgwMDI0NQ==",
lat: 60.623944,
lon: 25.292147
},
{
id: "U3RvcDpIU0w6OTgwMDI0Nw==",
lat: 60.625219,
lon: 25.295761
},
{
id: "U3RvcDpIU0w6OTgwMDI0OQ==",
lat: 60.627771,
lon: 25.302861
},
{
id: "U3RvcDpIU0w6OTgwMDI1MQ==",
lat: 60.631013,
lon: 25.30999
},
{
id: "U3RvcDpIU0w6OTgwMDIwMA==",
lat: 60.634351,
lon: 25.315662
},
{
id: "U3RvcDpIU0w6OTgwMDI1Nw==",
lat: 60.634122,
lon: 25.314319
},
{
id: "U3RvcDpIU0w6OTgwMDI1OQ==",
lat: 60.636739,
lon: 25.31841
},
{
id: "U3RvcDpIU0w6OTgwMDI1Mw==",
lat: 60.63959,
lon: 25.322291
},
{
id: "U3RvcDpIU0w6OTgwMDI1NQ==",
lat: 60.645623,
lon: 25.319486
},
{
id: "U3RvcDpIU0w6OTgwMDI1OA==",
lat: 60.642029,
lon: 25.307073
},
{
id: "U3RvcDpIU0w6OTgwMDI1Mg==",
lat: 60.630525,
lon: 25.308563
},
{
id: "U3RvcDpIU0w6OTgwMDI1MA==",
lat: 60.628267,
lon: 25.30352
},
{
id: "U3RvcDpIU0w6OTgwMDI0OA==",
lat: 60.625044,
lon: 25.294365
},
{
id: "U3RvcDpIU0w6OTgwMDI0Ng==",
lat: 60.623646,
lon: 25.290491
},
{
id: "U3RvcDpIU0w6OTgwMDI0NA==",
lat: 60.622851,
lon: 25.281562
},
{
id: "U3RvcDpIU0w6OTgwMDI0Mg==",
lat: 60.623424,
lon: 25.274205
},
{
id: "U3RvcDpIU0w6OTgwMDI0MA==",
lat: 60.618655,
lon: 25.262309
},
{
id: "U3RvcDpIU0w6OTgwMDIzOA==",
lat: 60.61862,
lon: 25.251531
},
{
id: "U3RvcDpIU0w6OTgwMDIzNg==",
lat: 60.616805,
lon: 25.240283
},
{
id: "U3RvcDpIU0w6OTgwMDIzNA==",
lat: 60.613703,
lon: 25.225207
},
{
id: "U3RvcDpIU0w6OTgwMDIzMg==",
lat: 60.61209,
lon: 25.213166
},
{
id: "U3RvcDpIU0w6OTgwMDIzMA==",
lat: 60.610196,
lon: 25.210119
},
{
id: "U3RvcDpIU0w6OTgwMDIyOA==",
lat: 60.606745,
lon: 25.203672
},
{
id: "U3RvcDpIU0w6OTgwMDIyNg==",
lat: 60.601391,
lon: 25.203072
},
{
id: "U3RvcDpIU0w6OTgwMDIyNA==",
lat: 60.593803,
lon: 25.19255
},
{
id: "U3RvcDpIU0w6OTgwMDIyMg==",
lat: 60.583721,
lon: 25.172528
},
{
id: "U3RvcDpIU0w6OTgwMDIyMA==",
lat: 60.579306,
lon: 25.162006
},
{
id: "U3RvcDpIU0w6OTgwMDIxOA==",
lat: 60.576866,
lon: 25.159767
},
{
id: "U3RvcDpIU0w6OTgwMDIxNg==",
lat: 60.574745,
lon: 25.153853
},
{
id: "U3RvcDpIU0w6OTgwMDIxNA==",
lat: 60.571293,
lon: 25.148296
},
{
id: "U3RvcDpIU0w6OTgwMDIxMg==",
lat: 60.569298,
lon: 25.145472
},
{
id: "U3RvcDpIU0w6OTgwMDIxMA==",
lat: 60.566508,
lon: 25.139921
},
{
id: "U3RvcDpIU0w6OTgwMDIwOA==",
lat: 60.564552,
lon: 25.136715
},
{
id: "U3RvcDpIU0w6OTgwMDIwNg==",
lat: 60.560779,
lon: 25.136072
},
{
id: "U3RvcDpIU0w6OTgwMDIwNA==",
lat: 60.557224,
lon: 25.127689
},
{
id: "U3RvcDpIU0w6OTgwMDIwMg==",
lat: 60.548628,
lon: 25.121959
},
{
id: "U3RvcDpIU0w6OTYyMDEzMA==",
lat: 60.546026,
lon: 25.118111
},
{
id: "U3RvcDpIU0w6OTYyMDEyOA==",
lat: 60.542592,
lon: 25.117474
},
{
id: "U3RvcDpIU0w6OTYyMDEyNg==",
lat: 60.540297,
lon: 25.114163
},
{
id: "U3RvcDpIU0w6OTYyMDExNQ==",
lat: 60.536589,
lon: 25.112111
},
{
id: "U3RvcDpIU0w6OTYyMDEwOQ==",
lat: 60.531432,
lon: 25.109525
},
{
id: "U3RvcDpIU0w6OTYyMDExMQ==",
lat: 60.527961,
lon: 25.104432
},
{
id: "U3RvcDpIU0w6OTYyMDEyMQ==",
lat: 60.5271,
lon: 25.102984
},
{
id: "U3RvcDpIU0w6OTYyMDEyMg==",
lat: 60.524806,
lon: 25.100191
},
{
id: "U3RvcDpIU0w6OTYyMDEyMA==",
lat: 60.520712,
lon: 25.097855
},
{
id: "U3RvcDpIU0w6OTYyMDEwMQ==",
lat: 60.516602,
lon: 25.100577
},
{
id: "U3RvcDpIU0w6OTUxMTAwMA==",
lat: 60.505717,
lon: 25.097145
},
{
id: "U3RvcDpIU0w6OTUxMTAxNA==",
lat: 60.501876,
lon: 25.092309
},
{
id: "U3RvcDpIU0w6OTUxMjAwNQ==",
lat: 60.496901,
lon: 25.092005
},
{
id: "U3RvcDpIU0w6OTUxMjAwMg==",
lat: 60.493273,
lon: 25.091476
},
{
id: "U3RvcDpIU0w6OTUxMjAwMA==",
lat: 60.489363,
lon: 25.091271
},
{
id: "U3RvcDpIU0w6OTUwMDIwOA==",
lat: 60.484409,
lon: 25.090334
},
{
id: "U3RvcDpIU0w6OTUwMDIxMA==",
lat: 60.482476,
lon: 25.085652
},
{
id: "U3RvcDpIU0w6OTUwMDIxMg==",
lat: 60.479456,
lon: 25.0841
},
{
id: "U3RvcDpIU0w6OTUwMDIxNA==",
lat: 60.476041,
lon: 25.087756
},
{
id: "U3RvcDpIU0w6OTUwMTAwMg==",
lat: 60.473138,
lon: 25.086983
},
{
id: "U3RvcDpIU0w6OTUwMDIwMA==",
lat: 60.47372,
lon: 25.090098
},
{
id: "U3RvcDpIU0w6OTUwMTAwOA==",
lat: 60.470457,
lon: 25.088669
},
{
id: "U3RvcDpIU0w6OTUwMTAwOQ==",
lat: 60.46858,
lon: 25.086553
},
{
id: "U3RvcDpIU0w6OTUwMTAxMA==",
lat: 60.464957,
lon: 25.086094
},
{
id: "U3RvcDpIU0w6OTUyMjAwMw==",
lat: 60.4594,
lon: 25.085262
},
{
id: "U3RvcDpIU0w6OTUyMjAwNA==",
lat: 60.456397,
lon: 25.083441
},
{
id: "U3RvcDpIU0w6OTUyMzAwMA==",
lat: 60.453127,
lon: 25.081499
},
{
id: "U3RvcDpIU0w6OTUwNjAwMg==",
lat: 60.445708,
lon: 25.077829
},
{
id: "U3RvcDpIU0w6OTY1MDYwNQ==",
lat: 60.443133,
lon: 25.07554
},
{
id: "U3RvcDpIU0w6OTY1MDYxOA==",
lat: 60.437911,
lon: 25.068885
},
{
id: "U3RvcDpIU0w6OTY1MDYyMA==",
lat: 60.434359,
lon: 25.06276
},
{
id: "U3RvcDpIU0w6OTY1MDYwMw==",
lat: 60.430897,
lon: 25.05647
},
{
id: "U3RvcDpIU0w6OTY1MDYwMA==",
lat: 60.426754,
lon: 25.053925
},
{
id: "U3RvcDpIU0w6OTY1MDYxMA==",
lat: 60.42385,
lon: 25.053545
},
{
id: "U3RvcDpIU0w6OTY1MDUwNQ==",
lat: 60.417916,
lon: 25.05271
},
{
id: "U3RvcDpIU0w6OTY1MDQwNg==",
lat: 60.414022,
lon: 25.049991
},
{
id: "U3RvcDpIU0w6OTY1MDMyNQ==",
lat: 60.410933,
lon: 25.045152
},
{
id: "U3RvcDpIU0w6OTY1MDMyNw==",
lat: 60.409244,
lon: 25.042448
},
{
id: "U3RvcDpIU0w6OTY1MDMyMg==",
lat: 60.406367,
lon: 25.041696
},
{
id: "U3RvcDpIU0w6OTY1MDMxOQ==",
lat: 60.404485,
lon: 25.041464
},
{
id: "U3RvcDpIU0w6OTY1MDEwMg==",
lat: 60.40142,
lon: 25.030759
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
}
]
},
{
gtfsId: "HSL:9977",
shortName: "977",
longName: "Ylikerava-Päivölä-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA3MDIxNg==",
lat: 60.423727,
lon: 25.128088
},
{
id: "U3RvcDpIU0w6OTA1MDIzNw==",
lat: 60.41085,
lon: 25.136687
},
{
id: "U3RvcDpIU0w6OTA1MDIwNA==",
lat: 60.40798,
lon: 25.14112
},
{
id: "U3RvcDpIU0w6OTA1MDIyNg==",
lat: 60.40598,
lon: 25.13959
},
{
id: "U3RvcDpIU0w6OTA1MDIyNw==",
lat: 60.40562,
lon: 25.13303
},
{
id: "U3RvcDpIU0w6OTA0MDIxOA==",
lat: 60.40565,
lon: 25.115
},
{
id: "U3RvcDpIU0w6OTA0MDIxNQ==",
lat: 60.40475,
lon: 25.11062
},
{
id: "U3RvcDpIU0w6OTA0MDIwOQ==",
lat: 60.40329,
lon: 25.10603
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
},
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMA==",
lat: 60.40314,
lon: 25.10726
},
{
id: "U3RvcDpIU0w6OTA0MDIxNw==",
lat: 60.405,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6OTA0MDIxOQ==",
lat: 60.4059,
lon: 25.11659
},
{
id: "U3RvcDpIU0w6OTA1MDIyOQ==",
lat: 60.40502,
lon: 25.13488
},
{
id: "U3RvcDpIU0w6OTA1MDIyMg==",
lat: 60.40684,
lon: 25.14171
},
{
id: "U3RvcDpIU0w6OTA1MDIwMw==",
lat: 60.40851,
lon: 25.14048
},
{
id: "U3RvcDpIU0w6OTA1MDIzNg==",
lat: 60.41092,
lon: 25.136889
},
{
id: "U3RvcDpIU0w6OTA3MDIxOA==",
lat: 60.42273,
lon: 25.12829
}
]
},
{
gtfsId: "HSL:9978",
shortName: "978",
longName: "Keinukallio-Sorsakorpi-Keravan asema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA0MDIwOA==",
lat: 60.40445,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIxMA==",
lat: 60.40314,
lon: 25.10726
},
{
id: "U3RvcDpIU0w6OTA0MDIxNw==",
lat: 60.405,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6OTA0MDIxOQ==",
lat: 60.4059,
lon: 25.11659
},
{
id: "U3RvcDpIU0w6OTA1MDIyOQ==",
lat: 60.40502,
lon: 25.13488
},
{
id: "U3RvcDpIU0w6OTA1MDIyNQ==",
lat: 60.40554,
lon: 25.14059
},
{
id: "U3RvcDpIU0w6OTA1MDIzNA==",
lat: 60.40252,
lon: 25.14004
},
{
id: "U3RvcDpIU0w6OTA1MDIzMw==",
lat: 60.40055,
lon: 25.14017
},
{
id: "U3RvcDpIU0w6OTA1MDIxNg==",
lat: 60.40003,
lon: 25.14512
},
{
id: "U3RvcDpIU0w6OTA1MDIxNA==",
lat: 60.39609,
lon: 25.14491
},
{
id: "U3RvcDpIU0w6OTA1MDIxMg==",
lat: 60.39415,
lon: 25.14529
},
{
id: "U3RvcDpIU0w6OTA1MDIxMA==",
lat: 60.39164,
lon: 25.14634
},
{
id: "U3RvcDpIU0w6OTA1MDIwOA==",
lat: 60.38884,
lon: 25.14521
},
{
id: "U3RvcDpIU0w6OTEwMDIxNQ==",
lat: 60.384847,
lon: 25.136669
},
{
id: "U3RvcDpIU0w6OTA1MDIwNg==",
lat: 60.38642,
lon: 25.14572
},
{
id: "U3RvcDpIU0w6OTA1MDIwOQ==",
lat: 60.38965,
lon: 25.14576
},
{
id: "U3RvcDpIU0w6OTA1MDIxMQ==",
lat: 60.39214,
lon: 25.14665
},
{
id: "U3RvcDpIU0w6OTA1MDIxMw==",
lat: 60.39432,
lon: 25.14548
},
{
id: "U3RvcDpIU0w6OTA1MDIxNQ==",
lat: 60.39715,
lon: 25.14532
},
{
id: "U3RvcDpIU0w6OTA1MDIxNw==",
lat: 60.4001,
lon: 25.1452
},
{
id: "U3RvcDpIU0w6OTA1MDIzMg==",
lat: 60.40087,
lon: 25.13935
},
{
id: "U3RvcDpIU0w6OTA1MDIzNQ==",
lat: 60.4028,
lon: 25.14068
},
{
id: "U3RvcDpIU0w6OTA1MDIyNg==",
lat: 60.40598,
lon: 25.13959
},
{
id: "U3RvcDpIU0w6OTA1MDIyNw==",
lat: 60.40562,
lon: 25.13303
},
{
id: "U3RvcDpIU0w6OTA0MDIxOA==",
lat: 60.40565,
lon: 25.115
},
{
id: "U3RvcDpIU0w6OTA0MDIxNQ==",
lat: 60.40475,
lon: 25.11062
},
{
id: "U3RvcDpIU0w6OTA0MDIwOQ==",
lat: 60.40329,
lon: 25.10603
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
}
]
},
{
gtfsId: "HSL:6915T",
shortName: "915T",
longName: "Kuntakeskus-Siuntion kk.-Järvinummi-Kahvimaa",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAyMw==",
lat: 60.165141,
lon: 24.197315
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAzMw==",
lat: 60.171361,
lon: 24.201095
},
{
id: "U3RvcDpIU0w6NjMwMTAxMg==",
lat: 60.173692,
lon: 24.206942
},
{
id: "U3RvcDpIU0w6NjMwMTAzMA==",
lat: 60.179294,
lon: 24.202626
},
{
id: "U3RvcDpIU0w6NjMwMTA0MA==",
lat: 60.19108,
lon: 24.203815
},
{
id: "U3RvcDpIU0w6NjMwMTA2Mw==",
lat: 60.2183,
lon: 24.240424
},
{
id: "U3RvcDpIU0w6NjMwMTA1Ng==",
lat: 60.233838,
lon: 24.254802
},
{
id: "U3RvcDpIU0w6NjMwMTA2NQ==",
lat: 60.248472,
lon: 24.297604
},
{
id: "U3RvcDpIU0w6NjMwMTA2OQ==",
lat: 60.26863,
lon: 24.302913
},
{
id: "U3RvcDpIU0w6NjMwMTA2Ng==",
lat: 60.248523,
lon: 24.297696
},
{
id: "U3RvcDpIU0w6NjMwMTA1Nw==",
lat: 60.234227,
lon: 24.253235
},
{
id: "U3RvcDpIU0w6NjMwMTA2NA==",
lat: 60.218328,
lon: 24.240314
},
{
id: "U3RvcDpIU0w6NjMwMTAyMA==",
lat: 60.190246,
lon: 24.20253
},
{
id: "U3RvcDpIU0w6NjMwMTAzMQ==",
lat: 60.178093,
lon: 24.202822
},
{
id: "U3RvcDpIU0w6NjMwMTAxMQ==",
lat: 60.172765,
lon: 24.206878
},
{
id: "U3RvcDpIU0w6NjMwMTA1Mg==",
lat: 60.170375,
lon: 24.200431
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
}
]
},
{
gtfsId: "HSL:9987BB",
shortName: "987BB",
longName: "Nikkilä-Jokimäki-Laukkoski",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyMjI1OQ==",
lat: 60.375139,
lon: 25.267128
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwOA==",
lat: 60.386435,
lon: 25.282542
},
{
id: "U3RvcDpIU0w6OTIyOTIwMw==",
lat: 60.390658,
lon: 25.291292
},
{
id: "U3RvcDpIU0w6OTIyOTIwNg==",
lat: 60.393408,
lon: 25.296543
},
{
id: "U3RvcDpIU0w6OTIyOTIwOA==",
lat: 60.396172,
lon: 25.298523
},
{
id: "U3RvcDpIU0w6OTIyNTIwMw==",
lat: 60.402635,
lon: 25.299295
},
{
id: "U3RvcDpIU0w6OTIyNTIwNQ==",
lat: 60.406127,
lon: 25.30665
},
{
id: "U3RvcDpIU0w6OTIyNTIwNg==",
lat: 60.40681,
lon: 25.315015
},
{
id: "U3RvcDpIU0w6OTIyNTIwOA==",
lat: 60.40889,
lon: 25.318735
},
{
id: "U3RvcDpIU0w6OTIyNTIwOQ==",
lat: 60.410377,
lon: 25.321968
},
{
id: "U3RvcDpIU0w6OTIyNTIxMg==",
lat: 60.41308,
lon: 25.328807
},
{
id: "U3RvcDpIU0w6OTIyNTIxNA==",
lat: 60.416008,
lon: 25.330725
},
{
id: "U3RvcDpIU0w6OTIyNTIxNQ==",
lat: 60.418978,
lon: 25.332633
},
{
id: "U3RvcDpIU0w6OTIyNTIxOA==",
lat: 60.425025,
lon: 25.338565
},
{
id: "U3RvcDpIU0w6OTQwMDIxMQ==",
lat: 60.435523,
lon: 25.368753
},
{
id: "U3RvcDpIU0w6OTQwMDIwNQ==",
lat: 60.432417,
lon: 25.399457
}
]
},
{
gtfsId: "HSL:4724N",
shortName: "724N",
longName: "Rautatientori-Tikkurila-Koivukylä-Päiväkumpu",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDc1MDIxNw==",
lat: 60.31596,
lon: 25.10011
},
{
id: "U3RvcDpIU0w6NDc1MDIwOA==",
lat: 60.31848,
lon: 25.09669
},
{
id: "U3RvcDpIU0w6NDc1MDIxMA==",
lat: 60.3206,
lon: 25.09284
},
{
id: "U3RvcDpIU0w6NDc1MDIxMg==",
lat: 60.32134,
lon: 25.0874
},
{
id: "U3RvcDpIU0w6NDc0MDIzMA==",
lat: 60.32246,
lon: 25.08175
},
{
id: "U3RvcDpIU0w6NDc0MDIzNw==",
lat: 60.32363,
lon: 25.07618
},
{
id: "U3RvcDpIU0w6NDc0MDIwNA==",
lat: 60.32067,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNg==",
lat: 60.3177,
lon: 25.07508
},
{
id: "U3RvcDpIU0w6NDc0MDIyMg==",
lat: 60.31541,
lon: 25.07132
},
{
id: "U3RvcDpIU0w6NDc0MDIyNw==",
lat: 60.31677,
lon: 25.06715
},
{
id: "U3RvcDpIU0w6NDc0MDIyNA==",
lat: 60.31925,
lon: 25.06135
},
{
id: "U3RvcDpIU0w6NDc0MDIxNA==",
lat: 60.32079,
lon: 25.06203
},
{
id: "U3RvcDpIU0w6NDcwMDIxMA==",
lat: 60.32347,
lon: 25.05847
},
{
id: "U3RvcDpIU0w6NDcyMDIyNw==",
lat: 60.325038,
lon: 25.050357
},
{
id: "U3RvcDpIU0w6NDcwMDIzMg==",
lat: 60.326547,
lon: 25.0421
},
{
id: "U3RvcDpIU0w6NDcwMDIzMw==",
lat: 60.325487,
lon: 25.041647
},
{
id: "U3RvcDpIU0w6NDcwMDIyOQ==",
lat: 60.322323,
lon: 25.042012
},
{
id: "U3RvcDpIU0w6NDcwMDIwMg==",
lat: 60.31968,
lon: 25.03908
},
{
id: "U3RvcDpIU0w6NDY1MDIxMA==",
lat: 60.3149,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6NDY1MDIwOA==",
lat: 60.31072,
lon: 25.03015
},
{
id: "U3RvcDpIU0w6NDY1MDIwNg==",
lat: 60.30949,
lon: 25.02695
},
{
id: "U3RvcDpIU0w6NDY1MDIwNA==",
lat: 60.30635,
lon: 25.02439
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIwNw==",
lat: 60.30182,
lon: 25.02328
},
{
id: "U3RvcDpIU0w6NDYzMDIyNQ==",
lat: 60.30021,
lon: 25.02911
},
{
id: "U3RvcDpIU0w6NDYzMDIwOQ==",
lat: 60.299,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6NDYxMDIwOQ==",
lat: 60.2969,
lon: 25.03573
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI0Nw==",
lat: 60.293663,
lon: 25.044318
},
{
id: "U3RvcDpIU0w6NDYxMDIzNg==",
lat: 60.29838,
lon: 25.0454
},
{
id: "U3RvcDpIU0w6NDYyMDIyNw==",
lat: 60.29821,
lon: 25.05193
},
{
id: "U3RvcDpIU0w6NDYyMDIxNw==",
lat: 60.29828,
lon: 25.055708
},
{
id: "U3RvcDpIU0w6NDYyMDIwNQ==",
lat: 60.29549,
lon: 25.0614
},
{
id: "U3RvcDpIU0w6NDY2MDI5OQ==",
lat: 60.29509,
lon: 25.06703
},
{
id: "U3RvcDpIU0w6NDY2MDIwMQ==",
lat: 60.29136,
lon: 25.07367
},
{
id: "U3RvcDpIU0w6NDY2MDIzMA==",
lat: 60.288522,
lon: 25.077184
},
{
id: "U3RvcDpIU0w6NDY2MDIwOA==",
lat: 60.28666,
lon: 25.08042
},
{
id: "U3RvcDpIU0w6NDY0MDIxMQ==",
lat: 60.28169,
lon: 25.07941
},
{
id: "U3RvcDpIU0w6NDY0MDIxMw==",
lat: 60.27837,
lon: 25.07894
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDE4Mg==",
lat: 60.17098,
lon: 24.9427
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDY0MDIxMg==",
lat: 60.27986,
lon: 25.079974
},
{
id: "U3RvcDpIU0w6NDY0MDIwOA==",
lat: 60.2826,
lon: 25.07956
},
{
id: "U3RvcDpIU0w6NDY0MDIwNg==",
lat: 60.28606,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6NDY2MDIwNg==",
lat: 60.28758,
lon: 25.07993
},
{
id: "U3RvcDpIU0w6NDY2MDIwNA==",
lat: 60.28978,
lon: 25.07599
},
{
id: "U3RvcDpIU0w6NDY2MDIwMg==",
lat: 60.29189,
lon: 25.07317
},
{
id: "U3RvcDpIU0w6NDY2MDI5OA==",
lat: 60.29531,
lon: 25.06689
},
{
id: "U3RvcDpIU0w6NDYyMDIwNg==",
lat: 60.29581,
lon: 25.05983
},
{
id: "U3RvcDpIU0w6NDYyMDIyMg==",
lat: 60.29868,
lon: 25.05371
},
{
id: "U3RvcDpIU0w6NDYyMDIzMQ==",
lat: 60.2985,
lon: 25.05011
},
{
id: "U3RvcDpIU0w6NDYxMDIzNw==",
lat: 60.29861,
lon: 25.044342
},
{
id: "U3RvcDpIU0w6NDYxMDI1MA==",
lat: 60.293905,
lon: 25.044436
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIyOA==",
lat: 60.29661,
lon: 25.03844
},
{
id: "U3RvcDpIU0w6NDYxMDIzMQ==",
lat: 60.29765,
lon: 25.03472
},
{
id: "U3RvcDpIU0w6NDYzMDIxMA==",
lat: 60.29964,
lon: 25.03247
},
{
id: "U3RvcDpIU0w6NDYzMDIyNg==",
lat: 60.30105,
lon: 25.02662
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIwMw==",
lat: 60.30689,
lon: 25.02499
},
{
id: "U3RvcDpIU0w6NDY1MDIwNQ==",
lat: 60.31,
lon: 25.0287
},
{
id: "U3RvcDpIU0w6NDY1MDIwNw==",
lat: 60.31132,
lon: 25.03142
},
{
id: "U3RvcDpIU0w6NDY1MDIwOQ==",
lat: 60.31516,
lon: 25.03566
},
{
id: "U3RvcDpIU0w6NDcwMDIwMQ==",
lat: 60.3203,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDcwMDIyOA==",
lat: 60.32246,
lon: 25.042177
},
{
id: "U3RvcDpIU0w6NDcwMDIzNA==",
lat: 60.325902,
lon: 25.041882
},
{
id: "U3RvcDpIU0w6NDcyMDIyNQ==",
lat: 60.326482,
lon: 25.043723
},
{
id: "U3RvcDpIU0w6NDcwMDIwNw==",
lat: 60.3246,
lon: 25.05219
},
{
id: "U3RvcDpIU0w6NDcwMDIwOQ==",
lat: 60.32329,
lon: 25.0588
},
{
id: "U3RvcDpIU0w6NDc0MDIxNQ==",
lat: 60.32133,
lon: 25.06167
},
{
id: "U3RvcDpIU0w6NDc0MDIyMw==",
lat: 60.31843,
lon: 25.06179
},
{
id: "U3RvcDpIU0w6NDc0MDIwOQ==",
lat: 60.31549,
lon: 25.07315
},
{
id: "U3RvcDpIU0w6NDc0MDIwNw==",
lat: 60.31774,
lon: 25.07539
},
{
id: "U3RvcDpIU0w6NDc0MDIwNQ==",
lat: 60.31983,
lon: 25.07345
},
{
id: "U3RvcDpIU0w6NDc0MDIwMw==",
lat: 60.32145,
lon: 25.07416
},
{
id: "U3RvcDpIU0w6NDc0MDIzNA==",
lat: 60.32318,
lon: 25.07886
},
{
id: "U3RvcDpIU0w6NDc0MDIzMQ==",
lat: 60.32183,
lon: 25.08353
},
{
id: "U3RvcDpIU0w6NDc1MDIxMQ==",
lat: 60.32087,
lon: 25.08958
},
{
id: "U3RvcDpIU0w6NDc1MDIwOQ==",
lat: 60.31961,
lon: 25.09455
},
{
id: "U3RvcDpIU0w6NDc1MDIxMw==",
lat: 60.31788,
lon: 25.09712
},
{
id: "U3RvcDpIU0w6NDc1MDIyMg==",
lat: 60.31618,
lon: 25.09939
}
]
},
{
gtfsId: "HSL:2436K",
shortName: "436K",
longName: "Elielinaukio-Martinlaakso-Juvanmalmi-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDIzOQ==",
lat: 60.171981,
lon: 24.93971
},
{
id: "U3RvcDpIU0w6MTEzMDEwNg==",
lat: 60.17884,
lon: 24.92917
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMQ==",
lat: 60.26319,
lon: 24.87052
},
{
id: "U3RvcDpIU0w6NDE2MDIyNg==",
lat: 60.26548,
lon: 24.86497
},
{
id: "U3RvcDpIU0w6NDE1MDIzMA==",
lat: 60.26948,
lon: 24.85788
},
{
id: "U3RvcDpIU0w6NDE1MDIxNw==",
lat: 60.27172,
lon: 24.85481
},
{
id: "U3RvcDpIU0w6NDE3MDI5Mw==",
lat: 60.275267,
lon: 24.856513
},
{
id: "U3RvcDpIU0w6NDE3MDI0Nw==",
lat: 60.27742,
lon: 24.85389
},
{
id: "U3RvcDpIU0w6NDE3MDI5OA==",
lat: 60.28101,
lon: 24.85392
},
{
id: "U3RvcDpIU0w6NDE3MDI0Mg==",
lat: 60.28476,
lon: 24.84794
},
{
id: "U3RvcDpIU0w6NDE3MDIzNg==",
lat: 60.28304,
lon: 24.84057
},
{
id: "U3RvcDpIU0w6NDE0MDI1Mw==",
lat: 60.28171,
lon: 24.83488
},
{
id: "U3RvcDpIU0w6NDE0MDI1NA==",
lat: 60.2802,
lon: 24.82517
},
{
id: "U3RvcDpIU0w6NDE0MDIyMQ==",
lat: 60.27733,
lon: 24.8202
},
{
id: "U3RvcDpIU0w6NDE0MDIxNw==",
lat: 60.27352,
lon: 24.81058
},
{
id: "U3RvcDpIU0w6NDE0MDI0NA==",
lat: 60.27128,
lon: 24.8068
},
{
id: "U3RvcDpIU0w6NDEyMDIxNA==",
lat: 60.27342,
lon: 24.7938
},
{
id: "U3RvcDpIU0w6NDEyMDIxNg==",
lat: 60.27395,
lon: 24.77924
},
{
id: "U3RvcDpIU0w6MjcxNTIyOQ==",
lat: 60.27164,
lon: 24.76011
},
{
id: "U3RvcDpIU0w6MjcxNTIzMg==",
lat: 60.275,
lon: 24.76107
},
{
id: "U3RvcDpIU0w6MjcxNTIzMw==",
lat: 60.278,
lon: 24.76154
},
{
id: "U3RvcDpIU0w6MjcxNTIzNQ==",
lat: 60.27888,
lon: 24.7575
},
{
id: "U3RvcDpIU0w6MjcxNTIzNw==",
lat: 60.27908,
lon: 24.74978
},
{
id: "U3RvcDpIU0w6MjcxNTI0MQ==",
lat: 60.28485,
lon: 24.74651
},
{
id: "U3RvcDpIU0w6MjcxNDIwNw==",
lat: 60.28958,
lon: 24.74415
},
{
id: "U3RvcDpIU0w6MjcxNDI0NA==",
lat: 60.29397,
lon: 24.74164
},
{
id: "U3RvcDpIU0w6MjcxNDI0Ng==",
lat: 60.29568,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjcyMTI5NA==",
lat: 60.29856,
lon: 24.73566
},
{
id: "U3RvcDpIU0w6MjcyMTI4NA==",
lat: 60.30131,
lon: 24.73778
},
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTI4NQ==",
lat: 60.3017,
lon: 24.73789
},
{
id: "U3RvcDpIU0w6MjcxNDI5NQ==",
lat: 60.29716,
lon: 24.73534
},
{
id: "U3RvcDpIU0w6MjcxNDI5Nw==",
lat: 60.29513,
lon: 24.73867
},
{
id: "U3RvcDpIU0w6MjcxNDI0NQ==",
lat: 60.29371,
lon: 24.74248
},
{
id: "U3RvcDpIU0w6MjcxNDIwNg==",
lat: 60.28919,
lon: 24.74444
},
{
id: "U3RvcDpIU0w6MjcxNTI0MA==",
lat: 60.28346,
lon: 24.74589
},
{
id: "U3RvcDpIU0w6MjcxNTIzOA==",
lat: 60.27823,
lon: 24.75086
},
{
id: "U3RvcDpIU0w6MjcxNTIzNg==",
lat: 60.27871,
lon: 24.75894
},
{
id: "U3RvcDpIU0w6MjcxNTIzNA==",
lat: 60.2784,
lon: 24.76146
},
{
id: "U3RvcDpIU0w6MjcxNTIzMQ==",
lat: 60.2743,
lon: 24.76071
},
{
id: "U3RvcDpIU0w6MjcxNTIzMA==",
lat: 60.26954,
lon: 24.75945
},
{
id: "U3RvcDpIU0w6NDEyMDIxNw==",
lat: 60.27395,
lon: 24.78154
},
{
id: "U3RvcDpIU0w6NDEyMDIzNg==",
lat: 60.272876,
lon: 24.790986
},
{
id: "U3RvcDpIU0w6NDEyMDI4OQ==",
lat: 60.2705,
lon: 24.79726
},
{
id: "U3RvcDpIU0w6NDEyMDI5NQ==",
lat: 60.2708,
lon: 24.80224
},
{
id: "U3RvcDpIU0w6NDE0MDI0NQ==",
lat: 60.27149,
lon: 24.80801
},
{
id: "U3RvcDpIU0w6NDE0MDIxNg==",
lat: 60.27357,
lon: 24.81095
},
{
id: "U3RvcDpIU0w6NDE0MDI0Mw==",
lat: 60.27524,
lon: 24.816228
},
{
id: "U3RvcDpIU0w6NDE0MDIyMA==",
lat: 60.27788,
lon: 24.82187
},
{
id: "U3RvcDpIU0w6NDE0MDI1NQ==",
lat: 60.28066,
lon: 24.82694
},
{
id: "U3RvcDpIU0w6NDE3MDIxNA==",
lat: 60.28201,
lon: 24.83669
},
{
id: "U3RvcDpIU0w6NDE3MDIzNw==",
lat: 60.28335,
lon: 24.84259
},
{
id: "U3RvcDpIU0w6NDE3MDIzOA==",
lat: 60.28469,
lon: 24.84987
},
{
id: "U3RvcDpIU0w6NDE3MDIyMA==",
lat: 60.28226,
lon: 24.85237
},
{
id: "U3RvcDpIU0w6NDE3MDIyMg==",
lat: 60.279742,
lon: 24.854647
},
{
id: "U3RvcDpIU0w6NDE3MDIxNQ==",
lat: 60.2772,
lon: 24.85298
},
{
id: "U3RvcDpIU0w6NDE3MDI5OQ==",
lat: 60.2753,
lon: 24.8562
},
{
id: "U3RvcDpIU0w6NDE1MDIxOA==",
lat: 60.2703,
lon: 24.85623
},
{
id: "U3RvcDpIU0w6NDE1MDIzMQ==",
lat: 60.26866,
lon: 24.85922
},
{
id: "U3RvcDpIU0w6NDE2MDIyNw==",
lat: 60.26541,
lon: 24.86472
},
{
id: "U3RvcDpIU0w6NDE2MDIxMg==",
lat: 60.263299,
lon: 24.869046
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTAyMDEyOA==",
lat: 60.171203,
lon: 24.93958
}
]
},
{
gtfsId: "HSL:9642K",
shortName: "642K",
longName: "Leinelä-Ruotsinkylä-Lahela-Hyrylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDcwMDIyNQ==",
lat: 60.32362,
lon: 25.03701
},
{
id: "U3RvcDpIU0w6NDcxMDIzMQ==",
lat: 60.32451,
lon: 25.02443
},
{
id: "U3RvcDpIU0w6NDcxMDIwNw==",
lat: 60.32345,
lon: 25.01674
},
{
id: "U3RvcDpIU0w6NDY3MDIxOQ==",
lat: 60.32314,
lon: 25.01208
},
{
id: "U3RvcDpIU0w6NDY3MDIxNw==",
lat: 60.3234,
lon: 25.00589
},
{
id: "U3RvcDpIU0w6NDcxMDIwNQ==",
lat: 60.32397,
lon: 25.00108
},
{
id: "U3RvcDpIU0w6NDcxMDIwMw==",
lat: 60.33233,
lon: 25.00378
},
{
id: "U3RvcDpIU0w6OTY3MDUwNg==",
lat: 60.336877,
lon: 25.004063
},
{
id: "U3RvcDpIU0w6OTY3MDUxNQ==",
lat: 60.340337,
lon: 25.003756
},
{
id: "U3RvcDpIU0w6OTY3MDUxMw==",
lat: 60.343194,
lon: 25.003081
},
{
id: "U3RvcDpIU0w6OTY3MDUyNA==",
lat: 60.347829,
lon: 25.004667
},
{
id: "U3RvcDpIU0w6OTY3MDUyNg==",
lat: 60.354703,
lon: 25.009253
},
{
id: "U3RvcDpIU0w6OTY3MDUwNA==",
lat: 60.365182,
lon: 25.00855
},
{
id: "U3RvcDpIU0w6OTY3MDUwMw==",
lat: 60.368584,
lon: 25.011852
},
{
id: "U3RvcDpIU0w6OTY1MTMxNw==",
lat: 60.374858,
lon: 25.017726
},
{
id: "U3RvcDpIU0w6OTY1MTMwMQ==",
lat: 60.377366,
lon: 25.013702
},
{
id: "U3RvcDpIU0w6OTY1MTMwOQ==",
lat: 60.378562,
lon: 25.012256
},
{
id: "U3RvcDpIU0w6OTY1MTQwNQ==",
lat: 60.381872,
lon: 25.01535
},
{
id: "U3RvcDpIU0w6OTY1MTQwMQ==",
lat: 60.383909,
lon: 25.010676
},
{
id: "U3RvcDpIU0w6OTY1MTMwMg==",
lat: 60.377097,
lon: 24.993542
},
{
id: "U3RvcDpIU0w6OTY3MDIwMg==",
lat: 60.373366,
lon: 24.986651
},
{
id: "U3RvcDpIU0w6OTY3MDIwMQ==",
lat: 60.367431,
lon: 24.979066
},
{
id: "U3RvcDpIU0w6OTY3MDIwOQ==",
lat: 60.370096,
lon: 24.972334
},
{
id: "U3RvcDpIU0w6OTY1MTEwMQ==",
lat: 60.376759,
lon: 24.974271
},
{
id: "U3RvcDpIU0w6OTY1MTIwNA==",
lat: 60.381782,
lon: 24.979181
},
{
id: "U3RvcDpIU0w6OTY1MTIwMg==",
lat: 60.386147,
lon: 24.985578
},
{
id: "U3RvcDpIU0w6OTY1MTIwNg==",
lat: 60.389323,
lon: 24.988481
},
{
id: "U3RvcDpIU0w6OTY1MTAwOQ==",
lat: 60.394039,
lon: 24.986352
},
{
id: "U3RvcDpIU0w6OTY1MTAwNA==",
lat: 60.399132,
lon: 24.982543
},
{
id: "U3RvcDpIU0w6OTY1MTAxMg==",
lat: 60.402549,
lon: 24.989306
},
{
id: "U3RvcDpIU0w6OTY1MTAxMA==",
lat: 60.403621,
lon: 24.993351
},
{
id: "U3RvcDpIU0w6OTY1MTAyNg==",
lat: 60.405089,
lon: 24.999478
},
{
id: "U3RvcDpIU0w6OTY1MTAwMQ==",
lat: 60.405361,
lon: 25.002492
},
{
id: "U3RvcDpIU0w6OTY1MDkwMA==",
lat: 60.406062,
lon: 25.009508
},
{
id: "U3RvcDpIU0w6OTY1MDkwMg==",
lat: 60.405499,
lon: 25.012577
},
{
id: "U3RvcDpIU0w6OTY1MDMwMw==",
lat: 60.4033,
lon: 25.02419
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
},
{
id: "U3RvcDpIU0w6OTY1MDEyMw==",
lat: 60.401866,
lon: 25.028215
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MDkwMQ==",
lat: 60.406126,
lon: 25.009112
},
{
id: "U3RvcDpIU0w6OTY1MTAwMA==",
lat: 60.405733,
lon: 25.004427
},
{
id: "U3RvcDpIU0w6OTY1MTAyNQ==",
lat: 60.405001,
lon: 24.998075
},
{
id: "U3RvcDpIU0w6OTY1MTAxMQ==",
lat: 60.403581,
lon: 24.992938
},
{
id: "U3RvcDpIU0w6OTY1MTAxMw==",
lat: 60.401747,
lon: 24.986525
},
{
id: "U3RvcDpIU0w6OTY1MTAwNQ==",
lat: 60.398272,
lon: 24.981927
},
{
id: "U3RvcDpIU0w6OTY1MTAwOA==",
lat: 60.394614,
lon: 24.985621
},
{
id: "U3RvcDpIU0w6OTY1MTIwNw==",
lat: 60.388511,
lon: 24.988179
},
{
id: "U3RvcDpIU0w6OTY1MTIwMQ==",
lat: 60.386628,
lon: 24.98607
},
{
id: "U3RvcDpIU0w6OTY1MTIwNQ==",
lat: 60.381389,
lon: 24.978371
},
{
id: "U3RvcDpIU0w6OTY1MTEwMg==",
lat: 60.374658,
lon: 24.972308
},
{
id: "U3RvcDpIU0w6OTY3MDIxMA==",
lat: 60.369358,
lon: 24.97256
},
{
id: "U3RvcDpIU0w6OTY3MDIwMA==",
lat: 60.367606,
lon: 24.979371
},
{
id: "U3RvcDpIU0w6OTY1MTMwNQ==",
lat: 60.374048,
lon: 24.987541
},
{
id: "U3RvcDpIU0w6OTY1MTMwMw==",
lat: 60.377475,
lon: 24.995715
},
{
id: "U3RvcDpIU0w6OTY1MTQwMA==",
lat: 60.383973,
lon: 25.010521
},
{
id: "U3RvcDpIU0w6OTY1MTQwNA==",
lat: 60.382054,
lon: 25.014925
},
{
id: "U3RvcDpIU0w6OTY1MTMwOA==",
lat: 60.378836,
lon: 25.012496
},
{
id: "U3RvcDpIU0w6OTY1MTMwMA==",
lat: 60.377481,
lon: 25.013463
},
{
id: "U3RvcDpIU0w6OTY1MTMxNg==",
lat: 60.374891,
lon: 25.017616
},
{
id: "U3RvcDpIU0w6OTY1MTMxMg==",
lat: 60.374001,
lon: 25.018583
},
{
id: "U3RvcDpIU0w6OTY3MDUwMg==",
lat: 60.368227,
lon: 25.010802
},
{
id: "U3RvcDpIU0w6OTY3MDUwNQ==",
lat: 60.364502,
lon: 25.009361
},
{
id: "U3RvcDpIU0w6OTY3MDUyNw==",
lat: 60.353749,
lon: 25.008657
},
{
id: "U3RvcDpIU0w6OTY3MDUyNQ==",
lat: 60.34703,
lon: 25.003354
},
{
id: "U3RvcDpIU0w6OTY3MDUxNA==",
lat: 60.342295,
lon: 25.003129
},
{
id: "U3RvcDpIU0w6OTY3MDUxOA==",
lat: 60.339312,
lon: 25.003986
},
{
id: "U3RvcDpIU0w6OTY3MDUwNw==",
lat: 60.33588,
lon: 25.003993
},
{
id: "U3RvcDpIU0w6NDcxMDIwMg==",
lat: 60.33129,
lon: 25.00324
},
{
id: "U3RvcDpIU0w6NDY3MDIxOA==",
lat: 60.32319,
lon: 25.00773
},
{
id: "U3RvcDpIU0w6NDY3MDIxNA==",
lat: 60.32302,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDcxMDIwNg==",
lat: 60.32362,
lon: 25.01831
},
{
id: "U3RvcDpIU0w6NDcwMDIyNw==",
lat: 60.32441,
lon: 25.02678
},
{
id: "U3RvcDpIU0w6NDcwMDIyNg==",
lat: 60.32334,
lon: 25.03762
}
]
},
{
gtfsId: "HSL:9993K",
shortName: "993K",
longName: "Söderkulla-Box-Gesterby-Nikkilä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIwODIxMw==",
lat: 60.301052,
lon: 25.327132
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODI1NQ==",
lat: 60.298851,
lon: 25.337327
},
{
id: "U3RvcDpIU0w6OTIwODI1Nw==",
lat: 60.298,
lon: 25.339552
},
{
id: "U3RvcDpIU0w6OTIwODI1MA==",
lat: 60.296725,
lon: 25.350455
},
{
id: "U3RvcDpIU0w6OTIwODIzMA==",
lat: 60.29683,
lon: 25.35423
},
{
id: "U3RvcDpIU0w6OTIwODIzMg==",
lat: 60.29856,
lon: 25.358295
},
{
id: "U3RvcDpIU0w6OTIxMzIwNA==",
lat: 60.30139,
lon: 25.364787
},
{
id: "U3RvcDpIU0w6OTIxMzIwNg==",
lat: 60.304287,
lon: 25.371417
},
{
id: "U3RvcDpIU0w6OTIxMzIxMg==",
lat: 60.307833,
lon: 25.379585
},
{
id: "U3RvcDpIU0w6OTIxMzIzMg==",
lat: 60.311137,
lon: 25.38733
},
{
id: "U3RvcDpIU0w6OTIxMzIxNg==",
lat: 60.30948,
lon: 25.392305
},
{
id: "U3RvcDpIU0w6OTIxMzIxOQ==",
lat: 60.30575,
lon: 25.393793
},
{
id: "U3RvcDpIU0w6OTIxMzIxOA==",
lat: 60.30665,
lon: 25.393678
},
{
id: "U3RvcDpIU0w6OTIxMzIxNw==",
lat: 60.309948,
lon: 25.392422
},
{
id: "U3RvcDpIU0w6OTIxMzIxNA==",
lat: 60.312295,
lon: 25.38889
},
{
id: "U3RvcDpIU0w6OTIxMzIwOQ==",
lat: 60.320625,
lon: 25.378695
},
{
id: "U3RvcDpIU0w6OTIxMzIwNQ==",
lat: 60.323652,
lon: 25.372752
},
{
id: "U3RvcDpIU0w6OTIxMzIwMg==",
lat: 60.325059,
lon: 25.364011
},
{
id: "U3RvcDpIU0w6OTIyMDIyOA==",
lat: 60.32928,
lon: 25.356063
},
{
id: "U3RvcDpIU0w6OTIyMDIyNQ==",
lat: 60.333433,
lon: 25.345335
},
{
id: "U3RvcDpIU0w6OTIyMDIzMw==",
lat: 60.336445,
lon: 25.322073
},
{
id: "U3RvcDpIU0w6OTIyMDIzMQ==",
lat: 60.338087,
lon: 25.314405
},
{
id: "U3RvcDpIU0w6OTIyMDIyOQ==",
lat: 60.339222,
lon: 25.305938
},
{
id: "U3RvcDpIU0w6OTIyMDIyNA==",
lat: 60.343604,
lon: 25.298369
},
{
id: "U3RvcDpIU0w6OTIyMDIyMA==",
lat: 60.334865,
lon: 25.280292
},
{
id: "U3RvcDpIU0w6OTIyMDIxMQ==",
lat: 60.333691,
lon: 25.265295
},
{
id: "U3RvcDpIU0w6OTIyMDIwNQ==",
lat: 60.340675,
lon: 25.263232
},
{
id: "U3RvcDpIU0w6OTIyMDIwNg==",
lat: 60.347598,
lon: 25.263275
},
{
id: "U3RvcDpIU0w6OTIyMDIxNA==",
lat: 60.353453,
lon: 25.26834
},
{
id: "U3RvcDpIU0w6OTIxNjIxOQ==",
lat: 60.356245,
lon: 25.266868
},
{
id: "U3RvcDpIU0w6OTIxNjIxNA==",
lat: 60.363368,
lon: 25.261563
},
{
id: "U3RvcDpIU0w6OTIyMjI0MA==",
lat: 60.369115,
lon: 25.258614
},
{
id: "U3RvcDpIU0w6OTIyMjIyMg==",
lat: 60.370252,
lon: 25.258915
},
{
id: "U3RvcDpIU0w6OTIyMjIyNQ==",
lat: 60.371527,
lon: 25.262477
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjI0Nw==",
lat: 60.374422,
lon: 25.253161
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjIyOQ==",
lat: 60.375727,
lon: 25.267724
},
{
id: "U3RvcDpIU0w6OTIyMjIyNg==",
lat: 60.371818,
lon: 25.262633
},
{
id: "U3RvcDpIU0w6OTIyMjIyMQ==",
lat: 60.37037,
lon: 25.258497
},
{
id: "U3RvcDpIU0w6OTIxNjIxMw==",
lat: 60.363567,
lon: 25.26105
},
{
id: "U3RvcDpIU0w6OTIyMDIxMg==",
lat: 60.354502,
lon: 25.267033
},
{
id: "U3RvcDpIU0w6OTIyMDIxNQ==",
lat: 60.351588,
lon: 25.267842
},
{
id: "U3RvcDpIU0w6OTIyMDIwNA==",
lat: 60.346382,
lon: 25.262063
},
{
id: "U3RvcDpIU0w6OTIyMDIwMw==",
lat: 60.339652,
lon: 25.262577
},
{
id: "U3RvcDpIU0w6OTIyMDIxOQ==",
lat: 60.334703,
lon: 25.278488
},
{
id: "U3RvcDpIU0w6OTIyMDIzMA==",
lat: 60.338982,
lon: 25.30602
},
{
id: "U3RvcDpIU0w6OTIyMDIzMg==",
lat: 60.337962,
lon: 25.314433
},
{
id: "U3RvcDpIU0w6OTIyMDIzNA==",
lat: 60.33629,
lon: 25.322145
},
{
id: "U3RvcDpIU0w6OTIyMDIyNg==",
lat: 60.333225,
lon: 25.345593
},
{
id: "U3RvcDpIU0w6OTIyMDIyNw==",
lat: 60.329183,
lon: 25.355528
},
{
id: "U3RvcDpIU0w6OTIxMzIwMQ==",
lat: 60.324762,
lon: 25.364348
},
{
id: "U3RvcDpIU0w6OTIxMzIwOA==",
lat: 60.323312,
lon: 25.373127
},
{
id: "U3RvcDpIU0w6OTIxMzIxMQ==",
lat: 60.320253,
lon: 25.379077
},
{
id: "U3RvcDpIU0w6OTIxMzIxMw==",
lat: 60.311393,
lon: 25.38738
},
{
id: "U3RvcDpIU0w6OTIxMzIxMA==",
lat: 60.307273,
lon: 25.377832
},
{
id: "U3RvcDpIU0w6OTIxMzIwNw==",
lat: 60.304748,
lon: 25.372035
},
{
id: "U3RvcDpIU0w6OTIxMzIwMw==",
lat: 60.301112,
lon: 25.36366
},
{
id: "U3RvcDpIU0w6OTIwODIzMw==",
lat: 60.299153,
lon: 25.359143
},
{
id: "U3RvcDpIU0w6OTIwODIzMQ==",
lat: 60.297247,
lon: 25.354823
},
{
id: "U3RvcDpIU0w6OTIwODI1MQ==",
lat: 60.297067,
lon: 25.347959
},
{
id: "U3RvcDpIU0w6OTIwODI1Ng==",
lat: 60.298387,
lon: 25.337094
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
}
]
},
{
gtfsId: "HSL:2108N",
shortName: "108N",
longName: "Kamppi-Teekkarikylä-Tapiola(M)-Westendinasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjIzMTIyNQ==",
lat: 60.1688,
lon: 24.804352
},
{
id: "U3RvcDpIU0w6MjIxMTIzNw==",
lat: 60.17083,
lon: 24.81079
},
{
id: "U3RvcDpIU0w6MjIxMTI3NQ==",
lat: 60.17197,
lon: 24.80231
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMzIxMA==",
lat: 60.17798,
lon: 24.81266
},
{
id: "U3RvcDpIU0w6MjIxMzIwOQ==",
lat: 60.17862,
lon: 24.81721
},
{
id: "U3RvcDpIU0w6MjIxMzIwNw==",
lat: 60.17895,
lon: 24.8207
},
{
id: "U3RvcDpIU0w6MjIyMjIxNA==",
lat: 60.1807,
lon: 24.82479
},
{
id: "U3RvcDpIU0w6MjIyMjIyNA==",
lat: 60.18517,
lon: 24.82042
},
{
id: "U3RvcDpIU0w6MjIyMjIwNg==",
lat: 60.18701,
lon: 24.82762
},
{
id: "U3RvcDpIU0w6MjIyMjIwNw==",
lat: 60.18909,
lon: 24.82975
},
{
id: "U3RvcDpIU0w6MjIyMjIwOA==",
lat: 60.18862,
lon: 24.83449
},
{
id: "U3RvcDpIU0w6MjIyMjIxMA==",
lat: 60.187376,
lon: 24.833901
},
{
id: "U3RvcDpIU0w6MjIyMjIwNA==",
lat: 60.18274,
lon: 24.83212
},
{
id: "U3RvcDpIU0w6MjIyMjIwMg==",
lat: 60.1798,
lon: 24.83641
},
{
id: "U3RvcDpIU0w6MTMwMzExNA==",
lat: 60.18153,
lon: 24.849633
},
{
id: "U3RvcDpIU0w6MTMwMjIxOQ==",
lat: 60.18488,
lon: 24.85935
},
{
id: "U3RvcDpIU0w6MTMwMjIxNw==",
lat: 60.18716,
lon: 24.86985
},
{
id: "U3RvcDpIU0w6MTMwMTIxNQ==",
lat: 60.192436,
lon: 24.880264
},
{
id: "U3RvcDpIU0w6MTMwMTEyMg==",
lat: 60.196005,
lon: 24.886202
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
},
{
id: "U3RvcDpIU0w6MTE1MDEwOA==",
lat: 60.188734,
lon: 24.912259
},
{
id: "U3RvcDpIU0w6MTE0MDEwNQ==",
lat: 60.18479,
lon: 24.91689
},
{
id: "U3RvcDpIU0w6MTE0MDEwMw==",
lat: 60.17966,
lon: 24.92227
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDI4NA==",
lat: 60.1688,
lon: 24.93093
},
{
id: "U3RvcDpIU0w6MTA0MDI3MQ==",
lat: 60.169119,
lon: 24.932058
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEwMg==",
lat: 60.180739,
lon: 24.921434
},
{
id: "U3RvcDpIU0w6MTE0MDEzMw==",
lat: 60.18581,
lon: 24.91596
},
{
id: "U3RvcDpIU0w6MTE1MDEwNw==",
lat: 60.189912,
lon: 24.909831
},
{
id: "U3RvcDpIU0w6MTE1MDEwOQ==",
lat: 60.19067,
lon: 24.90781
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTIxMg==",
lat: 60.19575,
lon: 24.8846
},
{
id: "U3RvcDpIU0w6MTMwMTIxNA==",
lat: 60.19223,
lon: 24.87814
},
{
id: "U3RvcDpIU0w6MTMwMjIxNg==",
lat: 60.18696,
lon: 24.8681
},
{
id: "U3RvcDpIU0w6MTMwMjIxOA==",
lat: 60.184553,
lon: 24.857309
},
{
id: "U3RvcDpIU0w6MTMwMzI5OA==",
lat: 60.1816,
lon: 24.8493
},
{
id: "U3RvcDpIU0w6MjIyMjIwMQ==",
lat: 60.18023,
lon: 24.8376
},
{
id: "U3RvcDpIU0w6MjIyMjIwMw==",
lat: 60.18197,
lon: 24.83372
},
{
id: "U3RvcDpIU0w6MjIyMjIwOQ==",
lat: 60.18833,
lon: 24.83492
},
{
id: "U3RvcDpIU0w6MjIyMjIyNw==",
lat: 60.18963,
lon: 24.82959
},
{
id: "U3RvcDpIU0w6MjIyMjIxMw==",
lat: 60.187099,
lon: 24.827559
},
{
id: "U3RvcDpIU0w6MjIyMjIyMw==",
lat: 60.184969,
lon: 24.819846
},
{
id: "U3RvcDpIU0w6MjIxMzIwNg==",
lat: 60.17908,
lon: 24.82074
},
{
id: "U3RvcDpIU0w6MjIxMzIwOA==",
lat: 60.17872,
lon: 24.81654
},
{
id: "U3RvcDpIU0w6MjIxMTIxMQ==",
lat: 60.17718,
lon: 24.81083
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMTI3NA==",
lat: 60.17223,
lon: 24.80195
},
{
id: "U3RvcDpIU0w6MjIxMTIzOA==",
lat: 60.17046,
lon: 24.81056
},
{
id: "U3RvcDpIU0w6MjIzMTIxMw==",
lat: 60.16881,
lon: 24.80491
}
]
},
{
gtfsId: "HSL:9787K",
shortName: "787K",
longName: "Rautatientori-Kuninkaanmäki-Nikkilä-Pornainen",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIyNQ==",
lat: 60.27255,
lon: 25.09256
},
{
id: "U3RvcDpIU0w6NDkzMDIzMA==",
lat: 60.27502,
lon: 25.09521
},
{
id: "U3RvcDpIU0w6NDk0MDIyMg==",
lat: 60.28128,
lon: 25.102
},
{
id: "U3RvcDpIU0w6NDk2MDIxNA==",
lat: 60.2883,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6NDk2MDI5OA==",
lat: 60.293118,
lon: 25.099951
},
{
id: "U3RvcDpIU0w6NDk2MDIxNg==",
lat: 60.2979,
lon: 25.10244
},
{
id: "U3RvcDpIU0w6NDk3MDI5Nw==",
lat: 60.30293,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6NDk3MDI0NQ==",
lat: 60.304945,
lon: 25.106319
},
{
id: "U3RvcDpIU0w6NDk3MDI5OQ==",
lat: 60.30677,
lon: 25.109677
},
{
id: "U3RvcDpIU0w6NDk3MDIzNw==",
lat: 60.307303,
lon: 25.116067
},
{
id: "U3RvcDpIU0w6NDk3MDIxMQ==",
lat: 60.30996,
lon: 25.12301
},
{
id: "U3RvcDpIU0w6NDk3MDIxMw==",
lat: 60.31868,
lon: 25.12728
},
{
id: "U3RvcDpIU0w6OTIxNDIwOQ==",
lat: 60.324263,
lon: 25.137407
},
{
id: "U3RvcDpIU0w6OTIxNDIwNQ==",
lat: 60.329622,
lon: 25.13404
},
{
id: "U3RvcDpIU0w6NDg2MDIwMQ==",
lat: 60.336937,
lon: 25.131358
},
{
id: "U3RvcDpIU0w6NDg2MDIzNA==",
lat: 60.33946,
lon: 25.13387
},
{
id: "U3RvcDpIU0w6NDg2MDIzMg==",
lat: 60.34099,
lon: 25.14079
},
{
id: "U3RvcDpIU0w6NDg2MDIzMA==",
lat: 60.34199,
lon: 25.14701
},
{
id: "U3RvcDpIU0w6OTIxNDIyNg==",
lat: 60.342592,
lon: 25.152172
},
{
id: "U3RvcDpIU0w6OTIxNDIxNw==",
lat: 60.347115,
lon: 25.152818
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwOA==",
lat: 60.386435,
lon: 25.282542
},
{
id: "U3RvcDpIU0w6OTIyOTIwMw==",
lat: 60.390658,
lon: 25.291292
},
{
id: "U3RvcDpIU0w6OTIyOTIwNg==",
lat: 60.393408,
lon: 25.296543
},
{
id: "U3RvcDpIU0w6OTIyOTIwOA==",
lat: 60.396172,
lon: 25.298523
},
{
id: "U3RvcDpIU0w6OTIyNTIwMw==",
lat: 60.402635,
lon: 25.299295
},
{
id: "U3RvcDpIU0w6OTIyNTIwNQ==",
lat: 60.406127,
lon: 25.30665
},
{
id: "U3RvcDpIU0w6OTIyNTIwNg==",
lat: 60.40681,
lon: 25.315015
},
{
id: "U3RvcDpIU0w6OTIyNTIwOA==",
lat: 60.40889,
lon: 25.318735
},
{
id: "U3RvcDpIU0w6OTIyNTIwOQ==",
lat: 60.410377,
lon: 25.321968
},
{
id: "U3RvcDpIU0w6OTIyNTIxMg==",
lat: 60.41308,
lon: 25.328807
},
{
id: "U3RvcDpIU0w6OTIyNTIxNA==",
lat: 60.416008,
lon: 25.330725
},
{
id: "U3RvcDpIU0w6OTIyNTIxNQ==",
lat: 60.418978,
lon: 25.332633
},
{
id: "U3RvcDpIU0w6OTIyNTIxOA==",
lat: 60.425025,
lon: 25.338565
},
{
id: "U3RvcDpIU0w6OTQwMDIxMQ==",
lat: 60.435523,
lon: 25.368753
},
{
id: "U3RvcDpIU0w6OTQwMDIwOA==",
lat: 60.477653,
lon: 25.374435
},
{
id: "U3RvcDpIU0w6OTQwMDIwMQ==",
lat: 60.484347,
lon: 25.368078
},
{
id: "U3RvcDpIU0w6NDk3MDIxNw==",
lat: 60.30573,
lon: 25.10498
},
{
id: "U3RvcDpIU0w6NDk3MDIxOQ==",
lat: 60.31407,
lon: 25.10985
},
{
id: "U3RvcDpIU0w6NDk3MDIyMQ==",
lat: 60.31937,
lon: 25.11534
},
{
id: "U3RvcDpIU0w6NDk3MDIxNQ==",
lat: 60.32003,
lon: 25.12451
},
{
id: "U3RvcDpIU0w6OTQwMDIxNA==",
lat: 60.508422,
lon: 25.227405
},
{
id: "U3RvcDpIU0w6OTQwMDIxMg==",
lat: 60.528221,
lon: 25.303242
},
{
id: "U3RvcDpIU0w6OTQwMDIwMg==",
lat: 60.483505,
lon: 25.368993
},
{
id: "U3RvcDpIU0w6OTQwMDIwOQ==",
lat: 60.47742,
lon: 25.374157
},
{
id: "U3RvcDpIU0w6OTQwMDIwNQ==",
lat: 60.432417,
lon: 25.399457
},
{
id: "U3RvcDpIU0w6OTQwMDIxMA==",
lat: 60.434959,
lon: 25.367006
},
{
id: "U3RvcDpIU0w6OTIyNTIxNw==",
lat: 60.42515,
lon: 25.338463
},
{
id: "U3RvcDpIU0w6OTIyNTIxNg==",
lat: 60.41998,
lon: 25.332845
},
{
id: "U3RvcDpIU0w6OTIyNTIxMw==",
lat: 60.41603,
lon: 25.33023
},
{
id: "U3RvcDpIU0w6OTIyNTIxMQ==",
lat: 60.412957,
lon: 25.328448
},
{
id: "U3RvcDpIU0w6OTIyNTIxMA==",
lat: 60.410613,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyNTIwMQ==",
lat: 60.408782,
lon: 25.318287
},
{
id: "U3RvcDpIU0w6OTIyNTIwNw==",
lat: 60.406928,
lon: 25.314803
},
{
id: "U3RvcDpIU0w6OTIyNTIwNA==",
lat: 60.405853,
lon: 25.305318
},
{
id: "U3RvcDpIU0w6OTIyNTIwMg==",
lat: 60.401832,
lon: 25.298322
},
{
id: "U3RvcDpIU0w6OTIyOTIwNw==",
lat: 60.395527,
lon: 25.298033
},
{
id: "U3RvcDpIU0w6OTIyOTIwNQ==",
lat: 60.392832,
lon: 25.295147
},
{
id: "U3RvcDpIU0w6OTIyOTIwNA==",
lat: 60.390917,
lon: 25.291257
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxNjIxMQ==",
lat: 60.368428,
lon: 25.230412
},
{
id: "U3RvcDpIU0w6OTIxNjIwOQ==",
lat: 60.365565,
lon: 25.224187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNw==",
lat: 60.361667,
lon: 25.213187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNQ==",
lat: 60.361128,
lon: 25.205277
},
{
id: "U3RvcDpIU0w6OTIxNjIwMg==",
lat: 60.36037,
lon: 25.193757
},
{
id: "U3RvcDpIU0w6OTIxNDIyNA==",
lat: 60.359773,
lon: 25.180833
},
{
id: "U3RvcDpIU0w6OTIxNDIyMg==",
lat: 60.358407,
lon: 25.176255
},
{
id: "U3RvcDpIU0w6OTIxNDIyMA==",
lat: 60.357083,
lon: 25.167383
},
{
id: "U3RvcDpIU0w6OTIxNDIyNw==",
lat: 60.354067,
lon: 25.158408
},
{
id: "U3RvcDpIU0w6OTIxNDIxNg==",
lat: 60.34661,
lon: 25.152565
},
{
id: "U3RvcDpIU0w6OTIxNDIyNQ==",
lat: 60.342921,
lon: 25.152253
},
{
id: "U3RvcDpIU0w6NDg2MDIyOQ==",
lat: 60.342058,
lon: 25.146987
},
{
id: "U3RvcDpIU0w6NDg2MDIzMQ==",
lat: 60.34105,
lon: 25.14113
},
{
id: "U3RvcDpIU0w6NDg2MDIwNw==",
lat: 60.34049,
lon: 25.13834
},
{
id: "U3RvcDpIU0w6NDg2MDIzMw==",
lat: 60.33938,
lon: 25.13317
},
{
id: "U3RvcDpIU0w6NDg2MDIwMg==",
lat: 60.33761,
lon: 25.13086
},
{
id: "U3RvcDpIU0w6OTIxNDIwNg==",
lat: 60.329127,
lon: 25.133099
},
{
id: "U3RvcDpIU0w6OTIxNDIwOA==",
lat: 60.32346,
lon: 25.13657
},
{
id: "U3RvcDpIU0w6NDk3MDIxNg==",
lat: 60.31884,
lon: 25.12654
},
{
id: "U3RvcDpIU0w6NDk3MDIyMg==",
lat: 60.31916,
lon: 25.11493
},
{
id: "U3RvcDpIU0w6NDk3MDIyMA==",
lat: 60.31307,
lon: 25.10852
},
{
id: "U3RvcDpIU0w6NDk3MDIxOA==",
lat: 60.304039,
lon: 25.104318
},
{
id: "U3RvcDpIU0w6NDk3MDI5Ng==",
lat: 60.30183,
lon: 25.10375
},
{
id: "U3RvcDpIU0w6NDk2MDIxNw==",
lat: 60.29775,
lon: 25.10205
},
{
id: "U3RvcDpIU0w6NDk2MDI5OQ==",
lat: 60.292049,
lon: 25.099393
},
{
id: "U3RvcDpIU0w6NDk2MDIxNQ==",
lat: 60.28741,
lon: 25.10189
},
{
id: "U3RvcDpIU0w6NDk0MDIyMw==",
lat: 60.2806,
lon: 25.10108
},
{
id: "U3RvcDpIU0w6NDkzMDIyNg==",
lat: 60.27535,
lon: 25.09522
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwMA==",
lat: 60.173091,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6NDk3MDIxNA==",
lat: 60.31839,
lon: 25.12634
},
{
id: "U3RvcDpIU0w6NDk3MDIxMg==",
lat: 60.3094,
lon: 25.1222
},
{
id: "U3RvcDpIU0w6NDk3MDIxMA==",
lat: 60.307773,
lon: 25.114235
},
{
id: "U3RvcDpIU0w6NDk3MDI5OA==",
lat: 60.307177,
lon: 25.109792
}
]
},
{
gtfsId: "HSL:7465B",
shortName: "465B",
longName: "Kamppi-Keimola-Syväoja",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxOA==",
lat: 60.356043,
lon: 24.807018
},
{
id: "U3RvcDpIU0w6NDMxMDIxMA==",
lat: 60.360961,
lon: 24.807177
},
{
id: "U3RvcDpIU0w6NDMxMDIxMg==",
lat: 60.374543,
lon: 24.805901
},
{
id: "U3RvcDpIU0w6NDMxMDIxMQ==",
lat: 60.373678,
lon: 24.80553
},
{
id: "U3RvcDpIU0w6NDMxMDIwOQ==",
lat: 60.360498,
lon: 24.807107
},
{
id: "U3RvcDpIU0w6NDMxMDIxMw==",
lat: 60.354738,
lon: 24.805117
},
{
id: "U3RvcDpIU0w6NDIyMDIwMg==",
lat: 60.313429,
lon: 24.840766
},
{
id: "U3RvcDpIU0w6NDE4MDIyMQ==",
lat: 60.288826,
lon: 24.861242
},
{
id: "U3RvcDpIU0w6NDE4MDIxOQ==",
lat: 60.28404,
lon: 24.86467
},
{
id: "U3RvcDpIU0w6NDE4MDIxNw==",
lat: 60.2782,
lon: 24.86844
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
}
]
},
{
gtfsId: "HSL:9787A",
shortName: "787A",
longName: "Rautatientori-Jokivarsi-Nikkilä-Pornainen-Halkia",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTQwMDIwNA==",
lat: 60.528868,
lon: 25.302017
},
{
id: "U3RvcDpIU0w6OTQwMDIxMg==",
lat: 60.528221,
lon: 25.303242
},
{
id: "U3RvcDpIU0w6OTQwMDIwMg==",
lat: 60.483505,
lon: 25.368993
},
{
id: "U3RvcDpIU0w6OTQwMDIwOQ==",
lat: 60.47742,
lon: 25.374157
},
{
id: "U3RvcDpIU0w6OTQwMDIwNQ==",
lat: 60.432417,
lon: 25.399457
},
{
id: "U3RvcDpIU0w6OTQwMDIxMA==",
lat: 60.434959,
lon: 25.367006
},
{
id: "U3RvcDpIU0w6OTIyNTIxNw==",
lat: 60.42515,
lon: 25.338463
},
{
id: "U3RvcDpIU0w6OTIyNTIxNg==",
lat: 60.41998,
lon: 25.332845
},
{
id: "U3RvcDpIU0w6OTIyNTIxMw==",
lat: 60.41603,
lon: 25.33023
},
{
id: "U3RvcDpIU0w6OTIyNTIxMQ==",
lat: 60.412957,
lon: 25.328448
},
{
id: "U3RvcDpIU0w6OTIyNTIxMA==",
lat: 60.410613,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyNTIwMQ==",
lat: 60.408782,
lon: 25.318287
},
{
id: "U3RvcDpIU0w6OTIyNTIwNw==",
lat: 60.406928,
lon: 25.314803
},
{
id: "U3RvcDpIU0w6OTIyNTIwNA==",
lat: 60.405853,
lon: 25.305318
},
{
id: "U3RvcDpIU0w6OTIyNTIwMg==",
lat: 60.401832,
lon: 25.298322
},
{
id: "U3RvcDpIU0w6OTIyOTIwNw==",
lat: 60.395527,
lon: 25.298033
},
{
id: "U3RvcDpIU0w6OTIyOTIwNQ==",
lat: 60.392832,
lon: 25.295147
},
{
id: "U3RvcDpIU0w6OTIyOTIwNA==",
lat: 60.390917,
lon: 25.291257
},
{
id: "U3RvcDpIU0w6OTIyNDIwNw==",
lat: 60.385903,
lon: 25.280982
},
{
id: "U3RvcDpIU0w6OTIyNDIwOQ==",
lat: 60.383837,
lon: 25.277388
},
{
id: "U3RvcDpIU0w6OTIyMjI0OA==",
lat: 60.379358,
lon: 25.273966
},
{
id: "U3RvcDpIU0w6OTIyMjIzNw==",
lat: 60.377256,
lon: 25.272366
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxNjIxMQ==",
lat: 60.368428,
lon: 25.230412
},
{
id: "U3RvcDpIU0w6OTIxNjIwOQ==",
lat: 60.365565,
lon: 25.224187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNw==",
lat: 60.361667,
lon: 25.213187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNQ==",
lat: 60.361128,
lon: 25.205277
},
{
id: "U3RvcDpIU0w6OTIxNjIwMg==",
lat: 60.36037,
lon: 25.193757
},
{
id: "U3RvcDpIU0w6OTIxNDIyNA==",
lat: 60.359773,
lon: 25.180833
},
{
id: "U3RvcDpIU0w6OTIxNDIyMg==",
lat: 60.358407,
lon: 25.176255
},
{
id: "U3RvcDpIU0w6OTIxNDIyMA==",
lat: 60.357083,
lon: 25.167383
},
{
id: "U3RvcDpIU0w6OTIxNDIxOA==",
lat: 60.354335,
lon: 25.157322
},
{
id: "U3RvcDpIU0w6OTIxNDIxMg==",
lat: 60.34823,
lon: 25.139113
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMQ==",
lat: 60.34501,
lon: 25.11781
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwMA==",
lat: 60.173091,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6OTIxNDIxMw==",
lat: 60.348392,
lon: 25.141493
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMjIzNg==",
lat: 60.376529,
lon: 25.272652
},
{
id: "U3RvcDpIU0w6OTIyMjI0OQ==",
lat: 60.379329,
lon: 25.2742
},
{
id: "U3RvcDpIU0w6OTIyNDIwNQ==",
lat: 60.3851,
lon: 25.280011
},
{
id: "U3RvcDpIU0w6OTIyNDIwOA==",
lat: 60.386435,
lon: 25.282542
},
{
id: "U3RvcDpIU0w6OTIyOTIwMw==",
lat: 60.390658,
lon: 25.291292
},
{
id: "U3RvcDpIU0w6OTIyOTIwNg==",
lat: 60.393408,
lon: 25.296543
},
{
id: "U3RvcDpIU0w6OTIyOTIwOA==",
lat: 60.396172,
lon: 25.298523
},
{
id: "U3RvcDpIU0w6OTIyNTIwMw==",
lat: 60.402635,
lon: 25.299295
},
{
id: "U3RvcDpIU0w6OTIyNTIwNQ==",
lat: 60.406127,
lon: 25.30665
},
{
id: "U3RvcDpIU0w6OTIyNTIwNg==",
lat: 60.40681,
lon: 25.315015
},
{
id: "U3RvcDpIU0w6OTIyNTIwOA==",
lat: 60.40889,
lon: 25.318735
},
{
id: "U3RvcDpIU0w6OTIyNTIwOQ==",
lat: 60.410377,
lon: 25.321968
},
{
id: "U3RvcDpIU0w6OTIyNTIxMg==",
lat: 60.41308,
lon: 25.328807
},
{
id: "U3RvcDpIU0w6OTIyNTIxNA==",
lat: 60.416008,
lon: 25.330725
},
{
id: "U3RvcDpIU0w6OTIyNTIxNQ==",
lat: 60.418978,
lon: 25.332633
},
{
id: "U3RvcDpIU0w6OTIyNTIxOA==",
lat: 60.425025,
lon: 25.338565
},
{
id: "U3RvcDpIU0w6OTQwMDIxMQ==",
lat: 60.435523,
lon: 25.368753
},
{
id: "U3RvcDpIU0w6OTQwMDIwOA==",
lat: 60.477653,
lon: 25.374435
},
{
id: "U3RvcDpIU0w6OTQwMDIwMw==",
lat: 60.484878,
lon: 25.36799
}
]
},
{
gtfsId: "HSL:1805",
shortName: "805",
longName: "Itäkeskus (M)-Myllypuro",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1NDE5Mg==",
lat: 60.220467,
lon: 25.064765
},
{
id: "U3RvcDpIU0w6MTQ1NDE1MA==",
lat: 60.22192,
lon: 25.05795
},
{
id: "U3RvcDpIU0w6MTQ1NDEwMQ==",
lat: 60.224618,
lon: 25.054735
},
{
id: "U3RvcDpIU0w6MTQ1NDEwMw==",
lat: 60.226939,
lon: 25.054034
},
{
id: "U3RvcDpIU0w6MTQ1NDEwNQ==",
lat: 60.228059,
lon: 25.054394
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NA==",
lat: 60.22739,
lon: 25.07177
},
{
id: "U3RvcDpIU0w6MTQ1NDExMA==",
lat: 60.225633,
lon: 25.077135
},
{
id: "U3RvcDpIU0w6MTQ1NDEzOA==",
lat: 60.225707,
lon: 25.076062
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MQ==",
lat: 60.2236,
lon: 25.07608
},
{
id: "U3RvcDpIU0w6MTQ1NDExNQ==",
lat: 60.223549,
lon: 25.082989
},
{
id: "U3RvcDpIU0w6MTQ3MTE2NA==",
lat: 60.225494,
lon: 25.083088
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMw==",
lat: 60.22723,
lon: 25.08458
},
{
id: "U3RvcDpIU0w6MTQ3MTEyOQ==",
lat: 60.22999,
lon: 25.09946
},
{
id: "U3RvcDpIU0w6MTQ3MjEwNQ==",
lat: 60.232535,
lon: 25.102188
},
{
id: "U3RvcDpIU0w6MTQ3MjExNQ==",
lat: 60.233596,
lon: 25.105184
},
{
id: "U3RvcDpIU0w6MTQ3MzEyNw==",
lat: 60.233368,
lon: 25.111115
},
{
id: "U3RvcDpIU0w6MTQ3MzExMw==",
lat: 60.23762,
lon: 25.110412
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMQ==",
lat: 60.22934,
lon: 25.118306
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMg==",
lat: 60.229243,
lon: 25.115878
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMw==",
lat: 60.22898,
lon: 25.110548
},
{
id: "U3RvcDpIU0w6MTQ1MTEwNA==",
lat: 60.22734,
lon: 25.10319
},
{
id: "U3RvcDpIU0w6MTQ1MTExOA==",
lat: 60.223525,
lon: 25.10517
},
{
id: "U3RvcDpIU0w6MTQ1MTExOQ==",
lat: 60.221682,
lon: 25.107668
},
{
id: "U3RvcDpIU0w6MTQ1MTEyMQ==",
lat: 60.220048,
lon: 25.104584
},
{
id: "U3RvcDpIU0w6MTQ1MTE3NQ==",
lat: 60.219834,
lon: 25.100155
},
{
id: "U3RvcDpIU0w6MTQ1MzEyNQ==",
lat: 60.218642,
lon: 25.093242
},
{
id: "U3RvcDpIU0w6MTQ1MzExMQ==",
lat: 60.21633,
lon: 25.09587
},
{
id: "U3RvcDpIU0w6MTQ1MzExMw==",
lat: 60.217232,
lon: 25.089587
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMw==",
lat: 60.218238,
lon: 25.085768
},
{
id: "U3RvcDpIU0w6MTQ1MzEwMw==",
lat: 60.217003,
lon: 25.089523
},
{
id: "U3RvcDpIU0w6MTQ1MzEzOA==",
lat: 60.21533,
lon: 25.09017
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzExMg==",
lat: 60.210165,
lon: 25.077287
},
{
id: "U3RvcDpIU0w6MTQ1MzEzMg==",
lat: 60.209881,
lon: 25.078219
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MzEwNw==",
lat: 60.21557,
lon: 25.09193
},
{
id: "U3RvcDpIU0w6MTQ1MTExMQ==",
lat: 60.218557,
lon: 25.093377
},
{
id: "U3RvcDpIU0w6MTQ1MTE3OA==",
lat: 60.21973,
lon: 25.10042
},
{
id: "U3RvcDpIU0w6MTQ1MTEwMw==",
lat: 60.22724,
lon: 25.10316
},
{
id: "U3RvcDpIU0w6MTQ3MzEwOQ==",
lat: 60.23783,
lon: 25.10901
},
{
id: "U3RvcDpIU0w6MTQ3MzEyNg==",
lat: 60.233316,
lon: 25.110897
},
{
id: "U3RvcDpIU0w6MTQ3MjEzMg==",
lat: 60.23268,
lon: 25.0993
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNg==",
lat: 60.2287,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNA==",
lat: 60.22677,
lon: 25.08374
},
{
id: "U3RvcDpIU0w6MTQ3MTExNA==",
lat: 60.224607,
lon: 25.084945
},
{
id: "U3RvcDpIU0w6MTQ1NDEyNw==",
lat: 60.223605,
lon: 25.082473
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MA==",
lat: 60.22444,
lon: 25.07567
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Mw==",
lat: 60.22775,
lon: 25.0709
},
{
id: "U3RvcDpIU0w6MTQ1NDEzNg==",
lat: 60.228565,
lon: 25.065237
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Mg==",
lat: 60.22848,
lon: 25.054395
},
{
id: "U3RvcDpIU0w6MTQ1NDEwNA==",
lat: 60.226913,
lon: 25.053997
},
{
id: "U3RvcDpIU0w6MTQ1NDEwMg==",
lat: 60.224782,
lon: 25.054285
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Nw==",
lat: 60.22353,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OQ==",
lat: 60.22198,
lon: 25.05776
}
]
},
{
gtfsId: "HSL:4624N",
shortName: "624N",
longName: "Tikkurila-Ruskeasanta-Ilola-Leinelä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDYxMDI1Mw==",
lat: 60.294111,
lon: 25.044463
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIyOA==",
lat: 60.29661,
lon: 25.03844
},
{
id: "U3RvcDpIU0w6NDYxMDIzMQ==",
lat: 60.29765,
lon: 25.03472
},
{
id: "U3RvcDpIU0w6NDYzMDIxMA==",
lat: 60.29964,
lon: 25.03247
},
{
id: "U3RvcDpIU0w6NDYzMDIyNg==",
lat: 60.30105,
lon: 25.02662
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIxMQ==",
lat: 60.30783,
lon: 25.02128
},
{
id: "U3RvcDpIU0w6NDY3MDIwOQ==",
lat: 60.31333,
lon: 25.01636
},
{
id: "U3RvcDpIU0w6NDY3MDIxMA==",
lat: 60.3158,
lon: 25.01389
},
{
id: "U3RvcDpIU0w6NDY3MDIxMg==",
lat: 60.3198,
lon: 25.01384
},
{
id: "U3RvcDpIU0w6NDY3MDIxOQ==",
lat: 60.32314,
lon: 25.01208
},
{
id: "U3RvcDpIU0w6NDY3MDIxNw==",
lat: 60.3234,
lon: 25.00589
},
{
id: "U3RvcDpIU0w6NDcxMDIwNQ==",
lat: 60.32397,
lon: 25.00108
},
{
id: "U3RvcDpIU0w6NDcxMDIyNg==",
lat: 60.3295,
lon: 25.00469
},
{
id: "U3RvcDpIU0w6NDcxMDIwMQ==",
lat: 60.33262,
lon: 25.00988
},
{
id: "U3RvcDpIU0w6NDcxMDIyMw==",
lat: 60.33363,
lon: 25.01447
},
{
id: "U3RvcDpIU0w6NDcxMDIyMQ==",
lat: 60.33191,
lon: 25.01751
},
{
id: "U3RvcDpIU0w6NDcxMDI0MA==",
lat: 60.332042,
lon: 25.019907
},
{
id: "U3RvcDpIU0w6NDcxMDIzOQ==",
lat: 60.33326,
lon: 25.02735
},
{
id: "U3RvcDpIU0w6NDcxMDIxNw==",
lat: 60.32983,
lon: 25.02648
},
{
id: "U3RvcDpIU0w6NDcxMDIwOQ==",
lat: 60.32633,
lon: 25.02468
},
{
id: "U3RvcDpIU0w6NDcwMDIyNw==",
lat: 60.32441,
lon: 25.02678
},
{
id: "U3RvcDpIU0w6NDcwMDIyNg==",
lat: 60.32334,
lon: 25.03762
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
},
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyNQ==",
lat: 60.32362,
lon: 25.03701
},
{
id: "U3RvcDpIU0w6NDcxMDIwOA==",
lat: 60.32624,
lon: 25.02493
},
{
id: "U3RvcDpIU0w6NDcxMDIxOA==",
lat: 60.32946,
lon: 25.02685
},
{
id: "U3RvcDpIU0w6NDcxMDIzOA==",
lat: 60.33382,
lon: 25.02609
},
{
id: "U3RvcDpIU0w6NDcxMDI0MQ==",
lat: 60.332301,
lon: 25.019994
},
{
id: "U3RvcDpIU0w6NDcxMDIyMg==",
lat: 60.33269,
lon: 25.01633
},
{
id: "U3RvcDpIU0w6NDcxMDIyOQ==",
lat: 60.33346,
lon: 25.01295
},
{
id: "U3RvcDpIU0w6NDcxMDIyOA==",
lat: 60.33221,
lon: 25.00904
},
{
id: "U3RvcDpIU0w6NDcxMDIyNw==",
lat: 60.33016,
lon: 25.00643
},
{
id: "U3RvcDpIU0w6NDY3MDIxOA==",
lat: 60.32319,
lon: 25.00773
},
{
id: "U3RvcDpIU0w6NDY3MDIxMw==",
lat: 60.32259,
lon: 25.0127
},
{
id: "U3RvcDpIU0w6NDY3MDIxMQ==",
lat: 60.31772,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDY3MDIwNg==",
lat: 60.31488,
lon: 25.01453
},
{
id: "U3RvcDpIU0w6NDY3MDIwOA==",
lat: 60.31332,
lon: 25.01609
},
{
id: "U3RvcDpIU0w6NDY1MDIxMg==",
lat: 60.30758,
lon: 25.02169
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIwNw==",
lat: 60.30182,
lon: 25.02328
},
{
id: "U3RvcDpIU0w6NDYzMDIyNQ==",
lat: 60.30021,
lon: 25.02911
},
{
id: "U3RvcDpIU0w6NDYzMDIwOQ==",
lat: 60.299,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6NDYxMDIwOQ==",
lat: 60.2969,
lon: 25.03573
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
}
]
},
{
gtfsId: "HSL:1802",
shortName: "802",
longName: "Itäkeskus(M)-Jollas",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzEzMg==",
lat: 60.209881,
lon: 25.078219
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMQ==",
lat: 60.2075,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6MTQ1NTExMA==",
lat: 60.2067,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ1NTEyOQ==",
lat: 60.2078,
lon: 25.0823
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMQ==",
lat: 60.20916,
lon: 25.08738
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNg==",
lat: 60.20959,
lon: 25.091516
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNA==",
lat: 60.208146,
lon: 25.09688
},
{
id: "U3RvcDpIU0w6MTQ1MjE2OQ==",
lat: 60.207813,
lon: 25.101287
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMA==",
lat: 60.208607,
lon: 25.103713
},
{
id: "U3RvcDpIU0w6MTQ1MjE3MA==",
lat: 60.208067,
lon: 25.098807
},
{
id: "U3RvcDpIU0w6MTQ1MjE2OA==",
lat: 60.20809,
lon: 25.09569
},
{
id: "U3RvcDpIU0w6MTQ1NTExMw==",
lat: 60.203251,
lon: 25.095111
},
{
id: "U3RvcDpIU0w6MTQ1NTE2MQ==",
lat: 60.20354,
lon: 25.07957
},
{
id: "U3RvcDpIU0w6MTQ1NTE3Mg==",
lat: 60.20392,
lon: 25.07614
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OQ==",
lat: 60.20303,
lon: 25.07354
},
{
id: "U3RvcDpIU0w6MTQzMjE4MQ==",
lat: 60.20187,
lon: 25.0646
},
{
id: "U3RvcDpIU0w6MTQzMjE3OQ==",
lat: 60.20199,
lon: 25.0616
},
{
id: "U3RvcDpIU0w6MTQzMjE2Mg==",
lat: 60.2007,
lon: 25.05952
},
{
id: "U3RvcDpIU0w6MTQzMjExMg==",
lat: 60.197833,
lon: 25.054813
},
{
id: "U3RvcDpIU0w6MTQzMjE1NA==",
lat: 60.197495,
lon: 25.052206
},
{
id: "U3RvcDpIU0w6MTQzMjExNg==",
lat: 60.19635,
lon: 25.050907
},
{
id: "U3RvcDpIU0w6MTQzMjE1OQ==",
lat: 60.19806,
lon: 25.05587
},
{
id: "U3RvcDpIU0w6MTQzMjE2MQ==",
lat: 60.20088,
lon: 25.05972
},
{
id: "U3RvcDpIU0w6MTQzMjEyNg==",
lat: 60.203497,
lon: 25.062618
},
{
id: "U3RvcDpIU0w6MTQzMjEwNQ==",
lat: 60.20473,
lon: 25.062643
},
{
id: "U3RvcDpIU0w6MTQzMjEwNg==",
lat: 60.205063,
lon: 25.060942
},
{
id: "U3RvcDpIU0w6MTQzMjEwNw==",
lat: 60.203773,
lon: 25.060594
},
{
id: "U3RvcDpIU0w6MTQzMjEyNQ==",
lat: 60.20352,
lon: 25.05932
},
{
id: "U3RvcDpIU0w6MTQzMjEyNA==",
lat: 60.206237,
lon: 25.062354
},
{
id: "U3RvcDpIU0w6MTQzMjEyMw==",
lat: 60.206284,
lon: 25.057458
},
{
id: "U3RvcDpIU0w6MTQzMzEyMQ==",
lat: 60.20659,
lon: 25.05309
},
{
id: "U3RvcDpIU0w6MTQzMzEyNw==",
lat: 60.2052,
lon: 25.04822
},
{
id: "U3RvcDpIU0w6MTQzMTEyOQ==",
lat: 60.206496,
lon: 25.044421
},
{
id: "U3RvcDpIU0w6MTQzMTEzMQ==",
lat: 60.207053,
lon: 25.041649
},
{
id: "U3RvcDpIU0w6MTQzMTE1MQ==",
lat: 60.207202,
lon: 25.036953
},
{
id: "U3RvcDpIU0w6MTQzMTE0OA==",
lat: 60.20553,
lon: 25.03599
},
{
id: "U3RvcDpIU0w6MTQzMTE0Ng==",
lat: 60.20423,
lon: 25.03388
},
{
id: "U3RvcDpIU0w6MTQzMTE0NA==",
lat: 60.20156,
lon: 25.03135
},
{
id: "U3RvcDpIU0w6MTQzMTE0Mg==",
lat: 60.19926,
lon: 25.03136
},
{
id: "U3RvcDpIU0w6MTQzMTE1NA==",
lat: 60.197587,
lon: 25.02811
},
{
id: "U3RvcDpIU0w6MTQzMTEwNg==",
lat: 60.19456,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTQzNDExMg==",
lat: 60.19326,
lon: 25.03494
},
{
id: "U3RvcDpIU0w6MTQzNDE2Nw==",
lat: 60.19142,
lon: 25.03411
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mg==",
lat: 60.187968,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6MTQzNDE3Nw==",
lat: 60.188834,
lon: 25.037202
},
{
id: "U3RvcDpIU0w6MTQzNDE3MA==",
lat: 60.18775,
lon: 25.04133
},
{
id: "U3RvcDpIU0w6MTQzNDE3Mw==",
lat: 60.18668,
lon: 25.04262
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMQ==",
lat: 60.18391,
lon: 25.04893
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNA==",
lat: 60.18367,
lon: 25.05709
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNg==",
lat: 60.18038,
lon: 25.05966
},
{
id: "U3RvcDpIU0w6MTQ5MTEyOA==",
lat: 60.17809,
lon: 25.05687
},
{
id: "U3RvcDpIU0w6MTQ5MTE3MA==",
lat: 60.178258,
lon: 25.0532
},
{
id: "U3RvcDpIU0w6MTQ5MTE3Mw==",
lat: 60.179037,
lon: 25.052463
},
{
id: "U3RvcDpIU0w6MTQ5MTE0Nw==",
lat: 60.180887,
lon: 25.052744
},
{
id: "U3RvcDpIU0w6MTQ5MTE1MA==",
lat: 60.181178,
lon: 25.054732
},
{
id: "U3RvcDpIU0w6MTQ5MTE0OA==",
lat: 60.180929,
lon: 25.052287
},
{
id: "U3RvcDpIU0w6MTQ5MTE3Mg==",
lat: 60.178733,
lon: 25.052345
},
{
id: "U3RvcDpIU0w6MTQ5MTEwNw==",
lat: 60.17786,
lon: 25.04891
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOQ==",
lat: 60.17566,
lon: 25.0462
},
{
id: "U3RvcDpIU0w6MTQ5MTExMQ==",
lat: 60.174743,
lon: 25.040362
},
{
id: "U3RvcDpIU0w6MTQ5MzEwMQ==",
lat: 60.174438,
lon: 25.029956
},
{
id: "U3RvcDpIU0w6MTQ5MTE0Mw==",
lat: 60.170788,
lon: 25.038448
},
{
id: "U3RvcDpIU0w6MTQ5MTEzOQ==",
lat: 60.169458,
lon: 25.037778
},
{
id: "U3RvcDpIU0w6MTQ5MTE0NA==",
lat: 60.170772,
lon: 25.038525
},
{
id: "U3RvcDpIU0w6MTQ5MTExMw==",
lat: 60.17171,
lon: 25.04015
},
{
id: "U3RvcDpIU0w6MTQ5MTExNQ==",
lat: 60.17027,
lon: 25.04299
},
{
id: "U3RvcDpIU0w6MTQ5MTExNw==",
lat: 60.16854,
lon: 25.04599
},
{
id: "U3RvcDpIU0w6MTQ5MTExOQ==",
lat: 60.16787,
lon: 25.04265
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMQ==",
lat: 60.16737,
lon: 25.03772
},
{
id: "U3RvcDpIU0w6MTQ5MTEyMA==",
lat: 60.1679,
lon: 25.04305
},
{
id: "U3RvcDpIU0w6MTQ5NTEzNQ==",
lat: 60.16803,
lon: 25.0489
},
{
id: "U3RvcDpIU0w6MTQ5MjEzNw==",
lat: 60.16596,
lon: 25.05495
},
{
id: "U3RvcDpIU0w6MTQ5MjE0MQ==",
lat: 60.16448,
lon: 25.06189
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Mw==",
lat: 60.16404,
lon: 25.07081
},
{
id: "U3RvcDpIU0w6MTQ5MjEyMQ==",
lat: 60.165093,
lon: 25.075415
},
{
id: "U3RvcDpIU0w6MTQ5MjEyMw==",
lat: 60.164216,
lon: 25.077242
},
{
id: "U3RvcDpIU0w6MTQ5MjEwMA==",
lat: 60.161556,
lon: 25.083062
},
{
id: "U3RvcDpIU0w6MTQ5MjEwMw==",
lat: 60.160887,
lon: 25.092593
},
{
id: "U3RvcDpIU0w6MTQ5MjEyNg==",
lat: 60.161187,
lon: 25.08553
},
{
id: "U3RvcDpIU0w6MTQ5MjEyMg==",
lat: 60.164225,
lon: 25.077224
},
{
id: "U3RvcDpIU0w6MTQ5MjE0NA==",
lat: 60.164,
lon: 25.06984
},
{
id: "U3RvcDpIU0w6MTQ5MjE0Mg==",
lat: 60.16455,
lon: 25.06189
},
{
id: "U3RvcDpIU0w6MTQ5MTEzOA==",
lat: 60.16636,
lon: 25.05391
},
{
id: "U3RvcDpIU0w6MTQ5MTExOA==",
lat: 60.16886,
lon: 25.04583
},
{
id: "U3RvcDpIU0w6MTQ5MTExNg==",
lat: 60.17101,
lon: 25.04185
},
{
id: "U3RvcDpIU0w6MTQ5MTE3MQ==",
lat: 60.172362,
lon: 25.039398
},
{
id: "U3RvcDpIU0w6MTQ5MTExMg==",
lat: 60.174846,
lon: 25.041802
},
{
id: "U3RvcDpIU0w6MTQ5MTExMA==",
lat: 60.1756,
lon: 25.04661
},
{
id: "U3RvcDpIU0w6MTQ5MTEwOA==",
lat: 60.17786,
lon: 25.04901
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Nw==",
lat: 60.17822,
lon: 25.05075
},
{
id: "U3RvcDpIU0w6MTQ5MTE2OQ==",
lat: 60.178132,
lon: 25.053262
},
{
id: "U3RvcDpIU0w6MTQ5MTEyOQ==",
lat: 60.17805,
lon: 25.05738
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNw==",
lat: 60.18081,
lon: 25.0596
},
{
id: "U3RvcDpIU0w6MTQ5MTEyNQ==",
lat: 60.18384,
lon: 25.05705
},
{
id: "U3RvcDpIU0w6MTQ5MTE1Mg==",
lat: 60.184319,
lon: 25.060903
},
{
id: "U3RvcDpIU0w6MTQ5MTE5OQ==",
lat: 60.18652,
lon: 25.057775
},
{
id: "U3RvcDpIU0w6MTQ5MTEwMg==",
lat: 60.18442,
lon: 25.04812
},
{
id: "U3RvcDpIU0w6MTQzNDE3NA==",
lat: 60.18706,
lon: 25.04258
},
{
id: "U3RvcDpIU0w6MTQzNDE3Ng==",
lat: 60.18833,
lon: 25.04042
},
{
id: "U3RvcDpIU0w6MTQzNDE3OA==",
lat: 60.189238,
lon: 25.037143
},
{
id: "U3RvcDpIU0w6MTQzNDE2OA==",
lat: 60.19153,
lon: 25.03457
},
{
id: "U3RvcDpIU0w6MTQzMzExMw==",
lat: 60.19352,
lon: 25.03487
},
{
id: "U3RvcDpIU0w6MTQzMTEzOQ==",
lat: 60.19542,
lon: 25.03125
},
{
id: "U3RvcDpIU0w6MTQzMTE0MQ==",
lat: 60.19795,
lon: 25.03163
},
{
id: "U3RvcDpIU0w6MTQzMTE0Mw==",
lat: 60.20234,
lon: 25.03197
},
{
id: "U3RvcDpIU0w6MTQzMTE0NQ==",
lat: 60.20462,
lon: 25.03467
},
{
id: "U3RvcDpIU0w6MTQzMTE0Nw==",
lat: 60.20579,
lon: 25.03667
},
{
id: "U3RvcDpIU0w6MTQzMTE1Mg==",
lat: 60.207652,
lon: 25.037388
},
{
id: "U3RvcDpIU0w6MTQzMTEwOQ==",
lat: 60.20798,
lon: 25.03966
},
{
id: "U3RvcDpIU0w6MTQzMTEzMA==",
lat: 60.206214,
lon: 25.044957
},
{
id: "U3RvcDpIU0w6MTQzMzEyOA==",
lat: 60.20521,
lon: 25.04774
},
{
id: "U3RvcDpIU0w6MTQzMzEyMA==",
lat: 60.20661,
lon: 25.05334
},
{
id: "U3RvcDpIU0w6MTQzMjEyMg==",
lat: 60.20641,
lon: 25.0571
},
{
id: "U3RvcDpIU0w6MTQzMjE2NA==",
lat: 60.203,
lon: 25.05946
},
{
id: "U3RvcDpIU0w6MTQzMjE3OA==",
lat: 60.20195,
lon: 25.06185
},
{
id: "U3RvcDpIU0w6MTQzMjE4MA==",
lat: 60.20174,
lon: 25.0658
},
{
id: "U3RvcDpIU0w6MTQ1NTE1OA==",
lat: 60.20285,
lon: 25.07329
},
{
id: "U3RvcDpIU0w6MTQ1NTE3MQ==",
lat: 60.20428,
lon: 25.07685
},
{
id: "U3RvcDpIU0w6MTQ1NTE2MA==",
lat: 60.20324,
lon: 25.08139
},
{
id: "U3RvcDpIU0w6MTQ1NTExMg==",
lat: 60.203288,
lon: 25.095087
},
{
id: "U3RvcDpIU0w6MTQ1NTEwOA==",
lat: 60.204917,
lon: 25.094463
},
{
id: "U3RvcDpIU0w6MTQ1NTExMQ==",
lat: 60.206107,
lon: 25.094846
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMw==",
lat: 60.208799,
lon: 25.095008
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMg==",
lat: 60.20912,
lon: 25.08664
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMA==",
lat: 60.20779,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1NTEwOQ==",
lat: 60.20635,
lon: 25.07659
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMg==",
lat: 60.20757,
lon: 25.07562
},
{
id: "U3RvcDpIU0w6MTQ1MzExMg==",
lat: 60.210165,
lon: 25.077287
}
]
},
{
gtfsId: "HSL:1801",
shortName: "801",
longName: "Itäkeskus-Varjakanvalkama",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MTExMA==",
lat: 60.218866,
lon: 25.120259
},
{
id: "U3RvcDpIU0w6MTQ1MTEwOA==",
lat: 60.21845,
lon: 25.117452
},
{
id: "U3RvcDpIU0w6MTQ1MTExNg==",
lat: 60.21833,
lon: 25.11394
},
{
id: "U3RvcDpIU0w6MTQ1MTExNQ==",
lat: 60.21634,
lon: 25.11096
},
{
id: "U3RvcDpIU0w6MTQ1MTEwMg==",
lat: 60.214802,
lon: 25.108286
},
{
id: "U3RvcDpIU0w6MTQ1MTEwMA==",
lat: 60.214263,
lon: 25.106332
},
{
id: "U3RvcDpIU0w6MTQ1MjExNA==",
lat: 60.213293,
lon: 25.102399
},
{
id: "U3RvcDpIU0w6MTQ1MjExMQ==",
lat: 60.211908,
lon: 25.105476
},
{
id: "U3RvcDpIU0w6MTQ1MjEwOQ==",
lat: 60.210937,
lon: 25.102132
},
{
id: "U3RvcDpIU0w6MTQ1MjEzOQ==",
lat: 60.208948,
lon: 25.099878
},
{
id: "U3RvcDpIU0w6MTQ1MjE0MQ==",
lat: 60.2102,
lon: 25.09811
},
{
id: "U3RvcDpIU0w6MTQ1MjEzNA==",
lat: 60.21086,
lon: 25.09226
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMg==",
lat: 60.20912,
lon: 25.08664
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMA==",
lat: 60.20779,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1NTEwOQ==",
lat: 60.20635,
lon: 25.07659
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMg==",
lat: 60.20757,
lon: 25.07562
},
{
id: "U3RvcDpIU0w6MTQ1MzExMg==",
lat: 60.210165,
lon: 25.077287
},
{
id: "U3RvcDpIU0w6MTQ1MzEzMg==",
lat: 60.209881,
lon: 25.078219
},
{
id: "U3RvcDpIU0w6MTQ1NTEwMQ==",
lat: 60.2075,
lon: 25.0753
},
{
id: "U3RvcDpIU0w6MTQ1NTExMA==",
lat: 60.2067,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ1NTEyOQ==",
lat: 60.2078,
lon: 25.0823
},
{
id: "U3RvcDpIU0w6MTQ1NTEzMQ==",
lat: 60.20916,
lon: 25.08738
},
{
id: "U3RvcDpIU0w6MTQ1MjEzMw==",
lat: 60.21087,
lon: 25.09252
},
{
id: "U3RvcDpIU0w6MTQ1MjE0Mg==",
lat: 60.210275,
lon: 25.097863
},
{
id: "U3RvcDpIU0w6MTQ1MjE0MA==",
lat: 60.20889,
lon: 25.09973
},
{
id: "U3RvcDpIU0w6MTQ1MjEwOA==",
lat: 60.211068,
lon: 25.102749
},
{
id: "U3RvcDpIU0w6MTQ1MjExMA==",
lat: 60.211812,
lon: 25.105433
},
{
id: "U3RvcDpIU0w6MTQ1MjExMw==",
lat: 60.213303,
lon: 25.102558
},
{
id: "U3RvcDpIU0w6MTQ1MTEwMQ==",
lat: 60.214299,
lon: 25.106158
},
{
id: "U3RvcDpIU0w6MTQ1MTEwNQ==",
lat: 60.214838,
lon: 25.108287
},
{
id: "U3RvcDpIU0w6MTQ1MTExNA==",
lat: 60.21641,
lon: 25.11116
},
{
id: "U3RvcDpIU0w6MTQ1MTEyMg==",
lat: 60.21834,
lon: 25.11409
},
{
id: "U3RvcDpIU0w6MTQ1MTEwOQ==",
lat: 60.220283,
lon: 25.118178
}
]
},
{
gtfsId: "HSL:9641",
shortName: "641",
longName: "Tikkurila-Leinelä-Hyrylä-Kerava",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTA0MDIyMA==",
lat: 60.40444,
lon: 25.105
},
{
id: "U3RvcDpIU0w6OTA0MDIwNQ==",
lat: 60.40346,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6OTA0MDIwMw==",
lat: 60.40212,
lon: 25.09875
},
{
id: "U3RvcDpIU0w6OTA0MDIwMQ==",
lat: 60.4041,
lon: 25.09687
},
{
id: "U3RvcDpIU0w6OTAxMDI0NA==",
lat: 60.40588,
lon: 25.09427
},
{
id: "U3RvcDpIU0w6OTAxMDI0Mw==",
lat: 60.40746,
lon: 25.09113
},
{
id: "U3RvcDpIU0w6OTAxMDI0MQ==",
lat: 60.40895,
lon: 25.08768
},
{
id: "U3RvcDpIU0w6OTAxMDIxNQ==",
lat: 60.40978,
lon: 25.08347
},
{
id: "U3RvcDpIU0w6OTY1MDQxOA==",
lat: 60.411005,
lon: 25.076163
},
{
id: "U3RvcDpIU0w6OTY1MDQwMQ==",
lat: 60.412982,
lon: 25.071106
},
{
id: "U3RvcDpIU0w6OTY1MDQxNg==",
lat: 60.415137,
lon: 25.064932
},
{
id: "U3RvcDpIU0w6OTY1MDQyMA==",
lat: 60.414242,
lon: 25.060548
},
{
id: "U3RvcDpIU0w6OTY1MDQwOQ==",
lat: 60.414496,
lon: 25.054166
},
{
id: "U3RvcDpIU0w6OTY1MDQwNg==",
lat: 60.414022,
lon: 25.049991
},
{
id: "U3RvcDpIU0w6OTY1MDMyNQ==",
lat: 60.410933,
lon: 25.045152
},
{
id: "U3RvcDpIU0w6OTY1MDMyNw==",
lat: 60.409244,
lon: 25.042448
},
{
id: "U3RvcDpIU0w6OTY1MDMyMg==",
lat: 60.406367,
lon: 25.041696
},
{
id: "U3RvcDpIU0w6OTY1MDMxOQ==",
lat: 60.404485,
lon: 25.041464
},
{
id: "U3RvcDpIU0w6OTY1MDEwMg==",
lat: 60.40142,
lon: 25.030759
},
{
id: "U3RvcDpIU0w6OTY1MDEyMQ==",
lat: 60.401747,
lon: 25.028205
},
{
id: "U3RvcDpIU0w6OTY1MDExMQ==",
lat: 60.400819,
lon: 25.026307
},
{
id: "U3RvcDpIU0w6OTY1MDEwNQ==",
lat: 60.398721,
lon: 25.02284
},
{
id: "U3RvcDpIU0w6OTY1MTUwNA==",
lat: 60.394205,
lon: 25.021614
},
{
id: "U3RvcDpIU0w6OTY1MTUwMQ==",
lat: 60.390458,
lon: 25.023577
},
{
id: "U3RvcDpIU0w6OTY1MTcwMQ==",
lat: 60.386727,
lon: 25.025077
},
{
id: "U3RvcDpIU0w6OTY1MTYxMw==",
lat: 60.382931,
lon: 25.025434
},
{
id: "U3RvcDpIU0w6OTY1MTYwMQ==",
lat: 60.378409,
lon: 25.022339
},
{
id: "U3RvcDpIU0w6OTY1MTMxMg==",
lat: 60.374001,
lon: 25.018583
},
{
id: "U3RvcDpIU0w6OTY3MDUwMg==",
lat: 60.368227,
lon: 25.010802
},
{
id: "U3RvcDpIU0w6OTY3MDUwMA==",
lat: 60.358509,
lon: 25.000551
},
{
id: "U3RvcDpIU0w6OTY3MDUxMQ==",
lat: 60.341781,
lon: 25.004458
},
{
id: "U3RvcDpIU0w6OTY3MDUzMw==",
lat: 60.343093,
lon: 25.021248
},
{
id: "U3RvcDpIU0w6OTY3MDUzMQ==",
lat: 60.339383,
lon: 25.022798
},
{
id: "U3RvcDpIU0w6NDcxMDI0Mw==",
lat: 60.336051,
lon: 25.026532
},
{
id: "U3RvcDpIU0w6NDcxMDIzOQ==",
lat: 60.33326,
lon: 25.02735
},
{
id: "U3RvcDpIU0w6NDcxMDIxNw==",
lat: 60.32983,
lon: 25.02648
},
{
id: "U3RvcDpIU0w6NDcxMDIwOQ==",
lat: 60.32633,
lon: 25.02468
},
{
id: "U3RvcDpIU0w6NDcwMDIyNw==",
lat: 60.32441,
lon: 25.02678
},
{
id: "U3RvcDpIU0w6NDcwMDIyNg==",
lat: 60.32334,
lon: 25.03762
},
{
id: "U3RvcDpIU0w6NDcwMDIzMQ==",
lat: 60.323717,
lon: 25.039283
},
{
id: "U3RvcDpIU0w6NDcwMDIyOQ==",
lat: 60.322323,
lon: 25.042012
},
{
id: "U3RvcDpIU0w6NDcwMDIwMg==",
lat: 60.31968,
lon: 25.03908
},
{
id: "U3RvcDpIU0w6NDY1MDIxMA==",
lat: 60.3149,
lon: 25.03463
},
{
id: "U3RvcDpIU0w6NDY1MDIwOA==",
lat: 60.31072,
lon: 25.03015
},
{
id: "U3RvcDpIU0w6NDY1MDIwNg==",
lat: 60.30949,
lon: 25.02695
},
{
id: "U3RvcDpIU0w6NDY1MDIwNA==",
lat: 60.30635,
lon: 25.02439
},
{
id: "U3RvcDpIU0w6NDY1MDIwMg==",
lat: 60.30443,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6NDYzMDIwNw==",
lat: 60.30182,
lon: 25.02328
},
{
id: "U3RvcDpIU0w6NDYzMDIyNQ==",
lat: 60.30021,
lon: 25.02911
},
{
id: "U3RvcDpIU0w6NDYzMDIwOQ==",
lat: 60.299,
lon: 25.03367
},
{
id: "U3RvcDpIU0w6NDYxMDIwOQ==",
lat: 60.2969,
lon: 25.03573
},
{
id: "U3RvcDpIU0w6NDYxMDIyNw==",
lat: 60.29594,
lon: 25.03905
},
{
id: "U3RvcDpIU0w6NDYxMDIxNA==",
lat: 60.29427,
lon: 25.0381
},
{
id: "U3RvcDpIU0w6NDYxMDIwNQ==",
lat: 60.29209,
lon: 25.03887
},
{
id: "U3RvcDpIU0w6NDYxMDIwNg==",
lat: 60.29278,
lon: 25.043604
},
{
id: "U3RvcDpIU0w6NDYxMDI1Mg==",
lat: 60.294038,
lon: 25.04448
},
{
id: "U3RvcDpIU0w6NDYxMDIwNA==",
lat: 60.29223,
lon: 25.03852
},
{
id: "U3RvcDpIU0w6NDYxMDIxMw==",
lat: 60.29388,
lon: 25.0382
},
{
id: "U3RvcDpIU0w6NDYxMDIyOA==",
lat: 60.29661,
lon: 25.03844
},
{
id: "U3RvcDpIU0w6NDYxMDIzMQ==",
lat: 60.29765,
lon: 25.03472
},
{
id: "U3RvcDpIU0w6NDYzMDIxMA==",
lat: 60.29964,
lon: 25.03247
},
{
id: "U3RvcDpIU0w6NDYzMDIyNg==",
lat: 60.30105,
lon: 25.02662
},
{
id: "U3RvcDpIU0w6NDYzMDIwOA==",
lat: 60.30254,
lon: 25.02311
},
{
id: "U3RvcDpIU0w6NDY1MDIwMQ==",
lat: 60.30511,
lon: 25.02385
},
{
id: "U3RvcDpIU0w6NDY1MDIwMw==",
lat: 60.30689,
lon: 25.02499
},
{
id: "U3RvcDpIU0w6NDY1MDIwNQ==",
lat: 60.31,
lon: 25.0287
},
{
id: "U3RvcDpIU0w6NDY1MDIwNw==",
lat: 60.31132,
lon: 25.03142
},
{
id: "U3RvcDpIU0w6NDY1MDIwOQ==",
lat: 60.31516,
lon: 25.03566
},
{
id: "U3RvcDpIU0w6NDcwMDIwMQ==",
lat: 60.3203,
lon: 25.03941
},
{
id: "U3RvcDpIU0w6NDcwMDIyOA==",
lat: 60.32246,
lon: 25.042177
},
{
id: "U3RvcDpIU0w6NDcwMDIzMA==",
lat: 60.323644,
lon: 25.038948
},
{
id: "U3RvcDpIU0w6NDcwMDIyNQ==",
lat: 60.32362,
lon: 25.03701
},
{
id: "U3RvcDpIU0w6NDcxMDIwOA==",
lat: 60.32624,
lon: 25.02493
},
{
id: "U3RvcDpIU0w6NDcxMDIxOA==",
lat: 60.32946,
lon: 25.02685
},
{
id: "U3RvcDpIU0w6NDcxMDI0NA==",
lat: 60.334368,
lon: 25.027149
},
{
id: "U3RvcDpIU0w6NDcxMDI0Mg==",
lat: 60.336744,
lon: 25.026228
},
{
id: "U3RvcDpIU0w6OTY3MDUzMg==",
lat: 60.339372,
lon: 25.023015
},
{
id: "U3RvcDpIU0w6OTY3MDUwOA==",
lat: 60.343363,
lon: 25.020459
},
{
id: "U3RvcDpIU0w6OTY3MDUxMg==",
lat: 60.342071,
lon: 25.005156
},
{
id: "U3RvcDpIU0w6OTY3MDUyMw==",
lat: 60.342142,
lon: 25.002158
},
{
id: "U3RvcDpIU0w6OTY3MDUwMQ==",
lat: 60.358831,
lon: 25.001472
},
{
id: "U3RvcDpIU0w6OTY3MDUwMw==",
lat: 60.368584,
lon: 25.011852
},
{
id: "U3RvcDpIU0w6OTY1MTMxMw==",
lat: 60.375518,
lon: 25.019879
},
{
id: "U3RvcDpIU0w6OTY1MTYwMg==",
lat: 60.379778,
lon: 25.023895
},
{
id: "U3RvcDpIU0w6OTY1MTYxMg==",
lat: 60.382748,
lon: 25.025649
},
{
id: "U3RvcDpIU0w6OTY1MTcwMg==",
lat: 60.385848,
lon: 25.025451
},
{
id: "U3RvcDpIU0w6OTY1MTUwMg==",
lat: 60.391748,
lon: 25.023073
},
{
id: "U3RvcDpIU0w6OTY1MTUwMw==",
lat: 60.394225,
lon: 25.021879
},
{
id: "U3RvcDpIU0w6OTY1MDEwNA==",
lat: 60.397977,
lon: 25.022502
},
{
id: "U3RvcDpIU0w6OTY1MDExMA==",
lat: 60.400624,
lon: 25.026438
},
{
id: "U3RvcDpIU0w6OTY1MDEyMg==",
lat: 60.401853,
lon: 25.027808
},
{
id: "U3RvcDpIU0w6OTY1MDEwMw==",
lat: 60.401391,
lon: 25.03098
},
{
id: "U3RvcDpIU0w6OTY1MDMyNA==",
lat: 60.402958,
lon: 25.039074
},
{
id: "U3RvcDpIU0w6OTY1MDMxOA==",
lat: 60.404662,
lon: 25.041673
},
{
id: "U3RvcDpIU0w6OTY1MDMyMQ==",
lat: 60.407436,
lon: 25.041864
},
{
id: "U3RvcDpIU0w6OTY1MDMyNg==",
lat: 60.409443,
lon: 25.042818
},
{
id: "U3RvcDpIU0w6OTY1MDMwMQ==",
lat: 60.411513,
lon: 25.045253
},
{
id: "U3RvcDpIU0w6OTY1MDQxNA==",
lat: 60.412355,
lon: 25.047274
},
{
id: "U3RvcDpIU0w6OTY1MDQwOA==",
lat: 60.414462,
lon: 25.053068
},
{
id: "U3RvcDpIU0w6OTY1MDQxOQ==",
lat: 60.414541,
lon: 25.062168
},
{
id: "U3RvcDpIU0w6OTY1MDQxNQ==",
lat: 60.414239,
lon: 25.068257
},
{
id: "U3RvcDpIU0w6OTY1MDQwMA==",
lat: 60.412498,
lon: 25.072411
},
{
id: "U3RvcDpIU0w6OTY1MDQxNw==",
lat: 60.410369,
lon: 25.07738
},
{
id: "U3RvcDpIU0w6OTAyMDIwNQ==",
lat: 60.40746,
lon: 25.0907
},
{
id: "U3RvcDpIU0w6OTAyMDIwNw==",
lat: 60.40457,
lon: 25.096
},
{
id: "U3RvcDpIU0w6OTA0MDIwNA==",
lat: 60.40206,
lon: 25.09889
},
{
id: "U3RvcDpIU0w6OTA0MDIwNg==",
lat: 60.40346,
lon: 25.10141
},
{
id: "U3RvcDpIU0w6OTA0MDIwMA==",
lat: 60.404182,
lon: 25.104826
}
]
},
{
gtfsId: "HSL:9642",
shortName: "642",
longName: "Leinelä-Lahela-Hyrylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDEyMw==",
lat: 60.401866,
lon: 25.028215
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MDkwMQ==",
lat: 60.406126,
lon: 25.009112
},
{
id: "U3RvcDpIU0w6OTY1MTAwMA==",
lat: 60.405733,
lon: 25.004427
},
{
id: "U3RvcDpIU0w6OTY1MTAyNQ==",
lat: 60.405001,
lon: 24.998075
},
{
id: "U3RvcDpIU0w6OTY1MTAxMQ==",
lat: 60.403581,
lon: 24.992938
},
{
id: "U3RvcDpIU0w6OTY1MTAxMw==",
lat: 60.401747,
lon: 24.986525
},
{
id: "U3RvcDpIU0w6OTY1MTAwNQ==",
lat: 60.398272,
lon: 24.981927
},
{
id: "U3RvcDpIU0w6OTY1MTAwOA==",
lat: 60.394614,
lon: 24.985621
},
{
id: "U3RvcDpIU0w6OTY1MTIwNw==",
lat: 60.388511,
lon: 24.988179
},
{
id: "U3RvcDpIU0w6OTY1MTIwMQ==",
lat: 60.386628,
lon: 24.98607
},
{
id: "U3RvcDpIU0w6OTY1MTIwOA==",
lat: 60.380733,
lon: 24.979981
},
{
id: "U3RvcDpIU0w6OTY1MTIxMA==",
lat: 60.379998,
lon: 24.985959
},
{
id: "U3RvcDpIU0w6OTY1MTMwMw==",
lat: 60.377475,
lon: 24.995715
},
{
id: "U3RvcDpIU0w6OTY1MTQwMA==",
lat: 60.383973,
lon: 25.010521
},
{
id: "U3RvcDpIU0w6OTY1MTQwNA==",
lat: 60.382054,
lon: 25.014925
},
{
id: "U3RvcDpIU0w6OTY1MTMwOA==",
lat: 60.378836,
lon: 25.012496
},
{
id: "U3RvcDpIU0w6OTY1MTMwMA==",
lat: 60.377481,
lon: 25.013463
},
{
id: "U3RvcDpIU0w6OTY1MTMxNg==",
lat: 60.374891,
lon: 25.017616
},
{
id: "U3RvcDpIU0w6OTY1MTMxMg==",
lat: 60.374001,
lon: 25.018583
},
{
id: "U3RvcDpIU0w6OTY3MDUwMg==",
lat: 60.368227,
lon: 25.010802
},
{
id: "U3RvcDpIU0w6OTY3MDUwNQ==",
lat: 60.364502,
lon: 25.009361
},
{
id: "U3RvcDpIU0w6OTY3MDUyNw==",
lat: 60.353749,
lon: 25.008657
},
{
id: "U3RvcDpIU0w6OTY3MDUyNQ==",
lat: 60.34703,
lon: 25.003354
},
{
id: "U3RvcDpIU0w6OTY3MDUxNA==",
lat: 60.342295,
lon: 25.003129
},
{
id: "U3RvcDpIU0w6OTY3MDUxOA==",
lat: 60.339312,
lon: 25.003986
},
{
id: "U3RvcDpIU0w6OTY3MDUwNw==",
lat: 60.33588,
lon: 25.003993
},
{
id: "U3RvcDpIU0w6NDcxMDIwMg==",
lat: 60.33129,
lon: 25.00324
},
{
id: "U3RvcDpIU0w6NDY3MDIxOA==",
lat: 60.32319,
lon: 25.00773
},
{
id: "U3RvcDpIU0w6NDY3MDIxNA==",
lat: 60.32302,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDcxMDIwNg==",
lat: 60.32362,
lon: 25.01831
},
{
id: "U3RvcDpIU0w6NDcwMDIyNw==",
lat: 60.32441,
lon: 25.02678
},
{
id: "U3RvcDpIU0w6NDcwMDIyNg==",
lat: 60.32334,
lon: 25.03762
},
{
id: "U3RvcDpIU0w6NDcwMDIyNQ==",
lat: 60.32362,
lon: 25.03701
},
{
id: "U3RvcDpIU0w6NDcxMDIzMQ==",
lat: 60.32451,
lon: 25.02443
},
{
id: "U3RvcDpIU0w6NDcxMDIwNw==",
lat: 60.32345,
lon: 25.01674
},
{
id: "U3RvcDpIU0w6NDY3MDIxOQ==",
lat: 60.32314,
lon: 25.01208
},
{
id: "U3RvcDpIU0w6NDY3MDIxNw==",
lat: 60.3234,
lon: 25.00589
},
{
id: "U3RvcDpIU0w6NDcxMDIwNQ==",
lat: 60.32397,
lon: 25.00108
},
{
id: "U3RvcDpIU0w6NDcxMDIwMw==",
lat: 60.33233,
lon: 25.00378
},
{
id: "U3RvcDpIU0w6OTY3MDUwNg==",
lat: 60.336877,
lon: 25.004063
},
{
id: "U3RvcDpIU0w6OTY3MDUxNQ==",
lat: 60.340337,
lon: 25.003756
},
{
id: "U3RvcDpIU0w6OTY3MDUxMw==",
lat: 60.343194,
lon: 25.003081
},
{
id: "U3RvcDpIU0w6OTY3MDUyNA==",
lat: 60.347829,
lon: 25.004667
},
{
id: "U3RvcDpIU0w6OTY3MDUyNg==",
lat: 60.354703,
lon: 25.009253
},
{
id: "U3RvcDpIU0w6OTY3MDUwNA==",
lat: 60.365182,
lon: 25.00855
},
{
id: "U3RvcDpIU0w6OTY3MDUwMw==",
lat: 60.368584,
lon: 25.011852
},
{
id: "U3RvcDpIU0w6OTY1MTMxNw==",
lat: 60.374858,
lon: 25.017726
},
{
id: "U3RvcDpIU0w6OTY1MTMwMQ==",
lat: 60.377366,
lon: 25.013702
},
{
id: "U3RvcDpIU0w6OTY1MTMwOQ==",
lat: 60.378562,
lon: 25.012256
},
{
id: "U3RvcDpIU0w6OTY1MTQwNQ==",
lat: 60.381872,
lon: 25.01535
},
{
id: "U3RvcDpIU0w6OTY1MTQwMQ==",
lat: 60.383909,
lon: 25.010676
},
{
id: "U3RvcDpIU0w6OTY1MTMxOA==",
lat: 60.377594,
lon: 24.994208
},
{
id: "U3RvcDpIU0w6OTY1MTIwOQ==",
lat: 60.380164,
lon: 24.985366
},
{
id: "U3RvcDpIU0w6OTY1MTIwNA==",
lat: 60.381782,
lon: 24.979181
},
{
id: "U3RvcDpIU0w6OTY1MTIwMg==",
lat: 60.386147,
lon: 24.985578
},
{
id: "U3RvcDpIU0w6OTY1MTIwNg==",
lat: 60.389323,
lon: 24.988481
},
{
id: "U3RvcDpIU0w6OTY1MTAwOQ==",
lat: 60.394039,
lon: 24.986352
},
{
id: "U3RvcDpIU0w6OTY1MTAwNA==",
lat: 60.399132,
lon: 24.982543
},
{
id: "U3RvcDpIU0w6OTY1MTAxMg==",
lat: 60.402549,
lon: 24.989306
},
{
id: "U3RvcDpIU0w6OTY1MTAxMA==",
lat: 60.403621,
lon: 24.993351
},
{
id: "U3RvcDpIU0w6OTY1MTAyNg==",
lat: 60.405089,
lon: 24.999478
},
{
id: "U3RvcDpIU0w6OTY1MTAwMQ==",
lat: 60.405361,
lon: 25.002492
},
{
id: "U3RvcDpIU0w6OTY1MDkwMA==",
lat: 60.406062,
lon: 25.009508
},
{
id: "U3RvcDpIU0w6OTY1MDkwMg==",
lat: 60.405499,
lon: 25.012577
},
{
id: "U3RvcDpIU0w6OTY1MDMwMw==",
lat: 60.4033,
lon: 25.02419
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
}
]
},
{
gtfsId: "HSL:1018N",
shortName: "18N",
longName: "Hernesaari-Kamppi- Munkkivuori",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTIwNDEwMQ==",
lat: 60.148283,
lon: 24.923295
},
{
id: "U3RvcDpIU0w6MTIwNDExNQ==",
lat: 60.148991,
lon: 24.926635
},
{
id: "U3RvcDpIU0w6MTIwNDExMw==",
lat: 60.15253,
lon: 24.93034
},
{
id: "U3RvcDpIU0w6MTIwNDExOA==",
lat: 60.15427,
lon: 24.93177
},
{
id: "U3RvcDpIU0w6MTIwNDEwOQ==",
lat: 60.15611,
lon: 24.93037
},
{
id: "U3RvcDpIU0w6MTIwNDExMQ==",
lat: 60.15744,
lon: 24.932268
},
{
id: "U3RvcDpIU0w6MTA1MDExNQ==",
lat: 60.157802,
lon: 24.935992
},
{
id: "U3RvcDpIU0w6MTA2MDEwNA==",
lat: 60.158277,
lon: 24.94121
},
{
id: "U3RvcDpIU0w6MTA1MDEwOA==",
lat: 60.161274,
lon: 24.941349
},
{
id: "U3RvcDpIU0w6MTA1MDEwNg==",
lat: 60.16288,
lon: 24.93909
},
{
id: "U3RvcDpIU0w6MTA0MDEyMw==",
lat: 60.16494,
lon: 24.93622
},
{
id: "U3RvcDpIU0w6MTA0MDEyNQ==",
lat: 60.167257,
lon: 24.933017
},
{
id: "U3RvcDpIU0w6MTA0MDE0NA==",
lat: 60.169432,
lon: 24.930045
},
{
id: "U3RvcDpIU0w6MTEzMDExMA==",
lat: 60.17209,
lon: 24.92367
},
{
id: "U3RvcDpIU0w6MTEzMDEwMw==",
lat: 60.175862,
lon: 24.922297
},
{
id: "U3RvcDpIU0w6MTE0MDEyNw==",
lat: 60.180264,
lon: 24.921903
},
{
id: "U3RvcDpIU0w6MTE0MDEyOQ==",
lat: 60.18153,
lon: 24.92058
},
{
id: "U3RvcDpIU0w6MTE0MDEzMQ==",
lat: 60.18341,
lon: 24.91852
},
{
id: "U3RvcDpIU0w6MTE0MDEzMw==",
lat: 60.18581,
lon: 24.91596
},
{
id: "U3RvcDpIU0w6MTE1MDEwNw==",
lat: 60.189912,
lon: 24.909831
},
{
id: "U3RvcDpIU0w6MTE1MDEwOQ==",
lat: 60.19067,
lon: 24.90781
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTE0OA==",
lat: 60.197065,
lon: 24.88267
},
{
id: "U3RvcDpIU0w6MTMwMTE0Nw==",
lat: 60.198302,
lon: 24.876747
},
{
id: "U3RvcDpIU0w6MTMwMTE0Ng==",
lat: 60.201122,
lon: 24.875988
},
{
id: "U3RvcDpIU0w6MTMwNDEzMA==",
lat: 60.20412,
lon: 24.86842
},
{
id: "U3RvcDpIU0w6MTMwNDEzMQ==",
lat: 60.20569,
lon: 24.8638
},
{
id: "U3RvcDpIU0w6MTMwNDEzMg==",
lat: 60.20745,
lon: 24.86424
},
{
id: "U3RvcDpIU0w6MTMwNDEzOA==",
lat: 60.20749,
lon: 24.85745
},
{
id: "U3RvcDpIU0w6MTMwNDEzMw==",
lat: 60.2091,
lon: 24.86682
},
{
id: "U3RvcDpIU0w6MTMwNDEzNA==",
lat: 60.2091,
lon: 24.8748
},
{
id: "U3RvcDpIU0w6MTMwNDEzNQ==",
lat: 60.20743,
lon: 24.87799
},
{
id: "U3RvcDpIU0w6MTMwNDEwNQ==",
lat: 60.205858,
lon: 24.87594
},
{
id: "U3RvcDpIU0w6MTMwNDE2MQ==",
lat: 60.20542,
lon: 24.87725
},
{
id: "U3RvcDpIU0w6MTMwNDEwMw==",
lat: 60.205472,
lon: 24.877963
},
{
id: "U3RvcDpIU0w6MTMwNDEyOQ==",
lat: 60.203905,
lon: 24.873805
},
{
id: "U3RvcDpIU0w6MTMwMTE0NQ==",
lat: 60.201432,
lon: 24.87506
},
{
id: "U3RvcDpIU0w6MTMwMTEwMw==",
lat: 60.197903,
lon: 24.876563
},
{
id: "U3RvcDpIU0w6MTMwMTE3MQ==",
lat: 60.19645,
lon: 24.883458
},
{
id: "U3RvcDpIU0w6MTMwMTEyNA==",
lat: 60.19618,
lon: 24.88529
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
},
{
id: "U3RvcDpIU0w6MTE1MDEwOA==",
lat: 60.188734,
lon: 24.912259
},
{
id: "U3RvcDpIU0w6MTE0MDEwNQ==",
lat: 60.18479,
lon: 24.91689
},
{
id: "U3RvcDpIU0w6MTE0MDEzMA==",
lat: 60.18142,
lon: 24.92043
},
{
id: "U3RvcDpIU0w6MTE0MDEwMw==",
lat: 60.17966,
lon: 24.92227
},
{
id: "U3RvcDpIU0w6MTEzMDEwNA==",
lat: 60.175737,
lon: 24.921831
},
{
id: "U3RvcDpIU0w6MTEzMDEzOQ==",
lat: 60.17126,
lon: 24.925464
},
{
id: "U3RvcDpIU0w6MTA0MDE0OA==",
lat: 60.169156,
lon: 24.930101
},
{
id: "U3RvcDpIU0w6MTA0MDEyNg==",
lat: 60.165618,
lon: 24.931375
},
{
id: "U3RvcDpIU0w6MTA0MDEyNA==",
lat: 60.163645,
lon: 24.934098
},
{
id: "U3RvcDpIU0w6MTA1MDEwNw==",
lat: 60.162453,
lon: 24.935799
},
{
id: "U3RvcDpIU0w6MTA1MDExMA==",
lat: 60.160876,
lon: 24.938023
},
{
id: "U3RvcDpIU0w6MTA1MDEwOQ==",
lat: 60.16061,
lon: 24.94144
},
{
id: "U3RvcDpIU0w6MTA2MDEwMw==",
lat: 60.15788,
lon: 24.94127
},
{
id: "U3RvcDpIU0w6MTIwNDEwNg==",
lat: 60.15405,
lon: 24.93159
},
{
id: "U3RvcDpIU0w6MTIwNDExNA==",
lat: 60.151931,
lon: 24.929466
},
{
id: "U3RvcDpIU0w6MTIwNDExNg==",
lat: 60.149082,
lon: 24.926715
},
{
id: "U3RvcDpIU0w6MTIwNDEwOA==",
lat: 60.14868,
lon: 24.92424
},
{
id: "U3RvcDpIU0w6MTA1MDExMg==",
lat: 60.157973,
lon: 24.939742
},
{
id: "U3RvcDpIU0w6MTA1MDExMw==",
lat: 60.15783,
lon: 24.93573
},
{
id: "U3RvcDpIU0w6MTIwNDExMg==",
lat: 60.15755,
lon: 24.93267
},
{
id: "U3RvcDpIU0w6MTIwNDExMA==",
lat: 60.155956,
lon: 24.93036
}
]
},
{
gtfsId: "HSL:7465",
shortName: "465",
longName: "Kamppi-Keimola-Syväoja",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDIxNg==",
lat: 60.18465,
lon: 24.92313
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDIwMg==",
lat: 60.19813,
lon: 24.90152
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE0NA==",
lat: 60.208778,
lon: 24.899522
},
{
id: "U3RvcDpIU0w6MTI5MjE0Ng==",
lat: 60.212458,
lon: 24.902736
},
{
id: "U3RvcDpIU0w6MTI5MzE1MA==",
lat: 60.22025,
lon: 24.90961
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mg==",
lat: 60.22861,
lon: 24.9063
},
{
id: "U3RvcDpIU0w6MTI4MTE1NA==",
lat: 60.2325,
lon: 24.90275
},
{
id: "U3RvcDpIU0w6MTMzMjEwOQ==",
lat: 60.238753,
lon: 24.897169
},
{
id: "U3RvcDpIU0w6MTMzMjExMQ==",
lat: 60.24143,
lon: 24.89447
},
{
id: "U3RvcDpIU0w6MTMzMjExMw==",
lat: 60.24563,
lon: 24.89056
},
{
id: "U3RvcDpIU0w6MTMzNDEyNg==",
lat: 60.25346,
lon: 24.88321
},
{
id: "U3RvcDpIU0w6MTMzNDEyOA==",
lat: 60.26039,
lon: 24.87731
},
{
id: "U3RvcDpIU0w6NDE2MDIxMw==",
lat: 60.26635,
lon: 24.87516
},
{
id: "U3RvcDpIU0w6NDE2MDIxNQ==",
lat: 60.27018,
lon: 24.87501
},
{
id: "U3RvcDpIU0w6NDE4MDIxNA==",
lat: 60.27398,
lon: 24.87234
},
{
id: "U3RvcDpIU0w6NDE4MDIxNg==",
lat: 60.27743,
lon: 24.86946
},
{
id: "U3RvcDpIU0w6NDE4MDIxOA==",
lat: 60.283501,
lon: 24.865481
},
{
id: "U3RvcDpIU0w6NDE4MDIyMA==",
lat: 60.2892,
lon: 24.8617
},
{
id: "U3RvcDpIU0w6NDIyMDIwMQ==",
lat: 60.313852,
lon: 24.841751
},
{
id: "U3RvcDpIU0w6NDMxMDIxOA==",
lat: 60.356043,
lon: 24.807018
},
{
id: "U3RvcDpIU0w6NDMxMDIxMA==",
lat: 60.360961,
lon: 24.807177
},
{
id: "U3RvcDpIU0w6NDMxMDIxMg==",
lat: 60.374543,
lon: 24.805901
},
{
id: "U3RvcDpIU0w6NDMxMDIxMQ==",
lat: 60.373678,
lon: 24.80553
},
{
id: "U3RvcDpIU0w6NDMxMDIwOQ==",
lat: 60.360498,
lon: 24.807107
},
{
id: "U3RvcDpIU0w6NDMxMDIxMw==",
lat: 60.354738,
lon: 24.805117
},
{
id: "U3RvcDpIU0w6NDIyMDIwMg==",
lat: 60.313429,
lon: 24.840766
},
{
id: "U3RvcDpIU0w6NDE4MDIyMQ==",
lat: 60.288826,
lon: 24.861242
},
{
id: "U3RvcDpIU0w6NDE4MDIxOQ==",
lat: 60.28404,
lon: 24.86467
},
{
id: "U3RvcDpIU0w6NDE4MDIxNw==",
lat: 60.2782,
lon: 24.86844
},
{
id: "U3RvcDpIU0w6NDE4MDIxNQ==",
lat: 60.274343,
lon: 24.871283
},
{
id: "U3RvcDpIU0w6NDE2MDIxNg==",
lat: 60.2707,
lon: 24.8746
},
{
id: "U3RvcDpIU0w6NDE2MDIxNA==",
lat: 60.2663,
lon: 24.87468
},
{
id: "U3RvcDpIU0w6MTMzNDE0NA==",
lat: 60.258375,
lon: 24.878176
},
{
id: "U3RvcDpIU0w6MTMzNDEyNw==",
lat: 60.252949,
lon: 24.883245
},
{
id: "U3RvcDpIU0w6MTMzMjExNA==",
lat: 60.24402,
lon: 24.89145
},
{
id: "U3RvcDpIU0w6MTMzMjExMg==",
lat: 60.24126,
lon: 24.89403
},
{
id: "U3RvcDpIU0w6MTMzMjExMA==",
lat: 60.23788,
lon: 24.89714
},
{
id: "U3RvcDpIU0w6MTI4MTE1NQ==",
lat: 60.23225,
lon: 24.90237
},
{
id: "U3RvcDpIU0w6MTI5MzE1Mw==",
lat: 60.22807,
lon: 24.90623
},
{
id: "U3RvcDpIU0w6MTI5MzE1NQ==",
lat: 60.21887,
lon: 24.90872
},
{
id: "U3RvcDpIU0w6MTI5MjE0NQ==",
lat: 60.21111,
lon: 24.90026
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
}
]
},
{
gtfsId: "HSL:9643",
shortName: "643",
longName: "Hakaniemi-Hyrylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MDEyMQ==",
lat: 60.401747,
lon: 25.028205
},
{
id: "U3RvcDpIU0w6OTY1MDExMQ==",
lat: 60.400819,
lon: 25.026307
},
{
id: "U3RvcDpIU0w6OTY1MDEwNQ==",
lat: 60.398721,
lon: 25.02284
},
{
id: "U3RvcDpIU0w6OTY1MTUwNA==",
lat: 60.394205,
lon: 25.021614
},
{
id: "U3RvcDpIU0w6OTY1MTUwMQ==",
lat: 60.390458,
lon: 25.023577
},
{
id: "U3RvcDpIU0w6OTY1MTcwMQ==",
lat: 60.386727,
lon: 25.025077
},
{
id: "U3RvcDpIU0w6OTY1MTYxMw==",
lat: 60.382931,
lon: 25.025434
},
{
id: "U3RvcDpIU0w6OTY1MTYwMQ==",
lat: 60.378409,
lon: 25.022339
},
{
id: "U3RvcDpIU0w6OTY1MTMxMg==",
lat: 60.374001,
lon: 25.018583
},
{
id: "U3RvcDpIU0w6OTY3MDUwMg==",
lat: 60.368227,
lon: 25.010802
},
{
id: "U3RvcDpIU0w6OTY3MDUwMA==",
lat: 60.358509,
lon: 25.000551
},
{
id: "U3RvcDpIU0w6OTY3MDUxMQ==",
lat: 60.341781,
lon: 25.004458
},
{
id: "U3RvcDpIU0w6OTY3MDUxNA==",
lat: 60.342295,
lon: 25.003129
},
{
id: "U3RvcDpIU0w6OTY3MDUxOA==",
lat: 60.339312,
lon: 25.003986
},
{
id: "U3RvcDpIU0w6OTY3MDUwNw==",
lat: 60.33588,
lon: 25.003993
},
{
id: "U3RvcDpIU0w6NDcxMDIwMg==",
lat: 60.33129,
lon: 25.00324
},
{
id: "U3RvcDpIU0w6NDcxMDIwNA==",
lat: 60.32314,
lon: 25.00089
},
{
id: "U3RvcDpIU0w6NDY3MDIwMQ==",
lat: 60.31931,
lon: 25.00022
},
{
id: "U3RvcDpIU0w6NDY3MDIyMQ==",
lat: 60.31554,
lon: 24.99887
},
{
id: "U3RvcDpIU0w6NDY3MDIxNQ==",
lat: 60.31214,
lon: 24.99851
},
{
id: "U3RvcDpIU0w6NDY4MDIzMw==",
lat: 60.30751,
lon: 24.99824
},
{
id: "U3RvcDpIU0w6NDY4MDIxOA==",
lat: 60.3012,
lon: 24.98972
},
{
id: "U3RvcDpIU0w6NDY4MDI1MA==",
lat: 60.29421,
lon: 24.98286
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mg==",
lat: 60.28722,
lon: 24.97696
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMzEyNw==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTE1MA==",
lat: 60.178205,
lon: 24.951532
},
{
id: "U3RvcDpIU0w6MTExMTExNw==",
lat: 60.179463,
lon: 24.952195
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDY4MDI1MQ==",
lat: 60.28629,
lon: 24.98319
},
{
id: "U3RvcDpIU0w6NDY4MDI0OQ==",
lat: 60.29431,
lon: 24.98431
},
{
id: "U3RvcDpIU0w6NDY4MDIxNw==",
lat: 60.29991,
lon: 24.98982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMg==",
lat: 60.307715,
lon: 24.999454
},
{
id: "U3RvcDpIU0w6NDY3MDIxNg==",
lat: 60.31302,
lon: 24.99868
},
{
id: "U3RvcDpIU0w6NDY3MDIyMA==",
lat: 60.3168,
lon: 24.99965
},
{
id: "U3RvcDpIU0w6NDY3MDIwMg==",
lat: 60.31952,
lon: 25.00066
},
{
id: "U3RvcDpIU0w6NDcxMDIwNQ==",
lat: 60.32397,
lon: 25.00108
},
{
id: "U3RvcDpIU0w6NDcxMDIwMw==",
lat: 60.33233,
lon: 25.00378
},
{
id: "U3RvcDpIU0w6OTY3MDUwNg==",
lat: 60.336877,
lon: 25.004063
},
{
id: "U3RvcDpIU0w6OTY3MDUxNQ==",
lat: 60.340337,
lon: 25.003756
},
{
id: "U3RvcDpIU0w6OTY3MDUyMQ==",
lat: 60.34271,
lon: 25.003802
},
{
id: "U3RvcDpIU0w6OTY3MDUxMg==",
lat: 60.342071,
lon: 25.005156
},
{
id: "U3RvcDpIU0w6OTY3MDUyMw==",
lat: 60.342142,
lon: 25.002158
},
{
id: "U3RvcDpIU0w6OTY3MDUwMQ==",
lat: 60.358831,
lon: 25.001472
},
{
id: "U3RvcDpIU0w6OTY3MDUwMw==",
lat: 60.368584,
lon: 25.011852
},
{
id: "U3RvcDpIU0w6OTY1MTMxMw==",
lat: 60.375518,
lon: 25.019879
},
{
id: "U3RvcDpIU0w6OTY1MTYwMg==",
lat: 60.379778,
lon: 25.023895
},
{
id: "U3RvcDpIU0w6OTY1MTYxMg==",
lat: 60.382748,
lon: 25.025649
},
{
id: "U3RvcDpIU0w6OTY1MTcwMg==",
lat: 60.385848,
lon: 25.025451
},
{
id: "U3RvcDpIU0w6OTY1MTUwMg==",
lat: 60.391748,
lon: 25.023073
},
{
id: "U3RvcDpIU0w6OTY1MTUwMw==",
lat: 60.394225,
lon: 25.021879
},
{
id: "U3RvcDpIU0w6OTY1MDEwNA==",
lat: 60.397977,
lon: 25.022502
},
{
id: "U3RvcDpIU0w6OTY1MDExMA==",
lat: 60.400624,
lon: 25.026438
},
{
id: "U3RvcDpIU0w6OTY1MDEwOQ==",
lat: 60.402133,
lon: 25.027607
}
]
},
{
gtfsId: "HSL:7346",
shortName: "346",
longName: "Helsinki-Kalajärvi-(Vihti)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyNTIyOA==",
lat: 60.333083,
lon: 24.607364
},
{
id: "U3RvcDpIU0w6MjcyNTIyNg==",
lat: 60.3272,
lon: 24.63851
},
{
id: "U3RvcDpIU0w6MjcyNTIyNA==",
lat: 60.32614,
lon: 24.64792
},
{
id: "U3RvcDpIU0w6MjcyNTIyMg==",
lat: 60.32546,
lon: 24.66288
},
{
id: "U3RvcDpIU0w6MjcyMjIyMA==",
lat: 60.3231,
lon: 24.67743
},
{
id: "U3RvcDpIU0w6MjcyMjIxOA==",
lat: 60.31928,
lon: 24.69631
},
{
id: "U3RvcDpIU0w6MjcyMjIxNg==",
lat: 60.31804,
lon: 24.70547
},
{
id: "U3RvcDpIU0w6MjcyMjIwMQ==",
lat: 60.317037,
lon: 24.71352
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIwNg==",
lat: 60.30432,
lon: 24.74926
},
{
id: "U3RvcDpIU0w6MjcyMTIwNA==",
lat: 60.30331,
lon: 24.75364
},
{
id: "U3RvcDpIU0w6MjcyMTIxMQ==",
lat: 60.30155,
lon: 24.76128
},
{
id: "U3RvcDpIU0w6MjcyMTIwMg==",
lat: 60.300467,
lon: 24.765783
},
{
id: "U3RvcDpIU0w6NDIwMDIwOA==",
lat: 60.29054,
lon: 24.78286
},
{
id: "U3RvcDpIU0w6NDIwMDIwNg==",
lat: 60.28661,
lon: 24.78718
},
{
id: "U3RvcDpIU0w6NDIwMDIwNA==",
lat: 60.28288,
lon: 24.79207
},
{
id: "U3RvcDpIU0w6NDIwMDIwMg==",
lat: 60.27836,
lon: 24.80175
},
{
id: "U3RvcDpIU0w6NDE0MDIwNg==",
lat: 60.27008,
lon: 24.80541
},
{
id: "U3RvcDpIU0w6NDE0MDIwNA==",
lat: 60.26651,
lon: 24.80758
},
{
id: "U3RvcDpIU0w6NDE0MDIwMg==",
lat: 60.26319,
lon: 24.81097
},
{
id: "U3RvcDpIU0w6NDEzMDIwNg==",
lat: 60.25993,
lon: 24.81378
},
{
id: "U3RvcDpIU0w6NDEzMDIwNA==",
lat: 60.25613,
lon: 24.81857
},
{
id: "U3RvcDpIU0w6NDEzMDIwMg==",
lat: 60.25491,
lon: 24.822517
},
{
id: "U3RvcDpIU0w6MTMyMDI5Mg==",
lat: 60.24917,
lon: 24.83552
},
{
id: "U3RvcDpIU0w6MTMyMDI5NA==",
lat: 60.24309,
lon: 24.84648
},
{
id: "U3RvcDpIU0w6MTMyMDEyMA==",
lat: 60.239267,
lon: 24.852589
},
{
id: "U3RvcDpIU0w6MTQ2MzExOA==",
lat: 60.23293,
lon: 24.86311
},
{
id: "U3RvcDpIU0w6MTI5NDEyNA==",
lat: 60.227,
lon: 24.87358
},
{
id: "U3RvcDpIU0w6MTI5NDEyMg==",
lat: 60.22447,
lon: 24.87771
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mw==",
lat: 60.21865,
lon: 24.8815
},
{
id: "U3RvcDpIU0w6MTI5MTE4MQ==",
lat: 60.215735,
lon: 24.883378
},
{
id: "U3RvcDpIU0w6MTI5MTExOQ==",
lat: 60.209999,
lon: 24.888297
},
{
id: "U3RvcDpIU0w6MTE2MDEwOQ==",
lat: 60.206997,
lon: 24.898935
},
{
id: "U3RvcDpIU0w6MTE2MDEwNw==",
lat: 60.202501,
lon: 24.898989
},
{
id: "U3RvcDpIU0w6MTE2MDEwNA==",
lat: 60.197709,
lon: 24.901115
},
{
id: "U3RvcDpIU0w6MTE4MDIwNg==",
lat: 60.19551,
lon: 24.90115
},
{
id: "U3RvcDpIU0w6MTE4MDExNQ==",
lat: 60.19182,
lon: 24.91102
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDExNg==",
lat: 60.18433,
lon: 24.92357
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE4MDIxNA==",
lat: 60.19169,
lon: 24.91203
},
{
id: "U3RvcDpIU0w6MTE4MDIwMw==",
lat: 60.19522,
lon: 24.90259
},
{
id: "U3RvcDpIU0w6MTE2MDEwMQ==",
lat: 60.19789,
lon: 24.90154
},
{
id: "U3RvcDpIU0w6MTE2MDIwNg==",
lat: 60.20521,
lon: 24.89933
},
{
id: "U3RvcDpIU0w6MTI5MTE2Nw==",
lat: 60.20825,
lon: 24.89767
},
{
id: "U3RvcDpIU0w6MTI5MTEyMA==",
lat: 60.20988,
lon: 24.88902
},
{
id: "U3RvcDpIU0w6MTI5MTE4MA==",
lat: 60.21517,
lon: 24.88415
},
{
id: "U3RvcDpIU0w6MTI5MTE4Mg==",
lat: 60.21988,
lon: 24.88124
},
{
id: "U3RvcDpIU0w6MTI5NDEyMQ==",
lat: 60.22517,
lon: 24.87707
},
{
id: "U3RvcDpIU0w6MTQ2NDEyMw==",
lat: 60.22792,
lon: 24.87272
},
{
id: "U3RvcDpIU0w6MTQ2MzExNw==",
lat: 60.23393,
lon: 24.862
},
{
id: "U3RvcDpIU0w6MTMyMDExOQ==",
lat: 60.2387,
lon: 24.85418
},
{
id: "U3RvcDpIU0w6MTMyMDI5Nw==",
lat: 60.24435,
lon: 24.84502
},
{
id: "U3RvcDpIU0w6MTMyMDI5NQ==",
lat: 60.24945,
lon: 24.83561
},
{
id: "U3RvcDpIU0w6NDEzMDIwMQ==",
lat: 60.25526,
lon: 24.82217
},
{
id: "U3RvcDpIU0w6NDEzMDIwMw==",
lat: 60.25722,
lon: 24.81692
},
{
id: "U3RvcDpIU0w6NDEzMDIwNQ==",
lat: 60.26044,
lon: 24.81385
},
{
id: "U3RvcDpIU0w6NDE0MDIwMQ==",
lat: 60.26336,
lon: 24.81133
},
{
id: "U3RvcDpIU0w6NDE0MDIwMw==",
lat: 60.26779,
lon: 24.807
},
{
id: "U3RvcDpIU0w6NDE0MDIwNQ==",
lat: 60.27025,
lon: 24.80581
},
{
id: "U3RvcDpIU0w6NDIwMDIwMQ==",
lat: 60.27705,
lon: 24.80344
},
{
id: "U3RvcDpIU0w6NDIwMDIwMw==",
lat: 60.28351,
lon: 24.79137
},
{
id: "U3RvcDpIU0w6NDIwMDIwNQ==",
lat: 60.28806,
lon: 24.78593
},
{
id: "U3RvcDpIU0w6NDIwMDIwNw==",
lat: 60.29149,
lon: 24.78204
},
{
id: "U3RvcDpIU0w6MjcyMTIwMQ==",
lat: 60.3012,
lon: 24.76346
},
{
id: "U3RvcDpIU0w6MjcyMTIwMw==",
lat: 60.30298,
lon: 24.75568
},
{
id: "U3RvcDpIU0w6MjcyMTIwNQ==",
lat: 60.30469,
lon: 24.74827
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMjIxMw==",
lat: 60.31699,
lon: 24.71427
},
{
id: "U3RvcDpIU0w6MjcyMjIxNQ==",
lat: 60.31825,
lon: 24.70452
},
{
id: "U3RvcDpIU0w6MjcyMjIxNw==",
lat: 60.31969,
lon: 24.69525
},
{
id: "U3RvcDpIU0w6MjcyMjIxOQ==",
lat: 60.32298,
lon: 24.6786
},
{
id: "U3RvcDpIU0w6MjcyNTIyMQ==",
lat: 60.32553,
lon: 24.66102
},
{
id: "U3RvcDpIU0w6MjcyNTIyMw==",
lat: 60.32644,
lon: 24.64625
},
{
id: "U3RvcDpIU0w6MjcyNTIyNQ==",
lat: 60.327888,
lon: 24.63592
},
{
id: "U3RvcDpIU0w6MjcyNTIyNw==",
lat: 60.333623,
lon: 24.606017
}
]
},
{
gtfsId: "HSL:9643N",
shortName: "643N",
longName: "Rautatientori-Hyrylä-Lahela",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTY1MTIwNQ==",
lat: 60.381389,
lon: 24.978371
},
{
id: "U3RvcDpIU0w6OTY1MTEwMg==",
lat: 60.374658,
lon: 24.972308
},
{
id: "U3RvcDpIU0w6OTY3MDIxMA==",
lat: 60.369358,
lon: 24.97256
},
{
id: "U3RvcDpIU0w6OTY3MDIwNA==",
lat: 60.366296,
lon: 24.979635
},
{
id: "U3RvcDpIU0w6OTY3MDIxMg==",
lat: 60.362805,
lon: 24.986112
},
{
id: "U3RvcDpIU0w6OTY3MDIwNg==",
lat: 60.359107,
lon: 24.99781
},
{
id: "U3RvcDpIU0w6OTY3MDMwMw==",
lat: 60.350304,
lon: 24.998045
},
{
id: "U3RvcDpIU0w6OTY3MDUyNQ==",
lat: 60.34703,
lon: 25.003354
},
{
id: "U3RvcDpIU0w6OTY3MDUyMQ==",
lat: 60.34271,
lon: 25.003802
},
{
id: "U3RvcDpIU0w6OTY3MDUzMw==",
lat: 60.343093,
lon: 25.021248
},
{
id: "U3RvcDpIU0w6OTY3MDUzMQ==",
lat: 60.339383,
lon: 25.022798
},
{
id: "U3RvcDpIU0w6NDcxMDI0Mw==",
lat: 60.336051,
lon: 25.026532
},
{
id: "U3RvcDpIU0w6NDcxMDIzOQ==",
lat: 60.33326,
lon: 25.02735
},
{
id: "U3RvcDpIU0w6NDcxMDIxNw==",
lat: 60.32983,
lon: 25.02648
},
{
id: "U3RvcDpIU0w6NDcxMDIwOQ==",
lat: 60.32633,
lon: 25.02468
},
{
id: "U3RvcDpIU0w6NDcxMDIzMQ==",
lat: 60.32451,
lon: 25.02443
},
{
id: "U3RvcDpIU0w6NDcxMDIwNw==",
lat: 60.32345,
lon: 25.01674
},
{
id: "U3RvcDpIU0w6NDY3MDIxMw==",
lat: 60.32259,
lon: 25.0127
},
{
id: "U3RvcDpIU0w6NDY3MDIxMQ==",
lat: 60.31772,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDY3MDIwNw==",
lat: 60.31545,
lon: 25.01216
},
{
id: "U3RvcDpIU0w6NDY3MDIwNA==",
lat: 60.31644,
lon: 25.00259
},
{
id: "U3RvcDpIU0w6NDY3MDIyMQ==",
lat: 60.31554,
lon: 24.99887
},
{
id: "U3RvcDpIU0w6NDY3MDIxNQ==",
lat: 60.31214,
lon: 24.99851
},
{
id: "U3RvcDpIU0w6NDY4MDIzMw==",
lat: 60.30751,
lon: 24.99824
},
{
id: "U3RvcDpIU0w6NDY4MDIxOA==",
lat: 60.3012,
lon: 24.98972
},
{
id: "U3RvcDpIU0w6NDY4MDI1MA==",
lat: 60.29421,
lon: 24.98286
},
{
id: "U3RvcDpIU0w6NDY4MDI1Mg==",
lat: 60.28722,
lon: 24.97696
},
{
id: "U3RvcDpIU0w6NDUwMDIyNA==",
lat: 60.28274,
lon: 24.97822
},
{
id: "U3RvcDpIU0w6NDUwMDIxMA==",
lat: 60.27039,
lon: 24.97244
},
{
id: "U3RvcDpIU0w6MTM1MzEwNA==",
lat: 60.25589,
lon: 24.951839
},
{
id: "U3RvcDpIU0w6MTM0MjI5OQ==",
lat: 60.24415,
lon: 24.94731
},
{
id: "U3RvcDpIU0w6MTI4MzE4Nw==",
lat: 60.23053,
lon: 24.94255
},
{
id: "U3RvcDpIU0w6MTI4NDExNg==",
lat: 60.22102,
lon: 24.945
},
{
id: "U3RvcDpIU0w6MTI1MDEwNA==",
lat: 60.21268,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTE3MzEwMg==",
lat: 60.20786,
lon: 24.94523
},
{
id: "U3RvcDpIU0w6MTE3MzExMQ==",
lat: 60.20099,
lon: 24.94455
},
{
id: "U3RvcDpIU0w6MTIyMDEwOA==",
lat: 60.19747,
lon: 24.94955
},
{
id: "U3RvcDpIU0w6MTIyMDE4Mg==",
lat: 60.19531,
lon: 24.95494
},
{
id: "U3RvcDpIU0w6MTIyMDExMQ==",
lat: 60.19201,
lon: 24.96102
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDIwNA==",
lat: 60.17165,
lon: 24.94327
},
{
id: "U3RvcDpIU0w6MTExMTE0Mg==",
lat: 60.17886,
lon: 24.95075
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEyNA==",
lat: 60.18788,
lon: 24.9632
},
{
id: "U3RvcDpIU0w6MTIyMDE4NA==",
lat: 60.19181,
lon: 24.96179
},
{
id: "U3RvcDpIU0w6MTIyMDI4Mg==",
lat: 60.19577,
lon: 24.95466
},
{
id: "U3RvcDpIU0w6MTIyMDIwNw==",
lat: 60.19788,
lon: 24.949406
},
{
id: "U3RvcDpIU0w6MTI0MDExMA==",
lat: 60.20142,
lon: 24.9454
},
{
id: "U3RvcDpIU0w6MTI1MDEwMQ==",
lat: 60.20953,
lon: 24.94534
},
{
id: "U3RvcDpIU0w6MTI1MDIwMw==",
lat: 60.21282,
lon: 24.94351
},
{
id: "U3RvcDpIU0w6MTI4NDExNQ==",
lat: 60.22117,
lon: 24.94574
},
{
id: "U3RvcDpIU0w6MTI4NDE4Ng==",
lat: 60.22978,
lon: 24.94377
},
{
id: "U3RvcDpIU0w6MTM0MjE5OA==",
lat: 60.24586,
lon: 24.94904
},
{
id: "U3RvcDpIU0w6MTM1MzEwNQ==",
lat: 60.256109,
lon: 24.953666
},
{
id: "U3RvcDpIU0w6NDUwMDIwOQ==",
lat: 60.2694,
lon: 24.97335
},
{
id: "U3RvcDpIU0w6NDUxMDI0OA==",
lat: 60.28276,
lon: 24.97933
},
{
id: "U3RvcDpIU0w6NDY4MDI1MQ==",
lat: 60.28629,
lon: 24.98319
},
{
id: "U3RvcDpIU0w6NDY4MDI0OQ==",
lat: 60.29431,
lon: 24.98431
},
{
id: "U3RvcDpIU0w6NDY4MDIxNw==",
lat: 60.29991,
lon: 24.98982
},
{
id: "U3RvcDpIU0w6NDY4MDIwMg==",
lat: 60.307715,
lon: 24.999454
},
{
id: "U3RvcDpIU0w6NDY3MDIxNg==",
lat: 60.31302,
lon: 24.99868
},
{
id: "U3RvcDpIU0w6NDY3MDIwNQ==",
lat: 60.31623,
lon: 25.0045
},
{
id: "U3RvcDpIU0w6NDY3MDIxMA==",
lat: 60.3158,
lon: 25.01389
},
{
id: "U3RvcDpIU0w6NDY3MDIxMg==",
lat: 60.3198,
lon: 25.01384
},
{
id: "U3RvcDpIU0w6NDY3MDIxNA==",
lat: 60.32302,
lon: 25.01385
},
{
id: "U3RvcDpIU0w6NDcxMDIwNg==",
lat: 60.32362,
lon: 25.01831
},
{
id: "U3RvcDpIU0w6NDcxMDIwOA==",
lat: 60.32624,
lon: 25.02493
},
{
id: "U3RvcDpIU0w6NDcxMDIxOA==",
lat: 60.32946,
lon: 25.02685
},
{
id: "U3RvcDpIU0w6NDcxMDI0NA==",
lat: 60.334368,
lon: 25.027149
},
{
id: "U3RvcDpIU0w6NDcxMDI0Mg==",
lat: 60.336744,
lon: 25.026228
},
{
id: "U3RvcDpIU0w6OTY3MDUzMg==",
lat: 60.339372,
lon: 25.023015
},
{
id: "U3RvcDpIU0w6OTY3MDUwOA==",
lat: 60.343363,
lon: 25.020459
},
{
id: "U3RvcDpIU0w6OTY3MDUxMg==",
lat: 60.342071,
lon: 25.005156
},
{
id: "U3RvcDpIU0w6OTY3MDUyMw==",
lat: 60.342142,
lon: 25.002158
},
{
id: "U3RvcDpIU0w6OTY3MDUwMQ==",
lat: 60.358831,
lon: 25.001472
},
{
id: "U3RvcDpIU0w6OTY3MDUwMw==",
lat: 60.368584,
lon: 25.011852
},
{
id: "U3RvcDpIU0w6OTY1MTMxMw==",
lat: 60.375518,
lon: 25.019879
},
{
id: "U3RvcDpIU0w6OTY1MTYwMg==",
lat: 60.379778,
lon: 25.023895
},
{
id: "U3RvcDpIU0w6OTY1MTYxMg==",
lat: 60.382748,
lon: 25.025649
},
{
id: "U3RvcDpIU0w6OTY1MTcwMg==",
lat: 60.385848,
lon: 25.025451
},
{
id: "U3RvcDpIU0w6OTY1MTUwMg==",
lat: 60.391748,
lon: 25.023073
},
{
id: "U3RvcDpIU0w6OTY1MTUwMw==",
lat: 60.394225,
lon: 25.021879
},
{
id: "U3RvcDpIU0w6OTY1MDEwNA==",
lat: 60.397977,
lon: 25.022502
},
{
id: "U3RvcDpIU0w6OTY1MDExMA==",
lat: 60.400624,
lon: 25.026438
},
{
id: "U3RvcDpIU0w6OTY1MDEyMw==",
lat: 60.401866,
lon: 25.028215
},
{
id: "U3RvcDpIU0w6OTY1MDMwMg==",
lat: 60.403526,
lon: 25.02313
},
{
id: "U3RvcDpIU0w6OTY1MDkwMw==",
lat: 60.405455,
lon: 25.013213
},
{
id: "U3RvcDpIU0w6OTY1MDkwMQ==",
lat: 60.406126,
lon: 25.009112
},
{
id: "U3RvcDpIU0w6OTY1MTAwMA==",
lat: 60.405733,
lon: 25.004427
},
{
id: "U3RvcDpIU0w6OTY1MTAyNQ==",
lat: 60.405001,
lon: 24.998075
},
{
id: "U3RvcDpIU0w6OTY1MTAxMQ==",
lat: 60.403581,
lon: 24.992938
},
{
id: "U3RvcDpIU0w6OTY1MTAxMw==",
lat: 60.401747,
lon: 24.986525
},
{
id: "U3RvcDpIU0w6OTY1MTAwNQ==",
lat: 60.398272,
lon: 24.981927
},
{
id: "U3RvcDpIU0w6OTY1MTAwOA==",
lat: 60.394614,
lon: 24.985621
},
{
id: "U3RvcDpIU0w6OTY1MTIwNw==",
lat: 60.388511,
lon: 24.988179
},
{
id: "U3RvcDpIU0w6OTY1MTIwMQ==",
lat: 60.386628,
lon: 24.98607
}
]
},
{
gtfsId: "HSL:9994K",
shortName: "994K",
longName: "Söderkulla-Gumbostrand",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIwODI1NQ==",
lat: 60.298851,
lon: 25.337327
},
{
id: "U3RvcDpIU0w6OTIwODIxNA==",
lat: 60.298227,
lon: 25.329072
},
{
id: "U3RvcDpIU0w6OTIwODIxMA==",
lat: 60.297008,
lon: 25.322927
},
{
id: "U3RvcDpIU0w6OTIxMDIxMQ==",
lat: 60.292553,
lon: 25.311915
},
{
id: "U3RvcDpIU0w6OTIxMDIwOQ==",
lat: 60.290293,
lon: 25.307124
},
{
id: "U3RvcDpIU0w6OTIxMDIwOA==",
lat: 60.287115,
lon: 25.301985
},
{
id: "U3RvcDpIU0w6OTIxMDIwNg==",
lat: 60.284302,
lon: 25.298328
},
{
id: "U3RvcDpIU0w6OTIxMDIwMw==",
lat: 60.279217,
lon: 25.291527
},
{
id: "U3RvcDpIU0w6OTIwNDIwMQ==",
lat: 60.274445,
lon: 25.28587
},
{
id: "U3RvcDpIU0w6OTIwNDIxMA==",
lat: 60.269652,
lon: 25.285145
},
{
id: "U3RvcDpIU0w6OTIwNDIxMQ==",
lat: 60.262999,
lon: 25.285848
},
{
id: "U3RvcDpIU0w6OTIwNDIxNQ==",
lat: 60.258807,
lon: 25.288242
},
{
id: "U3RvcDpIU0w6OTIwNDIxNg==",
lat: 60.2558,
lon: 25.294289
},
{
id: "U3RvcDpIU0w6OTIwODIxNg==",
lat: 60.29934,
lon: 25.33039
},
{
id: "U3RvcDpIU0w6OTIwODIxMw==",
lat: 60.301052,
lon: 25.327132
},
{
id: "U3RvcDpIU0w6OTIwNDIxNA==",
lat: 60.259268,
lon: 25.287866
},
{
id: "U3RvcDpIU0w6OTIwNDIxMw==",
lat: 60.263888,
lon: 25.287839
},
{
id: "U3RvcDpIU0w6OTIwNDIwOQ==",
lat: 60.27005,
lon: 25.285327
},
{
id: "U3RvcDpIU0w6OTIwNDIxMg==",
lat: 60.275142,
lon: 25.287136
},
{
id: "U3RvcDpIU0w6OTIxMDIwNA==",
lat: 60.280193,
lon: 25.293077
},
{
id: "U3RvcDpIU0w6OTIxMDIwNw==",
lat: 60.285534,
lon: 25.300471
},
{
id: "U3RvcDpIU0w6OTIxMDIxMA==",
lat: 60.290757,
lon: 25.308611
},
{
id: "U3RvcDpIU0w6OTIxMDIxMg==",
lat: 60.292936,
lon: 25.313265
},
{
id: "U3RvcDpIU0w6OTIwODIxMQ==",
lat: 60.297276,
lon: 25.324799
},
{
id: "U3RvcDpIU0w6OTIwODIxNw==",
lat: 60.298236,
lon: 25.331673
},
{
id: "U3RvcDpIU0w6OTIwODIxMg==",
lat: 60.300798,
lon: 25.32663
}
]
},
{
gtfsId: "HSL:9788K",
shortName: "788K",
longName: "Rautatientori-Kuninkaanmäki-Nikkilä-Hinthaara-Porvoo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTMwMDIwMQ==",
lat: 60.392996,
lon: 25.663648
},
{
id: "U3RvcDpIU0w6OTMwMDIzNw==",
lat: 60.392675,
lon: 25.65431
},
{
id: "U3RvcDpIU0w6OTMwMDIzNQ==",
lat: 60.3913,
lon: 25.648302
},
{
id: "U3RvcDpIU0w6OTMwMDIzMw==",
lat: 60.390603,
lon: 25.637555
},
{
id: "U3RvcDpIU0w6OTMwMDIzMQ==",
lat: 60.390549,
lon: 25.629824
},
{
id: "U3RvcDpIU0w6OTMwMDIyOQ==",
lat: 60.39233,
lon: 25.609066
},
{
id: "U3RvcDpIU0w6OTMwMDIyNw==",
lat: 60.391679,
lon: 25.605135
},
{
id: "U3RvcDpIU0w6OTMwMDIyNQ==",
lat: 60.391167,
lon: 25.591857
},
{
id: "U3RvcDpIU0w6OTMwMDIyMw==",
lat: 60.390711,
lon: 25.58157
},
{
id: "U3RvcDpIU0w6OTMwMDIyMQ==",
lat: 60.388313,
lon: 25.5731
},
{
id: "U3RvcDpIU0w6OTMwMDIxOQ==",
lat: 60.389326,
lon: 25.559222
},
{
id: "U3RvcDpIU0w6OTMwMDIxNw==",
lat: 60.387959,
lon: 25.547971
},
{
id: "U3RvcDpIU0w6OTMwMDIxNQ==",
lat: 60.391696,
lon: 25.540238
},
{
id: "U3RvcDpIU0w6OTMwMDIxMw==",
lat: 60.393414,
lon: 25.534173
},
{
id: "U3RvcDpIU0w6OTMwMDIxMQ==",
lat: 60.397024,
lon: 25.51819
},
{
id: "U3RvcDpIU0w6OTMwMDIwOQ==",
lat: 60.398088,
lon: 25.509397
},
{
id: "U3RvcDpIU0w6OTMwMDIwNw==",
lat: 60.399488,
lon: 25.492408
},
{
id: "U3RvcDpIU0w6OTMwMDIwMw==",
lat: 60.399923,
lon: 25.48041
},
{
id: "U3RvcDpIU0w6OTMwMDI1Nw==",
lat: 60.397593,
lon: 25.473874
},
{
id: "U3RvcDpIU0w6OTMwMDI1NQ==",
lat: 60.395964,
lon: 25.459858
},
{
id: "U3RvcDpIU0w6OTMwMDI1Mw==",
lat: 60.3948,
lon: 25.44965
},
{
id: "U3RvcDpIU0w6OTMwMDI1MQ==",
lat: 60.395104,
lon: 25.436971
},
{
id: "U3RvcDpIU0w6OTMwMDI0OQ==",
lat: 60.393263,
lon: 25.426317
},
{
id: "U3RvcDpIU0w6OTMwMDI0Nw==",
lat: 60.390545,
lon: 25.419174
},
{
id: "U3RvcDpIU0w6OTMwMDI0NQ==",
lat: 60.386483,
lon: 25.410225
},
{
id: "U3RvcDpIU0w6OTMwMDI0Mw==",
lat: 60.383481,
lon: 25.401751
},
{
id: "U3RvcDpIU0w6OTMwMDI0MQ==",
lat: 60.382141,
lon: 25.394954
},
{
id: "U3RvcDpIU0w6OTMwMDIzOQ==",
lat: 60.380604,
lon: 25.385213
},
{
id: "U3RvcDpIU0w6OTIyODIxMQ==",
lat: 60.375512,
lon: 25.353321
},
{
id: "U3RvcDpIU0w6OTIyODIxMA==",
lat: 60.374632,
lon: 25.343212
},
{
id: "U3RvcDpIU0w6OTIyODIwOQ==",
lat: 60.372538,
lon: 25.338537
},
{
id: "U3RvcDpIU0w6OTIyODIwOA==",
lat: 60.37081,
lon: 25.33492
},
{
id: "U3RvcDpIU0w6OTIyODIwNw==",
lat: 60.36993,
lon: 25.328368
},
{
id: "U3RvcDpIU0w6OTIyODIwNg==",
lat: 60.368545,
lon: 25.320832
},
{
id: "U3RvcDpIU0w6OTIyODIwNA==",
lat: 60.367617,
lon: 25.301282
},
{
id: "U3RvcDpIU0w6OTIyODIwMQ==",
lat: 60.370982,
lon: 25.297348
},
{
id: "U3RvcDpIU0w6OTIyMzIwOQ==",
lat: 60.372798,
lon: 25.29157
},
{
id: "U3RvcDpIU0w6OTIyMzIwNg==",
lat: 60.374383,
lon: 25.284143
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
},
{
id: "U3RvcDpIU0w6OTIyMjIyNw==",
lat: 60.377197,
lon: 25.263602
},
{
id: "U3RvcDpIU0w6OTIyMjIxOQ==",
lat: 60.376202,
lon: 25.257745
},
{
id: "U3RvcDpIU0w6OTIyMjIxMg==",
lat: 60.373653,
lon: 25.250247
},
{
id: "U3RvcDpIU0w6OTIyMjIwNQ==",
lat: 60.371072,
lon: 25.239792
},
{
id: "U3RvcDpIU0w6OTIxNjIxMQ==",
lat: 60.368428,
lon: 25.230412
},
{
id: "U3RvcDpIU0w6OTIxNjIwOQ==",
lat: 60.365565,
lon: 25.224187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNw==",
lat: 60.361667,
lon: 25.213187
},
{
id: "U3RvcDpIU0w6OTIxNjIwNQ==",
lat: 60.361128,
lon: 25.205277
},
{
id: "U3RvcDpIU0w6OTIxNjIwMg==",
lat: 60.36037,
lon: 25.193757
},
{
id: "U3RvcDpIU0w6OTIxNDIyNA==",
lat: 60.359773,
lon: 25.180833
},
{
id: "U3RvcDpIU0w6OTIxNDIyMg==",
lat: 60.358407,
lon: 25.176255
},
{
id: "U3RvcDpIU0w6OTIxNDIyMA==",
lat: 60.357083,
lon: 25.167383
},
{
id: "U3RvcDpIU0w6OTIxNDIyNw==",
lat: 60.354067,
lon: 25.158408
},
{
id: "U3RvcDpIU0w6OTIxNDIxNg==",
lat: 60.34661,
lon: 25.152565
},
{
id: "U3RvcDpIU0w6OTIxNDIyNQ==",
lat: 60.342921,
lon: 25.152253
},
{
id: "U3RvcDpIU0w6NDg2MDIyOQ==",
lat: 60.342058,
lon: 25.146987
},
{
id: "U3RvcDpIU0w6NDg2MDIzMQ==",
lat: 60.34105,
lon: 25.14113
},
{
id: "U3RvcDpIU0w6NDg2MDIwNw==",
lat: 60.34049,
lon: 25.13834
},
{
id: "U3RvcDpIU0w6NDg2MDIzMw==",
lat: 60.33938,
lon: 25.13317
},
{
id: "U3RvcDpIU0w6NDg2MDIwMg==",
lat: 60.33761,
lon: 25.13086
},
{
id: "U3RvcDpIU0w6OTIxNDIwNg==",
lat: 60.329127,
lon: 25.133099
},
{
id: "U3RvcDpIU0w6OTIxNDIwOA==",
lat: 60.32346,
lon: 25.13657
},
{
id: "U3RvcDpIU0w6NDk3MDIxNg==",
lat: 60.31884,
lon: 25.12654
},
{
id: "U3RvcDpIU0w6NDk3MDIyMg==",
lat: 60.31916,
lon: 25.11493
},
{
id: "U3RvcDpIU0w6NDk3MDIyMA==",
lat: 60.31307,
lon: 25.10852
},
{
id: "U3RvcDpIU0w6NDk3MDIxOA==",
lat: 60.304039,
lon: 25.104318
},
{
id: "U3RvcDpIU0w6NDk3MDI5Ng==",
lat: 60.30183,
lon: 25.10375
},
{
id: "U3RvcDpIU0w6NDk2MDIxNw==",
lat: 60.29775,
lon: 25.10205
},
{
id: "U3RvcDpIU0w6NDk2MDI5OQ==",
lat: 60.292049,
lon: 25.099393
},
{
id: "U3RvcDpIU0w6NDk2MDIxNQ==",
lat: 60.28741,
lon: 25.10189
},
{
id: "U3RvcDpIU0w6NDk0MDIyMw==",
lat: 60.2806,
lon: 25.10108
},
{
id: "U3RvcDpIU0w6NDkzMDIyNg==",
lat: 60.27535,
lon: 25.09522
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDEwMA==",
lat: 60.173091,
lon: 24.94329
},
{
id: "U3RvcDpIU0w6NDk3MDIxNA==",
lat: 60.31839,
lon: 25.12634
},
{
id: "U3RvcDpIU0w6NDk3MDIxMg==",
lat: 60.3094,
lon: 25.1222
},
{
id: "U3RvcDpIU0w6NDk3MDIxMA==",
lat: 60.307773,
lon: 25.114235
},
{
id: "U3RvcDpIU0w6NDk3MDI5OA==",
lat: 60.307177,
lon: 25.109792
},
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIyNQ==",
lat: 60.27255,
lon: 25.09256
},
{
id: "U3RvcDpIU0w6NDkzMDIzMA==",
lat: 60.27502,
lon: 25.09521
},
{
id: "U3RvcDpIU0w6NDk0MDIyMg==",
lat: 60.28128,
lon: 25.102
},
{
id: "U3RvcDpIU0w6NDk2MDIxNA==",
lat: 60.2883,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6NDk2MDI5OA==",
lat: 60.293118,
lon: 25.099951
},
{
id: "U3RvcDpIU0w6NDk2MDIxNg==",
lat: 60.2979,
lon: 25.10244
},
{
id: "U3RvcDpIU0w6NDk3MDI5Nw==",
lat: 60.30293,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6NDk3MDIxNw==",
lat: 60.30573,
lon: 25.10498
},
{
id: "U3RvcDpIU0w6NDk3MDIxOQ==",
lat: 60.31407,
lon: 25.10985
},
{
id: "U3RvcDpIU0w6NDk3MDIyMQ==",
lat: 60.31937,
lon: 25.11534
},
{
id: "U3RvcDpIU0w6NDk3MDIxNQ==",
lat: 60.32003,
lon: 25.12451
},
{
id: "U3RvcDpIU0w6NDk3MDIxMw==",
lat: 60.31868,
lon: 25.12728
},
{
id: "U3RvcDpIU0w6OTIxNDIwOQ==",
lat: 60.324263,
lon: 25.137407
},
{
id: "U3RvcDpIU0w6OTIxNDIwNQ==",
lat: 60.329622,
lon: 25.13404
},
{
id: "U3RvcDpIU0w6NDg2MDIwMQ==",
lat: 60.336937,
lon: 25.131358
},
{
id: "U3RvcDpIU0w6NDg2MDIzNA==",
lat: 60.33946,
lon: 25.13387
},
{
id: "U3RvcDpIU0w6NDg2MDIzMg==",
lat: 60.34099,
lon: 25.14079
},
{
id: "U3RvcDpIU0w6NDg2MDIzMA==",
lat: 60.34199,
lon: 25.14701
},
{
id: "U3RvcDpIU0w6OTIxNDIyNg==",
lat: 60.342592,
lon: 25.152172
},
{
id: "U3RvcDpIU0w6OTIxNDIxNw==",
lat: 60.347115,
lon: 25.152818
},
{
id: "U3RvcDpIU0w6OTIxNDIxOQ==",
lat: 60.35473,
lon: 25.15923
},
{
id: "U3RvcDpIU0w6OTIxNDIyMQ==",
lat: 60.357143,
lon: 25.168667
},
{
id: "U3RvcDpIU0w6OTIxNDIyMw==",
lat: 60.35865,
lon: 25.178128
},
{
id: "U3RvcDpIU0w6OTIxNjIwMQ==",
lat: 60.35998,
lon: 25.182357
},
{
id: "U3RvcDpIU0w6OTIxNjIwMw==",
lat: 60.360322,
lon: 25.196298
},
{
id: "U3RvcDpIU0w6OTIxNjIwNg==",
lat: 60.360912,
lon: 25.207367
},
{
id: "U3RvcDpIU0w6OTIxNjIwOA==",
lat: 60.361942,
lon: 25.215232
},
{
id: "U3RvcDpIU0w6OTIxNjIxMA==",
lat: 60.365972,
lon: 25.225338
},
{
id: "U3RvcDpIU0w6OTIxNjIxMg==",
lat: 60.368757,
lon: 25.23185
},
{
id: "U3RvcDpIU0w6OTIyMjIwNg==",
lat: 60.371222,
lon: 25.241545
},
{
id: "U3RvcDpIU0w6OTIyMjIxMw==",
lat: 60.374073,
lon: 25.252023
},
{
id: "U3RvcDpIU0w6OTIyMjIyMw==",
lat: 60.376493,
lon: 25.259803
},
{
id: "U3RvcDpIU0w6OTIyMjIyOA==",
lat: 60.376918,
lon: 25.265687
},
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMzIwNw==",
lat: 60.37368,
lon: 25.286597
},
{
id: "U3RvcDpIU0w6OTIyMzIxMA==",
lat: 60.372358,
lon: 25.29282
},
{
id: "U3RvcDpIU0w6OTIyODIwMg==",
lat: 60.370258,
lon: 25.2979
},
{
id: "U3RvcDpIU0w6OTIyODIwNQ==",
lat: 60.36726,
lon: 25.301515
},
{
id: "U3RvcDpIU0w6OTIyMTIwMw==",
lat: 60.367635,
lon: 25.306268
},
{
id: "U3RvcDpIU0w6OTIyMTIwNA==",
lat: 60.368627,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyMTIwNQ==",
lat: 60.370042,
lon: 25.329923
},
{
id: "U3RvcDpIU0w6OTIyMTIwNw==",
lat: 60.37197,
lon: 25.33759
},
{
id: "U3RvcDpIU0w6OTIyMTIwOA==",
lat: 60.374532,
lon: 25.343738
},
{
id: "U3RvcDpIU0w6OTIyMTIwOQ==",
lat: 60.375335,
lon: 25.35389
},
{
id: "U3RvcDpIU0w6OTMwMDI0MA==",
lat: 60.380053,
lon: 25.383648
},
{
id: "U3RvcDpIU0w6OTMwMDI0Mg==",
lat: 60.382138,
lon: 25.395569
},
{
id: "U3RvcDpIU0w6OTMwMDI0NA==",
lat: 60.382916,
lon: 25.399536
},
{
id: "U3RvcDpIU0w6OTMwMDI0Ng==",
lat: 60.386293,
lon: 25.409743
},
{
id: "U3RvcDpIU0w6OTMwMDI0OA==",
lat: 60.391155,
lon: 25.420482
},
{
id: "U3RvcDpIU0w6OTMwMDI1MA==",
lat: 60.393861,
lon: 25.429046
},
{
id: "U3RvcDpIU0w6OTMwMDI1Mg==",
lat: 60.395092,
lon: 25.435522
},
{
id: "U3RvcDpIU0w6OTMwMDI1NA==",
lat: 60.394829,
lon: 25.450753
},
{
id: "U3RvcDpIU0w6OTMwMDI1Ng==",
lat: 60.395981,
lon: 25.460147
},
{
id: "U3RvcDpIU0w6OTMwMDI1OA==",
lat: 60.397453,
lon: 25.473666
},
{
id: "U3RvcDpIU0w6OTMwMDIwMg==",
lat: 60.39983,
lon: 25.480889
},
{
id: "U3RvcDpIU0w6OTMwMDIwNg==",
lat: 60.399468,
lon: 25.490812
},
{
id: "U3RvcDpIU0w6OTMwMDIwOA==",
lat: 60.397968,
lon: 25.504043
},
{
id: "U3RvcDpIU0w6OTMwMDIxMA==",
lat: 60.396853,
lon: 25.518776
},
{
id: "U3RvcDpIU0w6OTMwMDIxMg==",
lat: 60.393409,
lon: 25.533706
},
{
id: "U3RvcDpIU0w6OTMwMDIxNA==",
lat: 60.391172,
lon: 25.541072
},
{
id: "U3RvcDpIU0w6OTMwMDIxNg==",
lat: 60.388057,
lon: 25.546898
},
{
id: "U3RvcDpIU0w6OTMwMDIxOA==",
lat: 60.38933,
lon: 25.559936
},
{
id: "U3RvcDpIU0w6OTMwMDIyMA==",
lat: 60.387681,
lon: 25.570238
},
{
id: "U3RvcDpIU0w6OTMwMDIyMg==",
lat: 60.390226,
lon: 25.579652
},
{
id: "U3RvcDpIU0w6OTMwMDIyNA==",
lat: 60.39098,
lon: 25.592476
},
{
id: "U3RvcDpIU0w6OTMwMDIyNg==",
lat: 60.39204,
lon: 25.606718
},
{
id: "U3RvcDpIU0w6OTMwMDIyOA==",
lat: 60.392303,
lon: 25.609147
},
{
id: "U3RvcDpIU0w6OTMwMDIzMA==",
lat: 60.390359,
lon: 25.617548
},
{
id: "U3RvcDpIU0w6OTMwMDIzMg==",
lat: 60.390138,
lon: 25.625004
},
{
id: "U3RvcDpIU0w6OTMwMDIzNA==",
lat: 60.390487,
lon: 25.639308
},
{
id: "U3RvcDpIU0w6OTMwMDIzNg==",
lat: 60.39104,
lon: 25.647726
},
{
id: "U3RvcDpIU0w6OTMwMDIzOA==",
lat: 60.393042,
lon: 25.655838
},
{
id: "U3RvcDpIU0w6NDk3MDI0NQ==",
lat: 60.304945,
lon: 25.106319
},
{
id: "U3RvcDpIU0w6NDk3MDI5OQ==",
lat: 60.30677,
lon: 25.109677
},
{
id: "U3RvcDpIU0w6NDk3MDIzNw==",
lat: 60.307303,
lon: 25.116067
},
{
id: "U3RvcDpIU0w6NDk3MDIxMQ==",
lat: 60.30996,
lon: 25.12301
}
]
},
{
gtfsId: "HSL:2531B",
shortName: "531B",
longName: "Tiistilä-Matinkylä (M)-Olari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMyMzI0OA==",
lat: 60.1728,
lon: 24.72541
},
{
id: "U3RvcDpIU0w6MjMyMzI0Nw==",
lat: 60.17271,
lon: 24.72739
},
{
id: "U3RvcDpIU0w6MjMyMzI1MQ==",
lat: 60.17156,
lon: 24.73162
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mw==",
lat: 60.168587,
lon: 24.734538
},
{
id: "U3RvcDpIU0w6MjMyMjIxMQ==",
lat: 60.16456,
lon: 24.73676
},
{
id: "U3RvcDpIU0w6MjMxMTIxMQ==",
lat: 60.16246,
lon: 24.73833
},
{
id: "U3RvcDpIU0w6MjMxMTIwMQ==",
lat: 60.160644,
lon: 24.740316
},
{
id: "U3RvcDpIU0w6MjMxMTIwNQ==",
lat: 60.15791,
lon: 24.74276
},
{
id: "U3RvcDpIU0w6MjMxMTIwNw==",
lat: 60.15533,
lon: 24.745
},
{
id: "U3RvcDpIU0w6MjMxMTIwOA==",
lat: 60.15312,
lon: 24.74728
},
{
id: "U3RvcDpIU0w6MjMxMzIxMA==",
lat: 60.15149,
lon: 24.75032
},
{
id: "U3RvcDpIU0w6MjMxMTIxMg==",
lat: 60.14926,
lon: 24.74822
},
{
id: "U3RvcDpIU0w6MjMxMTIxNA==",
lat: 60.14808,
lon: 24.74123
},
{
id: "U3RvcDpIU0w6MjMxMjIxNg==",
lat: 60.15117,
lon: 24.73608
},
{
id: "U3RvcDpIU0w6MjMxMjIxOA==",
lat: 60.15421,
lon: 24.72872
},
{
id: "U3RvcDpIU0w6MjMxNDIyMA==",
lat: 60.15719,
lon: 24.7262
},
{
id: "U3RvcDpIU0w6MjMxMjIwMQ==",
lat: 60.157855,
lon: 24.725891
},
{
id: "U3RvcDpIU0w6MjMxNDIyMQ==",
lat: 60.15638,
lon: 24.72662
},
{
id: "U3RvcDpIU0w6MjMxMjIxOQ==",
lat: 60.15334,
lon: 24.72924
},
{
id: "U3RvcDpIU0w6MjMxMjIxNw==",
lat: 60.15029,
lon: 24.73707
},
{
id: "U3RvcDpIU0w6MjMxNTIxNQ==",
lat: 60.14763,
lon: 24.74306
},
{
id: "U3RvcDpIU0w6MjMxMTIxMw==",
lat: 60.14925,
lon: 24.74849
},
{
id: "U3RvcDpIU0w6MjMxMzIxMQ==",
lat: 60.15182,
lon: 24.74997
},
{
id: "U3RvcDpIU0w6MjMxMTIwOQ==",
lat: 60.15387,
lon: 24.74657
},
{
id: "U3RvcDpIU0w6MjMxMTIwNg==",
lat: 60.1563,
lon: 24.74446
},
{
id: "U3RvcDpIU0w6MjMxNDIwOA==",
lat: 60.161049,
lon: 24.740512
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjMyMjIxMg==",
lat: 60.164558,
lon: 24.737052
},
{
id: "U3RvcDpIU0w6MjMyMzIwNw==",
lat: 60.16695,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mg==",
lat: 60.169261,
lon: 24.734193
},
{
id: "U3RvcDpIU0w6MjMyMzI1MA==",
lat: 60.17271,
lon: 24.73068
}
]
},
{
gtfsId: "HSL:9788B",
shortName: "788B",
longName: "Nikkilä-Hinthaara-Porvoo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6OTIyMjI0Ng==",
lat: 60.37614,
lon: 25.267989
},
{
id: "U3RvcDpIU0w6OTIyMjIzOQ==",
lat: 60.373192,
lon: 25.269333
},
{
id: "U3RvcDpIU0w6OTIyMzIxMw==",
lat: 60.373177,
lon: 25.277457
},
{
id: "U3RvcDpIU0w6OTIyMzIwMw==",
lat: 60.373952,
lon: 25.279264
},
{
id: "U3RvcDpIU0w6OTIyMzIwNw==",
lat: 60.37368,
lon: 25.286597
},
{
id: "U3RvcDpIU0w6OTIyMzIxMA==",
lat: 60.372358,
lon: 25.29282
},
{
id: "U3RvcDpIU0w6OTIyODIwMg==",
lat: 60.370258,
lon: 25.2979
},
{
id: "U3RvcDpIU0w6OTIyODIwNQ==",
lat: 60.36726,
lon: 25.301515
},
{
id: "U3RvcDpIU0w6OTIyMTIwMw==",
lat: 60.367635,
lon: 25.306268
},
{
id: "U3RvcDpIU0w6OTIyMTIwNA==",
lat: 60.368627,
lon: 25.322257
},
{
id: "U3RvcDpIU0w6OTIyMTIwNQ==",
lat: 60.370042,
lon: 25.329923
},
{
id: "U3RvcDpIU0w6OTIyMTIwNw==",
lat: 60.37197,
lon: 25.33759
},
{
id: "U3RvcDpIU0w6OTIyMTIwOA==",
lat: 60.374532,
lon: 25.343738
},
{
id: "U3RvcDpIU0w6OTIyMTIwOQ==",
lat: 60.375335,
lon: 25.35389
},
{
id: "U3RvcDpIU0w6OTMwMDI0MA==",
lat: 60.380053,
lon: 25.383648
},
{
id: "U3RvcDpIU0w6OTMwMDI0Mg==",
lat: 60.382138,
lon: 25.395569
},
{
id: "U3RvcDpIU0w6OTMwMDI0NA==",
lat: 60.382916,
lon: 25.399536
},
{
id: "U3RvcDpIU0w6OTMwMDI0Ng==",
lat: 60.386293,
lon: 25.409743
},
{
id: "U3RvcDpIU0w6OTMwMDI0OA==",
lat: 60.391155,
lon: 25.420482
},
{
id: "U3RvcDpIU0w6OTMwMDI1MA==",
lat: 60.393861,
lon: 25.429046
},
{
id: "U3RvcDpIU0w6OTMwMDI1Mg==",
lat: 60.395092,
lon: 25.435522
},
{
id: "U3RvcDpIU0w6OTMwMDI1NA==",
lat: 60.394829,
lon: 25.450753
},
{
id: "U3RvcDpIU0w6OTMwMDI1Ng==",
lat: 60.395981,
lon: 25.460147
},
{
id: "U3RvcDpIU0w6OTMwMDI1OA==",
lat: 60.397453,
lon: 25.473666
},
{
id: "U3RvcDpIU0w6OTMwMDIwMg==",
lat: 60.39983,
lon: 25.480889
},
{
id: "U3RvcDpIU0w6OTMwMDIwNg==",
lat: 60.399468,
lon: 25.490812
},
{
id: "U3RvcDpIU0w6OTMwMDIwOA==",
lat: 60.397968,
lon: 25.504043
},
{
id: "U3RvcDpIU0w6OTMwMDIxMA==",
lat: 60.396853,
lon: 25.518776
},
{
id: "U3RvcDpIU0w6OTMwMDIxMg==",
lat: 60.393409,
lon: 25.533706
},
{
id: "U3RvcDpIU0w6OTMwMDIxNA==",
lat: 60.391172,
lon: 25.541072
},
{
id: "U3RvcDpIU0w6OTMwMDIxNg==",
lat: 60.388057,
lon: 25.546898
},
{
id: "U3RvcDpIU0w6OTMwMDIxOA==",
lat: 60.38933,
lon: 25.559936
},
{
id: "U3RvcDpIU0w6OTMwMDIyMA==",
lat: 60.387681,
lon: 25.570238
},
{
id: "U3RvcDpIU0w6OTMwMDIyMg==",
lat: 60.390226,
lon: 25.579652
},
{
id: "U3RvcDpIU0w6OTMwMDIyNA==",
lat: 60.39098,
lon: 25.592476
},
{
id: "U3RvcDpIU0w6OTMwMDIyNg==",
lat: 60.39204,
lon: 25.606718
},
{
id: "U3RvcDpIU0w6OTMwMDIyOA==",
lat: 60.392303,
lon: 25.609147
},
{
id: "U3RvcDpIU0w6OTMwMDIzMA==",
lat: 60.390359,
lon: 25.617548
},
{
id: "U3RvcDpIU0w6OTMwMDIzMg==",
lat: 60.390138,
lon: 25.625004
},
{
id: "U3RvcDpIU0w6OTMwMDIzNA==",
lat: 60.390487,
lon: 25.639308
},
{
id: "U3RvcDpIU0w6OTMwMDIzNg==",
lat: 60.39104,
lon: 25.647726
},
{
id: "U3RvcDpIU0w6OTMwMDIzOA==",
lat: 60.393042,
lon: 25.655838
},
{
id: "U3RvcDpIU0w6OTMwMDIwMQ==",
lat: 60.392996,
lon: 25.663648
},
{
id: "U3RvcDpIU0w6OTMwMDIzNw==",
lat: 60.392675,
lon: 25.65431
},
{
id: "U3RvcDpIU0w6OTMwMDIzNQ==",
lat: 60.3913,
lon: 25.648302
},
{
id: "U3RvcDpIU0w6OTMwMDIzMw==",
lat: 60.390603,
lon: 25.637555
},
{
id: "U3RvcDpIU0w6OTMwMDIzMQ==",
lat: 60.390549,
lon: 25.629824
},
{
id: "U3RvcDpIU0w6OTMwMDIyOQ==",
lat: 60.39233,
lon: 25.609066
},
{
id: "U3RvcDpIU0w6OTMwMDIyNw==",
lat: 60.391679,
lon: 25.605135
},
{
id: "U3RvcDpIU0w6OTMwMDIyNQ==",
lat: 60.391167,
lon: 25.591857
},
{
id: "U3RvcDpIU0w6OTMwMDIyMw==",
lat: 60.390711,
lon: 25.58157
},
{
id: "U3RvcDpIU0w6OTMwMDIyMQ==",
lat: 60.388313,
lon: 25.5731
},
{
id: "U3RvcDpIU0w6OTMwMDIxOQ==",
lat: 60.389326,
lon: 25.559222
},
{
id: "U3RvcDpIU0w6OTMwMDIxNw==",
lat: 60.387959,
lon: 25.547971
},
{
id: "U3RvcDpIU0w6OTMwMDIxNQ==",
lat: 60.391696,
lon: 25.540238
},
{
id: "U3RvcDpIU0w6OTMwMDIxMw==",
lat: 60.393414,
lon: 25.534173
},
{
id: "U3RvcDpIU0w6OTMwMDIxMQ==",
lat: 60.397024,
lon: 25.51819
},
{
id: "U3RvcDpIU0w6OTMwMDIwOQ==",
lat: 60.398088,
lon: 25.509397
},
{
id: "U3RvcDpIU0w6OTMwMDIwNw==",
lat: 60.399488,
lon: 25.492408
},
{
id: "U3RvcDpIU0w6OTMwMDIwMw==",
lat: 60.399923,
lon: 25.48041
},
{
id: "U3RvcDpIU0w6OTMwMDI1Nw==",
lat: 60.397593,
lon: 25.473874
},
{
id: "U3RvcDpIU0w6OTMwMDI1NQ==",
lat: 60.395964,
lon: 25.459858
},
{
id: "U3RvcDpIU0w6OTMwMDI1Mw==",
lat: 60.3948,
lon: 25.44965
},
{
id: "U3RvcDpIU0w6OTMwMDI1MQ==",
lat: 60.395104,
lon: 25.436971
},
{
id: "U3RvcDpIU0w6OTMwMDI0OQ==",
lat: 60.393263,
lon: 25.426317
},
{
id: "U3RvcDpIU0w6OTMwMDI0Nw==",
lat: 60.390545,
lon: 25.419174
},
{
id: "U3RvcDpIU0w6OTMwMDI0NQ==",
lat: 60.386483,
lon: 25.410225
},
{
id: "U3RvcDpIU0w6OTMwMDI0Mw==",
lat: 60.383481,
lon: 25.401751
},
{
id: "U3RvcDpIU0w6OTMwMDI0MQ==",
lat: 60.382141,
lon: 25.394954
},
{
id: "U3RvcDpIU0w6OTMwMDIzOQ==",
lat: 60.380604,
lon: 25.385213
},
{
id: "U3RvcDpIU0w6OTIyODIxMQ==",
lat: 60.375512,
lon: 25.353321
},
{
id: "U3RvcDpIU0w6OTIyODIxMA==",
lat: 60.374632,
lon: 25.343212
},
{
id: "U3RvcDpIU0w6OTIyODIwOQ==",
lat: 60.372538,
lon: 25.338537
},
{
id: "U3RvcDpIU0w6OTIyODIwOA==",
lat: 60.37081,
lon: 25.33492
},
{
id: "U3RvcDpIU0w6OTIyODIwNw==",
lat: 60.36993,
lon: 25.328368
},
{
id: "U3RvcDpIU0w6OTIyODIwNg==",
lat: 60.368545,
lon: 25.320832
},
{
id: "U3RvcDpIU0w6OTIyODIwNA==",
lat: 60.367617,
lon: 25.301282
},
{
id: "U3RvcDpIU0w6OTIyODIwMQ==",
lat: 60.370982,
lon: 25.297348
},
{
id: "U3RvcDpIU0w6OTIyMzIwOQ==",
lat: 60.372798,
lon: 25.29157
},
{
id: "U3RvcDpIU0w6OTIyMzIwNg==",
lat: 60.374383,
lon: 25.284143
},
{
id: "U3RvcDpIU0w6OTIyMzIwMg==",
lat: 60.374358,
lon: 25.278789
},
{
id: "U3RvcDpIU0w6OTIyMzIxMg==",
lat: 60.373375,
lon: 25.275361
},
{
id: "U3RvcDpIU0w6OTIyMzIwMQ==",
lat: 60.373275,
lon: 25.26957
},
{
id: "U3RvcDpIU0w6OTIyMjI0NQ==",
lat: 60.376205,
lon: 25.268411
}
]
},
{
gtfsId: "HSL:6913B",
shortName: "913B",
longName: "Kuntakeskus-Karskog",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMzAwOA==",
lat: 60.17316,
lon: 24.28346
},
{
id: "U3RvcDpIU0w6NjMwMzAwNA==",
lat: 60.190251,
lon: 24.269025
},
{
id: "U3RvcDpIU0w6NjMwMzAwMg==",
lat: 60.193857,
lon: 24.261159
},
{
id: "U3RvcDpIU0w6NjMwMTAwMg==",
lat: 60.194368,
lon: 24.251792
},
{
id: "U3RvcDpIU0w6NjMwMTAxNg==",
lat: 60.188088,
lon: 24.245
},
{
id: "U3RvcDpIU0w6NjMwMTAwMQ==",
lat: 60.184142,
lon: 24.239233
},
{
id: "U3RvcDpIU0w6NjMwMTA0Ng==",
lat: 60.180368,
lon: 24.234423
},
{
id: "U3RvcDpIU0w6NjMwMTAyNQ==",
lat: 60.178408,
lon: 24.225049
},
{
id: "U3RvcDpIU0w6NjMwMTAxMQ==",
lat: 60.172765,
lon: 24.206878
},
{
id: "U3RvcDpIU0w6NjMwMTA1Mg==",
lat: 60.170375,
lon: 24.200431
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAxNg==",
lat: 60.133773,
lon: 24.229992
},
{
id: "U3RvcDpIU0w6NjMwMjAwMQ==",
lat: 60.128729,
lon: 24.232488
},
{
id: "U3RvcDpIU0w6NjMwMjAwOQ==",
lat: 60.120639,
lon: 24.239353
},
{
id: "U3RvcDpIU0w6NjMwNDAxMQ==",
lat: 60.109771,
lon: 24.27025
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNjAwNQ==",
lat: 60.105749,
lon: 24.291215
},
{
id: "U3RvcDpIU0w6NjMwNjAwMw==",
lat: 60.114029,
lon: 24.300907
},
{
id: "U3RvcDpIU0w6NjMwMjAyNA==",
lat: 60.141303,
lon: 24.263845
}
]
},
{
gtfsId: "HSL:6913A",
shortName: "913A",
longName: "Kuntakeskus-Karskog",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMzAwNw==",
lat: 60.172658,
lon: 24.283591
},
{
id: "U3RvcDpIU0w6NjMwMjAyMw==",
lat: 60.140859,
lon: 24.264659
},
{
id: "U3RvcDpIU0w6NjMwNjAwMg==",
lat: 60.11389,
lon: 24.300788
},
{
id: "U3RvcDpIU0w6NjMwNjAwNA==",
lat: 60.106052,
lon: 24.290729
},
{
id: "U3RvcDpIU0w6NjMwNzAwNg==",
lat: 60.09981,
lon: 24.299634
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAxMA==",
lat: 60.097766,
lon: 24.288409
},
{
id: "U3RvcDpIU0w6NjMwNDAxMg==",
lat: 60.109782,
lon: 24.270426
},
{
id: "U3RvcDpIU0w6NjMwMjAwNQ==",
lat: 60.117387,
lon: 24.241306
},
{
id: "U3RvcDpIU0w6NjMwMjAwOA==",
lat: 60.121106,
lon: 24.239152
},
{
id: "U3RvcDpIU0w6NjMwMjAwMA==",
lat: 60.130476,
lon: 24.232493
},
{
id: "U3RvcDpIU0w6NjMwMjAxNw==",
lat: 60.135228,
lon: 24.228995
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAyMw==",
lat: 60.165141,
lon: 24.197315
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAzMw==",
lat: 60.171361,
lon: 24.201095
},
{
id: "U3RvcDpIU0w6NjMwMTAxMA==",
lat: 60.173575,
lon: 24.210197
},
{
id: "U3RvcDpIU0w6NjMwMTAyNg==",
lat: 60.178262,
lon: 24.223798
},
{
id: "U3RvcDpIU0w6NjMwMTA0Nw==",
lat: 60.179052,
lon: 24.233051
},
{
id: "U3RvcDpIU0w6NjMwMTAwMA==",
lat: 60.184995,
lon: 24.240861
},
{
id: "U3RvcDpIU0w6NjMwMTAxNQ==",
lat: 60.189068,
lon: 24.246139
},
{
id: "U3RvcDpIU0w6NjMwMTAwMw==",
lat: 60.194916,
lon: 24.253819
},
{
id: "U3RvcDpIU0w6NjMwMzAwMQ==",
lat: 60.192339,
lon: 24.262109
}
]
},
{
gtfsId: "HSL:6912K",
shortName: "912K",
longName: "Kuntakeskus-Störsvik-Pikkala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxNg==",
lat: 60.133773,
lon: 24.229992
},
{
id: "U3RvcDpIU0w6NjMwMjAwMQ==",
lat: 60.128729,
lon: 24.232488
},
{
id: "U3RvcDpIU0w6NjMwMjAwOQ==",
lat: 60.120639,
lon: 24.239353
},
{
id: "U3RvcDpIU0w6NjMwMjAwNA==",
lat: 60.116061,
lon: 24.241087
},
{
id: "U3RvcDpIU0w6NjMwMjAxOQ==",
lat: 60.110936,
lon: 24.241778
},
{
id: "U3RvcDpIU0w6NjMwNDAwNw==",
lat: 60.102476,
lon: 24.24881
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNA==",
lat: 60.080806,
lon: 24.291003
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNzAwNA==",
lat: 60.099132,
lon: 24.303275
},
{
id: "U3RvcDpIU0w6NjMwNzAwOA==",
lat: 60.099232,
lon: 24.331415
},
{
id: "U3RvcDpIU0w6NjA3MDIzMA==",
lat: 60.097948,
lon: 24.342707
},
{
id: "U3RvcDpIU0w6NjA3MDIzMg==",
lat: 60.094845,
lon: 24.34585
}
]
},
{
gtfsId: "HSL:2510",
shortName: "510",
longName: "Herttoniemi(M)-Pasila-Meilahti-Tapiola(M)-Westendinasema",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDE1OQ==",
lat: 60.18875,
lon: 24.96923
},
{
id: "U3RvcDpIU0w6MTIyMDExOQ==",
lat: 60.18964,
lon: 24.96309
},
{
id: "U3RvcDpIU0w6MTIyMDExMg==",
lat: 60.19091,
lon: 24.95609
},
{
id: "U3RvcDpIU0w6MTIyMDEzNA==",
lat: 60.19321,
lon: 24.95005
},
{
id: "U3RvcDpIU0w6MTIyMDExNA==",
lat: 60.194732,
lon: 24.946392
},
{
id: "U3RvcDpIU0w6MTE3MzExMw==",
lat: 60.19669,
lon: 24.941768
},
{
id: "U3RvcDpIU0w6MTE3MzEyNQ==",
lat: 60.198537,
lon: 24.937137
},
{
id: "U3RvcDpIU0w6MTE3MTE1Mw==",
lat: 60.19641,
lon: 24.9288
},
{
id: "U3RvcDpIU0w6MTE4MDEyMQ==",
lat: 60.19123,
lon: 24.92366
},
{
id: "U3RvcDpIU0w6MTE1MDEzMw==",
lat: 60.1913,
lon: 24.91195
},
{
id: "U3RvcDpIU0w6MTE1MDExNg==",
lat: 60.191346,
lon: 24.906254
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTMwMTIxMg==",
lat: 60.19575,
lon: 24.8846
},
{
id: "U3RvcDpIU0w6MTMwMjIxNg==",
lat: 60.18696,
lon: 24.8681
},
{
id: "U3RvcDpIU0w6MTMwMjIxOA==",
lat: 60.184553,
lon: 24.857309
},
{
id: "U3RvcDpIU0w6MTMwMzI5OA==",
lat: 60.1816,
lon: 24.8493
},
{
id: "U3RvcDpIU0w6MjIyMjIwMQ==",
lat: 60.18023,
lon: 24.8376
},
{
id: "U3RvcDpIU0w6MjIyMjIzNA==",
lat: 60.18362,
lon: 24.82779
},
{
id: "U3RvcDpIU0w6MjIxMzIwOA==",
lat: 60.17872,
lon: 24.81654
},
{
id: "U3RvcDpIU0w6MjIxMTIxMQ==",
lat: 60.17718,
lon: 24.81083
},
{
id: "U3RvcDpIU0w6MjIxMTIxMg==",
lat: 60.175226,
lon: 24.805712
},
{
id: "U3RvcDpIU0w6MjIxMTI3NA==",
lat: 60.17223,
lon: 24.80195
},
{
id: "U3RvcDpIU0w6MjIzMTIxMw==",
lat: 60.16881,
lon: 24.80491
},
{
id: "U3RvcDpIU0w6MjIzMTIyNQ==",
lat: 60.1688,
lon: 24.804352
},
{
id: "U3RvcDpIU0w6MjIxMTI3NQ==",
lat: 60.17197,
lon: 24.80231
},
{
id: "U3RvcDpIU0w6MjIxMTIxMw==",
lat: 60.174836,
lon: 24.804387
},
{
id: "U3RvcDpIU0w6MjIxMzIxMA==",
lat: 60.17798,
lon: 24.81266
},
{
id: "U3RvcDpIU0w6MjIxMzIwOQ==",
lat: 60.17862,
lon: 24.81721
},
{
id: "U3RvcDpIU0w6MjIyMjIxMg==",
lat: 60.183766,
lon: 24.828012
},
{
id: "U3RvcDpIU0w6MjIyMjIwMg==",
lat: 60.1798,
lon: 24.83641
},
{
id: "U3RvcDpIU0w6MTMwMzExNA==",
lat: 60.18153,
lon: 24.849633
},
{
id: "U3RvcDpIU0w6MTMwMjIxOQ==",
lat: 60.18488,
lon: 24.85935
},
{
id: "U3RvcDpIU0w6MTMwMjIxNw==",
lat: 60.18716,
lon: 24.86985
},
{
id: "U3RvcDpIU0w6MTMwMTEyMg==",
lat: 60.196005,
lon: 24.886202
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExOA==",
lat: 60.19113,
lon: 24.90804
},
{
id: "U3RvcDpIU0w6MTE1MDEzNA==",
lat: 60.19095,
lon: 24.91255
},
{
id: "U3RvcDpIU0w6MTE3MTEyMg==",
lat: 60.19145,
lon: 24.92554
},
{
id: "U3RvcDpIU0w6MTE3MTE1Mg==",
lat: 60.19662,
lon: 24.92898
},
{
id: "U3RvcDpIU0w6MTE3MzEwNA==",
lat: 60.1983,
lon: 24.937373
},
{
id: "U3RvcDpIU0w6MTIyMDEzMQ==",
lat: 60.196616,
lon: 24.94209
},
{
id: "U3RvcDpIU0w6MTIyMDExNw==",
lat: 60.19528,
lon: 24.94443
},
{
id: "U3RvcDpIU0w6MTIyMDExNQ==",
lat: 60.19326,
lon: 24.94925
},
{
id: "U3RvcDpIU0w6MTIyMDExMw==",
lat: 60.19119,
lon: 24.95434
},
{
id: "U3RvcDpIU0w6MTIyMDEyMA==",
lat: 60.189463,
lon: 24.962315
},
{
id: "U3RvcDpIU0w6MTEwMDE2MA==",
lat: 60.1886,
lon: 24.96962
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzMTEwMw==",
lat: 60.19436,
lon: 25.02981
}
]
},
{
gtfsId: "HSL:2348BK",
shortName: "348BK",
longName: "Hännikäinen-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMzI0NA==",
lat: 60.34567,
lon: 24.73115
},
{
id: "U3RvcDpIU0w6MjcyMzI0Mg==",
lat: 60.34457,
lon: 24.72664
},
{
id: "U3RvcDpIU0w6MjcyMzI0MA==",
lat: 60.34214,
lon: 24.71353
},
{
id: "U3RvcDpIU0w6MjcyMzIzOA==",
lat: 60.3368,
lon: 24.71016
},
{
id: "U3RvcDpIU0w6MjcyMzIzNg==",
lat: 60.33429,
lon: 24.70989
},
{
id: "U3RvcDpIU0w6MjcyMzIzNA==",
lat: 60.32961,
lon: 24.70996
},
{
id: "U3RvcDpIU0w6MjcyMzIzMg==",
lat: 60.324161,
lon: 24.714759
},
{
id: "U3RvcDpIU0w6MjcyMzIxMA==",
lat: 60.321463,
lon: 24.717534
},
{
id: "U3RvcDpIU0w6MjcyMzIzMA==",
lat: 60.31757,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIxMw==",
lat: 60.30444,
lon: 24.74096
},
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTIxMg==",
lat: 60.305,
lon: 24.74149
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMzIyOQ==",
lat: 60.31776,
lon: 24.71642
},
{
id: "U3RvcDpIU0w6MjcyMzIxMQ==",
lat: 60.32229,
lon: 24.71755
},
{
id: "U3RvcDpIU0w6MjcyMzIzMQ==",
lat: 60.323319,
lon: 24.7162
},
{
id: "U3RvcDpIU0w6MjcyMzIzMw==",
lat: 60.32928,
lon: 24.71024
},
{
id: "U3RvcDpIU0w6MjcyMzIzNQ==",
lat: 60.33417,
lon: 24.71006
},
{
id: "U3RvcDpIU0w6MjcyMzIzNw==",
lat: 60.33689,
lon: 24.71032
},
{
id: "U3RvcDpIU0w6MjcyMzIzOQ==",
lat: 60.34191,
lon: 24.71348
},
{
id: "U3RvcDpIU0w6MjcyMzI0MQ==",
lat: 60.3446,
lon: 24.72721
}
]
},
{
gtfsId: "HSL:4739V",
shortName: "739V",
longName: "Rautatientori-Pohjois-Nikinmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExNQ==",
lat: 60.17141,
lon: 24.94266
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIyNQ==",
lat: 60.27255,
lon: 25.09256
},
{
id: "U3RvcDpIU0w6NDkzMDIzMA==",
lat: 60.27502,
lon: 25.09521
},
{
id: "U3RvcDpIU0w6NDk0MDIyMg==",
lat: 60.28128,
lon: 25.102
},
{
id: "U3RvcDpIU0w6NDk2MDIxNA==",
lat: 60.2883,
lon: 25.1012
},
{
id: "U3RvcDpIU0w6NDk2MDI5OA==",
lat: 60.293118,
lon: 25.099951
},
{
id: "U3RvcDpIU0w6NDk2MDIxNg==",
lat: 60.2979,
lon: 25.10244
},
{
id: "U3RvcDpIU0w6NDk3MDI5Nw==",
lat: 60.30293,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6NDk3MDIxNw==",
lat: 60.30573,
lon: 25.10498
},
{
id: "U3RvcDpIU0w6NDk3MDIxOQ==",
lat: 60.31407,
lon: 25.10985
},
{
id: "U3RvcDpIU0w6NDk3MDIyMQ==",
lat: 60.31937,
lon: 25.11534
},
{
id: "U3RvcDpIU0w6NDk3MDIxNQ==",
lat: 60.32003,
lon: 25.12451
},
{
id: "U3RvcDpIU0w6NDk3MDIxMw==",
lat: 60.31868,
lon: 25.12728
},
{
id: "U3RvcDpIU0w6OTIxNDIwOQ==",
lat: 60.324263,
lon: 25.137407
},
{
id: "U3RvcDpIU0w6OTIxNDIwNQ==",
lat: 60.329622,
lon: 25.13404
},
{
id: "U3RvcDpIU0w6NDg2MDIwMQ==",
lat: 60.336937,
lon: 25.131358
},
{
id: "U3RvcDpIU0w6NDg2MDIwMw==",
lat: 60.34003,
lon: 25.12899
},
{
id: "U3RvcDpIU0w6NDg2MDI0MQ==",
lat: 60.34367,
lon: 25.13171
},
{
id: "U3RvcDpIU0w6NDg2MDIyNA==",
lat: 60.3452,
lon: 25.13308
},
{
id: "U3RvcDpIU0w6NDg2MDI1Mg==",
lat: 60.347832,
lon: 25.131183
},
{
id: "U3RvcDpIU0w6NDg2MDI1NA==",
lat: 60.350746,
lon: 25.132717
},
{
id: "U3RvcDpIU0w6NDg2MDI1Ng==",
lat: 60.355147,
lon: 25.13705
},
{
id: "U3RvcDpIU0w6NDg2MDI1MA==",
lat: 60.35599,
lon: 25.14148
},
{
id: "U3RvcDpIU0w6NDg2MDI0Nw==",
lat: 60.35822,
lon: 25.14772
},
{
id: "U3RvcDpIU0w6NDg2MDIxNg==",
lat: 60.3582,
lon: 25.14771
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mw==",
lat: 60.35602,
lon: 25.13996
},
{
id: "U3RvcDpIU0w6NDg2MDI1Nw==",
lat: 60.353914,
lon: 25.137069
},
{
id: "U3RvcDpIU0w6NDg2MDI1Mw==",
lat: 60.350253,
lon: 25.131591
},
{
id: "U3RvcDpIU0w6NDg2MDI1MQ==",
lat: 60.347289,
lon: 25.13221
},
{
id: "U3RvcDpIU0w6NDg2MDIyMw==",
lat: 60.34559,
lon: 25.13249
},
{
id: "U3RvcDpIU0w6NDg2MDIwNA==",
lat: 60.33975,
lon: 25.12921
},
{
id: "U3RvcDpIU0w6NDg2MDIwMg==",
lat: 60.33761,
lon: 25.13086
},
{
id: "U3RvcDpIU0w6OTIxNDIwNg==",
lat: 60.329127,
lon: 25.133099
},
{
id: "U3RvcDpIU0w6OTIxNDIwOA==",
lat: 60.32346,
lon: 25.13657
},
{
id: "U3RvcDpIU0w6NDk3MDIxNg==",
lat: 60.31884,
lon: 25.12654
},
{
id: "U3RvcDpIU0w6NDk3MDIyMg==",
lat: 60.31916,
lon: 25.11493
},
{
id: "U3RvcDpIU0w6NDk3MDIyMA==",
lat: 60.31307,
lon: 25.10852
},
{
id: "U3RvcDpIU0w6NDk3MDIxOA==",
lat: 60.304039,
lon: 25.104318
},
{
id: "U3RvcDpIU0w6NDk3MDI5Ng==",
lat: 60.30183,
lon: 25.10375
},
{
id: "U3RvcDpIU0w6NDk2MDIxNw==",
lat: 60.29775,
lon: 25.10205
},
{
id: "U3RvcDpIU0w6NDk2MDI5OQ==",
lat: 60.292049,
lon: 25.099393
},
{
id: "U3RvcDpIU0w6NDk2MDIxNQ==",
lat: 60.28741,
lon: 25.10189
},
{
id: "U3RvcDpIU0w6NDk0MDIyMw==",
lat: 60.2806,
lon: 25.10108
},
{
id: "U3RvcDpIU0w6NDkzMDIyNg==",
lat: 60.27535,
lon: 25.09522
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4717A",
shortName: "717A",
longName: "Rautatientori-Jakomäki-Hakunila-Sotunki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDIyNw==",
lat: 60.29097,
lon: 25.11945
},
{
id: "U3RvcDpIU0w6NDk2MDIyNQ==",
lat: 60.29152,
lon: 25.11378
},
{
id: "U3RvcDpIU0w6NDk2MDIyMw==",
lat: 60.29266,
lon: 25.1126
},
{
id: "U3RvcDpIU0w6NDk2MDIyMA==",
lat: 60.29456,
lon: 25.10822
},
{
id: "U3RvcDpIU0w6NDk2MDIzNQ==",
lat: 60.29629,
lon: 25.10753
},
{
id: "U3RvcDpIU0w6NDk2MDI5NQ==",
lat: 60.29711,
lon: 25.10977
},
{
id: "U3RvcDpIU0w6NDk2MDIwNg==",
lat: 60.29764,
lon: 25.11134
},
{
id: "U3RvcDpIU0w6NDk2MDIwNw==",
lat: 60.29731,
lon: 25.11392
},
{
id: "U3RvcDpIU0w6NDk2MDIxMQ==",
lat: 60.29767,
lon: 25.12152
},
{
id: "U3RvcDpIU0w6NDk4MDIwMQ==",
lat: 60.2977,
lon: 25.12546
},
{
id: "U3RvcDpIU0w6NDk4MDIwMw==",
lat: 60.297,
lon: 25.12953
},
{
id: "U3RvcDpIU0w6NDk4MDIwNQ==",
lat: 60.29406,
lon: 25.13442
},
{
id: "U3RvcDpIU0w6NDk4MDIxOQ==",
lat: 60.29327,
lon: 25.13677
},
{
id: "U3RvcDpIU0w6NDk4MDIwNw==",
lat: 60.29198,
lon: 25.13955
},
{
id: "U3RvcDpIU0w6NDk4MDIwOQ==",
lat: 60.28843,
lon: 25.13889
},
{
id: "U3RvcDpIU0w6NDk4MDIxMQ==",
lat: 60.28449,
lon: 25.13485
},
{
id: "U3RvcDpIU0w6NDk4MDIxMw==",
lat: 60.27735,
lon: 25.13335
},
{
id: "U3RvcDpIU0w6NDk0MDIwMQ==",
lat: 60.27995,
lon: 25.12467
},
{
id: "U3RvcDpIU0w6NDk0MDIwMg==",
lat: 60.2793,
lon: 25.12528
},
{
id: "U3RvcDpIU0w6NDk4MDIxNA==",
lat: 60.27794,
lon: 25.13378
},
{
id: "U3RvcDpIU0w6NDk4MDIxMg==",
lat: 60.28507,
lon: 25.13526
},
{
id: "U3RvcDpIU0w6NDk4MDIxMA==",
lat: 60.2892,
lon: 25.13926
},
{
id: "U3RvcDpIU0w6NDk4MDIxOA==",
lat: 60.29201,
lon: 25.13969
},
{
id: "U3RvcDpIU0w6NDk4MDIwOA==",
lat: 60.29297,
lon: 25.13781
},
{
id: "U3RvcDpIU0w6NDk4MDIwNg==",
lat: 60.29396,
lon: 25.13554
},
{
id: "U3RvcDpIU0w6NDk4MDIwNA==",
lat: 60.29711,
lon: 25.12958
},
{
id: "U3RvcDpIU0w6NDk4MDIwMg==",
lat: 60.29776,
lon: 25.12568
},
{
id: "U3RvcDpIU0w6NDk2MDIxMw==",
lat: 60.29795,
lon: 25.12205
},
{
id: "U3RvcDpIU0w6NDk2MDI0MQ==",
lat: 60.29773,
lon: 25.11143
},
{
id: "U3RvcDpIU0w6NDk2MDI5NA==",
lat: 60.29714,
lon: 25.10963
},
{
id: "U3RvcDpIU0w6NDk2MDIzOA==",
lat: 60.29628,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk2MDIxOQ==",
lat: 60.29418,
lon: 25.10836
},
{
id: "U3RvcDpIU0w6NDk2MDIyMg==",
lat: 60.2927,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:6174Z",
shortName: "174Z",
longName: "Matinkylä (M)-Kirkkonummi-Gesterby",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxOQ==",
lat: 60.160171,
lon: 24.738517
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDIwMg==",
lat: 60.147525,
lon: 24.572943
},
{
id: "U3RvcDpIU0w6NjAzMDIwNg==",
lat: 60.137865,
lon: 24.532207
},
{
id: "U3RvcDpIU0w6NjAzMDIwMg==",
lat: 60.133613,
lon: 24.509142
},
{
id: "U3RvcDpIU0w6NjA2MDIxMg==",
lat: 60.1185,
lon: 24.47475
},
{
id: "U3RvcDpIU0w6NjA0MDI2Mg==",
lat: 60.12006,
lon: 24.470677
},
{
id: "U3RvcDpIU0w6NjA0MDI3MQ==",
lat: 60.125957,
lon: 24.470868
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI5Mg==",
lat: 60.119723,
lon: 24.441012
},
{
id: "U3RvcDpIU0w6NjA1MDI1NA==",
lat: 60.122759,
lon: 24.427463
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA0MDI3MA==",
lat: 60.124332,
lon: 24.411187
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mg==",
lat: 60.127002,
lon: 24.416042
},
{
id: "U3RvcDpIU0w6NjA0MDI3Ng==",
lat: 60.129328,
lon: 24.419208
},
{
id: "U3RvcDpIU0w6NjA0MDI3OA==",
lat: 60.130365,
lon: 24.425962
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mg==",
lat: 60.132354,
lon: 24.430257
},
{
id: "U3RvcDpIU0w6NjA0MDI0NA==",
lat: 60.133633,
lon: 24.429907
},
{
id: "U3RvcDpIU0w6NjA0MDI0Ng==",
lat: 60.134168,
lon: 24.44247
},
{
id: "U3RvcDpIU0w6NjA0MDI4NA==",
lat: 60.137257,
lon: 24.447662
},
{
id: "U3RvcDpIU0w6NjA0MDI1MA==",
lat: 60.136902,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI0Nw==",
lat: 60.13445,
lon: 24.44258
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mw==",
lat: 60.13286,
lon: 24.429452
},
{
id: "U3RvcDpIU0w6NjA0MDI4MA==",
lat: 60.130422,
lon: 24.425053
},
{
id: "U3RvcDpIU0w6NjA0MDI3NA==",
lat: 60.129002,
lon: 24.41859
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mw==",
lat: 60.126575,
lon: 24.415172
},
{
id: "U3RvcDpIU0w6NjA0MDI2OQ==",
lat: 60.12398,
lon: 24.410722
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mw==",
lat: 60.122346,
lon: 24.427386
},
{
id: "U3RvcDpIU0w6NjA0MDI5Ng==",
lat: 60.119674,
lon: 24.441337
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIwMA==",
lat: 60.12564,
lon: 24.47039
},
{
id: "U3RvcDpIU0w6NjA1MDIyMA==",
lat: 60.119183,
lon: 24.471579
},
{
id: "U3RvcDpIU0w6NjA0MDI0MQ==",
lat: 60.119302,
lon: 24.476357
},
{
id: "U3RvcDpIU0w6NjA0MDIxNQ==",
lat: 60.119058,
lon: 24.4813
},
{
id: "U3RvcDpIU0w6NjAzMDIwMQ==",
lat: 60.133472,
lon: 24.512763
},
{
id: "U3RvcDpIU0w6NjAzMDIzMg==",
lat: 60.13751,
lon: 24.537388
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:2502",
shortName: "502",
longName: "Merihaka-Meilahti-Munkkiniemi-Leppävaara",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIzNQ==",
lat: 60.21893,
lon: 24.81164
},
{
id: "U3RvcDpIU0w6MjExODI4MA==",
lat: 60.2171,
lon: 24.820558
},
{
id: "U3RvcDpIU0w6MjExODI3OA==",
lat: 60.217,
lon: 24.82504
},
{
id: "U3RvcDpIU0w6MjExODI3Ng==",
lat: 60.21489,
lon: 24.82632
},
{
id: "U3RvcDpIU0w6MjExODIwMQ==",
lat: 60.21264,
lon: 24.82623
},
{
id: "U3RvcDpIU0w6MjExODIwNg==",
lat: 60.21042,
lon: 24.82635
},
{
id: "U3RvcDpIU0w6MjExODIwOA==",
lat: 60.21132,
lon: 24.83059
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyNg==",
lat: 60.19909,
lon: 24.8835
},
{
id: "U3RvcDpIU0w6MTMwMTEyNA==",
lat: 60.19618,
lon: 24.88529
},
{
id: "U3RvcDpIU0w6MTE1MDExNA==",
lat: 60.1942,
lon: 24.89206
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
},
{
id: "U3RvcDpIU0w6MTE1MDEwOA==",
lat: 60.188734,
lon: 24.912259
},
{
id: "U3RvcDpIU0w6MTE0MDEwNg==",
lat: 60.18579,
lon: 24.91579
},
{
id: "U3RvcDpIU0w6MTE0MDExMA==",
lat: 60.183679,
lon: 24.919857
},
{
id: "U3RvcDpIU0w6MTE0MDEwOA==",
lat: 60.184083,
lon: 24.924736
},
{
id: "U3RvcDpIU0w6MTEyMjEwMg==",
lat: 60.18643,
lon: 24.94185
},
{
id: "U3RvcDpIU0w6MTExMjE1NQ==",
lat: 60.18563,
lon: 24.94331
},
{
id: "U3RvcDpIU0w6MTExMjE1Mw==",
lat: 60.18415,
lon: 24.94172
},
{
id: "U3RvcDpIU0w6MTExMjEwNQ==",
lat: 60.18276,
lon: 24.94536
},
{
id: "U3RvcDpIU0w6MTExMjEwMw==",
lat: 60.181563,
lon: 24.948399
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMQ==",
lat: 60.17905,
lon: 24.9605
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTExMjEzNw==",
lat: 60.18141,
lon: 24.94897
},
{
id: "U3RvcDpIU0w6MTExMjEwNA==",
lat: 60.18287,
lon: 24.94524
},
{
id: "U3RvcDpIU0w6MTExMjE1Mg==",
lat: 60.18445,
lon: 24.94114
},
{
id: "U3RvcDpIU0w6MTExMjE1NA==",
lat: 60.18556,
lon: 24.94337
},
{
id: "U3RvcDpIU0w6MTEyMjEwMQ==",
lat: 60.18642,
lon: 24.94121
},
{
id: "U3RvcDpIU0w6MTE0MDEwNw==",
lat: 60.184173,
lon: 24.924404
},
{
id: "U3RvcDpIU0w6MTE0MDEwOQ==",
lat: 60.18376,
lon: 24.92175
},
{
id: "U3RvcDpIU0w6MTE0MDEwNA==",
lat: 60.18484,
lon: 24.917
},
{
id: "U3RvcDpIU0w6MTE1MDEwNw==",
lat: 60.189912,
lon: 24.909831
},
{
id: "U3RvcDpIU0w6MTE1MDEwOQ==",
lat: 60.19067,
lon: 24.90781
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTE1MDExMw==",
lat: 60.19522,
lon: 24.8907
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MjExODIwNw==",
lat: 60.211442,
lon: 24.830477
},
{
id: "U3RvcDpIU0w6MjExODIwNA==",
lat: 60.21104,
lon: 24.82569
},
{
id: "U3RvcDpIU0w6MjExODIwMw==",
lat: 60.21222,
lon: 24.8263
},
{
id: "U3RvcDpIU0w6MjExODI3Nw==",
lat: 60.2147,
lon: 24.82653
},
{
id: "U3RvcDpIU0w6MjExODI4NA==",
lat: 60.21716,
lon: 24.825386
},
{
id: "U3RvcDpIU0w6MjExODI4Ng==",
lat: 60.2184,
lon: 24.81792
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
},
{
id: "U3RvcDpIU0w6MTExMTExOA==",
lat: 60.179444,
lon: 24.952266
}
]
},
{
gtfsId: "HSL:6915B",
shortName: "915B",
longName: "Kuntakeskus-Siuntion kk.-Annila-Järvinummi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMTA1Nw==",
lat: 60.234227,
lon: 24.253235
},
{
id: "U3RvcDpIU0w6NjMwMTA2NA==",
lat: 60.218328,
lon: 24.240314
},
{
id: "U3RvcDpIU0w6NjMwMTAyMA==",
lat: 60.190246,
lon: 24.20253
},
{
id: "U3RvcDpIU0w6NjMwMTAzMQ==",
lat: 60.178093,
lon: 24.202822
},
{
id: "U3RvcDpIU0w6NjMwMTAxMQ==",
lat: 60.172765,
lon: 24.206878
},
{
id: "U3RvcDpIU0w6NjMwMTA1Mg==",
lat: 60.170375,
lon: 24.200431
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAyMw==",
lat: 60.165141,
lon: 24.197315
},
{
id: "U3RvcDpIU0w6NjMwMTAzMw==",
lat: 60.171361,
lon: 24.201095
},
{
id: "U3RvcDpIU0w6NjMwMTAxMA==",
lat: 60.173575,
lon: 24.210197
},
{
id: "U3RvcDpIU0w6NjMwMTAyNg==",
lat: 60.178262,
lon: 24.223798
},
{
id: "U3RvcDpIU0w6NjMwMTA0Nw==",
lat: 60.179052,
lon: 24.233051
},
{
id: "U3RvcDpIU0w6NjMwMTAwMA==",
lat: 60.184995,
lon: 24.240861
},
{
id: "U3RvcDpIU0w6NjMwMTAxNQ==",
lat: 60.189068,
lon: 24.246139
},
{
id: "U3RvcDpIU0w6NjMwMTA2Nw==",
lat: 60.195057,
lon: 24.252617
},
{
id: "U3RvcDpIU0w6NjMwMTA2Ng==",
lat: 60.248523,
lon: 24.297696
}
]
},
{
gtfsId: "HSL:6915A",
shortName: "915A",
longName: "Kuntakeskus-Siuntion kk.-Järvinummi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMTA1Ng==",
lat: 60.233838,
lon: 24.254802
},
{
id: "U3RvcDpIU0w6NjMwMTA2NQ==",
lat: 60.248472,
lon: 24.297604
},
{
id: "U3RvcDpIU0w6NjMwMTAwMg==",
lat: 60.194368,
lon: 24.251792
},
{
id: "U3RvcDpIU0w6NjMwMTAxNg==",
lat: 60.188088,
lon: 24.245
},
{
id: "U3RvcDpIU0w6NjMwMTAwMQ==",
lat: 60.184142,
lon: 24.239233
},
{
id: "U3RvcDpIU0w6NjMwMTA0Ng==",
lat: 60.180368,
lon: 24.234423
},
{
id: "U3RvcDpIU0w6NjMwMTAyNQ==",
lat: 60.178408,
lon: 24.225049
},
{
id: "U3RvcDpIU0w6NjMwMTAxMQ==",
lat: 60.172765,
lon: 24.206878
},
{
id: "U3RvcDpIU0w6NjMwMTA1Mg==",
lat: 60.170375,
lon: 24.200431
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAyMw==",
lat: 60.165141,
lon: 24.197315
},
{
id: "U3RvcDpIU0w6NjMwMTAzMw==",
lat: 60.171361,
lon: 24.201095
},
{
id: "U3RvcDpIU0w6NjMwMTAxMg==",
lat: 60.173692,
lon: 24.206942
},
{
id: "U3RvcDpIU0w6NjMwMTAzMA==",
lat: 60.179294,
lon: 24.202626
},
{
id: "U3RvcDpIU0w6NjMwMTA0MA==",
lat: 60.19108,
lon: 24.203815
},
{
id: "U3RvcDpIU0w6NjMwMTA2Mw==",
lat: 60.2183,
lon: 24.240424
}
]
},
{
gtfsId: "HSL:4717",
shortName: "717",
longName: "Rautatientori-Jakomäki-Hakunila-Kuninkaanmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDIyNw==",
lat: 60.29097,
lon: 25.11945
},
{
id: "U3RvcDpIU0w6NDk2MDIyNQ==",
lat: 60.29152,
lon: 25.11378
},
{
id: "U3RvcDpIU0w6NDk2MDIyMw==",
lat: 60.29266,
lon: 25.1126
},
{
id: "U3RvcDpIU0w6NDk2MDIyMA==",
lat: 60.29456,
lon: 25.10822
},
{
id: "U3RvcDpIU0w6NDk2MDIzNQ==",
lat: 60.29629,
lon: 25.10753
},
{
id: "U3RvcDpIU0w6NDk2MDI5NQ==",
lat: 60.29711,
lon: 25.10977
},
{
id: "U3RvcDpIU0w6NDk2MDIwNg==",
lat: 60.29764,
lon: 25.11134
},
{
id: "U3RvcDpIU0w6NDk3MDIwMQ==",
lat: 60.29814,
lon: 25.11254
},
{
id: "U3RvcDpIU0w6NDk3MDIyNQ==",
lat: 60.30042,
lon: 25.11287
},
{
id: "U3RvcDpIU0w6NDk3MDIwMw==",
lat: 60.30191,
lon: 25.11707
},
{
id: "U3RvcDpIU0w6NDk3MDIwNQ==",
lat: 60.3033,
lon: 25.1184
},
{
id: "U3RvcDpIU0w6NDk3MDIwNw==",
lat: 60.30592,
lon: 25.11718
},
{
id: "U3RvcDpIU0w6NDk3MDIxMA==",
lat: 60.307773,
lon: 25.114235
},
{
id: "U3RvcDpIU0w6NDk3MDI5OA==",
lat: 60.307177,
lon: 25.109792
},
{
id: "U3RvcDpIU0w6NDk3MDIyNw==",
lat: 60.30423,
lon: 25.10676
},
{
id: "U3RvcDpIU0w6NDk3MDIzNQ==",
lat: 60.30158,
lon: 25.10637
},
{
id: "U3RvcDpIU0w6NDk3MDIzMw==",
lat: 60.30091,
lon: 25.10537
},
{
id: "U3RvcDpIU0w6NDk3MDIzMg==",
lat: 60.30053,
lon: 25.10575
},
{
id: "U3RvcDpIU0w6NDk3MDIzNA==",
lat: 60.30129,
lon: 25.10641
},
{
id: "U3RvcDpIU0w6NDk3MDIyOA==",
lat: 60.30416,
lon: 25.10698
},
{
id: "U3RvcDpIU0w6NDk3MDI5OQ==",
lat: 60.30677,
lon: 25.109677
},
{
id: "U3RvcDpIU0w6NDk3MDIzNg==",
lat: 60.3072,
lon: 25.11525
},
{
id: "U3RvcDpIU0w6NDk3MDIwOA==",
lat: 60.30525,
lon: 25.11701
},
{
id: "U3RvcDpIU0w6NDk3MDIwNg==",
lat: 60.30338,
lon: 25.11821
},
{
id: "U3RvcDpIU0w6NDk3MDIwNA==",
lat: 60.30143,
lon: 25.11551
},
{
id: "U3RvcDpIU0w6NDk3MDIyNg==",
lat: 60.29981,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDI0MQ==",
lat: 60.29773,
lon: 25.11143
},
{
id: "U3RvcDpIU0w6NDk2MDI5NA==",
lat: 60.29714,
lon: 25.10963
},
{
id: "U3RvcDpIU0w6NDk2MDIzOA==",
lat: 60.29628,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk2MDIxOQ==",
lat: 60.29418,
lon: 25.10836
},
{
id: "U3RvcDpIU0w6NDk2MDIyMg==",
lat: 60.2927,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE0OA==",
lat: 60.25976,
lon: 25.0842
},
{
id: "U3RvcDpIU0w6MTQxNDE0Ng==",
lat: 60.25619,
lon: 25.08183
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4737K",
shortName: "737K",
longName: "Pohjois-Nikinmäki-Nikinmäki-Jokivarsi-Mikkola-Korso",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDg2MDIxNg==",
lat: 60.3582,
lon: 25.14771
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mw==",
lat: 60.35602,
lon: 25.13996
},
{
id: "U3RvcDpIU0w6NDg2MDIyMA==",
lat: 60.35607,
lon: 25.13692
},
{
id: "U3RvcDpIU0w6NDg2MDIxOA==",
lat: 60.35661,
lon: 25.12949
},
{
id: "U3RvcDpIU0w6NDg2MDIzNg==",
lat: 60.35596,
lon: 25.12691
},
{
id: "U3RvcDpIU0w6NDg2MDIxMw==",
lat: 60.35381,
lon: 25.12674
},
{
id: "U3RvcDpIU0w6NDg2MDIxNQ==",
lat: 60.34614,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6NDg2MDIwNg==",
lat: 60.343,
lon: 25.1273
},
{
id: "U3RvcDpIU0w6NDg2MDIwNA==",
lat: 60.33975,
lon: 25.12921
},
{
id: "U3RvcDpIU0w6NDg2MDIzNA==",
lat: 60.33946,
lon: 25.13387
},
{
id: "U3RvcDpIU0w6NDg2MDIzMg==",
lat: 60.34099,
lon: 25.14079
},
{
id: "U3RvcDpIU0w6NDg2MDIzMA==",
lat: 60.34199,
lon: 25.14701
},
{
id: "U3RvcDpIU0w6NDg2MDIyOA==",
lat: 60.3449,
lon: 25.14691
},
{
id: "U3RvcDpIU0w6NDg2MDIyNg==",
lat: 60.34491,
lon: 25.14009
},
{
id: "U3RvcDpIU0w6NDg2MDIyNA==",
lat: 60.3452,
lon: 25.13308
},
{
id: "U3RvcDpIU0w6NDg2MDIwOQ==",
lat: 60.345648,
lon: 25.128683
},
{
id: "U3RvcDpIU0w6NDg1MDIwMw==",
lat: 60.34529,
lon: 25.11796
},
{
id: "U3RvcDpIU0w6NDg1MDIwNQ==",
lat: 60.346137,
lon: 25.113348
},
{
id: "U3RvcDpIU0w6NDg1MDIwNw==",
lat: 60.35075,
lon: 25.11402
},
{
id: "U3RvcDpIU0w6NDg1MDIwOQ==",
lat: 60.35293,
lon: 25.11242
},
{
id: "U3RvcDpIU0w6NDgzMDIwOQ==",
lat: 60.35221,
lon: 25.10526
},
{
id: "U3RvcDpIU0w6NDgzMDI5Nw==",
lat: 60.35087,
lon: 25.10562
},
{
id: "U3RvcDpIU0w6NDgzMDI5NQ==",
lat: 60.34851,
lon: 25.10636
},
{
id: "U3RvcDpIU0w6NDgyMDIxMQ==",
lat: 60.34527,
lon: 25.10271
},
{
id: "U3RvcDpIU0w6NDgyMDIxOA==",
lat: 60.34362,
lon: 25.10246
},
{
id: "U3RvcDpIU0w6NDgyMDIyNQ==",
lat: 60.34225,
lon: 25.1052
},
{
id: "U3RvcDpIU0w6NDgyMDIyMw==",
lat: 60.34043,
lon: 25.1051
},
{
id: "U3RvcDpIU0w6NDgyMDIxMA==",
lat: 60.33979,
lon: 25.10148
},
{
id: "U3RvcDpIU0w6NDgyMDIwOA==",
lat: 60.34133,
lon: 25.09714
},
{
id: "U3RvcDpIU0w6NDgyMDIwNA==",
lat: 60.34338,
lon: 25.09789
},
{
id: "U3RvcDpIU0w6NDgyMDIwNg==",
lat: 60.34513,
lon: 25.09491
},
{
id: "U3RvcDpIU0w6NDgzMDIwMQ==",
lat: 60.3453,
lon: 25.08927
},
{
id: "U3RvcDpIU0w6NDgzMDI5OQ==",
lat: 60.34672,
lon: 25.08124
},
{
id: "U3RvcDpIU0w6NDgxMDI5OQ==",
lat: 60.34736,
lon: 25.07515
},
{
id: "U3RvcDpIU0w6NDgxMDIwMQ==",
lat: 60.34928,
lon: 25.07708
},
{
id: "U3RvcDpIU0w6NDgxMDIzOQ==",
lat: 60.351113,
lon: 25.077546
},
{
id: "U3RvcDpIU0w6NDgxMDI0MA==",
lat: 60.35101,
lon: 25.07761
},
{
id: "U3RvcDpIU0w6NDgxMDIwMg==",
lat: 60.34964,
lon: 25.07699
},
{
id: "U3RvcDpIU0w6NDgxMDI5OA==",
lat: 60.346684,
lon: 25.075914
},
{
id: "U3RvcDpIU0w6NDgzMDI5OA==",
lat: 60.34554,
lon: 25.08651
},
{
id: "U3RvcDpIU0w6NDgzMDIwMg==",
lat: 60.34514,
lon: 25.09151
},
{
id: "U3RvcDpIU0w6NDgyMDIwMw==",
lat: 60.34321,
lon: 25.09762
},
{
id: "U3RvcDpIU0w6NDgyMDIwNQ==",
lat: 60.34113,
lon: 25.09689
},
{
id: "U3RvcDpIU0w6NDgyMDIxNA==",
lat: 60.33971,
lon: 25.10071
},
{
id: "U3RvcDpIU0w6NDgyMDIyMg==",
lat: 60.33964,
lon: 25.10486
},
{
id: "U3RvcDpIU0w6NDgyMDIyNA==",
lat: 60.34237,
lon: 25.10535
},
{
id: "U3RvcDpIU0w6NDgyMDIxOQ==",
lat: 60.34357,
lon: 25.10374
},
{
id: "U3RvcDpIU0w6NDgyMDIxMg==",
lat: 60.34595,
lon: 25.10529
},
{
id: "U3RvcDpIU0w6NDgzMDI5NA==",
lat: 60.34935,
lon: 25.1062
},
{
id: "U3RvcDpIU0w6NDg0MDIxMg==",
lat: 60.35293,
lon: 25.10646
},
{
id: "U3RvcDpIU0w6NDg1MDIwOA==",
lat: 60.35287,
lon: 25.11271
},
{
id: "U3RvcDpIU0w6NDg1MDIwNg==",
lat: 60.35037,
lon: 25.11386
},
{
id: "U3RvcDpIU0w6NDg1MDIwNA==",
lat: 60.346552,
lon: 25.113178
},
{
id: "U3RvcDpIU0w6NDg1MDIwMg==",
lat: 60.34513,
lon: 25.11996
},
{
id: "U3RvcDpIU0w6NDg2MDI0Mg==",
lat: 60.34572,
lon: 25.130623
},
{
id: "U3RvcDpIU0w6NDg2MDIzNw==",
lat: 60.34486,
lon: 25.13346
},
{
id: "U3RvcDpIU0w6NDg2MDIyNQ==",
lat: 60.34486,
lon: 25.14023
},
{
id: "U3RvcDpIU0w6NDg2MDIyNw==",
lat: 60.34492,
lon: 25.14658
},
{
id: "U3RvcDpIU0w6NDg2MDIyOQ==",
lat: 60.342058,
lon: 25.146987
},
{
id: "U3RvcDpIU0w6NDg2MDIzMQ==",
lat: 60.34105,
lon: 25.14113
},
{
id: "U3RvcDpIU0w6NDg2MDIwNw==",
lat: 60.34049,
lon: 25.13834
},
{
id: "U3RvcDpIU0w6NDg2MDIzMw==",
lat: 60.33938,
lon: 25.13317
},
{
id: "U3RvcDpIU0w6NDg2MDIwMw==",
lat: 60.34003,
lon: 25.12899
},
{
id: "U3RvcDpIU0w6NDg2MDIxMA==",
lat: 60.34297,
lon: 25.12747
},
{
id: "U3RvcDpIU0w6NDg2MDIxMg==",
lat: 60.34735,
lon: 25.12712
},
{
id: "U3RvcDpIU0w6NDg2MDIxNA==",
lat: 60.35468,
lon: 25.12701
},
{
id: "U3RvcDpIU0w6NDg2MDIxNw==",
lat: 60.35687,
lon: 25.13116
},
{
id: "U3RvcDpIU0w6NDg2MDIxOQ==",
lat: 60.35598,
lon: 25.13691
},
{
id: "U3RvcDpIU0w6NDg2MDI1MA==",
lat: 60.35599,
lon: 25.14148
},
{
id: "U3RvcDpIU0w6NDg2MDI0Nw==",
lat: 60.35822,
lon: 25.14772
}
]
},
{
gtfsId: "HSL:4718",
shortName: "718",
longName: "Rautatientori-Nissas",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6NDkzMDIzMw==",
lat: 60.270331,
lon: 25.099303
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk0MDIyOQ==",
lat: 60.28679,
lon: 25.12379
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMw==",
lat: 60.26977,
lon: 25.10163
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:4719",
shortName: "719",
longName: "Nybygget-Hakunila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk0MDIzMA==",
lat: 60.27698,
lon: 25.10402
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDk0MDIwOQ==",
lat: 60.27158,
lon: 25.10579
},
{
id: "U3RvcDpIU0w6NDk0MDIwNw==",
lat: 60.27485,
lon: 25.10877
},
{
id: "U3RvcDpIU0w6NDk0MDIwNQ==",
lat: 60.27662,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6NDk0MDI5Ng==",
lat: 60.27916,
lon: 25.11468
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyOA==",
lat: 60.2815,
lon: 25.12098
},
{
id: "U3RvcDpIU0w6NDk0MDIwMg==",
lat: 60.2793,
lon: 25.12528
},
{
id: "U3RvcDpIU0w6NDk4MDIxNA==",
lat: 60.27794,
lon: 25.13378
},
{
id: "U3RvcDpIU0w6NDk4MDIxMg==",
lat: 60.28507,
lon: 25.13526
},
{
id: "U3RvcDpIU0w6NDk4MDIxNw==",
lat: 60.28471,
lon: 25.18175
},
{
id: "U3RvcDpIU0w6NDk4MDIxNg==",
lat: 60.28252,
lon: 25.15787
},
{
id: "U3RvcDpIU0w6NDk4MDIwOQ==",
lat: 60.28843,
lon: 25.13889
},
{
id: "U3RvcDpIU0w6NDk4MDIxMQ==",
lat: 60.28449,
lon: 25.13485
},
{
id: "U3RvcDpIU0w6NDk4MDIxMw==",
lat: 60.27735,
lon: 25.13335
},
{
id: "U3RvcDpIU0w6NDk0MDIwMQ==",
lat: 60.27995,
lon: 25.12467
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OA==",
lat: 60.28001,
lon: 25.11556
},
{
id: "U3RvcDpIU0w6NDk0MDI5Nw==",
lat: 60.27866,
lon: 25.11328
},
{
id: "U3RvcDpIU0w6NDk0MDIwNA==",
lat: 60.27641,
lon: 25.11153
},
{
id: "U3RvcDpIU0w6NDk0MDIwNg==",
lat: 60.2751,
lon: 25.10886
},
{
id: "U3RvcDpIU0w6NDk0MDIwOA==",
lat: 60.27165,
lon: 25.10582
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
}
]
},
{
gtfsId: "HSL:2533",
shortName: "533",
longName: "Matinkylä-Suurpelto-Kauniainen-Järvenperä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjYzMjI2MQ==",
lat: 60.24461,
lon: 24.71319
},
{
id: "U3RvcDpIU0w6MjYzMjI1MA==",
lat: 60.24335,
lon: 24.71488
},
{
id: "U3RvcDpIU0w6MjYzMjI0OA==",
lat: 60.24082,
lon: 24.71155
},
{
id: "U3RvcDpIU0w6MjYzMjI0Ng==",
lat: 60.23841,
lon: 24.70811
},
{
id: "U3RvcDpIU0w6MjE1MjIzOA==",
lat: 60.23408,
lon: 24.71654
},
{
id: "U3RvcDpIU0w6MjE1MjIzNg==",
lat: 60.23194,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjE1MjIzNA==",
lat: 60.2298,
lon: 24.71542
},
{
id: "U3RvcDpIU0w6MjE1MjIzMg==",
lat: 60.228,
lon: 24.70977
},
{
id: "U3RvcDpIU0w6MjE1MjIzMA==",
lat: 60.22545,
lon: 24.7065
},
{
id: "U3RvcDpIU0w6MzE3MDIyNw==",
lat: 60.22372,
lon: 24.70727
},
{
id: "U3RvcDpIU0w6MzE3MDIyNg==",
lat: 60.2214,
lon: 24.71551
},
{
id: "U3RvcDpIU0w6MzE3MDIyNA==",
lat: 60.22025,
lon: 24.71118
},
{
id: "U3RvcDpIU0w6MzE3MDIxMw==",
lat: 60.21566,
lon: 24.71209
},
{
id: "U3RvcDpIU0w6MzE3MDIxMA==",
lat: 60.2139,
lon: 24.7169
},
{
id: "U3RvcDpIU0w6MzE3MDIwOQ==",
lat: 60.21369,
lon: 24.72097
},
{
id: "U3RvcDpIU0w6MzE3MDIwNw==",
lat: 60.21235,
lon: 24.72818
},
{
id: "U3RvcDpIU0w6MzE3MDI0MA==",
lat: 60.21083,
lon: 24.72933
},
{
id: "U3RvcDpIU0w6MzE3MDIzMQ==",
lat: 60.2096,
lon: 24.73197
},
{
id: "U3RvcDpIU0w6MzE3MDIyOQ==",
lat: 60.20949,
lon: 24.73919
},
{
id: "U3RvcDpIU0w6MjEzMTI1MA==",
lat: 60.207094,
lon: 24.752523
},
{
id: "U3RvcDpIU0w6MjEzMTI1MQ==",
lat: 60.20632,
lon: 24.75354
},
{
id: "U3RvcDpIU0w6MjMzMTIwNw==",
lat: 60.189316,
lon: 24.741816
},
{
id: "U3RvcDpIU0w6MjMzMTIxMQ==",
lat: 60.186573,
lon: 24.743208
},
{
id: "U3RvcDpIU0w6MjMzMTIwOQ==",
lat: 60.18293,
lon: 24.74496
},
{
id: "U3RvcDpIU0w6MjMzMTIwNQ==",
lat: 60.18102,
lon: 24.74392
},
{
id: "U3RvcDpIU0w6MjMyMjIzOQ==",
lat: 60.17763,
lon: 24.74183
},
{
id: "U3RvcDpIU0w6MjMyMjIzNA==",
lat: 60.17516,
lon: 24.7422
},
{
id: "U3RvcDpIU0w6MjMyMjIzNQ==",
lat: 60.17491,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjMyMjIzNw==",
lat: 60.17479,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjMyMzI1MQ==",
lat: 60.17156,
lon: 24.73162
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mw==",
lat: 60.168587,
lon: 24.734538
},
{
id: "U3RvcDpIU0w6MjMyMjIxMQ==",
lat: 60.16456,
lon: 24.73676
},
{
id: "U3RvcDpIU0w6MjMxMTIxMQ==",
lat: 60.16246,
lon: 24.73833
},
{
id: "U3RvcDpIU0w6MjMxMTIwMQ==",
lat: 60.160644,
lon: 24.740316
},
{
id: "U3RvcDpIU0w6MjMxMTIxNQ==",
lat: 60.15764,
lon: 24.73829
},
{
id: "U3RvcDpIU0w6MjMxMTIwMw==",
lat: 60.158108,
lon: 24.741168
},
{
id: "U3RvcDpIU0w6MjMxNDIwOQ==",
lat: 60.160509,
lon: 24.740794
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjMyMjIxMg==",
lat: 60.164558,
lon: 24.737052
},
{
id: "U3RvcDpIU0w6MjMyMzIwNw==",
lat: 60.16695,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mg==",
lat: 60.169261,
lon: 24.734193
},
{
id: "U3RvcDpIU0w6MjMyMzI1MA==",
lat: 60.17271,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjMyMjIzOA==",
lat: 60.17468,
lon: 24.73368
},
{
id: "U3RvcDpIU0w6MjMyMjIzNg==",
lat: 60.17473,
lon: 24.7386
},
{
id: "U3RvcDpIU0w6MjMyMjI0OA==",
lat: 60.17565,
lon: 24.74279
},
{
id: "U3RvcDpIU0w6MjMyMjI0MA==",
lat: 60.17783,
lon: 24.74201
},
{
id: "U3RvcDpIU0w6MjMzMTIwNA==",
lat: 60.18081,
lon: 24.74421
},
{
id: "U3RvcDpIU0w6MjMzMTIwNg==",
lat: 60.18218,
lon: 24.74539
},
{
id: "U3RvcDpIU0w6MjMzMTIwOA==",
lat: 60.184573,
lon: 24.7443
},
{
id: "U3RvcDpIU0w6MjMzMjIxMQ==",
lat: 60.186421,
lon: 24.7434
},
{
id: "U3RvcDpIU0w6MjMzMjIwNw==",
lat: 60.190021,
lon: 24.741632
},
{
id: "U3RvcDpIU0w6MjI0MTIxMQ==",
lat: 60.187875,
lon: 24.750442
},
{
id: "U3RvcDpIU0w6MjEzMTI1Nw==",
lat: 60.207166,
lon: 24.75329
},
{
id: "U3RvcDpIU0w6MzE3MDIyOA==",
lat: 60.20948,
lon: 24.73798
},
{
id: "U3RvcDpIU0w6MzE3MDIzMA==",
lat: 60.20981,
lon: 24.73151
},
{
id: "U3RvcDpIU0w6MzE3MDIzOQ==",
lat: 60.21096,
lon: 24.72951
},
{
id: "U3RvcDpIU0w6MzE3MDI1Nw==",
lat: 60.21267,
lon: 24.72825
},
{
id: "U3RvcDpIU0w6MzE3MDIwOA==",
lat: 60.21381,
lon: 24.72083
},
{
id: "U3RvcDpIU0w6MzE3MDIxMQ==",
lat: 60.2143,
lon: 24.71582
},
{
id: "U3RvcDpIU0w6MzE3MDIxMg==",
lat: 60.21638,
lon: 24.71126
},
{
id: "U3RvcDpIU0w6MzE3MDIyMw==",
lat: 60.22007,
lon: 24.71116
},
{
id: "U3RvcDpIU0w6MzE3MDIyNQ==",
lat: 60.22209,
lon: 24.71463
},
{
id: "U3RvcDpIU0w6MjE1MjI0Mw==",
lat: 60.22459,
lon: 24.70664
},
{
id: "U3RvcDpIU0w6MjE1MjIyOQ==",
lat: 60.22726,
lon: 24.708
},
{
id: "U3RvcDpIU0w6MjE1MjIzMQ==",
lat: 60.22812,
lon: 24.71094
},
{
id: "U3RvcDpIU0w6MjE1MjIzMw==",
lat: 60.23013,
lon: 24.71583
},
{
id: "U3RvcDpIU0w6MjE1MjIzNQ==",
lat: 60.23214,
lon: 24.71632
},
{
id: "U3RvcDpIU0w6MjE1MjI0NQ==",
lat: 60.23402,
lon: 24.71677
},
{
id: "U3RvcDpIU0w6MjE1MjIzOQ==",
lat: 60.2351,
lon: 24.71562
},
{
id: "U3RvcDpIU0w6MjYzMjI0Nw==",
lat: 60.2389,
lon: 24.70829
},
{
id: "U3RvcDpIU0w6MjYzMjI0OQ==",
lat: 60.24109,
lon: 24.71284
},
{
id: "U3RvcDpIU0w6MjYzMjI3MQ==",
lat: 60.24436,
lon: 24.71404
}
]
},
{
gtfsId: "HSL:6902K",
shortName: "902K",
longName: "Pikkalan tehdas-Kirkkonummi-Porkkala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjA3MDIzMg==",
lat: 60.094845,
lon: 24.34585
},
{
id: "U3RvcDpIU0w6NjA3MDIzMQ==",
lat: 60.097233,
lon: 24.342965
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNw==",
lat: 60.118187,
lon: 24.37067
},
{
id: "U3RvcDpIU0w6NjA1MDIwOQ==",
lat: 60.121223,
lon: 24.377082
},
{
id: "U3RvcDpIU0w6NjA1MDIxMQ==",
lat: 60.121985,
lon: 24.386015
},
{
id: "U3RvcDpIU0w6NjA1MDIxMw==",
lat: 60.123857,
lon: 24.399738
},
{
id: "U3RvcDpIU0w6NjA0MDIzNQ==",
lat: 60.123883,
lon: 24.40556
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA0MDIzNg==",
lat: 60.124797,
lon: 24.426783
},
{
id: "U3RvcDpIU0w6NjA0MDIzOQ==",
lat: 60.126123,
lon: 24.435517
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI4Nw==",
lat: 60.119861,
lon: 24.441108
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIwMA==",
lat: 60.12564,
lon: 24.47039
},
{
id: "U3RvcDpIU0w6NjA1MDIyMA==",
lat: 60.119183,
lon: 24.471579
},
{
id: "U3RvcDpIU0w6NjA0MDI0MQ==",
lat: 60.119302,
lon: 24.476357
},
{
id: "U3RvcDpIU0w6NjA2MDIwOA==",
lat: 60.11543,
lon: 24.4815
},
{
id: "U3RvcDpIU0w6NjA2MDIwNg==",
lat: 60.105797,
lon: 24.4791
},
{
id: "U3RvcDpIU0w6NjA2MDIwNA==",
lat: 60.102107,
lon: 24.486558
},
{
id: "U3RvcDpIU0w6NjA2MDIwMw==",
lat: 60.098087,
lon: 24.497983
},
{
id: "U3RvcDpIU0w6NjA2MDIwMQ==",
lat: 60.092123,
lon: 24.501967
},
{
id: "U3RvcDpIU0w6NjA5MDIyOA==",
lat: 60.085615,
lon: 24.500817
},
{
id: "U3RvcDpIU0w6NjA5MDIyNg==",
lat: 60.08123,
lon: 24.496783
},
{
id: "U3RvcDpIU0w6NjA5MDIyMw==",
lat: 60.07712,
lon: 24.501165
},
{
id: "U3RvcDpIU0w6NjA5MDIyMg==",
lat: 60.071335,
lon: 24.495877
},
{
id: "U3RvcDpIU0w6NjA5MDIyMA==",
lat: 60.06357,
lon: 24.49424
},
{
id: "U3RvcDpIU0w6NjA5MDIxOA==",
lat: 60.05874,
lon: 24.494908
},
{
id: "U3RvcDpIU0w6NjA5MDIzMA==",
lat: 60.052577,
lon: 24.499713
},
{
id: "U3RvcDpIU0w6NjA5MDIxNA==",
lat: 60.04819,
lon: 24.503337
},
{
id: "U3RvcDpIU0w6NjA5MDIxMg==",
lat: 60.044835,
lon: 24.497432
},
{
id: "U3RvcDpIU0w6NjA5MDIxMA==",
lat: 60.042177,
lon: 24.494337
},
{
id: "U3RvcDpIU0w6NjA5MDIwOQ==",
lat: 60.03919,
lon: 24.492007
},
{
id: "U3RvcDpIU0w6NjA5MDIzOQ==",
lat: 60.036069,
lon: 24.489542
},
{
id: "U3RvcDpIU0w6NjA5MDI0MQ==",
lat: 60.030105,
lon: 24.483945
},
{
id: "U3RvcDpIU0w6NjA5MDIzMQ==",
lat: 60.02247,
lon: 24.482435
},
{
id: "U3RvcDpIU0w6NjA5MDIwNg==",
lat: 60.01759,
lon: 24.476402
},
{
id: "U3RvcDpIU0w6NjA5MDI0OQ==",
lat: 60.014982,
lon: 24.470494
},
{
id: "U3RvcDpIU0w6NjA5MDIwNQ==",
lat: 60.009071,
lon: 24.454008
},
{
id: "U3RvcDpIU0w6NjA5MDI0NQ==",
lat: 60.007047,
lon: 24.455363
},
{
id: "U3RvcDpIU0w6NjA5MDI0Mw==",
lat: 60.005103,
lon: 24.45333
},
{
id: "U3RvcDpIU0w6NjA5MDIwNA==",
lat: 59.998063,
lon: 24.448872
},
{
id: "U3RvcDpIU0w6NjA5MDIwMw==",
lat: 59.99222,
lon: 24.439738
},
{
id: "U3RvcDpIU0w6NjA5MDIwMQ==",
lat: 59.987483,
lon: 24.430405
},
{
id: "U3RvcDpIU0w6NjA5MDIwMg==",
lat: 59.9922,
lon: 24.440759
},
{
id: "U3RvcDpIU0w6NjA5MDIzMg==",
lat: 59.998753,
lon: 24.449967
},
{
id: "U3RvcDpIU0w6NjA5MDI0Mg==",
lat: 60.00507,
lon: 24.453577
},
{
id: "U3RvcDpIU0w6NjA5MDI0NA==",
lat: 60.007402,
lon: 24.455442
},
{
id: "U3RvcDpIU0w6NjA5MDIzMw==",
lat: 60.009204,
lon: 24.454296
},
{
id: "U3RvcDpIU0w6NjA5MDI0Ng==",
lat: 60.009741,
lon: 24.457476
},
{
id: "U3RvcDpIU0w6NjA5MDI0OA==",
lat: 60.014973,
lon: 24.470458
},
{
id: "U3RvcDpIU0w6NjA5MDIzNA==",
lat: 60.0163,
lon: 24.47546
},
{
id: "U3RvcDpIU0w6NjA5MDIwNw==",
lat: 60.022503,
lon: 24.482725
},
{
id: "U3RvcDpIU0w6NjA5MDIwOA==",
lat: 60.030548,
lon: 24.484473
},
{
id: "U3RvcDpIU0w6NjA5MDI0MA==",
lat: 60.036238,
lon: 24.489898
},
{
id: "U3RvcDpIU0w6NjA5MDIzOA==",
lat: 60.039238,
lon: 24.492443
},
{
id: "U3RvcDpIU0w6NjA5MDIzNw==",
lat: 60.042203,
lon: 24.494565
},
{
id: "U3RvcDpIU0w6NjA5MDIxMQ==",
lat: 60.044468,
lon: 24.497257
},
{
id: "U3RvcDpIU0w6NjA5MDIxMw==",
lat: 60.048112,
lon: 24.503567
},
{
id: "U3RvcDpIU0w6NjA5MDIxNQ==",
lat: 60.052008,
lon: 24.503085
},
{
id: "U3RvcDpIU0w6NjA5MDIxNg==",
lat: 60.054248,
lon: 24.500235
},
{
id: "U3RvcDpIU0w6NjA5MDIxNw==",
lat: 60.058347,
lon: 24.495902
},
{
id: "U3RvcDpIU0w6NjA5MDIxOQ==",
lat: 60.063217,
lon: 24.494603
},
{
id: "U3RvcDpIU0w6NjA5MDIyMQ==",
lat: 60.070387,
lon: 24.496762
},
{
id: "U3RvcDpIU0w6NjA5MDIyNA==",
lat: 60.077937,
lon: 24.501228
},
{
id: "U3RvcDpIU0w6NjA5MDIyNQ==",
lat: 60.081038,
lon: 24.497378
},
{
id: "U3RvcDpIU0w6NjA5MDIyNw==",
lat: 60.085263,
lon: 24.500833
},
{
id: "U3RvcDpIU0w6NjA5MDIyOQ==",
lat: 60.091498,
lon: 24.502918
},
{
id: "U3RvcDpIU0w6NjA2MDIwMg==",
lat: 60.097985,
lon: 24.498815
},
{
id: "U3RvcDpIU0w6NjA2MDIwNQ==",
lat: 60.102485,
lon: 24.486728
},
{
id: "U3RvcDpIU0w6NjA2MDIwNw==",
lat: 60.106565,
lon: 24.479938
},
{
id: "U3RvcDpIU0w6NjA2MDIwOQ==",
lat: 60.11624,
lon: 24.4822
},
{
id: "U3RvcDpIU0w6NjA2MDIxMg==",
lat: 60.1185,
lon: 24.47475
},
{
id: "U3RvcDpIU0w6NjA0MDI2Mg==",
lat: 60.12006,
lon: 24.470677
},
{
id: "U3RvcDpIU0w6NjA0MDI3MQ==",
lat: 60.125957,
lon: 24.470868
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA0MDI5NQ==",
lat: 60.119658,
lon: 24.441538
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDIzOA==",
lat: 60.125828,
lon: 24.433405
},
{
id: "U3RvcDpIU0w6NjA0MDIzNw==",
lat: 60.125218,
lon: 24.42728
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA1MDIxOQ==",
lat: 60.12335,
lon: 24.410108
},
{
id: "U3RvcDpIU0w6NjA1MDIxNQ==",
lat: 60.123878,
lon: 24.404211
},
{
id: "U3RvcDpIU0w6NjA1MDIxNA==",
lat: 60.123608,
lon: 24.39643
},
{
id: "U3RvcDpIU0w6NjA1MDIxMg==",
lat: 60.12206,
lon: 24.385388
},
{
id: "U3RvcDpIU0w6NjA1MDIxMA==",
lat: 60.121138,
lon: 24.376124
},
{
id: "U3RvcDpIU0w6NjA1MDIwOA==",
lat: 60.118412,
lon: 24.370543
},
{
id: "U3RvcDpIU0w6NjA1MDIwMw==",
lat: 60.105278,
lon: 24.369337
},
{
id: "U3RvcDpIU0w6NjA1MDIwMg==",
lat: 60.103433,
lon: 24.364292
},
{
id: "U3RvcDpIU0w6NjA3MDIyOQ==",
lat: 60.101495,
lon: 24.345007
},
{
id: "U3RvcDpIU0w6NjA3MDIzMA==",
lat: 60.097948,
lon: 24.342707
}
]
},
{
gtfsId: "HSL:2532",
shortName: "532",
longName: "Matinkylä-Suurpelto-Kera-Leppävaara",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjExMTIzMA==",
lat: 60.21927,
lon: 24.81018
},
{
id: "U3RvcDpIU0w6MjExMTIxMA==",
lat: 60.22268,
lon: 24.80355
},
{
id: "U3RvcDpIU0w6MjEzMjIwMQ==",
lat: 60.22379,
lon: 24.78607
},
{
id: "U3RvcDpIU0w6MjEzMzIwMw==",
lat: 60.22572,
lon: 24.77758
},
{
id: "U3RvcDpIU0w6MjEzMjIwNQ==",
lat: 60.22578,
lon: 24.76438
},
{
id: "U3RvcDpIU0w6MjEzMjIyNQ==",
lat: 60.22342,
lon: 24.76031
},
{
id: "U3RvcDpIU0w6MjEzMjIwOQ==",
lat: 60.22036,
lon: 24.76229
},
{
id: "U3RvcDpIU0w6MjEzMjIxMw==",
lat: 60.21915,
lon: 24.76594
},
{
id: "U3RvcDpIU0w6MjEzMjIxMQ==",
lat: 60.21481,
lon: 24.76384
},
{
id: "U3RvcDpIU0w6MjEzMTI0NA==",
lat: 60.21154,
lon: 24.76284
},
{
id: "U3RvcDpIU0w6MjEzMTI0Ng==",
lat: 60.20944,
lon: 24.75608
},
{
id: "U3RvcDpIU0w6MjEzMTI0OA==",
lat: 60.20843,
lon: 24.75262
},
{
id: "U3RvcDpIU0w6MjEzMTI1MA==",
lat: 60.207094,
lon: 24.752523
},
{
id: "U3RvcDpIU0w6MjEzMTI1MQ==",
lat: 60.20632,
lon: 24.75354
},
{
id: "U3RvcDpIU0w6MjMzMTIwNw==",
lat: 60.189316,
lon: 24.741816
},
{
id: "U3RvcDpIU0w6MjMzMTIxMQ==",
lat: 60.186573,
lon: 24.743208
},
{
id: "U3RvcDpIU0w6MjMzMTIwOQ==",
lat: 60.18293,
lon: 24.74496
},
{
id: "U3RvcDpIU0w6MjMzMTIwNQ==",
lat: 60.18102,
lon: 24.74392
},
{
id: "U3RvcDpIU0w6MjMyMjIzOQ==",
lat: 60.17763,
lon: 24.74183
},
{
id: "U3RvcDpIU0w6MjMyMjIzNA==",
lat: 60.17516,
lon: 24.7422
},
{
id: "U3RvcDpIU0w6MjMyMjIzNQ==",
lat: 60.17491,
lon: 24.73786
},
{
id: "U3RvcDpIU0w6MjMyMjIzNw==",
lat: 60.17479,
lon: 24.73369
},
{
id: "U3RvcDpIU0w6MjMyMzI1MQ==",
lat: 60.17156,
lon: 24.73162
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mw==",
lat: 60.168587,
lon: 24.734538
},
{
id: "U3RvcDpIU0w6MjMyMjIxMQ==",
lat: 60.16456,
lon: 24.73676
},
{
id: "U3RvcDpIU0w6MjMxMTIxMQ==",
lat: 60.16246,
lon: 24.73833
},
{
id: "U3RvcDpIU0w6MjMxMTIwMQ==",
lat: 60.160644,
lon: 24.740316
},
{
id: "U3RvcDpIU0w6MjMxMTIxNQ==",
lat: 60.15764,
lon: 24.73829
},
{
id: "U3RvcDpIU0w6MjMxMTIwMw==",
lat: 60.158108,
lon: 24.741168
},
{
id: "U3RvcDpIU0w6MjMxNDIwOQ==",
lat: 60.160509,
lon: 24.740794
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjMyMjIxMg==",
lat: 60.164558,
lon: 24.737052
},
{
id: "U3RvcDpIU0w6MjMyMzIwNw==",
lat: 60.16695,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mg==",
lat: 60.169261,
lon: 24.734193
},
{
id: "U3RvcDpIU0w6MjMyMzI1MA==",
lat: 60.17271,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjMyMjIzOA==",
lat: 60.17468,
lon: 24.73368
},
{
id: "U3RvcDpIU0w6MjMyMjIzNg==",
lat: 60.17473,
lon: 24.7386
},
{
id: "U3RvcDpIU0w6MjMyMjI0OA==",
lat: 60.17565,
lon: 24.74279
},
{
id: "U3RvcDpIU0w6MjMyMjI0MA==",
lat: 60.17783,
lon: 24.74201
},
{
id: "U3RvcDpIU0w6MjMzMTIwNA==",
lat: 60.18081,
lon: 24.74421
},
{
id: "U3RvcDpIU0w6MjMzMTIwNg==",
lat: 60.18218,
lon: 24.74539
},
{
id: "U3RvcDpIU0w6MjMzMTIwOA==",
lat: 60.184573,
lon: 24.7443
},
{
id: "U3RvcDpIU0w6MjMzMjIxMQ==",
lat: 60.186421,
lon: 24.7434
},
{
id: "U3RvcDpIU0w6MjMzMjIwNw==",
lat: 60.190021,
lon: 24.741632
},
{
id: "U3RvcDpIU0w6MjI0MTIxMQ==",
lat: 60.187875,
lon: 24.750442
},
{
id: "U3RvcDpIU0w6MjEzMTI1Nw==",
lat: 60.207166,
lon: 24.75329
},
{
id: "U3RvcDpIU0w6MjEzMTI0OQ==",
lat: 60.208477,
lon: 24.7532
},
{
id: "U3RvcDpIU0w6MjEzMTI0Nw==",
lat: 60.20968,
lon: 24.75843
},
{
id: "U3RvcDpIU0w6MjEzMjIxMA==",
lat: 60.21233,
lon: 24.7638
},
{
id: "U3RvcDpIU0w6MjEzMjIxMg==",
lat: 60.21588,
lon: 24.76508
},
{
id: "U3RvcDpIU0w6MjEzMjIxNA==",
lat: 60.22026,
lon: 24.76504
},
{
id: "U3RvcDpIU0w6MjEzMjIyOA==",
lat: 60.22098,
lon: 24.76128
},
{
id: "U3RvcDpIU0w6MjEzMjIyNg==",
lat: 60.223568,
lon: 24.760402
},
{
id: "U3RvcDpIU0w6MjEzMjIwOA==",
lat: 60.225528,
lon: 24.760625
},
{
id: "U3RvcDpIU0w6MjEzMjIwNg==",
lat: 60.225743,
lon: 24.766743
},
{
id: "U3RvcDpIU0w6MjEzMzIwNA==",
lat: 60.22495,
lon: 24.77919
},
{
id: "U3RvcDpIU0w6MjEzMjIwMg==",
lat: 60.223593,
lon: 24.788593
},
{
id: "U3RvcDpIU0w6MjExMTIwMA==",
lat: 60.22015,
lon: 24.80185
},
{
id: "U3RvcDpIU0w6MjExMTIzMQ==",
lat: 60.219171,
lon: 24.81335
}
]
},
{
gtfsId: "HSL:2531",
shortName: "531",
longName: "Tiistilä-Matinkylä (M)-Olari-Espoon keskus-Jorvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxMjIwMQ==",
lat: 60.157855,
lon: 24.725891
},
{
id: "U3RvcDpIU0w6MjMxNDIyMQ==",
lat: 60.15638,
lon: 24.72662
},
{
id: "U3RvcDpIU0w6MjMxMjIxOQ==",
lat: 60.15334,
lon: 24.72924
},
{
id: "U3RvcDpIU0w6MjMxMjIxNw==",
lat: 60.15029,
lon: 24.73707
},
{
id: "U3RvcDpIU0w6MjMxNTIxNQ==",
lat: 60.14763,
lon: 24.74306
},
{
id: "U3RvcDpIU0w6MjMxMTIxMw==",
lat: 60.14925,
lon: 24.74849
},
{
id: "U3RvcDpIU0w6MjMxMzIxMQ==",
lat: 60.15182,
lon: 24.74997
},
{
id: "U3RvcDpIU0w6MjMxMTIwOQ==",
lat: 60.15387,
lon: 24.74657
},
{
id: "U3RvcDpIU0w6MjMxMTIwNg==",
lat: 60.1563,
lon: 24.74446
},
{
id: "U3RvcDpIU0w6MjMxNDIwOA==",
lat: 60.161049,
lon: 24.740512
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjMyMjIxMg==",
lat: 60.164558,
lon: 24.737052
},
{
id: "U3RvcDpIU0w6MjMyMzIwNw==",
lat: 60.16695,
lon: 24.73645
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mg==",
lat: 60.169261,
lon: 24.734193
},
{
id: "U3RvcDpIU0w6MjMyMzI1MA==",
lat: 60.17271,
lon: 24.73068
},
{
id: "U3RvcDpIU0w6MjMyMzI0MA==",
lat: 60.17256,
lon: 24.72448
},
{
id: "U3RvcDpIU0w6MjMyMTIxNQ==",
lat: 60.17308,
lon: 24.72252
},
{
id: "U3RvcDpIU0w6MjMyMTIxNw==",
lat: 60.176736,
lon: 24.716377
},
{
id: "U3RvcDpIU0w6MjMyMTI2Mg==",
lat: 60.17488,
lon: 24.70841
},
{
id: "U3RvcDpIU0w6MjMyMTIyMA==",
lat: 60.17429,
lon: 24.70261
},
{
id: "U3RvcDpIU0w6MjQzMjI2Mg==",
lat: 60.1735,
lon: 24.68914
},
{
id: "U3RvcDpIU0w6MjQzMzIwOQ==",
lat: 60.17571,
lon: 24.6874
},
{
id: "U3RvcDpIU0w6MjQzMzIxMQ==",
lat: 60.18002,
lon: 24.67472
},
{
id: "U3RvcDpIU0w6MjQzMTIxMw==",
lat: 60.18185,
lon: 24.67064
},
{
id: "U3RvcDpIU0w6MjYxNTIxNQ==",
lat: 60.18836,
lon: 24.6668
},
{
id: "U3RvcDpIU0w6MjYxNTIzNg==",
lat: 60.19542,
lon: 24.66347
},
{
id: "U3RvcDpIU0w6MjYxMTIzNA==",
lat: 60.19898,
lon: 24.65519
},
{
id: "U3RvcDpIU0w6MjYxNTIzMA==",
lat: 60.20332,
lon: 24.65198
},
{
id: "U3RvcDpIU0w6MjYxMTI0OQ==",
lat: 60.2057,
lon: 24.65781
},
{
id: "U3RvcDpIU0w6MjYxMTI1MQ==",
lat: 60.20778,
lon: 24.66085
},
{
id: "U3RvcDpIU0w6MjYxMTI1Nw==",
lat: 60.21117,
lon: 24.65619
},
{
id: "U3RvcDpIU0w6MjYxMTIwMw==",
lat: 60.21406,
lon: 24.65375
},
{
id: "U3RvcDpIU0w6MjYzMTIxOA==",
lat: 60.21701,
lon: 24.6607
},
{
id: "U3RvcDpIU0w6MjYzMTIxNw==",
lat: 60.21878,
lon: 24.66194
},
{
id: "U3RvcDpIU0w6MjYzMTI4MA==",
lat: 60.22107,
lon: 24.66798
},
{
id: "U3RvcDpIU0w6MjYzMTIwNA==",
lat: 60.22248,
lon: 24.67796
},
{
id: "U3RvcDpIU0w6MjYzMTI2OQ==",
lat: 60.22126,
lon: 24.68531
},
{
id: "U3RvcDpIU0w6MjYzMTIwMw==",
lat: 60.22263,
lon: 24.67577
},
{
id: "U3RvcDpIU0w6MjYzMTI4MQ==",
lat: 60.22125,
lon: 24.66782
},
{
id: "U3RvcDpIU0w6MjYzMTIxOQ==",
lat: 60.21797,
lon: 24.66112
},
{
id: "U3RvcDpIU0w6MjYxMTI2NA==",
lat: 60.21543,
lon: 24.65783
},
{
id: "U3RvcDpIU0w6MjYxMTIwMg==",
lat: 60.2131,
lon: 24.65328
},
{
id: "U3RvcDpIU0w6MjYxMTI0OA==",
lat: 60.21164,
lon: 24.65499
},
{
id: "U3RvcDpIU0w6MjYxMTI1MA==",
lat: 60.20801,
lon: 24.66041
},
{
id: "U3RvcDpIU0w6MjYxMTIwOA==",
lat: 60.20556,
lon: 24.65573
},
{
id: "U3RvcDpIU0w6MjYxNTIzMw==",
lat: 60.2023,
lon: 24.65257
},
{
id: "U3RvcDpIU0w6MjYxMTIzNQ==",
lat: 60.19896,
lon: 24.6548
},
{
id: "U3RvcDpIU0w6MjYxNTIzOQ==",
lat: 60.1952,
lon: 24.66358
},
{
id: "U3RvcDpIU0w6MjYxNTIxNg==",
lat: 60.18792,
lon: 24.66694
},
{
id: "U3RvcDpIU0w6MjQzMTIxNA==",
lat: 60.18073,
lon: 24.67139
},
{
id: "U3RvcDpIU0w6MjQzMzIxMg==",
lat: 60.17993,
lon: 24.67732
},
{
id: "U3RvcDpIU0w6MjQzMzIxMA==",
lat: 60.17515,
lon: 24.68784
},
{
id: "U3RvcDpIU0w6MjQzMzI0Ng==",
lat: 60.17303,
lon: 24.68987
},
{
id: "U3RvcDpIU0w6MjMyMTIyMQ==",
lat: 60.17427,
lon: 24.70461
},
{
id: "U3RvcDpIU0w6MjMyMTI2MQ==",
lat: 60.17485,
lon: 24.70874
},
{
id: "U3RvcDpIU0w6MjMyMTIxOA==",
lat: 60.176604,
lon: 24.716805
},
{
id: "U3RvcDpIU0w6MjMyMTIxNg==",
lat: 60.1729,
lon: 24.72234
},
{
id: "U3RvcDpIU0w6MjMyMzI0Nw==",
lat: 60.17271,
lon: 24.72739
},
{
id: "U3RvcDpIU0w6MjMyMzI1MQ==",
lat: 60.17156,
lon: 24.73162
},
{
id: "U3RvcDpIU0w6MjMyMzI1Mw==",
lat: 60.168587,
lon: 24.734538
},
{
id: "U3RvcDpIU0w6MjMyMjIxMQ==",
lat: 60.16456,
lon: 24.73676
},
{
id: "U3RvcDpIU0w6MjMxMTIxMQ==",
lat: 60.16246,
lon: 24.73833
},
{
id: "U3RvcDpIU0w6MjMxMTIwMQ==",
lat: 60.160644,
lon: 24.740316
},
{
id: "U3RvcDpIU0w6MjMxMTIwNQ==",
lat: 60.15791,
lon: 24.74276
},
{
id: "U3RvcDpIU0w6MjMxMTIwNw==",
lat: 60.15533,
lon: 24.745
},
{
id: "U3RvcDpIU0w6MjMxMTIwOA==",
lat: 60.15312,
lon: 24.74728
},
{
id: "U3RvcDpIU0w6MjMxMzIxMA==",
lat: 60.15149,
lon: 24.75032
},
{
id: "U3RvcDpIU0w6MjMxMTIxMg==",
lat: 60.14926,
lon: 24.74822
},
{
id: "U3RvcDpIU0w6MjMxMTIxNA==",
lat: 60.14808,
lon: 24.74123
},
{
id: "U3RvcDpIU0w6MjMxMjIxNg==",
lat: 60.15117,
lon: 24.73608
},
{
id: "U3RvcDpIU0w6MjMxMjIxOA==",
lat: 60.15421,
lon: 24.72872
},
{
id: "U3RvcDpIU0w6MjMxNDIyMA==",
lat: 60.15719,
lon: 24.7262
}
]
},
{
gtfsId: "HSL:4711",
shortName: "711",
longName: "Kuninkaanmäki-Tikkurila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk3MDIzMg==",
lat: 60.30053,
lon: 25.10575
},
{
id: "U3RvcDpIU0w6NDk2MDIwNQ==",
lat: 60.29786,
lon: 25.10536
},
{
id: "U3RvcDpIU0w6NDk2MDIyOQ==",
lat: 60.29727,
lon: 25.10411
},
{
id: "U3RvcDpIU0w6NDk2MDIwMQ==",
lat: 60.29577,
lon: 25.10332
},
{
id: "U3RvcDpIU0w6NDk2MDIxOQ==",
lat: 60.29418,
lon: 25.10836
},
{
id: "U3RvcDpIU0w6NDk2MDIyMg==",
lat: 60.2927,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNQ==",
lat: 60.27901,
lon: 25.10592
},
{
id: "U3RvcDpIU0w6NDk0MDIxMw==",
lat: 60.28017,
lon: 25.10204
},
{
id: "U3RvcDpIU0w6NDk0MDIxMQ==",
lat: 60.280871,
lon: 25.095651
},
{
id: "U3RvcDpIU0w6NDY0MDIxMA==",
lat: 60.28163,
lon: 25.08709
},
{
id: "U3RvcDpIU0w6NDY0MDIxMQ==",
lat: 60.28169,
lon: 25.07941
},
{
id: "U3RvcDpIU0w6NDY0MDI5MA==",
lat: 60.279277,
lon: 25.078762
},
{
id: "U3RvcDpIU0w6NDY0MDI5NA==",
lat: 60.28066,
lon: 25.07098
},
{
id: "U3RvcDpIU0w6NDY0MDIyNg==",
lat: 60.28304,
lon: 25.06759
},
{
id: "U3RvcDpIU0w6NDY0MDIyNA==",
lat: 60.28498,
lon: 25.06687
},
{
id: "U3RvcDpIU0w6NDY0MDIyMg==",
lat: 60.28505,
lon: 25.06294
},
{
id: "U3RvcDpIU0w6NDY0MDIyMA==",
lat: 60.28623,
lon: 25.05673
},
{
id: "U3RvcDpIU0w6NDY0MDIxOA==",
lat: 60.28555,
lon: 25.0519
},
{
id: "U3RvcDpIU0w6NDY0MDIxNg==",
lat: 60.28301,
lon: 25.0481
},
{
id: "U3RvcDpIU0w6NDY0MDI5Mg==",
lat: 60.28589,
lon: 25.04432
},
{
id: "U3RvcDpIU0w6NDY0MDIwMg==",
lat: 60.28895,
lon: 25.04713
},
{
id: "U3RvcDpIU0w6NDYyMDIwMQ==",
lat: 60.29099,
lon: 25.04725
},
{
id: "U3RvcDpIU0w6NDYyMDIyMw==",
lat: 60.2934,
lon: 25.05029
},
{
id: "U3RvcDpIU0w6NDYyMDIyNQ==",
lat: 60.29529,
lon: 25.04892
},
{
id: "U3RvcDpIU0w6NDYyMDIzMQ==",
lat: 60.2985,
lon: 25.05011
},
{
id: "U3RvcDpIU0w6NDYxMDIzNw==",
lat: 60.29861,
lon: 25.044342
},
{
id: "U3RvcDpIU0w6NDYxMDIwNw==",
lat: 60.293293,
lon: 25.043366
},
{
id: "U3RvcDpIU0w6NDYxMDI0OQ==",
lat: 60.293842,
lon: 25.044378
},
{
id: "U3RvcDpIU0w6NDYxMDIzNg==",
lat: 60.29838,
lon: 25.0454
},
{
id: "U3RvcDpIU0w6NDYyMDIyNg==",
lat: 60.29803,
lon: 25.0506
},
{
id: "U3RvcDpIU0w6NDYyMDIyNA==",
lat: 60.29566,
lon: 25.04876
},
{
id: "U3RvcDpIU0w6NDYyMDIwNA==",
lat: 60.29256,
lon: 25.05016
},
{
id: "U3RvcDpIU0w6NDY0MDIwMQ==",
lat: 60.28954,
lon: 25.04697
},
{
id: "U3RvcDpIU0w6NDY0MDI5Mw==",
lat: 60.28541,
lon: 25.04517
},
{
id: "U3RvcDpIU0w6NDY0MDIxNw==",
lat: 60.28283,
lon: 25.04819
},
{
id: "U3RvcDpIU0w6NDY0MDIxOQ==",
lat: 60.28581,
lon: 25.05395
},
{
id: "U3RvcDpIU0w6NDY0MDIyMQ==",
lat: 60.28585,
lon: 25.05881
},
{
id: "U3RvcDpIU0w6NDY0MDIyMw==",
lat: 60.28491,
lon: 25.06423
},
{
id: "U3RvcDpIU0w6NDY0MDIyNQ==",
lat: 60.28286,
lon: 25.06756
},
{
id: "U3RvcDpIU0w6NDY0MDI5NQ==",
lat: 60.28049,
lon: 25.07192
},
{
id: "U3RvcDpIU0w6NDY0MDI5MQ==",
lat: 60.27915,
lon: 25.078957
},
{
id: "U3RvcDpIU0w6NDY0MDIxMg==",
lat: 60.27986,
lon: 25.079974
},
{
id: "U3RvcDpIU0w6NDY0MDIwNw==",
lat: 60.28193,
lon: 25.0804
},
{
id: "U3RvcDpIU0w6NDY0MDIwOQ==",
lat: 60.28153,
lon: 25.0894
},
{
id: "U3RvcDpIU0w6NDk0MDIxMA==",
lat: 60.28073,
lon: 25.09603
},
{
id: "U3RvcDpIU0w6NDk0MDIxMg==",
lat: 60.27969,
lon: 25.10342
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDIyNw==",
lat: 60.29097,
lon: 25.11945
},
{
id: "U3RvcDpIU0w6NDk2MDIyNQ==",
lat: 60.29152,
lon: 25.11378
},
{
id: "U3RvcDpIU0w6NDk2MDIyMw==",
lat: 60.29266,
lon: 25.1126
},
{
id: "U3RvcDpIU0w6NDk2MDIyMA==",
lat: 60.29456,
lon: 25.10822
},
{
id: "U3RvcDpIU0w6NDk2MDIwMg==",
lat: 60.29575,
lon: 25.10275
},
{
id: "U3RvcDpIU0w6NDk2MDIxOA==",
lat: 60.29722,
lon: 25.10454
},
{
id: "U3RvcDpIU0w6NDk2MDIxMg==",
lat: 60.29888,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk3MDIzMw==",
lat: 60.30091,
lon: 25.10537
}
]
},
{
gtfsId: "HSL:4712",
shortName: "712",
longName: "Kuninkaanmäki-Tikkurila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk3MDIzMg==",
lat: 60.30053,
lon: 25.10575
},
{
id: "U3RvcDpIU0w6NDk3MDIzNA==",
lat: 60.30129,
lon: 25.10641
},
{
id: "U3RvcDpIU0w6NDk3MDIyOA==",
lat: 60.30416,
lon: 25.10698
},
{
id: "U3RvcDpIU0w6NDk3MDI5OQ==",
lat: 60.30677,
lon: 25.109677
},
{
id: "U3RvcDpIU0w6NDk3MDIzNg==",
lat: 60.3072,
lon: 25.11525
},
{
id: "U3RvcDpIU0w6NDk3MDIwOA==",
lat: 60.30525,
lon: 25.11701
},
{
id: "U3RvcDpIU0w6NDk3MDIwNg==",
lat: 60.30338,
lon: 25.11821
},
{
id: "U3RvcDpIU0w6NDk3MDIwNA==",
lat: 60.30143,
lon: 25.11551
},
{
id: "U3RvcDpIU0w6NDk3MDIyNg==",
lat: 60.29981,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDI0MQ==",
lat: 60.29773,
lon: 25.11143
},
{
id: "U3RvcDpIU0w6NDk2MDIzMA==",
lat: 60.29761,
lon: 25.10883
},
{
id: "U3RvcDpIU0w6NDk2MDIyOQ==",
lat: 60.29727,
lon: 25.10411
},
{
id: "U3RvcDpIU0w6NDk2MDIzNA==",
lat: 60.296906,
lon: 25.09927
},
{
id: "U3RvcDpIU0w6NDk2MDI5Ng==",
lat: 60.2938,
lon: 25.09667
},
{
id: "U3RvcDpIU0w6NDY2MDIwNQ==",
lat: 60.29378,
lon: 25.089652
},
{
id: "U3RvcDpIU0w6NDY2MDIxMg==",
lat: 60.29411,
lon: 25.08373
},
{
id: "U3RvcDpIU0w6NDY2MDIxMA==",
lat: 60.28999,
lon: 25.08171
},
{
id: "U3RvcDpIU0w6NDY2MDIwNg==",
lat: 60.28758,
lon: 25.07993
},
{
id: "U3RvcDpIU0w6NDY2MDIwNA==",
lat: 60.28978,
lon: 25.07599
},
{
id: "U3RvcDpIU0w6NDY2MDIwMg==",
lat: 60.29189,
lon: 25.07317
},
{
id: "U3RvcDpIU0w6NDY2MDI5OA==",
lat: 60.29531,
lon: 25.06689
},
{
id: "U3RvcDpIU0w6NDYyMDIwNg==",
lat: 60.29581,
lon: 25.05983
},
{
id: "U3RvcDpIU0w6NDYyMDIyMg==",
lat: 60.29868,
lon: 25.05371
},
{
id: "U3RvcDpIU0w6NDYyMDIzMQ==",
lat: 60.2985,
lon: 25.05011
},
{
id: "U3RvcDpIU0w6NDYxMDIzNw==",
lat: 60.29861,
lon: 25.044342
},
{
id: "U3RvcDpIU0w6NDYxMDIwNw==",
lat: 60.293293,
lon: 25.043366
},
{
id: "U3RvcDpIU0w6NDYxMDI0OQ==",
lat: 60.293842,
lon: 25.044378
},
{
id: "U3RvcDpIU0w6NDYxMDIzNg==",
lat: 60.29838,
lon: 25.0454
},
{
id: "U3RvcDpIU0w6NDYyMDIyNw==",
lat: 60.29821,
lon: 25.05193
},
{
id: "U3RvcDpIU0w6NDYyMDIxNw==",
lat: 60.29828,
lon: 25.055708
},
{
id: "U3RvcDpIU0w6NDYyMDIwNQ==",
lat: 60.29549,
lon: 25.0614
},
{
id: "U3RvcDpIU0w6NDY2MDI5OQ==",
lat: 60.29509,
lon: 25.06703
},
{
id: "U3RvcDpIU0w6NDY2MDIwMQ==",
lat: 60.29136,
lon: 25.07367
},
{
id: "U3RvcDpIU0w6NDY2MDIzMA==",
lat: 60.288522,
lon: 25.077184
},
{
id: "U3RvcDpIU0w6NDY2MDIwNw==",
lat: 60.2879,
lon: 25.08108
},
{
id: "U3RvcDpIU0w6NDY2MDIwOQ==",
lat: 60.29043,
lon: 25.08209
},
{
id: "U3RvcDpIU0w6NDY2MDIyMQ==",
lat: 60.29429,
lon: 25.08505
},
{
id: "U3RvcDpIU0w6NDY2MDIyOQ==",
lat: 60.293636,
lon: 25.091242
},
{
id: "U3RvcDpIU0w6NDk2MDIwOA==",
lat: 60.294405,
lon: 25.097644
},
{
id: "U3RvcDpIU0w6NDk2MDIyMQ==",
lat: 60.296912,
lon: 25.099394
},
{
id: "U3RvcDpIU0w6NDk2MDIxOA==",
lat: 60.29722,
lon: 25.10454
},
{
id: "U3RvcDpIU0w6NDk2MDIwNg==",
lat: 60.29764,
lon: 25.11134
},
{
id: "U3RvcDpIU0w6NDk3MDIwMQ==",
lat: 60.29814,
lon: 25.11254
},
{
id: "U3RvcDpIU0w6NDk3MDIyNQ==",
lat: 60.30042,
lon: 25.11287
},
{
id: "U3RvcDpIU0w6NDk3MDIwMw==",
lat: 60.30191,
lon: 25.11707
},
{
id: "U3RvcDpIU0w6NDk3MDIwNQ==",
lat: 60.3033,
lon: 25.1184
},
{
id: "U3RvcDpIU0w6NDk3MDIwNw==",
lat: 60.30592,
lon: 25.11718
},
{
id: "U3RvcDpIU0w6NDk3MDIxMA==",
lat: 60.307773,
lon: 25.114235
},
{
id: "U3RvcDpIU0w6NDk3MDI5OA==",
lat: 60.307177,
lon: 25.109792
},
{
id: "U3RvcDpIU0w6NDk3MDIyNw==",
lat: 60.30423,
lon: 25.10676
},
{
id: "U3RvcDpIU0w6NDk3MDIzNQ==",
lat: 60.30158,
lon: 25.10637
},
{
id: "U3RvcDpIU0w6NDk3MDIzMw==",
lat: 60.30091,
lon: 25.10537
}
]
},
{
gtfsId: "HSL:4713",
shortName: "713",
longName: "Hakunilan palvelulinja",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk3MDI4OA==",
lat: 60.305612,
lon: 25.116163
},
{
id: "U3RvcDpIU0w6NDk3MDI5NA==",
lat: 60.302686,
lon: 25.116353
},
{
id: "U3RvcDpIU0w6NDk3MDI0Mg==",
lat: 60.300034,
lon: 25.118128
},
{
id: "U3RvcDpIU0w6NDk3MDI0Mw==",
lat: 60.299145,
lon: 25.119169
},
{
id: "U3RvcDpIU0w6NDk2MDIxMw==",
lat: 60.29795,
lon: 25.12205
},
{
id: "U3RvcDpIU0w6NDk2MDI0MQ==",
lat: 60.29773,
lon: 25.11143
},
{
id: "U3RvcDpIU0w6NDk2MDI5NA==",
lat: 60.29714,
lon: 25.10963
},
{
id: "U3RvcDpIU0w6NDk2MDIzOA==",
lat: 60.29628,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk2MDIwMg==",
lat: 60.29575,
lon: 25.10275
},
{
id: "U3RvcDpIU0w6NDk2MDIwOQ==",
lat: 60.293237,
lon: 25.105682
},
{
id: "U3RvcDpIU0w6NDk2MDIxMA==",
lat: 60.291354,
lon: 25.106714
},
{
id: "U3RvcDpIU0w6NDk2MDIwNA==",
lat: 60.288998,
lon: 25.111356
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDI0Mg==",
lat: 60.283594,
lon: 25.118571
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDIwMA==",
lat: 60.280406,
lon: 25.119604
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIzMA==",
lat: 60.27698,
lon: 25.10402
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIzNQ==",
lat: 60.266884,
lon: 25.09546
},
{
id: "U3RvcDpIU0w6NDkzMDIyNw==",
lat: 60.268803,
lon: 25.097238
},
{
id: "U3RvcDpIU0w6NDkzMDIzNg==",
lat: 60.270948,
lon: 25.095569
},
{
id: "U3RvcDpIU0w6NDkzMDIyNA==",
lat: 60.269518,
lon: 25.092579
},
{
id: "U3RvcDpIU0w6NDkzMDIyMw==",
lat: 60.266648,
lon: 25.093825
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDI0Mg==",
lat: 60.289573,
lon: 25.123515
},
{
id: "U3RvcDpIU0w6NDk2MDIzMw==",
lat: 60.293006,
lon: 25.123018
},
{
id: "U3RvcDpIU0w6NDk3MDIzOA==",
lat: 60.298737,
lon: 25.124106
},
{
id: "U3RvcDpIU0w6NDk3MDIzOQ==",
lat: 60.300912,
lon: 25.127395
},
{
id: "U3RvcDpIU0w6NDk3MDI0MA==",
lat: 60.303466,
lon: 25.124418
},
{
id: "U3RvcDpIU0w6NDk3MDI0MQ==",
lat: 60.304912,
lon: 25.122615
}
]
},
{
gtfsId: "HSL:6914T",
shortName: "914T",
longName: "Kuntakeskus- Siuntion kk.-Bocksintie",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwMDAwNg==",
lat: 60.178044,
lon: 24.049176
},
{
id: "U3RvcDpIU0w6NjMwMDAxOA==",
lat: 60.176004,
lon: 24.062917
},
{
id: "U3RvcDpIU0w6NjMwMDAxNg==",
lat: 60.176563,
lon: 24.076933
},
{
id: "U3RvcDpIU0w6NjMwMDAxMA==",
lat: 60.174555,
lon: 24.093479
},
{
id: "U3RvcDpIU0w6NjMwMDAyMQ==",
lat: 60.173292,
lon: 24.101885
},
{
id: "U3RvcDpIU0w6NjMwMDAxNA==",
lat: 60.173985,
lon: 24.109245
},
{
id: "U3RvcDpIU0w6NjMwMDAwOQ==",
lat: 60.173839,
lon: 24.120039
},
{
id: "U3RvcDpIU0w6NjMwMDAyNQ==",
lat: 60.172955,
lon: 24.128346
},
{
id: "U3RvcDpIU0w6NjMwMDAyNA==",
lat: 60.175433,
lon: 24.14095
},
{
id: "U3RvcDpIU0w6NjMwMTAzOQ==",
lat: 60.171287,
lon: 24.163422
},
{
id: "U3RvcDpIU0w6NjMwMTA0Mg==",
lat: 60.169831,
lon: 24.177081
},
{
id: "U3RvcDpIU0w6NjMwMTAyMg==",
lat: 60.169538,
lon: 24.183912
},
{
id: "U3RvcDpIU0w6NjMwMTA1MA==",
lat: 60.169682,
lon: 24.194282
},
{
id: "U3RvcDpIU0w6NjMwMTA1Mg==",
lat: 60.170375,
lon: 24.200431
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
}
]
},
{
gtfsId: "HSL:6914B",
shortName: "914B",
longName: "Kuntakeskus- Siuntion kk.-Raivio",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE1MDIwMQ==",
lat: 60.18728,
lon: 24.296465
},
{
id: "U3RvcDpIU0w6NjMwMzAwNg==",
lat: 60.189011,
lon: 24.284748
},
{
id: "U3RvcDpIU0w6NjMwMzAwNA==",
lat: 60.190251,
lon: 24.269025
},
{
id: "U3RvcDpIU0w6NjMwMzAwMg==",
lat: 60.193857,
lon: 24.261159
},
{
id: "U3RvcDpIU0w6NjMwMTAwMg==",
lat: 60.194368,
lon: 24.251792
},
{
id: "U3RvcDpIU0w6NjMwMTAxNg==",
lat: 60.188088,
lon: 24.245
},
{
id: "U3RvcDpIU0w6NjMwMTAwMQ==",
lat: 60.184142,
lon: 24.239233
},
{
id: "U3RvcDpIU0w6NjMwMTA0Ng==",
lat: 60.180368,
lon: 24.234423
},
{
id: "U3RvcDpIU0w6NjMwMTAyNQ==",
lat: 60.178408,
lon: 24.225049
},
{
id: "U3RvcDpIU0w6NjMwMTAxMQ==",
lat: 60.172765,
lon: 24.206878
},
{
id: "U3RvcDpIU0w6NjMwMTA1Mg==",
lat: 60.170375,
lon: 24.200431
},
{
id: "U3RvcDpIU0w6NjMwMTAyNw==",
lat: 60.168741,
lon: 24.199053
},
{
id: "U3RvcDpIU0w6NjMwMTAyNA==",
lat: 60.163961,
lon: 24.198038
},
{
id: "U3RvcDpIU0w6NjMwMjAxMA==",
lat: 60.153881,
lon: 24.206897
},
{
id: "U3RvcDpIU0w6NjMwMjAwNg==",
lat: 60.149686,
lon: 24.212446
},
{
id: "U3RvcDpIU0w6NjMwMjAyMA==",
lat: 60.144488,
lon: 24.221742
},
{
id: "U3RvcDpIU0w6NjMwMjAwMg==",
lat: 60.141908,
lon: 24.224241
},
{
id: "U3RvcDpIU0w6NjMwMjAyMg==",
lat: 60.137306,
lon: 24.225504
},
{
id: "U3RvcDpIU0w6NjMwMjAxMw==",
lat: 60.137098,
lon: 24.229063
},
{
id: "U3RvcDpIU0w6NjMwMjAwMw==",
lat: 60.142883,
lon: 24.223182
},
{
id: "U3RvcDpIU0w6NjMwMjAyMQ==",
lat: 60.145087,
lon: 24.22137
},
{
id: "U3RvcDpIU0w6NjMwMjAwNw==",
lat: 60.150356,
lon: 24.210695
},
{
id: "U3RvcDpIU0w6NjMwMjAxMQ==",
lat: 60.154719,
lon: 24.207027
},
{
id: "U3RvcDpIU0w6NjMwMTAyMw==",
lat: 60.165141,
lon: 24.197315
},
{
id: "U3RvcDpIU0w6NjMwMTAzMw==",
lat: 60.171361,
lon: 24.201095
},
{
id: "U3RvcDpIU0w6NjMwMTAxMA==",
lat: 60.173575,
lon: 24.210197
},
{
id: "U3RvcDpIU0w6NjMwMTAyNg==",
lat: 60.178262,
lon: 24.223798
},
{
id: "U3RvcDpIU0w6NjMwMTA0Nw==",
lat: 60.179052,
lon: 24.233051
},
{
id: "U3RvcDpIU0w6NjMwMTAwMA==",
lat: 60.184995,
lon: 24.240861
},
{
id: "U3RvcDpIU0w6NjMwMTAxNQ==",
lat: 60.189068,
lon: 24.246139
},
{
id: "U3RvcDpIU0w6NjMwMTAwMw==",
lat: 60.194916,
lon: 24.253819
},
{
id: "U3RvcDpIU0w6NjMwMzAwMQ==",
lat: 60.192339,
lon: 24.262109
},
{
id: "U3RvcDpIU0w6NjMwMzAwMw==",
lat: 60.190393,
lon: 24.271201
},
{
id: "U3RvcDpIU0w6NjMwMzAwNQ==",
lat: 60.188498,
lon: 24.286477
},
{
id: "U3RvcDpIU0w6NjE1MDIwMg==",
lat: 60.187337,
lon: 24.298318
}
]
},
{
gtfsId: "HSL:1554",
shortName: "554",
longName: "Itäkeskus-Malmi-Tapaninkylä",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTM5MjE1NA==",
lat: 60.26573,
lon: 25.01614
},
{
id: "U3RvcDpIU0w6MTQwMzE2NA==",
lat: 60.26767,
lon: 25.01355
},
{
id: "U3RvcDpIU0w6MTQwMzE3NQ==",
lat: 60.26745,
lon: 25.00825
},
{
id: "U3RvcDpIU0w6MTQwMzE2Ng==",
lat: 60.26941,
lon: 25.00959
},
{
id: "U3RvcDpIU0w6MTQwMzE2Nw==",
lat: 60.27149,
lon: 25.00543
},
{
id: "U3RvcDpIU0w6MTQwMzE2OQ==",
lat: 60.27504,
lon: 25.0013
},
{
id: "U3RvcDpIU0w6MTQwMTEwOQ==",
lat: 60.27481,
lon: 24.99796
},
{
id: "U3RvcDpIU0w6MTQwMTEwNA==",
lat: 60.27209,
lon: 24.9922
},
{
id: "U3RvcDpIU0w6MTQwMTEwMg==",
lat: 60.26954,
lon: 24.98362
},
{
id: "U3RvcDpIU0w6MTQwMzExNQ==",
lat: 60.26636,
lon: 24.98058
},
{
id: "U3RvcDpIU0w6MTM5MTExMw==",
lat: 60.26397,
lon: 24.98368
},
{
id: "U3RvcDpIU0w6MTM5MTExMQ==",
lat: 60.26071,
lon: 24.9871
},
{
id: "U3RvcDpIU0w6MTM5MTEwOQ==",
lat: 60.2585,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM4MTEwNw==",
lat: 60.25636,
lon: 24.99936
},
{
id: "U3RvcDpIU0w6MTM4MTEyMw==",
lat: 60.253412,
lon: 25.002922
},
{
id: "U3RvcDpIU0w6MTM4MTEyMQ==",
lat: 60.25192,
lon: 25.00724
},
{
id: "U3RvcDpIU0w6MTM4MTEwNA==",
lat: 60.24999,
lon: 25.00914
},
{
id: "U3RvcDpIU0w6MTM4MjEyNA==",
lat: 60.24725,
lon: 25.01131
},
{
id: "U3RvcDpIU0w6MTM4MjExNg==",
lat: 60.24336,
lon: 25.0153
},
{
id: "U3RvcDpIU0w6MTM4MjE1MQ==",
lat: 60.242436,
lon: 25.018122
},
{
id: "U3RvcDpIU0w6MTM4MjEwNA==",
lat: 60.24164,
lon: 25.02326
},
{
id: "U3RvcDpIU0w6MTM4MjEwMg==",
lat: 60.241,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMg==",
lat: 60.236477,
lon: 25.042171
},
{
id: "U3RvcDpIU0w6MTQ1NDEyOQ==",
lat: 60.229685,
lon: 25.055331
},
{
id: "U3RvcDpIU0w6MTQ1NDExNA==",
lat: 60.227923,
lon: 25.071773
},
{
id: "U3RvcDpIU0w6MTQ1NDExMg==",
lat: 60.22483,
lon: 25.0789
},
{
id: "U3RvcDpIU0w6MTQ1NDExNw==",
lat: 60.22102,
lon: 25.08156
},
{
id: "U3RvcDpIU0w6MTQ1MzExMA==",
lat: 60.21752,
lon: 25.08351
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
},
{
id: "U3RvcDpIU0w6MTQ1MzIxNA==",
lat: 60.21033,
lon: 25.07785
},
{
id: "U3RvcDpIU0w6MTQ1MzEwNA==",
lat: 60.21008,
lon: 25.0766
},
{
id: "U3RvcDpIU0w6MTQ1MzE4MQ==",
lat: 60.21211,
lon: 25.08187
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMQ==",
lat: 60.21472,
lon: 25.08581
},
{
id: "U3RvcDpIU0w6MTQ1MzEwOQ==",
lat: 60.21775,
lon: 25.08378
},
{
id: "U3RvcDpIU0w6MTQ1NDExNg==",
lat: 60.22127,
lon: 25.08186
},
{
id: "U3RvcDpIU0w6MTQ1NDExMQ==",
lat: 60.225,
lon: 25.07936
},
{
id: "U3RvcDpIU0w6MTQ1NDExMw==",
lat: 60.22808,
lon: 25.0721
},
{
id: "U3RvcDpIU0w6MTQ3NDE4OQ==",
lat: 60.23086,
lon: 25.054144
},
{
id: "U3RvcDpIU0w6MTQ3NDEyMQ==",
lat: 60.236942,
lon: 25.045093
},
{
id: "U3RvcDpIU0w6MTM4MjEwMQ==",
lat: 60.24123,
lon: 25.03104
},
{
id: "U3RvcDpIU0w6MTM4MjE1MA==",
lat: 60.242531,
lon: 25.01917
},
{
id: "U3RvcDpIU0w6MTM4MjExNQ==",
lat: 60.24349,
lon: 25.01545
},
{
id: "U3RvcDpIU0w6MTM4MjEyMw==",
lat: 60.24755,
lon: 25.01138
},
{
id: "U3RvcDpIU0w6MTM4MjEzMw==",
lat: 60.250684,
lon: 25.009103
},
{
id: "U3RvcDpIU0w6MTM4MTEyMA==",
lat: 60.25147,
lon: 25.00839
},
{
id: "U3RvcDpIU0w6MTM4MTEyNg==",
lat: 60.253761,
lon: 25.00345
},
{
id: "U3RvcDpIU0w6MTM5MTEwNg==",
lat: 60.25733,
lon: 24.99789
},
{
id: "U3RvcDpIU0w6MTM5MTEwOA==",
lat: 60.25877,
lon: 24.9934
},
{
id: "U3RvcDpIU0w6MTM5MTExMA==",
lat: 60.26129,
lon: 24.98636
},
{
id: "U3RvcDpIU0w6MTM5MTExMg==",
lat: 60.26381,
lon: 24.98384
},
{
id: "U3RvcDpIU0w6MTQwMzEzNQ==",
lat: 60.26514,
lon: 24.98307
},
{
id: "U3RvcDpIU0w6MTQwMTExNA==",
lat: 60.26722,
lon: 24.98012
},
{
id: "U3RvcDpIU0w6MTQwMTEwMQ==",
lat: 60.2693,
lon: 24.98338
},
{
id: "U3RvcDpIU0w6MTQwMTEwMw==",
lat: 60.27145,
lon: 24.99206
},
{
id: "U3RvcDpIU0w6MTQwMTExMA==",
lat: 60.27481,
lon: 24.99852
},
{
id: "U3RvcDpIU0w6MTQwMzE3MA==",
lat: 60.27426,
lon: 25.00182
},
{
id: "U3RvcDpIU0w6MTQwMzE2OA==",
lat: 60.27189,
lon: 25.00451
},
{
id: "U3RvcDpIU0w6MTQwMzEzMw==",
lat: 60.26892,
lon: 25.00956
},
{
id: "U3RvcDpIU0w6MTM5MTE5Ng==",
lat: 60.26709,
lon: 25.00979
},
{
id: "U3RvcDpIU0w6MTM5MjE4NQ==",
lat: 60.26738,
lon: 25.01464
}
]
},
{
gtfsId: "HSL:6901K",
shortName: "901K",
longName: "Luoma-Masala-Gesterby-Hirsala",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjExMDIwMw==",
lat: 60.071335,
lon: 24.600077
},
{
id: "U3RvcDpIU0w6NjExMDIxOQ==",
lat: 60.078487,
lon: 24.59941
},
{
id: "U3RvcDpIU0w6NjExMDIwNA==",
lat: 60.089557,
lon: 24.588597
},
{
id: "U3RvcDpIU0w6NjExMDIyNA==",
lat: 60.093308,
lon: 24.58309
},
{
id: "U3RvcDpIU0w6NjExMDIxNg==",
lat: 60.094005,
lon: 24.575327
},
{
id: "U3RvcDpIU0w6NjExMDIwNg==",
lat: 60.095577,
lon: 24.5684
},
{
id: "U3RvcDpIU0w6NjExMDIyMA==",
lat: 60.099417,
lon: 24.565767
},
{
id: "U3RvcDpIU0w6NjExMDIwOQ==",
lat: 60.100827,
lon: 24.565322
},
{
id: "U3RvcDpIU0w6NjExMDIxMA==",
lat: 60.104822,
lon: 24.567557
},
{
id: "U3RvcDpIU0w6NjExMDIxMg==",
lat: 60.109715,
lon: 24.569682
},
{
id: "U3RvcDpIU0w6NjExMDIxNQ==",
lat: 60.115187,
lon: 24.552907
},
{
id: "U3RvcDpIU0w6NjAzMDIxMA==",
lat: 60.121708,
lon: 24.530325
},
{
id: "U3RvcDpIU0w6NjAzMDIxMg==",
lat: 60.124132,
lon: 24.520852
},
{
id: "U3RvcDpIU0w6NjAzMDIyOA==",
lat: 60.132833,
lon: 24.512607
},
{
id: "U3RvcDpIU0w6NjA0MDIxNg==",
lat: 60.119052,
lon: 24.477277
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA0MDIxMQ==",
lat: 60.1159,
lon: 24.4454
},
{
id: "U3RvcDpIU0w6NjA0MDIxNQ==",
lat: 60.119058,
lon: 24.4813
},
{
id: "U3RvcDpIU0w6NjAzMDIwMQ==",
lat: 60.133472,
lon: 24.512763
},
{
id: "U3RvcDpIU0w6NjAzMDIzMg==",
lat: 60.13751,
lon: 24.537388
},
{
id: "U3RvcDpIU0w6NjAyMDI2MA==",
lat: 60.148067,
lon: 24.573078
},
{
id: "U3RvcDpIU0w6NjAyMDIwOA==",
lat: 60.149502,
lon: 24.564343
},
{
id: "U3RvcDpIU0w6NjAyMDIxNA==",
lat: 60.153555,
lon: 24.544262
},
{
id: "U3RvcDpIU0w6NjAyMDIxNg==",
lat: 60.154818,
lon: 24.531715
},
{
id: "U3RvcDpIU0w6NjAyMDIxNw==",
lat: 60.155497,
lon: 24.531227
},
{
id: "U3RvcDpIU0w6NjAyMDIyNA==",
lat: 60.1588,
lon: 24.536007
},
{
id: "U3RvcDpIU0w6NjAyMDIyOA==",
lat: 60.161683,
lon: 24.538822
},
{
id: "U3RvcDpIU0w6NjAyMDIzMQ==",
lat: 60.167277,
lon: 24.541513
},
{
id: "U3RvcDpIU0w6NjAyMDIzNQ==",
lat: 60.169593,
lon: 24.543572
},
{
id: "U3RvcDpIU0w6NjAyMDIzOA==",
lat: 60.171893,
lon: 24.547945
},
{
id: "U3RvcDpIU0w6NjAyMDI0NA==",
lat: 60.176757,
lon: 24.545682
},
{
id: "U3RvcDpIU0w6NjAyMDIzOQ==",
lat: 60.172823,
lon: 24.54828
},
{
id: "U3RvcDpIU0w6NjAyMDIzNA==",
lat: 60.16918,
lon: 24.54261
},
{
id: "U3RvcDpIU0w6NjAyMDIzMA==",
lat: 60.166542,
lon: 24.540887
},
{
id: "U3RvcDpIU0w6NjAyMDIyOQ==",
lat: 60.163035,
lon: 24.539265
},
{
id: "U3RvcDpIU0w6NjAyMDIyNw==",
lat: 60.159457,
lon: 24.536668
},
{
id: "U3RvcDpIU0w6NjAyMDIxOA==",
lat: 60.156095,
lon: 24.531702
},
{
id: "U3RvcDpIU0w6NjAyMDIxNQ==",
lat: 60.154503,
lon: 24.532388
},
{
id: "U3RvcDpIU0w6NjAyMDIxMw==",
lat: 60.15282,
lon: 24.545448
},
{
id: "U3RvcDpIU0w6NjAyMDIwNw==",
lat: 60.149187,
lon: 24.56578
},
{
id: "U3RvcDpIU0w6NjAyMDI1OQ==",
lat: 60.14789,
lon: 24.572755
},
{
id: "U3RvcDpIU0w6NjAyMDIwMg==",
lat: 60.147525,
lon: 24.572943
},
{
id: "U3RvcDpIU0w6NjAzMDIwNg==",
lat: 60.137865,
lon: 24.532207
},
{
id: "U3RvcDpIU0w6NjAzMDIwMg==",
lat: 60.133613,
lon: 24.509142
},
{
id: "U3RvcDpIU0w6NjAzMDIxMw==",
lat: 60.131883,
lon: 24.513693
},
{
id: "U3RvcDpIU0w6NjAzMDIxMQ==",
lat: 60.124167,
lon: 24.51922
},
{
id: "U3RvcDpIU0w6NjAzMDIwOQ==",
lat: 60.121192,
lon: 24.5324
},
{
id: "U3RvcDpIU0w6NjExMDIxNA==",
lat: 60.115472,
lon: 24.551775
},
{
id: "U3RvcDpIU0w6NjExMDIxMw==",
lat: 60.110733,
lon: 24.568545
},
{
id: "U3RvcDpIU0w6NjExMDIxMQ==",
lat: 60.105242,
lon: 24.567665
},
{
id: "U3RvcDpIU0w6NjExMDIwOA==",
lat: 60.100745,
lon: 24.564475
},
{
id: "U3RvcDpIU0w6NjExMDIyMQ==",
lat: 60.099545,
lon: 24.565625
},
{
id: "U3RvcDpIU0w6NjExMDIwNw==",
lat: 60.09573,
lon: 24.567762
},
{
id: "U3RvcDpIU0w6NjExMDIyMg==",
lat: 60.093675,
lon: 24.571182
},
{
id: "U3RvcDpIU0w6NjExMDIxNw==",
lat: 60.094023,
lon: 24.574278
},
{
id: "U3RvcDpIU0w6NjExMDIyMw==",
lat: 60.093053,
lon: 24.583542
},
{
id: "U3RvcDpIU0w6NjExMDIwNQ==",
lat: 60.089933,
lon: 24.588155
},
{
id: "U3RvcDpIU0w6NjExMDIyNQ==",
lat: 60.082878,
lon: 24.589508
},
{
id: "U3RvcDpIU0w6NjExMDIxOA==",
lat: 60.077473,
lon: 24.60104
}
]
},
{
gtfsId: "HSL:1500",
shortName: "500",
longName: "Itäkeskus(M)-Pasila-Munkkivuori",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTMwNDEwNA==",
lat: 60.205001,
lon: 24.879196
},
{
id: "U3RvcDpIU0w6MTMwNDEyOQ==",
lat: 60.203905,
lon: 24.873805
},
{
id: "U3RvcDpIU0w6MTMwMTE0NQ==",
lat: 60.201432,
lon: 24.87506
},
{
id: "U3RvcDpIU0w6MTMwMTEwMw==",
lat: 60.197903,
lon: 24.876563
},
{
id: "U3RvcDpIU0w6MTMwMTEyMg==",
lat: 60.196005,
lon: 24.886202
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExOA==",
lat: 60.19113,
lon: 24.90804
},
{
id: "U3RvcDpIU0w6MTE1MDEzNA==",
lat: 60.19095,
lon: 24.91255
},
{
id: "U3RvcDpIU0w6MTE3MTEyMg==",
lat: 60.19145,
lon: 24.92554
},
{
id: "U3RvcDpIU0w6MTE3MTE1Mg==",
lat: 60.19662,
lon: 24.92898
},
{
id: "U3RvcDpIU0w6MTE3MzEwNA==",
lat: 60.1983,
lon: 24.937373
},
{
id: "U3RvcDpIU0w6MTIyMDEzMQ==",
lat: 60.196616,
lon: 24.94209
},
{
id: "U3RvcDpIU0w6MTIyMDExNw==",
lat: 60.19528,
lon: 24.94443
},
{
id: "U3RvcDpIU0w6MTIyMDExNQ==",
lat: 60.19326,
lon: 24.94925
},
{
id: "U3RvcDpIU0w6MTIyMDExMw==",
lat: 60.19119,
lon: 24.95434
},
{
id: "U3RvcDpIU0w6MTIyMDEyMA==",
lat: 60.189463,
lon: 24.962315
},
{
id: "U3RvcDpIU0w6MTEwMDE2MA==",
lat: 60.1886,
lon: 24.96962
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzMzEwOA==",
lat: 60.19382,
lon: 25.03673
},
{
id: "U3RvcDpIU0w6MTQzMzEwNg==",
lat: 60.198894,
lon: 25.041099
},
{
id: "U3RvcDpIU0w6MTQzMzEwMw==",
lat: 60.202472,
lon: 25.045383
},
{
id: "U3RvcDpIU0w6MTQzMzExOA==",
lat: 60.20505,
lon: 25.05101
},
{
id: "U3RvcDpIU0w6MTQzMzEyMA==",
lat: 60.20661,
lon: 25.05334
},
{
id: "U3RvcDpIU0w6MTQ1MzExNA==",
lat: 60.21033,
lon: 25.07785
},
{
id: "U3RvcDpIU0w6MTQ1MzE4NA==",
lat: 60.20952,
lon: 25.07627
},
{
id: "U3RvcDpIU0w6MTQzMzEyMQ==",
lat: 60.20659,
lon: 25.05309
},
{
id: "U3RvcDpIU0w6MTQzMzExOQ==",
lat: 60.20481,
lon: 25.05045
},
{
id: "U3RvcDpIU0w6MTQzMzEwNA==",
lat: 60.20248,
lon: 25.04501
},
{
id: "U3RvcDpIU0w6MTQzMzEwNQ==",
lat: 60.19848,
lon: 25.04089
},
{
id: "U3RvcDpIU0w6MTQzMzEwNw==",
lat: 60.19604,
lon: 25.03875
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDE1OQ==",
lat: 60.18875,
lon: 24.96923
},
{
id: "U3RvcDpIU0w6MTIyMDExOQ==",
lat: 60.18964,
lon: 24.96309
},
{
id: "U3RvcDpIU0w6MTIyMDExMg==",
lat: 60.19091,
lon: 24.95609
},
{
id: "U3RvcDpIU0w6MTIyMDEzNA==",
lat: 60.19321,
lon: 24.95005
},
{
id: "U3RvcDpIU0w6MTIyMDExNA==",
lat: 60.194732,
lon: 24.946392
},
{
id: "U3RvcDpIU0w6MTE3MzExMw==",
lat: 60.19669,
lon: 24.941768
},
{
id: "U3RvcDpIU0w6MTE3MzEyNQ==",
lat: 60.198537,
lon: 24.937137
},
{
id: "U3RvcDpIU0w6MTE3MTE1Mw==",
lat: 60.19641,
lon: 24.9288
},
{
id: "U3RvcDpIU0w6MTE4MDEyMQ==",
lat: 60.19123,
lon: 24.92366
},
{
id: "U3RvcDpIU0w6MTE1MDEzMw==",
lat: 60.1913,
lon: 24.91195
},
{
id: "U3RvcDpIU0w6MTE1MDExNg==",
lat: 60.191346,
lon: 24.906254
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTMwMTE0OA==",
lat: 60.197065,
lon: 24.88267
},
{
id: "U3RvcDpIU0w6MTMwMTE0Nw==",
lat: 60.198302,
lon: 24.876747
},
{
id: "U3RvcDpIU0w6MTMwMTE0Ng==",
lat: 60.201122,
lon: 24.875988
},
{
id: "U3RvcDpIU0w6MTMwNDE1OQ==",
lat: 60.20391,
lon: 24.87377
},
{
id: "U3RvcDpIU0w6MTMwNDE2MQ==",
lat: 60.20542,
lon: 24.87725
}
]
},
{
gtfsId: "HSL:4719K",
shortName: "719K",
longName: "Nybygget-Länsisalmi-Hakunila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk4MDIxNw==",
lat: 60.28471,
lon: 25.18175
},
{
id: "U3RvcDpIU0w6NDk4MDIxNg==",
lat: 60.28252,
lon: 25.15787
},
{
id: "U3RvcDpIU0w6NDk4MDIwOQ==",
lat: 60.28843,
lon: 25.13889
},
{
id: "U3RvcDpIU0w6NDk4MDIxMQ==",
lat: 60.28449,
lon: 25.13485
},
{
id: "U3RvcDpIU0w6NDk4MDIyMA==",
lat: 60.27699,
lon: 25.13448
},
{
id: "U3RvcDpIU0w6NDkyMDIwMQ==",
lat: 60.27523,
lon: 25.13787
},
{
id: "U3RvcDpIU0w6NDkyMDIwMw==",
lat: 60.2721,
lon: 25.1386
},
{
id: "U3RvcDpIU0w6NDkyMDIwNQ==",
lat: 60.26836,
lon: 25.13851
},
{
id: "U3RvcDpIU0w6NDkyMDIwNw==",
lat: 60.265003,
lon: 25.140218
},
{
id: "U3RvcDpIU0w6NDkwMDIwOQ==",
lat: 60.25796,
lon: 25.14486
},
{
id: "U3RvcDpIU0w6NDkwMDIwMw==",
lat: 60.25638,
lon: 25.14215
},
{
id: "U3RvcDpIU0w6NDkwMDIwOA==",
lat: 60.25836,
lon: 25.14474
},
{
id: "U3RvcDpIU0w6NDkyMDIwOA==",
lat: 60.26487,
lon: 25.14023
},
{
id: "U3RvcDpIU0w6NDkyMDIwNg==",
lat: 60.269,
lon: 25.13899
},
{
id: "U3RvcDpIU0w6NDkyMDIwNA==",
lat: 60.27321,
lon: 25.1384
},
{
id: "U3RvcDpIU0w6NDkyMDIwMg==",
lat: 60.27563,
lon: 25.13748
},
{
id: "U3RvcDpIU0w6NDk4MDIxMw==",
lat: 60.27735,
lon: 25.13335
},
{
id: "U3RvcDpIU0w6NDk0MDIwMQ==",
lat: 60.27995,
lon: 25.12467
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OA==",
lat: 60.28001,
lon: 25.11556
},
{
id: "U3RvcDpIU0w6NDk0MDI5Nw==",
lat: 60.27866,
lon: 25.11328
},
{
id: "U3RvcDpIU0w6NDk0MDIwNA==",
lat: 60.27641,
lon: 25.11153
},
{
id: "U3RvcDpIU0w6NDk0MDIwNg==",
lat: 60.2751,
lon: 25.10886
},
{
id: "U3RvcDpIU0w6NDk0MDIwOA==",
lat: 60.27165,
lon: 25.10582
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDIzMA==",
lat: 60.27698,
lon: 25.10402
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDk0MDIwOQ==",
lat: 60.27158,
lon: 25.10579
},
{
id: "U3RvcDpIU0w6NDk0MDIwNw==",
lat: 60.27485,
lon: 25.10877
},
{
id: "U3RvcDpIU0w6NDk0MDIwNQ==",
lat: 60.27662,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6NDk0MDI5Ng==",
lat: 60.27916,
lon: 25.11468
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyOA==",
lat: 60.2815,
lon: 25.12098
},
{
id: "U3RvcDpIU0w6NDk0MDIwMg==",
lat: 60.2793,
lon: 25.12528
},
{
id: "U3RvcDpIU0w6NDk4MDIxNA==",
lat: 60.27794,
lon: 25.13378
},
{
id: "U3RvcDpIU0w6NDk4MDIxMg==",
lat: 60.28507,
lon: 25.13526
}
]
},
{
gtfsId: "HSL:1093K",
shortName: "93K",
longName: "Itäkeskus(M)-Östersundom-Karhusaari-Landbo",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTQ1MzE4OQ==",
lat: 60.20987,
lon: 25.07621
},
{
id: "U3RvcDpIU0w6MTQ1MzExNw==",
lat: 60.21156,
lon: 25.08114
},
{
id: "U3RvcDpIU0w6MTQ1MzExOQ==",
lat: 60.21466,
lon: 25.08826
},
{
id: "U3RvcDpIU0w6MTQ1MjExOQ==",
lat: 60.215433,
lon: 25.094638
},
{
id: "U3RvcDpIU0w6MTQ1MTE4Nw==",
lat: 60.21833,
lon: 25.10429
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MA==",
lat: 60.22011,
lon: 25.10815
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mg==",
lat: 60.22345,
lon: 25.11436
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mg==",
lat: 60.22755,
lon: 25.12199
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NA==",
lat: 60.23008,
lon: 25.12675
},
{
id: "U3RvcDpIU0w6MTQ3MzExOQ==",
lat: 60.23115,
lon: 25.12893
},
{
id: "U3RvcDpIU0w6MTYwMDIwMQ==",
lat: 60.2431,
lon: 25.14191
},
{
id: "U3RvcDpIU0w6MTYwMDIwMw==",
lat: 60.245348,
lon: 25.151417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNQ==",
lat: 60.246743,
lon: 25.155558
},
{
id: "U3RvcDpIU0w6MTYwMDIwNw==",
lat: 60.249545,
lon: 25.164438
},
{
id: "U3RvcDpIU0w6MTYwMDIwOQ==",
lat: 60.251682,
lon: 25.176211
},
{
id: "U3RvcDpIU0w6MTYwMDIxMQ==",
lat: 60.253477,
lon: 25.185895
},
{
id: "U3RvcDpIU0w6MTYwMTIwNQ==",
lat: 60.254682,
lon: 25.19118
},
{
id: "U3RvcDpIU0w6MTYwMTIwMQ==",
lat: 60.250873,
lon: 25.206712
},
{
id: "U3RvcDpIU0w6MTYwMTIwOQ==",
lat: 60.250312,
lon: 25.21374
},
{
id: "U3RvcDpIU0w6MTYwMTIwMw==",
lat: 60.249875,
lon: 25.220435
},
{
id: "U3RvcDpIU0w6MTYwMTIwNw==",
lat: 60.251412,
lon: 25.226228
},
{
id: "U3RvcDpIU0w6MTYwMTIwNg==",
lat: 60.252653,
lon: 25.230468
},
{
id: "U3RvcDpIU0w6MTYwMTIwOA==",
lat: 60.251579,
lon: 25.225211
},
{
id: "U3RvcDpIU0w6MTYwMTIwNA==",
lat: 60.249973,
lon: 25.21957
},
{
id: "U3RvcDpIU0w6MTYwMTIxMA==",
lat: 60.250277,
lon: 25.214468
},
{
id: "U3RvcDpIU0w6MTYwMTIwMg==",
lat: 60.250832,
lon: 25.206825
},
{
id: "U3RvcDpIU0w6MTYwMDIxMw==",
lat: 60.255158,
lon: 25.192102
},
{
id: "U3RvcDpIU0w6MTYwMjIwMQ==",
lat: 60.26087,
lon: 25.20992
},
{
id: "U3RvcDpIU0w6MTYwMjIwMw==",
lat: 60.270892,
lon: 25.201837
},
{
id: "U3RvcDpIU0w6MTYwMjEwOQ==",
lat: 60.268693,
lon: 25.197693
},
{
id: "U3RvcDpIU0w6MTYwMjExMA==",
lat: 60.26958,
lon: 25.19261
},
{
id: "U3RvcDpIU0w6MTYwMjExMQ==",
lat: 60.271778,
lon: 25.194812
},
{
id: "U3RvcDpIU0w6MTYwMjEwMg==",
lat: 60.270765,
lon: 25.201473
},
{
id: "U3RvcDpIU0w6MTYwMjIwNA==",
lat: 60.265179,
lon: 25.209755
},
{
id: "U3RvcDpIU0w6MTYwMjIwMg==",
lat: 60.261023,
lon: 25.209925
},
{
id: "U3RvcDpIU0w6MTYwMDIxNg==",
lat: 60.25977,
lon: 25.208407
},
{
id: "U3RvcDpIU0w6MTYwMDIxNA==",
lat: 60.25475,
lon: 25.190433
},
{
id: "U3RvcDpIU0w6MTYwMDIxMg==",
lat: 60.253138,
lon: 25.183522
},
{
id: "U3RvcDpIU0w6MTYwMDIxMA==",
lat: 60.2514,
lon: 25.173983
},
{
id: "U3RvcDpIU0w6MTYwMDIwOA==",
lat: 60.249428,
lon: 25.163417
},
{
id: "U3RvcDpIU0w6MTYwMDIwNg==",
lat: 60.24737,
lon: 25.156468
},
{
id: "U3RvcDpIU0w6MTYwMDIwNA==",
lat: 60.245817,
lon: 25.152437
},
{
id: "U3RvcDpIU0w6MTYwMDIwMg==",
lat: 60.24422,
lon: 25.142975
},
{
id: "U3RvcDpIU0w6MTQ3MzEyMA==",
lat: 60.23124,
lon: 25.12868
},
{
id: "U3RvcDpIU0w6MTQ3MzE2NQ==",
lat: 60.230417,
lon: 25.126925
},
{
id: "U3RvcDpIU0w6MTQ3MzE2Mw==",
lat: 60.22763,
lon: 25.12171
},
{
id: "U3RvcDpIU0w6MTQ1MTE5Mw==",
lat: 60.22338,
lon: 25.11381
},
{
id: "U3RvcDpIU0w6MTQ1MTE5MQ==",
lat: 60.22017,
lon: 25.10757
},
{
id: "U3RvcDpIU0w6MTQ1MTE4OA==",
lat: 60.21806,
lon: 25.10282
},
{
id: "U3RvcDpIU0w6MTQ1MzEzNA==",
lat: 60.21477,
lon: 25.09232
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMA==",
lat: 60.21479,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ1MzEyMg==",
lat: 60.21348,
lon: 25.08321
},
{
id: "U3RvcDpIU0w6MTQ1MzExOA==",
lat: 60.21144,
lon: 25.079953
}
]
},
{
gtfsId: "HSL:1506",
shortName: "506",
longName: "Myllypuro(M)-Viikki-Kumpula-Pasila-Meilahti",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTE1MDE0NQ==",
lat: 60.18994,
lon: 24.90626
},
{
id: "U3RvcDpIU0w6MTE1MDExOA==",
lat: 60.19113,
lon: 24.90804
},
{
id: "U3RvcDpIU0w6MTE1MDEzNA==",
lat: 60.19095,
lon: 24.91255
},
{
id: "U3RvcDpIU0w6MTE3MTEyMg==",
lat: 60.19145,
lon: 24.92554
},
{
id: "U3RvcDpIU0w6MTE3MTEzNA==",
lat: 60.19303,
lon: 24.9299
},
{
id: "U3RvcDpIU0w6MTE3MTE1Mg==",
lat: 60.19662,
lon: 24.92898
},
{
id: "U3RvcDpIU0w6MTE3MzEwNQ==",
lat: 60.19942,
lon: 24.93461
},
{
id: "U3RvcDpIU0w6MTE3MzEwNw==",
lat: 60.20298,
lon: 24.93323
},
{
id: "U3RvcDpIU0w6MTE3MzEzMg==",
lat: 60.20781,
lon: 24.9413
},
{
id: "U3RvcDpIU0w6MTI1MDExMQ==",
lat: 60.20885,
lon: 24.94716
},
{
id: "U3RvcDpIU0w6MTI1MDExMw==",
lat: 60.21096,
lon: 24.95256
},
{
id: "U3RvcDpIU0w6MTI1MDExNQ==",
lat: 60.21249,
lon: 24.95648
},
{
id: "U3RvcDpIU0w6MTI1MDEwNg==",
lat: 60.21303,
lon: 24.95897
},
{
id: "U3RvcDpIU0w6MTI0MDEwOA==",
lat: 60.2097,
lon: 24.96382
},
{
id: "U3RvcDpIU0w6MTI0MDEzMQ==",
lat: 60.20816,
lon: 24.96606
},
{
id: "U3RvcDpIU0w6MTI0MDEzMw==",
lat: 60.20488,
lon: 24.96385
},
{
id: "U3RvcDpIU0w6MTIzMDEwOQ==",
lat: 60.20312,
lon: 24.9673
},
{
id: "U3RvcDpIU0w6MTIzMDExMw==",
lat: 60.20548,
lon: 24.97209
},
{
id: "U3RvcDpIU0w6MTIzMDEwNA==",
lat: 60.20827,
lon: 24.97504
},
{
id: "U3RvcDpIU0w6MTIzMDEwMg==",
lat: 60.21121,
lon: 24.97757
},
{
id: "U3RvcDpIU0w6MTI3MDEwMw==",
lat: 60.21316,
lon: 24.97917
},
{
id: "U3RvcDpIU0w6MTI3MDEwNA==",
lat: 60.217158,
lon: 24.981087
},
{
id: "U3RvcDpIU0w6MTM2MTEwMw==",
lat: 60.21896,
lon: 24.98699
},
{
id: "U3RvcDpIU0w6MTM2MTEwNQ==",
lat: 60.22475,
lon: 24.99648
},
{
id: "U3RvcDpIU0w6MTM2MTEwNw==",
lat: 60.22709,
lon: 25.00447
},
{
id: "U3RvcDpIU0w6MTM2MjEzOQ==",
lat: 60.22709,
lon: 25.01242
},
{
id: "U3RvcDpIU0w6MTM2MjEzNw==",
lat: 60.22536,
lon: 25.01653
},
{
id: "U3RvcDpIU0w6MTM2MjExOA==",
lat: 60.22445,
lon: 25.02165
},
{
id: "U3RvcDpIU0w6MTM2MjExNQ==",
lat: 60.22567,
lon: 25.02402
},
{
id: "U3RvcDpIU0w6MTM2MjEyNw==",
lat: 60.22806,
lon: 25.02792
},
{
id: "U3RvcDpIU0w6MTM2MjEyOQ==",
lat: 60.23112,
lon: 25.03053
},
{
id: "U3RvcDpIU0w6MTM2MjEzMw==",
lat: 60.23366,
lon: 25.0309
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mw==",
lat: 60.23446,
lon: 25.03309
},
{
id: "U3RvcDpIU0w6MTM2MjE0NQ==",
lat: 60.23508,
lon: 25.04165
},
{
id: "U3RvcDpIU0w6MTM2MjE0Nw==",
lat: 60.234,
lon: 25.04546
},
{
id: "U3RvcDpIU0w6MTM2MjEwMw==",
lat: 60.232415,
lon: 25.048574
},
{
id: "U3RvcDpIU0w6MTQ1NDEzMw==",
lat: 60.229547,
lon: 25.053197
},
{
id: "U3RvcDpIU0w6MTQ1NDEyOQ==",
lat: 60.229685,
lon: 25.055331
},
{
id: "U3RvcDpIU0w6MTQ1NDExNA==",
lat: 60.227923,
lon: 25.071773
},
{
id: "U3RvcDpIU0w6MTQ1NDExMg==",
lat: 60.22483,
lon: 25.0789
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MA==",
lat: 60.22444,
lon: 25.07567
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Mw==",
lat: 60.22775,
lon: 25.0709
},
{
id: "U3RvcDpIU0w6MTQ1NDEzNg==",
lat: 60.228565,
lon: 25.065237
},
{
id: "U3RvcDpIU0w6MTQ1NDEzNQ==",
lat: 60.229505,
lon: 25.055613
},
{
id: "U3RvcDpIU0w6MTM2MjEwMg==",
lat: 60.232588,
lon: 25.048672
},
{
id: "U3RvcDpIU0w6MTM2MjE0OA==",
lat: 60.23443,
lon: 25.04458
},
{
id: "U3RvcDpIU0w6MTM2MjE0Ng==",
lat: 60.23531,
lon: 25.04045
},
{
id: "U3RvcDpIU0w6MTM2MjE0NA==",
lat: 60.23451,
lon: 25.03253
},
{
id: "U3RvcDpIU0w6MTM2MjExOQ==",
lat: 60.233,
lon: 25.03099
},
{
id: "U3RvcDpIU0w6MTM2MjEzMA==",
lat: 60.23052,
lon: 25.02988
},
{
id: "U3RvcDpIU0w6MTM2MjEyOA==",
lat: 60.22822,
lon: 25.02787
},
{
id: "U3RvcDpIU0w6MTM2MjExNg==",
lat: 60.22564,
lon: 25.02357
},
{
id: "U3RvcDpIU0w6MTM2MjExMg==",
lat: 60.22423,
lon: 25.0203
},
{
id: "U3RvcDpIU0w6MTM2MjEzOA==",
lat: 60.225563,
lon: 25.016455
},
{
id: "U3RvcDpIU0w6MTM2MjE0MA==",
lat: 60.22724,
lon: 25.01184
},
{
id: "U3RvcDpIU0w6MTM2MTEwOA==",
lat: 60.22744,
lon: 25.00263
},
{
id: "U3RvcDpIU0w6MTM2MTEyMA==",
lat: 60.225478,
lon: 24.997258
},
{
id: "U3RvcDpIU0w6MTM2MTEwNg==",
lat: 60.223823,
lon: 24.995055
},
{
id: "U3RvcDpIU0w6MTM2MTEwNA==",
lat: 60.21836,
lon: 24.98539
},
{
id: "U3RvcDpIU0w6MTI3MDEwNQ==",
lat: 60.21611,
lon: 24.98016
},
{
id: "U3RvcDpIU0w6MTI3MDEwMg==",
lat: 60.21252,
lon: 24.97844
},
{
id: "U3RvcDpIU0w6MTIzMDEwMQ==",
lat: 60.210234,
lon: 24.976613
},
{
id: "U3RvcDpIU0w6MTIzMDEwMw==",
lat: 60.20808,
lon: 24.97474
},
{
id: "U3RvcDpIU0w6MTIzMDExNA==",
lat: 60.20593,
lon: 24.97255
},
{
id: "U3RvcDpIU0w6MTIzMDExMg==",
lat: 60.20316,
lon: 24.96657
},
{
id: "U3RvcDpIU0w6MTI0MDEzNA==",
lat: 60.20583,
lon: 24.96293
},
{
id: "U3RvcDpIU0w6MTI0MDEzMg==",
lat: 60.20808,
lon: 24.96621
},
{
id: "U3RvcDpIU0w6MTI0MDEwNw==",
lat: 60.20952,
lon: 24.96435
},
{
id: "U3RvcDpIU0w6MTI1MDEwNQ==",
lat: 60.2129,
lon: 24.95926
},
{
id: "U3RvcDpIU0w6MTI1MDExNg==",
lat: 60.21238,
lon: 24.95536
},
{
id: "U3RvcDpIU0w6MTI1MDExNA==",
lat: 60.21108,
lon: 24.95203
},
{
id: "U3RvcDpIU0w6MTI1MDExMg==",
lat: 60.20938,
lon: 24.94761
},
{
id: "U3RvcDpIU0w6MTI1MDEzMw==",
lat: 60.20863,
lon: 24.94408
},
{
id: "U3RvcDpIU0w6MTE3MzEzMw==",
lat: 60.20753,
lon: 24.93986
},
{
id: "U3RvcDpIU0w6MTE3MzEwOA==",
lat: 60.2026,
lon: 24.9329
},
{
id: "U3RvcDpIU0w6MTE3MzEwNg==",
lat: 60.19989,
lon: 24.93402
},
{
id: "U3RvcDpIU0w6MTE3MTE1Mw==",
lat: 60.19641,
lon: 24.9288
},
{
id: "U3RvcDpIU0w6MTE3MTEzNQ==",
lat: 60.19232,
lon: 24.92817
},
{
id: "U3RvcDpIU0w6MTE4MDEyMQ==",
lat: 60.19123,
lon: 24.92366
},
{
id: "U3RvcDpIU0w6MTE1MDEzMw==",
lat: 60.1913,
lon: 24.91195
},
{
id: "U3RvcDpIU0w6MTE1MDExMA==",
lat: 60.19067,
lon: 24.90756
}
]
},
{
gtfsId: "HSL:7280",
shortName: "280",
longName: "Kamppi-Turunväylä-Veikkola-",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjE3MDIxNg==",
lat: 60.282955,
lon: 24.40827
},
{
id: "U3RvcDpIU0w6NjE3MDIxNA==",
lat: 60.279164,
lon: 24.411463
},
{
id: "U3RvcDpIU0w6NjE3MDIxMg==",
lat: 60.276707,
lon: 24.416505
},
{
id: "U3RvcDpIU0w6NjE3MDIxMA==",
lat: 60.273982,
lon: 24.422243
},
{
id: "U3RvcDpIU0w6NjE3MDIwOA==",
lat: 60.272485,
lon: 24.427072
},
{
id: "U3RvcDpIU0w6NjE3MDIyOA==",
lat: 60.27056,
lon: 24.439
},
{
id: "U3RvcDpIU0w6NjE3MDIwNg==",
lat: 60.269694,
lon: 24.444329
},
{
id: "U3RvcDpIU0w6MjYxMTIxNQ==",
lat: 60.215458,
lon: 24.660593
},
{
id: "U3RvcDpIU0w6MjI0MjIxMg==",
lat: 60.20552,
lon: 24.75889
},
{
id: "U3RvcDpIU0w6MjI1MjIwNQ==",
lat: 60.206778,
lon: 24.787551
},
{
id: "U3RvcDpIU0w6MjEyMjIwMQ==",
lat: 60.20835,
lon: 24.81254
},
{
id: "U3RvcDpIU0w6MTMwMTE1OA==",
lat: 60.20188,
lon: 24.88185
},
{
id: "U3RvcDpIU0w6MTMwMTEyMg==",
lat: 60.196005,
lon: 24.886202
},
{
id: "U3RvcDpIU0w6MTE1MDExMg==",
lat: 60.19281,
lon: 24.89547
},
{
id: "U3RvcDpIU0w6MTE1MDExOA==",
lat: 60.19113,
lon: 24.90804
},
{
id: "U3RvcDpIU0w6MTE0MDExOA==",
lat: 60.18922,
lon: 24.91698
},
{
id: "U3RvcDpIU0w6MTE0MDExNQ==",
lat: 60.18346,
lon: 24.92454
},
{
id: "U3RvcDpIU0w6MTEzMDEwNw==",
lat: 60.17714,
lon: 24.92988
},
{
id: "U3RvcDpIU0w6MTEzMDEwNQ==",
lat: 60.17391,
lon: 24.93328
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDIwNg==",
lat: 60.17842,
lon: 24.92938
},
{
id: "U3RvcDpIU0w6MTE0MDIwNQ==",
lat: 60.182265,
lon: 24.926924
},
{
id: "U3RvcDpIU0w6MTE0MDExNw==",
lat: 60.18948,
lon: 24.91707
},
{
id: "U3RvcDpIU0w6MTE1MDExNg==",
lat: 60.191346,
lon: 24.906254
},
{
id: "U3RvcDpIU0w6MTE1MDExMQ==",
lat: 60.19352,
lon: 24.89467
},
{
id: "U3RvcDpIU0w6MTMwMTEyMw==",
lat: 60.19735,
lon: 24.88474
},
{
id: "U3RvcDpIU0w6MTMwMTEyNQ==",
lat: 60.20002,
lon: 24.88334
},
{
id: "U3RvcDpIU0w6MjI1MjIwMg==",
lat: 60.208897,
lon: 24.812408
},
{
id: "U3RvcDpIU0w6MjI1MjIwNg==",
lat: 60.207086,
lon: 24.783914
},
{
id: "U3RvcDpIU0w6MjEzMTI1MQ==",
lat: 60.20632,
lon: 24.75354
},
{
id: "U3RvcDpIU0w6MjYxMTI4OQ==",
lat: 60.215959,
lon: 24.661282
},
{
id: "U3RvcDpIU0w6NjE3MDIwNw==",
lat: 60.27008,
lon: 24.443606
},
{
id: "U3RvcDpIU0w6NjE3MDIyNw==",
lat: 60.271035,
lon: 24.437315
},
{
id: "U3RvcDpIU0w6NjE3MDIwOQ==",
lat: 60.272774,
lon: 24.426463
},
{
id: "U3RvcDpIU0w6NjE3MDIxMQ==",
lat: 60.274747,
lon: 24.421215
},
{
id: "U3RvcDpIU0w6NjE3MDIxMw==",
lat: 60.277579,
lon: 24.41515
},
{
id: "U3RvcDpIU0w6NjE3MDIxNQ==",
lat: 60.278958,
lon: 24.412177
},
{
id: "U3RvcDpIU0w6NjE3MDIxNw==",
lat: 60.283153,
lon: 24.408507
}
]
},
{
gtfsId: "HSL:1092N",
shortName: "92N",
longName: "Rautatientori-Myllypuro-Kivikko-Kontula (Keinutie)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMA==",
lat: 60.17132,
lon: 24.94302
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzMTEwNQ==",
lat: 60.19461,
lon: 25.0322
},
{
id: "U3RvcDpIU0w6MTQzMTE4MQ==",
lat: 60.1991,
lon: 25.03757
},
{
id: "U3RvcDpIU0w6MTQzMzEyOA==",
lat: 60.20521,
lon: 25.04774
},
{
id: "U3RvcDpIU0w6MTQzMzEyMA==",
lat: 60.20661,
lon: 25.05334
},
{
id: "U3RvcDpIU0w6MTQ1NjExOA==",
lat: 60.2102,
lon: 25.05852
},
{
id: "U3RvcDpIU0w6MTQ1NjEwMQ==",
lat: 60.215588,
lon: 25.060236
},
{
id: "U3RvcDpIU0w6MTQ1NDExOA==",
lat: 60.218648,
lon: 25.058152
},
{
id: "U3RvcDpIU0w6MTQ1NDE1Ng==",
lat: 60.21997,
lon: 25.05752
},
{
id: "U3RvcDpIU0w6MTQ1NDE1MA==",
lat: 60.22192,
lon: 25.05795
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OA==",
lat: 60.22447,
lon: 25.05881
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Ng==",
lat: 60.22731,
lon: 25.06406
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NA==",
lat: 60.22739,
lon: 25.07177
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MQ==",
lat: 60.2236,
lon: 25.07608
},
{
id: "U3RvcDpIU0w6MTQ1NDExNQ==",
lat: 60.223549,
lon: 25.082989
},
{
id: "U3RvcDpIU0w6MTQ3MTE2NA==",
lat: 60.225494,
lon: 25.083088
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMw==",
lat: 60.22723,
lon: 25.08458
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNQ==",
lat: 60.22981,
lon: 25.08912
},
{
id: "U3RvcDpIU0w6MTQ3MTE1OA==",
lat: 60.23084,
lon: 25.08527
},
{
id: "U3RvcDpIU0w6MTQ3MTE4NQ==",
lat: 60.2317,
lon: 25.08121
},
{
id: "U3RvcDpIU0w6MTQ3MTEyMA==",
lat: 60.23377,
lon: 25.08125
},
{
id: "U3RvcDpIU0w6MTQ3MTE1OQ==",
lat: 60.23613,
lon: 25.08247
},
{
id: "U3RvcDpIU0w6MTQ3MTEzOA==",
lat: 60.235943,
lon: 25.080696
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NA==",
lat: 60.23335,
lon: 25.07789
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mg==",
lat: 60.231,
lon: 25.0756
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Ng==",
lat: 60.22852,
lon: 25.07353
},
{
id: "U3RvcDpIU0w6MTQ3MTE3OA==",
lat: 60.22896,
lon: 25.06766
},
{
id: "U3RvcDpIU0w6MTQ3MTE4MA==",
lat: 60.23153,
lon: 25.06444
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMQ==",
lat: 60.23361,
lon: 25.0628
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMw==",
lat: 60.23707,
lon: 25.06766
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNQ==",
lat: 60.23879,
lon: 25.06735
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNw==",
lat: 60.24025,
lon: 25.07194
},
{
id: "U3RvcDpIU0w6MTQ3MTE1NA==",
lat: 60.238443,
lon: 25.071928
},
{
id: "U3RvcDpIU0w6MTQ3MTE1NQ==",
lat: 60.23607,
lon: 25.0716
},
{
id: "U3RvcDpIU0w6MTQ3MTEzMw==",
lat: 60.23795,
lon: 25.07195
},
{
id: "U3RvcDpIU0w6MTQ3NDEwOA==",
lat: 60.24054,
lon: 25.07018
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNg==",
lat: 60.2387,
lon: 25.0672
},
{
id: "U3RvcDpIU0w6MTQ3NDEwNA==",
lat: 60.23695,
lon: 25.06738
},
{
id: "U3RvcDpIU0w6MTQ3NDEwMg==",
lat: 60.23314,
lon: 25.06215
},
{
id: "U3RvcDpIU0w6MTQ3MTE4Mw==",
lat: 60.2309,
lon: 25.06506
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Nw==",
lat: 60.22886,
lon: 25.06757
},
{
id: "U3RvcDpIU0w6MTQ3MTE3NQ==",
lat: 60.22913,
lon: 25.074
},
{
id: "U3RvcDpIU0w6MTQ3MTE3MQ==",
lat: 60.23145,
lon: 25.07625
},
{
id: "U3RvcDpIU0w6MTQ3MTE3Mw==",
lat: 60.23353,
lon: 25.07833
},
{
id: "U3RvcDpIU0w6MTQ3MTEzNw==",
lat: 60.235733,
lon: 25.08065
},
{
id: "U3RvcDpIU0w6MTQ3MTE3OQ==",
lat: 60.23602,
lon: 25.0822
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Ng==",
lat: 60.23179,
lon: 25.08045
},
{
id: "U3RvcDpIU0w6MTQ3MTE1Nw==",
lat: 60.23065,
lon: 25.0857
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNg==",
lat: 60.2287,
lon: 25.0882
},
{
id: "U3RvcDpIU0w6MTQ3MTEyNA==",
lat: 60.22677,
lon: 25.08374
},
{
id: "U3RvcDpIU0w6MTQ3MTExNA==",
lat: 60.224607,
lon: 25.084945
},
{
id: "U3RvcDpIU0w6MTQ1NDEyNw==",
lat: 60.223605,
lon: 25.082473
},
{
id: "U3RvcDpIU0w6MTQ1NDE0MA==",
lat: 60.22444,
lon: 25.07567
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Mw==",
lat: 60.22775,
lon: 25.0709
},
{
id: "U3RvcDpIU0w6MTQ1NDE0NQ==",
lat: 60.227,
lon: 25.06296
},
{
id: "U3RvcDpIU0w6MTQ1NDE0Nw==",
lat: 60.22353,
lon: 25.05775
},
{
id: "U3RvcDpIU0w6MTQ1NDE0OQ==",
lat: 60.22198,
lon: 25.05776
},
{
id: "U3RvcDpIU0w6MTQ1NDE1Nw==",
lat: 60.22014,
lon: 25.05738
},
{
id: "U3RvcDpIU0w6MTQ1NDExOQ==",
lat: 60.218012,
lon: 25.059017
},
{
id: "U3RvcDpIU0w6MTQ1NjEwMg==",
lat: 60.215364,
lon: 25.059164
},
{
id: "U3RvcDpIU0w6MTQ1NjE1Mw==",
lat: 60.209323,
lon: 25.056896
},
{
id: "U3RvcDpIU0w6MTQzMzEyMQ==",
lat: 60.20659,
lon: 25.05309
},
{
id: "U3RvcDpIU0w6MTQzMzEyNw==",
lat: 60.2052,
lon: 25.04822
},
{
id: "U3RvcDpIU0w6MTQzMTE4Mg==",
lat: 60.2058,
lon: 25.04504
},
{
id: "U3RvcDpIU0w6MTQzMTE4MA==",
lat: 60.19873,
lon: 25.03652
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:7192",
shortName: "192",
longName: "Kamppi-Länsiväylä(-Inkoo)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjMwNDAwMA==",
lat: 60.094333,
lon: 24.242655
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjMwNDAwNg==",
lat: 60.097625,
lon: 24.289709
},
{
id: "U3RvcDpIU0w6NjMwNzAwNA==",
lat: 60.099132,
lon: 24.303275
},
{
id: "U3RvcDpIU0w6NjMwNzAwOA==",
lat: 60.099232,
lon: 24.331415
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNA==",
lat: 60.106061,
lon: 24.371492
},
{
id: "U3RvcDpIU0w6NjA1MDIwNQ==",
lat: 60.110392,
lon: 24.384672
},
{
id: "U3RvcDpIU0w6NjA0MDIwOQ==",
lat: 60.114941,
lon: 24.414073
},
{
id: "U3RvcDpIU0w6NjA0MDIxMg==",
lat: 60.115939,
lon: 24.426609
},
{
id: "U3RvcDpIU0w6NjA0MDIxMQ==",
lat: 60.1159,
lon: 24.4454
},
{
id: "U3RvcDpIU0w6NjA0MDIxNQ==",
lat: 60.119058,
lon: 24.4813
},
{
id: "U3RvcDpIU0w6NjAzMDIwMQ==",
lat: 60.133472,
lon: 24.512763
},
{
id: "U3RvcDpIU0w6NjAzMDIzMg==",
lat: 60.13751,
lon: 24.537388
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTEzMDExMg==",
lat: 60.16818,
lon: 24.923302
},
{
id: "U3RvcDpIU0w6MTA0MDEzMA==",
lat: 60.17016,
lon: 24.92995
},
{
id: "U3RvcDpIU0w6MTA0MDI5MA==",
lat: 60.169711,
lon: 24.933736
},
{
id: "U3RvcDpIU0w6MTA0MDI5MQ==",
lat: 60.169588,
lon: 24.933372
},
{
id: "U3RvcDpIU0w6MTEzMDExMw==",
lat: 60.170862,
lon: 24.930898
},
{
id: "U3RvcDpIU0w6MTEzMDExNQ==",
lat: 60.168485,
lon: 24.923568
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDIwMg==",
lat: 60.147525,
lon: 24.572943
},
{
id: "U3RvcDpIU0w6NjAzMDIwNg==",
lat: 60.137865,
lon: 24.532207
},
{
id: "U3RvcDpIU0w6NjAzMDIwMg==",
lat: 60.133613,
lon: 24.509142
},
{
id: "U3RvcDpIU0w6NjA0MDIxNg==",
lat: 60.119052,
lon: 24.477277
},
{
id: "U3RvcDpIU0w6NjA0MDIxNA==",
lat: 60.117086,
lon: 24.44276
},
{
id: "U3RvcDpIU0w6NjA0MDIxMw==",
lat: 60.116116,
lon: 24.426538
},
{
id: "U3RvcDpIU0w6NjA0MDIxMA==",
lat: 60.114838,
lon: 24.411756
},
{
id: "U3RvcDpIU0w6NjA1MDIwNg==",
lat: 60.110009,
lon: 24.382306
},
{
id: "U3RvcDpIU0w6NjA1MDIwMw==",
lat: 60.105278,
lon: 24.369337
},
{
id: "U3RvcDpIU0w6NjA1MDIwMg==",
lat: 60.103433,
lon: 24.364292
},
{
id: "U3RvcDpIU0w6NjA3MDIyOQ==",
lat: 60.101495,
lon: 24.345007
},
{
id: "U3RvcDpIU0w6NjMwNzAwNw==",
lat: 60.09886,
lon: 24.329275
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwMQ==",
lat: 60.094172,
lon: 24.241083
}
]
},
{
gtfsId: "HSL:7191",
shortName: "191",
longName: "Kirkkonummi-Pikkala th.(-Inkoo)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjA0MDI4Nw==",
lat: 60.119861,
lon: 24.441108
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA0MDIxNA==",
lat: 60.117086,
lon: 24.44276
},
{
id: "U3RvcDpIU0w6NjA0MDIxMw==",
lat: 60.116116,
lon: 24.426538
},
{
id: "U3RvcDpIU0w6NjA0MDIxMA==",
lat: 60.114838,
lon: 24.411756
},
{
id: "U3RvcDpIU0w6NjA1MDIwNg==",
lat: 60.110009,
lon: 24.382306
},
{
id: "U3RvcDpIU0w6NjA1MDIwMw==",
lat: 60.105278,
lon: 24.369337
},
{
id: "U3RvcDpIU0w6NjA1MDIwMg==",
lat: 60.103433,
lon: 24.364292
},
{
id: "U3RvcDpIU0w6NjA3MDIyOQ==",
lat: 60.101495,
lon: 24.345007
},
{
id: "U3RvcDpIU0w6NjMwNzAwNw==",
lat: 60.09886,
lon: 24.329275
},
{
id: "U3RvcDpIU0w6NjMwNzAwNQ==",
lat: 60.099251,
lon: 24.3006
},
{
id: "U3RvcDpIU0w6NjMwNDAwNQ==",
lat: 60.097218,
lon: 24.287899
},
{
id: "U3RvcDpIU0w6NjMwNDAwMw==",
lat: 60.096184,
lon: 24.258319
},
{
id: "U3RvcDpIU0w6NjMwNDAwMQ==",
lat: 60.094172,
lon: 24.241083
},
{
id: "U3RvcDpIU0w6NjMwNDAwMA==",
lat: 60.094333,
lon: 24.242655
},
{
id: "U3RvcDpIU0w6NjMwNDAwMg==",
lat: 60.096148,
lon: 24.257656
},
{
id: "U3RvcDpIU0w6NjA3MDIyOA==",
lat: 60.101337,
lon: 24.34443
},
{
id: "U3RvcDpIU0w6NjA1MDIwMQ==",
lat: 60.103863,
lon: 24.36639
},
{
id: "U3RvcDpIU0w6NjA1MDIwNA==",
lat: 60.106061,
lon: 24.371492
},
{
id: "U3RvcDpIU0w6NjA1MDIwNQ==",
lat: 60.110392,
lon: 24.384672
},
{
id: "U3RvcDpIU0w6NjA0MDIwOQ==",
lat: 60.114941,
lon: 24.414073
},
{
id: "U3RvcDpIU0w6NjA0MDIxMg==",
lat: 60.115939,
lon: 24.426609
},
{
id: "U3RvcDpIU0w6NjA0MDI4NQ==",
lat: 60.118858,
lon: 24.438951
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
}
]
},
{
gtfsId: "HSL:4717N",
shortName: "717N",
longName: "Rautatientori-Jakomäki-Hakunila-Kuninkaanmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6MTQxNDE0NA==",
lat: 60.25401,
lon: 25.07816
},
{
id: "U3RvcDpIU0w6MTQxNDE0Mg==",
lat: 60.2538,
lon: 25.07331
},
{
id: "U3RvcDpIU0w6MTQxNDE0MA==",
lat: 60.25535,
lon: 25.06984
},
{
id: "U3RvcDpIU0w6MTQxNDEzOA==",
lat: 60.25918,
lon: 25.07194
},
{
id: "U3RvcDpIU0w6MTQxNDEzNg==",
lat: 60.261686,
lon: 25.075141
},
{
id: "U3RvcDpIU0w6MTQxNDE1Mg==",
lat: 60.2619,
lon: 25.08012
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDIyNw==",
lat: 60.29097,
lon: 25.11945
},
{
id: "U3RvcDpIU0w6NDk2MDIyNQ==",
lat: 60.29152,
lon: 25.11378
},
{
id: "U3RvcDpIU0w6NDk2MDIyMw==",
lat: 60.29266,
lon: 25.1126
},
{
id: "U3RvcDpIU0w6NDk2MDIyMA==",
lat: 60.29456,
lon: 25.10822
},
{
id: "U3RvcDpIU0w6NDk2MDIzNQ==",
lat: 60.29629,
lon: 25.10753
},
{
id: "U3RvcDpIU0w6NDk2MDI5NQ==",
lat: 60.29711,
lon: 25.10977
},
{
id: "U3RvcDpIU0w6NDk2MDIxMg==",
lat: 60.29888,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk3MDIzMw==",
lat: 60.30091,
lon: 25.10537
},
{
id: "U3RvcDpIU0w6NDk3MDIzMg==",
lat: 60.30053,
lon: 25.10575
},
{
id: "U3RvcDpIU0w6NDk2MDIwNQ==",
lat: 60.29786,
lon: 25.10536
},
{
id: "U3RvcDpIU0w6NDk2MDI5NA==",
lat: 60.29714,
lon: 25.10963
},
{
id: "U3RvcDpIU0w6NDk2MDIzOA==",
lat: 60.29628,
lon: 25.10712
},
{
id: "U3RvcDpIU0w6NDk2MDIxOQ==",
lat: 60.29418,
lon: 25.10836
},
{
id: "U3RvcDpIU0w6NDk2MDIyMg==",
lat: 60.2927,
lon: 25.1125
},
{
id: "U3RvcDpIU0w6NDk2MDIyNA==",
lat: 60.2913,
lon: 25.11414
},
{
id: "U3RvcDpIU0w6NDk2MDIyNg==",
lat: 60.2906,
lon: 25.12053
},
{
id: "U3RvcDpIU0w6NDk2MDI0MA==",
lat: 60.28826,
lon: 25.12278
},
{
id: "U3RvcDpIU0w6NDk0MDIyNg==",
lat: 60.28473,
lon: 25.12101
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OQ==",
lat: 60.28134,
lon: 25.11511
},
{
id: "U3RvcDpIU0w6NDk0MDI5NQ==",
lat: 60.28177,
lon: 25.11241
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mw==",
lat: 60.27973,
lon: 25.10858
},
{
id: "U3RvcDpIU0w6NDk0MDIxNA==",
lat: 60.27791,
lon: 25.10567
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDkzMDIwMQ==",
lat: 60.26739,
lon: 25.09956
},
{
id: "U3RvcDpIU0w6NDkzMDIwNQ==",
lat: 60.26543,
lon: 25.09705
},
{
id: "U3RvcDpIU0w6NDkzMDIwOQ==",
lat: 60.26285,
lon: 25.09348
},
{
id: "U3RvcDpIU0w6NDkzMDIxMA==",
lat: 60.26178,
lon: 25.0887
},
{
id: "U3RvcDpIU0w6MTQxNDE1Mw==",
lat: 60.26209,
lon: 25.07929
},
{
id: "U3RvcDpIU0w6MTQxNDEzNQ==",
lat: 60.261811,
lon: 25.075388
},
{
id: "U3RvcDpIU0w6MTQxNDEzNw==",
lat: 60.259321,
lon: 25.071821
},
{
id: "U3RvcDpIU0w6MTQxNDEzOQ==",
lat: 60.25497,
lon: 25.06971
},
{
id: "U3RvcDpIU0w6MTQxNDE0MQ==",
lat: 60.25368,
lon: 25.07349
},
{
id: "U3RvcDpIU0w6MTQxNDE0Mw==",
lat: 60.2539,
lon: 25.07806
},
{
id: "U3RvcDpIU0w6MTM2MjE0Mg==",
lat: 60.22916,
lon: 25.0124
},
{
id: "U3RvcDpIU0w6MTI0MDEyMw==",
lat: 60.21279,
lon: 24.9702
},
{
id: "U3RvcDpIU0w6MTI0MDEwNg==",
lat: 60.20699,
lon: 24.967438
},
{
id: "U3RvcDpIU0w6MTI0MDExOA==",
lat: 60.203978,
lon: 24.965546
},
{
id: "U3RvcDpIU0w6MTIyMDEwNA==",
lat: 60.19551,
lon: 24.96272
},
{
id: "U3RvcDpIU0w6MTIyMDEwMg==",
lat: 60.19168,
lon: 24.96451
},
{
id: "U3RvcDpIU0w6MTExMzEzMQ==",
lat: 60.18685,
lon: 24.9612
},
{
id: "U3RvcDpIU0w6MTExMjEyNg==",
lat: 60.18261,
lon: 24.95673
},
{
id: "U3RvcDpIU0w6MTExMTExNg==",
lat: 60.17856,
lon: 24.94992
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:6173Z",
shortName: "173Z",
longName: "Matinkylä (M)-Kirkkonummi-Upinniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxOQ==",
lat: 60.160171,
lon: 24.738517
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDIwMg==",
lat: 60.147525,
lon: 24.572943
},
{
id: "U3RvcDpIU0w6NjAzMDIwNg==",
lat: 60.137865,
lon: 24.532207
},
{
id: "U3RvcDpIU0w6NjAzMDIwMg==",
lat: 60.133613,
lon: 24.509142
},
{
id: "U3RvcDpIU0w6NjA2MDIxMg==",
lat: 60.1185,
lon: 24.47475
},
{
id: "U3RvcDpIU0w6NjA0MDI2Mg==",
lat: 60.12006,
lon: 24.470677
},
{
id: "U3RvcDpIU0w6NjA0MDI3MQ==",
lat: 60.125957,
lon: 24.470868
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI5Mw==",
lat: 60.119659,
lon: 24.441186
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA3MDI0Mw==",
lat: 60.115295,
lon: 24.444255
},
{
id: "U3RvcDpIU0w6NjA0MDIwNw==",
lat: 60.112248,
lon: 24.445382
},
{
id: "U3RvcDpIU0w6NjA0MDIwNQ==",
lat: 60.10854,
lon: 24.44222
},
{
id: "U3RvcDpIU0w6NjA0MDIwMw==",
lat: 60.106028,
lon: 24.43808
},
{
id: "U3RvcDpIU0w6NjA0MDIwMg==",
lat: 60.102843,
lon: 24.43134
},
{
id: "U3RvcDpIU0w6NjA3MDI0MQ==",
lat: 60.100687,
lon: 24.421182
},
{
id: "U3RvcDpIU0w6NjA3MDIyNQ==",
lat: 60.096573,
lon: 24.414515
},
{
id: "U3RvcDpIU0w6NjA3MDIyMw==",
lat: 60.094627,
lon: 24.40926
},
{
id: "U3RvcDpIU0w6NjA3MDIyMA==",
lat: 60.093213,
lon: 24.401212
},
{
id: "U3RvcDpIU0w6NjA3MDIzNw==",
lat: 60.092233,
lon: 24.396735
},
{
id: "U3RvcDpIU0w6NjA3MDIxNA==",
lat: 60.090353,
lon: 24.387245
},
{
id: "U3RvcDpIU0w6NjA3MDIzNA==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIxNg==",
lat: 60.090662,
lon: 24.38842
},
{
id: "U3RvcDpIU0w6NjA3MDIxOA==",
lat: 60.09218,
lon: 24.39843
},
{
id: "U3RvcDpIU0w6NjA3MDIxOQ==",
lat: 60.09339,
lon: 24.402122
},
{
id: "U3RvcDpIU0w6NjA3MDIyMg==",
lat: 60.094425,
lon: 24.410103
},
{
id: "U3RvcDpIU0w6NjA3MDIyMQ==",
lat: 60.094098,
lon: 24.411655
},
{
id: "U3RvcDpIU0w6NjA3MDIxNQ==",
lat: 60.090597,
lon: 24.409795
},
{
id: "U3RvcDpIU0w6NjA3MDIxMA==",
lat: 60.087858,
lon: 24.408618
},
{
id: "U3RvcDpIU0w6NjA3MDIwOA==",
lat: 60.083508,
lon: 24.403963
},
{
id: "U3RvcDpIU0w6NjA3MDIwNQ==",
lat: 60.080148,
lon: 24.399735
},
{
id: "U3RvcDpIU0w6NjA3MDIwMw==",
lat: 60.075464,
lon: 24.394231
},
{
id: "U3RvcDpIU0w6NjA3MDIwMg==",
lat: 60.069282,
lon: 24.388602
},
{
id: "U3RvcDpIU0w6NjA4MDIxMA==",
lat: 60.064062,
lon: 24.385022
},
{
id: "U3RvcDpIU0w6NjA4MDIwOA==",
lat: 60.060075,
lon: 24.38244
},
{
id: "U3RvcDpIU0w6NjA4MDIwNQ==",
lat: 60.055292,
lon: 24.376925
},
{
id: "U3RvcDpIU0w6NjA4MDIwMw==",
lat: 60.049887,
lon: 24.373005
},
{
id: "U3RvcDpIU0w6NjEwMDIxMA==",
lat: 60.042432,
lon: 24.3699
},
{
id: "U3RvcDpIU0w6NjEwMDIwOQ==",
lat: 60.037182,
lon: 24.369817
},
{
id: "U3RvcDpIU0w6NjEwMDIwNg==",
lat: 60.032892,
lon: 24.366045
},
{
id: "U3RvcDpIU0w6NjEwMDIwMw==",
lat: 60.029863,
lon: 24.366433
},
{
id: "U3RvcDpIU0w6NjEwMDIwMQ==",
lat: 60.028168,
lon: 24.367202
},
{
id: "U3RvcDpIU0w6NjEwMDIwMg==",
lat: 60.028482,
lon: 24.357707
},
{
id: "U3RvcDpIU0w6NjEwMDIwNQ==",
lat: 60.031298,
lon: 24.354285
},
{
id: "U3RvcDpIU0w6NjEwMDIwNw==",
lat: 60.034112,
lon: 24.362122
},
{
id: "U3RvcDpIU0w6NjEwMDIwOA==",
lat: 60.036892,
lon: 24.369562
},
{
id: "U3RvcDpIU0w6NjEwMDIxMQ==",
lat: 60.042207,
lon: 24.370552
},
{
id: "U3RvcDpIU0w6NjA4MDIwMg==",
lat: 60.048668,
lon: 24.37264
},
{
id: "U3RvcDpIU0w6NjA4MDIwNA==",
lat: 60.054922,
lon: 24.376973
},
{
id: "U3RvcDpIU0w6NjA4MDIwNg==",
lat: 60.05687,
lon: 24.379203
},
{
id: "U3RvcDpIU0w6NjA4MDIwNw==",
lat: 60.059462,
lon: 24.382783
},
{
id: "U3RvcDpIU0w6NjA4MDIwOQ==",
lat: 60.063675,
lon: 24.385032
},
{
id: "U3RvcDpIU0w6NjA3MDIwMQ==",
lat: 60.068838,
lon: 24.389293
},
{
id: "U3RvcDpIU0w6NjA3MDIwNA==",
lat: 60.076112,
lon: 24.395513
},
{
id: "U3RvcDpIU0w6NjA3MDIwNg==",
lat: 60.080733,
lon: 24.400545
},
{
id: "U3RvcDpIU0w6NjA3MDIwNw==",
lat: 60.084103,
lon: 24.405502
},
{
id: "U3RvcDpIU0w6NjA3MDIxMg==",
lat: 60.086772,
lon: 24.408497
},
{
id: "U3RvcDpIU0w6NjA3MDIxNw==",
lat: 60.091925,
lon: 24.410829
},
{
id: "U3RvcDpIU0w6NjA3MDIxMw==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIyNA==",
lat: 60.094795,
lon: 24.412478
},
{
id: "U3RvcDpIU0w6NjA3MDIyNg==",
lat: 60.097217,
lon: 24.415857
},
{
id: "U3RvcDpIU0w6NjA3MDIyNw==",
lat: 60.100692,
lon: 24.42214
},
{
id: "U3RvcDpIU0w6NjA0MDIwMQ==",
lat: 60.103107,
lon: 24.432607
},
{
id: "U3RvcDpIU0w6NjA0MDIwNA==",
lat: 60.106515,
lon: 24.439315
},
{
id: "U3RvcDpIU0w6NjA0MDIwNg==",
lat: 60.109248,
lon: 24.44381
},
{
id: "U3RvcDpIU0w6NjA0MDIwOA==",
lat: 60.113168,
lon: 24.44543
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5Ng==",
lat: 60.119674,
lon: 24.441337
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIwMA==",
lat: 60.12564,
lon: 24.47039
},
{
id: "U3RvcDpIU0w6NjA1MDIyMA==",
lat: 60.119183,
lon: 24.471579
},
{
id: "U3RvcDpIU0w6NjA0MDI0MQ==",
lat: 60.119302,
lon: 24.476357
},
{
id: "U3RvcDpIU0w6NjA0MDIxNQ==",
lat: 60.119058,
lon: 24.4813
},
{
id: "U3RvcDpIU0w6NjAzMDIwMQ==",
lat: 60.133472,
lon: 24.512763
},
{
id: "U3RvcDpIU0w6NjAzMDIzMg==",
lat: 60.13751,
lon: 24.537388
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:4717K",
shortName: "717K",
longName: "Rautatientori-Jakomäki-Vaarala-Hakunila-Kuninkaanmäki",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDExNw==",
lat: 60.17133,
lon: 24.94277
},
{
id: "U3RvcDpIU0w6MTExMTExMg==",
lat: 60.17932,
lon: 24.95073
},
{
id: "U3RvcDpIU0w6MTEwMDEyNQ==",
lat: 60.18247,
lon: 24.95715
},
{
id: "U3RvcDpIU0w6MTEyMTEzMA==",
lat: 60.18815,
lon: 24.96368
},
{
id: "U3RvcDpIU0w6MTIxMDEwMQ==",
lat: 60.19261,
lon: 24.9648
},
{
id: "U3RvcDpIU0w6MTIyMDIwNQ==",
lat: 60.19922,
lon: 24.96206
},
{
id: "U3RvcDpIU0w6MTI0MDEwMw==",
lat: 60.203679,
lon: 24.965952
},
{
id: "U3RvcDpIU0w6MTI0MDEyMQ==",
lat: 60.208114,
lon: 24.968409
},
{
id: "U3RvcDpIU0w6MTI0MDEyMg==",
lat: 60.21218,
lon: 24.97028
},
{
id: "U3RvcDpIU0w6MTM2MjE0MQ==",
lat: 60.22872,
lon: 25.01358
},
{
id: "U3RvcDpIU0w6MTQxNDE0NQ==",
lat: 60.25679,
lon: 25.08238
},
{
id: "U3RvcDpIU0w6MTQxNDE0Nw==",
lat: 60.25979,
lon: 25.08457
},
{
id: "U3RvcDpIU0w6NDkzMDIxMQ==",
lat: 60.26223,
lon: 25.09044
},
{
id: "U3RvcDpIU0w6NDkzMDIxOA==",
lat: 60.25851,
lon: 25.10222
},
{
id: "U3RvcDpIU0w6NDkzMDIyMA==",
lat: 60.25746,
lon: 25.10541
},
{
id: "U3RvcDpIU0w6NDkzMDIyMQ==",
lat: 60.2583,
lon: 25.103354
},
{
id: "U3RvcDpIU0w6NDkzMDIxOQ==",
lat: 60.25927,
lon: 25.10128
},
{
id: "U3RvcDpIU0w6NDkzMDIyOQ==",
lat: 60.26043,
lon: 25.09767
},
{
id: "U3RvcDpIU0w6NDkzMDIwOA==",
lat: 60.2631,
lon: 25.09417
},
{
id: "U3RvcDpIU0w6NDkzMDIwNg==",
lat: 60.26621,
lon: 25.09831
},
{
id: "U3RvcDpIU0w6NDkzMDIwNA==",
lat: 60.26826,
lon: 25.10116
},
{
id: "U3RvcDpIU0w6NDkzMDIwMg==",
lat: 60.26963,
lon: 25.10339
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
},
{
id: "U3RvcDpIU0w6NDk0MDI5Mg==",
lat: 60.27886,
lon: 25.1077
},
{
id: "U3RvcDpIU0w6NDk0MDI5NA==",
lat: 60.28146,
lon: 25.1118
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyNQ==",
lat: 60.282313,
lon: 25.120083
},
{
id: "U3RvcDpIU0w6NDk0MDIyNw==",
lat: 60.2853,
lon: 25.12259
},
{
id: "U3RvcDpIU0w6NDk2MDIzOQ==",
lat: 60.28754,
lon: 25.12383
},
{
id: "U3RvcDpIU0w6NDk2MDIyNw==",
lat: 60.29097,
lon: 25.11945
},
{
id: "U3RvcDpIU0w6NDk2MDIyNQ==",
lat: 60.29152,
lon: 25.11378
},
{
id: "U3RvcDpIU0w6NDk2MDIyMw==",
lat: 60.29266,
lon: 25.1126
},
{
id: "U3RvcDpIU0w6NDk2MDIyMA==",
lat: 60.29456,
lon: 25.10822
},
{
id: "U3RvcDpIU0w6NDk2MDIzNQ==",
lat: 60.29629,
lon: 25.10753
},
{
id: "U3RvcDpIU0w6NDk2MDI5NQ==",
lat: 60.29711,
lon: 25.10977
},
{
id: "U3RvcDpIU0w6NDk2MDIwNg==",
lat: 60.29764,
lon: 25.11134
},
{
id: "U3RvcDpIU0w6NDk3MDIwMQ==",
lat: 60.29814,
lon: 25.11254
},
{
id: "U3RvcDpIU0w6NDk3MDIyNQ==",
lat: 60.30042,
lon: 25.11287
},
{
id: "U3RvcDpIU0w6NDk3MDIwMw==",
lat: 60.30191,
lon: 25.11707
},
{
id: "U3RvcDpIU0w6NDk3MDIwNQ==",
lat: 60.3033,
lon: 25.1184
},
{
id: "U3RvcDpIU0w6NDk3MDIwNw==",
lat: 60.30592,
lon: 25.11718
},
{
id: "U3RvcDpIU0w6NDk3MDIxMA==",
lat: 60.307773,
lon: 25.114235
},
{
id: "U3RvcDpIU0w6NDk3MDI5OA==",
lat: 60.307177,
lon: 25.109792
},
{
id: "U3RvcDpIU0w6NDk3MDIyNw==",
lat: 60.30423,
lon: 25.10676
},
{
id: "U3RvcDpIU0w6NDk3MDIzNQ==",
lat: 60.30158,
lon: 25.10637
},
{
id: "U3RvcDpIU0w6NDk3MDIzMw==",
lat: 60.30091,
lon: 25.10537
}
]
},
{
gtfsId: "HSL:2349BK",
shortName: "349BK",
longName: "Lepsämänjoki-Hännikäinen-Kalajärvi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjcyMTI3Ng==",
lat: 60.30633,
lon: 24.73625
},
{
id: "U3RvcDpIU0w6MjcyMTIxMg==",
lat: 60.305,
lon: 24.74149
},
{
id: "U3RvcDpIU0w6MjcyMTIwNw==",
lat: 60.30771,
lon: 24.73601
},
{
id: "U3RvcDpIU0w6MjcyMTIwOQ==",
lat: 60.30964,
lon: 24.73158
},
{
id: "U3RvcDpIU0w6MjcyMjIxMQ==",
lat: 60.31157,
lon: 24.72685
},
{
id: "U3RvcDpIU0w6MjcyMzIyOQ==",
lat: 60.31776,
lon: 24.71642
},
{
id: "U3RvcDpIU0w6MjcyMzIxMQ==",
lat: 60.32229,
lon: 24.71755
},
{
id: "U3RvcDpIU0w6MjcyMzIzMQ==",
lat: 60.323319,
lon: 24.7162
},
{
id: "U3RvcDpIU0w6MjcyMzIzMw==",
lat: 60.32928,
lon: 24.71024
},
{
id: "U3RvcDpIU0w6MjcyMzIzNQ==",
lat: 60.33417,
lon: 24.71006
},
{
id: "U3RvcDpIU0w6MjcyMzIzNw==",
lat: 60.33689,
lon: 24.71032
},
{
id: "U3RvcDpIU0w6MjcyMzIzOQ==",
lat: 60.34191,
lon: 24.71348
},
{
id: "U3RvcDpIU0w6MjcyMzI0MQ==",
lat: 60.3446,
lon: 24.72721
},
{
id: "U3RvcDpIU0w6MjcyMzI0NA==",
lat: 60.34567,
lon: 24.73115
},
{
id: "U3RvcDpIU0w6MjcyMzI0Mg==",
lat: 60.34457,
lon: 24.72664
},
{
id: "U3RvcDpIU0w6MjcyMzI0MA==",
lat: 60.34214,
lon: 24.71353
},
{
id: "U3RvcDpIU0w6MjcyMzI3Ng==",
lat: 60.34047,
lon: 24.70653
},
{
id: "U3RvcDpIU0w6MjcyMzI3Mw==",
lat: 60.34273,
lon: 24.70409
},
{
id: "U3RvcDpIU0w6MjcyMzI3MQ==",
lat: 60.34615,
lon: 24.70234
},
{
id: "U3RvcDpIU0w6MjcyMzI2MQ==",
lat: 60.34888,
lon: 24.69919
},
{
id: "U3RvcDpIU0w6MjcyMzI0Ng==",
lat: 60.35487,
lon: 24.69083
},
{
id: "U3RvcDpIU0w6MjcyMzI4MA==",
lat: 60.35762,
lon: 24.672833
},
{
id: "U3RvcDpIU0w6MjcyMzI4Mg==",
lat: 60.35718,
lon: 24.68554
},
{
id: "U3RvcDpIU0w6MjcyMzI3Mg==",
lat: 60.35454,
lon: 24.69139
},
{
id: "U3RvcDpIU0w6MjcyMzI2Mg==",
lat: 60.3486,
lon: 24.69945
},
{
id: "U3RvcDpIU0w6MjcyMzI3NA==",
lat: 60.34616,
lon: 24.70221
},
{
id: "U3RvcDpIU0w6MjcyMzI3NQ==",
lat: 60.3427,
lon: 24.70397
},
{
id: "U3RvcDpIU0w6MjcyMzI3OQ==",
lat: 60.34035,
lon: 24.70672
},
{
id: "U3RvcDpIU0w6MjcyMzIzOA==",
lat: 60.3368,
lon: 24.71016
},
{
id: "U3RvcDpIU0w6MjcyMzIzNg==",
lat: 60.33429,
lon: 24.70989
},
{
id: "U3RvcDpIU0w6MjcyMzIzNA==",
lat: 60.32961,
lon: 24.70996
},
{
id: "U3RvcDpIU0w6MjcyMzIzMg==",
lat: 60.324161,
lon: 24.714759
},
{
id: "U3RvcDpIU0w6MjcyMzIxMA==",
lat: 60.321463,
lon: 24.717534
},
{
id: "U3RvcDpIU0w6MjcyMzIzMA==",
lat: 60.31757,
lon: 24.71609
},
{
id: "U3RvcDpIU0w6MjcyMjIxMg==",
lat: 60.31226,
lon: 24.7241
},
{
id: "U3RvcDpIU0w6MjcyMTIxMA==",
lat: 60.30984,
lon: 24.73088
},
{
id: "U3RvcDpIU0w6MjcyMTIwOA==",
lat: 60.306944,
lon: 24.738153
},
{
id: "U3RvcDpIU0w6MjcyMTIxMw==",
lat: 60.30444,
lon: 24.74096
}
]
},
{
gtfsId: "HSL:1091K",
shortName: "91K",
longName: "Rapuojantie-Östersundom-Puroniitty",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDkyMDIwNw==",
lat: 60.265003,
lon: 25.140218
},
{
id: "U3RvcDpIU0w6MTYwMjEyMg==",
lat: 60.255705,
lon: 25.154408
},
{
id: "U3RvcDpIU0w6MTYwMTEzMA==",
lat: 60.238345,
lon: 25.186932
},
{
id: "U3RvcDpIU0w6MTYwMDIwNw==",
lat: 60.249545,
lon: 25.164438
},
{
id: "U3RvcDpIU0w6MTYwMDIwOQ==",
lat: 60.251682,
lon: 25.176211
},
{
id: "U3RvcDpIU0w6MTYwMTE0MA==",
lat: 60.249382,
lon: 25.187215
},
{
id: "U3RvcDpIU0w6MTYwMDIxMQ==",
lat: 60.253477,
lon: 25.185895
},
{
id: "U3RvcDpIU0w6MTYwMDIxMw==",
lat: 60.255158,
lon: 25.192102
},
{
id: "U3RvcDpIU0w6MTYwMjIwMQ==",
lat: 60.26087,
lon: 25.20992
},
{
id: "U3RvcDpIU0w6MTYwMjIwNg==",
lat: 60.282621,
lon: 25.196232
},
{
id: "U3RvcDpIU0w6MTYwMjIwNA==",
lat: 60.265179,
lon: 25.209755
},
{
id: "U3RvcDpIU0w6MTYwMjIwMg==",
lat: 60.261023,
lon: 25.209925
},
{
id: "U3RvcDpIU0w6MTYwMDIxNQ==",
lat: 60.259785,
lon: 25.211032
},
{
id: "U3RvcDpIU0w6MTYwMDIzMQ==",
lat: 60.260022,
lon: 25.215462
},
{
id: "U3RvcDpIU0w6MTYwMDIxNw==",
lat: 60.260177,
lon: 25.219923
},
{
id: "U3RvcDpIU0w6MTYwMjEwMQ==",
lat: 60.29232,
lon: 25.240888
},
{
id: "U3RvcDpIU0w6MTYwMDIxOA==",
lat: 60.260228,
lon: 25.218075
},
{
id: "U3RvcDpIU0w6MTYwMjIwNQ==",
lat: 60.282538,
lon: 25.196488
},
{
id: "U3RvcDpIU0w6MTYwMDIxNg==",
lat: 60.25977,
lon: 25.208407
},
{
id: "U3RvcDpIU0w6MTYwMDIxNA==",
lat: 60.25475,
lon: 25.190433
},
{
id: "U3RvcDpIU0w6MTYwMDIxMg==",
lat: 60.253138,
lon: 25.183522
},
{
id: "U3RvcDpIU0w6MTYwMDIxMA==",
lat: 60.2514,
lon: 25.173983
},
{
id: "U3RvcDpIU0w6MTYwMjEyMQ==",
lat: 60.255762,
lon: 25.154099
},
{
id: "U3RvcDpIU0w6NDkwMDIwOA==",
lat: 60.25836,
lon: 25.14474
},
{
id: "U3RvcDpIU0w6NDkyMDIwOA==",
lat: 60.26487,
lon: 25.14023
}
]
},
{
gtfsId: "HSL:4719B",
shortName: "719B",
longName: "Länsisalmi-Hakunila",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NDk0MDIzMA==",
lat: 60.27698,
lon: 25.10402
},
{
id: "U3RvcDpIU0w6NDk0MDIxNg==",
lat: 60.2763,
lon: 25.1043
},
{
id: "U3RvcDpIU0w6NDk0MDIxOA==",
lat: 60.2743,
lon: 25.10409
},
{
id: "U3RvcDpIU0w6NDk0MDIyMA==",
lat: 60.27266,
lon: 25.1041
},
{
id: "U3RvcDpIU0w6NDk0MDIwOQ==",
lat: 60.27158,
lon: 25.10579
},
{
id: "U3RvcDpIU0w6NDk0MDIwNw==",
lat: 60.27485,
lon: 25.10877
},
{
id: "U3RvcDpIU0w6NDk0MDIwNQ==",
lat: 60.27662,
lon: 25.11215
},
{
id: "U3RvcDpIU0w6NDk0MDI5Ng==",
lat: 60.27916,
lon: 25.11468
},
{
id: "U3RvcDpIU0w6NDk0MDIwMw==",
lat: 60.28061,
lon: 25.11721
},
{
id: "U3RvcDpIU0w6NDk0MDIyOA==",
lat: 60.2815,
lon: 25.12098
},
{
id: "U3RvcDpIU0w6NDk0MDIwMg==",
lat: 60.2793,
lon: 25.12528
},
{
id: "U3RvcDpIU0w6NDk4MDIyMA==",
lat: 60.27699,
lon: 25.13448
},
{
id: "U3RvcDpIU0w6NDkyMDIwMQ==",
lat: 60.27523,
lon: 25.13787
},
{
id: "U3RvcDpIU0w6NDkyMDIwMw==",
lat: 60.2721,
lon: 25.1386
},
{
id: "U3RvcDpIU0w6NDkyMDIwNQ==",
lat: 60.26836,
lon: 25.13851
},
{
id: "U3RvcDpIU0w6NDkyMDIwNw==",
lat: 60.265003,
lon: 25.140218
},
{
id: "U3RvcDpIU0w6NDkwMDIwOQ==",
lat: 60.25796,
lon: 25.14486
},
{
id: "U3RvcDpIU0w6NDkwMDIwMw==",
lat: 60.25638,
lon: 25.14215
},
{
id: "U3RvcDpIU0w6NDkwMDIwOA==",
lat: 60.25836,
lon: 25.14474
},
{
id: "U3RvcDpIU0w6NDkyMDIwOA==",
lat: 60.26487,
lon: 25.14023
},
{
id: "U3RvcDpIU0w6NDkyMDIwNg==",
lat: 60.269,
lon: 25.13899
},
{
id: "U3RvcDpIU0w6NDkyMDIwNA==",
lat: 60.27321,
lon: 25.1384
},
{
id: "U3RvcDpIU0w6NDkyMDIwMg==",
lat: 60.27563,
lon: 25.13748
},
{
id: "U3RvcDpIU0w6NDk4MDIxMw==",
lat: 60.27735,
lon: 25.13335
},
{
id: "U3RvcDpIU0w6NDk0MDIwMQ==",
lat: 60.27995,
lon: 25.12467
},
{
id: "U3RvcDpIU0w6NDk0MDIyNA==",
lat: 60.28127,
lon: 25.11927
},
{
id: "U3RvcDpIU0w6NDk0MDI5OA==",
lat: 60.28001,
lon: 25.11556
},
{
id: "U3RvcDpIU0w6NDk0MDI5Nw==",
lat: 60.27866,
lon: 25.11328
},
{
id: "U3RvcDpIU0w6NDk0MDIwNA==",
lat: 60.27641,
lon: 25.11153
},
{
id: "U3RvcDpIU0w6NDk0MDIwNg==",
lat: 60.2751,
lon: 25.10886
},
{
id: "U3RvcDpIU0w6NDk0MDIwOA==",
lat: 60.27165,
lon: 25.10582
},
{
id: "U3RvcDpIU0w6NDk0MDIyMQ==",
lat: 60.27316,
lon: 25.10431
},
{
id: "U3RvcDpIU0w6NDk0MDIxOQ==",
lat: 60.27431,
lon: 25.10434
},
{
id: "U3RvcDpIU0w6NDk0MDIxNw==",
lat: 60.27631,
lon: 25.1045
}
]
},
{
gtfsId: "HSL:1090A",
shortName: "90A",
longName: "Rautatientori-Vuosaaren satama",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTAyMDEyMg==",
lat: 60.17085,
lon: 24.94333
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzMTEwNQ==",
lat: 60.19461,
lon: 25.0322
},
{
id: "U3RvcDpIU0w6MTQzMTE4MQ==",
lat: 60.1991,
lon: 25.03757
},
{
id: "U3RvcDpIU0w6MTQzMzE4Mw==",
lat: 60.20588,
lon: 25.04745
},
{
id: "U3RvcDpIU0w6MTQ1NzEwNw==",
lat: 60.209231,
lon: 25.079047
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNg==",
lat: 60.20959,
lon: 25.091516
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNA==",
lat: 60.208146,
lon: 25.09688
},
{
id: "U3RvcDpIU0w6MTQ1MjE2OQ==",
lat: 60.207813,
lon: 25.101287
},
{
id: "U3RvcDpIU0w6MTU0MTE5NQ==",
lat: 60.20494,
lon: 25.11985
},
{
id: "U3RvcDpIU0w6MTU0MTExNQ==",
lat: 60.20448,
lon: 25.12802
},
{
id: "U3RvcDpIU0w6MTU0MzEwMQ==",
lat: 60.20712,
lon: 25.14335
},
{
id: "U3RvcDpIU0w6MTU0MTE3Ng==",
lat: 60.20762,
lon: 25.15195
},
{
id: "U3RvcDpIU0w6MTU0MTE3NA==",
lat: 60.20854,
lon: 25.15843
},
{
id: "U3RvcDpIU0w6MTU0MjEwMQ==",
lat: 60.21077,
lon: 25.163977
},
{
id: "U3RvcDpIU0w6MTU0MjEwMw==",
lat: 60.21407,
lon: 25.16823
},
{
id: "U3RvcDpIU0w6MTU0MjEzOA==",
lat: 60.21651,
lon: 25.16496
},
{
id: "U3RvcDpIU0w6MTU0ODEwMA==",
lat: 60.21917,
lon: 25.1732
},
{
id: "U3RvcDpIU0w6MTU0ODEwNA==",
lat: 60.221504,
lon: 25.175434
},
{
id: "U3RvcDpIU0w6MTU0ODEwMQ==",
lat: 60.21917,
lon: 25.17245
},
{
id: "U3RvcDpIU0w6MTU0MjEzNw==",
lat: 60.2176,
lon: 25.1638
},
{
id: "U3RvcDpIU0w6MTU0MjEwNA==",
lat: 60.213157,
lon: 25.167747
},
{
id: "U3RvcDpIU0w6MTU0MjEwMg==",
lat: 60.210102,
lon: 25.162402
},
{
id: "U3RvcDpIU0w6MTU0NjEwMw==",
lat: 60.2083,
lon: 25.1565
},
{
id: "U3RvcDpIU0w6MTU0MTE3Nw==",
lat: 60.2077,
lon: 25.1517
},
{
id: "U3RvcDpIU0w6MTU0MzEwMg==",
lat: 60.2071,
lon: 25.1428
},
{
id: "U3RvcDpIU0w6MTU0MTExNA==",
lat: 60.2047,
lon: 25.1276
},
{
id: "U3RvcDpIU0w6MTU0MTE5Ng==",
lat: 60.2054,
lon: 25.1199
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMQ==",
lat: 60.208349,
lon: 25.104742
},
{
id: "U3RvcDpIU0w6MTQ1MjE3MA==",
lat: 60.208067,
lon: 25.098807
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMw==",
lat: 60.208799,
lon: 25.095008
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNQ==",
lat: 60.210859,
lon: 25.090062
},
{
id: "U3RvcDpIU0w6MTQ1NzEwNg==",
lat: 60.209455,
lon: 25.078313
},
{
id: "U3RvcDpIU0w6MTQzMTE4Mg==",
lat: 60.2058,
lon: 25.04504
},
{
id: "U3RvcDpIU0w6MTQzMTE4MA==",
lat: 60.19873,
lon: 25.03652
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
}
]
},
{
gtfsId: "HSL:6173K",
shortName: "173K",
longName: "Matinkylä (M)-Masala-Kirkkonummi-Upinniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6NjEwMDIwNg==",
lat: 60.032892,
lon: 24.366045
},
{
id: "U3RvcDpIU0w6NjEwMDIwMw==",
lat: 60.029863,
lon: 24.366433
},
{
id: "U3RvcDpIU0w6NjEwMDIwMQ==",
lat: 60.028168,
lon: 24.367202
},
{
id: "U3RvcDpIU0w6NjEwMDIwMg==",
lat: 60.028482,
lon: 24.357707
},
{
id: "U3RvcDpIU0w6NjEwMDIwNQ==",
lat: 60.031298,
lon: 24.354285
},
{
id: "U3RvcDpIU0w6NjEwMDIwNw==",
lat: 60.034112,
lon: 24.362122
},
{
id: "U3RvcDpIU0w6NjEwMDIwOA==",
lat: 60.036892,
lon: 24.369562
},
{
id: "U3RvcDpIU0w6NjEwMDIxMQ==",
lat: 60.042207,
lon: 24.370552
},
{
id: "U3RvcDpIU0w6NjA4MDIwMg==",
lat: 60.048668,
lon: 24.37264
},
{
id: "U3RvcDpIU0w6NjA4MDIwNA==",
lat: 60.054922,
lon: 24.376973
},
{
id: "U3RvcDpIU0w6NjA4MDIwNg==",
lat: 60.05687,
lon: 24.379203
},
{
id: "U3RvcDpIU0w6NjA4MDIwNw==",
lat: 60.059462,
lon: 24.382783
},
{
id: "U3RvcDpIU0w6NjA4MDIwOQ==",
lat: 60.063675,
lon: 24.385032
},
{
id: "U3RvcDpIU0w6NjA3MDIwMQ==",
lat: 60.068838,
lon: 24.389293
},
{
id: "U3RvcDpIU0w6NjA3MDIwNA==",
lat: 60.076112,
lon: 24.395513
},
{
id: "U3RvcDpIU0w6NjA3MDIwNg==",
lat: 60.080733,
lon: 24.400545
},
{
id: "U3RvcDpIU0w6NjA3MDIwNw==",
lat: 60.084103,
lon: 24.405502
},
{
id: "U3RvcDpIU0w6NjA3MDIxMg==",
lat: 60.086772,
lon: 24.408497
},
{
id: "U3RvcDpIU0w6NjA3MDIxNw==",
lat: 60.091925,
lon: 24.410829
},
{
id: "U3RvcDpIU0w6NjA3MDIyMw==",
lat: 60.094627,
lon: 24.40926
},
{
id: "U3RvcDpIU0w6NjA3MDIyMA==",
lat: 60.093213,
lon: 24.401212
},
{
id: "U3RvcDpIU0w6NjA3MDIzNw==",
lat: 60.092233,
lon: 24.396735
},
{
id: "U3RvcDpIU0w6NjA3MDIxNA==",
lat: 60.090353,
lon: 24.387245
},
{
id: "U3RvcDpIU0w6NjA3MDIxMw==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIxNg==",
lat: 60.090662,
lon: 24.38842
},
{
id: "U3RvcDpIU0w6NjA3MDIxOA==",
lat: 60.09218,
lon: 24.39843
},
{
id: "U3RvcDpIU0w6NjA3MDIxOQ==",
lat: 60.09339,
lon: 24.402122
},
{
id: "U3RvcDpIU0w6NjA3MDIyMg==",
lat: 60.094425,
lon: 24.410103
},
{
id: "U3RvcDpIU0w6NjA3MDIyNA==",
lat: 60.094795,
lon: 24.412478
},
{
id: "U3RvcDpIU0w6NjA3MDIyNg==",
lat: 60.097217,
lon: 24.415857
},
{
id: "U3RvcDpIU0w6NjA3MDIyNw==",
lat: 60.100692,
lon: 24.42214
},
{
id: "U3RvcDpIU0w6NjA0MDIwMQ==",
lat: 60.103107,
lon: 24.432607
},
{
id: "U3RvcDpIU0w6NjA0MDIwNA==",
lat: 60.106515,
lon: 24.439315
},
{
id: "U3RvcDpIU0w6NjA0MDIwNg==",
lat: 60.109248,
lon: 24.44381
},
{
id: "U3RvcDpIU0w6NjA0MDIwOA==",
lat: 60.113168,
lon: 24.44543
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA1MDI1NA==",
lat: 60.122759,
lon: 24.427463
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA0MDI3MA==",
lat: 60.124332,
lon: 24.411187
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mg==",
lat: 60.127002,
lon: 24.416042
},
{
id: "U3RvcDpIU0w6NjA0MDI3Ng==",
lat: 60.129328,
lon: 24.419208
},
{
id: "U3RvcDpIU0w6NjA0MDI3OA==",
lat: 60.130365,
lon: 24.425962
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mg==",
lat: 60.132354,
lon: 24.430257
},
{
id: "U3RvcDpIU0w6NjA0MDI0NA==",
lat: 60.133633,
lon: 24.429907
},
{
id: "U3RvcDpIU0w6NjA0MDI0Ng==",
lat: 60.134168,
lon: 24.44247
},
{
id: "U3RvcDpIU0w6NjA0MDI4NA==",
lat: 60.137257,
lon: 24.447662
},
{
id: "U3RvcDpIU0w6NjA0MDI1MA==",
lat: 60.136902,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIyMw==",
lat: 60.126372,
lon: 24.471547
},
{
id: "U3RvcDpIU0w6NjA0MDIyNw==",
lat: 60.130182,
lon: 24.48253
},
{
id: "U3RvcDpIU0w6NjAzMDIxNA==",
lat: 60.132453,
lon: 24.492952
},
{
id: "U3RvcDpIU0w6NjAzMDIxNw==",
lat: 60.134682,
lon: 24.50252
},
{
id: "U3RvcDpIU0w6NjAzMDIyMg==",
lat: 60.137063,
lon: 24.507907
},
{
id: "U3RvcDpIU0w6NjAzMDIyNQ==",
lat: 60.139437,
lon: 24.51347
},
{
id: "U3RvcDpIU0w6NjAzMDIyNw==",
lat: 60.143618,
lon: 24.521718
},
{
id: "U3RvcDpIU0w6NjAyMDIxMA==",
lat: 60.151237,
lon: 24.528287
},
{
id: "U3RvcDpIU0w6NjAyMDIxNQ==",
lat: 60.154503,
lon: 24.532388
},
{
id: "U3RvcDpIU0w6NjAyMDIxMw==",
lat: 60.15282,
lon: 24.545448
},
{
id: "U3RvcDpIU0w6NjAyMDIwNw==",
lat: 60.149187,
lon: 24.56578
},
{
id: "U3RvcDpIU0w6NjAyMDI1OQ==",
lat: 60.14789,
lon: 24.572755
},
{
id: "U3RvcDpIU0w6NjAyMDI0OQ==",
lat: 60.146723,
lon: 24.580065
},
{
id: "U3RvcDpIU0w6NjAyMDI1MQ==",
lat: 60.148718,
lon: 24.588332
},
{
id: "U3RvcDpIU0w6NjAyMDI1Mw==",
lat: 60.151257,
lon: 24.595448
},
{
id: "U3RvcDpIU0w6NjAyMDI1NQ==",
lat: 60.152969,
lon: 24.599857
},
{
id: "U3RvcDpIU0w6NjAyMDI1Nw==",
lat: 60.155509,
lon: 24.606553
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
},
{
id: "U3RvcDpIU0w6MjMxNDIxOQ==",
lat: 60.160171,
lon: 24.738517
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6NjAyMDI1OA==",
lat: 60.155162,
lon: 24.605287
},
{
id: "U3RvcDpIU0w6NjAyMDI1Ng==",
lat: 60.152433,
lon: 24.59821
},
{
id: "U3RvcDpIU0w6NjAyMDI1NA==",
lat: 60.150785,
lon: 24.5936
},
{
id: "U3RvcDpIU0w6NjAyMDI1Mg==",
lat: 60.148407,
lon: 24.586327
},
{
id: "U3RvcDpIU0w6NjAyMDI1MA==",
lat: 60.14632,
lon: 24.578854
},
{
id: "U3RvcDpIU0w6NjAyMDI2MA==",
lat: 60.148067,
lon: 24.573078
},
{
id: "U3RvcDpIU0w6NjAyMDIwOA==",
lat: 60.149502,
lon: 24.564343
},
{
id: "U3RvcDpIU0w6NjAyMDIxNA==",
lat: 60.153555,
lon: 24.544262
},
{
id: "U3RvcDpIU0w6NjAyMDIxNg==",
lat: 60.154818,
lon: 24.531715
},
{
id: "U3RvcDpIU0w6NjAyMDIwOQ==",
lat: 60.150418,
lon: 24.527258
},
{
id: "U3RvcDpIU0w6NjAzMDIyNg==",
lat: 60.142742,
lon: 24.520495
},
{
id: "U3RvcDpIU0w6NjAzMDIyNA==",
lat: 60.139088,
lon: 24.51195
},
{
id: "U3RvcDpIU0w6NjAzMDIyMw==",
lat: 60.137172,
lon: 24.507677
},
{
id: "U3RvcDpIU0w6NjAzMDIxOA==",
lat: 60.13512,
lon: 24.503027
},
{
id: "U3RvcDpIU0w6NjAzMDIxNQ==",
lat: 60.132965,
lon: 24.494397
},
{
id: "U3RvcDpIU0w6NjA0MDIyOA==",
lat: 60.130113,
lon: 24.480768
},
{
id: "U3RvcDpIU0w6NjA0MDIyNQ==",
lat: 60.126777,
lon: 24.472177
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI0Nw==",
lat: 60.13445,
lon: 24.44258
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mw==",
lat: 60.13286,
lon: 24.429452
},
{
id: "U3RvcDpIU0w6NjA0MDI4MA==",
lat: 60.130422,
lon: 24.425053
},
{
id: "U3RvcDpIU0w6NjA0MDI3NA==",
lat: 60.129002,
lon: 24.41859
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mw==",
lat: 60.126575,
lon: 24.415172
},
{
id: "U3RvcDpIU0w6NjA0MDI2OQ==",
lat: 60.12398,
lon: 24.410722
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mw==",
lat: 60.122346,
lon: 24.427386
},
{
id: "U3RvcDpIU0w6NjA0MDI5Mw==",
lat: 60.119659,
lon: 24.441186
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA3MDI0Mw==",
lat: 60.115295,
lon: 24.444255
},
{
id: "U3RvcDpIU0w6NjA0MDIwNw==",
lat: 60.112248,
lon: 24.445382
},
{
id: "U3RvcDpIU0w6NjA0MDIwNQ==",
lat: 60.10854,
lon: 24.44222
},
{
id: "U3RvcDpIU0w6NjA0MDIwMw==",
lat: 60.106028,
lon: 24.43808
},
{
id: "U3RvcDpIU0w6NjA0MDIwMg==",
lat: 60.102843,
lon: 24.43134
},
{
id: "U3RvcDpIU0w6NjA3MDI0MQ==",
lat: 60.100687,
lon: 24.421182
},
{
id: "U3RvcDpIU0w6NjA3MDIyNQ==",
lat: 60.096573,
lon: 24.414515
},
{
id: "U3RvcDpIU0w6NjA3MDIzNA==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIyMQ==",
lat: 60.094098,
lon: 24.411655
},
{
id: "U3RvcDpIU0w6NjA3MDIxNQ==",
lat: 60.090597,
lon: 24.409795
},
{
id: "U3RvcDpIU0w6NjA3MDIxMA==",
lat: 60.087858,
lon: 24.408618
},
{
id: "U3RvcDpIU0w6NjA3MDIwOA==",
lat: 60.083508,
lon: 24.403963
},
{
id: "U3RvcDpIU0w6NjA3MDIwNQ==",
lat: 60.080148,
lon: 24.399735
},
{
id: "U3RvcDpIU0w6NjA3MDIwMw==",
lat: 60.075464,
lon: 24.394231
},
{
id: "U3RvcDpIU0w6NjA3MDIwMg==",
lat: 60.069282,
lon: 24.388602
},
{
id: "U3RvcDpIU0w6NjA4MDIxMA==",
lat: 60.064062,
lon: 24.385022
},
{
id: "U3RvcDpIU0w6NjA4MDIwOA==",
lat: 60.060075,
lon: 24.38244
},
{
id: "U3RvcDpIU0w6NjA4MDIwNQ==",
lat: 60.055292,
lon: 24.376925
},
{
id: "U3RvcDpIU0w6NjA4MDIwMw==",
lat: 60.049887,
lon: 24.373005
},
{
id: "U3RvcDpIU0w6NjEwMDIxMA==",
lat: 60.042432,
lon: 24.3699
},
{
id: "U3RvcDpIU0w6NjEwMDIwOQ==",
lat: 60.037182,
lon: 24.369817
}
]
},
{
gtfsId: "HSL:6173N",
shortName: "173N",
longName: "Kamppi-Masala-Kirkkonummi-Upinniemi",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTA0MDI4Mg==",
lat: 60.16885,
lon: 24.93109
},
{
id: "U3RvcDpIU0w6MTA0MDIzMw==",
lat: 60.16594,
lon: 24.92659
},
{
id: "U3RvcDpIU0w6MTIwMTIyOQ==",
lat: 60.16455,
lon: 24.91327
},
{
id: "U3RvcDpIU0w6MjIyMjIwNQ==",
lat: 60.16646,
lon: 24.84158
},
{
id: "U3RvcDpIU0w6MjIxMzIzNg==",
lat: 60.16978,
lon: 24.8233
},
{
id: "U3RvcDpIU0w6MjIxMTI4OA==",
lat: 60.17018,
lon: 24.81011
},
{
id: "U3RvcDpIU0w6MjIxNDI5MQ==",
lat: 60.16774,
lon: 24.76961
},
{
id: "U3RvcDpIU0w6MjMyMjIwMQ==",
lat: 60.16625,
lon: 24.74964
},
{
id: "U3RvcDpIU0w6MjMyMjIxMA==",
lat: 60.16413,
lon: 24.73839
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6MjQxMzIzOA==",
lat: 60.157561,
lon: 24.621901
},
{
id: "U3RvcDpIU0w6MjQxMzIyOA==",
lat: 60.158344,
lon: 24.619044
},
{
id: "U3RvcDpIU0w6NjAyMDI1OA==",
lat: 60.155162,
lon: 24.605287
},
{
id: "U3RvcDpIU0w6NjAyMDI1Ng==",
lat: 60.152433,
lon: 24.59821
},
{
id: "U3RvcDpIU0w6NjAyMDI1NA==",
lat: 60.150785,
lon: 24.5936
},
{
id: "U3RvcDpIU0w6NjAyMDI1Mg==",
lat: 60.148407,
lon: 24.586327
},
{
id: "U3RvcDpIU0w6NjAyMDI1MA==",
lat: 60.14632,
lon: 24.578854
},
{
id: "U3RvcDpIU0w6NjAyMDI2MA==",
lat: 60.148067,
lon: 24.573078
},
{
id: "U3RvcDpIU0w6NjAyMDIwOA==",
lat: 60.149502,
lon: 24.564343
},
{
id: "U3RvcDpIU0w6NjAyMDIxNA==",
lat: 60.153555,
lon: 24.544262
},
{
id: "U3RvcDpIU0w6NjAyMDIxNg==",
lat: 60.154818,
lon: 24.531715
},
{
id: "U3RvcDpIU0w6NjAyMDIwOQ==",
lat: 60.150418,
lon: 24.527258
},
{
id: "U3RvcDpIU0w6NjAzMDIyNg==",
lat: 60.142742,
lon: 24.520495
},
{
id: "U3RvcDpIU0w6NjAzMDIyNA==",
lat: 60.139088,
lon: 24.51195
},
{
id: "U3RvcDpIU0w6NjAzMDIyMw==",
lat: 60.137172,
lon: 24.507677
},
{
id: "U3RvcDpIU0w6NjAzMDIxOA==",
lat: 60.13512,
lon: 24.503027
},
{
id: "U3RvcDpIU0w6NjAzMDIxNQ==",
lat: 60.132965,
lon: 24.494397
},
{
id: "U3RvcDpIU0w6NjA0MDIyOA==",
lat: 60.130113,
lon: 24.480768
},
{
id: "U3RvcDpIU0w6NjA0MDIyNQ==",
lat: 60.126777,
lon: 24.472177
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI4NA==",
lat: 60.137257,
lon: 24.447662
},
{
id: "U3RvcDpIU0w6NjA0MDI1MA==",
lat: 60.136902,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI0Nw==",
lat: 60.13445,
lon: 24.44258
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mw==",
lat: 60.13286,
lon: 24.429452
},
{
id: "U3RvcDpIU0w6NjA0MDI4MA==",
lat: 60.130422,
lon: 24.425053
},
{
id: "U3RvcDpIU0w6NjA0MDI3NA==",
lat: 60.129002,
lon: 24.41859
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mw==",
lat: 60.126575,
lon: 24.415172
},
{
id: "U3RvcDpIU0w6NjA0MDI2OQ==",
lat: 60.12398,
lon: 24.410722
},
{
id: "U3RvcDpIU0w6NjA0MDIzMQ==",
lat: 60.122858,
lon: 24.411142
},
{
id: "U3RvcDpIU0w6NjA0MDIzMw==",
lat: 60.123517,
lon: 24.423733
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mw==",
lat: 60.122346,
lon: 24.427386
},
{
id: "U3RvcDpIU0w6NjA0MDI5Mw==",
lat: 60.119659,
lon: 24.441186
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA3MDI0Mw==",
lat: 60.115295,
lon: 24.444255
},
{
id: "U3RvcDpIU0w6NjA0MDIwNw==",
lat: 60.112248,
lon: 24.445382
},
{
id: "U3RvcDpIU0w6NjA0MDIwNQ==",
lat: 60.10854,
lon: 24.44222
},
{
id: "U3RvcDpIU0w6NjA0MDIwMw==",
lat: 60.106028,
lon: 24.43808
},
{
id: "U3RvcDpIU0w6NjA0MDIwMg==",
lat: 60.102843,
lon: 24.43134
},
{
id: "U3RvcDpIU0w6NjA3MDI0MQ==",
lat: 60.100687,
lon: 24.421182
},
{
id: "U3RvcDpIU0w6NjA3MDIyNQ==",
lat: 60.096573,
lon: 24.414515
},
{
id: "U3RvcDpIU0w6NjA3MDIyMw==",
lat: 60.094627,
lon: 24.40926
},
{
id: "U3RvcDpIU0w6NjA3MDIyMA==",
lat: 60.093213,
lon: 24.401212
},
{
id: "U3RvcDpIU0w6NjA3MDIzNw==",
lat: 60.092233,
lon: 24.396735
},
{
id: "U3RvcDpIU0w6NjA3MDIxNA==",
lat: 60.090353,
lon: 24.387245
},
{
id: "U3RvcDpIU0w6NjA3MDIzNA==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIxNg==",
lat: 60.090662,
lon: 24.38842
},
{
id: "U3RvcDpIU0w6NjA3MDIxOA==",
lat: 60.09218,
lon: 24.39843
},
{
id: "U3RvcDpIU0w6NjA3MDIxOQ==",
lat: 60.09339,
lon: 24.402122
},
{
id: "U3RvcDpIU0w6NjA3MDIyMg==",
lat: 60.094425,
lon: 24.410103
},
{
id: "U3RvcDpIU0w6NjA3MDIyMQ==",
lat: 60.094098,
lon: 24.411655
},
{
id: "U3RvcDpIU0w6NjA3MDIxNQ==",
lat: 60.090597,
lon: 24.409795
},
{
id: "U3RvcDpIU0w6NjA3MDIxMA==",
lat: 60.087858,
lon: 24.408618
},
{
id: "U3RvcDpIU0w6NjA3MDIwOA==",
lat: 60.083508,
lon: 24.403963
},
{
id: "U3RvcDpIU0w6NjA3MDIwNQ==",
lat: 60.080148,
lon: 24.399735
},
{
id: "U3RvcDpIU0w6NjA3MDIwMw==",
lat: 60.075464,
lon: 24.394231
},
{
id: "U3RvcDpIU0w6NjA3MDIwMg==",
lat: 60.069282,
lon: 24.388602
},
{
id: "U3RvcDpIU0w6NjA4MDIxMA==",
lat: 60.064062,
lon: 24.385022
},
{
id: "U3RvcDpIU0w6NjA4MDIwOA==",
lat: 60.060075,
lon: 24.38244
},
{
id: "U3RvcDpIU0w6NjA4MDIwNQ==",
lat: 60.055292,
lon: 24.376925
},
{
id: "U3RvcDpIU0w6NjA4MDIwMw==",
lat: 60.049887,
lon: 24.373005
},
{
id: "U3RvcDpIU0w6NjEwMDIxMA==",
lat: 60.042432,
lon: 24.3699
},
{
id: "U3RvcDpIU0w6NjEwMDIwOQ==",
lat: 60.037182,
lon: 24.369817
},
{
id: "U3RvcDpIU0w6NjEwMDIwNg==",
lat: 60.032892,
lon: 24.366045
},
{
id: "U3RvcDpIU0w6NjEwMDIwMw==",
lat: 60.029863,
lon: 24.366433
},
{
id: "U3RvcDpIU0w6NjEwMDIwMQ==",
lat: 60.028168,
lon: 24.367202
},
{
id: "U3RvcDpIU0w6NjEwMDIwMg==",
lat: 60.028482,
lon: 24.357707
},
{
id: "U3RvcDpIU0w6NjEwMDIwNQ==",
lat: 60.031298,
lon: 24.354285
},
{
id: "U3RvcDpIU0w6NjEwMDIwNw==",
lat: 60.034112,
lon: 24.362122
},
{
id: "U3RvcDpIU0w6NjEwMDIwOA==",
lat: 60.036892,
lon: 24.369562
},
{
id: "U3RvcDpIU0w6NjEwMDIxMQ==",
lat: 60.042207,
lon: 24.370552
},
{
id: "U3RvcDpIU0w6NjA4MDIwMg==",
lat: 60.048668,
lon: 24.37264
},
{
id: "U3RvcDpIU0w6NjA4MDIwNA==",
lat: 60.054922,
lon: 24.376973
},
{
id: "U3RvcDpIU0w6NjA4MDIwNg==",
lat: 60.05687,
lon: 24.379203
},
{
id: "U3RvcDpIU0w6NjA4MDIwNw==",
lat: 60.059462,
lon: 24.382783
},
{
id: "U3RvcDpIU0w6NjA4MDIwOQ==",
lat: 60.063675,
lon: 24.385032
},
{
id: "U3RvcDpIU0w6NjA3MDIwMQ==",
lat: 60.068838,
lon: 24.389293
},
{
id: "U3RvcDpIU0w6NjA3MDIwNA==",
lat: 60.076112,
lon: 24.395513
},
{
id: "U3RvcDpIU0w6NjA3MDIwNg==",
lat: 60.080733,
lon: 24.400545
},
{
id: "U3RvcDpIU0w6NjA3MDIwNw==",
lat: 60.084103,
lon: 24.405502
},
{
id: "U3RvcDpIU0w6NjA3MDIxMg==",
lat: 60.086772,
lon: 24.408497
},
{
id: "U3RvcDpIU0w6NjA3MDIxNw==",
lat: 60.091925,
lon: 24.410829
},
{
id: "U3RvcDpIU0w6NjA3MDIxMw==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIyNA==",
lat: 60.094795,
lon: 24.412478
},
{
id: "U3RvcDpIU0w6NjA3MDIyNg==",
lat: 60.097217,
lon: 24.415857
},
{
id: "U3RvcDpIU0w6NjA3MDIyNw==",
lat: 60.100692,
lon: 24.42214
},
{
id: "U3RvcDpIU0w6NjA0MDIwMQ==",
lat: 60.103107,
lon: 24.432607
},
{
id: "U3RvcDpIU0w6NjA0MDIwNA==",
lat: 60.106515,
lon: 24.439315
},
{
id: "U3RvcDpIU0w6NjA0MDIwNg==",
lat: 60.109248,
lon: 24.44381
},
{
id: "U3RvcDpIU0w6NjA0MDIwOA==",
lat: 60.113168,
lon: 24.44543
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA1MDI1NA==",
lat: 60.122759,
lon: 24.427463
},
{
id: "U3RvcDpIU0w6NjA0MDIzNA==",
lat: 60.123458,
lon: 24.422153
},
{
id: "U3RvcDpIU0w6NjA0MDI3MA==",
lat: 60.124332,
lon: 24.411187
},
{
id: "U3RvcDpIU0w6NjA0MDI3Mg==",
lat: 60.127002,
lon: 24.416042
},
{
id: "U3RvcDpIU0w6NjA0MDI3Ng==",
lat: 60.129328,
lon: 24.419208
},
{
id: "U3RvcDpIU0w6NjA0MDI3OA==",
lat: 60.130365,
lon: 24.425962
},
{
id: "U3RvcDpIU0w6NjA0MDI0Mg==",
lat: 60.132354,
lon: 24.430257
},
{
id: "U3RvcDpIU0w6NjA0MDI0NA==",
lat: 60.133633,
lon: 24.429907
},
{
id: "U3RvcDpIU0w6NjA0MDI0Ng==",
lat: 60.134168,
lon: 24.44247
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIyMw==",
lat: 60.126372,
lon: 24.471547
},
{
id: "U3RvcDpIU0w6NjA0MDIyNw==",
lat: 60.130182,
lon: 24.48253
},
{
id: "U3RvcDpIU0w6NjAzMDIxNA==",
lat: 60.132453,
lon: 24.492952
},
{
id: "U3RvcDpIU0w6NjAzMDIxNw==",
lat: 60.134682,
lon: 24.50252
},
{
id: "U3RvcDpIU0w6NjAzMDIyMg==",
lat: 60.137063,
lon: 24.507907
},
{
id: "U3RvcDpIU0w6NjAzMDIyNQ==",
lat: 60.139437,
lon: 24.51347
},
{
id: "U3RvcDpIU0w6NjAzMDIyNw==",
lat: 60.143618,
lon: 24.521718
},
{
id: "U3RvcDpIU0w6NjAyMDIxMA==",
lat: 60.151237,
lon: 24.528287
},
{
id: "U3RvcDpIU0w6NjAyMDIxNQ==",
lat: 60.154503,
lon: 24.532388
},
{
id: "U3RvcDpIU0w6NjAyMDIxMw==",
lat: 60.15282,
lon: 24.545448
},
{
id: "U3RvcDpIU0w6NjAyMDIwNw==",
lat: 60.149187,
lon: 24.56578
},
{
id: "U3RvcDpIU0w6NjAyMDI1OQ==",
lat: 60.14789,
lon: 24.572755
},
{
id: "U3RvcDpIU0w6NjAyMDI0OQ==",
lat: 60.146723,
lon: 24.580065
},
{
id: "U3RvcDpIU0w6NjAyMDI1MQ==",
lat: 60.148718,
lon: 24.588332
},
{
id: "U3RvcDpIU0w6NjAyMDI1Mw==",
lat: 60.151257,
lon: 24.595448
},
{
id: "U3RvcDpIU0w6NjAyMDI1NQ==",
lat: 60.152969,
lon: 24.599857
},
{
id: "U3RvcDpIU0w6NjAyMDI1Nw==",
lat: 60.155509,
lon: 24.606553
},
{
id: "U3RvcDpIU0w6MjQxMzIyOQ==",
lat: 60.158316,
lon: 24.61858
},
{
id: "U3RvcDpIU0w6MjQxMzIzOQ==",
lat: 60.157002,
lon: 24.623586
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxMTIyMA==",
lat: 60.162931,
lon: 24.737044
},
{
id: "U3RvcDpIU0w6MjIzMjI4MA==",
lat: 60.1659,
lon: 24.75641
},
{
id: "U3RvcDpIU0w6MjIzMjIzMg==",
lat: 60.16756,
lon: 24.77298
},
{
id: "U3RvcDpIU0w6MjIzMTIwMg==",
lat: 60.16898,
lon: 24.805
},
{
id: "U3RvcDpIU0w6MjIzMTIwMQ==",
lat: 60.168748,
lon: 24.825967
},
{
id: "U3RvcDpIU0w6MjIzMjIwNA==",
lat: 60.16583,
lon: 24.84252
},
{
id: "U3RvcDpIU0w6MTIwMTEzMA==",
lat: 60.16431,
lon: 24.91405
},
{
id: "U3RvcDpIU0w6MTA0MDIzNA==",
lat: 60.16627,
lon: 24.92699
},
{
id: "U3RvcDpIU0w6MTA0MDI4OQ==",
lat: 60.1688,
lon: 24.93012
}
]
},
{
gtfsId: "HSL:6172V",
shortName: "172V",
longName: "Matinkylä (M)-Masala-Kirkkonummi-Kantvik",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MjMxNDIxOQ==",
lat: 60.160171,
lon: 24.738517
},
{
id: "U3RvcDpIU0w6MjMxMTIxMA==",
lat: 60.162683,
lon: 24.73868
},
{
id: "U3RvcDpIU0w6MjQzMjIwMQ==",
lat: 60.16042,
lon: 24.70324
},
{
id: "U3RvcDpIU0w6MjQyMTIxNw==",
lat: 60.153848,
lon: 24.660872
},
{
id: "U3RvcDpIU0w6NjAyMDI2MA==",
lat: 60.148067,
lon: 24.573078
},
{
id: "U3RvcDpIU0w6NjAyMDIwOA==",
lat: 60.149502,
lon: 24.564343
},
{
id: "U3RvcDpIU0w6NjAyMDIxNA==",
lat: 60.153555,
lon: 24.544262
},
{
id: "U3RvcDpIU0w6NjAyMDIxNg==",
lat: 60.154818,
lon: 24.531715
},
{
id: "U3RvcDpIU0w6NjAyMDIwOQ==",
lat: 60.150418,
lon: 24.527258
},
{
id: "U3RvcDpIU0w6NjAzMDIyNg==",
lat: 60.142742,
lon: 24.520495
},
{
id: "U3RvcDpIU0w6NjAzMDIyNA==",
lat: 60.139088,
lon: 24.51195
},
{
id: "U3RvcDpIU0w6NjAzMDIyMw==",
lat: 60.137172,
lon: 24.507677
},
{
id: "U3RvcDpIU0w6NjAzMDIxOA==",
lat: 60.13512,
lon: 24.503027
},
{
id: "U3RvcDpIU0w6NjAzMDIxNQ==",
lat: 60.132965,
lon: 24.494397
},
{
id: "U3RvcDpIU0w6NjA0MDIyOA==",
lat: 60.130113,
lon: 24.480768
},
{
id: "U3RvcDpIU0w6NjA0MDIyNQ==",
lat: 60.126777,
lon: 24.472177
},
{
id: "U3RvcDpIU0w6NjA0MDIyNg==",
lat: 60.126855,
lon: 24.463377
},
{
id: "U3RvcDpIU0w6NjA0MDIyMg==",
lat: 60.12543,
lon: 24.458422
},
{
id: "U3RvcDpIU0w6NjA0MDIyMA==",
lat: 60.124705,
lon: 24.455278
},
{
id: "U3RvcDpIU0w6NjA0MDIxOQ==",
lat: 60.124075,
lon: 24.450053
},
{
id: "U3RvcDpIU0w6NjA1MDI1MA==",
lat: 60.124165,
lon: 24.441558
},
{
id: "U3RvcDpIU0w6NjA0MDI3NQ==",
lat: 60.129061,
lon: 24.446102
},
{
id: "U3RvcDpIU0w6NjA0MDI4Mg==",
lat: 60.133433,
lon: 24.445385
},
{
id: "U3RvcDpIU0w6NjA0MDI4NA==",
lat: 60.137257,
lon: 24.447662
},
{
id: "U3RvcDpIU0w6NjA0MDI1MA==",
lat: 60.136902,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI4MQ==",
lat: 60.132403,
lon: 24.446242
},
{
id: "U3RvcDpIU0w6NjA0MDI3Nw==",
lat: 60.129148,
lon: 24.445763
},
{
id: "U3RvcDpIU0w6NjA1MDI1MQ==",
lat: 60.12328,
lon: 24.4415
},
{
id: "U3RvcDpIU0w6NjA0MDI5Mw==",
lat: 60.119659,
lon: 24.441186
},
{
id: "U3RvcDpIU0w6NjA0MDI2MQ==",
lat: 60.118768,
lon: 24.442995
},
{
id: "U3RvcDpIU0w6NjA3MDI0Mw==",
lat: 60.115295,
lon: 24.444255
},
{
id: "U3RvcDpIU0w6NjA0MDIwNw==",
lat: 60.112248,
lon: 24.445382
},
{
id: "U3RvcDpIU0w6NjA0MDIwNQ==",
lat: 60.10854,
lon: 24.44222
},
{
id: "U3RvcDpIU0w6NjA0MDIwMw==",
lat: 60.106028,
lon: 24.43808
},
{
id: "U3RvcDpIU0w6NjA0MDIwMg==",
lat: 60.102843,
lon: 24.43134
},
{
id: "U3RvcDpIU0w6NjA3MDI0MQ==",
lat: 60.100687,
lon: 24.421182
},
{
id: "U3RvcDpIU0w6NjA3MDIyNQ==",
lat: 60.096573,
lon: 24.414515
},
{
id: "U3RvcDpIU0w6NjA3MDIyMw==",
lat: 60.094627,
lon: 24.40926
},
{
id: "U3RvcDpIU0w6NjA3MDIyMA==",
lat: 60.093213,
lon: 24.401212
},
{
id: "U3RvcDpIU0w6NjA3MDIzNw==",
lat: 60.092233,
lon: 24.396735
},
{
id: "U3RvcDpIU0w6NjA3MDIxNA==",
lat: 60.090353,
lon: 24.387245
},
{
id: "U3RvcDpIU0w6NjA3MDIxMw==",
lat: 60.089537,
lon: 24.381437
},
{
id: "U3RvcDpIU0w6NjA3MDIxNg==",
lat: 60.090662,
lon: 24.38842
},
{
id: "U3RvcDpIU0w6NjA3MDIxOA==",
lat: 60.09218,
lon: 24.39843
},
{
id: "U3RvcDpIU0w6NjA3MDIxOQ==",
lat: 60.09339,
lon: 24.402122
},
{
id: "U3RvcDpIU0w6NjA3MDIyMg==",
lat: 60.094425,
lon: 24.410103
},
{
id: "U3RvcDpIU0w6NjA3MDIyNA==",
lat: 60.094795,
lon: 24.412478
},
{
id: "U3RvcDpIU0w6NjA3MDIyNg==",
lat: 60.097217,
lon: 24.415857
},
{
id: "U3RvcDpIU0w6NjA3MDIyNw==",
lat: 60.100692,
lon: 24.42214
},
{
id: "U3RvcDpIU0w6NjA0MDIwMQ==",
lat: 60.103107,
lon: 24.432607
},
{
id: "U3RvcDpIU0w6NjA0MDIwNA==",
lat: 60.106515,
lon: 24.439315
},
{
id: "U3RvcDpIU0w6NjA0MDIwNg==",
lat: 60.109248,
lon: 24.44381
},
{
id: "U3RvcDpIU0w6NjA0MDIwOA==",
lat: 60.113168,
lon: 24.44543
},
{
id: "U3RvcDpIU0w6NjA0MDI2MA==",
lat: 60.118532,
lon: 24.443487
},
{
id: "U3RvcDpIU0w6NjA0MDI5MQ==",
lat: 60.119715,
lon: 24.44079
},
{
id: "U3RvcDpIU0w6NjA1MDI1Mg==",
lat: 60.12379,
lon: 24.44275
},
{
id: "U3RvcDpIU0w6NjA0MDIxNw==",
lat: 60.124093,
lon: 24.45091
},
{
id: "U3RvcDpIU0w6NjA0MDIxOA==",
lat: 60.124475,
lon: 24.456073
},
{
id: "U3RvcDpIU0w6NjA0MDIyMQ==",
lat: 60.125593,
lon: 24.459067
},
{
id: "U3RvcDpIU0w6NjA0MDIyNA==",
lat: 60.1267,
lon: 24.4639
},
{
id: "U3RvcDpIU0w6NjA0MDIyMw==",
lat: 60.126372,
lon: 24.471547
},
{
id: "U3RvcDpIU0w6NjA0MDIyNw==",
lat: 60.130182,
lon: 24.48253
},
{
id: "U3RvcDpIU0w6NjAzMDIxNA==",
lat: 60.132453,
lon: 24.492952
},
{
id: "U3RvcDpIU0w6NjAzMDIxNw==",
lat: 60.134682,
lon: 24.50252
},
{
id: "U3RvcDpIU0w6NjAzMDIyMg==",
lat: 60.137063,
lon: 24.507907
},
{
id: "U3RvcDpIU0w6NjAzMDIyNQ==",
lat: 60.139437,
lon: 24.51347
},
{
id: "U3RvcDpIU0w6NjAzMDIyNw==",
lat: 60.143618,
lon: 24.521718
},
{
id: "U3RvcDpIU0w6NjAyMDIxMA==",
lat: 60.151237,
lon: 24.528287
},
{
id: "U3RvcDpIU0w6NjAyMDIxNQ==",
lat: 60.154503,
lon: 24.532388
},
{
id: "U3RvcDpIU0w6NjAyMDIxMw==",
lat: 60.15282,
lon: 24.545448
},
{
id: "U3RvcDpIU0w6NjAyMDIwNw==",
lat: 60.149187,
lon: 24.56578
},
{
id: "U3RvcDpIU0w6NjAyMDI1OQ==",
lat: 60.14789,
lon: 24.572755
},
{
id: "U3RvcDpIU0w6NjAyMDIwMQ==",
lat: 60.146692,
lon: 24.577627
},
{
id: "U3RvcDpIU0w6MjQ0MzIyNw==",
lat: 60.153208,
lon: 24.667688
},
{
id: "U3RvcDpIU0w6MjQ0MjIwMQ==",
lat: 60.160253,
lon: 24.70772
},
{
id: "U3RvcDpIU0w6MjMxNDIwNw==",
lat: 60.161258,
lon: 24.736561
},
{
id: "U3RvcDpIU0w6MjMxNDIwMA==",
lat: 60.159927,
lon: 24.73946
}
]
},
{
gtfsId: "HSL:1090N",
shortName: "90N",
longName: "Rautatientori-Länsi-Herttoniemi-Vuosaari (Kallvikintie)",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTU0MTA0Nw==",
lat: 60.222273,
lon: 25.134413
},
{
id: "U3RvcDpIU0w6MTU0MTEwNA==",
lat: 60.21717,
lon: 25.13261
},
{
id: "U3RvcDpIU0w6MTU0MTIxOA==",
lat: 60.212982,
lon: 25.134375
},
{
id: "U3RvcDpIU0w6MTU0MTEyMA==",
lat: 60.20957,
lon: 25.13682
},
{
id: "U3RvcDpIU0w6MTU0MTE2NA==",
lat: 60.209178,
lon: 25.142691
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mg==",
lat: 60.20747,
lon: 25.14414
},
{
id: "U3RvcDpIU0w6MTU0MTE2OQ==",
lat: 60.20368,
lon: 25.14414
},
{
id: "U3RvcDpIU0w6MTU0MTE2Nw==",
lat: 60.20293,
lon: 25.13906
},
{
id: "U3RvcDpIU0w6MTU0MTE1Ng==",
lat: 60.20388,
lon: 25.13639
},
{
id: "U3RvcDpIU0w6MTU0MTExNA==",
lat: 60.2047,
lon: 25.1276
},
{
id: "U3RvcDpIU0w6MTU0MTE5Ng==",
lat: 60.2054,
lon: 25.1199
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMQ==",
lat: 60.208349,
lon: 25.104742
},
{
id: "U3RvcDpIU0w6MTQ1MjE3MA==",
lat: 60.208067,
lon: 25.098807
},
{
id: "U3RvcDpIU0w6MTQ1MjEwMw==",
lat: 60.208799,
lon: 25.095008
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNQ==",
lat: 60.210859,
lon: 25.090062
},
{
id: "U3RvcDpIU0w6MTQ1NzEwNg==",
lat: 60.209455,
lon: 25.078313
},
{
id: "U3RvcDpIU0w6MTQ1NDE4NA==",
lat: 60.21495,
lon: 25.04414
},
{
id: "U3RvcDpIU0w6MTQzMTEzNg==",
lat: 60.2123,
lon: 25.03822
},
{
id: "U3RvcDpIU0w6MTQzMTEzNA==",
lat: 60.209183,
lon: 25.037994
},
{
id: "U3RvcDpIU0w6MTQzMTEwOQ==",
lat: 60.20798,
lon: 25.03966
},
{
id: "U3RvcDpIU0w6MTQzMTE0OA==",
lat: 60.20553,
lon: 25.03599
},
{
id: "U3RvcDpIU0w6MTQzMTE0Ng==",
lat: 60.20423,
lon: 25.03388
},
{
id: "U3RvcDpIU0w6MTQzMTE0NA==",
lat: 60.20156,
lon: 25.03135
},
{
id: "U3RvcDpIU0w6MTQzMTE0Mg==",
lat: 60.19926,
lon: 25.03136
},
{
id: "U3RvcDpIU0w6MTQzMTE0MA==",
lat: 60.19654,
lon: 25.03189
},
{
id: "U3RvcDpIU0w6MTQzMTE4Nw==",
lat: 60.19392,
lon: 25.02975
},
{
id: "U3RvcDpIU0w6MTQzMTEwMg==",
lat: 60.19172,
lon: 25.02131
},
{
id: "U3RvcDpIU0w6MTQyMDExOA==",
lat: 60.18896,
lon: 25.01072
},
{
id: "U3RvcDpIU0w6MTQyMDExNg==",
lat: 60.18756,
lon: 25.00164
},
{
id: "U3RvcDpIU0w6MTEwMDExMA==",
lat: 60.187081,
lon: 24.980178
},
{
id: "U3RvcDpIU0w6MTEwMDEwNw==",
lat: 60.18769,
lon: 24.96954
},
{
id: "U3RvcDpIU0w6MTEwMDEyMg==",
lat: 60.185206,
lon: 24.966406
},
{
id: "U3RvcDpIU0w6MTEwMDEwMw==",
lat: 60.18239,
lon: 24.96182
},
{
id: "U3RvcDpIU0w6MTExMTE0Ng==",
lat: 60.17987,
lon: 24.9576
},
{
id: "U3RvcDpIU0w6MTExMTE4MA==",
lat: 60.178438,
lon: 24.95265
},
{
id: "U3RvcDpIU0w6MTAyMDEwNg==",
lat: 60.17348,
lon: 24.94914
},
{
id: "U3RvcDpIU0w6MTAyMDIwMQ==",
lat: 60.17192,
lon: 24.94376
},
{
id: "U3RvcDpIU0w6MTAyMDEyMg==",
lat: 60.17085,
lon: 24.94333
},
{
id: "U3RvcDpIU0w6MTAyMDEwNQ==",
lat: 60.17502,
lon: 24.95049
},
{
id: "U3RvcDpIU0w6MTExMTE0Mw==",
lat: 60.178258,
lon: 24.953103
},
{
id: "U3RvcDpIU0w6MTEwMDEwMg==",
lat: 60.18206,
lon: 24.96208
},
{
id: "U3RvcDpIU0w6MTEwMDEwNQ==",
lat: 60.18688,
lon: 24.96915
},
{
id: "U3RvcDpIU0w6MTEwMDEwOQ==",
lat: 60.186563,
lon: 24.981246
},
{
id: "U3RvcDpIU0w6MTQyMDExNQ==",
lat: 60.18642,
lon: 24.99894
},
{
id: "U3RvcDpIU0w6MTQyMDExNw==",
lat: 60.18864,
lon: 25.01154
},
{
id: "U3RvcDpIU0w6MTQzNDEwMQ==",
lat: 60.19212,
lon: 25.02393
},
{
id: "U3RvcDpIU0w6MTQzMTEzOQ==",
lat: 60.19542,
lon: 25.03125
},
{
id: "U3RvcDpIU0w6MTQzMTE0MQ==",
lat: 60.19795,
lon: 25.03163
},
{
id: "U3RvcDpIU0w6MTQzMTE0Mw==",
lat: 60.20234,
lon: 25.03197
},
{
id: "U3RvcDpIU0w6MTQzMTE0NQ==",
lat: 60.20462,
lon: 25.03467
},
{
id: "U3RvcDpIU0w6MTQzMTE0Nw==",
lat: 60.20579,
lon: 25.03667
},
{
id: "U3RvcDpIU0w6MTQzMTE1MA==",
lat: 60.20742,
lon: 25.03925
},
{
id: "U3RvcDpIU0w6MTQzMTEzMw==",
lat: 60.209329,
lon: 25.037957
},
{
id: "U3RvcDpIU0w6MTQzMTEzNQ==",
lat: 60.21268,
lon: 25.03878
},
{
id: "U3RvcDpIU0w6MTQzMTEzNw==",
lat: 60.21487,
lon: 25.04418
},
{
id: "U3RvcDpIU0w6MTQ1NzEwNw==",
lat: 60.209231,
lon: 25.079047
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNg==",
lat: 60.20959,
lon: 25.091516
},
{
id: "U3RvcDpIU0w6MTQ1MjEwNA==",
lat: 60.208146,
lon: 25.09688
},
{
id: "U3RvcDpIU0w6MTQ1MjE2OQ==",
lat: 60.207813,
lon: 25.101287
},
{
id: "U3RvcDpIU0w6MTU0MTE5NQ==",
lat: 60.20494,
lon: 25.11985
},
{
id: "U3RvcDpIU0w6MTU0MTExNQ==",
lat: 60.20448,
lon: 25.12802
},
{
id: "U3RvcDpIU0w6MTU0MTE1Nw==",
lat: 60.20344,
lon: 25.13657
},
{
id: "U3RvcDpIU0w6MTU0MTE2Ng==",
lat: 60.20297,
lon: 25.14019
},
{
id: "U3RvcDpIU0w6MTU0MTE2OA==",
lat: 60.20375,
lon: 25.14482
},
{
id: "U3RvcDpIU0w6MTUzMTExNQ==",
lat: 60.20765,
lon: 25.14419
},
{
id: "U3RvcDpIU0w6MTU0MTE2Mw==",
lat: 60.2094,
lon: 25.14272
},
{
id: "U3RvcDpIU0w6MTU0MTExMQ==",
lat: 60.21026,
lon: 25.13588
},
{
id: "U3RvcDpIU0w6MTU0MTIwNw==",
lat: 60.214381,
lon: 25.133902
},
{
id: "U3RvcDpIU0w6MTU0MTEwNQ==",
lat: 60.21844,
lon: 25.13328
},
{
id: "U3RvcDpIU0w6MTU0MTExOA==",
lat: 60.223197,
lon: 25.135699
}
]
},
{
gtfsId: "HSL:1090R",
shortName: "90R",
longName: "Vuosaari-Aurinkolahti-Vuosaari",
mode: "BUS",
stops: [
{
id: "U3RvcDpIU0w6MTU0NTEyMA==",
lat: 60.205934,
lon: 25.145157
},
{
id: "U3RvcDpIU0w6MTUzMTE1OA==",
lat: 60.20239,
lon: 25.14966
},
{
id: "U3RvcDpIU0w6MTUzMTE1Ng==",
lat: 60.20211,
lon: 25.15324
},
{
id: "U3RvcDpIU0w6MTUzMTE1NA==",
lat: 60.20314,
lon: 25.15917
},
{
id: "U3RvcDpIU0w6MTUzMTExNw==",
lat: 60.205191,
lon: 25.156313
},
{
id: "U3RvcDpIU0w6MTUzMTExOQ==",
lat: 60.20463,
lon: 25.151767
},
{
id: "U3RvcDpIU0w6MTUzMTE1OQ==",
lat: 60.204132,
lon: 25.147136
},
{
id: "U3RvcDpIU0w6MTU0NTEyMQ==",
lat: 60.205906,
lon: 25.145174
}
]
}
]
}
}